/*!
 * imagesLoaded PACKAGED v4.1.3
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

!function(e,t){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",t):"object"==typeof module&&module.exports?module.exports=t():e.EvEmitter=t()}("undefined"!=typeof window?window:this,function(){function e(){}var t=e.prototype;return t.on=function(e,t){if(e&&t){var i=this._events=this._events||{},n=i[e]=i[e]||[];return-1==n.indexOf(t)&&n.push(t),this}},t.once=function(e,t){if(e&&t){this.on(e,t);var i=this._onceEvents=this._onceEvents||{},n=i[e]=i[e]||{};return n[t]=!0,this}},t.off=function(e,t){var i=this._events&&this._events[e];if(i&&i.length){var n=i.indexOf(t);return-1!=n&&i.splice(n,1),this}},t.emitEvent=function(e,t){var i=this._events&&this._events[e];if(i&&i.length){var n=0,o=i[n];t=t||[];for(var r=this._onceEvents&&this._onceEvents[e];o;){var s=r&&r[o];s&&(this.off(e,o),delete r[o]),o.apply(this,t),n+=s?0:1,o=i[n]}return this}},t.allOff=t.removeAllListeners=function(){delete this._events,delete this._onceEvents},e}),function(e,t){"use strict";"function"==typeof define&&define.amd?define(["ev-emitter/ev-emitter"],function(i){return t(e,i)}):"object"==typeof module&&module.exports?module.exports=t(e,require("ev-emitter")):e.imagesLoaded=t(e,e.EvEmitter)}("undefined"!=typeof window?window:this,function(e,t){function i(e,t){for(var i in t)e[i]=t[i];return e}function n(e){var t=[];if(Array.isArray(e))t=e;else if("number"==typeof e.length)for(var i=0;i<e.length;i++)t.push(e[i]);else t.push(e);return t}function o(e,t,r){return this instanceof o?("string"==typeof e&&(e=document.querySelectorAll(e)),this.elements=n(e),this.options=i({},this.options),"function"==typeof t?r=t:i(this.options,t),r&&this.on("always",r),this.getImages(),h&&(this.jqDeferred=new h.Deferred),void setTimeout(function(){this.check()}.bind(this))):new o(e,t,r)}function r(e){this.img=e}function s(e,t){this.url=e,this.element=t,this.img=new Image}var h=e.jQuery,a=e.console;o.prototype=Object.create(t.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(e){"IMG"==e.nodeName&&this.addImage(e),this.options.background===!0&&this.addElementBackgroundImages(e);var t=e.nodeType;if(t&&d[t]){for(var i=e.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=e.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var d={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(e){var t=getComputedStyle(e);if(t)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(t.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,e),n=i.exec(t.backgroundImage)}},o.prototype.addImage=function(e){var t=new r(e);this.images.push(t)},o.prototype.addBackground=function(e,t){var i=new s(e,t);this.images.push(i)},o.prototype.check=function(){function e(e,i,n){setTimeout(function(){t.progress(e,i,n)})}var t=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(t){t.once("progress",e),t.check()}):void this.complete()},o.prototype.progress=function(e,t,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!e.isLoaded,this.emitEvent("progress",[this,e,t]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,e),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,e,t)},o.prototype.complete=function(){var e=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(e,[this]),this.emitEvent("always",[this]),this.jqDeferred){var t=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[t](this)}},r.prototype=Object.create(t.prototype),r.prototype.check=function(){var e=this.getIsImageComplete();return e?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&void 0!==this.img.naturalWidth},r.prototype.confirm=function(e,t){this.isLoaded=e,this.emitEvent("progress",[this,this.img,t])},r.prototype.handleEvent=function(e){var t="on"+e.type;this[t]&&this[t](e)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var e=this.getIsImageComplete();e&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(e,t){this.isLoaded=e,this.emitEvent("progress",[this,this.element,t])},o.makeJQueryPlugin=function(t){t=t||e.jQuery,t&&(h=t,h.fn.imagesLoaded=function(e,t){var i=new o(this,e,t);return i.jqDeferred.promise(h(this))})},o.makeJQueryPlugin(),o});

/*! flip - v1.1.2 - 2016-10-20
* https://github.com/nnattawat/flip
* Copyright (c) 2016 Nattawat Nonsung; Licensed MIT */

!function(a){var b=function(){var a,b=document.createElement("fakeelement"),c={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(a in c)if(void 0!==b.style[a])return c[a]},c=function(b,c,d){this.setting={axis:"y",reverse:!1,trigger:"click",speed:500,forceHeight:!1,forceWidth:!1,autoSize:!0,front:".front",back:".back"},this.setting=a.extend(this.setting,c),"string"!=typeof c.axis||"x"!==c.axis.toLowerCase()&&"y"!==c.axis.toLowerCase()||(this.setting.axis=c.axis.toLowerCase()),"boolean"==typeof c.reverse&&(this.setting.reverse=c.reverse),"string"==typeof c.trigger&&(this.setting.trigger=c.trigger.toLowerCase());var e=parseInt(c.speed);isNaN(e)||(this.setting.speed=e),"boolean"==typeof c.forceHeight&&(this.setting.forceHeight=c.forceHeight),"boolean"==typeof c.forceWidth&&(this.setting.forceWidth=c.forceWidth),"boolean"==typeof c.autoSize&&(this.setting.autoSize=c.autoSize),("string"==typeof c.front||c.front instanceof a)&&(this.setting.front=c.front),("string"==typeof c.back||c.back instanceof a)&&(this.setting.back=c.back),this.element=b,this.frontElement=this.getFrontElement(),this.backElement=this.getBackElement(),this.isFlipped=!1,this.init(d)};a.extend(c.prototype,{flipDone:function(a){var c=this;c.element.one(b(),function(){c.element.trigger("flip:done"),"function"==typeof a&&a.call(c.element)})},flip:function(a){if(!this.isFlipped){this.isFlipped=!0;var b="rotate"+this.setting.axis;this.frontElement.css({transform:b+(this.setting.reverse?"(-180deg)":"(180deg)"),"z-index":"0"}),this.backElement.css({transform:b+"(0deg)","z-index":"1"}),this.flipDone(a)}},unflip:function(a){if(this.isFlipped){this.isFlipped=!1;var b="rotate"+this.setting.axis;this.frontElement.css({transform:b+"(0deg)","z-index":"1"}),this.backElement.css({transform:b+(this.setting.reverse?"(180deg)":"(-180deg)"),"z-index":"0"}),this.flipDone(a)}},getFrontElement:function(){return this.setting.front instanceof a?this.setting.front:this.element.find(this.setting.front)},getBackElement:function(){return this.setting.back instanceof a?this.setting.back:this.element.find(this.setting.back)},init:function(a){var b=this,c=b.frontElement.add(b.backElement),d="rotate"+b.setting.axis,e=2*b.element["outer"+("rotatex"===d?"Height":"Width")](),f={perspective:e,position:"relative"},g={transform:d+"("+(b.setting.reverse?"180deg":"-180deg")+")","z-index":"0",position:"relative"},h={"backface-visibility":"hidden","transform-style":"preserve-3d",position:"absolute","z-index":"1"};b.setting.forceHeight?c.outerHeight(b.element.height()):b.setting.autoSize&&(h.height="100%"),b.setting.forceWidth?c.outerWidth(b.element.width()):b.setting.autoSize&&(h.width="100%"),(window.chrome||window.Intl&&Intl.v8BreakIterator)&&"CSS"in window&&(f["-webkit-transform-style"]="preserve-3d"),c.css(h).find("*").css({"backface-visibility":"hidden"}),b.element.css(f),b.backElement.css(g),setTimeout(function(){var d=b.setting.speed/1e3||.5;c.css({transition:"all "+d+"s ease-out"}),"function"==typeof a&&a.call(b.element)},20),b.attachEvents()},clickHandler:function(b){b||(b=window.event),this.element.find(a(b.target).closest('button, a, input[type="submit"]')).length||(this.isFlipped?this.unflip():this.flip())},hoverHandler:function(){var b=this;b.element.off("mouseleave.flip"),b.flip(),setTimeout(function(){b.element.on("mouseleave.flip",a.proxy(b.unflip,b)),b.element.is(":hover")||b.unflip()},b.setting.speed+150)},attachEvents:function(){var b=this;"click"===b.setting.trigger?b.element.on(a.fn.tap?"tap.flip":"click.flip",a.proxy(b.clickHandler,b)):"hover"===b.setting.trigger&&(b.element.on("mouseenter.flip",a.proxy(b.hoverHandler,b)),b.element.on("mouseleave.flip",a.proxy(b.unflip,b)))},flipChanged:function(a){this.element.trigger("flip:change"),"function"==typeof a&&a.call(this.element)},changeSettings:function(a,b){var c=this,d=!1;if(void 0!==a.axis&&c.setting.axis!==a.axis.toLowerCase()&&(c.setting.axis=a.axis.toLowerCase(),d=!0),void 0!==a.reverse&&c.setting.reverse!==a.reverse&&(c.setting.reverse=a.reverse,d=!0),d){var e=c.frontElement.add(c.backElement),f=e.css(["transition-property","transition-timing-function","transition-duration","transition-delay"]);e.css({transition:"none"});var g="rotate"+c.setting.axis;c.isFlipped?c.frontElement.css({transform:g+(c.setting.reverse?"(-180deg)":"(180deg)"),"z-index":"0"}):c.backElement.css({transform:g+(c.setting.reverse?"(180deg)":"(-180deg)"),"z-index":"0"}),setTimeout(function(){e.css(f),c.flipChanged(b)},0)}else c.flipChanged(b)}}),a.fn.flip=function(b,d){return"function"==typeof b&&(d=b),"string"==typeof b||"boolean"==typeof b?this.each(function(){var c=a(this).data("flip-model");"toggle"===b&&(b=!c.isFlipped),b?c.flip(d):c.unflip(d)}):this.each(function(){if(a(this).data("flip-model")){var e=a(this).data("flip-model");!b||void 0===b.axis&&void 0===b.reverse||e.changeSettings(b,d)}else a(this).data("flip-model",new c(a(this),b||{},d))}),this}}(jQuery);
//# sourceMappingURL=jquery.flip.min.js.map
/*!
 * jQuery initialize - v1.0.0 - 12/14/2016
 * https://github.com/adampietrasiak/jquery.initialize
 *
 * Copyright (c) 2015-2016 Adam Pietrasiak
 * Released under the MIT license
 * https://github.com/timpler/jquery.initialize/blob/master/LICENSE
 */
;(function ($) {
    // MutationSelectorObserver represents a selector and it's associated initialization callback.
    var MutationSelectorObserver = function (selector, callback) {
        this.selector = selector;
        this.callback = callback;
    };

    // List of MutationSelectorObservers.
    var msobservers = [];
    msobservers.initialize = function (selector, callback) {

        // Wrap the callback so that we can ensure that it is only
        // called once per element.
        var seen = [];
        var callbackOnce = function () {
            if (seen.indexOf(this) == -1) {
                seen.push(this);
                $(this).each(callback);
            }
        };

        // See if the selector matches any elements already on the page.
        $(selector).each(callbackOnce);

        // Then, add it to the list of selector observers.
        this.push(new MutationSelectorObserver(selector, callbackOnce));
    };

    // The MutationObserver watches for when new elements are added to the DOM.
    var observer = new MutationObserver(function (mutations) {

        // For each MutationSelectorObserver currently registered.
        for (var j = 0; j < msobservers.length; j++) {
            $(msobservers[j].selector).each(msobservers[j].callback);
        }
    });

    // Observe the entire document.
    observer.observe(document.documentElement, {childList: true, subtree: true, attributes: true});

    // Deprecated API (does not work with jQuery >= 3.1.1):
    $.fn.initialize = function (callback) {
        msobservers.initialize(this.selector, callback);
    };
    $.initialize = function (selector, callback) {
        msobservers.initialize(selector, callback);
    };
})(jQuery);

/**
 * menu-aim is a jQuery plugin for dropdown menus that can differentiate
 * between a user trying hover over a dropdown item vs trying to navigate into
 * a submenu's contents.
 *
 * menu-aim assumes that you have are using a menu with submenus that expand
 * to the menu's right. It will fire events when the user's mouse enters a new
 * dropdown item *and* when that item is being intentionally hovered over.
 *
 * __________________________
 * | Monkeys  >|   Gorilla  |
 * | Gorillas >|   Content  |
 * | Chimps   >|   Here     |
 * |___________|____________|
 *
 * In the above example, "Gorillas" is selected and its submenu content is
 * being shown on the right. Imagine that the user's cursor is hovering over
 * "Gorillas." When they move their mouse into the "Gorilla Content" area, they
 * may briefly hover over "Chimps." This shouldn't close the "Gorilla Content"
 * area.
 *
 * This problem is normally solved using timeouts and delays. menu-aim tries to
 * solve this by detecting the direction of the user's mouse movement. This can
 * make for quicker transitions when navigating up and down the menu. The
 * experience is hopefully similar to amazon.com/'s "Shop by Department"
 * dropdown.
 *
 * Use like so:
 *
 *      $("#menu").menuAim({
 *          activate: $.noop,  // fired on row activation
 *          deactivate: $.noop  // fired on row deactivation
 *      });
 *
 *  ...to receive events when a menu's row has been purposefully (de)activated.
 *
 * The following options can be passed to menuAim. All functions execute with
 * the relevant row's HTML element as the execution context ('this'):
 *
 *      .menuAim({
 *          // Function to call when a row is purposefully activated. Use this
 *          // to show a submenu's content for the activated row.
 *          activate: function() {},
 *
 *          // Function to call when a row is deactivated.
 *          deactivate: function() {},
 *
 *          // Function to call when mouse enters a menu row. Entering a row
 *          // does not mean the row has been activated, as the user may be
 *          // mousing over to a submenu.
 *          enter: function() {},
 *
 *          // Function to call when mouse exits a menu row.
 *          exit: function() {},
 *
 *          // Selector for identifying which elements in the menu are rows
 *          // that can trigger the above events. Defaults to "> li".
 *          rowSelector: "> li",
 *
 *          // You may have some menu rows that aren't submenus and therefore
 *          // shouldn't ever need to "activate." If so, filter submenu rows w/
 *          // this selector. Defaults to "*" (all elements).
 *          submenuSelector: "*",
 *
 *          // Direction the submenu opens relative to the main menu. Can be
 *          // left, right, above, or below. Defaults to "right".
 *          submenuDirection: "right"
 *      });
 *
 * https://github.com/kamens/jQuery-menu-aim
*/
(function($) {

    $.fn.menuAim = function(opts) {
        // Initialize menu-aim for all elements in jQuery collection
        this.each(function() {
            init.call(this, opts);
        });

        return this;
    };

    function init(opts) {
        var $menu = $(this),
            activeRow = null,
            mouseLocs = [],
            lastDelayLoc = null,
            timeoutId = null,
            options = $.extend({
                rowSelector: "> li",
                submenuSelector: "*",
                submenuDirection: "right",
                tolerance: 75,  // bigger = more forgivey when entering submenu
                enter: $.noop,
                exit: $.noop,
                activate: $.noop,
                deactivate: $.noop,
                exitMenu: $.noop
            }, opts);

        var MOUSE_LOCS_TRACKED = 3,  // number of past mouse locations to track
            DELAY = 300;  // ms delay when user appears to be entering submenu

        /**
         * Keep track of the last few locations of the mouse.
         */
        var mousemoveDocument = function(e) {
                mouseLocs.push({x: e.pageX, y: e.pageY});

                if (mouseLocs.length > MOUSE_LOCS_TRACKED) {
                    mouseLocs.shift();
                }
            };

        /**
         * Cancel possible row activations when leaving the menu entirely
         */
        var mouseleaveMenu = function() {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }

                // If exitMenu is supplied and returns true, deactivate the
                // currently active row on menu exit.
                if (options.exitMenu(this)) {
                    if (activeRow) {
                        options.deactivate(activeRow);
                    }

                    activeRow = null;
                }
            };

        /**
         * Trigger a possible row activation whenever entering a new row.
         */
        var mouseenterRow = function() {
                if (timeoutId) {
                    // Cancel any previous activation delays
                    clearTimeout(timeoutId);
                }

                options.enter(this);
                possiblyActivate(this);
            },
            mouseleaveRow = function() {
                options.exit(this);
            };

        /*
         * Immediately activate a row if the user clicks on it.
         */
        var clickRow = function() {
                activate(this);
            };

        /**
         * Activate a menu row.
         */
        var activate = function(row) {
                if (row == activeRow) {
                    return;
                }

                if (activeRow) {
                    options.deactivate(activeRow);
                }

                options.activate(row);
                activeRow = row;
            };

        /**
         * Possibly activate a menu row. If mouse movement indicates that we
         * shouldn't activate yet because user may be trying to enter
         * a submenu's content, then delay and check again later.
         */
        var possiblyActivate = function(row) {
                var delay = activationDelay();

                if (delay) {
                    timeoutId = setTimeout(function() {
                        possiblyActivate(row);
                    }, delay);
                } else {
                    activate(row);
                }
            };

        /**
         * Return the amount of time that should be used as a delay before the
         * currently hovered row is activated.
         *
         * Returns 0 if the activation should happen immediately. Otherwise,
         * returns the number of milliseconds that should be delayed before
         * checking again to see if the row should be activated.
         */
        var activationDelay = function() {
                if (!activeRow || !$(activeRow).is(options.submenuSelector)) {
                    // If there is no other submenu row already active, then
                    // go ahead and activate immediately.
                    return 0;
                }

                var offset = $menu.offset(),
                    upperLeft = {
                        x: offset.left,
                        y: offset.top - options.tolerance
                    },
                    upperRight = {
                        x: offset.left + $menu.outerWidth(),
                        y: upperLeft.y
                    },
                    lowerLeft = {
                        x: offset.left,
                        y: offset.top + $menu.outerHeight() + options.tolerance
                    },
                    lowerRight = {
                        x: offset.left + $menu.outerWidth(),
                        y: lowerLeft.y
                    },
                    loc = mouseLocs[mouseLocs.length - 1],
                    prevLoc = mouseLocs[0];

                if (!loc) {
                    return 0;
                }

                if (!prevLoc) {
                    prevLoc = loc;
                }

                if (prevLoc.x < offset.left || prevLoc.x > lowerRight.x ||
                    prevLoc.y < offset.top || prevLoc.y > lowerRight.y) {
                    // If the previous mouse location was outside of the entire
                    // menu's bounds, immediately activate.
                    return 0;
                }

                if (lastDelayLoc &&
                        loc.x == lastDelayLoc.x && loc.y == lastDelayLoc.y) {
                    // If the mouse hasn't moved since the last time we checked
                    // for activation status, immediately activate.
                    return 0;
                }

                // Detect if the user is moving towards the currently activated
                // submenu.
                //
                // If the mouse is heading relatively clearly towards
                // the submenu's content, we should wait and give the user more
                // time before activating a new row. If the mouse is heading
                // elsewhere, we can immediately activate a new row.
                //
                // We detect this by calculating the slope formed between the
                // current mouse location and the upper/lower right points of
                // the menu. We do the same for the previous mouse location.
                // If the current mouse location's slopes are
                // increasing/decreasing appropriately compared to the
                // previous's, we know the user is moving toward the submenu.
                //
                // Note that since the y-axis increases as the cursor moves
                // down the screen, we are looking for the slope between the
                // cursor and the upper right corner to decrease over time, not
                // increase (somewhat counterintuitively).
                function slope(a, b) {
                    return (b.y - a.y) / (b.x - a.x);
                };

                var decreasingCorner = upperRight,
                    increasingCorner = lowerRight;

                // Our expectations for decreasing or increasing slope values
                // depends on which direction the submenu opens relative to the
                // main menu. By default, if the menu opens on the right, we
                // expect the slope between the cursor and the upper right
                // corner to decrease over time, as explained above. If the
                // submenu opens in a different direction, we change our slope
                // expectations.
                if (options.submenuDirection == "left") {
                    decreasingCorner = lowerLeft;
                    increasingCorner = upperLeft;
                } else if (options.submenuDirection == "below") {
                    decreasingCorner = lowerRight;
                    increasingCorner = lowerLeft;
                } else if (options.submenuDirection == "above") {
                    decreasingCorner = upperLeft;
                    increasingCorner = upperRight;
                }

                var decreasingSlope = slope(loc, decreasingCorner),
                    increasingSlope = slope(loc, increasingCorner),
                    prevDecreasingSlope = slope(prevLoc, decreasingCorner),
                    prevIncreasingSlope = slope(prevLoc, increasingCorner);

                if (decreasingSlope < prevDecreasingSlope &&
                        increasingSlope > prevIncreasingSlope) {
                    // Mouse is moving from previous location towards the
                    // currently activated submenu. Delay before activating a
                    // new menu row, because user may be moving into submenu.
                    lastDelayLoc = loc;
                    return DELAY;
                }

                lastDelayLoc = null;
                return 0;
            };

        /**
         * Hook up initial menu events
         */
        $menu
            .mouseleave(mouseleaveMenu)
            .find(options.rowSelector)
                .mouseenter(mouseenterRow)
                .mouseleave(mouseleaveRow)
                .click(clickRow);

        $(document).mousemove(mousemoveDocument);

    };
})(jQuery);


/*!
 * parallax.js v1.4.2 (http://pixelcog.github.io/parallax.js/)
 * @copyright 2016 PixelCog, Inc.
 * @license MIT (https://github.com/pixelcog/parallax.js/blob/master/LICENSE)
 */
!function(t,i,e,s){function o(i,e){var h=this;"object"==typeof e&&(delete e.refresh,delete e.render,t.extend(this,e)),this.$element=t(i),!this.imageSrc&&this.$element.is("img")&&(this.imageSrc=this.$element.attr("src"));var r=(this.position+"").toLowerCase().match(/\S+/g)||[];if(r.length<1&&r.push("center"),1==r.length&&r.push(r[0]),("top"==r[0]||"bottom"==r[0]||"left"==r[1]||"right"==r[1])&&(r=[r[1],r[0]]),this.positionX!=s&&(r[0]=this.positionX.toLowerCase()),this.positionY!=s&&(r[1]=this.positionY.toLowerCase()),h.positionX=r[0],h.positionY=r[1],"left"!=this.positionX&&"right"!=this.positionX&&(this.positionX=isNaN(parseInt(this.positionX))?"center":parseInt(this.positionX)),"top"!=this.positionY&&"bottom"!=this.positionY&&(this.positionY=isNaN(parseInt(this.positionY))?"center":parseInt(this.positionY)),this.position=this.positionX+(isNaN(this.positionX)?"":"px")+" "+this.positionY+(isNaN(this.positionY)?"":"px"),navigator.userAgent.match(/(iPod|iPhone|iPad)/))return this.imageSrc&&this.iosFix&&!this.$element.is("img")&&this.$element.css({backgroundImage:"url("+this.imageSrc+")",backgroundSize:"cover",backgroundPosition:this.position}),this;if(navigator.userAgent.match(/(Android)/))return this.imageSrc&&this.androidFix&&!this.$element.is("img")&&this.$element.css({backgroundImage:"url("+this.imageSrc+")",backgroundSize:"cover",backgroundPosition:this.position}),this;this.$mirror=t("<div />").prependTo("body");var a=this.$element.find(">.parallax-slider"),n=!1;0==a.length?this.$slider=t("<img />").prependTo(this.$mirror):(this.$slider=a.prependTo(this.$mirror),n=!0),this.$mirror.addClass("parallax-mirror").css({visibility:"hidden",zIndex:this.zIndex,position:"fixed",top:0,left:0,overflow:"hidden"}),this.$slider.addClass("parallax-slider").one("load",function(){h.naturalHeight&&h.naturalWidth||(h.naturalHeight=this.naturalHeight||this.height||1,h.naturalWidth=this.naturalWidth||this.width||1),h.aspectRatio=h.naturalWidth/h.naturalHeight,o.isSetup||o.setup(),o.sliders.push(h),o.isFresh=!1,o.requestRender()}),n||(this.$slider[0].src=this.imageSrc),(this.naturalHeight&&this.naturalWidth||this.$slider[0].complete||a.length>0)&&this.$slider.trigger("load")}function h(s){return this.each(function(){var h=t(this),r="object"==typeof s&&s;this==i||this==e||h.is("body")?o.configure(r):h.data("px.parallax")?"object"==typeof s&&t.extend(h.data("px.parallax"),r):(r=t.extend({},h.data(),r),h.data("px.parallax",new o(this,r))),"string"==typeof s&&("destroy"==s?o.destroy(this):o[s]())})}!function(){for(var t=0,e=["ms","moz","webkit","o"],s=0;s<e.length&&!i.requestAnimationFrame;++s)i.requestAnimationFrame=i[e[s]+"RequestAnimationFrame"],i.cancelAnimationFrame=i[e[s]+"CancelAnimationFrame"]||i[e[s]+"CancelRequestAnimationFrame"];i.requestAnimationFrame||(i.requestAnimationFrame=function(e){var s=(new Date).getTime(),o=Math.max(0,16-(s-t)),h=i.setTimeout(function(){e(s+o)},o);return t=s+o,h}),i.cancelAnimationFrame||(i.cancelAnimationFrame=function(t){clearTimeout(t)})}(),t.extend(o.prototype,{speed:.2,bleed:0,zIndex:-100,iosFix:!0,androidFix:!0,position:"center",overScrollFix:!1,refresh:function(){this.boxWidth=this.$element.outerWidth(),this.boxHeight=this.$element.outerHeight()+2*this.bleed,this.boxOffsetTop=this.$element.offset().top-this.bleed,this.boxOffsetLeft=this.$element.offset().left,this.boxOffsetBottom=this.boxOffsetTop+this.boxHeight;var t=o.winHeight,i=o.docHeight,e=Math.min(this.boxOffsetTop,i-t),s=Math.max(this.boxOffsetTop+this.boxHeight-t,0),h=this.boxHeight+(e-s)*(1-this.speed)|0,r=(this.boxOffsetTop-e)*(1-this.speed)|0;if(h*this.aspectRatio>=this.boxWidth){this.imageWidth=h*this.aspectRatio|0,this.imageHeight=h,this.offsetBaseTop=r;var a=this.imageWidth-this.boxWidth;this.offsetLeft="left"==this.positionX?0:"right"==this.positionX?-a:isNaN(this.positionX)?-a/2|0:Math.max(this.positionX,-a)}else{this.imageWidth=this.boxWidth,this.imageHeight=this.boxWidth/this.aspectRatio|0,this.offsetLeft=0;var a=this.imageHeight-h;this.offsetBaseTop="top"==this.positionY?r:"bottom"==this.positionY?r-a:isNaN(this.positionY)?r-a/2|0:r+Math.max(this.positionY,-a)}},render:function(){var t=o.scrollTop,i=o.scrollLeft,e=this.overScrollFix?o.overScroll:0,s=t+o.winHeight;this.boxOffsetBottom>t&&this.boxOffsetTop<=s?(this.visibility="visible",this.mirrorTop=this.boxOffsetTop-t,this.mirrorLeft=this.boxOffsetLeft-i,this.offsetTop=this.offsetBaseTop-this.mirrorTop*(1-this.speed)):this.visibility="hidden",this.$mirror.css({transform:"translate3d(0px, 0px, 0px)",visibility:this.visibility,top:this.mirrorTop-e,left:this.mirrorLeft,height:this.boxHeight,width:this.boxWidth}),this.$slider.css({transform:"translate3d(0px, 0px, 0px)",position:"absolute",top:this.offsetTop,left:this.offsetLeft,height:this.imageHeight,width:this.imageWidth,maxWidth:"none"})}}),t.extend(o,{scrollTop:0,scrollLeft:0,winHeight:0,winWidth:0,docHeight:1<<30,docWidth:1<<30,sliders:[],isReady:!1,isFresh:!1,isBusy:!1,setup:function(){if(!this.isReady){var s=t(e),h=t(i),r=function(){o.winHeight=h.height(),o.winWidth=h.width(),o.docHeight=s.height(),o.docWidth=s.width()},a=function(){var t=h.scrollTop(),i=o.docHeight-o.winHeight,e=o.docWidth-o.winWidth;o.scrollTop=Math.max(0,Math.min(i,t)),o.scrollLeft=Math.max(0,Math.min(e,h.scrollLeft())),o.overScroll=Math.max(t-i,Math.min(t,0))};h.on("resize.px.parallax load.px.parallax",function(){r(),o.isFresh=!1,o.requestRender()}).on("scroll.px.parallax load.px.parallax",function(){a(),o.requestRender()}),r(),a(),this.isReady=!0}},configure:function(i){"object"==typeof i&&(delete i.refresh,delete i.render,t.extend(this.prototype,i))},refresh:function(){t.each(this.sliders,function(){this.refresh()}),this.isFresh=!0},render:function(){this.isFresh||this.refresh(),t.each(this.sliders,function(){this.render()})},requestRender:function(){var t=this;this.isBusy||(this.isBusy=!0,i.requestAnimationFrame(function(){t.render(),t.isBusy=!1}))},destroy:function(e){var s,h=t(e).data("px.parallax");for(h.$mirror.remove(),s=0;s<this.sliders.length;s+=1)this.sliders[s]==h&&this.sliders.splice(s,1);t(e).data("px.parallax",!1),0===this.sliders.length&&(t(i).off("scroll.px.parallax resize.px.parallax load.px.parallax"),this.isReady=!1,o.isSetup=!1)}});var r=t.fn.parallax;t.fn.parallax=h,t.fn.parallax.Constructor=o,t.fn.parallax.noConflict=function(){return t.fn.parallax=r,this},t(e).on("ready.px.parallax.data-api",function(){t('[data-parallax="scroll"]').parallax()})}(jQuery,window,document);

/*
 * Pick (for jQuery)
 * version: 1.0 (10/07/2010)
 * @requires any version of jQuery
 *
 * Licensed under the MIT:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2010, 2010 Caroline Hill [ mllegeorgesand@gmail.com ]
 *
 * Usage:
 *
 *  jQuery(document).ready(function() {
 *    jQuery('#gallery li').pick(6);
 *  })
 *
 *  The above will randomly pick 6 elements from the wrapped set, and
 *  remove others from the document.
 *
 *  What is returned is the wrapped set of picked elements.
 *  The removed elements are no longer in that set.
 *
 *  Ex:
 *
 *  var how_many = jQuery('#gallery li').pick(6).size(); // Will return 6.
 *
 */

(function( $ ){
  $.fn.pick = function(how_many) {
    
    var how_many = how_many || 4;
  
    // Picking random numbers without repeating. 
    var index_array = [];
    var original_obj_size = this.size();
    for (var i=0; i<original_obj_size; i++) {
      index_array.push(i);
    }
    //+ Jonas Raoni Soares Silva
    //@ http://jsfromhell.com/array/shuffle [rev. #1]
    var shuffle = function(v) {
      for (var j, x, i = v.length; i; j = parseInt(Math.random() * i), x = v[--i], v[i] = v[j], v[j] = x);
      return v;
    };
    var new_index_array = shuffle(index_array).slice(0,how_many);
    
    // Ditching unpicked elements and removing those from the returned set.
    return this.each(function(i) {
       if ($.inArray(i,new_index_array) === -1) {
          $(this).remove();
       }
    }).filter(function() {
      if (this.parentNode === null) {
        return false;
      }
      else {
        return true;
      }
    });

  };
})( jQuery );
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.5.9
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return '<button type="button" data-role="none" role="button" aria-required="false" tabindex="0">' + (i + 1) + '</button>';
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: false,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.hidden = 'hidden';
            _.paused = false;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, dataSettings, settings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);
            _.checkResponsive(true);

        }

        return Slick;

    }());

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

        if (_.slideCount > _.options.slidesToShow && _.paused !== true) {
            _.autoPlayTimer = setInterval(_.autoPlayIterator,
                _.options.autoplaySpeed);
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;
        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this;

        if (_.options.infinite === false) {

            if (_.direction === 1) {

                if ((_.currentSlide + 1) === _.slideCount -
                    1) {
                    _.direction = 0;
                }

                _.slideHandler(_.currentSlide + _.options.slidesToScroll);

            } else {

                if ((_.currentSlide - 1 === 0)) {

                    _.direction = 1;

                }

                _.slideHandler(_.currentSlide - _.options.slidesToScroll);

            }

        } else {

            _.slideHandler(_.currentSlide + _.options.slidesToScroll);

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dotString;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            dotString = '<ul class="' + _.options.dotsClass + '">';

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dotString += '<li>' + _.options.customPaging.call(this, _, i) + '</li>';
            }

            dotString += '</ul>';

            _.$dots = $(dotString).appendTo(
                _.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div aria-live="polite" class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 1) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.html(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.target),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots).off('click.slick', _.changeSlide);

            if (_.options.pauseOnDotsHover === true && _.options.autoplay === true) {

                $('li', _.$dots)
                    .off('mouseenter.slick', $.proxy(_.setPaused, _, true))
                    .off('mouseleave.slick', $.proxy(_.setPaused, _, false));

            }

        }

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.$list.off('mouseenter.slick', $.proxy(_.setPaused, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.setPaused, _, false));

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);
    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 1) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.html(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }


        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css("display","");

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css("display","");

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }

        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                verticalOffset = (verticalHeight * _.options.slidesToShow) * -1;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.on('click.slick', {
                message: 'previous'
            }, _.changeSlide);
            _.$nextArrow.on('click.slick', {
                message: 'next'
            }, _.changeSlide);
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.options.autoplay === true) {
            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.setPaused, _, true))
                .on('mouseleave.slick', $.proxy(_.setPaused, _, false));
        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        _.$list.on('mouseenter.slick', $.proxy(_.setPaused, _, true));
        _.$list.on('mouseleave.slick', $.proxy(_.setPaused, _, false));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

        if (_.options.autoplay === true) {

            _.autoPlay();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: 'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {
            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {
                    image
                        .animate({ opacity: 0 }, 100, function() {
                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy')
                                        .removeClass('slick-loading');
                                });
                        });
                };

                imageToLoad.src = imageSource;

            });
        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = rangeStart + _.options.slidesToShow;
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.paused = false;
        _.autoPlay();

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        _.$slider.trigger('afterChange', [_, index]);

        _.animating = false;

        _.setPosition();

        _.swipeLeft = null;

        if (_.options.autoplay === true && _.paused === false) {
            _.autoPlay();
        }
        if (_.options.accessibility === true) {
            _.initADA();
        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {
        event.preventDefault();
    };

    Slick.prototype.progressiveLazyLoad = function() {

        var _ = this,
            imgCount, targetImage;

        imgCount = $('img[data-lazy]', _.$slider).length;

        if (imgCount > 0) {
            targetImage = $('img[data-lazy]', _.$slider).first();
            targetImage.attr('src', null);
            targetImage.attr('src', targetImage.attr('data-lazy')).removeClass('slick-loading').load(function() {
                    targetImage.removeAttr('data-lazy');
                    _.progressiveLazyLoad();

                    if (_.options.adaptiveHeight === true) {
                        _.setPosition();
                    }
                })
                .error(function() {
                    targetImage.removeAttr('data-lazy');
                    _.progressiveLazyLoad();
                });
        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, firstVisible;

        firstVisible = _.slideCount - _.options.slidesToShow;

        // check that the new breakpoint can actually accept the
        // "current slide" as the current slide, otherwise we need
        // to set it to the closest possible value.
        if ( !_.options.infinite ) {
            if ( _.slideCount <= _.options.slidesToShow ) {
                _.currentSlide = 0;
            } else if ( _.currentSlide > firstVisible ) {
                _.currentSlide = firstVisible;
            }
        }

         currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === "array" && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;
                currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(0);

        _.setPosition();

        _.$slider.trigger('reInit', [_]);

        if (_.options.autoplay === true) {
            _.focusHandler();
        }

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption = Slick.prototype.slickSetOption = function(option, value, refresh) {

        var _ = this, l, item;

        if( option === "responsive" && $.type(value) === "array" ) {
            for ( item in value ) {
                if( $.type( _.options.responsive ) !== "array" ) {
                    _.options.responsive = [ value[item] ];
                } else {
                    l = _.options.responsive.length-1;
                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {
                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {
                            _.options.responsive.splice(l,1);
                        }
                        l--;
                    }
                    _.options.responsive.push( value[item] );
                }
            }
        } else {
            _.options[option] = value;
        }

        if (refresh === true) {
            _.unload();
            _.reinit();
        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {

                    _.$slides
                        .slice(index - centerOffset, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand') {
            _.lazyLoad();
        }

    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.setPaused = function(paused) {

        var _ = this;

        if (_.options.autoplay === true && _.options.pauseOnHover === true) {
            _.paused = paused;
            if (!paused) {
                _.autoPlay();
            } else {
                _.autoPlayClear();
            }
        }
    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.setSlideClasses(index);
            _.asNavFor(index);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if (_.options.autoplay === true) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'left';
            } else {
                return 'right';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount;

        _.dragging = false;

        _.shouldClick = (_.touchObject.swipeLength > 10) ? false : true;

        if (_.touchObject.curX === undefined) {
            return false;
        }

        if (_.touchObject.edgeHit === true) {
            _.$slider.trigger('edge', [_, _.swipeDirection()]);
        }

        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {

            switch (_.swipeDirection()) {
                case 'left':
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
                    _.slideHandler(slideCount);
                    _.currentDirection = 0;
                    _.touchObject = {};
                    _.$slider.trigger('swipe', [_, 'left']);
                    break;

                case 'right':
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
                    _.slideHandler(slideCount);
                    _.currentDirection = 1;
                    _.touchObject = {};
                    _.$slider.trigger('swipe', [_, 'right']);
                    break;
            }
        } else {
            if (_.touchObject.startX !== _.touchObject.curX) {
                _.slideHandler(_.currentSlide);
                _.touchObject = {};
            }
        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = Math.round(Math.sqrt(
                Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        }

        swipeDirection = _.swipeDirection();

        if (swipeDirection === 'vertical') {
            return;
        }

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                .removeClass('slick-active')
                .attr('aria-hidden', 'true');

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active')
                .attr('aria-hidden', 'false');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if (document[_.hidden]) {
            _.paused = true;
            _.autoPlayClear();
        } else {
            if (_.options.autoplay === true) {
                _.paused = false;
                _.autoPlay();
            }
        }

    };
    Slick.prototype.initADA = function() {
        var _ = this;
        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        _.$slideTrack.attr('role', 'listbox');

        _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
            $(this).attr({
                'role': 'option',
                'aria-describedby': 'slick-slide' + _.instanceUid + i + ''
            });
        });

        if (_.$dots !== null) {
            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                $(this).attr({
                    'role': 'presentation',
                    'aria-selected': 'false',
                    'aria-controls': 'navigation' + _.instanceUid + i + '',
                    'id': 'slick-slide' + _.instanceUid + i + ''
                });
            })
                .first().attr('aria-selected', 'true').end()
                .find('button').attr('role', 'button').end()
                .closest('div').attr('role', 'toolbar');
        }
        _.activateADA();

    };

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.focusHandler = function() {
        var _ = this;
        _.$slider.on('focus.slick blur.slick', '*', function(event) {
            event.stopImmediatePropagation();
            var sf = $(this);
            setTimeout(function() {
                if (_.isPlay) {
                    if (sf.is(':focus')) {
                        _.autoPlayClear();
                        _.paused = true;
                    } else {
                        _.paused = false;
                        _.autoPlay();
                    }
                }
            }, 0);
        });
    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));

!function(e) {
  var t = {};
  function i(n) {
      if (t[n])
          return t[n].exports;
      var r = t[n] = {
          i: n,
          l: !1,
          exports: {}
      };
      return e[n].call(r.exports, r, r.exports, i),
      r.l = !0,
      r.exports
  }
  i.m = e,
  i.c = t,
  i.d = function(e, t, n) {
      i.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: n
      })
  }
  ,
  i.r = function(e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
      }),
      Object.defineProperty(e, "__esModule", {
          value: !0
      })
  }
  ,
  i.t = function(e, t) {
      if (1 & t && (e = i(e)),
      8 & t)
          return e;
      if (4 & t && "object" == typeof e && e && e.__esModule)
          return e;
      var n = Object.create(null);
      if (i.r(n),
      Object.defineProperty(n, "default", {
          enumerable: !0,
          value: e
      }),
      2 & t && "string" != typeof e)
          for (var r in e)
              i.d(n, r, function(t) {
                  return e[t]
              }
              .bind(null, r));
      return n
  }
  ,
  i.n = function(e) {
      var t = e && e.__esModule ? function() {
          return e.default
      }
      : function() {
          return e
      }
      ;
      return i.d(t, "a", t),
      t
  }
  ,
  i.o = function(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t)
  }
  ,
  i.p = "/",
  i(i.s = 205)
}([function(e, t, i) {
  "use strict";
  var n = function(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "_on"
        , i = {}
        , n = Reflect.ownKeys(Reflect.getPrototypeOf(e))
        , r = !0
        , o = !1
        , s = void 0;
      try {
          for (var a, l = n[Symbol.iterator](); !(r = (a = l.next()).done); r = !0) {
              var c = a.value;
              0 === c.indexOf(t) && (i[c] = e[c].bind(e))
          }
      } catch (e) {
          o = !0,
          s = e
      } finally {
          try {
              r || null == l.return || l.return()
          } finally {
              if (o)
                  throw s
          }
      }
      return i
  }
    , r = function() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0]
        , t = window.navigator.userAgent
        , i = !!t.match(/iPad/i) || !!t.match(/iPhone/i)
        , n = !!t.match(/WebKit/i)
        , r = i && n && !t.match(/CriOS/i)
        , o = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      return e && (o && document.body.classList.add("is-safari"),
      r && document.body.classList.add("is-safari-ios")),
      {
          safari: o,
          safariIos: r
      }
  }
    , o = function() {
      return window.addEventListener("touchstart", function e() {
          document.body.classList.add("is-user-touch"),
          window.removeEventListener("touchstart", e, !1)
      }, !1),
      "ontouchstart"in document.documentElement && document.body.classList.add("is-touch-browser"),
      this
  }
    , s = function(e, t, i, n) {
      return (e /= n) < 1 / 2.75 ? i * (7.5625 * e * e) + t : e < 2 / 2.75 ? i * (7.5625 * (e -= 1.5 / 2.75) * e + .75) + t : e < 2.5 / 2.75 ? i * (7.5625 * (e -= 2.25 / 2.75) * e + .9375) + t : i * (7.5625 * (e -= 2.625 / 2.75) * e + .984375) + t
  }
    , a = function(e, t, i, n) {
      return i - s(n - e, 0, i, n) + t
  }
    , l = {
      easeInQuad: function(e, t, i, n) {
          return i * (e /= n) * e + t
      },
      easeOutQuad: function(e, t, i, n) {
          return -i * (e /= n) * (e - 2) + t
      },
      easeInOutQuad: function(e, t, i, n) {
          return (e /= n / 2) < 1 ? i / 2 * e * e + t : -i / 2 * (--e * (e - 2) - 1) + t
      },
      easeInCubic: function(e, t, i, n) {
          return i * (e /= n) * e * e + t
      },
      easeOutCubic: function(e, t, i, n) {
          return i * ((e = e / n - 1) * e * e + 1) + t
      },
      easeInOutCubic: function(e, t, i, n) {
          return (e /= n / 2) < 1 ? i / 2 * e * e * e + t : i / 2 * ((e -= 2) * e * e + 2) + t
      },
      easeInQuart: function(e, t, i, n) {
          return i * (e /= n) * e * e * e + t
      },
      easeOutQuart: function(e, t, i, n) {
          return -i * ((e = e / n - 1) * e * e * e - 1) + t
      },
      easeInOutQuart: function(e, t, i, n) {
          return (e /= n / 2) < 1 ? i / 2 * e * e * e * e + t : -i / 2 * ((e -= 2) * e * e * e - 2) + t
      },
      easeInQuint: function(e, t, i, n) {
          return i * (e /= n) * e * e * e * e + t
      },
      easeOutQuint: function(e, t, i, n) {
          return i * ((e = e / n - 1) * e * e * e * e + 1) + t
      },
      easeInOutQuint: function(e, t, i, n) {
          return (e /= n / 2) < 1 ? i / 2 * e * e * e * e * e + t : i / 2 * ((e -= 2) * e * e * e * e + 2) + t
      },
      easeInSine: function(e, t, i, n) {
          return -i * Math.cos(e / n * (Math.PI / 2)) + i + t
      },
      easeOutSine: function(e, t, i, n) {
          return i * Math.sin(e / n * (Math.PI / 2)) + t
      },
      easeInOutSine: function(e, t, i, n) {
          return -i / 2 * (Math.cos(Math.PI * e / n) - 1) + t
      },
      easeInExpo: function(e, t, i, n) {
          return 0 == e ? t : i * Math.pow(2, 10 * (e / n - 1)) + t
      },
      easeOutExpo: function(e, t, i, n) {
          return e == n ? t + i : i * (1 - Math.pow(2, -10 * e / n)) + t
      },
      easeInOutExpo: function(e, t, i, n) {
          return 0 == e ? t : e == n ? t + i : (e /= n / 2) < 1 ? i / 2 * Math.pow(2, 10 * (e - 1)) + t : i / 2 * (2 - Math.pow(2, -10 * --e)) + t
      },
      easeInCirc: function(e, t, i, n) {
          return -i * (Math.sqrt(1 - (e /= n) * e) - 1) + t
      },
      easeOutCirc: function(e, t, i, n) {
          return i * Math.sqrt(1 - (e = e / n - 1) * e) + t
      },
      easeInOutCirc: function(e, t, i, n) {
          return (e /= n / 2) < 1 ? -i / 2 * (Math.sqrt(1 - e * e) - 1) + t : i / 2 * (Math.sqrt(1 - (e -= 2) * e) + 1) + t
      },
      easeInElastic: function(e, t, i, n) {
          var r = 1.70158
            , o = 0
            , s = i;
          if (0 == e)
              return t;
          if (1 == (e /= n))
              return t + i;
          if (o || (o = .3 * n),
          s < Math.abs(i)) {
              s = i;
              r = o / 4
          } else
              r = o / (2 * Math.PI) * Math.asin(i / s);
          return -s * Math.pow(2, 10 * (e -= 1)) * Math.sin((e * n - r) * (2 * Math.PI) / o) + t
      },
      easeOutElastic: function(e, t, i, n) {
          var r = 1.70158
            , o = 0
            , s = i;
          if (0 == e)
              return t;
          if (1 == (e /= n))
              return t + i;
          if (o || (o = .3 * n),
          s < Math.abs(i)) {
              s = i;
              r = o / 4
          } else
              r = o / (2 * Math.PI) * Math.asin(i / s);
          return s * Math.pow(2, -10 * e) * Math.sin((e * n - r) * (2 * Math.PI) / o) + i + t
      },
      easeInOutElastic: function(e, t, i, n) {
          var r = 1.70158
            , o = 0
            , s = i;
          if (0 == e)
              return t;
          if (2 == (e /= n / 2))
              return t + i;
          if (o || (o = n * (.3 * 1.5)),
          s < Math.abs(i)) {
              s = i;
              r = o / 4
          } else
              r = o / (2 * Math.PI) * Math.asin(i / s);
          return e < 1 ? s * Math.pow(2, 10 * (e -= 1)) * Math.sin((e * n - r) * (2 * Math.PI) / o) * -.5 + t : s * Math.pow(2, -10 * (e -= 1)) * Math.sin((e * n - r) * (2 * Math.PI) / o) * .5 + i + t
      },
      easeInBack: function(e, t, i, n, r) {
          return null == r && (r = 1.70158),
          i * (e /= n) * e * ((r + 1) * e - r) + t
      },
      easeOutBack: function(e, t, i, n, r) {
          return null == r && (r = 1.70158),
          i * ((e = e / n - 1) * e * ((r + 1) * e + r) + 1) + t
      },
      easeInOutBack: function(e, t, i, n, r) {
          return null == r && (r = 1.70158),
          (e /= n / 2) < 1 ? i / 2 * (e * e * ((1 + (r *= 1.525)) * e - r)) + t : i / 2 * ((e -= 2) * e * ((1 + (r *= 1.525)) * e + r) + 2) + t
      },
      easeInBounce: a,
      easeOutBounce: s,
      easeInOutBounce: function(e, t, i, n) {
          return e < n / 2 ? .5 * a(2 * e, 0, i, n) + t : .5 * s(2 * e - n, 0, i, n) + .5 * i + t
      }
  }
    , c = i(9)
    , u = i.n(c)
    , h = i(2);
  function d(e) {
      return function(e) {
          if (Array.isArray(e)) {
              for (var t = 0, i = new Array(e.length); t < e.length; t++)
                  i[t] = e[t];
              return i
          }
      }(e) || function(e) {
          if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))
              return Array.from(e)
      }(e) || function() {
          throw new TypeError("Invalid attempt to spread non-iterable instance")
      }()
  }
  var p = function(e, t, i, n, r) {
      var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null
        , s = u.a.apply(void 0, d(e))
        , a = Date.now()
        , l = 0
        , c = function() {
          var e = Math.min(1, l / n);
          return t + s(e) * (i - t)
      };
      h.a.on(function e() {
          (l = Date.now() - a) < n ? r(c()) : (r(c()),
          "function" == typeof o && o(c()),
          h.a.off(e))
      })
  }
    , f = function(e) {
      for (var t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null) || e.parentElement.children, i = 0; i < t.length; i++)
          if (e === t[i])
              return i;
      return -1
  }
    , m = function(e) {
      var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]
        , i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : window;
      if (e) {
          var n = e.offsetLeft
            , r = e.offsetTop
            , o = e.offsetWidth
            , s = e.offsetHeight
            , a = {
              top: r,
              bottom: r + s,
              left: n,
              right: n + o,
              width: o,
              height: s,
              centerX: n + o / 2,
              centerY: n + s / 2
          };
          if (t) {
              var l = e.getBoundingClientRect();
              a.scrollTop = l.top + i.scrollY,
              a.scrollBottom = a.scrollTop + a.height,
              a.scrollLeft = l.left + i.scrollX,
              a.scrollRight = a.scrollLeft + a.width
          }
          return a
      }
  }
    , g = function(e) {
      var t;
      if (e) {
          var i = e.indexOf("?");
          i >= 0 ? t = e.substring(i + 1) : -1 === e.indexOf("#") && (t = e)
      } else
          t = window.location.search.substring(1);
      var n = {};
      if (!t)
          return n;
      for (var r = t.split("&"), o = 0; o < r.length; o++) {
          var s = r[o].split("=");
          if (s[0]) {
              var a = s[0]
                , l = s[1] || null;
              n[a] = l
          }
      }
      return n
  }
    , v = i(20)
    , y = function(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "min"
        , i = "min" === t ? "min" : "max"
        , n = "width" === (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "width") ? "width" : "height"
        , r = v.breakpoints[e];
      return "max" === t && r++,
      window.matchMedia("(".concat(i, "-").concat(n, ":").concat(r, "px)")).matches
  }
    , _ = function(e, t, i) {
      var n = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
      if (e)
          for (var r = 0; r < e.length; r++) {
              var o = e[r];
              n && o.removeEventListener(t, i),
              o.addEventListener(t, i)
          }
  }
    , b = function(e, t, i) {
      if (e)
          for (var n = 0; n < e.length; n++) {
              e[n].removeEventListener(t, i)
          }
  };
  function w(e) {
      return function(e) {
          if (Array.isArray(e)) {
              for (var t = 0, i = new Array(e.length); t < e.length; t++)
                  i[t] = e[t];
              return i
          }
      }(e) || function(e) {
          if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))
              return Array.from(e)
      }(e) || function() {
          throw new TypeError("Invalid attempt to spread non-iterable instance")
      }()
  }
  var x = function(e, t, i, n) {
      var r;
      if (e) {
          for (var o = [], s = !1, a = !1, l = 0; l < e.length; l++) {
              var c = e[l]
                , u = {}
                , h = void 0;
              switch (t) {
              case "add":
              case "remove":
                  h = Z.isArray(i) ? i : [i],
                  (r = c.classList)[t].apply(r, w(h));
                  break;
              case "item":
              case "contains":
                  u.target = c,
                  u.value = c.classList[t](i),
                  o.push(u),
                  s = !0,
                  a = !0 === n;
                  break;
              case "toggle":
              case "replace":
                  c.classList[t](i, n)
              }
          }
          if (s) {
              if (a) {
                  for (var d = 0, p = 0; p < o.length; p++)
                      o[p].value && d++;
                  o = d
              }
              return o
          }
      }
      return null
  }
    , k = i(8)
    , S = i.n(k)
    , E = i(39)
    , T = i.n(E)
    , C = i(14)
    , L = i.n(C)
    , A = i(40)
    , P = i.n(A)
    , I = i(41)
    , M = i.n(I)
    , O = i(3)
    , z = i.n(O)
    , D = i(42)
    , R = i.n(D)
    , B = i(43)
    , j = i.n(B)
    , F = i(44)
    , N = i.n(F)
    , U = i(19)
    , q = i.n(U)
    , H = i(45)
    , V = i.n(H)
    , W = i(46)
    , $ = i.n(W)
    , G = i(47)
    , X = i.n(G)
    , Z = {
      isArray: S.a,
      isBoolean: T.a,
      isFunction: L.a,
      isInteger: P.a,
      isNumber: M.a,
      isObject: z.a,
      isString: R.a,
      isUndefined: j.a,
      capitalize: N.a,
      debounce: q.a,
      merge: V.a,
      template: $.a,
      throttle: X.a
  };
  i.d(t, "a", function() {
      return n
  }),
  i.d(t, "b", function() {
      return r
  }),
  i.d(t, "c", function() {
      return o
  }),
  i.d(t, "e", function() {
      return l
  }),
  i.d(t, "d", function() {
      return p
  }),
  i.d(t, "f", function() {
      return f
  }),
  i.d(t, "g", function() {
      return m
  }),
  i.d(t, "h", function() {
      return g
  }),
  i.d(t, "j", function() {
      return y
  }),
  i.d(t, "k", function() {
      return _
  }),
  i.d(t, "m", function() {
      return b
  }),
  i.d(t, "l", function() {
      return x
  }),
  i.d(t, "i", function() {
      return Z
  })
}
, function(e, t, i) {
  "use strict";
  i(9);
  var n = i(0)
    , r = i(2);
  function o(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var s = i(52)
    , a = function() {
      function e() {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.debug = {
              log: !0
          },
          this.objects = {
              subscribers: []
          }
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "on",
          value: function(e, t) {
              var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null
                , n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
              this._addListener(e, t, i, !0, n)
          }
      }, {
          key: "one",
          value: function(e, t) {
              var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null
                , n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
              this._addListener(e, t, i, !1, n)
          }
      }, {
          key: "off",
          value: function(e, t) {
              var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null
                , n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
              this._removeListener(e, t, i, n)
          }
      }, {
          key: "dispatch",
          value: function(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              this._dispatch(e, t)
          }
      }, {
          key: "_addListener",
          value: function(e, t) {
              var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null
                , n = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3]
                , r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
              this.objects.subscribers || (this.objects.subscribers = []),
              this.debug.log && c.lawg("_addListener1", e, t, i, r);
              for (var o = !1, a = 0, l = this.objects.subscribers.length; a < l; a++) {
                  var u = this.objects.subscribers[a];
                  u.eventId !== e || u.callback !== t || u.context !== i && (u.context || i) || u.recurring !== n || !s(subscribe.params, r) || (o = !0)
              }
              this.debug.log && c.lawg("match?", o, e),
              o || this.objects.subscribers.push({
                  eventId: e,
                  callback: t,
                  context: i,
                  recurring: n,
                  params: r
              }),
              this.debug.log && c.lawg("_addListener2", this.objects.subscribers)
          }
      }, {
          key: "_removeListener",
          value: function(e, t) {
              var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null
                , n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
              this.objects.subscribers || (this.objects.subscribers = []);
              for (var r = 0, o = this.objects.subscribers.length; r < o; r++) {
                  var a = this.objects.subscribers[r];
                  if (a.eventId === e && a.callback === t && (a.context === i || !a.context && !i) && s(n)) {
                      this.objects.subscribers.splice(r, 1);
                      break
                  }
              }
          }
      }, {
          key: "_dispatch",
          value: function(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              if (this.objects.subscribers && this.objects.subscribers.length) {
                  for (var i = this.objects.subscribers.concat(), n = [], r = 0, o = i.length; r < o; r++) {
                      var s = i[r];
                      if (s.eventId === e && (n.push(s),
                      !s.recurring)) {
                          var a = this.objects.subscribers.indexOf(s);
                          this.objects.subscribers.splice(a, 1),
                          this.debug.log && c.lawg("splice @", a, s.callback)
                      }
                  }
                  for (var l = 0, u = n.length; l < u; l++) {
                      var h = n[l];
                      h.callback.apply(h.context, [h, t])
                  }
              }
          }
      }, {
          key: "removeAll",
          value: function() {
              this.objects.subscribers = []
          }
      }, {
          key: "reset",
          value: function() {
              this.removeAll()
          }
      }]) && o(t.prototype, i),
      n && o(t, n),
      e
  }();
  i(16);
  function l(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var c = new (function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.config = {
              logInProduction: !1
          },
          Object.assign(this.config, t)
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "assert",
          value: function(e) {
              for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
                  i[n - 1] = arguments[n];
              this.run.apply(this, ["assert", e].concat(i))
          }
      }, {
          key: "clear",
          value: function() {
              this.run("clear")
          }
      }, {
          key: "debug",
          value: function() {
              for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
                  t[i] = arguments[i];
              this.run.apply(this, ["debug"].concat(t))
          }
      }, {
          key: "dir",
          value: function(e, t) {
              this.run("dir", e, t)
          }
      }, {
          key: "dirxml",
          value: function() {
              for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
                  t[i] = arguments[i];
              this.run.apply(this, ["dirxml"].concat(t))
          }
      }, {
          key: "error",
          value: function() {
              for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
                  t[i] = arguments[i];
              this.run.apply(this, ["error"].concat(t))
          }
      }, {
          key: "info",
          value: function() {
              for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
                  t[i] = arguments[i];
              this.run.apply(this, ["info"].concat(t))
          }
      }, {
          key: "lawg",
          value: function() {
              for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
                  t[i] = arguments[i];
              this.run.apply(this, ["groupCollapsed"].concat(t)),
              this.run.apply(this, ["trace"].concat(t)),
              this.run("groupEnd")
          }
      }, {
          key: "log",
          value: function() {
              for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
                  t[i] = arguments[i];
              this.run.apply(this, ["log"].concat(t))
          }
      }, {
          key: "table",
          value: function(e, t) {
              this.run("table", e, t)
          }
      }, {
          key: "trace",
          value: function() {
              for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
                  t[i] = arguments[i];
              this.run.apply(this, ["trace"].concat(t))
          }
      }, {
          key: "warn",
          value: function() {
              for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
                  t[i] = arguments[i];
              this.run.apply(this, ["warn"].concat(t))
          }
      }, {
          key: "count",
          value: function(e) {
              this.run("count", e)
          }
      }, {
          key: "countReset",
          value: function(e) {
              this.run("countReset", e)
          }
      }, {
          key: "group",
          value: function() {
              for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
                  t[i] = arguments[i];
              this.run.apply(this, ["group"].concat(t))
          }
      }, {
          key: "groupCollapsed",
          value: function() {
              for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
                  t[i] = arguments[i];
              this.run.apply(this, ["groupCollapsed"].concat(t))
          }
      }, {
          key: "groupEnd",
          value: function() {
              this.run("groupEnd")
          }
      }, {
          key: "time",
          value: function(e) {
              this.run("time", e)
          }
      }, {
          key: "timeLog",
          value: function(e) {
              for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
                  i[n - 1] = arguments[n];
              this.run.apply(this, ["timeLog"].concat(i))
          }
      }, {
          key: "timeEnd",
          value: function(e) {
              this.run("timeEnd", e)
          }
      }, {
          key: "run",
          value: function(e) {
              if (this.validateEnvironment()) {
                  for (var t, i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)
                      n[r - 1] = arguments[r];
                  (t = window.console)[e].apply(t, n)
              }
          }
      }, {
          key: "validateEnvironment",
          value: function() {
              return this.config.logInProduction,
              "console"in window
          }
      }]) && l(t.prototype, i),
      n && l(t, n),
      e
  }());
  function u(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var h = function() {
      function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0
            , i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.defaults = {
              currentValue: t,
              lastValue: null,
              callback: null,
              callbackComplete: null,
              ratio: .16,
              minDifference: .2
          },
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(n.a)(this),
          this.flags = {
              isPaused: !0,
              isStopped: !0,
              isComplete: !1
          },
          this.states = {
              currentValue: this.options.currentValue,
              lastValue: null === this.options.lastValue ? this.options.currentValue : this.options.lastValue,
              easedValue: null === this.options.lastValue ? this.options.currentValue : this.options.lastValue,
              startTime: Date.now()
          },
          this.init()
      }
      var t, i, o;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.start()
          }
      }, {
          key: "resetTime",
          value: function() {
              this.states.startTime = Date.now()
          }
      }, {
          key: "pause",
          value: function() {
              this.flags.isPaused || (this.flags.isPaused = !0,
              r.a.off(this.events._onLoop))
          }
      }, {
          key: "unpause",
          value: function() {
              this.flags.isPaused && (this.flags.isPaused = !1,
              this.flags.isStopped && (this.flags.isStopped = !1,
              this.resetTime()),
              r.a.on(this.events._onLoop))
          }
      }, {
          key: "start",
          value: function() {
              this.unpause()
          }
      }, {
          key: "stop",
          value: function() {
              this.pause(),
              this.flags.isStopped = !0
          }
      }, {
          key: "_onLoop",
          value: function() {
              this.tick()
          }
      }, {
          key: "tick",
          value: function() {
              this.flags.isComplete || (this.states.timeElapsed = Date.now() - this.states.startTime,
              this.calculate())
          }
      }, {
          key: "calculate",
          value: function() {
              var e = (this.states.currentValue - this.states.lastValue) * this.options.ratio;
              Math.abs(e) < this.options.minDifference && (e = 0),
              this.states.lastValue = this.states.easedValue,
              this.states.easedValue = this.states.easedValue + e,
              e ? "function" == typeof this.options.callback && this.options.callback(this.states.easedValue) : ("function" == typeof this.options.callback && this.options.callback(this.states.easedValue),
              "function" == typeof this.options.callbackComplete && this.options.callbackComplete(this.states.easedValue),
              this.flags.isComplete = !0)
          }
      }, {
          key: "update",
          value: function(e) {
              this.states.currentValue !== e && (this.options.currentValue = e,
              this.states.currentValue = e,
              this.resetTime(),
              this.flags.isComplete = !1)
          }
      }, {
          key: "destroy",
          value: function() {
              this.stop()
          }
      }, {
          key: "paused",
          get: function() {
              return this.flags.isPaused
          }
      }, {
          key: "playing",
          get: function() {
              return !this.flags.isPaused
          }
      }, {
          key: "value",
          get: function() {
              return this.states.easedValue
          }
      }, {
          key: "callback",
          set: function(e) {
              this.options.callback = e
          }
      }, {
          key: "callbackComplete",
          set: function(e) {
              this.options.callbackComplete = e
          }
      }]) && u(t.prototype, i),
      o && u(t, o),
      e
  }();
  function d(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var p = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.defaults = {
              autoEnable: !0,
              callback: null,
              switchBuffer: 60
          },
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(n.a)(this),
          this.coords = {
              directionDistance: 0,
              scrollYLast: 0,
              scrollDirectionSwitchY: -1
          },
          this.flags = {
              isEnabled: !1,
              isInitialized: !1,
              isScrollDirectionSwitch: !1
          },
          this.status = {
              direction: e.STATIC
          },
          this.footlong = new a,
          this.init()
      }
      var t, i, r;
      return t = e,
      r = [{
          key: "DIRECTION_CHANGE",
          get: function() {
              return "directionChange"
          }
      }, {
          key: "UP",
          get: function() {
              return "up"
          }
      }, {
          key: "DOWN",
          get: function() {
              return "down"
          }
      }, {
          key: "STATIC",
          get: function() {
              return "static"
          }
      }],
      (i = [{
          key: "init",
          value: function() {
              this.addEventListeners(),
              this.options.autoEnable && this.enable()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              this.el.section.addEventListener("resize", this.events._onResize),
              this.el.section.addEventListener("scroll", this.events._onScroll, {
                  passive: !0
              })
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              this.el.section.addEventListener("resize", this.events._onResize),
              this.el.section.addEventListener("scroll", this.events._onScroll)
          }
      }, {
          key: "_onResize",
          value: function() {
              this.checkResize()
          }
      }, {
          key: "_onScroll",
          value: function() {
              this.checkScroll()
          }
      }, {
          key: "checkResize",
          value: function() {
              this.flags.isEnabled && this.checkScroll()
          }
      }, {
          key: "checkScroll",
          value: function() {
              var t = Math.max(0, this.el.section === window ? window.scrollY : this.el.section.scrollTop);
              if (this.flags.isEnabled)
                  if (this.coords.directionDistance = t - this.coords.scrollDirectionSwitchY,
                  this.isScrollDirectionSwitch)
                      this.status.direction === e.DOWN && this.coords.directionDistance > 0 || this.status.direction === e.UP && this.coords.directionDistance < 0 ? this.isScrollDirectionSwitch = !1 : Math.abs(this.coords.directionDistance) >= this.options.switchBuffer && (this.isScrollDirectionSwitch = !1,
                      this.setDirection(this.coords.directionDistance < 0 ? e.UP : e.DOWN));
                  else {
                      var i = t - this.coords.scrollYLast;
                      this.status.direction === e.DOWN && i < 0 || this.status.direction === e.UP && i > 0 ? (this.isScrollDirectionSwitch = !0,
                      this.coords.scrollDirectionSwitchY = t) : t - this.coords.scrollYLast > 0 ? this.setDirection(e.DOWN) : t - this.coords.scrollYLast < 0 ? this.setDirection(e.UP) : t - this.coords.scrollYLast == 0 && this.setDirection(e.STATIC)
                  }
              this.coords.scrollYLast = t
          }
      }, {
          key: "setDirection",
          value: function(t) {
              this.status.direction !== t && (this.status.direction = t,
              this.options.callback && this.options.callback.apply(null, [{
                  direction: this.status.direction
              }]),
              this.dispatch(e.DIRECTION_CHANGE, {
                  direction: this.status.direction,
                  directionDistance: this.coords.directionDistance
              }))
          }
      }, {
          key: "enable",
          value: function() {
              this.flags.isEnabled || (this.flags.isEnabled = !0,
              this.coords.directionDistance = 0,
              this.setDirection(e.STATIC))
          }
      }, {
          key: "disable",
          value: function() {
              this.flags.isEnabled && (this.flags.isEnabled = !1,
              this.coords.directionDistance = 0,
              this.setDirection(e.STATIC))
          }
      }, {
          key: "on",
          value: function(e, t) {
              var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null
                , n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
              this.footlong.on(e, t, i, n)
          }
      }, {
          key: "one",
          value: function() {
              this.footlong.one(eventId, callback, context, params)
          }
      }, {
          key: "off",
          value: function() {
              this.footlong.off(eventId, callback, context, params)
          }
      }, {
          key: "dispatch",
          value: function(t) {
              var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
              this.footlong.dispatch(e.DIRECTION_CHANGE, i)
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }, {
          key: "direction",
          get: function() {
              return this.status.direction
          }
      }, {
          key: "directionDistance",
          get: function() {
              return this.coords.directionDistance
          }
      }]) && d(t.prototype, i),
      r && d(t, r),
      e
  }();
  function f(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var m = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.xhr = new XMLHttpRequest,
          this.type = t,
          this.url = "",
          this.data = null,
          this.header = {},
          this.onprogress = !1,
          this.timeout = 3e4
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "setHeader",
          value: function(e, t) {
              return this.header[e] = t,
              this
          }
      }, {
          key: "onProgress",
          value: function(e) {
              return this.onprogress = e,
              this
          }
      }, {
          key: "setTimeout",
          value: function(e) {
              return this.timeout = e,
              this
          }
      }, {
          key: "setType",
          value: function() {
              try {
                  this.xhr.responseType = this.type
              } catch (e) {}
          }
      }, {
          key: "onreadystatechange",
          value: function(e, t) {
              var i = this;
              this.xhr.onreadystatechange = function() {
                  4 === i.xhr.readyState && (200 === i.xhr.status ? e(i.xhr) : t(i.xhr))
              }
          }
      }, {
          key: "request",
          value: function(e) {
              var t = this;
              return new Promise(function(i, n) {
                  for (var r in t.onprogress && (t.xhr.onprogress = t.onprogress),
                  t.setType(),
                  t.onreadystatechange(i, n),
                  t.xhr.open(e, t.url, !0),
                  t.header)
                      t.xhr.setRequestHeader(r, t.header[r]);
                  t.xhr.timeout = t.timeout,
                  t.xhr.send(t.data)
              }
              )
          }
      }, {
          key: "get",
          value: function(e) {
              return this.url = e,
              this.request("GET")
          }
      }, {
          key: "post",
          value: function(e, t) {
              return this.url = e,
              this.data = t,
              this.request("POST")
          }
      }, {
          key: "put",
          value: function(e, t) {
              return this.url = e,
              this.data = t,
              this.request("PUT")
          }
      }, {
          key: "delete",
          value: function(e, t) {
              return this.url = e,
              this.data = t,
              this.request("DELETE")
          }
      }, {
          key: "abort",
          value: function() {
              this.xhr.abort()
          }
      }]) && f(t.prototype, i),
      n && f(t, n),
      e
  }();
  i.d(t, "a", function() {
      return a
  }),
  i.d(t, "b", function() {
      return c
  }),
  i.d(t, "c", function() {
      return h
  }),
  i.d(t, "d", function() {
      return p
  }),
  i.d(t, "e", function() {
      return m
  })
}
, function(e, t, i) {
  "use strict";
  var n = i(1);
  function r(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var o = function() {
      function e() {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.objects = {
              animationFrame: null,
              subscribers: []
          },
          this.counters = {
              frame: 0
          },
          this.flags = {
              autoStart: !0,
              isPlaying: !1
          },
          this.debug = {
              log: !1
          }
      }
      var t, i, o;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.flags.autoStart && this.start()
          }
      }, {
          key: "on",
          value: function(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null
                , i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2]
                , n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
              this._addListener(e, t, i, n)
          }
      }, {
          key: "one",
          value: function(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null
                , i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
              this._addListener(e, t, !1, i)
          }
      }, {
          key: "off",
          value: function(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
              this._removeListener(e, t)
          }
      }, {
          key: "pause",
          value: function() {
              this.flags.isPlaying && (this.flags.isPlaying = !1)
          }
      }, {
          key: "unpause",
          value: function() {
              this.flags.isPlaying || (this.flags.isPlaying = !0,
              this._tick())
          }
      }, {
          key: "start",
          value: function() {
              this.unpause()
          }
      }, {
          key: "removeAll",
          value: function() {
              this.objects.subscribers = []
          }
      }, {
          key: "resetFrameCount",
          value: function() {
              this.counters.frame = 0
          }
      }, {
          key: "reset",
          value: function() {
              this.removeAll(),
              this.resetFrameCount()
          }
      }, {
          key: "_addListener",
          value: function(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null
                , i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2]
                , r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
              this.objects.subscribers || (this.objects.subscribers = []),
              this.debug.log && n.b.lawg("add RAF", e, t, i, r, "now", this.counters.frame);
              for (var o = !1, s = 0, a = this.objects.subscribers.length; s < a; s++) {
                  var l = this.objects.subscribers[s];
                  if (l.callback === e && this.isContextMatch(l.context, t) && l.recurring === i && l.frameDelay === r) {
                      o = !0;
                      break
                  }
              }
              this.debug.log && n.b.lawg("match?", o),
              o || this.objects.subscribers.push({
                  callback: e,
                  context: t,
                  recurring: i,
                  frameDelay: r,
                  triggerFrame: this.counters.frame + r,
                  startFrame: this.counters.frame
              }),
              this.debug.log && n.b.lawg("_addListener", this.objects.subscribers)
          }
      }, {
          key: "_removeListener",
          value: function(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null
                , i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2]
                , n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
              this.objects.subscribers || (this.objects.subscribers = []);
              for (var r = 0, o = this.objects.subscribers.length; r < o; r++) {
                  var s = this.objects.subscribers[r];
                  if (s.callback === e && this.isContextMatch(s.context, t) && s.recurring === i && s.frameDelay === n) {
                      this.objects.subscribers.splice(r, 1);
                      break
                  }
              }
          }
      }, {
          key: "_triggerFrame",
          value: function() {
              if (this.objects.subscribers && this.objects.subscribers.length) {
                  for (var e = this.objects.subscribers.concat(), t = [], i = 0, r = e.length; i < r; i++) {
                      var o = e[i];
                      if (this.counters.frame >= o.triggerFrame)
                          if (t.push(o),
                          o.recurring)
                              o.triggerFrame += o.frameDelay;
                          else {
                              var s = this.objects.subscribers.indexOf(o);
                              this.objects.subscribers.splice(s, 1),
                              this.debug.log && n.b.lawg("splice @", s, o.callback)
                          }
                  }
                  for (var a = 0, l = t.length; a < l; a++) {
                      var c = t[a];
                      c.callback.apply(c.context, [])
                  }
              }
          }
      }, {
          key: "_tick",
          value: function() {
              var e = this
                , t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              this.counters.frame++,
              this.objects.animationFrame = window.requestAnimationFrame(function() {
                  (e.flags.isPlaying || t) && (e._triggerFrame(),
                  e._tick())
              })
          }
      }, {
          key: "isContextMatch",
          value: function(e, t) {
              return e && t ? e === t : !e && !t
          }
      }]) && r(t.prototype, i),
      o && r(t, o),
      e
  }();
  t.a = new o
}
, function(e, t) {
  e.exports = function(e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t)
  }
}
, function(e, t, i) {
  "use strict";
  t.a = new class {
      constructor() {
          this.routes = [],
          this.map = {},
          this.root = "/",
          this.http404 = "/404",
          this.redirects = {},
          this.addEventListeners()
      }
      parse(e) {
          return decodeURI(e).split("/").filter(e=>{
              if ("" !== e)
                  return e
          }
          )
      }
      route(e, t) {
          const i = this.parse(e);
          this.routes.push(e),
          this.map[e] = {
              params: i,
              fn: t
          }
      }
      navigate(e) {
          if (e !== window.location.pathname) {
              let t = e;
              this.redirects[e] && (t = this.redirects[e]),
              window.history.pushState(!1, !1, this.root.replace(/\/$/, "") + t)
          }
          this.check()
      }
      redirect(e) {
          for (const t in e)
              this.redirects[t] = e[t]
      }
      check() {
          let e = window.location.pathname.replace(this.root.replace(/\/$/, ""), "")
            , t = {
              route: !1,
              accuracy: 0,
              variables: []
          };
          this.redirects[e] && (e = this.redirects[e]);
          const i = this.parse(e);
          for (const e in this.routes) {
              const n = this.map[this.routes[e]].params
                , r = [];
              let o = 0;
              if (i.length) {
                  if (i.length <= n.length)
                      for (const e in n)
                          if (i[e])
                              if (i[e] === n[e])
                                  o += 100;
                              else if (":" === n[e].charAt(0))
                                  o += 5,
                                  r.push(i[e]);
                              else {
                                  if ("?" !== n[e].charAt(0))
                                      break;
                                  o += 1,
                                  ":" === n[e].charAt(1) && r.push(i[e])
                              }
                          else
                              "?" !== n[e].charAt(0) && (o = 0)
              } else
                  t = {
                      route: "/",
                      accuracy: o,
                      variables: r
                  };
              o && o >= t.accuracy && (t = {
                  route: this.routes[e],
                  accuracy: o,
                  variables: r
              })
          }
          t.route && this.map[t.route] ? this.map[t.route].fn(...t.variables) : this.map[this.http404] && this.map[this.http404].fn()
      }
      start(e) {
          if (e)
              for (const t in e)
                  this.route(t, e[t]);
          this.check()
      }
      _windowOnPopstate() {
          this.check()
      }
      addEventListeners() {
          this._windowOnPopstate = this._windowOnPopstate.bind(this),
          window.addEventListener("popstate", this._windowOnPopstate)
      }
      removeEventListeners() {
          window.removeEventListener("popstate", this._windowOnPopstate)
      }
  }
}
, function(e, t) {
  var i = Object.prototype.toString;
  e.exports = function(e) {
      return i.call(e)
  }
}
, function(e, t) {
  e.exports = function(e) {
      return null != e && "object" == typeof e
  }
}
, function(e, t, i) {
  var n;
  /*!
* jQuery JavaScript Library v3.3.1
* https://jquery.com/
*
* Includes Sizzle.js
* https://sizzlejs.com/
*
* Copyright JS Foundation and other contributors
* Released under the MIT license
* https://jquery.org/license
*
* Date: 2018-01-20T17:24Z
*/
  /*!
* jQuery JavaScript Library v3.3.1
* https://jquery.com/
*
* Includes Sizzle.js
* https://sizzlejs.com/
*
* Copyright JS Foundation and other contributors
* Released under the MIT license
* https://jquery.org/license
*
* Date: 2018-01-20T17:24Z
*/
  !function(t, i) {
      "use strict";
      "object" == typeof e.exports ? e.exports = t.document ? i(t, !0) : function(e) {
          if (!e.document)
              throw new Error("jQuery requires a window with a document");
          return i(e)
      }
      : i(t)
  }("undefined" != typeof window ? window : this, function(i, r) {
      "use strict";
      var o = []
        , s = i.document
        , a = Object.getPrototypeOf
        , l = o.slice
        , c = o.concat
        , u = o.push
        , h = o.indexOf
        , d = {}
        , p = d.toString
        , f = d.hasOwnProperty
        , m = f.toString
        , g = m.call(Object)
        , v = {}
        , y = function(e) {
          return "function" == typeof e && "number" != typeof e.nodeType
      }
        , _ = function(e) {
          return null != e && e === e.window
      }
        , b = {
          type: !0,
          src: !0,
          noModule: !0
      };
      function w(e, t, i) {
          var n, r = (t = t || s).createElement("script");
          if (r.text = e,
          i)
              for (n in b)
                  i[n] && (r[n] = i[n]);
          t.head.appendChild(r).parentNode.removeChild(r)
      }
      function x(e) {
          return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? d[p.call(e)] || "object" : typeof e
      }
      var k = function(e, t) {
          return new k.fn.init(e,t)
      }
        , S = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
      function E(e) {
          var t = !!e && "length"in e && e.length
            , i = x(e);
          return !y(e) && !_(e) && ("array" === i || 0 === t || "number" == typeof t && t > 0 && t - 1 in e)
      }
      k.fn = k.prototype = {
          jquery: "3.3.1",
          constructor: k,
          length: 0,
          toArray: function() {
              return l.call(this)
          },
          get: function(e) {
              return null == e ? l.call(this) : e < 0 ? this[e + this.length] : this[e]
          },
          pushStack: function(e) {
              var t = k.merge(this.constructor(), e);
              return t.prevObject = this,
              t
          },
          each: function(e) {
              return k.each(this, e)
          },
          map: function(e) {
              return this.pushStack(k.map(this, function(t, i) {
                  return e.call(t, i, t)
              }))
          },
          slice: function() {
              return this.pushStack(l.apply(this, arguments))
          },
          first: function() {
              return this.eq(0)
          },
          last: function() {
              return this.eq(-1)
          },
          eq: function(e) {
              var t = this.length
                , i = +e + (e < 0 ? t : 0);
              return this.pushStack(i >= 0 && i < t ? [this[i]] : [])
          },
          end: function() {
              return this.prevObject || this.constructor()
          },
          push: u,
          sort: o.sort,
          splice: o.splice
      },
      k.extend = k.fn.extend = function() {
          var e, t, i, n, r, o, s = arguments[0] || {}, a = 1, l = arguments.length, c = !1;
          for ("boolean" == typeof s && (c = s,
          s = arguments[a] || {},
          a++),
          "object" == typeof s || y(s) || (s = {}),
          a === l && (s = this,
          a--); a < l; a++)
              if (null != (e = arguments[a]))
                  for (t in e)
                      i = s[t],
                      s !== (n = e[t]) && (c && n && (k.isPlainObject(n) || (r = Array.isArray(n))) ? (r ? (r = !1,
                      o = i && Array.isArray(i) ? i : []) : o = i && k.isPlainObject(i) ? i : {},
                      s[t] = k.extend(c, o, n)) : void 0 !== n && (s[t] = n));
          return s
      }
      ,
      k.extend({
          expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
          isReady: !0,
          error: function(e) {
              throw new Error(e)
          },
          noop: function() {},
          isPlainObject: function(e) {
              var t, i;
              return !(!e || "[object Object]" !== p.call(e)) && (!(t = a(e)) || "function" == typeof (i = f.call(t, "constructor") && t.constructor) && m.call(i) === g)
          },
          isEmptyObject: function(e) {
              var t;
              for (t in e)
                  return !1;
              return !0
          },
          globalEval: function(e) {
              w(e)
          },
          each: function(e, t) {
              var i, n = 0;
              if (E(e))
                  for (i = e.length; n < i && !1 !== t.call(e[n], n, e[n]); n++)
                      ;
              else
                  for (n in e)
                      if (!1 === t.call(e[n], n, e[n]))
                          break;
              return e
          },
          trim: function(e) {
              return null == e ? "" : (e + "").replace(S, "")
          },
          makeArray: function(e, t) {
              var i = t || [];
              return null != e && (E(Object(e)) ? k.merge(i, "string" == typeof e ? [e] : e) : u.call(i, e)),
              i
          },
          inArray: function(e, t, i) {
              return null == t ? -1 : h.call(t, e, i)
          },
          merge: function(e, t) {
              for (var i = +t.length, n = 0, r = e.length; n < i; n++)
                  e[r++] = t[n];
              return e.length = r,
              e
          },
          grep: function(e, t, i) {
              for (var n = [], r = 0, o = e.length, s = !i; r < o; r++)
                  !t(e[r], r) !== s && n.push(e[r]);
              return n
          },
          map: function(e, t, i) {
              var n, r, o = 0, s = [];
              if (E(e))
                  for (n = e.length; o < n; o++)
                      null != (r = t(e[o], o, i)) && s.push(r);
              else
                  for (o in e)
                      null != (r = t(e[o], o, i)) && s.push(r);
              return c.apply([], s)
          },
          guid: 1,
          support: v
      }),
      "function" == typeof Symbol && (k.fn[Symbol.iterator] = o[Symbol.iterator]),
      k.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
          d["[object " + t + "]"] = t.toLowerCase()
      });
      var T = /*!
* Sizzle CSS Selector Engine v2.3.3
* https://sizzlejs.com/
*
* Copyright jQuery Foundation and other contributors
* Released under the MIT license
* http://jquery.org/license
*
* Date: 2016-08-08
*/
      function(e) {
          var t, i, n, r, o, s, a, l, c, u, h, d, p, f, m, g, v, y, _, b = "sizzle" + 1 * new Date, w = e.document, x = 0, k = 0, S = se(), E = se(), T = se(), C = function(e, t) {
              return e === t && (h = !0),
              0
          }, L = {}.hasOwnProperty, A = [], P = A.pop, I = A.push, M = A.push, O = A.slice, z = function(e, t) {
              for (var i = 0, n = e.length; i < n; i++)
                  if (e[i] === t)
                      return i;
              return -1
          }, D = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", R = "[\\x20\\t\\r\\n\\f]", B = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+", j = "\\[" + R + "*(" + B + ")(?:" + R + "*([*^$|!~]?=)" + R + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + B + "))|)" + R + "*\\]", F = ":(" + B + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + j + ")*)|.*)\\)|)", N = new RegExp(R + "+","g"), U = new RegExp("^" + R + "+|((?:^|[^\\\\])(?:\\\\.)*)" + R + "+$","g"), q = new RegExp("^" + R + "*," + R + "*"), H = new RegExp("^" + R + "*([>+~]|" + R + ")" + R + "*"), V = new RegExp("=" + R + "*([^\\]'\"]*?)" + R + "*\\]","g"), W = new RegExp(F), $ = new RegExp("^" + B + "$"), G = {
              ID: new RegExp("^#(" + B + ")"),
              CLASS: new RegExp("^\\.(" + B + ")"),
              TAG: new RegExp("^(" + B + "|[*])"),
              ATTR: new RegExp("^" + j),
              PSEUDO: new RegExp("^" + F),
              CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + R + "*(even|odd|(([+-]|)(\\d*)n|)" + R + "*(?:([+-]|)" + R + "*(\\d+)|))" + R + "*\\)|)","i"),
              bool: new RegExp("^(?:" + D + ")$","i"),
              needsContext: new RegExp("^" + R + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + R + "*((?:-\\d)?\\d*)" + R + "*\\)|)(?=[^-]|$)","i")
          }, X = /^(?:input|select|textarea|button)$/i, Z = /^h\d$/i, Y = /^[^{]+\{\s*\[native \w/, K = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, J = /[+~]/, Q = new RegExp("\\\\([\\da-f]{1,6}" + R + "?|(" + R + ")|.)","ig"), ee = function(e, t, i) {
              var n = "0x" + t - 65536;
              return n != n || i ? t : n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320)
          }, te = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, ie = function(e, t) {
              return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
          }, ne = function() {
              d()
          }, re = ye(function(e) {
              return !0 === e.disabled && ("form"in e || "label"in e)
          }, {
              dir: "parentNode",
              next: "legend"
          });
          try {
              M.apply(A = O.call(w.childNodes), w.childNodes),
              A[w.childNodes.length].nodeType
          } catch (e) {
              M = {
                  apply: A.length ? function(e, t) {
                      I.apply(e, O.call(t))
                  }
                  : function(e, t) {
                      for (var i = e.length, n = 0; e[i++] = t[n++]; )
                          ;
                      e.length = i - 1
                  }
              }
          }
          function oe(e, t, n, r) {
              var o, a, c, u, h, f, v, y = t && t.ownerDocument, x = t ? t.nodeType : 9;
              if (n = n || [],
              "string" != typeof e || !e || 1 !== x && 9 !== x && 11 !== x)
                  return n;
              if (!r && ((t ? t.ownerDocument || t : w) !== p && d(t),
              t = t || p,
              m)) {
                  if (11 !== x && (h = K.exec(e)))
                      if (o = h[1]) {
                          if (9 === x) {
                              if (!(c = t.getElementById(o)))
                                  return n;
                              if (c.id === o)
                                  return n.push(c),
                                  n
                          } else if (y && (c = y.getElementById(o)) && _(t, c) && c.id === o)
                              return n.push(c),
                              n
                      } else {
                          if (h[2])
                              return M.apply(n, t.getElementsByTagName(e)),
                              n;
                          if ((o = h[3]) && i.getElementsByClassName && t.getElementsByClassName)
                              return M.apply(n, t.getElementsByClassName(o)),
                              n
                      }
                  if (i.qsa && !T[e + " "] && (!g || !g.test(e))) {
                      if (1 !== x)
                          y = t,
                          v = e;
                      else if ("object" !== t.nodeName.toLowerCase()) {
                          for ((u = t.getAttribute("id")) ? u = u.replace(te, ie) : t.setAttribute("id", u = b),
                          a = (f = s(e)).length; a--; )
                              f[a] = "#" + u + " " + ve(f[a]);
                          v = f.join(","),
                          y = J.test(e) && me(t.parentNode) || t
                      }
                      if (v)
                          try {
                              return M.apply(n, y.querySelectorAll(v)),
                              n
                          } catch (e) {} finally {
                              u === b && t.removeAttribute("id")
                          }
                  }
              }
              return l(e.replace(U, "$1"), t, n, r)
          }
          function se() {
              var e = [];
              return function t(i, r) {
                  return e.push(i + " ") > n.cacheLength && delete t[e.shift()],
                  t[i + " "] = r
              }
          }
          function ae(e) {
              return e[b] = !0,
              e
          }
          function le(e) {
              var t = p.createElement("fieldset");
              try {
                  return !!e(t)
              } catch (e) {
                  return !1
              } finally {
                  t.parentNode && t.parentNode.removeChild(t),
                  t = null
              }
          }
          function ce(e, t) {
              for (var i = e.split("|"), r = i.length; r--; )
                  n.attrHandle[i[r]] = t
          }
          function ue(e, t) {
              var i = t && e
                , n = i && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
              if (n)
                  return n;
              if (i)
                  for (; i = i.nextSibling; )
                      if (i === t)
                          return -1;
              return e ? 1 : -1
          }
          function he(e) {
              return function(t) {
                  return "input" === t.nodeName.toLowerCase() && t.type === e
              }
          }
          function de(e) {
              return function(t) {
                  var i = t.nodeName.toLowerCase();
                  return ("input" === i || "button" === i) && t.type === e
              }
          }
          function pe(e) {
              return function(t) {
                  return "form"in t ? t.parentNode && !1 === t.disabled ? "label"in t ? "label"in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && re(t) === e : t.disabled === e : "label"in t && t.disabled === e
              }
          }
          function fe(e) {
              return ae(function(t) {
                  return t = +t,
                  ae(function(i, n) {
                      for (var r, o = e([], i.length, t), s = o.length; s--; )
                          i[r = o[s]] && (i[r] = !(n[r] = i[r]))
                  })
              })
          }
          function me(e) {
              return e && void 0 !== e.getElementsByTagName && e
          }
          for (t in i = oe.support = {},
          o = oe.isXML = function(e) {
              var t = e && (e.ownerDocument || e).documentElement;
              return !!t && "HTML" !== t.nodeName
          }
          ,
          d = oe.setDocument = function(e) {
              var t, r, s = e ? e.ownerDocument || e : w;
              return s !== p && 9 === s.nodeType && s.documentElement ? (f = (p = s).documentElement,
              m = !o(p),
              w !== p && (r = p.defaultView) && r.top !== r && (r.addEventListener ? r.addEventListener("unload", ne, !1) : r.attachEvent && r.attachEvent("onunload", ne)),
              i.attributes = le(function(e) {
                  return e.className = "i",
                  !e.getAttribute("className")
              }),
              i.getElementsByTagName = le(function(e) {
                  return e.appendChild(p.createComment("")),
                  !e.getElementsByTagName("*").length
              }),
              i.getElementsByClassName = Y.test(p.getElementsByClassName),
              i.getById = le(function(e) {
                  return f.appendChild(e).id = b,
                  !p.getElementsByName || !p.getElementsByName(b).length
              }),
              i.getById ? (n.filter.ID = function(e) {
                  var t = e.replace(Q, ee);
                  return function(e) {
                      return e.getAttribute("id") === t
                  }
              }
              ,
              n.find.ID = function(e, t) {
                  if (void 0 !== t.getElementById && m) {
                      var i = t.getElementById(e);
                      return i ? [i] : []
                  }
              }
              ) : (n.filter.ID = function(e) {
                  var t = e.replace(Q, ee);
                  return function(e) {
                      var i = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                      return i && i.value === t
                  }
              }
              ,
              n.find.ID = function(e, t) {
                  if (void 0 !== t.getElementById && m) {
                      var i, n, r, o = t.getElementById(e);
                      if (o) {
                          if ((i = o.getAttributeNode("id")) && i.value === e)
                              return [o];
                          for (r = t.getElementsByName(e),
                          n = 0; o = r[n++]; )
                              if ((i = o.getAttributeNode("id")) && i.value === e)
                                  return [o]
                      }
                      return []
                  }
              }
              ),
              n.find.TAG = i.getElementsByTagName ? function(e, t) {
                  return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : i.qsa ? t.querySelectorAll(e) : void 0
              }
              : function(e, t) {
                  var i, n = [], r = 0, o = t.getElementsByTagName(e);
                  if ("*" === e) {
                      for (; i = o[r++]; )
                          1 === i.nodeType && n.push(i);
                      return n
                  }
                  return o
              }
              ,
              n.find.CLASS = i.getElementsByClassName && function(e, t) {
                  if (void 0 !== t.getElementsByClassName && m)
                      return t.getElementsByClassName(e)
              }
              ,
              v = [],
              g = [],
              (i.qsa = Y.test(p.querySelectorAll)) && (le(function(e) {
                  f.appendChild(e).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\r\\' msallowcapture=''><option selected=''></option></select>",
                  e.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + R + "*(?:''|\"\")"),
                  e.querySelectorAll("[selected]").length || g.push("\\[" + R + "*(?:value|" + D + ")"),
                  e.querySelectorAll("[id~=" + b + "-]").length || g.push("~="),
                  e.querySelectorAll(":checked").length || g.push(":checked"),
                  e.querySelectorAll("a#" + b + "+*").length || g.push(".#.+[+~]")
              }),
              le(function(e) {
                  e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                  var t = p.createElement("input");
                  t.setAttribute("type", "hidden"),
                  e.appendChild(t).setAttribute("name", "D"),
                  e.querySelectorAll("[name=d]").length && g.push("name" + R + "*[*^$|!~]?="),
                  2 !== e.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"),
                  f.appendChild(e).disabled = !0,
                  2 !== e.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"),
                  e.querySelectorAll("*,:x"),
                  g.push(",.*:")
              })),
              (i.matchesSelector = Y.test(y = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector)) && le(function(e) {
                  i.disconnectedMatch = y.call(e, "*"),
                  y.call(e, "[s!='']:x"),
                  v.push("!=", F)
              }),
              g = g.length && new RegExp(g.join("|")),
              v = v.length && new RegExp(v.join("|")),
              t = Y.test(f.compareDocumentPosition),
              _ = t || Y.test(f.contains) ? function(e, t) {
                  var i = 9 === e.nodeType ? e.documentElement : e
                    , n = t && t.parentNode;
                  return e === n || !(!n || 1 !== n.nodeType || !(i.contains ? i.contains(n) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(n)))
              }
              : function(e, t) {
                  if (t)
                      for (; t = t.parentNode; )
                          if (t === e)
                              return !0;
                  return !1
              }
              ,
              C = t ? function(e, t) {
                  if (e === t)
                      return h = !0,
                      0;
                  var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                  return n || (1 & (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !i.sortDetached && t.compareDocumentPosition(e) === n ? e === p || e.ownerDocument === w && _(w, e) ? -1 : t === p || t.ownerDocument === w && _(w, t) ? 1 : u ? z(u, e) - z(u, t) : 0 : 4 & n ? -1 : 1)
              }
              : function(e, t) {
                  if (e === t)
                      return h = !0,
                      0;
                  var i, n = 0, r = e.parentNode, o = t.parentNode, s = [e], a = [t];
                  if (!r || !o)
                      return e === p ? -1 : t === p ? 1 : r ? -1 : o ? 1 : u ? z(u, e) - z(u, t) : 0;
                  if (r === o)
                      return ue(e, t);
                  for (i = e; i = i.parentNode; )
                      s.unshift(i);
                  for (i = t; i = i.parentNode; )
                      a.unshift(i);
                  for (; s[n] === a[n]; )
                      n++;
                  return n ? ue(s[n], a[n]) : s[n] === w ? -1 : a[n] === w ? 1 : 0
              }
              ,
              p) : p
          }
          ,
          oe.matches = function(e, t) {
              return oe(e, null, null, t)
          }
          ,
          oe.matchesSelector = function(e, t) {
              if ((e.ownerDocument || e) !== p && d(e),
              t = t.replace(V, "='$1']"),
              i.matchesSelector && m && !T[t + " "] && (!v || !v.test(t)) && (!g || !g.test(t)))
                  try {
                      var n = y.call(e, t);
                      if (n || i.disconnectedMatch || e.document && 11 !== e.document.nodeType)
                          return n
                  } catch (e) {}
              return oe(t, p, null, [e]).length > 0
          }
          ,
          oe.contains = function(e, t) {
              return (e.ownerDocument || e) !== p && d(e),
              _(e, t)
          }
          ,
          oe.attr = function(e, t) {
              (e.ownerDocument || e) !== p && d(e);
              var r = n.attrHandle[t.toLowerCase()]
                , o = r && L.call(n.attrHandle, t.toLowerCase()) ? r(e, t, !m) : void 0;
              return void 0 !== o ? o : i.attributes || !m ? e.getAttribute(t) : (o = e.getAttributeNode(t)) && o.specified ? o.value : null
          }
          ,
          oe.escape = function(e) {
              return (e + "").replace(te, ie)
          }
          ,
          oe.error = function(e) {
              throw new Error("Syntax error, unrecognized expression: " + e)
          }
          ,
          oe.uniqueSort = function(e) {
              var t, n = [], r = 0, o = 0;
              if (h = !i.detectDuplicates,
              u = !i.sortStable && e.slice(0),
              e.sort(C),
              h) {
                  for (; t = e[o++]; )
                      t === e[o] && (r = n.push(o));
                  for (; r--; )
                      e.splice(n[r], 1)
              }
              return u = null,
              e
          }
          ,
          r = oe.getText = function(e) {
              var t, i = "", n = 0, o = e.nodeType;
              if (o) {
                  if (1 === o || 9 === o || 11 === o) {
                      if ("string" == typeof e.textContent)
                          return e.textContent;
                      for (e = e.firstChild; e; e = e.nextSibling)
                          i += r(e)
                  } else if (3 === o || 4 === o)
                      return e.nodeValue
              } else
                  for (; t = e[n++]; )
                      i += r(t);
              return i
          }
          ,
          (n = oe.selectors = {
              cacheLength: 50,
              createPseudo: ae,
              match: G,
              attrHandle: {},
              find: {},
              relative: {
                  ">": {
                      dir: "parentNode",
                      first: !0
                  },
                  " ": {
                      dir: "parentNode"
                  },
                  "+": {
                      dir: "previousSibling",
                      first: !0
                  },
                  "~": {
                      dir: "previousSibling"
                  }
              },
              preFilter: {
                  ATTR: function(e) {
                      return e[1] = e[1].replace(Q, ee),
                      e[3] = (e[3] || e[4] || e[5] || "").replace(Q, ee),
                      "~=" === e[2] && (e[3] = " " + e[3] + " "),
                      e.slice(0, 4)
                  },
                  CHILD: function(e) {
                      return e[1] = e[1].toLowerCase(),
                      "nth" === e[1].slice(0, 3) ? (e[3] || oe.error(e[0]),
                      e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])),
                      e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && oe.error(e[0]),
                      e
                  },
                  PSEUDO: function(e) {
                      var t, i = !e[6] && e[2];
                      return G.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : i && W.test(i) && (t = s(i, !0)) && (t = i.indexOf(")", i.length - t) - i.length) && (e[0] = e[0].slice(0, t),
                      e[2] = i.slice(0, t)),
                      e.slice(0, 3))
                  }
              },
              filter: {
                  TAG: function(e) {
                      var t = e.replace(Q, ee).toLowerCase();
                      return "*" === e ? function() {
                          return !0
                      }
                      : function(e) {
                          return e.nodeName && e.nodeName.toLowerCase() === t
                      }
                  },
                  CLASS: function(e) {
                      var t = S[e + " "];
                      return t || (t = new RegExp("(^|" + R + ")" + e + "(" + R + "|$)")) && S(e, function(e) {
                          return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
                      })
                  },
                  ATTR: function(e, t, i) {
                      return function(n) {
                          var r = oe.attr(n, e);
                          return null == r ? "!=" === t : !t || (r += "",
                          "=" === t ? r === i : "!=" === t ? r !== i : "^=" === t ? i && 0 === r.indexOf(i) : "*=" === t ? i && r.indexOf(i) > -1 : "$=" === t ? i && r.slice(-i.length) === i : "~=" === t ? (" " + r.replace(N, " ") + " ").indexOf(i) > -1 : "|=" === t && (r === i || r.slice(0, i.length + 1) === i + "-"))
                      }
                  },
                  CHILD: function(e, t, i, n, r) {
                      var o = "nth" !== e.slice(0, 3)
                        , s = "last" !== e.slice(-4)
                        , a = "of-type" === t;
                      return 1 === n && 0 === r ? function(e) {
                          return !!e.parentNode
                      }
                      : function(t, i, l) {
                          var c, u, h, d, p, f, m = o !== s ? "nextSibling" : "previousSibling", g = t.parentNode, v = a && t.nodeName.toLowerCase(), y = !l && !a, _ = !1;
                          if (g) {
                              if (o) {
                                  for (; m; ) {
                                      for (d = t; d = d[m]; )
                                          if (a ? d.nodeName.toLowerCase() === v : 1 === d.nodeType)
                                              return !1;
                                      f = m = "only" === e && !f && "nextSibling"
                                  }
                                  return !0
                              }
                              if (f = [s ? g.firstChild : g.lastChild],
                              s && y) {
                                  for (_ = (p = (c = (u = (h = (d = g)[b] || (d[b] = {}))[d.uniqueID] || (h[d.uniqueID] = {}))[e] || [])[0] === x && c[1]) && c[2],
                                  d = p && g.childNodes[p]; d = ++p && d && d[m] || (_ = p = 0) || f.pop(); )
                                      if (1 === d.nodeType && ++_ && d === t) {
                                          u[e] = [x, p, _];
                                          break
                                      }
                              } else if (y && (_ = p = (c = (u = (h = (d = t)[b] || (d[b] = {}))[d.uniqueID] || (h[d.uniqueID] = {}))[e] || [])[0] === x && c[1]),
                              !1 === _)
                                  for (; (d = ++p && d && d[m] || (_ = p = 0) || f.pop()) && ((a ? d.nodeName.toLowerCase() !== v : 1 !== d.nodeType) || !++_ || (y && ((u = (h = d[b] || (d[b] = {}))[d.uniqueID] || (h[d.uniqueID] = {}))[e] = [x, _]),
                                  d !== t)); )
                                      ;
                              return (_ -= r) === n || _ % n == 0 && _ / n >= 0
                          }
                      }
                  },
                  PSEUDO: function(e, t) {
                      var i, r = n.pseudos[e] || n.setFilters[e.toLowerCase()] || oe.error("unsupported pseudo: " + e);
                      return r[b] ? r(t) : r.length > 1 ? (i = [e, e, "", t],
                      n.setFilters.hasOwnProperty(e.toLowerCase()) ? ae(function(e, i) {
                          for (var n, o = r(e, t), s = o.length; s--; )
                              e[n = z(e, o[s])] = !(i[n] = o[s])
                      }) : function(e) {
                          return r(e, 0, i)
                      }
                      ) : r
                  }
              },
              pseudos: {
                  not: ae(function(e) {
                      var t = []
                        , i = []
                        , n = a(e.replace(U, "$1"));
                      return n[b] ? ae(function(e, t, i, r) {
                          for (var o, s = n(e, null, r, []), a = e.length; a--; )
                              (o = s[a]) && (e[a] = !(t[a] = o))
                      }) : function(e, r, o) {
                          return t[0] = e,
                          n(t, null, o, i),
                          t[0] = null,
                          !i.pop()
                      }
                  }),
                  has: ae(function(e) {
                      return function(t) {
                          return oe(e, t).length > 0
                      }
                  }),
                  contains: ae(function(e) {
                      return e = e.replace(Q, ee),
                      function(t) {
                          return (t.textContent || t.innerText || r(t)).indexOf(e) > -1
                      }
                  }),
                  lang: ae(function(e) {
                      return $.test(e || "") || oe.error("unsupported lang: " + e),
                      e = e.replace(Q, ee).toLowerCase(),
                      function(t) {
                          var i;
                          do {
                              if (i = m ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                                  return (i = i.toLowerCase()) === e || 0 === i.indexOf(e + "-")
                          } while ((t = t.parentNode) && 1 === t.nodeType);return !1
                      }
                  }),
                  target: function(t) {
                      var i = e.location && e.location.hash;
                      return i && i.slice(1) === t.id
                  },
                  root: function(e) {
                      return e === f
                  },
                  focus: function(e) {
                      return e === p.activeElement && (!p.hasFocus || p.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                  },
                  enabled: pe(!1),
                  disabled: pe(!0),
                  checked: function(e) {
                      var t = e.nodeName.toLowerCase();
                      return "input" === t && !!e.checked || "option" === t && !!e.selected
                  },
                  selected: function(e) {
                      return e.parentNode && e.parentNode.selectedIndex,
                      !0 === e.selected
                  },
                  empty: function(e) {
                      for (e = e.firstChild; e; e = e.nextSibling)
                          if (e.nodeType < 6)
                              return !1;
                      return !0
                  },
                  parent: function(e) {
                      return !n.pseudos.empty(e)
                  },
                  header: function(e) {
                      return Z.test(e.nodeName)
                  },
                  input: function(e) {
                      return X.test(e.nodeName)
                  },
                  button: function(e) {
                      var t = e.nodeName.toLowerCase();
                      return "input" === t && "button" === e.type || "button" === t
                  },
                  text: function(e) {
                      var t;
                      return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                  },
                  first: fe(function() {
                      return [0]
                  }),
                  last: fe(function(e, t) {
                      return [t - 1]
                  }),
                  eq: fe(function(e, t, i) {
                      return [i < 0 ? i + t : i]
                  }),
                  even: fe(function(e, t) {
                      for (var i = 0; i < t; i += 2)
                          e.push(i);
                      return e
                  }),
                  odd: fe(function(e, t) {
                      for (var i = 1; i < t; i += 2)
                          e.push(i);
                      return e
                  }),
                  lt: fe(function(e, t, i) {
                      for (var n = i < 0 ? i + t : i; --n >= 0; )
                          e.push(n);
                      return e
                  }),
                  gt: fe(function(e, t, i) {
                      for (var n = i < 0 ? i + t : i; ++n < t; )
                          e.push(n);
                      return e
                  })
              }
          }).pseudos.nth = n.pseudos.eq,
          {
              radio: !0,
              checkbox: !0,
              file: !0,
              password: !0,
              image: !0
          })
              n.pseudos[t] = he(t);
          for (t in {
              submit: !0,
              reset: !0
          })
              n.pseudos[t] = de(t);
          function ge() {}
          function ve(e) {
              for (var t = 0, i = e.length, n = ""; t < i; t++)
                  n += e[t].value;
              return n
          }
          function ye(e, t, i) {
              var n = t.dir
                , r = t.next
                , o = r || n
                , s = i && "parentNode" === o
                , a = k++;
              return t.first ? function(t, i, r) {
                  for (; t = t[n]; )
                      if (1 === t.nodeType || s)
                          return e(t, i, r);
                  return !1
              }
              : function(t, i, l) {
                  var c, u, h, d = [x, a];
                  if (l) {
                      for (; t = t[n]; )
                          if ((1 === t.nodeType || s) && e(t, i, l))
                              return !0
                  } else
                      for (; t = t[n]; )
                          if (1 === t.nodeType || s)
                              if (u = (h = t[b] || (t[b] = {}))[t.uniqueID] || (h[t.uniqueID] = {}),
                              r && r === t.nodeName.toLowerCase())
                                  t = t[n] || t;
                              else {
                                  if ((c = u[o]) && c[0] === x && c[1] === a)
                                      return d[2] = c[2];
                                  if (u[o] = d,
                                  d[2] = e(t, i, l))
                                      return !0
                              }
                  return !1
              }
          }
          function _e(e) {
              return e.length > 1 ? function(t, i, n) {
                  for (var r = e.length; r--; )
                      if (!e[r](t, i, n))
                          return !1;
                  return !0
              }
              : e[0]
          }
          function be(e, t, i, n, r) {
              for (var o, s = [], a = 0, l = e.length, c = null != t; a < l; a++)
                  (o = e[a]) && (i && !i(o, n, r) || (s.push(o),
                  c && t.push(a)));
              return s
          }
          function we(e, t, i, n, r, o) {
              return n && !n[b] && (n = we(n)),
              r && !r[b] && (r = we(r, o)),
              ae(function(o, s, a, l) {
                  var c, u, h, d = [], p = [], f = s.length, m = o || function(e, t, i) {
                      for (var n = 0, r = t.length; n < r; n++)
                          oe(e, t[n], i);
                      return i
                  }(t || "*", a.nodeType ? [a] : a, []), g = !e || !o && t ? m : be(m, d, e, a, l), v = i ? r || (o ? e : f || n) ? [] : s : g;
                  if (i && i(g, v, a, l),
                  n)
                      for (c = be(v, p),
                      n(c, [], a, l),
                      u = c.length; u--; )
                          (h = c[u]) && (v[p[u]] = !(g[p[u]] = h));
                  if (o) {
                      if (r || e) {
                          if (r) {
                              for (c = [],
                              u = v.length; u--; )
                                  (h = v[u]) && c.push(g[u] = h);
                              r(null, v = [], c, l)
                          }
                          for (u = v.length; u--; )
                              (h = v[u]) && (c = r ? z(o, h) : d[u]) > -1 && (o[c] = !(s[c] = h))
                      }
                  } else
                      v = be(v === s ? v.splice(f, v.length) : v),
                      r ? r(null, s, v, l) : M.apply(s, v)
              })
          }
          function xe(e) {
              for (var t, i, r, o = e.length, s = n.relative[e[0].type], a = s || n.relative[" "], l = s ? 1 : 0, u = ye(function(e) {
                  return e === t
              }, a, !0), h = ye(function(e) {
                  return z(t, e) > -1
              }, a, !0), d = [function(e, i, n) {
                  var r = !s && (n || i !== c) || ((t = i).nodeType ? u(e, i, n) : h(e, i, n));
                  return t = null,
                  r
              }
              ]; l < o; l++)
                  if (i = n.relative[e[l].type])
                      d = [ye(_e(d), i)];
                  else {
                      if ((i = n.filter[e[l].type].apply(null, e[l].matches))[b]) {
                          for (r = ++l; r < o && !n.relative[e[r].type]; r++)
                              ;
                          return we(l > 1 && _e(d), l > 1 && ve(e.slice(0, l - 1).concat({
                              value: " " === e[l - 2].type ? "*" : ""
                          })).replace(U, "$1"), i, l < r && xe(e.slice(l, r)), r < o && xe(e = e.slice(r)), r < o && ve(e))
                      }
                      d.push(i)
                  }
              return _e(d)
          }
          return ge.prototype = n.filters = n.pseudos,
          n.setFilters = new ge,
          s = oe.tokenize = function(e, t) {
              var i, r, o, s, a, l, c, u = E[e + " "];
              if (u)
                  return t ? 0 : u.slice(0);
              for (a = e,
              l = [],
              c = n.preFilter; a; ) {
                  for (s in i && !(r = q.exec(a)) || (r && (a = a.slice(r[0].length) || a),
                  l.push(o = [])),
                  i = !1,
                  (r = H.exec(a)) && (i = r.shift(),
                  o.push({
                      value: i,
                      type: r[0].replace(U, " ")
                  }),
                  a = a.slice(i.length)),
                  n.filter)
                      !(r = G[s].exec(a)) || c[s] && !(r = c[s](r)) || (i = r.shift(),
                      o.push({
                          value: i,
                          type: s,
                          matches: r
                      }),
                      a = a.slice(i.length));
                  if (!i)
                      break
              }
              return t ? a.length : a ? oe.error(e) : E(e, l).slice(0)
          }
          ,
          a = oe.compile = function(e, t) {
              var i, r = [], o = [], a = T[e + " "];
              if (!a) {
                  for (t || (t = s(e)),
                  i = t.length; i--; )
                      (a = xe(t[i]))[b] ? r.push(a) : o.push(a);
                  (a = T(e, function(e, t) {
                      var i = t.length > 0
                        , r = e.length > 0
                        , o = function(o, s, a, l, u) {
                          var h, f, g, v = 0, y = "0", _ = o && [], b = [], w = c, k = o || r && n.find.TAG("*", u), S = x += null == w ? 1 : Math.random() || .1, E = k.length;
                          for (u && (c = s === p || s || u); y !== E && null != (h = k[y]); y++) {
                              if (r && h) {
                                  for (f = 0,
                                  s || h.ownerDocument === p || (d(h),
                                  a = !m); g = e[f++]; )
                                      if (g(h, s || p, a)) {
                                          l.push(h);
                                          break
                                      }
                                  u && (x = S)
                              }
                              i && ((h = !g && h) && v--,
                              o && _.push(h))
                          }
                          if (v += y,
                          i && y !== v) {
                              for (f = 0; g = t[f++]; )
                                  g(_, b, s, a);
                              if (o) {
                                  if (v > 0)
                                      for (; y--; )
                                          _[y] || b[y] || (b[y] = P.call(l));
                                  b = be(b)
                              }
                              M.apply(l, b),
                              u && !o && b.length > 0 && v + t.length > 1 && oe.uniqueSort(l)
                          }
                          return u && (x = S,
                          c = w),
                          _
                      };
                      return i ? ae(o) : o
                  }(o, r))).selector = e
              }
              return a
          }
          ,
          l = oe.select = function(e, t, i, r) {
              var o, l, c, u, h, d = "function" == typeof e && e, p = !r && s(e = d.selector || e);
              if (i = i || [],
              1 === p.length) {
                  if ((l = p[0] = p[0].slice(0)).length > 2 && "ID" === (c = l[0]).type && 9 === t.nodeType && m && n.relative[l[1].type]) {
                      if (!(t = (n.find.ID(c.matches[0].replace(Q, ee), t) || [])[0]))
                          return i;
                      d && (t = t.parentNode),
                      e = e.slice(l.shift().value.length)
                  }
                  for (o = G.needsContext.test(e) ? 0 : l.length; o-- && (c = l[o],
                  !n.relative[u = c.type]); )
                      if ((h = n.find[u]) && (r = h(c.matches[0].replace(Q, ee), J.test(l[0].type) && me(t.parentNode) || t))) {
                          if (l.splice(o, 1),
                          !(e = r.length && ve(l)))
                              return M.apply(i, r),
                              i;
                          break
                      }
              }
              return (d || a(e, p))(r, t, !m, i, !t || J.test(e) && me(t.parentNode) || t),
              i
          }
          ,
          i.sortStable = b.split("").sort(C).join("") === b,
          i.detectDuplicates = !!h,
          d(),
          i.sortDetached = le(function(e) {
              return 1 & e.compareDocumentPosition(p.createElement("fieldset"))
          }),
          le(function(e) {
              return e.innerHTML = "<a href='#'></a>",
              "#" === e.firstChild.getAttribute("href")
          }) || ce("type|href|height|width", function(e, t, i) {
              if (!i)
                  return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
          }),
          i.attributes && le(function(e) {
              return e.innerHTML = "<input/>",
              e.firstChild.setAttribute("value", ""),
              "" === e.firstChild.getAttribute("value")
          }) || ce("value", function(e, t, i) {
              if (!i && "input" === e.nodeName.toLowerCase())
                  return e.defaultValue
          }),
          le(function(e) {
              return null == e.getAttribute("disabled")
          }) || ce(D, function(e, t, i) {
              var n;
              if (!i)
                  return !0 === e[t] ? t.toLowerCase() : (n = e.getAttributeNode(t)) && n.specified ? n.value : null
          }),
          oe
      }(i);
      k.find = T,
      k.expr = T.selectors,
      k.expr[":"] = k.expr.pseudos,
      k.uniqueSort = k.unique = T.uniqueSort,
      k.text = T.getText,
      k.isXMLDoc = T.isXML,
      k.contains = T.contains,
      k.escapeSelector = T.escape;
      var C = function(e, t, i) {
          for (var n = [], r = void 0 !== i; (e = e[t]) && 9 !== e.nodeType; )
              if (1 === e.nodeType) {
                  if (r && k(e).is(i))
                      break;
                  n.push(e)
              }
          return n
      }
        , L = function(e, t) {
          for (var i = []; e; e = e.nextSibling)
              1 === e.nodeType && e !== t && i.push(e);
          return i
      }
        , A = k.expr.match.needsContext;
      function P(e, t) {
          return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
      }
      var I = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
      function M(e, t, i) {
          return y(t) ? k.grep(e, function(e, n) {
              return !!t.call(e, n, e) !== i
          }) : t.nodeType ? k.grep(e, function(e) {
              return e === t !== i
          }) : "string" != typeof t ? k.grep(e, function(e) {
              return h.call(t, e) > -1 !== i
          }) : k.filter(t, e, i)
      }
      k.filter = function(e, t, i) {
          var n = t[0];
          return i && (e = ":not(" + e + ")"),
          1 === t.length && 1 === n.nodeType ? k.find.matchesSelector(n, e) ? [n] : [] : k.find.matches(e, k.grep(t, function(e) {
              return 1 === e.nodeType
          }))
      }
      ,
      k.fn.extend({
          find: function(e) {
              var t, i, n = this.length, r = this;
              if ("string" != typeof e)
                  return this.pushStack(k(e).filter(function() {
                      for (t = 0; t < n; t++)
                          if (k.contains(r[t], this))
                              return !0
                  }));
              for (i = this.pushStack([]),
              t = 0; t < n; t++)
                  k.find(e, r[t], i);
              return n > 1 ? k.uniqueSort(i) : i
          },
          filter: function(e) {
              return this.pushStack(M(this, e || [], !1))
          },
          not: function(e) {
              return this.pushStack(M(this, e || [], !0))
          },
          is: function(e) {
              return !!M(this, "string" == typeof e && A.test(e) ? k(e) : e || [], !1).length
          }
      });
      var O, z = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
      (k.fn.init = function(e, t, i) {
          var n, r;
          if (!e)
              return this;
          if (i = i || O,
          "string" == typeof e) {
              if (!(n = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : z.exec(e)) || !n[1] && t)
                  return !t || t.jquery ? (t || i).find(e) : this.constructor(t).find(e);
              if (n[1]) {
                  if (t = t instanceof k ? t[0] : t,
                  k.merge(this, k.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : s, !0)),
                  I.test(n[1]) && k.isPlainObject(t))
                      for (n in t)
                          y(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
                  return this
              }
              return (r = s.getElementById(n[2])) && (this[0] = r,
              this.length = 1),
              this
          }
          return e.nodeType ? (this[0] = e,
          this.length = 1,
          this) : y(e) ? void 0 !== i.ready ? i.ready(e) : e(k) : k.makeArray(e, this)
      }
      ).prototype = k.fn,
      O = k(s);
      var D = /^(?:parents|prev(?:Until|All))/
        , R = {
          children: !0,
          contents: !0,
          next: !0,
          prev: !0
      };
      function B(e, t) {
          for (; (e = e[t]) && 1 !== e.nodeType; )
              ;
          return e
      }
      k.fn.extend({
          has: function(e) {
              var t = k(e, this)
                , i = t.length;
              return this.filter(function() {
                  for (var e = 0; e < i; e++)
                      if (k.contains(this, t[e]))
                          return !0
              })
          },
          closest: function(e, t) {
              var i, n = 0, r = this.length, o = [], s = "string" != typeof e && k(e);
              if (!A.test(e))
                  for (; n < r; n++)
                      for (i = this[n]; i && i !== t; i = i.parentNode)
                          if (i.nodeType < 11 && (s ? s.index(i) > -1 : 1 === i.nodeType && k.find.matchesSelector(i, e))) {
                              o.push(i);
                              break
                          }
              return this.pushStack(o.length > 1 ? k.uniqueSort(o) : o)
          },
          index: function(e) {
              return e ? "string" == typeof e ? h.call(k(e), this[0]) : h.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
          },
          add: function(e, t) {
              return this.pushStack(k.uniqueSort(k.merge(this.get(), k(e, t))))
          },
          addBack: function(e) {
              return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
          }
      }),
      k.each({
          parent: function(e) {
              var t = e.parentNode;
              return t && 11 !== t.nodeType ? t : null
          },
          parents: function(e) {
              return C(e, "parentNode")
          },
          parentsUntil: function(e, t, i) {
              return C(e, "parentNode", i)
          },
          next: function(e) {
              return B(e, "nextSibling")
          },
          prev: function(e) {
              return B(e, "previousSibling")
          },
          nextAll: function(e) {
              return C(e, "nextSibling")
          },
          prevAll: function(e) {
              return C(e, "previousSibling")
          },
          nextUntil: function(e, t, i) {
              return C(e, "nextSibling", i)
          },
          prevUntil: function(e, t, i) {
              return C(e, "previousSibling", i)
          },
          siblings: function(e) {
              return L((e.parentNode || {}).firstChild, e)
          },
          children: function(e) {
              return L(e.firstChild)
          },
          contents: function(e) {
              return P(e, "iframe") ? e.contentDocument : (P(e, "template") && (e = e.content || e),
              k.merge([], e.childNodes))
          }
      }, function(e, t) {
          k.fn[e] = function(i, n) {
              var r = k.map(this, t, i);
              return "Until" !== e.slice(-5) && (n = i),
              n && "string" == typeof n && (r = k.filter(n, r)),
              this.length > 1 && (R[e] || k.uniqueSort(r),
              D.test(e) && r.reverse()),
              this.pushStack(r)
          }
      });
      var j = /[^\x20\t\r\n\f]+/g;
      function F(e) {
          return e
      }
      function N(e) {
          throw e
      }
      function U(e, t, i, n) {
          var r;
          try {
              e && y(r = e.promise) ? r.call(e).done(t).fail(i) : e && y(r = e.then) ? r.call(e, t, i) : t.apply(void 0, [e].slice(n))
          } catch (e) {
              i.apply(void 0, [e])
          }
      }
      k.Callbacks = function(e) {
          e = "string" == typeof e ? function(e) {
              var t = {};
              return k.each(e.match(j) || [], function(e, i) {
                  t[i] = !0
              }),
              t
          }(e) : k.extend({}, e);
          var t, i, n, r, o = [], s = [], a = -1, l = function() {
              for (r = r || e.once,
              n = t = !0; s.length; a = -1)
                  for (i = s.shift(); ++a < o.length; )
                      !1 === o[a].apply(i[0], i[1]) && e.stopOnFalse && (a = o.length,
                      i = !1);
              e.memory || (i = !1),
              t = !1,
              r && (o = i ? [] : "")
          }, c = {
              add: function() {
                  return o && (i && !t && (a = o.length - 1,
                  s.push(i)),
                  function t(i) {
                      k.each(i, function(i, n) {
                          y(n) ? e.unique && c.has(n) || o.push(n) : n && n.length && "string" !== x(n) && t(n)
                      })
                  }(arguments),
                  i && !t && l()),
                  this
              },
              remove: function() {
                  return k.each(arguments, function(e, t) {
                      for (var i; (i = k.inArray(t, o, i)) > -1; )
                          o.splice(i, 1),
                          i <= a && a--
                  }),
                  this
              },
              has: function(e) {
                  return e ? k.inArray(e, o) > -1 : o.length > 0
              },
              empty: function() {
                  return o && (o = []),
                  this
              },
              disable: function() {
                  return r = s = [],
                  o = i = "",
                  this
              },
              disabled: function() {
                  return !o
              },
              lock: function() {
                  return r = s = [],
                  i || t || (o = i = ""),
                  this
              },
              locked: function() {
                  return !!r
              },
              fireWith: function(e, i) {
                  return r || (i = [e, (i = i || []).slice ? i.slice() : i],
                  s.push(i),
                  t || l()),
                  this
              },
              fire: function() {
                  return c.fireWith(this, arguments),
                  this
              },
              fired: function() {
                  return !!n
              }
          };
          return c
      }
      ,
      k.extend({
          Deferred: function(e) {
              var t = [["notify", "progress", k.Callbacks("memory"), k.Callbacks("memory"), 2], ["resolve", "done", k.Callbacks("once memory"), k.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", k.Callbacks("once memory"), k.Callbacks("once memory"), 1, "rejected"]]
                , n = "pending"
                , r = {
                  state: function() {
                      return n
                  },
                  always: function() {
                      return o.done(arguments).fail(arguments),
                      this
                  },
                  catch: function(e) {
                      return r.then(null, e)
                  },
                  pipe: function() {
                      var e = arguments;
                      return k.Deferred(function(i) {
                          k.each(t, function(t, n) {
                              var r = y(e[n[4]]) && e[n[4]];
                              o[n[1]](function() {
                                  var e = r && r.apply(this, arguments);
                                  e && y(e.promise) ? e.promise().progress(i.notify).done(i.resolve).fail(i.reject) : i[n[0] + "With"](this, r ? [e] : arguments)
                              })
                          }),
                          e = null
                      }).promise()
                  },
                  then: function(e, n, r) {
                      var o = 0;
                      function s(e, t, n, r) {
                          return function() {
                              var a = this
                                , l = arguments
                                , c = function() {
                                  var i, c;
                                  if (!(e < o)) {
                                      if ((i = n.apply(a, l)) === t.promise())
                                          throw new TypeError("Thenable self-resolution");
                                      c = i && ("object" == typeof i || "function" == typeof i) && i.then,
                                      y(c) ? r ? c.call(i, s(o, t, F, r), s(o, t, N, r)) : (o++,
                                      c.call(i, s(o, t, F, r), s(o, t, N, r), s(o, t, F, t.notifyWith))) : (n !== F && (a = void 0,
                                      l = [i]),
                                      (r || t.resolveWith)(a, l))
                                  }
                              }
                                , u = r ? c : function() {
                                  try {
                                      c()
                                  } catch (i) {
                                      k.Deferred.exceptionHook && k.Deferred.exceptionHook(i, u.stackTrace),
                                      e + 1 >= o && (n !== N && (a = void 0,
                                      l = [i]),
                                      t.rejectWith(a, l))
                                  }
                              }
                              ;
                              e ? u() : (k.Deferred.getStackHook && (u.stackTrace = k.Deferred.getStackHook()),
                              i.setTimeout(u))
                          }
                      }
                      return k.Deferred(function(i) {
                          t[0][3].add(s(0, i, y(r) ? r : F, i.notifyWith)),
                          t[1][3].add(s(0, i, y(e) ? e : F)),
                          t[2][3].add(s(0, i, y(n) ? n : N))
                      }).promise()
                  },
                  promise: function(e) {
                      return null != e ? k.extend(e, r) : r
                  }
              }
                , o = {};
              return k.each(t, function(e, i) {
                  var s = i[2]
                    , a = i[5];
                  r[i[1]] = s.add,
                  a && s.add(function() {
                      n = a
                  }, t[3 - e][2].disable, t[3 - e][3].disable, t[0][2].lock, t[0][3].lock),
                  s.add(i[3].fire),
                  o[i[0]] = function() {
                      return o[i[0] + "With"](this === o ? void 0 : this, arguments),
                      this
                  }
                  ,
                  o[i[0] + "With"] = s.fireWith
              }),
              r.promise(o),
              e && e.call(o, o),
              o
          },
          when: function(e) {
              var t = arguments.length
                , i = t
                , n = Array(i)
                , r = l.call(arguments)
                , o = k.Deferred()
                , s = function(e) {
                  return function(i) {
                      n[e] = this,
                      r[e] = arguments.length > 1 ? l.call(arguments) : i,
                      --t || o.resolveWith(n, r)
                  }
              };
              if (t <= 1 && (U(e, o.done(s(i)).resolve, o.reject, !t),
              "pending" === o.state() || y(r[i] && r[i].then)))
                  return o.then();
              for (; i--; )
                  U(r[i], s(i), o.reject);
              return o.promise()
          }
      });
      var q = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
      k.Deferred.exceptionHook = function(e, t) {
          i.console && i.console.warn && e && q.test(e.name) && i.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t)
      }
      ,
      k.readyException = function(e) {
          i.setTimeout(function() {
              throw e
          })
      }
      ;
      var H = k.Deferred();
      function V() {
          s.removeEventListener("DOMContentLoaded", V),
          i.removeEventListener("load", V),
          k.ready()
      }
      k.fn.ready = function(e) {
          return H.then(e).catch(function(e) {
              k.readyException(e)
          }),
          this
      }
      ,
      k.extend({
          isReady: !1,
          readyWait: 1,
          ready: function(e) {
              (!0 === e ? --k.readyWait : k.isReady) || (k.isReady = !0,
              !0 !== e && --k.readyWait > 0 || H.resolveWith(s, [k]))
          }
      }),
      k.ready.then = H.then,
      "complete" === s.readyState || "loading" !== s.readyState && !s.documentElement.doScroll ? i.setTimeout(k.ready) : (s.addEventListener("DOMContentLoaded", V),
      i.addEventListener("load", V));
      var W = function(e, t, i, n, r, o, s) {
          var a = 0
            , l = e.length
            , c = null == i;
          if ("object" === x(i))
              for (a in r = !0,
              i)
                  W(e, t, a, i[a], !0, o, s);
          else if (void 0 !== n && (r = !0,
          y(n) || (s = !0),
          c && (s ? (t.call(e, n),
          t = null) : (c = t,
          t = function(e, t, i) {
              return c.call(k(e), i)
          }
          )),
          t))
              for (; a < l; a++)
                  t(e[a], i, s ? n : n.call(e[a], a, t(e[a], i)));
          return r ? e : c ? t.call(e) : l ? t(e[0], i) : o
      }
        , $ = /^-ms-/
        , G = /-([a-z])/g;
      function X(e, t) {
          return t.toUpperCase()
      }
      function Z(e) {
          return e.replace($, "ms-").replace(G, X)
      }
      var Y = function(e) {
          return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
      };
      function K() {
          this.expando = k.expando + K.uid++
      }
      K.uid = 1,
      K.prototype = {
          cache: function(e) {
              var t = e[this.expando];
              return t || (t = {},
              Y(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                  value: t,
                  configurable: !0
              }))),
              t
          },
          set: function(e, t, i) {
              var n, r = this.cache(e);
              if ("string" == typeof t)
                  r[Z(t)] = i;
              else
                  for (n in t)
                      r[Z(n)] = t[n];
              return r
          },
          get: function(e, t) {
              return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][Z(t)]
          },
          access: function(e, t, i) {
              return void 0 === t || t && "string" == typeof t && void 0 === i ? this.get(e, t) : (this.set(e, t, i),
              void 0 !== i ? i : t)
          },
          remove: function(e, t) {
              var i, n = e[this.expando];
              if (void 0 !== n) {
                  if (void 0 !== t) {
                      i = (t = Array.isArray(t) ? t.map(Z) : (t = Z(t))in n ? [t] : t.match(j) || []).length;
                      for (; i--; )
                          delete n[t[i]]
                  }
                  (void 0 === t || k.isEmptyObject(n)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
              }
          },
          hasData: function(e) {
              var t = e[this.expando];
              return void 0 !== t && !k.isEmptyObject(t)
          }
      };
      var J = new K
        , Q = new K
        , ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
        , te = /[A-Z]/g;
      function ie(e, t, i) {
          var n;
          if (void 0 === i && 1 === e.nodeType)
              if (n = "data-" + t.replace(te, "-$&").toLowerCase(),
              "string" == typeof (i = e.getAttribute(n))) {
                  try {
                      i = function(e) {
                          return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : ee.test(e) ? JSON.parse(e) : e)
                      }(i)
                  } catch (e) {}
                  Q.set(e, t, i)
              } else
                  i = void 0;
          return i
      }
      k.extend({
          hasData: function(e) {
              return Q.hasData(e) || J.hasData(e)
          },
          data: function(e, t, i) {
              return Q.access(e, t, i)
          },
          removeData: function(e, t) {
              Q.remove(e, t)
          },
          _data: function(e, t, i) {
              return J.access(e, t, i)
          },
          _removeData: function(e, t) {
              J.remove(e, t)
          }
      }),
      k.fn.extend({
          data: function(e, t) {
              var i, n, r, o = this[0], s = o && o.attributes;
              if (void 0 === e) {
                  if (this.length && (r = Q.get(o),
                  1 === o.nodeType && !J.get(o, "hasDataAttrs"))) {
                      for (i = s.length; i--; )
                          s[i] && 0 === (n = s[i].name).indexOf("data-") && (n = Z(n.slice(5)),
                          ie(o, n, r[n]));
                      J.set(o, "hasDataAttrs", !0)
                  }
                  return r
              }
              return "object" == typeof e ? this.each(function() {
                  Q.set(this, e)
              }) : W(this, function(t) {
                  var i;
                  if (o && void 0 === t)
                      return void 0 !== (i = Q.get(o, e)) ? i : void 0 !== (i = ie(o, e)) ? i : void 0;
                  this.each(function() {
                      Q.set(this, e, t)
                  })
              }, null, t, arguments.length > 1, null, !0)
          },
          removeData: function(e) {
              return this.each(function() {
                  Q.remove(this, e)
              })
          }
      }),
      k.extend({
          queue: function(e, t, i) {
              var n;
              if (e)
                  return t = (t || "fx") + "queue",
                  n = J.get(e, t),
                  i && (!n || Array.isArray(i) ? n = J.access(e, t, k.makeArray(i)) : n.push(i)),
                  n || []
          },
          dequeue: function(e, t) {
              t = t || "fx";
              var i = k.queue(e, t)
                , n = i.length
                , r = i.shift()
                , o = k._queueHooks(e, t);
              "inprogress" === r && (r = i.shift(),
              n--),
              r && ("fx" === t && i.unshift("inprogress"),
              delete o.stop,
              r.call(e, function() {
                  k.dequeue(e, t)
              }, o)),
              !n && o && o.empty.fire()
          },
          _queueHooks: function(e, t) {
              var i = t + "queueHooks";
              return J.get(e, i) || J.access(e, i, {
                  empty: k.Callbacks("once memory").add(function() {
                      J.remove(e, [t + "queue", i])
                  })
              })
          }
      }),
      k.fn.extend({
          queue: function(e, t) {
              var i = 2;
              return "string" != typeof e && (t = e,
              e = "fx",
              i--),
              arguments.length < i ? k.queue(this[0], e) : void 0 === t ? this : this.each(function() {
                  var i = k.queue(this, e, t);
                  k._queueHooks(this, e),
                  "fx" === e && "inprogress" !== i[0] && k.dequeue(this, e)
              })
          },
          dequeue: function(e) {
              return this.each(function() {
                  k.dequeue(this, e)
              })
          },
          clearQueue: function(e) {
              return this.queue(e || "fx", [])
          },
          promise: function(e, t) {
              var i, n = 1, r = k.Deferred(), o = this, s = this.length, a = function() {
                  --n || r.resolveWith(o, [o])
              };
              for ("string" != typeof e && (t = e,
              e = void 0),
              e = e || "fx"; s--; )
                  (i = J.get(o[s], e + "queueHooks")) && i.empty && (n++,
                  i.empty.add(a));
              return a(),
              r.promise(t)
          }
      });
      var ne = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
        , re = new RegExp("^(?:([+-])=|)(" + ne + ")([a-z%]*)$","i")
        , oe = ["Top", "Right", "Bottom", "Left"]
        , se = function(e, t) {
          return "none" === (e = t || e).style.display || "" === e.style.display && k.contains(e.ownerDocument, e) && "none" === k.css(e, "display")
      }
        , ae = function(e, t, i, n) {
          var r, o, s = {};
          for (o in t)
              s[o] = e.style[o],
              e.style[o] = t[o];
          for (o in r = i.apply(e, n || []),
          t)
              e.style[o] = s[o];
          return r
      };
      function le(e, t, i, n) {
          var r, o, s = 20, a = n ? function() {
              return n.cur()
          }
          : function() {
              return k.css(e, t, "")
          }
          , l = a(), c = i && i[3] || (k.cssNumber[t] ? "" : "px"), u = (k.cssNumber[t] || "px" !== c && +l) && re.exec(k.css(e, t));
          if (u && u[3] !== c) {
              for (l /= 2,
              c = c || u[3],
              u = +l || 1; s--; )
                  k.style(e, t, u + c),
                  (1 - o) * (1 - (o = a() / l || .5)) <= 0 && (s = 0),
                  u /= o;
              u *= 2,
              k.style(e, t, u + c),
              i = i || []
          }
          return i && (u = +u || +l || 0,
          r = i[1] ? u + (i[1] + 1) * i[2] : +i[2],
          n && (n.unit = c,
          n.start = u,
          n.end = r)),
          r
      }
      var ce = {};
      function ue(e) {
          var t, i = e.ownerDocument, n = e.nodeName, r = ce[n];
          return r || (t = i.body.appendChild(i.createElement(n)),
          r = k.css(t, "display"),
          t.parentNode.removeChild(t),
          "none" === r && (r = "block"),
          ce[n] = r,
          r)
      }
      function he(e, t) {
          for (var i, n, r = [], o = 0, s = e.length; o < s; o++)
              (n = e[o]).style && (i = n.style.display,
              t ? ("none" === i && (r[o] = J.get(n, "display") || null,
              r[o] || (n.style.display = "")),
              "" === n.style.display && se(n) && (r[o] = ue(n))) : "none" !== i && (r[o] = "none",
              J.set(n, "display", i)));
          for (o = 0; o < s; o++)
              null != r[o] && (e[o].style.display = r[o]);
          return e
      }
      k.fn.extend({
          show: function() {
              return he(this, !0)
          },
          hide: function() {
              return he(this)
          },
          toggle: function(e) {
              return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                  se(this) ? k(this).show() : k(this).hide()
              })
          }
      });
      var de = /^(?:checkbox|radio)$/i
        , pe = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i
        , fe = /^$|^module$|\/(?:java|ecma)script/i
        , me = {
          option: [1, "<select multiple='multiple'>", "</select>"],
          thead: [1, "<table>", "</table>"],
          col: [2, "<table><colgroup>", "</colgroup></table>"],
          tr: [2, "<table><tbody>", "</tbody></table>"],
          td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
          _default: [0, "", ""]
      };
      function ge(e, t) {
          var i;
          return i = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [],
          void 0 === t || t && P(e, t) ? k.merge([e], i) : i
      }
      function ve(e, t) {
          for (var i = 0, n = e.length; i < n; i++)
              J.set(e[i], "globalEval", !t || J.get(t[i], "globalEval"))
      }
      me.optgroup = me.option,
      me.tbody = me.tfoot = me.colgroup = me.caption = me.thead,
      me.th = me.td;
      var ye, _e, be = /<|&#?\w+;/;
      function we(e, t, i, n, r) {
          for (var o, s, a, l, c, u, h = t.createDocumentFragment(), d = [], p = 0, f = e.length; p < f; p++)
              if ((o = e[p]) || 0 === o)
                  if ("object" === x(o))
                      k.merge(d, o.nodeType ? [o] : o);
                  else if (be.test(o)) {
                      for (s = s || h.appendChild(t.createElement("div")),
                      a = (pe.exec(o) || ["", ""])[1].toLowerCase(),
                      l = me[a] || me._default,
                      s.innerHTML = l[1] + k.htmlPrefilter(o) + l[2],
                      u = l[0]; u--; )
                          s = s.lastChild;
                      k.merge(d, s.childNodes),
                      (s = h.firstChild).textContent = ""
                  } else
                      d.push(t.createTextNode(o));
          for (h.textContent = "",
          p = 0; o = d[p++]; )
              if (n && k.inArray(o, n) > -1)
                  r && r.push(o);
              else if (c = k.contains(o.ownerDocument, o),
              s = ge(h.appendChild(o), "script"),
              c && ve(s),
              i)
                  for (u = 0; o = s[u++]; )
                      fe.test(o.type || "") && i.push(o);
          return h
      }
      ye = s.createDocumentFragment().appendChild(s.createElement("div")),
      (_e = s.createElement("input")).setAttribute("type", "radio"),
      _e.setAttribute("checked", "checked"),
      _e.setAttribute("name", "t"),
      ye.appendChild(_e),
      v.checkClone = ye.cloneNode(!0).cloneNode(!0).lastChild.checked,
      ye.innerHTML = "<textarea>x</textarea>",
      v.noCloneChecked = !!ye.cloneNode(!0).lastChild.defaultValue;
      var xe = s.documentElement
        , ke = /^key/
        , Se = /^(?:mouse|pointer|contextmenu|drag|drop)|click/
        , Ee = /^([^.]*)(?:\.(.+)|)/;
      function Te() {
          return !0
      }
      function Ce() {
          return !1
      }
      function Le() {
          try {
              return s.activeElement
          } catch (e) {}
      }
      function Ae(e, t, i, n, r, o) {
          var s, a;
          if ("object" == typeof t) {
              for (a in "string" != typeof i && (n = n || i,
              i = void 0),
              t)
                  Ae(e, a, i, n, t[a], o);
              return e
          }
          if (null == n && null == r ? (r = i,
          n = i = void 0) : null == r && ("string" == typeof i ? (r = n,
          n = void 0) : (r = n,
          n = i,
          i = void 0)),
          !1 === r)
              r = Ce;
          else if (!r)
              return e;
          return 1 === o && (s = r,
          (r = function(e) {
              return k().off(e),
              s.apply(this, arguments)
          }
          ).guid = s.guid || (s.guid = k.guid++)),
          e.each(function() {
              k.event.add(this, t, r, n, i)
          })
      }
      k.event = {
          global: {},
          add: function(e, t, i, n, r) {
              var o, s, a, l, c, u, h, d, p, f, m, g = J.get(e);
              if (g)
                  for (i.handler && (i = (o = i).handler,
                  r = o.selector),
                  r && k.find.matchesSelector(xe, r),
                  i.guid || (i.guid = k.guid++),
                  (l = g.events) || (l = g.events = {}),
                  (s = g.handle) || (s = g.handle = function(t) {
                      return void 0 !== k && k.event.triggered !== t.type ? k.event.dispatch.apply(e, arguments) : void 0
                  }
                  ),
                  c = (t = (t || "").match(j) || [""]).length; c--; )
                      p = m = (a = Ee.exec(t[c]) || [])[1],
                      f = (a[2] || "").split(".").sort(),
                      p && (h = k.event.special[p] || {},
                      p = (r ? h.delegateType : h.bindType) || p,
                      h = k.event.special[p] || {},
                      u = k.extend({
                          type: p,
                          origType: m,
                          data: n,
                          handler: i,
                          guid: i.guid,
                          selector: r,
                          needsContext: r && k.expr.match.needsContext.test(r),
                          namespace: f.join(".")
                      }, o),
                      (d = l[p]) || ((d = l[p] = []).delegateCount = 0,
                      h.setup && !1 !== h.setup.call(e, n, f, s) || e.addEventListener && e.addEventListener(p, s)),
                      h.add && (h.add.call(e, u),
                      u.handler.guid || (u.handler.guid = i.guid)),
                      r ? d.splice(d.delegateCount++, 0, u) : d.push(u),
                      k.event.global[p] = !0)
          },
          remove: function(e, t, i, n, r) {
              var o, s, a, l, c, u, h, d, p, f, m, g = J.hasData(e) && J.get(e);
              if (g && (l = g.events)) {
                  for (c = (t = (t || "").match(j) || [""]).length; c--; )
                      if (p = m = (a = Ee.exec(t[c]) || [])[1],
                      f = (a[2] || "").split(".").sort(),
                      p) {
                          for (h = k.event.special[p] || {},
                          d = l[p = (n ? h.delegateType : h.bindType) || p] || [],
                          a = a[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                          s = o = d.length; o--; )
                              u = d[o],
                              !r && m !== u.origType || i && i.guid !== u.guid || a && !a.test(u.namespace) || n && n !== u.selector && ("**" !== n || !u.selector) || (d.splice(o, 1),
                              u.selector && d.delegateCount--,
                              h.remove && h.remove.call(e, u));
                          s && !d.length && (h.teardown && !1 !== h.teardown.call(e, f, g.handle) || k.removeEvent(e, p, g.handle),
                          delete l[p])
                      } else
                          for (p in l)
                              k.event.remove(e, p + t[c], i, n, !0);
                  k.isEmptyObject(l) && J.remove(e, "handle events")
              }
          },
          dispatch: function(e) {
              var t, i, n, r, o, s, a = k.event.fix(e), l = new Array(arguments.length), c = (J.get(this, "events") || {})[a.type] || [], u = k.event.special[a.type] || {};
              for (l[0] = a,
              t = 1; t < arguments.length; t++)
                  l[t] = arguments[t];
              if (a.delegateTarget = this,
              !u.preDispatch || !1 !== u.preDispatch.call(this, a)) {
                  for (s = k.event.handlers.call(this, a, c),
                  t = 0; (r = s[t++]) && !a.isPropagationStopped(); )
                      for (a.currentTarget = r.elem,
                      i = 0; (o = r.handlers[i++]) && !a.isImmediatePropagationStopped(); )
                          a.rnamespace && !a.rnamespace.test(o.namespace) || (a.handleObj = o,
                          a.data = o.data,
                          void 0 !== (n = ((k.event.special[o.origType] || {}).handle || o.handler).apply(r.elem, l)) && !1 === (a.result = n) && (a.preventDefault(),
                          a.stopPropagation()));
                  return u.postDispatch && u.postDispatch.call(this, a),
                  a.result
              }
          },
          handlers: function(e, t) {
              var i, n, r, o, s, a = [], l = t.delegateCount, c = e.target;
              if (l && c.nodeType && !("click" === e.type && e.button >= 1))
                  for (; c !== this; c = c.parentNode || this)
                      if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                          for (o = [],
                          s = {},
                          i = 0; i < l; i++)
                              void 0 === s[r = (n = t[i]).selector + " "] && (s[r] = n.needsContext ? k(r, this).index(c) > -1 : k.find(r, this, null, [c]).length),
                              s[r] && o.push(n);
                          o.length && a.push({
                              elem: c,
                              handlers: o
                          })
                      }
              return c = this,
              l < t.length && a.push({
                  elem: c,
                  handlers: t.slice(l)
              }),
              a
          },
          addProp: function(e, t) {
              Object.defineProperty(k.Event.prototype, e, {
                  enumerable: !0,
                  configurable: !0,
                  get: y(t) ? function() {
                      if (this.originalEvent)
                          return t(this.originalEvent)
                  }
                  : function() {
                      if (this.originalEvent)
                          return this.originalEvent[e]
                  }
                  ,
                  set: function(t) {
                      Object.defineProperty(this, e, {
                          enumerable: !0,
                          configurable: !0,
                          writable: !0,
                          value: t
                      })
                  }
              })
          },
          fix: function(e) {
              return e[k.expando] ? e : new k.Event(e)
          },
          special: {
              load: {
                  noBubble: !0
              },
              focus: {
                  trigger: function() {
                      if (this !== Le() && this.focus)
                          return this.focus(),
                          !1
                  },
                  delegateType: "focusin"
              },
              blur: {
                  trigger: function() {
                      if (this === Le() && this.blur)
                          return this.blur(),
                          !1
                  },
                  delegateType: "focusout"
              },
              click: {
                  trigger: function() {
                      if ("checkbox" === this.type && this.click && P(this, "input"))
                          return this.click(),
                          !1
                  },
                  _default: function(e) {
                      return P(e.target, "a")
                  }
              },
              beforeunload: {
                  postDispatch: function(e) {
                      void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                  }
              }
          }
      },
      k.removeEvent = function(e, t, i) {
          e.removeEventListener && e.removeEventListener(t, i)
      }
      ,
      k.Event = function(e, t) {
          if (!(this instanceof k.Event))
              return new k.Event(e,t);
          e && e.type ? (this.originalEvent = e,
          this.type = e.type,
          this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Te : Ce,
          this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target,
          this.currentTarget = e.currentTarget,
          this.relatedTarget = e.relatedTarget) : this.type = e,
          t && k.extend(this, t),
          this.timeStamp = e && e.timeStamp || Date.now(),
          this[k.expando] = !0
      }
      ,
      k.Event.prototype = {
          constructor: k.Event,
          isDefaultPrevented: Ce,
          isPropagationStopped: Ce,
          isImmediatePropagationStopped: Ce,
          isSimulated: !1,
          preventDefault: function() {
              var e = this.originalEvent;
              this.isDefaultPrevented = Te,
              e && !this.isSimulated && e.preventDefault()
          },
          stopPropagation: function() {
              var e = this.originalEvent;
              this.isPropagationStopped = Te,
              e && !this.isSimulated && e.stopPropagation()
          },
          stopImmediatePropagation: function() {
              var e = this.originalEvent;
              this.isImmediatePropagationStopped = Te,
              e && !this.isSimulated && e.stopImmediatePropagation(),
              this.stopPropagation()
          }
      },
      k.each({
          altKey: !0,
          bubbles: !0,
          cancelable: !0,
          changedTouches: !0,
          ctrlKey: !0,
          detail: !0,
          eventPhase: !0,
          metaKey: !0,
          pageX: !0,
          pageY: !0,
          shiftKey: !0,
          view: !0,
          char: !0,
          charCode: !0,
          key: !0,
          keyCode: !0,
          button: !0,
          buttons: !0,
          clientX: !0,
          clientY: !0,
          offsetX: !0,
          offsetY: !0,
          pointerId: !0,
          pointerType: !0,
          screenX: !0,
          screenY: !0,
          targetTouches: !0,
          toElement: !0,
          touches: !0,
          which: function(e) {
              var t = e.button;
              return null == e.which && ke.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && Se.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which
          }
      }, k.event.addProp),
      k.each({
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout"
      }, function(e, t) {
          k.event.special[e] = {
              delegateType: t,
              bindType: t,
              handle: function(e) {
                  var i, n = e.relatedTarget, r = e.handleObj;
                  return n && (n === this || k.contains(this, n)) || (e.type = r.origType,
                  i = r.handler.apply(this, arguments),
                  e.type = t),
                  i
              }
          }
      }),
      k.fn.extend({
          on: function(e, t, i, n) {
              return Ae(this, e, t, i, n)
          },
          one: function(e, t, i, n) {
              return Ae(this, e, t, i, n, 1)
          },
          off: function(e, t, i) {
              var n, r;
              if (e && e.preventDefault && e.handleObj)
                  return n = e.handleObj,
                  k(e.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler),
                  this;
              if ("object" == typeof e) {
                  for (r in e)
                      this.off(r, t, e[r]);
                  return this
              }
              return !1 !== t && "function" != typeof t || (i = t,
              t = void 0),
              !1 === i && (i = Ce),
              this.each(function() {
                  k.event.remove(this, e, i, t)
              })
          }
      });
      var Pe = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi
        , Ie = /<script|<style|<link/i
        , Me = /checked\s*(?:[^=]|=\s*.checked.)/i
        , Oe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
      function ze(e, t) {
          return P(e, "table") && P(11 !== t.nodeType ? t : t.firstChild, "tr") && k(e).children("tbody")[0] || e
      }
      function De(e) {
          return e.type = (null !== e.getAttribute("type")) + "/" + e.type,
          e
      }
      function Re(e) {
          return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"),
          e
      }
      function Be(e, t) {
          var i, n, r, o, s, a, l, c;
          if (1 === t.nodeType) {
              if (J.hasData(e) && (o = J.access(e),
              s = J.set(t, o),
              c = o.events))
                  for (r in delete s.handle,
                  s.events = {},
                  c)
                      for (i = 0,
                      n = c[r].length; i < n; i++)
                          k.event.add(t, r, c[r][i]);
              Q.hasData(e) && (a = Q.access(e),
              l = k.extend({}, a),
              Q.set(t, l))
          }
      }
      function je(e, t, i, n) {
          t = c.apply([], t);
          var r, o, s, a, l, u, h = 0, d = e.length, p = d - 1, f = t[0], m = y(f);
          if (m || d > 1 && "string" == typeof f && !v.checkClone && Me.test(f))
              return e.each(function(r) {
                  var o = e.eq(r);
                  m && (t[0] = f.call(this, r, o.html())),
                  je(o, t, i, n)
              });
          if (d && (o = (r = we(t, e[0].ownerDocument, !1, e, n)).firstChild,
          1 === r.childNodes.length && (r = o),
          o || n)) {
              for (a = (s = k.map(ge(r, "script"), De)).length; h < d; h++)
                  l = r,
                  h !== p && (l = k.clone(l, !0, !0),
                  a && k.merge(s, ge(l, "script"))),
                  i.call(e[h], l, h);
              if (a)
                  for (u = s[s.length - 1].ownerDocument,
                  k.map(s, Re),
                  h = 0; h < a; h++)
                      l = s[h],
                      fe.test(l.type || "") && !J.access(l, "globalEval") && k.contains(u, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? k._evalUrl && k._evalUrl(l.src) : w(l.textContent.replace(Oe, ""), u, l))
          }
          return e
      }
      function Fe(e, t, i) {
          for (var n, r = t ? k.filter(t, e) : e, o = 0; null != (n = r[o]); o++)
              i || 1 !== n.nodeType || k.cleanData(ge(n)),
              n.parentNode && (i && k.contains(n.ownerDocument, n) && ve(ge(n, "script")),
              n.parentNode.removeChild(n));
          return e
      }
      k.extend({
          htmlPrefilter: function(e) {
              return e.replace(Pe, "<$1></$2>")
          },
          clone: function(e, t, i) {
              var n, r, o, s, a, l, c, u = e.cloneNode(!0), h = k.contains(e.ownerDocument, e);
              if (!(v.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || k.isXMLDoc(e)))
                  for (s = ge(u),
                  n = 0,
                  r = (o = ge(e)).length; n < r; n++)
                      a = o[n],
                      l = s[n],
                      c = void 0,
                      "input" === (c = l.nodeName.toLowerCase()) && de.test(a.type) ? l.checked = a.checked : "input" !== c && "textarea" !== c || (l.defaultValue = a.defaultValue);
              if (t)
                  if (i)
                      for (o = o || ge(e),
                      s = s || ge(u),
                      n = 0,
                      r = o.length; n < r; n++)
                          Be(o[n], s[n]);
                  else
                      Be(e, u);
              return (s = ge(u, "script")).length > 0 && ve(s, !h && ge(e, "script")),
              u
          },
          cleanData: function(e) {
              for (var t, i, n, r = k.event.special, o = 0; void 0 !== (i = e[o]); o++)
                  if (Y(i)) {
                      if (t = i[J.expando]) {
                          if (t.events)
                              for (n in t.events)
                                  r[n] ? k.event.remove(i, n) : k.removeEvent(i, n, t.handle);
                          i[J.expando] = void 0
                      }
                      i[Q.expando] && (i[Q.expando] = void 0)
                  }
          }
      }),
      k.fn.extend({
          detach: function(e) {
              return Fe(this, e, !0)
          },
          remove: function(e) {
              return Fe(this, e)
          },
          text: function(e) {
              return W(this, function(e) {
                  return void 0 === e ? k.text(this) : this.empty().each(function() {
                      1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                  })
              }, null, e, arguments.length)
          },
          append: function() {
              return je(this, arguments, function(e) {
                  1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || ze(this, e).appendChild(e)
              })
          },
          prepend: function() {
              return je(this, arguments, function(e) {
                  if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                      var t = ze(this, e);
                      t.insertBefore(e, t.firstChild)
                  }
              })
          },
          before: function() {
              return je(this, arguments, function(e) {
                  this.parentNode && this.parentNode.insertBefore(e, this)
              })
          },
          after: function() {
              return je(this, arguments, function(e) {
                  this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
              })
          },
          empty: function() {
              for (var e, t = 0; null != (e = this[t]); t++)
                  1 === e.nodeType && (k.cleanData(ge(e, !1)),
                  e.textContent = "");
              return this
          },
          clone: function(e, t) {
              return e = null != e && e,
              t = null == t ? e : t,
              this.map(function() {
                  return k.clone(this, e, t)
              })
          },
          html: function(e) {
              return W(this, function(e) {
                  var t = this[0] || {}
                    , i = 0
                    , n = this.length;
                  if (void 0 === e && 1 === t.nodeType)
                      return t.innerHTML;
                  if ("string" == typeof e && !Ie.test(e) && !me[(pe.exec(e) || ["", ""])[1].toLowerCase()]) {
                      e = k.htmlPrefilter(e);
                      try {
                          for (; i < n; i++)
                              1 === (t = this[i] || {}).nodeType && (k.cleanData(ge(t, !1)),
                              t.innerHTML = e);
                          t = 0
                      } catch (e) {}
                  }
                  t && this.empty().append(e)
              }, null, e, arguments.length)
          },
          replaceWith: function() {
              var e = [];
              return je(this, arguments, function(t) {
                  var i = this.parentNode;
                  k.inArray(this, e) < 0 && (k.cleanData(ge(this)),
                  i && i.replaceChild(t, this))
              }, e)
          }
      }),
      k.each({
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith"
      }, function(e, t) {
          k.fn[e] = function(e) {
              for (var i, n = [], r = k(e), o = r.length - 1, s = 0; s <= o; s++)
                  i = s === o ? this : this.clone(!0),
                  k(r[s])[t](i),
                  u.apply(n, i.get());
              return this.pushStack(n)
          }
      });
      var Ne = new RegExp("^(" + ne + ")(?!px)[a-z%]+$","i")
        , Ue = function(e) {
          var t = e.ownerDocument.defaultView;
          return t && t.opener || (t = i),
          t.getComputedStyle(e)
      }
        , qe = new RegExp(oe.join("|"),"i");
      function He(e, t, i) {
          var n, r, o, s, a = e.style;
          return (i = i || Ue(e)) && ("" !== (s = i.getPropertyValue(t) || i[t]) || k.contains(e.ownerDocument, e) || (s = k.style(e, t)),
          !v.pixelBoxStyles() && Ne.test(s) && qe.test(t) && (n = a.width,
          r = a.minWidth,
          o = a.maxWidth,
          a.minWidth = a.maxWidth = a.width = s,
          s = i.width,
          a.width = n,
          a.minWidth = r,
          a.maxWidth = o)),
          void 0 !== s ? s + "" : s
      }
      function Ve(e, t) {
          return {
              get: function() {
                  if (!e())
                      return (this.get = t).apply(this, arguments);
                  delete this.get
              }
          }
      }
      !function() {
          function e() {
              if (u) {
                  c.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",
                  u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",
                  xe.appendChild(c).appendChild(u);
                  var e = i.getComputedStyle(u);
                  n = "1%" !== e.top,
                  l = 12 === t(e.marginLeft),
                  u.style.right = "60%",
                  a = 36 === t(e.right),
                  r = 36 === t(e.width),
                  u.style.position = "absolute",
                  o = 36 === u.offsetWidth || "absolute",
                  xe.removeChild(c),
                  u = null
              }
          }
          function t(e) {
              return Math.round(parseFloat(e))
          }
          var n, r, o, a, l, c = s.createElement("div"), u = s.createElement("div");
          u.style && (u.style.backgroundClip = "content-box",
          u.cloneNode(!0).style.backgroundClip = "",
          v.clearCloneStyle = "content-box" === u.style.backgroundClip,
          k.extend(v, {
              boxSizingReliable: function() {
                  return e(),
                  r
              },
              pixelBoxStyles: function() {
                  return e(),
                  a
              },
              pixelPosition: function() {
                  return e(),
                  n
              },
              reliableMarginLeft: function() {
                  return e(),
                  l
              },
              scrollboxSize: function() {
                  return e(),
                  o
              }
          }))
      }();
      var We = /^(none|table(?!-c[ea]).+)/
        , $e = /^--/
        , Ge = {
          position: "absolute",
          visibility: "hidden",
          display: "block"
      }
        , Xe = {
          letterSpacing: "0",
          fontWeight: "400"
      }
        , Ze = ["Webkit", "Moz", "ms"]
        , Ye = s.createElement("div").style;
      function Ke(e) {
          var t = k.cssProps[e];
          return t || (t = k.cssProps[e] = function(e) {
              if (e in Ye)
                  return e;
              for (var t = e[0].toUpperCase() + e.slice(1), i = Ze.length; i--; )
                  if ((e = Ze[i] + t)in Ye)
                      return e
          }(e) || e),
          t
      }
      function Je(e, t, i) {
          var n = re.exec(t);
          return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : t
      }
      function Qe(e, t, i, n, r, o) {
          var s = "width" === t ? 1 : 0
            , a = 0
            , l = 0;
          if (i === (n ? "border" : "content"))
              return 0;
          for (; s < 4; s += 2)
              "margin" === i && (l += k.css(e, i + oe[s], !0, r)),
              n ? ("content" === i && (l -= k.css(e, "padding" + oe[s], !0, r)),
              "margin" !== i && (l -= k.css(e, "border" + oe[s] + "Width", !0, r))) : (l += k.css(e, "padding" + oe[s], !0, r),
              "padding" !== i ? l += k.css(e, "border" + oe[s] + "Width", !0, r) : a += k.css(e, "border" + oe[s] + "Width", !0, r));
          return !n && o >= 0 && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - l - a - .5))),
          l
      }
      function et(e, t, i) {
          var n = Ue(e)
            , r = He(e, t, n)
            , o = "border-box" === k.css(e, "boxSizing", !1, n)
            , s = o;
          if (Ne.test(r)) {
              if (!i)
                  return r;
              r = "auto"
          }
          return s = s && (v.boxSizingReliable() || r === e.style[t]),
          ("auto" === r || !parseFloat(r) && "inline" === k.css(e, "display", !1, n)) && (r = e["offset" + t[0].toUpperCase() + t.slice(1)],
          s = !0),
          (r = parseFloat(r) || 0) + Qe(e, t, i || (o ? "border" : "content"), s, n, r) + "px"
      }
      function tt(e, t, i, n, r) {
          return new tt.prototype.init(e,t,i,n,r)
      }
      k.extend({
          cssHooks: {
              opacity: {
                  get: function(e, t) {
                      if (t) {
                          var i = He(e, "opacity");
                          return "" === i ? "1" : i
                      }
                  }
              }
          },
          cssNumber: {
              animationIterationCount: !0,
              columnCount: !0,
              fillOpacity: !0,
              flexGrow: !0,
              flexShrink: !0,
              fontWeight: !0,
              lineHeight: !0,
              opacity: !0,
              order: !0,
              orphans: !0,
              widows: !0,
              zIndex: !0,
              zoom: !0
          },
          cssProps: {},
          style: function(e, t, i, n) {
              if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                  var r, o, s, a = Z(t), l = $e.test(t), c = e.style;
                  if (l || (t = Ke(a)),
                  s = k.cssHooks[t] || k.cssHooks[a],
                  void 0 === i)
                      return s && "get"in s && void 0 !== (r = s.get(e, !1, n)) ? r : c[t];
                  "string" === (o = typeof i) && (r = re.exec(i)) && r[1] && (i = le(e, t, r),
                  o = "number"),
                  null != i && i == i && ("number" === o && (i += r && r[3] || (k.cssNumber[a] ? "" : "px")),
                  v.clearCloneStyle || "" !== i || 0 !== t.indexOf("background") || (c[t] = "inherit"),
                  s && "set"in s && void 0 === (i = s.set(e, i, n)) || (l ? c.setProperty(t, i) : c[t] = i))
              }
          },
          css: function(e, t, i, n) {
              var r, o, s, a = Z(t);
              return $e.test(t) || (t = Ke(a)),
              (s = k.cssHooks[t] || k.cssHooks[a]) && "get"in s && (r = s.get(e, !0, i)),
              void 0 === r && (r = He(e, t, n)),
              "normal" === r && t in Xe && (r = Xe[t]),
              "" === i || i ? (o = parseFloat(r),
              !0 === i || isFinite(o) ? o || 0 : r) : r
          }
      }),
      k.each(["height", "width"], function(e, t) {
          k.cssHooks[t] = {
              get: function(e, i, n) {
                  if (i)
                      return !We.test(k.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? et(e, t, n) : ae(e, Ge, function() {
                          return et(e, t, n)
                      })
              },
              set: function(e, i, n) {
                  var r, o = Ue(e), s = "border-box" === k.css(e, "boxSizing", !1, o), a = n && Qe(e, t, n, s, o);
                  return s && v.scrollboxSize() === o.position && (a -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - Qe(e, t, "border", !1, o) - .5)),
                  a && (r = re.exec(i)) && "px" !== (r[3] || "px") && (e.style[t] = i,
                  i = k.css(e, t)),
                  Je(0, i, a)
              }
          }
      }),
      k.cssHooks.marginLeft = Ve(v.reliableMarginLeft, function(e, t) {
          if (t)
              return (parseFloat(He(e, "marginLeft")) || e.getBoundingClientRect().left - ae(e, {
                  marginLeft: 0
              }, function() {
                  return e.getBoundingClientRect().left
              })) + "px"
      }),
      k.each({
          margin: "",
          padding: "",
          border: "Width"
      }, function(e, t) {
          k.cssHooks[e + t] = {
              expand: function(i) {
                  for (var n = 0, r = {}, o = "string" == typeof i ? i.split(" ") : [i]; n < 4; n++)
                      r[e + oe[n] + t] = o[n] || o[n - 2] || o[0];
                  return r
              }
          },
          "margin" !== e && (k.cssHooks[e + t].set = Je)
      }),
      k.fn.extend({
          css: function(e, t) {
              return W(this, function(e, t, i) {
                  var n, r, o = {}, s = 0;
                  if (Array.isArray(t)) {
                      for (n = Ue(e),
                      r = t.length; s < r; s++)
                          o[t[s]] = k.css(e, t[s], !1, n);
                      return o
                  }
                  return void 0 !== i ? k.style(e, t, i) : k.css(e, t)
              }, e, t, arguments.length > 1)
          }
      }),
      k.Tween = tt,
      tt.prototype = {
          constructor: tt,
          init: function(e, t, i, n, r, o) {
              this.elem = e,
              this.prop = i,
              this.easing = r || k.easing._default,
              this.options = t,
              this.start = this.now = this.cur(),
              this.end = n,
              this.unit = o || (k.cssNumber[i] ? "" : "px")
          },
          cur: function() {
              var e = tt.propHooks[this.prop];
              return e && e.get ? e.get(this) : tt.propHooks._default.get(this)
          },
          run: function(e) {
              var t, i = tt.propHooks[this.prop];
              return this.options.duration ? this.pos = t = k.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e,
              this.now = (this.end - this.start) * t + this.start,
              this.options.step && this.options.step.call(this.elem, this.now, this),
              i && i.set ? i.set(this) : tt.propHooks._default.set(this),
              this
          }
      },
      tt.prototype.init.prototype = tt.prototype,
      tt.propHooks = {
          _default: {
              get: function(e) {
                  var t;
                  return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = k.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0
              },
              set: function(e) {
                  k.fx.step[e.prop] ? k.fx.step[e.prop](e) : 1 !== e.elem.nodeType || null == e.elem.style[k.cssProps[e.prop]] && !k.cssHooks[e.prop] ? e.elem[e.prop] = e.now : k.style(e.elem, e.prop, e.now + e.unit)
              }
          }
      },
      tt.propHooks.scrollTop = tt.propHooks.scrollLeft = {
          set: function(e) {
              e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
          }
      },
      k.easing = {
          linear: function(e) {
              return e
          },
          swing: function(e) {
              return .5 - Math.cos(e * Math.PI) / 2
          },
          _default: "swing"
      },
      k.fx = tt.prototype.init,
      k.fx.step = {};
      var it, nt, rt = /^(?:toggle|show|hide)$/, ot = /queueHooks$/;
      function st() {
          nt && (!1 === s.hidden && i.requestAnimationFrame ? i.requestAnimationFrame(st) : i.setTimeout(st, k.fx.interval),
          k.fx.tick())
      }
      function at() {
          return i.setTimeout(function() {
              it = void 0
          }),
          it = Date.now()
      }
      function lt(e, t) {
          var i, n = 0, r = {
              height: e
          };
          for (t = t ? 1 : 0; n < 4; n += 2 - t)
              r["margin" + (i = oe[n])] = r["padding" + i] = e;
          return t && (r.opacity = r.width = e),
          r
      }
      function ct(e, t, i) {
          for (var n, r = (ut.tweeners[t] || []).concat(ut.tweeners["*"]), o = 0, s = r.length; o < s; o++)
              if (n = r[o].call(i, t, e))
                  return n
      }
      function ut(e, t, i) {
          var n, r, o = 0, s = ut.prefilters.length, a = k.Deferred().always(function() {
              delete l.elem
          }), l = function() {
              if (r)
                  return !1;
              for (var t = it || at(), i = Math.max(0, c.startTime + c.duration - t), n = 1 - (i / c.duration || 0), o = 0, s = c.tweens.length; o < s; o++)
                  c.tweens[o].run(n);
              return a.notifyWith(e, [c, n, i]),
              n < 1 && s ? i : (s || a.notifyWith(e, [c, 1, 0]),
              a.resolveWith(e, [c]),
              !1)
          }, c = a.promise({
              elem: e,
              props: k.extend({}, t),
              opts: k.extend(!0, {
                  specialEasing: {},
                  easing: k.easing._default
              }, i),
              originalProperties: t,
              originalOptions: i,
              startTime: it || at(),
              duration: i.duration,
              tweens: [],
              createTween: function(t, i) {
                  var n = k.Tween(e, c.opts, t, i, c.opts.specialEasing[t] || c.opts.easing);
                  return c.tweens.push(n),
                  n
              },
              stop: function(t) {
                  var i = 0
                    , n = t ? c.tweens.length : 0;
                  if (r)
                      return this;
                  for (r = !0; i < n; i++)
                      c.tweens[i].run(1);
                  return t ? (a.notifyWith(e, [c, 1, 0]),
                  a.resolveWith(e, [c, t])) : a.rejectWith(e, [c, t]),
                  this
              }
          }), u = c.props;
          for (!function(e, t) {
              var i, n, r, o, s;
              for (i in e)
                  if (r = t[n = Z(i)],
                  o = e[i],
                  Array.isArray(o) && (r = o[1],
                  o = e[i] = o[0]),
                  i !== n && (e[n] = o,
                  delete e[i]),
                  (s = k.cssHooks[n]) && "expand"in s)
                      for (i in o = s.expand(o),
                      delete e[n],
                      o)
                          i in e || (e[i] = o[i],
                          t[i] = r);
                  else
                      t[n] = r
          }(u, c.opts.specialEasing); o < s; o++)
              if (n = ut.prefilters[o].call(c, e, u, c.opts))
                  return y(n.stop) && (k._queueHooks(c.elem, c.opts.queue).stop = n.stop.bind(n)),
                  n;
          return k.map(u, ct, c),
          y(c.opts.start) && c.opts.start.call(e, c),
          c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always),
          k.fx.timer(k.extend(l, {
              elem: e,
              anim: c,
              queue: c.opts.queue
          })),
          c
      }
      k.Animation = k.extend(ut, {
          tweeners: {
              "*": [function(e, t) {
                  var i = this.createTween(e, t);
                  return le(i.elem, e, re.exec(t), i),
                  i
              }
              ]
          },
          tweener: function(e, t) {
              y(e) ? (t = e,
              e = ["*"]) : e = e.match(j);
              for (var i, n = 0, r = e.length; n < r; n++)
                  i = e[n],
                  ut.tweeners[i] = ut.tweeners[i] || [],
                  ut.tweeners[i].unshift(t)
          },
          prefilters: [function(e, t, i) {
              var n, r, o, s, a, l, c, u, h = "width"in t || "height"in t, d = this, p = {}, f = e.style, m = e.nodeType && se(e), g = J.get(e, "fxshow");
              for (n in i.queue || (null == (s = k._queueHooks(e, "fx")).unqueued && (s.unqueued = 0,
              a = s.empty.fire,
              s.empty.fire = function() {
                  s.unqueued || a()
              }
              ),
              s.unqueued++,
              d.always(function() {
                  d.always(function() {
                      s.unqueued--,
                      k.queue(e, "fx").length || s.empty.fire()
                  })
              })),
              t)
                  if (r = t[n],
                  rt.test(r)) {
                      if (delete t[n],
                      o = o || "toggle" === r,
                      r === (m ? "hide" : "show")) {
                          if ("show" !== r || !g || void 0 === g[n])
                              continue;
                          m = !0
                      }
                      p[n] = g && g[n] || k.style(e, n)
                  }
              if ((l = !k.isEmptyObject(t)) || !k.isEmptyObject(p))
                  for (n in h && 1 === e.nodeType && (i.overflow = [f.overflow, f.overflowX, f.overflowY],
                  null == (c = g && g.display) && (c = J.get(e, "display")),
                  "none" === (u = k.css(e, "display")) && (c ? u = c : (he([e], !0),
                  c = e.style.display || c,
                  u = k.css(e, "display"),
                  he([e]))),
                  ("inline" === u || "inline-block" === u && null != c) && "none" === k.css(e, "float") && (l || (d.done(function() {
                      f.display = c
                  }),
                  null == c && (u = f.display,
                  c = "none" === u ? "" : u)),
                  f.display = "inline-block")),
                  i.overflow && (f.overflow = "hidden",
                  d.always(function() {
                      f.overflow = i.overflow[0],
                      f.overflowX = i.overflow[1],
                      f.overflowY = i.overflow[2]
                  })),
                  l = !1,
                  p)
                      l || (g ? "hidden"in g && (m = g.hidden) : g = J.access(e, "fxshow", {
                          display: c
                      }),
                      o && (g.hidden = !m),
                      m && he([e], !0),
                      d.done(function() {
                          for (n in m || he([e]),
                          J.remove(e, "fxshow"),
                          p)
                              k.style(e, n, p[n])
                      })),
                      l = ct(m ? g[n] : 0, n, d),
                      n in g || (g[n] = l.start,
                      m && (l.end = l.start,
                      l.start = 0))
          }
          ],
          prefilter: function(e, t) {
              t ? ut.prefilters.unshift(e) : ut.prefilters.push(e)
          }
      }),
      k.speed = function(e, t, i) {
          var n = e && "object" == typeof e ? k.extend({}, e) : {
              complete: i || !i && t || y(e) && e,
              duration: e,
              easing: i && t || t && !y(t) && t
          };
          return k.fx.off ? n.duration = 0 : "number" != typeof n.duration && (n.duration in k.fx.speeds ? n.duration = k.fx.speeds[n.duration] : n.duration = k.fx.speeds._default),
          null != n.queue && !0 !== n.queue || (n.queue = "fx"),
          n.old = n.complete,
          n.complete = function() {
              y(n.old) && n.old.call(this),
              n.queue && k.dequeue(this, n.queue)
          }
          ,
          n
      }
      ,
      k.fn.extend({
          fadeTo: function(e, t, i, n) {
              return this.filter(se).css("opacity", 0).show().end().animate({
                  opacity: t
              }, e, i, n)
          },
          animate: function(e, t, i, n) {
              var r = k.isEmptyObject(e)
                , o = k.speed(t, i, n)
                , s = function() {
                  var t = ut(this, k.extend({}, e), o);
                  (r || J.get(this, "finish")) && t.stop(!0)
              };
              return s.finish = s,
              r || !1 === o.queue ? this.each(s) : this.queue(o.queue, s)
          },
          stop: function(e, t, i) {
              var n = function(e) {
                  var t = e.stop;
                  delete e.stop,
                  t(i)
              };
              return "string" != typeof e && (i = t,
              t = e,
              e = void 0),
              t && !1 !== e && this.queue(e || "fx", []),
              this.each(function() {
                  var t = !0
                    , r = null != e && e + "queueHooks"
                    , o = k.timers
                    , s = J.get(this);
                  if (r)
                      s[r] && s[r].stop && n(s[r]);
                  else
                      for (r in s)
                          s[r] && s[r].stop && ot.test(r) && n(s[r]);
                  for (r = o.length; r--; )
                      o[r].elem !== this || null != e && o[r].queue !== e || (o[r].anim.stop(i),
                      t = !1,
                      o.splice(r, 1));
                  !t && i || k.dequeue(this, e)
              })
          },
          finish: function(e) {
              return !1 !== e && (e = e || "fx"),
              this.each(function() {
                  var t, i = J.get(this), n = i[e + "queue"], r = i[e + "queueHooks"], o = k.timers, s = n ? n.length : 0;
                  for (i.finish = !0,
                  k.queue(this, e, []),
                  r && r.stop && r.stop.call(this, !0),
                  t = o.length; t--; )
                      o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0),
                      o.splice(t, 1));
                  for (t = 0; t < s; t++)
                      n[t] && n[t].finish && n[t].finish.call(this);
                  delete i.finish
              })
          }
      }),
      k.each(["toggle", "show", "hide"], function(e, t) {
          var i = k.fn[t];
          k.fn[t] = function(e, n, r) {
              return null == e || "boolean" == typeof e ? i.apply(this, arguments) : this.animate(lt(t, !0), e, n, r)
          }
      }),
      k.each({
          slideDown: lt("show"),
          slideUp: lt("hide"),
          slideToggle: lt("toggle"),
          fadeIn: {
              opacity: "show"
          },
          fadeOut: {
              opacity: "hide"
          },
          fadeToggle: {
              opacity: "toggle"
          }
      }, function(e, t) {
          k.fn[e] = function(e, i, n) {
              return this.animate(t, e, i, n)
          }
      }),
      k.timers = [],
      k.fx.tick = function() {
          var e, t = 0, i = k.timers;
          for (it = Date.now(); t < i.length; t++)
              (e = i[t])() || i[t] !== e || i.splice(t--, 1);
          i.length || k.fx.stop(),
          it = void 0
      }
      ,
      k.fx.timer = function(e) {
          k.timers.push(e),
          k.fx.start()
      }
      ,
      k.fx.interval = 13,
      k.fx.start = function() {
          nt || (nt = !0,
          st())
      }
      ,
      k.fx.stop = function() {
          nt = null
      }
      ,
      k.fx.speeds = {
          slow: 600,
          fast: 200,
          _default: 400
      },
      k.fn.delay = function(e, t) {
          return e = k.fx && k.fx.speeds[e] || e,
          t = t || "fx",
          this.queue(t, function(t, n) {
              var r = i.setTimeout(t, e);
              n.stop = function() {
                  i.clearTimeout(r)
              }
          })
      }
      ,
      function() {
          var e = s.createElement("input")
            , t = s.createElement("select").appendChild(s.createElement("option"));
          e.type = "checkbox",
          v.checkOn = "" !== e.value,
          v.optSelected = t.selected,
          (e = s.createElement("input")).value = "t",
          e.type = "radio",
          v.radioValue = "t" === e.value
      }();
      var ht, dt = k.expr.attrHandle;
      k.fn.extend({
          attr: function(e, t) {
              return W(this, k.attr, e, t, arguments.length > 1)
          },
          removeAttr: function(e) {
              return this.each(function() {
                  k.removeAttr(this, e)
              })
          }
      }),
      k.extend({
          attr: function(e, t, i) {
              var n, r, o = e.nodeType;
              if (3 !== o && 8 !== o && 2 !== o)
                  return void 0 === e.getAttribute ? k.prop(e, t, i) : (1 === o && k.isXMLDoc(e) || (r = k.attrHooks[t.toLowerCase()] || (k.expr.match.bool.test(t) ? ht : void 0)),
                  void 0 !== i ? null === i ? void k.removeAttr(e, t) : r && "set"in r && void 0 !== (n = r.set(e, i, t)) ? n : (e.setAttribute(t, i + ""),
                  i) : r && "get"in r && null !== (n = r.get(e, t)) ? n : null == (n = k.find.attr(e, t)) ? void 0 : n)
          },
          attrHooks: {
              type: {
                  set: function(e, t) {
                      if (!v.radioValue && "radio" === t && P(e, "input")) {
                          var i = e.value;
                          return e.setAttribute("type", t),
                          i && (e.value = i),
                          t
                      }
                  }
              }
          },
          removeAttr: function(e, t) {
              var i, n = 0, r = t && t.match(j);
              if (r && 1 === e.nodeType)
                  for (; i = r[n++]; )
                      e.removeAttribute(i)
          }
      }),
      ht = {
          set: function(e, t, i) {
              return !1 === t ? k.removeAttr(e, i) : e.setAttribute(i, i),
              i
          }
      },
      k.each(k.expr.match.bool.source.match(/\w+/g), function(e, t) {
          var i = dt[t] || k.find.attr;
          dt[t] = function(e, t, n) {
              var r, o, s = t.toLowerCase();
              return n || (o = dt[s],
              dt[s] = r,
              r = null != i(e, t, n) ? s : null,
              dt[s] = o),
              r
          }
      });
      var pt = /^(?:input|select|textarea|button)$/i
        , ft = /^(?:a|area)$/i;
      function mt(e) {
          return (e.match(j) || []).join(" ")
      }
      function gt(e) {
          return e.getAttribute && e.getAttribute("class") || ""
      }
      function vt(e) {
          return Array.isArray(e) ? e : "string" == typeof e && e.match(j) || []
      }
      k.fn.extend({
          prop: function(e, t) {
              return W(this, k.prop, e, t, arguments.length > 1)
          },
          removeProp: function(e) {
              return this.each(function() {
                  delete this[k.propFix[e] || e]
              })
          }
      }),
      k.extend({
          prop: function(e, t, i) {
              var n, r, o = e.nodeType;
              if (3 !== o && 8 !== o && 2 !== o)
                  return 1 === o && k.isXMLDoc(e) || (t = k.propFix[t] || t,
                  r = k.propHooks[t]),
                  void 0 !== i ? r && "set"in r && void 0 !== (n = r.set(e, i, t)) ? n : e[t] = i : r && "get"in r && null !== (n = r.get(e, t)) ? n : e[t]
          },
          propHooks: {
              tabIndex: {
                  get: function(e) {
                      var t = k.find.attr(e, "tabindex");
                      return t ? parseInt(t, 10) : pt.test(e.nodeName) || ft.test(e.nodeName) && e.href ? 0 : -1
                  }
              }
          },
          propFix: {
              for: "htmlFor",
              class: "className"
          }
      }),
      v.optSelected || (k.propHooks.selected = {
          get: function(e) {
              var t = e.parentNode;
              return t && t.parentNode && t.parentNode.selectedIndex,
              null
          },
          set: function(e) {
              var t = e.parentNode;
              t && (t.selectedIndex,
              t.parentNode && t.parentNode.selectedIndex)
          }
      }),
      k.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
          k.propFix[this.toLowerCase()] = this
      }),
      k.fn.extend({
          addClass: function(e) {
              var t, i, n, r, o, s, a, l = 0;
              if (y(e))
                  return this.each(function(t) {
                      k(this).addClass(e.call(this, t, gt(this)))
                  });
              if ((t = vt(e)).length)
                  for (; i = this[l++]; )
                      if (r = gt(i),
                      n = 1 === i.nodeType && " " + mt(r) + " ") {
                          for (s = 0; o = t[s++]; )
                              n.indexOf(" " + o + " ") < 0 && (n += o + " ");
                          r !== (a = mt(n)) && i.setAttribute("class", a)
                      }
              return this
          },
          removeClass: function(e) {
              var t, i, n, r, o, s, a, l = 0;
              if (y(e))
                  return this.each(function(t) {
                      k(this).removeClass(e.call(this, t, gt(this)))
                  });
              if (!arguments.length)
                  return this.attr("class", "");
              if ((t = vt(e)).length)
                  for (; i = this[l++]; )
                      if (r = gt(i),
                      n = 1 === i.nodeType && " " + mt(r) + " ") {
                          for (s = 0; o = t[s++]; )
                              for (; n.indexOf(" " + o + " ") > -1; )
                                  n = n.replace(" " + o + " ", " ");
                          r !== (a = mt(n)) && i.setAttribute("class", a)
                      }
              return this
          },
          toggleClass: function(e, t) {
              var i = typeof e
                , n = "string" === i || Array.isArray(e);
              return "boolean" == typeof t && n ? t ? this.addClass(e) : this.removeClass(e) : y(e) ? this.each(function(i) {
                  k(this).toggleClass(e.call(this, i, gt(this), t), t)
              }) : this.each(function() {
                  var t, r, o, s;
                  if (n)
                      for (r = 0,
                      o = k(this),
                      s = vt(e); t = s[r++]; )
                          o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
                  else
                      void 0 !== e && "boolean" !== i || ((t = gt(this)) && J.set(this, "__className__", t),
                      this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : J.get(this, "__className__") || ""))
              })
          },
          hasClass: function(e) {
              var t, i, n = 0;
              for (t = " " + e + " "; i = this[n++]; )
                  if (1 === i.nodeType && (" " + mt(gt(i)) + " ").indexOf(t) > -1)
                      return !0;
              return !1
          }
      });
      var yt = /\r/g;
      k.fn.extend({
          val: function(e) {
              var t, i, n, r = this[0];
              return arguments.length ? (n = y(e),
              this.each(function(i) {
                  var r;
                  1 === this.nodeType && (null == (r = n ? e.call(this, i, k(this).val()) : e) ? r = "" : "number" == typeof r ? r += "" : Array.isArray(r) && (r = k.map(r, function(e) {
                      return null == e ? "" : e + ""
                  })),
                  (t = k.valHooks[this.type] || k.valHooks[this.nodeName.toLowerCase()]) && "set"in t && void 0 !== t.set(this, r, "value") || (this.value = r))
              })) : r ? (t = k.valHooks[r.type] || k.valHooks[r.nodeName.toLowerCase()]) && "get"in t && void 0 !== (i = t.get(r, "value")) ? i : "string" == typeof (i = r.value) ? i.replace(yt, "") : null == i ? "" : i : void 0
          }
      }),
      k.extend({
          valHooks: {
              option: {
                  get: function(e) {
                      var t = k.find.attr(e, "value");
                      return null != t ? t : mt(k.text(e))
                  }
              },
              select: {
                  get: function(e) {
                      var t, i, n, r = e.options, o = e.selectedIndex, s = "select-one" === e.type, a = s ? null : [], l = s ? o + 1 : r.length;
                      for (n = o < 0 ? l : s ? o : 0; n < l; n++)
                          if (((i = r[n]).selected || n === o) && !i.disabled && (!i.parentNode.disabled || !P(i.parentNode, "optgroup"))) {
                              if (t = k(i).val(),
                              s)
                                  return t;
                              a.push(t)
                          }
                      return a
                  },
                  set: function(e, t) {
                      for (var i, n, r = e.options, o = k.makeArray(t), s = r.length; s--; )
                          ((n = r[s]).selected = k.inArray(k.valHooks.option.get(n), o) > -1) && (i = !0);
                      return i || (e.selectedIndex = -1),
                      o
                  }
              }
          }
      }),
      k.each(["radio", "checkbox"], function() {
          k.valHooks[this] = {
              set: function(e, t) {
                  if (Array.isArray(t))
                      return e.checked = k.inArray(k(e).val(), t) > -1
              }
          },
          v.checkOn || (k.valHooks[this].get = function(e) {
              return null === e.getAttribute("value") ? "on" : e.value
          }
          )
      }),
      v.focusin = "onfocusin"in i;
      var _t = /^(?:focusinfocus|focusoutblur)$/
        , bt = function(e) {
          e.stopPropagation()
      };
      k.extend(k.event, {
          trigger: function(e, t, n, r) {
              var o, a, l, c, u, h, d, p, m = [n || s], g = f.call(e, "type") ? e.type : e, v = f.call(e, "namespace") ? e.namespace.split(".") : [];
              if (a = p = l = n = n || s,
              3 !== n.nodeType && 8 !== n.nodeType && !_t.test(g + k.event.triggered) && (g.indexOf(".") > -1 && (v = g.split("."),
              g = v.shift(),
              v.sort()),
              u = g.indexOf(":") < 0 && "on" + g,
              (e = e[k.expando] ? e : new k.Event(g,"object" == typeof e && e)).isTrigger = r ? 2 : 3,
              e.namespace = v.join("."),
              e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + v.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
              e.result = void 0,
              e.target || (e.target = n),
              t = null == t ? [e] : k.makeArray(t, [e]),
              d = k.event.special[g] || {},
              r || !d.trigger || !1 !== d.trigger.apply(n, t))) {
                  if (!r && !d.noBubble && !_(n)) {
                      for (c = d.delegateType || g,
                      _t.test(c + g) || (a = a.parentNode); a; a = a.parentNode)
                          m.push(a),
                          l = a;
                      l === (n.ownerDocument || s) && m.push(l.defaultView || l.parentWindow || i)
                  }
                  for (o = 0; (a = m[o++]) && !e.isPropagationStopped(); )
                      p = a,
                      e.type = o > 1 ? c : d.bindType || g,
                      (h = (J.get(a, "events") || {})[e.type] && J.get(a, "handle")) && h.apply(a, t),
                      (h = u && a[u]) && h.apply && Y(a) && (e.result = h.apply(a, t),
                      !1 === e.result && e.preventDefault());
                  return e.type = g,
                  r || e.isDefaultPrevented() || d._default && !1 !== d._default.apply(m.pop(), t) || !Y(n) || u && y(n[g]) && !_(n) && ((l = n[u]) && (n[u] = null),
                  k.event.triggered = g,
                  e.isPropagationStopped() && p.addEventListener(g, bt),
                  n[g](),
                  e.isPropagationStopped() && p.removeEventListener(g, bt),
                  k.event.triggered = void 0,
                  l && (n[u] = l)),
                  e.result
              }
          },
          simulate: function(e, t, i) {
              var n = k.extend(new k.Event, i, {
                  type: e,
                  isSimulated: !0
              });
              k.event.trigger(n, null, t)
          }
      }),
      k.fn.extend({
          trigger: function(e, t) {
              return this.each(function() {
                  k.event.trigger(e, t, this)
              })
          },
          triggerHandler: function(e, t) {
              var i = this[0];
              if (i)
                  return k.event.trigger(e, t, i, !0)
          }
      }),
      v.focusin || k.each({
          focus: "focusin",
          blur: "focusout"
      }, function(e, t) {
          var i = function(e) {
              k.event.simulate(t, e.target, k.event.fix(e))
          };
          k.event.special[t] = {
              setup: function() {
                  var n = this.ownerDocument || this
                    , r = J.access(n, t);
                  r || n.addEventListener(e, i, !0),
                  J.access(n, t, (r || 0) + 1)
              },
              teardown: function() {
                  var n = this.ownerDocument || this
                    , r = J.access(n, t) - 1;
                  r ? J.access(n, t, r) : (n.removeEventListener(e, i, !0),
                  J.remove(n, t))
              }
          }
      });
      var wt = i.location
        , xt = Date.now()
        , kt = /\?/;
      k.parseXML = function(e) {
          var t;
          if (!e || "string" != typeof e)
              return null;
          try {
              t = (new i.DOMParser).parseFromString(e, "text/xml")
          } catch (e) {
              t = void 0
          }
          return t && !t.getElementsByTagName("parsererror").length || k.error("Invalid XML: " + e),
          t
      }
      ;
      var St = /\[\]$/
        , Et = /\r?\n/g
        , Tt = /^(?:submit|button|image|reset|file)$/i
        , Ct = /^(?:input|select|textarea|keygen)/i;
      function Lt(e, t, i, n) {
          var r;
          if (Array.isArray(t))
              k.each(t, function(t, r) {
                  i || St.test(e) ? n(e, r) : Lt(e + "[" + ("object" == typeof r && null != r ? t : "") + "]", r, i, n)
              });
          else if (i || "object" !== x(t))
              n(e, t);
          else
              for (r in t)
                  Lt(e + "[" + r + "]", t[r], i, n)
      }
      k.param = function(e, t) {
          var i, n = [], r = function(e, t) {
              var i = y(t) ? t() : t;
              n[n.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == i ? "" : i)
          };
          if (Array.isArray(e) || e.jquery && !k.isPlainObject(e))
              k.each(e, function() {
                  r(this.name, this.value)
              });
          else
              for (i in e)
                  Lt(i, e[i], t, r);
          return n.join("&")
      }
      ,
      k.fn.extend({
          serialize: function() {
              return k.param(this.serializeArray())
          },
          serializeArray: function() {
              return this.map(function() {
                  var e = k.prop(this, "elements");
                  return e ? k.makeArray(e) : this
              }).filter(function() {
                  var e = this.type;
                  return this.name && !k(this).is(":disabled") && Ct.test(this.nodeName) && !Tt.test(e) && (this.checked || !de.test(e))
              }).map(function(e, t) {
                  var i = k(this).val();
                  return null == i ? null : Array.isArray(i) ? k.map(i, function(e) {
                      return {
                          name: t.name,
                          value: e.replace(Et, "\r\n")
                      }
                  }) : {
                      name: t.name,
                      value: i.replace(Et, "\r\n")
                  }
              }).get()
          }
      });
      var At = /%20/g
        , Pt = /#.*$/
        , It = /([?&])_=[^&]*/
        , Mt = /^(.*?):[ \t]*([^\r\n]*)$/gm
        , Ot = /^(?:GET|HEAD)$/
        , zt = /^\/\//
        , Dt = {}
        , Rt = {}
        , Bt = "*/".concat("*")
        , jt = s.createElement("a");
      function Ft(e) {
          return function(t, i) {
              "string" != typeof t && (i = t,
              t = "*");
              var n, r = 0, o = t.toLowerCase().match(j) || [];
              if (y(i))
                  for (; n = o[r++]; )
                      "+" === n[0] ? (n = n.slice(1) || "*",
                      (e[n] = e[n] || []).unshift(i)) : (e[n] = e[n] || []).push(i)
          }
      }
      function Nt(e, t, i, n) {
          var r = {}
            , o = e === Rt;
          function s(a) {
              var l;
              return r[a] = !0,
              k.each(e[a] || [], function(e, a) {
                  var c = a(t, i, n);
                  return "string" != typeof c || o || r[c] ? o ? !(l = c) : void 0 : (t.dataTypes.unshift(c),
                  s(c),
                  !1)
              }),
              l
          }
          return s(t.dataTypes[0]) || !r["*"] && s("*")
      }
      function Ut(e, t) {
          var i, n, r = k.ajaxSettings.flatOptions || {};
          for (i in t)
              void 0 !== t[i] && ((r[i] ? e : n || (n = {}))[i] = t[i]);
          return n && k.extend(!0, e, n),
          e
      }
      jt.href = wt.href,
      k.extend({
          active: 0,
          lastModified: {},
          etag: {},
          ajaxSettings: {
              url: wt.href,
              type: "GET",
              isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(wt.protocol),
              global: !0,
              processData: !0,
              async: !0,
              contentType: "application/x-www-form-urlencoded; charset=UTF-8",
              accepts: {
                  "*": Bt,
                  text: "text/plain",
                  html: "text/html",
                  xml: "application/xml, text/xml",
                  json: "application/json, text/javascript"
              },
              contents: {
                  xml: /\bxml\b/,
                  html: /\bhtml/,
                  json: /\bjson\b/
              },
              responseFields: {
                  xml: "responseXML",
                  text: "responseText",
                  json: "responseJSON"
              },
              converters: {
                  "* text": String,
                  "text html": !0,
                  "text json": JSON.parse,
                  "text xml": k.parseXML
              },
              flatOptions: {
                  url: !0,
                  context: !0
              }
          },
          ajaxSetup: function(e, t) {
              return t ? Ut(Ut(e, k.ajaxSettings), t) : Ut(k.ajaxSettings, e)
          },
          ajaxPrefilter: Ft(Dt),
          ajaxTransport: Ft(Rt),
          ajax: function(e, t) {
              "object" == typeof e && (t = e,
              e = void 0),
              t = t || {};
              var n, r, o, a, l, c, u, h, d, p, f = k.ajaxSetup({}, t), m = f.context || f, g = f.context && (m.nodeType || m.jquery) ? k(m) : k.event, v = k.Deferred(), y = k.Callbacks("once memory"), _ = f.statusCode || {}, b = {}, w = {}, x = "canceled", S = {
                  readyState: 0,
                  getResponseHeader: function(e) {
                      var t;
                      if (u) {
                          if (!a)
                              for (a = {}; t = Mt.exec(o); )
                                  a[t[1].toLowerCase()] = t[2];
                          t = a[e.toLowerCase()]
                      }
                      return null == t ? null : t
                  },
                  getAllResponseHeaders: function() {
                      return u ? o : null
                  },
                  setRequestHeader: function(e, t) {
                      return null == u && (e = w[e.toLowerCase()] = w[e.toLowerCase()] || e,
                      b[e] = t),
                      this
                  },
                  overrideMimeType: function(e) {
                      return null == u && (f.mimeType = e),
                      this
                  },
                  statusCode: function(e) {
                      var t;
                      if (e)
                          if (u)
                              S.always(e[S.status]);
                          else
                              for (t in e)
                                  _[t] = [_[t], e[t]];
                      return this
                  },
                  abort: function(e) {
                      var t = e || x;
                      return n && n.abort(t),
                      E(0, t),
                      this
                  }
              };
              if (v.promise(S),
              f.url = ((e || f.url || wt.href) + "").replace(zt, wt.protocol + "//"),
              f.type = t.method || t.type || f.method || f.type,
              f.dataTypes = (f.dataType || "*").toLowerCase().match(j) || [""],
              null == f.crossDomain) {
                  c = s.createElement("a");
                  try {
                      c.href = f.url,
                      c.href = c.href,
                      f.crossDomain = jt.protocol + "//" + jt.host != c.protocol + "//" + c.host
                  } catch (e) {
                      f.crossDomain = !0
                  }
              }
              if (f.data && f.processData && "string" != typeof f.data && (f.data = k.param(f.data, f.traditional)),
              Nt(Dt, f, t, S),
              u)
                  return S;
              for (d in (h = k.event && f.global) && 0 == k.active++ && k.event.trigger("ajaxStart"),
              f.type = f.type.toUpperCase(),
              f.hasContent = !Ot.test(f.type),
              r = f.url.replace(Pt, ""),
              f.hasContent ? f.data && f.processData && 0 === (f.contentType || "").indexOf("application/x-www-form-urlencoded") && (f.data = f.data.replace(At, "+")) : (p = f.url.slice(r.length),
              f.data && (f.processData || "string" == typeof f.data) && (r += (kt.test(r) ? "&" : "?") + f.data,
              delete f.data),
              !1 === f.cache && (r = r.replace(It, "$1"),
              p = (kt.test(r) ? "&" : "?") + "_=" + xt++ + p),
              f.url = r + p),
              f.ifModified && (k.lastModified[r] && S.setRequestHeader("If-Modified-Since", k.lastModified[r]),
              k.etag[r] && S.setRequestHeader("If-None-Match", k.etag[r])),
              (f.data && f.hasContent && !1 !== f.contentType || t.contentType) && S.setRequestHeader("Content-Type", f.contentType),
              S.setRequestHeader("Accept", f.dataTypes[0] && f.accepts[f.dataTypes[0]] ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + Bt + "; q=0.01" : "") : f.accepts["*"]),
              f.headers)
                  S.setRequestHeader(d, f.headers[d]);
              if (f.beforeSend && (!1 === f.beforeSend.call(m, S, f) || u))
                  return S.abort();
              if (x = "abort",
              y.add(f.complete),
              S.done(f.success),
              S.fail(f.error),
              n = Nt(Rt, f, t, S)) {
                  if (S.readyState = 1,
                  h && g.trigger("ajaxSend", [S, f]),
                  u)
                      return S;
                  f.async && f.timeout > 0 && (l = i.setTimeout(function() {
                      S.abort("timeout")
                  }, f.timeout));
                  try {
                      u = !1,
                      n.send(b, E)
                  } catch (e) {
                      if (u)
                          throw e;
                      E(-1, e)
                  }
              } else
                  E(-1, "No Transport");
              function E(e, t, s, a) {
                  var c, d, p, b, w, x = t;
                  u || (u = !0,
                  l && i.clearTimeout(l),
                  n = void 0,
                  o = a || "",
                  S.readyState = e > 0 ? 4 : 0,
                  c = e >= 200 && e < 300 || 304 === e,
                  s && (b = function(e, t, i) {
                      for (var n, r, o, s, a = e.contents, l = e.dataTypes; "*" === l[0]; )
                          l.shift(),
                          void 0 === n && (n = e.mimeType || t.getResponseHeader("Content-Type"));
                      if (n)
                          for (r in a)
                              if (a[r] && a[r].test(n)) {
                                  l.unshift(r);
                                  break
                              }
                      if (l[0]in i)
                          o = l[0];
                      else {
                          for (r in i) {
                              if (!l[0] || e.converters[r + " " + l[0]]) {
                                  o = r;
                                  break
                              }
                              s || (s = r)
                          }
                          o = o || s
                      }
                      if (o)
                          return o !== l[0] && l.unshift(o),
                          i[o]
                  }(f, S, s)),
                  b = function(e, t, i, n) {
                      var r, o, s, a, l, c = {}, u = e.dataTypes.slice();
                      if (u[1])
                          for (s in e.converters)
                              c[s.toLowerCase()] = e.converters[s];
                      for (o = u.shift(); o; )
                          if (e.responseFields[o] && (i[e.responseFields[o]] = t),
                          !l && n && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                          l = o,
                          o = u.shift())
                              if ("*" === o)
                                  o = l;
                              else if ("*" !== l && l !== o) {
                                  if (!(s = c[l + " " + o] || c["* " + o]))
                                      for (r in c)
                                          if ((a = r.split(" "))[1] === o && (s = c[l + " " + a[0]] || c["* " + a[0]])) {
                                              !0 === s ? s = c[r] : !0 !== c[r] && (o = a[0],
                                              u.unshift(a[1]));
                                              break
                                          }
                                  if (!0 !== s)
                                      if (s && e.throws)
                                          t = s(t);
                                      else
                                          try {
                                              t = s(t)
                                          } catch (e) {
                                              return {
                                                  state: "parsererror",
                                                  error: s ? e : "No conversion from " + l + " to " + o
                                              }
                                          }
                              }
                      return {
                          state: "success",
                          data: t
                      }
                  }(f, b, S, c),
                  c ? (f.ifModified && ((w = S.getResponseHeader("Last-Modified")) && (k.lastModified[r] = w),
                  (w = S.getResponseHeader("etag")) && (k.etag[r] = w)),
                  204 === e || "HEAD" === f.type ? x = "nocontent" : 304 === e ? x = "notmodified" : (x = b.state,
                  d = b.data,
                  c = !(p = b.error))) : (p = x,
                  !e && x || (x = "error",
                  e < 0 && (e = 0))),
                  S.status = e,
                  S.statusText = (t || x) + "",
                  c ? v.resolveWith(m, [d, x, S]) : v.rejectWith(m, [S, x, p]),
                  S.statusCode(_),
                  _ = void 0,
                  h && g.trigger(c ? "ajaxSuccess" : "ajaxError", [S, f, c ? d : p]),
                  y.fireWith(m, [S, x]),
                  h && (g.trigger("ajaxComplete", [S, f]),
                  --k.active || k.event.trigger("ajaxStop")))
              }
              return S
          },
          getJSON: function(e, t, i) {
              return k.get(e, t, i, "json")
          },
          getScript: function(e, t) {
              return k.get(e, void 0, t, "script")
          }
      }),
      k.each(["get", "post"], function(e, t) {
          k[t] = function(e, i, n, r) {
              return y(i) && (r = r || n,
              n = i,
              i = void 0),
              k.ajax(k.extend({
                  url: e,
                  type: t,
                  dataType: r,
                  data: i,
                  success: n
              }, k.isPlainObject(e) && e))
          }
      }),
      k._evalUrl = function(e) {
          return k.ajax({
              url: e,
              type: "GET",
              dataType: "script",
              cache: !0,
              async: !1,
              global: !1,
              throws: !0
          })
      }
      ,
      k.fn.extend({
          wrapAll: function(e) {
              var t;
              return this[0] && (y(e) && (e = e.call(this[0])),
              t = k(e, this[0].ownerDocument).eq(0).clone(!0),
              this[0].parentNode && t.insertBefore(this[0]),
              t.map(function() {
                  for (var e = this; e.firstElementChild; )
                      e = e.firstElementChild;
                  return e
              }).append(this)),
              this
          },
          wrapInner: function(e) {
              return y(e) ? this.each(function(t) {
                  k(this).wrapInner(e.call(this, t))
              }) : this.each(function() {
                  var t = k(this)
                    , i = t.contents();
                  i.length ? i.wrapAll(e) : t.append(e)
              })
          },
          wrap: function(e) {
              var t = y(e);
              return this.each(function(i) {
                  k(this).wrapAll(t ? e.call(this, i) : e)
              })
          },
          unwrap: function(e) {
              return this.parent(e).not("body").each(function() {
                  k(this).replaceWith(this.childNodes)
              }),
              this
          }
      }),
      k.expr.pseudos.hidden = function(e) {
          return !k.expr.pseudos.visible(e)
      }
      ,
      k.expr.pseudos.visible = function(e) {
          return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
      }
      ,
      k.ajaxSettings.xhr = function() {
          try {
              return new i.XMLHttpRequest
          } catch (e) {}
      }
      ;
      var qt = {
          0: 200,
          1223: 204
      }
        , Ht = k.ajaxSettings.xhr();
      v.cors = !!Ht && "withCredentials"in Ht,
      v.ajax = Ht = !!Ht,
      k.ajaxTransport(function(e) {
          var t, n;
          if (v.cors || Ht && !e.crossDomain)
              return {
                  send: function(r, o) {
                      var s, a = e.xhr();
                      if (a.open(e.type, e.url, e.async, e.username, e.password),
                      e.xhrFields)
                          for (s in e.xhrFields)
                              a[s] = e.xhrFields[s];
                      for (s in e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType),
                      e.crossDomain || r["X-Requested-With"] || (r["X-Requested-With"] = "XMLHttpRequest"),
                      r)
                          a.setRequestHeader(s, r[s]);
                      t = function(e) {
                          return function() {
                              t && (t = n = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null,
                              "abort" === e ? a.abort() : "error" === e ? "number" != typeof a.status ? o(0, "error") : o(a.status, a.statusText) : o(qt[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                                  binary: a.response
                              } : {
                                  text: a.responseText
                              }, a.getAllResponseHeaders()))
                          }
                      }
                      ,
                      a.onload = t(),
                      n = a.onerror = a.ontimeout = t("error"),
                      void 0 !== a.onabort ? a.onabort = n : a.onreadystatechange = function() {
                          4 === a.readyState && i.setTimeout(function() {
                              t && n()
                          })
                      }
                      ,
                      t = t("abort");
                      try {
                          a.send(e.hasContent && e.data || null)
                      } catch (e) {
                          if (t)
                              throw e
                      }
                  },
                  abort: function() {
                      t && t()
                  }
              }
      }),
      k.ajaxPrefilter(function(e) {
          e.crossDomain && (e.contents.script = !1)
      }),
      k.ajaxSetup({
          accepts: {
              script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
          },
          contents: {
              script: /\b(?:java|ecma)script\b/
          },
          converters: {
              "text script": function(e) {
                  return k.globalEval(e),
                  e
              }
          }
      }),
      k.ajaxPrefilter("script", function(e) {
          void 0 === e.cache && (e.cache = !1),
          e.crossDomain && (e.type = "GET")
      }),
      k.ajaxTransport("script", function(e) {
          var t, i;
          if (e.crossDomain)
              return {
                  send: function(n, r) {
                      t = k("<script>").prop({
                          charset: e.scriptCharset,
                          src: e.url
                      }).on("load error", i = function(e) {
                          t.remove(),
                          i = null,
                          e && r("error" === e.type ? 404 : 200, e.type)
                      }
                      ),
                      s.head.appendChild(t[0])
                  },
                  abort: function() {
                      i && i()
                  }
              }
      });
      var Vt, Wt = [], $t = /(=)\?(?=&|$)|\?\?/;
      k.ajaxSetup({
          jsonp: "callback",
          jsonpCallback: function() {
              var e = Wt.pop() || k.expando + "_" + xt++;
              return this[e] = !0,
              e
          }
      }),
      k.ajaxPrefilter("json jsonp", function(e, t, n) {
          var r, o, s, a = !1 !== e.jsonp && ($t.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && $t.test(e.data) && "data");
          if (a || "jsonp" === e.dataTypes[0])
              return r = e.jsonpCallback = y(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback,
              a ? e[a] = e[a].replace($t, "$1" + r) : !1 !== e.jsonp && (e.url += (kt.test(e.url) ? "&" : "?") + e.jsonp + "=" + r),
              e.converters["script json"] = function() {
                  return s || k.error(r + " was not called"),
                  s[0]
              }
              ,
              e.dataTypes[0] = "json",
              o = i[r],
              i[r] = function() {
                  s = arguments
              }
              ,
              n.always(function() {
                  void 0 === o ? k(i).removeProp(r) : i[r] = o,
                  e[r] && (e.jsonpCallback = t.jsonpCallback,
                  Wt.push(r)),
                  s && y(o) && o(s[0]),
                  s = o = void 0
              }),
              "script"
      }),
      v.createHTMLDocument = ((Vt = s.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>",
      2 === Vt.childNodes.length),
      k.parseHTML = function(e, t, i) {
          return "string" != typeof e ? [] : ("boolean" == typeof t && (i = t,
          t = !1),
          t || (v.createHTMLDocument ? ((n = (t = s.implementation.createHTMLDocument("")).createElement("base")).href = s.location.href,
          t.head.appendChild(n)) : t = s),
          o = !i && [],
          (r = I.exec(e)) ? [t.createElement(r[1])] : (r = we([e], t, o),
          o && o.length && k(o).remove(),
          k.merge([], r.childNodes)));
          var n, r, o
      }
      ,
      k.fn.load = function(e, t, i) {
          var n, r, o, s = this, a = e.indexOf(" ");
          return a > -1 && (n = mt(e.slice(a)),
          e = e.slice(0, a)),
          y(t) ? (i = t,
          t = void 0) : t && "object" == typeof t && (r = "POST"),
          s.length > 0 && k.ajax({
              url: e,
              type: r || "GET",
              dataType: "html",
              data: t
          }).done(function(e) {
              o = arguments,
              s.html(n ? k("<div>").append(k.parseHTML(e)).find(n) : e)
          }).always(i && function(e, t) {
              s.each(function() {
                  i.apply(this, o || [e.responseText, t, e])
              })
          }
          ),
          this
      }
      ,
      k.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
          k.fn[t] = function(e) {
              return this.on(t, e)
          }
      }),
      k.expr.pseudos.animated = function(e) {
          return k.grep(k.timers, function(t) {
              return e === t.elem
          }).length
      }
      ,
      k.offset = {
          setOffset: function(e, t, i) {
              var n, r, o, s, a, l, c = k.css(e, "position"), u = k(e), h = {};
              "static" === c && (e.style.position = "relative"),
              a = u.offset(),
              o = k.css(e, "top"),
              l = k.css(e, "left"),
              ("absolute" === c || "fixed" === c) && (o + l).indexOf("auto") > -1 ? (s = (n = u.position()).top,
              r = n.left) : (s = parseFloat(o) || 0,
              r = parseFloat(l) || 0),
              y(t) && (t = t.call(e, i, k.extend({}, a))),
              null != t.top && (h.top = t.top - a.top + s),
              null != t.left && (h.left = t.left - a.left + r),
              "using"in t ? t.using.call(e, h) : u.css(h)
          }
      },
      k.fn.extend({
          offset: function(e) {
              if (arguments.length)
                  return void 0 === e ? this : this.each(function(t) {
                      k.offset.setOffset(this, e, t)
                  });
              var t, i, n = this[0];
              return n ? n.getClientRects().length ? (t = n.getBoundingClientRect(),
              i = n.ownerDocument.defaultView,
              {
                  top: t.top + i.pageYOffset,
                  left: t.left + i.pageXOffset
              }) : {
                  top: 0,
                  left: 0
              } : void 0
          },
          position: function() {
              if (this[0]) {
                  var e, t, i, n = this[0], r = {
                      top: 0,
                      left: 0
                  };
                  if ("fixed" === k.css(n, "position"))
                      t = n.getBoundingClientRect();
                  else {
                      for (t = this.offset(),
                      i = n.ownerDocument,
                      e = n.offsetParent || i.documentElement; e && (e === i.body || e === i.documentElement) && "static" === k.css(e, "position"); )
                          e = e.parentNode;
                      e && e !== n && 1 === e.nodeType && ((r = k(e).offset()).top += k.css(e, "borderTopWidth", !0),
                      r.left += k.css(e, "borderLeftWidth", !0))
                  }
                  return {
                      top: t.top - r.top - k.css(n, "marginTop", !0),
                      left: t.left - r.left - k.css(n, "marginLeft", !0)
                  }
              }
          },
          offsetParent: function() {
              return this.map(function() {
                  for (var e = this.offsetParent; e && "static" === k.css(e, "position"); )
                      e = e.offsetParent;
                  return e || xe
              })
          }
      }),
      k.each({
          scrollLeft: "pageXOffset",
          scrollTop: "pageYOffset"
      }, function(e, t) {
          var i = "pageYOffset" === t;
          k.fn[e] = function(n) {
              return W(this, function(e, n, r) {
                  var o;
                  if (_(e) ? o = e : 9 === e.nodeType && (o = e.defaultView),
                  void 0 === r)
                      return o ? o[t] : e[n];
                  o ? o.scrollTo(i ? o.pageXOffset : r, i ? r : o.pageYOffset) : e[n] = r
              }, e, n, arguments.length)
          }
      }),
      k.each(["top", "left"], function(e, t) {
          k.cssHooks[t] = Ve(v.pixelPosition, function(e, i) {
              if (i)
                  return i = He(e, t),
                  Ne.test(i) ? k(e).position()[t] + "px" : i
          })
      }),
      k.each({
          Height: "height",
          Width: "width"
      }, function(e, t) {
          k.each({
              padding: "inner" + e,
              content: t,
              "": "outer" + e
          }, function(i, n) {
              k.fn[n] = function(r, o) {
                  var s = arguments.length && (i || "boolean" != typeof r)
                    , a = i || (!0 === r || !0 === o ? "margin" : "border");
                  return W(this, function(t, i, r) {
                      var o;
                      return _(t) ? 0 === n.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement,
                      Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === r ? k.css(t, i, a) : k.style(t, i, r, a)
                  }, t, s ? r : void 0, s)
              }
          })
      }),
      k.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(e, t) {
          k.fn[t] = function(e, i) {
              return arguments.length > 0 ? this.on(t, null, e, i) : this.trigger(t)
          }
      }),
      k.fn.extend({
          hover: function(e, t) {
              return this.mouseenter(e).mouseleave(t || e)
          }
      }),
      k.fn.extend({
          bind: function(e, t, i) {
              return this.on(e, null, t, i)
          },
          unbind: function(e, t) {
              return this.off(e, null, t)
          },
          delegate: function(e, t, i, n) {
              return this.on(t, e, i, n)
          },
          undelegate: function(e, t, i) {
              return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", i)
          }
      }),
      k.proxy = function(e, t) {
          var i, n, r;
          if ("string" == typeof t && (i = e[t],
          t = e,
          e = i),
          y(e))
              return n = l.call(arguments, 2),
              (r = function() {
                  return e.apply(t || this, n.concat(l.call(arguments)))
              }
              ).guid = e.guid = e.guid || k.guid++,
              r
      }
      ,
      k.holdReady = function(e) {
          e ? k.readyWait++ : k.ready(!0)
      }
      ,
      k.isArray = Array.isArray,
      k.parseJSON = JSON.parse,
      k.nodeName = P,
      k.isFunction = y,
      k.isWindow = _,
      k.camelCase = Z,
      k.type = x,
      k.now = Date.now,
      k.isNumeric = function(e) {
          var t = k.type(e);
          return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
      }
      ,
      void 0 === (n = function() {
          return k
      }
      .apply(t, [])) || (e.exports = n);
      var Gt = i.jQuery
        , Xt = i.$;
      return k.noConflict = function(e) {
          return i.$ === k && (i.$ = Xt),
          e && i.jQuery === k && (i.jQuery = Gt),
          k
      }
      ,
      r || (i.jQuery = i.$ = k),
      k
  })
}
, function(e, t) {
  var i = Array.isArray;
  e.exports = i
}
, function(e, t) {
  var i = 4
    , n = .001
    , r = 1e-7
    , o = 10
    , s = 11
    , a = 1 / (s - 1)
    , l = "function" == typeof Float32Array;
  function c(e, t) {
      return 1 - 3 * t + 3 * e
  }
  function u(e, t) {
      return 3 * t - 6 * e
  }
  function h(e) {
      return 3 * e
  }
  function d(e, t, i) {
      return ((c(t, i) * e + u(t, i)) * e + h(t)) * e
  }
  function p(e, t, i) {
      return 3 * c(t, i) * e * e + 2 * u(t, i) * e + h(t)
  }
  function f(e) {
      return e
  }
  e.exports = function(e, t, c, u) {
      if (!(0 <= e && e <= 1 && 0 <= c && c <= 1))
          throw new Error("bezier x values must be in [0, 1] range");
      if (e === t && c === u)
          return f;
      for (var h = l ? new Float32Array(s) : new Array(s), m = 0; m < s; ++m)
          h[m] = d(m * a, e, c);
      function g(t) {
          for (var l = 0, u = 1, f = s - 1; u !== f && h[u] <= t; ++u)
              l += a;
          var m = l + (t - h[--u]) / (h[u + 1] - h[u]) * a
            , g = p(m, e, c);
          return g >= n ? function(e, t, n, r) {
              for (var o = 0; o < i; ++o) {
                  var s = p(t, n, r);
                  if (0 === s)
                      return t;
                  t -= (d(t, n, r) - e) / s
              }
              return t
          }(t, m, e, c) : 0 === g ? m : function(e, t, i, n, s) {
              var a, l, c = 0;
              do {
                  (a = d(l = t + (i - t) / 2, n, s) - e) > 0 ? i = l : t = l
              } while (Math.abs(a) > r && ++c < o);return l
          }(t, l, l + a, e, c)
      }
      return function(e) {
          return 0 === e ? 0 : 1 === e ? 1 : d(g(e), t, u)
      }
  }
}
, function(e, t, i) {
  var n = i(55);
  e.exports = function(e) {
      return null == e ? "" : n(e)
  }
}
, function(e, t, i) {
  var n = i(57)
    , r = "object" == typeof self && self && self.Object === Object && self
    , o = n || r || Function("return this")();
  e.exports = o
}
, function(e, t, i) {
  var n = i(13);
  e.exports = function(e, t) {
      for (var i = e.length; i--; )
          if (n(e[i][0], t))
              return i;
      return -1
  }
}
, function(e, t) {
  e.exports = function(e, t) {
      return e === t || e != e && t != t
  }
}
, function(e, t, i) {
  var n = i(5)
    , r = i(3)
    , o = "[object AsyncFunction]"
    , s = "[object Function]"
    , a = "[object GeneratorFunction]"
    , l = "[object Proxy]";
  e.exports = function(e) {
      if (!r(e))
          return !1;
      var t = n(e);
      return t == s || t == a || t == o || t == l
  }
}
, , function(e, t, i) {
  "use strict";
  i.d(t, "b", function() {
      return s
  }),
  i.d(t, "a", function() {
      return a
  });
  var n = i(0);
  function r(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  function o(e, t) {
      if (!(e instanceof t))
          throw new TypeError("Cannot call a class as a function")
  }
  var s = "lazy"
    , a = function() {
      function e(t, i) {
          o(this, e),
          this.el = {
              section: t
          },
          this.defaults = {},
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(n.a)(this),
          this.flags = {
              isMainController: !1
          },
          this.queue = [],
          this.lazyItems = [],
          this.init()
      }
      var t, i, s;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              var e = this.el.section.getAttribute("data-lazy-src");
              if (!Object(n.j)("medium")) {
                  var t = this.el.section.getAttribute("data-lazy-src-mobile");
                  t && (e = t)
              }
              this.el.section.setAttribute("src", e),
              this.addEventListeners()
          }
      }, {
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "_onScroll",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && r(t.prototype, i),
      s && r(t, s),
      e
  }()
}
, function(e, t, i) {
  var n = i(73);
  e.exports = function(e, t, i) {
      "__proto__" == t && n ? n(e, t, {
          configurable: !0,
          enumerable: !0,
          value: i,
          writable: !0
      }) : e[t] = i
  }
}
, function(e, t) {
  e.exports = function(e) {
      var t = [];
      if (null != e)
          for (var i in Object(e))
              t.push(i);
      return t
  }
}
, function(e, t, i) {
  var n = i(3)
    , r = i(65)
    , o = i(23)
    , s = "Expected a function"
    , a = Math.max
    , l = Math.min;
  e.exports = function(e, t, i) {
      var c, u, h, d, p, f, m = 0, g = !1, v = !1, y = !0;
      if ("function" != typeof e)
          throw new TypeError(s);
      function _(t) {
          var i = c
            , n = u;
          return c = u = void 0,
          m = t,
          d = e.apply(n, i)
      }
      function b(e) {
          var i = e - f;
          return void 0 === f || i >= t || i < 0 || v && e - m >= h
      }
      function w() {
          var e = r();
          if (b(e))
              return x(e);
          p = setTimeout(w, function(e) {
              var i = t - (e - f);
              return v ? l(i, h - (e - m)) : i
          }(e))
      }
      function x(e) {
          return p = void 0,
          y && c ? _(e) : (c = u = void 0,
          d)
      }
      function k() {
          var e = r()
            , i = b(e);
          if (c = arguments,
          u = this,
          f = e,
          i) {
              if (void 0 === p)
                  return function(e) {
                      return m = e,
                      p = setTimeout(w, t),
                      g ? _(e) : d
                  }(f);
              if (v)
                  return p = setTimeout(w, t),
                  _(f)
          }
          return void 0 === p && (p = setTimeout(w, t)),
          d
      }
      return t = o(t) || 0,
      n(i) && (g = !!i.leading,
      h = (v = "maxWait"in i) ? a(o(i.maxWait) || 0, t) : h,
      y = "trailing"in i ? !!i.trailing : y),
      k.cancel = function() {
          void 0 !== p && clearTimeout(p),
          m = 0,
          c = f = u = p = void 0
      }
      ,
      k.flush = function() {
          return void 0 === p ? d : x(r())
      }
      ,
      k
  }
}
, function(e) {
  e.exports = {
      root: "/",
      breakpoints: {
          tiny: 480,
          small: 576,
          medium: 768,
          large: 992,
          xlarge: 1280,
          xxlarge: 1440,
          xxxlarge: 1600,
          xxxxlarge: 1800
      }
  }
}
, function(e, t) {
  var i;
  i = function() {
      return this
  }();
  try {
      i = i || new Function("return this")()
  } catch (e) {
      "object" == typeof window && (i = window)
  }
  e.exports = i
}
, function(e, t, i) {
  "use strict";
  i.d(t, "a", function() {
      return n
  });
  class n {
      constructor(e) {
          this.xhr = new XMLHttpRequest,
          this.type = e,
          this.url = "",
          this.data = null,
          this.header = {},
          this.onprogress = !1,
          this.timeout = 3e4
      }
      setHeader(e, t) {
          return this.header[e] = t,
          this
      }
      onProgress(e) {
          return this.onprogress = e,
          this
      }
      setTimeout(e) {
          return this.timeout = e,
          this
      }
      setType() {
          try {
              this.xhr.responseType = this.type
          } catch (e) {}
      }
      onreadystatechange(e, t) {
          this.xhr.onreadystatechange = (()=>{
              4 === this.xhr.readyState && (200 === this.xhr.status ? e(this.xhr) : t(this.xhr))
          }
          )
      }
      request(e) {
          return new Promise((t,i)=>{
              this.onprogress && (this.xhr.onprogress = this.onprogress),
              this.setType(),
              this.onreadystatechange(t, i),
              this.xhr.open(e, this.url, !0);
              for (const e in this.header)
                  this.xhr.setRequestHeader(e, this.header[e]);
              this.xhr.timeout = this.timeout,
              this.xhr.send(this.data)
          }
          )
      }
      get(e) {
          return this.url = e,
          this.request("GET")
      }
      post(e, t) {
          return this.url = e,
          this.data = t,
          this.request("POST")
      }
      put(e, t) {
          return this.url = e,
          this.data = t,
          this.request("PUT")
      }
      delete(e, t) {
          return this.url = e,
          this.data = t,
          this.request("DELETE")
      }
      abort() {
          this.xhr.abort()
      }
  }
}
, function(e, t, i) {
  var n = i(3)
    , r = i(24)
    , o = NaN
    , s = /^\s+|\s+$/g
    , a = /^[-+]0x[0-9a-f]+$/i
    , l = /^0b[01]+$/i
    , c = /^0o[0-7]+$/i
    , u = parseInt;
  e.exports = function(e) {
      if ("number" == typeof e)
          return e;
      if (r(e))
          return o;
      if (n(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
          e = n(t) ? t + "" : t
      }
      if ("string" != typeof e)
          return 0 === e ? e : +e;
      e = e.replace(s, "");
      var i = l.test(e);
      return i || c.test(e) ? u(e.slice(2), i ? 2 : 8) : a.test(e) ? o : +e
  }
}
, function(e, t) {
  e.exports = function() {
      return !1
  }
}
, function(e, t) {
  e.exports = function(e, t) {
      for (var i = -1, n = null == e ? 0 : e.length, r = Array(n); ++i < n; )
          r[i] = t(e[i], i, e);
      return r
  }
}
, function(e, t) {
  e.exports = function() {
      return !1
  }
}
, function(e, t, i) {
  var n = i(17)
    , r = i(13);
  e.exports = function(e, t, i) {
      (void 0 === i || r(e[t], i)) && (void 0 !== i || t in e) || n(e, t, i)
  }
}
, function(e, t, i) {
  var n = i(29)(Object.getPrototypeOf, Object);
  e.exports = n
}
, function(e, t) {
  e.exports = function(e, t) {
      return function(i) {
          return e(t(i))
      }
  }
}
, function(e, t, i) {
  var n = i(5)
    , r = i(28)
    , o = i(6)
    , s = "[object Object]"
    , a = Function.prototype
    , l = Object.prototype
    , c = a.toString
    , u = l.hasOwnProperty
    , h = c.call(Object);
  e.exports = function(e) {
      if (!o(e) || n(e) != s)
          return !1;
      var t = r(e);
      if (null === t)
          return !0;
      var i = u.call(t, "constructor") && t.constructor;
      return "function" == typeof i && i instanceof i && c.call(i) == h
  }
}
, function(e, t) {
  e.exports = function(e, t) {
      if ("__proto__" != t)
          return e[t]
  }
}
, function(e, t, i) {
  var n = i(93)
    , r = i(17);
  e.exports = function(e, t, i, o) {
      var s = !i;
      i || (i = {});
      for (var a = -1, l = t.length; ++a < l; ) {
          var c = t[a]
            , u = o ? o(i[c], e[c], c, i, e) : void 0;
          void 0 === u && (u = e[c]),
          s ? r(i, c, u) : n(i, c, u)
      }
      return i
  }
}
, function(e, t, i) {
  var n = i(34)
    , r = i(36);
  e.exports = function(e) {
      return n(function(t, i) {
          var n = -1
            , o = i.length
            , s = o > 1 ? i[o - 1] : void 0
            , a = o > 2 ? i[2] : void 0;
          for (s = e.length > 3 && "function" == typeof s ? (o--,
          s) : void 0,
          a && r(i[0], i[1], a) && (s = o < 3 ? void 0 : s,
          o = 1),
          t = Object(t); ++n < o; ) {
              var l = i[n];
              l && e(t, l, n, s)
          }
          return t
      })
  }
}
, function(e, t, i) {
  var n = i(94)
    , r = i(95)
    , o = i(96);
  e.exports = function(e, t) {
      return o(r(e, t, n), e + "")
  }
}
, function(e, t) {
  e.exports = function(e, t, i) {
      switch (i.length) {
      case 0:
          return e.call(t);
      case 1:
          return e.call(t, i[0]);
      case 2:
          return e.call(t, i[0], i[1]);
      case 3:
          return e.call(t, i[0], i[1], i[2])
      }
      return e.apply(t, i)
  }
}
, function(e, t) {
  e.exports = function() {
      return !1
  }
}
, function(e, t, i) {
  var n = i(5)
    , r = i(6)
    , o = i(30)
    , s = "[object DOMException]"
    , a = "[object Error]";
  e.exports = function(e) {
      if (!r(e))
          return !1;
      var t = n(e);
      return t == a || t == s || "string" == typeof e.message && "string" == typeof e.name && !o(e)
  }
}
, function(e, t) {
  e.exports = /<%=([\s\S]+?)%>/g
}
, function(e, t, i) {
  var n = i(5)
    , r = i(6)
    , o = "[object Boolean]";
  e.exports = function(e) {
      return !0 === e || !1 === e || r(e) && n(e) == o
  }
}
, function(e, t, i) {
  var n = i(53);
  e.exports = function(e) {
      return "number" == typeof e && e == n(e)
  }
}
, function(e, t, i) {
  var n = i(5)
    , r = i(6)
    , o = "[object Number]";
  e.exports = function(e) {
      return "number" == typeof e || r(e) && n(e) == o
  }
}
, function(e, t, i) {
  var n = i(5)
    , r = i(8)
    , o = i(6)
    , s = "[object String]";
  e.exports = function(e) {
      return "string" == typeof e || !r(e) && o(e) && n(e) == s
  }
}
, function(e, t) {
  e.exports = function(e) {
      return void 0 === e
  }
}
, function(e, t, i) {
  var n = i(10)
    , r = i(58);
  e.exports = function(e) {
      return r(n(e).toLowerCase())
  }
}
, function(e, t, i) {
  var n = i(66)
    , r = i(33)(function(e, t, i) {
      n(e, t, i)
  });
  e.exports = r
}
, function(e, t, i) {
  var n = i(97)
    , r = i(98)
    , o = i(99)
    , s = i(100)
    , a = i(101)
    , l = i(37)
    , c = i(36)
    , u = i(102)
    , h = i(38)
    , d = i(103)
    , p = i(10)
    , f = /\b__p \+= '';/g
    , m = /\b(__p \+=) '' \+/g
    , g = /(__e\(.*?\)|\b__t\)) \+\n'';/g
    , v = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g
    , y = /($^)/
    , _ = /['\n\r\u2028\u2029\\]/g;
  e.exports = function(e, t, i) {
      var b = d.imports._.templateSettings || d;
      i && c(e, t, i) && (t = void 0),
      e = p(e),
      t = n({}, t, b, s);
      var w, x, k = n({}, t.imports, b.imports, s), S = u(k), E = o(k, S), T = 0, C = t.interpolate || y, L = "__p += '", A = RegExp((t.escape || y).source + "|" + C.source + "|" + (C === h ? v : y).source + "|" + (t.evaluate || y).source + "|$", "g"), P = "sourceURL"in t ? "//# sourceURL=" + t.sourceURL + "\n" : "";
      e.replace(A, function(t, i, n, r, o, s) {
          return n || (n = r),
          L += e.slice(T, s).replace(_, a),
          i && (w = !0,
          L += "' +\n__e(" + i + ") +\n'"),
          o && (x = !0,
          L += "';\n" + o + ";\n__p += '"),
          n && (L += "' +\n((__t = (" + n + ")) == null ? '' : __t) +\n'"),
          T = s + t.length,
          t
      }),
      L += "';\n";
      var I = t.variable;
      I || (L = "with (obj) {\n" + L + "\n}\n"),
      L = (x ? L.replace(f, "") : L).replace(m, "$1").replace(g, "$1;"),
      L = "function(" + (I || "obj") + ") {\n" + (I ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (w ? ", __e = _.escape" : "") + (x ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + L + "return __p\n}";
      var M = r(function() {
          return Function(S, P + "return " + L).apply(void 0, E)
      });
      if (M.source = L,
      l(M))
          throw M;
      return M
  }
}
, function(e, t, i) {
  var n = i(19)
    , r = i(3)
    , o = "Expected a function";
  e.exports = function(e, t, i) {
      var s = !0
        , a = !0;
      if ("function" != typeof e)
          throw new TypeError(o);
      return r(i) && (s = "leading"in i ? !!i.leading : s,
      a = "trailing"in i ? !!i.trailing : a),
      n(e, t, {
          leading: s,
          maxWait: t,
          trailing: a
      })
  }
}
, function(e, t) {
  e.exports = function(e) {
      return e.webpackPolyfill || (e.deprecate = function() {}
      ,
      e.paths = [],
      e.children || (e.children = []),
      Object.defineProperty(e, "loaded", {
          enumerable: !0,
          get: function() {
              return e.l
          }
      }),
      Object.defineProperty(e, "id", {
          enumerable: !0,
          get: function() {
              return e.i
          }
      }),
      e.webpackPolyfill = 1),
      e
  }
}
, function(e, t, i) {
  "use strict";
  e.exports = {
      API_ORIGIN: "https://api.mapbox.com",
      EVENT_PROGRESS_DOWNLOAD: "downloadProgress",
      EVENT_PROGRESS_UPLOAD: "uploadProgress",
      EVENT_ERROR: "error",
      EVENT_RESPONSE: "response",
      ERROR_HTTP: "HttpError",
      ERROR_REQUEST_ABORTED: "RequestAbortedError"
  }
}
, function(e, t) {
  e.exports = function() {
      for (var e = {}, t = 0; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n)
              i.call(n, r) && (e[r] = n[r])
      }
      return e
  }
  ;
  var i = Object.prototype.hasOwnProperty
}
, function(e, t, i) {
  e.exports = function() {
      "use strict";
      var e, t, i;
      function n(n, r) {
          if (e)
              if (t) {
                  var o = "var sharedChunk = {}; (" + e + ")(sharedChunk); (" + t + ")(sharedChunk);"
                    , s = {};
                  e(s),
                  (i = r(s)).workerUrl = window.URL.createObjectURL(new Blob([o],{
                      type: "text/javascript"
                  }))
              } else
                  t = r;
          else
              e = r
      }
      return n(0, function(e) {
          function t(e, t) {
              return e(t = {
                  exports: {}
              }, t.exports),
              t.exports
          }
          var i = n;
          function n(e, t, i, n) {
              this.cx = 3 * e,
              this.bx = 3 * (i - e) - this.cx,
              this.ax = 1 - this.cx - this.bx,
              this.cy = 3 * t,
              this.by = 3 * (n - t) - this.cy,
              this.ay = 1 - this.cy - this.by,
              this.p1x = e,
              this.p1y = n,
              this.p2x = i,
              this.p2y = n
          }
          n.prototype.sampleCurveX = function(e) {
              return ((this.ax * e + this.bx) * e + this.cx) * e
          }
          ,
          n.prototype.sampleCurveY = function(e) {
              return ((this.ay * e + this.by) * e + this.cy) * e
          }
          ,
          n.prototype.sampleCurveDerivativeX = function(e) {
              return (3 * this.ax * e + 2 * this.bx) * e + this.cx
          }
          ,
          n.prototype.solveCurveX = function(e, t) {
              var i, n, r, o, s;
              for (void 0 === t && (t = 1e-6),
              r = e,
              s = 0; s < 8; s++) {
                  if (o = this.sampleCurveX(r) - e,
                  Math.abs(o) < t)
                      return r;
                  var a = this.sampleCurveDerivativeX(r);
                  if (Math.abs(a) < 1e-6)
                      break;
                  r -= o / a
              }
              if ((r = e) < (i = 0))
                  return i;
              if (r > (n = 1))
                  return n;
              for (; i < n; ) {
                  if (o = this.sampleCurveX(r),
                  Math.abs(o - e) < t)
                      return r;
                  e > o ? i = r : n = r,
                  r = .5 * (n - i) + i
              }
              return r
          }
          ,
          n.prototype.solve = function(e, t) {
              return this.sampleCurveY(this.solveCurveX(e, t))
          }
          ;
          var r = o;
          function o(e, t) {
              this.x = e,
              this.y = t
          }
          function s(e, t) {
              if (Array.isArray(e)) {
                  if (!Array.isArray(t) || e.length !== t.length)
                      return !1;
                  for (var i = 0; i < e.length; i++)
                      if (!s(e[i], t[i]))
                          return !1;
                  return !0
              }
              if ("object" == typeof e && null !== e && null !== t) {
                  if ("object" != typeof t)
                      return !1;
                  if (Object.keys(e).length !== Object.keys(t).length)
                      return !1;
                  for (var n in e)
                      if (!s(e[n], t[n]))
                          return !1;
                  return !0
              }
              return e === t
          }
          function a(e, t, n, r) {
              var o = new i(e,t,n,r);
              return function(e) {
                  return o.solve(e)
              }
          }
          o.prototype = {
              clone: function() {
                  return new o(this.x,this.y)
              },
              add: function(e) {
                  return this.clone()._add(e)
              },
              sub: function(e) {
                  return this.clone()._sub(e)
              },
              multByPoint: function(e) {
                  return this.clone()._multByPoint(e)
              },
              divByPoint: function(e) {
                  return this.clone()._divByPoint(e)
              },
              mult: function(e) {
                  return this.clone()._mult(e)
              },
              div: function(e) {
                  return this.clone()._div(e)
              },
              rotate: function(e) {
                  return this.clone()._rotate(e)
              },
              rotateAround: function(e, t) {
                  return this.clone()._rotateAround(e, t)
              },
              matMult: function(e) {
                  return this.clone()._matMult(e)
              },
              unit: function() {
                  return this.clone()._unit()
              },
              perp: function() {
                  return this.clone()._perp()
              },
              round: function() {
                  return this.clone()._round()
              },
              mag: function() {
                  return Math.sqrt(this.x * this.x + this.y * this.y)
              },
              equals: function(e) {
                  return this.x === e.x && this.y === e.y
              },
              dist: function(e) {
                  return Math.sqrt(this.distSqr(e))
              },
              distSqr: function(e) {
                  var t = e.x - this.x
                    , i = e.y - this.y;
                  return t * t + i * i
              },
              angle: function() {
                  return Math.atan2(this.y, this.x)
              },
              angleTo: function(e) {
                  return Math.atan2(this.y - e.y, this.x - e.x)
              },
              angleWith: function(e) {
                  return this.angleWithSep(e.x, e.y)
              },
              angleWithSep: function(e, t) {
                  return Math.atan2(this.x * t - this.y * e, this.x * e + this.y * t)
              },
              _matMult: function(e) {
                  var t = e[0] * this.x + e[1] * this.y
                    , i = e[2] * this.x + e[3] * this.y;
                  return this.x = t,
                  this.y = i,
                  this
              },
              _add: function(e) {
                  return this.x += e.x,
                  this.y += e.y,
                  this
              },
              _sub: function(e) {
                  return this.x -= e.x,
                  this.y -= e.y,
                  this
              },
              _mult: function(e) {
                  return this.x *= e,
                  this.y *= e,
                  this
              },
              _div: function(e) {
                  return this.x /= e,
                  this.y /= e,
                  this
              },
              _multByPoint: function(e) {
                  return this.x *= e.x,
                  this.y *= e.y,
                  this
              },
              _divByPoint: function(e) {
                  return this.x /= e.x,
                  this.y /= e.y,
                  this
              },
              _unit: function() {
                  return this._div(this.mag()),
                  this
              },
              _perp: function() {
                  var e = this.y;
                  return this.y = this.x,
                  this.x = -e,
                  this
              },
              _rotate: function(e) {
                  var t = Math.cos(e)
                    , i = Math.sin(e)
                    , n = t * this.x - i * this.y
                    , r = i * this.x + t * this.y;
                  return this.x = n,
                  this.y = r,
                  this
              },
              _rotateAround: function(e, t) {
                  var i = Math.cos(e)
                    , n = Math.sin(e)
                    , r = t.x + i * (this.x - t.x) - n * (this.y - t.y)
                    , o = t.y + n * (this.x - t.x) + i * (this.y - t.y);
                  return this.x = r,
                  this.y = o,
                  this
              },
              _round: function() {
                  return this.x = Math.round(this.x),
                  this.y = Math.round(this.y),
                  this
              }
          },
          o.convert = function(e) {
              return e instanceof o ? e : Array.isArray(e) ? new o(e[0],e[1]) : e
          }
          ;
          var l = a(.25, .1, .25, 1);
          function c(e, t, i) {
              return Math.min(i, Math.max(t, e))
          }
          function u(e, t, i) {
              var n = i - t
                , r = ((e - t) % n + n) % n + t;
              return r === t ? i : r
          }
          function h(e) {
              for (var t = [], i = arguments.length - 1; i-- > 0; )
                  t[i] = arguments[i + 1];
              for (var n = 0, r = t; n < r.length; n += 1) {
                  var o = r[n];
                  for (var s in o)
                      e[s] = o[s]
              }
              return e
          }
          var d = 1;
          function p() {
              return d++
          }
          function f() {
              return function e(t) {
                  return t ? (t ^ 16 * Math.random() >> t / 4).toString(16) : ([1e7] + -[1e3] + -4e3 + -8e3 + -1e11).replace(/[018]/g, e)
              }()
          }
          function m(e) {
              return !!e && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(e)
          }
          function g(e, t) {
              e.forEach(function(e) {
                  t[e] && (t[e] = t[e].bind(t))
              })
          }
          function v(e, t) {
              return -1 !== e.indexOf(t, e.length - t.length)
          }
          function y(e, t, i) {
              var n = {};
              for (var r in e)
                  n[r] = t.call(i || this, e[r], r, e);
              return n
          }
          function _(e, t, i) {
              var n = {};
              for (var r in e)
                  t.call(i || this, e[r], r, e) && (n[r] = e[r]);
              return n
          }
          function b(e) {
              return Array.isArray(e) ? e.map(b) : "object" == typeof e && e ? y(e, b) : e
          }
          var w = {};
          function x(e) {
              w[e] || ("undefined" != typeof console && console.warn(e),
              w[e] = !0)
          }
          function k(e, t, i) {
              return (i.y - e.y) * (t.x - e.x) > (t.y - e.y) * (i.x - e.x)
          }
          function S(e) {
              for (var t = 0, i = 0, n = e.length, r = n - 1, o = void 0, s = void 0; i < n; r = i++)
                  o = e[i],
                  t += ((s = e[r]).x - o.x) * (o.y + s.y);
              return t
          }
          function E(e) {
              try {
                  var t = self[e];
                  return t.setItem("_mapbox_test_", 1),
                  t.removeItem("_mapbox_test_"),
                  !0
              } catch (e) {
                  return !1
              }
          }
          var T, C, L = self.performance && self.performance.now ? self.performance.now.bind(self.performance) : Date.now.bind(Date), A = self.requestAnimationFrame || self.mozRequestAnimationFrame || self.webkitRequestAnimationFrame || self.msRequestAnimationFrame, P = self.cancelAnimationFrame || self.mozCancelAnimationFrame || self.webkitCancelAnimationFrame || self.msCancelAnimationFrame, I = {
              now: L,
              frame: function(e) {
                  var t = A(e);
                  return {
                      cancel: function() {
                          return P(t)
                      }
                  }
              },
              getImageData: function(e) {
                  var t = self.document.createElement("canvas")
                    , i = t.getContext("2d");
                  if (!i)
                      throw new Error("failed to create canvas 2d context");
                  return t.width = e.width,
                  t.height = e.height,
                  i.drawImage(e, 0, 0, e.width, e.height),
                  i.getImageData(0, 0, e.width, e.height)
              },
              resolveURL: function(e) {
                  var t = self.document.createElement("a");
                  return t.href = e,
                  t.href
              },
              hardwareConcurrency: self.navigator.hardwareConcurrency || 4,
              get devicePixelRatio() {
                  return self.devicePixelRatio
              }
          }, M = {
              API_URL: "https://api.mapbox.com",
              get EVENTS_URL() {
                  return this.API_URL ? 0 === this.API_URL.indexOf("https://api.mapbox.cn") ? "https://events.mapbox.cn/events/v2" : 0 === this.API_URL.indexOf("https://api.mapbox.com") ? "https://events.mapbox.com/events/v2" : null : null
              },
              FEEDBACK_URL: "https://apps.mapbox.com/feedback",
              REQUIRE_ACCESS_TOKEN: !0,
              ACCESS_TOKEN: null,
              MAX_PARALLEL_IMAGE_REQUESTS: 16
          }, O = {
              supported: !1,
              testSupport: function(e) {
                  !z && C && (D ? R(e) : T = e)
              }
          }, z = !1, D = !1;
          function R(e) {
              var t = e.createTexture();
              e.bindTexture(e.TEXTURE_2D, t);
              try {
                  if (e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, C),
                  e.isContextLost())
                      return;
                  O.supported = !0
              } catch (e) {}
              e.deleteTexture(t),
              z = !0
          }
          self.document && ((C = self.document.createElement("img")).onload = function() {
              T && R(T),
              T = null,
              D = !0
          }
          ,
          C.onerror = function() {
              z = !0,
              T = null
          }
          ,
          C.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
          var B = "See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes";
          function j(e, t) {
              var i = $(M.API_URL);
              if (e.protocol = i.protocol,
              e.authority = i.authority,
              "/" !== i.path && (e.path = "" + i.path + e.path),
              !M.REQUIRE_ACCESS_TOKEN)
                  return G(e);
              if (!(t = t || M.ACCESS_TOKEN))
                  throw new Error("An API access token is required to use Mapbox GL. " + B);
              if ("s" === t[0])
                  throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). " + B);
              return e.params.push("access_token=" + t),
              G(e)
          }
          function F(e) {
              return 0 === e.indexOf("mapbox:")
          }
          var N = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
          function U(e) {
              return N.test(e)
          }
          var q = /(\.(png|jpg)\d*)(?=$)/
            , H = /\.[\w]+$/
            , V = function(e) {
              var t = $(e);
              if (!t.path.match(/(^\/v4\/)/) || !t.path.match(H))
                  return e;
              var i = "mapbox://tiles/";
              i += t.path.replace("/v4/", "");
              var n = t.params.filter(function(e) {
                  return !e.match(/^access_token=/)
              });
              return n.length && (i += "?" + n.join("&")),
              i
          }
            , W = /^(\w+):\/\/([^\/?]*)(\/[^?]+)?\??(.+)?/;
          function $(e) {
              var t = e.match(W);
              if (!t)
                  throw new Error("Unable to parse URL object");
              return {
                  protocol: t[1],
                  authority: t[2],
                  path: t[3] || "/",
                  params: t[4] ? t[4].split("&") : []
              }
          }
          function G(e) {
              var t = e.params.length ? "?" + e.params.join("&") : "";
              return e.protocol + "://" + e.authority + e.path + t
          }
          function X(e) {
              if (!e)
                  return null;
              var t, i = e.split(".");
              if (!i || 3 !== i.length)
                  return null;
              try {
                  return JSON.parse((t = i[1],
                  decodeURIComponent(self.atob(t).split("").map(function(e) {
                      return "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)
                  }).join(""))))
              } catch (e) {
                  return null
              }
          }
          var Z = function(e) {
              this.type = e,
              this.anonId = null,
              this.eventData = {},
              this.queue = [],
              this.pendingRequest = null
          };
          Z.prototype.getStorageKey = function(e) {
              var t, i = X(M.ACCESS_TOKEN), n = "";
              return i && i.u ? (t = i.u,
              n = self.btoa(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g, function(e, t) {
                  return String.fromCharCode(Number("0x" + t))
              }))) : n = M.ACCESS_TOKEN || "",
              e ? "mapbox.eventData." + e + ":" + n : "mapbox.eventData:" + n
          }
          ,
          Z.prototype.fetchEventData = function() {
              var e = E("localStorage")
                , t = this.getStorageKey()
                , i = this.getStorageKey("uuid");
              if (e)
                  try {
                      var n = self.localStorage.getItem(t);
                      n && (this.eventData = JSON.parse(n));
                      var r = self.localStorage.getItem(i);
                      r && (this.anonId = r)
                  } catch (e) {
                      x("Unable to read from LocalStorage")
                  }
          }
          ,
          Z.prototype.saveEventData = function() {
              var e = E("localStorage")
                , t = this.getStorageKey()
                , i = this.getStorageKey("uuid");
              if (e)
                  try {
                      self.localStorage.setItem(i, this.anonId),
                      Object.keys(this.eventData).length >= 1 && self.localStorage.setItem(t, JSON.stringify(this.eventData))
                  } catch (e) {
                      x("Unable to write to LocalStorage")
                  }
          }
          ,
          Z.prototype.processRequests = function() {}
          ,
          Z.prototype.postEvent = function(e, t, i) {
              var n = this;
              if (M.EVENTS_URL) {
                  var r = $(M.EVENTS_URL);
                  r.params.push("access_token=" + (M.ACCESS_TOKEN || ""));
                  var o = {
                      event: this.type,
                      created: new Date(e).toISOString(),
                      sdkIdentifier: "mapbox-gl-js",
                      sdkVersion: "0.53.1",
                      userId: this.anonId
                  }
                    , s = t ? h(o, t) : o
                    , a = {
                      url: G(r),
                      headers: {
                          "Content-Type": "text/plain"
                      },
                      body: JSON.stringify([s])
                  };
                  this.pendingRequest = ce(a, function(e) {
                      n.pendingRequest = null,
                      i(e),
                      n.saveEventData(),
                      n.processRequests()
                  })
              }
          }
          ,
          Z.prototype.queueRequest = function(e) {
              this.queue.push(e),
              this.processRequests()
          }
          ;
          var Y = function(e) {
              function t() {
                  e.call(this, "map.load"),
                  this.success = {}
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.postMapLoadEvent = function(e, t) {
                  M.EVENTS_URL && M.ACCESS_TOKEN && Array.isArray(e) && e.some(function(e) {
                      return F(e) || U(e)
                  }) && this.queueRequest({
                      id: t,
                      timestamp: Date.now()
                  })
              }
              ,
              t.prototype.processRequests = function() {
                  var e = this;
                  if (!this.pendingRequest && 0 !== this.queue.length) {
                      var t = this.queue.shift()
                        , i = t.id
                        , n = t.timestamp;
                      i && this.success[i] || (this.anonId || this.fetchEventData(),
                      m(this.anonId) || (this.anonId = f()),
                      this.postEvent(n, {}, function(t) {
                          t || i && (e.success[i] = !0)
                      }))
                  }
              }
              ,
              t
          }(Z)
            , K = new (function(e) {
              function t() {
                  e.call(this, "appUserTurnstile")
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.postTurnstileEvent = function(e) {
                  M.EVENTS_URL && M.ACCESS_TOKEN && Array.isArray(e) && e.some(function(e) {
                      return F(e) || U(e)
                  }) && this.queueRequest(Date.now())
              }
              ,
              t.prototype.processRequests = function() {
                  var e = this;
                  if (!this.pendingRequest && 0 !== this.queue.length) {
                      this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                      var t = X(M.ACCESS_TOKEN)
                        , i = t ? t.u : M.ACCESS_TOKEN
                        , n = i !== this.eventData.tokenU;
                      m(this.anonId) || (this.anonId = f(),
                      n = !0);
                      var r = this.queue.shift();
                      if (this.eventData.lastSuccess) {
                          var o = new Date(this.eventData.lastSuccess)
                            , s = new Date(r)
                            , a = (r - this.eventData.lastSuccess) / 864e5;
                          n = n || a >= 1 || a < -1 || o.getDate() !== s.getDate()
                      } else
                          n = !0;
                      if (!n)
                          return this.processRequests();
                      this.postEvent(r, {
                          "enabled.telemetry": !1
                      }, function(t) {
                          t || (e.eventData.lastSuccess = r,
                          e.eventData.tokenU = i)
                      })
                  }
              }
              ,
              t
          }(Z))
            , J = K.postTurnstileEvent.bind(K)
            , Q = new Y
            , ee = Q.postMapLoadEvent.bind(Q)
            , te = {
              Unknown: "Unknown",
              Style: "Style",
              Source: "Source",
              Tile: "Tile",
              Glyphs: "Glyphs",
              SpriteImage: "SpriteImage",
              SpriteJSON: "SpriteJSON",
              Image: "Image"
          };
          "function" == typeof Object.freeze && Object.freeze(te);
          var ie = function(e) {
              function t(t, i, n) {
                  401 === i && U(n) && (t += ": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"),
                  e.call(this, t),
                  this.status = i,
                  this.url = n,
                  this.name = this.constructor.name,
                  this.message = t
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.toString = function() {
                  return this.name + ": " + this.message + " (" + this.status + "): " + this.url
              }
              ,
              t
          }(Error);
          function ne() {
              return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope
          }
          var re, oe, se = ne() ? function() {
              return self.worker && self.worker.referrer
          }
          : function() {
              var e = self.location.origin;
              if (e && "null" !== e && "file://" !== e)
                  return e + self.location.pathname
          }
          , ae = function(e, t) {
              if (!/^file:/.test(e.url)) {
                  if (self.fetch && self.Request && self.AbortController)
                      return function(e, t) {
                          var i = new self.AbortController
                            , n = new self.Request(e.url,{
                              method: e.method || "GET",
                              body: e.body,
                              credentials: e.credentials,
                              headers: e.headers,
                              referrer: se(),
                              signal: i.signal
                          });
                          return "json" === e.type && n.headers.set("Accept", "application/json"),
                          self.fetch(n).then(function(i) {
                              i.ok ? i[e.type || "text"]().then(function(e) {
                                  t(null, e, i.headers.get("Cache-Control"), i.headers.get("Expires"))
                              }).catch(function(e) {
                                  return t(new Error(e.message))
                              }) : t(new ie(i.statusText,i.status,e.url))
                          }).catch(function(e) {
                              20 !== e.code && t(new Error(e.message))
                          }),
                          {
                              cancel: function() {
                                  return i.abort()
                              }
                          }
                      }(e, t);
                  if (ne() && self.worker && self.worker.actor)
                      return self.worker.actor.send("getResource", e, t)
              }
              return function(e, t) {
                  var i = new self.XMLHttpRequest;
                  for (var n in i.open(e.method || "GET", e.url, !0),
                  "arrayBuffer" === e.type && (i.responseType = "arraybuffer"),
                  e.headers)
                      i.setRequestHeader(n, e.headers[n]);
                  return "json" === e.type && i.setRequestHeader("Accept", "application/json"),
                  i.withCredentials = "include" === e.credentials,
                  i.onerror = function() {
                      t(new Error(i.statusText))
                  }
                  ,
                  i.onload = function() {
                      if ((i.status >= 200 && i.status < 300 || 0 === i.status) && null !== i.response) {
                          var n = i.response;
                          if ("json" === e.type)
                              try {
                                  n = JSON.parse(i.response)
                              } catch (e) {
                                  return t(e)
                              }
                          t(null, n, i.getResponseHeader("Cache-Control"), i.getResponseHeader("Expires"))
                      } else
                          t(new ie(i.statusText,i.status,e.url))
                  }
                  ,
                  i.send(e.body),
                  {
                      cancel: function() {
                          return i.abort()
                      }
                  }
              }(e, t)
          }, le = function(e, t) {
              return ae(h(e, {
                  type: "arrayBuffer"
              }), t)
          }, ce = function(e, t) {
              return ae(h(e, {
                  method: "POST"
              }), t)
          };
          re = [],
          oe = 0;
          var ue = function(e, t) {
              if (oe >= M.MAX_PARALLEL_IMAGE_REQUESTS) {
                  var i = {
                      requestParameters: e,
                      callback: t,
                      cancelled: !1,
                      cancel: function() {
                          this.cancelled = !0
                      }
                  };
                  return re.push(i),
                  i
              }
              oe++;
              var n = !1
                , r = function() {
                  if (!n)
                      for (n = !0,
                      oe--; re.length && oe < M.MAX_PARALLEL_IMAGE_REQUESTS; ) {
                          var e = re.shift()
                            , t = e.requestParameters
                            , i = e.callback;
                          e.cancelled || (e.cancel = ue(t, i).cancel)
                      }
              }
                , o = le(e, function(e, i, n, o) {
                  if (r(),
                  e)
                      t(e);
                  else if (i) {
                      var s = new self.Image
                        , a = self.URL || self.webkitURL;
                      s.onload = function() {
                          t(null, s),
                          a.revokeObjectURL(s.src)
                      }
                      ,
                      s.onerror = function() {
                          return t(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."))
                      }
                      ;
                      var l = new self.Blob([new Uint8Array(i)],{
                          type: "image/png"
                      });
                      s.cacheControl = n,
                      s.expires = o,
                      s.src = i.byteLength ? a.createObjectURL(l) : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII="
                  }
              });
              return {
                  cancel: function() {
                      o.cancel(),
                      r()
                  }
              }
          };
          function he(e, t, i) {
              i[e] && -1 !== i[e].indexOf(t) || (i[e] = i[e] || [],
              i[e].push(t))
          }
          function de(e, t, i) {
              if (i && i[e]) {
                  var n = i[e].indexOf(t);
                  -1 !== n && i[e].splice(n, 1)
              }
          }
          var pe = function(e, t) {
              void 0 === t && (t = {}),
              h(this, t),
              this.type = e
          }
            , fe = function(e) {
              function t(t, i) {
                  void 0 === i && (i = {}),
                  e.call(this, "error", h({
                      error: t
                  }, i))
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t
          }(pe)
            , me = function() {};
          me.prototype.on = function(e, t) {
              return this._listeners = this._listeners || {},
              he(e, t, this._listeners),
              this
          }
          ,
          me.prototype.off = function(e, t) {
              return de(e, t, this._listeners),
              de(e, t, this._oneTimeListeners),
              this
          }
          ,
          me.prototype.once = function(e, t) {
              return this._oneTimeListeners = this._oneTimeListeners || {},
              he(e, t, this._oneTimeListeners),
              this
          }
          ,
          me.prototype.fire = function(e, t) {
              "string" == typeof e && (e = new pe(e,t || {}));
              var i = e.type;
              if (this.listens(i)) {
                  e.target = this;
                  for (var n = 0, r = this._listeners && this._listeners[i] ? this._listeners[i].slice() : []; n < r.length; n += 1)
                      r[n].call(this, e);
                  for (var o = 0, s = this._oneTimeListeners && this._oneTimeListeners[i] ? this._oneTimeListeners[i].slice() : []; o < s.length; o += 1) {
                      var a = s[o];
                      de(i, a, this._oneTimeListeners),
                      a.call(this, e)
                  }
                  var l = this._eventedParent;
                  l && (h(e, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData),
                  l.fire(e))
              } else
                  e instanceof fe && console.error(e.error);
              return this
          }
          ,
          me.prototype.listens = function(e) {
              return this._listeners && this._listeners[e] && this._listeners[e].length > 0 || this._oneTimeListeners && this._oneTimeListeners[e] && this._oneTimeListeners[e].length > 0 || this._eventedParent && this._eventedParent.listens(e)
          }
          ,
          me.prototype.setEventedParent = function(e, t) {
              return this._eventedParent = e,
              this._eventedParentData = t,
              this
          }
          ;
          var ge = {
              $version: 8,
              $root: {
                  version: {
                      required: !0,
                      type: "enum",
                      values: [8]
                  },
                  name: {
                      type: "string"
                  },
                  metadata: {
                      type: "*"
                  },
                  center: {
                      type: "array",
                      value: "number"
                  },
                  zoom: {
                      type: "number"
                  },
                  bearing: {
                      type: "number",
                      default: 0,
                      period: 360,
                      units: "degrees"
                  },
                  pitch: {
                      type: "number",
                      default: 0,
                      units: "degrees"
                  },
                  light: {
                      type: "light"
                  },
                  sources: {
                      required: !0,
                      type: "sources"
                  },
                  sprite: {
                      type: "string"
                  },
                  glyphs: {
                      type: "string"
                  },
                  transition: {
                      type: "transition"
                  },
                  layers: {
                      required: !0,
                      type: "array",
                      value: "layer"
                  }
              },
              sources: {
                  "*": {
                      type: "source"
                  }
              },
              source: ["source_vector", "source_raster", "source_raster_dem", "source_geojson", "source_video", "source_image"],
              source_vector: {
                  type: {
                      required: !0,
                      type: "enum",
                      values: {
                          vector: {}
                      }
                  },
                  url: {
                      type: "string"
                  },
                  tiles: {
                      type: "array",
                      value: "string"
                  },
                  bounds: {
                      type: "array",
                      value: "number",
                      length: 4,
                      default: [-180, -85.051129, 180, 85.051129]
                  },
                  scheme: {
                      type: "enum",
                      values: {
                          xyz: {},
                          tms: {}
                      },
                      default: "xyz"
                  },
                  minzoom: {
                      type: "number",
                      default: 0
                  },
                  maxzoom: {
                      type: "number",
                      default: 22
                  },
                  attribution: {
                      type: "string"
                  },
                  "*": {
                      type: "*"
                  }
              },
              source_raster: {
                  type: {
                      required: !0,
                      type: "enum",
                      values: {
                          raster: {}
                      }
                  },
                  url: {
                      type: "string"
                  },
                  tiles: {
                      type: "array",
                      value: "string"
                  },
                  bounds: {
                      type: "array",
                      value: "number",
                      length: 4,
                      default: [-180, -85.051129, 180, 85.051129]
                  },
                  minzoom: {
                      type: "number",
                      default: 0
                  },
                  maxzoom: {
                      type: "number",
                      default: 22
                  },
                  tileSize: {
                      type: "number",
                      default: 512,
                      units: "pixels"
                  },
                  scheme: {
                      type: "enum",
                      values: {
                          xyz: {},
                          tms: {}
                      },
                      default: "xyz"
                  },
                  attribution: {
                      type: "string"
                  },
                  "*": {
                      type: "*"
                  }
              },
              source_raster_dem: {
                  type: {
                      required: !0,
                      type: "enum",
                      values: {
                          "raster-dem": {}
                      }
                  },
                  url: {
                      type: "string"
                  },
                  tiles: {
                      type: "array",
                      value: "string"
                  },
                  bounds: {
                      type: "array",
                      value: "number",
                      length: 4,
                      default: [-180, -85.051129, 180, 85.051129]
                  },
                  minzoom: {
                      type: "number",
                      default: 0
                  },
                  maxzoom: {
                      type: "number",
                      default: 22
                  },
                  tileSize: {
                      type: "number",
                      default: 512,
                      units: "pixels"
                  },
                  attribution: {
                      type: "string"
                  },
                  encoding: {
                      type: "enum",
                      values: {
                          terrarium: {},
                          mapbox: {}
                      },
                      default: "mapbox"
                  },
                  "*": {
                      type: "*"
                  }
              },
              source_geojson: {
                  type: {
                      required: !0,
                      type: "enum",
                      values: {
                          geojson: {}
                      }
                  },
                  data: {
                      type: "*"
                  },
                  maxzoom: {
                      type: "number",
                      default: 18
                  },
                  attribution: {
                      type: "string"
                  },
                  buffer: {
                      type: "number",
                      default: 128,
                      maximum: 512,
                      minimum: 0
                  },
                  tolerance: {
                      type: "number",
                      default: .375
                  },
                  cluster: {
                      type: "boolean",
                      default: !1
                  },
                  clusterRadius: {
                      type: "number",
                      default: 50,
                      minimum: 0
                  },
                  clusterMaxZoom: {
                      type: "number"
                  },
                  clusterProperties: {
                      type: "*"
                  },
                  lineMetrics: {
                      type: "boolean",
                      default: !1
                  },
                  generateId: {
                      type: "boolean",
                      default: !1
                  }
              },
              source_video: {
                  type: {
                      required: !0,
                      type: "enum",
                      values: {
                          video: {}
                      }
                  },
                  urls: {
                      required: !0,
                      type: "array",
                      value: "string"
                  },
                  coordinates: {
                      required: !0,
                      type: "array",
                      length: 4,
                      value: {
                          type: "array",
                          length: 2,
                          value: "number"
                      }
                  }
              },
              source_image: {
                  type: {
                      required: !0,
                      type: "enum",
                      values: {
                          image: {}
                      }
                  },
                  url: {
                      required: !0,
                      type: "string"
                  },
                  coordinates: {
                      required: !0,
                      type: "array",
                      length: 4,
                      value: {
                          type: "array",
                          length: 2,
                          value: "number"
                      }
                  }
              },
              layer: {
                  id: {
                      type: "string",
                      required: !0
                  },
                  type: {
                      type: "enum",
                      values: {
                          fill: {},
                          line: {},
                          symbol: {},
                          circle: {},
                          heatmap: {},
                          "fill-extrusion": {},
                          raster: {},
                          hillshade: {},
                          background: {}
                      },
                      required: !0
                  },
                  metadata: {
                      type: "*"
                  },
                  source: {
                      type: "string"
                  },
                  "source-layer": {
                      type: "string"
                  },
                  minzoom: {
                      type: "number",
                      minimum: 0,
                      maximum: 24
                  },
                  maxzoom: {
                      type: "number",
                      minimum: 0,
                      maximum: 24
                  },
                  filter: {
                      type: "filter"
                  },
                  layout: {
                      type: "layout"
                  },
                  paint: {
                      type: "paint"
                  }
              },
              layout: ["layout_fill", "layout_line", "layout_circle", "layout_heatmap", "layout_fill-extrusion", "layout_symbol", "layout_raster", "layout_hillshade", "layout_background"],
              layout_background: {
                  visibility: {
                      type: "enum",
                      values: {
                          visible: {},
                          none: {}
                      },
                      default: "visible",
                      "property-type": "constant"
                  }
              },
              layout_fill: {
                  visibility: {
                      type: "enum",
                      values: {
                          visible: {},
                          none: {}
                      },
                      default: "visible",
                      "property-type": "constant"
                  }
              },
              layout_circle: {
                  visibility: {
                      type: "enum",
                      values: {
                          visible: {},
                          none: {}
                      },
                      default: "visible",
                      "property-type": "constant"
                  }
              },
              layout_heatmap: {
                  visibility: {
                      type: "enum",
                      values: {
                          visible: {},
                          none: {}
                      },
                      default: "visible",
                      "property-type": "constant"
                  }
              },
              "layout_fill-extrusion": {
                  visibility: {
                      type: "enum",
                      values: {
                          visible: {},
                          none: {}
                      },
                      default: "visible",
                      "property-type": "constant"
                  }
              },
              layout_line: {
                  "line-cap": {
                      type: "enum",
                      values: {
                          butt: {},
                          round: {},
                          square: {}
                      },
                      default: "butt",
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "line-join": {
                      type: "enum",
                      values: {
                          bevel: {},
                          round: {},
                          miter: {}
                      },
                      default: "miter",
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "line-miter-limit": {
                      type: "number",
                      default: 2,
                      requires: [{
                          "line-join": "miter"
                      }],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "line-round-limit": {
                      type: "number",
                      default: 1.05,
                      requires: [{
                          "line-join": "round"
                      }],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  visibility: {
                      type: "enum",
                      values: {
                          visible: {},
                          none: {}
                      },
                      default: "visible",
                      "property-type": "constant"
                  }
              },
              layout_symbol: {
                  "symbol-placement": {
                      type: "enum",
                      values: {
                          point: {},
                          line: {},
                          "line-center": {}
                      },
                      default: "point",
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "symbol-spacing": {
                      type: "number",
                      default: 250,
                      minimum: 1,
                      units: "pixels",
                      requires: [{
                          "symbol-placement": "line"
                      }],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "symbol-avoid-edges": {
                      type: "boolean",
                      default: !1,
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "symbol-sort-key": {
                      type: "number",
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "symbol-z-order": {
                      type: "enum",
                      values: {
                          auto: {},
                          "viewport-y": {},
                          source: {}
                      },
                      default: "auto",
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "icon-allow-overlap": {
                      type: "boolean",
                      default: !1,
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "icon-ignore-placement": {
                      type: "boolean",
                      default: !1,
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "icon-optional": {
                      type: "boolean",
                      default: !1,
                      requires: ["icon-image", "text-field"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "icon-rotation-alignment": {
                      type: "enum",
                      values: {
                          map: {},
                          viewport: {},
                          auto: {}
                      },
                      default: "auto",
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "icon-size": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      units: "factor of the original icon size",
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "icon-text-fit": {
                      type: "enum",
                      values: {
                          none: {},
                          width: {},
                          height: {},
                          both: {}
                      },
                      default: "none",
                      requires: ["icon-image", "text-field"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "icon-text-fit-padding": {
                      type: "array",
                      value: "number",
                      length: 4,
                      default: [0, 0, 0, 0],
                      units: "pixels",
                      requires: ["icon-image", "text-field", {
                          "icon-text-fit": ["both", "width", "height"]
                      }],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "icon-image": {
                      type: "string",
                      tokens: !0,
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "icon-rotate": {
                      type: "number",
                      default: 0,
                      period: 360,
                      units: "degrees",
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "icon-padding": {
                      type: "number",
                      default: 2,
                      minimum: 0,
                      units: "pixels",
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "icon-keep-upright": {
                      type: "boolean",
                      default: !1,
                      requires: ["icon-image", {
                          "icon-rotation-alignment": "map"
                      }, {
                          "symbol-placement": ["line", "line-center"]
                      }],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "icon-offset": {
                      type: "array",
                      value: "number",
                      length: 2,
                      default: [0, 0],
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "icon-anchor": {
                      type: "enum",
                      values: {
                          center: {},
                          left: {},
                          right: {},
                          top: {},
                          bottom: {},
                          "top-left": {},
                          "top-right": {},
                          "bottom-left": {},
                          "bottom-right": {}
                      },
                      default: "center",
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "icon-pitch-alignment": {
                      type: "enum",
                      values: {
                          map: {},
                          viewport: {},
                          auto: {}
                      },
                      default: "auto",
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "text-pitch-alignment": {
                      type: "enum",
                      values: {
                          map: {},
                          viewport: {},
                          auto: {}
                      },
                      default: "auto",
                      requires: ["text-field"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "text-rotation-alignment": {
                      type: "enum",
                      values: {
                          map: {},
                          viewport: {},
                          auto: {}
                      },
                      default: "auto",
                      requires: ["text-field"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "text-field": {
                      type: "formatted",
                      default: "",
                      tokens: !0,
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-font": {
                      type: "array",
                      value: "string",
                      default: ["Open Sans Regular", "Arial Unicode MS Regular"],
                      requires: ["text-field"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-size": {
                      type: "number",
                      default: 16,
                      minimum: 0,
                      units: "pixels",
                      requires: ["text-field"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-max-width": {
                      type: "number",
                      default: 10,
                      minimum: 0,
                      units: "ems",
                      requires: ["text-field"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-line-height": {
                      type: "number",
                      default: 1.2,
                      units: "ems",
                      requires: ["text-field"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "text-letter-spacing": {
                      type: "number",
                      default: 0,
                      units: "ems",
                      requires: ["text-field"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-justify": {
                      type: "enum",
                      values: {
                          left: {},
                          center: {},
                          right: {}
                      },
                      default: "center",
                      requires: ["text-field"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-anchor": {
                      type: "enum",
                      values: {
                          center: {},
                          left: {},
                          right: {},
                          top: {},
                          bottom: {},
                          "top-left": {},
                          "top-right": {},
                          "bottom-left": {},
                          "bottom-right": {}
                      },
                      default: "center",
                      requires: ["text-field"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-max-angle": {
                      type: "number",
                      default: 45,
                      units: "degrees",
                      requires: ["text-field", {
                          "symbol-placement": ["line", "line-center"]
                      }],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "text-rotate": {
                      type: "number",
                      default: 0,
                      period: 360,
                      units: "degrees",
                      requires: ["text-field"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-padding": {
                      type: "number",
                      default: 2,
                      minimum: 0,
                      units: "pixels",
                      requires: ["text-field"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "text-keep-upright": {
                      type: "boolean",
                      default: !0,
                      requires: ["text-field", {
                          "text-rotation-alignment": "map"
                      }, {
                          "symbol-placement": ["line", "line-center"]
                      }],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "text-transform": {
                      type: "enum",
                      values: {
                          none: {},
                          uppercase: {},
                          lowercase: {}
                      },
                      default: "none",
                      requires: ["text-field"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-offset": {
                      type: "array",
                      value: "number",
                      units: "ems",
                      length: 2,
                      default: [0, 0],
                      requires: ["text-field"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-allow-overlap": {
                      type: "boolean",
                      default: !1,
                      requires: ["text-field"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "text-ignore-placement": {
                      type: "boolean",
                      default: !1,
                      requires: ["text-field"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "text-optional": {
                      type: "boolean",
                      default: !1,
                      requires: ["text-field", "icon-image"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  visibility: {
                      type: "enum",
                      values: {
                          visible: {},
                          none: {}
                      },
                      default: "visible",
                      "property-type": "constant"
                  }
              },
              layout_raster: {
                  visibility: {
                      type: "enum",
                      values: {
                          visible: {},
                          none: {}
                      },
                      default: "visible",
                      "property-type": "constant"
                  }
              },
              layout_hillshade: {
                  visibility: {
                      type: "enum",
                      values: {
                          visible: {},
                          none: {}
                      },
                      default: "visible",
                      "property-type": "constant"
                  }
              },
              filter: {
                  type: "array",
                  value: "*"
              },
              filter_operator: {
                  type: "enum",
                  values: {
                      "==": {},
                      "!=": {},
                      ">": {},
                      ">=": {},
                      "<": {},
                      "<=": {},
                      in: {},
                      "!in": {},
                      all: {},
                      any: {},
                      none: {},
                      has: {},
                      "!has": {}
                  }
              },
              geometry_type: {
                  type: "enum",
                  values: {
                      Point: {},
                      LineString: {},
                      Polygon: {}
                  }
              },
              function: {
                  expression: {
                      type: "expression"
                  },
                  stops: {
                      type: "array",
                      value: "function_stop"
                  },
                  base: {
                      type: "number",
                      default: 1,
                      minimum: 0
                  },
                  property: {
                      type: "string",
                      default: "$zoom"
                  },
                  type: {
                      type: "enum",
                      values: {
                          identity: {},
                          exponential: {},
                          interval: {},
                          categorical: {}
                      },
                      default: "exponential"
                  },
                  colorSpace: {
                      type: "enum",
                      values: {
                          rgb: {},
                          lab: {},
                          hcl: {}
                      },
                      default: "rgb"
                  },
                  default: {
                      type: "*",
                      required: !1
                  }
              },
              function_stop: {
                  type: "array",
                  minimum: 0,
                  maximum: 22,
                  value: ["number", "color"],
                  length: 2
              },
              expression: {
                  type: "array",
                  value: "*",
                  minimum: 1
              },
              expression_name: {
                  type: "enum",
                  values: {
                      let: {
                          group: "Variable binding"
                      },
                      var: {
                          group: "Variable binding"
                      },
                      literal: {
                          group: "Types"
                      },
                      array: {
                          group: "Types"
                      },
                      at: {
                          group: "Lookup"
                      },
                      case: {
                          group: "Decision"
                      },
                      match: {
                          group: "Decision"
                      },
                      coalesce: {
                          group: "Decision"
                      },
                      step: {
                          group: "Ramps, scales, curves"
                      },
                      interpolate: {
                          group: "Ramps, scales, curves"
                      },
                      "interpolate-hcl": {
                          group: "Ramps, scales, curves"
                      },
                      "interpolate-lab": {
                          group: "Ramps, scales, curves"
                      },
                      ln2: {
                          group: "Math"
                      },
                      pi: {
                          group: "Math"
                      },
                      e: {
                          group: "Math"
                      },
                      typeof: {
                          group: "Types"
                      },
                      string: {
                          group: "Types"
                      },
                      number: {
                          group: "Types"
                      },
                      boolean: {
                          group: "Types"
                      },
                      object: {
                          group: "Types"
                      },
                      collator: {
                          group: "Types"
                      },
                      format: {
                          group: "Types"
                      },
                      "number-format": {
                          group: "Types"
                      },
                      "to-string": {
                          group: "Types"
                      },
                      "to-number": {
                          group: "Types"
                      },
                      "to-boolean": {
                          group: "Types"
                      },
                      "to-rgba": {
                          group: "Color"
                      },
                      "to-color": {
                          group: "Types"
                      },
                      rgb: {
                          group: "Color"
                      },
                      rgba: {
                          group: "Color"
                      },
                      get: {
                          group: "Lookup"
                      },
                      has: {
                          group: "Lookup"
                      },
                      length: {
                          group: "Lookup"
                      },
                      properties: {
                          group: "Feature data"
                      },
                      "feature-state": {
                          group: "Feature data"
                      },
                      "geometry-type": {
                          group: "Feature data"
                      },
                      id: {
                          group: "Feature data"
                      },
                      zoom: {
                          group: "Zoom"
                      },
                      "heatmap-density": {
                          group: "Heatmap"
                      },
                      "line-progress": {
                          group: "Feature data"
                      },
                      accumulated: {
                          group: "Feature data"
                      },
                      "+": {
                          group: "Math"
                      },
                      "*": {
                          group: "Math"
                      },
                      "-": {
                          group: "Math"
                      },
                      "/": {
                          group: "Math"
                      },
                      "%": {
                          group: "Math"
                      },
                      "^": {
                          group: "Math"
                      },
                      sqrt: {
                          group: "Math"
                      },
                      log10: {
                          group: "Math"
                      },
                      ln: {
                          group: "Math"
                      },
                      log2: {
                          group: "Math"
                      },
                      sin: {
                          group: "Math"
                      },
                      cos: {
                          group: "Math"
                      },
                      tan: {
                          group: "Math"
                      },
                      asin: {
                          group: "Math"
                      },
                      acos: {
                          group: "Math"
                      },
                      atan: {
                          group: "Math"
                      },
                      min: {
                          group: "Math"
                      },
                      max: {
                          group: "Math"
                      },
                      round: {
                          group: "Math"
                      },
                      abs: {
                          group: "Math"
                      },
                      ceil: {
                          group: "Math"
                      },
                      floor: {
                          group: "Math"
                      },
                      "==": {
                          group: "Decision"
                      },
                      "!=": {
                          group: "Decision"
                      },
                      ">": {
                          group: "Decision"
                      },
                      "<": {
                          group: "Decision"
                      },
                      ">=": {
                          group: "Decision"
                      },
                      "<=": {
                          group: "Decision"
                      },
                      all: {
                          group: "Decision"
                      },
                      any: {
                          group: "Decision"
                      },
                      "!": {
                          group: "Decision"
                      },
                      "is-supported-script": {
                          group: "String"
                      },
                      upcase: {
                          group: "String"
                      },
                      downcase: {
                          group: "String"
                      },
                      concat: {
                          group: "String"
                      },
                      "resolved-locale": {
                          group: "String"
                      }
                  }
              },
              light: {
                  anchor: {
                      type: "enum",
                      default: "viewport",
                      values: {
                          map: {},
                          viewport: {}
                      },
                      "property-type": "data-constant",
                      transition: !1,
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      }
                  },
                  position: {
                      type: "array",
                      default: [1.15, 210, 30],
                      length: 3,
                      value: "number",
                      "property-type": "data-constant",
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      }
                  },
                  color: {
                      type: "color",
                      "property-type": "data-constant",
                      default: "#ffffff",
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      transition: !0
                  },
                  intensity: {
                      type: "number",
                      "property-type": "data-constant",
                      default: .5,
                      minimum: 0,
                      maximum: 1,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      transition: !0
                  }
              },
              paint: ["paint_fill", "paint_line", "paint_circle", "paint_heatmap", "paint_fill-extrusion", "paint_symbol", "paint_raster", "paint_hillshade", "paint_background"],
              paint_fill: {
                  "fill-antialias": {
                      type: "boolean",
                      default: !0,
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "fill-opacity": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      maximum: 1,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "fill-color": {
                      type: "color",
                      default: "#000000",
                      transition: !0,
                      requires: [{
                          "!": "fill-pattern"
                      }],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "fill-outline-color": {
                      type: "color",
                      transition: !0,
                      requires: [{
                          "!": "fill-pattern"
                      }, {
                          "fill-antialias": !0
                      }],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "fill-translate": {
                      type: "array",
                      value: "number",
                      length: 2,
                      default: [0, 0],
                      transition: !0,
                      units: "pixels",
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "fill-translate-anchor": {
                      type: "enum",
                      values: {
                          map: {},
                          viewport: {}
                      },
                      default: "map",
                      requires: ["fill-translate"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "fill-pattern": {
                      type: "string",
                      transition: !0,
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "cross-faded-data-driven"
                  }
              },
              "paint_fill-extrusion": {
                  "fill-extrusion-opacity": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      maximum: 1,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "fill-extrusion-color": {
                      type: "color",
                      default: "#000000",
                      transition: !0,
                      requires: [{
                          "!": "fill-extrusion-pattern"
                      }],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "fill-extrusion-translate": {
                      type: "array",
                      value: "number",
                      length: 2,
                      default: [0, 0],
                      transition: !0,
                      units: "pixels",
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "fill-extrusion-translate-anchor": {
                      type: "enum",
                      values: {
                          map: {},
                          viewport: {}
                      },
                      default: "map",
                      requires: ["fill-extrusion-translate"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "fill-extrusion-pattern": {
                      type: "string",
                      transition: !0,
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "cross-faded-data-driven"
                  },
                  "fill-extrusion-height": {
                      type: "number",
                      default: 0,
                      minimum: 0,
                      units: "meters",
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "fill-extrusion-base": {
                      type: "number",
                      default: 0,
                      minimum: 0,
                      units: "meters",
                      transition: !0,
                      requires: ["fill-extrusion-height"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "fill-extrusion-vertical-gradient": {
                      type: "boolean",
                      default: !0,
                      transition: !1,
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  }
              },
              paint_line: {
                  "line-opacity": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      maximum: 1,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "line-color": {
                      type: "color",
                      default: "#000000",
                      transition: !0,
                      requires: [{
                          "!": "line-pattern"
                      }],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "line-translate": {
                      type: "array",
                      value: "number",
                      length: 2,
                      default: [0, 0],
                      transition: !0,
                      units: "pixels",
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "line-translate-anchor": {
                      type: "enum",
                      values: {
                          map: {},
                          viewport: {}
                      },
                      default: "map",
                      requires: ["line-translate"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "line-width": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      transition: !0,
                      units: "pixels",
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "line-gap-width": {
                      type: "number",
                      default: 0,
                      minimum: 0,
                      transition: !0,
                      units: "pixels",
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "line-offset": {
                      type: "number",
                      default: 0,
                      transition: !0,
                      units: "pixels",
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "line-blur": {
                      type: "number",
                      default: 0,
                      minimum: 0,
                      transition: !0,
                      units: "pixels",
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "line-dasharray": {
                      type: "array",
                      value: "number",
                      minimum: 0,
                      transition: !0,
                      units: "line widths",
                      requires: [{
                          "!": "line-pattern"
                      }],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "cross-faded"
                  },
                  "line-pattern": {
                      type: "string",
                      transition: !0,
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom", "feature"]
                      },
                      "property-type": "cross-faded-data-driven"
                  },
                  "line-gradient": {
                      type: "color",
                      transition: !1,
                      requires: [{
                          "!": "line-dasharray"
                      }, {
                          "!": "line-pattern"
                      }, {
                          source: "geojson",
                          has: {
                              lineMetrics: !0
                          }
                      }],
                      expression: {
                          interpolated: !0,
                          parameters: ["line-progress"]
                      },
                      "property-type": "color-ramp"
                  }
              },
              paint_circle: {
                  "circle-radius": {
                      type: "number",
                      default: 5,
                      minimum: 0,
                      transition: !0,
                      units: "pixels",
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "circle-color": {
                      type: "color",
                      default: "#000000",
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "circle-blur": {
                      type: "number",
                      default: 0,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "circle-opacity": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      maximum: 1,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "circle-translate": {
                      type: "array",
                      value: "number",
                      length: 2,
                      default: [0, 0],
                      transition: !0,
                      units: "pixels",
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "circle-translate-anchor": {
                      type: "enum",
                      values: {
                          map: {},
                          viewport: {}
                      },
                      default: "map",
                      requires: ["circle-translate"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "circle-pitch-scale": {
                      type: "enum",
                      values: {
                          map: {},
                          viewport: {}
                      },
                      default: "map",
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "circle-pitch-alignment": {
                      type: "enum",
                      values: {
                          map: {},
                          viewport: {}
                      },
                      default: "viewport",
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "circle-stroke-width": {
                      type: "number",
                      default: 0,
                      minimum: 0,
                      transition: !0,
                      units: "pixels",
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "circle-stroke-color": {
                      type: "color",
                      default: "#000000",
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "circle-stroke-opacity": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      maximum: 1,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  }
              },
              paint_heatmap: {
                  "heatmap-radius": {
                      type: "number",
                      default: 30,
                      minimum: 1,
                      transition: !0,
                      units: "pixels",
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "heatmap-weight": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      transition: !1,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "heatmap-intensity": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "heatmap-color": {
                      type: "color",
                      default: ["interpolate", ["linear"], ["heatmap-density"], 0, "rgba(0, 0, 255, 0)", .1, "royalblue", .3, "cyan", .5, "lime", .7, "yellow", 1, "red"],
                      transition: !1,
                      expression: {
                          interpolated: !0,
                          parameters: ["heatmap-density"]
                      },
                      "property-type": "color-ramp"
                  },
                  "heatmap-opacity": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      maximum: 1,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  }
              },
              paint_symbol: {
                  "icon-opacity": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      maximum: 1,
                      transition: !0,
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "icon-color": {
                      type: "color",
                      default: "#000000",
                      transition: !0,
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "icon-halo-color": {
                      type: "color",
                      default: "rgba(0, 0, 0, 0)",
                      transition: !0,
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "icon-halo-width": {
                      type: "number",
                      default: 0,
                      minimum: 0,
                      transition: !0,
                      units: "pixels",
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "icon-halo-blur": {
                      type: "number",
                      default: 0,
                      minimum: 0,
                      transition: !0,
                      units: "pixels",
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "icon-translate": {
                      type: "array",
                      value: "number",
                      length: 2,
                      default: [0, 0],
                      transition: !0,
                      units: "pixels",
                      requires: ["icon-image"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "icon-translate-anchor": {
                      type: "enum",
                      values: {
                          map: {},
                          viewport: {}
                      },
                      default: "map",
                      requires: ["icon-image", "icon-translate"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "text-opacity": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      maximum: 1,
                      transition: !0,
                      requires: ["text-field"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-color": {
                      type: "color",
                      default: "#000000",
                      transition: !0,
                      requires: ["text-field"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-halo-color": {
                      type: "color",
                      default: "rgba(0, 0, 0, 0)",
                      transition: !0,
                      requires: ["text-field"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-halo-width": {
                      type: "number",
                      default: 0,
                      minimum: 0,
                      transition: !0,
                      units: "pixels",
                      requires: ["text-field"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-halo-blur": {
                      type: "number",
                      default: 0,
                      minimum: 0,
                      transition: !0,
                      units: "pixels",
                      requires: ["text-field"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom", "feature", "feature-state"]
                      },
                      "property-type": "data-driven"
                  },
                  "text-translate": {
                      type: "array",
                      value: "number",
                      length: 2,
                      default: [0, 0],
                      transition: !0,
                      units: "pixels",
                      requires: ["text-field"],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "text-translate-anchor": {
                      type: "enum",
                      values: {
                          map: {},
                          viewport: {}
                      },
                      default: "map",
                      requires: ["text-field", "text-translate"],
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  }
              },
              paint_raster: {
                  "raster-opacity": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      maximum: 1,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "raster-hue-rotate": {
                      type: "number",
                      default: 0,
                      period: 360,
                      transition: !0,
                      units: "degrees",
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "raster-brightness-min": {
                      type: "number",
                      default: 0,
                      minimum: 0,
                      maximum: 1,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "raster-brightness-max": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      maximum: 1,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "raster-saturation": {
                      type: "number",
                      default: 0,
                      minimum: -1,
                      maximum: 1,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "raster-contrast": {
                      type: "number",
                      default: 0,
                      minimum: -1,
                      maximum: 1,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "raster-resampling": {
                      type: "enum",
                      values: {
                          linear: {},
                          nearest: {}
                      },
                      default: "linear",
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "raster-fade-duration": {
                      type: "number",
                      default: 300,
                      minimum: 0,
                      transition: !1,
                      units: "milliseconds",
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  }
              },
              paint_hillshade: {
                  "hillshade-illumination-direction": {
                      type: "number",
                      default: 335,
                      minimum: 0,
                      maximum: 359,
                      transition: !1,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "hillshade-illumination-anchor": {
                      type: "enum",
                      values: {
                          map: {},
                          viewport: {}
                      },
                      default: "viewport",
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "hillshade-exaggeration": {
                      type: "number",
                      default: .5,
                      minimum: 0,
                      maximum: 1,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "hillshade-shadow-color": {
                      type: "color",
                      default: "#000000",
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "hillshade-highlight-color": {
                      type: "color",
                      default: "#FFFFFF",
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "hillshade-accent-color": {
                      type: "color",
                      default: "#000000",
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  }
              },
              paint_background: {
                  "background-color": {
                      type: "color",
                      default: "#000000",
                      transition: !0,
                      requires: [{
                          "!": "background-pattern"
                      }],
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  },
                  "background-pattern": {
                      type: "string",
                      transition: !0,
                      expression: {
                          interpolated: !1,
                          parameters: ["zoom"]
                      },
                      "property-type": "cross-faded"
                  },
                  "background-opacity": {
                      type: "number",
                      default: 1,
                      minimum: 0,
                      maximum: 1,
                      transition: !0,
                      expression: {
                          interpolated: !0,
                          parameters: ["zoom"]
                      },
                      "property-type": "data-constant"
                  }
              },
              transition: {
                  duration: {
                      type: "number",
                      default: 300,
                      minimum: 0,
                      units: "milliseconds"
                  },
                  delay: {
                      type: "number",
                      default: 0,
                      minimum: 0,
                      units: "milliseconds"
                  }
              },
              "property-type": {
                  "data-driven": {
                      type: "property-type"
                  },
                  "cross-faded": {
                      type: "property-type"
                  },
                  "cross-faded-data-driven": {
                      type: "property-type"
                  },
                  "color-ramp": {
                      type: "property-type"
                  },
                  "data-constant": {
                      type: "property-type"
                  },
                  constant: {
                      type: "property-type"
                  }
              }
          }
            , ve = function(e, t, i, n) {
              this.message = (e ? e + ": " : "") + i,
              n && (this.identifier = n),
              null != t && t.__line__ && (this.line = t.__line__)
          };
          function ye(e) {
              var t = e.key
                , i = e.value;
              return i ? [new ve(t,i,"constants have been deprecated as of v8")] : []
          }
          function _e(e) {
              for (var t = [], i = arguments.length - 1; i-- > 0; )
                  t[i] = arguments[i + 1];
              for (var n = 0, r = t; n < r.length; n += 1) {
                  var o = r[n];
                  for (var s in o)
                      e[s] = o[s]
              }
              return e
          }
          function be(e) {
              return e instanceof Number || e instanceof String || e instanceof Boolean ? e.valueOf() : e
          }
          function we(e) {
              return Array.isArray(e) ? e.map(we) : be(e)
          }
          var xe = function(e) {
              function t(t, i) {
                  e.call(this, i),
                  this.message = i,
                  this.key = t
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t
          }(Error)
            , ke = function(e, t) {
              void 0 === t && (t = []),
              this.parent = e,
              this.bindings = {};
              for (var i = 0, n = t; i < n.length; i += 1) {
                  var r = n[i]
                    , o = r[0]
                    , s = r[1];
                  this.bindings[o] = s
              }
          };
          ke.prototype.concat = function(e) {
              return new ke(this,e)
          }
          ,
          ke.prototype.get = function(e) {
              if (this.bindings[e])
                  return this.bindings[e];
              if (this.parent)
                  return this.parent.get(e);
              throw new Error(e + " not found in scope.")
          }
          ,
          ke.prototype.has = function(e) {
              return !!this.bindings[e] || !!this.parent && this.parent.has(e)
          }
          ;
          var Se = {
              kind: "null"
          }
            , Ee = {
              kind: "number"
          }
            , Te = {
              kind: "string"
          }
            , Ce = {
              kind: "boolean"
          }
            , Le = {
              kind: "color"
          }
            , Ae = {
              kind: "object"
          }
            , Pe = {
              kind: "value"
          }
            , Ie = {
              kind: "collator"
          }
            , Me = {
              kind: "formatted"
          };
          function Oe(e, t) {
              return {
                  kind: "array",
                  itemType: e,
                  N: t
              }
          }
          function ze(e) {
              if ("array" === e.kind) {
                  var t = ze(e.itemType);
                  return "number" == typeof e.N ? "array<" + t + ", " + e.N + ">" : "value" === e.itemType.kind ? "array" : "array<" + t + ">"
              }
              return e.kind
          }
          var De = [Se, Ee, Te, Ce, Le, Me, Ae, Oe(Pe)];
          function Re(e, t) {
              if ("error" === t.kind)
                  return null;
              if ("array" === e.kind) {
                  if ("array" === t.kind && (0 === t.N && "value" === t.itemType.kind || !Re(e.itemType, t.itemType)) && ("number" != typeof e.N || e.N === t.N))
                      return null
              } else {
                  if (e.kind === t.kind)
                      return null;
                  if ("value" === e.kind)
                      for (var i = 0, n = De; i < n.length; i += 1)
                          if (!Re(n[i], t))
                              return null
              }
              return "Expected " + ze(e) + " but found " + ze(t) + " instead."
          }
          var Be = t(function(e, t) {
              var i = {
                  transparent: [0, 0, 0, 0],
                  aliceblue: [240, 248, 255, 1],
                  antiquewhite: [250, 235, 215, 1],
                  aqua: [0, 255, 255, 1],
                  aquamarine: [127, 255, 212, 1],
                  azure: [240, 255, 255, 1],
                  beige: [245, 245, 220, 1],
                  bisque: [255, 228, 196, 1],
                  black: [0, 0, 0, 1],
                  blanchedalmond: [255, 235, 205, 1],
                  blue: [0, 0, 255, 1],
                  blueviolet: [138, 43, 226, 1],
                  brown: [165, 42, 42, 1],
                  burlywood: [222, 184, 135, 1],
                  cadetblue: [95, 158, 160, 1],
                  chartreuse: [127, 255, 0, 1],
                  chocolate: [210, 105, 30, 1],
                  coral: [255, 127, 80, 1],
                  cornflowerblue: [100, 149, 237, 1],
                  cornsilk: [255, 248, 220, 1],
                  crimson: [220, 20, 60, 1],
                  cyan: [0, 255, 255, 1],
                  darkblue: [0, 0, 139, 1],
                  darkcyan: [0, 139, 139, 1],
                  darkgoldenrod: [184, 134, 11, 1],
                  darkgray: [169, 169, 169, 1],
                  darkgreen: [0, 100, 0, 1],
                  darkgrey: [169, 169, 169, 1],
                  darkkhaki: [189, 183, 107, 1],
                  darkmagenta: [139, 0, 139, 1],
                  darkolivegreen: [85, 107, 47, 1],
                  darkorange: [255, 140, 0, 1],
                  darkorchid: [153, 50, 204, 1],
                  darkred: [139, 0, 0, 1],
                  darksalmon: [233, 150, 122, 1],
                  darkseagreen: [143, 188, 143, 1],
                  darkslateblue: [72, 61, 139, 1],
                  darkslategray: [47, 79, 79, 1],
                  darkslategrey: [47, 79, 79, 1],
                  darkturquoise: [0, 206, 209, 1],
                  darkviolet: [148, 0, 211, 1],
                  deeppink: [255, 20, 147, 1],
                  deepskyblue: [0, 191, 255, 1],
                  dimgray: [105, 105, 105, 1],
                  dimgrey: [105, 105, 105, 1],
                  dodgerblue: [30, 144, 255, 1],
                  firebrick: [178, 34, 34, 1],
                  floralwhite: [255, 250, 240, 1],
                  forestgreen: [34, 139, 34, 1],
                  fuchsia: [255, 0, 255, 1],
                  gainsboro: [220, 220, 220, 1],
                  ghostwhite: [248, 248, 255, 1],
                  gold: [255, 215, 0, 1],
                  goldenrod: [218, 165, 32, 1],
                  gray: [128, 128, 128, 1],
                  green: [0, 128, 0, 1],
                  greenyellow: [173, 255, 47, 1],
                  grey: [128, 128, 128, 1],
                  honeydew: [240, 255, 240, 1],
                  hotpink: [255, 105, 180, 1],
                  indianred: [205, 92, 92, 1],
                  indigo: [75, 0, 130, 1],
                  ivory: [255, 255, 240, 1],
                  khaki: [240, 230, 140, 1],
                  lavender: [230, 230, 250, 1],
                  lavenderblush: [255, 240, 245, 1],
                  lawngreen: [124, 252, 0, 1],
                  lemonchiffon: [255, 250, 205, 1],
                  lightblue: [173, 216, 230, 1],
                  lightcoral: [240, 128, 128, 1],
                  lightcyan: [224, 255, 255, 1],
                  lightgoldenrodyellow: [250, 250, 210, 1],
                  lightgray: [211, 211, 211, 1],
                  lightgreen: [144, 238, 144, 1],
                  lightgrey: [211, 211, 211, 1],
                  lightpink: [255, 182, 193, 1],
                  lightsalmon: [255, 160, 122, 1],
                  lightseagreen: [32, 178, 170, 1],
                  lightskyblue: [135, 206, 250, 1],
                  lightslategray: [119, 136, 153, 1],
                  lightslategrey: [119, 136, 153, 1],
                  lightsteelblue: [176, 196, 222, 1],
                  lightyellow: [255, 255, 224, 1],
                  lime: [0, 255, 0, 1],
                  limegreen: [50, 205, 50, 1],
                  linen: [250, 240, 230, 1],
                  magenta: [255, 0, 255, 1],
                  maroon: [128, 0, 0, 1],
                  mediumaquamarine: [102, 205, 170, 1],
                  mediumblue: [0, 0, 205, 1],
                  mediumorchid: [186, 85, 211, 1],
                  mediumpurple: [147, 112, 219, 1],
                  mediumseagreen: [60, 179, 113, 1],
                  mediumslateblue: [123, 104, 238, 1],
                  mediumspringgreen: [0, 250, 154, 1],
                  mediumturquoise: [72, 209, 204, 1],
                  mediumvioletred: [199, 21, 133, 1],
                  midnightblue: [25, 25, 112, 1],
                  mintcream: [245, 255, 250, 1],
                  mistyrose: [255, 228, 225, 1],
                  moccasin: [255, 228, 181, 1],
                  navajowhite: [255, 222, 173, 1],
                  navy: [0, 0, 128, 1],
                  oldlace: [253, 245, 230, 1],
                  olive: [128, 128, 0, 1],
                  olivedrab: [107, 142, 35, 1],
                  orange: [255, 165, 0, 1],
                  orangered: [255, 69, 0, 1],
                  orchid: [218, 112, 214, 1],
                  palegoldenrod: [238, 232, 170, 1],
                  palegreen: [152, 251, 152, 1],
                  paleturquoise: [175, 238, 238, 1],
                  palevioletred: [219, 112, 147, 1],
                  papayawhip: [255, 239, 213, 1],
                  peachpuff: [255, 218, 185, 1],
                  peru: [205, 133, 63, 1],
                  pink: [255, 192, 203, 1],
                  plum: [221, 160, 221, 1],
                  powderblue: [176, 224, 230, 1],
                  purple: [128, 0, 128, 1],
                  rebeccapurple: [102, 51, 153, 1],
                  red: [255, 0, 0, 1],
                  rosybrown: [188, 143, 143, 1],
                  royalblue: [65, 105, 225, 1],
                  saddlebrown: [139, 69, 19, 1],
                  salmon: [250, 128, 114, 1],
                  sandybrown: [244, 164, 96, 1],
                  seagreen: [46, 139, 87, 1],
                  seashell: [255, 245, 238, 1],
                  sienna: [160, 82, 45, 1],
                  silver: [192, 192, 192, 1],
                  skyblue: [135, 206, 235, 1],
                  slateblue: [106, 90, 205, 1],
                  slategray: [112, 128, 144, 1],
                  slategrey: [112, 128, 144, 1],
                  snow: [255, 250, 250, 1],
                  springgreen: [0, 255, 127, 1],
                  steelblue: [70, 130, 180, 1],
                  tan: [210, 180, 140, 1],
                  teal: [0, 128, 128, 1],
                  thistle: [216, 191, 216, 1],
                  tomato: [255, 99, 71, 1],
                  turquoise: [64, 224, 208, 1],
                  violet: [238, 130, 238, 1],
                  wheat: [245, 222, 179, 1],
                  white: [255, 255, 255, 1],
                  whitesmoke: [245, 245, 245, 1],
                  yellow: [255, 255, 0, 1],
                  yellowgreen: [154, 205, 50, 1]
              };
              function n(e) {
                  return (e = Math.round(e)) < 0 ? 0 : e > 255 ? 255 : e
              }
              function r(e) {
                  return e < 0 ? 0 : e > 1 ? 1 : e
              }
              function o(e) {
                  return "%" === e[e.length - 1] ? n(parseFloat(e) / 100 * 255) : n(parseInt(e))
              }
              function s(e) {
                  return "%" === e[e.length - 1] ? r(parseFloat(e) / 100) : r(parseFloat(e))
              }
              function a(e, t, i) {
                  return i < 0 ? i += 1 : i > 1 && (i -= 1),
                  6 * i < 1 ? e + (t - e) * i * 6 : 2 * i < 1 ? t : 3 * i < 2 ? e + (t - e) * (2 / 3 - i) * 6 : e
              }
              try {
                  t.parseCSSColor = function(e) {
                      var t, r = e.replace(/ /g, "").toLowerCase();
                      if (r in i)
                          return i[r].slice();
                      if ("#" === r[0])
                          return 4 === r.length ? (t = parseInt(r.substr(1), 16)) >= 0 && t <= 4095 ? [(3840 & t) >> 4 | (3840 & t) >> 8, 240 & t | (240 & t) >> 4, 15 & t | (15 & t) << 4, 1] : null : 7 === r.length && (t = parseInt(r.substr(1), 16)) >= 0 && t <= 16777215 ? [(16711680 & t) >> 16, (65280 & t) >> 8, 255 & t, 1] : null;
                      var l = r.indexOf("(")
                        , c = r.indexOf(")");
                      if (-1 !== l && c + 1 === r.length) {
                          var u = r.substr(0, l)
                            , h = r.substr(l + 1, c - (l + 1)).split(",")
                            , d = 1;
                          switch (u) {
                          case "rgba":
                              if (4 !== h.length)
                                  return null;
                              d = s(h.pop());
                          case "rgb":
                              return 3 !== h.length ? null : [o(h[0]), o(h[1]), o(h[2]), d];
                          case "hsla":
                              if (4 !== h.length)
                                  return null;
                              d = s(h.pop());
                          case "hsl":
                              if (3 !== h.length)
                                  return null;
                              var p = (parseFloat(h[0]) % 360 + 360) % 360 / 360
                                , f = s(h[1])
                                , m = s(h[2])
                                , g = m <= .5 ? m * (f + 1) : m + f - m * f
                                , v = 2 * m - g;
                              return [n(255 * a(v, g, p + 1 / 3)), n(255 * a(v, g, p)), n(255 * a(v, g, p - 1 / 3)), d];
                          default:
                              return null
                          }
                      }
                      return null
                  }
              } catch (e) {}
          }).parseCSSColor
            , je = function(e, t, i, n) {
              void 0 === n && (n = 1),
              this.r = e,
              this.g = t,
              this.b = i,
              this.a = n
          };
          je.parse = function(e) {
              if (e) {
                  if (e instanceof je)
                      return e;
                  if ("string" == typeof e) {
                      var t = Be(e);
                      if (t)
                          return new je(t[0] / 255 * t[3],t[1] / 255 * t[3],t[2] / 255 * t[3],t[3])
                  }
              }
          }
          ,
          je.prototype.toString = function() {
              var e = this.toArray()
                , t = e[0]
                , i = e[1]
                , n = e[2]
                , r = e[3];
              return "rgba(" + Math.round(t) + "," + Math.round(i) + "," + Math.round(n) + "," + r + ")"
          }
          ,
          je.prototype.toArray = function() {
              var e = this.r
                , t = this.g
                , i = this.b
                , n = this.a;
              return 0 === n ? [0, 0, 0, 0] : [255 * e / n, 255 * t / n, 255 * i / n, n]
          }
          ,
          je.black = new je(0,0,0,1),
          je.white = new je(1,1,1,1),
          je.transparent = new je(0,0,0,0),
          je.red = new je(1,0,0,1);
          var Fe = function(e, t, i) {
              this.sensitivity = e ? t ? "variant" : "case" : t ? "accent" : "base",
              this.locale = i,
              this.collator = new Intl.Collator(this.locale ? this.locale : [],{
                  sensitivity: this.sensitivity,
                  usage: "search"
              })
          };
          Fe.prototype.compare = function(e, t) {
              return this.collator.compare(e, t)
          }
          ,
          Fe.prototype.resolvedLocale = function() {
              return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale
          }
          ;
          var Ne = function(e, t, i) {
              this.text = e,
              this.scale = t,
              this.fontStack = i
          }
            , Ue = function(e) {
              this.sections = e
          };
          function qe(e, t, i, n) {
              return "number" == typeof e && e >= 0 && e <= 255 && "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof i && i >= 0 && i <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : "Invalid rgba value [" + [e, t, i, n].join(", ") + "]: 'a' must be between 0 and 1." : "Invalid rgba value [" + ("number" == typeof n ? [e, t, i, n] : [e, t, i]).join(", ") + "]: 'r', 'g', and 'b' must be between 0 and 255."
          }
          function He(e) {
              if (null === e)
                  return Se;
              if ("string" == typeof e)
                  return Te;
              if ("boolean" == typeof e)
                  return Ce;
              if ("number" == typeof e)
                  return Ee;
              if (e instanceof je)
                  return Le;
              if (e instanceof Fe)
                  return Ie;
              if (e instanceof Ue)
                  return Me;
              if (Array.isArray(e)) {
                  for (var t, i = e.length, n = 0, r = e; n < r.length; n += 1) {
                      var o = He(r[n]);
                      if (t) {
                          if (t === o)
                              continue;
                          t = Pe;
                          break
                      }
                      t = o
                  }
                  return Oe(t || Pe, i)
              }
              return Ae
          }
          function Ve(e) {
              var t = typeof e;
              return null === e ? "" : "string" === t || "number" === t || "boolean" === t ? String(e) : e instanceof je || e instanceof Ue ? e.toString() : JSON.stringify(e)
          }
          Ue.fromString = function(e) {
              return new Ue([new Ne(e,null,null)])
          }
          ,
          Ue.prototype.toString = function() {
              return this.sections.map(function(e) {
                  return e.text
              }).join("")
          }
          ,
          Ue.prototype.serialize = function() {
              for (var e = ["format"], t = 0, i = this.sections; t < i.length; t += 1) {
                  var n = i[t];
                  e.push(n.text);
                  var r = {};
                  n.fontStack && (r["text-font"] = ["literal", n.fontStack.split(",")]),
                  n.scale && (r["font-scale"] = n.scale),
                  e.push(r)
              }
              return e
          }
          ;
          var We = function(e, t) {
              this.type = e,
              this.value = t
          };
          We.parse = function(e, t) {
              if (2 !== e.length)
                  return t.error("'literal' expression requires exactly one argument, but found " + (e.length - 1) + " instead.");
              if (!function e(t) {
                  if (null === t)
                      return !0;
                  if ("string" == typeof t)
                      return !0;
                  if ("boolean" == typeof t)
                      return !0;
                  if ("number" == typeof t)
                      return !0;
                  if (t instanceof je)
                      return !0;
                  if (t instanceof Fe)
                      return !0;
                  if (t instanceof Ue)
                      return !0;
                  if (Array.isArray(t)) {
                      for (var i = 0, n = t; i < n.length; i += 1)
                          if (!e(n[i]))
                              return !1;
                      return !0
                  }
                  if ("object" == typeof t) {
                      for (var r in t)
                          if (!e(t[r]))
                              return !1;
                      return !0
                  }
                  return !1
              }(e[1]))
                  return t.error("invalid value");
              var i = e[1]
                , n = He(i)
                , r = t.expectedType;
              return "array" !== n.kind || 0 !== n.N || !r || "array" !== r.kind || "number" == typeof r.N && 0 !== r.N || (n = r),
              new We(n,i)
          }
          ,
          We.prototype.evaluate = function() {
              return this.value
          }
          ,
          We.prototype.eachChild = function() {}
          ,
          We.prototype.possibleOutputs = function() {
              return [this.value]
          }
          ,
          We.prototype.serialize = function() {
              return "array" === this.type.kind || "object" === this.type.kind ? ["literal", this.value] : this.value instanceof je ? ["rgba"].concat(this.value.toArray()) : this.value instanceof Ue ? this.value.serialize() : this.value
          }
          ;
          var $e = function(e) {
              this.name = "ExpressionEvaluationError",
              this.message = e
          };
          $e.prototype.toJSON = function() {
              return this.message
          }
          ;
          var Ge = {
              string: Te,
              number: Ee,
              boolean: Ce,
              object: Ae
          }
            , Xe = function(e, t) {
              this.type = e,
              this.args = t
          };
          Xe.parse = function(e, t) {
              if (e.length < 2)
                  return t.error("Expected at least one argument.");
              var i, n = 1, r = e[0];
              if ("array" === r) {
                  var o, s;
                  if (e.length > 2) {
                      var a = e[1];
                      if ("string" != typeof a || !(a in Ge) || "object" === a)
                          return t.error('The item type argument of "array" must be one of string, number, boolean', 1);
                      o = Ge[a],
                      n++
                  } else
                      o = Pe;
                  if (e.length > 3) {
                      if (null !== e[2] && ("number" != typeof e[2] || e[2] < 0 || e[2] !== Math.floor(e[2])))
                          return t.error('The length argument to "array" must be a positive integer literal', 2);
                      s = e[2],
                      n++
                  }
                  i = Oe(o, s)
              } else
                  i = Ge[r];
              for (var l = []; n < e.length; n++) {
                  var c = t.parse(e[n], n, Pe);
                  if (!c)
                      return null;
                  l.push(c)
              }
              return new Xe(i,l)
          }
          ,
          Xe.prototype.evaluate = function(e) {
              for (var t = 0; t < this.args.length; t++) {
                  var i = this.args[t].evaluate(e);
                  if (!Re(this.type, He(i)))
                      return i;
                  if (t === this.args.length - 1)
                      throw new $e("Expected value to be of type " + ze(this.type) + ", but found " + ze(He(i)) + " instead.")
              }
              return null
          }
          ,
          Xe.prototype.eachChild = function(e) {
              this.args.forEach(e)
          }
          ,
          Xe.prototype.possibleOutputs = function() {
              var e;
              return (e = []).concat.apply(e, this.args.map(function(e) {
                  return e.possibleOutputs()
              }))
          }
          ,
          Xe.prototype.serialize = function() {
              var e = this.type
                , t = [e.kind];
              if ("array" === e.kind) {
                  var i = e.itemType;
                  if ("string" === i.kind || "number" === i.kind || "boolean" === i.kind) {
                      t.push(i.kind);
                      var n = e.N;
                      ("number" == typeof n || this.args.length > 1) && t.push(n)
                  }
              }
              return t.concat(this.args.map(function(e) {
                  return e.serialize()
              }))
          }
          ;
          var Ze = function(e) {
              this.type = Me,
              this.sections = e
          };
          Ze.parse = function(e, t) {
              if (e.length < 3)
                  return t.error("Expected at least two arguments.");
              if ((e.length - 1) % 2 != 0)
                  return t.error("Expected an even number of arguments.");
              for (var i = [], n = 1; n < e.length - 1; n += 2) {
                  var r = t.parse(e[n], 1, Pe);
                  if (!r)
                      return null;
                  var o = r.type.kind;
                  if ("string" !== o && "value" !== o && "null" !== o)
                      return t.error("Formatted text type must be 'string', 'value', or 'null'.");
                  var s = e[n + 1];
                  if ("object" != typeof s || Array.isArray(s))
                      return t.error("Format options argument must be an object.");
                  var a = null;
                  if (s["font-scale"] && !(a = t.parse(s["font-scale"], 1, Ee)))
                      return null;
                  var l = null;
                  if (s["text-font"] && !(l = t.parse(s["text-font"], 1, Oe(Te))))
                      return null;
                  i.push({
                      text: r,
                      scale: a,
                      font: l
                  })
              }
              return new Ze(i)
          }
          ,
          Ze.prototype.evaluate = function(e) {
              return new Ue(this.sections.map(function(t) {
                  return new Ne(Ve(t.text.evaluate(e)),t.scale ? t.scale.evaluate(e) : null,t.font ? t.font.evaluate(e).join(",") : null)
              }))
          }
          ,
          Ze.prototype.eachChild = function(e) {
              for (var t = 0, i = this.sections; t < i.length; t += 1) {
                  var n = i[t];
                  e(n.text),
                  n.scale && e(n.scale),
                  n.font && e(n.font)
              }
          }
          ,
          Ze.prototype.possibleOutputs = function() {
              return [void 0]
          }
          ,
          Ze.prototype.serialize = function() {
              for (var e = ["format"], t = 0, i = this.sections; t < i.length; t += 1) {
                  var n = i[t];
                  e.push(n.text.serialize());
                  var r = {};
                  n.scale && (r["font-scale"] = n.scale.serialize()),
                  n.font && (r["text-font"] = n.font.serialize()),
                  e.push(r)
              }
              return e
          }
          ;
          var Ye = {
              "to-boolean": Ce,
              "to-color": Le,
              "to-number": Ee,
              "to-string": Te
          }
            , Ke = function(e, t) {
              this.type = e,
              this.args = t
          };
          Ke.parse = function(e, t) {
              if (e.length < 2)
                  return t.error("Expected at least one argument.");
              var i = e[0];
              if (("to-boolean" === i || "to-string" === i) && 2 !== e.length)
                  return t.error("Expected one argument.");
              for (var n = Ye[i], r = [], o = 1; o < e.length; o++) {
                  var s = t.parse(e[o], o, Pe);
                  if (!s)
                      return null;
                  r.push(s)
              }
              return new Ke(n,r)
          }
          ,
          Ke.prototype.evaluate = function(e) {
              if ("boolean" === this.type.kind)
                  return Boolean(this.args[0].evaluate(e));
              if ("color" === this.type.kind) {
                  for (var t, i, n = 0, r = this.args; n < r.length; n += 1) {
                      if (i = null,
                      (t = r[n].evaluate(e))instanceof je)
                          return t;
                      if ("string" == typeof t) {
                          var o = e.parseColor(t);
                          if (o)
                              return o
                      } else if (Array.isArray(t) && !(i = t.length < 3 || t.length > 4 ? "Invalid rbga value " + JSON.stringify(t) + ": expected an array containing either three or four numeric values." : qe(t[0], t[1], t[2], t[3])))
                          return new je(t[0] / 255,t[1] / 255,t[2] / 255,t[3])
                  }
                  throw new $e(i || "Could not parse color from value '" + ("string" == typeof t ? t : JSON.stringify(t)) + "'")
              }
              if ("number" === this.type.kind) {
                  for (var s = null, a = 0, l = this.args; a < l.length; a += 1) {
                      if (null === (s = l[a].evaluate(e)))
                          return 0;
                      var c = Number(s);
                      if (!isNaN(c))
                          return c
                  }
                  throw new $e("Could not convert " + JSON.stringify(s) + " to number.")
              }
              return "formatted" === this.type.kind ? Ue.fromString(Ve(this.args[0].evaluate(e))) : Ve(this.args[0].evaluate(e))
          }
          ,
          Ke.prototype.eachChild = function(e) {
              this.args.forEach(e)
          }
          ,
          Ke.prototype.possibleOutputs = function() {
              var e;
              return (e = []).concat.apply(e, this.args.map(function(e) {
                  return e.possibleOutputs()
              }))
          }
          ,
          Ke.prototype.serialize = function() {
              if ("formatted" === this.type.kind)
                  return new Ze([{
                      text: this.args[0],
                      scale: null,
                      font: null
                  }]).serialize();
              var e = ["to-" + this.type.kind];
              return this.eachChild(function(t) {
                  e.push(t.serialize())
              }),
              e
          }
          ;
          var Je = ["Unknown", "Point", "LineString", "Polygon"]
            , Qe = function() {
              this.globals = null,
              this.feature = null,
              this.featureState = null,
              this._parseColorCache = {}
          };
          Qe.prototype.id = function() {
              return this.feature && "id"in this.feature ? this.feature.id : null
          }
          ,
          Qe.prototype.geometryType = function() {
              return this.feature ? "number" == typeof this.feature.type ? Je[this.feature.type] : this.feature.type : null
          }
          ,
          Qe.prototype.properties = function() {
              return this.feature && this.feature.properties || {}
          }
          ,
          Qe.prototype.parseColor = function(e) {
              var t = this._parseColorCache[e];
              return t || (t = this._parseColorCache[e] = je.parse(e)),
              t
          }
          ;
          var et = function(e, t, i, n) {
              this.name = e,
              this.type = t,
              this._evaluate = i,
              this.args = n
          };
          et.prototype.evaluate = function(e) {
              return this._evaluate(e, this.args)
          }
          ,
          et.prototype.eachChild = function(e) {
              this.args.forEach(e)
          }
          ,
          et.prototype.possibleOutputs = function() {
              return [void 0]
          }
          ,
          et.prototype.serialize = function() {
              return [this.name].concat(this.args.map(function(e) {
                  return e.serialize()
              }))
          }
          ,
          et.parse = function(e, t) {
              var i, n = e[0], r = et.definitions[n];
              if (!r)
                  return t.error('Unknown expression "' + n + '". If you wanted a literal array, use ["literal", [...]].', 0);
              for (var o = Array.isArray(r) ? r[0] : r.type, s = Array.isArray(r) ? [[r[1], r[2]]] : r.overloads, a = s.filter(function(t) {
                  var i = t[0];
                  return !Array.isArray(i) || i.length === e.length - 1
              }), l = null, c = 0, u = a; c < u.length; c += 1) {
                  var h = u[c]
                    , d = h[0]
                    , p = h[1];
                  l = new st(t.registry,t.path,null,t.scope);
                  for (var f = [], m = !1, g = 1; g < e.length; g++) {
                      var v = e[g]
                        , y = Array.isArray(d) ? d[g - 1] : d.type
                        , _ = l.parse(v, 1 + f.length, y);
                      if (!_) {
                          m = !0;
                          break
                      }
                      f.push(_)
                  }
                  if (!m)
                      if (Array.isArray(d) && d.length !== f.length)
                          l.error("Expected " + d.length + " arguments, but found " + f.length + " instead.");
                      else {
                          for (var b = 0; b < f.length; b++) {
                              var w = Array.isArray(d) ? d[b] : d.type
                                , x = f[b];
                              l.concat(b + 1).checkSubtype(w, x.type)
                          }
                          if (0 === l.errors.length)
                              return new et(n,o,p,f)
                      }
              }
              if (1 === a.length)
                  (i = t.errors).push.apply(i, l.errors);
              else {
                  for (var k = (a.length ? a : s).map(function(e) {
                      var t;
                      return t = e[0],
                      Array.isArray(t) ? "(" + t.map(ze).join(", ") + ")" : "(" + ze(t.type) + "...)"
                  }).join(" | "), S = [], E = 1; E < e.length; E++) {
                      var T = t.parse(e[E], 1 + S.length);
                      if (!T)
                          return null;
                      S.push(ze(T.type))
                  }
                  t.error("Expected arguments of type " + k + ", but found (" + S.join(", ") + ") instead.")
              }
              return null
          }
          ,
          et.register = function(e, t) {
              for (var i in et.definitions = t,
              t)
                  e[i] = et
          }
          ;
          var tt = function(e, t, i) {
              this.type = Ie,
              this.locale = i,
              this.caseSensitive = e,
              this.diacriticSensitive = t
          };
          function it(e) {
              if (e instanceof et) {
                  if ("get" === e.name && 1 === e.args.length)
                      return !1;
                  if ("feature-state" === e.name)
                      return !1;
                  if ("has" === e.name && 1 === e.args.length)
                      return !1;
                  if ("properties" === e.name || "geometry-type" === e.name || "id" === e.name)
                      return !1;
                  if (/^filter-/.test(e.name))
                      return !1
              }
              var t = !0;
              return e.eachChild(function(e) {
                  t && !it(e) && (t = !1)
              }),
              t
          }
          function nt(e) {
              if (e instanceof et && "feature-state" === e.name)
                  return !1;
              var t = !0;
              return e.eachChild(function(e) {
                  t && !nt(e) && (t = !1)
              }),
              t
          }
          function rt(e, t) {
              if (e instanceof et && t.indexOf(e.name) >= 0)
                  return !1;
              var i = !0;
              return e.eachChild(function(e) {
                  i && !rt(e, t) && (i = !1)
              }),
              i
          }
          tt.parse = function(e, t) {
              if (2 !== e.length)
                  return t.error("Expected one argument.");
              var i = e[1];
              if ("object" != typeof i || Array.isArray(i))
                  return t.error("Collator options argument must be an object.");
              var n = t.parse(void 0 !== i["case-sensitive"] && i["case-sensitive"], 1, Ce);
              if (!n)
                  return null;
              var r = t.parse(void 0 !== i["diacritic-sensitive"] && i["diacritic-sensitive"], 1, Ce);
              if (!r)
                  return null;
              var o = null;
              return i.locale && !(o = t.parse(i.locale, 1, Te)) ? null : new tt(n,r,o)
          }
          ,
          tt.prototype.evaluate = function(e) {
              return new Fe(this.caseSensitive.evaluate(e),this.diacriticSensitive.evaluate(e),this.locale ? this.locale.evaluate(e) : null)
          }
          ,
          tt.prototype.eachChild = function(e) {
              e(this.caseSensitive),
              e(this.diacriticSensitive),
              this.locale && e(this.locale)
          }
          ,
          tt.prototype.possibleOutputs = function() {
              return [void 0]
          }
          ,
          tt.prototype.serialize = function() {
              var e = {};
              return e["case-sensitive"] = this.caseSensitive.serialize(),
              e["diacritic-sensitive"] = this.diacriticSensitive.serialize(),
              this.locale && (e.locale = this.locale.serialize()),
              ["collator", e]
          }
          ;
          var ot = function(e, t) {
              this.type = t.type,
              this.name = e,
              this.boundExpression = t
          };
          ot.parse = function(e, t) {
              if (2 !== e.length || "string" != typeof e[1])
                  return t.error("'var' expression requires exactly one string literal argument.");
              var i = e[1];
              return t.scope.has(i) ? new ot(i,t.scope.get(i)) : t.error('Unknown variable "' + i + '". Make sure "' + i + '" has been bound in an enclosing "let" expression before using it.', 1)
          }
          ,
          ot.prototype.evaluate = function(e) {
              return this.boundExpression.evaluate(e)
          }
          ,
          ot.prototype.eachChild = function() {}
          ,
          ot.prototype.possibleOutputs = function() {
              return [void 0]
          }
          ,
          ot.prototype.serialize = function() {
              return ["var", this.name]
          }
          ;
          var st = function(e, t, i, n, r) {
              void 0 === t && (t = []),
              void 0 === n && (n = new ke),
              void 0 === r && (r = []),
              this.registry = e,
              this.path = t,
              this.key = t.map(function(e) {
                  return "[" + e + "]"
              }).join(""),
              this.scope = n,
              this.errors = r,
              this.expectedType = i
          };
          function at(e, t) {
              for (var i, n, r = 0, o = e.length - 1, s = 0; r <= o; ) {
                  if (i = e[s = Math.floor((r + o) / 2)],
                  n = e[s + 1],
                  t === i || t > i && t < n)
                      return s;
                  if (i < t)
                      r = s + 1;
                  else {
                      if (!(i > t))
                          throw new $e("Input is not a number.");
                      o = s - 1
                  }
              }
              return Math.max(s - 1, 0)
          }
          st.prototype.parse = function(e, t, i, n, r) {
              return void 0 === r && (r = {}),
              t ? this.concat(t, i, n)._parse(e, r) : this._parse(e, r)
          }
          ,
          st.prototype._parse = function(e, t) {
              function i(e, t, i) {
                  return "assert" === i ? new Xe(t,[e]) : "coerce" === i ? new Ke(t,[e]) : e
              }
              if (null !== e && "string" != typeof e && "boolean" != typeof e && "number" != typeof e || (e = ["literal", e]),
              Array.isArray(e)) {
                  if (0 === e.length)
                      return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                  var n = e[0];
                  if ("string" != typeof n)
                      return this.error("Expression name must be a string, but found " + typeof n + ' instead. If you wanted a literal array, use ["literal", [...]].', 0),
                      null;
                  var r = this.registry[n];
                  if (r) {
                      var o = r.parse(e, this);
                      if (!o)
                          return null;
                      if (this.expectedType) {
                          var s = this.expectedType
                            , a = o.type;
                          if ("string" !== s.kind && "number" !== s.kind && "boolean" !== s.kind && "object" !== s.kind && "array" !== s.kind || "value" !== a.kind)
                              if ("color" !== s.kind && "formatted" !== s.kind || "value" !== a.kind && "string" !== a.kind) {
                                  if (this.checkSubtype(s, a))
                                      return null
                              } else
                                  o = i(o, s, t.typeAnnotation || "coerce");
                          else
                              o = i(o, s, t.typeAnnotation || "assert")
                      }
                      if (!(o instanceof We) && function e(t) {
                          if (t instanceof ot)
                              return e(t.boundExpression);
                          if (t instanceof et && "error" === t.name)
                              return !1;
                          if (t instanceof tt)
                              return !1;
                          var i = t instanceof Ke || t instanceof Xe
                            , n = !0;
                          return t.eachChild(function(t) {
                              n = i ? n && e(t) : n && t instanceof We
                          }),
                          !!n && it(t) && rt(t, ["zoom", "heatmap-density", "line-progress", "accumulated", "is-supported-script"])
                      }(o)) {
                          var l = new Qe;
                          try {
                              o = new We(o.type,o.evaluate(l))
                          } catch (e) {
                              return this.error(e.message),
                              null
                          }
                      }
                      return o
                  }
                  return this.error('Unknown expression "' + n + '". If you wanted a literal array, use ["literal", [...]].', 0)
              }
              return void 0 === e ? this.error("'undefined' value invalid. Use null instead.") : "object" == typeof e ? this.error('Bare objects invalid. Use ["literal", {...}] instead.') : this.error("Expected an array, but found " + typeof e + " instead.")
          }
          ,
          st.prototype.concat = function(e, t, i) {
              var n = "number" == typeof e ? this.path.concat(e) : this.path
                , r = i ? this.scope.concat(i) : this.scope;
              return new st(this.registry,n,t || null,r,this.errors)
          }
          ,
          st.prototype.error = function(e) {
              for (var t = [], i = arguments.length - 1; i-- > 0; )
                  t[i] = arguments[i + 1];
              var n = "" + this.key + t.map(function(e) {
                  return "[" + e + "]"
              }).join("");
              this.errors.push(new xe(n,e))
          }
          ,
          st.prototype.checkSubtype = function(e, t) {
              var i = Re(e, t);
              return i && this.error(i),
              i
          }
          ;
          var lt = function(e, t, i) {
              this.type = e,
              this.input = t,
              this.labels = [],
              this.outputs = [];
              for (var n = 0, r = i; n < r.length; n += 1) {
                  var o = r[n]
                    , s = o[0]
                    , a = o[1];
                  this.labels.push(s),
                  this.outputs.push(a)
              }
          };
          function ct(e, t, i) {
              return e * (1 - i) + t * i
          }
          lt.parse = function(e, t) {
              var i = e[1]
                , n = e.slice(2);
              if (e.length - 1 < 4)
                  return t.error("Expected at least 4 arguments, but found only " + (e.length - 1) + ".");
              if ((e.length - 1) % 2 != 0)
                  return t.error("Expected an even number of arguments.");
              if (!(i = t.parse(i, 1, Ee)))
                  return null;
              var r = []
                , o = null;
              t.expectedType && "value" !== t.expectedType.kind && (o = t.expectedType),
              n.unshift(-1 / 0);
              for (var s = 0; s < n.length; s += 2) {
                  var a = n[s]
                    , l = n[s + 1]
                    , c = s + 1
                    , u = s + 2;
                  if ("number" != typeof a)
                      return t.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', c);
                  if (r.length && r[r.length - 1][0] >= a)
                      return t.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', c);
                  var h = t.parse(l, u, o);
                  if (!h)
                      return null;
                  o = o || h.type,
                  r.push([a, h])
              }
              return new lt(o,i,r)
          }
          ,
          lt.prototype.evaluate = function(e) {
              var t = this.labels
                , i = this.outputs;
              if (1 === t.length)
                  return i[0].evaluate(e);
              var n = this.input.evaluate(e);
              if (n <= t[0])
                  return i[0].evaluate(e);
              var r = t.length;
              return n >= t[r - 1] ? i[r - 1].evaluate(e) : i[at(t, n)].evaluate(e)
          }
          ,
          lt.prototype.eachChild = function(e) {
              e(this.input);
              for (var t = 0, i = this.outputs; t < i.length; t += 1)
                  e(i[t])
          }
          ,
          lt.prototype.possibleOutputs = function() {
              var e;
              return (e = []).concat.apply(e, this.outputs.map(function(e) {
                  return e.possibleOutputs()
              }))
          }
          ,
          lt.prototype.serialize = function() {
              for (var e = ["step", this.input.serialize()], t = 0; t < this.labels.length; t++)
                  t > 0 && e.push(this.labels[t]),
                  e.push(this.outputs[t].serialize());
              return e
          }
          ;
          var ut = Object.freeze({
              number: ct,
              color: function(e, t, i) {
                  return new je(ct(e.r, t.r, i),ct(e.g, t.g, i),ct(e.b, t.b, i),ct(e.a, t.a, i))
              },
              array: function(e, t, i) {
                  return e.map(function(e, n) {
                      return ct(e, t[n], i)
                  })
              }
          })
            , ht = .95047
            , dt = 1
            , pt = 1.08883
            , ft = 4 / 29
            , mt = 6 / 29
            , gt = 3 * mt * mt
            , vt = mt * mt * mt
            , yt = Math.PI / 180
            , _t = 180 / Math.PI;
          function bt(e) {
              return e > vt ? Math.pow(e, 1 / 3) : e / gt + ft
          }
          function wt(e) {
              return e > mt ? e * e * e : gt * (e - ft)
          }
          function xt(e) {
              return 255 * (e <= .0031308 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - .055)
          }
          function kt(e) {
              return (e /= 255) <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4)
          }
          function St(e) {
              var t = kt(e.r)
                , i = kt(e.g)
                , n = kt(e.b)
                , r = bt((.4124564 * t + .3575761 * i + .1804375 * n) / ht)
                , o = bt((.2126729 * t + .7151522 * i + .072175 * n) / dt);
              return {
                  l: 116 * o - 16,
                  a: 500 * (r - o),
                  b: 200 * (o - bt((.0193339 * t + .119192 * i + .9503041 * n) / pt)),
                  alpha: e.a
              }
          }
          function Et(e) {
              var t = (e.l + 16) / 116
                , i = isNaN(e.a) ? t : t + e.a / 500
                , n = isNaN(e.b) ? t : t - e.b / 200;
              return t = dt * wt(t),
              i = ht * wt(i),
              n = pt * wt(n),
              new je(xt(3.2404542 * i - 1.5371385 * t - .4985314 * n),xt(-.969266 * i + 1.8760108 * t + .041556 * n),xt(.0556434 * i - .2040259 * t + 1.0572252 * n),e.alpha)
          }
          function Tt(e, t, i) {
              var n = t - e;
              return e + i * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n)
          }
          var Ct = {
              forward: St,
              reverse: Et,
              interpolate: function(e, t, i) {
                  return {
                      l: ct(e.l, t.l, i),
                      a: ct(e.a, t.a, i),
                      b: ct(e.b, t.b, i),
                      alpha: ct(e.alpha, t.alpha, i)
                  }
              }
          }
            , Lt = {
              forward: function(e) {
                  var t = St(e)
                    , i = t.l
                    , n = t.a
                    , r = t.b
                    , o = Math.atan2(r, n) * _t;
                  return {
                      h: o < 0 ? o + 360 : o,
                      c: Math.sqrt(n * n + r * r),
                      l: i,
                      alpha: e.a
                  }
              },
              reverse: function(e) {
                  var t = e.h * yt
                    , i = e.c;
                  return Et({
                      l: e.l,
                      a: Math.cos(t) * i,
                      b: Math.sin(t) * i,
                      alpha: e.alpha
                  })
              },
              interpolate: function(e, t, i) {
                  return {
                      h: Tt(e.h, t.h, i),
                      c: ct(e.c, t.c, i),
                      l: ct(e.l, t.l, i),
                      alpha: ct(e.alpha, t.alpha, i)
                  }
              }
          }
            , At = Object.freeze({
              lab: Ct,
              hcl: Lt
          })
            , Pt = function(e, t, i, n, r) {
              this.type = e,
              this.operator = t,
              this.interpolation = i,
              this.input = n,
              this.labels = [],
              this.outputs = [];
              for (var o = 0, s = r; o < s.length; o += 1) {
                  var a = s[o]
                    , l = a[0]
                    , c = a[1];
                  this.labels.push(l),
                  this.outputs.push(c)
              }
          };
          function It(e, t, i, n) {
              var r = n - i
                , o = e - i;
              return 0 === r ? 0 : 1 === t ? o / r : (Math.pow(t, o) - 1) / (Math.pow(t, r) - 1)
          }
          Pt.interpolationFactor = function(e, t, n, r) {
              var o = 0;
              if ("exponential" === e.name)
                  o = It(t, e.base, n, r);
              else if ("linear" === e.name)
                  o = It(t, 1, n, r);
              else if ("cubic-bezier" === e.name) {
                  var s = e.controlPoints;
                  o = new i(s[0],s[1],s[2],s[3]).solve(It(t, 1, n, r))
              }
              return o
          }
          ,
          Pt.parse = function(e, t) {
              var i = e[0]
                , n = e[1]
                , r = e[2]
                , o = e.slice(3);
              if (!Array.isArray(n) || 0 === n.length)
                  return t.error("Expected an interpolation type expression.", 1);
              if ("linear" === n[0])
                  n = {
                      name: "linear"
                  };
              else if ("exponential" === n[0]) {
                  var s = n[1];
                  if ("number" != typeof s)
                      return t.error("Exponential interpolation requires a numeric base.", 1, 1);
                  n = {
                      name: "exponential",
                      base: s
                  }
              } else {
                  if ("cubic-bezier" !== n[0])
                      return t.error("Unknown interpolation type " + String(n[0]), 1, 0);
                  var a = n.slice(1);
                  if (4 !== a.length || a.some(function(e) {
                      return "number" != typeof e || e < 0 || e > 1
                  }))
                      return t.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                  n = {
                      name: "cubic-bezier",
                      controlPoints: a
                  }
              }
              if (e.length - 1 < 4)
                  return t.error("Expected at least 4 arguments, but found only " + (e.length - 1) + ".");
              if ((e.length - 1) % 2 != 0)
                  return t.error("Expected an even number of arguments.");
              if (!(r = t.parse(r, 2, Ee)))
                  return null;
              var l = []
                , c = null;
              "interpolate-hcl" === i || "interpolate-lab" === i ? c = Le : t.expectedType && "value" !== t.expectedType.kind && (c = t.expectedType);
              for (var u = 0; u < o.length; u += 2) {
                  var h = o[u]
                    , d = o[u + 1]
                    , p = u + 3
                    , f = u + 4;
                  if ("number" != typeof h)
                      return t.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', p);
                  if (l.length && l[l.length - 1][0] >= h)
                      return t.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', p);
                  var m = t.parse(d, f, c);
                  if (!m)
                      return null;
                  c = c || m.type,
                  l.push([h, m])
              }
              return "number" === c.kind || "color" === c.kind || "array" === c.kind && "number" === c.itemType.kind && "number" == typeof c.N ? new Pt(c,i,n,r,l) : t.error("Type " + ze(c) + " is not interpolatable.")
          }
          ,
          Pt.prototype.evaluate = function(e) {
              var t = this.labels
                , i = this.outputs;
              if (1 === t.length)
                  return i[0].evaluate(e);
              var n = this.input.evaluate(e);
              if (n <= t[0])
                  return i[0].evaluate(e);
              var r = t.length;
              if (n >= t[r - 1])
                  return i[r - 1].evaluate(e);
              var o = at(t, n)
                , s = t[o]
                , a = t[o + 1]
                , l = Pt.interpolationFactor(this.interpolation, n, s, a)
                , c = i[o].evaluate(e)
                , u = i[o + 1].evaluate(e);
              return "interpolate" === this.operator ? ut[this.type.kind.toLowerCase()](c, u, l) : "interpolate-hcl" === this.operator ? Lt.reverse(Lt.interpolate(Lt.forward(c), Lt.forward(u), l)) : Ct.reverse(Ct.interpolate(Ct.forward(c), Ct.forward(u), l))
          }
          ,
          Pt.prototype.eachChild = function(e) {
              e(this.input);
              for (var t = 0, i = this.outputs; t < i.length; t += 1)
                  e(i[t])
          }
          ,
          Pt.prototype.possibleOutputs = function() {
              var e;
              return (e = []).concat.apply(e, this.outputs.map(function(e) {
                  return e.possibleOutputs()
              }))
          }
          ,
          Pt.prototype.serialize = function() {
              var e;
              e = "linear" === this.interpolation.name ? ["linear"] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? ["linear"] : ["exponential", this.interpolation.base] : ["cubic-bezier"].concat(this.interpolation.controlPoints);
              for (var t = [this.operator, e, this.input.serialize()], i = 0; i < this.labels.length; i++)
                  t.push(this.labels[i], this.outputs[i].serialize());
              return t
          }
          ;
          var Mt = function(e, t) {
              this.type = e,
              this.args = t
          };
          Mt.parse = function(e, t) {
              if (e.length < 2)
                  return t.error("Expectected at least one argument.");
              var i = null
                , n = t.expectedType;
              n && "value" !== n.kind && (i = n);
              for (var r = [], o = 0, s = e.slice(1); o < s.length; o += 1) {
                  var a = s[o]
                    , l = t.parse(a, 1 + r.length, i, void 0, {
                      typeAnnotation: "omit"
                  });
                  if (!l)
                      return null;
                  i = i || l.type,
                  r.push(l)
              }
              var c = n && r.some(function(e) {
                  return Re(n, e.type)
              });
              return new Mt(c ? Pe : i,r)
          }
          ,
          Mt.prototype.evaluate = function(e) {
              for (var t = null, i = 0, n = this.args; i < n.length && null === (t = n[i].evaluate(e)); i += 1)
                  ;
              return t
          }
          ,
          Mt.prototype.eachChild = function(e) {
              this.args.forEach(e)
          }
          ,
          Mt.prototype.possibleOutputs = function() {
              var e;
              return (e = []).concat.apply(e, this.args.map(function(e) {
                  return e.possibleOutputs()
              }))
          }
          ,
          Mt.prototype.serialize = function() {
              var e = ["coalesce"];
              return this.eachChild(function(t) {
                  e.push(t.serialize())
              }),
              e
          }
          ;
          var Ot = function(e, t) {
              this.type = t.type,
              this.bindings = [].concat(e),
              this.result = t
          };
          Ot.prototype.evaluate = function(e) {
              return this.result.evaluate(e)
          }
          ,
          Ot.prototype.eachChild = function(e) {
              for (var t = 0, i = this.bindings; t < i.length; t += 1)
                  e(i[t][1]);
              e(this.result)
          }
          ,
          Ot.parse = function(e, t) {
              if (e.length < 4)
                  return t.error("Expected at least 3 arguments, but found " + (e.length - 1) + " instead.");
              for (var i = [], n = 1; n < e.length - 1; n += 2) {
                  var r = e[n];
                  if ("string" != typeof r)
                      return t.error("Expected string, but found " + typeof r + " instead.", n);
                  if (/[^a-zA-Z0-9_]/.test(r))
                      return t.error("Variable names must contain only alphanumeric characters or '_'.", n);
                  var o = t.parse(e[n + 1], n + 1);
                  if (!o)
                      return null;
                  i.push([r, o])
              }
              var s = t.parse(e[e.length - 1], e.length - 1, t.expectedType, i);
              return s ? new Ot(i,s) : null
          }
          ,
          Ot.prototype.possibleOutputs = function() {
              return this.result.possibleOutputs()
          }
          ,
          Ot.prototype.serialize = function() {
              for (var e = ["let"], t = 0, i = this.bindings; t < i.length; t += 1) {
                  var n = i[t]
                    , r = n[0]
                    , o = n[1];
                  e.push(r, o.serialize())
              }
              return e.push(this.result.serialize()),
              e
          }
          ;
          var zt = function(e, t, i) {
              this.type = e,
              this.index = t,
              this.input = i
          };
          zt.parse = function(e, t) {
              if (3 !== e.length)
                  return t.error("Expected 2 arguments, but found " + (e.length - 1) + " instead.");
              var i = t.parse(e[1], 1, Ee)
                , n = t.parse(e[2], 2, Oe(t.expectedType || Pe));
              if (!i || !n)
                  return null;
              var r = n.type;
              return new zt(r.itemType,i,n)
          }
          ,
          zt.prototype.evaluate = function(e) {
              var t = this.index.evaluate(e)
                , i = this.input.evaluate(e);
              if (t < 0)
                  throw new $e("Array index out of bounds: " + t + " < 0.");
              if (t >= i.length)
                  throw new $e("Array index out of bounds: " + t + " > " + (i.length - 1) + ".");
              if (t !== Math.floor(t))
                  throw new $e("Array index must be an integer, but found " + t + " instead.");
              return i[t]
          }
          ,
          zt.prototype.eachChild = function(e) {
              e(this.index),
              e(this.input)
          }
          ,
          zt.prototype.possibleOutputs = function() {
              return [void 0]
          }
          ,
          zt.prototype.serialize = function() {
              return ["at", this.index.serialize(), this.input.serialize()]
          }
          ;
          var Dt = function(e, t, i, n, r, o) {
              this.inputType = e,
              this.type = t,
              this.input = i,
              this.cases = n,
              this.outputs = r,
              this.otherwise = o
          };
          Dt.parse = function(e, t) {
              if (e.length < 5)
                  return t.error("Expected at least 4 arguments, but found only " + (e.length - 1) + ".");
              if (e.length % 2 != 1)
                  return t.error("Expected an even number of arguments.");
              var i, n;
              t.expectedType && "value" !== t.expectedType.kind && (n = t.expectedType);
              for (var r = {}, o = [], s = 2; s < e.length - 1; s += 2) {
                  var a = e[s]
                    , l = e[s + 1];
                  Array.isArray(a) || (a = [a]);
                  var c = t.concat(s);
                  if (0 === a.length)
                      return c.error("Expected at least one branch label.");
                  for (var u = 0, h = a; u < h.length; u += 1) {
                      var d = h[u];
                      if ("number" != typeof d && "string" != typeof d)
                          return c.error("Branch labels must be numbers or strings.");
                      if ("number" == typeof d && Math.abs(d) > Number.MAX_SAFE_INTEGER)
                          return c.error("Branch labels must be integers no larger than " + Number.MAX_SAFE_INTEGER + ".");
                      if ("number" == typeof d && Math.floor(d) !== d)
                          return c.error("Numeric branch labels must be integer values.");
                      if (i) {
                          if (c.checkSubtype(i, He(d)))
                              return null
                      } else
                          i = He(d);
                      if (void 0 !== r[String(d)])
                          return c.error("Branch labels must be unique.");
                      r[String(d)] = o.length
                  }
                  var p = t.parse(l, s, n);
                  if (!p)
                      return null;
                  n = n || p.type,
                  o.push(p)
              }
              var f = t.parse(e[1], 1, Pe);
              if (!f)
                  return null;
              var m = t.parse(e[e.length - 1], e.length - 1, n);
              return m ? "value" !== f.type.kind && t.concat(1).checkSubtype(i, f.type) ? null : new Dt(i,n,f,r,o,m) : null
          }
          ,
          Dt.prototype.evaluate = function(e) {
              var t = this.input.evaluate(e);
              return (He(t) === this.inputType && this.outputs[this.cases[t]] || this.otherwise).evaluate(e)
          }
          ,
          Dt.prototype.eachChild = function(e) {
              e(this.input),
              this.outputs.forEach(e),
              e(this.otherwise)
          }
          ,
          Dt.prototype.possibleOutputs = function() {
              var e;
              return (e = []).concat.apply(e, this.outputs.map(function(e) {
                  return e.possibleOutputs()
              })).concat(this.otherwise.possibleOutputs())
          }
          ,
          Dt.prototype.serialize = function() {
              for (var e = this, t = ["match", this.input.serialize()], i = [], n = {}, r = 0, o = Object.keys(this.cases).sort(); r < o.length; r += 1) {
                  var s = o[r];
                  void 0 === (h = n[this.cases[s]]) ? (n[this.cases[s]] = i.length,
                  i.push([this.cases[s], [s]])) : i[h][1].push(s)
              }
              for (var a = function(t) {
                  return "number" === e.inputType.kind ? Number(t) : t
              }, l = 0, c = i; l < c.length; l += 1) {
                  var u = c[l]
                    , h = u[0]
                    , d = u[1];
                  1 === d.length ? t.push(a(d[0])) : t.push(d.map(a)),
                  t.push(this.outputs[outputIndex$1].serialize())
              }
              return t.push(this.otherwise.serialize()),
              t
          }
          ;
          var Rt = function(e, t, i) {
              this.type = e,
              this.branches = t,
              this.otherwise = i
          };
          function Bt(e, t) {
              return "==" === e || "!=" === e ? "boolean" === t.kind || "string" === t.kind || "number" === t.kind || "null" === t.kind || "value" === t.kind : "string" === t.kind || "number" === t.kind || "value" === t.kind
          }
          function jt(e, t, i, n) {
              return 0 === n.compare(t, i)
          }
          function Ft(e, t, i) {
              var n = "==" !== e && "!=" !== e;
              return function() {
                  function r(e, t, i) {
                      this.type = Ce,
                      this.lhs = e,
                      this.rhs = t,
                      this.collator = i,
                      this.hasUntypedArgument = "value" === e.type.kind || "value" === t.type.kind
                  }
                  return r.parse = function(e, t) {
                      if (3 !== e.length && 4 !== e.length)
                          return t.error("Expected two or three arguments.");
                      var i = e[0]
                        , o = t.parse(e[1], 1, Pe);
                      if (!o)
                          return null;
                      if (!Bt(i, o.type))
                          return t.concat(1).error('"' + i + "\" comparisons are not supported for type '" + ze(o.type) + "'.");
                      var s = t.parse(e[2], 2, Pe);
                      if (!s)
                          return null;
                      if (!Bt(i, s.type))
                          return t.concat(2).error('"' + i + "\" comparisons are not supported for type '" + ze(s.type) + "'.");
                      if (o.type.kind !== s.type.kind && "value" !== o.type.kind && "value" !== s.type.kind)
                          return t.error("Cannot compare types '" + ze(o.type) + "' and '" + ze(s.type) + "'.");
                      n && ("value" === o.type.kind && "value" !== s.type.kind ? o = new Xe(s.type,[o]) : "value" !== o.type.kind && "value" === s.type.kind && (s = new Xe(o.type,[s])));
                      var a = null;
                      if (4 === e.length) {
                          if ("string" !== o.type.kind && "string" !== s.type.kind && "value" !== o.type.kind && "value" !== s.type.kind)
                              return t.error("Cannot use collator to compare non-string types.");
                          if (!(a = t.parse(e[3], 3, Ie)))
                              return null
                      }
                      return new r(o,s,a)
                  }
                  ,
                  r.prototype.evaluate = function(r) {
                      var o = this.lhs.evaluate(r)
                        , s = this.rhs.evaluate(r);
                      if (n && this.hasUntypedArgument) {
                          var a = He(o)
                            , l = He(s);
                          if (a.kind !== l.kind || "string" !== a.kind && "number" !== a.kind)
                              throw new $e('Expected arguments for "' + e + '" to be (string, string) or (number, number), but found (' + a.kind + ", " + l.kind + ") instead.")
                      }
                      if (this.collator && !n && this.hasUntypedArgument) {
                          var c = He(o)
                            , u = He(s);
                          if ("string" !== c.kind || "string" !== u.kind)
                              return t(r, o, s)
                      }
                      return this.collator ? i(r, o, s, this.collator.evaluate(r)) : t(r, o, s)
                  }
                  ,
                  r.prototype.eachChild = function(e) {
                      e(this.lhs),
                      e(this.rhs),
                      this.collator && e(this.collator)
                  }
                  ,
                  r.prototype.possibleOutputs = function() {
                      return [!0, !1]
                  }
                  ,
                  r.prototype.serialize = function() {
                      var t = [e];
                      return this.eachChild(function(e) {
                          t.push(e.serialize())
                      }),
                      t
                  }
                  ,
                  r
              }()
          }
          Rt.parse = function(e, t) {
              if (e.length < 4)
                  return t.error("Expected at least 3 arguments, but found only " + (e.length - 1) + ".");
              if (e.length % 2 != 0)
                  return t.error("Expected an odd number of arguments.");
              var i;
              t.expectedType && "value" !== t.expectedType.kind && (i = t.expectedType);
              for (var n = [], r = 1; r < e.length - 1; r += 2) {
                  var o = t.parse(e[r], r, Ce);
                  if (!o)
                      return null;
                  var s = t.parse(e[r + 1], r + 1, i);
                  if (!s)
                      return null;
                  n.push([o, s]),
                  i = i || s.type
              }
              var a = t.parse(e[e.length - 1], e.length - 1, i);
              return a ? new Rt(i,n,a) : null
          }
          ,
          Rt.prototype.evaluate = function(e) {
              for (var t = 0, i = this.branches; t < i.length; t += 1) {
                  var n = i[t]
                    , r = n[0]
                    , o = n[1];
                  if (r.evaluate(e))
                      return o.evaluate(e)
              }
              return this.otherwise.evaluate(e)
          }
          ,
          Rt.prototype.eachChild = function(e) {
              for (var t = 0, i = this.branches; t < i.length; t += 1) {
                  var n = i[t]
                    , r = n[0]
                    , o = n[1];
                  e(r),
                  e(o)
              }
              e(this.otherwise)
          }
          ,
          Rt.prototype.possibleOutputs = function() {
              var e;
              return (e = []).concat.apply(e, this.branches.map(function(e) {
                  return e[0],
                  e[1].possibleOutputs()
              })).concat(this.otherwise.possibleOutputs())
          }
          ,
          Rt.prototype.serialize = function() {
              var e = ["case"];
              return this.eachChild(function(t) {
                  e.push(t.serialize())
              }),
              e
          }
          ;
          var Nt = Ft("==", function(e, t, i) {
              return t === i
          }, jt)
            , Ut = Ft("!=", function(e, t, i) {
              return t !== i
          }, function(e, t, i, n) {
              return !jt(0, t, i, n)
          })
            , qt = Ft("<", function(e, t, i) {
              return t < i
          }, function(e, t, i, n) {
              return n.compare(t, i) < 0
          })
            , Ht = Ft(">", function(e, t, i) {
              return t > i
          }, function(e, t, i, n) {
              return n.compare(t, i) > 0
          })
            , Vt = Ft("<=", function(e, t, i) {
              return t <= i
          }, function(e, t, i, n) {
              return n.compare(t, i) <= 0
          })
            , Wt = Ft(">=", function(e, t, i) {
              return t >= i
          }, function(e, t, i, n) {
              return n.compare(t, i) >= 0
          })
            , $t = function(e, t, i, n, r) {
              this.type = Te,
              this.number = e,
              this.locale = t,
              this.currency = i,
              this.minFractionDigits = n,
              this.maxFractionDigits = r
          };
          $t.parse = function(e, t) {
              if (3 !== e.length)
                  return t.error("Expected two arguments.");
              var i = t.parse(e[1], 1, Ee);
              if (!i)
                  return null;
              var n = e[2];
              if ("object" != typeof n || Array.isArray(n))
                  return t.error("NumberFormat options argument must be an object.");
              var r = null;
              if (n.locale && !(r = t.parse(n.locale, 1, Te)))
                  return null;
              var o = null;
              if (n.currency && !(o = t.parse(n.currency, 1, Te)))
                  return null;
              var s = null;
              if (n["min-fraction-digits"] && !(s = t.parse(n["min-fraction-digits"], 1, Ee)))
                  return null;
              var a = null;
              return n["max-fraction-digits"] && !(a = t.parse(n["max-fraction-digits"], 1, Ee)) ? null : new $t(i,r,o,s,a)
          }
          ,
          $t.prototype.evaluate = function(e) {
              return new Intl.NumberFormat(this.locale ? this.locale.evaluate(e) : [],{
                  style: this.currency ? "currency" : "decimal",
                  currency: this.currency ? this.currency.evaluate(e) : void 0,
                  minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(e) : void 0,
                  maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(e) : void 0
              }).format(this.number.evaluate(e))
          }
          ,
          $t.prototype.eachChild = function(e) {
              e(this.number),
              this.locale && e(this.locale),
              this.currency && e(this.currency),
              this.minFractionDigits && e(this.minFractionDigits),
              this.maxFractionDigits && e(this.maxFractionDigits)
          }
          ,
          $t.prototype.possibleOutputs = function() {
              return [void 0]
          }
          ,
          $t.prototype.serialize = function() {
              var e = {};
              return this.locale && (e.locale = this.locale.serialize()),
              this.currency && (e.currency = this.currency.serialize()),
              this.minFractionDigits && (e["min-fraction-digits"] = this.minFractionDigits.serialize()),
              this.maxFractionDigits && (e["max-fraction-digits"] = this.maxFractionDigits.serialize()),
              ["number-format", this.number.serialize(), e]
          }
          ;
          var Gt = function(e) {
              this.type = Ee,
              this.input = e
          };
          Gt.parse = function(e, t) {
              if (2 !== e.length)
                  return t.error("Expected 1 argument, but found " + (e.length - 1) + " instead.");
              var i = t.parse(e[1], 1);
              return i ? "array" !== i.type.kind && "string" !== i.type.kind && "value" !== i.type.kind ? t.error("Expected argument of type string or array, but found " + ze(i.type) + " instead.") : new Gt(i) : null
          }
          ,
          Gt.prototype.evaluate = function(e) {
              var t = this.input.evaluate(e);
              if ("string" == typeof t)
                  return t.length;
              if (Array.isArray(t))
                  return t.length;
              throw new $e("Expected value to be of type string or array, but found " + ze(He(t)) + " instead.")
          }
          ,
          Gt.prototype.eachChild = function(e) {
              e(this.input)
          }
          ,
          Gt.prototype.possibleOutputs = function() {
              return [void 0]
          }
          ,
          Gt.prototype.serialize = function() {
              var e = ["length"];
              return this.eachChild(function(t) {
                  e.push(t.serialize())
              }),
              e
          }
          ;
          var Xt = {
              "==": Nt,
              "!=": Ut,
              ">": Ht,
              "<": qt,
              ">=": Wt,
              "<=": Vt,
              array: Xe,
              at: zt,
              boolean: Xe,
              case: Rt,
              coalesce: Mt,
              collator: tt,
              format: Ze,
              interpolate: Pt,
              "interpolate-hcl": Pt,
              "interpolate-lab": Pt,
              length: Gt,
              let: Ot,
              literal: We,
              match: Dt,
              number: Xe,
              "number-format": $t,
              object: Xe,
              step: lt,
              string: Xe,
              "to-boolean": Ke,
              "to-color": Ke,
              "to-number": Ke,
              "to-string": Ke,
              var: ot
          };
          function Zt(e, t) {
              var i = t[0]
                , n = t[1]
                , r = t[2]
                , o = t[3];
              i = i.evaluate(e),
              n = n.evaluate(e),
              r = r.evaluate(e);
              var s = o ? o.evaluate(e) : 1
                , a = qe(i, n, r, s);
              if (a)
                  throw new $e(a);
              return new je(i / 255 * s,n / 255 * s,r / 255 * s,s)
          }
          function Yt(e, t) {
              return e in t
          }
          function Kt(e, t) {
              var i = t[e];
              return void 0 === i ? null : i
          }
          function Jt(e) {
              return {
                  type: e
              }
          }
          function Qt(e) {
              return {
                  result: "success",
                  value: e
              }
          }
          function ei(e) {
              return {
                  result: "error",
                  value: e
              }
          }
          function ti(e) {
              return "data-driven" === e["property-type"] || "cross-faded-data-driven" === e["property-type"]
          }
          function ii(e) {
              return !!e.expression && e.expression.parameters.indexOf("zoom") > -1
          }
          function ni(e) {
              return !!e.expression && e.expression.interpolated
          }
          function ri(e) {
              return e instanceof Number ? "number" : e instanceof String ? "string" : e instanceof Boolean ? "boolean" : Array.isArray(e) ? "array" : null === e ? "null" : typeof e
          }
          function oi(e) {
              return "object" == typeof e && null !== e && !Array.isArray(e)
          }
          function si(e) {
              return e
          }
          function ai(e, t, i) {
              return void 0 !== e ? e : void 0 !== t ? t : void 0 !== i ? i : void 0
          }
          function li(e, t, i, n, r) {
              return ai(typeof i === r ? n[i] : void 0, e.default, t.default)
          }
          function ci(e, t, i) {
              if ("number" !== ri(i))
                  return ai(e.default, t.default);
              var n = e.stops.length;
              if (1 === n)
                  return e.stops[0][1];
              if (i <= e.stops[0][0])
                  return e.stops[0][1];
              if (i >= e.stops[n - 1][0])
                  return e.stops[n - 1][1];
              var r = di(e.stops, i);
              return e.stops[r][1]
          }
          function ui(e, t, i) {
              var n = void 0 !== e.base ? e.base : 1;
              if ("number" !== ri(i))
                  return ai(e.default, t.default);
              var r = e.stops.length;
              if (1 === r)
                  return e.stops[0][1];
              if (i <= e.stops[0][0])
                  return e.stops[0][1];
              if (i >= e.stops[r - 1][0])
                  return e.stops[r - 1][1];
              var o = di(e.stops, i)
                , s = function(e, t, i, n) {
                  var r = n - i
                    , o = e - i;
                  return 0 === r ? 0 : 1 === t ? o / r : (Math.pow(t, o) - 1) / (Math.pow(t, r) - 1)
              }(i, n, e.stops[o][0], e.stops[o + 1][0])
                , a = e.stops[o][1]
                , l = e.stops[o + 1][1]
                , c = ut[t.type] || si;
              if (e.colorSpace && "rgb" !== e.colorSpace) {
                  var u = At[e.colorSpace];
                  c = function(e, t) {
                      return u.reverse(u.interpolate(u.forward(e), u.forward(t), s))
                  }
              }
              return "function" == typeof a.evaluate ? {
                  evaluate: function() {
                      for (var e = [], t = arguments.length; t--; )
                          e[t] = arguments[t];
                      var i = a.evaluate.apply(void 0, e)
                        , n = l.evaluate.apply(void 0, e);
                      if (void 0 !== i && void 0 !== n)
                          return c(i, n, s)
                  }
              } : c(a, l, s)
          }
          function hi(e, t, i) {
              return "color" === t.type ? i = je.parse(i) : "formatted" === t.type ? i = Ue.fromString(i.toString()) : ri(i) === t.type || "enum" === t.type && t.values[i] || (i = void 0),
              ai(i, e.default, t.default)
          }
          function di(e, t) {
              for (var i, n, r = 0, o = e.length - 1, s = 0; r <= o; ) {
                  if (i = e[s = Math.floor((r + o) / 2)][0],
                  n = e[s + 1][0],
                  t === i || t > i && t < n)
                      return s;
                  i < t ? r = s + 1 : i > t && (o = s - 1)
              }
              return Math.max(s - 1, 0)
          }
          et.register(Xt, {
              error: [{
                  kind: "error"
              }, [Te], function(e, t) {
                  var i = t[0];
                  throw new $e(i.evaluate(e))
              }
              ],
              typeof: [Te, [Pe], function(e, t) {
                  return ze(He(t[0].evaluate(e)))
              }
              ],
              "to-rgba": [Oe(Ee, 4), [Le], function(e, t) {
                  return t[0].evaluate(e).toArray()
              }
              ],
              rgb: [Le, [Ee, Ee, Ee], Zt],
              rgba: [Le, [Ee, Ee, Ee, Ee], Zt],
              has: {
                  type: Ce,
                  overloads: [[[Te], function(e, t) {
                      return Yt(t[0].evaluate(e), e.properties())
                  }
                  ], [[Te, Ae], function(e, t) {
                      var i = t[0]
                        , n = t[1];
                      return Yt(i.evaluate(e), n.evaluate(e))
                  }
                  ]]
              },
              get: {
                  type: Pe,
                  overloads: [[[Te], function(e, t) {
                      return Kt(t[0].evaluate(e), e.properties())
                  }
                  ], [[Te, Ae], function(e, t) {
                      var i = t[0]
                        , n = t[1];
                      return Kt(i.evaluate(e), n.evaluate(e))
                  }
                  ]]
              },
              "feature-state": [Pe, [Te], function(e, t) {
                  return Kt(t[0].evaluate(e), e.featureState || {})
              }
              ],
              properties: [Ae, [], function(e) {
                  return e.properties()
              }
              ],
              "geometry-type": [Te, [], function(e) {
                  return e.geometryType()
              }
              ],
              id: [Pe, [], function(e) {
                  return e.id()
              }
              ],
              zoom: [Ee, [], function(e) {
                  return e.globals.zoom
              }
              ],
              "heatmap-density": [Ee, [], function(e) {
                  return e.globals.heatmapDensity || 0
              }
              ],
              "line-progress": [Ee, [], function(e) {
                  return e.globals.lineProgress || 0
              }
              ],
              accumulated: [Pe, [], function(e) {
                  return void 0 === e.globals.accumulated ? null : e.globals.accumulated
              }
              ],
              "+": [Ee, Jt(Ee), function(e, t) {
                  for (var i = 0, n = 0, r = t; n < r.length; n += 1)
                      i += r[n].evaluate(e);
                  return i
              }
              ],
              "*": [Ee, Jt(Ee), function(e, t) {
                  for (var i = 1, n = 0, r = t; n < r.length; n += 1)
                      i *= r[n].evaluate(e);
                  return i
              }
              ],
              "-": {
                  type: Ee,
                  overloads: [[[Ee, Ee], function(e, t) {
                      var i = t[0]
                        , n = t[1];
                      return i.evaluate(e) - n.evaluate(e)
                  }
                  ], [[Ee], function(e, t) {
                      return -t[0].evaluate(e)
                  }
                  ]]
              },
              "/": [Ee, [Ee, Ee], function(e, t) {
                  var i = t[0]
                    , n = t[1];
                  return i.evaluate(e) / n.evaluate(e)
              }
              ],
              "%": [Ee, [Ee, Ee], function(e, t) {
                  var i = t[0]
                    , n = t[1];
                  return i.evaluate(e) % n.evaluate(e)
              }
              ],
              ln2: [Ee, [], function() {
                  return Math.LN2
              }
              ],
              pi: [Ee, [], function() {
                  return Math.PI
              }
              ],
              e: [Ee, [], function() {
                  return Math.E
              }
              ],
              "^": [Ee, [Ee, Ee], function(e, t) {
                  var i = t[0]
                    , n = t[1];
                  return Math.pow(i.evaluate(e), n.evaluate(e))
              }
              ],
              sqrt: [Ee, [Ee], function(e, t) {
                  var i = t[0];
                  return Math.sqrt(i.evaluate(e))
              }
              ],
              log10: [Ee, [Ee], function(e, t) {
                  var i = t[0];
                  return Math.log(i.evaluate(e)) / Math.LN10
              }
              ],
              ln: [Ee, [Ee], function(e, t) {
                  var i = t[0];
                  return Math.log(i.evaluate(e))
              }
              ],
              log2: [Ee, [Ee], function(e, t) {
                  var i = t[0];
                  return Math.log(i.evaluate(e)) / Math.LN2
              }
              ],
              sin: [Ee, [Ee], function(e, t) {
                  var i = t[0];
                  return Math.sin(i.evaluate(e))
              }
              ],
              cos: [Ee, [Ee], function(e, t) {
                  var i = t[0];
                  return Math.cos(i.evaluate(e))
              }
              ],
              tan: [Ee, [Ee], function(e, t) {
                  var i = t[0];
                  return Math.tan(i.evaluate(e))
              }
              ],
              asin: [Ee, [Ee], function(e, t) {
                  var i = t[0];
                  return Math.asin(i.evaluate(e))
              }
              ],
              acos: [Ee, [Ee], function(e, t) {
                  var i = t[0];
                  return Math.acos(i.evaluate(e))
              }
              ],
              atan: [Ee, [Ee], function(e, t) {
                  var i = t[0];
                  return Math.atan(i.evaluate(e))
              }
              ],
              min: [Ee, Jt(Ee), function(e, t) {
                  return Math.min.apply(Math, t.map(function(t) {
                      return t.evaluate(e)
                  }))
              }
              ],
              max: [Ee, Jt(Ee), function(e, t) {
                  return Math.max.apply(Math, t.map(function(t) {
                      return t.evaluate(e)
                  }))
              }
              ],
              abs: [Ee, [Ee], function(e, t) {
                  var i = t[0];
                  return Math.abs(i.evaluate(e))
              }
              ],
              round: [Ee, [Ee], function(e, t) {
                  var i = t[0].evaluate(e);
                  return i < 0 ? -Math.round(-i) : Math.round(i)
              }
              ],
              floor: [Ee, [Ee], function(e, t) {
                  var i = t[0];
                  return Math.floor(i.evaluate(e))
              }
              ],
              ceil: [Ee, [Ee], function(e, t) {
                  var i = t[0];
                  return Math.ceil(i.evaluate(e))
              }
              ],
              "filter-==": [Ce, [Te, Pe], function(e, t) {
                  var i = t[0]
                    , n = t[1];
                  return e.properties()[i.value] === n.value
              }
              ],
              "filter-id-==": [Ce, [Pe], function(e, t) {
                  var i = t[0];
                  return e.id() === i.value
              }
              ],
              "filter-type-==": [Ce, [Te], function(e, t) {
                  var i = t[0];
                  return e.geometryType() === i.value
              }
              ],
              "filter-<": [Ce, [Te, Pe], function(e, t) {
                  var i = t[0]
                    , n = t[1]
                    , r = e.properties()[i.value]
                    , o = n.value;
                  return typeof r == typeof o && r < o
              }
              ],
              "filter-id-<": [Ce, [Pe], function(e, t) {
                  var i = t[0]
                    , n = e.id()
                    , r = i.value;
                  return typeof n == typeof r && n < r
              }
              ],
              "filter->": [Ce, [Te, Pe], function(e, t) {
                  var i = t[0]
                    , n = t[1]
                    , r = e.properties()[i.value]
                    , o = n.value;
                  return typeof r == typeof o && r > o
              }
              ],
              "filter-id->": [Ce, [Pe], function(e, t) {
                  var i = t[0]
                    , n = e.id()
                    , r = i.value;
                  return typeof n == typeof r && n > r
              }
              ],
              "filter-<=": [Ce, [Te, Pe], function(e, t) {
                  var i = t[0]
                    , n = t[1]
                    , r = e.properties()[i.value]
                    , o = n.value;
                  return typeof r == typeof o && r <= o
              }
              ],
              "filter-id-<=": [Ce, [Pe], function(e, t) {
                  var i = t[0]
                    , n = e.id()
                    , r = i.value;
                  return typeof n == typeof r && n <= r
              }
              ],
              "filter->=": [Ce, [Te, Pe], function(e, t) {
                  var i = t[0]
                    , n = t[1]
                    , r = e.properties()[i.value]
                    , o = n.value;
                  return typeof r == typeof o && r >= o
              }
              ],
              "filter-id->=": [Ce, [Pe], function(e, t) {
                  var i = t[0]
                    , n = e.id()
                    , r = i.value;
                  return typeof n == typeof r && n >= r
              }
              ],
              "filter-has": [Ce, [Pe], function(e, t) {
                  return t[0].value in e.properties()
              }
              ],
              "filter-has-id": [Ce, [], function(e) {
                  return null !== e.id()
              }
              ],
              "filter-type-in": [Ce, [Oe(Te)], function(e, t) {
                  return t[0].value.indexOf(e.geometryType()) >= 0
              }
              ],
              "filter-id-in": [Ce, [Oe(Pe)], function(e, t) {
                  return t[0].value.indexOf(e.id()) >= 0
              }
              ],
              "filter-in-small": [Ce, [Te, Oe(Pe)], function(e, t) {
                  var i = t[0];
                  return t[1].value.indexOf(e.properties()[i.value]) >= 0
              }
              ],
              "filter-in-large": [Ce, [Te, Oe(Pe)], function(e, t) {
                  var i = t[0]
                    , n = t[1];
                  return function(e, t, i, n) {
                      for (; i <= n; ) {
                          var r = i + n >> 1;
                          if (t[r] === e)
                              return !0;
                          t[r] > e ? n = r - 1 : i = r + 1
                      }
                      return !1
                  }(e.properties()[i.value], n.value, 0, n.value.length - 1)
              }
              ],
              all: {
                  type: Ce,
                  overloads: [[[Ce, Ce], function(e, t) {
                      var i = t[0]
                        , n = t[1];
                      return i.evaluate(e) && n.evaluate(e)
                  }
                  ], [Jt(Ce), function(e, t) {
                      for (var i = 0, n = t; i < n.length; i += 1)
                          if (!n[i].evaluate(e))
                              return !1;
                      return !0
                  }
                  ]]
              },
              any: {
                  type: Ce,
                  overloads: [[[Ce, Ce], function(e, t) {
                      var i = t[0]
                        , n = t[1];
                      return i.evaluate(e) || n.evaluate(e)
                  }
                  ], [Jt(Ce), function(e, t) {
                      for (var i = 0, n = t; i < n.length; i += 1)
                          if (n[i].evaluate(e))
                              return !0;
                      return !1
                  }
                  ]]
              },
              "!": [Ce, [Ce], function(e, t) {
                  return !t[0].evaluate(e)
              }
              ],
              "is-supported-script": [Ce, [Te], function(e, t) {
                  var i = t[0]
                    , n = e.globals && e.globals.isSupportedScript;
                  return !n || n(i.evaluate(e))
              }
              ],
              upcase: [Te, [Te], function(e, t) {
                  return t[0].evaluate(e).toUpperCase()
              }
              ],
              downcase: [Te, [Te], function(e, t) {
                  return t[0].evaluate(e).toLowerCase()
              }
              ],
              concat: [Te, Jt(Pe), function(e, t) {
                  return t.map(function(t) {
                      return Ve(t.evaluate(e))
                  }).join("")
              }
              ],
              "resolved-locale": [Te, [Ie], function(e, t) {
                  return t[0].evaluate(e).resolvedLocale()
              }
              ]
          });
          var pi = function(e, t) {
              var i;
              this.expression = e,
              this._warningHistory = {},
              this._evaluator = new Qe,
              this._defaultValue = t ? "color" === (i = t).type && oi(i.default) ? new je(0,0,0,0) : "color" === i.type ? je.parse(i.default) || null : void 0 === i.default ? null : i.default : null,
              this._enumValues = t && "enum" === t.type ? t.values : null
          };
          function fi(e) {
              return Array.isArray(e) && e.length > 0 && "string" == typeof e[0] && e[0]in Xt
          }
          function mi(e, t) {
              var i = new st(Xt,[],t ? function(e) {
                  var t = {
                      color: Le,
                      string: Te,
                      number: Ee,
                      enum: Te,
                      boolean: Ce,
                      formatted: Me
                  };
                  return "array" === e.type ? Oe(t[e.value] || Pe, e.length) : t[e.type]
              }(t) : void 0)
                , n = i.parse(e, void 0, void 0, void 0, t && "string" === t.type ? {
                  typeAnnotation: "coerce"
              } : void 0);
              return n ? Qt(new pi(n,t)) : ei(i.errors)
          }
          pi.prototype.evaluateWithoutErrorHandling = function(e, t, i) {
              return this._evaluator.globals = e,
              this._evaluator.feature = t,
              this._evaluator.featureState = i,
              this.expression.evaluate(this._evaluator)
          }
          ,
          pi.prototype.evaluate = function(e, t, i) {
              this._evaluator.globals = e,
              this._evaluator.feature = t || null,
              this._evaluator.featureState = i || null;
              try {
                  var n = this.expression.evaluate(this._evaluator);
                  if (null == n)
                      return this._defaultValue;
                  if (this._enumValues && !(n in this._enumValues))
                      throw new $e("Expected value to be one of " + Object.keys(this._enumValues).map(function(e) {
                          return JSON.stringify(e)
                      }).join(", ") + ", but found " + JSON.stringify(n) + " instead.");
                  return n
              } catch (e) {
                  return this._warningHistory[e.message] || (this._warningHistory[e.message] = !0,
                  "undefined" != typeof console && console.warn(e.message)),
                  this._defaultValue
              }
          }
          ;
          var gi = function(e, t) {
              this.kind = e,
              this._styleExpression = t,
              this.isStateDependent = "constant" !== e && !nt(t.expression)
          };
          gi.prototype.evaluateWithoutErrorHandling = function(e, t, i) {
              return this._styleExpression.evaluateWithoutErrorHandling(e, t, i)
          }
          ,
          gi.prototype.evaluate = function(e, t, i) {
              return this._styleExpression.evaluate(e, t, i)
          }
          ;
          var vi = function(e, t, i) {
              this.kind = e,
              this.zoomStops = i.labels,
              this._styleExpression = t,
              this.isStateDependent = "camera" !== e && !nt(t.expression),
              i instanceof Pt && (this._interpolationType = i.interpolation)
          };
          function yi(e, t) {
              if ("error" === (e = mi(e, t)).result)
                  return e;
              var i = e.value.expression
                , n = it(i);
              if (!n && !ti(t))
                  return ei([new xe("","data expressions not supported")]);
              var r = rt(i, ["zoom"]);
              if (!r && !ii(t))
                  return ei([new xe("","zoom expressions not supported")]);
              var o = function e(t) {
                  var i = null;
                  if (t instanceof Ot)
                      i = e(t.result);
                  else if (t instanceof Mt)
                      for (var n = 0, r = t.args; n < r.length; n += 1) {
                          var o = r[n];
                          if (i = e(o))
                              break
                      }
                  else
                      (t instanceof lt || t instanceof Pt) && t.input instanceof et && "zoom" === t.input.name && (i = t);
                  return i instanceof xe ? i : (t.eachChild(function(t) {
                      var n = e(t);
                      n instanceof xe ? i = n : !i && n ? i = new xe("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : i && n && i !== n && (i = new xe("",'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'))
                  }),
                  i)
              }(i);
              return o || r ? o instanceof xe ? ei([o]) : o instanceof Pt && !ni(t) ? ei([new xe("",'"interpolate" expressions cannot be used with this property')]) : Qt(o ? new vi(n ? "camera" : "composite",e.value,o) : new gi(n ? "constant" : "source",e.value)) : ei([new xe("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')])
          }
          vi.prototype.evaluateWithoutErrorHandling = function(e, t, i) {
              return this._styleExpression.evaluateWithoutErrorHandling(e, t, i)
          }
          ,
          vi.prototype.evaluate = function(e, t, i) {
              return this._styleExpression.evaluate(e, t, i)
          }
          ,
          vi.prototype.interpolationFactor = function(e, t, i) {
              return this._interpolationType ? Pt.interpolationFactor(this._interpolationType, e, t, i) : 0
          }
          ;
          var _i = function(e, t) {
              this._parameters = e,
              this._specification = t,
              _e(this, function e(t, i) {
                  var n, r, o, s = "color" === i.type, a = t.stops && "object" == typeof t.stops[0][0], l = a || void 0 !== t.property, c = a || !l, u = t.type || (ni(i) ? "exponential" : "interval");
                  if (s && ((t = _e({}, t)).stops && (t.stops = t.stops.map(function(e) {
                      return [e[0], je.parse(e[1])]
                  })),
                  t.default ? t.default = je.parse(t.default) : t.default = je.parse(i.default)),
                  t.colorSpace && "rgb" !== t.colorSpace && !At[t.colorSpace])
                      throw new Error("Unknown color space: " + t.colorSpace);
                  if ("exponential" === u)
                      n = ui;
                  else if ("interval" === u)
                      n = ci;
                  else if ("categorical" === u) {
                      n = li,
                      r = Object.create(null);
                      for (var h = 0, d = t.stops; h < d.length; h += 1) {
                          var p = d[h];
                          r[p[0]] = p[1]
                      }
                      o = typeof t.stops[0][0]
                  } else {
                      if ("identity" !== u)
                          throw new Error('Unknown function type "' + u + '"');
                      n = hi
                  }
                  if (a) {
                      for (var f = {}, m = [], g = 0; g < t.stops.length; g++) {
                          var v = t.stops[g]
                            , y = v[0].zoom;
                          void 0 === f[y] && (f[y] = {
                              zoom: y,
                              type: t.type,
                              property: t.property,
                              default: t.default,
                              stops: []
                          },
                          m.push(y)),
                          f[y].stops.push([v[0].value, v[1]])
                      }
                      for (var _ = [], b = 0, w = m; b < w.length; b += 1) {
                          var x = w[b];
                          _.push([f[x].zoom, e(f[x], i)])
                      }
                      return {
                          kind: "composite",
                          interpolationFactor: Pt.interpolationFactor.bind(void 0, {
                              name: "linear"
                          }),
                          zoomStops: _.map(function(e) {
                              return e[0]
                          }),
                          evaluate: function(e, n) {
                              var r = e.zoom;
                              return ui({
                                  stops: _,
                                  base: t.base
                              }, i, r).evaluate(r, n)
                          }
                      }
                  }
                  return c ? {
                      kind: "camera",
                      interpolationFactor: "exponential" === u ? Pt.interpolationFactor.bind(void 0, {
                          name: "exponential",
                          base: void 0 !== t.base ? t.base : 1
                      }) : function() {
                          return 0
                      }
                      ,
                      zoomStops: t.stops.map(function(e) {
                          return e[0]
                      }),
                      evaluate: function(e) {
                          var s = e.zoom;
                          return n(t, i, s, r, o)
                      }
                  } : {
                      kind: "source",
                      evaluate: function(e, s) {
                          var a = s && s.properties ? s.properties[t.property] : void 0;
                          return void 0 === a ? ai(t.default, i.default) : n(t, i, a, r, o)
                      }
                  }
              }(this._parameters, this._specification))
          };
          function bi(e, t) {
              if (oi(e))
                  return new _i(e,t);
              if (fi(e)) {
                  var i = yi(e, t);
                  if ("error" === i.result)
                      throw new Error(i.value.map(function(e) {
                          return e.key + ": " + e.message
                      }).join(", "));
                  return i.value
              }
              var n = e;
              return "string" == typeof e && "color" === t.type && (n = je.parse(e)),
              {
                  kind: "constant",
                  evaluate: function() {
                      return n
                  }
              }
          }
          function wi(e) {
              var t = e.key
                , i = e.value
                , n = e.valueSpec || {}
                , r = e.objectElementValidators || {}
                , o = e.style
                , s = e.styleSpec
                , a = []
                , l = ri(i);
              if ("object" !== l)
                  return [new ve(t,i,"object expected, " + l + " found")];
              for (var c in i) {
                  var u = c.split(".")[0]
                    , h = n[u] || n["*"]
                    , d = void 0;
                  if (r[u])
                      d = r[u];
                  else if (n[u])
                      d = Wi;
                  else if (r["*"])
                      d = r["*"];
                  else {
                      if (!n["*"]) {
                          a.push(new ve(t,i[c],'unknown property "' + c + '"'));
                          continue
                      }
                      d = Wi
                  }
                  a = a.concat(d({
                      key: (t ? t + "." : t) + c,
                      value: i[c],
                      valueSpec: h,
                      style: o,
                      styleSpec: s,
                      object: i,
                      objectKey: c
                  }, i))
              }
              for (var p in n)
                  r[p] || n[p].required && void 0 === n[p].default && void 0 === i[p] && a.push(new ve(t,i,'missing required property "' + p + '"'));
              return a
          }
          function xi(e) {
              var t = e.value
                , i = e.valueSpec
                , n = e.style
                , r = e.styleSpec
                , o = e.key
                , s = e.arrayElementValidator || Wi;
              if ("array" !== ri(t))
                  return [new ve(o,t,"array expected, " + ri(t) + " found")];
              if (i.length && t.length !== i.length)
                  return [new ve(o,t,"array length " + i.length + " expected, length " + t.length + " found")];
              if (i["min-length"] && t.length < i["min-length"])
                  return [new ve(o,t,"array length at least " + i["min-length"] + " expected, length " + t.length + " found")];
              var a = {
                  type: i.value
              };
              r.$version < 7 && (a.function = i.function),
              "object" === ri(i.value) && (a = i.value);
              for (var l = [], c = 0; c < t.length; c++)
                  l = l.concat(s({
                      array: t,
                      arrayIndex: c,
                      value: t[c],
                      valueSpec: a,
                      style: n,
                      styleSpec: r,
                      key: o + "[" + c + "]"
                  }));
              return l
          }
          function ki(e) {
              var t = e.key
                , i = e.value
                , n = e.valueSpec
                , r = ri(i);
              return "number" !== r ? [new ve(t,i,"number expected, " + r + " found")] : "minimum"in n && i < n.minimum ? [new ve(t,i,i + " is less than the minimum value " + n.minimum)] : "maximum"in n && i > n.maximum ? [new ve(t,i,i + " is greater than the maximum value " + n.maximum)] : []
          }
          function Si(e) {
              var t, i, n, r = e.valueSpec, o = be(e.value.type), s = {}, a = "categorical" !== o && void 0 === e.value.property, l = !a, c = "array" === ri(e.value.stops) && "array" === ri(e.value.stops[0]) && "object" === ri(e.value.stops[0][0]), u = wi({
                  key: e.key,
                  value: e.value,
                  valueSpec: e.styleSpec.function,
                  style: e.style,
                  styleSpec: e.styleSpec,
                  objectElementValidators: {
                      stops: function(e) {
                          if ("identity" === o)
                              return [new ve(e.key,e.value,'identity function may not have a "stops" property')];
                          var t = []
                            , i = e.value;
                          return t = t.concat(xi({
                              key: e.key,
                              value: i,
                              valueSpec: e.valueSpec,
                              style: e.style,
                              styleSpec: e.styleSpec,
                              arrayElementValidator: h
                          })),
                          "array" === ri(i) && 0 === i.length && t.push(new ve(e.key,i,"array must have at least one stop")),
                          t
                      },
                      default: function(e) {
                          return Wi({
                              key: e.key,
                              value: e.value,
                              valueSpec: r,
                              style: e.style,
                              styleSpec: e.styleSpec
                          })
                      }
                  }
              });
              return "identity" === o && a && u.push(new ve(e.key,e.value,'missing required property "property"')),
              "identity" === o || e.value.stops || u.push(new ve(e.key,e.value,'missing required property "stops"')),
              "exponential" === o && e.valueSpec.expression && !ni(e.valueSpec) && u.push(new ve(e.key,e.value,"exponential functions not supported")),
              e.styleSpec.$version >= 8 && (l && !ti(e.valueSpec) ? u.push(new ve(e.key,e.value,"property functions not supported")) : a && !ii(e.valueSpec) && u.push(new ve(e.key,e.value,"zoom functions not supported"))),
              "categorical" !== o && !c || void 0 !== e.value.property || u.push(new ve(e.key,e.value,'"property" property is required')),
              u;
              function h(e) {
                  var t = []
                    , o = e.value
                    , a = e.key;
                  if ("array" !== ri(o))
                      return [new ve(a,o,"array expected, " + ri(o) + " found")];
                  if (2 !== o.length)
                      return [new ve(a,o,"array length 2 expected, length " + o.length + " found")];
                  if (c) {
                      if ("object" !== ri(o[0]))
                          return [new ve(a,o,"object expected, " + ri(o[0]) + " found")];
                      if (void 0 === o[0].zoom)
                          return [new ve(a,o,"object stop key must have zoom")];
                      if (void 0 === o[0].value)
                          return [new ve(a,o,"object stop key must have value")];
                      if (n && n > be(o[0].zoom))
                          return [new ve(a,o[0].zoom,"stop zoom values must appear in ascending order")];
                      be(o[0].zoom) !== n && (n = be(o[0].zoom),
                      i = void 0,
                      s = {}),
                      t = t.concat(wi({
                          key: a + "[0]",
                          value: o[0],
                          valueSpec: {
                              zoom: {}
                          },
                          style: e.style,
                          styleSpec: e.styleSpec,
                          objectElementValidators: {
                              zoom: ki,
                              value: d
                          }
                      }))
                  } else
                      t = t.concat(d({
                          key: a + "[0]",
                          value: o[0],
                          valueSpec: {},
                          style: e.style,
                          styleSpec: e.styleSpec
                      }, o));
                  return fi(we(o[1])) ? t.concat([new ve(a + "[1]",o[1],"expressions are not allowed in function stops.")]) : t.concat(Wi({
                      key: a + "[1]",
                      value: o[1],
                      valueSpec: r,
                      style: e.style,
                      styleSpec: e.styleSpec
                  }))
              }
              function d(e, n) {
                  var a = ri(e.value)
                    , l = be(e.value)
                    , c = null !== e.value ? e.value : n;
                  if (t) {
                      if (a !== t)
                          return [new ve(e.key,c,a + " stop domain type must match previous stop domain type " + t)]
                  } else
                      t = a;
                  if ("number" !== a && "string" !== a && "boolean" !== a)
                      return [new ve(e.key,c,"stop domain value must be a number, string, or boolean")];
                  if ("number" !== a && "categorical" !== o) {
                      var u = "number expected, " + a + " found";
                      return ti(r) && void 0 === o && (u += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'),
                      [new ve(e.key,c,u)]
                  }
                  return "categorical" !== o || "number" !== a || isFinite(l) && Math.floor(l) === l ? "categorical" !== o && "number" === a && void 0 !== i && l < i ? [new ve(e.key,c,"stop domain values must appear in ascending order")] : (i = l,
                  "categorical" === o && l in s ? [new ve(e.key,c,"stop domain values must be unique")] : (s[l] = !0,
                  [])) : [new ve(e.key,c,"integer expected, found " + l)]
              }
          }
          function Ei(e) {
              var t = ("property" === e.expressionContext ? yi : mi)(we(e.value), e.valueSpec);
              if ("error" === t.result)
                  return t.value.map(function(t) {
                      return new ve("" + e.key + t.key,e.value,t.message)
                  });
              var i = t.value.expression || t.value._styleExpression.expression;
              if ("property" === e.expressionContext && "text-font" === e.propertyKey && -1 !== i.possibleOutputs().indexOf(void 0))
                  return [new ve(e.key,e.value,'Invalid data expression for "' + e.propertyKey + '". Output values must be contained as literals within the expression.')];
              if ("property" === e.expressionContext && "layout" === e.propertyType && !nt(i))
                  return [new ve(e.key,e.value,'"feature-state" data expressions are not supported with layout properties.')];
              if ("filter" === e.expressionContext && !nt(i))
                  return [new ve(e.key,e.value,'"feature-state" data expressions are not supported with filters.')];
              if (e.expressionContext && 0 === e.expressionContext.indexOf("cluster")) {
                  if (!rt(i, ["zoom", "feature-state"]))
                      return [new ve(e.key,e.value,'"zoom" and "feature-state" expressions are not supported with cluster properties.')];
                  if ("cluster-initial" === e.expressionContext && !it(i))
                      return [new ve(e.key,e.value,"Feature data expressions are not supported with initial expression part of cluster properties.")]
              }
              return []
          }
          function Ti(e) {
              var t = e.key
                , i = e.value
                , n = e.valueSpec
                , r = [];
              return Array.isArray(n.values) ? -1 === n.values.indexOf(be(i)) && r.push(new ve(t,i,"expected one of [" + n.values.join(", ") + "], " + JSON.stringify(i) + " found")) : -1 === Object.keys(n.values).indexOf(be(i)) && r.push(new ve(t,i,"expected one of [" + Object.keys(n.values).join(", ") + "], " + JSON.stringify(i) + " found")),
              r
          }
          function Ci(e) {
              if (!0 === e || !1 === e)
                  return !0;
              if (!Array.isArray(e) || 0 === e.length)
                  return !1;
              switch (e[0]) {
              case "has":
                  return e.length >= 2 && "$id" !== e[1] && "$type" !== e[1];
              case "in":
              case "!in":
              case "!has":
              case "none":
                  return !1;
              case "==":
              case "!=":
              case ">":
              case ">=":
              case "<":
              case "<=":
                  return 3 !== e.length || Array.isArray(e[1]) || Array.isArray(e[2]);
              case "any":
              case "all":
                  for (var t = 0, i = e.slice(1); t < i.length; t += 1) {
                      var n = i[t];
                      if (!Ci(n) && "boolean" != typeof n)
                          return !1
                  }
                  return !0;
              default:
                  return !0
              }
          }
          _i.deserialize = function(e) {
              return new _i(e._parameters,e._specification)
          }
          ,
          _i.serialize = function(e) {
              return {
                  _parameters: e._parameters,
                  _specification: e._specification
              }
          }
          ;
          var Li = {
              type: "boolean",
              default: !1,
              transition: !1,
              "property-type": "data-driven",
              expression: {
                  interpolated: !1,
                  parameters: ["zoom", "feature"]
              }
          };
          function Ai(e) {
              if (null == e)
                  return function() {
                      return !0
                  }
                  ;
              Ci(e) || (e = Ii(e));
              var t = mi(e, Li);
              if ("error" === t.result)
                  throw new Error(t.value.map(function(e) {
                      return e.key + ": " + e.message
                  }).join(", "));
              return function(e, i) {
                  return t.value.evaluate(e, i)
              }
          }
          function Pi(e, t) {
              return e < t ? -1 : e > t ? 1 : 0
          }
          function Ii(e) {
              if (!e)
                  return !0;
              var t, i = e[0];
              return e.length <= 1 ? "any" !== i : "==" === i ? Mi(e[1], e[2], "==") : "!=" === i ? Di(Mi(e[1], e[2], "==")) : "<" === i || ">" === i || "<=" === i || ">=" === i ? Mi(e[1], e[2], i) : "any" === i ? (t = e.slice(1),
              ["any"].concat(t.map(Ii))) : "all" === i ? ["all"].concat(e.slice(1).map(Ii)) : "none" === i ? ["all"].concat(e.slice(1).map(Ii).map(Di)) : "in" === i ? Oi(e[1], e.slice(2)) : "!in" === i ? Di(Oi(e[1], e.slice(2))) : "has" === i ? zi(e[1]) : "!has" !== i || Di(zi(e[1]))
          }
          function Mi(e, t, i) {
              switch (e) {
              case "$type":
                  return ["filter-type-" + i, t];
              case "$id":
                  return ["filter-id-" + i, t];
              default:
                  return ["filter-" + i, e, t]
              }
          }
          function Oi(e, t) {
              if (0 === t.length)
                  return !1;
              switch (e) {
              case "$type":
                  return ["filter-type-in", ["literal", t]];
              case "$id":
                  return ["filter-id-in", ["literal", t]];
              default:
                  return t.length > 200 && !t.some(function(e) {
                      return typeof e != typeof t[0]
                  }) ? ["filter-in-large", e, ["literal", t.sort(Pi)]] : ["filter-in-small", e, ["literal", t]]
              }
          }
          function zi(e) {
              switch (e) {
              case "$type":
                  return !0;
              case "$id":
                  return ["filter-has-id"];
              default:
                  return ["filter-has", e]
              }
          }
          function Di(e) {
              return ["!", e]
          }
          function Ri(e) {
              return Ci(we(e.value)) ? Ei(_e({}, e, {
                  expressionContext: "filter",
                  valueSpec: {
                      value: "boolean"
                  }
              })) : function e(t) {
                  var i = t.value
                    , n = t.key;
                  if ("array" !== ri(i))
                      return [new ve(n,i,"array expected, " + ri(i) + " found")];
                  var r, o = t.styleSpec, s = [];
                  if (i.length < 1)
                      return [new ve(n,i,"filter array must have at least 1 element")];
                  switch (s = s.concat(Ti({
                      key: n + "[0]",
                      value: i[0],
                      valueSpec: o.filter_operator,
                      style: t.style,
                      styleSpec: t.styleSpec
                  })),
                  be(i[0])) {
                  case "<":
                  case "<=":
                  case ">":
                  case ">=":
                      i.length >= 2 && "$type" === be(i[1]) && s.push(new ve(n,i,'"$type" cannot be use with operator "' + i[0] + '"'));
                  case "==":
                  case "!=":
                      3 !== i.length && s.push(new ve(n,i,'filter array for operator "' + i[0] + '" must have 3 elements'));
                  case "in":
                  case "!in":
                      i.length >= 2 && "string" !== (r = ri(i[1])) && s.push(new ve(n + "[1]",i[1],"string expected, " + r + " found"));
                      for (var a = 2; a < i.length; a++)
                          r = ri(i[a]),
                          "$type" === be(i[1]) ? s = s.concat(Ti({
                              key: n + "[" + a + "]",
                              value: i[a],
                              valueSpec: o.geometry_type,
                              style: t.style,
                              styleSpec: t.styleSpec
                          })) : "string" !== r && "number" !== r && "boolean" !== r && s.push(new ve(n + "[" + a + "]",i[a],"string, number, or boolean expected, " + r + " found"));
                      break;
                  case "any":
                  case "all":
                  case "none":
                      for (var l = 1; l < i.length; l++)
                          s = s.concat(e({
                              key: n + "[" + l + "]",
                              value: i[l],
                              style: t.style,
                              styleSpec: t.styleSpec
                          }));
                      break;
                  case "has":
                  case "!has":
                      r = ri(i[1]),
                      2 !== i.length ? s.push(new ve(n,i,'filter array for "' + i[0] + '" operator must have 2 elements')) : "string" !== r && s.push(new ve(n + "[1]",i[1],"string expected, " + r + " found"))
                  }
                  return s
              }(e)
          }
          function Bi(e, t) {
              var i = e.key
                , n = e.style
                , r = e.styleSpec
                , o = e.value
                , s = e.objectKey
                , a = r[t + "_" + e.layerType];
              if (!a)
                  return [];
              var l = s.match(/^(.*)-transition$/);
              if ("paint" === t && l && a[l[1]] && a[l[1]].transition)
                  return Wi({
                      key: i,
                      value: o,
                      valueSpec: r.transition,
                      style: n,
                      styleSpec: r
                  });
              var c, u = e.valueSpec || a[s];
              if (!u)
                  return [new ve(i,o,'unknown property "' + s + '"')];
              if ("string" === ri(o) && ti(u) && !u.tokens && (c = /^{([^}]+)}$/.exec(o)))
                  return [new ve(i,o,'"' + s + '" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": ' + JSON.stringify(c[1]) + " }`.")];
              var h = [];
              return "symbol" === e.layerType && ("text-field" === s && n && !n.glyphs && h.push(new ve(i,o,'use of "text-field" requires a style "glyphs" property')),
              "text-font" === s && oi(we(o)) && "identity" === be(o.type) && h.push(new ve(i,o,'"text-font" does not support identity functions'))),
              h.concat(Wi({
                  key: e.key,
                  value: o,
                  valueSpec: u,
                  style: n,
                  styleSpec: r,
                  expressionContext: "property",
                  propertyType: t,
                  propertyKey: s
              }))
          }
          function ji(e) {
              return Bi(e, "paint")
          }
          function Fi(e) {
              return Bi(e, "layout")
          }
          function Ni(e) {
              var t = []
                , i = e.value
                , n = e.key
                , r = e.style
                , o = e.styleSpec;
              i.type || i.ref || t.push(new ve(n,i,'either "type" or "ref" is required'));
              var s, a = be(i.type), l = be(i.ref);
              if (i.id)
                  for (var c = be(i.id), u = 0; u < e.arrayIndex; u++) {
                      var h = r.layers[u];
                      be(h.id) === c && t.push(new ve(n,i.id,'duplicate layer id "' + i.id + '", previously used at line ' + h.id.__line__))
                  }
              if ("ref"in i)
                  ["type", "source", "source-layer", "filter", "layout"].forEach(function(e) {
                      e in i && t.push(new ve(n,i[e],'"' + e + '" is prohibited for ref layers'))
                  }),
                  r.layers.forEach(function(e) {
                      be(e.id) === l && (s = e)
                  }),
                  s ? s.ref ? t.push(new ve(n,i.ref,"ref cannot reference another ref layer")) : a = be(s.type) : t.push(new ve(n,i.ref,'ref layer "' + l + '" not found'));
              else if ("background" !== a)
                  if (i.source) {
                      var d = r.sources && r.sources[i.source]
                        , p = d && be(d.type);
                      d ? "vector" === p && "raster" === a ? t.push(new ve(n,i.source,'layer "' + i.id + '" requires a raster source')) : "raster" === p && "raster" !== a ? t.push(new ve(n,i.source,'layer "' + i.id + '" requires a vector source')) : "vector" !== p || i["source-layer"] ? "raster-dem" === p && "hillshade" !== a ? t.push(new ve(n,i.source,"raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== a || !i.paint || !i.paint["line-gradient"] || "geojson" === p && d.lineMetrics || t.push(new ve(n,i,'layer "' + i.id + '" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.')) : t.push(new ve(n,i,'layer "' + i.id + '" must specify a "source-layer"')) : t.push(new ve(n,i.source,'source "' + i.source + '" not found'))
                  } else
                      t.push(new ve(n,i,'missing required property "source"'));
              return t = t.concat(wi({
                  key: n,
                  value: i,
                  valueSpec: o.layer,
                  style: e.style,
                  styleSpec: e.styleSpec,
                  objectElementValidators: {
                      "*": function() {
                          return []
                      },
                      type: function() {
                          return Wi({
                              key: n + ".type",
                              value: i.type,
                              valueSpec: o.layer.type,
                              style: e.style,
                              styleSpec: e.styleSpec,
                              object: i,
                              objectKey: "type"
                          })
                      },
                      filter: Ri,
                      layout: function(e) {
                          return wi({
                              layer: i,
                              key: e.key,
                              value: e.value,
                              style: e.style,
                              styleSpec: e.styleSpec,
                              objectElementValidators: {
                                  "*": function(e) {
                                      return Fi(_e({
                                          layerType: a
                                      }, e))
                                  }
                              }
                          })
                      },
                      paint: function(e) {
                          return wi({
                              layer: i,
                              key: e.key,
                              value: e.value,
                              style: e.style,
                              styleSpec: e.styleSpec,
                              objectElementValidators: {
                                  "*": function(e) {
                                      return ji(_e({
                                          layerType: a
                                      }, e))
                                  }
                              }
                          })
                      }
                  }
              }))
          }
          function Ui(e) {
              var t = e.value
                , i = e.key
                , n = e.styleSpec
                , r = e.style;
              if (!t.type)
                  return [new ve(i,t,'"type" is required')];
              var o, s = be(t.type);
              switch (s) {
              case "vector":
              case "raster":
              case "raster-dem":
                  if (o = wi({
                      key: i,
                      value: t,
                      valueSpec: n["source_" + s.replace("-", "_")],
                      style: e.style,
                      styleSpec: n
                  }),
                  "url"in t)
                      for (var a in t)
                          ["type", "url", "tileSize"].indexOf(a) < 0 && o.push(new ve(i + "." + a,t[a],'a source with a "url" property may not include a "' + a + '" property'));
                  return o;
              case "geojson":
                  if (o = wi({
                      key: i,
                      value: t,
                      valueSpec: n.source_geojson,
                      style: r,
                      styleSpec: n
                  }),
                  t.cluster)
                      for (var l in t.clusterProperties) {
                          var c = t.clusterProperties[l]
                            , u = c[0]
                            , h = c[1]
                            , d = "string" == typeof u ? [u, ["accumulated"], ["get", l]] : u;
                          o.push.apply(o, Ei({
                              key: i + "." + l + ".map",
                              value: h,
                              expressionContext: "cluster-map"
                          })),
                          o.push.apply(o, Ei({
                              key: i + "." + l + ".reduce",
                              value: d,
                              expressionContext: "cluster-reduce"
                          }))
                      }
                  return o;
              case "video":
                  return wi({
                      key: i,
                      value: t,
                      valueSpec: n.source_video,
                      style: r,
                      styleSpec: n
                  });
              case "image":
                  return wi({
                      key: i,
                      value: t,
                      valueSpec: n.source_image,
                      style: r,
                      styleSpec: n
                  });
              case "canvas":
                  return [new ve(i,null,"Please use runtime APIs to add canvas sources, rather than including them in stylesheets.","source.canvas")];
              default:
                  return Ti({
                      key: i + ".type",
                      value: t.type,
                      valueSpec: {
                          values: ["vector", "raster", "raster-dem", "geojson", "video", "image"]
                      },
                      style: r,
                      styleSpec: n
                  })
              }
          }
          function qi(e) {
              var t = e.value
                , i = e.styleSpec
                , n = i.light
                , r = e.style
                , o = []
                , s = ri(t);
              if (void 0 === t)
                  return o;
              if ("object" !== s)
                  return o.concat([new ve("light",t,"object expected, " + s + " found")]);
              for (var a in t) {
                  var l = a.match(/^(.*)-transition$/);
                  o = l && n[l[1]] && n[l[1]].transition ? o.concat(Wi({
                      key: a,
                      value: t[a],
                      valueSpec: i.transition,
                      style: r,
                      styleSpec: i
                  })) : n[a] ? o.concat(Wi({
                      key: a,
                      value: t[a],
                      valueSpec: n[a],
                      style: r,
                      styleSpec: i
                  })) : o.concat([new ve(a,t[a],'unknown property "' + a + '"')])
              }
              return o
          }
          function Hi(e) {
              var t = e.value
                , i = e.key
                , n = ri(t);
              return "string" !== n ? [new ve(i,t,"string expected, " + n + " found")] : []
          }
          var Vi = {
              "*": function() {
                  return []
              },
              array: xi,
              boolean: function(e) {
                  var t = e.value
                    , i = e.key
                    , n = ri(t);
                  return "boolean" !== n ? [new ve(i,t,"boolean expected, " + n + " found")] : []
              },
              number: ki,
              color: function(e) {
                  var t = e.key
                    , i = e.value
                    , n = ri(i);
                  return "string" !== n ? [new ve(t,i,"color expected, " + n + " found")] : null === Be(i) ? [new ve(t,i,'color expected, "' + i + '" found')] : []
              },
              constants: ye,
              enum: Ti,
              filter: Ri,
              function: Si,
              layer: Ni,
              object: wi,
              source: Ui,
              light: qi,
              string: Hi,
              formatted: function(e) {
                  return 0 === Hi(e).length ? [] : Ei(e)
              }
          };
          function Wi(e) {
              var t = e.value
                , i = e.valueSpec
                , n = e.styleSpec;
              return i.expression && oi(be(t)) ? Si(e) : i.expression && fi(we(t)) ? Ei(e) : i.type && Vi[i.type] ? Vi[i.type](e) : wi(_e({}, e, {
                  valueSpec: i.type ? n[i.type] : i
              }))
          }
          function $i(e) {
              var t = e.value
                , i = e.key
                , n = Hi(e);
              return n.length ? n : (-1 === t.indexOf("{fontstack}") && n.push(new ve(i,t,'"glyphs" url must include a "{fontstack}" token')),
              -1 === t.indexOf("{range}") && n.push(new ve(i,t,'"glyphs" url must include a "{range}" token')),
              n)
          }
          function Gi(e, t) {
              t = t || ge;
              var i = [];
              return i = i.concat(Wi({
                  key: "",
                  value: e,
                  valueSpec: t.$root,
                  styleSpec: t,
                  style: e,
                  objectElementValidators: {
                      glyphs: $i,
                      "*": function() {
                          return []
                      }
                  }
              })),
              e.constants && (i = i.concat(ye({
                  key: "constants",
                  value: e.constants,
                  style: e,
                  styleSpec: t
              }))),
              Xi(i)
          }
          function Xi(e) {
              return [].concat(e).sort(function(e, t) {
                  return e.line - t.line
              })
          }
          function Zi(e) {
              return function() {
                  for (var t = [], i = arguments.length; i--; )
                      t[i] = arguments[i];
                  return Xi(e.apply(this, t))
              }
          }
          Gi.source = Zi(Ui),
          Gi.light = Zi(qi),
          Gi.layer = Zi(Ni),
          Gi.filter = Zi(Ri),
          Gi.paintProperty = Zi(ji),
          Gi.layoutProperty = Zi(Fi);
          var Yi = Gi
            , Ki = Gi.light
            , Ji = Gi.paintProperty
            , Qi = Gi.layoutProperty;
          function en(e, t) {
              var i = !1;
              if (t && t.length)
                  for (var n = 0, r = t; n < r.length; n += 1) {
                      var o = r[n];
                      e.fire(new fe(new Error(o.message))),
                      i = !0
                  }
              return i
          }
          var tn = rn
            , nn = 3;
          function rn(e, t, i) {
              var n = this.cells = [];
              if (e instanceof ArrayBuffer) {
                  this.arrayBuffer = e;
                  var r = new Int32Array(this.arrayBuffer);
                  e = r[0],
                  t = r[1],
                  i = r[2],
                  this.d = t + 2 * i;
                  for (var o = 0; o < this.d * this.d; o++) {
                      var s = r[nn + o]
                        , a = r[nn + o + 1];
                      n.push(s === a ? null : r.subarray(s, a))
                  }
                  var l = r[nn + n.length]
                    , c = r[nn + n.length + 1];
                  this.keys = r.subarray(l, c),
                  this.bboxes = r.subarray(c),
                  this.insert = this._insertReadonly
              } else {
                  this.d = t + 2 * i;
                  for (var u = 0; u < this.d * this.d; u++)
                      n.push([]);
                  this.keys = [],
                  this.bboxes = []
              }
              this.n = t,
              this.extent = e,
              this.padding = i,
              this.scale = t / e,
              this.uid = 0;
              var h = i / t * e;
              this.min = -h,
              this.max = e + h
          }
          rn.prototype.insert = function(e, t, i, n, r) {
              this._forEachCell(t, i, n, r, this._insertCell, this.uid++),
              this.keys.push(e),
              this.bboxes.push(t),
              this.bboxes.push(i),
              this.bboxes.push(n),
              this.bboxes.push(r)
          }
          ,
          rn.prototype._insertReadonly = function() {
              throw "Cannot insert into a GridIndex created from an ArrayBuffer."
          }
          ,
          rn.prototype._insertCell = function(e, t, i, n, r, o) {
              this.cells[r].push(o)
          }
          ,
          rn.prototype.query = function(e, t, i, n, r) {
              var o = this.min
                , s = this.max;
              if (e <= o && t <= o && s <= i && s <= n && !r)
                  return Array.prototype.slice.call(this.keys);
              var a = [];
              return this._forEachCell(e, t, i, n, this._queryCell, a, {}, r),
              a
          }
          ,
          rn.prototype._queryCell = function(e, t, i, n, r, o, s, a) {
              var l = this.cells[r];
              if (null !== l)
                  for (var c = this.keys, u = this.bboxes, h = 0; h < l.length; h++) {
                      var d = l[h];
                      if (void 0 === s[d]) {
                          var p = 4 * d;
                          (a ? a(u[p + 0], u[p + 1], u[p + 2], u[p + 3]) : e <= u[p + 2] && t <= u[p + 3] && i >= u[p + 0] && n >= u[p + 1]) ? (s[d] = !0,
                          o.push(c[d])) : s[d] = !1
                      }
                  }
          }
          ,
          rn.prototype._forEachCell = function(e, t, i, n, r, o, s, a) {
              for (var l = this._convertToCellCoord(e), c = this._convertToCellCoord(t), u = this._convertToCellCoord(i), h = this._convertToCellCoord(n), d = l; d <= u; d++)
                  for (var p = c; p <= h; p++) {
                      var f = this.d * p + d;
                      if ((!a || a(this._convertFromCellCoord(d), this._convertFromCellCoord(p), this._convertFromCellCoord(d + 1), this._convertFromCellCoord(p + 1))) && r.call(this, e, t, i, n, f, o, s, a))
                          return
                  }
          }
          ,
          rn.prototype._convertFromCellCoord = function(e) {
              return (e - this.padding) / this.scale
          }
          ,
          rn.prototype._convertToCellCoord = function(e) {
              return Math.max(0, Math.min(this.d - 1, Math.floor(e * this.scale) + this.padding))
          }
          ,
          rn.prototype.toArrayBuffer = function() {
              if (this.arrayBuffer)
                  return this.arrayBuffer;
              for (var e = this.cells, t = nn + this.cells.length + 1 + 1, i = 0, n = 0; n < this.cells.length; n++)
                  i += this.cells[n].length;
              var r = new Int32Array(t + i + this.keys.length + this.bboxes.length);
              r[0] = this.extent,
              r[1] = this.n,
              r[2] = this.padding;
              for (var o = t, s = 0; s < e.length; s++) {
                  var a = e[s];
                  r[nn + s] = o,
                  r.set(a, o),
                  o += a.length
              }
              return r[nn + e.length] = o,
              r.set(this.keys, o),
              o += this.keys.length,
              r[nn + e.length + 1] = o,
              r.set(this.bboxes, o),
              o += this.bboxes.length,
              r.buffer
          }
          ;
          var on = self.ImageData
            , sn = {};
          function an(e, t, i) {
              void 0 === i && (i = {}),
              Object.defineProperty(t, "_classRegistryKey", {
                  value: e,
                  writeable: !1
              }),
              sn[e] = {
                  klass: t,
                  omit: i.omit || [],
                  shallow: i.shallow || []
              }
          }
          for (var ln in an("Object", Object),
          tn.serialize = function(e, t) {
              var i = e.toArrayBuffer();
              return t && t.push(i),
              {
                  buffer: i
              }
          }
          ,
          tn.deserialize = function(e) {
              return new tn(e.buffer)
          }
          ,
          an("Grid", tn),
          an("Color", je),
          an("Error", Error),
          an("StylePropertyFunction", _i),
          an("StyleExpression", pi, {
              omit: ["_evaluator"]
          }),
          an("ZoomDependentExpression", vi),
          an("ZoomConstantExpression", gi),
          an("CompoundExpression", et, {
              omit: ["_evaluate"]
          }),
          Xt)
              Xt[ln]._classRegistryKey || an("Expression_" + ln, Xt[ln]);
          function cn(e, t) {
              if (null == e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || e instanceof Boolean || e instanceof Number || e instanceof String || e instanceof Date || e instanceof RegExp)
                  return e;
              if (e instanceof ArrayBuffer)
                  return t && t.push(e),
                  e;
              if (ArrayBuffer.isView(e)) {
                  var i = e;
                  return t && t.push(i.buffer),
                  i
              }
              if (e instanceof on)
                  return t && t.push(e.data.buffer),
                  e;
              if (Array.isArray(e)) {
                  for (var n = [], r = 0, o = e; r < o.length; r += 1) {
                      var s = o[r];
                      n.push(cn(s, t))
                  }
                  return n
              }
              if ("object" == typeof e) {
                  var a = e.constructor
                    , l = a._classRegistryKey;
                  if (!l)
                      throw new Error("can't serialize object of unregistered class");
                  var c = a.serialize ? a.serialize(e, t) : {};
                  if (!a.serialize) {
                      for (var u in e)
                          if (e.hasOwnProperty(u) && !(sn[l].omit.indexOf(u) >= 0)) {
                              var h = e[u];
                              c[u] = sn[l].shallow.indexOf(u) >= 0 ? h : cn(h, t)
                          }
                      e instanceof Error && (c.message = e.message)
                  }
                  if (c.$name)
                      throw new Error("$name property is reserved for worker serialization logic.");
                  return "Object" !== l && (c.$name = l),
                  c
              }
              throw new Error("can't serialize object of type " + typeof e)
          }
          function un(e) {
              if (null == e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || e instanceof Boolean || e instanceof Number || e instanceof String || e instanceof Date || e instanceof RegExp || e instanceof ArrayBuffer || ArrayBuffer.isView(e) || e instanceof on)
                  return e;
              if (Array.isArray(e))
                  return e.map(un);
              if ("object" == typeof e) {
                  var t = e.$name || "Object"
                    , i = sn[t].klass;
                  if (!i)
                      throw new Error("can't deserialize unregistered class " + t);
                  if (i.deserialize)
                      return i.deserialize(e);
                  for (var n = Object.create(i.prototype), r = 0, o = Object.keys(e); r < o.length; r += 1) {
                      var s = o[r];
                      if ("$name" !== s) {
                          var a = e[s];
                          n[s] = sn[t].shallow.indexOf(s) >= 0 ? a : un(a)
                      }
                  }
                  return n
              }
              throw new Error("can't deserialize object of type " + typeof e)
          }
          var hn = function() {
              this.first = !0
          };
          hn.prototype.update = function(e, t) {
              var i = Math.floor(e);
              return this.first ? (this.first = !1,
              this.lastIntegerZoom = i,
              this.lastIntegerZoomTime = 0,
              this.lastZoom = e,
              this.lastFloorZoom = i,
              !0) : (this.lastFloorZoom > i ? (this.lastIntegerZoom = i + 1,
              this.lastIntegerZoomTime = t) : this.lastFloorZoom < i && (this.lastIntegerZoom = i,
              this.lastIntegerZoomTime = t),
              e !== this.lastZoom && (this.lastZoom = e,
              this.lastFloorZoom = i,
              !0))
          }
          ;
          var dn = {
              "Latin-1 Supplement": function(e) {
                  return e >= 128 && e <= 255
              },
              Arabic: function(e) {
                  return e >= 1536 && e <= 1791
              },
              "Arabic Supplement": function(e) {
                  return e >= 1872 && e <= 1919
              },
              "Arabic Extended-A": function(e) {
                  return e >= 2208 && e <= 2303
              },
              "Hangul Jamo": function(e) {
                  return e >= 4352 && e <= 4607
              },
              "Unified Canadian Aboriginal Syllabics": function(e) {
                  return e >= 5120 && e <= 5759
              },
              Khmer: function(e) {
                  return e >= 6016 && e <= 6143
              },
              "Unified Canadian Aboriginal Syllabics Extended": function(e) {
                  return e >= 6320 && e <= 6399
              },
              "General Punctuation": function(e) {
                  return e >= 8192 && e <= 8303
              },
              "Letterlike Symbols": function(e) {
                  return e >= 8448 && e <= 8527
              },
              "Number Forms": function(e) {
                  return e >= 8528 && e <= 8591
              },
              "Miscellaneous Technical": function(e) {
                  return e >= 8960 && e <= 9215
              },
              "Control Pictures": function(e) {
                  return e >= 9216 && e <= 9279
              },
              "Optical Character Recognition": function(e) {
                  return e >= 9280 && e <= 9311
              },
              "Enclosed Alphanumerics": function(e) {
                  return e >= 9312 && e <= 9471
              },
              "Geometric Shapes": function(e) {
                  return e >= 9632 && e <= 9727
              },
              "Miscellaneous Symbols": function(e) {
                  return e >= 9728 && e <= 9983
              },
              "Miscellaneous Symbols and Arrows": function(e) {
                  return e >= 11008 && e <= 11263
              },
              "CJK Radicals Supplement": function(e) {
                  return e >= 11904 && e <= 12031
              },
              "Kangxi Radicals": function(e) {
                  return e >= 12032 && e <= 12255
              },
              "Ideographic Description Characters": function(e) {
                  return e >= 12272 && e <= 12287
              },
              "CJK Symbols and Punctuation": function(e) {
                  return e >= 12288 && e <= 12351
              },
              Hiragana: function(e) {
                  return e >= 12352 && e <= 12447
              },
              Katakana: function(e) {
                  return e >= 12448 && e <= 12543
              },
              Bopomofo: function(e) {
                  return e >= 12544 && e <= 12591
              },
              "Hangul Compatibility Jamo": function(e) {
                  return e >= 12592 && e <= 12687
              },
              Kanbun: function(e) {
                  return e >= 12688 && e <= 12703
              },
              "Bopomofo Extended": function(e) {
                  return e >= 12704 && e <= 12735
              },
              "CJK Strokes": function(e) {
                  return e >= 12736 && e <= 12783
              },
              "Katakana Phonetic Extensions": function(e) {
                  return e >= 12784 && e <= 12799
              },
              "Enclosed CJK Letters and Months": function(e) {
                  return e >= 12800 && e <= 13055
              },
              "CJK Compatibility": function(e) {
                  return e >= 13056 && e <= 13311
              },
              "CJK Unified Ideographs Extension A": function(e) {
                  return e >= 13312 && e <= 19903
              },
              "Yijing Hexagram Symbols": function(e) {
                  return e >= 19904 && e <= 19967
              },
              "CJK Unified Ideographs": function(e) {
                  return e >= 19968 && e <= 40959
              },
              "Yi Syllables": function(e) {
                  return e >= 40960 && e <= 42127
              },
              "Yi Radicals": function(e) {
                  return e >= 42128 && e <= 42191
              },
              "Hangul Jamo Extended-A": function(e) {
                  return e >= 43360 && e <= 43391
              },
              "Hangul Syllables": function(e) {
                  return e >= 44032 && e <= 55215
              },
              "Hangul Jamo Extended-B": function(e) {
                  return e >= 55216 && e <= 55295
              },
              "Private Use Area": function(e) {
                  return e >= 57344 && e <= 63743
              },
              "CJK Compatibility Ideographs": function(e) {
                  return e >= 63744 && e <= 64255
              },
              "Arabic Presentation Forms-A": function(e) {
                  return e >= 64336 && e <= 65023
              },
              "Vertical Forms": function(e) {
                  return e >= 65040 && e <= 65055
              },
              "CJK Compatibility Forms": function(e) {
                  return e >= 65072 && e <= 65103
              },
              "Small Form Variants": function(e) {
                  return e >= 65104 && e <= 65135
              },
              "Arabic Presentation Forms-B": function(e) {
                  return e >= 65136 && e <= 65279
              },
              "Halfwidth and Fullwidth Forms": function(e) {
                  return e >= 65280 && e <= 65519
              }
          };
          function pn(e) {
              for (var t = 0, i = e; t < i.length; t += 1)
                  if (mn(i[t].charCodeAt(0)))
                      return !0;
              return !1
          }
          function fn(e) {
              return !(dn.Arabic(e) || dn["Arabic Supplement"](e) || dn["Arabic Extended-A"](e) || dn["Arabic Presentation Forms-A"](e) || dn["Arabic Presentation Forms-B"](e))
          }
          function mn(e) {
              return !(746 !== e && 747 !== e && (e < 4352 || !(dn["Bopomofo Extended"](e) || dn.Bopomofo(e) || dn["CJK Compatibility Forms"](e) && !(e >= 65097 && e <= 65103) || dn["CJK Compatibility Ideographs"](e) || dn["CJK Compatibility"](e) || dn["CJK Radicals Supplement"](e) || dn["CJK Strokes"](e) || !(!dn["CJK Symbols and Punctuation"](e) || e >= 12296 && e <= 12305 || e >= 12308 && e <= 12319 || 12336 === e) || dn["CJK Unified Ideographs Extension A"](e) || dn["CJK Unified Ideographs"](e) || dn["Enclosed CJK Letters and Months"](e) || dn["Hangul Compatibility Jamo"](e) || dn["Hangul Jamo Extended-A"](e) || dn["Hangul Jamo Extended-B"](e) || dn["Hangul Jamo"](e) || dn["Hangul Syllables"](e) || dn.Hiragana(e) || dn["Ideographic Description Characters"](e) || dn.Kanbun(e) || dn["Kangxi Radicals"](e) || dn["Katakana Phonetic Extensions"](e) || dn.Katakana(e) && 12540 !== e || !(!dn["Halfwidth and Fullwidth Forms"](e) || 65288 === e || 65289 === e || 65293 === e || e >= 65306 && e <= 65310 || 65339 === e || 65341 === e || 65343 === e || e >= 65371 && e <= 65503 || 65507 === e || e >= 65512 && e <= 65519) || !(!dn["Small Form Variants"](e) || e >= 65112 && e <= 65118 || e >= 65123 && e <= 65126) || dn["Unified Canadian Aboriginal Syllabics"](e) || dn["Unified Canadian Aboriginal Syllabics Extended"](e) || dn["Vertical Forms"](e) || dn["Yijing Hexagram Symbols"](e) || dn["Yi Syllables"](e) || dn["Yi Radicals"](e))))
          }
          function gn(e) {
              return !(mn(e) || function(e) {
                  return !!(dn["Latin-1 Supplement"](e) && (167 === e || 169 === e || 174 === e || 177 === e || 188 === e || 189 === e || 190 === e || 215 === e || 247 === e) || dn["General Punctuation"](e) && (8214 === e || 8224 === e || 8225 === e || 8240 === e || 8241 === e || 8251 === e || 8252 === e || 8258 === e || 8263 === e || 8264 === e || 8265 === e || 8273 === e) || dn["Letterlike Symbols"](e) || dn["Number Forms"](e) || dn["Miscellaneous Technical"](e) && (e >= 8960 && e <= 8967 || e >= 8972 && e <= 8991 || e >= 8996 && e <= 9e3 || 9003 === e || e >= 9085 && e <= 9114 || e >= 9150 && e <= 9165 || 9167 === e || e >= 9169 && e <= 9179 || e >= 9186 && e <= 9215) || dn["Control Pictures"](e) && 9251 !== e || dn["Optical Character Recognition"](e) || dn["Enclosed Alphanumerics"](e) || dn["Geometric Shapes"](e) || dn["Miscellaneous Symbols"](e) && !(e >= 9754 && e <= 9759) || dn["Miscellaneous Symbols and Arrows"](e) && (e >= 11026 && e <= 11055 || e >= 11088 && e <= 11097 || e >= 11192 && e <= 11243) || dn["CJK Symbols and Punctuation"](e) || dn.Katakana(e) || dn["Private Use Area"](e) || dn["CJK Compatibility Forms"](e) || dn["Small Form Variants"](e) || dn["Halfwidth and Fullwidth Forms"](e) || 8734 === e || 8756 === e || 8757 === e || e >= 9984 && e <= 10087 || e >= 10102 && e <= 10131 || 65532 === e || 65533 === e)
              }(e))
          }
          function vn(e, t) {
              return !(!t && (e >= 1424 && e <= 2303 || dn["Arabic Presentation Forms-A"](e) || dn["Arabic Presentation Forms-B"](e)) || e >= 2304 && e <= 3583 || e >= 3840 && e <= 4255 || dn.Khmer(e))
          }
          var yn, _n = !1, bn = null, wn = !1, xn = new me, kn = {
              applyArabicShaping: null,
              processBidirectionalText: null,
              processStyledBidirectionalText: null,
              isLoaded: function() {
                  return wn || null != kn.applyArabicShaping
              }
          }, Sn = function(e, t) {
              this.zoom = e,
              t ? (this.now = t.now,
              this.fadeDuration = t.fadeDuration,
              this.zoomHistory = t.zoomHistory,
              this.transition = t.transition) : (this.now = 0,
              this.fadeDuration = 0,
              this.zoomHistory = new hn,
              this.transition = {})
          };
          Sn.prototype.isSupportedScript = function(e) {
              return function(e, t) {
                  for (var i = 0, n = e; i < n.length; i += 1)
                      if (!vn(n[i].charCodeAt(0), t))
                          return !1;
                  return !0
              }(e, kn.isLoaded())
          }
          ,
          Sn.prototype.crossFadingFactor = function() {
              return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1)
          }
          ,
          Sn.prototype.getCrossfadeParameters = function() {
              var e = this.zoom
                , t = e - Math.floor(e)
                , i = this.crossFadingFactor();
              return e > this.zoomHistory.lastIntegerZoom ? {
                  fromScale: 2,
                  toScale: 1,
                  t: t + (1 - t) * i
              } : {
                  fromScale: .5,
                  toScale: 1,
                  t: 1 - (1 - i) * t
              }
          }
          ;
          var En = function(e, t) {
              this.property = e,
              this.value = t,
              this.expression = bi(void 0 === t ? e.specification.default : t, e.specification)
          };
          En.prototype.isDataDriven = function() {
              return "source" === this.expression.kind || "composite" === this.expression.kind
          }
          ,
          En.prototype.possiblyEvaluate = function(e) {
              return this.property.possiblyEvaluate(this, e)
          }
          ;
          var Tn = function(e) {
              this.property = e,
              this.value = new En(e,void 0)
          };
          Tn.prototype.transitioned = function(e, t) {
              return new Ln(this.property,this.value,t,h({}, e.transition, this.transition),e.now)
          }
          ,
          Tn.prototype.untransitioned = function() {
              return new Ln(this.property,this.value,null,{},0)
          }
          ;
          var Cn = function(e) {
              this._properties = e,
              this._values = Object.create(e.defaultTransitionablePropertyValues)
          };
          Cn.prototype.getValue = function(e) {
              return b(this._values[e].value.value)
          }
          ,
          Cn.prototype.setValue = function(e, t) {
              this._values.hasOwnProperty(e) || (this._values[e] = new Tn(this._values[e].property)),
              this._values[e].value = new En(this._values[e].property,null === t ? void 0 : b(t))
          }
          ,
          Cn.prototype.getTransition = function(e) {
              return b(this._values[e].transition)
          }
          ,
          Cn.prototype.setTransition = function(e, t) {
              this._values.hasOwnProperty(e) || (this._values[e] = new Tn(this._values[e].property)),
              this._values[e].transition = b(t) || void 0
          }
          ,
          Cn.prototype.serialize = function() {
              for (var e = {}, t = 0, i = Object.keys(this._values); t < i.length; t += 1) {
                  var n = i[t]
                    , r = this.getValue(n);
                  void 0 !== r && (e[n] = r);
                  var o = this.getTransition(n);
                  void 0 !== o && (e[n + "-transition"] = o)
              }
              return e
          }
          ,
          Cn.prototype.transitioned = function(e, t) {
              for (var i = new An(this._properties), n = 0, r = Object.keys(this._values); n < r.length; n += 1) {
                  var o = r[n];
                  i._values[o] = this._values[o].transitioned(e, t._values[o])
              }
              return i
          }
          ,
          Cn.prototype.untransitioned = function() {
              for (var e = new An(this._properties), t = 0, i = Object.keys(this._values); t < i.length; t += 1) {
                  var n = i[t];
                  e._values[n] = this._values[n].untransitioned()
              }
              return e
          }
          ;
          var Ln = function(e, t, i, n, r) {
              this.property = e,
              this.value = t,
              this.begin = r + n.delay || 0,
              this.end = this.begin + n.duration || 0,
              e.specification.transition && (n.delay || n.duration) && (this.prior = i)
          };
          Ln.prototype.possiblyEvaluate = function(e) {
              var t = e.now || 0
                , i = this.value.possiblyEvaluate(e)
                , n = this.prior;
              if (n) {
                  if (t > this.end)
                      return this.prior = null,
                      i;
                  if (this.value.isDataDriven())
                      return this.prior = null,
                      i;
                  if (t < this.begin)
                      return n.possiblyEvaluate(e);
                  var r = (t - this.begin) / (this.end - this.begin);
                  return this.property.interpolate(n.possiblyEvaluate(e), i, function(e) {
                      if (r <= 0)
                          return 0;
                      if (r >= 1)
                          return 1;
                      var t = r * r
                        , i = t * r;
                      return 4 * (r < .5 ? i : 3 * (r - t) + i - .75)
                  }())
              }
              return i
          }
          ;
          var An = function(e) {
              this._properties = e,
              this._values = Object.create(e.defaultTransitioningPropertyValues)
          };
          An.prototype.possiblyEvaluate = function(e) {
              for (var t = new Mn(this._properties), i = 0, n = Object.keys(this._values); i < n.length; i += 1) {
                  var r = n[i];
                  t._values[r] = this._values[r].possiblyEvaluate(e)
              }
              return t
          }
          ,
          An.prototype.hasTransition = function() {
              for (var e = 0, t = Object.keys(this._values); e < t.length; e += 1) {
                  var i = t[e];
                  if (this._values[i].prior)
                      return !0
              }
              return !1
          }
          ;
          var Pn = function(e) {
              this._properties = e,
              this._values = Object.create(e.defaultPropertyValues)
          };
          Pn.prototype.getValue = function(e) {
              return b(this._values[e].value)
          }
          ,
          Pn.prototype.setValue = function(e, t) {
              this._values[e] = new En(this._values[e].property,null === t ? void 0 : b(t))
          }
          ,
          Pn.prototype.serialize = function() {
              for (var e = {}, t = 0, i = Object.keys(this._values); t < i.length; t += 1) {
                  var n = i[t]
                    , r = this.getValue(n);
                  void 0 !== r && (e[n] = r)
              }
              return e
          }
          ,
          Pn.prototype.possiblyEvaluate = function(e) {
              for (var t = new Mn(this._properties), i = 0, n = Object.keys(this._values); i < n.length; i += 1) {
                  var r = n[i];
                  t._values[r] = this._values[r].possiblyEvaluate(e)
              }
              return t
          }
          ;
          var In = function(e, t, i) {
              this.property = e,
              this.value = t,
              this.parameters = i
          };
          In.prototype.isConstant = function() {
              return "constant" === this.value.kind
          }
          ,
          In.prototype.constantOr = function(e) {
              return "constant" === this.value.kind ? this.value.value : e
          }
          ,
          In.prototype.evaluate = function(e, t) {
              return this.property.evaluate(this.value, this.parameters, e, t)
          }
          ;
          var Mn = function(e) {
              this._properties = e,
              this._values = Object.create(e.defaultPossiblyEvaluatedValues)
          };
          Mn.prototype.get = function(e) {
              return this._values[e]
          }
          ;
          var On = function(e) {
              this.specification = e
          };
          On.prototype.possiblyEvaluate = function(e, t) {
              return e.expression.evaluate(t)
          }
          ,
          On.prototype.interpolate = function(e, t, i) {
              var n = ut[this.specification.type];
              return n ? n(e, t, i) : e
          }
          ;
          var zn = function(e) {
              this.specification = e
          };
          zn.prototype.possiblyEvaluate = function(e, t) {
              return "constant" === e.expression.kind || "camera" === e.expression.kind ? new In(this,{
                  kind: "constant",
                  value: e.expression.evaluate(t)
              },t) : new In(this,e.expression,t)
          }
          ,
          zn.prototype.interpolate = function(e, t, i) {
              if ("constant" !== e.value.kind || "constant" !== t.value.kind)
                  return e;
              if (void 0 === e.value.value || void 0 === t.value.value)
                  return new In(this,{
                      kind: "constant",
                      value: void 0
                  },e.parameters);
              var n = ut[this.specification.type];
              return n ? new In(this,{
                  kind: "constant",
                  value: n(e.value.value, t.value.value, i)
              },e.parameters) : e
          }
          ,
          zn.prototype.evaluate = function(e, t, i, n) {
              return "constant" === e.kind ? e.value : e.evaluate(t, i, n)
          }
          ;
          var Dn = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.possiblyEvaluate = function(e, t) {
                  if (void 0 === e.value)
                      return new In(this,{
                          kind: "constant",
                          value: void 0
                      },t);
                  if ("constant" === e.expression.kind) {
                      var i = e.expression.evaluate(t)
                        , n = this._calculate(i, i, i, t);
                      return new In(this,{
                          kind: "constant",
                          value: n
                      },t)
                  }
                  if ("camera" === e.expression.kind) {
                      var r = this._calculate(e.expression.evaluate({
                          zoom: t.zoom - 1
                      }), e.expression.evaluate({
                          zoom: t.zoom
                      }), e.expression.evaluate({
                          zoom: t.zoom + 1
                      }), t);
                      return new In(this,{
                          kind: "constant",
                          value: r
                      },t)
                  }
                  return new In(this,e.expression,t)
              }
              ,
              t.prototype.evaluate = function(e, t, i, n) {
                  if ("source" === e.kind) {
                      var r = e.evaluate(t, i, n);
                      return this._calculate(r, r, r, t)
                  }
                  return "composite" === e.kind ? this._calculate(e.evaluate({
                      zoom: Math.floor(t.zoom) - 1
                  }, i, n), e.evaluate({
                      zoom: Math.floor(t.zoom)
                  }, i, n), e.evaluate({
                      zoom: Math.floor(t.zoom) + 1
                  }, i, n), t) : e.value
              }
              ,
              t.prototype._calculate = function(e, t, i, n) {
                  return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                      from: e,
                      to: t
                  } : {
                      from: i,
                      to: t
                  }
              }
              ,
              t.prototype.interpolate = function(e) {
                  return e
              }
              ,
              t
          }(zn)
            , Rn = function(e) {
              this.specification = e
          };
          Rn.prototype.possiblyEvaluate = function(e, t) {
              if (void 0 !== e.value) {
                  if ("constant" === e.expression.kind) {
                      var i = e.expression.evaluate(t);
                      return this._calculate(i, i, i, t)
                  }
                  return this._calculate(e.expression.evaluate(new Sn(Math.floor(t.zoom - 1),t)), e.expression.evaluate(new Sn(Math.floor(t.zoom),t)), e.expression.evaluate(new Sn(Math.floor(t.zoom + 1),t)), t)
              }
          }
          ,
          Rn.prototype._calculate = function(e, t, i, n) {
              return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                  from: e,
                  to: t
              } : {
                  from: i,
                  to: t
              }
          }
          ,
          Rn.prototype.interpolate = function(e) {
              return e
          }
          ;
          var Bn = function(e) {
              this.specification = e
          };
          Bn.prototype.possiblyEvaluate = function(e, t) {
              return !!e.expression.evaluate(t)
          }
          ,
          Bn.prototype.interpolate = function() {
              return !1
          }
          ;
          var jn = function(e) {
              for (var t in this.properties = e,
              this.defaultPropertyValues = {},
              this.defaultTransitionablePropertyValues = {},
              this.defaultTransitioningPropertyValues = {},
              this.defaultPossiblyEvaluatedValues = {},
              e) {
                  var i = e[t]
                    , n = this.defaultPropertyValues[t] = new En(i,void 0)
                    , r = this.defaultTransitionablePropertyValues[t] = new Tn(i);
                  this.defaultTransitioningPropertyValues[t] = r.untransitioned(),
                  this.defaultPossiblyEvaluatedValues[t] = n.possiblyEvaluate({})
              }
          };
          an("DataDrivenProperty", zn),
          an("DataConstantProperty", On),
          an("CrossFadedDataDrivenProperty", Dn),
          an("CrossFadedProperty", Rn),
          an("ColorRampProperty", Bn);
          var Fn = function(e) {
              function t(t, i) {
                  if (e.call(this),
                  this.id = t.id,
                  this.type = t.type,
                  this.visibility = "visible",
                  this._featureFilter = function() {
                      return !0
                  }
                  ,
                  "custom" !== t.type && (t = t,
                  this.metadata = t.metadata,
                  this.minzoom = t.minzoom,
                  this.maxzoom = t.maxzoom,
                  "background" !== t.type && (this.source = t.source,
                  this.sourceLayer = t["source-layer"],
                  this.filter = t.filter),
                  i.layout && (this._unevaluatedLayout = new Pn(i.layout)),
                  i.paint)) {
                      for (var n in this._transitionablePaint = new Cn(i.paint),
                      t.paint)
                          this.setPaintProperty(n, t.paint[n], {
                              validate: !1
                          });
                      for (var r in t.layout)
                          this.setLayoutProperty(r, t.layout[r], {
                              validate: !1
                          });
                      this._transitioningPaint = this._transitionablePaint.untransitioned()
                  }
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getCrossfadeParameters = function() {
                  return this._crossfadeParameters
              }
              ,
              t.prototype.getLayoutProperty = function(e) {
                  return "visibility" === e ? this.visibility : this._unevaluatedLayout.getValue(e)
              }
              ,
              t.prototype.setLayoutProperty = function(e, t, i) {
                  if (void 0 === i && (i = {}),
                  null != t) {
                      var n = "layers." + this.id + ".layout." + e;
                      if (this._validate(Qi, n, e, t, i))
                          return
                  }
                  "visibility" !== e ? this._unevaluatedLayout.setValue(e, t) : this.visibility = "none" === t ? t : "visible"
              }
              ,
              t.prototype.getPaintProperty = function(e) {
                  return v(e, "-transition") ? this._transitionablePaint.getTransition(e.slice(0, -"-transition".length)) : this._transitionablePaint.getValue(e)
              }
              ,
              t.prototype.setPaintProperty = function(e, t, i) {
                  if (void 0 === i && (i = {}),
                  null != t) {
                      var n = "layers." + this.id + ".paint." + e;
                      if (this._validate(Ji, n, e, t, i))
                          return !1
                  }
                  if (v(e, "-transition"))
                      return this._transitionablePaint.setTransition(e.slice(0, -"-transition".length), t || void 0),
                      !1;
                  var r = this._transitionablePaint._values[e]
                    , o = "cross-faded-data-driven" === r.property.specification["property-type"] && !r.value.value && t
                    , s = this._transitionablePaint._values[e].value.isDataDriven();
                  this._transitionablePaint.setValue(e, t);
                  var a = this._transitionablePaint._values[e].value.isDataDriven();
                  return this._handleSpecialPaintPropertyUpdate(e),
                  a || s || o
              }
              ,
              t.prototype._handleSpecialPaintPropertyUpdate = function(e) {}
              ,
              t.prototype.isHidden = function(e) {
                  return !!(this.minzoom && e < this.minzoom) || !!(this.maxzoom && e >= this.maxzoom) || "none" === this.visibility
              }
              ,
              t.prototype.updateTransitions = function(e) {
                  this._transitioningPaint = this._transitionablePaint.transitioned(e, this._transitioningPaint)
              }
              ,
              t.prototype.hasTransition = function() {
                  return this._transitioningPaint.hasTransition()
              }
              ,
              t.prototype.recalculate = function(e) {
                  e.getCrossfadeParameters && (this._crossfadeParameters = e.getCrossfadeParameters()),
                  this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(e)),
                  this.paint = this._transitioningPaint.possiblyEvaluate(e)
              }
              ,
              t.prototype.serialize = function() {
                  var e = {
                      id: this.id,
                      type: this.type,
                      source: this.source,
                      "source-layer": this.sourceLayer,
                      metadata: this.metadata,
                      minzoom: this.minzoom,
                      maxzoom: this.maxzoom,
                      filter: this.filter,
                      layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                      paint: this._transitionablePaint && this._transitionablePaint.serialize()
                  };
                  return "none" === this.visibility && (e.layout = e.layout || {},
                  e.layout.visibility = "none"),
                  _(e, function(e, t) {
                      return !(void 0 === e || "layout" === t && !Object.keys(e).length || "paint" === t && !Object.keys(e).length)
                  })
              }
              ,
              t.prototype._validate = function(e, t, i, n, r) {
                  return void 0 === r && (r = {}),
                  (!r || !1 !== r.validate) && en(this, e.call(Yi, {
                      key: t,
                      layerType: this.type,
                      objectKey: i,
                      value: n,
                      styleSpec: ge,
                      style: {
                          glyphs: !0,
                          sprite: !0
                      }
                  }))
              }
              ,
              t.prototype.hasOffscreenPass = function() {
                  return !1
              }
              ,
              t.prototype.resize = function() {}
              ,
              t.prototype.isStateDependent = function() {
                  for (var e in this.paint._values) {
                      var t = this.paint.get(e);
                      if (t instanceof In && ti(t.property.specification) && ("source" === t.value.kind || "composite" === t.value.kind) && t.value.isStateDependent)
                          return !0
                  }
                  return !1
              }
              ,
              t
          }(me)
            , Nn = {
              Int8: Int8Array,
              Uint8: Uint8Array,
              Int16: Int16Array,
              Uint16: Uint16Array,
              Int32: Int32Array,
              Uint32: Uint32Array,
              Float32: Float32Array
          }
            , Un = function(e, t) {
              this._structArray = e,
              this._pos1 = t * this.size,
              this._pos2 = this._pos1 / 2,
              this._pos4 = this._pos1 / 4,
              this._pos8 = this._pos1 / 8
          }
            , qn = function() {
              this.isTransferred = !1,
              this.capacity = -1,
              this.resize(0)
          };
          function Hn(e, t) {
              void 0 === t && (t = 1);
              var i = 0
                , n = 0;
              return {
                  members: e.map(function(e) {
                      var r, o = (r = e.type,
                      Nn[r].BYTES_PER_ELEMENT), s = i = Vn(i, Math.max(t, o)), a = e.components || 1;
                      return n = Math.max(n, o),
                      i += o * a,
                      {
                          name: e.name,
                          type: e.type,
                          components: a,
                          offset: s
                      }
                  }),
                  size: Vn(i, Math.max(n, t)),
                  alignment: t
              }
          }
          function Vn(e, t) {
              return Math.ceil(e / t) * t
          }
          qn.serialize = function(e, t) {
              return e._trim(),
              t && (e.isTransferred = !0,
              t.push(e.arrayBuffer)),
              {
                  length: e.length,
                  arrayBuffer: e.arrayBuffer
              }
          }
          ,
          qn.deserialize = function(e) {
              var t = Object.create(this.prototype);
              return t.arrayBuffer = e.arrayBuffer,
              t.length = e.length,
              t.capacity = e.arrayBuffer.byteLength / t.bytesPerElement,
              t._refreshViews(),
              t
          }
          ,
          qn.prototype._trim = function() {
              this.length !== this.capacity && (this.capacity = this.length,
              this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement),
              this._refreshViews())
          }
          ,
          qn.prototype.clear = function() {
              this.length = 0
          }
          ,
          qn.prototype.resize = function(e) {
              this.reserve(e),
              this.length = e
          }
          ,
          qn.prototype.reserve = function(e) {
              if (e > this.capacity) {
                  this.capacity = Math.max(e, Math.floor(5 * this.capacity), 128),
                  this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                  var t = this.uint8;
                  this._refreshViews(),
                  t && this.uint8.set(t)
              }
          }
          ,
          qn.prototype._refreshViews = function() {
              throw new Error("_refreshViews() must be implemented by each concrete StructArray layout")
          }
          ;
          var Wn = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.int16 = new Int16Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t) {
                  var i = this.length;
                  return this.resize(i + 1),
                  this.emplace(i, e, t)
              }
              ,
              t.prototype.emplace = function(e, t, i) {
                  var n = 2 * e;
                  return this.int16[n + 0] = t,
                  this.int16[n + 1] = i,
                  e
              }
              ,
              t
          }(qn);
          Wn.prototype.bytesPerElement = 4,
          an("StructArrayLayout2i4", Wn);
          var $n = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.int16 = new Int16Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t, i, n) {
                  var r = this.length;
                  return this.resize(r + 1),
                  this.emplace(r, e, t, i, n)
              }
              ,
              t.prototype.emplace = function(e, t, i, n, r) {
                  var o = 4 * e;
                  return this.int16[o + 0] = t,
                  this.int16[o + 1] = i,
                  this.int16[o + 2] = n,
                  this.int16[o + 3] = r,
                  e
              }
              ,
              t
          }(qn);
          $n.prototype.bytesPerElement = 8,
          an("StructArrayLayout4i8", $n);
          var Gn = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.int16 = new Int16Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t, i, n, r, o) {
                  var s = this.length;
                  return this.resize(s + 1),
                  this.emplace(s, e, t, i, n, r, o)
              }
              ,
              t.prototype.emplace = function(e, t, i, n, r, o, s) {
                  var a = 6 * e;
                  return this.int16[a + 0] = t,
                  this.int16[a + 1] = i,
                  this.int16[a + 2] = n,
                  this.int16[a + 3] = r,
                  this.int16[a + 4] = o,
                  this.int16[a + 5] = s,
                  e
              }
              ,
              t
          }(qn);
          Gn.prototype.bytesPerElement = 12,
          an("StructArrayLayout2i4i12", Gn);
          var Xn = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.int16 = new Int16Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t, i, n, r, o, s, a) {
                  var l = this.length;
                  return this.resize(l + 1),
                  this.emplace(l, e, t, i, n, r, o, s, a)
              }
              ,
              t.prototype.emplace = function(e, t, i, n, r, o, s, a, l) {
                  var c = 6 * e
                    , u = 12 * e;
                  return this.int16[c + 0] = t,
                  this.int16[c + 1] = i,
                  this.int16[c + 2] = n,
                  this.int16[c + 3] = r,
                  this.uint8[u + 8] = o,
                  this.uint8[u + 9] = s,
                  this.uint8[u + 10] = a,
                  this.uint8[u + 11] = l,
                  e
              }
              ,
              t
          }(qn);
          Xn.prototype.bytesPerElement = 12,
          an("StructArrayLayout4i4ub12", Xn);
          var Zn = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.uint16 = new Uint16Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t, i, n, r, o, s, a) {
                  var l = this.length;
                  return this.resize(l + 1),
                  this.emplace(l, e, t, i, n, r, o, s, a)
              }
              ,
              t.prototype.emplace = function(e, t, i, n, r, o, s, a, l) {
                  var c = 8 * e;
                  return this.uint16[c + 0] = t,
                  this.uint16[c + 1] = i,
                  this.uint16[c + 2] = n,
                  this.uint16[c + 3] = r,
                  this.uint16[c + 4] = o,
                  this.uint16[c + 5] = s,
                  this.uint16[c + 6] = a,
                  this.uint16[c + 7] = l,
                  e
              }
              ,
              t
          }(qn);
          Zn.prototype.bytesPerElement = 16,
          an("StructArrayLayout8ui16", Zn);
          var Yn = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.int16 = new Int16Array(this.arrayBuffer),
                  this.uint16 = new Uint16Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t, i, n, r, o, s, a) {
                  var l = this.length;
                  return this.resize(l + 1),
                  this.emplace(l, e, t, i, n, r, o, s, a)
              }
              ,
              t.prototype.emplace = function(e, t, i, n, r, o, s, a, l) {
                  var c = 8 * e;
                  return this.int16[c + 0] = t,
                  this.int16[c + 1] = i,
                  this.int16[c + 2] = n,
                  this.int16[c + 3] = r,
                  this.uint16[c + 4] = o,
                  this.uint16[c + 5] = s,
                  this.uint16[c + 6] = a,
                  this.uint16[c + 7] = l,
                  e
              }
              ,
              t
          }(qn);
          Yn.prototype.bytesPerElement = 16,
          an("StructArrayLayout4i4ui16", Yn);
          var Kn = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.float32 = new Float32Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t, i) {
                  var n = this.length;
                  return this.resize(n + 1),
                  this.emplace(n, e, t, i)
              }
              ,
              t.prototype.emplace = function(e, t, i, n) {
                  var r = 3 * e;
                  return this.float32[r + 0] = t,
                  this.float32[r + 1] = i,
                  this.float32[r + 2] = n,
                  e
              }
              ,
              t
          }(qn);
          Kn.prototype.bytesPerElement = 12,
          an("StructArrayLayout3f12", Kn);
          var Jn = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.uint32 = new Uint32Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e) {
                  var t = this.length;
                  return this.resize(t + 1),
                  this.emplace(t, e)
              }
              ,
              t.prototype.emplace = function(e, t) {
                  var i = 1 * e;
                  return this.uint32[i + 0] = t,
                  e
              }
              ,
              t
          }(qn);
          Jn.prototype.bytesPerElement = 4,
          an("StructArrayLayout1ul4", Jn);
          var Qn = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.int16 = new Int16Array(this.arrayBuffer),
                  this.uint32 = new Uint32Array(this.arrayBuffer),
                  this.uint16 = new Uint16Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t, i, n, r, o, s, a, l, c, u) {
                  var h = this.length;
                  return this.resize(h + 1),
                  this.emplace(h, e, t, i, n, r, o, s, a, l, c, u)
              }
              ,
              t.prototype.emplace = function(e, t, i, n, r, o, s, a, l, c, u, h) {
                  var d = 12 * e
                    , p = 6 * e;
                  return this.int16[d + 0] = t,
                  this.int16[d + 1] = i,
                  this.int16[d + 2] = n,
                  this.int16[d + 3] = r,
                  this.int16[d + 4] = o,
                  this.int16[d + 5] = s,
                  this.uint32[p + 3] = a,
                  this.uint16[d + 8] = l,
                  this.uint16[d + 9] = c,
                  this.int16[d + 10] = u,
                  this.int16[d + 11] = h,
                  e
              }
              ,
              t
          }(qn);
          Qn.prototype.bytesPerElement = 24,
          an("StructArrayLayout6i1ul2ui2i24", Qn);
          var er = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.int16 = new Int16Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t, i, n, r, o) {
                  var s = this.length;
                  return this.resize(s + 1),
                  this.emplace(s, e, t, i, n, r, o)
              }
              ,
              t.prototype.emplace = function(e, t, i, n, r, o, s) {
                  var a = 6 * e;
                  return this.int16[a + 0] = t,
                  this.int16[a + 1] = i,
                  this.int16[a + 2] = n,
                  this.int16[a + 3] = r,
                  this.int16[a + 4] = o,
                  this.int16[a + 5] = s,
                  e
              }
              ,
              t
          }(qn);
          er.prototype.bytesPerElement = 12,
          an("StructArrayLayout2i2i2i12", er);
          var tr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t) {
                  var i = this.length;
                  return this.resize(i + 1),
                  this.emplace(i, e, t)
              }
              ,
              t.prototype.emplace = function(e, t, i) {
                  var n = 4 * e;
                  return this.uint8[n + 0] = t,
                  this.uint8[n + 1] = i,
                  e
              }
              ,
              t
          }(qn);
          tr.prototype.bytesPerElement = 4,
          an("StructArrayLayout2ub4", tr);
          var ir = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.int16 = new Int16Array(this.arrayBuffer),
                  this.uint16 = new Uint16Array(this.arrayBuffer),
                  this.uint32 = new Uint32Array(this.arrayBuffer),
                  this.float32 = new Float32Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t, i, n, r, o, s, a, l, c, u, h, d, p) {
                  var f = this.length;
                  return this.resize(f + 1),
                  this.emplace(f, e, t, i, n, r, o, s, a, l, c, u, h, d, p)
              }
              ,
              t.prototype.emplace = function(e, t, i, n, r, o, s, a, l, c, u, h, d, p, f) {
                  var m = 20 * e
                    , g = 10 * e
                    , v = 40 * e;
                  return this.int16[m + 0] = t,
                  this.int16[m + 1] = i,
                  this.uint16[m + 2] = n,
                  this.uint16[m + 3] = r,
                  this.uint32[g + 2] = o,
                  this.uint32[g + 3] = s,
                  this.uint32[g + 4] = a,
                  this.uint16[m + 10] = l,
                  this.uint16[m + 11] = c,
                  this.uint16[m + 12] = u,
                  this.float32[g + 7] = h,
                  this.float32[g + 8] = d,
                  this.uint8[v + 36] = p,
                  this.uint8[v + 37] = f,
                  e
              }
              ,
              t
          }(qn);
          ir.prototype.bytesPerElement = 40,
          an("StructArrayLayout2i2ui3ul3ui2f2ub40", ir);
          var nr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.int16 = new Int16Array(this.arrayBuffer),
                  this.uint16 = new Uint16Array(this.arrayBuffer),
                  this.uint32 = new Uint32Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t, i, n, r, o, s, a, l, c, u, h, d, p) {
                  var f = this.length;
                  return this.resize(f + 1),
                  this.emplace(f, e, t, i, n, r, o, s, a, l, c, u, h, d, p)
              }
              ,
              t.prototype.emplace = function(e, t, i, n, r, o, s, a, l, c, u, h, d, p, f) {
                  var m = 16 * e
                    , g = 8 * e;
                  return this.int16[m + 0] = t,
                  this.int16[m + 1] = i,
                  this.int16[m + 2] = n,
                  this.int16[m + 3] = r,
                  this.uint16[m + 4] = o,
                  this.uint16[m + 5] = s,
                  this.uint16[m + 6] = a,
                  this.uint16[m + 7] = l,
                  this.uint16[m + 8] = c,
                  this.uint16[m + 9] = u,
                  this.uint16[m + 10] = h,
                  this.uint16[m + 11] = d,
                  this.uint16[m + 12] = p,
                  this.uint32[g + 7] = f,
                  e
              }
              ,
              t
          }(qn);
          nr.prototype.bytesPerElement = 32,
          an("StructArrayLayout4i9ui1ul32", nr);
          var rr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.float32 = new Float32Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e) {
                  var t = this.length;
                  return this.resize(t + 1),
                  this.emplace(t, e)
              }
              ,
              t.prototype.emplace = function(e, t) {
                  var i = 1 * e;
                  return this.float32[i + 0] = t,
                  e
              }
              ,
              t
          }(qn);
          rr.prototype.bytesPerElement = 4,
          an("StructArrayLayout1f4", rr);
          var or = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.int16 = new Int16Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t, i) {
                  var n = this.length;
                  return this.resize(n + 1),
                  this.emplace(n, e, t, i)
              }
              ,
              t.prototype.emplace = function(e, t, i, n) {
                  var r = 3 * e;
                  return this.int16[r + 0] = t,
                  this.int16[r + 1] = i,
                  this.int16[r + 2] = n,
                  e
              }
              ,
              t
          }(qn);
          or.prototype.bytesPerElement = 6,
          an("StructArrayLayout3i6", or);
          var sr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.uint32 = new Uint32Array(this.arrayBuffer),
                  this.uint16 = new Uint16Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t, i) {
                  var n = this.length;
                  return this.resize(n + 1),
                  this.emplace(n, e, t, i)
              }
              ,
              t.prototype.emplace = function(e, t, i, n) {
                  var r = 2 * e
                    , o = 4 * e;
                  return this.uint32[r + 0] = t,
                  this.uint16[o + 2] = i,
                  this.uint16[o + 3] = n,
                  e
              }
              ,
              t
          }(qn);
          sr.prototype.bytesPerElement = 8,
          an("StructArrayLayout1ul2ui8", sr);
          var ar = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.uint16 = new Uint16Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t, i) {
                  var n = this.length;
                  return this.resize(n + 1),
                  this.emplace(n, e, t, i)
              }
              ,
              t.prototype.emplace = function(e, t, i, n) {
                  var r = 3 * e;
                  return this.uint16[r + 0] = t,
                  this.uint16[r + 1] = i,
                  this.uint16[r + 2] = n,
                  e
              }
              ,
              t
          }(qn);
          ar.prototype.bytesPerElement = 6,
          an("StructArrayLayout3ui6", ar);
          var lr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.uint16 = new Uint16Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t) {
                  var i = this.length;
                  return this.resize(i + 1),
                  this.emplace(i, e, t)
              }
              ,
              t.prototype.emplace = function(e, t, i) {
                  var n = 2 * e;
                  return this.uint16[n + 0] = t,
                  this.uint16[n + 1] = i,
                  e
              }
              ,
              t
          }(qn);
          lr.prototype.bytesPerElement = 4,
          an("StructArrayLayout2ui4", lr);
          var cr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.uint16 = new Uint16Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e) {
                  var t = this.length;
                  return this.resize(t + 1),
                  this.emplace(t, e)
              }
              ,
              t.prototype.emplace = function(e, t) {
                  var i = 1 * e;
                  return this.uint16[i + 0] = t,
                  e
              }
              ,
              t
          }(qn);
          cr.prototype.bytesPerElement = 2,
          an("StructArrayLayout1ui2", cr);
          var ur = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.float32 = new Float32Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t) {
                  var i = this.length;
                  return this.resize(i + 1),
                  this.emplace(i, e, t)
              }
              ,
              t.prototype.emplace = function(e, t, i) {
                  var n = 2 * e;
                  return this.float32[n + 0] = t,
                  this.float32[n + 1] = i,
                  e
              }
              ,
              t
          }(qn);
          ur.prototype.bytesPerElement = 8,
          an("StructArrayLayout2f8", ur);
          var hr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._refreshViews = function() {
                  this.uint8 = new Uint8Array(this.arrayBuffer),
                  this.float32 = new Float32Array(this.arrayBuffer)
              }
              ,
              t.prototype.emplaceBack = function(e, t, i, n) {
                  var r = this.length;
                  return this.resize(r + 1),
                  this.emplace(r, e, t, i, n)
              }
              ,
              t.prototype.emplace = function(e, t, i, n, r) {
                  var o = 4 * e;
                  return this.float32[o + 0] = t,
                  this.float32[o + 1] = i,
                  this.float32[o + 2] = n,
                  this.float32[o + 3] = r,
                  e
              }
              ,
              t
          }(qn);
          hr.prototype.bytesPerElement = 16,
          an("StructArrayLayout4f16", hr);
          var dr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t;
              var i = {
                  anchorPointX: {
                      configurable: !0
                  },
                  anchorPointY: {
                      configurable: !0
                  },
                  x1: {
                      configurable: !0
                  },
                  y1: {
                      configurable: !0
                  },
                  x2: {
                      configurable: !0
                  },
                  y2: {
                      configurable: !0
                  },
                  featureIndex: {
                      configurable: !0
                  },
                  sourceLayerIndex: {
                      configurable: !0
                  },
                  bucketIndex: {
                      configurable: !0
                  },
                  radius: {
                      configurable: !0
                  },
                  signedDistanceFromAnchor: {
                      configurable: !0
                  },
                  anchorPoint: {
                      configurable: !0
                  }
              };
              return i.anchorPointX.get = function() {
                  return this._structArray.int16[this._pos2 + 0]
              }
              ,
              i.anchorPointX.set = function(e) {
                  this._structArray.int16[this._pos2 + 0] = e
              }
              ,
              i.anchorPointY.get = function() {
                  return this._structArray.int16[this._pos2 + 1]
              }
              ,
              i.anchorPointY.set = function(e) {
                  this._structArray.int16[this._pos2 + 1] = e
              }
              ,
              i.x1.get = function() {
                  return this._structArray.int16[this._pos2 + 2]
              }
              ,
              i.x1.set = function(e) {
                  this._structArray.int16[this._pos2 + 2] = e
              }
              ,
              i.y1.get = function() {
                  return this._structArray.int16[this._pos2 + 3]
              }
              ,
              i.y1.set = function(e) {
                  this._structArray.int16[this._pos2 + 3] = e
              }
              ,
              i.x2.get = function() {
                  return this._structArray.int16[this._pos2 + 4]
              }
              ,
              i.x2.set = function(e) {
                  this._structArray.int16[this._pos2 + 4] = e
              }
              ,
              i.y2.get = function() {
                  return this._structArray.int16[this._pos2 + 5]
              }
              ,
              i.y2.set = function(e) {
                  this._structArray.int16[this._pos2 + 5] = e
              }
              ,
              i.featureIndex.get = function() {
                  return this._structArray.uint32[this._pos4 + 3]
              }
              ,
              i.featureIndex.set = function(e) {
                  this._structArray.uint32[this._pos4 + 3] = e
              }
              ,
              i.sourceLayerIndex.get = function() {
                  return this._structArray.uint16[this._pos2 + 8]
              }
              ,
              i.sourceLayerIndex.set = function(e) {
                  this._structArray.uint16[this._pos2 + 8] = e
              }
              ,
              i.bucketIndex.get = function() {
                  return this._structArray.uint16[this._pos2 + 9]
              }
              ,
              i.bucketIndex.set = function(e) {
                  this._structArray.uint16[this._pos2 + 9] = e
              }
              ,
              i.radius.get = function() {
                  return this._structArray.int16[this._pos2 + 10]
              }
              ,
              i.radius.set = function(e) {
                  this._structArray.int16[this._pos2 + 10] = e
              }
              ,
              i.signedDistanceFromAnchor.get = function() {
                  return this._structArray.int16[this._pos2 + 11]
              }
              ,
              i.signedDistanceFromAnchor.set = function(e) {
                  this._structArray.int16[this._pos2 + 11] = e
              }
              ,
              i.anchorPoint.get = function() {
                  return new r(this.anchorPointX,this.anchorPointY)
              }
              ,
              Object.defineProperties(t.prototype, i),
              t
          }(Un);
          dr.prototype.size = 24;
          var pr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.get = function(e) {
                  return new dr(this,e)
              }
              ,
              t
          }(Qn);
          an("CollisionBoxArray", pr);
          var fr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t;
              var i = {
                  anchorX: {
                      configurable: !0
                  },
                  anchorY: {
                      configurable: !0
                  },
                  glyphStartIndex: {
                      configurable: !0
                  },
                  numGlyphs: {
                      configurable: !0
                  },
                  vertexStartIndex: {
                      configurable: !0
                  },
                  lineStartIndex: {
                      configurable: !0
                  },
                  lineLength: {
                      configurable: !0
                  },
                  segment: {
                      configurable: !0
                  },
                  lowerSize: {
                      configurable: !0
                  },
                  upperSize: {
                      configurable: !0
                  },
                  lineOffsetX: {
                      configurable: !0
                  },
                  lineOffsetY: {
                      configurable: !0
                  },
                  writingMode: {
                      configurable: !0
                  },
                  hidden: {
                      configurable: !0
                  }
              };
              return i.anchorX.get = function() {
                  return this._structArray.int16[this._pos2 + 0]
              }
              ,
              i.anchorX.set = function(e) {
                  this._structArray.int16[this._pos2 + 0] = e
              }
              ,
              i.anchorY.get = function() {
                  return this._structArray.int16[this._pos2 + 1]
              }
              ,
              i.anchorY.set = function(e) {
                  this._structArray.int16[this._pos2 + 1] = e
              }
              ,
              i.glyphStartIndex.get = function() {
                  return this._structArray.uint16[this._pos2 + 2]
              }
              ,
              i.glyphStartIndex.set = function(e) {
                  this._structArray.uint16[this._pos2 + 2] = e
              }
              ,
              i.numGlyphs.get = function() {
                  return this._structArray.uint16[this._pos2 + 3]
              }
              ,
              i.numGlyphs.set = function(e) {
                  this._structArray.uint16[this._pos2 + 3] = e
              }
              ,
              i.vertexStartIndex.get = function() {
                  return this._structArray.uint32[this._pos4 + 2]
              }
              ,
              i.vertexStartIndex.set = function(e) {
                  this._structArray.uint32[this._pos4 + 2] = e
              }
              ,
              i.lineStartIndex.get = function() {
                  return this._structArray.uint32[this._pos4 + 3]
              }
              ,
              i.lineStartIndex.set = function(e) {
                  this._structArray.uint32[this._pos4 + 3] = e
              }
              ,
              i.lineLength.get = function() {
                  return this._structArray.uint32[this._pos4 + 4]
              }
              ,
              i.lineLength.set = function(e) {
                  this._structArray.uint32[this._pos4 + 4] = e
              }
              ,
              i.segment.get = function() {
                  return this._structArray.uint16[this._pos2 + 10]
              }
              ,
              i.segment.set = function(e) {
                  this._structArray.uint16[this._pos2 + 10] = e
              }
              ,
              i.lowerSize.get = function() {
                  return this._structArray.uint16[this._pos2 + 11]
              }
              ,
              i.lowerSize.set = function(e) {
                  this._structArray.uint16[this._pos2 + 11] = e
              }
              ,
              i.upperSize.get = function() {
                  return this._structArray.uint16[this._pos2 + 12]
              }
              ,
              i.upperSize.set = function(e) {
                  this._structArray.uint16[this._pos2 + 12] = e
              }
              ,
              i.lineOffsetX.get = function() {
                  return this._structArray.float32[this._pos4 + 7]
              }
              ,
              i.lineOffsetX.set = function(e) {
                  this._structArray.float32[this._pos4 + 7] = e
              }
              ,
              i.lineOffsetY.get = function() {
                  return this._structArray.float32[this._pos4 + 8]
              }
              ,
              i.lineOffsetY.set = function(e) {
                  this._structArray.float32[this._pos4 + 8] = e
              }
              ,
              i.writingMode.get = function() {
                  return this._structArray.uint8[this._pos1 + 36]
              }
              ,
              i.writingMode.set = function(e) {
                  this._structArray.uint8[this._pos1 + 36] = e
              }
              ,
              i.hidden.get = function() {
                  return this._structArray.uint8[this._pos1 + 37]
              }
              ,
              i.hidden.set = function(e) {
                  this._structArray.uint8[this._pos1 + 37] = e
              }
              ,
              Object.defineProperties(t.prototype, i),
              t
          }(Un);
          fr.prototype.size = 40;
          var mr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.get = function(e) {
                  return new fr(this,e)
              }
              ,
              t
          }(ir);
          an("PlacedSymbolArray", mr);
          var gr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t;
              var i = {
                  anchorX: {
                      configurable: !0
                  },
                  anchorY: {
                      configurable: !0
                  },
                  horizontalPlacedTextSymbolIndex: {
                      configurable: !0
                  },
                  verticalPlacedTextSymbolIndex: {
                      configurable: !0
                  },
                  key: {
                      configurable: !0
                  },
                  textBoxStartIndex: {
                      configurable: !0
                  },
                  textBoxEndIndex: {
                      configurable: !0
                  },
                  iconBoxStartIndex: {
                      configurable: !0
                  },
                  iconBoxEndIndex: {
                      configurable: !0
                  },
                  featureIndex: {
                      configurable: !0
                  },
                  numGlyphVertices: {
                      configurable: !0
                  },
                  numVerticalGlyphVertices: {
                      configurable: !0
                  },
                  numIconVertices: {
                      configurable: !0
                  },
                  crossTileID: {
                      configurable: !0
                  }
              };
              return i.anchorX.get = function() {
                  return this._structArray.int16[this._pos2 + 0]
              }
              ,
              i.anchorX.set = function(e) {
                  this._structArray.int16[this._pos2 + 0] = e
              }
              ,
              i.anchorY.get = function() {
                  return this._structArray.int16[this._pos2 + 1]
              }
              ,
              i.anchorY.set = function(e) {
                  this._structArray.int16[this._pos2 + 1] = e
              }
              ,
              i.horizontalPlacedTextSymbolIndex.get = function() {
                  return this._structArray.int16[this._pos2 + 2]
              }
              ,
              i.horizontalPlacedTextSymbolIndex.set = function(e) {
                  this._structArray.int16[this._pos2 + 2] = e
              }
              ,
              i.verticalPlacedTextSymbolIndex.get = function() {
                  return this._structArray.int16[this._pos2 + 3]
              }
              ,
              i.verticalPlacedTextSymbolIndex.set = function(e) {
                  this._structArray.int16[this._pos2 + 3] = e
              }
              ,
              i.key.get = function() {
                  return this._structArray.uint16[this._pos2 + 4]
              }
              ,
              i.key.set = function(e) {
                  this._structArray.uint16[this._pos2 + 4] = e
              }
              ,
              i.textBoxStartIndex.get = function() {
                  return this._structArray.uint16[this._pos2 + 5]
              }
              ,
              i.textBoxStartIndex.set = function(e) {
                  this._structArray.uint16[this._pos2 + 5] = e
              }
              ,
              i.textBoxEndIndex.get = function() {
                  return this._structArray.uint16[this._pos2 + 6]
              }
              ,
              i.textBoxEndIndex.set = function(e) {
                  this._structArray.uint16[this._pos2 + 6] = e
              }
              ,
              i.iconBoxStartIndex.get = function() {
                  return this._structArray.uint16[this._pos2 + 7]
              }
              ,
              i.iconBoxStartIndex.set = function(e) {
                  this._structArray.uint16[this._pos2 + 7] = e
              }
              ,
              i.iconBoxEndIndex.get = function() {
                  return this._structArray.uint16[this._pos2 + 8]
              }
              ,
              i.iconBoxEndIndex.set = function(e) {
                  this._structArray.uint16[this._pos2 + 8] = e
              }
              ,
              i.featureIndex.get = function() {
                  return this._structArray.uint16[this._pos2 + 9]
              }
              ,
              i.featureIndex.set = function(e) {
                  this._structArray.uint16[this._pos2 + 9] = e
              }
              ,
              i.numGlyphVertices.get = function() {
                  return this._structArray.uint16[this._pos2 + 10]
              }
              ,
              i.numGlyphVertices.set = function(e) {
                  this._structArray.uint16[this._pos2 + 10] = e
              }
              ,
              i.numVerticalGlyphVertices.get = function() {
                  return this._structArray.uint16[this._pos2 + 11]
              }
              ,
              i.numVerticalGlyphVertices.set = function(e) {
                  this._structArray.uint16[this._pos2 + 11] = e
              }
              ,
              i.numIconVertices.get = function() {
                  return this._structArray.uint16[this._pos2 + 12]
              }
              ,
              i.numIconVertices.set = function(e) {
                  this._structArray.uint16[this._pos2 + 12] = e
              }
              ,
              i.crossTileID.get = function() {
                  return this._structArray.uint32[this._pos4 + 7]
              }
              ,
              i.crossTileID.set = function(e) {
                  this._structArray.uint32[this._pos4 + 7] = e
              }
              ,
              Object.defineProperties(t.prototype, i),
              t
          }(Un);
          gr.prototype.size = 32;
          var vr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.get = function(e) {
                  return new gr(this,e)
              }
              ,
              t
          }(nr);
          an("SymbolInstanceArray", vr);
          var yr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t;
              var i = {
                  offsetX: {
                      configurable: !0
                  }
              };
              return i.offsetX.get = function() {
                  return this._structArray.float32[this._pos4 + 0]
              }
              ,
              i.offsetX.set = function(e) {
                  this._structArray.float32[this._pos4 + 0] = e
              }
              ,
              Object.defineProperties(t.prototype, i),
              t
          }(Un);
          yr.prototype.size = 4;
          var _r = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getoffsetX = function(e) {
                  return this.float32[1 * e + 0]
              }
              ,
              t.prototype.get = function(e) {
                  return new yr(this,e)
              }
              ,
              t
          }(rr);
          an("GlyphOffsetArray", _r);
          var br = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t;
              var i = {
                  x: {
                      configurable: !0
                  },
                  y: {
                      configurable: !0
                  },
                  tileUnitDistanceFromAnchor: {
                      configurable: !0
                  }
              };
              return i.x.get = function() {
                  return this._structArray.int16[this._pos2 + 0]
              }
              ,
              i.x.set = function(e) {
                  this._structArray.int16[this._pos2 + 0] = e
              }
              ,
              i.y.get = function() {
                  return this._structArray.int16[this._pos2 + 1]
              }
              ,
              i.y.set = function(e) {
                  this._structArray.int16[this._pos2 + 1] = e
              }
              ,
              i.tileUnitDistanceFromAnchor.get = function() {
                  return this._structArray.int16[this._pos2 + 2]
              }
              ,
              i.tileUnitDistanceFromAnchor.set = function(e) {
                  this._structArray.int16[this._pos2 + 2] = e
              }
              ,
              Object.defineProperties(t.prototype, i),
              t
          }(Un);
          br.prototype.size = 6;
          var wr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getx = function(e) {
                  return this.int16[3 * e + 0]
              }
              ,
              t.prototype.gety = function(e) {
                  return this.int16[3 * e + 1]
              }
              ,
              t.prototype.gettileUnitDistanceFromAnchor = function(e) {
                  return this.int16[3 * e + 2]
              }
              ,
              t.prototype.get = function(e) {
                  return new br(this,e)
              }
              ,
              t
          }(or);
          an("SymbolLineVertexArray", wr);
          var xr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t;
              var i = {
                  featureIndex: {
                      configurable: !0
                  },
                  sourceLayerIndex: {
                      configurable: !0
                  },
                  bucketIndex: {
                      configurable: !0
                  }
              };
              return i.featureIndex.get = function() {
                  return this._structArray.uint32[this._pos4 + 0]
              }
              ,
              i.featureIndex.set = function(e) {
                  this._structArray.uint32[this._pos4 + 0] = e
              }
              ,
              i.sourceLayerIndex.get = function() {
                  return this._structArray.uint16[this._pos2 + 2]
              }
              ,
              i.sourceLayerIndex.set = function(e) {
                  this._structArray.uint16[this._pos2 + 2] = e
              }
              ,
              i.bucketIndex.get = function() {
                  return this._structArray.uint16[this._pos2 + 3]
              }
              ,
              i.bucketIndex.set = function(e) {
                  this._structArray.uint16[this._pos2 + 3] = e
              }
              ,
              Object.defineProperties(t.prototype, i),
              t
          }(Un);
          xr.prototype.size = 8;
          var kr = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.get = function(e) {
                  return new xr(this,e)
              }
              ,
              t
          }(sr);
          an("FeatureIndexArray", kr);
          var Sr = Hn([{
              name: "a_pos",
              components: 2,
              type: "Int16"
          }], 4)
            , Er = Sr.members
            , Tr = (Sr.size,
          Sr.alignment,
          function(e) {
              void 0 === e && (e = []),
              this.segments = e
          }
          );
          function Cr(e, t) {
              return 256 * (e = c(Math.floor(e), 0, 255)) + c(Math.floor(t), 0, 255)
          }
          Tr.prototype.prepareSegment = function(e, t, i, n) {
              var r = this.segments[this.segments.length - 1];
              return e > Tr.MAX_VERTEX_ARRAY_LENGTH && x("Max vertices per segment is " + Tr.MAX_VERTEX_ARRAY_LENGTH + ": bucket requested " + e),
              (!r || r.vertexLength + e > Tr.MAX_VERTEX_ARRAY_LENGTH || r.sortKey !== n) && (r = {
                  vertexOffset: t.length,
                  primitiveOffset: i.length,
                  vertexLength: 0,
                  primitiveLength: 0
              },
              void 0 !== n && (r.sortKey = n),
              this.segments.push(r)),
              r
          }
          ,
          Tr.prototype.get = function() {
              return this.segments
          }
          ,
          Tr.prototype.destroy = function() {
              for (var e = 0, t = this.segments; e < t.length; e += 1) {
                  var i = t[e];
                  for (var n in i.vaos)
                      i.vaos[n].destroy()
              }
          }
          ,
          Tr.simpleSegment = function(e, t, i, n) {
              return new Tr([{
                  vertexOffset: e,
                  primitiveOffset: t,
                  vertexLength: i,
                  primitiveLength: n,
                  vaos: {},
                  sortKey: 0
              }])
          }
          ,
          Tr.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1,
          an("SegmentVector", Tr);
          var Lr = function() {
              this.ids = [],
              this.positions = [],
              this.indexed = !1
          };
          function Ar(e, t, i) {
              var n = e[t];
              e[t] = e[i],
              e[i] = n
          }
          Lr.prototype.add = function(e, t, i, n) {
              this.ids.push(e),
              this.positions.push(t, i, n)
          }
          ,
          Lr.prototype.getPositions = function(e) {
              for (var t = 0, i = this.ids.length - 1; t < i; ) {
                  var n = t + i >> 1;
                  this.ids[n] >= e ? i = n : t = n + 1
              }
              for (var r = []; this.ids[t] === e; ) {
                  var o = this.positions[3 * t]
                    , s = this.positions[3 * t + 1]
                    , a = this.positions[3 * t + 2];
                  r.push({
                      index: o,
                      start: s,
                      end: a
                  }),
                  t++
              }
              return r
          }
          ,
          Lr.serialize = function(e, t) {
              var i = new Float64Array(e.ids)
                , n = new Uint32Array(e.positions);
              return function e(t, i, n, r) {
                  if (!(n >= r)) {
                      for (var o = t[n + r >> 1], s = n - 1, a = r + 1; ; ) {
                          do {
                              s++
                          } while (t[s] < o);do {
                              a--
                          } while (t[a] > o);if (s >= a)
                              break;
                          Ar(t, s, a),
                          Ar(i, 3 * s, 3 * a),
                          Ar(i, 3 * s + 1, 3 * a + 1),
                          Ar(i, 3 * s + 2, 3 * a + 2)
                      }
                      e(t, i, n, a),
                      e(t, i, a + 1, r)
                  }
              }(i, n, 0, i.length - 1),
              t.push(i.buffer, n.buffer),
              {
                  ids: i,
                  positions: n
              }
          }
          ,
          Lr.deserialize = function(e) {
              var t = new Lr;
              return t.ids = e.ids,
              t.positions = e.positions,
              t.indexed = !0,
              t
          }
          ,
          an("FeaturePositionMap", Lr);
          var Pr = function(e, t) {
              this.gl = e.gl,
              this.location = t
          }
            , Ir = function(e) {
              function t(t, i) {
                  e.call(this, t, i),
                  this.current = 0
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.set = function(e) {
                  this.current !== e && (this.current = e,
                  this.gl.uniform1i(this.location, e))
              }
              ,
              t
          }(Pr)
            , Mr = function(e) {
              function t(t, i) {
                  e.call(this, t, i),
                  this.current = 0
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.set = function(e) {
                  this.current !== e && (this.current = e,
                  this.gl.uniform1f(this.location, e))
              }
              ,
              t
          }(Pr)
            , Or = function(e) {
              function t(t, i) {
                  e.call(this, t, i),
                  this.current = [0, 0]
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.set = function(e) {
                  e[0] === this.current[0] && e[1] === this.current[1] || (this.current = e,
                  this.gl.uniform2f(this.location, e[0], e[1]))
              }
              ,
              t
          }(Pr)
            , zr = function(e) {
              function t(t, i) {
                  e.call(this, t, i),
                  this.current = [0, 0, 0]
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.set = function(e) {
                  e[0] === this.current[0] && e[1] === this.current[1] && e[2] === this.current[2] || (this.current = e,
                  this.gl.uniform3f(this.location, e[0], e[1], e[2]))
              }
              ,
              t
          }(Pr)
            , Dr = function(e) {
              function t(t, i) {
                  e.call(this, t, i),
                  this.current = [0, 0, 0, 0]
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.set = function(e) {
                  e[0] === this.current[0] && e[1] === this.current[1] && e[2] === this.current[2] && e[3] === this.current[3] || (this.current = e,
                  this.gl.uniform4f(this.location, e[0], e[1], e[2], e[3]))
              }
              ,
              t
          }(Pr)
            , Rr = function(e) {
              function t(t, i) {
                  e.call(this, t, i),
                  this.current = je.transparent
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.set = function(e) {
                  e.r === this.current.r && e.g === this.current.g && e.b === this.current.b && e.a === this.current.a || (this.current = e,
                  this.gl.uniform4f(this.location, e.r, e.g, e.b, e.a))
              }
              ,
              t
          }(Pr)
            , Br = new Float32Array(16)
            , jr = function(e) {
              function t(t, i) {
                  e.call(this, t, i),
                  this.current = Br
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.set = function(e) {
                  if (e[12] !== this.current[12] || e[0] !== this.current[0])
                      return this.current = e,
                      void this.gl.uniformMatrix4fv(this.location, !1, e);
                  for (var t = 1; t < 16; t++)
                      if (e[t] !== this.current[t]) {
                          this.current = e,
                          this.gl.uniformMatrix4fv(this.location, !1, e);
                          break
                      }
              }
              ,
              t
          }(Pr);
          function Fr(e) {
              return [Cr(255 * e.r, 255 * e.g), Cr(255 * e.b, 255 * e.a)]
          }
          var Nr = function(e, t, i) {
              this.value = e,
              this.names = t,
              this.uniformNames = this.names.map(function(e) {
                  return "u_" + e
              }),
              this.type = i,
              this.maxValue = -1 / 0
          };
          Nr.prototype.defines = function() {
              return this.names.map(function(e) {
                  return "#define HAS_UNIFORM_u_" + e
              })
          }
          ,
          Nr.prototype.setConstantPatternPositions = function() {}
          ,
          Nr.prototype.populatePaintArray = function() {}
          ,
          Nr.prototype.updatePaintArray = function() {}
          ,
          Nr.prototype.upload = function() {}
          ,
          Nr.prototype.destroy = function() {}
          ,
          Nr.prototype.setUniforms = function(e, t, i, n) {
              t.set(n.constantOr(this.value))
          }
          ,
          Nr.prototype.getBinding = function(e, t) {
              return "color" === this.type ? new Rr(e,t) : new Mr(e,t)
          }
          ,
          Nr.serialize = function(e) {
              var t = e.value
                , i = e.names
                , n = e.type;
              return {
                  value: cn(t),
                  names: i,
                  type: n
              }
          }
          ,
          Nr.deserialize = function(e) {
              var t = e.value
                , i = e.names
                , n = e.type;
              return new Nr(un(t),i,n)
          }
          ;
          var Ur = function(e, t, i) {
              this.value = e,
              this.names = t,
              this.uniformNames = this.names.map(function(e) {
                  return "u_" + e
              }),
              this.type = i,
              this.maxValue = -1 / 0,
              this.patternPositions = {
                  patternTo: null,
                  patternFrom: null
              }
          };
          Ur.prototype.defines = function() {
              return this.names.map(function(e) {
                  return "#define HAS_UNIFORM_u_" + e
              })
          }
          ,
          Ur.prototype.populatePaintArray = function() {}
          ,
          Ur.prototype.updatePaintArray = function() {}
          ,
          Ur.prototype.upload = function() {}
          ,
          Ur.prototype.destroy = function() {}
          ,
          Ur.prototype.setConstantPatternPositions = function(e, t) {
              this.patternPositions.patternTo = e.tlbr,
              this.patternPositions.patternFrom = t.tlbr
          }
          ,
          Ur.prototype.setUniforms = function(e, t, i, n, r) {
              var o = this.patternPositions;
              "u_pattern_to" === r && o.patternTo && t.set(o.patternTo),
              "u_pattern_from" === r && o.patternFrom && t.set(o.patternFrom)
          }
          ,
          Ur.prototype.getBinding = function(e, t) {
              return new Dr(e,t)
          }
          ;
          var qr = function(e, t, i, n) {
              this.expression = e,
              this.names = t,
              this.type = i,
              this.uniformNames = this.names.map(function(e) {
                  return "a_" + e
              }),
              this.maxValue = -1 / 0,
              this.paintVertexAttributes = t.map(function(e) {
                  return {
                      name: "a_" + e,
                      type: "Float32",
                      components: "color" === i ? 2 : 1,
                      offset: 0
                  }
              }),
              this.paintVertexArray = new n
          };
          qr.prototype.defines = function() {
              return []
          }
          ,
          qr.prototype.setConstantPatternPositions = function() {}
          ,
          qr.prototype.populatePaintArray = function(e, t) {
              var i = this.paintVertexArray
                , n = i.length;
              i.reserve(e);
              var r = this.expression.evaluate(new Sn(0), t, {});
              if ("color" === this.type)
                  for (var o = Fr(r), s = n; s < e; s++)
                      i.emplaceBack(o[0], o[1]);
              else {
                  for (var a = n; a < e; a++)
                      i.emplaceBack(r);
                  this.maxValue = Math.max(this.maxValue, r)
              }
          }
          ,
          qr.prototype.updatePaintArray = function(e, t, i, n) {
              var r = this.paintVertexArray
                , o = this.expression.evaluate({
                  zoom: 0
              }, i, n);
              if ("color" === this.type)
                  for (var s = Fr(o), a = e; a < t; a++)
                      r.emplace(a, s[0], s[1]);
              else {
                  for (var l = e; l < t; l++)
                      r.emplace(l, o);
                  this.maxValue = Math.max(this.maxValue, o)
              }
          }
          ,
          qr.prototype.upload = function(e) {
              this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent))
          }
          ,
          qr.prototype.destroy = function() {
              this.paintVertexBuffer && this.paintVertexBuffer.destroy()
          }
          ,
          qr.prototype.setUniforms = function(e, t) {
              t.set(0)
          }
          ,
          qr.prototype.getBinding = function(e, t) {
              return new Mr(e,t)
          }
          ;
          var Hr = function(e, t, i, n, r, o) {
              this.expression = e,
              this.names = t,
              this.uniformNames = this.names.map(function(e) {
                  return "a_" + e + "_t"
              }),
              this.type = i,
              this.useIntegerZoom = n,
              this.zoom = r,
              this.maxValue = -1 / 0;
              var s = o;
              this.paintVertexAttributes = t.map(function(e) {
                  return {
                      name: "a_" + e,
                      type: "Float32",
                      components: "color" === i ? 4 : 2,
                      offset: 0
                  }
              }),
              this.paintVertexArray = new s
          };
          Hr.prototype.defines = function() {
              return []
          }
          ,
          Hr.prototype.setConstantPatternPositions = function() {}
          ,
          Hr.prototype.populatePaintArray = function(e, t) {
              var i = this.paintVertexArray
                , n = i.length;
              i.reserve(e);
              var r = this.expression.evaluate(new Sn(this.zoom), t, {})
                , o = this.expression.evaluate(new Sn(this.zoom + 1), t, {});
              if ("color" === this.type)
                  for (var s = Fr(r), a = Fr(o), l = n; l < e; l++)
                      i.emplaceBack(s[0], s[1], a[0], a[1]);
              else {
                  for (var c = n; c < e; c++)
                      i.emplaceBack(r, o);
                  this.maxValue = Math.max(this.maxValue, r, o)
              }
          }
          ,
          Hr.prototype.updatePaintArray = function(e, t, i, n) {
              var r = this.paintVertexArray
                , o = this.expression.evaluate({
                  zoom: this.zoom
              }, i, n)
                , s = this.expression.evaluate({
                  zoom: this.zoom + 1
              }, i, n);
              if ("color" === this.type)
                  for (var a = Fr(o), l = Fr(s), c = e; c < t; c++)
                      r.emplace(c, a[0], a[1], l[0], l[1]);
              else {
                  for (var u = e; u < t; u++)
                      r.emplace(u, o, s);
                  this.maxValue = Math.max(this.maxValue, o, s)
              }
          }
          ,
          Hr.prototype.upload = function(e) {
              this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent))
          }
          ,
          Hr.prototype.destroy = function() {
              this.paintVertexBuffer && this.paintVertexBuffer.destroy()
          }
          ,
          Hr.prototype.interpolationFactor = function(e) {
              return this.useIntegerZoom ? this.expression.interpolationFactor(Math.floor(e), this.zoom, this.zoom + 1) : this.expression.interpolationFactor(e, this.zoom, this.zoom + 1)
          }
          ,
          Hr.prototype.setUniforms = function(e, t, i) {
              t.set(this.interpolationFactor(i.zoom))
          }
          ,
          Hr.prototype.getBinding = function(e, t) {
              return new Mr(e,t)
          }
          ;
          var Vr = function(e, t, i, n, r, o, s) {
              this.expression = e,
              this.names = t,
              this.type = i,
              this.uniformNames = this.names.map(function(e) {
                  return "a_" + e + "_t"
              }),
              this.useIntegerZoom = n,
              this.zoom = r,
              this.maxValue = -1 / 0,
              this.layerId = s,
              this.paintVertexAttributes = t.map(function(e) {
                  return {
                      name: "a_" + e,
                      type: "Uint16",
                      components: 4,
                      offset: 0
                  }
              }),
              this.zoomInPaintVertexArray = new o,
              this.zoomOutPaintVertexArray = new o
          };
          Vr.prototype.defines = function() {
              return []
          }
          ,
          Vr.prototype.setConstantPatternPositions = function() {}
          ,
          Vr.prototype.populatePaintArray = function(e, t, i) {
              var n = this.zoomInPaintVertexArray
                , r = this.zoomOutPaintVertexArray
                , o = this.layerId
                , s = n.length;
              if (n.reserve(e),
              r.reserve(e),
              i && t.patterns && t.patterns[o]) {
                  var a = t.patterns[o]
                    , l = a.min
                    , c = a.mid
                    , u = a.max
                    , h = i[l]
                    , d = i[c]
                    , p = i[u];
                  if (!h || !d || !p)
                      return;
                  for (var f = s; f < e; f++)
                      n.emplaceBack(d.tl[0], d.tl[1], d.br[0], d.br[1], h.tl[0], h.tl[1], h.br[0], h.br[1]),
                      r.emplaceBack(d.tl[0], d.tl[1], d.br[0], d.br[1], p.tl[0], p.tl[1], p.br[0], p.br[1])
              }
          }
          ,
          Vr.prototype.updatePaintArray = function(e, t, i, n, r) {
              var o = this.zoomInPaintVertexArray
                , s = this.zoomOutPaintVertexArray
                , a = this.layerId;
              if (r && i.patterns && i.patterns[a]) {
                  var l = i.patterns[a]
                    , c = l.min
                    , u = l.mid
                    , h = l.max
                    , d = r[c]
                    , p = r[u]
                    , f = r[h];
                  if (!d || !p || !f)
                      return;
                  for (var m = e; m < t; m++)
                      o.emplace(m, p.tl[0], p.tl[1], p.br[0], p.br[1], d.tl[0], d.tl[1], d.br[0], d.br[1]),
                      s.emplace(m, p.tl[0], p.tl[1], p.br[0], p.br[1], f.tl[0], f.tl[1], f.br[0], f.br[1])
              }
          }
          ,
          Vr.prototype.upload = function(e) {
              this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = e.createVertexBuffer(this.zoomInPaintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent),
              this.zoomOutPaintVertexBuffer = e.createVertexBuffer(this.zoomOutPaintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent))
          }
          ,
          Vr.prototype.destroy = function() {
              this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(),
              this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy()
          }
          ,
          Vr.prototype.setUniforms = function(e, t) {
              t.set(0)
          }
          ,
          Vr.prototype.getBinding = function(e, t) {
              return new Mr(e,t)
          }
          ;
          var Wr = function() {
              this.binders = {},
              this.cacheKey = "",
              this._buffers = [],
              this._featureMap = new Lr,
              this._bufferOffset = 0
          };
          Wr.createDynamic = function(e, t, i) {
              var n = new Wr
                , r = [];
              for (var o in e.paint._values)
                  if (i(o)) {
                      var s = e.paint.get(o);
                      if (s instanceof In && ti(s.property.specification)) {
                          var a = Gr(o, e.type)
                            , l = s.property.specification.type
                            , c = s.property.useIntegerZoom;
                          if ("cross-faded" === s.property.specification["property-type"] || "cross-faded-data-driven" === s.property.specification["property-type"])
                              if ("constant" === s.value.kind)
                                  n.binders[o] = new Ur(s.value.value,a,l),
                                  r.push("/u_" + o);
                              else {
                                  var u = Xr(o, l, "source");
                                  n.binders[o] = new Vr(s.value,a,l,c,t,u,e.id),
                                  r.push("/a_" + o)
                              }
                          else if ("constant" === s.value.kind)
                              n.binders[o] = new Nr(s.value.value,a,l),
                              r.push("/u_" + o);
                          else if ("source" === s.value.kind) {
                              var h = Xr(o, l, "source");
                              n.binders[o] = new qr(s.value,a,l,h),
                              r.push("/a_" + o)
                          } else {
                              var d = Xr(o, l, "composite");
                              n.binders[o] = new Hr(s.value,a,l,c,t,d),
                              r.push("/z_" + o)
                          }
                      }
                  }
              return n.cacheKey = r.sort().join(""),
              n
          }
          ,
          Wr.prototype.populatePaintArrays = function(e, t, i, n) {
              for (var r in this.binders)
                  this.binders[r].populatePaintArray(e, t, n);
              void 0 !== t.id && this._featureMap.add(+t.id, i, this._bufferOffset, e),
              this._bufferOffset = e
          }
          ,
          Wr.prototype.setConstantPatternPositions = function(e, t) {
              for (var i in this.binders)
                  this.binders[i].setConstantPatternPositions(e, t)
          }
          ,
          Wr.prototype.updatePaintArrays = function(e, t, i, n) {
              var r = !1;
              for (var o in e)
                  for (var s = 0, a = this._featureMap.getPositions(+o); s < a.length; s += 1) {
                      var l = a[s]
                        , c = t.feature(l.index);
                      for (var u in this.binders) {
                          var h = this.binders[u];
                          if (!(h instanceof Nr || h instanceof Ur) && !0 === h.expression.isStateDependent) {
                              var d = i.paint.get(u);
                              h.expression = d.value,
                              h.updatePaintArray(l.start, l.end, c, e[o], n),
                              r = !0
                          }
                      }
                  }
              return r
          }
          ,
          Wr.prototype.defines = function() {
              var e = [];
              for (var t in this.binders)
                  e.push.apply(e, this.binders[t].defines());
              return e
          }
          ,
          Wr.prototype.getPaintVertexBuffers = function() {
              return this._buffers
          }
          ,
          Wr.prototype.getUniforms = function(e, t) {
              var i = {};
              for (var n in this.binders)
                  for (var r = this.binders[n], o = 0, s = r.uniformNames; o < s.length; o += 1) {
                      var a = s[o];
                      i[a] = r.getBinding(e, t[a])
                  }
              return i
          }
          ,
          Wr.prototype.setUniforms = function(e, t, i, n) {
              for (var r in this.binders)
                  for (var o = this.binders[r], s = 0, a = o.uniformNames; s < a.length; s += 1) {
                      var l = a[s];
                      o.setUniforms(e, t[l], n, i.get(r), l)
                  }
          }
          ,
          Wr.prototype.updatePatternPaintBuffers = function(e) {
              var t = [];
              for (var i in this.binders) {
                  var n = this.binders[i];
                  if (n instanceof Vr) {
                      var r = 2 === e.fromScale ? n.zoomInPaintVertexBuffer : n.zoomOutPaintVertexBuffer;
                      r && t.push(r)
                  } else
                      (n instanceof qr || n instanceof Hr) && n.paintVertexBuffer && t.push(n.paintVertexBuffer)
              }
              this._buffers = t
          }
          ,
          Wr.prototype.upload = function(e) {
              for (var t in this.binders)
                  this.binders[t].upload(e);
              var i = [];
              for (var n in this.binders) {
                  var r = this.binders[n];
                  (r instanceof qr || r instanceof Hr) && r.paintVertexBuffer && i.push(r.paintVertexBuffer)
              }
              this._buffers = i
          }
          ,
          Wr.prototype.destroy = function() {
              for (var e in this.binders)
                  this.binders[e].destroy()
          }
          ;
          var $r = function(e, t, i, n) {
              void 0 === n && (n = function() {
                  return !0
              }
              ),
              this.programConfigurations = {};
              for (var r = 0, o = t; r < o.length; r += 1) {
                  var s = o[r];
                  this.programConfigurations[s.id] = Wr.createDynamic(s, i, n),
                  this.programConfigurations[s.id].layoutAttributes = e
              }
              this.needsUpload = !1
          };
          function Gr(e, t) {
              return {
                  "text-opacity": ["opacity"],
                  "icon-opacity": ["opacity"],
                  "text-color": ["fill_color"],
                  "icon-color": ["fill_color"],
                  "text-halo-color": ["halo_color"],
                  "icon-halo-color": ["halo_color"],
                  "text-halo-blur": ["halo_blur"],
                  "icon-halo-blur": ["halo_blur"],
                  "text-halo-width": ["halo_width"],
                  "icon-halo-width": ["halo_width"],
                  "line-gap-width": ["gapwidth"],
                  "line-pattern": ["pattern_to", "pattern_from"],
                  "fill-pattern": ["pattern_to", "pattern_from"],
                  "fill-extrusion-pattern": ["pattern_to", "pattern_from"]
              }[e] || [e.replace(t + "-", "").replace(/-/g, "_")]
          }
          function Xr(e, t, i) {
              var n = {
                  color: {
                      source: ur,
                      composite: hr
                  },
                  number: {
                      source: rr,
                      composite: ur
                  }
              }
                , r = function(e) {
                  return {
                      "line-pattern": {
                          source: Zn,
                          composite: Zn
                      },
                      "fill-pattern": {
                          source: Zn,
                          composite: Zn
                      },
                      "fill-extrusion-pattern": {
                          source: Zn,
                          composite: Zn
                      }
                  }[e]
              }(e);
              return r && r[i] || n[t][i]
          }
          $r.prototype.populatePaintArrays = function(e, t, i, n) {
              for (var r in this.programConfigurations)
                  this.programConfigurations[r].populatePaintArrays(e, t, i, n);
              this.needsUpload = !0
          }
          ,
          $r.prototype.updatePaintArrays = function(e, t, i, n) {
              for (var r = 0, o = i; r < o.length; r += 1) {
                  var s = o[r];
                  this.needsUpload = this.programConfigurations[s.id].updatePaintArrays(e, t, s, n) || this.needsUpload
              }
          }
          ,
          $r.prototype.get = function(e) {
              return this.programConfigurations[e]
          }
          ,
          $r.prototype.upload = function(e) {
              if (this.needsUpload) {
                  for (var t in this.programConfigurations)
                      this.programConfigurations[t].upload(e);
                  this.needsUpload = !1
              }
          }
          ,
          $r.prototype.destroy = function() {
              for (var e in this.programConfigurations)
                  this.programConfigurations[e].destroy()
          }
          ,
          an("ConstantBinder", Nr),
          an("CrossFadedConstantBinder", Ur),
          an("SourceExpressionBinder", qr),
          an("CrossFadedCompositeBinder", Vr),
          an("CompositeExpressionBinder", Hr),
          an("ProgramConfiguration", Wr, {
              omit: ["_buffers"]
          }),
          an("ProgramConfigurationSet", $r);
          var Zr = 8192
            , Yr = {
              min: -1 * Math.pow(2, 15),
              max: Math.pow(2, 15) - 1
          };
          function Kr(e) {
              for (var t = Zr / e.extent, i = e.loadGeometry(), n = 0; n < i.length; n++)
                  for (var r = i[n], o = 0; o < r.length; o++) {
                      var s = r[o];
                      s.x = Math.round(s.x * t),
                      s.y = Math.round(s.y * t),
                      (s.x < Yr.min || s.x > Yr.max || s.y < Yr.min || s.y > Yr.max) && x("Geometry exceeds allowed extent, reduce your vector tile buffer size")
                  }
              return i
          }
          function Jr(e, t, i, n, r) {
              e.emplaceBack(2 * t + (n + 1) / 2, 2 * i + (r + 1) / 2)
          }
          var Qr = function(e) {
              this.zoom = e.zoom,
              this.overscaling = e.overscaling,
              this.layers = e.layers,
              this.layerIds = this.layers.map(function(e) {
                  return e.id
              }),
              this.index = e.index,
              this.hasPattern = !1,
              this.layoutVertexArray = new Wn,
              this.indexArray = new ar,
              this.segments = new Tr,
              this.programConfigurations = new $r(Er,e.layers,e.zoom),
              this.stateDependentLayerIds = this.layers.filter(function(e) {
                  return e.isStateDependent()
              }).map(function(e) {
                  return e.id
              })
          };
          function eo(e, t) {
              for (var i = 0; i < e.length; i++)
                  if (co(t, e[i]))
                      return !0;
              for (var n = 0; n < t.length; n++)
                  if (co(e, t[n]))
                      return !0;
              return !!ro(e, t)
          }
          function to(e, t, i) {
              return !!co(e, t) || !!so(t, e, i)
          }
          function io(e, t) {
              if (1 === e.length)
                  return lo(t, e[0]);
              for (var i = 0; i < t.length; i++)
                  for (var n = t[i], r = 0; r < n.length; r++)
                      if (co(e, n[r]))
                          return !0;
              for (var o = 0; o < e.length; o++)
                  if (lo(t, e[o]))
                      return !0;
              for (var s = 0; s < t.length; s++)
                  if (ro(e, t[s]))
                      return !0;
              return !1
          }
          function no(e, t, i) {
              if (e.length > 1) {
                  if (ro(e, t))
                      return !0;
                  for (var n = 0; n < t.length; n++)
                      if (so(t[n], e, i))
                          return !0
              }
              for (var r = 0; r < e.length; r++)
                  if (so(e[r], t, i))
                      return !0;
              return !1
          }
          function ro(e, t) {
              if (0 === e.length || 0 === t.length)
                  return !1;
              for (var i = 0; i < e.length - 1; i++)
                  for (var n = e[i], r = e[i + 1], o = 0; o < t.length - 1; o++)
                      if (oo(n, r, t[o], t[o + 1]))
                          return !0;
              return !1
          }
          function oo(e, t, i, n) {
              return k(e, i, n) !== k(t, i, n) && k(e, t, i) !== k(e, t, n)
          }
          function so(e, t, i) {
              var n = i * i;
              if (1 === t.length)
                  return e.distSqr(t[0]) < n;
              for (var r = 1; r < t.length; r++)
                  if (ao(e, t[r - 1], t[r]) < n)
                      return !0;
              return !1
          }
          function ao(e, t, i) {
              var n = t.distSqr(i);
              if (0 === n)
                  return e.distSqr(t);
              var r = ((e.x - t.x) * (i.x - t.x) + (e.y - t.y) * (i.y - t.y)) / n;
              return r < 0 ? e.distSqr(t) : r > 1 ? e.distSqr(i) : e.distSqr(i.sub(t)._mult(r)._add(t))
          }
          function lo(e, t) {
              for (var i, n, r, o = !1, s = 0; s < e.length; s++)
                  for (var a = 0, l = (i = e[s]).length - 1; a < i.length; l = a++)
                      n = i[a],
                      r = i[l],
                      n.y > t.y != r.y > t.y && t.x < (r.x - n.x) * (t.y - n.y) / (r.y - n.y) + n.x && (o = !o);
              return o
          }
          function co(e, t) {
              for (var i = !1, n = 0, r = e.length - 1; n < e.length; r = n++) {
                  var o = e[n]
                    , s = e[r];
                  o.y > t.y != s.y > t.y && t.x < (s.x - o.x) * (t.y - o.y) / (s.y - o.y) + o.x && (i = !i)
              }
              return i
          }
          function uo(e, t, i) {
              var n = i[0]
                , r = i[2];
              if (e.x < n.x && t.x < n.x || e.x > r.x && t.x > r.x || e.y < n.y && t.y < n.y || e.y > r.y && t.y > r.y)
                  return !1;
              var o = k(e, t, i[0]);
              return o !== k(e, t, i[1]) || o !== k(e, t, i[2]) || o !== k(e, t, i[3])
          }
          function ho(e, t, i) {
              var n = t.paint.get(e).value;
              return "constant" === n.kind ? n.value : i.programConfigurations.get(t.id).binders[e].maxValue
          }
          function po(e) {
              return Math.sqrt(e[0] * e[0] + e[1] * e[1])
          }
          function fo(e, t, i, n, o) {
              if (!t[0] && !t[1])
                  return e;
              var s = r.convert(t)._mult(o);
              "viewport" === i && s._rotate(-n);
              for (var a = [], l = 0; l < e.length; l++) {
                  var c = e[l];
                  a.push(c.sub(s))
              }
              return a
          }
          Qr.prototype.populate = function(e, t) {
              for (var i = 0, n = e; i < n.length; i += 1) {
                  var r = n[i]
                    , o = r.feature
                    , s = r.index
                    , a = r.sourceLayerIndex;
                  if (this.layers[0]._featureFilter(new Sn(this.zoom), o)) {
                      var l = Kr(o);
                      this.addFeature(o, l, s),
                      t.featureIndex.insert(o, l, s, a, this.index)
                  }
              }
          }
          ,
          Qr.prototype.update = function(e, t, i) {
              this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e, t, this.stateDependentLayers, i)
          }
          ,
          Qr.prototype.isEmpty = function() {
              return 0 === this.layoutVertexArray.length
          }
          ,
          Qr.prototype.uploadPending = function() {
              return !this.uploaded || this.programConfigurations.needsUpload
          }
          ,
          Qr.prototype.upload = function(e) {
              this.uploaded || (this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, Er),
              this.indexBuffer = e.createIndexBuffer(this.indexArray)),
              this.programConfigurations.upload(e),
              this.uploaded = !0
          }
          ,
          Qr.prototype.destroy = function() {
              this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(),
              this.indexBuffer.destroy(),
              this.programConfigurations.destroy(),
              this.segments.destroy())
          }
          ,
          Qr.prototype.addFeature = function(e, t, i) {
              for (var n = 0, r = t; n < r.length; n += 1)
                  for (var o = 0, s = r[n]; o < s.length; o += 1) {
                      var a = s[o]
                        , l = a.x
                        , c = a.y;
                      if (!(l < 0 || l >= Zr || c < 0 || c >= Zr)) {
                          var u = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray)
                            , h = u.vertexLength;
                          Jr(this.layoutVertexArray, l, c, -1, -1),
                          Jr(this.layoutVertexArray, l, c, 1, -1),
                          Jr(this.layoutVertexArray, l, c, 1, 1),
                          Jr(this.layoutVertexArray, l, c, -1, 1),
                          this.indexArray.emplaceBack(h, h + 1, h + 2),
                          this.indexArray.emplaceBack(h, h + 3, h + 2),
                          u.vertexLength += 4,
                          u.primitiveLength += 2
                      }
                  }
              this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e, i, {})
          }
          ,
          an("CircleBucket", Qr, {
              omit: ["layers"]
          });
          var mo = {
              paint: new jn({
                  "circle-radius": new zn(ge.paint_circle["circle-radius"]),
                  "circle-color": new zn(ge.paint_circle["circle-color"]),
                  "circle-blur": new zn(ge.paint_circle["circle-blur"]),
                  "circle-opacity": new zn(ge.paint_circle["circle-opacity"]),
                  "circle-translate": new On(ge.paint_circle["circle-translate"]),
                  "circle-translate-anchor": new On(ge.paint_circle["circle-translate-anchor"]),
                  "circle-pitch-scale": new On(ge.paint_circle["circle-pitch-scale"]),
                  "circle-pitch-alignment": new On(ge.paint_circle["circle-pitch-alignment"]),
                  "circle-stroke-width": new zn(ge.paint_circle["circle-stroke-width"]),
                  "circle-stroke-color": new zn(ge.paint_circle["circle-stroke-color"]),
                  "circle-stroke-opacity": new zn(ge.paint_circle["circle-stroke-opacity"])
              })
          }
            , go = "undefined" != typeof Float32Array ? Float32Array : Array;
          function vo() {
              var e = new go(9);
              return go != Float32Array && (e[1] = 0,
              e[2] = 0,
              e[3] = 0,
              e[5] = 0,
              e[6] = 0,
              e[7] = 0),
              e[0] = 1,
              e[4] = 1,
              e[8] = 1,
              e
          }
          function yo() {
              var e = new go(3);
              return go != Float32Array && (e[0] = 0,
              e[1] = 0,
              e[2] = 0),
              e
          }
          function _o(e, t, i) {
              var n = new go(3);
              return n[0] = e,
              n[1] = t,
              n[2] = i,
              n
          }
          function bo(e, t, i) {
              var n = t[0]
                , r = t[1]
                , o = t[2]
                , s = t[3];
              return e[0] = i[0] * n + i[4] * r + i[8] * o + i[12] * s,
              e[1] = i[1] * n + i[5] * r + i[9] * o + i[13] * s,
              e[2] = i[2] * n + i[6] * r + i[10] * o + i[14] * s,
              e[3] = i[3] * n + i[7] * r + i[11] * o + i[15] * s,
              e
          }
          function wo() {
              var e = new go(4);
              return go != Float32Array && (e[0] = 0,
              e[1] = 0,
              e[2] = 0),
              e[3] = 1,
              e
          }
          Math.PI,
          yo(),
          function() {
              var e;
              e = new go(4),
              go != Float32Array && (e[0] = 0,
              e[1] = 0,
              e[2] = 0,
              e[3] = 0)
          }(),
          yo(),
          _o(1, 0, 0),
          _o(0, 1, 0),
          wo(),
          wo(),
          vo(),
          function() {
              var e;
              e = new go(2),
              go != Float32Array && (e[0] = 0,
              e[1] = 0)
          }();
          var xo = function(e) {
              function t(t) {
                  e.call(this, t, mo)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.createBucket = function(e) {
                  return new Qr(e)
              }
              ,
              t.prototype.queryRadius = function(e) {
                  var t = e;
                  return ho("circle-radius", this, t) + ho("circle-stroke-width", this, t) + po(this.paint.get("circle-translate"))
              }
              ,
              t.prototype.queryIntersectsFeature = function(e, t, i, n, r, o, s, a) {
                  for (var l = fo(e, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), o.angle, s), c = this.paint.get("circle-radius").evaluate(t, i) + this.paint.get("circle-stroke-width").evaluate(t, i), u = "map" === this.paint.get("circle-pitch-alignment"), h = u ? l : function(e, t) {
                      return l.map(function(e) {
                          return ko(e, t)
                      })
                  }(0, a), d = u ? c * s : c, p = 0, f = n; p < f.length; p += 1)
                      for (var m = 0, g = f[p]; m < g.length; m += 1) {
                          var v = g[m]
                            , y = u ? v : ko(v, a)
                            , _ = d
                            , b = bo([], [v.x, v.y, 0, 1], a);
                          if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? _ *= b[3] / o.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (_ *= o.cameraToCenterDistance / b[3]),
                          to(h, y, _))
                              return !0
                      }
                  return !1
              }
              ,
              t
          }(Fn);
          function ko(e, t) {
              var i = bo([], [e.x, e.y, 0, 1], t);
              return new r(i[0] / i[3],i[1] / i[3])
          }
          var So = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t
          }(Qr);
          function Eo(e, t, i, n) {
              var r = t.width
                , o = t.height;
              if (n) {
                  if (n.length !== r * o * i)
                      throw new RangeError("mismatched image size")
              } else
                  n = new Uint8Array(r * o * i);
              return e.width = r,
              e.height = o,
              e.data = n,
              e
          }
          function To(e, t, i) {
              var n = t.width
                , r = t.height;
              if (n !== e.width || r !== e.height) {
                  var o = Eo({}, {
                      width: n,
                      height: r
                  }, i);
                  Co(e, o, {
                      x: 0,
                      y: 0
                  }, {
                      x: 0,
                      y: 0
                  }, {
                      width: Math.min(e.width, n),
                      height: Math.min(e.height, r)
                  }, i),
                  e.width = n,
                  e.height = r,
                  e.data = o.data
              }
          }
          function Co(e, t, i, n, r, o) {
              if (0 === r.width || 0 === r.height)
                  return t;
              if (r.width > e.width || r.height > e.height || i.x > e.width - r.width || i.y > e.height - r.height)
                  throw new RangeError("out of range source coordinates for image copy");
              if (r.width > t.width || r.height > t.height || n.x > t.width - r.width || n.y > t.height - r.height)
                  throw new RangeError("out of range destination coordinates for image copy");
              for (var s = e.data, a = t.data, l = 0; l < r.height; l++)
                  for (var c = ((i.y + l) * e.width + i.x) * o, u = ((n.y + l) * t.width + n.x) * o, h = 0; h < r.width * o; h++)
                      a[u + h] = s[c + h];
              return t
          }
          an("HeatmapBucket", So, {
              omit: ["layers"]
          });
          var Lo = function(e, t) {
              Eo(this, e, 1, t)
          };
          Lo.prototype.resize = function(e) {
              To(this, e, 1)
          }
          ,
          Lo.prototype.clone = function() {
              return new Lo({
                  width: this.width,
                  height: this.height
              },new Uint8Array(this.data))
          }
          ,
          Lo.copy = function(e, t, i, n, r) {
              Co(e, t, i, n, r, 1)
          }
          ;
          var Ao = function(e, t) {
              Eo(this, e, 4, t)
          };
          Ao.prototype.resize = function(e) {
              To(this, e, 4)
          }
          ,
          Ao.prototype.clone = function() {
              return new Ao({
                  width: this.width,
                  height: this.height
              },new Uint8Array(this.data))
          }
          ,
          Ao.copy = function(e, t, i, n, r) {
              Co(e, t, i, n, r, 4)
          }
          ,
          an("AlphaImage", Lo),
          an("RGBAImage", Ao);
          var Po = {
              paint: new jn({
                  "heatmap-radius": new zn(ge.paint_heatmap["heatmap-radius"]),
                  "heatmap-weight": new zn(ge.paint_heatmap["heatmap-weight"]),
                  "heatmap-intensity": new On(ge.paint_heatmap["heatmap-intensity"]),
                  "heatmap-color": new Bn(ge.paint_heatmap["heatmap-color"]),
                  "heatmap-opacity": new On(ge.paint_heatmap["heatmap-opacity"])
              })
          };
          function Io(e, t) {
              for (var i = new Uint8Array(1024), n = {}, r = 0, o = 0; r < 256; r++,
              o += 4) {
                  n[t] = r / 255;
                  var s = e.evaluate(n);
                  i[o + 0] = Math.floor(255 * s.r / s.a),
                  i[o + 1] = Math.floor(255 * s.g / s.a),
                  i[o + 2] = Math.floor(255 * s.b / s.a),
                  i[o + 3] = Math.floor(255 * s.a)
              }
              return new Ao({
                  width: 256,
                  height: 1
              },i)
          }
          var Mo = function(e) {
              function t(t) {
                  e.call(this, t, Po),
                  this._updateColorRamp()
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.createBucket = function(e) {
                  return new So(e)
              }
              ,
              t.prototype._handleSpecialPaintPropertyUpdate = function(e) {
                  "heatmap-color" === e && this._updateColorRamp()
              }
              ,
              t.prototype._updateColorRamp = function() {
                  var e = this._transitionablePaint._values["heatmap-color"].value.expression;
                  this.colorRamp = Io(e, "heatmapDensity"),
                  this.colorRampTexture = null
              }
              ,
              t.prototype.resize = function() {
                  this.heatmapFbo && (this.heatmapFbo.destroy(),
                  this.heatmapFbo = null)
              }
              ,
              t.prototype.queryRadius = function() {
                  return 0
              }
              ,
              t.prototype.queryIntersectsFeature = function() {
                  return !1
              }
              ,
              t.prototype.hasOffscreenPass = function() {
                  return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility
              }
              ,
              t
          }(Fn)
            , Oo = {
              paint: new jn({
                  "hillshade-illumination-direction": new On(ge.paint_hillshade["hillshade-illumination-direction"]),
                  "hillshade-illumination-anchor": new On(ge.paint_hillshade["hillshade-illumination-anchor"]),
                  "hillshade-exaggeration": new On(ge.paint_hillshade["hillshade-exaggeration"]),
                  "hillshade-shadow-color": new On(ge.paint_hillshade["hillshade-shadow-color"]),
                  "hillshade-highlight-color": new On(ge.paint_hillshade["hillshade-highlight-color"]),
                  "hillshade-accent-color": new On(ge.paint_hillshade["hillshade-accent-color"])
              })
          }
            , zo = function(e) {
              function t(t) {
                  e.call(this, t, Oo)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.hasOffscreenPass = function() {
                  return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility
              }
              ,
              t
          }(Fn)
            , Do = Hn([{
              name: "a_pos",
              components: 2,
              type: "Int16"
          }], 4)
            , Ro = Do.members
            , Bo = (Do.size,
          Do.alignment,
          Fo)
            , jo = Fo;
          function Fo(e, t, i) {
              i = i || 2;
              var n, r, o, s, a, l, c, u = t && t.length, h = u ? t[0] * i : e.length, d = No(e, 0, h, i, !0), p = [];
              if (!d || d.next === d.prev)
                  return p;
              if (u && (d = function(e, t, i, n) {
                  var r, o, s, a = [];
                  for (r = 0,
                  o = t.length; r < o; r++)
                      (s = No(e, t[r] * n, r < o - 1 ? t[r + 1] * n : e.length, n, !1)) === s.next && (s.steiner = !0),
                      a.push(Yo(s));
                  for (a.sort(Go),
                  r = 0; r < a.length; r++)
                      Xo(a[r], i),
                      i = Uo(i, i.next);
                  return i
              }(e, t, d, i)),
              e.length > 80 * i) {
                  n = o = e[0],
                  r = s = e[1];
                  for (var f = i; f < h; f += i)
                      (a = e[f]) < n && (n = a),
                      (l = e[f + 1]) < r && (r = l),
                      a > o && (o = a),
                      l > s && (s = l);
                  c = 0 !== (c = Math.max(o - n, s - r)) ? 1 / c : 0
              }
              return qo(d, p, i, n, r, c),
              p
          }
          function No(e, t, i, n, r) {
              var o, s;
              if (r === as(e, t, i, n) > 0)
                  for (o = t; o < i; o += n)
                      s = rs(o, e[o], e[o + 1], s);
              else
                  for (o = i - n; o >= t; o -= n)
                      s = rs(o, e[o], e[o + 1], s);
              return s && es(s, s.next) && (os(s),
              s = s.next),
              s
          }
          function Uo(e, t) {
              if (!e)
                  return e;
              t || (t = e);
              var i, n = e;
              do {
                  if (i = !1,
                  n.steiner || !es(n, n.next) && 0 !== Qo(n.prev, n, n.next))
                      n = n.next;
                  else {
                      if (os(n),
                      (n = t = n.prev) === n.next)
                          break;
                      i = !0
                  }
              } while (i || n !== t);return t
          }
          function qo(e, t, i, n, r, o, s) {
              if (e) {
                  !s && o && function(e, t, i, n) {
                      var r = e;
                      do {
                          null === r.z && (r.z = Zo(r.x, r.y, t, i, n)),
                          r.prevZ = r.prev,
                          r.nextZ = r.next,
                          r = r.next
                      } while (r !== e);r.prevZ.nextZ = null,
                      r.prevZ = null,
                      function(e) {
                          var t, i, n, r, o, s, a, l, c = 1;
                          do {
                              for (i = e,
                              e = null,
                              o = null,
                              s = 0; i; ) {
                                  for (s++,
                                  n = i,
                                  a = 0,
                                  t = 0; t < c && (a++,
                                  n = n.nextZ); t++)
                                      ;
                                  for (l = c; a > 0 || l > 0 && n; )
                                      0 !== a && (0 === l || !n || i.z <= n.z) ? (r = i,
                                      i = i.nextZ,
                                      a--) : (r = n,
                                      n = n.nextZ,
                                      l--),
                                      o ? o.nextZ = r : e = r,
                                      r.prevZ = o,
                                      o = r;
                                  i = n
                              }
                              o.nextZ = null,
                              c *= 2
                          } while (s > 1)
                      }(r)
                  }(e, n, r, o);
                  for (var a, l, c = e; e.prev !== e.next; )
                      if (a = e.prev,
                      l = e.next,
                      o ? Vo(e, n, r, o) : Ho(e))
                          t.push(a.i / i),
                          t.push(e.i / i),
                          t.push(l.i / i),
                          os(e),
                          e = l.next,
                          c = l.next;
                      else if ((e = l) === c) {
                          s ? 1 === s ? qo(e = Wo(e, t, i), t, i, n, r, o, 2) : 2 === s && $o(e, t, i, n, r, o) : qo(Uo(e), t, i, n, r, o, 1);
                          break
                      }
              }
          }
          function Ho(e) {
              var t = e.prev
                , i = e
                , n = e.next;
              if (Qo(t, i, n) >= 0)
                  return !1;
              for (var r = e.next.next; r !== e.prev; ) {
                  if (Ko(t.x, t.y, i.x, i.y, n.x, n.y, r.x, r.y) && Qo(r.prev, r, r.next) >= 0)
                      return !1;
                  r = r.next
              }
              return !0
          }
          function Vo(e, t, i, n) {
              var r = e.prev
                , o = e
                , s = e.next;
              if (Qo(r, o, s) >= 0)
                  return !1;
              for (var a = r.x < o.x ? r.x < s.x ? r.x : s.x : o.x < s.x ? o.x : s.x, l = r.y < o.y ? r.y < s.y ? r.y : s.y : o.y < s.y ? o.y : s.y, c = r.x > o.x ? r.x > s.x ? r.x : s.x : o.x > s.x ? o.x : s.x, u = r.y > o.y ? r.y > s.y ? r.y : s.y : o.y > s.y ? o.y : s.y, h = Zo(a, l, t, i, n), d = Zo(c, u, t, i, n), p = e.prevZ, f = e.nextZ; p && p.z >= h && f && f.z <= d; ) {
                  if (p !== e.prev && p !== e.next && Ko(r.x, r.y, o.x, o.y, s.x, s.y, p.x, p.y) && Qo(p.prev, p, p.next) >= 0)
                      return !1;
                  if (p = p.prevZ,
                  f !== e.prev && f !== e.next && Ko(r.x, r.y, o.x, o.y, s.x, s.y, f.x, f.y) && Qo(f.prev, f, f.next) >= 0)
                      return !1;
                  f = f.nextZ
              }
              for (; p && p.z >= h; ) {
                  if (p !== e.prev && p !== e.next && Ko(r.x, r.y, o.x, o.y, s.x, s.y, p.x, p.y) && Qo(p.prev, p, p.next) >= 0)
                      return !1;
                  p = p.prevZ
              }
              for (; f && f.z <= d; ) {
                  if (f !== e.prev && f !== e.next && Ko(r.x, r.y, o.x, o.y, s.x, s.y, f.x, f.y) && Qo(f.prev, f, f.next) >= 0)
                      return !1;
                  f = f.nextZ
              }
              return !0
          }
          function Wo(e, t, i) {
              var n = e;
              do {
                  var r = n.prev
                    , o = n.next.next;
                  !es(r, o) && ts(r, n, n.next, o) && is(r, o) && is(o, r) && (t.push(r.i / i),
                  t.push(n.i / i),
                  t.push(o.i / i),
                  os(n),
                  os(n.next),
                  n = e = o),
                  n = n.next
              } while (n !== e);return n
          }
          function $o(e, t, i, n, r, o) {
              var s = e;
              do {
                  for (var a = s.next.next; a !== s.prev; ) {
                      if (s.i !== a.i && Jo(s, a)) {
                          var l = ns(s, a);
                          return s = Uo(s, s.next),
                          l = Uo(l, l.next),
                          qo(s, t, i, n, r, o),
                          void qo(l, t, i, n, r, o)
                      }
                      a = a.next
                  }
                  s = s.next
              } while (s !== e)
          }
          function Go(e, t) {
              return e.x - t.x
          }
          function Xo(e, t) {
              if (t = function(e, t) {
                  var i, n = t, r = e.x, o = e.y, s = -1 / 0;
                  do {
                      if (o <= n.y && o >= n.next.y && n.next.y !== n.y) {
                          var a = n.x + (o - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                          if (a <= r && a > s) {
                              if (s = a,
                              a === r) {
                                  if (o === n.y)
                                      return n;
                                  if (o === n.next.y)
                                      return n.next
                              }
                              i = n.x < n.next.x ? n : n.next
                          }
                      }
                      n = n.next
                  } while (n !== t);if (!i)
                      return null;
                  if (r === s)
                      return i.prev;
                  var l, c = i, u = i.x, h = i.y, d = 1 / 0;
                  for (n = i.next; n !== c; )
                      r >= n.x && n.x >= u && r !== n.x && Ko(o < h ? r : s, o, u, h, o < h ? s : r, o, n.x, n.y) && ((l = Math.abs(o - n.y) / (r - n.x)) < d || l === d && n.x > i.x) && is(n, e) && (i = n,
                      d = l),
                      n = n.next;
                  return i
              }(e, t)) {
                  var i = ns(t, e);
                  Uo(i, i.next)
              }
          }
          function Zo(e, t, i, n, r) {
              return (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = 32767 * (e - i) * r) | e << 8)) | e << 4)) | e << 2)) | e << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = 32767 * (t - n) * r) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1
          }
          function Yo(e) {
              var t = e
                , i = e;
              do {
                  (t.x < i.x || t.x === i.x && t.y < i.y) && (i = t),
                  t = t.next
              } while (t !== e);return i
          }
          function Ko(e, t, i, n, r, o, s, a) {
              return (r - s) * (t - a) - (e - s) * (o - a) >= 0 && (e - s) * (n - a) - (i - s) * (t - a) >= 0 && (i - s) * (o - a) - (r - s) * (n - a) >= 0
          }
          function Jo(e, t) {
              return e.next.i !== t.i && e.prev.i !== t.i && !function(e, t) {
                  var i = e;
                  do {
                      if (i.i !== e.i && i.next.i !== e.i && i.i !== t.i && i.next.i !== t.i && ts(i, i.next, e, t))
                          return !0;
                      i = i.next
                  } while (i !== e);return !1
              }(e, t) && is(e, t) && is(t, e) && function(e, t) {
                  var i = e
                    , n = !1
                    , r = (e.x + t.x) / 2
                    , o = (e.y + t.y) / 2;
                  do {
                      i.y > o != i.next.y > o && i.next.y !== i.y && r < (i.next.x - i.x) * (o - i.y) / (i.next.y - i.y) + i.x && (n = !n),
                      i = i.next
                  } while (i !== e);return n
              }(e, t)
          }
          function Qo(e, t, i) {
              return (t.y - e.y) * (i.x - t.x) - (t.x - e.x) * (i.y - t.y)
          }
          function es(e, t) {
              return e.x === t.x && e.y === t.y
          }
          function ts(e, t, i, n) {
              return !!(es(e, t) && es(i, n) || es(e, n) && es(i, t)) || Qo(e, t, i) > 0 != Qo(e, t, n) > 0 && Qo(i, n, e) > 0 != Qo(i, n, t) > 0
          }
          function is(e, t) {
              return Qo(e.prev, e, e.next) < 0 ? Qo(e, t, e.next) >= 0 && Qo(e, e.prev, t) >= 0 : Qo(e, t, e.prev) < 0 || Qo(e, e.next, t) < 0
          }
          function ns(e, t) {
              var i = new ss(e.i,e.x,e.y)
                , n = new ss(t.i,t.x,t.y)
                , r = e.next
                , o = t.prev;
              return e.next = t,
              t.prev = e,
              i.next = r,
              r.prev = i,
              n.next = i,
              i.prev = n,
              o.next = n,
              n.prev = o,
              n
          }
          function rs(e, t, i, n) {
              var r = new ss(e,t,i);
              return n ? (r.next = n.next,
              r.prev = n,
              n.next.prev = r,
              n.next = r) : (r.prev = r,
              r.next = r),
              r
          }
          function os(e) {
              e.next.prev = e.prev,
              e.prev.next = e.next,
              e.prevZ && (e.prevZ.nextZ = e.nextZ),
              e.nextZ && (e.nextZ.prevZ = e.prevZ)
          }
          function ss(e, t, i) {
              this.i = e,
              this.x = t,
              this.y = i,
              this.prev = null,
              this.next = null,
              this.z = null,
              this.prevZ = null,
              this.nextZ = null,
              this.steiner = !1
          }
          function as(e, t, i, n) {
              for (var r = 0, o = t, s = i - n; o < i; o += n)
                  r += (e[s] - e[o]) * (e[o + 1] + e[s + 1]),
                  s = o;
              return r
          }
          function ls(e, t, i, n, r) {
              !function e(t, i, n, r, o) {
                  for (; r > n; ) {
                      if (r - n > 600) {
                          var s = r - n + 1
                            , a = i - n + 1
                            , l = Math.log(s)
                            , c = .5 * Math.exp(2 * l / 3)
                            , u = .5 * Math.sqrt(l * c * (s - c) / s) * (a - s / 2 < 0 ? -1 : 1);
                          e(t, i, Math.max(n, Math.floor(i - a * c / s + u)), Math.min(r, Math.floor(i + (s - a) * c / s + u)), o)
                      }
                      var h = t[i]
                        , d = n
                        , p = r;
                      for (cs(t, n, i),
                      o(t[r], h) > 0 && cs(t, n, r); d < p; ) {
                          for (cs(t, d, p),
                          d++,
                          p--; o(t[d], h) < 0; )
                              d++;
                          for (; o(t[p], h) > 0; )
                              p--
                      }
                      0 === o(t[n], h) ? cs(t, n, p) : cs(t, ++p, r),
                      p <= i && (n = p + 1),
                      i <= p && (r = p - 1)
                  }
              }(e, t, i || 0, n || e.length - 1, r || us)
          }
          function cs(e, t, i) {
              var n = e[t];
              e[t] = e[i],
              e[i] = n
          }
          function us(e, t) {
              return e < t ? -1 : e > t ? 1 : 0
          }
          function hs(e, t) {
              var i = e.length;
              if (i <= 1)
                  return [e];
              for (var n, r, o = [], s = 0; s < i; s++) {
                  var a = S(e[s]);
                  0 !== a && (e[s].area = Math.abs(a),
                  void 0 === r && (r = a < 0),
                  r === a < 0 ? (n && o.push(n),
                  n = [e[s]]) : n.push(e[s]))
              }
              if (n && o.push(n),
              t > 1)
                  for (var l = 0; l < o.length; l++)
                      o[l].length <= t || (ls(o[l], t, 1, o[l].length - 1, ds),
                      o[l] = o[l].slice(0, t));
              return o
          }
          function ds(e, t) {
              return t.area - e.area
          }
          function ps(e, t, i) {
              for (var n = i.patternDependencies, r = !1, o = 0, s = t; o < s.length; o += 1) {
                  var a = s[o].paint.get(e + "-pattern");
                  a.isConstant() || (r = !0);
                  var l = a.constantOr(null);
                  l && (r = !0,
                  n[l.to] = !0,
                  n[l.from] = !0)
              }
              return r
          }
          function fs(e, t, i, n, r) {
              for (var o = r.patternDependencies, s = 0, a = t; s < a.length; s += 1) {
                  var l = a[s]
                    , c = l.paint.get(e + "-pattern").value;
                  if ("constant" !== c.kind) {
                      var u = c.evaluate({
                          zoom: n - 1
                      }, i, {})
                        , h = c.evaluate({
                          zoom: n
                      }, i, {})
                        , d = c.evaluate({
                          zoom: n + 1
                      }, i, {});
                      o[u] = !0,
                      o[h] = !0,
                      o[d] = !0,
                      i.patterns[l.id] = {
                          min: u,
                          mid: h,
                          max: d
                      }
                  }
              }
              return i
          }
          Fo.deviation = function(e, t, i, n) {
              var r = t && t.length
                , o = r ? t[0] * i : e.length
                , s = Math.abs(as(e, 0, o, i));
              if (r)
                  for (var a = 0, l = t.length; a < l; a++) {
                      var c = t[a] * i
                        , u = a < l - 1 ? t[a + 1] * i : e.length;
                      s -= Math.abs(as(e, c, u, i))
                  }
              var h = 0;
              for (a = 0; a < n.length; a += 3) {
                  var d = n[a] * i
                    , p = n[a + 1] * i
                    , f = n[a + 2] * i;
                  h += Math.abs((e[d] - e[f]) * (e[p + 1] - e[d + 1]) - (e[d] - e[p]) * (e[f + 1] - e[d + 1]))
              }
              return 0 === s && 0 === h ? 0 : Math.abs((h - s) / s)
          }
          ,
          Fo.flatten = function(e) {
              for (var t = e[0][0].length, i = {
                  vertices: [],
                  holes: [],
                  dimensions: t
              }, n = 0, r = 0; r < e.length; r++) {
                  for (var o = 0; o < e[r].length; o++)
                      for (var s = 0; s < t; s++)
                          i.vertices.push(e[r][o][s]);
                  r > 0 && (n += e[r - 1].length,
                  i.holes.push(n))
              }
              return i
          }
          ,
          Bo.default = jo;
          var ms = function(e) {
              this.zoom = e.zoom,
              this.overscaling = e.overscaling,
              this.layers = e.layers,
              this.layerIds = this.layers.map(function(e) {
                  return e.id
              }),
              this.index = e.index,
              this.hasPattern = !1,
              this.layoutVertexArray = new Wn,
              this.indexArray = new ar,
              this.indexArray2 = new lr,
              this.programConfigurations = new $r(Ro,e.layers,e.zoom),
              this.segments = new Tr,
              this.segments2 = new Tr,
              this.stateDependentLayerIds = this.layers.filter(function(e) {
                  return e.isStateDependent()
              }).map(function(e) {
                  return e.id
              })
          };
          ms.prototype.populate = function(e, t) {
              this.features = [],
              this.hasPattern = ps("fill", this.layers, t);
              for (var i = 0, n = e; i < n.length; i += 1) {
                  var r = n[i]
                    , o = r.feature
                    , s = r.index
                    , a = r.sourceLayerIndex;
                  if (this.layers[0]._featureFilter(new Sn(this.zoom), o)) {
                      var l = Kr(o)
                        , c = {
                          sourceLayerIndex: a,
                          index: s,
                          geometry: l,
                          properties: o.properties,
                          type: o.type,
                          patterns: {}
                      };
                      void 0 !== o.id && (c.id = o.id),
                      this.hasPattern ? this.features.push(fs("fill", this.layers, c, this.zoom, t)) : this.addFeature(c, l, s, {}),
                      t.featureIndex.insert(o, l, s, a, this.index)
                  }
              }
          }
          ,
          ms.prototype.update = function(e, t, i) {
              this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e, t, this.stateDependentLayers, i)
          }
          ,
          ms.prototype.addFeatures = function(e, t) {
              for (var i = 0, n = this.features; i < n.length; i += 1) {
                  var r = n[i]
                    , o = r.geometry;
                  this.addFeature(r, o, r.index, t)
              }
          }
          ,
          ms.prototype.isEmpty = function() {
              return 0 === this.layoutVertexArray.length
          }
          ,
          ms.prototype.uploadPending = function() {
              return !this.uploaded || this.programConfigurations.needsUpload
          }
          ,
          ms.prototype.upload = function(e) {
              this.uploaded || (this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, Ro),
              this.indexBuffer = e.createIndexBuffer(this.indexArray),
              this.indexBuffer2 = e.createIndexBuffer(this.indexArray2)),
              this.programConfigurations.upload(e),
              this.uploaded = !0
          }
          ,
          ms.prototype.destroy = function() {
              this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(),
              this.indexBuffer.destroy(),
              this.indexBuffer2.destroy(),
              this.programConfigurations.destroy(),
              this.segments.destroy(),
              this.segments2.destroy())
          }
          ,
          ms.prototype.addFeature = function(e, t, i, n) {
              for (var r = 0, o = hs(t, 500); r < o.length; r += 1) {
                  for (var s = o[r], a = 0, l = 0, c = s; l < c.length; l += 1)
                      a += c[l].length;
                  for (var u = this.segments.prepareSegment(a, this.layoutVertexArray, this.indexArray), h = u.vertexLength, d = [], p = [], f = 0, m = s; f < m.length; f += 1) {
                      var g = m[f];
                      if (0 !== g.length) {
                          g !== s[0] && p.push(d.length / 2);
                          var v = this.segments2.prepareSegment(g.length, this.layoutVertexArray, this.indexArray2)
                            , y = v.vertexLength;
                          this.layoutVertexArray.emplaceBack(g[0].x, g[0].y),
                          this.indexArray2.emplaceBack(y + g.length - 1, y),
                          d.push(g[0].x),
                          d.push(g[0].y);
                          for (var _ = 1; _ < g.length; _++)
                              this.layoutVertexArray.emplaceBack(g[_].x, g[_].y),
                              this.indexArray2.emplaceBack(y + _ - 1, y + _),
                              d.push(g[_].x),
                              d.push(g[_].y);
                          v.vertexLength += g.length,
                          v.primitiveLength += g.length
                      }
                  }
                  for (var b = Bo(d, p), w = 0; w < b.length; w += 3)
                      this.indexArray.emplaceBack(h + b[w], h + b[w + 1], h + b[w + 2]);
                  u.vertexLength += a,
                  u.primitiveLength += b.length / 3
              }
              this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e, i, n)
          }
          ,
          an("FillBucket", ms, {
              omit: ["layers", "features"]
          });
          var gs = {
              paint: new jn({
                  "fill-antialias": new On(ge.paint_fill["fill-antialias"]),
                  "fill-opacity": new zn(ge.paint_fill["fill-opacity"]),
                  "fill-color": new zn(ge.paint_fill["fill-color"]),
                  "fill-outline-color": new zn(ge.paint_fill["fill-outline-color"]),
                  "fill-translate": new On(ge.paint_fill["fill-translate"]),
                  "fill-translate-anchor": new On(ge.paint_fill["fill-translate-anchor"]),
                  "fill-pattern": new Dn(ge.paint_fill["fill-pattern"])
              })
          }
            , vs = function(e) {
              function t(t) {
                  e.call(this, t, gs)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.recalculate = function(t) {
                  e.prototype.recalculate.call(this, t);
                  var i = this.paint._values["fill-outline-color"];
                  "constant" === i.value.kind && void 0 === i.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"])
              }
              ,
              t.prototype.createBucket = function(e) {
                  return new ms(e)
              }
              ,
              t.prototype.queryRadius = function() {
                  return po(this.paint.get("fill-translate"))
              }
              ,
              t.prototype.queryIntersectsFeature = function(e, t, i, n, r, o, s) {
                  return io(fo(e, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), o.angle, s), n)
              }
              ,
              t
          }(Fn)
            , ys = Hn([{
              name: "a_pos",
              components: 2,
              type: "Int16"
          }, {
              name: "a_normal_ed",
              components: 4,
              type: "Int16"
          }], 4)
            , _s = ys.members
            , bs = (ys.size,
          ys.alignment,
          Math.pow(2, 13));
          function ws(e, t, i, n, r, o, s, a) {
              e.emplaceBack(t, i, 2 * Math.floor(n * bs) + s, r * bs * 2, o * bs * 2, Math.round(a))
          }
          var xs = function(e) {
              this.zoom = e.zoom,
              this.overscaling = e.overscaling,
              this.layers = e.layers,
              this.layerIds = this.layers.map(function(e) {
                  return e.id
              }),
              this.index = e.index,
              this.hasPattern = !1,
              this.layoutVertexArray = new Gn,
              this.indexArray = new ar,
              this.programConfigurations = new $r(_s,e.layers,e.zoom),
              this.segments = new Tr,
              this.stateDependentLayerIds = this.layers.filter(function(e) {
                  return e.isStateDependent()
              }).map(function(e) {
                  return e.id
              })
          };
          function ks(e, t) {
              return e.x === t.x && (e.x < 0 || e.x > Zr) || e.y === t.y && (e.y < 0 || e.y > Zr)
          }
          function Ss(e) {
              return e.every(function(e) {
                  return e.x < 0
              }) || e.every(function(e) {
                  return e.x > Zr
              }) || e.every(function(e) {
                  return e.y < 0
              }) || e.every(function(e) {
                  return e.y > Zr
              })
          }
          xs.prototype.populate = function(e, t) {
              this.features = [],
              this.hasPattern = ps("fill-extrusion", this.layers, t);
              for (var i = 0, n = e; i < n.length; i += 1) {
                  var r = n[i]
                    , o = r.feature
                    , s = r.index
                    , a = r.sourceLayerIndex;
                  if (this.layers[0]._featureFilter(new Sn(this.zoom), o)) {
                      var l = Kr(o)
                        , c = {
                          sourceLayerIndex: a,
                          index: s,
                          geometry: l,
                          properties: o.properties,
                          type: o.type,
                          patterns: {}
                      };
                      void 0 !== o.id && (c.id = o.id),
                      this.hasPattern ? this.features.push(fs("fill-extrusion", this.layers, c, this.zoom, t)) : this.addFeature(c, l, s, {}),
                      t.featureIndex.insert(o, l, s, a, this.index, !0)
                  }
              }
          }
          ,
          xs.prototype.addFeatures = function(e, t) {
              for (var i = 0, n = this.features; i < n.length; i += 1) {
                  var r = n[i]
                    , o = r.geometry;
                  this.addFeature(r, o, r.index, t)
              }
          }
          ,
          xs.prototype.update = function(e, t, i) {
              this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e, t, this.stateDependentLayers, i)
          }
          ,
          xs.prototype.isEmpty = function() {
              return 0 === this.layoutVertexArray.length
          }
          ,
          xs.prototype.uploadPending = function() {
              return !this.uploaded || this.programConfigurations.needsUpload
          }
          ,
          xs.prototype.upload = function(e) {
              this.uploaded || (this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, _s),
              this.indexBuffer = e.createIndexBuffer(this.indexArray)),
              this.programConfigurations.upload(e),
              this.uploaded = !0
          }
          ,
          xs.prototype.destroy = function() {
              this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(),
              this.indexBuffer.destroy(),
              this.programConfigurations.destroy(),
              this.segments.destroy())
          }
          ,
          xs.prototype.addFeature = function(e, t, i, n) {
              for (var r = 0, o = hs(t, 500); r < o.length; r += 1) {
                  for (var s = o[r], a = 0, l = 0, c = s; l < c.length; l += 1)
                      a += c[l].length;
                  for (var u = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray), h = 0, d = s; h < d.length; h += 1) {
                      var p = d[h];
                      if (0 !== p.length && !Ss(p))
                          for (var f = 0, m = 0; m < p.length; m++) {
                              var g = p[m];
                              if (m >= 1) {
                                  var v = p[m - 1];
                                  if (!ks(g, v)) {
                                      u.vertexLength + 4 > Tr.MAX_VERTEX_ARRAY_LENGTH && (u = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                      var y = g.sub(v)._perp()._unit()
                                        , _ = v.dist(g);
                                      f + _ > 32768 && (f = 0),
                                      ws(this.layoutVertexArray, g.x, g.y, y.x, y.y, 0, 0, f),
                                      ws(this.layoutVertexArray, g.x, g.y, y.x, y.y, 0, 1, f),
                                      f += _,
                                      ws(this.layoutVertexArray, v.x, v.y, y.x, y.y, 0, 0, f),
                                      ws(this.layoutVertexArray, v.x, v.y, y.x, y.y, 0, 1, f);
                                      var b = u.vertexLength;
                                      this.indexArray.emplaceBack(b, b + 2, b + 1),
                                      this.indexArray.emplaceBack(b + 1, b + 2, b + 3),
                                      u.vertexLength += 4,
                                      u.primitiveLength += 2
                                  }
                              }
                          }
                  }
                  u.vertexLength + a > Tr.MAX_VERTEX_ARRAY_LENGTH && (u = this.segments.prepareSegment(a, this.layoutVertexArray, this.indexArray));
                  for (var w = [], x = [], k = u.vertexLength, S = 0, E = s; S < E.length; S += 1) {
                      var T = E[S];
                      if (0 !== T.length) {
                          T !== s[0] && x.push(w.length / 2);
                          for (var C = 0; C < T.length; C++) {
                              var L = T[C];
                              ws(this.layoutVertexArray, L.x, L.y, 0, 0, 1, 1, 0),
                              w.push(L.x),
                              w.push(L.y)
                          }
                      }
                  }
                  for (var A = Bo(w, x), P = 0; P < A.length; P += 3)
                      this.indexArray.emplaceBack(k + A[P], k + A[P + 2], k + A[P + 1]);
                  u.primitiveLength += A.length / 3,
                  u.vertexLength += a
              }
              this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e, i, n)
          }
          ,
          an("FillExtrusionBucket", xs, {
              omit: ["layers", "features"]
          });
          var Es = {
              paint: new jn({
                  "fill-extrusion-opacity": new On(ge["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                  "fill-extrusion-color": new zn(ge["paint_fill-extrusion"]["fill-extrusion-color"]),
                  "fill-extrusion-translate": new On(ge["paint_fill-extrusion"]["fill-extrusion-translate"]),
                  "fill-extrusion-translate-anchor": new On(ge["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                  "fill-extrusion-pattern": new Dn(ge["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                  "fill-extrusion-height": new zn(ge["paint_fill-extrusion"]["fill-extrusion-height"]),
                  "fill-extrusion-base": new zn(ge["paint_fill-extrusion"]["fill-extrusion-base"]),
                  "fill-extrusion-vertical-gradient": new On(ge["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
              })
          }
            , Ts = function(e) {
              function t(t) {
                  e.call(this, t, Es)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.createBucket = function(e) {
                  return new xs(e)
              }
              ,
              t.prototype.queryRadius = function() {
                  return po(this.paint.get("fill-extrusion-translate"))
              }
              ,
              t.prototype.queryIntersectsFeature = function(e, t, i, n, o, s, a, l) {
                  var c = fo(e, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), s.angle, a)
                    , u = this.paint.get("fill-extrusion-height").evaluate(t, i)
                    , h = this.paint.get("fill-extrusion-base").evaluate(t, i)
                    , d = function(e, t, i, n) {
                      for (var o = [], s = 0, a = e; s < a.length; s += 1) {
                          var l = a[s]
                            , c = [l.x, l.y, 0, 1];
                          bo(c, c, t),
                          o.push(new r(c[0] / c[3],c[1] / c[3]))
                      }
                      return o
                  }(c, l)
                    , p = function(e, t, i, n) {
                      for (var o = [], s = [], a = n[8] * t, l = n[9] * t, c = n[10] * t, u = n[11] * t, h = n[8] * i, d = n[9] * i, p = n[10] * i, f = n[11] * i, m = 0, g = e; m < g.length; m += 1) {
                          for (var v = [], y = [], _ = 0, b = g[m]; _ < b.length; _ += 1) {
                              var w = b[_]
                                , x = w.x
                                , k = w.y
                                , S = n[0] * x + n[4] * k + n[12]
                                , E = n[1] * x + n[5] * k + n[13]
                                , T = n[2] * x + n[6] * k + n[14]
                                , C = n[3] * x + n[7] * k + n[15]
                                , L = T + c
                                , A = C + u
                                , P = S + h
                                , I = E + d
                                , M = T + p
                                , O = C + f
                                , z = new r((S + a) / A,(E + l) / A);
                              z.z = L / A,
                              v.push(z);
                              var D = new r(P / O,I / O);
                              D.z = M / O,
                              y.push(D)
                          }
                          o.push(v),
                          s.push(y)
                      }
                      return [o, s]
                  }(n, h, u, l);
                  return function(e, t, i) {
                      var n = 1 / 0;
                      io(i, t) && (n = Ls(i, t[0]));
                      for (var r = 0; r < t.length; r++)
                          for (var o = t[r], s = e[r], a = 0; a < o.length - 1; a++) {
                              var l = o[a]
                                , c = o[a + 1]
                                , u = s[a]
                                , h = [l, c, s[a + 1], u, l];
                              eo(i, h) && (n = Math.min(n, Ls(i, h)))
                          }
                      return n !== 1 / 0 && n
                  }(p[0], p[1], d)
              }
              ,
              t.prototype.hasOffscreenPass = function() {
                  return 0 !== this.paint.get("fill-extrusion-opacity") && "none" !== this.visibility
              }
              ,
              t.prototype.resize = function() {
                  this.viewportFrame && (this.viewportFrame.destroy(),
                  this.viewportFrame = null)
              }
              ,
              t
          }(Fn);
          function Cs(e, t) {
              return e.x * t.x + e.y * t.y
          }
          function Ls(e, t) {
              if (1 === e.length) {
                  var i = t[0]
                    , n = t[1]
                    , r = t[3]
                    , o = e[0]
                    , s = n.sub(i)
                    , a = r.sub(i)
                    , l = o.sub(i)
                    , c = Cs(s, s)
                    , u = Cs(s, a)
                    , h = Cs(a, a)
                    , d = Cs(l, s)
                    , p = Cs(l, a)
                    , f = c * h - u * u
                    , m = (h * d - u * p) / f
                    , g = (c * p - u * d) / f
                    , v = 1 - m - g;
                  return i.z * v + n.z * m + r.z * g
              }
              for (var y = 1 / 0, _ = 0, b = t; _ < b.length; _ += 1) {
                  var w = b[_];
                  y = Math.min(y, w.z)
              }
              return y
          }
          var As = Hn([{
              name: "a_pos_normal",
              components: 4,
              type: "Int16"
          }, {
              name: "a_data",
              components: 4,
              type: "Uint8"
          }], 4)
            , Ps = As.members
            , Is = (As.size,
          As.alignment,
          Ms);
          function Ms(e, t, i, n, r) {
              this.properties = {},
              this.extent = i,
              this.type = 0,
              this._pbf = e,
              this._geometry = -1,
              this._keys = n,
              this._values = r,
              e.readFields(Os, this, t)
          }
          function Os(e, t, i) {
              1 == e ? t.id = i.readVarint() : 2 == e ? function(e, t) {
                  for (var i = e.readVarint() + e.pos; e.pos < i; ) {
                      var n = t._keys[e.readVarint()]
                        , r = t._values[e.readVarint()];
                      t.properties[n] = r
                  }
              }(i, t) : 3 == e ? t.type = i.readVarint() : 4 == e && (t._geometry = i.pos)
          }
          function zs(e) {
              for (var t, i, n = 0, r = 0, o = e.length, s = o - 1; r < o; s = r++)
                  t = e[r],
                  n += ((i = e[s]).x - t.x) * (t.y + i.y);
              return n
          }
          Ms.types = ["Unknown", "Point", "LineString", "Polygon"],
          Ms.prototype.loadGeometry = function() {
              var e = this._pbf;
              e.pos = this._geometry;
              for (var t, i = e.readVarint() + e.pos, n = 1, o = 0, s = 0, a = 0, l = []; e.pos < i; ) {
                  if (o <= 0) {
                      var c = e.readVarint();
                      n = 7 & c,
                      o = c >> 3
                  }
                  if (o--,
                  1 === n || 2 === n)
                      s += e.readSVarint(),
                      a += e.readSVarint(),
                      1 === n && (t && l.push(t),
                      t = []),
                      t.push(new r(s,a));
                  else {
                      if (7 !== n)
                          throw new Error("unknown command " + n);
                      t && t.push(t[0].clone())
                  }
              }
              return t && l.push(t),
              l
          }
          ,
          Ms.prototype.bbox = function() {
              var e = this._pbf;
              e.pos = this._geometry;
              for (var t = e.readVarint() + e.pos, i = 1, n = 0, r = 0, o = 0, s = 1 / 0, a = -1 / 0, l = 1 / 0, c = -1 / 0; e.pos < t; ) {
                  if (n <= 0) {
                      var u = e.readVarint();
                      i = 7 & u,
                      n = u >> 3
                  }
                  if (n--,
                  1 === i || 2 === i)
                      (r += e.readSVarint()) < s && (s = r),
                      r > a && (a = r),
                      (o += e.readSVarint()) < l && (l = o),
                      o > c && (c = o);
                  else if (7 !== i)
                      throw new Error("unknown command " + i)
              }
              return [s, l, a, c]
          }
          ,
          Ms.prototype.toGeoJSON = function(e, t, i) {
              var n, r, o = this.extent * Math.pow(2, i), s = this.extent * e, a = this.extent * t, l = this.loadGeometry(), c = Ms.types[this.type];
              function u(e) {
                  for (var t = 0; t < e.length; t++) {
                      var i = e[t]
                        , n = 180 - 360 * (i.y + a) / o;
                      e[t] = [360 * (i.x + s) / o - 180, 360 / Math.PI * Math.atan(Math.exp(n * Math.PI / 180)) - 90]
                  }
              }
              switch (this.type) {
              case 1:
                  var h = [];
                  for (n = 0; n < l.length; n++)
                      h[n] = l[n][0];
                  u(l = h);
                  break;
              case 2:
                  for (n = 0; n < l.length; n++)
                      u(l[n]);
                  break;
              case 3:
                  for (l = function(e) {
                      var t = e.length;
                      if (t <= 1)
                          return [e];
                      for (var i, n, r = [], o = 0; o < t; o++) {
                          var s = zs(e[o]);
                          0 !== s && (void 0 === n && (n = s < 0),
                          n === s < 0 ? (i && r.push(i),
                          i = [e[o]]) : i.push(e[o]))
                      }
                      return i && r.push(i),
                      r
                  }(l),
                  n = 0; n < l.length; n++)
                      for (r = 0; r < l[n].length; r++)
                          u(l[n][r])
              }
              1 === l.length ? l = l[0] : c = "Multi" + c;
              var d = {
                  type: "Feature",
                  geometry: {
                      type: c,
                      coordinates: l
                  },
                  properties: this.properties
              };
              return "id"in this && (d.id = this.id),
              d
          }
          ;
          var Ds = Rs;
          function Rs(e, t) {
              this.version = 1,
              this.name = null,
              this.extent = 4096,
              this.length = 0,
              this._pbf = e,
              this._keys = [],
              this._values = [],
              this._features = [],
              e.readFields(Bs, this, t),
              this.length = this._features.length
          }
          function Bs(e, t, i) {
              15 === e ? t.version = i.readVarint() : 1 === e ? t.name = i.readString() : 5 === e ? t.extent = i.readVarint() : 2 === e ? t._features.push(i.pos) : 3 === e ? t._keys.push(i.readString()) : 4 === e && t._values.push(function(e) {
                  for (var t = null, i = e.readVarint() + e.pos; e.pos < i; ) {
                      var n = e.readVarint() >> 3;
                      t = 1 === n ? e.readString() : 2 === n ? e.readFloat() : 3 === n ? e.readDouble() : 4 === n ? e.readVarint64() : 5 === n ? e.readVarint() : 6 === n ? e.readSVarint() : 7 === n ? e.readBoolean() : null
                  }
                  return t
              }(i))
          }
          function js(e, t, i) {
              if (3 === e) {
                  var n = new Ds(i,i.readVarint() + i.pos);
                  n.length && (t[n.name] = n)
              }
          }
          Rs.prototype.feature = function(e) {
              if (e < 0 || e >= this._features.length)
                  throw new Error("feature index out of bounds");
              this._pbf.pos = this._features[e];
              var t = this._pbf.readVarint() + this._pbf.pos;
              return new Is(this._pbf,t,this.extent,this._keys,this._values)
          }
          ;
          var Fs = {
              VectorTile: function(e, t) {
                  this.layers = e.readFields(js, {}, t)
              },
              VectorTileFeature: Is,
              VectorTileLayer: Ds
          }
            , Ns = Fs.VectorTileFeature.types
            , Us = 63
            , qs = Math.cos(Math.PI / 180 * 37.5)
            , Hs = .5
            , Vs = Math.pow(2, 14) / Hs;
          function Ws(e, t, i, n, r, o, s) {
              e.emplaceBack(t.x, t.y, n ? 1 : 0, r ? 1 : -1, Math.round(Us * i.x) + 128, Math.round(Us * i.y) + 128, 1 + (0 === o ? 0 : o < 0 ? -1 : 1) | (s * Hs & 63) << 2, s * Hs >> 6)
          }
          var $s = function(e) {
              this.zoom = e.zoom,
              this.overscaling = e.overscaling,
              this.layers = e.layers,
              this.layerIds = this.layers.map(function(e) {
                  return e.id
              }),
              this.index = e.index,
              this.features = [],
              this.hasPattern = !1,
              this.layoutVertexArray = new Xn,
              this.indexArray = new ar,
              this.programConfigurations = new $r(Ps,e.layers,e.zoom),
              this.segments = new Tr,
              this.stateDependentLayerIds = this.layers.filter(function(e) {
                  return e.isStateDependent()
              }).map(function(e) {
                  return e.id
              })
          };
          function Gs(e, t) {
              return (e / t.tileTotal * (t.end - t.start) + t.start) * (Vs - 1)
          }
          $s.prototype.populate = function(e, t) {
              this.features = [],
              this.hasPattern = ps("line", this.layers, t);
              for (var i = 0, n = e; i < n.length; i += 1) {
                  var r = n[i]
                    , o = r.feature
                    , s = r.index
                    , a = r.sourceLayerIndex;
                  if (this.layers[0]._featureFilter(new Sn(this.zoom), o)) {
                      var l = Kr(o)
                        , c = {
                          sourceLayerIndex: a,
                          index: s,
                          geometry: l,
                          properties: o.properties,
                          type: o.type,
                          patterns: {}
                      };
                      void 0 !== o.id && (c.id = o.id),
                      this.hasPattern ? this.features.push(fs("line", this.layers, c, this.zoom, t)) : this.addFeature(c, l, s, {}),
                      t.featureIndex.insert(o, l, s, a, this.index)
                  }
              }
          }
          ,
          $s.prototype.update = function(e, t, i) {
              this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e, t, this.stateDependentLayers, i)
          }
          ,
          $s.prototype.addFeatures = function(e, t) {
              for (var i = 0, n = this.features; i < n.length; i += 1) {
                  var r = n[i]
                    , o = r.geometry;
                  this.addFeature(r, o, r.index, t)
              }
          }
          ,
          $s.prototype.isEmpty = function() {
              return 0 === this.layoutVertexArray.length
          }
          ,
          $s.prototype.uploadPending = function() {
              return !this.uploaded || this.programConfigurations.needsUpload
          }
          ,
          $s.prototype.upload = function(e) {
              this.uploaded || (this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, Ps),
              this.indexBuffer = e.createIndexBuffer(this.indexArray)),
              this.programConfigurations.upload(e),
              this.uploaded = !0
          }
          ,
          $s.prototype.destroy = function() {
              this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(),
              this.indexBuffer.destroy(),
              this.programConfigurations.destroy(),
              this.segments.destroy())
          }
          ,
          $s.prototype.addFeature = function(e, t, i, n) {
              for (var r = this.layers[0].layout, o = r.get("line-join").evaluate(e, {}), s = r.get("line-cap"), a = r.get("line-miter-limit"), l = r.get("line-round-limit"), c = 0, u = t; c < u.length; c += 1) {
                  var h = u[c];
                  this.addLine(h, e, o, s, a, l, i, n)
              }
          }
          ,
          $s.prototype.addLine = function(e, t, i, n, r, o, s, a) {
              var l = null;
              t.properties && t.properties.hasOwnProperty("mapbox_clip_start") && t.properties.hasOwnProperty("mapbox_clip_end") && (l = {
                  start: t.properties.mapbox_clip_start,
                  end: t.properties.mapbox_clip_end,
                  tileTotal: void 0
              });
              for (var c = "Polygon" === Ns[t.type], u = e.length; u >= 2 && e[u - 1].equals(e[u - 2]); )
                  u--;
              for (var h = 0; h < u - 1 && e[h].equals(e[h + 1]); )
                  h++;
              if (!(u < (c ? 3 : 2))) {
                  l && (l.tileTotal = function(e, t, i) {
                      for (var n, r, o = 0, s = h; s < i - 1; s++)
                          n = e[s],
                          r = e[s + 1],
                          o += n.dist(r);
                      return o
                  }(e, 0, u)),
                  "bevel" === i && (r = 1.05);
                  var d = Zr / (512 * this.overscaling) * 15
                    , p = e[h]
                    , f = this.segments.prepareSegment(10 * u, this.layoutVertexArray, this.indexArray);
                  this.distance = 0;
                  var m, g, v, y = n, _ = c ? "butt" : n, b = !0, w = void 0, x = void 0, k = void 0, S = void 0;
                  this.e1 = this.e2 = this.e3 = -1,
                  c && (m = e[u - 2],
                  S = p.sub(m)._unit()._perp());
                  for (var E = h; E < u; E++)
                      if (!(x = c && E === u - 1 ? e[h + 1] : e[E + 1]) || !e[E].equals(x)) {
                          S && (k = S),
                          m && (w = m),
                          m = e[E],
                          S = x ? x.sub(m)._unit()._perp() : k;
                          var T = (k = k || S).add(S);
                          0 === T.x && 0 === T.y || T._unit();
                          var C = T.x * S.x + T.y * S.y
                            , L = 0 !== C ? 1 / C : 1 / 0
                            , A = C < qs && w && x;
                          if (A && E > h) {
                              var P = m.dist(w);
                              if (P > 2 * d) {
                                  var I = m.sub(m.sub(w)._mult(d / P)._round());
                                  this.distance += I.dist(w),
                                  this.addCurrentVertex(I, this.distance, k.mult(1), 0, 0, !1, f, l),
                                  w = I
                              }
                          }
                          var M = w && x
                            , O = M ? i : x ? y : _;
                          if (M && "round" === O && (L < o ? O = "miter" : L <= 2 && (O = "fakeround")),
                          "miter" === O && L > r && (O = "bevel"),
                          "bevel" === O && (L > 2 && (O = "flipbevel"),
                          L < r && (O = "miter")),
                          w && (this.distance += m.dist(w)),
                          "miter" === O)
                              T._mult(L),
                              this.addCurrentVertex(m, this.distance, T, 0, 0, !1, f, l);
                          else if ("flipbevel" === O) {
                              if (L > 100)
                                  T = S.clone().mult(-1);
                              else {
                                  var z = k.x * S.y - k.y * S.x > 0 ? -1 : 1
                                    , D = L * k.add(S).mag() / k.sub(S).mag();
                                  T._perp()._mult(D * z)
                              }
                              this.addCurrentVertex(m, this.distance, T, 0, 0, !1, f, l),
                              this.addCurrentVertex(m, this.distance, T.mult(-1), 0, 0, !1, f, l)
                          } else if ("bevel" === O || "fakeround" === O) {
                              var R = k.x * S.y - k.y * S.x > 0
                                , B = -Math.sqrt(L * L - 1);
                              if (R ? (v = 0,
                              g = B) : (g = 0,
                              v = B),
                              b || this.addCurrentVertex(m, this.distance, k, g, v, !1, f, l),
                              "fakeround" === O) {
                                  for (var j = Math.floor(8 * (.5 - (C - .5))), F = void 0, N = 0; N < j; N++)
                                      F = S.mult((N + 1) / (j + 1))._add(k)._unit(),
                                      this.addPieSliceVertex(m, this.distance, F, R, f, l);
                                  this.addPieSliceVertex(m, this.distance, T, R, f, l);
                                  for (var U = j - 1; U >= 0; U--)
                                      F = k.mult((U + 1) / (j + 1))._add(S)._unit(),
                                      this.addPieSliceVertex(m, this.distance, F, R, f, l)
                              }
                              x && this.addCurrentVertex(m, this.distance, S, -g, -v, !1, f, l)
                          } else
                              "butt" === O ? (b || this.addCurrentVertex(m, this.distance, k, 0, 0, !1, f, l),
                              x && this.addCurrentVertex(m, this.distance, S, 0, 0, !1, f, l)) : "square" === O ? (b || (this.addCurrentVertex(m, this.distance, k, 1, 1, !1, f, l),
                              this.e1 = this.e2 = -1),
                              x && this.addCurrentVertex(m, this.distance, S, -1, -1, !1, f, l)) : "round" === O && (b || (this.addCurrentVertex(m, this.distance, k, 0, 0, !1, f, l),
                              this.addCurrentVertex(m, this.distance, k, 1, 1, !0, f, l),
                              this.e1 = this.e2 = -1),
                              x && (this.addCurrentVertex(m, this.distance, S, -1, -1, !0, f, l),
                              this.addCurrentVertex(m, this.distance, S, 0, 0, !1, f, l)));
                          if (A && E < u - 1) {
                              var q = m.dist(x);
                              if (q > 2 * d) {
                                  var H = m.add(x.sub(m)._mult(d / q)._round());
                                  this.distance += H.dist(m),
                                  this.addCurrentVertex(H, this.distance, S.mult(1), 0, 0, !1, f, l),
                                  m = H
                              }
                          }
                          b = !1
                      }
                  this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, s, a)
              }
          }
          ,
          $s.prototype.addCurrentVertex = function(e, t, i, n, r, o, s, a) {
              var l, c = this.layoutVertexArray, u = this.indexArray;
              a && (t = Gs(t, a)),
              l = i.clone(),
              n && l._sub(i.perp()._mult(n)),
              Ws(c, e, l, o, !1, n, t),
              this.e3 = s.vertexLength++,
              this.e1 >= 0 && this.e2 >= 0 && (u.emplaceBack(this.e1, this.e2, this.e3),
              s.primitiveLength++),
              this.e1 = this.e2,
              this.e2 = this.e3,
              l = i.mult(-1),
              r && l._sub(i.perp()._mult(r)),
              Ws(c, e, l, o, !0, -r, t),
              this.e3 = s.vertexLength++,
              this.e1 >= 0 && this.e2 >= 0 && (u.emplaceBack(this.e1, this.e2, this.e3),
              s.primitiveLength++),
              this.e1 = this.e2,
              this.e2 = this.e3,
              t > Vs / 2 && !a && (this.distance = 0,
              this.addCurrentVertex(e, this.distance, i, n, r, o, s))
          }
          ,
          $s.prototype.addPieSliceVertex = function(e, t, i, n, r, o) {
              i = i.mult(n ? -1 : 1);
              var s = this.layoutVertexArray
                , a = this.indexArray;
              o && (t = Gs(t, o)),
              Ws(s, e, i, !1, n, 0, t),
              this.e3 = r.vertexLength++,
              this.e1 >= 0 && this.e2 >= 0 && (a.emplaceBack(this.e1, this.e2, this.e3),
              r.primitiveLength++),
              n ? this.e2 = this.e3 : this.e1 = this.e3
          }
          ,
          an("LineBucket", $s, {
              omit: ["layers", "features"]
          });
          var Xs = new jn({
              "line-cap": new On(ge.layout_line["line-cap"]),
              "line-join": new zn(ge.layout_line["line-join"]),
              "line-miter-limit": new On(ge.layout_line["line-miter-limit"]),
              "line-round-limit": new On(ge.layout_line["line-round-limit"])
          })
            , Zs = {
              paint: new jn({
                  "line-opacity": new zn(ge.paint_line["line-opacity"]),
                  "line-color": new zn(ge.paint_line["line-color"]),
                  "line-translate": new On(ge.paint_line["line-translate"]),
                  "line-translate-anchor": new On(ge.paint_line["line-translate-anchor"]),
                  "line-width": new zn(ge.paint_line["line-width"]),
                  "line-gap-width": new zn(ge.paint_line["line-gap-width"]),
                  "line-offset": new zn(ge.paint_line["line-offset"]),
                  "line-blur": new zn(ge.paint_line["line-blur"]),
                  "line-dasharray": new Rn(ge.paint_line["line-dasharray"]),
                  "line-pattern": new Dn(ge.paint_line["line-pattern"]),
                  "line-gradient": new Bn(ge.paint_line["line-gradient"])
              }),
              layout: Xs
          }
            , Ys = new (function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.possiblyEvaluate = function(t, i) {
                  return i = new Sn(Math.floor(i.zoom),{
                      now: i.now,
                      fadeDuration: i.fadeDuration,
                      zoomHistory: i.zoomHistory,
                      transition: i.transition
                  }),
                  e.prototype.possiblyEvaluate.call(this, t, i)
              }
              ,
              t.prototype.evaluate = function(t, i, n, r) {
                  return i = h({}, i, {
                      zoom: Math.floor(i.zoom)
                  }),
                  e.prototype.evaluate.call(this, t, i, n, r)
              }
              ,
              t
          }(zn))(Zs.paint.properties["line-width"].specification);
          Ys.useIntegerZoom = !0;
          var Ks = function(e) {
              function t(t) {
                  e.call(this, t, Zs)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype._handleSpecialPaintPropertyUpdate = function(e) {
                  "line-gradient" === e && this._updateGradient()
              }
              ,
              t.prototype._updateGradient = function() {
                  var e = this._transitionablePaint._values["line-gradient"].value.expression;
                  this.gradient = Io(e, "lineProgress"),
                  this.gradientTexture = null
              }
              ,
              t.prototype.recalculate = function(t) {
                  e.prototype.recalculate.call(this, t),
                  this.paint._values["line-floorwidth"] = Ys.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t)
              }
              ,
              t.prototype.createBucket = function(e) {
                  return new $s(e)
              }
              ,
              t.prototype.queryRadius = function(e) {
                  var t = e
                    , i = Js(ho("line-width", this, t), ho("line-gap-width", this, t))
                    , n = ho("line-offset", this, t);
                  return i / 2 + Math.abs(n) + po(this.paint.get("line-translate"))
              }
              ,
              t.prototype.queryIntersectsFeature = function(e, t, i, n, o, s, a) {
                  var l = fo(e, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), s.angle, a)
                    , c = a / 2 * Js(this.paint.get("line-width").evaluate(t, i), this.paint.get("line-gap-width").evaluate(t, i))
                    , u = this.paint.get("line-offset").evaluate(t, i);
                  return u && (n = function(e, t) {
                      for (var i = [], n = new r(0,0), o = 0; o < e.length; o++) {
                          for (var s = e[o], a = [], l = 0; l < s.length; l++) {
                              var c = s[l - 1]
                                , u = s[l]
                                , h = s[l + 1]
                                , d = 0 === l ? n : u.sub(c)._unit()._perp()
                                , p = l === s.length - 1 ? n : h.sub(u)._unit()._perp()
                                , f = d._add(p)._unit()
                                , m = f.x * p.x + f.y * p.y;
                              f._mult(1 / m),
                              a.push(f._mult(t)._add(u))
                          }
                          i.push(a)
                      }
                      return i
                  }(n, u * a)),
                  function(e, t, i) {
                      for (var n = 0; n < t.length; n++) {
                          var r = t[n];
                          if (e.length >= 3)
                              for (var o = 0; o < r.length; o++)
                                  if (co(e, r[o]))
                                      return !0;
                          if (no(e, r, i))
                              return !0
                      }
                      return !1
                  }(l, n, c)
              }
              ,
              t
          }(Fn);
          function Js(e, t) {
              return t > 0 ? t + 2 * e : e
          }
          var Qs = Hn([{
              name: "a_pos_offset",
              components: 4,
              type: "Int16"
          }, {
              name: "a_data",
              components: 4,
              type: "Uint16"
          }])
            , ea = Hn([{
              name: "a_projected_pos",
              components: 3,
              type: "Float32"
          }], 4)
            , ta = (Hn([{
              name: "a_fade_opacity",
              components: 1,
              type: "Uint32"
          }], 4),
          Hn([{
              name: "a_placed",
              components: 2,
              type: "Uint8"
          }], 4))
            , ia = (Hn([{
              type: "Int16",
              name: "anchorPointX"
          }, {
              type: "Int16",
              name: "anchorPointY"
          }, {
              type: "Int16",
              name: "x1"
          }, {
              type: "Int16",
              name: "y1"
          }, {
              type: "Int16",
              name: "x2"
          }, {
              type: "Int16",
              name: "y2"
          }, {
              type: "Uint32",
              name: "featureIndex"
          }, {
              type: "Uint16",
              name: "sourceLayerIndex"
          }, {
              type: "Uint16",
              name: "bucketIndex"
          }, {
              type: "Int16",
              name: "radius"
          }, {
              type: "Int16",
              name: "signedDistanceFromAnchor"
          }]),
          Hn([{
              name: "a_pos",
              components: 2,
              type: "Int16"
          }, {
              name: "a_anchor_pos",
              components: 2,
              type: "Int16"
          }, {
              name: "a_extrude",
              components: 2,
              type: "Int16"
          }], 4))
            , na = Hn([{
              name: "a_pos",
              components: 2,
              type: "Int16"
          }, {
              name: "a_anchor_pos",
              components: 2,
              type: "Int16"
          }, {
              name: "a_extrude",
              components: 2,
              type: "Int16"
          }], 4);
          function ra(e, t, i) {
              return e.sections.forEach(function(e) {
                  e.text = function(e, t, i) {
                      var n = t.layout.get("text-transform").evaluate(i, {});
                      return "uppercase" === n ? e = e.toLocaleUpperCase() : "lowercase" === n && (e = e.toLocaleLowerCase()),
                      kn.applyArabicShaping && (e = kn.applyArabicShaping(e)),
                      e
                  }(e.text, t, i)
              }),
              e
          }
          Hn([{
              type: "Int16",
              name: "anchorX"
          }, {
              type: "Int16",
              name: "anchorY"
          }, {
              type: "Uint16",
              name: "glyphStartIndex"
          }, {
              type: "Uint16",
              name: "numGlyphs"
          }, {
              type: "Uint32",
              name: "vertexStartIndex"
          }, {
              type: "Uint32",
              name: "lineStartIndex"
          }, {
              type: "Uint32",
              name: "lineLength"
          }, {
              type: "Uint16",
              name: "segment"
          }, {
              type: "Uint16",
              name: "lowerSize"
          }, {
              type: "Uint16",
              name: "upperSize"
          }, {
              type: "Float32",
              name: "lineOffsetX"
          }, {
              type: "Float32",
              name: "lineOffsetY"
          }, {
              type: "Uint8",
              name: "writingMode"
          }, {
              type: "Uint8",
              name: "hidden"
          }]),
          Hn([{
              type: "Int16",
              name: "anchorX"
          }, {
              type: "Int16",
              name: "anchorY"
          }, {
              type: "Int16",
              name: "horizontalPlacedTextSymbolIndex"
          }, {
              type: "Int16",
              name: "verticalPlacedTextSymbolIndex"
          }, {
              type: "Uint16",
              name: "key"
          }, {
              type: "Uint16",
              name: "textBoxStartIndex"
          }, {
              type: "Uint16",
              name: "textBoxEndIndex"
          }, {
              type: "Uint16",
              name: "iconBoxStartIndex"
          }, {
              type: "Uint16",
              name: "iconBoxEndIndex"
          }, {
              type: "Uint16",
              name: "featureIndex"
          }, {
              type: "Uint16",
              name: "numGlyphVertices"
          }, {
              type: "Uint16",
              name: "numVerticalGlyphVertices"
          }, {
              type: "Uint16",
              name: "numIconVertices"
          }, {
              type: "Uint32",
              name: "crossTileID"
          }]),
          Hn([{
              type: "Float32",
              name: "offsetX"
          }]),
          Hn([{
              type: "Int16",
              name: "x"
          }, {
              type: "Int16",
              name: "y"
          }, {
              type: "Int16",
              name: "tileUnitDistanceFromAnchor"
          }]);
          var oa = {
              "!": "︕",
              "#": "＃",
              $: "＄",
              "%": "％",
              "&": "＆",
              "(": "︵",
              ")": "︶",
              "*": "＊",
              "+": "＋",
              ",": "︐",
              "-": "︲",
              ".": "・",
              "/": "／",
              ":": "︓",
              ";": "︔",
              "<": "︿",
              "=": "＝",
              ">": "﹀",
              "?": "︖",
              "@": "＠",
              "[": "﹇",
              "\\": "＼",
              "]": "﹈",
              "^": "＾",
              _: "︳",
              "`": "｀",
              "{": "︷",
              "|": "―",
              "}": "︸",
              "~": "～",
              "¢": "￠",
              "£": "￡",
              "¥": "￥",
              "¦": "￤",
              "¬": "￢",
              "¯": "￣",
              "–": "︲",
              "—": "︱",
              "‘": "﹃",
              "’": "﹄",
              "“": "﹁",
              "”": "﹂",
              "…": "︙",
              "‧": "・",
              "₩": "￦",
              "、": "︑",
              "。": "︒",
              "〈": "︿",
              "〉": "﹀",
              "《": "︽",
              "》": "︾",
              "「": "﹁",
              "」": "﹂",
              "『": "﹃",
              "』": "﹄",
              "【": "︻",
              "】": "︼",
              "〔": "︹",
              "〕": "︺",
              "〖": "︗",
              "〗": "︘",
              "！": "︕",
              "（": "︵",
              "）": "︶",
              "，": "︐",
              "－": "︲",
              "．": "・",
              "：": "︓",
              "；": "︔",
              "＜": "︿",
              "＞": "﹀",
              "？": "︖",
              "［": "﹇",
              "］": "﹈",
              "＿": "︳",
              "｛": "︷",
              "｜": "―",
              "｝": "︸",
              "｟": "︵",
              "｠": "︶",
              "｡": "︒",
              "｢": "﹁",
              "｣": "﹂"
          }
            , sa = function(e) {
              function t(t, i, n, r) {
                  e.call(this, t, i),
                  this.angle = n,
                  void 0 !== r && (this.segment = r)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.clone = function() {
                  return new t(this.x,this.y,this.angle,this.segment)
              }
              ,
              t
          }(r);
          function aa(e, t) {
              var i = t.expression;
              if ("constant" === i.kind)
                  return {
                      functionType: "constant",
                      layoutSize: i.evaluate(new Sn(e + 1))
                  };
              if ("source" === i.kind)
                  return {
                      functionType: "source"
                  };
              for (var n = i.zoomStops, r = 0; r < n.length && n[r] <= e; )
                  r++;
              for (var o = r = Math.max(0, r - 1); o < n.length && n[o] < e + 1; )
                  o++;
              o = Math.min(n.length - 1, o);
              var s = {
                  min: n[r],
                  max: n[o]
              };
              return "composite" === i.kind ? {
                  functionType: "composite",
                  zoomRange: s,
                  propertyValue: t.value
              } : {
                  functionType: "camera",
                  layoutSize: i.evaluate(new Sn(e + 1)),
                  zoomRange: s,
                  sizeRange: {
                      min: i.evaluate(new Sn(s.min)),
                      max: i.evaluate(new Sn(s.max))
                  },
                  propertyValue: t.value
              }
          }
          an("Anchor", sa);
          var la = Fs.VectorTileFeature.types
            , ca = [{
              name: "a_fade_opacity",
              components: 1,
              type: "Uint8",
              offset: 0
          }];
          function ua(e, t, i, n, r, o, s, a) {
              e.emplaceBack(t, i, Math.round(32 * n), Math.round(32 * r), o, s, a ? a[0] : 0, a ? a[1] : 0)
          }
          function ha(e, t, i) {
              e.emplaceBack(t.x, t.y, i),
              e.emplaceBack(t.x, t.y, i),
              e.emplaceBack(t.x, t.y, i),
              e.emplaceBack(t.x, t.y, i)
          }
          var da = function(e) {
              this.layoutVertexArray = new Yn,
              this.indexArray = new ar,
              this.programConfigurations = e,
              this.segments = new Tr,
              this.dynamicLayoutVertexArray = new Kn,
              this.opacityVertexArray = new Jn,
              this.placedSymbolArray = new mr
          };
          da.prototype.upload = function(e, t, i, n) {
              i && (this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, Qs.members),
              this.indexBuffer = e.createIndexBuffer(this.indexArray, t),
              this.dynamicLayoutVertexBuffer = e.createVertexBuffer(this.dynamicLayoutVertexArray, ea.members, !0),
              this.opacityVertexBuffer = e.createVertexBuffer(this.opacityVertexArray, ca, !0),
              this.opacityVertexBuffer.itemSize = 1),
              (i || n) && this.programConfigurations.upload(e)
          }
          ,
          da.prototype.destroy = function() {
              this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(),
              this.indexBuffer.destroy(),
              this.programConfigurations.destroy(),
              this.segments.destroy(),
              this.dynamicLayoutVertexBuffer.destroy(),
              this.opacityVertexBuffer.destroy())
          }
          ,
          an("SymbolBuffers", da);
          var pa = function(e, t, i) {
              this.layoutVertexArray = new e,
              this.layoutAttributes = t,
              this.indexArray = new i,
              this.segments = new Tr,
              this.collisionVertexArray = new tr
          };
          pa.prototype.upload = function(e) {
              this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes),
              this.indexBuffer = e.createIndexBuffer(this.indexArray),
              this.collisionVertexBuffer = e.createVertexBuffer(this.collisionVertexArray, ta.members, !0)
          }
          ,
          pa.prototype.destroy = function() {
              this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(),
              this.indexBuffer.destroy(),
              this.segments.destroy(),
              this.collisionVertexBuffer.destroy())
          }
          ,
          an("CollisionBuffers", pa);
          var fa = function(e) {
              this.collisionBoxArray = e.collisionBoxArray,
              this.zoom = e.zoom,
              this.overscaling = e.overscaling,
              this.layers = e.layers,
              this.layerIds = this.layers.map(function(e) {
                  return e.id
              }),
              this.index = e.index,
              this.pixelRatio = e.pixelRatio,
              this.sourceLayerIndex = e.sourceLayerIndex,
              this.hasPattern = !1;
              var t = this.layers[0]._unevaluatedLayout._values;
              this.textSizeData = aa(this.zoom, t["text-size"]),
              this.iconSizeData = aa(this.zoom, t["icon-size"]);
              var i = this.layers[0].layout
                , n = i.get("symbol-sort-key")
                , r = i.get("symbol-z-order");
              this.sortFeaturesByKey = "viewport-y" !== r && void 0 !== n.constantOr(1);
              var o = "viewport-y" === r || "auto" === r && !this.sortFeaturesByKey;
              this.sortFeaturesByY = o && (i.get("text-allow-overlap") || i.get("icon-allow-overlap") || i.get("text-ignore-placement") || i.get("icon-ignore-placement")),
              this.stateDependentLayerIds = this.layers.filter(function(e) {
                  return e.isStateDependent()
              }).map(function(e) {
                  return e.id
              }),
              this.sourceID = e.sourceID
          };
          fa.prototype.createArrays = function() {
              this.text = new da(new $r(Qs.members,this.layers,this.zoom,function(e) {
                  return /^text/.test(e)
              }
              )),
              this.icon = new da(new $r(Qs.members,this.layers,this.zoom,function(e) {
                  return /^icon/.test(e)
              }
              )),
              this.collisionBox = new pa(er,ia.members,lr),
              this.collisionCircle = new pa(er,na.members,ar),
              this.glyphOffsetArray = new _r,
              this.lineVertexArray = new wr,
              this.symbolInstances = new vr
          }
          ,
          fa.prototype.calculateGlyphDependencies = function(e, t, i, n) {
              for (var r = 0; r < e.length; r++)
                  if (t[e.charCodeAt(r)] = !0,
                  i && n) {
                      var o = oa[e.charAt(r)];
                      o && (t[o.charCodeAt(0)] = !0)
                  }
          }
          ,
          fa.prototype.populate = function(e, t) {
              var i = this.layers[0]
                , n = i.layout
                , r = n.get("text-font")
                , o = n.get("text-field")
                , s = n.get("icon-image")
                , a = ("constant" !== o.value.kind || o.value.value.toString().length > 0) && ("constant" !== r.value.kind || r.value.value.length > 0)
                , l = "constant" !== s.value.kind || s.value.value && s.value.value.length > 0
                , c = n.get("symbol-sort-key");
              if (this.features = [],
              a || l) {
                  for (var u = t.iconDependencies, h = t.glyphDependencies, d = new Sn(this.zoom), p = 0, f = e; p < f.length; p += 1) {
                      var m = f[p]
                        , g = m.feature
                        , v = m.index
                        , y = m.sourceLayerIndex;
                      if (i._featureFilter(d, g)) {
                          var _ = void 0;
                          if (a) {
                              var b = i.getValueAndResolveTokens("text-field", g);
                              _ = ra(b instanceof Ue ? b : Ue.fromString(b), i, g)
                          }
                          var w = void 0;
                          if (l && (w = i.getValueAndResolveTokens("icon-image", g)),
                          _ || w) {
                              var x = this.sortFeaturesByKey ? c.evaluate(g, {}) : void 0
                                , k = {
                                  text: _,
                                  icon: w,
                                  index: v,
                                  sourceLayerIndex: y,
                                  geometry: Kr(g),
                                  properties: g.properties,
                                  type: la[g.type],
                                  sortKey: x
                              };
                              if (void 0 !== g.id && (k.id = g.id),
                              this.features.push(k),
                              w && (u[w] = !0),
                              _)
                                  for (var S = r.evaluate(g, {}).join(","), E = "map" === n.get("text-rotation-alignment") && "point" !== n.get("symbol-placement"), T = 0, C = _.sections; T < C.length; T += 1) {
                                      var L = C[T]
                                        , A = pn(_.toString())
                                        , P = L.fontStack || S
                                        , I = h[P] = h[P] || {};
                                      this.calculateGlyphDependencies(L.text, I, E, A)
                                  }
                          }
                      }
                  }
                  "line" === n.get("symbol-placement") && (this.features = function(e) {
                      var t = {}
                        , i = {}
                        , n = []
                        , r = 0;
                      function o(t) {
                          n.push(e[t]),
                          r++
                      }
                      function s(e, t, r) {
                          var o = i[e];
                          return delete i[e],
                          i[t] = o,
                          n[o].geometry[0].pop(),
                          n[o].geometry[0] = n[o].geometry[0].concat(r[0]),
                          o
                      }
                      function a(e, i, r) {
                          var o = t[i];
                          return delete t[i],
                          t[e] = o,
                          n[o].geometry[0].shift(),
                          n[o].geometry[0] = r[0].concat(n[o].geometry[0]),
                          o
                      }
                      function l(e, t, i) {
                          var n = i ? t[0][t[0].length - 1] : t[0][0];
                          return e + ":" + n.x + ":" + n.y
                      }
                      for (var c = 0; c < e.length; c++) {
                          var u = e[c]
                            , h = u.geometry
                            , d = u.text ? u.text.toString() : null;
                          if (d) {
                              var p = l(d, h)
                                , f = l(d, h, !0);
                              if (p in i && f in t && i[p] !== t[f]) {
                                  var m = a(p, f, h)
                                    , g = s(p, f, n[m].geometry);
                                  delete t[p],
                                  delete i[f],
                                  i[l(d, n[g].geometry, !0)] = g,
                                  n[m].geometry = null
                              } else
                                  p in i ? s(p, f, h) : f in t ? a(p, f, h) : (o(c),
                                  t[p] = r - 1,
                                  i[f] = r - 1)
                          } else
                              o(c)
                      }
                      return n.filter(function(e) {
                          return e.geometry
                      })
                  }(this.features)),
                  this.sortFeaturesByKey && this.features.sort(function(e, t) {
                      return e.sortKey - t.sortKey
                  })
              }
          }
          ,
          fa.prototype.update = function(e, t, i) {
              this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(e, t, this.layers, i),
              this.icon.programConfigurations.updatePaintArrays(e, t, this.layers, i))
          }
          ,
          fa.prototype.isEmpty = function() {
              return 0 === this.symbolInstances.length
          }
          ,
          fa.prototype.uploadPending = function() {
              return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload
          }
          ,
          fa.prototype.upload = function(e) {
              this.uploaded || (this.collisionBox.upload(e),
              this.collisionCircle.upload(e)),
              this.text.upload(e, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload),
              this.icon.upload(e, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload),
              this.uploaded = !0
          }
          ,
          fa.prototype.destroy = function() {
              this.text.destroy(),
              this.icon.destroy(),
              this.collisionBox.destroy(),
              this.collisionCircle.destroy()
          }
          ,
          fa.prototype.addToLineVertexArray = function(e, t) {
              var i = this.lineVertexArray.length;
              if (void 0 !== e.segment) {
                  for (var n = e.dist(t[e.segment + 1]), r = e.dist(t[e.segment]), o = {}, s = e.segment + 1; s < t.length; s++)
                      o[s] = {
                          x: t[s].x,
                          y: t[s].y,
                          tileUnitDistanceFromAnchor: n
                      },
                      s < t.length - 1 && (n += t[s + 1].dist(t[s]));
                  for (var a = e.segment || 0; a >= 0; a--)
                      o[a] = {
                          x: t[a].x,
                          y: t[a].y,
                          tileUnitDistanceFromAnchor: r
                      },
                      a > 0 && (r += t[a - 1].dist(t[a]));
                  for (var l = 0; l < t.length; l++) {
                      var c = o[l];
                      this.lineVertexArray.emplaceBack(c.x, c.y, c.tileUnitDistanceFromAnchor)
                  }
              }
              return {
                  lineStartIndex: i,
                  lineLength: this.lineVertexArray.length - i
              }
          }
          ,
          fa.prototype.addSymbols = function(e, t, i, n, r, o, s, a, l, c) {
              for (var u = e.indexArray, h = e.layoutVertexArray, d = e.dynamicLayoutVertexArray, p = e.segments.prepareSegment(4 * t.length, e.layoutVertexArray, e.indexArray, o.sortKey), f = this.glyphOffsetArray.length, m = p.vertexLength, g = 0, v = t; g < v.length; g += 1) {
                  var y = v[g]
                    , _ = y.tl
                    , b = y.tr
                    , w = y.bl
                    , x = y.br
                    , k = y.tex
                    , S = p.vertexLength
                    , E = y.glyphOffset[1];
                  ua(h, a.x, a.y, _.x, E + _.y, k.x, k.y, i),
                  ua(h, a.x, a.y, b.x, E + b.y, k.x + k.w, k.y, i),
                  ua(h, a.x, a.y, w.x, E + w.y, k.x, k.y + k.h, i),
                  ua(h, a.x, a.y, x.x, E + x.y, k.x + k.w, k.y + k.h, i),
                  ha(d, a, 0),
                  u.emplaceBack(S, S + 1, S + 2),
                  u.emplaceBack(S + 1, S + 2, S + 3),
                  p.vertexLength += 4,
                  p.primitiveLength += 2,
                  this.glyphOffsetArray.emplaceBack(y.glyphOffset[0])
              }
              e.placedSymbolArray.emplaceBack(a.x, a.y, f, this.glyphOffsetArray.length - f, m, l, c, a.segment, i ? i[0] : 0, i ? i[1] : 0, n[0], n[1], s, !1),
              e.programConfigurations.populatePaintArrays(e.layoutVertexArray.length, o, o.index, {})
          }
          ,
          fa.prototype._addCollisionDebugVertex = function(e, t, i, n, r, o) {
              return t.emplaceBack(0, 0),
              e.emplaceBack(i.x, i.y, n, r, Math.round(o.x), Math.round(o.y))
          }
          ,
          fa.prototype.addCollisionDebugVertices = function(e, t, i, n, o, s, a, l) {
              var c = o.segments.prepareSegment(4, o.layoutVertexArray, o.indexArray)
                , u = c.vertexLength
                , h = o.layoutVertexArray
                , d = o.collisionVertexArray
                , p = a.anchorX
                , f = a.anchorY;
              if (this._addCollisionDebugVertex(h, d, s, p, f, new r(e,t)),
              this._addCollisionDebugVertex(h, d, s, p, f, new r(i,t)),
              this._addCollisionDebugVertex(h, d, s, p, f, new r(i,n)),
              this._addCollisionDebugVertex(h, d, s, p, f, new r(e,n)),
              c.vertexLength += 4,
              l) {
                  var m = o.indexArray;
                  m.emplaceBack(u, u + 1, u + 2),
                  m.emplaceBack(u, u + 2, u + 3),
                  c.primitiveLength += 2
              } else {
                  var g = o.indexArray;
                  g.emplaceBack(u, u + 1),
                  g.emplaceBack(u + 1, u + 2),
                  g.emplaceBack(u + 2, u + 3),
                  g.emplaceBack(u + 3, u),
                  c.primitiveLength += 4
              }
          }
          ,
          fa.prototype.addDebugCollisionBoxes = function(e, t, i) {
              for (var n = e; n < t; n++) {
                  var r = this.collisionBoxArray.get(n)
                    , o = r.x1
                    , s = r.y1
                    , a = r.x2
                    , l = r.y2
                    , c = r.radius > 0;
                  this.addCollisionDebugVertices(o, s, a, l, c ? this.collisionCircle : this.collisionBox, r.anchorPoint, i, c)
              }
          }
          ,
          fa.prototype.generateCollisionDebugBuffers = function() {
              for (var e = 0; e < this.symbolInstances.length; e++) {
                  var t = this.symbolInstances.get(e);
                  this.addDebugCollisionBoxes(t.textBoxStartIndex, t.textBoxEndIndex, t),
                  this.addDebugCollisionBoxes(t.iconBoxStartIndex, t.iconBoxEndIndex, t)
              }
          }
          ,
          fa.prototype._deserializeCollisionBoxesForSymbol = function(e, t, i, n, r) {
              for (var o = {}, s = t; s < i; s++) {
                  var a = e.get(s);
                  if (0 === a.radius) {
                      o.textBox = {
                          x1: a.x1,
                          y1: a.y1,
                          x2: a.x2,
                          y2: a.y2,
                          anchorPointX: a.anchorPointX,
                          anchorPointY: a.anchorPointY
                      },
                      o.textFeatureIndex = a.featureIndex;
                      break
                  }
                  o.textCircles || (o.textCircles = [],
                  o.textFeatureIndex = a.featureIndex),
                  o.textCircles.push(a.anchorPointX, a.anchorPointY, a.radius, a.signedDistanceFromAnchor, 1)
              }
              for (var l = n; l < r; l++) {
                  var c = e.get(l);
                  if (0 === c.radius) {
                      o.iconBox = {
                          x1: c.x1,
                          y1: c.y1,
                          x2: c.x2,
                          y2: c.y2,
                          anchorPointX: c.anchorPointX,
                          anchorPointY: c.anchorPointY
                      },
                      o.iconFeatureIndex = c.featureIndex;
                      break
                  }
              }
              return o
          }
          ,
          fa.prototype.deserializeCollisionBoxes = function(e) {
              this.collisionArrays = [];
              for (var t = 0; t < this.symbolInstances.length; t++) {
                  var i = this.symbolInstances.get(t);
                  this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(e, i.textBoxStartIndex, i.textBoxEndIndex, i.iconBoxStartIndex, i.iconBoxEndIndex))
              }
          }
          ,
          fa.prototype.hasTextData = function() {
              return this.text.segments.get().length > 0
          }
          ,
          fa.prototype.hasIconData = function() {
              return this.icon.segments.get().length > 0
          }
          ,
          fa.prototype.hasCollisionBoxData = function() {
              return this.collisionBox.segments.get().length > 0
          }
          ,
          fa.prototype.hasCollisionCircleData = function() {
              return this.collisionCircle.segments.get().length > 0
          }
          ,
          fa.prototype.addIndicesForPlacedTextSymbol = function(e) {
              for (var t = this.text.placedSymbolArray.get(e), i = t.vertexStartIndex + 4 * t.numGlyphs, n = t.vertexStartIndex; n < i; n += 4)
                  this.text.indexArray.emplaceBack(n, n + 1, n + 2),
                  this.text.indexArray.emplaceBack(n + 1, n + 2, n + 3)
          }
          ,
          fa.prototype.sortFeatures = function(e) {
              if (this.sortFeaturesByY && this.sortedAngle !== e && (this.sortedAngle = e,
              !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1))) {
                  for (var t = [], i = 0; i < this.symbolInstances.length; i++)
                      t.push(i);
                  for (var n = Math.sin(e), r = Math.cos(e), o = [], s = [], a = 0; a < this.symbolInstances.length; a++) {
                      var l = this.symbolInstances.get(a);
                      o.push(0 | Math.round(n * l.anchorX + r * l.anchorY)),
                      s.push(l.featureIndex)
                  }
                  t.sort(function(e, t) {
                      return o[e] - o[t] || s[t] - s[e]
                  }),
                  this.text.indexArray.clear(),
                  this.icon.indexArray.clear(),
                  this.featureSortOrder = [];
                  for (var c = 0, u = t; c < u.length; c += 1) {
                      var h = u[c]
                        , d = this.symbolInstances.get(h);
                      this.featureSortOrder.push(d.featureIndex),
                      d.horizontalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedTextSymbol(d.horizontalPlacedTextSymbolIndex),
                      d.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedTextSymbol(d.verticalPlacedTextSymbolIndex);
                      var p = this.icon.placedSymbolArray.get(h);
                      if (p.numGlyphs) {
                          var f = p.vertexStartIndex;
                          this.icon.indexArray.emplaceBack(f, f + 1, f + 2),
                          this.icon.indexArray.emplaceBack(f + 1, f + 2, f + 3)
                      }
                  }
                  this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray),
                  this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray)
              }
          }
          ,
          an("SymbolBucket", fa, {
              omit: ["layers", "collisionBoxArray", "features", "compareText"]
          }),
          fa.MAX_GLYPHS = 65535,
          fa.addDynamicAttributes = ha;
          var ma = new jn({
              "symbol-placement": new On(ge.layout_symbol["symbol-placement"]),
              "symbol-spacing": new On(ge.layout_symbol["symbol-spacing"]),
              "symbol-avoid-edges": new On(ge.layout_symbol["symbol-avoid-edges"]),
              "symbol-sort-key": new zn(ge.layout_symbol["symbol-sort-key"]),
              "symbol-z-order": new On(ge.layout_symbol["symbol-z-order"]),
              "icon-allow-overlap": new On(ge.layout_symbol["icon-allow-overlap"]),
              "icon-ignore-placement": new On(ge.layout_symbol["icon-ignore-placement"]),
              "icon-optional": new On(ge.layout_symbol["icon-optional"]),
              "icon-rotation-alignment": new On(ge.layout_symbol["icon-rotation-alignment"]),
              "icon-size": new zn(ge.layout_symbol["icon-size"]),
              "icon-text-fit": new On(ge.layout_symbol["icon-text-fit"]),
              "icon-text-fit-padding": new On(ge.layout_symbol["icon-text-fit-padding"]),
              "icon-image": new zn(ge.layout_symbol["icon-image"]),
              "icon-rotate": new zn(ge.layout_symbol["icon-rotate"]),
              "icon-padding": new On(ge.layout_symbol["icon-padding"]),
              "icon-keep-upright": new On(ge.layout_symbol["icon-keep-upright"]),
              "icon-offset": new zn(ge.layout_symbol["icon-offset"]),
              "icon-anchor": new zn(ge.layout_symbol["icon-anchor"]),
              "icon-pitch-alignment": new On(ge.layout_symbol["icon-pitch-alignment"]),
              "text-pitch-alignment": new On(ge.layout_symbol["text-pitch-alignment"]),
              "text-rotation-alignment": new On(ge.layout_symbol["text-rotation-alignment"]),
              "text-field": new zn(ge.layout_symbol["text-field"]),
              "text-font": new zn(ge.layout_symbol["text-font"]),
              "text-size": new zn(ge.layout_symbol["text-size"]),
              "text-max-width": new zn(ge.layout_symbol["text-max-width"]),
              "text-line-height": new On(ge.layout_symbol["text-line-height"]),
              "text-letter-spacing": new zn(ge.layout_symbol["text-letter-spacing"]),
              "text-justify": new zn(ge.layout_symbol["text-justify"]),
              "text-anchor": new zn(ge.layout_symbol["text-anchor"]),
              "text-max-angle": new On(ge.layout_symbol["text-max-angle"]),
              "text-rotate": new zn(ge.layout_symbol["text-rotate"]),
              "text-padding": new On(ge.layout_symbol["text-padding"]),
              "text-keep-upright": new On(ge.layout_symbol["text-keep-upright"]),
              "text-transform": new zn(ge.layout_symbol["text-transform"]),
              "text-offset": new zn(ge.layout_symbol["text-offset"]),
              "text-allow-overlap": new On(ge.layout_symbol["text-allow-overlap"]),
              "text-ignore-placement": new On(ge.layout_symbol["text-ignore-placement"]),
              "text-optional": new On(ge.layout_symbol["text-optional"])
          })
            , ga = {
              paint: new jn({
                  "icon-opacity": new zn(ge.paint_symbol["icon-opacity"]),
                  "icon-color": new zn(ge.paint_symbol["icon-color"]),
                  "icon-halo-color": new zn(ge.paint_symbol["icon-halo-color"]),
                  "icon-halo-width": new zn(ge.paint_symbol["icon-halo-width"]),
                  "icon-halo-blur": new zn(ge.paint_symbol["icon-halo-blur"]),
                  "icon-translate": new On(ge.paint_symbol["icon-translate"]),
                  "icon-translate-anchor": new On(ge.paint_symbol["icon-translate-anchor"]),
                  "text-opacity": new zn(ge.paint_symbol["text-opacity"]),
                  "text-color": new zn(ge.paint_symbol["text-color"]),
                  "text-halo-color": new zn(ge.paint_symbol["text-halo-color"]),
                  "text-halo-width": new zn(ge.paint_symbol["text-halo-width"]),
                  "text-halo-blur": new zn(ge.paint_symbol["text-halo-blur"]),
                  "text-translate": new On(ge.paint_symbol["text-translate"]),
                  "text-translate-anchor": new On(ge.paint_symbol["text-translate-anchor"])
              }),
              layout: ma
          }
            , va = function(e) {
              function t(t) {
                  e.call(this, t, ga)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.recalculate = function(t) {
                  e.prototype.recalculate.call(this, t),
                  "auto" === this.layout.get("icon-rotation-alignment") && ("point" !== this.layout.get("symbol-placement") ? this.layout._values["icon-rotation-alignment"] = "map" : this.layout._values["icon-rotation-alignment"] = "viewport"),
                  "auto" === this.layout.get("text-rotation-alignment") && ("point" !== this.layout.get("symbol-placement") ? this.layout._values["text-rotation-alignment"] = "map" : this.layout._values["text-rotation-alignment"] = "viewport"),
                  "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")),
                  "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"))
              }
              ,
              t.prototype.getValueAndResolveTokens = function(e, t) {
                  var i, n = this.layout.get(e).evaluate(t, {}), r = this._unevaluatedLayout._values[e];
                  return r.isDataDriven() || fi(r.value) ? n : (i = t.properties,
                  n.replace(/{([^{}]+)}/g, function(e, t) {
                      return t in i ? String(i[t]) : ""
                  }))
              }
              ,
              t.prototype.createBucket = function(e) {
                  return new fa(e)
              }
              ,
              t.prototype.queryRadius = function() {
                  return 0
              }
              ,
              t.prototype.queryIntersectsFeature = function() {
                  return !1
              }
              ,
              t
          }(Fn)
            , ya = {
              paint: new jn({
                  "background-color": new On(ge.paint_background["background-color"]),
                  "background-pattern": new Rn(ge.paint_background["background-pattern"]),
                  "background-opacity": new On(ge.paint_background["background-opacity"])
              })
          }
            , _a = function(e) {
              function t(t) {
                  e.call(this, t, ya)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t
          }(Fn)
            , ba = {
              paint: new jn({
                  "raster-opacity": new On(ge.paint_raster["raster-opacity"]),
                  "raster-hue-rotate": new On(ge.paint_raster["raster-hue-rotate"]),
                  "raster-brightness-min": new On(ge.paint_raster["raster-brightness-min"]),
                  "raster-brightness-max": new On(ge.paint_raster["raster-brightness-max"]),
                  "raster-saturation": new On(ge.paint_raster["raster-saturation"]),
                  "raster-contrast": new On(ge.paint_raster["raster-contrast"]),
                  "raster-resampling": new On(ge.paint_raster["raster-resampling"]),
                  "raster-fade-duration": new On(ge.paint_raster["raster-fade-duration"])
              })
          }
            , wa = function(e) {
              function t(t) {
                  e.call(this, t, ba)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t
          }(Fn)
            , xa = function(e) {
              function t(t) {
                  e.call(this, t, {}),
                  this.implementation = t
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.hasOffscreenPass = function() {
                  return void 0 !== this.implementation.prerender || "3d" === this.implementation.renderingMode
              }
              ,
              t.prototype.recalculate = function() {}
              ,
              t.prototype.updateTransitions = function() {}
              ,
              t.prototype.hasTransition = function() {}
              ,
              t.prototype.serialize = function() {}
              ,
              t.prototype.resize = function() {
                  this.viewportFrame && (this.viewportFrame.destroy(),
                  this.viewportFrame = null)
              }
              ,
              t.prototype.onAdd = function(e) {
                  this.implementation.onAdd && this.implementation.onAdd(e, e.painter.context.gl)
              }
              ,
              t.prototype.onRemove = function(e) {
                  this.implementation.onRemove && this.implementation.onRemove(e)
              }
              ,
              t
          }(Fn)
            , ka = {
              circle: xo,
              heatmap: Mo,
              hillshade: zo,
              fill: vs,
              "fill-extrusion": Ts,
              line: Ks,
              symbol: va,
              background: _a,
              raster: wa
          };
          function Sa(e) {
              for (var t = 0, i = 0, n = 0, r = e; n < r.length; n += 1) {
                  var o = r[n];
                  t += o.w * o.h,
                  i = Math.max(i, o.w)
              }
              e.sort(function(e, t) {
                  return t.h - e.h
              });
              for (var s = [{
                  x: 0,
                  y: 0,
                  w: Math.max(Math.ceil(Math.sqrt(t / .95)), i),
                  h: 1 / 0
              }], a = 0, l = 0, c = 0, u = e; c < u.length; c += 1)
                  for (var h = u[c], d = s.length - 1; d >= 0; d--) {
                      var p = s[d];
                      if (!(h.w > p.w || h.h > p.h)) {
                          if (h.x = p.x,
                          h.y = p.y,
                          l = Math.max(l, h.y + h.h),
                          a = Math.max(a, h.x + h.w),
                          h.w === p.w && h.h === p.h) {
                              var f = s.pop();
                              d < s.length && (s[d] = f)
                          } else
                              h.h === p.h ? (p.x += h.w,
                              p.w -= h.w) : h.w === p.w ? (p.y += h.h,
                              p.h -= h.h) : (s.push({
                                  x: p.x + h.w,
                                  y: p.y,
                                  w: p.w - h.w,
                                  h: h.h
                              }),
                              p.y += h.h,
                              p.h -= h.h);
                          break
                      }
                  }
              return {
                  w: a,
                  h: l,
                  fill: t / (a * l) || 0
              }
          }
          var Ea = function(e, t) {
              var i = t.pixelRatio;
              this.paddedRect = e,
              this.pixelRatio = i
          }
            , Ta = {
              tl: {
                  configurable: !0
              },
              br: {
                  configurable: !0
              },
              tlbr: {
                  configurable: !0
              },
              displaySize: {
                  configurable: !0
              }
          };
          Ta.tl.get = function() {
              return [this.paddedRect.x + 1, this.paddedRect.y + 1]
          }
          ,
          Ta.br.get = function() {
              return [this.paddedRect.x + this.paddedRect.w - 1, this.paddedRect.y + this.paddedRect.h - 1]
          }
          ,
          Ta.tlbr.get = function() {
              return this.tl.concat(this.br)
          }
          ,
          Ta.displaySize.get = function() {
              return [(this.paddedRect.w - 2) / this.pixelRatio, (this.paddedRect.h - 2) / this.pixelRatio]
          }
          ,
          Object.defineProperties(Ea.prototype, Ta);
          var Ca = function(e, t) {
              var i = {}
                , n = {}
                , r = [];
              for (var o in e) {
                  var s = e[o]
                    , a = {
                      x: 0,
                      y: 0,
                      w: s.data.width + 2,
                      h: s.data.height + 2
                  };
                  r.push(a),
                  i[o] = new Ea(a,s)
              }
              for (var l in t) {
                  var c = t[l]
                    , u = {
                      x: 0,
                      y: 0,
                      w: c.data.width + 2,
                      h: c.data.height + 2
                  };
                  r.push(u),
                  n[l] = new Ea(u,c)
              }
              var h = Sa(r)
                , d = h.w
                , p = h.h
                , f = new Ao({
                  width: d || 1,
                  height: p || 1
              });
              for (var m in e) {
                  var g = e[m]
                    , v = i[m].paddedRect;
                  Ao.copy(g.data, f, {
                      x: 0,
                      y: 0
                  }, {
                      x: v.x + 1,
                      y: v.y + 1
                  }, g.data)
              }
              for (var y in t) {
                  var _ = t[y]
                    , b = n[y].paddedRect
                    , w = b.x + 1
                    , x = b.y + 1
                    , k = _.data.width
                    , S = _.data.height;
                  Ao.copy(_.data, f, {
                      x: 0,
                      y: 0
                  }, {
                      x: w,
                      y: x
                  }, _.data),
                  Ao.copy(_.data, f, {
                      x: 0,
                      y: S - 1
                  }, {
                      x: w,
                      y: x - 1
                  }, {
                      width: k,
                      height: 1
                  }),
                  Ao.copy(_.data, f, {
                      x: 0,
                      y: 0
                  }, {
                      x: w,
                      y: x + S
                  }, {
                      width: k,
                      height: 1
                  }),
                  Ao.copy(_.data, f, {
                      x: k - 1,
                      y: 0
                  }, {
                      x: w - 1,
                      y: x
                  }, {
                      width: 1,
                      height: S
                  }),
                  Ao.copy(_.data, f, {
                      x: 0,
                      y: 0
                  }, {
                      x: w + k,
                      y: x
                  }, {
                      width: 1,
                      height: S
                  })
              }
              this.image = f,
              this.iconPositions = i,
              this.patternPositions = n
          };
          an("ImagePosition", Ea),
          an("ImageAtlas", Ca);
          var La = self.HTMLImageElement
            , Aa = self.HTMLCanvasElement
            , Pa = self.HTMLVideoElement
            , Ia = self.ImageData
            , Ma = function(e, t, i, n) {
              this.context = e,
              this.format = i,
              this.texture = e.gl.createTexture(),
              this.update(t, n)
          };
          Ma.prototype.update = function(e, t) {
              var i = e.width
                , n = e.height
                , r = !this.size || this.size[0] !== i || this.size[1] !== n
                , o = this.context
                , s = o.gl;
              this.useMipmap = Boolean(t && t.useMipmap),
              s.bindTexture(s.TEXTURE_2D, this.texture),
              o.pixelStoreUnpackFlipY.set(!1),
              o.pixelStoreUnpack.set(1),
              o.pixelStoreUnpackPremultiplyAlpha.set(this.format === s.RGBA && (!t || !1 !== t.premultiply)),
              r ? (this.size = [i, n],
              e instanceof La || e instanceof Aa || e instanceof Pa || e instanceof Ia ? s.texImage2D(s.TEXTURE_2D, 0, this.format, this.format, s.UNSIGNED_BYTE, e) : s.texImage2D(s.TEXTURE_2D, 0, this.format, i, n, 0, this.format, s.UNSIGNED_BYTE, e.data)) : e instanceof La || e instanceof Aa || e instanceof Pa || e instanceof Ia ? s.texSubImage2D(s.TEXTURE_2D, 0, 0, 0, s.RGBA, s.UNSIGNED_BYTE, e) : s.texSubImage2D(s.TEXTURE_2D, 0, 0, 0, i, n, s.RGBA, s.UNSIGNED_BYTE, e.data),
              this.useMipmap && this.isSizePowerOfTwo() && s.generateMipmap(s.TEXTURE_2D)
          }
          ,
          Ma.prototype.bind = function(e, t, i) {
              var n = this.context.gl;
              n.bindTexture(n.TEXTURE_2D, this.texture),
              i !== n.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (i = n.LINEAR),
              e !== this.filter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, e),
              n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, i || e),
              this.filter = e),
              t !== this.wrap && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, t),
              n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, t),
              this.wrap = t)
          }
          ,
          Ma.prototype.isSizePowerOfTwo = function() {
              return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0
          }
          ,
          Ma.prototype.destroy = function() {
              this.context.gl.deleteTexture(this.texture),
              this.texture = null
          }
          ;
          var Oa = function(e, t, i, n, r) {
              var o, s, a = 8 * r - n - 1, l = (1 << a) - 1, c = l >> 1, u = -7, h = i ? r - 1 : 0, d = i ? -1 : 1, p = e[t + h];
              for (h += d,
              o = p & (1 << -u) - 1,
              p >>= -u,
              u += a; u > 0; o = 256 * o + e[t + h],
              h += d,
              u -= 8)
                  ;
              for (s = o & (1 << -u) - 1,
              o >>= -u,
              u += n; u > 0; s = 256 * s + e[t + h],
              h += d,
              u -= 8)
                  ;
              if (0 === o)
                  o = 1 - c;
              else {
                  if (o === l)
                      return s ? NaN : 1 / 0 * (p ? -1 : 1);
                  s += Math.pow(2, n),
                  o -= c
              }
              return (p ? -1 : 1) * s * Math.pow(2, o - n)
          }
            , za = function(e, t, i, n, r, o) {
              var s, a, l, c = 8 * o - r - 1, u = (1 << c) - 1, h = u >> 1, d = 23 === r ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = n ? 0 : o - 1, f = n ? 1 : -1, m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
              for (t = Math.abs(t),
              isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0,
              s = u) : (s = Math.floor(Math.log(t) / Math.LN2),
              t * (l = Math.pow(2, -s)) < 1 && (s--,
              l *= 2),
              (t += s + h >= 1 ? d / l : d * Math.pow(2, 1 - h)) * l >= 2 && (s++,
              l /= 2),
              s + h >= u ? (a = 0,
              s = u) : s + h >= 1 ? (a = (t * l - 1) * Math.pow(2, r),
              s += h) : (a = t * Math.pow(2, h - 1) * Math.pow(2, r),
              s = 0)); r >= 8; e[i + p] = 255 & a,
              p += f,
              a /= 256,
              r -= 8)
                  ;
              for (s = s << r | a,
              c += r; c > 0; e[i + p] = 255 & s,
              p += f,
              s /= 256,
              c -= 8)
                  ;
              e[i + p - f] |= 128 * m
          }
            , Da = Ra;
          function Ra(e) {
              this.buf = ArrayBuffer.isView && ArrayBuffer.isView(e) ? e : new Uint8Array(e || 0),
              this.pos = 0,
              this.type = 0,
              this.length = this.buf.length
          }
          function Ba(e) {
              return e.type === Ra.Bytes ? e.readVarint() + e.pos : e.pos + 1
          }
          function ja(e, t, i) {
              return i ? 4294967296 * t + (e >>> 0) : 4294967296 * (t >>> 0) + (e >>> 0)
          }
          function Fa(e, t, i) {
              var n = t <= 16383 ? 1 : t <= 2097151 ? 2 : t <= 268435455 ? 3 : Math.ceil(Math.log(t) / (7 * Math.LN2));
              i.realloc(n);
              for (var r = i.pos - 1; r >= e; r--)
                  i.buf[r + n] = i.buf[r]
          }
          function Na(e, t) {
              for (var i = 0; i < e.length; i++)
                  t.writeVarint(e[i])
          }
          function Ua(e, t) {
              for (var i = 0; i < e.length; i++)
                  t.writeSVarint(e[i])
          }
          function qa(e, t) {
              for (var i = 0; i < e.length; i++)
                  t.writeFloat(e[i])
          }
          function Ha(e, t) {
              for (var i = 0; i < e.length; i++)
                  t.writeDouble(e[i])
          }
          function Va(e, t) {
              for (var i = 0; i < e.length; i++)
                  t.writeBoolean(e[i])
          }
          function Wa(e, t) {
              for (var i = 0; i < e.length; i++)
                  t.writeFixed32(e[i])
          }
          function $a(e, t) {
              for (var i = 0; i < e.length; i++)
                  t.writeSFixed32(e[i])
          }
          function Ga(e, t) {
              for (var i = 0; i < e.length; i++)
                  t.writeFixed64(e[i])
          }
          function Xa(e, t) {
              for (var i = 0; i < e.length; i++)
                  t.writeSFixed64(e[i])
          }
          function Za(e, t) {
              return (e[t] | e[t + 1] << 8 | e[t + 2] << 16) + 16777216 * e[t + 3]
          }
          function Ya(e, t, i) {
              e[i] = t,
              e[i + 1] = t >>> 8,
              e[i + 2] = t >>> 16,
              e[i + 3] = t >>> 24
          }
          function Ka(e, t) {
              return (e[t] | e[t + 1] << 8 | e[t + 2] << 16) + (e[t + 3] << 24)
          }
          Ra.Varint = 0,
          Ra.Fixed64 = 1,
          Ra.Bytes = 2,
          Ra.Fixed32 = 5,
          Ra.prototype = {
              destroy: function() {
                  this.buf = null
              },
              readFields: function(e, t, i) {
                  for (i = i || this.length; this.pos < i; ) {
                      var n = this.readVarint()
                        , r = n >> 3
                        , o = this.pos;
                      this.type = 7 & n,
                      e(r, t, this),
                      this.pos === o && this.skip(n)
                  }
                  return t
              },
              readMessage: function(e, t) {
                  return this.readFields(e, t, this.readVarint() + this.pos)
              },
              readFixed32: function() {
                  var e = Za(this.buf, this.pos);
                  return this.pos += 4,
                  e
              },
              readSFixed32: function() {
                  var e = Ka(this.buf, this.pos);
                  return this.pos += 4,
                  e
              },
              readFixed64: function() {
                  var e = Za(this.buf, this.pos) + 4294967296 * Za(this.buf, this.pos + 4);
                  return this.pos += 8,
                  e
              },
              readSFixed64: function() {
                  var e = Za(this.buf, this.pos) + 4294967296 * Ka(this.buf, this.pos + 4);
                  return this.pos += 8,
                  e
              },
              readFloat: function() {
                  var e = Oa(this.buf, this.pos, !0, 23, 4);
                  return this.pos += 4,
                  e
              },
              readDouble: function() {
                  var e = Oa(this.buf, this.pos, !0, 52, 8);
                  return this.pos += 8,
                  e
              },
              readVarint: function(e) {
                  var t, i, n = this.buf;
                  return t = 127 & (i = n[this.pos++]),
                  i < 128 ? t : (t |= (127 & (i = n[this.pos++])) << 7,
                  i < 128 ? t : (t |= (127 & (i = n[this.pos++])) << 14,
                  i < 128 ? t : (t |= (127 & (i = n[this.pos++])) << 21,
                  i < 128 ? t : function(e, t, i) {
                      var n, r, o = i.buf;
                      if (n = (112 & (r = o[i.pos++])) >> 4,
                      r < 128)
                          return ja(e, n, t);
                      if (n |= (127 & (r = o[i.pos++])) << 3,
                      r < 128)
                          return ja(e, n, t);
                      if (n |= (127 & (r = o[i.pos++])) << 10,
                      r < 128)
                          return ja(e, n, t);
                      if (n |= (127 & (r = o[i.pos++])) << 17,
                      r < 128)
                          return ja(e, n, t);
                      if (n |= (127 & (r = o[i.pos++])) << 24,
                      r < 128)
                          return ja(e, n, t);
                      if (n |= (1 & (r = o[i.pos++])) << 31,
                      r < 128)
                          return ja(e, n, t);
                      throw new Error("Expected varint not more than 10 bytes")
                  }(t |= (15 & (i = n[this.pos])) << 28, e, this))))
              },
              readVarint64: function() {
                  return this.readVarint(!0)
              },
              readSVarint: function() {
                  var e = this.readVarint();
                  return e % 2 == 1 ? (e + 1) / -2 : e / 2
              },
              readBoolean: function() {
                  return Boolean(this.readVarint())
              },
              readString: function() {
                  var e = this.readVarint() + this.pos
                    , t = function(e, t, i) {
                      for (var n = "", r = t; r < i; ) {
                          var o, s, a, l = e[r], c = null, u = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                          if (r + u > i)
                              break;
                          1 === u ? l < 128 && (c = l) : 2 === u ? 128 == (192 & (o = e[r + 1])) && (c = (31 & l) << 6 | 63 & o) <= 127 && (c = null) : 3 === u ? (o = e[r + 1],
                          s = e[r + 2],
                          128 == (192 & o) && 128 == (192 & s) && ((c = (15 & l) << 12 | (63 & o) << 6 | 63 & s) <= 2047 || c >= 55296 && c <= 57343) && (c = null)) : 4 === u && (o = e[r + 1],
                          s = e[r + 2],
                          a = e[r + 3],
                          128 == (192 & o) && 128 == (192 & s) && 128 == (192 & a) && ((c = (15 & l) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & a) <= 65535 || c >= 1114112) && (c = null)),
                          null === c ? (c = 65533,
                          u = 1) : c > 65535 && (c -= 65536,
                          n += String.fromCharCode(c >>> 10 & 1023 | 55296),
                          c = 56320 | 1023 & c),
                          n += String.fromCharCode(c),
                          r += u
                      }
                      return n
                  }(this.buf, this.pos, e);
                  return this.pos = e,
                  t
              },
              readBytes: function() {
                  var e = this.readVarint() + this.pos
                    , t = this.buf.subarray(this.pos, e);
                  return this.pos = e,
                  t
              },
              readPackedVarint: function(e, t) {
                  var i = Ba(this);
                  for (e = e || []; this.pos < i; )
                      e.push(this.readVarint(t));
                  return e
              },
              readPackedSVarint: function(e) {
                  var t = Ba(this);
                  for (e = e || []; this.pos < t; )
                      e.push(this.readSVarint());
                  return e
              },
              readPackedBoolean: function(e) {
                  var t = Ba(this);
                  for (e = e || []; this.pos < t; )
                      e.push(this.readBoolean());
                  return e
              },
              readPackedFloat: function(e) {
                  var t = Ba(this);
                  for (e = e || []; this.pos < t; )
                      e.push(this.readFloat());
                  return e
              },
              readPackedDouble: function(e) {
                  var t = Ba(this);
                  for (e = e || []; this.pos < t; )
                      e.push(this.readDouble());
                  return e
              },
              readPackedFixed32: function(e) {
                  var t = Ba(this);
                  for (e = e || []; this.pos < t; )
                      e.push(this.readFixed32());
                  return e
              },
              readPackedSFixed32: function(e) {
                  var t = Ba(this);
                  for (e = e || []; this.pos < t; )
                      e.push(this.readSFixed32());
                  return e
              },
              readPackedFixed64: function(e) {
                  var t = Ba(this);
                  for (e = e || []; this.pos < t; )
                      e.push(this.readFixed64());
                  return e
              },
              readPackedSFixed64: function(e) {
                  var t = Ba(this);
                  for (e = e || []; this.pos < t; )
                      e.push(this.readSFixed64());
                  return e
              },
              skip: function(e) {
                  var t = 7 & e;
                  if (t === Ra.Varint)
                      for (; this.buf[this.pos++] > 127; )
                          ;
                  else if (t === Ra.Bytes)
                      this.pos = this.readVarint() + this.pos;
                  else if (t === Ra.Fixed32)
                      this.pos += 4;
                  else {
                      if (t !== Ra.Fixed64)
                          throw new Error("Unimplemented type: " + t);
                      this.pos += 8
                  }
              },
              writeTag: function(e, t) {
                  this.writeVarint(e << 3 | t)
              },
              realloc: function(e) {
                  for (var t = this.length || 16; t < this.pos + e; )
                      t *= 2;
                  if (t !== this.length) {
                      var i = new Uint8Array(t);
                      i.set(this.buf),
                      this.buf = i,
                      this.length = t
                  }
              },
              finish: function() {
                  return this.length = this.pos,
                  this.pos = 0,
                  this.buf.subarray(0, this.length)
              },
              writeFixed32: function(e) {
                  this.realloc(4),
                  Ya(this.buf, e, this.pos),
                  this.pos += 4
              },
              writeSFixed32: function(e) {
                  this.realloc(4),
                  Ya(this.buf, e, this.pos),
                  this.pos += 4
              },
              writeFixed64: function(e) {
                  this.realloc(8),
                  Ya(this.buf, -1 & e, this.pos),
                  Ya(this.buf, Math.floor(e * (1 / 4294967296)), this.pos + 4),
                  this.pos += 8
              },
              writeSFixed64: function(e) {
                  this.realloc(8),
                  Ya(this.buf, -1 & e, this.pos),
                  Ya(this.buf, Math.floor(e * (1 / 4294967296)), this.pos + 4),
                  this.pos += 8
              },
              writeVarint: function(e) {
                  (e = +e || 0) > 268435455 || e < 0 ? function(e, t) {
                      var i, n;
                      if (e >= 0 ? (i = e % 4294967296 | 0,
                      n = e / 4294967296 | 0) : (n = ~(-e / 4294967296),
                      4294967295 ^ (i = ~(-e % 4294967296)) ? i = i + 1 | 0 : (i = 0,
                      n = n + 1 | 0)),
                      e >= 0x10000000000000000 || e < -0x10000000000000000)
                          throw new Error("Given varint doesn't fit into 10 bytes");
                      t.realloc(10),
                      function(e, t, i) {
                          i.buf[i.pos++] = 127 & e | 128,
                          e >>>= 7,
                          i.buf[i.pos++] = 127 & e | 128,
                          e >>>= 7,
                          i.buf[i.pos++] = 127 & e | 128,
                          e >>>= 7,
                          i.buf[i.pos++] = 127 & e | 128,
                          e >>>= 7,
                          i.buf[i.pos] = 127 & e
                      }(i, 0, t),
                      function(e, t) {
                          var i = (7 & e) << 4;
                          t.buf[t.pos++] |= i | ((e >>>= 3) ? 128 : 0),
                          e && (t.buf[t.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0),
                          e && (t.buf[t.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0),
                          e && (t.buf[t.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0),
                          e && (t.buf[t.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0),
                          e && (t.buf[t.pos++] = 127 & e)))))
                      }(n, t)
                  }(e, this) : (this.realloc(4),
                  this.buf[this.pos++] = 127 & e | (e > 127 ? 128 : 0),
                  e <= 127 || (this.buf[this.pos++] = 127 & (e >>>= 7) | (e > 127 ? 128 : 0),
                  e <= 127 || (this.buf[this.pos++] = 127 & (e >>>= 7) | (e > 127 ? 128 : 0),
                  e <= 127 || (this.buf[this.pos++] = e >>> 7 & 127))))
              },
              writeSVarint: function(e) {
                  this.writeVarint(e < 0 ? 2 * -e - 1 : 2 * e)
              },
              writeBoolean: function(e) {
                  this.writeVarint(Boolean(e))
              },
              writeString: function(e) {
                  e = String(e),
                  this.realloc(4 * e.length),
                  this.pos++;
                  var t = this.pos;
                  this.pos = function(e, t, i) {
                      for (var n, r, o = 0; o < t.length; o++) {
                          if ((n = t.charCodeAt(o)) > 55295 && n < 57344) {
                              if (!r) {
                                  n > 56319 || o + 1 === t.length ? (e[i++] = 239,
                                  e[i++] = 191,
                                  e[i++] = 189) : r = n;
                                  continue
                              }
                              if (n < 56320) {
                                  e[i++] = 239,
                                  e[i++] = 191,
                                  e[i++] = 189,
                                  r = n;
                                  continue
                              }
                              n = r - 55296 << 10 | n - 56320 | 65536,
                              r = null
                          } else
                              r && (e[i++] = 239,
                              e[i++] = 191,
                              e[i++] = 189,
                              r = null);
                          n < 128 ? e[i++] = n : (n < 2048 ? e[i++] = n >> 6 | 192 : (n < 65536 ? e[i++] = n >> 12 | 224 : (e[i++] = n >> 18 | 240,
                          e[i++] = n >> 12 & 63 | 128),
                          e[i++] = n >> 6 & 63 | 128),
                          e[i++] = 63 & n | 128)
                      }
                      return i
                  }(this.buf, e, this.pos);
                  var i = this.pos - t;
                  i >= 128 && Fa(t, i, this),
                  this.pos = t - 1,
                  this.writeVarint(i),
                  this.pos += i
              },
              writeFloat: function(e) {
                  this.realloc(4),
                  za(this.buf, e, this.pos, !0, 23, 4),
                  this.pos += 4
              },
              writeDouble: function(e) {
                  this.realloc(8),
                  za(this.buf, e, this.pos, !0, 52, 8),
                  this.pos += 8
              },
              writeBytes: function(e) {
                  var t = e.length;
                  this.writeVarint(t),
                  this.realloc(t);
                  for (var i = 0; i < t; i++)
                      this.buf[this.pos++] = e[i]
              },
              writeRawMessage: function(e, t) {
                  this.pos++;
                  var i = this.pos;
                  e(t, this);
                  var n = this.pos - i;
                  n >= 128 && Fa(i, n, this),
                  this.pos = i - 1,
                  this.writeVarint(n),
                  this.pos += n
              },
              writeMessage: function(e, t, i) {
                  this.writeTag(e, Ra.Bytes),
                  this.writeRawMessage(t, i)
              },
              writePackedVarint: function(e, t) {
                  this.writeMessage(e, Na, t)
              },
              writePackedSVarint: function(e, t) {
                  this.writeMessage(e, Ua, t)
              },
              writePackedBoolean: function(e, t) {
                  this.writeMessage(e, Va, t)
              },
              writePackedFloat: function(e, t) {
                  this.writeMessage(e, qa, t)
              },
              writePackedDouble: function(e, t) {
                  this.writeMessage(e, Ha, t)
              },
              writePackedFixed32: function(e, t) {
                  this.writeMessage(e, Wa, t)
              },
              writePackedSFixed32: function(e, t) {
                  this.writeMessage(e, $a, t)
              },
              writePackedFixed64: function(e, t) {
                  this.writeMessage(e, Ga, t)
              },
              writePackedSFixed64: function(e, t) {
                  this.writeMessage(e, Xa, t)
              },
              writeBytesField: function(e, t) {
                  this.writeTag(e, Ra.Bytes),
                  this.writeBytes(t)
              },
              writeFixed32Field: function(e, t) {
                  this.writeTag(e, Ra.Fixed32),
                  this.writeFixed32(t)
              },
              writeSFixed32Field: function(e, t) {
                  this.writeTag(e, Ra.Fixed32),
                  this.writeSFixed32(t)
              },
              writeFixed64Field: function(e, t) {
                  this.writeTag(e, Ra.Fixed64),
                  this.writeFixed64(t)
              },
              writeSFixed64Field: function(e, t) {
                  this.writeTag(e, Ra.Fixed64),
                  this.writeSFixed64(t)
              },
              writeVarintField: function(e, t) {
                  this.writeTag(e, Ra.Varint),
                  this.writeVarint(t)
              },
              writeSVarintField: function(e, t) {
                  this.writeTag(e, Ra.Varint),
                  this.writeSVarint(t)
              },
              writeStringField: function(e, t) {
                  this.writeTag(e, Ra.Bytes),
                  this.writeString(t)
              },
              writeFloatField: function(e, t) {
                  this.writeTag(e, Ra.Fixed32),
                  this.writeFloat(t)
              },
              writeDoubleField: function(e, t) {
                  this.writeTag(e, Ra.Fixed64),
                  this.writeDouble(t)
              },
              writeBooleanField: function(e, t) {
                  this.writeVarintField(e, Boolean(t))
              }
          };
          var Ja = 3;
          function Qa(e, t, i) {
              1 === e && i.readMessage(el, t)
          }
          function el(e, t, i) {
              if (3 === e) {
                  var n = i.readMessage(tl, {})
                    , r = n.id
                    , o = n.bitmap
                    , s = n.width
                    , a = n.height
                    , l = n.left
                    , c = n.top
                    , u = n.advance;
                  t.push({
                      id: r,
                      bitmap: new Lo({
                          width: s + 2 * Ja,
                          height: a + 2 * Ja
                      },o),
                      metrics: {
                          width: s,
                          height: a,
                          left: l,
                          top: c,
                          advance: u
                      }
                  })
              }
          }
          function tl(e, t, i) {
              1 === e ? t.id = i.readVarint() : 2 === e ? t.bitmap = i.readBytes() : 3 === e ? t.width = i.readVarint() : 4 === e ? t.height = i.readVarint() : 5 === e ? t.left = i.readSVarint() : 6 === e ? t.top = i.readSVarint() : 7 === e && (t.advance = i.readVarint())
          }
          var il = Ja
            , nl = function(e, t, i) {
              this.target = e,
              this.parent = t,
              this.mapId = i,
              this.callbacks = {},
              this.callbackID = 0,
              g(["receive"], this),
              this.target.addEventListener("message", this.receive, !1)
          };
          function rl(e, t, i) {
              var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, i);
              return [e * n - 2 * Math.PI * 6378137 / 2, t * n - 2 * Math.PI * 6378137 / 2]
          }
          nl.prototype.send = function(e, t, i, n) {
              var r = this
                , o = i ? this.mapId + ":" + this.callbackID++ : null;
              i && (this.callbacks[o] = i);
              var s = [];
              if (this.target.postMessage({
                  targetMapId: n,
                  sourceMapId: this.mapId,
                  type: e,
                  id: String(o),
                  data: cn(t, s)
              }, s),
              i)
                  return {
                      cancel: function() {
                          return r.target.postMessage({
                              targetMapId: n,
                              sourceMapId: r.mapId,
                              type: "<cancel>",
                              id: String(o)
                          })
                      }
                  }
          }
          ,
          nl.prototype.receive = function(e) {
              var t, i = this, n = e.data, r = n.id;
              if (!n.targetMapId || this.mapId === n.targetMapId) {
                  var o = function(e, t) {
                      delete i.callbacks[r];
                      var n = [];
                      i.target.postMessage({
                          sourceMapId: i.mapId,
                          type: "<response>",
                          id: String(r),
                          error: e ? cn(e) : null,
                          data: cn(t, n)
                      }, n)
                  };
                  if ("<response>" === n.type || "<cancel>" === n.type)
                      t = this.callbacks[n.id],
                      delete this.callbacks[n.id],
                      t && n.error ? t(un(n.error)) : t && t(null, un(n.data));
                  else if (void 0 !== n.id && this.parent[n.type]) {
                      this.callbacks[n.id] = null;
                      var s = this.parent[n.type](n.sourceMapId, un(n.data), o);
                      s && null === this.callbacks[n.id] && (this.callbacks[n.id] = s)
                  } else if (void 0 !== n.id && this.parent.getWorkerSource) {
                      var a = n.type.split(".")
                        , l = un(n.data);
                      this.parent.getWorkerSource(n.sourceMapId, a[0], l.source)[a[1]](l, o)
                  } else
                      this.parent[n.type](un(n.data))
              }
          }
          ,
          nl.prototype.remove = function() {
              this.target.removeEventListener("message", this.receive, !1)
          }
          ;
          var ol = function(e, t) {
              e && (t ? this.setSouthWest(e).setNorthEast(t) : 4 === e.length ? this.setSouthWest([e[0], e[1]]).setNorthEast([e[2], e[3]]) : this.setSouthWest(e[0]).setNorthEast(e[1]))
          };
          ol.prototype.setNorthEast = function(e) {
              return this._ne = e instanceof sl ? new sl(e.lng,e.lat) : sl.convert(e),
              this
          }
          ,
          ol.prototype.setSouthWest = function(e) {
              return this._sw = e instanceof sl ? new sl(e.lng,e.lat) : sl.convert(e),
              this
          }
          ,
          ol.prototype.extend = function(e) {
              var t, i, n = this._sw, r = this._ne;
              if (e instanceof sl)
                  t = e,
                  i = e;
              else {
                  if (!(e instanceof ol))
                      return Array.isArray(e) ? e.every(Array.isArray) ? this.extend(ol.convert(e)) : this.extend(sl.convert(e)) : this;
                  if (t = e._sw,
                  i = e._ne,
                  !t || !i)
                      return this
              }
              return n || r ? (n.lng = Math.min(t.lng, n.lng),
              n.lat = Math.min(t.lat, n.lat),
              r.lng = Math.max(i.lng, r.lng),
              r.lat = Math.max(i.lat, r.lat)) : (this._sw = new sl(t.lng,t.lat),
              this._ne = new sl(i.lng,i.lat)),
              this
          }
          ,
          ol.prototype.getCenter = function() {
              return new sl((this._sw.lng + this._ne.lng) / 2,(this._sw.lat + this._ne.lat) / 2)
          }
          ,
          ol.prototype.getSouthWest = function() {
              return this._sw
          }
          ,
          ol.prototype.getNorthEast = function() {
              return this._ne
          }
          ,
          ol.prototype.getNorthWest = function() {
              return new sl(this.getWest(),this.getNorth())
          }
          ,
          ol.prototype.getSouthEast = function() {
              return new sl(this.getEast(),this.getSouth())
          }
          ,
          ol.prototype.getWest = function() {
              return this._sw.lng
          }
          ,
          ol.prototype.getSouth = function() {
              return this._sw.lat
          }
          ,
          ol.prototype.getEast = function() {
              return this._ne.lng
          }
          ,
          ol.prototype.getNorth = function() {
              return this._ne.lat
          }
          ,
          ol.prototype.toArray = function() {
              return [this._sw.toArray(), this._ne.toArray()]
          }
          ,
          ol.prototype.toString = function() {
              return "LngLatBounds(" + this._sw.toString() + ", " + this._ne.toString() + ")"
          }
          ,
          ol.prototype.isEmpty = function() {
              return !(this._sw && this._ne)
          }
          ,
          ol.convert = function(e) {
              return !e || e instanceof ol ? e : new ol(e)
          }
          ;
          var sl = function(e, t) {
              if (isNaN(e) || isNaN(t))
                  throw new Error("Invalid LngLat object: (" + e + ", " + t + ")");
              if (this.lng = +e,
              this.lat = +t,
              this.lat > 90 || this.lat < -90)
                  throw new Error("Invalid LngLat latitude value: must be between -90 and 90")
          };
          function al(e) {
              return 2 * Math.PI * 6378137 * Math.cos(e * Math.PI / 180)
          }
          function ll(e) {
              return (180 + e) / 360
          }
          function cl(e) {
              return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e * Math.PI / 360))) / 360
          }
          function ul(e, t) {
              return e / al(t)
          }
          function hl(e) {
              var t = 180 - 360 * e;
              return 360 / Math.PI * Math.atan(Math.exp(t * Math.PI / 180)) - 90
          }
          sl.prototype.wrap = function() {
              return new sl(u(this.lng, -180, 180),this.lat)
          }
          ,
          sl.prototype.toArray = function() {
              return [this.lng, this.lat]
          }
          ,
          sl.prototype.toString = function() {
              return "LngLat(" + this.lng + ", " + this.lat + ")"
          }
          ,
          sl.prototype.toBounds = function(e) {
              void 0 === e && (e = 0);
              var t = 360 * e / 40075017
                , i = t / Math.cos(Math.PI / 180 * this.lat);
              return new ol(new sl(this.lng - i,this.lat - t),new sl(this.lng + i,this.lat + t))
          }
          ,
          sl.convert = function(e) {
              if (e instanceof sl)
                  return e;
              if (Array.isArray(e) && (2 === e.length || 3 === e.length))
                  return new sl(Number(e[0]),Number(e[1]));
              if (!Array.isArray(e) && "object" == typeof e && null !== e)
                  return new sl(Number("lng"in e ? e.lng : e.lon),Number(e.lat));
              throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]")
          }
          ;
          var dl = function(e, t, i) {
              void 0 === i && (i = 0),
              this.x = +e,
              this.y = +t,
              this.z = +i
          };
          dl.fromLngLat = function(e, t) {
              void 0 === t && (t = 0);
              var i = sl.convert(e);
              return new dl(ll(i.lng),cl(i.lat),ul(t, i.lat))
          }
          ,
          dl.prototype.toLngLat = function() {
              return new sl(360 * this.x - 180,hl(this.y))
          }
          ,
          dl.prototype.toAltitude = function() {
              return this.z * al(hl(this.y))
          }
          ;
          var pl = function(e, t, i) {
              this.z = e,
              this.x = t,
              this.y = i,
              this.key = gl(0, e, t, i)
          };
          pl.prototype.equals = function(e) {
              return this.z === e.z && this.x === e.x && this.y === e.y
          }
          ,
          pl.prototype.url = function(e, t) {
              var i, n, r, o, s, a = (i = this.x,
              n = this.y,
              r = this.z,
              o = rl(256 * i, 256 * (n = Math.pow(2, r) - n - 1), r),
              s = rl(256 * (i + 1), 256 * (n + 1), r),
              o[0] + "," + o[1] + "," + s[0] + "," + s[1]), l = function(e, t, i) {
                  for (var n, r = "", o = e; o > 0; o--)
                      r += (t & (n = 1 << o - 1) ? 1 : 0) + (i & n ? 2 : 0);
                  return r
              }(this.z, this.x, this.y);
              return e[(this.x + this.y) % e.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace("{z}", String(this.z)).replace("{x}", String(this.x)).replace("{y}", String("tms" === t ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", l).replace("{bbox-epsg-3857}", a)
          }
          ,
          pl.prototype.getTilePoint = function(e) {
              var t = Math.pow(2, this.z);
              return new r((e.x * t - this.x) * Zr,(e.y * t - this.y) * Zr)
          }
          ;
          var fl = function(e, t) {
              this.wrap = e,
              this.canonical = t,
              this.key = gl(e, t.z, t.x, t.y)
          }
            , ml = function(e, t, i, n, r) {
              this.overscaledZ = e,
              this.wrap = t,
              this.canonical = new pl(i,+n,+r),
              this.key = gl(t, e, n, r)
          };
          function gl(e, t, i, n) {
              (e *= 2) < 0 && (e = -1 * e - 1);
              var r = 1 << t;
              return 32 * (r * r * e + r * n + i) + t
          }
          ml.prototype.equals = function(e) {
              return this.overscaledZ === e.overscaledZ && this.wrap === e.wrap && this.canonical.equals(e.canonical)
          }
          ,
          ml.prototype.scaledTo = function(e) {
              var t = this.canonical.z - e;
              return e > this.canonical.z ? new ml(e,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y) : new ml(e,this.wrap,e,this.canonical.x >> t,this.canonical.y >> t)
          }
          ,
          ml.prototype.isChildOf = function(e) {
              if (e.wrap !== this.wrap)
                  return !1;
              var t = this.canonical.z - e.canonical.z;
              return 0 === e.overscaledZ || e.overscaledZ < this.overscaledZ && e.canonical.x === this.canonical.x >> t && e.canonical.y === this.canonical.y >> t
          }
          ,
          ml.prototype.children = function(e) {
              if (this.overscaledZ >= e)
                  return [new ml(this.overscaledZ + 1,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y)];
              var t = this.canonical.z + 1
                , i = 2 * this.canonical.x
                , n = 2 * this.canonical.y;
              return [new ml(t,this.wrap,t,i,n), new ml(t,this.wrap,t,i + 1,n), new ml(t,this.wrap,t,i,n + 1), new ml(t,this.wrap,t,i + 1,n + 1)]
          }
          ,
          ml.prototype.isLessThan = function(e) {
              return this.wrap < e.wrap || !(this.wrap > e.wrap) && (this.overscaledZ < e.overscaledZ || !(this.overscaledZ > e.overscaledZ) && (this.canonical.x < e.canonical.x || !(this.canonical.x > e.canonical.x) && this.canonical.y < e.canonical.y))
          }
          ,
          ml.prototype.wrapped = function() {
              return new ml(this.overscaledZ,0,this.canonical.z,this.canonical.x,this.canonical.y)
          }
          ,
          ml.prototype.unwrapTo = function(e) {
              return new ml(this.overscaledZ,e,this.canonical.z,this.canonical.x,this.canonical.y)
          }
          ,
          ml.prototype.overscaleFactor = function() {
              return Math.pow(2, this.overscaledZ - this.canonical.z)
          }
          ,
          ml.prototype.toUnwrapped = function() {
              return new fl(this.wrap,this.canonical)
          }
          ,
          ml.prototype.toString = function() {
              return this.overscaledZ + "/" + this.canonical.x + "/" + this.canonical.y
          }
          ,
          ml.prototype.getTilePoint = function(e) {
              return this.canonical.getTilePoint(new dl(e.x - this.wrap,e.y))
          }
          ,
          an("CanonicalTileID", pl),
          an("OverscaledTileID", ml, {
              omit: ["posMatrix"]
          });
          var vl = function(e, t, i) {
              if (this.uid = e,
              t.height !== t.width)
                  throw new RangeError("DEM tiles must be square");
              if (i && "mapbox" !== i && "terrarium" !== i)
                  return x('"' + i + '" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');
              var n = this.dim = t.height;
              this.stride = this.dim + 2,
              this.data = new Int32Array(this.stride * this.stride);
              for (var r = t.data, o = "terrarium" === i ? this._unpackTerrarium : this._unpackMapbox, s = 0; s < n; s++)
                  for (var a = 0; a < n; a++) {
                      var l = 4 * (s * n + a);
                      this.set(a, s, o(r[l], r[l + 1], r[l + 2]))
                  }
              for (var c = 0; c < n; c++)
                  this.set(-1, c, this.get(0, c)),
                  this.set(n, c, this.get(n - 1, c)),
                  this.set(c, -1, this.get(c, 0)),
                  this.set(c, n, this.get(c, n - 1));
              this.set(-1, -1, this.get(0, 0)),
              this.set(n, -1, this.get(n - 1, 0)),
              this.set(-1, n, this.get(0, n - 1)),
              this.set(n, n, this.get(n - 1, n - 1))
          };
          vl.prototype.set = function(e, t, i) {
              this.data[this._idx(e, t)] = i + 65536
          }
          ,
          vl.prototype.get = function(e, t) {
              return this.data[this._idx(e, t)] - 65536
          }
          ,
          vl.prototype._idx = function(e, t) {
              if (e < -1 || e >= this.dim + 1 || t < -1 || t >= this.dim + 1)
                  throw new RangeError("out of range source coordinates for DEM data");
              return (t + 1) * this.stride + (e + 1)
          }
          ,
          vl.prototype._unpackMapbox = function(e, t, i) {
              return (256 * e * 256 + 256 * t + i) / 10 - 1e4
          }
          ,
          vl.prototype._unpackTerrarium = function(e, t, i) {
              return 256 * e + t + i / 256 - 32768
          }
          ,
          vl.prototype.getPixels = function() {
              return new Ao({
                  width: this.stride,
                  height: this.stride
              },new Uint8Array(this.data.buffer))
          }
          ,
          vl.prototype.backfillBorder = function(e, t, i) {
              if (this.dim !== e.dim)
                  throw new Error("dem dimension mismatch");
              var n = t * this.dim
                , r = t * this.dim + this.dim
                , o = i * this.dim
                , s = i * this.dim + this.dim;
              switch (t) {
              case -1:
                  n = r - 1;
                  break;
              case 1:
                  r = n + 1
              }
              switch (i) {
              case -1:
                  o = s - 1;
                  break;
              case 1:
                  s = o + 1
              }
              for (var a = -t * this.dim, l = -i * this.dim, c = o; c < s; c++)
                  for (var u = n; u < r; u++)
                      this.set(u, c, e.get(u + a, c + l))
          }
          ,
          an("DEMData", vl);
          var yl = Hn([{
              name: "a_pos",
              type: "Int16",
              components: 2
          }, {
              name: "a_texture_pos",
              type: "Int16",
              components: 2
          }])
            , _l = function(e) {
              this._stringToNumber = {},
              this._numberToString = [];
              for (var t = 0; t < e.length; t++) {
                  var i = e[t];
                  this._stringToNumber[i] = t,
                  this._numberToString[t] = i
              }
          };
          _l.prototype.encode = function(e) {
              return this._stringToNumber[e]
          }
          ,
          _l.prototype.decode = function(e) {
              return this._numberToString[e]
          }
          ;
          var bl = function(e, t, i, n) {
              this.type = "Feature",
              this._vectorTileFeature = e,
              e._z = t,
              e._x = i,
              e._y = n,
              this.properties = e.properties,
              null != e.id && (this.id = e.id)
          }
            , wl = {
              geometry: {
                  configurable: !0
              }
          };
          wl.geometry.get = function() {
              return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry),
              this._geometry
          }
          ,
          wl.geometry.set = function(e) {
              this._geometry = e
          }
          ,
          bl.prototype.toJSON = function() {
              var e = {
                  geometry: this.geometry
              };
              for (var t in this)
                  "_geometry" !== t && "_vectorTileFeature" !== t && (e[t] = this[t]);
              return e
          }
          ,
          Object.defineProperties(bl.prototype, wl);
          var xl = function() {
              this.state = {},
              this.stateChanges = {},
              this.deletedStates = {}
          };
          xl.prototype.updateState = function(e, t, i) {
              var n = String(t);
              if (this.stateChanges[e] = this.stateChanges[e] || {},
              this.stateChanges[e][n] = this.stateChanges[e][n] || {},
              h(this.stateChanges[e][n], i),
              null === this.deletedStates[e])
                  for (var r in this.deletedStates[e] = {},
                  this.state[e])
                      r !== n && (this.deletedStates[e][r] = null);
              else if (this.deletedStates[e] && null === this.deletedStates[e][n])
                  for (var o in this.deletedStates[e][n] = {},
                  this.state[e][n])
                      i[o] || (this.deletedStates[e][n][o] = null);
              else
                  for (var s in i)
                      this.deletedStates[e] && this.deletedStates[e][n] && null === this.deletedStates[e][n][s] && delete this.deletedStates[e][n][s]
          }
          ,
          xl.prototype.removeFeatureState = function(e, t, i) {
              if (null !== this.deletedStates[e]) {
                  var n = String(t);
                  if (this.deletedStates[e] = this.deletedStates[e] || {},
                  i && t)
                      null !== this.deletedStates[e][n] && (this.deletedStates[e][n] = this.deletedStates[e][n] || {},
                      this.deletedStates[e][n][i] = null);
                  else if (t)
                      if (this.stateChanges[e] && this.stateChanges[e][n])
                          for (i in this.deletedStates[e][n] = {},
                          this.stateChanges[e][n])
                              this.deletedStates[e][n][i] = null;
                      else
                          this.deletedStates[e][n] = null;
                  else
                      this.deletedStates[e] = null
              }
          }
          ,
          xl.prototype.getState = function(e, t) {
              var i = String(t)
                , n = this.state[e] || {}
                , r = this.stateChanges[e] || {}
                , o = h({}, n[i], r[i]);
              if (null === this.deletedStates[e])
                  return {};
              if (this.deletedStates[e]) {
                  var s = this.deletedStates[e][t];
                  if (null === s)
                      return {};
                  for (var a in s)
                      delete o[a]
              }
              return o
          }
          ,
          xl.prototype.initializeTileState = function(e, t) {
              e.setFeatureState(this.state, t)
          }
          ,
          xl.prototype.coalesceChanges = function(e, t) {
              var i = {};
              for (var n in this.stateChanges) {
                  this.state[n] = this.state[n] || {};
                  var r = {};
                  for (var o in this.stateChanges[n])
                      this.state[n][o] || (this.state[n][o] = {}),
                      h(this.state[n][o], this.stateChanges[n][o]),
                      r[o] = this.state[n][o];
                  i[n] = r
              }
              for (var s in this.deletedStates) {
                  this.state[s] = this.state[s] || {};
                  var a = {};
                  if (null === this.deletedStates[s]) {
                      for (var l in this.state[s])
                          a[l] = {};
                      this.state[s] = {}
                  } else
                      for (var c in this.deletedStates[s]) {
                          if (null === this.deletedStates[s][c])
                              this.state[s][c] = {};
                          else
                              for (var u = 0, d = Object.keys(this.deletedStates[s][c]); u < d.length; u += 1) {
                                  var p = d[u];
                                  delete this.state[s][c][p]
                              }
                          a[c] = this.state[s][c]
                      }
                  i[s] = i[s] || {},
                  h(i[s], a)
              }
              if (this.stateChanges = {},
              this.deletedStates = {},
              0 !== Object.keys(i).length)
                  for (var f in e)
                      e[f].setFeatureState(i, t)
          }
          ;
          var kl = function(e, t, i) {
              this.tileID = e,
              this.x = e.canonical.x,
              this.y = e.canonical.y,
              this.z = e.canonical.z,
              this.grid = t || new tn(Zr,16,0),
              this.grid3D = new tn(Zr,16,0),
              this.featureIndexArray = i || new kr
          };
          function Sl(e) {
              for (var t = 1 / 0, i = 1 / 0, n = -1 / 0, r = -1 / 0, o = 0, s = e; o < s.length; o += 1) {
                  var a = s[o];
                  t = Math.min(t, a.x),
                  i = Math.min(i, a.y),
                  n = Math.max(n, a.x),
                  r = Math.max(r, a.y)
              }
              return {
                  minX: t,
                  minY: i,
                  maxX: n,
                  maxY: r
              }
          }
          function El(e, t) {
              return t - e
          }
          kl.prototype.insert = function(e, t, i, n, r, o) {
              var s = this.featureIndexArray.length;
              this.featureIndexArray.emplaceBack(i, n, r);
              for (var a = o ? this.grid3D : this.grid, l = 0; l < t.length; l++) {
                  for (var c = t[l], u = [1 / 0, 1 / 0, -1 / 0, -1 / 0], h = 0; h < c.length; h++) {
                      var d = c[h];
                      u[0] = Math.min(u[0], d.x),
                      u[1] = Math.min(u[1], d.y),
                      u[2] = Math.max(u[2], d.x),
                      u[3] = Math.max(u[3], d.y)
                  }
                  u[0] < Zr && u[1] < Zr && u[2] >= 0 && u[3] >= 0 && a.insert(s, u[0], u[1], u[2], u[3])
              }
          }
          ,
          kl.prototype.loadVTLayers = function() {
              return this.vtLayers || (this.vtLayers = new Fs.VectorTile(new Da(this.rawTileData)).layers,
              this.sourceLayerCoder = new _l(this.vtLayers ? Object.keys(this.vtLayers).sort() : ["_geojsonTileLayer"])),
              this.vtLayers
          }
          ,
          kl.prototype.query = function(e, t, i) {
              var n = this;
              this.loadVTLayers();
              for (var o = e.params || {}, s = Zr / e.tileSize / e.scale, a = Ai(o.filter), l = e.queryGeometry, c = e.queryPadding * s, u = Sl(l), h = this.grid.query(u.minX - c, u.minY - c, u.maxX + c, u.maxY + c), d = Sl(e.cameraQueryGeometry), p = 0, f = this.grid3D.query(d.minX - c, d.minY - c, d.maxX + c, d.maxY + c, function(t, i, n, o) {
                  return function(e, t, i, n, o) {
                      for (var s = 0, a = e; s < a.length; s += 1) {
                          var l = a[s];
                          if (t <= l.x && i <= l.y && n >= l.x && o >= l.y)
                              return !0
                      }
                      var c = [new r(t,i), new r(t,o), new r(n,o), new r(n,i)];
                      if (e.length > 2)
                          for (var u = 0, h = c; u < h.length; u += 1)
                              if (co(e, h[u]))
                                  return !0;
                      for (var d = 0; d < e.length - 1; d++)
                          if (uo(e[d], e[d + 1], c))
                              return !0;
                      return !1
                  }(e.cameraQueryGeometry, t - c, i - c, n + c, o + c)
              }); p < f.length; p += 1) {
                  var m = f[p];
                  h.push(m)
              }
              h.sort(El);
              for (var g, v = {}, y = function(r) {
                  var c = h[r];
                  if (c !== g) {
                      g = c;
                      var u = n.featureIndexArray.get(c)
                        , d = null;
                      n.loadMatchingFeature(v, u.bucketIndex, u.sourceLayerIndex, u.featureIndex, a, o.layers, t, function(t, r) {
                          d || (d = Kr(t));
                          var o = {};
                          return t.id && (o = i.getState(r.sourceLayer || "_geojsonTileLayer", t.id)),
                          r.queryIntersectsFeature(l, t, o, d, n.z, e.transform, s, e.pixelPosMatrix)
                      })
                  }
              }, _ = 0; _ < h.length; _++)
                  y(_);
              return v
          }
          ,
          kl.prototype.loadMatchingFeature = function(e, t, i, n, r, o, s, a) {
              var l = this.bucketLayerIDs[t];
              if (!o || function(e, t) {
                  for (var i = 0; i < e.length; i++)
                      if (t.indexOf(e[i]) >= 0)
                          return !0;
                  return !1
              }(o, l)) {
                  var c = this.sourceLayerCoder.decode(i)
                    , u = this.vtLayers[c].feature(n);
                  if (r(new Sn(this.tileID.overscaledZ), u))
                      for (var h = 0; h < l.length; h++) {
                          var d = l[h];
                          if (!(o && o.indexOf(d) < 0)) {
                              var p = s[d];
                              if (p) {
                                  var f = !a || a(u, p);
                                  if (f) {
                                      var m = new bl(u,this.z,this.x,this.y);
                                      m.layer = p.serialize();
                                      var g = e[d];
                                      void 0 === g && (g = e[d] = []),
                                      g.push({
                                          featureIndex: n,
                                          feature: m,
                                          intersectionZ: f
                                      })
                                  }
                              }
                          }
                      }
              }
          }
          ,
          kl.prototype.lookupSymbolFeatures = function(e, t, i, n, r, o) {
              var s = {};
              this.loadVTLayers();
              for (var a = Ai(n), l = 0, c = e; l < c.length; l += 1) {
                  var u = c[l];
                  this.loadMatchingFeature(s, t, i, u, a, r, o)
              }
              return s
          }
          ,
          kl.prototype.hasLayer = function(e) {
              for (var t = 0, i = this.bucketLayerIDs; t < i.length; t += 1)
                  for (var n = 0, r = i[t]; n < r.length; n += 1)
                      if (e === r[n])
                          return !0;
              return !1
          }
          ,
          an("FeatureIndex", kl, {
              omit: ["rawTileData", "sourceLayerCoder"]
          });
          var Tl = function(e, t) {
              this.tileID = e,
              this.uid = p(),
              this.uses = 0,
              this.tileSize = t,
              this.buckets = {},
              this.expirationTime = null,
              this.queryPadding = 0,
              this.hasSymbolBuckets = !1,
              this.expiredRequestCount = 0,
              this.state = "loading"
          };
          Tl.prototype.registerFadeDuration = function(e) {
              var t = e + this.timeAdded;
              t < I.now() || this.fadeEndTime && t < this.fadeEndTime || (this.fadeEndTime = t)
          }
          ,
          Tl.prototype.wasRequested = function() {
              return "errored" === this.state || "loaded" === this.state || "reloading" === this.state
          }
          ,
          Tl.prototype.loadVectorData = function(e, t, i) {
              if (this.hasData() && this.unloadVectorData(),
              this.state = "loaded",
              e) {
                  for (var n in e.featureIndex && (this.latestFeatureIndex = e.featureIndex,
                  e.rawTileData ? (this.latestRawTileData = e.rawTileData,
                  this.latestFeatureIndex.rawTileData = e.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)),
                  this.collisionBoxArray = e.collisionBoxArray,
                  this.buckets = function(e, t) {
                      var i = {};
                      if (!t)
                          return i;
                      for (var n = function() {
                          var e = o[r]
                            , n = e.layerIds.map(function(e) {
                              return t.getLayer(e)
                          }).filter(Boolean);
                          if (0 !== n.length) {
                              e.layers = n,
                              e.stateDependentLayerIds && (e.stateDependentLayers = e.stateDependentLayerIds.map(function(e) {
                                  return n.filter(function(t) {
                                      return t.id === e
                                  })[0]
                              }));
                              for (var s = 0, a = n; s < a.length; s += 1) {
                                  var l = a[s];
                                  i[l.id] = e
                              }
                          }
                      }, r = 0, o = e; r < o.length; r += 1)
                          n();
                      return i
                  }(e.buckets, t.style),
                  this.hasSymbolBuckets = !1,
                  this.buckets) {
                      var r = this.buckets[n];
                      if (r instanceof fa) {
                          if (this.hasSymbolBuckets = !0,
                          !i)
                              break;
                          r.justReloaded = !0
                      }
                  }
                  for (var o in this.queryPadding = 0,
                  this.buckets) {
                      var s = this.buckets[o];
                      this.queryPadding = Math.max(this.queryPadding, t.style.getLayer(o).queryRadius(s))
                  }
                  e.imageAtlas && (this.imageAtlas = e.imageAtlas),
                  e.glyphAtlasImage && (this.glyphAtlasImage = e.glyphAtlasImage)
              } else
                  this.collisionBoxArray = new pr
          }
          ,
          Tl.prototype.unloadVectorData = function() {
              for (var e in this.buckets)
                  this.buckets[e].destroy();
              this.buckets = {},
              this.imageAtlasTexture && this.imageAtlasTexture.destroy(),
              this.imageAtlas && (this.imageAtlas = null),
              this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(),
              this.latestFeatureIndex = null,
              this.state = "unloaded"
          }
          ,
          Tl.prototype.unloadDEMData = function() {
              this.dem = null,
              this.neighboringTiles = null,
              this.state = "unloaded"
          }
          ,
          Tl.prototype.getBucket = function(e) {
              return this.buckets[e.id]
          }
          ,
          Tl.prototype.upload = function(e) {
              for (var t in this.buckets) {
                  var i = this.buckets[t];
                  i.uploadPending() && i.upload(e)
              }
              var n = e.gl;
              this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new Ma(e,this.imageAtlas.image,n.RGBA),
              this.imageAtlas.uploaded = !0),
              this.glyphAtlasImage && (this.glyphAtlasTexture = new Ma(e,this.glyphAtlasImage,n.ALPHA),
              this.glyphAtlasImage = null)
          }
          ,
          Tl.prototype.queryRenderedFeatures = function(e, t, i, n, r, o, s, a, l) {
              return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                  queryGeometry: i,
                  cameraQueryGeometry: n,
                  scale: r,
                  tileSize: this.tileSize,
                  pixelPosMatrix: l,
                  transform: s,
                  params: o,
                  queryPadding: this.queryPadding * a
              }, e, t) : {}
          }
          ,
          Tl.prototype.querySourceFeatures = function(e, t) {
              if (this.latestFeatureIndex && this.latestFeatureIndex.rawTileData) {
                  var i = this.latestFeatureIndex.loadVTLayers()
                    , n = t ? t.sourceLayer : ""
                    , r = i._geojsonTileLayer || i[n];
                  if (r)
                      for (var o = Ai(t && t.filter), s = this.tileID.canonical, a = s.z, l = s.x, c = s.y, u = {
                          z: a,
                          x: l,
                          y: c
                      }, h = 0; h < r.length; h++) {
                          var d = r.feature(h);
                          if (o(new Sn(this.tileID.overscaledZ), d)) {
                              var p = new bl(d,a,l,c);
                              p.tile = u,
                              e.push(p)
                          }
                      }
              }
          }
          ,
          Tl.prototype.clearMask = function() {
              this.segments && (this.segments.destroy(),
              delete this.segments),
              this.maskedBoundsBuffer && (this.maskedBoundsBuffer.destroy(),
              delete this.maskedBoundsBuffer),
              this.maskedIndexBuffer && (this.maskedIndexBuffer.destroy(),
              delete this.maskedIndexBuffer)
          }
          ,
          Tl.prototype.setMask = function(e, t) {
              if (!s(this.mask, e) && (this.mask = e,
              this.clearMask(),
              !s(e, {
                  0: !0
              }))) {
                  var i = new $n
                    , n = new ar;
                  this.segments = new Tr,
                  this.segments.prepareSegment(0, i, n);
                  for (var o = Object.keys(e), a = 0; a < o.length; a++) {
                      var l = e[o[a]]
                        , c = Zr >> l.z
                        , u = new r(l.x * c,l.y * c)
                        , h = new r(u.x + c,u.y + c)
                        , d = this.segments.prepareSegment(4, i, n);
                      i.emplaceBack(u.x, u.y, u.x, u.y),
                      i.emplaceBack(h.x, u.y, h.x, u.y),
                      i.emplaceBack(u.x, h.y, u.x, h.y),
                      i.emplaceBack(h.x, h.y, h.x, h.y);
                      var p = d.vertexLength;
                      n.emplaceBack(p, p + 1, p + 2),
                      n.emplaceBack(p + 1, p + 2, p + 3),
                      d.vertexLength += 4,
                      d.primitiveLength += 2
                  }
                  this.maskedBoundsBuffer = t.createVertexBuffer(i, yl.members),
                  this.maskedIndexBuffer = t.createIndexBuffer(n)
              }
          }
          ,
          Tl.prototype.hasData = function() {
              return "loaded" === this.state || "reloading" === this.state || "expired" === this.state
          }
          ,
          Tl.prototype.patternsLoaded = function() {
              return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length
          }
          ,
          Tl.prototype.setExpiryData = function(e) {
              var t = this.expirationTime;
              if (e.cacheControl) {
                  var i = function(e) {
                      var t = {};
                      if (e.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, function(e, i, n, r) {
                          var o = n || r;
                          return t[i] = !o || o.toLowerCase(),
                          ""
                      }),
                      t["max-age"]) {
                          var i = parseInt(t["max-age"], 10);
                          isNaN(i) ? delete t["max-age"] : t["max-age"] = i
                      }
                      return t
                  }(e.cacheControl);
                  i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"])
              } else
                  e.expires && (this.expirationTime = new Date(e.expires).getTime());
              if (this.expirationTime) {
                  var n = Date.now()
                    , r = !1;
                  if (this.expirationTime > n)
                      r = !1;
                  else if (t)
                      if (this.expirationTime < t)
                          r = !0;
                      else {
                          var o = this.expirationTime - t;
                          o ? this.expirationTime = n + Math.max(o, 3e4) : r = !0
                      }
                  else
                      r = !0;
                  r ? (this.expiredRequestCount++,
                  this.state = "expired") : this.expiredRequestCount = 0
              }
          }
          ,
          Tl.prototype.getExpiryTimeout = function() {
              if (this.expirationTime)
                  return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1)
          }
          ,
          Tl.prototype.setFeatureState = function(e, t) {
              if (this.latestFeatureIndex && this.latestFeatureIndex.rawTileData && 0 !== Object.keys(e).length) {
                  var i = this.latestFeatureIndex.loadVTLayers();
                  for (var n in this.buckets) {
                      var r = this.buckets[n]
                        , o = r.layers[0].sourceLayer || "_geojsonTileLayer"
                        , s = i[o]
                        , a = e[o];
                      s && a && 0 !== Object.keys(a).length && (r.update(a, s, this.imageAtlas && this.imageAtlas.patternPositions || {}),
                      t && t.style && (this.queryPadding = Math.max(this.queryPadding, t.style.getLayer(n).queryRadius(r))))
                  }
              }
          }
          ,
          Tl.prototype.holdingForFade = function() {
              return void 0 !== this.symbolFadeHoldUntil
          }
          ,
          Tl.prototype.symbolFadeFinished = function() {
              return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < I.now()
          }
          ,
          Tl.prototype.clearFadeHold = function() {
              this.symbolFadeHoldUntil = void 0
          }
          ,
          Tl.prototype.setHoldDuration = function(e) {
              this.symbolFadeHoldUntil = I.now() + e
          }
          ;
          var Cl = {
              horizontal: 1,
              vertical: 2,
              horizontalOnly: 3
          }
            , Ll = function() {
              this.text = "",
              this.sectionIndex = [],
              this.sections = []
          };
          Ll.fromFeature = function(e, t) {
              for (var i = new Ll, n = 0; n < e.sections.length; n++) {
                  var r = e.sections[n];
                  i.sections.push({
                      scale: r.scale || 1,
                      fontStack: r.fontStack || t
                  }),
                  i.text += r.text;
                  for (var o = 0; o < r.text.length; o++)
                      i.sectionIndex.push(n)
              }
              return i
          }
          ,
          Ll.prototype.length = function() {
              return this.text.length
          }
          ,
          Ll.prototype.getSection = function(e) {
              return this.sections[this.sectionIndex[e]]
          }
          ,
          Ll.prototype.getCharCode = function(e) {
              return this.text.charCodeAt(e)
          }
          ,
          Ll.prototype.verticalizePunctuation = function() {
              this.text = function(e) {
                  for (var t = "", i = 0; i < e.length; i++) {
                      var n = e.charCodeAt(i + 1) || null
                        , r = e.charCodeAt(i - 1) || null;
                      n && gn(n) && !oa[e[i + 1]] || r && gn(r) && !oa[e[i - 1]] || !oa[e[i]] ? t += e[i] : t += oa[e[i]]
                  }
                  return t
              }(this.text)
          }
          ,
          Ll.prototype.trim = function() {
              for (var e = 0, t = 0; t < this.text.length && Al[this.text.charCodeAt(t)]; t++)
                  e++;
              for (var i = this.text.length, n = this.text.length - 1; n >= 0 && n >= e && Al[this.text.charCodeAt(n)]; n--)
                  i--;
              this.text = this.text.substring(e, i),
              this.sectionIndex = this.sectionIndex.slice(e, i)
          }
          ,
          Ll.prototype.substring = function(e, t) {
              var i = new Ll;
              return i.text = this.text.substring(e, t),
              i.sectionIndex = this.sectionIndex.slice(e, t),
              i.sections = this.sections,
              i
          }
          ,
          Ll.prototype.toString = function() {
              return this.text
          }
          ,
          Ll.prototype.getMaxScale = function() {
              var e = this;
              return this.sectionIndex.reduce(function(t, i) {
                  return Math.max(t, e.sections[i].scale)
              }, 0)
          }
          ;
          var Al = {
              9: !0,
              10: !0,
              11: !0,
              12: !0,
              13: !0,
              32: !0
          }
            , Pl = {};
          function Il(e, t, i, n) {
              var r = Math.pow(e - t, 2);
              return n ? e < t ? r / 2 : 2 * r : r + Math.abs(i) * i
          }
          function Ml(e, t) {
              var i = 0;
              return 10 === e && (i -= 1e4),
              40 !== e && 65288 !== e || (i += 50),
              41 !== t && 65289 !== t || (i += 50),
              i
          }
          function Ol(e, t, i, n, r, o) {
              for (var s = null, a = Il(t, i, r, o), l = 0, c = n; l < c.length; l += 1) {
                  var u = c[l]
                    , h = Il(t - u.x, i, r, o) + u.badness;
                  h <= a && (s = u,
                  a = h)
              }
              return {
                  index: e,
                  x: t,
                  priorBreak: s,
                  badness: a
              }
          }
          function zl(e, t, i, n) {
              if (!i)
                  return [];
              if (!e)
                  return [];
              for (var r, o = [], s = function(e, t, i, n) {
                  for (var r = 0, o = 0; o < e.length(); o++) {
                      var s = e.getSection(o)
                        , a = n[s.fontStack]
                        , l = a && a[e.getCharCode(o)];
                      l && (r += l.metrics.advance * s.scale + t)
                  }
                  return r / Math.max(1, Math.ceil(r / i))
              }(e, t, i, n), a = 0, l = 0; l < e.length(); l++) {
                  var c = e.getSection(l)
                    , u = e.getCharCode(l)
                    , h = n[c.fontStack]
                    , d = h && h[u];
                  d && !Al[u] && (a += d.metrics.advance * c.scale + t),
                  l < e.length() - 1 && (Pl[u] || !((r = u) < 11904) && (dn["Bopomofo Extended"](r) || dn.Bopomofo(r) || dn["CJK Compatibility Forms"](r) || dn["CJK Compatibility Ideographs"](r) || dn["CJK Compatibility"](r) || dn["CJK Radicals Supplement"](r) || dn["CJK Strokes"](r) || dn["CJK Symbols and Punctuation"](r) || dn["CJK Unified Ideographs Extension A"](r) || dn["CJK Unified Ideographs"](r) || dn["Enclosed CJK Letters and Months"](r) || dn["Halfwidth and Fullwidth Forms"](r) || dn.Hiragana(r) || dn["Ideographic Description Characters"](r) || dn["Kangxi Radicals"](r) || dn["Katakana Phonetic Extensions"](r) || dn.Katakana(r) || dn["Vertical Forms"](r) || dn["Yi Radicals"](r) || dn["Yi Syllables"](r))) && o.push(Ol(l + 1, a, s, o, Ml(u, e.getCharCode(l + 1)), !1))
              }
              return function e(t) {
                  return t ? e(t.priorBreak).concat(t.index) : []
              }(Ol(e.length(), a, s, o, 0, !0))
          }
          function Dl(e) {
              var t = .5
                , i = .5;
              switch (e) {
              case "right":
              case "top-right":
              case "bottom-right":
                  t = 1;
                  break;
              case "left":
              case "top-left":
              case "bottom-left":
                  t = 0
              }
              switch (e) {
              case "bottom":
              case "bottom-right":
              case "bottom-left":
                  i = 1;
                  break;
              case "top":
              case "top-right":
              case "top-left":
                  i = 0
              }
              return {
                  horizontalAlign: t,
                  verticalAlign: i
              }
          }
          function Rl(e, t, i, n, r) {
              if (r) {
                  var o = e[n]
                    , s = t[o.fontStack]
                    , a = s && s[o.glyph];
                  if (a)
                      for (var l = a.metrics.advance * o.scale, c = (e[n].x + l) * r, u = i; u <= n; u++)
                          e[u].x -= c
              }
          }
          Pl[10] = !0,
          Pl[32] = !0,
          Pl[38] = !0,
          Pl[40] = !0,
          Pl[41] = !0,
          Pl[43] = !0,
          Pl[45] = !0,
          Pl[47] = !0,
          Pl[173] = !0,
          Pl[183] = !0,
          Pl[8203] = !0,
          Pl[8208] = !0,
          Pl[8211] = !0,
          Pl[8231] = !0,
          e.createCommonjsModule = t,
          e.window = self,
          e.Point = r,
          e.browser = I,
          e.getJSON = function(e, t) {
              return ae(h(e, {
                  type: "json"
              }), t)
          }
          ,
          e.normalizeSpriteURL = function(e, t, i, n) {
              var r = $(e);
              return F(e) ? (r.path = "/styles/v1" + r.path + "/sprite" + t + i,
              j(r, n)) : (r.path += "" + t + i,
              G(r))
          }
          ,
          e.ResourceType = te,
          e.getImage = ue,
          e.RGBAImage = Ao,
          e.ImagePosition = Ea,
          e.Texture = Ma,
          e.potpack = Sa,
          e.normalizeGlyphsURL = function(e, t) {
              if (!F(e))
                  return e;
              var i = $(e);
              return i.path = "/fonts/v1" + i.path,
              j(i, t)
          }
          ,
          e.getArrayBuffer = le,
          e.parseGlyphPBF = function(e) {
              return new Da(e).readFields(Qa, [])
          }
          ,
          e.asyncAll = function(e, t, i) {
              if (!e.length)
                  return i(null, []);
              var n = e.length
                , r = new Array(e.length)
                , o = null;
              e.forEach(function(e, s) {
                  t(e, function(e, t) {
                      e && (o = e),
                      r[s] = t,
                      0 == --n && i(o, r)
                  })
              })
          }
          ,
          e.isChar = dn,
          e.AlphaImage = Lo,
          e.Properties = jn,
          e.DataConstantProperty = On,
          e.styleSpec = ge,
          e.validateLight = Ki,
          e.endsWith = v,
          e.emitValidationErrors = en,
          e.validateStyle = Yi,
          e.extend = h,
          e.Evented = me,
          e.sphericalToCartesian = function(e) {
              var t = e[0]
                , i = e[1]
                , n = e[2];
              return i += 90,
              i *= Math.PI / 180,
              n *= Math.PI / 180,
              {
                  x: t * Math.cos(i) * Math.sin(n),
                  y: t * Math.sin(i) * Math.sin(n),
                  z: t * Math.cos(n)
              }
          }
          ,
          e.number = ct,
          e.Transitionable = Cn,
          e.warnOnce = x,
          e.uniqueId = p,
          e.Actor = nl,
          e.normalizeSourceURL = function(e, t) {
              if (!F(e))
                  return e;
              var i = $(e);
              return i.path = "/v4/" + i.authority + ".json",
              i.params.push("secure"),
              j(i, t)
          }
          ,
          e.pick = function(e, t) {
              for (var i = {}, n = 0; n < t.length; n++) {
                  var r = t[n];
                  r in e && (i[r] = e[r])
              }
              return i
          }
          ,
          e.canonicalizeTileset = function(e, t) {
              if (!F(t))
                  return e.tiles || [];
              for (var i = [], n = 0, r = e.tiles; n < r.length; n += 1) {
                  var o = r[n]
                    , s = V(o);
                  i.push(s)
              }
              return i
          }
          ,
          e.LngLatBounds = ol,
          e.mercatorXfromLng = ll,
          e.mercatorYfromLat = cl,
          e.Event = pe,
          e.ErrorEvent = fe,
          e.postTurnstileEvent = J,
          e.postMapLoadEvent = ee,
          e.normalizeTileURL = function(e, t, i) {
              if (!t || !F(t))
                  return e;
              var n = $(e)
                , r = I.devicePixelRatio >= 2 || 512 === i ? "@2x" : ""
                , o = O.supported ? ".webp" : "$1";
              return n.path = n.path.replace(q, "" + r + o),
              n.path = "/v4" + n.path,
              j(n)
          }
          ,
          e.OverscaledTileID = ml,
          e.EXTENT = Zr,
          e.MercatorCoordinate = dl,
          e.CanonicalTileID = pl,
          e.StructArrayLayout4i8 = $n,
          e.rasterBoundsAttributes = yl,
          e.SegmentVector = Tr,
          e.getVideo = function(e, t) {
              var i, n, r = self.document.createElement("video");
              r.muted = !0,
              r.onloadstart = function() {
                  t(null, r)
              }
              ;
              for (var o = 0; o < e.length; o++) {
                  var s = self.document.createElement("source");
                  i = e[o],
                  n = void 0,
                  (n = self.document.createElement("a")).href = i,
                  (n.protocol !== self.document.location.protocol || n.host !== self.document.location.host) && (r.crossOrigin = "Anonymous"),
                  s.src = e[o],
                  r.appendChild(s)
              }
              return {
                  cancel: function() {}
              }
          }
          ,
          e.ValidationError = ve,
          e.bindAll = g,
          e.multiply = function(e, t, i) {
              var n = t[0]
                , r = t[1]
                , o = t[2]
                , s = t[3]
                , a = t[4]
                , l = t[5]
                , c = t[6]
                , u = t[7]
                , h = t[8]
                , d = t[9]
                , p = t[10]
                , f = t[11]
                , m = t[12]
                , g = t[13]
                , v = t[14]
                , y = t[15]
                , _ = i[0]
                , b = i[1]
                , w = i[2]
                , x = i[3];
              return e[0] = _ * n + b * a + w * h + x * m,
              e[1] = _ * r + b * l + w * d + x * g,
              e[2] = _ * o + b * c + w * p + x * v,
              e[3] = _ * s + b * u + w * f + x * y,
              _ = i[4],
              b = i[5],
              w = i[6],
              x = i[7],
              e[4] = _ * n + b * a + w * h + x * m,
              e[5] = _ * r + b * l + w * d + x * g,
              e[6] = _ * o + b * c + w * p + x * v,
              e[7] = _ * s + b * u + w * f + x * y,
              _ = i[8],
              b = i[9],
              w = i[10],
              x = i[11],
              e[8] = _ * n + b * a + w * h + x * m,
              e[9] = _ * r + b * l + w * d + x * g,
              e[10] = _ * o + b * c + w * p + x * v,
              e[11] = _ * s + b * u + w * f + x * y,
              _ = i[12],
              b = i[13],
              w = i[14],
              x = i[15],
              e[12] = _ * n + b * a + w * h + x * m,
              e[13] = _ * r + b * l + w * d + x * g,
              e[14] = _ * o + b * c + w * p + x * v,
              e[15] = _ * s + b * u + w * f + x * y,
              e
          }
          ,
          e.identity = function(e) {
              return e[0] = 1,
              e[1] = 0,
              e[2] = 0,
              e[3] = 0,
              e[4] = 0,
              e[5] = 1,
              e[6] = 0,
              e[7] = 0,
              e[8] = 0,
              e[9] = 0,
              e[10] = 1,
              e[11] = 0,
              e[12] = 0,
              e[13] = 0,
              e[14] = 0,
              e[15] = 1,
              e
          }
          ,
          e.translate = function(e, t, i) {
              var n, r, o, s, a, l, c, u, h, d, p, f, m = i[0], g = i[1], v = i[2];
              return t === e ? (e[12] = t[0] * m + t[4] * g + t[8] * v + t[12],
              e[13] = t[1] * m + t[5] * g + t[9] * v + t[13],
              e[14] = t[2] * m + t[6] * g + t[10] * v + t[14],
              e[15] = t[3] * m + t[7] * g + t[11] * v + t[15]) : (n = t[0],
              r = t[1],
              o = t[2],
              s = t[3],
              a = t[4],
              l = t[5],
              c = t[6],
              u = t[7],
              h = t[8],
              d = t[9],
              p = t[10],
              f = t[11],
              e[0] = n,
              e[1] = r,
              e[2] = o,
              e[3] = s,
              e[4] = a,
              e[5] = l,
              e[6] = c,
              e[7] = u,
              e[8] = h,
              e[9] = d,
              e[10] = p,
              e[11] = f,
              e[12] = n * m + a * g + h * v + t[12],
              e[13] = r * m + l * g + d * v + t[13],
              e[14] = o * m + c * g + p * v + t[14],
              e[15] = s * m + u * g + f * v + t[15]),
              e
          }
          ,
          e.scale = function(e, t, i) {
              var n = i[0]
                , r = i[1]
                , o = i[2];
              return e[0] = t[0] * n,
              e[1] = t[1] * n,
              e[2] = t[2] * n,
              e[3] = t[3] * n,
              e[4] = t[4] * r,
              e[5] = t[5] * r,
              e[6] = t[6] * r,
              e[7] = t[7] * r,
              e[8] = t[8] * o,
              e[9] = t[9] * o,
              e[10] = t[10] * o,
              e[11] = t[11] * o,
              e[12] = t[12],
              e[13] = t[13],
              e[14] = t[14],
              e[15] = t[15],
              e
          }
          ,
          e.Color = je,
          e.isEqual = s,
          e.keysDifference = function(e, t) {
              var i = [];
              for (var n in e)
                  n in t || i.push(n);
              return i
          }
          ,
          e.Tile = Tl,
          e.SourceFeatureState = xl,
          e.refProperties = ["type", "source", "source-layer", "minzoom", "maxzoom", "filter", "layout"],
          e.rotateZ = function(e, t, i) {
              var n = Math.sin(i)
                , r = Math.cos(i)
                , o = t[0]
                , s = t[1]
                , a = t[2]
                , l = t[3]
                , c = t[4]
                , u = t[5]
                , h = t[6]
                , d = t[7];
              return t !== e && (e[8] = t[8],
              e[9] = t[9],
              e[10] = t[10],
              e[11] = t[11],
              e[12] = t[12],
              e[13] = t[13],
              e[14] = t[14],
              e[15] = t[15]),
              e[0] = o * r + c * n,
              e[1] = s * r + u * n,
              e[2] = a * r + h * n,
              e[3] = l * r + d * n,
              e[4] = c * r - o * n,
              e[5] = u * r - s * n,
              e[6] = h * r - a * n,
              e[7] = d * r - l * n,
              e
          }
          ,
          e.evaluateSizeForZoom = function(e, t, i) {
              if ("constant" === e.functionType)
                  return {
                      uSizeT: 0,
                      uSize: e.layoutSize
                  };
              if ("source" === e.functionType)
                  return {
                      uSizeT: 0,
                      uSize: 0
                  };
              if ("camera" === e.functionType) {
                  var n = e.propertyValue
                    , r = e.zoomRange
                    , o = e.sizeRange
                    , s = c(bi(n, i.specification).interpolationFactor(t, r.min, r.max), 0, 1);
                  return {
                      uSizeT: 0,
                      uSize: o.min + s * (o.max - o.min)
                  }
              }
              var a = e.propertyValue
                , l = e.zoomRange;
              return {
                  uSizeT: c(bi(a, i.specification).interpolationFactor(t, l.min, l.max), 0, 1),
                  uSize: 0
              }
          }
          ,
          e.WritingMode = Cl,
          e.transformMat4 = bo,
          e.evaluateSizeForFeature = function(e, t, i) {
              var n = t;
              return "source" === e.functionType ? i.lowerSize / 256 : "composite" === e.functionType ? ct(i.lowerSize / 256, i.upperSize / 256, n.uSizeT) : n.uSize
          }
          ,
          e.addDynamicAttributes = ha,
          e.properties = ga,
          e.polygonIntersectsPolygon = eo,
          e.isMapboxURL = F,
          e.normalizeStyleURL = function(e, t) {
              if (!F(e))
                  return e;
              var i = $(e);
              return i.path = "/styles/v1" + i.path,
              j(i, t)
          }
          ,
          e.createStyleLayer = function(e) {
              return "custom" === e.type ? new xa(e) : new ka[e.type](e)
          }
          ,
          e.clone = b,
          e.validateCustomStyleLayer = function(e) {
              var t = []
                , i = e.id;
              return void 0 === i && t.push({
                  message: "layers." + i + ': missing required property "id"'
              }),
              void 0 === e.render && t.push({
                  message: "layers." + i + ': missing required method "render"'
              }),
              e.renderingMode && "2d" !== e.renderingMode && "3d" !== e.renderingMode && t.push({
                  message: "layers." + i + ': property "renderingMode" must be either "2d" or "3d"'
              }),
              t
          }
          ,
          e.filterObject = _,
          e.mapObject = y,
          e.evented = xn,
          e.makeRequest = ae,
          e.registerForPluginAvailability = function(e) {
              return bn ? e({
                  pluginURL: bn,
                  completionCallback: yn
              }) : xn.once("pluginAvailable", e),
              e
          }
          ,
          e.ZoomHistory = hn,
          e.getReferrer = se,
          e.createLayout = Hn,
          e.UniformMatrix4f = jr,
          e.Uniform3f = zr,
          e.Uniform1f = Mr,
          e.Uniform1i = Ir,
          e.Uniform2f = Or,
          e.Uniform4f = Dr,
          e.create = vo,
          e.fromRotation = function(e, t) {
              var i = Math.sin(t)
                , n = Math.cos(t);
              return e[0] = n,
              e[1] = i,
              e[2] = 0,
              e[3] = -i,
              e[4] = n,
              e[5] = 0,
              e[6] = 0,
              e[7] = 0,
              e[8] = 1,
              e
          }
          ,
          e.transformMat3 = function(e, t, i) {
              var n = t[0]
                , r = t[1]
                , o = t[2];
              return e[0] = n * i[0] + r * i[3] + o * i[6],
              e[1] = n * i[1] + r * i[4] + o * i[7],
              e[2] = n * i[2] + r * i[5] + o * i[8],
              e
          }
          ,
          e.create$1 = function() {
              var e = new go(16);
              return go != Float32Array && (e[1] = 0,
              e[2] = 0,
              e[3] = 0,
              e[4] = 0,
              e[6] = 0,
              e[7] = 0,
              e[8] = 0,
              e[9] = 0,
              e[11] = 0,
              e[12] = 0,
              e[13] = 0,
              e[14] = 0),
              e[0] = 1,
              e[5] = 1,
              e[10] = 1,
              e[15] = 1,
              e
          }
          ,
          e.ortho = function(e, t, i, n, r, o, s) {
              var a = 1 / (t - i)
                , l = 1 / (n - r)
                , c = 1 / (o - s);
              return e[0] = -2 * a,
              e[1] = 0,
              e[2] = 0,
              e[3] = 0,
              e[4] = 0,
              e[5] = -2 * l,
              e[6] = 0,
              e[7] = 0,
              e[8] = 0,
              e[9] = 0,
              e[10] = 2 * c,
              e[11] = 0,
              e[12] = (t + i) * a,
              e[13] = (r + n) * l,
              e[14] = (s + o) * c,
              e[15] = 1,
              e
          }
          ,
          e.UniformColor = Rr,
          e.clamp = c,
          e.StructArrayLayout2i4 = Wn,
          e.StructArrayLayout2ui4 = lr,
          e.ProgramConfiguration = Wr,
          e.StructArrayLayout1ui2 = cr,
          e.StructArrayLayout3ui6 = ar,
          e.wrap = u,
          e.create$2 = function() {
              var e = new go(4);
              return go != Float32Array && (e[1] = 0,
              e[2] = 0),
              e[0] = 1,
              e[3] = 1,
              e
          }
          ,
          e.rotate = function(e, t, i) {
              var n = t[0]
                , r = t[1]
                , o = t[2]
                , s = t[3]
                , a = Math.sin(i)
                , l = Math.cos(i);
              return e[0] = n * l + o * a,
              e[1] = r * l + s * a,
              e[2] = n * -a + o * l,
              e[3] = r * -a + s * l,
              e
          }
          ,
          e.LngLat = sl,
          e.UnwrappedTileID = fl,
          e.perspective = function(e, t, i, n, r) {
              var o, s = 1 / Math.tan(t / 2);
              return e[0] = s / i,
              e[1] = 0,
              e[2] = 0,
              e[3] = 0,
              e[4] = 0,
              e[5] = s,
              e[6] = 0,
              e[7] = 0,
              e[8] = 0,
              e[9] = 0,
              e[11] = -1,
              e[12] = 0,
              e[13] = 0,
              e[15] = 0,
              null != r && r !== 1 / 0 ? (o = 1 / (n - r),
              e[10] = (r + n) * o,
              e[14] = 2 * r * n * o) : (e[10] = -1,
              e[14] = -2 * n),
              e
          }
          ,
          e.rotateX = function(e, t, i) {
              var n = Math.sin(i)
                , r = Math.cos(i)
                , o = t[4]
                , s = t[5]
                , a = t[6]
                , l = t[7]
                , c = t[8]
                , u = t[9]
                , h = t[10]
                , d = t[11];
              return t !== e && (e[0] = t[0],
              e[1] = t[1],
              e[2] = t[2],
              e[3] = t[3],
              e[12] = t[12],
              e[13] = t[13],
              e[14] = t[14],
              e[15] = t[15]),
              e[4] = o * r + c * n,
              e[5] = s * r + u * n,
              e[6] = a * r + h * n,
              e[7] = l * r + d * n,
              e[8] = c * r - o * n,
              e[9] = u * r - s * n,
              e[10] = h * r - a * n,
              e[11] = d * r - l * n,
              e
          }
          ,
          e.mercatorZfromAltitude = ul,
          e.invert = function(e, t) {
              var i = t[0]
                , n = t[1]
                , r = t[2]
                , o = t[3]
                , s = t[4]
                , a = t[5]
                , l = t[6]
                , c = t[7]
                , u = t[8]
                , h = t[9]
                , d = t[10]
                , p = t[11]
                , f = t[12]
                , m = t[13]
                , g = t[14]
                , v = t[15]
                , y = i * a - n * s
                , _ = i * l - r * s
                , b = i * c - o * s
                , w = n * l - r * a
                , x = n * c - o * a
                , k = r * c - o * l
                , S = u * m - h * f
                , E = u * g - d * f
                , T = u * v - p * f
                , C = h * g - d * m
                , L = h * v - p * m
                , A = d * v - p * g
                , P = y * A - _ * L + b * C + w * T - x * E + k * S;
              return P ? (P = 1 / P,
              e[0] = (a * A - l * L + c * C) * P,
              e[1] = (r * L - n * A - o * C) * P,
              e[2] = (m * k - g * x + v * w) * P,
              e[3] = (d * x - h * k - p * w) * P,
              e[4] = (l * T - s * A - c * E) * P,
              e[5] = (i * A - r * T + o * E) * P,
              e[6] = (g * b - f * k - v * _) * P,
              e[7] = (u * k - d * b + p * _) * P,
              e[8] = (s * L - a * T + c * S) * P,
              e[9] = (n * T - i * L - o * S) * P,
              e[10] = (f * x - m * b + v * y) * P,
              e[11] = (h * b - u * x - p * y) * P,
              e[12] = (a * E - s * C - l * S) * P,
              e[13] = (i * C - n * E + r * S) * P,
              e[14] = (m * _ - f * w - g * y) * P,
              e[15] = (u * w - h * _ + d * y) * P,
              e) : null
          }
          ,
          e.ease = l,
          e.bezier = a,
          e.config = M,
          e.webpSupported = O,
          e.EvaluationParameters = Sn,
          e.version = "0.53.1",
          e.setRTLTextPlugin = function(e, t) {
              if (_n)
                  throw new Error("setRTLTextPlugin cannot be called multiple times.");
              _n = !0,
              bn = I.resolveURL(e),
              yn = function(e) {
                  e ? (_n = !1,
                  bn = null,
                  t && t(e)) : wn = !0
              }
              ,
              xn.fire(new pe("pluginAvailable",{
                  pluginURL: bn,
                  completionCallback: yn
              }))
          }
          ,
          e.featureFilter = Ai,
          e.values = function(e) {
              var t = [];
              for (var i in e)
                  t.push(e[i]);
              return t
          }
          ,
          e.Anchor = sa,
          e.GLYPH_PBF_BORDER = il,
          e.distToSegmentSquared = ao,
          e.allowsLetterSpacing = function(e) {
              for (var t = 0, i = e; t < i.length; t += 1)
                  if (!fn(i[t].charCodeAt(0)))
                      return !1;
              return !0
          }
          ,
          e.shapeText = function(e, t, i, n, r, o, s, a, l, c, u) {
              var h = Ll.fromFeature(e, i);
              u === Cl.vertical && h.verticalizePunctuation();
              var d, p = [], f = {
                  positionedGlyphs: p,
                  text: h,
                  top: l[1],
                  bottom: l[1],
                  left: l[0],
                  right: l[0],
                  writingMode: u
              }, m = kn.processBidirectionalText, g = kn.processStyledBidirectionalText;
              if (m && 1 === h.sections.length) {
                  d = [];
                  for (var v = 0, y = m(h.toString(), zl(h, a, n, t)); v < y.length; v += 1) {
                      var _ = y[v]
                        , b = new Ll;
                      b.text = _,
                      b.sections = h.sections;
                      for (var w = 0; w < _.length; w++)
                          b.sectionIndex.push(0);
                      d.push(b)
                  }
              } else if (g) {
                  d = [];
                  for (var x = 0, k = g(h.text, h.sectionIndex, zl(h, a, n, t)); x < k.length; x += 1) {
                      var S = k[x]
                        , E = new Ll;
                      E.text = S[0],
                      E.sectionIndex = S[1],
                      E.sections = h.sections,
                      d.push(E)
                  }
              } else
                  d = function(e, t) {
                      for (var i = [], n = e.text, r = 0, o = 0, s = t; o < s.length; o += 1) {
                          var a = s[o];
                          i.push(e.substring(r, a)),
                          r = a
                      }
                      return r < n.length && i.push(e.substring(r, n.length)),
                      i
                  }(h, zl(h, a, n, t));
              return function(e, t, i, n, r, o, s, a, l) {
                  for (var c = 0, u = -17, h = 0, d = e.positionedGlyphs, p = "right" === o ? 1 : "left" === o ? 0 : .5, f = 0, m = i; f < m.length; f += 1) {
                      var g = m[f];
                      g.trim();
                      var v = g.getMaxScale();
                      if (g.length()) {
                          for (var y = d.length, _ = 0; _ < g.length(); _++) {
                              var b = g.getSection(_)
                                , w = g.getCharCode(_)
                                , x = 24 * (v - b.scale)
                                , k = t[b.fontStack]
                                , S = k && k[w];
                              S && (mn(w) && s !== Cl.horizontal ? (d.push({
                                  glyph: w,
                                  x: c,
                                  y: x,
                                  vertical: !0,
                                  scale: b.scale,
                                  fontStack: b.fontStack
                              }),
                              c += l * b.scale + a) : (d.push({
                                  glyph: w,
                                  x: c,
                                  y: u + x,
                                  vertical: !1,
                                  scale: b.scale,
                                  fontStack: b.fontStack
                              }),
                              c += S.metrics.advance * b.scale + a))
                          }
                          if (d.length !== y) {
                              var E = c - a;
                              h = Math.max(E, h),
                              Rl(d, t, y, d.length - 1, p)
                          }
                          c = 0,
                          u += n * v
                      } else
                          u += n
                  }
                  var T = Dl(r)
                    , C = T.horizontalAlign
                    , L = T.verticalAlign;
                  !function(e, t, i, n, r, o, s) {
                      for (var a = (t - i) * r, l = (-n * s + .5) * o, c = 0; c < e.length; c++)
                          e[c].x += a,
                          e[c].y += l
                  }(d, p, C, L, h, n, i.length);
                  var A = u - -17;
                  e.top += -L * A,
                  e.bottom = e.top + A,
                  e.left += -C * h,
                  e.right = e.left + h
              }(f, t, d, r, o, s, u, a, c),
              !!p.length && (f.text = f.text.toString(),
              f)
          }
          ,
          e.allowsVerticalWritingMode = pn,
          e.shapeIcon = function(e, t, i) {
              var n = Dl(i)
                , r = n.horizontalAlign
                , o = n.verticalAlign
                , s = t[0]
                , a = t[1]
                , l = s - e.displaySize[0] * r
                , c = l + e.displaySize[0]
                , u = a - e.displaySize[1] * o;
              return {
                  image: e,
                  top: u,
                  bottom: u + e.displaySize[1],
                  left: l,
                  right: c
              }
          }
          ,
          e.classifyRings = hs,
          e.SIZE_PACK_FACTOR = 256,
          e.SymbolBucket = fa,
          e.register = an,
          e.CollisionBoxArray = pr,
          e.DictionaryCoder = _l,
          e.FeatureIndex = kl,
          e.ImageAtlas = Ca,
          e.LineBucket = $s,
          e.FillBucket = ms,
          e.FillExtrusionBucket = xs,
          e.mvt = Fs,
          e.Protobuf = Da,
          e.DEMData = vl,
          e.vectorTile = Fs,
          e.Point$1 = r,
          e.pbf = Da,
          e.createExpression = mi,
          e.plugin = kn
      }),
      n(0, function(e) {
          function t(e) {
              var i = typeof e;
              if ("number" === i || "boolean" === i || "string" === i || null == e)
                  return JSON.stringify(e);
              if (Array.isArray(e)) {
                  for (var n = "[", r = 0, o = e; r < o.length; r += 1)
                      n += t(o[r]) + ",";
                  return n + "]"
              }
              for (var s = Object.keys(e).sort(), a = "{", l = 0; l < s.length; l++)
                  a += JSON.stringify(s[l]) + ":" + t(e[s[l]]) + ",";
              return a + "}"
          }
          function i(i) {
              for (var n = "", r = 0, o = e.refProperties; r < o.length; r += 1)
                  n += "/" + t(i[o[r]]);
              return n
          }
          var n = function(e) {
              e && this.replace(e)
          };
          function r(e, t, i, n, r) {
              if (void 0 === t.segment)
                  return !0;
              for (var o = t, s = t.segment + 1, a = 0; a > -i / 2; ) {
                  if (--s < 0)
                      return !1;
                  a -= e[s].dist(o),
                  o = e[s]
              }
              a += e[s].dist(e[s + 1]),
              s++;
              for (var l = [], c = 0; a < i / 2; ) {
                  var u = e[s - 1]
                    , h = e[s]
                    , d = e[s + 1];
                  if (!d)
                      return !1;
                  var p = u.angleTo(h) - h.angleTo(d);
                  for (p = Math.abs((p + 3 * Math.PI) % (2 * Math.PI) - Math.PI),
                  l.push({
                      distance: a,
                      angleDelta: p
                  }),
                  c += p; a - l[0].distance > n; )
                      c -= l.shift().angleDelta;
                  if (c > r)
                      return !1;
                  s++,
                  a += h.dist(d)
              }
              return !0
          }
          function o(e) {
              for (var t = 0, i = 0; i < e.length - 1; i++)
                  t += e[i].dist(e[i + 1]);
              return t
          }
          function s(e, t, i) {
              return e ? .6 * t * i : 0
          }
          function a(e, t) {
              return Math.max(e ? e.right - e.left : 0, t ? t.right - t.left : 0)
          }
          function l(t, i, n, l, c, u) {
              for (var h = s(n, c, u), d = a(n, l) * u, p = 0, f = o(t) / 2, m = 0; m < t.length - 1; m++) {
                  var g = t[m]
                    , v = t[m + 1]
                    , y = g.dist(v);
                  if (p + y > f) {
                      var _ = (f - p) / y
                        , b = e.number(g.x, v.x, _)
                        , w = e.number(g.y, v.y, _)
                        , x = new e.Anchor(b,w,v.angleTo(g),m);
                      return x._round(),
                      !h || r(t, x, d, h, i) ? x : void 0
                  }
                  p += y
              }
          }
          function c(t, i, n, l, c, u, h, d, p) {
              var f = s(l, u, h)
                , m = a(l, c)
                , g = m * h
                , v = 0 === t[0].x || t[0].x === p || 0 === t[0].y || t[0].y === p;
              return i - g < i / 4 && (i = g + i / 4),
              function t(i, n, s, a, l, c, u, h, d) {
                  for (var p = c / 2, f = o(i), m = 0, g = n - s, v = [], y = 0; y < i.length - 1; y++) {
                      for (var _ = i[y], b = i[y + 1], w = _.dist(b), x = b.angleTo(_); g + s < m + w; ) {
                          var k = ((g += s) - m) / w
                            , S = e.number(_.x, b.x, k)
                            , E = e.number(_.y, b.y, k);
                          if (S >= 0 && S < d && E >= 0 && E < d && g - p >= 0 && g + p <= f) {
                              var T = new e.Anchor(S,E,x,y);
                              T._round(),
                              a && !r(i, T, c, a, l) || v.push(T)
                          }
                      }
                      m += w
                  }
                  return h || v.length || u || (v = t(i, m / 2, s, a, l, c, u, !0, d)),
                  v
              }(t, v ? i / 2 * d % i : (m / 2 + 2 * u) * h * d % i, i, f, n, g, v, !1, p)
          }
          n.prototype.replace = function(e) {
              this._layerConfigs = {},
              this._layers = {},
              this.update(e, [])
          }
          ,
          n.prototype.update = function(t, n) {
              for (var r = this, o = 0, s = t; o < s.length; o += 1) {
                  var a = s[o];
                  this._layerConfigs[a.id] = a;
                  var l = this._layers[a.id] = e.createStyleLayer(a);
                  l._featureFilter = e.featureFilter(l.filter)
              }
              for (var c = 0, u = n; c < u.length; c += 1) {
                  var h = u[c];
                  delete this._layerConfigs[h],
                  delete this._layers[h]
              }
              this.familiesBySource = {};
              for (var d = 0, p = function(e) {
                  for (var t = {}, n = 0; n < e.length; n++) {
                      var r = i(e[n])
                        , o = t[r];
                      o || (o = t[r] = []),
                      o.push(e[n])
                  }
                  var s = [];
                  for (var a in t)
                      s.push(t[a]);
                  return s
              }(e.values(this._layerConfigs)); d < p.length; d += 1) {
                  var f = p[d].map(function(e) {
                      return r._layers[e.id]
                  })
                    , m = f[0];
                  if ("none" !== m.visibility) {
                      var g = m.source || ""
                        , v = this.familiesBySource[g];
                      v || (v = this.familiesBySource[g] = {});
                      var y = m.sourceLayer || "_geojsonTileLayer"
                        , _ = v[y];
                      _ || (_ = v[y] = []),
                      _.push(f)
                  }
              }
          }
          ;
          var u = function(t, i, n, r, o, s, a, l, c, u, h, d) {
              var p = a.top * l - c
                , f = a.bottom * l + c
                , m = a.left * l - c
                , g = a.right * l + c;
              if (this.boxStartIndex = t.length,
              u) {
                  var v = f - p
                    , y = g - m;
                  v > 0 && (v = Math.max(10 * l, v),
                  this._addLineCollisionCircles(t, i, n, n.segment, y, v, r, o, s, h))
              } else {
                  if (d) {
                      var _ = new e.Point(m,p)
                        , b = new e.Point(g,p)
                        , w = new e.Point(m,f)
                        , x = new e.Point(g,f)
                        , k = d * Math.PI / 180;
                      _._rotate(k),
                      b._rotate(k),
                      w._rotate(k),
                      x._rotate(k),
                      m = Math.min(_.x, b.x, w.x, x.x),
                      g = Math.max(_.x, b.x, w.x, x.x),
                      p = Math.min(_.y, b.y, w.y, x.y),
                      f = Math.max(_.y, b.y, w.y, x.y)
                  }
                  t.emplaceBack(n.x, n.y, m, p, g, f, r, o, s, 0, 0)
              }
              this.boxEndIndex = t.length
          };
          u.prototype._addLineCollisionCircles = function(e, t, i, n, r, o, s, a, l, c) {
              var u = o / 2
                , h = Math.floor(r / u) || 1
                , d = 1 + .4 * Math.log(c) / Math.LN2
                , p = Math.floor(h * d / 2)
                , f = -o / 2
                , m = i
                , g = n + 1
                , v = f
                , y = -r / 2
                , _ = y - r / 4;
              do {
                  if (--g < 0) {
                      if (v > y)
                          return;
                      g = 0;
                      break
                  }
                  v -= t[g].dist(m),
                  m = t[g]
              } while (v > _);for (var b = t[g].dist(t[g + 1]), w = -p; w < h + p; w++) {
                  var x = w * u
                    , k = y + x;
                  if (x < 0 && (k += x),
                  x > r && (k += x - r),
                  !(k < v)) {
                      for (; v + b < k; ) {
                          if (v += b,
                          ++g + 1 >= t.length)
                              return;
                          b = t[g].dist(t[g + 1])
                      }
                      var S = k - v
                        , E = t[g]
                        , T = t[g + 1].sub(E)._unit()._mult(S)._add(E)._round()
                        , C = Math.abs(k - f) < u ? 0 : .8 * (k - f);
                      e.emplaceBack(T.x, T.y, -o / 2, -o / 2, o / 2, o / 2, s, a, l, o / 2, C)
                  }
              }
          }
          ;
          var h = function(e, t) {
              if (void 0 === e && (e = []),
              void 0 === t && (t = d),
              this.data = e,
              this.length = this.data.length,
              this.compare = t,
              this.length > 0)
                  for (var i = (this.length >> 1) - 1; i >= 0; i--)
                      this._down(i)
          };
          function d(e, t) {
              return e < t ? -1 : e > t ? 1 : 0
          }
          function p(t, i, n) {
              void 0 === i && (i = 1),
              void 0 === n && (n = !1);
              for (var r = 1 / 0, o = 1 / 0, s = -1 / 0, a = -1 / 0, l = t[0], c = 0; c < l.length; c++) {
                  var u = l[c];
                  (!c || u.x < r) && (r = u.x),
                  (!c || u.y < o) && (o = u.y),
                  (!c || u.x > s) && (s = u.x),
                  (!c || u.y > a) && (a = u.y)
              }
              var d = s - r
                , p = a - o
                , g = Math.min(d, p)
                , v = g / 2
                , y = new h([],f);
              if (0 === g)
                  return new e.Point(r,o);
              for (var _ = r; _ < s; _ += g)
                  for (var b = o; b < a; b += g)
                      y.push(new m(_ + v,b + v,v,t));
              for (var w = function(e) {
                  for (var t = 0, i = 0, n = 0, r = e[0], o = 0, s = r.length, a = s - 1; o < s; a = o++) {
                      var l = r[o]
                        , c = r[a]
                        , u = l.x * c.y - c.x * l.y;
                      i += (l.x + c.x) * u,
                      n += (l.y + c.y) * u,
                      t += 3 * u
                  }
                  return new m(i / t,n / t,0,e)
              }(t), x = y.length; y.length; ) {
                  var k = y.pop();
                  (k.d > w.d || !w.d) && (w = k,
                  n && console.log("found best %d after %d probes", Math.round(1e4 * k.d) / 1e4, x)),
                  k.max - w.d <= i || (v = k.h / 2,
                  y.push(new m(k.p.x - v,k.p.y - v,v,t)),
                  y.push(new m(k.p.x + v,k.p.y - v,v,t)),
                  y.push(new m(k.p.x - v,k.p.y + v,v,t)),
                  y.push(new m(k.p.x + v,k.p.y + v,v,t)),
                  x += 4)
              }
              return n && (console.log("num probes: " + x),
              console.log("best distance: " + w.d)),
              w.p
          }
          function f(e, t) {
              return t.max - e.max
          }
          function m(t, i, n, r) {
              this.p = new e.Point(t,i),
              this.h = n,
              this.d = function(t, i) {
                  for (var n = !1, r = 1 / 0, o = 0; o < i.length; o++)
                      for (var s = i[o], a = 0, l = s.length, c = l - 1; a < l; c = a++) {
                          var u = s[a]
                            , h = s[c];
                          u.y > t.y != h.y > t.y && t.x < (h.x - u.x) * (t.y - u.y) / (h.y - u.y) + u.x && (n = !n),
                          r = Math.min(r, e.distToSegmentSquared(t, u, h))
                      }
                  return (n ? 1 : -1) * Math.sqrt(r)
              }(this.p, r),
              this.max = this.d + this.h * Math.SQRT2
          }
          h.prototype.push = function(e) {
              this.data.push(e),
              this.length++,
              this._up(this.length - 1)
          }
          ,
          h.prototype.pop = function() {
              if (0 !== this.length) {
                  var e = this.data[0];
                  return this.length--,
                  this.length > 0 && (this.data[0] = this.data[this.length],
                  this._down(0)),
                  this.data.pop(),
                  e
              }
          }
          ,
          h.prototype.peek = function() {
              return this.data[0]
          }
          ,
          h.prototype._up = function(e) {
              for (var t = this.data, i = this.compare, n = t[e]; e > 0; ) {
                  var r = e - 1 >> 1
                    , o = t[r];
                  if (i(n, o) >= 0)
                      break;
                  t[e] = o,
                  e = r
              }
              t[e] = n
          }
          ,
          h.prototype._down = function(e) {
              for (var t = this.data, i = this.compare, n = this.length >> 1, r = t[e]; e < n; ) {
                  var o = 1 + (e << 1)
                    , s = t[o]
                    , a = o + 1;
                  if (a < this.length && i(t[a], s) < 0 && (o = a,
                  s = t[a]),
                  i(s, r) >= 0)
                      break;
                  t[e] = s,
                  e = o
              }
              t[e] = r
          }
          ;
          var g = e.createCommonjsModule(function(e) {
              e.exports = function(e, t) {
                  var i, n, r, o, s, a, l, c;
                  for (i = 3 & e.length,
                  n = e.length - i,
                  r = t,
                  s = 3432918353,
                  a = 461845907,
                  c = 0; c < n; )
                      l = 255 & e.charCodeAt(c) | (255 & e.charCodeAt(++c)) << 8 | (255 & e.charCodeAt(++c)) << 16 | (255 & e.charCodeAt(++c)) << 24,
                      ++c,
                      r = 27492 + (65535 & (o = 5 * (65535 & (r = (r ^= l = (65535 & (l = (l = (65535 & l) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 13 | r >>> 19)) + ((5 * (r >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (o >>> 16) & 65535) << 16);
                  switch (l = 0,
                  i) {
                  case 3:
                      l ^= (255 & e.charCodeAt(c + 2)) << 16;
                  case 2:
                      l ^= (255 & e.charCodeAt(c + 1)) << 8;
                  case 1:
                      r ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & e.charCodeAt(c))) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295
                  }
                  return r ^= e.length,
                  r = 2246822507 * (65535 & (r ^= r >>> 16)) + ((2246822507 * (r >>> 16) & 65535) << 16) & 4294967295,
                  r = 3266489909 * (65535 & (r ^= r >>> 13)) + ((3266489909 * (r >>> 16) & 65535) << 16) & 4294967295,
                  (r ^= r >>> 16) >>> 0
              }
          })
            , v = e.createCommonjsModule(function(e) {
              e.exports = function(e, t) {
                  for (var i, n = e.length, r = t ^ n, o = 0; n >= 4; )
                      i = 1540483477 * (65535 & (i = 255 & e.charCodeAt(o) | (255 & e.charCodeAt(++o)) << 8 | (255 & e.charCodeAt(++o)) << 16 | (255 & e.charCodeAt(++o)) << 24)) + ((1540483477 * (i >>> 16) & 65535) << 16),
                      r = 1540483477 * (65535 & r) + ((1540483477 * (r >>> 16) & 65535) << 16) ^ (i = 1540483477 * (65535 & (i ^= i >>> 24)) + ((1540483477 * (i >>> 16) & 65535) << 16)),
                      n -= 4,
                      ++o;
                  switch (n) {
                  case 3:
                      r ^= (255 & e.charCodeAt(o + 2)) << 16;
                  case 2:
                      r ^= (255 & e.charCodeAt(o + 1)) << 8;
                  case 1:
                      r = 1540483477 * (65535 & (r ^= 255 & e.charCodeAt(o))) + ((1540483477 * (r >>> 16) & 65535) << 16)
                  }
                  return r = 1540483477 * (65535 & (r ^= r >>> 13)) + ((1540483477 * (r >>> 16) & 65535) << 16),
                  (r ^= r >>> 15) >>> 0
              }
          })
            , y = g
            , _ = g
            , b = v;
          function w(t, i, n, r, o, s) {
              t.createArrays();
              var a = 512 * t.overscaling;
              t.tilePixelRatio = e.EXTENT / a,
              t.compareText = {},
              t.iconsNeedLinear = !1;
              var l = t.layers[0].layout
                , c = t.layers[0]._unevaluatedLayout._values
                , u = {};
              if ("composite" === t.textSizeData.functionType) {
                  var h = t.textSizeData.zoomRange
                    , d = h.min
                    , p = h.max;
                  u.compositeTextSizes = [c["text-size"].possiblyEvaluate(new e.EvaluationParameters(d)), c["text-size"].possiblyEvaluate(new e.EvaluationParameters(p))]
              }
              if ("composite" === t.iconSizeData.functionType) {
                  var f = t.iconSizeData.zoomRange
                    , m = f.min
                    , g = f.max;
                  u.compositeIconSizes = [c["icon-size"].possiblyEvaluate(new e.EvaluationParameters(m)), c["icon-size"].possiblyEvaluate(new e.EvaluationParameters(g))]
              }
              u.layoutTextSize = c["text-size"].possiblyEvaluate(new e.EvaluationParameters(t.zoom + 1)),
              u.layoutIconSize = c["icon-size"].possiblyEvaluate(new e.EvaluationParameters(t.zoom + 1)),
              u.textMaxSize = c["text-size"].possiblyEvaluate(new e.EvaluationParameters(18));
              for (var v = 24 * l.get("text-line-height"), y = "map" === l.get("text-rotation-alignment") && "point" !== l.get("symbol-placement"), _ = l.get("text-keep-upright"), b = 0, w = t.features; b < w.length; b += 1) {
                  var k = w[b]
                    , S = l.get("text-font").evaluate(k, {}).join(",")
                    , E = n
                    , T = {}
                    , C = k.text;
                  if (C) {
                      var L = C.toString()
                        , A = l.get("text-offset").evaluate(k, {}).map(function(e) {
                          return 24 * e
                      })
                        , P = 24 * l.get("text-letter-spacing").evaluate(k, {})
                        , I = e.allowsLetterSpacing(L) ? P : 0
                        , M = l.get("text-anchor").evaluate(k, {})
                        , O = l.get("text-justify").evaluate(k, {})
                        , z = "point" === l.get("symbol-placement") ? 24 * l.get("text-max-width").evaluate(k, {}) : 0;
                      T.horizontal = e.shapeText(C, i, S, z, v, M, O, I, A, 24, e.WritingMode.horizontal),
                      e.allowsVerticalWritingMode(L) && y && _ && (T.vertical = e.shapeText(C, i, S, z, v, M, O, I, A, 24, e.WritingMode.vertical))
                  }
                  var D = void 0;
                  if (k.icon) {
                      var R = r[k.icon];
                      R && (D = e.shapeIcon(o[k.icon], l.get("icon-offset").evaluate(k, {}), l.get("icon-anchor").evaluate(k, {})),
                      void 0 === t.sdfIcons ? t.sdfIcons = R.sdf : t.sdfIcons !== R.sdf && e.warnOnce("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"),
                      R.pixelRatio !== t.pixelRatio ? t.iconsNeedLinear = !0 : 0 !== l.get("icon-rotate").constantOr(1) && (t.iconsNeedLinear = !0))
                  }
                  (T.horizontal || D) && x(t, k, T, D, E, u)
              }
              s && t.generateCollisionDebugBuffers()
          }
          function x(t, i, n, r, o, s) {
              var a = s.layoutTextSize.evaluate(i, {})
                , h = s.layoutIconSize.evaluate(i, {})
                , d = s.textMaxSize.evaluate(i, {});
              void 0 === d && (d = a);
              var f = t.layers[0].layout
                , m = f.get("text-offset").evaluate(i, {})
                , g = f.get("icon-offset").evaluate(i, {})
                , v = a / 24
                , _ = t.tilePixelRatio * v
                , b = t.tilePixelRatio * d / 24
                , w = t.tilePixelRatio * h
                , x = t.tilePixelRatio * f.get("symbol-spacing")
                , T = f.get("text-padding") * t.tilePixelRatio
                , C = f.get("icon-padding") * t.tilePixelRatio
                , L = f.get("text-max-angle") / 180 * Math.PI
                , A = "map" === f.get("text-rotation-alignment") && "point" !== f.get("symbol-placement")
                , P = "map" === f.get("icon-rotation-alignment") && "point" !== f.get("symbol-placement")
                , I = f.get("symbol-placement")
                , M = x / 2
                , O = function(a, l) {
                  l.x < 0 || l.x >= e.EXTENT || l.y < 0 || l.y >= e.EXTENT || function(t, i, n, r, o, s, a, l, c, h, d, p, f, m, g, v, _, b, w, x, E) {
                      var T, C, L = t.addToLineVertexArray(i, n), A = 0, P = 0, I = 0, M = y(r.horizontal ? r.horizontal.text : ""), O = [];
                      if (r.horizontal) {
                          var z = s.layout.get("text-rotate").evaluate(w, {});
                          T = new u(a,n,i,l,c,h,r.horizontal,d,p,f,t.overscaling,z),
                          P += S(t, i, r.horizontal, s, f, w, m, L, r.vertical ? e.WritingMode.horizontal : e.WritingMode.horizontalOnly, O, x, E),
                          r.vertical && (I += S(t, i, r.vertical, s, f, w, m, L, e.WritingMode.vertical, O, x, E))
                      }
                      var D = T ? T.boxStartIndex : t.collisionBoxArray.length
                        , R = T ? T.boxEndIndex : t.collisionBoxArray.length;
                      if (o) {
                          var B = function(t, i, n, r, o, s) {
                              var a, l, c, u, h = i.image, d = n.layout, p = i.top - 1 / h.pixelRatio, f = i.left - 1 / h.pixelRatio, m = i.bottom + 1 / h.pixelRatio, g = i.right + 1 / h.pixelRatio;
                              if ("none" !== d.get("icon-text-fit") && o) {
                                  var v = g - f
                                    , y = m - p
                                    , _ = d.get("text-size").evaluate(s, {}) / 24
                                    , b = o.left * _
                                    , w = o.right * _
                                    , x = o.top * _
                                    , k = w - b
                                    , S = o.bottom * _ - x
                                    , E = d.get("icon-text-fit-padding")[0]
                                    , T = d.get("icon-text-fit-padding")[1]
                                    , C = d.get("icon-text-fit-padding")[2]
                                    , L = d.get("icon-text-fit-padding")[3]
                                    , A = "width" === d.get("icon-text-fit") ? .5 * (S - y) : 0
                                    , P = "height" === d.get("icon-text-fit") ? .5 * (k - v) : 0
                                    , I = "width" === d.get("icon-text-fit") || "both" === d.get("icon-text-fit") ? k : v
                                    , M = "height" === d.get("icon-text-fit") || "both" === d.get("icon-text-fit") ? S : y;
                                  a = new e.Point(b + P - L,x + A - E),
                                  l = new e.Point(b + P + T + I,x + A - E),
                                  c = new e.Point(b + P + T + I,x + A + C + M),
                                  u = new e.Point(b + P - L,x + A + C + M)
                              } else
                                  a = new e.Point(f,p),
                                  l = new e.Point(g,p),
                                  c = new e.Point(g,m),
                                  u = new e.Point(f,m);
                              var O = n.layout.get("icon-rotate").evaluate(s, {}) * Math.PI / 180;
                              if (O) {
                                  var z = Math.sin(O)
                                    , D = Math.cos(O)
                                    , R = [D, -z, z, D];
                                  a._matMult(R),
                                  l._matMult(R),
                                  u._matMult(R),
                                  c._matMult(R)
                              }
                              return [{
                                  tl: a,
                                  tr: l,
                                  bl: u,
                                  br: c,
                                  tex: h.paddedRect,
                                  writingMode: void 0,
                                  glyphOffset: [0, 0]
                              }]
                          }(0, o, s, 0, r.horizontal, w)
                            , j = s.layout.get("icon-rotate").evaluate(w, {});
                          C = new u(a,n,i,l,c,h,o,g,v,!1,t.overscaling,j),
                          A = 4 * B.length;
                          var F = t.iconSizeData
                            , N = null;
                          "source" === F.functionType ? (N = [e.SIZE_PACK_FACTOR * s.layout.get("icon-size").evaluate(w, {})])[0] > k && e.warnOnce(t.layerIds[0] + ': Value for "icon-size" is >= 256. Reduce your "icon-size".') : "composite" === F.functionType && ((N = [e.SIZE_PACK_FACTOR * E.compositeIconSizes[0].evaluate(w, {}), e.SIZE_PACK_FACTOR * E.compositeIconSizes[1].evaluate(w, {})])[0] > k || N[1] > k) && e.warnOnce(t.layerIds[0] + ': Value for "icon-size" is >= 256. Reduce your "icon-size".'),
                          t.addSymbols(t.icon, B, N, b, _, w, !1, i, L.lineStartIndex, L.lineLength)
                      }
                      var U = C ? C.boxStartIndex : t.collisionBoxArray.length
                        , q = C ? C.boxEndIndex : t.collisionBoxArray.length;
                      t.glyphOffsetArray.length >= e.SymbolBucket.MAX_GLYPHS && e.warnOnce("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"),
                      t.symbolInstances.emplaceBack(i.x, i.y, O.length > 0 ? O[0] : -1, O.length > 1 ? O[1] : -1, M, D, R, U, q, l, P, I, A, 0)
                  }(t, l, a, n, r, t.layers[0], t.collisionBoxArray, i.index, i.sourceLayerIndex, t.index, _, T, A, m, w, C, P, g, i, o, s)
              };
              if ("line" === I)
                  for (var z = 0, D = function(t, i, n, r, o) {
                      for (var s = [], a = 0; a < t.length; a++)
                          for (var l = t[a], c = void 0, u = 0; u < l.length - 1; u++) {
                              var h = l[u]
                                , d = l[u + 1];
                              h.x < 0 && d.x < 0 || (h.x < 0 ? h = new e.Point(0,h.y + (d.y - h.y) * ((0 - h.x) / (d.x - h.x)))._round() : d.x < 0 && (d = new e.Point(0,h.y + (d.y - h.y) * ((0 - h.x) / (d.x - h.x)))._round()),
                              h.y < 0 && d.y < 0 || (h.y < 0 ? h = new e.Point(h.x + (d.x - h.x) * ((0 - h.y) / (d.y - h.y)),0)._round() : d.y < 0 && (d = new e.Point(h.x + (d.x - h.x) * ((0 - h.y) / (d.y - h.y)),0)._round()),
                              h.x >= r && d.x >= r || (h.x >= r ? h = new e.Point(r,h.y + (d.y - h.y) * ((r - h.x) / (d.x - h.x)))._round() : d.x >= r && (d = new e.Point(r,h.y + (d.y - h.y) * ((r - h.x) / (d.x - h.x)))._round()),
                              h.y >= o && d.y >= o || (h.y >= o ? h = new e.Point(h.x + (d.x - h.x) * ((o - h.y) / (d.y - h.y)),o)._round() : d.y >= o && (d = new e.Point(h.x + (d.x - h.x) * ((o - h.y) / (d.y - h.y)),o)._round()),
                              c && h.equals(c[c.length - 1]) || (c = [h],
                              s.push(c)),
                              c.push(d)))))
                          }
                      return s
                  }(i.geometry, 0, 0, e.EXTENT, e.EXTENT); z < D.length; z += 1)
                      for (var R = D[z], B = 0, j = c(R, x, L, n.vertical || n.horizontal, r, 24, b, t.overscaling, e.EXTENT); B < j.length; B += 1) {
                          var F = j[B]
                            , N = n.horizontal;
                          N && E(t, N.text, M, F) || O(R, F)
                      }
              else if ("line-center" === I)
                  for (var U = 0, q = i.geometry; U < q.length; U += 1) {
                      var H = q[U];
                      if (H.length > 1) {
                          var V = l(H, L, n.vertical || n.horizontal, r, 24, b);
                          V && O(H, V)
                      }
                  }
              else if ("Polygon" === i.type)
                  for (var W = 0, $ = e.classifyRings(i.geometry, 0); W < $.length; W += 1) {
                      var G = $[W]
                        , X = p(G, 16);
                      O(G[0], new e.Anchor(X.x,X.y,0))
                  }
              else if ("LineString" === i.type)
                  for (var Z = 0, Y = i.geometry; Z < Y.length; Z += 1) {
                      var K = Y[Z];
                      O(K, new e.Anchor(K[0].x,K[0].y,0))
                  }
              else if ("Point" === i.type)
                  for (var J = 0, Q = i.geometry; J < Q.length; J += 1)
                      for (var ee = 0, te = Q[J]; ee < te.length; ee += 1) {
                          var ie = te[ee];
                          O([ie], new e.Anchor(ie.x,ie.y,0))
                      }
          }
          y.murmur3 = _,
          y.murmur2 = b;
          var k = 65535;
          function S(t, i, n, r, o, s, a, l, c, u, h, d) {
              var p = function(t, i, n, r, o, s) {
                  for (var a = n.layout.get("text-rotate").evaluate(o, {}) * Math.PI / 180, l = n.layout.get("text-offset").evaluate(o, {}).map(function(e) {
                      return 24 * e
                  }), c = i.positionedGlyphs, u = [], h = 0; h < c.length; h++) {
                      var d = c[h]
                        , p = s[d.fontStack]
                        , f = p && p[d.glyph];
                      if (f) {
                          var m = f.rect;
                          if (m) {
                              var g = e.GLYPH_PBF_BORDER + 1
                                , v = f.metrics.advance * d.scale / 2
                                , y = r ? [d.x + v, d.y] : [0, 0]
                                , _ = r ? [0, 0] : [d.x + v + l[0], d.y + l[1]]
                                , b = (f.metrics.left - g) * d.scale - v + _[0]
                                , w = (-f.metrics.top - g) * d.scale + _[1]
                                , x = b + m.w * d.scale
                                , k = w + m.h * d.scale
                                , S = new e.Point(b,w)
                                , E = new e.Point(x,w)
                                , T = new e.Point(b,k)
                                , C = new e.Point(x,k);
                              if (r && d.vertical) {
                                  var L = new e.Point(-v,v)
                                    , A = -Math.PI / 2
                                    , P = new e.Point(5,0);
                                  S._rotateAround(A, L)._add(P),
                                  E._rotateAround(A, L)._add(P),
                                  T._rotateAround(A, L)._add(P),
                                  C._rotateAround(A, L)._add(P)
                              }
                              if (a) {
                                  var I = Math.sin(a)
                                    , M = Math.cos(a)
                                    , O = [M, -I, I, M];
                                  S._matMult(O),
                                  E._matMult(O),
                                  T._matMult(O),
                                  C._matMult(O)
                              }
                              u.push({
                                  tl: S,
                                  tr: E,
                                  bl: T,
                                  br: C,
                                  tex: m,
                                  writingMode: i.writingMode,
                                  glyphOffset: y
                              })
                          }
                      }
                  }
                  return u
              }(0, n, r, o, s, h)
                , f = t.textSizeData
                , m = null;
              return "source" === f.functionType ? (m = [e.SIZE_PACK_FACTOR * r.layout.get("text-size").evaluate(s, {})])[0] > k && e.warnOnce(t.layerIds[0] + ': Value for "text-size" is >= 256. Reduce your "text-size".') : "composite" === f.functionType && ((m = [e.SIZE_PACK_FACTOR * d.compositeTextSizes[0].evaluate(s, {}), e.SIZE_PACK_FACTOR * d.compositeTextSizes[1].evaluate(s, {})])[0] > k || m[1] > k) && e.warnOnce(t.layerIds[0] + ': Value for "text-size" is >= 256. Reduce your "text-size".'),
              t.addSymbols(t.text, p, m, a, o, s, c, i, l.lineStartIndex, l.lineLength),
              u.push(t.text.placedSymbolArray.length - 1),
              4 * p.length
          }
          function E(e, t, i, n) {
              var r = e.compareText;
              if (t in r) {
                  for (var o = r[t], s = o.length - 1; s >= 0; s--)
                      if (n.dist(o[s]) < i)
                          return !0
              } else
                  r[t] = [];
              return r[t].push(n),
              !1
          }
          var T = function(t) {
              var i = {}
                , n = [];
              for (var r in t) {
                  var o = t[r]
                    , s = i[r] = {};
                  for (var a in o) {
                      var l = o[+a];
                      if (l && 0 !== l.bitmap.width && 0 !== l.bitmap.height) {
                          var c = {
                              x: 0,
                              y: 0,
                              w: l.bitmap.width + 2,
                              h: l.bitmap.height + 2
                          };
                          n.push(c),
                          s[a] = {
                              rect: c,
                              metrics: l.metrics
                          }
                      }
                  }
              }
              var u = e.potpack(n)
                , h = u.w
                , d = u.h
                , p = new e.AlphaImage({
                  width: h || 1,
                  height: d || 1
              });
              for (var f in t) {
                  var m = t[f];
                  for (var g in m) {
                      var v = m[+g];
                      if (v && 0 !== v.bitmap.width && 0 !== v.bitmap.height) {
                          var y = i[f][g].rect;
                          e.AlphaImage.copy(v.bitmap, p, {
                              x: 0,
                              y: 0
                          }, {
                              x: y.x + 1,
                              y: y.y + 1
                          }, v.bitmap)
                      }
                  }
              }
              this.image = p,
              this.positions = i
          };
          e.register("GlyphAtlas", T);
          var C = function(t) {
              this.tileID = new e.OverscaledTileID(t.tileID.overscaledZ,t.tileID.wrap,t.tileID.canonical.z,t.tileID.canonical.x,t.tileID.canonical.y),
              this.uid = t.uid,
              this.zoom = t.zoom,
              this.pixelRatio = t.pixelRatio,
              this.tileSize = t.tileSize,
              this.source = t.source,
              this.overscaling = this.tileID.overscaleFactor(),
              this.showCollisionBoxes = t.showCollisionBoxes,
              this.collectResourceTiming = !!t.collectResourceTiming,
              this.returnDependencies = !!t.returnDependencies
          };
          function L(t, i) {
              for (var n = new e.EvaluationParameters(i), r = 0, o = t; r < o.length; r += 1)
                  o[r].recalculate(n)
          }
          C.prototype.parse = function(t, i, n, r) {
              var o = this;
              this.status = "parsing",
              this.data = t,
              this.collisionBoxArray = new e.CollisionBoxArray;
              var s = new e.DictionaryCoder(Object.keys(t.layers).sort())
                , a = new e.FeatureIndex(this.tileID);
              a.bucketLayerIDs = [];
              var l, c, u, h, d = {}, p = {
                  featureIndex: a,
                  iconDependencies: {},
                  patternDependencies: {},
                  glyphDependencies: {}
              }, f = i.familiesBySource[this.source];
              for (var m in f) {
                  var g = t.layers[m];
                  if (g) {
                      1 === g.version && e.warnOnce('Vector tile source "' + this.source + '" layer "' + m + '" does not use vector tile spec v2 and therefore may have some rendering errors.');
                      for (var v = s.encode(m), y = [], _ = 0; _ < g.length; _++) {
                          var b = g.feature(_);
                          y.push({
                              feature: b,
                              index: _,
                              sourceLayerIndex: v
                          })
                      }
                      for (var x = 0, k = f[m]; x < k.length; x += 1) {
                          var S = k[x]
                            , E = S[0];
                          E.minzoom && this.zoom < Math.floor(E.minzoom) || E.maxzoom && this.zoom >= E.maxzoom || "none" !== E.visibility && (L(S, this.zoom),
                          (d[E.id] = E.createBucket({
                              index: a.bucketLayerIDs.length,
                              layers: S,
                              zoom: this.zoom,
                              pixelRatio: this.pixelRatio,
                              overscaling: this.overscaling,
                              collisionBoxArray: this.collisionBoxArray,
                              sourceLayerIndex: v,
                              sourceID: this.source
                          })).populate(y, p),
                          a.bucketLayerIDs.push(S.map(function(e) {
                              return e.id
                          })))
                      }
                  }
              }
              var C = e.mapObject(p.glyphDependencies, function(e) {
                  return Object.keys(e).map(Number)
              });
              Object.keys(C).length ? n.send("getGlyphs", {
                  uid: this.uid,
                  stacks: C
              }, function(e, t) {
                  l || (l = e,
                  c = t,
                  I.call(o))
              }) : c = {};
              var A = Object.keys(p.iconDependencies);
              A.length ? n.send("getImages", {
                  icons: A
              }, function(e, t) {
                  l || (l = e,
                  u = t,
                  I.call(o))
              }) : u = {};
              var P = Object.keys(p.patternDependencies);
              function I() {
                  if (l)
                      return r(l);
                  if (c && u && h) {
                      var t = new T(c)
                        , i = new e.ImageAtlas(u,h);
                      for (var n in d) {
                          var o = d[n];
                          o instanceof e.SymbolBucket ? (L(o.layers, this.zoom),
                          w(o, c, t.positions, u, i.iconPositions, this.showCollisionBoxes)) : o.hasPattern && (o instanceof e.LineBucket || o instanceof e.FillBucket || o instanceof e.FillExtrusionBucket) && (L(o.layers, this.zoom),
                          o.addFeatures(p, i.patternPositions))
                      }
                      this.status = "done",
                      r(null, {
                          buckets: e.values(d).filter(function(e) {
                              return !e.isEmpty()
                          }),
                          featureIndex: a,
                          collisionBoxArray: this.collisionBoxArray,
                          glyphAtlasImage: t.image,
                          imageAtlas: i,
                          glyphMap: this.returnDependencies ? c : null,
                          iconMap: this.returnDependencies ? u : null,
                          glyphPositions: this.returnDependencies ? t.positions : null
                      })
                  }
              }
              P.length ? n.send("getImages", {
                  icons: P
              }, function(e, t) {
                  l || (l = e,
                  h = t,
                  I.call(o))
              }) : h = {},
              I.call(this)
          }
          ;
          var A = "undefined" != typeof performance
            , P = {
              getEntriesByName: function(e) {
                  return !!(A && performance && performance.getEntriesByName) && performance.getEntriesByName(e)
              },
              mark: function(e) {
                  return !!(A && performance && performance.mark) && performance.mark(e)
              },
              measure: function(e, t, i) {
                  return !!(A && performance && performance.measure) && performance.measure(e, t, i)
              },
              clearMarks: function(e) {
                  return !!(A && performance && performance.clearMarks) && performance.clearMarks(e)
              },
              clearMeasures: function(e) {
                  return !!(A && performance && performance.clearMeasures) && performance.clearMeasures(e)
              }
          }
            , I = function(e) {
              this._marks = {
                  start: [e.url, "start"].join("#"),
                  end: [e.url, "end"].join("#"),
                  measure: e.url.toString()
              },
              P.mark(this._marks.start)
          };
          function M(t, i) {
              var n = e.getArrayBuffer(t.request, function(t, n, r, o) {
                  t ? i(t) : n && i(null, {
                      vectorTile: new e.mvt.VectorTile(new e.Protobuf(n)),
                      rawData: n,
                      cacheControl: r,
                      expires: o
                  })
              });
              return function() {
                  n.cancel(),
                  i()
              }
          }
          I.prototype.finish = function() {
              P.mark(this._marks.end);
              var e = P.getEntriesByName(this._marks.measure);
              return 0 === e.length && (P.measure(this._marks.measure, this._marks.start, this._marks.end),
              e = P.getEntriesByName(this._marks.measure),
              P.clearMarks(this._marks.start),
              P.clearMarks(this._marks.end),
              P.clearMeasures(this._marks.measure)),
              e
          }
          ,
          P.Performance = I;
          var O = function(e, t, i) {
              this.actor = e,
              this.layerIndex = t,
              this.loadVectorData = i || M,
              this.loading = {},
              this.loaded = {}
          };
          O.prototype.loadTile = function(t, i) {
              var n = this
                , r = t.uid;
              this.loading || (this.loading = {});
              var o = !!(t && t.request && t.request.collectResourceTiming) && new P.Performance(t.request)
                , s = this.loading[r] = new C(t);
              s.abort = this.loadVectorData(t, function(t, a) {
                  if (delete n.loading[r],
                  t || !a)
                      return s.status = "done",
                      n.loaded[r] = s,
                      i(t);
                  var l = a.rawData
                    , c = {};
                  a.expires && (c.expires = a.expires),
                  a.cacheControl && (c.cacheControl = a.cacheControl);
                  var u = {};
                  if (o) {
                      var h = o.finish();
                      h && (u.resourceTiming = JSON.parse(JSON.stringify(h)))
                  }
                  s.vectorTile = a.vectorTile,
                  s.parse(a.vectorTile, n.layerIndex, n.actor, function(t, n) {
                      if (t || !n)
                          return i(t);
                      i(null, e.extend({
                          rawTileData: l.slice(0)
                      }, n, c, u))
                  }),
                  n.loaded = n.loaded || {},
                  n.loaded[r] = s
              })
          }
          ,
          O.prototype.reloadTile = function(e, t) {
              var i = this.loaded
                , n = e.uid
                , r = this;
              if (i && i[n]) {
                  var o = i[n];
                  o.showCollisionBoxes = e.showCollisionBoxes;
                  var s = function(e, i) {
                      var n = o.reloadCallback;
                      n && (delete o.reloadCallback,
                      o.parse(o.vectorTile, r.layerIndex, r.actor, n)),
                      t(e, i)
                  };
                  "parsing" === o.status ? o.reloadCallback = s : "done" === o.status && (o.vectorTile ? o.parse(o.vectorTile, this.layerIndex, this.actor, s) : s())
              }
          }
          ,
          O.prototype.abortTile = function(e, t) {
              var i = this.loading
                , n = e.uid;
              i && i[n] && i[n].abort && (i[n].abort(),
              delete i[n]),
              t()
          }
          ,
          O.prototype.removeTile = function(e, t) {
              var i = this.loaded
                , n = e.uid;
              i && i[n] && delete i[n],
              t()
          }
          ;
          var z = function() {
              this.loaded = {}
          };
          z.prototype.loadTile = function(t, i) {
              var n = t.uid
                , r = t.encoding
                , o = t.rawImageData
                , s = new e.DEMData(n,o,r);
              this.loaded = this.loaded || {},
              this.loaded[n] = s,
              i(null, s)
          }
          ,
          z.prototype.removeTile = function(e) {
              var t = this.loaded
                , i = e.uid;
              t && t[i] && delete t[i]
          }
          ;
          var D = {
              RADIUS: 6378137,
              FLATTENING: 1 / 298.257223563,
              POLAR_RADIUS: 6356752.3142
          };
          function R(e) {
              var t = 0;
              if (e && e.length > 0) {
                  t += Math.abs(B(e[0]));
                  for (var i = 1; i < e.length; i++)
                      t -= Math.abs(B(e[i]))
              }
              return t
          }
          function B(e) {
              var t, i, n, r, o, s, a = 0, l = e.length;
              if (l > 2) {
                  for (s = 0; s < l; s++)
                      s === l - 2 ? (n = l - 2,
                      r = l - 1,
                      o = 0) : s === l - 1 ? (n = l - 1,
                      r = 0,
                      o = 1) : (n = s,
                      r = s + 1,
                      o = s + 2),
                      t = e[n],
                      i = e[r],
                      a += (j(e[o][0]) - j(t[0])) * Math.sin(j(i[1]));
                  a = a * D.RADIUS * D.RADIUS / 2
              }
              return a
          }
          function j(e) {
              return e * Math.PI / 180
          }
          var F = {
              geometry: function e(t) {
                  var i, n = 0;
                  switch (t.type) {
                  case "Polygon":
                      return R(t.coordinates);
                  case "MultiPolygon":
                      for (i = 0; i < t.coordinates.length; i++)
                          n += R(t.coordinates[i]);
                      return n;
                  case "Point":
                  case "MultiPoint":
                  case "LineString":
                  case "MultiLineString":
                      return 0;
                  case "GeometryCollection":
                      for (i = 0; i < t.geometries.length; i++)
                          n += e(t.geometries[i]);
                      return n
                  }
              },
              ring: B
          };
          function N(e, t) {
              return function(i) {
                  return e(i, t)
              }
          }
          function U(e, t) {
              t = !!t,
              e[0] = q(e[0], t);
              for (var i = 1; i < e.length; i++)
                  e[i] = q(e[i], !t);
              return e
          }
          function q(e, t) {
              return function(e) {
                  return F.ring(e) >= 0
              }(e) === t ? e : e.reverse()
          }
          var H = e.mvt.VectorTileFeature.prototype.toGeoJSON
            , V = function(t) {
              this._feature = t,
              this.extent = e.EXTENT,
              this.type = t.type,
              this.properties = t.tags,
              "id"in t && !isNaN(t.id) && (this.id = parseInt(t.id, 10))
          };
          V.prototype.loadGeometry = function() {
              if (1 === this._feature.type) {
                  for (var t = [], i = 0, n = this._feature.geometry; i < n.length; i += 1) {
                      var r = n[i];
                      t.push([new e.Point(r[0],r[1])])
                  }
                  return t
              }
              for (var o = [], s = 0, a = this._feature.geometry; s < a.length; s += 1) {
                  for (var l = [], c = 0, u = a[s]; c < u.length; c += 1) {
                      var h = u[c];
                      l.push(new e.Point(h[0],h[1]))
                  }
                  o.push(l)
              }
              return o
          }
          ,
          V.prototype.toGeoJSON = function(e, t, i) {
              return H.call(this, e, t, i)
          }
          ;
          var W = function(t) {
              this.layers = {
                  _geojsonTileLayer: this
              },
              this.name = "_geojsonTileLayer",
              this.extent = e.EXTENT,
              this.length = t.length,
              this._features = t
          };
          W.prototype.feature = function(e) {
              return new V(this._features[e])
          }
          ;
          var $ = e.vectorTile.VectorTileFeature
            , G = X;
          function X(e, t) {
              this.options = t || {},
              this.features = e,
              this.length = e.length
          }
          function Z(e, t) {
              this.id = "number" == typeof e.id ? e.id : void 0,
              this.type = e.type,
              this.rawGeometry = 1 === e.type ? [e.geometry] : e.geometry,
              this.properties = e.tags,
              this.extent = t || 4096
          }
          X.prototype.feature = function(e) {
              return new Z(this.features[e],this.options.extent)
          }
          ,
          Z.prototype.loadGeometry = function() {
              var t = this.rawGeometry;
              this.geometry = [];
              for (var i = 0; i < t.length; i++) {
                  for (var n = t[i], r = [], o = 0; o < n.length; o++)
                      r.push(new e.Point$1(n[o][0],n[o][1]));
                  this.geometry.push(r)
              }
              return this.geometry
          }
          ,
          Z.prototype.bbox = function() {
              this.geometry || this.loadGeometry();
              for (var e = this.geometry, t = 1 / 0, i = -1 / 0, n = 1 / 0, r = -1 / 0, o = 0; o < e.length; o++)
                  for (var s = e[o], a = 0; a < s.length; a++) {
                      var l = s[a];
                      t = Math.min(t, l.x),
                      i = Math.max(i, l.x),
                      n = Math.min(n, l.y),
                      r = Math.max(r, l.y)
                  }
              return [t, n, i, r]
          }
          ,
          Z.prototype.toGeoJSON = $.prototype.toGeoJSON;
          var Y = Q
            , K = Q
            , J = G;
          function Q(t) {
              var i = new e.pbf;
              return function(e, t) {
                  for (var i in e.layers)
                      t.writeMessage(3, ee, e.layers[i])
              }(t, i),
              i.finish()
          }
          function ee(e, t) {
              var i;
              t.writeVarintField(15, e.version || 1),
              t.writeStringField(1, e.name || ""),
              t.writeVarintField(5, e.extent || 4096);
              var n = {
                  keys: [],
                  values: [],
                  keycache: {},
                  valuecache: {}
              };
              for (i = 0; i < e.length; i++)
                  n.feature = e.feature(i),
                  t.writeMessage(2, te, n);
              var r = n.keys;
              for (i = 0; i < r.length; i++)
                  t.writeStringField(3, r[i]);
              var o = n.values;
              for (i = 0; i < o.length; i++)
                  t.writeMessage(4, se, o[i])
          }
          function te(e, t) {
              var i = e.feature;
              void 0 !== i.id && t.writeVarintField(1, i.id),
              t.writeMessage(2, ie, e),
              t.writeVarintField(3, i.type),
              t.writeMessage(4, oe, i)
          }
          function ie(e, t) {
              var i = e.feature
                , n = e.keys
                , r = e.values
                , o = e.keycache
                , s = e.valuecache;
              for (var a in i.properties) {
                  var l = o[a];
                  void 0 === l && (n.push(a),
                  l = n.length - 1,
                  o[a] = l),
                  t.writeVarint(l);
                  var c = i.properties[a]
                    , u = typeof c;
                  "string" !== u && "boolean" !== u && "number" !== u && (c = JSON.stringify(c));
                  var h = u + ":" + c
                    , d = s[h];
                  void 0 === d && (r.push(c),
                  d = r.length - 1,
                  s[h] = d),
                  t.writeVarint(d)
              }
          }
          function ne(e, t) {
              return (t << 3) + (7 & e)
          }
          function re(e) {
              return e << 1 ^ e >> 31
          }
          function oe(e, t) {
              for (var i = e.loadGeometry(), n = e.type, r = 0, o = 0, s = i.length, a = 0; a < s; a++) {
                  var l = i[a]
                    , c = 1;
                  1 === n && (c = l.length),
                  t.writeVarint(ne(1, c));
                  for (var u = 3 === n ? l.length - 1 : l.length, h = 0; h < u; h++) {
                      1 === h && 1 !== n && t.writeVarint(ne(2, u - 1));
                      var d = l[h].x - r
                        , p = l[h].y - o;
                      t.writeVarint(re(d)),
                      t.writeVarint(re(p)),
                      r += d,
                      o += p
                  }
                  3 === n && t.writeVarint(ne(7, 1))
              }
          }
          function se(e, t) {
              var i = typeof e;
              "string" === i ? t.writeStringField(1, e) : "boolean" === i ? t.writeBooleanField(7, e) : "number" === i && (e % 1 != 0 ? t.writeDoubleField(3, e) : e < 0 ? t.writeSVarintField(6, e) : t.writeVarintField(5, e))
          }
          function ae(e, t, i, n) {
              le(e, i, n),
              le(t, 2 * i, 2 * n),
              le(t, 2 * i + 1, 2 * n + 1)
          }
          function le(e, t, i) {
              var n = e[t];
              e[t] = e[i],
              e[i] = n
          }
          function ce(e, t, i, n) {
              var r = e - i
                , o = t - n;
              return r * r + o * o
          }
          Y.fromVectorTileJs = K,
          Y.fromGeojsonVt = function(e, t) {
              t = t || {};
              var i = {};
              for (var n in e)
                  i[n] = new G(e[n].features,t),
                  i[n].name = n,
                  i[n].version = t.version,
                  i[n].extent = t.extent;
              return Q({
                  layers: i
              })
          }
          ,
          Y.GeoJSONWrapper = J;
          var ue = function(e) {
              return e[0]
          }
            , he = function(e) {
              return e[1]
          }
            , de = function(e, t, i, n, r) {
              void 0 === t && (t = ue),
              void 0 === i && (i = he),
              void 0 === n && (n = 64),
              void 0 === r && (r = Float64Array),
              this.nodeSize = n,
              this.points = e;
              for (var o = e.length < 65536 ? Uint16Array : Uint32Array, s = this.ids = new o(e.length), a = this.coords = new r(2 * e.length), l = 0; l < e.length; l++)
                  s[l] = l,
                  a[2 * l] = t(e[l]),
                  a[2 * l + 1] = i(e[l]);
              !function e(t, i, n, r, o, s) {
                  if (!(o - r <= n)) {
                      var a = r + o >> 1;
                      !function e(t, i, n, r, o, s) {
                          for (; o > r; ) {
                              if (o - r > 600) {
                                  var a = o - r + 1
                                    , l = n - r + 1
                                    , c = Math.log(a)
                                    , u = .5 * Math.exp(2 * c / 3)
                                    , h = .5 * Math.sqrt(c * u * (a - u) / a) * (l - a / 2 < 0 ? -1 : 1);
                                  e(t, i, n, Math.max(r, Math.floor(n - l * u / a + h)), Math.min(o, Math.floor(n + (a - l) * u / a + h)), s)
                              }
                              var d = i[2 * n + s]
                                , p = r
                                , f = o;
                              for (ae(t, i, r, n),
                              i[2 * o + s] > d && ae(t, i, r, o); p < f; ) {
                                  for (ae(t, i, p, f),
                                  p++,
                                  f--; i[2 * p + s] < d; )
                                      p++;
                                  for (; i[2 * f + s] > d; )
                                      f--
                              }
                              i[2 * r + s] === d ? ae(t, i, r, f) : ae(t, i, ++f, o),
                              f <= n && (r = f + 1),
                              n <= f && (o = f - 1)
                          }
                      }(t, i, a, r, o, s % 2),
                      e(t, i, n, r, a - 1, s + 1),
                      e(t, i, n, a + 1, o, s + 1)
                  }
              }(s, a, n, 0, s.length - 1, 0)
          };
          de.prototype.range = function(e, t, i, n) {
              return function(e, t, i, n, r, o, s) {
                  for (var a, l, c = [0, e.length - 1, 0], u = []; c.length; ) {
                      var h = c.pop()
                        , d = c.pop()
                        , p = c.pop();
                      if (d - p <= s)
                          for (var f = p; f <= d; f++)
                              a = t[2 * f],
                              l = t[2 * f + 1],
                              a >= i && a <= r && l >= n && l <= o && u.push(e[f]);
                      else {
                          var m = Math.floor((p + d) / 2);
                          a = t[2 * m],
                          l = t[2 * m + 1],
                          a >= i && a <= r && l >= n && l <= o && u.push(e[m]);
                          var g = (h + 1) % 2;
                          (0 === h ? i <= a : n <= l) && (c.push(p),
                          c.push(m - 1),
                          c.push(g)),
                          (0 === h ? r >= a : o >= l) && (c.push(m + 1),
                          c.push(d),
                          c.push(g))
                      }
                  }
                  return u
              }(this.ids, this.coords, e, t, i, n, this.nodeSize)
          }
          ,
          de.prototype.within = function(e, t, i) {
              return function(e, t, i, n, r, o) {
                  for (var s = [0, e.length - 1, 0], a = [], l = r * r; s.length; ) {
                      var c = s.pop()
                        , u = s.pop()
                        , h = s.pop();
                      if (u - h <= o)
                          for (var d = h; d <= u; d++)
                              ce(t[2 * d], t[2 * d + 1], i, n) <= l && a.push(e[d]);
                      else {
                          var p = Math.floor((h + u) / 2)
                            , f = t[2 * p]
                            , m = t[2 * p + 1];
                          ce(f, m, i, n) <= l && a.push(e[p]);
                          var g = (c + 1) % 2;
                          (0 === c ? i - r <= f : n - r <= m) && (s.push(h),
                          s.push(p - 1),
                          s.push(g)),
                          (0 === c ? i + r >= f : n + r >= m) && (s.push(p + 1),
                          s.push(u),
                          s.push(g))
                      }
                  }
                  return a
              }(this.ids, this.coords, e, t, i, this.nodeSize)
          }
          ;
          var pe = {
              minZoom: 0,
              maxZoom: 16,
              radius: 40,
              extent: 512,
              nodeSize: 64,
              log: !1,
              reduce: null,
              map: function(e) {
                  return e
              }
          }
            , fe = function(e) {
              this.options = we(Object.create(pe), e),
              this.trees = new Array(this.options.maxZoom + 1)
          };
          function me(e, t, i, n, r) {
              return {
                  x: e,
                  y: t,
                  zoom: 1 / 0,
                  id: i,
                  parentId: -1,
                  numPoints: n,
                  properties: r
              }
          }
          function ge(e, t) {
              var i = e.geometry.coordinates
                , n = i[0]
                , r = i[1];
              return {
                  x: _e(n),
                  y: be(r),
                  zoom: 1 / 0,
                  index: t,
                  parentId: -1
              }
          }
          function ve(e) {
              return {
                  type: "Feature",
                  id: e.id,
                  properties: ye(e),
                  geometry: {
                      type: "Point",
                      coordinates: [(n = e.x,
                      360 * (n - .5)), (t = e.y,
                      i = (180 - 360 * t) * Math.PI / 180,
                      360 * Math.atan(Math.exp(i)) / Math.PI - 90)]
                  }
              };
              var t, i, n
          }
          function ye(e) {
              var t = e.numPoints
                , i = t >= 1e4 ? Math.round(t / 1e3) + "k" : t >= 1e3 ? Math.round(t / 100) / 10 + "k" : t;
              return we(we({}, e.properties), {
                  cluster: !0,
                  cluster_id: e.id,
                  point_count: t,
                  point_count_abbreviated: i
              })
          }
          function _e(e) {
              return e / 360 + .5
          }
          function be(e) {
              var t = Math.sin(e * Math.PI / 180)
                , i = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
              return i < 0 ? 0 : i > 1 ? 1 : i
          }
          function we(e, t) {
              for (var i in t)
                  e[i] = t[i];
              return e
          }
          function xe(e) {
              return e.x
          }
          function ke(e) {
              return e.y
          }
          function Se(e, t, i, n, r, o) {
              var s = r - i
                , a = o - n;
              if (0 !== s || 0 !== a) {
                  var l = ((e - i) * s + (t - n) * a) / (s * s + a * a);
                  l > 1 ? (i = r,
                  n = o) : l > 0 && (i += s * l,
                  n += a * l)
              }
              return (s = e - i) * s + (a = t - n) * a
          }
          function Ee(e, t, i, n) {
              var r = {
                  id: void 0 === e ? null : e,
                  type: t,
                  geometry: i,
                  tags: n,
                  minX: 1 / 0,
                  minY: 1 / 0,
                  maxX: -1 / 0,
                  maxY: -1 / 0
              };
              return function(e) {
                  var t = e.geometry
                    , i = e.type;
                  if ("Point" === i || "MultiPoint" === i || "LineString" === i)
                      Te(e, t);
                  else if ("Polygon" === i || "MultiLineString" === i)
                      for (var n = 0; n < t.length; n++)
                          Te(e, t[n]);
                  else if ("MultiPolygon" === i)
                      for (n = 0; n < t.length; n++)
                          for (var r = 0; r < t[n].length; r++)
                              Te(e, t[n][r])
              }(r),
              r
          }
          function Te(e, t) {
              for (var i = 0; i < t.length; i += 3)
                  e.minX = Math.min(e.minX, t[i]),
                  e.minY = Math.min(e.minY, t[i + 1]),
                  e.maxX = Math.max(e.maxX, t[i]),
                  e.maxY = Math.max(e.maxY, t[i + 1])
          }
          function Ce(e, t, i, n) {
              if (t.geometry) {
                  var r = t.geometry.coordinates
                    , o = t.geometry.type
                    , s = Math.pow(i.tolerance / ((1 << i.maxZoom) * i.extent), 2)
                    , a = []
                    , l = t.id;
                  if (i.promoteId ? l = t.properties[i.promoteId] : i.generateId && (l = n || 0),
                  "Point" === o)
                      Le(r, a);
                  else if ("MultiPoint" === o)
                      for (var c = 0; c < r.length; c++)
                          Le(r[c], a);
                  else if ("LineString" === o)
                      Ae(r, a, s, !1);
                  else if ("MultiLineString" === o) {
                      if (i.lineMetrics) {
                          for (c = 0; c < r.length; c++)
                              a = [],
                              Ae(r[c], a, s, !1),
                              e.push(Ee(l, "LineString", a, t.properties));
                          return
                      }
                      Pe(r, a, s, !1)
                  } else if ("Polygon" === o)
                      Pe(r, a, s, !0);
                  else {
                      if ("MultiPolygon" !== o) {
                          if ("GeometryCollection" === o) {
                              for (c = 0; c < t.geometry.geometries.length; c++)
                                  Ce(e, {
                                      id: l,
                                      geometry: t.geometry.geometries[c],
                                      properties: t.properties
                                  }, i, n);
                              return
                          }
                          throw new Error("Input data is not a valid GeoJSON object.")
                      }
                      for (c = 0; c < r.length; c++) {
                          var u = [];
                          Pe(r[c], u, s, !0),
                          a.push(u)
                      }
                  }
                  e.push(Ee(l, o, a, t.properties))
              }
          }
          function Le(e, t) {
              t.push(Ie(e[0])),
              t.push(Me(e[1])),
              t.push(0)
          }
          function Ae(e, t, i, n) {
              for (var r, o, s = 0, a = 0; a < e.length; a++) {
                  var l = Ie(e[a][0])
                    , c = Me(e[a][1]);
                  t.push(l),
                  t.push(c),
                  t.push(0),
                  a > 0 && (s += n ? (r * c - l * o) / 2 : Math.sqrt(Math.pow(l - r, 2) + Math.pow(c - o, 2))),
                  r = l,
                  o = c
              }
              var u = t.length - 3;
              t[2] = 1,
              function e(t, i, n, r) {
                  for (var o, s = r, a = n - i >> 1, l = n - i, c = t[i], u = t[i + 1], h = t[n], d = t[n + 1], p = i + 3; p < n; p += 3) {
                      var f = Se(t[p], t[p + 1], c, u, h, d);
                      if (f > s)
                          o = p,
                          s = f;
                      else if (f === s) {
                          var m = Math.abs(p - a);
                          m < l && (o = p,
                          l = m)
                      }
                  }
                  s > r && (o - i > 3 && e(t, i, o, r),
                  t[o + 2] = s,
                  n - o > 3 && e(t, o, n, r))
              }(t, 0, u, i),
              t[u + 2] = 1,
              t.size = Math.abs(s),
              t.start = 0,
              t.end = t.size
          }
          function Pe(e, t, i, n) {
              for (var r = 0; r < e.length; r++) {
                  var o = [];
                  Ae(e[r], o, i, n),
                  t.push(o)
              }
          }
          function Ie(e) {
              return e / 360 + .5
          }
          function Me(e) {
              var t = Math.sin(e * Math.PI / 180)
                , i = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
              return i < 0 ? 0 : i > 1 ? 1 : i
          }
          function Oe(e, t, i, n, r, o, s, a) {
              if (n /= t,
              o >= (i /= t) && s < n)
                  return e;
              if (s < i || o >= n)
                  return null;
              for (var l = [], c = 0; c < e.length; c++) {
                  var u = e[c]
                    , h = u.geometry
                    , d = u.type
                    , p = 0 === r ? u.minX : u.minY
                    , f = 0 === r ? u.maxX : u.maxY;
                  if (p >= i && f < n)
                      l.push(u);
                  else if (!(f < i || p >= n)) {
                      var m = [];
                      if ("Point" === d || "MultiPoint" === d)
                          ze(h, m, i, n, r);
                      else if ("LineString" === d)
                          De(h, m, i, n, r, !1, a.lineMetrics);
                      else if ("MultiLineString" === d)
                          Be(h, m, i, n, r, !1);
                      else if ("Polygon" === d)
                          Be(h, m, i, n, r, !0);
                      else if ("MultiPolygon" === d)
                          for (var g = 0; g < h.length; g++) {
                              var v = [];
                              Be(h[g], v, i, n, r, !0),
                              v.length && m.push(v)
                          }
                      if (m.length) {
                          if (a.lineMetrics && "LineString" === d) {
                              for (g = 0; g < m.length; g++)
                                  l.push(Ee(u.id, d, m[g], u.tags));
                              continue
                          }
                          "LineString" !== d && "MultiLineString" !== d || (1 === m.length ? (d = "LineString",
                          m = m[0]) : d = "MultiLineString"),
                          "Point" !== d && "MultiPoint" !== d || (d = 3 === m.length ? "Point" : "MultiPoint"),
                          l.push(Ee(u.id, d, m, u.tags))
                      }
                  }
              }
              return l.length ? l : null
          }
          function ze(e, t, i, n, r) {
              for (var o = 0; o < e.length; o += 3) {
                  var s = e[o + r];
                  s >= i && s <= n && (t.push(e[o]),
                  t.push(e[o + 1]),
                  t.push(e[o + 2]))
              }
          }
          function De(e, t, i, n, r, o, s) {
              for (var a, l, c = Re(e), u = 0 === r ? Fe : Ne, h = e.start, d = 0; d < e.length - 3; d += 3) {
                  var p = e[d]
                    , f = e[d + 1]
                    , m = e[d + 2]
                    , g = e[d + 3]
                    , v = e[d + 4]
                    , y = 0 === r ? p : f
                    , _ = 0 === r ? g : v
                    , b = !1;
                  s && (a = Math.sqrt(Math.pow(p - g, 2) + Math.pow(f - v, 2))),
                  y < i ? _ > i && (l = u(c, p, f, g, v, i),
                  s && (c.start = h + a * l)) : y > n ? _ < n && (l = u(c, p, f, g, v, n),
                  s && (c.start = h + a * l)) : je(c, p, f, m),
                  _ < i && y >= i && (l = u(c, p, f, g, v, i),
                  b = !0),
                  _ > n && y <= n && (l = u(c, p, f, g, v, n),
                  b = !0),
                  !o && b && (s && (c.end = h + a * l),
                  t.push(c),
                  c = Re(e)),
                  s && (h += a)
              }
              var w = e.length - 3;
              p = e[w],
              f = e[w + 1],
              m = e[w + 2],
              (y = 0 === r ? p : f) >= i && y <= n && je(c, p, f, m),
              w = c.length - 3,
              o && w >= 3 && (c[w] !== c[0] || c[w + 1] !== c[1]) && je(c, c[0], c[1], c[2]),
              c.length && t.push(c)
          }
          function Re(e) {
              var t = [];
              return t.size = e.size,
              t.start = e.start,
              t.end = e.end,
              t
          }
          function Be(e, t, i, n, r, o) {
              for (var s = 0; s < e.length; s++)
                  De(e[s], t, i, n, r, o, !1)
          }
          function je(e, t, i, n) {
              e.push(t),
              e.push(i),
              e.push(n)
          }
          function Fe(e, t, i, n, r, o) {
              var s = (o - t) / (n - t);
              return e.push(o),
              e.push(i + (r - i) * s),
              e.push(1),
              s
          }
          function Ne(e, t, i, n, r, o) {
              var s = (o - i) / (r - i);
              return e.push(t + (n - t) * s),
              e.push(o),
              e.push(1),
              s
          }
          function Ue(e, t) {
              for (var i = [], n = 0; n < e.length; n++) {
                  var r, o = e[n], s = o.type;
                  if ("Point" === s || "MultiPoint" === s || "LineString" === s)
                      r = qe(o.geometry, t);
                  else if ("MultiLineString" === s || "Polygon" === s) {
                      r = [];
                      for (var a = 0; a < o.geometry.length; a++)
                          r.push(qe(o.geometry[a], t))
                  } else if ("MultiPolygon" === s)
                      for (r = [],
                      a = 0; a < o.geometry.length; a++) {
                          for (var l = [], c = 0; c < o.geometry[a].length; c++)
                              l.push(qe(o.geometry[a][c], t));
                          r.push(l)
                      }
                  i.push(Ee(o.id, s, r, o.tags))
              }
              return i
          }
          function qe(e, t) {
              var i = [];
              i.size = e.size,
              void 0 !== e.start && (i.start = e.start,
              i.end = e.end);
              for (var n = 0; n < e.length; n += 3)
                  i.push(e[n] + t, e[n + 1], e[n + 2]);
              return i
          }
          function He(e, t) {
              if (e.transformed)
                  return e;
              var i, n, r, o = 1 << e.z, s = e.x, a = e.y;
              for (i = 0; i < e.features.length; i++) {
                  var l = e.features[i]
                    , c = l.geometry
                    , u = l.type;
                  if (l.geometry = [],
                  1 === u)
                      for (n = 0; n < c.length; n += 2)
                          l.geometry.push(Ve(c[n], c[n + 1], t, o, s, a));
                  else
                      for (n = 0; n < c.length; n++) {
                          var h = [];
                          for (r = 0; r < c[n].length; r += 2)
                              h.push(Ve(c[n][r], c[n][r + 1], t, o, s, a));
                          l.geometry.push(h)
                      }
              }
              return e.transformed = !0,
              e
          }
          function Ve(e, t, i, n, r, o) {
              return [Math.round(i * (e * n - r)), Math.round(i * (t * n - o))]
          }
          function We(e, t, i, n, r) {
              for (var o = t === r.maxZoom ? 0 : r.tolerance / ((1 << t) * r.extent), s = {
                  features: [],
                  numPoints: 0,
                  numSimplified: 0,
                  numFeatures: 0,
                  source: null,
                  x: i,
                  y: n,
                  z: t,
                  transformed: !1,
                  minX: 2,
                  minY: 1,
                  maxX: -1,
                  maxY: 0
              }, a = 0; a < e.length; a++) {
                  s.numFeatures++,
                  $e(s, e[a], o, r);
                  var l = e[a].minX
                    , c = e[a].minY
                    , u = e[a].maxX
                    , h = e[a].maxY;
                  l < s.minX && (s.minX = l),
                  c < s.minY && (s.minY = c),
                  u > s.maxX && (s.maxX = u),
                  h > s.maxY && (s.maxY = h)
              }
              return s
          }
          function $e(e, t, i, n) {
              var r = t.geometry
                , o = t.type
                , s = [];
              if ("Point" === o || "MultiPoint" === o)
                  for (var a = 0; a < r.length; a += 3)
                      s.push(r[a]),
                      s.push(r[a + 1]),
                      e.numPoints++,
                      e.numSimplified++;
              else if ("LineString" === o)
                  Ge(s, r, e, i, !1, !1);
              else if ("MultiLineString" === o || "Polygon" === o)
                  for (a = 0; a < r.length; a++)
                      Ge(s, r[a], e, i, "Polygon" === o, 0 === a);
              else if ("MultiPolygon" === o)
                  for (var l = 0; l < r.length; l++) {
                      var c = r[l];
                      for (a = 0; a < c.length; a++)
                          Ge(s, c[a], e, i, !0, 0 === a)
                  }
              if (s.length) {
                  var u = t.tags || null;
                  if ("LineString" === o && n.lineMetrics) {
                      for (var h in u = {},
                      t.tags)
                          u[h] = t.tags[h];
                      u.mapbox_clip_start = r.start / r.size,
                      u.mapbox_clip_end = r.end / r.size
                  }
                  var d = {
                      geometry: s,
                      type: "Polygon" === o || "MultiPolygon" === o ? 3 : "LineString" === o || "MultiLineString" === o ? 2 : 1,
                      tags: u
                  };
                  null !== t.id && (d.id = t.id),
                  e.features.push(d)
              }
          }
          function Ge(e, t, i, n, r, o) {
              var s = n * n;
              if (n > 0 && t.size < (r ? s : n))
                  i.numPoints += t.length / 3;
              else {
                  for (var a = [], l = 0; l < t.length; l += 3)
                      (0 === n || t[l + 2] > s) && (i.numSimplified++,
                      a.push(t[l]),
                      a.push(t[l + 1])),
                      i.numPoints++;
                  r && function(e, t) {
                      for (var i = 0, n = 0, r = e.length, o = r - 2; n < r; o = n,
                      n += 2)
                          i += (e[n] - e[o]) * (e[n + 1] + e[o + 1]);
                      if (i > 0 === t)
                          for (n = 0,
                          r = e.length; n < r / 2; n += 2) {
                              var s = e[n]
                                , a = e[n + 1];
                              e[n] = e[r - 2 - n],
                              e[n + 1] = e[r - 1 - n],
                              e[r - 2 - n] = s,
                              e[r - 1 - n] = a
                          }
                  }(a, o),
                  e.push(a)
              }
          }
          function Xe(e, t) {
              var i = (t = this.options = function(e, t) {
                  for (var i in t)
                      e[i] = t[i];
                  return e
              }(Object.create(this.options), t)).debug;
              if (i && console.time("preprocess data"),
              t.maxZoom < 0 || t.maxZoom > 24)
                  throw new Error("maxZoom should be in the 0-24 range");
              if (t.promoteId && t.generateId)
                  throw new Error("promoteId and generateId cannot be used together.");
              var n = function(e, t) {
                  var i = [];
                  if ("FeatureCollection" === e.type)
                      for (var n = 0; n < e.features.length; n++)
                          Ce(i, e.features[n], t, n);
                  else
                      "Feature" === e.type ? Ce(i, e, t) : Ce(i, {
                          geometry: e
                      }, t);
                  return i
              }(e, t);
              this.tiles = {},
              this.tileCoords = [],
              i && (console.timeEnd("preprocess data"),
              console.log("index: maxZoom: %d, maxPoints: %d", t.indexMaxZoom, t.indexMaxPoints),
              console.time("generate tiles"),
              this.stats = {},
              this.total = 0),
              (n = function(e, t) {
                  var i = t.buffer / t.extent
                    , n = e
                    , r = Oe(e, 1, -1 - i, i, 0, -1, 2, t)
                    , o = Oe(e, 1, 1 - i, 2 + i, 0, -1, 2, t);
                  return (r || o) && (n = Oe(e, 1, -i, 1 + i, 0, -1, 2, t) || [],
                  r && (n = Ue(r, 1).concat(n)),
                  o && (n = n.concat(Ue(o, -1)))),
                  n
              }(n, t)).length && this.splitTile(n, 0, 0, 0),
              i && (n.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints),
              console.timeEnd("generate tiles"),
              console.log("tiles generated:", this.total, JSON.stringify(this.stats)))
          }
          function Ze(e, t, i) {
              return 32 * ((1 << e) * i + t) + e
          }
          function Ye(e, t) {
              var i = e.tileID.canonical;
              if (!this._geoJSONIndex)
                  return t(null, null);
              var n = this._geoJSONIndex.getTile(i.z, i.x, i.y);
              if (!n)
                  return t(null, null);
              var r = new W(n.features)
                , o = Y(r);
              0 === o.byteOffset && o.byteLength === o.buffer.byteLength || (o = new Uint8Array(o)),
              t(null, {
                  vectorTile: r,
                  rawData: o.buffer
              })
          }
          fe.prototype.load = function(e) {
              var t = this.options
                , i = t.log
                , n = t.minZoom
                , r = t.maxZoom
                , o = t.nodeSize;
              i && console.time("total time");
              var s = "prepare " + e.length + " points";
              i && console.time(s),
              this.points = e;
              for (var a = [], l = 0; l < e.length; l++)
                  e[l].geometry && a.push(ge(e[l], l));
              this.trees[r + 1] = new de(a,xe,ke,o,Float32Array),
              i && console.timeEnd(s);
              for (var c = r; c >= n; c--) {
                  var u = +Date.now();
                  a = this._cluster(a, c),
                  this.trees[c] = new de(a,xe,ke,o,Float32Array),
                  i && console.log("z%d: %d clusters in %dms", c, a.length, +Date.now() - u)
              }
              return i && console.timeEnd("total time"),
              this
          }
          ,
          fe.prototype.getClusters = function(e, t) {
              var i = ((e[0] + 180) % 360 + 360) % 360 - 180
                , n = Math.max(-90, Math.min(90, e[1]))
                , r = 180 === e[2] ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180
                , o = Math.max(-90, Math.min(90, e[3]));
              if (e[2] - e[0] >= 360)
                  i = -180,
                  r = 180;
              else if (i > r) {
                  var s = this.getClusters([i, n, 180, o], t)
                    , a = this.getClusters([-180, n, r, o], t);
                  return s.concat(a)
              }
              for (var l = this.trees[this._limitZoom(t)], c = [], u = 0, h = l.range(_e(i), be(o), _e(r), be(n)); u < h.length; u += 1) {
                  var d = h[u]
                    , p = l.points[d];
                  c.push(p.numPoints ? ve(p) : this.points[p.index])
              }
              return c
          }
          ,
          fe.prototype.getChildren = function(e) {
              var t = e >> 5
                , i = e % 32
                , n = "No cluster with the specified id."
                , r = this.trees[i];
              if (!r)
                  throw new Error(n);
              var o = r.points[t];
              if (!o)
                  throw new Error(n);
              for (var s = this.options.radius / (this.options.extent * Math.pow(2, i - 1)), a = [], l = 0, c = r.within(o.x, o.y, s); l < c.length; l += 1) {
                  var u = c[l]
                    , h = r.points[u];
                  h.parentId === e && a.push(h.numPoints ? ve(h) : this.points[h.index])
              }
              if (0 === a.length)
                  throw new Error(n);
              return a
          }
          ,
          fe.prototype.getLeaves = function(e, t, i) {
              t = t || 10,
              i = i || 0;
              var n = [];
              return this._appendLeaves(n, e, t, i, 0),
              n
          }
          ,
          fe.prototype.getTile = function(e, t, i) {
              var n = this.trees[this._limitZoom(e)]
                , r = Math.pow(2, e)
                , o = this.options
                , s = o.extent
                , a = o.radius / s
                , l = (i - a) / r
                , c = (i + 1 + a) / r
                , u = {
                  features: []
              };
              return this._addTileFeatures(n.range((t - a) / r, l, (t + 1 + a) / r, c), n.points, t, i, r, u),
              0 === t && this._addTileFeatures(n.range(1 - a / r, l, 1, c), n.points, r, i, r, u),
              t === r - 1 && this._addTileFeatures(n.range(0, l, a / r, c), n.points, -1, i, r, u),
              u.features.length ? u : null
          }
          ,
          fe.prototype.getClusterExpansionZoom = function(e) {
              for (var t = e % 32 - 1; t <= this.options.maxZoom; ) {
                  var i = this.getChildren(e);
                  if (t++,
                  1 !== i.length)
                      break;
                  e = i[0].properties.cluster_id
              }
              return t
          }
          ,
          fe.prototype._appendLeaves = function(e, t, i, n, r) {
              for (var o = 0, s = this.getChildren(t); o < s.length; o += 1) {
                  var a = s[o]
                    , l = a.properties;
                  if (l && l.cluster ? r + l.point_count <= n ? r += l.point_count : r = this._appendLeaves(e, l.cluster_id, i, n, r) : r < n ? r++ : e.push(a),
                  e.length === i)
                      break
              }
              return r
          }
          ,
          fe.prototype._addTileFeatures = function(e, t, i, n, r, o) {
              for (var s = 0, a = e; s < a.length; s += 1) {
                  var l = t[a[s]]
                    , c = {
                      type: 1,
                      geometry: [[Math.round(this.options.extent * (l.x * r - i)), Math.round(this.options.extent * (l.y * r - n))]],
                      tags: l.numPoints ? ye(l) : this.points[l.index].properties
                  }
                    , u = l.numPoints ? l.id : this.points[l.index].id;
                  void 0 !== u && (c.id = u),
                  o.features.push(c)
              }
          }
          ,
          fe.prototype._limitZoom = function(e) {
              return Math.max(this.options.minZoom, Math.min(e, this.options.maxZoom + 1))
          }
          ,
          fe.prototype._cluster = function(e, t) {
              for (var i = [], n = this.options, r = n.radius, o = n.extent, s = n.reduce, a = r / (o * Math.pow(2, t)), l = 0; l < e.length; l++) {
                  var c = e[l];
                  if (!(c.zoom <= t)) {
                      c.zoom = t;
                      for (var u = this.trees[t + 1], h = u.within(c.x, c.y, a), d = c.numPoints || 1, p = c.x * d, f = c.y * d, m = s ? this._map(c, !0) : null, g = (l << 5) + (t + 1), v = 0, y = h; v < y.length; v += 1) {
                          var _ = y[v]
                            , b = u.points[_];
                          if (!(b.zoom <= t)) {
                              b.zoom = t;
                              var w = b.numPoints || 1;
                              p += b.x * w,
                              f += b.y * w,
                              d += w,
                              b.parentId = g,
                              s && s(m, this._map(b))
                          }
                      }
                      1 === d ? i.push(c) : (c.parentId = g,
                      i.push(me(p / d, f / d, g, d, m)))
                  }
              }
              return i
          }
          ,
          fe.prototype._map = function(e, t) {
              if (e.numPoints)
                  return t ? we({}, e.properties) : e.properties;
              var i = this.points[e.index].properties
                , n = this.options.map(i);
              return t && n === i ? we({}, n) : n
          }
          ,
          Xe.prototype.options = {
              maxZoom: 14,
              indexMaxZoom: 5,
              indexMaxPoints: 1e5,
              tolerance: 3,
              extent: 4096,
              buffer: 64,
              lineMetrics: !1,
              promoteId: null,
              generateId: !1,
              debug: 0
          },
          Xe.prototype.splitTile = function(e, t, i, n, r, o, s) {
              for (var a = [e, t, i, n], l = this.options, c = l.debug; a.length; ) {
                  n = a.pop(),
                  i = a.pop(),
                  t = a.pop(),
                  e = a.pop();
                  var u = 1 << t
                    , h = Ze(t, i, n)
                    , d = this.tiles[h];
                  if (!d && (c > 1 && console.time("creation"),
                  d = this.tiles[h] = We(e, t, i, n, l),
                  this.tileCoords.push({
                      z: t,
                      x: i,
                      y: n
                  }),
                  c)) {
                      c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t, i, n, d.numFeatures, d.numPoints, d.numSimplified),
                      console.timeEnd("creation"));
                      var p = "z" + t;
                      this.stats[p] = (this.stats[p] || 0) + 1,
                      this.total++
                  }
                  if (d.source = e,
                  r) {
                      if (t === l.maxZoom || t === r)
                          continue;
                      var f = 1 << r - t;
                      if (i !== Math.floor(o / f) || n !== Math.floor(s / f))
                          continue
                  } else if (t === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints)
                      continue;
                  if (d.source = null,
                  0 !== e.length) {
                      c > 1 && console.time("clipping");
                      var m, g, v, y, _, b, w = .5 * l.buffer / l.extent, x = .5 - w, k = .5 + w, S = 1 + w;
                      m = g = v = y = null,
                      _ = Oe(e, u, i - w, i + k, 0, d.minX, d.maxX, l),
                      b = Oe(e, u, i + x, i + S, 0, d.minX, d.maxX, l),
                      e = null,
                      _ && (m = Oe(_, u, n - w, n + k, 1, d.minY, d.maxY, l),
                      g = Oe(_, u, n + x, n + S, 1, d.minY, d.maxY, l),
                      _ = null),
                      b && (v = Oe(b, u, n - w, n + k, 1, d.minY, d.maxY, l),
                      y = Oe(b, u, n + x, n + S, 1, d.minY, d.maxY, l),
                      b = null),
                      c > 1 && console.timeEnd("clipping"),
                      a.push(m || [], t + 1, 2 * i, 2 * n),
                      a.push(g || [], t + 1, 2 * i, 2 * n + 1),
                      a.push(v || [], t + 1, 2 * i + 1, 2 * n),
                      a.push(y || [], t + 1, 2 * i + 1, 2 * n + 1)
                  }
              }
          }
          ,
          Xe.prototype.getTile = function(e, t, i) {
              var n = this.options
                , r = n.extent
                , o = n.debug;
              if (e < 0 || e > 24)
                  return null;
              var s = 1 << e
                , a = Ze(e, t = (t % s + s) % s, i);
              if (this.tiles[a])
                  return He(this.tiles[a], r);
              o > 1 && console.log("drilling down to z%d-%d-%d", e, t, i);
              for (var l, c = e, u = t, h = i; !l && c > 0; )
                  c--,
                  u = Math.floor(u / 2),
                  h = Math.floor(h / 2),
                  l = this.tiles[Ze(c, u, h)];
              return l && l.source ? (o > 1 && console.log("found parent tile z%d-%d-%d", c, u, h),
              o > 1 && console.time("drilling down"),
              this.splitTile(l.source, c, u, h, e, t, i),
              o > 1 && console.timeEnd("drilling down"),
              this.tiles[a] ? He(this.tiles[a], r) : null) : null
          }
          ;
          var Ke = function(t) {
              function i(e, i, n) {
                  t.call(this, e, i, Ye),
                  n && (this.loadGeoJSON = n)
              }
              return t && (i.__proto__ = t),
              i.prototype = Object.create(t && t.prototype),
              i.prototype.constructor = i,
              i.prototype.loadData = function(e, t) {
                  this._pendingCallback && this._pendingCallback(null, {
                      abandoned: !0
                  }),
                  this._pendingCallback = t,
                  this._pendingLoadDataParams = e,
                  this._state && "Idle" !== this._state ? this._state = "NeedsLoadData" : (this._state = "Coalescing",
                  this._loadData())
              }
              ,
              i.prototype._loadData = function() {
                  var t = this;
                  if (this._pendingCallback && this._pendingLoadDataParams) {
                      var i = this._pendingCallback
                        , n = this._pendingLoadDataParams;
                      delete this._pendingCallback,
                      delete this._pendingLoadDataParams;
                      var r = !!(n && n.request && n.request.collectResourceTiming) && new P.Performance(n.request);
                      this.loadGeoJSON(n, function(o, s) {
                          if (o || !s)
                              return i(o);
                          if ("object" != typeof s)
                              return i(new Error("Input data is not a valid GeoJSON object."));
                          !function e(t, i) {
                              switch (t && t.type || null) {
                              case "FeatureCollection":
                                  return t.features = t.features.map(N(e, i)),
                                  t;
                              case "GeometryCollection":
                                  return t.geometries = t.geometries.map(N(e, i)),
                                  t;
                              case "Feature":
                                  return t.geometry = e(t.geometry, i),
                                  t;
                              case "Polygon":
                              case "MultiPolygon":
                                  return function(e, t) {
                                      return "Polygon" === e.type ? e.coordinates = U(e.coordinates, t) : "MultiPolygon" === e.type && (e.coordinates = e.coordinates.map(N(U, t))),
                                      e
                                  }(t, i);
                              default:
                                  return t
                              }
                          }(s, !0);
                          try {
                              t._geoJSONIndex = n.cluster ? new fe(function(t) {
                                  var i = t.superclusterOptions
                                    , n = t.clusterProperties;
                                  if (!n || !i)
                                      return i;
                                  for (var r = {}, o = {}, s = {
                                      accumulated: null,
                                      zoom: 0
                                  }, a = {
                                      properties: null
                                  }, l = Object.keys(n), c = 0, u = l; c < u.length; c += 1) {
                                      var h = u[c]
                                        , d = n[h]
                                        , p = d[0]
                                        , f = d[1]
                                        , m = e.createExpression(f)
                                        , g = e.createExpression("string" == typeof p ? [p, ["accumulated"], ["get", h]] : p);
                                      r[h] = m.value,
                                      o[h] = g.value
                                  }
                                  return i.map = function(e) {
                                      a.properties = e;
                                      for (var t = {}, i = 0, n = l; i < n.length; i += 1) {
                                          var o = n[i];
                                          t[o] = r[o].evaluate(s, a)
                                      }
                                      return t
                                  }
                                  ,
                                  i.reduce = function(e, t) {
                                      a.properties = t;
                                      for (var i = 0, n = l; i < n.length; i += 1) {
                                          var r = n[i];
                                          s.accumulated = e[r],
                                          e[r] = o[r].evaluate(s, a)
                                      }
                                  }
                                  ,
                                  i
                              }(n)).load(s.features) : new Xe(s,n.geojsonVtOptions)
                          } catch (o) {
                              return i(o)
                          }
                          t.loaded = {};
                          var a = {};
                          if (r) {
                              var l = r.finish();
                              l && (a.resourceTiming = {},
                              a.resourceTiming[n.source] = JSON.parse(JSON.stringify(l)))
                          }
                          i(null, a)
                      })
                  }
              }
              ,
              i.prototype.coalesce = function() {
                  "Coalescing" === this._state ? this._state = "Idle" : "NeedsLoadData" === this._state && (this._state = "Coalescing",
                  this._loadData())
              }
              ,
              i.prototype.reloadTile = function(e, i) {
                  var n = this.loaded
                    , r = e.uid;
                  return n && n[r] ? t.prototype.reloadTile.call(this, e, i) : this.loadTile(e, i)
              }
              ,
              i.prototype.loadGeoJSON = function(t, i) {
                  if (t.request)
                      e.getJSON(t.request, i);
                  else {
                      if ("string" != typeof t.data)
                          return i(new Error("Input data is not a valid GeoJSON object."));
                      try {
                          return i(null, JSON.parse(t.data))
                      } catch (e) {
                          return i(new Error("Input data is not a valid GeoJSON object."))
                      }
                  }
              }
              ,
              i.prototype.removeSource = function(e, t) {
                  this._pendingCallback && this._pendingCallback(null, {
                      abandoned: !0
                  }),
                  t()
              }
              ,
              i.prototype.getClusterExpansionZoom = function(e, t) {
                  t(null, this._geoJSONIndex.getClusterExpansionZoom(e.clusterId))
              }
              ,
              i.prototype.getClusterChildren = function(e, t) {
                  t(null, this._geoJSONIndex.getChildren(e.clusterId))
              }
              ,
              i.prototype.getClusterLeaves = function(e, t) {
                  t(null, this._geoJSONIndex.getLeaves(e.clusterId, e.limit, e.offset))
              }
              ,
              i
          }(O)
            , Je = function(t) {
              var i = this;
              this.self = t,
              this.actor = new e.Actor(t,this),
              this.layerIndexes = {},
              this.workerSourceTypes = {
                  vector: O,
                  geojson: Ke
              },
              this.workerSources = {},
              this.demWorkerSources = {},
              this.self.registerWorkerSource = function(e, t) {
                  if (i.workerSourceTypes[e])
                      throw new Error('Worker source with name "' + e + '" already registered.');
                  i.workerSourceTypes[e] = t
              }
              ,
              this.self.registerRTLTextPlugin = function(t) {
                  if (e.plugin.isLoaded())
                      throw new Error("RTL text plugin already registered.");
                  e.plugin.applyArabicShaping = t.applyArabicShaping,
                  e.plugin.processBidirectionalText = t.processBidirectionalText,
                  e.plugin.processStyledBidirectionalText = t.processStyledBidirectionalText
              }
          };
          return Je.prototype.setReferrer = function(e, t) {
              this.referrer = t
          }
          ,
          Je.prototype.setLayers = function(e, t, i) {
              this.getLayerIndex(e).replace(t),
              i()
          }
          ,
          Je.prototype.updateLayers = function(e, t, i) {
              this.getLayerIndex(e).update(t.layers, t.removedIds),
              i()
          }
          ,
          Je.prototype.loadTile = function(e, t, i) {
              this.getWorkerSource(e, t.type, t.source).loadTile(t, i)
          }
          ,
          Je.prototype.loadDEMTile = function(e, t, i) {
              this.getDEMWorkerSource(e, t.source).loadTile(t, i)
          }
          ,
          Je.prototype.reloadTile = function(e, t, i) {
              this.getWorkerSource(e, t.type, t.source).reloadTile(t, i)
          }
          ,
          Je.prototype.abortTile = function(e, t, i) {
              this.getWorkerSource(e, t.type, t.source).abortTile(t, i)
          }
          ,
          Je.prototype.removeTile = function(e, t, i) {
              this.getWorkerSource(e, t.type, t.source).removeTile(t, i)
          }
          ,
          Je.prototype.removeDEMTile = function(e, t) {
              this.getDEMWorkerSource(e, t.source).removeTile(t)
          }
          ,
          Je.prototype.removeSource = function(e, t, i) {
              if (this.workerSources[e] && this.workerSources[e][t.type] && this.workerSources[e][t.type][t.source]) {
                  var n = this.workerSources[e][t.type][t.source];
                  delete this.workerSources[e][t.type][t.source],
                  void 0 !== n.removeSource ? n.removeSource(t, i) : i()
              }
          }
          ,
          Je.prototype.loadWorkerSource = function(e, t, i) {
              try {
                  this.self.importScripts(t.url),
                  i()
              } catch (e) {
                  i(e.toString())
              }
          }
          ,
          Je.prototype.loadRTLTextPlugin = function(t, i, n) {
              try {
                  e.plugin.isLoaded() || (this.self.importScripts(i),
                  n(e.plugin.isLoaded() ? null : new Error("RTL Text Plugin failed to import scripts from " + i)))
              } catch (e) {
                  n(e.toString())
              }
          }
          ,
          Je.prototype.getLayerIndex = function(e) {
              var t = this.layerIndexes[e];
              return t || (t = this.layerIndexes[e] = new n),
              t
          }
          ,
          Je.prototype.getWorkerSource = function(e, t, i) {
              var n = this;
              if (this.workerSources[e] || (this.workerSources[e] = {}),
              this.workerSources[e][t] || (this.workerSources[e][t] = {}),
              !this.workerSources[e][t][i]) {
                  var r = {
                      send: function(t, i, r) {
                          n.actor.send(t, i, r, e)
                      }
                  };
                  this.workerSources[e][t][i] = new this.workerSourceTypes[t](r,this.getLayerIndex(e))
              }
              return this.workerSources[e][t][i]
          }
          ,
          Je.prototype.getDEMWorkerSource = function(e, t) {
              return this.demWorkerSources[e] || (this.demWorkerSources[e] = {}),
              this.demWorkerSources[e][t] || (this.demWorkerSources[e][t] = new z),
              this.demWorkerSources[e][t]
          }
          ,
          "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope && (self.worker = new Je(self)),
          Je
      }),
      n(0, function(e) {
          var t = e.createCommonjsModule(function(e) {
              function t(e) {
                  return !!("undefined" != typeof window && "undefined" != typeof document && Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray && Function.prototype && Function.prototype.bind && Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions && "JSON"in window && "parse"in JSON && "stringify"in JSON && function() {
                      if (!("Worker"in window && "Blob"in window && "URL"in window))
                          return !1;
                      var e, t, i = new Blob([""],{
                          type: "text/javascript"
                      }), n = URL.createObjectURL(i);
                      try {
                          t = new Worker(n),
                          e = !0
                      } catch (t) {
                          e = !1
                      }
                      return t && t.terminate(),
                      URL.revokeObjectURL(n),
                      e
                  }() && "Uint8ClampedArray"in window && ArrayBuffer.isView && function(e) {
                      return void 0 === i[e] && (i[e] = function(e) {
                          var i = document.createElement("canvas")
                            , n = Object.create(t.webGLContextAttributes);
                          return n.failIfMajorPerformanceCaveat = e,
                          i.probablySupportsContext ? i.probablySupportsContext("webgl", n) || i.probablySupportsContext("experimental-webgl", n) : i.supportsContext ? i.supportsContext("webgl", n) || i.supportsContext("experimental-webgl", n) : i.getContext("webgl", n) || i.getContext("experimental-webgl", n)
                      }(e)),
                      i[e]
                  }(e && e.failIfMajorPerformanceCaveat))
              }
              e.exports ? e.exports = t : window && (window.mapboxgl = window.mapboxgl || {},
              window.mapboxgl.supported = t);
              var i = {};
              t.webGLContextAttributes = {
                  antialias: !1,
                  alpha: !0,
                  stencil: !0,
                  depth: !0
              }
          })
            , i = {
              create: function(t, i, n) {
                  var r = e.window.document.createElement(t);
                  return i && (r.className = i),
                  n && n.appendChild(r),
                  r
              },
              createNS: function(t, i) {
                  return e.window.document.createElementNS(t, i)
              }
          }
            , n = e.window.document ? e.window.document.documentElement.style : null;
          function r(e) {
              if (!n)
                  return null;
              for (var t = 0; t < e.length; t++)
                  if (e[t]in n)
                      return e[t];
              return e[0]
          }
          var o, s = r(["userSelect", "MozUserSelect", "WebkitUserSelect", "msUserSelect"]);
          i.disableDrag = function() {
              n && s && (o = n[s],
              n[s] = "none")
          }
          ,
          i.enableDrag = function() {
              n && s && (n[s] = o)
          }
          ;
          var a = r(["transform", "WebkitTransform"]);
          i.setTransform = function(e, t) {
              e.style[a] = t
          }
          ;
          var l = !1;
          try {
              var c = Object.defineProperty({}, "passive", {
                  get: function() {
                      l = !0
                  }
              });
              e.window.addEventListener("test", c, c),
              e.window.removeEventListener("test", c, c)
          } catch (e) {
              l = !1
          }
          i.addEventListener = function(e, t, i, n) {
              void 0 === n && (n = {}),
              "passive"in n && l ? e.addEventListener(t, i, n) : e.addEventListener(t, i, n.capture)
          }
          ,
          i.removeEventListener = function(e, t, i, n) {
              void 0 === n && (n = {}),
              "passive"in n && l ? e.removeEventListener(t, i, n) : e.removeEventListener(t, i, n.capture)
          }
          ;
          var u = function(t) {
              t.preventDefault(),
              t.stopPropagation(),
              e.window.removeEventListener("click", u, !0)
          };
          i.suppressClick = function() {
              e.window.addEventListener("click", u, !0),
              e.window.setTimeout(function() {
                  e.window.removeEventListener("click", u, !0)
              }, 0)
          }
          ,
          i.mousePos = function(t, i) {
              var n = t.getBoundingClientRect();
              return i = i.touches ? i.touches[0] : i,
              new e.Point(i.clientX - n.left - t.clientLeft,i.clientY - n.top - t.clientTop)
          }
          ,
          i.touchPos = function(t, i) {
              for (var n = t.getBoundingClientRect(), r = [], o = "touchend" === i.type ? i.changedTouches : i.touches, s = 0; s < o.length; s++)
                  r.push(new e.Point(o[s].clientX - n.left - t.clientLeft,o[s].clientY - n.top - t.clientTop));
              return r
          }
          ,
          i.mouseButton = function(t) {
              return void 0 !== e.window.InstallTrigger && 2 === t.button && t.ctrlKey && e.window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : t.button
          }
          ,
          i.remove = function(e) {
              e.parentNode && e.parentNode.removeChild(e)
          }
          ;
          var h = function() {
              this.images = {},
              this.loaded = !1,
              this.requestors = [],
              this.patterns = {},
              this.atlasImage = new e.RGBAImage({
                  width: 1,
                  height: 1
              }),
              this.dirty = !0
          };
          h.prototype.isLoaded = function() {
              return this.loaded
          }
          ,
          h.prototype.setLoaded = function(e) {
              if (this.loaded !== e && (this.loaded = e,
              e)) {
                  for (var t = 0, i = this.requestors; t < i.length; t += 1) {
                      var n = i[t]
                        , r = n.ids
                        , o = n.callback;
                      this._notify(r, o)
                  }
                  this.requestors = []
              }
          }
          ,
          h.prototype.getImage = function(e) {
              return this.images[e]
          }
          ,
          h.prototype.addImage = function(e, t) {
              this.images[e] = t
          }
          ,
          h.prototype.removeImage = function(e) {
              delete this.images[e],
              delete this.patterns[e]
          }
          ,
          h.prototype.listImages = function() {
              return Object.keys(this.images)
          }
          ,
          h.prototype.getImages = function(e, t) {
              var i = !0;
              if (!this.isLoaded())
                  for (var n = 0, r = e; n < r.length; n += 1) {
                      var o = r[n];
                      this.images[o] || (i = !1)
                  }
              this.isLoaded() || i ? this._notify(e, t) : this.requestors.push({
                  ids: e,
                  callback: t
              })
          }
          ,
          h.prototype._notify = function(e, t) {
              for (var i = {}, n = 0, r = e; n < r.length; n += 1) {
                  var o = r[n]
                    , s = this.images[o];
                  s && (i[o] = {
                      data: s.data.clone(),
                      pixelRatio: s.pixelRatio,
                      sdf: s.sdf
                  })
              }
              t(null, i)
          }
          ,
          h.prototype.getPixelSize = function() {
              var e = this.atlasImage;
              return {
                  width: e.width,
                  height: e.height
              }
          }
          ,
          h.prototype.getPattern = function(t) {
              var i = this.patterns[t];
              if (i)
                  return i.position;
              var n = this.getImage(t);
              if (!n)
                  return null;
              var r = {
                  w: n.data.width + 2,
                  h: n.data.height + 2,
                  x: 0,
                  y: 0
              }
                , o = new e.ImagePosition(r,n);
              return this.patterns[t] = {
                  bin: r,
                  position: o
              },
              this._updatePatternAtlas(),
              o
          }
          ,
          h.prototype.bind = function(t) {
              var i = t.gl;
              this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage),
              this.dirty = !1) : this.atlasTexture = new e.Texture(t,this.atlasImage,i.RGBA),
              this.atlasTexture.bind(i.LINEAR, i.CLAMP_TO_EDGE)
          }
          ,
          h.prototype._updatePatternAtlas = function() {
              var t = [];
              for (var i in this.patterns)
                  t.push(this.patterns[i].bin);
              var n = e.potpack(t)
                , r = n.w
                , o = n.h
                , s = this.atlasImage;
              for (var a in s.resize({
                  width: r || 1,
                  height: o || 1
              }),
              this.patterns) {
                  var l = this.patterns[a].bin
                    , c = l.x + 1
                    , u = l.y + 1
                    , h = this.images[a].data
                    , d = h.width
                    , p = h.height;
                  e.RGBAImage.copy(h, s, {
                      x: 0,
                      y: 0
                  }, {
                      x: c,
                      y: u
                  }, {
                      width: d,
                      height: p
                  }),
                  e.RGBAImage.copy(h, s, {
                      x: 0,
                      y: p - 1
                  }, {
                      x: c,
                      y: u - 1
                  }, {
                      width: d,
                      height: 1
                  }),
                  e.RGBAImage.copy(h, s, {
                      x: 0,
                      y: 0
                  }, {
                      x: c,
                      y: u + p
                  }, {
                      width: d,
                      height: 1
                  }),
                  e.RGBAImage.copy(h, s, {
                      x: d - 1,
                      y: 0
                  }, {
                      x: c - 1,
                      y: u
                  }, {
                      width: 1,
                      height: p
                  }),
                  e.RGBAImage.copy(h, s, {
                      x: 0,
                      y: 0
                  }, {
                      x: c + d,
                      y: u
                  }, {
                      width: 1,
                      height: p
                  })
              }
              this.dirty = !0
          }
          ;
          var d = f
            , p = 1e20;
          function f(e, t, i, n, r, o) {
              this.fontSize = e || 24,
              this.buffer = void 0 === t ? 3 : t,
              this.cutoff = n || .25,
              this.fontFamily = r || "sans-serif",
              this.fontWeight = o || "normal",
              this.radius = i || 8;
              var s = this.size = this.fontSize + 2 * this.buffer;
              this.canvas = document.createElement("canvas"),
              this.canvas.width = this.canvas.height = s,
              this.ctx = this.canvas.getContext("2d"),
              this.ctx.font = this.fontWeight + " " + this.fontSize + "px " + this.fontFamily,
              this.ctx.textBaseline = "middle",
              this.ctx.fillStyle = "black",
              this.gridOuter = new Float64Array(s * s),
              this.gridInner = new Float64Array(s * s),
              this.f = new Float64Array(s),
              this.d = new Float64Array(s),
              this.z = new Float64Array(s + 1),
              this.v = new Int16Array(s),
              this.middle = Math.round(s / 2 * (navigator.userAgent.indexOf("Gecko/") >= 0 ? 1.2 : 1))
          }
          function m(e, t, i, n, r, o, s) {
              for (var a = 0; a < t; a++) {
                  for (var l = 0; l < i; l++)
                      n[l] = e[l * t + a];
                  for (g(n, r, o, s, i),
                  l = 0; l < i; l++)
                      e[l * t + a] = r[l]
              }
              for (l = 0; l < i; l++) {
                  for (a = 0; a < t; a++)
                      n[a] = e[l * t + a];
                  for (g(n, r, o, s, t),
                  a = 0; a < t; a++)
                      e[l * t + a] = Math.sqrt(r[a])
              }
          }
          function g(e, t, i, n, r) {
              i[0] = 0,
              n[0] = -p,
              n[1] = +p;
              for (var o = 1, s = 0; o < r; o++) {
                  for (var a = (e[o] + o * o - (e[i[s]] + i[s] * i[s])) / (2 * o - 2 * i[s]); a <= n[s]; )
                      s--,
                      a = (e[o] + o * o - (e[i[s]] + i[s] * i[s])) / (2 * o - 2 * i[s]);
                  i[++s] = o,
                  n[s] = a,
                  n[s + 1] = +p
              }
              for (o = 0,
              s = 0; o < r; o++) {
                  for (; n[s + 1] < o; )
                      s++;
                  t[o] = (o - i[s]) * (o - i[s]) + e[i[s]]
              }
          }
          f.prototype.draw = function(e) {
              this.ctx.clearRect(0, 0, this.size, this.size),
              this.ctx.fillText(e, this.buffer, this.middle);
              for (var t = this.ctx.getImageData(0, 0, this.size, this.size), i = new Uint8ClampedArray(this.size * this.size), n = 0; n < this.size * this.size; n++) {
                  var r = t.data[4 * n + 3] / 255;
                  this.gridOuter[n] = 1 === r ? 0 : 0 === r ? p : Math.pow(Math.max(0, .5 - r), 2),
                  this.gridInner[n] = 1 === r ? p : 0 === r ? 0 : Math.pow(Math.max(0, r - .5), 2)
              }
              for (m(this.gridOuter, this.size, this.size, this.f, this.d, this.v, this.z),
              m(this.gridInner, this.size, this.size, this.f, this.d, this.v, this.z),
              n = 0; n < this.size * this.size; n++) {
                  var o = this.gridOuter[n] - this.gridInner[n];
                  i[n] = Math.max(0, Math.min(255, Math.round(255 - 255 * (o / this.radius + this.cutoff))))
              }
              return i
          }
          ;
          var v = function(e, t) {
              this.requestTransform = e,
              this.localIdeographFontFamily = t,
              this.entries = {}
          };
          v.prototype.setURL = function(e) {
              this.url = e
          }
          ,
          v.prototype.getGlyphs = function(t, i) {
              var n = this
                , r = [];
              for (var o in t)
                  for (var s = 0, a = t[o]; s < a.length; s += 1) {
                      var l = a[s];
                      r.push({
                          stack: o,
                          id: l
                      })
                  }
              e.asyncAll(r, function(e, t) {
                  var i = e.stack
                    , r = e.id
                    , o = n.entries[i];
                  o || (o = n.entries[i] = {
                      glyphs: {},
                      requests: {}
                  });
                  var s = o.glyphs[r];
                  if (void 0 === s)
                      if (s = n._tinySDF(o, i, r))
                          t(null, {
                              stack: i,
                              id: r,
                              glyph: s
                          });
                      else {
                          var a = Math.floor(r / 256);
                          if (256 * a > 65535)
                              t(new Error("glyphs > 65535 not supported"));
                          else {
                              var l = o.requests[a];
                              l || (l = o.requests[a] = [],
                              v.loadGlyphRange(i, a, n.url, n.requestTransform, function(e, t) {
                                  if (t)
                                      for (var i in t)
                                          o.glyphs[+i] = t[+i];
                                  for (var n = 0, r = l; n < r.length; n += 1)
                                      (0,
                                      r[n])(e, t);
                                  delete o.requests[a]
                              })),
                              l.push(function(e, n) {
                                  e ? t(e) : n && t(null, {
                                      stack: i,
                                      id: r,
                                      glyph: n[r] || null
                                  })
                              })
                          }
                      }
                  else
                      t(null, {
                          stack: i,
                          id: r,
                          glyph: s
                      })
              }, function(e, t) {
                  if (e)
                      i(e);
                  else if (t) {
                      for (var n = {}, r = 0, o = t; r < o.length; r += 1) {
                          var s = o[r]
                            , a = s.stack
                            , l = s.id
                            , c = s.glyph;
                          (n[a] || (n[a] = {}))[l] = c && {
                              id: c.id,
                              bitmap: c.bitmap.clone(),
                              metrics: c.metrics
                          }
                      }
                      i(null, n)
                  }
              })
          }
          ,
          v.prototype._tinySDF = function(t, i, n) {
              var r = this.localIdeographFontFamily;
              if (r && (e.isChar["CJK Unified Ideographs"](n) || e.isChar["Hangul Syllables"](n))) {
                  var o = t.tinySDF;
                  if (!o) {
                      var s = "400";
                      /bold/i.test(i) ? s = "900" : /medium/i.test(i) ? s = "500" : /light/i.test(i) && (s = "200"),
                      o = t.tinySDF = new v.TinySDF(24,3,8,.25,r,s)
                  }
                  return {
                      id: n,
                      bitmap: new e.AlphaImage({
                          width: 30,
                          height: 30
                      },o.draw(String.fromCharCode(n))),
                      metrics: {
                          width: 24,
                          height: 24,
                          left: 0,
                          top: -8,
                          advance: 24
                      }
                  }
              }
          }
          ,
          v.loadGlyphRange = function(t, i, n, r, o) {
              var s = 256 * i
                , a = s + 255
                , l = r(e.normalizeGlyphsURL(n).replace("{fontstack}", t).replace("{range}", s + "-" + a), e.ResourceType.Glyphs);
              e.getArrayBuffer(l, function(t, i) {
                  if (t)
                      o(t);
                  else if (i) {
                      for (var n = {}, r = 0, s = e.parseGlyphPBF(i); r < s.length; r += 1) {
                          var a = s[r];
                          n[a.id] = a
                      }
                      o(null, n)
                  }
              })
          }
          ,
          v.TinySDF = d;
          var y = function() {
              this.specification = e.styleSpec.light.position
          };
          y.prototype.possiblyEvaluate = function(t, i) {
              return e.sphericalToCartesian(t.expression.evaluate(i))
          }
          ,
          y.prototype.interpolate = function(t, i, n) {
              return {
                  x: e.number(t.x, i.x, n),
                  y: e.number(t.y, i.y, n),
                  z: e.number(t.z, i.z, n)
              }
          }
          ;
          var _ = new e.Properties({
              anchor: new e.DataConstantProperty(e.styleSpec.light.anchor),
              position: new y,
              color: new e.DataConstantProperty(e.styleSpec.light.color),
              intensity: new e.DataConstantProperty(e.styleSpec.light.intensity)
          })
            , b = function(t) {
              function i(i) {
                  t.call(this),
                  this._transitionable = new e.Transitionable(_),
                  this.setLight(i),
                  this._transitioning = this._transitionable.untransitioned()
              }
              return t && (i.__proto__ = t),
              i.prototype = Object.create(t && t.prototype),
              i.prototype.constructor = i,
              i.prototype.getLight = function() {
                  return this._transitionable.serialize()
              }
              ,
              i.prototype.setLight = function(t, i) {
                  if (void 0 === i && (i = {}),
                  !this._validate(e.validateLight, t, i))
                      for (var n in t) {
                          var r = t[n];
                          e.endsWith(n, "-transition") ? this._transitionable.setTransition(n.slice(0, -"-transition".length), r) : this._transitionable.setValue(n, r)
                      }
              }
              ,
              i.prototype.updateTransitions = function(e) {
                  this._transitioning = this._transitionable.transitioned(e, this._transitioning)
              }
              ,
              i.prototype.hasTransition = function() {
                  return this._transitioning.hasTransition()
              }
              ,
              i.prototype.recalculate = function(e) {
                  this.properties = this._transitioning.possiblyEvaluate(e)
              }
              ,
              i.prototype._validate = function(t, i, n) {
                  return (!n || !1 !== n.validate) && e.emitValidationErrors(this, t.call(e.validateStyle, e.extend({
                      value: i,
                      style: {
                          glyphs: !0,
                          sprite: !0
                      },
                      styleSpec: e.styleSpec
                  })))
              }
              ,
              i
          }(e.Evented)
            , w = function(e, t) {
              this.width = e,
              this.height = t,
              this.nextRow = 0,
              this.bytes = 4,
              this.data = new Uint8Array(this.width * this.height * this.bytes),
              this.positions = {}
          };
          w.prototype.getDash = function(e, t) {
              var i = e.join(",") + String(t);
              return this.positions[i] || (this.positions[i] = this.addDash(e, t)),
              this.positions[i]
          }
          ,
          w.prototype.addDash = function(t, i) {
              var n = i ? 7 : 0
                , r = 2 * n + 1;
              if (this.nextRow + r > this.height)
                  return e.warnOnce("LineAtlas out of space"),
                  null;
              for (var o = 0, s = 0; s < t.length; s++)
                  o += t[s];
              for (var a = this.width / o, l = a / 2, c = t.length % 2 == 1, u = -n; u <= n; u++)
                  for (var h = this.nextRow + n + u, d = this.width * h, p = c ? -t[t.length - 1] : 0, f = t[0], m = 1, g = 0; g < this.width; g++) {
                      for (; f < g / a; )
                          p = f,
                          f += t[m],
                          c && m === t.length - 1 && (f += t[0]),
                          m++;
                      var v = Math.abs(g - p * a)
                        , y = Math.abs(g - f * a)
                        , _ = Math.min(v, y)
                        , b = m % 2 == 1
                        , w = void 0;
                      if (i) {
                          var x = n ? u / n * (l + 1) : 0;
                          if (b) {
                              var k = l - Math.abs(x);
                              w = Math.sqrt(_ * _ + k * k)
                          } else
                              w = l - Math.sqrt(_ * _ + x * x)
                      } else
                          w = (b ? 1 : -1) * _;
                      this.data[3 + 4 * (d + g)] = Math.max(0, Math.min(255, w + 128))
                  }
              var S = {
                  y: (this.nextRow + n + .5) / this.height,
                  height: 2 * n / this.height,
                  width: o
              };
              return this.nextRow += r,
              this.dirty = !0,
              S
          }
          ,
          w.prototype.bind = function(e) {
              var t = e.gl;
              this.texture ? (t.bindTexture(t.TEXTURE_2D, this.texture),
              this.dirty && (this.dirty = !1,
              t.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, this.width, this.height, t.RGBA, t.UNSIGNED_BYTE, this.data))) : (this.texture = t.createTexture(),
              t.bindTexture(t.TEXTURE_2D, this.texture),
              t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.REPEAT),
              t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.REPEAT),
              t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR),
              t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR),
              t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, this.width, this.height, 0, t.RGBA, t.UNSIGNED_BYTE, this.data))
          }
          ;
          var x = function t(i, n) {
              this.workerPool = i,
              this.actors = [],
              this.currentActor = 0,
              this.id = e.uniqueId();
              for (var r = this.workerPool.acquire(this.id), o = 0; o < r.length; o++) {
                  var s = r[o]
                    , a = new t.Actor(s,n,this.id);
                  a.name = "Worker " + o,
                  this.actors.push(a)
              }
          };
          function k(t, i, n) {
              var r = function(i, r) {
                  if (i)
                      return n(i);
                  if (r) {
                      var o = e.pick(r, ["tiles", "minzoom", "maxzoom", "attribution", "mapbox_logo", "bounds"]);
                      r.vector_layers && (o.vectorLayers = r.vector_layers,
                      o.vectorLayerIds = o.vectorLayers.map(function(e) {
                          return e.id
                      })),
                      t.url && (o.tiles = e.canonicalizeTileset(o, t.url)),
                      n(null, o)
                  }
              };
              return t.url ? e.getJSON(i(e.normalizeSourceURL(t.url), e.ResourceType.Source), r) : e.browser.frame(function() {
                  return r(null, t)
              })
          }
          x.prototype.broadcast = function(t, i, n) {
              n = n || function() {}
              ,
              e.asyncAll(this.actors, function(e, n) {
                  e.send(t, i, n)
              }, n)
          }
          ,
          x.prototype.send = function(e, t, i, n) {
              return ("number" != typeof n || isNaN(n)) && (n = this.currentActor = (this.currentActor + 1) % this.actors.length),
              this.actors[n].send(e, t, i),
              n
          }
          ,
          x.prototype.remove = function() {
              this.actors.forEach(function(e) {
                  e.remove()
              }),
              this.actors = [],
              this.workerPool.release(this.id)
          }
          ,
          x.Actor = e.Actor;
          var S = function(t, i, n) {
              this.bounds = e.LngLatBounds.convert(this.validateBounds(t)),
              this.minzoom = i || 0,
              this.maxzoom = n || 24
          };
          S.prototype.validateBounds = function(e) {
              return Array.isArray(e) && 4 === e.length ? [Math.max(-180, e[0]), Math.max(-90, e[1]), Math.min(180, e[2]), Math.min(90, e[3])] : [-180, -90, 180, 90]
          }
          ,
          S.prototype.contains = function(t) {
              var i = Math.pow(2, t.z)
                , n = Math.floor(e.mercatorXfromLng(this.bounds.getWest()) * i)
                , r = Math.floor(e.mercatorYfromLat(this.bounds.getNorth()) * i)
                , o = Math.ceil(e.mercatorXfromLng(this.bounds.getEast()) * i)
                , s = Math.ceil(e.mercatorYfromLat(this.bounds.getSouth()) * i);
              return t.x >= n && t.x < o && t.y >= r && t.y < s
          }
          ;
          var E = function(t) {
              function i(i, n, r, o) {
                  if (t.call(this),
                  this.id = i,
                  this.dispatcher = r,
                  this.type = "vector",
                  this.minzoom = 0,
                  this.maxzoom = 22,
                  this.scheme = "xyz",
                  this.tileSize = 512,
                  this.reparseOverscaled = !0,
                  this.isTileClipped = !0,
                  e.extend(this, e.pick(n, ["url", "scheme", "tileSize"])),
                  this._options = e.extend({
                      type: "vector"
                  }, n),
                  this._collectResourceTiming = n.collectResourceTiming,
                  512 !== this.tileSize)
                      throw new Error("vector tile sources must have a tileSize of 512");
                  this.setEventedParent(o)
              }
              return t && (i.__proto__ = t),
              i.prototype = Object.create(t && t.prototype),
              i.prototype.constructor = i,
              i.prototype.load = function() {
                  var t = this;
                  this.fire(new e.Event("dataloading",{
                      dataType: "source"
                  })),
                  this._tileJSONRequest = k(this._options, this.map._transformRequest, function(i, n) {
                      t._tileJSONRequest = null,
                      i ? t.fire(new e.ErrorEvent(i)) : n && (e.extend(t, n),
                      n.bounds && (t.tileBounds = new S(n.bounds,t.minzoom,t.maxzoom)),
                      e.postTurnstileEvent(n.tiles),
                      e.postMapLoadEvent(n.tiles, t.map._getMapId()),
                      t.fire(new e.Event("data",{
                          dataType: "source",
                          sourceDataType: "metadata"
                      })),
                      t.fire(new e.Event("data",{
                          dataType: "source",
                          sourceDataType: "content"
                      })))
                  })
              }
              ,
              i.prototype.hasTile = function(e) {
                  return !this.tileBounds || this.tileBounds.contains(e.canonical)
              }
              ,
              i.prototype.onAdd = function(e) {
                  this.map = e,
                  this.load()
              }
              ,
              i.prototype.onRemove = function() {
                  this._tileJSONRequest && (this._tileJSONRequest.cancel(),
                  this._tileJSONRequest = null)
              }
              ,
              i.prototype.serialize = function() {
                  return e.extend({}, this._options)
              }
              ,
              i.prototype.loadTile = function(t, i) {
                  var n = e.normalizeTileURL(t.tileID.canonical.url(this.tiles, this.scheme), this.url)
                    , r = {
                      request: this.map._transformRequest(n, e.ResourceType.Tile),
                      uid: t.uid,
                      tileID: t.tileID,
                      zoom: t.tileID.overscaledZ,
                      tileSize: this.tileSize * t.tileID.overscaleFactor(),
                      type: this.type,
                      source: this.id,
                      pixelRatio: e.browser.devicePixelRatio,
                      showCollisionBoxes: this.map.showCollisionBoxes
                  };
                  function o(e, n) {
                      return t.aborted ? i(null) : e && 404 !== e.status ? i(e) : (n && n.resourceTiming && (t.resourceTiming = n.resourceTiming),
                      this.map._refreshExpiredTiles && n && t.setExpiryData(n),
                      t.loadVectorData(n, this.map.painter),
                      i(null),
                      void (t.reloadCallback && (this.loadTile(t, t.reloadCallback),
                      t.reloadCallback = null)))
                  }
                  r.request.collectResourceTiming = this._collectResourceTiming,
                  void 0 === t.workerID || "expired" === t.state ? t.workerID = this.dispatcher.send("loadTile", r, o.bind(this)) : "loading" === t.state ? t.reloadCallback = i : this.dispatcher.send("reloadTile", r, o.bind(this), t.workerID)
              }
              ,
              i.prototype.abortTile = function(e) {
                  this.dispatcher.send("abortTile", {
                      uid: e.uid,
                      type: this.type,
                      source: this.id
                  }, void 0, e.workerID)
              }
              ,
              i.prototype.unloadTile = function(e) {
                  e.unloadVectorData(),
                  this.dispatcher.send("removeTile", {
                      uid: e.uid,
                      type: this.type,
                      source: this.id
                  }, void 0, e.workerID)
              }
              ,
              i.prototype.hasTransition = function() {
                  return !1
              }
              ,
              i
          }(e.Evented)
            , T = function(t) {
              function i(i, n, r, o) {
                  t.call(this),
                  this.id = i,
                  this.dispatcher = r,
                  this.setEventedParent(o),
                  this.type = "raster",
                  this.minzoom = 0,
                  this.maxzoom = 22,
                  this.roundZoom = !0,
                  this.scheme = "xyz",
                  this.tileSize = 512,
                  this._loaded = !1,
                  this._options = e.extend({}, n),
                  e.extend(this, e.pick(n, ["url", "scheme", "tileSize"]))
              }
              return t && (i.__proto__ = t),
              i.prototype = Object.create(t && t.prototype),
              i.prototype.constructor = i,
              i.prototype.load = function() {
                  var t = this;
                  this.fire(new e.Event("dataloading",{
                      dataType: "source"
                  })),
                  this._tileJSONRequest = k(this._options, this.map._transformRequest, function(i, n) {
                      t._tileJSONRequest = null,
                      i ? t.fire(new e.ErrorEvent(i)) : n && (e.extend(t, n),
                      n.bounds && (t.tileBounds = new S(n.bounds,t.minzoom,t.maxzoom)),
                      e.postTurnstileEvent(n.tiles),
                      e.postMapLoadEvent(n.tiles, t.map._getMapId()),
                      t.fire(new e.Event("data",{
                          dataType: "source",
                          sourceDataType: "metadata"
                      })),
                      t.fire(new e.Event("data",{
                          dataType: "source",
                          sourceDataType: "content"
                      })))
                  })
              }
              ,
              i.prototype.onAdd = function(e) {
                  this.map = e,
                  this.load()
              }
              ,
              i.prototype.onRemove = function() {
                  this._tileJSONRequest && (this._tileJSONRequest.cancel(),
                  this._tileJSONRequest = null)
              }
              ,
              i.prototype.serialize = function() {
                  return e.extend({}, this._options)
              }
              ,
              i.prototype.hasTile = function(e) {
                  return !this.tileBounds || this.tileBounds.contains(e.canonical)
              }
              ,
              i.prototype.loadTile = function(t, i) {
                  var n = this
                    , r = e.normalizeTileURL(t.tileID.canonical.url(this.tiles, this.scheme), this.url, this.tileSize);
                  t.request = e.getImage(this.map._transformRequest(r, e.ResourceType.Tile), function(r, o) {
                      if (delete t.request,
                      t.aborted)
                          t.state = "unloaded",
                          i(null);
                      else if (r)
                          t.state = "errored",
                          i(r);
                      else if (o) {
                          n.map._refreshExpiredTiles && t.setExpiryData(o),
                          delete o.cacheControl,
                          delete o.expires;
                          var s = n.map.painter.context
                            , a = s.gl;
                          t.texture = n.map.painter.getTileTexture(o.width),
                          t.texture ? t.texture.update(o, {
                              useMipmap: !0
                          }) : (t.texture = new e.Texture(s,o,a.RGBA,{
                              useMipmap: !0
                          }),
                          t.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST),
                          s.extTextureFilterAnisotropic && a.texParameterf(a.TEXTURE_2D, s.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, s.extTextureFilterAnisotropicMax)),
                          t.state = "loaded",
                          i(null)
                      }
                  })
              }
              ,
              i.prototype.abortTile = function(e, t) {
                  e.request && (e.request.cancel(),
                  delete e.request),
                  t()
              }
              ,
              i.prototype.unloadTile = function(e, t) {
                  e.texture && this.map.painter.saveTileTexture(e.texture),
                  t()
              }
              ,
              i.prototype.hasTransition = function() {
                  return !1
              }
              ,
              i
          }(e.Evented)
            , C = function(t) {
              function i(i, n, r, o) {
                  t.call(this, i, n, r, o),
                  this.type = "raster-dem",
                  this.maxzoom = 22,
                  this._options = e.extend({}, n),
                  this.encoding = n.encoding || "mapbox"
              }
              return t && (i.__proto__ = t),
              i.prototype = Object.create(t && t.prototype),
              i.prototype.constructor = i,
              i.prototype.serialize = function() {
                  return {
                      type: "raster-dem",
                      url: this.url,
                      tileSize: this.tileSize,
                      tiles: this.tiles,
                      bounds: this.bounds,
                      encoding: this.encoding
                  }
              }
              ,
              i.prototype.loadTile = function(t, i) {
                  var n = e.normalizeTileURL(t.tileID.canonical.url(this.tiles, this.scheme), this.url, this.tileSize);
                  t.request = e.getImage(this.map._transformRequest(n, e.ResourceType.Tile), function(n, r) {
                      if (delete t.request,
                      t.aborted)
                          t.state = "unloaded",
                          i(null);
                      else if (n)
                          t.state = "errored",
                          i(n);
                      else if (r) {
                          this.map._refreshExpiredTiles && t.setExpiryData(r),
                          delete r.cacheControl,
                          delete r.expires;
                          var o = e.browser.getImageData(r)
                            , s = {
                              uid: t.uid,
                              coord: t.tileID,
                              source: this.id,
                              rawImageData: o,
                              encoding: this.encoding
                          };
                          t.workerID && "expired" !== t.state || (t.workerID = this.dispatcher.send("loadDEMTile", s, function(e, n) {
                              e && (t.state = "errored",
                              i(e)),
                              n && (t.dem = n,
                              t.needsHillshadePrepare = !0,
                              t.state = "loaded",
                              i(null))
                          }
                          .bind(this)))
                      }
                  }
                  .bind(this)),
                  t.neighboringTiles = this._getNeighboringTiles(t.tileID)
              }
              ,
              i.prototype._getNeighboringTiles = function(t) {
                  var i = t.canonical
                    , n = Math.pow(2, i.z)
                    , r = (i.x - 1 + n) % n
                    , o = 0 === i.x ? t.wrap - 1 : t.wrap
                    , s = (i.x + 1 + n) % n
                    , a = i.x + 1 === n ? t.wrap + 1 : t.wrap
                    , l = {};
                  return l[new e.OverscaledTileID(t.overscaledZ,o,i.z,r,i.y).key] = {
                      backfilled: !1
                  },
                  l[new e.OverscaledTileID(t.overscaledZ,a,i.z,s,i.y).key] = {
                      backfilled: !1
                  },
                  i.y > 0 && (l[new e.OverscaledTileID(t.overscaledZ,o,i.z,r,i.y - 1).key] = {
                      backfilled: !1
                  },
                  l[new e.OverscaledTileID(t.overscaledZ,t.wrap,i.z,i.x,i.y - 1).key] = {
                      backfilled: !1
                  },
                  l[new e.OverscaledTileID(t.overscaledZ,a,i.z,s,i.y - 1).key] = {
                      backfilled: !1
                  }),
                  i.y + 1 < n && (l[new e.OverscaledTileID(t.overscaledZ,o,i.z,r,i.y + 1).key] = {
                      backfilled: !1
                  },
                  l[new e.OverscaledTileID(t.overscaledZ,t.wrap,i.z,i.x,i.y + 1).key] = {
                      backfilled: !1
                  },
                  l[new e.OverscaledTileID(t.overscaledZ,a,i.z,s,i.y + 1).key] = {
                      backfilled: !1
                  }),
                  l
              }
              ,
              i.prototype.unloadTile = function(e) {
                  e.demTexture && this.map.painter.saveTileTexture(e.demTexture),
                  e.fbo && (e.fbo.destroy(),
                  delete e.fbo),
                  e.dem && delete e.dem,
                  delete e.neighboringTiles,
                  e.state = "unloaded",
                  this.dispatcher.send("removeDEMTile", {
                      uid: e.uid,
                      source: this.id
                  }, void 0, e.workerID)
              }
              ,
              i
          }(T)
            , L = function(t) {
              function i(i, n, r, o) {
                  t.call(this),
                  this.id = i,
                  this.type = "geojson",
                  this.minzoom = 0,
                  this.maxzoom = 18,
                  this.tileSize = 512,
                  this.isTileClipped = !0,
                  this.reparseOverscaled = !0,
                  this._removed = !1,
                  this.dispatcher = r,
                  this.setEventedParent(o),
                  this._data = n.data,
                  this._options = e.extend({}, n),
                  this._collectResourceTiming = n.collectResourceTiming,
                  this._resourceTiming = [],
                  void 0 !== n.maxzoom && (this.maxzoom = n.maxzoom),
                  n.type && (this.type = n.type),
                  n.attribution && (this.attribution = n.attribution);
                  var s = e.EXTENT / this.tileSize;
                  this.workerOptions = e.extend({
                      source: this.id,
                      cluster: n.cluster || !1,
                      geojsonVtOptions: {
                          buffer: (void 0 !== n.buffer ? n.buffer : 128) * s,
                          tolerance: (void 0 !== n.tolerance ? n.tolerance : .375) * s,
                          extent: e.EXTENT,
                          maxZoom: this.maxzoom,
                          lineMetrics: n.lineMetrics || !1,
                          generateId: n.generateId || !1
                      },
                      superclusterOptions: {
                          maxZoom: void 0 !== n.clusterMaxZoom ? Math.min(n.clusterMaxZoom, this.maxzoom - 1) : this.maxzoom - 1,
                          extent: e.EXTENT,
                          radius: (n.clusterRadius || 50) * s,
                          log: !1
                      },
                      clusterProperties: n.clusterProperties
                  }, n.workerOptions)
              }
              return t && (i.__proto__ = t),
              i.prototype = Object.create(t && t.prototype),
              i.prototype.constructor = i,
              i.prototype.load = function() {
                  var t = this;
                  this.fire(new e.Event("dataloading",{
                      dataType: "source"
                  })),
                  this._updateWorkerData(function(i) {
                      if (i)
                          t.fire(new e.ErrorEvent(i));
                      else {
                          var n = {
                              dataType: "source",
                              sourceDataType: "metadata"
                          };
                          t._collectResourceTiming && t._resourceTiming && t._resourceTiming.length > 0 && (n.resourceTiming = t._resourceTiming,
                          t._resourceTiming = []),
                          t.fire(new e.Event("data",n))
                      }
                  })
              }
              ,
              i.prototype.onAdd = function(e) {
                  this.map = e,
                  this.load()
              }
              ,
              i.prototype.setData = function(t) {
                  var i = this;
                  return this._data = t,
                  this.fire(new e.Event("dataloading",{
                      dataType: "source"
                  })),
                  this._updateWorkerData(function(t) {
                      if (t)
                          i.fire(new e.ErrorEvent(t));
                      else {
                          var n = {
                              dataType: "source",
                              sourceDataType: "content"
                          };
                          i._collectResourceTiming && i._resourceTiming && i._resourceTiming.length > 0 && (n.resourceTiming = i._resourceTiming,
                          i._resourceTiming = []),
                          i.fire(new e.Event("data",n))
                      }
                  }),
                  this
              }
              ,
              i.prototype.getClusterExpansionZoom = function(e, t) {
                  return this.dispatcher.send("geojson.getClusterExpansionZoom", {
                      clusterId: e,
                      source: this.id
                  }, t, this.workerID),
                  this
              }
              ,
              i.prototype.getClusterChildren = function(e, t) {
                  return this.dispatcher.send("geojson.getClusterChildren", {
                      clusterId: e,
                      source: this.id
                  }, t, this.workerID),
                  this
              }
              ,
              i.prototype.getClusterLeaves = function(e, t, i, n) {
                  return this.dispatcher.send("geojson.getClusterLeaves", {
                      source: this.id,
                      clusterId: e,
                      limit: t,
                      offset: i
                  }, n, this.workerID),
                  this
              }
              ,
              i.prototype._updateWorkerData = function(t) {
                  var i = this
                    , n = e.extend({}, this.workerOptions)
                    , r = this._data;
                  "string" == typeof r ? (n.request = this.map._transformRequest(e.browser.resolveURL(r), e.ResourceType.Source),
                  n.request.collectResourceTiming = this._collectResourceTiming) : n.data = JSON.stringify(r),
                  this.workerID = this.dispatcher.send(this.type + ".loadData", n, function(e, r) {
                      i._removed || r && r.abandoned || (i._loaded = !0,
                      r && r.resourceTiming && r.resourceTiming[i.id] && (i._resourceTiming = r.resourceTiming[i.id].slice(0)),
                      i.dispatcher.send(i.type + ".coalesce", {
                          source: n.source
                      }, null, i.workerID),
                      t(e))
                  }, this.workerID)
              }
              ,
              i.prototype.loadTile = function(t, i) {
                  var n = this
                    , r = void 0 === t.workerID ? "loadTile" : "reloadTile"
                    , o = {
                      type: this.type,
                      uid: t.uid,
                      tileID: t.tileID,
                      zoom: t.tileID.overscaledZ,
                      maxZoom: this.maxzoom,
                      tileSize: this.tileSize,
                      source: this.id,
                      pixelRatio: e.browser.devicePixelRatio,
                      showCollisionBoxes: this.map.showCollisionBoxes
                  };
                  t.workerID = this.dispatcher.send(r, o, function(e, o) {
                      return t.unloadVectorData(),
                      t.aborted ? i(null) : e ? i(e) : (t.loadVectorData(o, n.map.painter, "reloadTile" === r),
                      i(null))
                  }, this.workerID)
              }
              ,
              i.prototype.abortTile = function(e) {
                  e.aborted = !0
              }
              ,
              i.prototype.unloadTile = function(e) {
                  e.unloadVectorData(),
                  this.dispatcher.send("removeTile", {
                      uid: e.uid,
                      type: this.type,
                      source: this.id
                  }, null, e.workerID)
              }
              ,
              i.prototype.onRemove = function() {
                  this._removed = !0,
                  this.dispatcher.send("removeSource", {
                      type: this.type,
                      source: this.id
                  }, null, this.workerID)
              }
              ,
              i.prototype.serialize = function() {
                  return e.extend({}, this._options, {
                      type: this.type,
                      data: this._data
                  })
              }
              ,
              i.prototype.hasTransition = function() {
                  return !1
              }
              ,
              i
          }(e.Evented)
            , A = function(t) {
              function i(e, i, n, r) {
                  t.call(this),
                  this.id = e,
                  this.dispatcher = n,
                  this.coordinates = i.coordinates,
                  this.type = "image",
                  this.minzoom = 0,
                  this.maxzoom = 22,
                  this.tileSize = 512,
                  this.tiles = {},
                  this.setEventedParent(r),
                  this.options = i
              }
              return t && (i.__proto__ = t),
              i.prototype = Object.create(t && t.prototype),
              i.prototype.constructor = i,
              i.prototype.load = function(t, i) {
                  var n = this;
                  this.fire(new e.Event("dataloading",{
                      dataType: "source"
                  })),
                  this.url = this.options.url,
                  e.getImage(this.map._transformRequest(this.url, e.ResourceType.Image), function(r, o) {
                      r ? n.fire(new e.ErrorEvent(r)) : o && (n.image = o,
                      t && (n.coordinates = t),
                      i && i(),
                      n._finishLoading())
                  })
              }
              ,
              i.prototype.updateImage = function(e) {
                  var t = this;
                  return this.image && e.url ? (this.options.url = e.url,
                  this.load(e.coordinates, function() {
                      t.texture = null
                  }),
                  this) : this
              }
              ,
              i.prototype._finishLoading = function() {
                  this.map && (this.setCoordinates(this.coordinates),
                  this.fire(new e.Event("data",{
                      dataType: "source",
                      sourceDataType: "metadata"
                  })))
              }
              ,
              i.prototype.onAdd = function(e) {
                  this.map = e,
                  this.load()
              }
              ,
              i.prototype.setCoordinates = function(t) {
                  var i = this;
                  this.coordinates = t;
                  var n = t.map(e.MercatorCoordinate.fromLngLat);
                  this.tileID = function(t) {
                      for (var i = 1 / 0, n = 1 / 0, r = -1 / 0, o = -1 / 0, s = 0, a = t; s < a.length; s += 1) {
                          var l = a[s];
                          i = Math.min(i, l.x),
                          n = Math.min(n, l.y),
                          r = Math.max(r, l.x),
                          o = Math.max(o, l.y)
                      }
                      var c = r - i
                        , u = o - n
                        , h = Math.max(c, u)
                        , d = Math.max(0, Math.floor(-Math.log(h) / Math.LN2))
                        , p = Math.pow(2, d);
                      return new e.CanonicalTileID(d,Math.floor((i + r) / 2 * p),Math.floor((n + o) / 2 * p))
                  }(n),
                  this.minzoom = this.maxzoom = this.tileID.z;
                  var r = n.map(function(e) {
                      return i.tileID.getTilePoint(e)._round()
                  });
                  return this._boundsArray = new e.StructArrayLayout4i8,
                  this._boundsArray.emplaceBack(r[0].x, r[0].y, 0, 0),
                  this._boundsArray.emplaceBack(r[1].x, r[1].y, e.EXTENT, 0),
                  this._boundsArray.emplaceBack(r[3].x, r[3].y, 0, e.EXTENT),
                  this._boundsArray.emplaceBack(r[2].x, r[2].y, e.EXTENT, e.EXTENT),
                  this.boundsBuffer && (this.boundsBuffer.destroy(),
                  delete this.boundsBuffer),
                  this.fire(new e.Event("data",{
                      dataType: "source",
                      sourceDataType: "content"
                  })),
                  this
              }
              ,
              i.prototype.prepare = function() {
                  if (0 !== Object.keys(this.tiles).length && this.image) {
                      var t = this.map.painter.context
                        , i = t.gl;
                      for (var n in this.boundsBuffer || (this.boundsBuffer = t.createVertexBuffer(this._boundsArray, e.rasterBoundsAttributes.members)),
                      this.boundsSegments || (this.boundsSegments = e.SegmentVector.simpleSegment(0, 0, 4, 2)),
                      this.texture || (this.texture = new e.Texture(t,this.image,i.RGBA),
                      this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE)),
                      this.tiles) {
                          var r = this.tiles[n];
                          "loaded" !== r.state && (r.state = "loaded",
                          r.texture = this.texture)
                      }
                  }
              }
              ,
              i.prototype.loadTile = function(e, t) {
                  this.tileID && this.tileID.equals(e.tileID.canonical) ? (this.tiles[String(e.tileID.wrap)] = e,
                  e.buckets = {},
                  t(null)) : (e.state = "errored",
                  t(null))
              }
              ,
              i.prototype.serialize = function() {
                  return {
                      type: "image",
                      url: this.options.url,
                      coordinates: this.coordinates
                  }
              }
              ,
              i.prototype.hasTransition = function() {
                  return !1
              }
              ,
              i
          }(e.Evented)
            , P = {
              vector: E,
              raster: T,
              "raster-dem": C,
              geojson: L,
              video: function(t) {
                  function i(e, i, n, r) {
                      t.call(this, e, i, n, r),
                      this.roundZoom = !0,
                      this.type = "video",
                      this.options = i
                  }
                  return t && (i.__proto__ = t),
                  i.prototype = Object.create(t && t.prototype),
                  i.prototype.constructor = i,
                  i.prototype.load = function() {
                      var t = this
                        , i = this.options;
                      this.urls = [];
                      for (var n = 0, r = i.urls; n < r.length; n += 1) {
                          var o = r[n];
                          this.urls.push(this.map._transformRequest(o, e.ResourceType.Source).url)
                      }
                      e.getVideo(this.urls, function(i, n) {
                          i ? t.fire(new e.ErrorEvent(i)) : n && (t.video = n,
                          t.video.loop = !0,
                          t.video.addEventListener("playing", function() {
                              t.map.triggerRepaint()
                          }),
                          t.map && t.video.play(),
                          t._finishLoading())
                      })
                  }
                  ,
                  i.prototype.getVideo = function() {
                      return this.video
                  }
                  ,
                  i.prototype.onAdd = function(e) {
                      this.map || (this.map = e,
                      this.load(),
                      this.video && (this.video.play(),
                      this.setCoordinates(this.coordinates)))
                  }
                  ,
                  i.prototype.prepare = function() {
                      if (!(0 === Object.keys(this.tiles).length || this.video.readyState < 2)) {
                          var t = this.map.painter.context
                            , i = t.gl;
                          for (var n in this.boundsBuffer || (this.boundsBuffer = t.createVertexBuffer(this._boundsArray, e.rasterBoundsAttributes.members)),
                          this.boundsSegments || (this.boundsSegments = e.SegmentVector.simpleSegment(0, 0, 4, 2)),
                          this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE),
                          i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new e.Texture(t,this.video,i.RGBA),
                          this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE)),
                          this.tiles) {
                              var r = this.tiles[n];
                              "loaded" !== r.state && (r.state = "loaded",
                              r.texture = this.texture)
                          }
                      }
                  }
                  ,
                  i.prototype.serialize = function() {
                      return {
                          type: "video",
                          urls: this.urls,
                          coordinates: this.coordinates
                      }
                  }
                  ,
                  i.prototype.hasTransition = function() {
                      return this.video && !this.video.paused
                  }
                  ,
                  i
              }(A),
              image: A,
              canvas: function(t) {
                  function i(i, n, r, o) {
                      t.call(this, i, n, r, o),
                      n.coordinates ? Array.isArray(n.coordinates) && 4 === n.coordinates.length && !n.coordinates.some(function(e) {
                          return !Array.isArray(e) || 2 !== e.length || e.some(function(e) {
                              return "number" != typeof e
                          })
                      }) || this.fire(new e.ErrorEvent(new e.ValidationError("sources." + i,null,'"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e.ErrorEvent(new e.ValidationError("sources." + i,null,'missing required property "coordinates"'))),
                      n.animate && "boolean" != typeof n.animate && this.fire(new e.ErrorEvent(new e.ValidationError("sources." + i,null,'optional "animate" property must be a boolean value'))),
                      n.canvas ? "string" == typeof n.canvas || n.canvas instanceof e.window.HTMLCanvasElement || this.fire(new e.ErrorEvent(new e.ValidationError("sources." + i,null,'"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e.ErrorEvent(new e.ValidationError("sources." + i,null,'missing required property "canvas"'))),
                      this.options = n,
                      this.animate = void 0 === n.animate || n.animate
                  }
                  return t && (i.__proto__ = t),
                  i.prototype = Object.create(t && t.prototype),
                  i.prototype.constructor = i,
                  i.prototype.load = function() {
                      this.canvas || (this.canvas = this.options.canvas instanceof e.window.HTMLCanvasElement ? this.options.canvas : e.window.document.getElementById(this.options.canvas)),
                      this.width = this.canvas.width,
                      this.height = this.canvas.height,
                      this._hasInvalidDimensions() ? this.fire(new e.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                          this._playing = !0,
                          this.map.triggerRepaint()
                      }
                      ,
                      this.pause = function() {
                          this._playing = !1
                      }
                      ,
                      this._finishLoading())
                  }
                  ,
                  i.prototype.getCanvas = function() {
                      return this.canvas
                  }
                  ,
                  i.prototype.onAdd = function(e) {
                      this.map = e,
                      this.load(),
                      this.canvas && this.animate && this.play()
                  }
                  ,
                  i.prototype.onRemove = function() {
                      this.pause()
                  }
                  ,
                  i.prototype.prepare = function() {
                      var t = !1;
                      if (this.canvas.width !== this.width && (this.width = this.canvas.width,
                      t = !0),
                      this.canvas.height !== this.height && (this.height = this.canvas.height,
                      t = !0),
                      !this._hasInvalidDimensions() && 0 !== Object.keys(this.tiles).length) {
                          var i = this.map.painter.context
                            , n = i.gl;
                          for (var r in this.boundsBuffer || (this.boundsBuffer = i.createVertexBuffer(this._boundsArray, e.rasterBoundsAttributes.members)),
                          this.boundsSegments || (this.boundsSegments = e.SegmentVector.simpleSegment(0, 0, 4, 2)),
                          this.texture ? (t || this._playing) && this.texture.update(this.canvas, {
                              premultiply: !0
                          }) : this.texture = new e.Texture(i,this.canvas,n.RGBA,{
                              premultiply: !0
                          }),
                          this.tiles) {
                              var o = this.tiles[r];
                              "loaded" !== o.state && (o.state = "loaded",
                              o.texture = this.texture)
                          }
                      }
                  }
                  ,
                  i.prototype.serialize = function() {
                      return {
                          type: "canvas",
                          coordinates: this.coordinates
                      }
                  }
                  ,
                  i.prototype.hasTransition = function() {
                      return this._playing
                  }
                  ,
                  i.prototype._hasInvalidDimensions = function() {
                      for (var e = 0, t = [this.canvas.width, this.canvas.height]; e < t.length; e += 1) {
                          var i = t[e];
                          if (isNaN(i) || i <= 0)
                              return !0
                      }
                      return !1
                  }
                  ,
                  i
              }(A)
          }
            , I = function(t, i, n, r) {
              var o = new P[i.type](t,i,n,r);
              if (o.id !== t)
                  throw new Error("Expected Source id to be " + t + " instead of " + o.id);
              return e.bindAll(["load", "abort", "unload", "serialize", "prepare"], o),
              o
          };
          function M(t, i) {
              var n = e.identity([]);
              return e.translate(n, n, [1, 1, 0]),
              e.scale(n, n, [.5 * t.width, .5 * t.height, 1]),
              e.multiply(n, n, t.calculatePosMatrix(i.toUnwrapped()))
          }
          function O(e, t, i, n, r) {
              var o = function(e, t, i) {
                  if (e)
                      for (var n = 0, r = e; n < r.length; n += 1) {
                          var o = t[r[n]];
                          if (o && o.source === i && "fill-extrusion" === o.type)
                              return !0
                      }
                  else
                      for (var s in t) {
                          var a = t[s];
                          if (a.source === i && "fill-extrusion" === a.type)
                              return !0
                      }
                  return !1
              }(n && n.layers, t, e.id)
                , s = r.maxPitchScaleFactor()
                , a = e.tilesIn(i, s, o);
              a.sort(z);
              for (var l = [], c = 0, u = a; c < u.length; c += 1) {
                  var h = u[c];
                  l.push({
                      wrappedTileID: h.tileID.wrapped().key,
                      queryResults: h.tile.queryRenderedFeatures(t, e._state, h.queryGeometry, h.cameraQueryGeometry, h.scale, n, r, s, M(e.transform, h.tileID))
                  })
              }
              var d = function(e) {
                  for (var t = {}, i = {}, n = 0, r = e; n < r.length; n += 1) {
                      var o = r[n]
                        , s = o.queryResults
                        , a = o.wrappedTileID
                        , l = i[a] = i[a] || {};
                      for (var c in s)
                          for (var u = s[c], h = l[c] = l[c] || {}, d = t[c] = t[c] || [], p = 0, f = u; p < f.length; p += 1) {
                              var m = f[p];
                              h[m.featureIndex] || (h[m.featureIndex] = !0,
                              d.push(m))
                          }
                  }
                  return t
              }(l);
              for (var p in d)
                  d[p].forEach(function(t) {
                      var i = t.feature
                        , n = e.getFeatureState(i.layer["source-layer"], i.id);
                      i.source = i.layer.source,
                      i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]),
                      i.state = n
                  });
              return d
          }
          function z(e, t) {
              var i = e.tileID
                , n = t.tileID;
              return i.overscaledZ - n.overscaledZ || i.canonical.y - n.canonical.y || i.wrap - n.wrap || i.canonical.x - n.canonical.x
          }
          var D = function(e, t) {
              this.max = e,
              this.onRemove = t,
              this.reset()
          };
          D.prototype.reset = function() {
              for (var e in this.data)
                  for (var t = 0, i = this.data[e]; t < i.length; t += 1) {
                      var n = i[t];
                      n.timeout && clearTimeout(n.timeout),
                      this.onRemove(n.value)
                  }
              return this.data = {},
              this.order = [],
              this
          }
          ,
          D.prototype.add = function(e, t, i) {
              var n = this
                , r = e.wrapped().key;
              void 0 === this.data[r] && (this.data[r] = []);
              var o = {
                  value: t,
                  timeout: void 0
              };
              if (void 0 !== i && (o.timeout = setTimeout(function() {
                  n.remove(e, o)
              }, i)),
              this.data[r].push(o),
              this.order.push(r),
              this.order.length > this.max) {
                  var s = this._getAndRemoveByKey(this.order[0]);
                  s && this.onRemove(s)
              }
              return this
          }
          ,
          D.prototype.has = function(e) {
              return e.wrapped().key in this.data
          }
          ,
          D.prototype.getAndRemove = function(e) {
              return this.has(e) ? this._getAndRemoveByKey(e.wrapped().key) : null
          }
          ,
          D.prototype._getAndRemoveByKey = function(e) {
              var t = this.data[e].shift();
              return t.timeout && clearTimeout(t.timeout),
              0 === this.data[e].length && delete this.data[e],
              this.order.splice(this.order.indexOf(e), 1),
              t.value
          }
          ,
          D.prototype.get = function(e) {
              return this.has(e) ? this.data[e.wrapped().key][0].value : null
          }
          ,
          D.prototype.remove = function(e, t) {
              if (!this.has(e))
                  return this;
              var i = e.wrapped().key
                , n = void 0 === t ? 0 : this.data[i].indexOf(t)
                , r = this.data[i][n];
              return this.data[i].splice(n, 1),
              r.timeout && clearTimeout(r.timeout),
              0 === this.data[i].length && delete this.data[i],
              this.onRemove(r.value),
              this.order.splice(this.order.indexOf(i), 1),
              this
          }
          ,
          D.prototype.setMaxSize = function(e) {
              for (this.max = e; this.order.length > this.max; ) {
                  var t = this._getAndRemoveByKey(this.order[0]);
                  t && this.onRemove(t)
              }
              return this
          }
          ;
          var R = function(e, t, i) {
              this.context = e;
              var n = e.gl;
              this.buffer = n.createBuffer(),
              this.dynamicDraw = Boolean(i),
              this.context.unbindVAO(),
              e.bindElementBuffer.set(this.buffer),
              n.bufferData(n.ELEMENT_ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? n.DYNAMIC_DRAW : n.STATIC_DRAW),
              this.dynamicDraw || delete t.arrayBuffer
          };
          R.prototype.bind = function() {
              this.context.bindElementBuffer.set(this.buffer)
          }
          ,
          R.prototype.updateData = function(e) {
              var t = this.context.gl;
              this.context.unbindVAO(),
              this.bind(),
              t.bufferSubData(t.ELEMENT_ARRAY_BUFFER, 0, e.arrayBuffer)
          }
          ,
          R.prototype.destroy = function() {
              var e = this.context.gl;
              this.buffer && (e.deleteBuffer(this.buffer),
              delete this.buffer)
          }
          ;
          var B = {
              Int8: "BYTE",
              Uint8: "UNSIGNED_BYTE",
              Int16: "SHORT",
              Uint16: "UNSIGNED_SHORT",
              Int32: "INT",
              Uint32: "UNSIGNED_INT",
              Float32: "FLOAT"
          }
            , j = function(e, t, i, n) {
              this.length = t.length,
              this.attributes = i,
              this.itemSize = t.bytesPerElement,
              this.dynamicDraw = n,
              this.context = e;
              var r = e.gl;
              this.buffer = r.createBuffer(),
              e.bindVertexBuffer.set(this.buffer),
              r.bufferData(r.ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW),
              this.dynamicDraw || delete t.arrayBuffer
          };
          j.prototype.bind = function() {
              this.context.bindVertexBuffer.set(this.buffer)
          }
          ,
          j.prototype.updateData = function(e) {
              var t = this.context.gl;
              this.bind(),
              t.bufferSubData(t.ARRAY_BUFFER, 0, e.arrayBuffer)
          }
          ,
          j.prototype.enableAttributes = function(e, t) {
              for (var i = 0; i < this.attributes.length; i++) {
                  var n = this.attributes[i]
                    , r = t.attributes[n.name];
                  void 0 !== r && e.enableVertexAttribArray(r)
              }
          }
          ,
          j.prototype.setVertexAttribPointers = function(e, t, i) {
              for (var n = 0; n < this.attributes.length; n++) {
                  var r = this.attributes[n]
                    , o = t.attributes[r.name];
                  void 0 !== o && e.vertexAttribPointer(o, r.components, e[B[r.type]], !1, this.itemSize, r.offset + this.itemSize * (i || 0))
              }
          }
          ,
          j.prototype.destroy = function() {
              var e = this.context.gl;
              this.buffer && (e.deleteBuffer(this.buffer),
              delete this.buffer)
          }
          ;
          var F = function(e) {
              this.gl = e.gl,
              this.default = this.getDefault(),
              this.current = this.default,
              this.dirty = !1
          };
          F.prototype.get = function() {
              return this.current
          }
          ,
          F.prototype.set = function(e) {}
          ,
          F.prototype.getDefault = function() {
              return this.default
          }
          ,
          F.prototype.setDefault = function() {
              this.set(this.default)
          }
          ;
          var N = function(t) {
              function i() {
                  t.apply(this, arguments)
              }
              return t && (i.__proto__ = t),
              i.prototype = Object.create(t && t.prototype),
              i.prototype.constructor = i,
              i.prototype.getDefault = function() {
                  return e.Color.transparent
              }
              ,
              i.prototype.set = function(e) {
                  var t = this.current;
                  (e.r !== t.r || e.g !== t.g || e.b !== t.b || e.a !== t.a || this.dirty) && (this.gl.clearColor(e.r, e.g, e.b, e.a),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              i
          }(F)
            , U = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return 1
              }
              ,
              t.prototype.set = function(e) {
                  (e !== this.current || this.dirty) && (this.gl.clearDepth(e),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , q = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return 0
              }
              ,
              t.prototype.set = function(e) {
                  (e !== this.current || this.dirty) && (this.gl.clearStencil(e),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , H = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return [!0, !0, !0, !0]
              }
              ,
              t.prototype.set = function(e) {
                  var t = this.current;
                  (e[0] !== t[0] || e[1] !== t[1] || e[2] !== t[2] || e[3] !== t[3] || this.dirty) && (this.gl.colorMask(e[0], e[1], e[2], e[3]),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , V = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return !0
              }
              ,
              t.prototype.set = function(e) {
                  (e !== this.current || this.dirty) && (this.gl.depthMask(e),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , W = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return 255
              }
              ,
              t.prototype.set = function(e) {
                  (e !== this.current || this.dirty) && (this.gl.stencilMask(e),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , $ = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return {
                      func: this.gl.ALWAYS,
                      ref: 0,
                      mask: 255
                  }
              }
              ,
              t.prototype.set = function(e) {
                  var t = this.current;
                  (e.func !== t.func || e.ref !== t.ref || e.mask !== t.mask || this.dirty) && (this.gl.stencilFunc(e.func, e.ref, e.mask),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , G = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  var e = this.gl;
                  return [e.KEEP, e.KEEP, e.KEEP]
              }
              ,
              t.prototype.set = function(e) {
                  var t = this.current;
                  (e[0] !== t[0] || e[1] !== t[1] || e[2] !== t[2] || this.dirty) && (this.gl.stencilOp(e[0], e[1], e[2]),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , X = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return !1
              }
              ,
              t.prototype.set = function(e) {
                  if (e !== this.current || this.dirty) {
                      var t = this.gl;
                      e ? t.enable(t.STENCIL_TEST) : t.disable(t.STENCIL_TEST),
                      this.current = e,
                      this.dirty = !1
                  }
              }
              ,
              t
          }(F)
            , Z = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return [0, 1]
              }
              ,
              t.prototype.set = function(e) {
                  var t = this.current;
                  (e[0] !== t[0] || e[1] !== t[1] || this.dirty) && (this.gl.depthRange(e[0], e[1]),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , Y = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return !1
              }
              ,
              t.prototype.set = function(e) {
                  if (e !== this.current || this.dirty) {
                      var t = this.gl;
                      e ? t.enable(t.DEPTH_TEST) : t.disable(t.DEPTH_TEST),
                      this.current = e,
                      this.dirty = !1
                  }
              }
              ,
              t
          }(F)
            , K = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return this.gl.LESS
              }
              ,
              t.prototype.set = function(e) {
                  (e !== this.current || this.dirty) && (this.gl.depthFunc(e),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , J = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return !1
              }
              ,
              t.prototype.set = function(e) {
                  if (e !== this.current || this.dirty) {
                      var t = this.gl;
                      e ? t.enable(t.BLEND) : t.disable(t.BLEND),
                      this.current = e,
                      this.dirty = !1
                  }
              }
              ,
              t
          }(F)
            , Q = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  var e = this.gl;
                  return [e.ONE, e.ZERO]
              }
              ,
              t.prototype.set = function(e) {
                  var t = this.current;
                  (e[0] !== t[0] || e[1] !== t[1] || this.dirty) && (this.gl.blendFunc(e[0], e[1]),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , ee = function(t) {
              function i() {
                  t.apply(this, arguments)
              }
              return t && (i.__proto__ = t),
              i.prototype = Object.create(t && t.prototype),
              i.prototype.constructor = i,
              i.prototype.getDefault = function() {
                  return e.Color.transparent
              }
              ,
              i.prototype.set = function(e) {
                  var t = this.current;
                  (e.r !== t.r || e.g !== t.g || e.b !== t.b || e.a !== t.a || this.dirty) && (this.gl.blendColor(e.r, e.g, e.b, e.a),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              i
          }(F)
            , te = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return this.gl.FUNC_ADD
              }
              ,
              t.prototype.set = function(e) {
                  (e !== this.current || this.dirty) && (this.gl.blendEquation(e),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , ie = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return !1
              }
              ,
              t.prototype.set = function(e) {
                  if (e !== this.current || this.dirty) {
                      var t = this.gl;
                      e ? t.enable(t.CULL_FACE) : t.disable(t.CULL_FACE),
                      this.current = e,
                      this.dirty = !1
                  }
              }
              ,
              t
          }(F)
            , ne = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return this.gl.BACK
              }
              ,
              t.prototype.set = function(e) {
                  (e !== this.current || this.dirty) && (this.gl.cullFace(e),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , re = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return this.gl.CCW
              }
              ,
              t.prototype.set = function(e) {
                  (e !== this.current || this.dirty) && (this.gl.frontFace(e),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , oe = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return null
              }
              ,
              t.prototype.set = function(e) {
                  (e !== this.current || this.dirty) && (this.gl.useProgram(e),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , se = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return this.gl.TEXTURE0
              }
              ,
              t.prototype.set = function(e) {
                  (e !== this.current || this.dirty) && (this.gl.activeTexture(e),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , ae = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  var e = this.gl;
                  return [0, 0, e.drawingBufferWidth, e.drawingBufferHeight]
              }
              ,
              t.prototype.set = function(e) {
                  var t = this.current;
                  (e[0] !== t[0] || e[1] !== t[1] || e[2] !== t[2] || e[3] !== t[3] || this.dirty) && (this.gl.viewport(e[0], e[1], e[2], e[3]),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , le = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return null
              }
              ,
              t.prototype.set = function(e) {
                  if (e !== this.current || this.dirty) {
                      var t = this.gl;
                      t.bindFramebuffer(t.FRAMEBUFFER, e),
                      this.current = e,
                      this.dirty = !1
                  }
              }
              ,
              t
          }(F)
            , ce = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return null
              }
              ,
              t.prototype.set = function(e) {
                  if (e !== this.current || this.dirty) {
                      var t = this.gl;
                      t.bindRenderbuffer(t.RENDERBUFFER, e),
                      this.current = e,
                      this.dirty = !1
                  }
              }
              ,
              t
          }(F)
            , ue = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return null
              }
              ,
              t.prototype.set = function(e) {
                  if (e !== this.current || this.dirty) {
                      var t = this.gl;
                      t.bindTexture(t.TEXTURE_2D, e),
                      this.current = e,
                      this.dirty = !1
                  }
              }
              ,
              t
          }(F)
            , he = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return null
              }
              ,
              t.prototype.set = function(e) {
                  if (e !== this.current || this.dirty) {
                      var t = this.gl;
                      t.bindBuffer(t.ARRAY_BUFFER, e),
                      this.current = e,
                      this.dirty = !1
                  }
              }
              ,
              t
          }(F)
            , de = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return null
              }
              ,
              t.prototype.set = function(e) {
                  var t = this.gl;
                  t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, e),
                  this.current = e,
                  this.dirty = !1
              }
              ,
              t
          }(F)
            , pe = function(e) {
              function t(t) {
                  e.call(this, t),
                  this.vao = t.extVertexArrayObject
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return null
              }
              ,
              t.prototype.set = function(e) {
                  this.vao && (e !== this.current || this.dirty) && (this.vao.bindVertexArrayOES(e),
                  this.current = e,
                  this.dirty = !1)
              }
              ,
              t
          }(F)
            , fe = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return 4
              }
              ,
              t.prototype.set = function(e) {
                  if (e !== this.current || this.dirty) {
                      var t = this.gl;
                      t.pixelStorei(t.UNPACK_ALIGNMENT, e),
                      this.current = e,
                      this.dirty = !1
                  }
              }
              ,
              t
          }(F)
            , me = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return !1
              }
              ,
              t.prototype.set = function(e) {
                  if (e !== this.current || this.dirty) {
                      var t = this.gl;
                      t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e),
                      this.current = e,
                      this.dirty = !1
                  }
              }
              ,
              t
          }(F)
            , ge = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return !1
              }
              ,
              t.prototype.set = function(e) {
                  if (e !== this.current || this.dirty) {
                      var t = this.gl;
                      t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, e),
                      this.current = e,
                      this.dirty = !1
                  }
              }
              ,
              t
          }(F)
            , ve = function(e) {
              function t(t, i) {
                  e.call(this, t),
                  this.context = t,
                  this.parent = i
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.getDefault = function() {
                  return null
              }
              ,
              t
          }(F)
            , ye = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.setDirty = function() {
                  this.dirty = !0
              }
              ,
              t.prototype.set = function(e) {
                  if (e !== this.current || this.dirty) {
                      this.context.bindFramebuffer.set(this.parent);
                      var t = this.gl;
                      t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e, 0),
                      this.current = e,
                      this.dirty = !1
                  }
              }
              ,
              t
          }(ve)
            , _e = function(e) {
              function t() {
                  e.apply(this, arguments)
              }
              return e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t,
              t.prototype.set = function(e) {
                  if (e !== this.current || this.dirty) {
                      this.context.bindFramebuffer.set(this.parent);
                      var t = this.gl;
                      t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.RENDERBUFFER, e),
                      this.current = e,
                      this.dirty = !1
                  }
              }
              ,
              t
          }(ve)
            , be = function(e, t, i) {
              this.context = e,
              this.width = t,
              this.height = i;
              var n = e.gl
                , r = this.framebuffer = n.createFramebuffer();
              this.colorAttachment = new ye(e,r),
              this.depthAttachment = new _e(e,r)
          };
          be.prototype.destroy = function() {
              var e = this.context.gl
                , t = this.colorAttachment.get();
              t && e.deleteTexture(t);
              var i = this.depthAttachment.get();
              i && e.deleteRenderbuffer(i),
              e.deleteFramebuffer(this.framebuffer)
          }
          ;
          var we = function(e, t, i) {
              this.func = e,
              this.mask = t,
              this.range = i
          };
          we.ReadOnly = !1,
          we.ReadWrite = !0,
          we.disabled = new we(519,we.ReadOnly,[0, 1]);
          var xe = function(e, t, i, n, r, o) {
              this.test = e,
              this.ref = t,
              this.mask = i,
              this.fail = n,
              this.depthFail = r,
              this.pass = o
          };
          xe.disabled = new xe({
              func: 519,
              mask: 0
          },0,0,7680,7680,7680);
          var ke = function(e, t, i) {
              this.blendFunction = e,
              this.blendColor = t,
              this.mask = i
          };
          ke.disabled = new ke(ke.Replace = [1, 0],e.Color.transparent,[!1, !1, !1, !1]),
          ke.unblended = new ke(ke.Replace,e.Color.transparent,[!0, !0, !0, !0]),
          ke.alphaBlended = new ke([1, 771],e.Color.transparent,[!0, !0, !0, !0]);
          var Se = function(e, t, i) {
              this.enable = e,
              this.mode = t,
              this.frontFace = i
          };
          Se.disabled = new Se(!1,1029,2305),
          Se.backCCW = new Se(!0,1029,2305);
          var Ee = function(e) {
              this.gl = e,
              this.extVertexArrayObject = this.gl.getExtension("OES_vertex_array_object"),
              this.clearColor = new N(this),
              this.clearDepth = new U(this),
              this.clearStencil = new q(this),
              this.colorMask = new H(this),
              this.depthMask = new V(this),
              this.stencilMask = new W(this),
              this.stencilFunc = new $(this),
              this.stencilOp = new G(this),
              this.stencilTest = new X(this),
              this.depthRange = new Z(this),
              this.depthTest = new Y(this),
              this.depthFunc = new K(this),
              this.blend = new J(this),
              this.blendFunc = new Q(this),
              this.blendColor = new ee(this),
              this.blendEquation = new te(this),
              this.cullFace = new ie(this),
              this.cullFaceSide = new ne(this),
              this.frontFace = new re(this),
              this.program = new oe(this),
              this.activeTexture = new se(this),
              this.viewport = new ae(this),
              this.bindFramebuffer = new le(this),
              this.bindRenderbuffer = new ce(this),
              this.bindTexture = new ue(this),
              this.bindVertexBuffer = new he(this),
              this.bindElementBuffer = new de(this),
              this.bindVertexArrayOES = this.extVertexArrayObject && new pe(this),
              this.pixelStoreUnpack = new fe(this),
              this.pixelStoreUnpackPremultiplyAlpha = new me(this),
              this.pixelStoreUnpackFlipY = new ge(this),
              this.extTextureFilterAnisotropic = e.getExtension("EXT_texture_filter_anisotropic") || e.getExtension("MOZ_EXT_texture_filter_anisotropic") || e.getExtension("WEBKIT_EXT_texture_filter_anisotropic"),
              this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)),
              this.extTextureHalfFloat = e.getExtension("OES_texture_half_float"),
              this.extTextureHalfFloat && e.getExtension("OES_texture_half_float_linear")
          };
          Ee.prototype.setDirty = function() {
              this.clearColor.dirty = !0,
              this.clearDepth.dirty = !0,
              this.clearStencil.dirty = !0,
              this.colorMask.dirty = !0,
              this.depthMask.dirty = !0,
              this.stencilMask.dirty = !0,
              this.stencilFunc.dirty = !0,
              this.stencilOp.dirty = !0,
              this.stencilTest.dirty = !0,
              this.depthRange.dirty = !0,
              this.depthTest.dirty = !0,
              this.depthFunc.dirty = !0,
              this.blend.dirty = !0,
              this.blendFunc.dirty = !0,
              this.blendColor.dirty = !0,
              this.blendEquation.dirty = !0,
              this.cullFace.dirty = !0,
              this.cullFaceSide.dirty = !0,
              this.frontFace.dirty = !0,
              this.program.dirty = !0,
              this.activeTexture.dirty = !0,
              this.viewport.dirty = !0,
              this.bindFramebuffer.dirty = !0,
              this.bindRenderbuffer.dirty = !0,
              this.bindTexture.dirty = !0,
              this.bindVertexBuffer.dirty = !0,
              this.bindElementBuffer.dirty = !0,
              this.extVertexArrayObject && (this.bindVertexArrayOES.dirty = !0),
              this.pixelStoreUnpack.dirty = !0,
              this.pixelStoreUnpackPremultiplyAlpha.dirty = !0,
              this.pixelStoreUnpackFlipY.dirty = !0
          }
          ,
          Ee.prototype.createIndexBuffer = function(e, t) {
              return new R(this,e,t)
          }
          ,
          Ee.prototype.createVertexBuffer = function(e, t, i) {
              return new j(this,e,t,i)
          }
          ,
          Ee.prototype.createRenderbuffer = function(e, t, i) {
              var n = this.gl
                , r = n.createRenderbuffer();
              return this.bindRenderbuffer.set(r),
              n.renderbufferStorage(n.RENDERBUFFER, e, t, i),
              this.bindRenderbuffer.set(null),
              r
          }
          ,
          Ee.prototype.createFramebuffer = function(e, t) {
              return new be(this,e,t)
          }
          ,
          Ee.prototype.clear = function(e) {
              var t = e.color
                , i = e.depth
                , n = this.gl
                , r = 0;
              t && (r |= n.COLOR_BUFFER_BIT,
              this.clearColor.set(t),
              this.colorMask.set([!0, !0, !0, !0])),
              void 0 !== i && (r |= n.DEPTH_BUFFER_BIT,
              this.depthRange.set([0, 1]),
              this.clearDepth.set(i),
              this.depthMask.set(!0)),
              n.clear(r)
          }
          ,
          Ee.prototype.setCullFace = function(e) {
              !1 === e.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0),
              this.cullFaceSide.set(e.mode),
              this.frontFace.set(e.frontFace))
          }
          ,
          Ee.prototype.setDepthMode = function(e) {
              e.func !== this.gl.ALWAYS || e.mask ? (this.depthTest.set(!0),
              this.depthFunc.set(e.func),
              this.depthMask.set(e.mask),
              this.depthRange.set(e.range)) : this.depthTest.set(!1)
          }
          ,
          Ee.prototype.setStencilMode = function(e) {
              e.test.func !== this.gl.ALWAYS || e.mask ? (this.stencilTest.set(!0),
              this.stencilMask.set(e.mask),
              this.stencilOp.set([e.fail, e.depthFail, e.pass]),
              this.stencilFunc.set({
                  func: e.test.func,
                  ref: e.ref,
                  mask: e.test.mask
              })) : this.stencilTest.set(!1)
          }
          ,
          Ee.prototype.setColorMode = function(t) {
              e.isEqual(t.blendFunction, ke.Replace) ? this.blend.set(!1) : (this.blend.set(!0),
              this.blendFunc.set(t.blendFunction),
              this.blendColor.set(t.blendColor)),
              this.colorMask.set(t.mask)
          }
          ,
          Ee.prototype.unbindVAO = function() {
              this.extVertexArrayObject && this.bindVertexArrayOES.set(null)
          }
          ;
          var Te = function(t) {
              function i(i, n, r) {
                  var o = this;
                  t.call(this),
                  this.id = i,
                  this.dispatcher = r,
                  this.on("data", function(e) {
                      "source" === e.dataType && "metadata" === e.sourceDataType && (o._sourceLoaded = !0),
                      o._sourceLoaded && !o._paused && "source" === e.dataType && "content" === e.sourceDataType && (o.reload(),
                      o.transform && o.update(o.transform))
                  }),
                  this.on("error", function() {
                      o._sourceErrored = !0
                  }),
                  this._source = I(i, n, r, this),
                  this._tiles = {},
                  this._cache = new D(0,this._unloadTile.bind(this)),
                  this._timers = {},
                  this._cacheTimers = {},
                  this._maxTileCacheSize = null,
                  this._coveredTiles = {},
                  this._state = new e.SourceFeatureState
              }
              return t && (i.__proto__ = t),
              i.prototype = Object.create(t && t.prototype),
              i.prototype.constructor = i,
              i.prototype.onAdd = function(e) {
                  this.map = e,
                  this._maxTileCacheSize = e ? e._maxTileCacheSize : null,
                  this._source && this._source.onAdd && this._source.onAdd(e)
              }
              ,
              i.prototype.onRemove = function(e) {
                  this._source && this._source.onRemove && this._source.onRemove(e)
              }
              ,
              i.prototype.loaded = function() {
                  if (this._sourceErrored)
                      return !0;
                  if (!this._sourceLoaded)
                      return !1;
                  for (var e in this._tiles) {
                      var t = this._tiles[e];
                      if ("loaded" !== t.state && "errored" !== t.state)
                          return !1
                  }
                  return !0
              }
              ,
              i.prototype.getSource = function() {
                  return this._source
              }
              ,
              i.prototype.pause = function() {
                  this._paused = !0
              }
              ,
              i.prototype.resume = function() {
                  if (this._paused) {
                      var e = this._shouldReloadOnResume;
                      this._paused = !1,
                      this._shouldReloadOnResume = !1,
                      e && this.reload(),
                      this.transform && this.update(this.transform)
                  }
              }
              ,
              i.prototype._loadTile = function(e, t) {
                  return this._source.loadTile(e, t)
              }
              ,
              i.prototype._unloadTile = function(e) {
                  if (this._source.unloadTile)
                      return this._source.unloadTile(e, function() {})
              }
              ,
              i.prototype._abortTile = function(e) {
                  if (this._source.abortTile)
                      return this._source.abortTile(e, function() {})
              }
              ,
              i.prototype.serialize = function() {
                  return this._source.serialize()
              }
              ,
              i.prototype.prepare = function(e) {
                  for (var t in this._source.prepare && this._source.prepare(),
                  this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null),
                  this._tiles)
                      this._tiles[t].upload(e)
              }
              ,
              i.prototype.getIds = function() {
                  return Object.keys(this._tiles).map(Number).sort(Ce)
              }
              ,
              i.prototype.getRenderableIds = function(t) {
                  var i = this
                    , n = [];
                  for (var r in this._tiles)
                      this._isIdRenderable(+r, t) && n.push(+r);
                  return t ? n.sort(function(t, n) {
                      var r = i._tiles[t].tileID
                        , o = i._tiles[n].tileID
                        , s = new e.Point(r.canonical.x,r.canonical.y)._rotate(i.transform.angle)
                        , a = new e.Point(o.canonical.x,o.canonical.y)._rotate(i.transform.angle);
                      return r.overscaledZ - o.overscaledZ || a.y - s.y || a.x - s.x
                  }) : n.sort(Ce)
              }
              ,
              i.prototype.hasRenderableParent = function(e) {
                  var t = this.findLoadedParent(e, 0);
                  return !!t && this._isIdRenderable(t.tileID.key)
              }
              ,
              i.prototype._isIdRenderable = function(e, t) {
                  return this._tiles[e] && this._tiles[e].hasData() && !this._coveredTiles[e] && (t || !this._tiles[e].holdingForFade())
              }
              ,
              i.prototype.reload = function() {
                  if (this._paused)
                      this._shouldReloadOnResume = !0;
                  else
                      for (var e in this._cache.reset(),
                      this._tiles)
                          "errored" !== this._tiles[e].state && this._reloadTile(e, "reloading")
              }
              ,
              i.prototype._reloadTile = function(e, t) {
                  var i = this._tiles[e];
                  i && ("loading" !== i.state && (i.state = t),
                  this._loadTile(i, this._tileLoaded.bind(this, i, e, t)))
              }
              ,
              i.prototype._tileLoaded = function(t, i, n, r) {
                  if (r)
                      return t.state = "errored",
                      void (404 !== r.status ? this._source.fire(new e.ErrorEvent(r,{
                          tile: t
                      })) : this.update(this.transform));
                  t.timeAdded = e.browser.now(),
                  "expired" === n && (t.refreshedUponExpiration = !0),
                  this._setTileReloadTimer(i, t),
                  "raster-dem" === this.getSource().type && t.dem && this._backfillDEM(t),
                  this._state.initializeTileState(t, this.map ? this.map.painter : null),
                  this._source.fire(new e.Event("data",{
                      dataType: "source",
                      tile: t,
                      coord: t.tileID
                  }))
              }
              ,
              i.prototype._backfillDEM = function(e) {
                  for (var t = this.getRenderableIds(), i = 0; i < t.length; i++) {
                      var n = t[i];
                      if (e.neighboringTiles && e.neighboringTiles[n]) {
                          var r = this.getTileByID(n);
                          o(e, r),
                          o(r, e)
                      }
                  }
                  function o(e, t) {
                      e.needsHillshadePrepare = !0;
                      var i = t.tileID.canonical.x - e.tileID.canonical.x
                        , n = t.tileID.canonical.y - e.tileID.canonical.y
                        , r = Math.pow(2, e.tileID.canonical.z)
                        , o = t.tileID.key;
                      0 === i && 0 === n || Math.abs(n) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + r) ? i += r : 1 === Math.abs(i - r) && (i -= r)),
                      t.dem && e.dem && (e.dem.backfillBorder(t.dem, i, n),
                      e.neighboringTiles && e.neighboringTiles[o] && (e.neighboringTiles[o].backfilled = !0)))
                  }
              }
              ,
              i.prototype.getTile = function(e) {
                  return this.getTileByID(e.key)
              }
              ,
              i.prototype.getTileByID = function(e) {
                  return this._tiles[e]
              }
              ,
              i.prototype.getZoom = function(e) {
                  return e.zoom + e.scaleZoom(e.tileSize / this._source.tileSize)
              }
              ,
              i.prototype._retainLoadedChildren = function(e, t, i, n) {
                  for (var r in this._tiles) {
                      var o = this._tiles[r];
                      if (!(n[r] || !o.hasData() || o.tileID.overscaledZ <= t || o.tileID.overscaledZ > i)) {
                          for (var s = o.tileID; o && o.tileID.overscaledZ > t + 1; ) {
                              var a = o.tileID.scaledTo(o.tileID.overscaledZ - 1);
                              (o = this._tiles[a.key]) && o.hasData() && (s = a)
                          }
                          for (var l = s; l.overscaledZ > t; )
                              if (e[(l = l.scaledTo(l.overscaledZ - 1)).key]) {
                                  n[s.key] = s;
                                  break
                              }
                      }
                  }
              }
              ,
              i.prototype.findLoadedParent = function(e, t) {
                  for (var i = e.overscaledZ - 1; i >= t; i--) {
                      var n = e.scaledTo(i);
                      if (!n)
                          return;
                      var r = String(n.key)
                        , o = this._tiles[r];
                      if (o && o.hasData())
                          return o;
                      if (this._cache.has(n))
                          return this._cache.get(n)
                  }
              }
              ,
              i.prototype.updateCacheSize = function(e) {
                  var t = (Math.ceil(e.width / this._source.tileSize) + 1) * (Math.ceil(e.height / this._source.tileSize) + 1)
                    , i = Math.floor(5 * t)
                    , n = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, i) : i;
                  this._cache.setMaxSize(n)
              }
              ,
              i.prototype.handleWrapJump = function(e) {
                  var t = (e - (void 0 === this._prevLng ? e : this._prevLng)) / 360
                    , i = Math.round(t);
                  if (this._prevLng = e,
                  i) {
                      var n = {};
                      for (var r in this._tiles) {
                          var o = this._tiles[r];
                          o.tileID = o.tileID.unwrapTo(o.tileID.wrap + i),
                          n[o.tileID.key] = o
                      }
                      for (var s in this._tiles = n,
                      this._timers)
                          clearTimeout(this._timers[s]),
                          delete this._timers[s];
                      for (var a in this._tiles) {
                          var l = this._tiles[a];
                          this._setTileReloadTimer(a, l)
                      }
                  }
              }
              ,
              i.prototype.update = function(t) {
                  var n = this;
                  if (this.transform = t,
                  this._sourceLoaded && !this._paused) {
                      var r;
                      this.updateCacheSize(t),
                      this.handleWrapJump(this.transform.center.lng),
                      this._coveredTiles = {},
                      this.used ? this._source.tileID ? r = t.getVisibleUnwrappedCoordinates(this._source.tileID).map(function(t) {
                          return new e.OverscaledTileID(t.canonical.z,t.wrap,t.canonical.z,t.canonical.x,t.canonical.y)
                      }) : (r = t.coveringTiles({
                          tileSize: this._source.tileSize,
                          minzoom: this._source.minzoom,
                          maxzoom: this._source.maxzoom,
                          roundZoom: this._source.roundZoom,
                          reparseOverscaled: this._source.reparseOverscaled
                      }),
                      this._source.hasTile && (r = r.filter(function(e) {
                          return n._source.hasTile(e)
                      }))) : r = [];
                      var o = (this._source.roundZoom ? Math.round : Math.floor)(this.getZoom(t))
                        , s = Math.max(o - i.maxOverzooming, this._source.minzoom)
                        , a = Math.max(o + i.maxUnderzooming, this._source.minzoom)
                        , l = this._updateRetainedTiles(r, o);
                      if (Le(this._source.type)) {
                          for (var c = {}, u = {}, h = 0, d = Object.keys(l); h < d.length; h += 1) {
                              var p = d[h]
                                , f = l[p]
                                , m = this._tiles[p];
                              if (m && !(m.fadeEndTime && m.fadeEndTime <= e.browser.now())) {
                                  var g = this.findLoadedParent(f, s);
                                  g && (this._addTile(g.tileID),
                                  c[g.tileID.key] = g.tileID),
                                  u[p] = f
                              }
                          }
                          for (var v in this._retainLoadedChildren(u, o, a, l),
                          c)
                              l[v] || (this._coveredTiles[v] = !0,
                              l[v] = c[v])
                      }
                      for (var y in l)
                          this._tiles[y].clearFadeHold();
                      for (var _ = 0, b = e.keysDifference(this._tiles, l); _ < b.length; _ += 1) {
                          var w = b[_]
                            , x = this._tiles[w];
                          x.hasSymbolBuckets && !x.holdingForFade() ? x.setHoldDuration(this.map._fadeDuration) : x.hasSymbolBuckets && !x.symbolFadeFinished() || this._removeTile(w)
                      }
                  }
              }
              ,
              i.prototype.releaseSymbolFadeTiles = function() {
                  for (var e in this._tiles)
                      this._tiles[e].holdingForFade() && this._removeTile(e)
              }
              ,
              i.prototype._updateRetainedTiles = function(e, t) {
                  for (var n = {}, r = {}, o = Math.max(t - i.maxOverzooming, this._source.minzoom), s = Math.max(t + i.maxUnderzooming, this._source.minzoom), a = {}, l = 0, c = e; l < c.length; l += 1) {
                      var u = c[l]
                        , h = this._addTile(u);
                      n[u.key] = u,
                      h.hasData() || t < this._source.maxzoom && (a[u.key] = u)
                  }
                  this._retainLoadedChildren(a, t, s, n);
                  for (var d = 0, p = e; d < p.length; d += 1) {
                      var f = p[d]
                        , m = this._tiles[f.key];
                      if (!m.hasData()) {
                          if (t + 1 > this._source.maxzoom) {
                              var g = f.children(this._source.maxzoom)[0]
                                , v = this.getTile(g);
                              if (v && v.hasData()) {
                                  n[g.key] = g;
                                  continue
                              }
                          } else {
                              var y = f.children(this._source.maxzoom);
                              if (n[y[0].key] && n[y[1].key] && n[y[2].key] && n[y[3].key])
                                  continue
                          }
                          for (var _ = m.wasRequested(), b = f.overscaledZ - 1; b >= o; --b) {
                              var w = f.scaledTo(b);
                              if (r[w.key])
                                  break;
                              if (r[w.key] = !0,
                              !(m = this.getTile(w)) && _ && (m = this._addTile(w)),
                              m && (n[w.key] = w,
                              _ = m.wasRequested(),
                              m.hasData()))
                                  break
                          }
                      }
                  }
                  return n
              }
              ,
              i.prototype._addTile = function(t) {
                  var i = this._tiles[t.key];
                  if (i)
                      return i;
                  (i = this._cache.getAndRemove(t)) && (this._setTileReloadTimer(t.key, i),
                  i.tileID = t,
                  this._state.initializeTileState(i, this.map ? this.map.painter : null),
                  this._cacheTimers[t.key] && (clearTimeout(this._cacheTimers[t.key]),
                  delete this._cacheTimers[t.key],
                  this._setTileReloadTimer(t.key, i)));
                  var n = Boolean(i);
                  return n || (i = new e.Tile(t,this._source.tileSize * t.overscaleFactor()),
                  this._loadTile(i, this._tileLoaded.bind(this, i, t.key, i.state))),
                  i ? (i.uses++,
                  this._tiles[t.key] = i,
                  n || this._source.fire(new e.Event("dataloading",{
                      tile: i,
                      coord: i.tileID,
                      dataType: "source"
                  })),
                  i) : null
              }
              ,
              i.prototype._setTileReloadTimer = function(e, t) {
                  var i = this;
                  e in this._timers && (clearTimeout(this._timers[e]),
                  delete this._timers[e]);
                  var n = t.getExpiryTimeout();
                  n && (this._timers[e] = setTimeout(function() {
                      i._reloadTile(e, "expired"),
                      delete i._timers[e]
                  }, n))
              }
              ,
              i.prototype._removeTile = function(e) {
                  var t = this._tiles[e];
                  t && (t.uses--,
                  delete this._tiles[e],
                  this._timers[e] && (clearTimeout(this._timers[e]),
                  delete this._timers[e]),
                  t.uses > 0 || (t.hasData() ? this._cache.add(t.tileID, t, t.getExpiryTimeout()) : (t.aborted = !0,
                  this._abortTile(t),
                  this._unloadTile(t))))
              }
              ,
              i.prototype.clearTiles = function() {
                  for (var e in this._shouldReloadOnResume = !1,
                  this._paused = !1,
                  this._tiles)
                      this._removeTile(e);
                  this._cache.reset()
              }
              ,
              i.prototype.tilesIn = function(t, i, n) {
                  var r = this
                    , o = []
                    , s = this.transform;
                  if (!s)
                      return o;
                  for (var a = n ? s.getCameraQueryGeometry(t) : t, l = t.map(function(e) {
                      return s.pointCoordinate(e)
                  }), c = a.map(function(e) {
                      return s.pointCoordinate(e)
                  }), u = this.getIds(), h = 1 / 0, d = 1 / 0, p = -1 / 0, f = -1 / 0, m = 0, g = c; m < g.length; m += 1) {
                      var v = g[m];
                      h = Math.min(h, v.x),
                      d = Math.min(d, v.y),
                      p = Math.max(p, v.x),
                      f = Math.max(f, v.y)
                  }
                  for (var y = function(t) {
                      var n = r._tiles[u[t]];
                      if (!n.holdingForFade()) {
                          var a = n.tileID
                            , m = Math.pow(2, s.zoom - n.tileID.overscaledZ)
                            , g = i * n.queryPadding * e.EXTENT / n.tileSize / m
                            , v = [a.getTilePoint(new e.MercatorCoordinate(h,d)), a.getTilePoint(new e.MercatorCoordinate(p,f))];
                          if (v[0].x - g < e.EXTENT && v[0].y - g < e.EXTENT && v[1].x + g >= 0 && v[1].y + g >= 0) {
                              var y = l.map(function(e) {
                                  return a.getTilePoint(e)
                              })
                                , _ = c.map(function(e) {
                                  return a.getTilePoint(e)
                              });
                              o.push({
                                  tile: n,
                                  tileID: a,
                                  queryGeometry: y,
                                  cameraQueryGeometry: _,
                                  scale: m
                              })
                          }
                      }
                  }, _ = 0; _ < u.length; _++)
                      y(_);
                  return o
              }
              ,
              i.prototype.getVisibleCoordinates = function(e) {
                  for (var t = this, i = this.getRenderableIds(e).map(function(e) {
                      return t._tiles[e].tileID
                  }), n = 0, r = i; n < r.length; n += 1) {
                      var o = r[n];
                      o.posMatrix = this.transform.calculatePosMatrix(o.toUnwrapped())
                  }
                  return i
              }
              ,
              i.prototype.hasTransition = function() {
                  if (this._source.hasTransition())
                      return !0;
                  if (Le(this._source.type))
                      for (var t in this._tiles) {
                          var i = this._tiles[t];
                          if (void 0 !== i.fadeEndTime && i.fadeEndTime >= e.browser.now())
                              return !0
                      }
                  return !1
              }
              ,
              i.prototype.setFeatureState = function(e, t, i) {
                  e = e || "_geojsonTileLayer",
                  this._state.updateState(e, t, i)
              }
              ,
              i.prototype.removeFeatureState = function(e, t, i) {
                  e = e || "_geojsonTileLayer",
                  this._state.removeFeatureState(e, t, i)
              }
              ,
              i.prototype.getFeatureState = function(e, t) {
                  return e = e || "_geojsonTileLayer",
                  this._state.getState(e, t)
              }
              ,
              i
          }(e.Evented);
          function Ce(e, t) {
              return e % 32 - t % 32 || t - e
          }
          function Le(e) {
              return "raster" === e || "image" === e || "video" === e
          }
          function Ae() {
              return new e.window.Worker(Yn.workerUrl)
          }
          Te.maxOverzooming = 10,
          Te.maxUnderzooming = 3;
          var Pe = function() {
              this.active = {}
          };
          Pe.prototype.acquire = function(e) {
              if (!this.workers)
                  for (this.workers = []; this.workers.length < Pe.workerCount; )
                      this.workers.push(new Ae);
              return this.active[e] = !0,
              this.workers.slice()
          }
          ,
          Pe.prototype.release = function(e) {
              delete this.active[e],
              0 === Object.keys(this.active).length && (this.workers.forEach(function(e) {
                  e.terminate()
              }),
              this.workers = null)
          }
          ;
          var Ie, Me = Math.floor(e.browser.hardwareConcurrency / 2);
          function Oe(t, i) {
              var n = {};
              for (var r in t)
                  "ref" !== r && (n[r] = t[r]);
              return e.refProperties.forEach(function(e) {
                  e in i && (n[e] = i[e])
              }),
              n
          }
          function ze(e) {
              e = e.slice();
              for (var t = Object.create(null), i = 0; i < e.length; i++)
                  t[e[i].id] = e[i];
              for (var n = 0; n < e.length; n++)
                  "ref"in e[n] && (e[n] = Oe(e[n], t[e[n].ref]));
              return e
          }
          Pe.workerCount = Math.max(Math.min(Me, 6), 1);
          var De = {
              setStyle: "setStyle",
              addLayer: "addLayer",
              removeLayer: "removeLayer",
              setPaintProperty: "setPaintProperty",
              setLayoutProperty: "setLayoutProperty",
              setFilter: "setFilter",
              addSource: "addSource",
              removeSource: "removeSource",
              setGeoJSONSourceData: "setGeoJSONSourceData",
              setLayerZoomRange: "setLayerZoomRange",
              setLayerProperty: "setLayerProperty",
              setCenter: "setCenter",
              setZoom: "setZoom",
              setBearing: "setBearing",
              setPitch: "setPitch",
              setSprite: "setSprite",
              setGlyphs: "setGlyphs",
              setTransition: "setTransition",
              setLight: "setLight"
          };
          function Re(e, t, i) {
              i.push({
                  command: De.addSource,
                  args: [e, t[e]]
              })
          }
          function Be(e, t, i) {
              t.push({
                  command: De.removeSource,
                  args: [e]
              }),
              i[e] = !0
          }
          function je(e, t, i, n) {
              Be(e, i, n),
              Re(e, t, i)
          }
          function Fe(t, i, n) {
              var r;
              for (r in t[n])
                  if (t[n].hasOwnProperty(r) && "data" !== r && !e.isEqual(t[n][r], i[n][r]))
                      return !1;
              for (r in i[n])
                  if (i[n].hasOwnProperty(r) && "data" !== r && !e.isEqual(t[n][r], i[n][r]))
                      return !1;
              return !0
          }
          function Ne(t, i, n, r, o, s) {
              var a;
              for (a in i = i || {},
              t = t || {})
                  t.hasOwnProperty(a) && (e.isEqual(t[a], i[a]) || n.push({
                      command: s,
                      args: [r, a, i[a], o]
                  }));
              for (a in i)
                  i.hasOwnProperty(a) && !t.hasOwnProperty(a) && (e.isEqual(t[a], i[a]) || n.push({
                      command: s,
                      args: [r, a, i[a], o]
                  }))
          }
          function Ue(e) {
              return e.id
          }
          function qe(e, t) {
              return e[t.id] = t,
              e
          }
          var He = function(e, t, i) {
              var n = this.boxCells = []
                , r = this.circleCells = [];
              this.xCellCount = Math.ceil(e / i),
              this.yCellCount = Math.ceil(t / i);
              for (var o = 0; o < this.xCellCount * this.yCellCount; o++)
                  n.push([]),
                  r.push([]);
              this.circleKeys = [],
              this.boxKeys = [],
              this.bboxes = [],
              this.circles = [],
              this.width = e,
              this.height = t,
              this.xScale = this.xCellCount / e,
              this.yScale = this.yCellCount / t,
              this.boxUid = 0,
              this.circleUid = 0
          };
          He.prototype.keysLength = function() {
              return this.boxKeys.length + this.circleKeys.length
          }
          ,
          He.prototype.insert = function(e, t, i, n, r) {
              this._forEachCell(t, i, n, r, this._insertBoxCell, this.boxUid++),
              this.boxKeys.push(e),
              this.bboxes.push(t),
              this.bboxes.push(i),
              this.bboxes.push(n),
              this.bboxes.push(r)
          }
          ,
          He.prototype.insertCircle = function(e, t, i, n) {
              this._forEachCell(t - n, i - n, t + n, i + n, this._insertCircleCell, this.circleUid++),
              this.circleKeys.push(e),
              this.circles.push(t),
              this.circles.push(i),
              this.circles.push(n)
          }
          ,
          He.prototype._insertBoxCell = function(e, t, i, n, r, o) {
              this.boxCells[r].push(o)
          }
          ,
          He.prototype._insertCircleCell = function(e, t, i, n, r, o) {
              this.circleCells[r].push(o)
          }
          ,
          He.prototype._query = function(e, t, i, n, r, o) {
              if (i < 0 || e > this.width || n < 0 || t > this.height)
                  return !r && [];
              var s = [];
              if (e <= 0 && t <= 0 && this.width <= i && this.height <= n) {
                  if (r)
                      return !0;
                  for (var a = 0; a < this.boxKeys.length; a++)
                      s.push({
                          key: this.boxKeys[a],
                          x1: this.bboxes[4 * a],
                          y1: this.bboxes[4 * a + 1],
                          x2: this.bboxes[4 * a + 2],
                          y2: this.bboxes[4 * a + 3]
                      });
                  for (var l = 0; l < this.circleKeys.length; l++) {
                      var c = this.circles[3 * l]
                        , u = this.circles[3 * l + 1]
                        , h = this.circles[3 * l + 2];
                      s.push({
                          key: this.circleKeys[l],
                          x1: c - h,
                          y1: u - h,
                          x2: c + h,
                          y2: u + h
                      })
                  }
                  return o ? s.filter(o) : s
              }
              var d = {
                  hitTest: r,
                  seenUids: {
                      box: {},
                      circle: {}
                  }
              };
              return this._forEachCell(e, t, i, n, this._queryCell, s, d, o),
              r ? s.length > 0 : s
          }
          ,
          He.prototype._queryCircle = function(e, t, i, n, r) {
              var o = e - i
                , s = e + i
                , a = t - i
                , l = t + i;
              if (s < 0 || o > this.width || l < 0 || a > this.height)
                  return !n && [];
              var c = []
                , u = {
                  hitTest: n,
                  circle: {
                      x: e,
                      y: t,
                      radius: i
                  },
                  seenUids: {
                      box: {},
                      circle: {}
                  }
              };
              return this._forEachCell(o, a, s, l, this._queryCellCircle, c, u, r),
              n ? c.length > 0 : c
          }
          ,
          He.prototype.query = function(e, t, i, n, r) {
              return this._query(e, t, i, n, !1, r)
          }
          ,
          He.prototype.hitTest = function(e, t, i, n, r) {
              return this._query(e, t, i, n, !0, r)
          }
          ,
          He.prototype.hitTestCircle = function(e, t, i, n) {
              return this._queryCircle(e, t, i, !0, n)
          }
          ,
          He.prototype._queryCell = function(e, t, i, n, r, o, s, a) {
              var l = s.seenUids
                , c = this.boxCells[r];
              if (null !== c)
                  for (var u = this.bboxes, h = 0, d = c; h < d.length; h += 1) {
                      var p = d[h];
                      if (!l.box[p]) {
                          l.box[p] = !0;
                          var f = 4 * p;
                          if (e <= u[f + 2] && t <= u[f + 3] && i >= u[f + 0] && n >= u[f + 1] && (!a || a(this.boxKeys[p]))) {
                              if (s.hitTest)
                                  return o.push(!0),
                                  !0;
                              o.push({
                                  key: this.boxKeys[p],
                                  x1: u[f],
                                  y1: u[f + 1],
                                  x2: u[f + 2],
                                  y2: u[f + 3]
                              })
                          }
                      }
                  }
              var m = this.circleCells[r];
              if (null !== m)
                  for (var g = this.circles, v = 0, y = m; v < y.length; v += 1) {
                      var _ = y[v];
                      if (!l.circle[_]) {
                          l.circle[_] = !0;
                          var b = 3 * _;
                          if (this._circleAndRectCollide(g[b], g[b + 1], g[b + 2], e, t, i, n) && (!a || a(this.circleKeys[_]))) {
                              if (s.hitTest)
                                  return o.push(!0),
                                  !0;
                              var w = g[b]
                                , x = g[b + 1]
                                , k = g[b + 2];
                              o.push({
                                  key: this.circleKeys[_],
                                  x1: w - k,
                                  y1: x - k,
                                  x2: w + k,
                                  y2: x + k
                              })
                          }
                      }
                  }
          }
          ,
          He.prototype._queryCellCircle = function(e, t, i, n, r, o, s, a) {
              var l = s.circle
                , c = s.seenUids
                , u = this.boxCells[r];
              if (null !== u)
                  for (var h = this.bboxes, d = 0, p = u; d < p.length; d += 1) {
                      var f = p[d];
                      if (!c.box[f]) {
                          c.box[f] = !0;
                          var m = 4 * f;
                          if (this._circleAndRectCollide(l.x, l.y, l.radius, h[m + 0], h[m + 1], h[m + 2], h[m + 3]) && (!a || a(this.boxKeys[f])))
                              return o.push(!0),
                              !0
                      }
                  }
              var g = this.circleCells[r];
              if (null !== g)
                  for (var v = this.circles, y = 0, _ = g; y < _.length; y += 1) {
                      var b = _[y];
                      if (!c.circle[b]) {
                          c.circle[b] = !0;
                          var w = 3 * b;
                          if (this._circlesCollide(v[w], v[w + 1], v[w + 2], l.x, l.y, l.radius) && (!a || a(this.circleKeys[b])))
                              return o.push(!0),
                              !0
                      }
                  }
          }
          ,
          He.prototype._forEachCell = function(e, t, i, n, r, o, s, a) {
              for (var l = this._convertToXCellCoord(e), c = this._convertToYCellCoord(t), u = this._convertToXCellCoord(i), h = this._convertToYCellCoord(n), d = l; d <= u; d++)
                  for (var p = c; p <= h; p++) {
                      var f = this.xCellCount * p + d;
                      if (r.call(this, e, t, i, n, f, o, s, a))
                          return
                  }
          }
          ,
          He.prototype._convertToXCellCoord = function(e) {
              return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e * this.xScale)))
          }
          ,
          He.prototype._convertToYCellCoord = function(e) {
              return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e * this.yScale)))
          }
          ,
          He.prototype._circlesCollide = function(e, t, i, n, r, o) {
              var s = n - e
                , a = r - t
                , l = i + o;
              return l * l > s * s + a * a
          }
          ,
          He.prototype._circleAndRectCollide = function(e, t, i, n, r, o, s) {
              var a = (o - n) / 2
                , l = Math.abs(e - (n + a));
              if (l > a + i)
                  return !1;
              var c = (s - r) / 2
                , u = Math.abs(t - (r + c));
              if (u > c + i)
                  return !1;
              if (l <= a || u <= c)
                  return !0;
              var h = l - a
                , d = u - c;
              return h * h + d * d <= i * i
          }
          ;
          var Ve = e.properties.layout;
          function We(t, i, n, r, o) {
              var s = e.identity(new Float32Array(16));
              return i ? (e.identity(s),
              e.scale(s, s, [1 / o, 1 / o, 1]),
              n || e.rotateZ(s, s, r.angle)) : (e.scale(s, s, [r.width / 2, -r.height / 2, 1]),
              e.translate(s, s, [1, -1, 0]),
              e.multiply(s, s, t)),
              s
          }
          function $e(t, i, n, r, o) {
              var s = e.identity(new Float32Array(16));
              return i ? (e.multiply(s, s, t),
              e.scale(s, s, [o, o, 1]),
              n || e.rotateZ(s, s, -r.angle)) : (e.scale(s, s, [1, -1, 1]),
              e.translate(s, s, [-1, -1, 0]),
              e.scale(s, s, [2 / r.width, 2 / r.height, 1])),
              s
          }
          function Ge(t, i) {
              var n = [t.x, t.y, 0, 1];
              nt(n, n, i);
              var r = n[3];
              return {
                  point: new e.Point(n[0] / r,n[1] / r),
                  signedDistanceFromCamera: r
              }
          }
          function Xe(e, t) {
              var i = e[0] / e[3]
                , n = e[1] / e[3];
              return i >= -t[0] && i <= t[0] && n >= -t[1] && n <= t[1]
          }
          function Ze(t, i, n, r, o, s, a, l) {
              var c = r ? t.textSizeData : t.iconSizeData
                , u = e.evaluateSizeForZoom(c, n.transform.zoom, Ve.properties[r ? "text-size" : "icon-size"])
                , h = [256 / n.width * 2 + 1, 256 / n.height * 2 + 1]
                , d = r ? t.text.dynamicLayoutVertexArray : t.icon.dynamicLayoutVertexArray;
              d.clear();
              for (var p = t.lineVertexArray, f = r ? t.text.placedSymbolArray : t.icon.placedSymbolArray, m = n.transform.width / n.transform.height, g = !1, v = 0; v < f.length; v++) {
                  var y = f.get(v);
                  if (y.hidden || y.writingMode === e.WritingMode.vertical && !g)
                      it(y.numGlyphs, d);
                  else {
                      g = !1;
                      var _ = [y.anchorX, y.anchorY, 0, 1];
                      if (e.transformMat4(_, _, i),
                      Xe(_, h)) {
                          var b = .5 + _[3] / n.transform.cameraToCenterDistance * .5
                            , w = e.evaluateSizeForFeature(c, u, y)
                            , x = a ? w * b : w / b
                            , k = new e.Point(y.anchorX,y.anchorY)
                            , S = Ge(k, o).point
                            , E = {}
                            , T = Je(y, x, !1, l, i, o, s, t.glyphOffsetArray, p, d, S, k, E, m);
                          g = T.useVertical,
                          (T.notEnoughRoom || g || T.needsFlipping && Je(y, x, !0, l, i, o, s, t.glyphOffsetArray, p, d, S, k, E, m).notEnoughRoom) && it(y.numGlyphs, d)
                      } else
                          it(y.numGlyphs, d)
                  }
              }
              r ? t.text.dynamicLayoutVertexBuffer.updateData(d) : t.icon.dynamicLayoutVertexBuffer.updateData(d)
          }
          function Ye(e, t, i, n, r, o, s, a, l, c, u, h) {
              var d = a.glyphStartIndex + a.numGlyphs
                , p = a.lineStartIndex
                , f = a.lineStartIndex + a.lineLength
                , m = t.getoffsetX(a.glyphStartIndex)
                , g = t.getoffsetX(d - 1)
                , v = et(e * m, i, n, r, o, s, a.segment, p, f, l, c, u, h);
              if (!v)
                  return null;
              var y = et(e * g, i, n, r, o, s, a.segment, p, f, l, c, u, h);
              return y ? {
                  first: v,
                  last: y
              } : null
          }
          function Ke(t, i, n, r) {
              return t === e.WritingMode.horizontal && Math.abs(n.y - i.y) > Math.abs(n.x - i.x) * r ? {
                  useVertical: !0
              } : (t === e.WritingMode.vertical ? i.y < n.y : i.x > n.x) ? {
                  needsFlipping: !0
              } : null
          }
          function Je(t, i, n, r, o, s, a, l, c, u, h, d, p, f) {
              var m, g = i / 24, v = t.lineOffsetX * i, y = t.lineOffsetY * i;
              if (t.numGlyphs > 1) {
                  var _ = t.glyphStartIndex + t.numGlyphs
                    , b = t.lineStartIndex
                    , w = t.lineStartIndex + t.lineLength
                    , x = Ye(g, l, v, y, n, h, d, t, c, s, p, !1);
                  if (!x)
                      return {
                          notEnoughRoom: !0
                      };
                  var k = Ge(x.first.point, a).point
                    , S = Ge(x.last.point, a).point;
                  if (r && !n) {
                      var E = Ke(t.writingMode, k, S, f);
                      if (E)
                          return E
                  }
                  m = [x.first];
                  for (var T = t.glyphStartIndex + 1; T < _ - 1; T++)
                      m.push(et(g * l.getoffsetX(T), v, y, n, h, d, t.segment, b, w, c, s, p, !1));
                  m.push(x.last)
              } else {
                  if (r && !n) {
                      var C = Ge(d, o).point
                        , L = t.lineStartIndex + t.segment + 1
                        , A = new e.Point(c.getx(L),c.gety(L))
                        , P = Ge(A, o)
                        , I = P.signedDistanceFromCamera > 0 ? P.point : Qe(d, A, C, 1, o)
                        , M = Ke(t.writingMode, C, I, f);
                      if (M)
                          return M
                  }
                  var O = et(g * l.getoffsetX(t.glyphStartIndex), v, y, n, h, d, t.segment, t.lineStartIndex, t.lineStartIndex + t.lineLength, c, s, p, !1);
                  if (!O)
                      return {
                          notEnoughRoom: !0
                      };
                  m = [O]
              }
              for (var z = 0, D = m; z < D.length; z += 1) {
                  var R = D[z];
                  e.addDynamicAttributes(u, R.point, R.angle)
              }
              return {}
          }
          function Qe(e, t, i, n, r) {
              var o = Ge(e.add(e.sub(t)._unit()), r).point
                , s = i.sub(o);
              return i.add(s._mult(n / s.mag()))
          }
          function et(t, i, n, r, o, s, a, l, c, u, h, d, p) {
              var f = r ? t - i : t + i
                , m = f > 0 ? 1 : -1
                , g = 0;
              r && (m *= -1,
              g = Math.PI),
              m < 0 && (g += Math.PI);
              for (var v = m > 0 ? l + a : l + a + 1, y = v, _ = o, b = o, w = 0, x = 0, k = Math.abs(f); w + x <= k; ) {
                  if ((v += m) < l || v >= c)
                      return null;
                  if (b = _,
                  void 0 === (_ = d[v])) {
                      var S = new e.Point(u.getx(v),u.gety(v))
                        , E = Ge(S, h);
                      if (E.signedDistanceFromCamera > 0)
                          _ = d[v] = E.point;
                      else {
                          var T = v - m;
                          _ = Qe(0 === w ? s : new e.Point(u.getx(T),u.gety(T)), S, b, k - w + 1, h)
                      }
                  }
                  w += x,
                  x = b.dist(_)
              }
              var C = (k - w) / x
                , L = _.sub(b)
                , A = L.mult(C)._add(b);
              return A._add(L._unit()._perp()._mult(n * m)),
              {
                  point: A,
                  angle: g + Math.atan2(_.y - b.y, _.x - b.x),
                  tileDistance: p ? {
                      prevTileDistance: v - m === y ? 0 : u.gettileUnitDistanceFromAnchor(v - m),
                      lastSegmentViewportDistance: k - w
                  } : null
              }
          }
          var tt = new Float32Array([-1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0]);
          function it(e, t) {
              for (var i = 0; i < e; i++) {
                  var n = t.length;
                  t.resize(n + 4),
                  t.float32.set(tt, 3 * n)
              }
          }
          function nt(e, t, i) {
              var n = t[0]
                , r = t[1];
              return e[0] = i[0] * n + i[4] * r + i[12],
              e[1] = i[1] * n + i[5] * r + i[13],
              e[3] = i[3] * n + i[7] * r + i[15],
              e
          }
          var rt = function(e, t, i) {
              void 0 === t && (t = new He(e.width + 200,e.height + 200,25)),
              void 0 === i && (i = new He(e.width + 200,e.height + 200,25)),
              this.transform = e,
              this.grid = t,
              this.ignoredGrid = i,
              this.pitchfactor = Math.cos(e._pitch) * e.cameraToCenterDistance,
              this.screenRightBoundary = e.width + 100,
              this.screenBottomBoundary = e.height + 100,
              this.gridRightBoundary = e.width + 200,
              this.gridBottomBoundary = e.height + 200
          };
          function ot(e, t, i) {
              e[t + 4] = i ? 1 : 0
          }
          function st(t, i, n) {
              return i * (e.EXTENT / (t.tileSize * Math.pow(2, n - t.tileID.overscaledZ)))
          }
          rt.prototype.placeCollisionBox = function(e, t, i, n, r) {
              var o = this.projectAndGetPerspectiveRatio(n, e.anchorPointX, e.anchorPointY)
                , s = i * o.perspectiveRatio
                , a = e.x1 * s + o.point.x
                , l = e.y1 * s + o.point.y
                , c = e.x2 * s + o.point.x
                , u = e.y2 * s + o.point.y;
              return !this.isInsideGrid(a, l, c, u) || !t && this.grid.hitTest(a, l, c, u, r) ? {
                  box: [],
                  offscreen: !1
              } : {
                  box: [a, l, c, u],
                  offscreen: this.isOffscreen(a, l, c, u)
              }
          }
          ,
          rt.prototype.approximateTileDistance = function(e, t, i, n, r) {
              var o = r ? 1 : n / this.pitchfactor
                , s = e.lastSegmentViewportDistance * i;
              return e.prevTileDistance + s + (o - 1) * s * Math.abs(Math.sin(t))
          }
          ,
          rt.prototype.placeCollisionCircles = function(t, i, n, r, o, s, a, l, c, u, h, d, p) {
              var f = []
                , m = this.projectAnchor(c, o.anchorX, o.anchorY)
                , g = l / 24
                , v = o.lineOffsetX * l
                , y = o.lineOffsetY * l
                , _ = new e.Point(o.anchorX,o.anchorY)
                , b = Ye(g, a, v, y, !1, Ge(_, u).point, _, o, s, u, {}, !0)
                , w = !1
                , x = !1
                , k = !0
                , S = m.perspectiveRatio * r
                , E = 1 / (r * n)
                , T = 0
                , C = 0;
              b && (T = this.approximateTileDistance(b.first.tileDistance, b.first.angle, E, m.cameraDistance, d),
              C = this.approximateTileDistance(b.last.tileDistance, b.last.angle, E, m.cameraDistance, d));
              for (var L = 0; L < t.length; L += 5) {
                  var A = t[L]
                    , P = t[L + 1]
                    , I = t[L + 2]
                    , M = t[L + 3];
                  if (!b || M < -T || M > C)
                      ot(t, L, !1);
                  else {
                      var O = this.projectPoint(c, A, P)
                        , z = I * S;
                      if (f.length > 0) {
                          var D = O.x - f[f.length - 4]
                            , R = O.y - f[f.length - 3];
                          if (z * z * 2 > D * D + R * R && L + 8 < t.length) {
                              var B = t[L + 8];
                              if (B > -T && B < C) {
                                  ot(t, L, !1);
                                  continue
                              }
                          }
                      }
                      var j = L / 5;
                      f.push(O.x, O.y, z, j),
                      ot(t, L, !0);
                      var F = O.x - z
                        , N = O.y - z
                        , U = O.x + z
                        , q = O.y + z;
                      if (k = k && this.isOffscreen(F, N, U, q),
                      x = x || this.isInsideGrid(F, N, U, q),
                      !i && this.grid.hitTestCircle(O.x, O.y, z, p)) {
                          if (!h)
                              return {
                                  circles: [],
                                  offscreen: !1
                              };
                          w = !0
                      }
                  }
              }
              return {
                  circles: w || !x ? [] : f,
                  offscreen: k
              }
          }
          ,
          rt.prototype.queryRenderedSymbols = function(t) {
              if (0 === t.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength())
                  return {};
              for (var i = [], n = 1 / 0, r = 1 / 0, o = -1 / 0, s = -1 / 0, a = 0, l = t; a < l.length; a += 1) {
                  var c = l[a]
                    , u = new e.Point(c.x + 100,c.y + 100);
                  n = Math.min(n, u.x),
                  r = Math.min(r, u.y),
                  o = Math.max(o, u.x),
                  s = Math.max(s, u.y),
                  i.push(u)
              }
              for (var h = {}, d = {}, p = 0, f = this.grid.query(n, r, o, s).concat(this.ignoredGrid.query(n, r, o, s)); p < f.length; p += 1) {
                  var m = f[p]
                    , g = m.key;
                  if (void 0 === h[g.bucketInstanceId] && (h[g.bucketInstanceId] = {}),
                  !h[g.bucketInstanceId][g.featureIndex]) {
                      var v = [new e.Point(m.x1,m.y1), new e.Point(m.x2,m.y1), new e.Point(m.x2,m.y2), new e.Point(m.x1,m.y2)];
                      e.polygonIntersectsPolygon(i, v) && (h[g.bucketInstanceId][g.featureIndex] = !0,
                      void 0 === d[g.bucketInstanceId] && (d[g.bucketInstanceId] = []),
                      d[g.bucketInstanceId].push(g.featureIndex))
                  }
              }
              return d
          }
          ,
          rt.prototype.insertCollisionBox = function(e, t, i, n, r) {
              var o = {
                  bucketInstanceId: i,
                  featureIndex: n,
                  collisionGroupID: r
              };
              (t ? this.ignoredGrid : this.grid).insert(o, e[0], e[1], e[2], e[3])
          }
          ,
          rt.prototype.insertCollisionCircles = function(e, t, i, n, r) {
              for (var o = t ? this.ignoredGrid : this.grid, s = {
                  bucketInstanceId: i,
                  featureIndex: n,
                  collisionGroupID: r
              }, a = 0; a < e.length; a += 4)
                  o.insertCircle(s, e[a], e[a + 1], e[a + 2])
          }
          ,
          rt.prototype.projectAnchor = function(e, t, i) {
              var n = [t, i, 0, 1];
              return nt(n, n, e),
              {
                  perspectiveRatio: .5 + this.transform.cameraToCenterDistance / n[3] * .5,
                  cameraDistance: n[3]
              }
          }
          ,
          rt.prototype.projectPoint = function(t, i, n) {
              var r = [i, n, 0, 1];
              return nt(r, r, t),
              new e.Point((r[0] / r[3] + 1) / 2 * this.transform.width + 100,(-r[1] / r[3] + 1) / 2 * this.transform.height + 100)
          }
          ,
          rt.prototype.projectAndGetPerspectiveRatio = function(t, i, n) {
              var r = [i, n, 0, 1];
              return nt(r, r, t),
              {
                  point: new e.Point((r[0] / r[3] + 1) / 2 * this.transform.width + 100,(-r[1] / r[3] + 1) / 2 * this.transform.height + 100),
                  perspectiveRatio: .5 + this.transform.cameraToCenterDistance / r[3] * .5
              }
          }
          ,
          rt.prototype.isOffscreen = function(e, t, i, n) {
              return i < 100 || e >= this.screenRightBoundary || n < 100 || t > this.screenBottomBoundary
          }
          ,
          rt.prototype.isInsideGrid = function(e, t, i, n) {
              return i >= 0 && e < this.gridRightBoundary && n >= 0 && t < this.gridBottomBoundary
          }
          ;
          var at = function(e, t, i, n) {
              this.opacity = e ? Math.max(0, Math.min(1, e.opacity + (e.placed ? t : -t))) : n && i ? 1 : 0,
              this.placed = i
          };
          at.prototype.isHidden = function() {
              return 0 === this.opacity && !this.placed
          }
          ;
          var lt = function(e, t, i, n, r) {
              this.text = new at(e ? e.text : null,t,i,r),
              this.icon = new at(e ? e.icon : null,t,n,r)
          };
          lt.prototype.isHidden = function() {
              return this.text.isHidden() && this.icon.isHidden()
          }
          ;
          var ct = function(e, t, i) {
              this.text = e,
              this.icon = t,
              this.skipFade = i
          }
            , ut = function(e, t, i, n, r) {
              this.bucketInstanceId = e,
              this.featureIndex = t,
              this.sourceLayerIndex = i,
              this.bucketIndex = n,
              this.tileID = r
          }
            , ht = function(e) {
              this.crossSourceCollisions = e,
              this.maxGroupID = 0,
              this.collisionGroups = {}
          };
          ht.prototype.get = function(e) {
              if (this.crossSourceCollisions)
                  return {
                      ID: 0,
                      predicate: null
                  };
              if (!this.collisionGroups[e]) {
                  var t = ++this.maxGroupID;
                  this.collisionGroups[e] = {
                      ID: t,
                      predicate: function(e) {
                          return e.collisionGroupID === t
                      }
                  }
              }
              return this.collisionGroups[e]
          }
          ;
          var dt = function(e, t, i) {
              this.transform = e.clone(),
              this.collisionIndex = new rt(this.transform),
              this.placements = {},
              this.opacities = {},
              this.stale = !1,
              this.commitTime = 0,
              this.fadeDuration = t,
              this.retainedQueryData = {},
              this.collisionGroups = new ht(i)
          };
          function pt(e, t, i) {
              e.emplaceBack(t ? 1 : 0, i ? 1 : 0),
              e.emplaceBack(t ? 1 : 0, i ? 1 : 0),
              e.emplaceBack(t ? 1 : 0, i ? 1 : 0),
              e.emplaceBack(t ? 1 : 0, i ? 1 : 0)
          }
          dt.prototype.placeLayerTile = function(t, i, n, r) {
              var o = i.getBucket(t)
                , s = i.latestFeatureIndex;
              if (o && s && t.id === o.layerIds[0]) {
                  var a = i.collisionBoxArray
                    , l = o.layers[0].layout
                    , c = Math.pow(2, this.transform.zoom - i.tileID.overscaledZ)
                    , u = i.tileSize / e.EXTENT
                    , h = this.transform.calculatePosMatrix(i.tileID.toUnwrapped())
                    , d = We(h, "map" === l.get("text-pitch-alignment"), "map" === l.get("text-rotation-alignment"), this.transform, st(i, 1, this.transform.zoom))
                    , p = We(h, "map" === l.get("icon-pitch-alignment"), "map" === l.get("icon-rotation-alignment"), this.transform, st(i, 1, this.transform.zoom));
                  this.retainedQueryData[o.bucketInstanceId] = new ut(o.bucketInstanceId,s,o.sourceLayerIndex,o.index,i.tileID),
                  this.placeLayerBucket(o, h, d, p, c, u, n, i.holdingForFade(), r, a)
              }
          }
          ,
          dt.prototype.placeLayerBucket = function(t, i, n, r, o, s, a, l, c, u) {
              var h = t.layers[0].layout
                , d = e.evaluateSizeForZoom(t.textSizeData, this.transform.zoom, e.properties.layout.properties["text-size"])
                , p = h.get("text-optional")
                , f = h.get("icon-optional")
                , m = h.get("text-allow-overlap")
                , g = h.get("icon-allow-overlap")
                , v = m && (g || !t.hasIconData() || f)
                , y = g && (m || !t.hasTextData() || p)
                , _ = this.collisionGroups.get(t.sourceID);
              !t.collisionArrays && u && t.deserializeCollisionBoxes(u);
              for (var b = 0; b < t.symbolInstances.length; b++) {
                  var w = t.symbolInstances.get(b);
                  if (!c[w.crossTileID]) {
                      if (l) {
                          this.placements[w.crossTileID] = new ct(!1,!1,!1);
                          continue
                      }
                      var x = !1
                        , k = !1
                        , S = !0
                        , E = null
                        , T = null
                        , C = null
                        , L = 0
                        , A = 0
                        , P = t.collisionArrays[b];
                      P.textFeatureIndex && (L = P.textFeatureIndex),
                      P.textBox && (x = (E = this.collisionIndex.placeCollisionBox(P.textBox, h.get("text-allow-overlap"), s, i, _.predicate)).box.length > 0,
                      S = S && E.offscreen);
                      var I = P.textCircles;
                      if (I) {
                          var M = t.text.placedSymbolArray.get(w.horizontalPlacedTextSymbolIndex)
                            , O = e.evaluateSizeForFeature(t.textSizeData, d, M);
                          T = this.collisionIndex.placeCollisionCircles(I, h.get("text-allow-overlap"), o, s, M, t.lineVertexArray, t.glyphOffsetArray, O, i, n, a, "map" === h.get("text-pitch-alignment"), _.predicate),
                          x = h.get("text-allow-overlap") || T.circles.length > 0,
                          S = S && T.offscreen
                      }
                      P.iconFeatureIndex && (A = P.iconFeatureIndex),
                      P.iconBox && (k = (C = this.collisionIndex.placeCollisionBox(P.iconBox, h.get("icon-allow-overlap"), s, i, _.predicate)).box.length > 0,
                      S = S && C.offscreen);
                      var z = p || 0 === w.numGlyphVertices && 0 === w.numVerticalGlyphVertices
                        , D = f || 0 === w.numIconVertices;
                      z || D ? D ? z || (k = k && x) : x = k && x : k = x = k && x,
                      x && E && this.collisionIndex.insertCollisionBox(E.box, h.get("text-ignore-placement"), t.bucketInstanceId, L, _.ID),
                      k && C && this.collisionIndex.insertCollisionBox(C.box, h.get("icon-ignore-placement"), t.bucketInstanceId, A, _.ID),
                      x && T && this.collisionIndex.insertCollisionCircles(T.circles, h.get("text-ignore-placement"), t.bucketInstanceId, L, _.ID),
                      this.placements[w.crossTileID] = new ct(x || v,k || y,S || t.justReloaded),
                      c[w.crossTileID] = !0
                  }
              }
              t.justReloaded = !1
          }
          ,
          dt.prototype.commit = function(e, t) {
              this.commitTime = t;
              var i = !1
                , n = e && 0 !== this.fadeDuration ? (this.commitTime - e.commitTime) / this.fadeDuration : 1
                , r = e ? e.opacities : {};
              for (var o in this.placements) {
                  var s = this.placements[o]
                    , a = r[o];
                  a ? (this.opacities[o] = new lt(a,n,s.text,s.icon),
                  i = i || s.text !== a.text.placed || s.icon !== a.icon.placed) : (this.opacities[o] = new lt(null,n,s.text,s.icon,s.skipFade),
                  i = i || s.text || s.icon)
              }
              for (var l in r) {
                  var c = r[l];
                  if (!this.opacities[l]) {
                      var u = new lt(c,n,!1,!1);
                      u.isHidden() || (this.opacities[l] = u,
                      i = i || c.text.placed || c.icon.placed)
                  }
              }
              i ? this.lastPlacementChangeTime = t : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = e ? e.lastPlacementChangeTime : t)
          }
          ,
          dt.prototype.updateLayerOpacities = function(e, t) {
              for (var i = {}, n = 0, r = t; n < r.length; n += 1) {
                  var o = r[n]
                    , s = o.getBucket(e);
                  s && o.latestFeatureIndex && e.id === s.layerIds[0] && this.updateBucketOpacities(s, i, o.collisionBoxArray)
              }
          }
          ,
          dt.prototype.updateBucketOpacities = function(e, t, i) {
              e.hasTextData() && e.text.opacityVertexArray.clear(),
              e.hasIconData() && e.icon.opacityVertexArray.clear(),
              e.hasCollisionBoxData() && e.collisionBox.collisionVertexArray.clear(),
              e.hasCollisionCircleData() && e.collisionCircle.collisionVertexArray.clear();
              var n = e.layers[0].layout
                , r = new lt(null,0,!1,!1,!0)
                , o = n.get("text-allow-overlap")
                , s = n.get("icon-allow-overlap")
                , a = new lt(null,0,o && (s || !e.hasIconData() || n.get("icon-optional")),s && (o || !e.hasTextData() || n.get("text-optional")),!0);
              !e.collisionArrays && i && (e.hasCollisionBoxData() || e.hasCollisionCircleData()) && e.deserializeCollisionBoxes(i);
              for (var l = 0; l < e.symbolInstances.length; l++) {
                  var c = e.symbolInstances.get(l)
                    , u = t[c.crossTileID]
                    , h = this.opacities[c.crossTileID];
                  u ? h = r : h || (h = a,
                  this.opacities[c.crossTileID] = h),
                  t[c.crossTileID] = !0;
                  var d = c.numGlyphVertices > 0 || c.numVerticalGlyphVertices > 0
                    , p = c.numIconVertices > 0;
                  if (d) {
                      for (var f = wt(h.text), m = (c.numGlyphVertices + c.numVerticalGlyphVertices) / 4, g = 0; g < m; g++)
                          e.text.opacityVertexArray.emplaceBack(f);
                      e.text.placedSymbolArray.get(c.horizontalPlacedTextSymbolIndex).hidden = h.text.isHidden(),
                      c.verticalPlacedTextSymbolIndex >= 0 && (e.text.placedSymbolArray.get(c.verticalPlacedTextSymbolIndex).hidden = h.text.isHidden())
                  }
                  if (p) {
                      for (var v = wt(h.icon), y = 0; y < c.numIconVertices / 4; y++)
                          e.icon.opacityVertexArray.emplaceBack(v);
                      e.icon.placedSymbolArray.get(l).hidden = h.icon.isHidden()
                  }
                  if (e.hasCollisionBoxData() || e.hasCollisionCircleData()) {
                      var _ = e.collisionArrays[l];
                      if (_) {
                          _.textBox && pt(e.collisionBox.collisionVertexArray, h.text.placed, !1),
                          _.iconBox && pt(e.collisionBox.collisionVertexArray, h.icon.placed, !1);
                          var b = _.textCircles;
                          if (b && e.hasCollisionCircleData())
                              for (var w = 0; w < b.length; w += 5) {
                                  var x = u || 0 === b[w + 4];
                                  pt(e.collisionCircle.collisionVertexArray, h.text.placed, x)
                              }
                      }
                  }
              }
              e.sortFeatures(this.transform.angle),
              this.retainedQueryData[e.bucketInstanceId] && (this.retainedQueryData[e.bucketInstanceId].featureSortOrder = e.featureSortOrder),
              e.hasTextData() && e.text.opacityVertexBuffer && e.text.opacityVertexBuffer.updateData(e.text.opacityVertexArray),
              e.hasIconData() && e.icon.opacityVertexBuffer && e.icon.opacityVertexBuffer.updateData(e.icon.opacityVertexArray),
              e.hasCollisionBoxData() && e.collisionBox.collisionVertexBuffer && e.collisionBox.collisionVertexBuffer.updateData(e.collisionBox.collisionVertexArray),
              e.hasCollisionCircleData() && e.collisionCircle.collisionVertexBuffer && e.collisionCircle.collisionVertexBuffer.updateData(e.collisionCircle.collisionVertexArray)
          }
          ,
          dt.prototype.symbolFadeChange = function(e) {
              return 0 === this.fadeDuration ? 1 : (e - this.commitTime) / this.fadeDuration
          }
          ,
          dt.prototype.hasTransitions = function(e) {
              return this.stale || e - this.lastPlacementChangeTime < this.fadeDuration
          }
          ,
          dt.prototype.stillRecent = function(e) {
              return this.commitTime + this.fadeDuration > e
          }
          ,
          dt.prototype.setStale = function() {
              this.stale = !0
          }
          ;
          var ft = Math.pow(2, 25)
            , mt = Math.pow(2, 24)
            , gt = Math.pow(2, 17)
            , vt = Math.pow(2, 16)
            , yt = Math.pow(2, 9)
            , _t = Math.pow(2, 8)
            , bt = Math.pow(2, 1);
          function wt(e) {
              if (0 === e.opacity && !e.placed)
                  return 0;
              if (1 === e.opacity && e.placed)
                  return 4294967295;
              var t = e.placed ? 1 : 0
                , i = Math.floor(127 * e.opacity);
              return i * ft + t * mt + i * gt + t * vt + i * yt + t * _t + i * bt + t
          }
          var xt = function() {
              this._currentTileIndex = 0,
              this._seenCrossTileIDs = {}
          };
          xt.prototype.continuePlacement = function(e, t, i, n, r) {
              for (; this._currentTileIndex < e.length; ) {
                  var o = e[this._currentTileIndex];
                  if (t.placeLayerTile(n, o, i, this._seenCrossTileIDs),
                  this._currentTileIndex++,
                  r())
                      return !0
              }
          }
          ;
          var kt = function(e, t, i, n, r, o) {
              this.placement = new dt(e,r,o),
              this._currentPlacementIndex = t.length - 1,
              this._forceFullPlacement = i,
              this._showCollisionBoxes = n,
              this._done = !1
          };
          kt.prototype.isDone = function() {
              return this._done
          }
          ,
          kt.prototype.continuePlacement = function(t, i, n) {
              for (var r = this, o = e.browser.now(), s = function() {
                  var t = e.browser.now() - o;
                  return !r._forceFullPlacement && t > 2
              }; this._currentPlacementIndex >= 0; ) {
                  var a = i[t[this._currentPlacementIndex]]
                    , l = this.placement.collisionIndex.transform.zoom;
                  if ("symbol" === a.type && (!a.minzoom || a.minzoom <= l) && (!a.maxzoom || a.maxzoom > l)) {
                      if (this._inProgressLayer || (this._inProgressLayer = new xt),
                      this._inProgressLayer.continuePlacement(n[a.source], this.placement, this._showCollisionBoxes, a, s))
                          return;
                      delete this._inProgressLayer
                  }
                  this._currentPlacementIndex--
              }
              this._done = !0
          }
          ,
          kt.prototype.commit = function(e, t) {
              return this.placement.commit(e, t),
              this.placement
          }
          ;
          var St = 512 / e.EXTENT / 2
            , Et = function(e, t, i) {
              this.tileID = e,
              this.indexedSymbolInstances = {},
              this.bucketInstanceId = i;
              for (var n = 0; n < t.length; n++) {
                  var r = t.get(n)
                    , o = r.key;
                  this.indexedSymbolInstances[o] || (this.indexedSymbolInstances[o] = []),
                  this.indexedSymbolInstances[o].push({
                      crossTileID: r.crossTileID,
                      coord: this.getScaledCoordinates(r, e)
                  })
              }
          };
          Et.prototype.getScaledCoordinates = function(t, i) {
              var n = i.canonical.z - this.tileID.canonical.z
                , r = St / Math.pow(2, n);
              return {
                  x: Math.floor((i.canonical.x * e.EXTENT + t.anchorX) * r),
                  y: Math.floor((i.canonical.y * e.EXTENT + t.anchorY) * r)
              }
          }
          ,
          Et.prototype.findMatches = function(e, t, i) {
              for (var n = this.tileID.canonical.z < t.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - t.canonical.z), r = 0; r < e.length; r++) {
                  var o = e.get(r);
                  if (!o.crossTileID) {
                      var s = this.indexedSymbolInstances[o.key];
                      if (s)
                          for (var a = this.getScaledCoordinates(o, t), l = 0, c = s; l < c.length; l += 1) {
                              var u = c[l];
                              if (Math.abs(u.coord.x - a.x) <= n && Math.abs(u.coord.y - a.y) <= n && !i[u.crossTileID]) {
                                  i[u.crossTileID] = !0,
                                  o.crossTileID = u.crossTileID;
                                  break
                              }
                          }
                  }
              }
          }
          ;
          var Tt = function() {
              this.maxCrossTileID = 0
          };
          Tt.prototype.generate = function() {
              return ++this.maxCrossTileID
          }
          ;
          var Ct = function() {
              this.indexes = {},
              this.usedCrossTileIDs = {},
              this.lng = 0
          };
          Ct.prototype.handleWrapJump = function(e) {
              var t = Math.round((e - this.lng) / 360);
              if (0 !== t)
                  for (var i in this.indexes) {
                      var n = this.indexes[i]
                        , r = {};
                      for (var o in n) {
                          var s = n[o];
                          s.tileID = s.tileID.unwrapTo(s.tileID.wrap + t),
                          r[s.tileID.key] = s
                      }
                      this.indexes[i] = r
                  }
              this.lng = e
          }
          ,
          Ct.prototype.addBucket = function(e, t, i) {
              if (this.indexes[e.overscaledZ] && this.indexes[e.overscaledZ][e.key]) {
                  if (this.indexes[e.overscaledZ][e.key].bucketInstanceId === t.bucketInstanceId)
                      return !1;
                  this.removeBucketCrossTileIDs(e.overscaledZ, this.indexes[e.overscaledZ][e.key])
              }
              for (var n = 0; n < t.symbolInstances.length; n++)
                  t.symbolInstances.get(n).crossTileID = 0;
              this.usedCrossTileIDs[e.overscaledZ] || (this.usedCrossTileIDs[e.overscaledZ] = {});
              var r = this.usedCrossTileIDs[e.overscaledZ];
              for (var o in this.indexes) {
                  var s = this.indexes[o];
                  if (Number(o) > e.overscaledZ)
                      for (var a in s) {
                          var l = s[a];
                          l.tileID.isChildOf(e) && l.findMatches(t.symbolInstances, e, r)
                      }
                  else {
                      var c = s[e.scaledTo(Number(o)).key];
                      c && c.findMatches(t.symbolInstances, e, r)
                  }
              }
              for (var u = 0; u < t.symbolInstances.length; u++) {
                  var h = t.symbolInstances.get(u);
                  h.crossTileID || (h.crossTileID = i.generate(),
                  r[h.crossTileID] = !0)
              }
              return void 0 === this.indexes[e.overscaledZ] && (this.indexes[e.overscaledZ] = {}),
              this.indexes[e.overscaledZ][e.key] = new Et(e,t.symbolInstances,t.bucketInstanceId),
              !0
          }
          ,
          Ct.prototype.removeBucketCrossTileIDs = function(e, t) {
              for (var i in t.indexedSymbolInstances)
                  for (var n = 0, r = t.indexedSymbolInstances[i]; n < r.length; n += 1) {
                      var o = r[n];
                      delete this.usedCrossTileIDs[e][o.crossTileID]
                  }
          }
          ,
          Ct.prototype.removeStaleBuckets = function(e) {
              var t = !1;
              for (var i in this.indexes) {
                  var n = this.indexes[i];
                  for (var r in n)
                      e[n[r].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, n[r]),
                      delete n[r],
                      t = !0)
              }
              return t
          }
          ;
          var Lt = function() {
              this.layerIndexes = {},
              this.crossTileIDs = new Tt,
              this.maxBucketInstanceId = 0,
              this.bucketsInCurrentPlacement = {}
          };
          Lt.prototype.addLayer = function(e, t, i) {
              var n = this.layerIndexes[e.id];
              void 0 === n && (n = this.layerIndexes[e.id] = new Ct);
              var r = !1
                , o = {};
              n.handleWrapJump(i);
              for (var s = 0, a = t; s < a.length; s += 1) {
                  var l = a[s]
                    , c = l.getBucket(e);
                  c && e.id === c.layerIds[0] && (c.bucketInstanceId || (c.bucketInstanceId = ++this.maxBucketInstanceId),
                  n.addBucket(l.tileID, c, this.crossTileIDs) && (r = !0),
                  o[c.bucketInstanceId] = !0)
              }
              return n.removeStaleBuckets(o) && (r = !0),
              r
          }
          ,
          Lt.prototype.pruneUnusedLayers = function(e) {
              var t = {};
              for (var i in e.forEach(function(e) {
                  t[e] = !0
              }),
              this.layerIndexes)
                  t[i] || delete this.layerIndexes[i]
          }
          ;
          var At = function(t, i) {
              return e.emitValidationErrors(t, i && i.filter(function(e) {
                  return "source.canvas" !== e.identifier
              }))
          }
            , Pt = e.pick(De, ["addLayer", "removeLayer", "setPaintProperty", "setLayoutProperty", "setFilter", "addSource", "removeSource", "setLayerZoomRange", "setLight", "setTransition", "setGeoJSONSourceData"])
            , It = e.pick(De, ["setCenter", "setZoom", "setBearing", "setPitch"])
            , Mt = function(t) {
              function i(n, r) {
                  var o = this;
                  void 0 === r && (r = {}),
                  t.call(this),
                  this.map = n,
                  this.dispatcher = new x((Ie || (Ie = new Pe),
                  Ie),this),
                  this.imageManager = new h,
                  this.glyphManager = new v(n._transformRequest,r.localIdeographFontFamily),
                  this.lineAtlas = new w(256,512),
                  this.crossTileSymbolIndex = new Lt,
                  this._layers = {},
                  this._order = [],
                  this.sourceCaches = {},
                  this.zoomHistory = new e.ZoomHistory,
                  this._loaded = !1,
                  this._resetUpdates(),
                  this.dispatcher.broadcast("setReferrer", e.getReferrer());
                  var s = this;
                  this._rtlTextPluginCallback = i.registerForPluginAvailability(function(e) {
                      for (var t in s.dispatcher.broadcast("loadRTLTextPlugin", e.pluginURL, e.completionCallback),
                      s.sourceCaches)
                          s.sourceCaches[t].reload()
                  }),
                  this.on("data", function(e) {
                      if ("source" === e.dataType && "metadata" === e.sourceDataType) {
                          var t = o.sourceCaches[e.sourceId];
                          if (t) {
                              var i = t.getSource();
                              if (i && i.vectorLayerIds)
                                  for (var n in o._layers) {
                                      var r = o._layers[n];
                                      r.source === i.id && o._validateLayer(r)
                                  }
                          }
                      }
                  })
              }
              return t && (i.__proto__ = t),
              i.prototype = Object.create(t && t.prototype),
              i.prototype.constructor = i,
              i.prototype.loadURL = function(t, i) {
                  var n = this;
                  void 0 === i && (i = {}),
                  this.fire(new e.Event("dataloading",{
                      dataType: "style"
                  }));
                  var r = "boolean" == typeof i.validate ? i.validate : !e.isMapboxURL(t);
                  t = e.normalizeStyleURL(t, i.accessToken);
                  var o = this.map._transformRequest(t, e.ResourceType.Style);
                  this._request = e.getJSON(o, function(t, i) {
                      n._request = null,
                      t ? n.fire(new e.ErrorEvent(t)) : i && n._load(i, r)
                  })
              }
              ,
              i.prototype.loadJSON = function(t, i) {
                  var n = this;
                  void 0 === i && (i = {}),
                  this.fire(new e.Event("dataloading",{
                      dataType: "style"
                  })),
                  this._request = e.browser.frame(function() {
                      n._request = null,
                      n._load(t, !1 !== i.validate)
                  })
              }
              ,
              i.prototype._load = function(t, i) {
                  var n = this;
                  if (!i || !At(this, e.validateStyle(t))) {
                      for (var r in this._loaded = !0,
                      this.stylesheet = t,
                      t.sources)
                          this.addSource(r, t.sources[r], {
                              validate: !1
                          });
                      t.sprite ? this._spriteRequest = function(t, i, n) {
                          var r, o, s, a = e.browser.devicePixelRatio > 1 ? "@2x" : "", l = e.getJSON(i(e.normalizeSpriteURL(t, a, ".json"), e.ResourceType.SpriteJSON), function(e, t) {
                              l = null,
                              s || (s = e,
                              r = t,
                              u())
                          }), c = e.getImage(i(e.normalizeSpriteURL(t, a, ".png"), e.ResourceType.SpriteImage), function(e, t) {
                              c = null,
                              s || (s = e,
                              o = t,
                              u())
                          });
                          function u() {
                              if (s)
                                  n(s);
                              else if (r && o) {
                                  var t = e.browser.getImageData(o)
                                    , i = {};
                                  for (var a in r) {
                                      var l = r[a]
                                        , c = l.width
                                        , u = l.height
                                        , h = l.x
                                        , d = l.y
                                        , p = l.sdf
                                        , f = l.pixelRatio
                                        , m = new e.RGBAImage({
                                          width: c,
                                          height: u
                                      });
                                      e.RGBAImage.copy(t, m, {
                                          x: h,
                                          y: d
                                      }, {
                                          x: 0,
                                          y: 0
                                      }, {
                                          width: c,
                                          height: u
                                      }),
                                      i[a] = {
                                          data: m,
                                          pixelRatio: f,
                                          sdf: p
                                      }
                                  }
                                  n(null, i)
                              }
                          }
                          return {
                              cancel: function() {
                                  l && (l.cancel(),
                                  l = null),
                                  c && (c.cancel(),
                                  c = null)
                              }
                          }
                      }(t.sprite, this.map._transformRequest, function(t, i) {
                          if (n._spriteRequest = null,
                          t)
                              n.fire(new e.ErrorEvent(t));
                          else if (i)
                              for (var r in i)
                                  n.imageManager.addImage(r, i[r]);
                          n.imageManager.setLoaded(!0),
                          n.fire(new e.Event("data",{
                              dataType: "style"
                          }))
                      }) : this.imageManager.setLoaded(!0),
                      this.glyphManager.setURL(t.glyphs);
                      var o = ze(this.stylesheet.layers);
                      this._order = o.map(function(e) {
                          return e.id
                      }),
                      this._layers = {};
                      for (var s = 0, a = o; s < a.length; s += 1) {
                          var l = a[s];
                          (l = e.createStyleLayer(l)).setEventedParent(this, {
                              layer: {
                                  id: l.id
                              }
                          }),
                          this._layers[l.id] = l
                      }
                      this.dispatcher.broadcast("setLayers", this._serializeLayers(this._order)),
                      this.light = new b(this.stylesheet.light),
                      this.fire(new e.Event("data",{
                          dataType: "style"
                      })),
                      this.fire(new e.Event("style.load"))
                  }
              }
              ,
              i.prototype._validateLayer = function(t) {
                  var i = this.sourceCaches[t.source];
                  if (i) {
                      var n = t.sourceLayer;
                      if (n) {
                          var r = i.getSource();
                          ("geojson" === r.type || r.vectorLayerIds && -1 === r.vectorLayerIds.indexOf(n)) && this.fire(new e.ErrorEvent(new Error('Source layer "' + n + '" does not exist on source "' + r.id + '" as specified by style layer "' + t.id + '"')))
                      }
                  }
              }
              ,
              i.prototype.loaded = function() {
                  if (!this._loaded)
                      return !1;
                  if (Object.keys(this._updatedSources).length)
                      return !1;
                  for (var e in this.sourceCaches)
                      if (!this.sourceCaches[e].loaded())
                          return !1;
                  return !!this.imageManager.isLoaded()
              }
              ,
              i.prototype._serializeLayers = function(e) {
                  for (var t = [], i = 0, n = e; i < n.length; i += 1) {
                      var r = n[i]
                        , o = this._layers[r];
                      "custom" !== o.type && t.push(o.serialize())
                  }
                  return t
              }
              ,
              i.prototype.hasTransitions = function() {
                  if (this.light && this.light.hasTransition())
                      return !0;
                  for (var e in this.sourceCaches)
                      if (this.sourceCaches[e].hasTransition())
                          return !0;
                  for (var t in this._layers)
                      if (this._layers[t].hasTransition())
                          return !0;
                  return !1
              }
              ,
              i.prototype._checkLoaded = function() {
                  if (!this._loaded)
                      throw new Error("Style is not done loading")
              }
              ,
              i.prototype.update = function(t) {
                  if (this._loaded) {
                      var i = this._changed;
                      if (this._changed) {
                          var n = Object.keys(this._updatedLayers)
                            , r = Object.keys(this._removedLayers);
                          for (var o in (n.length || r.length) && this._updateWorkerLayers(n, r),
                          this._updatedSources) {
                              var s = this._updatedSources[o];
                              "reload" === s ? this._reloadSource(o) : "clear" === s && this._clearSource(o)
                          }
                          for (var a in this._updatedPaintProps)
                              this._layers[a].updateTransitions(t);
                          this.light.updateTransitions(t),
                          this._resetUpdates()
                      }
                      for (var l in this.sourceCaches)
                          this.sourceCaches[l].used = !1;
                      for (var c = 0, u = this._order; c < u.length; c += 1) {
                          var h = u[c]
                            , d = this._layers[h];
                          d.recalculate(t),
                          !d.isHidden(t.zoom) && d.source && (this.sourceCaches[d.source].used = !0)
                      }
                      this.light.recalculate(t),
                      this.z = t.zoom,
                      i && this.fire(new e.Event("data",{
                          dataType: "style"
                      }))
                  }
              }
              ,
              i.prototype._updateWorkerLayers = function(e, t) {
                  this.dispatcher.broadcast("updateLayers", {
                      layers: this._serializeLayers(e),
                      removedIds: t
                  })
              }
              ,
              i.prototype._resetUpdates = function() {
                  this._changed = !1,
                  this._updatedLayers = {},
                  this._removedLayers = {},
                  this._updatedSources = {},
                  this._updatedPaintProps = {}
              }
              ,
              i.prototype.setState = function(t) {
                  var i = this;
                  if (this._checkLoaded(),
                  At(this, e.validateStyle(t)))
                      return !1;
                  (t = e.clone(t)).layers = ze(t.layers);
                  var n = function(t, i) {
                      if (!t)
                          return [{
                              command: De.setStyle,
                              args: [i]
                          }];
                      var n = [];
                      try {
                          if (!e.isEqual(t.version, i.version))
                              return [{
                                  command: De.setStyle,
                                  args: [i]
                              }];
                          e.isEqual(t.center, i.center) || n.push({
                              command: De.setCenter,
                              args: [i.center]
                          }),
                          e.isEqual(t.zoom, i.zoom) || n.push({
                              command: De.setZoom,
                              args: [i.zoom]
                          }),
                          e.isEqual(t.bearing, i.bearing) || n.push({
                              command: De.setBearing,
                              args: [i.bearing]
                          }),
                          e.isEqual(t.pitch, i.pitch) || n.push({
                              command: De.setPitch,
                              args: [i.pitch]
                          }),
                          e.isEqual(t.sprite, i.sprite) || n.push({
                              command: De.setSprite,
                              args: [i.sprite]
                          }),
                          e.isEqual(t.glyphs, i.glyphs) || n.push({
                              command: De.setGlyphs,
                              args: [i.glyphs]
                          }),
                          e.isEqual(t.transition, i.transition) || n.push({
                              command: De.setTransition,
                              args: [i.transition]
                          }),
                          e.isEqual(t.light, i.light) || n.push({
                              command: De.setLight,
                              args: [i.light]
                          });
                          var r = {}
                            , o = [];
                          !function(t, i, n, r) {
                              var o;
                              for (o in i = i || {},
                              t = t || {})
                                  t.hasOwnProperty(o) && (i.hasOwnProperty(o) || Be(o, n, r));
                              for (o in i)
                                  i.hasOwnProperty(o) && (t.hasOwnProperty(o) ? e.isEqual(t[o], i[o]) || ("geojson" === t[o].type && "geojson" === i[o].type && Fe(t, i, o) ? n.push({
                                      command: De.setGeoJSONSourceData,
                                      args: [o, i[o].data]
                                  }) : je(o, i, n, r)) : Re(o, i, n))
                          }(t.sources, i.sources, o, r);
                          var s = [];
                          t.layers && t.layers.forEach(function(e) {
                              r[e.source] ? n.push({
                                  command: De.removeLayer,
                                  args: [e.id]
                              }) : s.push(e)
                          }),
                          n = n.concat(o),
                          function(t, i, n) {
                              i = i || [];
                              var r, o, s, a, l, c, u, h = (t = t || []).map(Ue), d = i.map(Ue), p = t.reduce(qe, {}), f = i.reduce(qe, {}), m = h.slice(), g = Object.create(null);
                              for (r = 0,
                              o = 0; r < h.length; r++)
                                  s = h[r],
                                  f.hasOwnProperty(s) ? o++ : (n.push({
                                      command: De.removeLayer,
                                      args: [s]
                                  }),
                                  m.splice(m.indexOf(s, o), 1));
                              for (r = 0,
                              o = 0; r < d.length; r++)
                                  s = d[d.length - 1 - r],
                                  m[m.length - 1 - r] !== s && (p.hasOwnProperty(s) ? (n.push({
                                      command: De.removeLayer,
                                      args: [s]
                                  }),
                                  m.splice(m.lastIndexOf(s, m.length - o), 1)) : o++,
                                  c = m[m.length - r],
                                  n.push({
                                      command: De.addLayer,
                                      args: [f[s], c]
                                  }),
                                  m.splice(m.length - r, 0, s),
                                  g[s] = !0);
                              for (r = 0; r < d.length; r++)
                                  if (a = p[s = d[r]],
                                  l = f[s],
                                  !g[s] && !e.isEqual(a, l))
                                      if (e.isEqual(a.source, l.source) && e.isEqual(a["source-layer"], l["source-layer"]) && e.isEqual(a.type, l.type)) {
                                          for (u in Ne(a.layout, l.layout, n, s, null, De.setLayoutProperty),
                                          Ne(a.paint, l.paint, n, s, null, De.setPaintProperty),
                                          e.isEqual(a.filter, l.filter) || n.push({
                                              command: De.setFilter,
                                              args: [s, l.filter]
                                          }),
                                          e.isEqual(a.minzoom, l.minzoom) && e.isEqual(a.maxzoom, l.maxzoom) || n.push({
                                              command: De.setLayerZoomRange,
                                              args: [s, l.minzoom, l.maxzoom]
                                          }),
                                          a)
                                              a.hasOwnProperty(u) && "layout" !== u && "paint" !== u && "filter" !== u && "metadata" !== u && "minzoom" !== u && "maxzoom" !== u && (0 === u.indexOf("paint.") ? Ne(a[u], l[u], n, s, u.slice(6), De.setPaintProperty) : e.isEqual(a[u], l[u]) || n.push({
                                                  command: De.setLayerProperty,
                                                  args: [s, u, l[u]]
                                              }));
                                          for (u in l)
                                              l.hasOwnProperty(u) && !a.hasOwnProperty(u) && "layout" !== u && "paint" !== u && "filter" !== u && "metadata" !== u && "minzoom" !== u && "maxzoom" !== u && (0 === u.indexOf("paint.") ? Ne(a[u], l[u], n, s, u.slice(6), De.setPaintProperty) : e.isEqual(a[u], l[u]) || n.push({
                                                  command: De.setLayerProperty,
                                                  args: [s, u, l[u]]
                                              }))
                                      } else
                                          n.push({
                                              command: De.removeLayer,
                                              args: [s]
                                          }),
                                          c = m[m.lastIndexOf(s) + 1],
                                          n.push({
                                              command: De.addLayer,
                                              args: [l, c]
                                          })
                          }(s, i.layers, n)
                      } catch (e) {
                          console.warn("Unable to compute style diff:", e),
                          n = [{
                              command: De.setStyle,
                              args: [i]
                          }]
                      }
                      return n
                  }(this.serialize(), t).filter(function(e) {
                      return !(e.command in It)
                  });
                  if (0 === n.length)
                      return !1;
                  var r = n.filter(function(e) {
                      return !(e.command in Pt)
                  });
                  if (r.length > 0)
                      throw new Error("Unimplemented: " + r.map(function(e) {
                          return e.command
                      }).join(", ") + ".");
                  return n.forEach(function(e) {
                      "setTransition" !== e.command && i[e.command].apply(i, e.args)
                  }),
                  this.stylesheet = t,
                  !0
              }
              ,
              i.prototype.addImage = function(t, i) {
                  if (this.getImage(t))
                      return this.fire(new e.ErrorEvent(new Error("An image with this name already exists.")));
                  this.imageManager.addImage(t, i),
                  this.fire(new e.Event("data",{
                      dataType: "style"
                  }))
              }
              ,
              i.prototype.getImage = function(e) {
                  return this.imageManager.getImage(e)
              }
              ,
              i.prototype.removeImage = function(t) {
                  if (!this.getImage(t))
                      return this.fire(new e.ErrorEvent(new Error("No image with this name exists.")));
                  this.imageManager.removeImage(t),
                  this.fire(new e.Event("data",{
                      dataType: "style"
                  }))
              }
              ,
              i.prototype.listImages = function() {
                  return this._checkLoaded(),
                  this.imageManager.listImages()
              }
              ,
              i.prototype.addSource = function(t, i, n) {
                  var r = this;
                  if (void 0 === n && (n = {}),
                  this._checkLoaded(),
                  void 0 !== this.sourceCaches[t])
                      throw new Error("There is already a source with this ID");
                  if (!i.type)
                      throw new Error("The type property must be defined, but the only the following properties were given: " + Object.keys(i).join(", ") + ".");
                  if (!(["vector", "raster", "geojson", "video", "image"].indexOf(i.type) >= 0 && this._validate(e.validateStyle.source, "sources." + t, i, null, n))) {
                      this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                      var o = this.sourceCaches[t] = new Te(t,i,this.dispatcher);
                      o.style = this,
                      o.setEventedParent(this, function() {
                          return {
                              isSourceLoaded: r.loaded(),
                              source: o.serialize(),
                              sourceId: t
                          }
                      }),
                      o.onAdd(this.map),
                      this._changed = !0
                  }
              }
              ,
              i.prototype.removeSource = function(t) {
                  if (this._checkLoaded(),
                  void 0 === this.sourceCaches[t])
                      throw new Error("There is no source with this ID");
                  for (var i in this._layers)
                      if (this._layers[i].source === t)
                          return this.fire(new e.ErrorEvent(new Error('Source "' + t + '" cannot be removed while layer "' + i + '" is using it.')));
                  var n = this.sourceCaches[t];
                  delete this.sourceCaches[t],
                  delete this._updatedSources[t],
                  n.fire(new e.Event("data",{
                      sourceDataType: "metadata",
                      dataType: "source",
                      sourceId: t
                  })),
                  n.setEventedParent(null),
                  n.clearTiles(),
                  n.onRemove && n.onRemove(this.map),
                  this._changed = !0
              }
              ,
              i.prototype.setGeoJSONSourceData = function(e, t) {
                  this._checkLoaded(),
                  this.sourceCaches[e].getSource().setData(t),
                  this._changed = !0
              }
              ,
              i.prototype.getSource = function(e) {
                  return this.sourceCaches[e] && this.sourceCaches[e].getSource()
              }
              ,
              i.prototype.addLayer = function(t, i, n) {
                  void 0 === n && (n = {}),
                  this._checkLoaded();
                  var r = t.id;
                  if (this.getLayer(r))
                      this.fire(new e.ErrorEvent(new Error('Layer with id "' + r + '" already exists on this map')));
                  else {
                      var o;
                      if ("custom" === t.type) {
                          if (At(this, e.validateCustomStyleLayer(t)))
                              return;
                          o = e.createStyleLayer(t)
                      } else {
                          if ("object" == typeof t.source && (this.addSource(r, t.source),
                          t = e.clone(t),
                          t = e.extend(t, {
                              source: r
                          })),
                          this._validate(e.validateStyle.layer, "layers." + r, t, {
                              arrayIndex: -1
                          }, n))
                              return;
                          o = e.createStyleLayer(t),
                          this._validateLayer(o),
                          o.setEventedParent(this, {
                              layer: {
                                  id: r
                              }
                          })
                      }
                      var s = i ? this._order.indexOf(i) : this._order.length;
                      if (i && -1 === s)
                          this.fire(new e.ErrorEvent(new Error('Layer with id "' + i + '" does not exist on this map.')));
                      else {
                          if (this._order.splice(s, 0, r),
                          this._layerOrderChanged = !0,
                          this._layers[r] = o,
                          this._removedLayers[r] && o.source && "custom" !== o.type) {
                              var a = this._removedLayers[r];
                              delete this._removedLayers[r],
                              a.type !== o.type ? this._updatedSources[o.source] = "clear" : (this._updatedSources[o.source] = "reload",
                              this.sourceCaches[o.source].pause())
                          }
                          this._updateLayer(o),
                          o.onAdd && o.onAdd(this.map)
                      }
                  }
              }
              ,
              i.prototype.moveLayer = function(t, i) {
                  if (this._checkLoaded(),
                  this._changed = !0,
                  this._layers[t]) {
                      if (t !== i) {
                          var n = this._order.indexOf(t);
                          this._order.splice(n, 1);
                          var r = i ? this._order.indexOf(i) : this._order.length;
                          i && -1 === r ? this.fire(new e.ErrorEvent(new Error('Layer with id "' + i + '" does not exist on this map.'))) : (this._order.splice(r, 0, t),
                          this._layerOrderChanged = !0)
                      }
                  } else
                      this.fire(new e.ErrorEvent(new Error("The layer '" + t + "' does not exist in the map's style and cannot be moved.")))
              }
              ,
              i.prototype.removeLayer = function(t) {
                  this._checkLoaded();
                  var i = this._layers[t];
                  if (i) {
                      i.setEventedParent(null);
                      var n = this._order.indexOf(t);
                      this._order.splice(n, 1),
                      this._layerOrderChanged = !0,
                      this._changed = !0,
                      this._removedLayers[t] = i,
                      delete this._layers[t],
                      delete this._updatedLayers[t],
                      delete this._updatedPaintProps[t],
                      i.onRemove && i.onRemove(this.map)
                  } else
                      this.fire(new e.ErrorEvent(new Error("The layer '" + t + "' does not exist in the map's style and cannot be removed.")))
              }
              ,
              i.prototype.getLayer = function(e) {
                  return this._layers[e]
              }
              ,
              i.prototype.setLayerZoomRange = function(t, i, n) {
                  this._checkLoaded();
                  var r = this.getLayer(t);
                  r ? r.minzoom === i && r.maxzoom === n || (null != i && (r.minzoom = i),
                  null != n && (r.maxzoom = n),
                  this._updateLayer(r)) : this.fire(new e.ErrorEvent(new Error("The layer '" + t + "' does not exist in the map's style and cannot have zoom extent.")))
              }
              ,
              i.prototype.setFilter = function(t, i, n) {
                  void 0 === n && (n = {}),
                  this._checkLoaded();
                  var r = this.getLayer(t);
                  if (r) {
                      if (!e.isEqual(r.filter, i))
                          return null == i ? (r.filter = void 0,
                          void this._updateLayer(r)) : void (this._validate(e.validateStyle.filter, "layers." + r.id + ".filter", i, null, n) || (r.filter = e.clone(i),
                          this._updateLayer(r)))
                  } else
                      this.fire(new e.ErrorEvent(new Error("The layer '" + t + "' does not exist in the map's style and cannot be filtered.")))
              }
              ,
              i.prototype.getFilter = function(t) {
                  return e.clone(this.getLayer(t).filter)
              }
              ,
              i.prototype.setLayoutProperty = function(t, i, n, r) {
                  void 0 === r && (r = {}),
                  this._checkLoaded();
                  var o = this.getLayer(t);
                  o ? e.isEqual(o.getLayoutProperty(i), n) || (o.setLayoutProperty(i, n, r),
                  this._updateLayer(o)) : this.fire(new e.ErrorEvent(new Error("The layer '" + t + "' does not exist in the map's style and cannot be styled.")))
              }
              ,
              i.prototype.getLayoutProperty = function(t, i) {
                  var n = this.getLayer(t);
                  if (n)
                      return n.getLayoutProperty(i);
                  this.fire(new e.ErrorEvent(new Error("The layer '" + t + "' does not exist in the map's style.")))
              }
              ,
              i.prototype.setPaintProperty = function(t, i, n, r) {
                  void 0 === r && (r = {}),
                  this._checkLoaded();
                  var o = this.getLayer(t);
                  o ? e.isEqual(o.getPaintProperty(i), n) || (o.setPaintProperty(i, n, r) && this._updateLayer(o),
                  this._changed = !0,
                  this._updatedPaintProps[t] = !0) : this.fire(new e.ErrorEvent(new Error("The layer '" + t + "' does not exist in the map's style and cannot be styled.")))
              }
              ,
              i.prototype.getPaintProperty = function(e, t) {
                  return this.getLayer(e).getPaintProperty(t)
              }
              ,
              i.prototype.setFeatureState = function(t, i) {
                  this._checkLoaded();
                  var n = t.source
                    , r = t.sourceLayer
                    , o = this.sourceCaches[n]
                    , s = parseInt(t.id, 10);
                  if (void 0 !== o) {
                      var a = o.getSource().type;
                      "geojson" === a && r ? this.fire(new e.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== a || r ? isNaN(s) || s < 0 ? this.fire(new e.ErrorEvent(new Error("The feature id parameter must be provided and non-negative."))) : o.setFeatureState(r, s, i) : this.fire(new e.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")))
                  } else
                      this.fire(new e.ErrorEvent(new Error("The source '" + n + "' does not exist in the map's style.")))
              }
              ,
              i.prototype.removeFeatureState = function(t, i) {
                  this._checkLoaded();
                  var n = t.source
                    , r = this.sourceCaches[n];
                  if (void 0 !== r) {
                      var o = r.getSource().type
                        , s = "vector" === o ? t.sourceLayer : void 0
                        , a = parseInt(t.id, 10);
                      "vector" !== o || s ? t.id && isNaN(a) || a < 0 ? this.fire(new e.ErrorEvent(new Error("The feature id parameter must be non-negative."))) : !i || t.id ? r.removeFeatureState(s, a, i) : this.fire(new e.ErrorEvent(new Error("A feature id is requred to remove its specific state property."))) : this.fire(new e.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")))
                  } else
                      this.fire(new e.ErrorEvent(new Error("The source '" + n + "' does not exist in the map's style.")))
              }
              ,
              i.prototype.getFeatureState = function(t) {
                  this._checkLoaded();
                  var i = t.source
                    , n = t.sourceLayer
                    , r = this.sourceCaches[i]
                    , o = parseInt(t.id, 10);
                  if (void 0 !== r)
                      if ("vector" !== r.getSource().type || n) {
                          if (!(isNaN(o) || o < 0))
                              return r.getFeatureState(n, o);
                          this.fire(new e.ErrorEvent(new Error("The feature id parameter must be provided and non-negative.")))
                      } else
                          this.fire(new e.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                  else
                      this.fire(new e.ErrorEvent(new Error("The source '" + i + "' does not exist in the map's style.")))
              }
              ,
              i.prototype.getTransition = function() {
                  return e.extend({
                      duration: 300,
                      delay: 0
                  }, this.stylesheet && this.stylesheet.transition)
              }
              ,
              i.prototype.serialize = function() {
                  return e.filterObject({
                      version: this.stylesheet.version,
                      name: this.stylesheet.name,
                      metadata: this.stylesheet.metadata,
                      light: this.stylesheet.light,
                      center: this.stylesheet.center,
                      zoom: this.stylesheet.zoom,
                      bearing: this.stylesheet.bearing,
                      pitch: this.stylesheet.pitch,
                      sprite: this.stylesheet.sprite,
                      glyphs: this.stylesheet.glyphs,
                      transition: this.stylesheet.transition,
                      sources: e.mapObject(this.sourceCaches, function(e) {
                          return e.serialize()
                      }),
                      layers: this._serializeLayers(this._order)
                  }, function(e) {
                      return void 0 !== e
                  })
              }
              ,
              i.prototype._updateLayer = function(e) {
                  this._updatedLayers[e.id] = !0,
                  e.source && !this._updatedSources[e.source] && (this._updatedSources[e.source] = "reload",
                  this.sourceCaches[e.source].pause()),
                  this._changed = !0
              }
              ,
              i.prototype._flattenAndSortRenderedFeatures = function(e) {
                  for (var t = this, i = function(e) {
                      return "fill-extrusion" === t._layers[e].type
                  }, n = {}, r = [], o = this._order.length - 1; o >= 0; o--) {
                      var s = this._order[o];
                      if (i(s)) {
                          n[s] = o;
                          for (var a = 0, l = e; a < l.length; a += 1) {
                              var c = l[a][s];
                              if (c)
                                  for (var u = 0, h = c; u < h.length; u += 1) {
                                      var d = h[u];
                                      r.push(d)
                                  }
                          }
                      }
                  }
                  r.sort(function(e, t) {
                      return t.intersectionZ - e.intersectionZ
                  });
                  for (var p = [], f = this._order.length - 1; f >= 0; f--) {
                      var m = this._order[f];
                      if (i(m))
                          for (var g = r.length - 1; g >= 0; g--) {
                              var v = r[g].feature;
                              if (n[v.layer.id] < f)
                                  break;
                              p.push(v),
                              r.pop()
                          }
                      else
                          for (var y = 0, _ = e; y < _.length; y += 1) {
                              var b = _[y][m];
                              if (b)
                                  for (var w = 0, x = b; w < x.length; w += 1) {
                                      var k = x[w];
                                      p.push(k.feature)
                                  }
                          }
                  }
                  return p
              }
              ,
              i.prototype.queryRenderedFeatures = function(t, i, n) {
                  i && i.filter && this._validate(e.validateStyle.filter, "queryRenderedFeatures.filter", i.filter);
                  var r = {};
                  if (i && i.layers) {
                      if (!Array.isArray(i.layers))
                          return this.fire(new e.ErrorEvent(new Error("parameters.layers must be an Array."))),
                          [];
                      for (var o = 0, s = i.layers; o < s.length; o += 1) {
                          var a = s[o]
                            , l = this._layers[a];
                          if (!l)
                              return this.fire(new e.ErrorEvent(new Error("The layer '" + a + "' does not exist in the map's style and cannot be queried for features."))),
                              [];
                          r[l.source] = !0
                      }
                  }
                  var c = [];
                  for (var u in this.sourceCaches)
                      i.layers && !r[u] || c.push(O(this.sourceCaches[u], this._layers, t, i, n));
                  return this.placement && c.push(function(e, t, i, n, r, o) {
                      for (var s = {}, a = r.queryRenderedSymbols(i), l = [], c = 0, u = Object.keys(a).map(Number); c < u.length; c += 1) {
                          var h = u[c];
                          l.push(o[h])
                      }
                      l.sort(z);
                      for (var d = function() {
                          var t = f[p]
                            , i = t.featureIndex.lookupSymbolFeatures(a[t.bucketInstanceId], t.bucketIndex, t.sourceLayerIndex, n.filter, n.layers, e);
                          for (var r in i) {
                              var o = s[r] = s[r] || []
                                , l = i[r];
                              l.sort(function(e, i) {
                                  var n = t.featureSortOrder;
                                  if (n) {
                                      var r = n.indexOf(e.featureIndex);
                                      return n.indexOf(i.featureIndex) - r
                                  }
                                  return i.featureIndex - e.featureIndex
                              });
                              for (var c = 0, u = l; c < u.length; c += 1) {
                                  var h = u[c];
                                  o.push(h)
                              }
                          }
                      }, p = 0, f = l; p < f.length; p += 1)
                          d();
                      var m = function(i) {
                          s[i].forEach(function(n) {
                              var r = n.feature
                                , o = e[i]
                                , s = t[o.source].getFeatureState(r.layer["source-layer"], r.id);
                              r.source = r.layer.source,
                              r.layer["source-layer"] && (r.sourceLayer = r.layer["source-layer"]),
                              r.state = s
                          })
                      };
                      for (var g in s)
                          m(g);
                      return s
                  }(this._layers, this.sourceCaches, t, i, this.placement.collisionIndex, this.placement.retainedQueryData)),
                  this._flattenAndSortRenderedFeatures(c)
              }
              ,
              i.prototype.querySourceFeatures = function(t, i) {
                  i && i.filter && this._validate(e.validateStyle.filter, "querySourceFeatures.filter", i.filter);
                  var n = this.sourceCaches[t];
                  return n ? function(e, t) {
                      for (var i = e.getRenderableIds().map(function(t) {
                          return e.getTileByID(t)
                      }), n = [], r = {}, o = 0; o < i.length; o++) {
                          var s = i[o]
                            , a = s.tileID.canonical.key;
                          r[a] || (r[a] = !0,
                          s.querySourceFeatures(n, t))
                      }
                      return n
                  }(n, i) : []
              }
              ,
              i.prototype.addSourceType = function(e, t, n) {
                  return i.getSourceType(e) ? n(new Error('A source type called "' + e + '" already exists.')) : (i.setSourceType(e, t),
                  t.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                      name: e,
                      url: t.workerSourceURL
                  }, n) : n(null, null))
              }
              ,
              i.prototype.getLight = function() {
                  return this.light.getLight()
              }
              ,
              i.prototype.setLight = function(t, i) {
                  void 0 === i && (i = {}),
                  this._checkLoaded();
                  var n = this.light.getLight()
                    , r = !1;
                  for (var o in t)
                      if (!e.isEqual(t[o], n[o])) {
                          r = !0;
                          break
                      }
                  if (r) {
                      var s = {
                          now: e.browser.now(),
                          transition: e.extend({
                              duration: 300,
                              delay: 0
                          }, this.stylesheet.transition)
                      };
                      this.light.setLight(t, i),
                      this.light.updateTransitions(s)
                  }
              }
              ,
              i.prototype._validate = function(t, i, n, r, o) {
                  return void 0 === o && (o = {}),
                  (!o || !1 !== o.validate) && At(this, t.call(e.validateStyle, e.extend({
                      key: i,
                      style: this.serialize(),
                      value: n,
                      styleSpec: e.styleSpec
                  }, r)))
              }
              ,
              i.prototype._remove = function() {
                  for (var t in this._request && (this._request.cancel(),
                  this._request = null),
                  this._spriteRequest && (this._spriteRequest.cancel(),
                  this._spriteRequest = null),
                  e.evented.off("pluginAvailable", this._rtlTextPluginCallback),
                  this.sourceCaches)
                      this.sourceCaches[t].clearTiles();
                  this.dispatcher.remove()
              }
              ,
              i.prototype._clearSource = function(e) {
                  this.sourceCaches[e].clearTiles()
              }
              ,
              i.prototype._reloadSource = function(e) {
                  this.sourceCaches[e].resume(),
                  this.sourceCaches[e].reload()
              }
              ,
              i.prototype._updateSources = function(e) {
                  for (var t in this.sourceCaches)
                      this.sourceCaches[t].update(e)
              }
              ,
              i.prototype._generateCollisionBoxes = function() {
                  for (var e in this.sourceCaches)
                      this._reloadSource(e)
              }
              ,
              i.prototype._updatePlacement = function(t, i, n, r) {
                  for (var o = !1, s = !1, a = {}, l = 0, c = this._order; l < c.length; l += 1) {
                      var u = c[l]
                        , h = this._layers[u];
                      if ("symbol" === h.type) {
                          if (!a[h.source]) {
                              var d = this.sourceCaches[h.source];
                              a[h.source] = d.getRenderableIds(!0).map(function(e) {
                                  return d.getTileByID(e)
                              }).sort(function(e, t) {
                                  return t.tileID.overscaledZ - e.tileID.overscaledZ || (e.tileID.isLessThan(t.tileID) ? -1 : 1)
                              })
                          }
                          var p = this.crossTileSymbolIndex.addLayer(h, a[h.source], t.center.lng);
                          o = o || p
                      }
                  }
                  this.crossTileSymbolIndex.pruneUnusedLayers(this._order);
                  var f = this._layerOrderChanged || 0 === n;
                  if ((f || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(e.browser.now())) && (this.pauseablePlacement = new kt(t,this._order,f,i,n,r),
                  this._layerOrderChanged = !1),
                  this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, a),
                  this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(this.placement, e.browser.now()),
                  s = !0),
                  o && this.pauseablePlacement.placement.setStale()),
                  s || o)
                      for (var m = 0, g = this._order; m < g.length; m += 1) {
                          var v = g[m]
                            , y = this._layers[v];
                          "symbol" === y.type && this.placement.updateLayerOpacities(y, a[y.source])
                      }
                  return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(e.browser.now())
              }
              ,
              i.prototype._releaseSymbolFadeTiles = function() {
                  for (var e in this.sourceCaches)
                      this.sourceCaches[e].releaseSymbolFadeTiles()
              }
              ,
              i.prototype.getImages = function(e, t, i) {
                  this.imageManager.getImages(t.icons, i)
              }
              ,
              i.prototype.getGlyphs = function(e, t, i) {
                  this.glyphManager.getGlyphs(t.stacks, i)
              }
              ,
              i.prototype.getResource = function(t, i, n) {
                  return e.makeRequest(i, n)
              }
              ,
              i
          }(e.Evented);
          Mt.getSourceType = function(e) {
              return P[e]
          }
          ,
          Mt.setSourceType = function(e, t) {
              P[e] = t
          }
          ,
          Mt.registerForPluginAvailability = e.registerForPluginAvailability;
          var Ot = e.createLayout([{
              name: "a_pos",
              type: "Int16",
              components: 2
          }])
            , zt = si("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}")
            , Dt = si("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}")
            , Rt = si("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}")
            , Bt = si("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvarying vec3 v_data;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvarying vec3 v_data;void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,0,1);} else {gl_Position=u_matrix*vec4(circle_center,0,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/DEVICE_PIXEL_RATIO/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}")
            , jt = si("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}")
            , Ft = si("#pragma mapbox: define highp float weight\nuniform highp float u_intensity;varying vec2 v_extrude;\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;const highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}")
            , Nt = si("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}")
            , Ut = si("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);gl_Position.xy+=a_extrude*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}")
            , qt = si("uniform float u_overscale_factor;varying float v_placed;varying float v_notUsed;varying float v_radius;varying vec2 v_extrude;varying vec2 v_extrude_scale;void main() {float alpha=0.5;vec4 color=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {color=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {color*=.2;}float extrude_scale_length=length(v_extrude_scale);float extrude_length=length(v_extrude)*extrude_scale_length;float stroke_width=15.0*extrude_scale_length/u_overscale_factor;float radius=v_radius*extrude_scale_length;float distance_to_edge=abs(extrude_length-radius);float opacity_t=smoothstep(-stroke_width,0.0,-distance_to_edge);gl_FragColor=opacity_t*color;}", "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;varying float v_radius;varying vec2 v_extrude;varying vec2 v_extrude_scale;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);highp float padding_factor=1.2;gl_Position.xy+=a_extrude*u_extrude_scale*padding_factor*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;v_radius=abs(a_extrude.y);v_extrude=a_extrude*padding_factor;v_extrude_scale=u_extrude_scale*u_camera_to_center_distance*collision_perspective_ratio;}")
            , Ht = si("uniform highp vec4 u_color;void main() {gl_FragColor=u_color;}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}")
            , Vt = si("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}")
            , Wt = si("#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvarying vec2 v_pos;void main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}")
            , $t = si("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec4 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}")
            , Gt = si("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec4 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileZoomRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}")
            , Xt = si("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);}")
            , Zt = si("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec4 u_scale;uniform float u_vertical_gradient;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));}")
            , Yt = si("uniform sampler2D u_image;uniform float u_opacity;varying vec2 v_pos;void main() {gl_FragColor=texture2D(u_image,v_pos)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}")
            , Kt = si("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform float u_maxzoom;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;return (data.r+data.g*256.0+data.b*256.0*256.0)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggeration=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/ pow(2.0,(u_zoom-u_maxzoom)*exaggeration+19.2562-u_zoom);gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}")
            , Jt = si("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}")
            , Qt = si("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvarying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/DEVICE_PIXEL_RATIO)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define ANTIALIASING 1.0/DEVICE_PIXEL_RATIO/2.0\n#define scale 0.015873016\nattribute vec4 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_gl_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nvec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=a_pos_normal.xy;mediump vec2 normal=a_pos_normal.zw;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_gl_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}")
            , ei = si("#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nuniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp float v_lineprogress;void main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/DEVICE_PIXEL_RATIO)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,vec2(v_lineprogress,0.5));gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define MAX_LINE_DISTANCE 32767.0\n#define ANTIALIASING 1.0/DEVICE_PIXEL_RATIO/2.0\n#define scale 0.015873016\nattribute vec4 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_gl_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_lineprogress;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nvec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_lineprogress=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0/MAX_LINE_DISTANCE;vec2 pos=a_pos_normal.xy;mediump vec2 normal=a_pos_normal.zw;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_gl_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}")
            , ti = si("uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec4 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileZoomRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/DEVICE_PIXEL_RATIO)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x,1.0);float x_b=mod(v_linesofar/pattern_size_b.x,1.0);float y_a=0.5+(v_normal.y*clamp(v_width2.s,0.0,(pattern_size_a.y+2.0)/2.0)/pattern_size_a.y);float y_b=0.5+(v_normal.y*clamp(v_width2.s,0.0,(pattern_size_b.y+2.0)/2.0)/pattern_size_b.y);vec2 pos_a=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,vec2(x_a,y_a));vec2 pos_b=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,vec2(x_b,y_b));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\n#define ANTIALIASING 1.0/DEVICE_PIXEL_RATIO/2.0\nattribute vec4 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_gl_units_to_pixels;uniform mediump float u_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=a_pos_normal.xy;mediump vec2 normal=a_pos_normal.zw;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_gl_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_linesofar=a_linesofar;v_width2=vec2(outset,inset);}")
            , ii = si("uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/DEVICE_PIXEL_RATIO)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\n#define ANTIALIASING 1.0/DEVICE_PIXEL_RATIO/2.0\nattribute vec4 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_gl_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nvec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=a_pos_normal.xy;mediump vec2 normal=a_pos_normal.zw;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_gl_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}")
            , ni = si("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}")
            , ri = si("uniform sampler2D u_texture;\n#pragma mapbox: define lowp float opacity\nvarying vec2 v_tex;varying float v_fade_opacity;void main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;\n#pragma mapbox: define lowp float opacity\nuniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_gl_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;void main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size[0],a_size[1],u_size_t)/256.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size[0]/256.0;} else if (!u_is_size_zoom_constant && u_is_size_feature_constant) {size=u_size;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_gl_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));}")
            , oi = si("#define SDF_PX 8.0\n#define EDGE_GAMMA 0.105/DEVICE_PIXEL_RATIO\nuniform bool u_is_halo;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nuniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;void main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nuniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_gl_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;void main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size[0],a_size[1],u_size_t)/256.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size[0]/256.0;} else if (!u_is_size_zoom_constant && u_is_size_feature_constant) {size=u_size;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_gl_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);float gamma_scale=gl_Position.w;vec2 tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0=vec2(tex.x,tex.y);v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}");
          function si(e, t) {
              var i = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g
                , n = {};
              return {
                  fragmentSource: e = e.replace(i, function(e, t, i, r, o) {
                      return n[o] = !0,
                      "define" === t ? "\n#ifndef HAS_UNIFORM_u_" + o + "\nvarying " + i + " " + r + " " + o + ";\n#else\nuniform " + i + " " + r + " u_" + o + ";\n#endif\n" : "\n#ifdef HAS_UNIFORM_u_" + o + "\n    " + i + " " + r + " " + o + " = u_" + o + ";\n#endif\n"
                  }),
                  vertexSource: t = t.replace(i, function(e, t, i, r, o) {
                      var s = "float" === r ? "vec2" : "vec4"
                        , a = o.match(/color/) ? "color" : s;
                      return n[o] ? "define" === t ? "\n#ifndef HAS_UNIFORM_u_" + o + "\nuniform lowp float a_" + o + "_t;\nattribute " + i + " " + s + " a_" + o + ";\nvarying " + i + " " + r + " " + o + ";\n#else\nuniform " + i + " " + r + " u_" + o + ";\n#endif\n" : "vec4" === a ? "\n#ifndef HAS_UNIFORM_u_" + o + "\n    " + o + " = a_" + o + ";\n#else\n    " + i + " " + r + " " + o + " = u_" + o + ";\n#endif\n" : "\n#ifndef HAS_UNIFORM_u_" + o + "\n    " + o + " = unpack_mix_" + a + "(a_" + o + ", a_" + o + "_t);\n#else\n    " + i + " " + r + " " + o + " = u_" + o + ";\n#endif\n" : "define" === t ? "\n#ifndef HAS_UNIFORM_u_" + o + "\nuniform lowp float a_" + o + "_t;\nattribute " + i + " " + s + " a_" + o + ";\n#else\nuniform " + i + " " + r + " u_" + o + ";\n#endif\n" : "vec4" === a ? "\n#ifndef HAS_UNIFORM_u_" + o + "\n    " + i + " " + r + " " + o + " = a_" + o + ";\n#else\n    " + i + " " + r + " " + o + " = u_" + o + ";\n#endif\n" : "\n#ifndef HAS_UNIFORM_u_" + o + "\n    " + i + " " + r + " " + o + " = unpack_mix_" + a + "(a_" + o + ", a_" + o + "_t);\n#else\n    " + i + " " + r + " " + o + " = u_" + o + ";\n#endif\n"
                  })
              }
          }
          var ai = Object.freeze({
              prelude: zt,
              background: Dt,
              backgroundPattern: Rt,
              circle: Bt,
              clippingMask: jt,
              heatmap: Ft,
              heatmapTexture: Nt,
              collisionBox: Ut,
              collisionCircle: qt,
              debug: Ht,
              fill: Vt,
              fillOutline: Wt,
              fillOutlinePattern: $t,
              fillPattern: Gt,
              fillExtrusion: Xt,
              fillExtrusionPattern: Zt,
              extrusionTexture: Yt,
              hillshadePrepare: Kt,
              hillshade: Jt,
              line: Qt,
              lineGradient: ei,
              linePattern: ti,
              lineSDF: ii,
              raster: ni,
              symbolIcon: ri,
              symbolSDF: oi
          })
            , li = function() {
              this.boundProgram = null,
              this.boundLayoutVertexBuffer = null,
              this.boundPaintVertexBuffers = [],
              this.boundIndexBuffer = null,
              this.boundVertexOffset = null,
              this.boundDynamicVertexBuffer = null,
              this.vao = null
          };
          li.prototype.bind = function(e, t, i, n, r, o, s, a) {
              this.context = e;
              for (var l = this.boundPaintVertexBuffers.length !== n.length, c = 0; !l && c < n.length; c++)
                  this.boundPaintVertexBuffers[c] !== n[c] && (l = !0);
              var u = !this.vao || this.boundProgram !== t || this.boundLayoutVertexBuffer !== i || l || this.boundIndexBuffer !== r || this.boundVertexOffset !== o || this.boundDynamicVertexBuffer !== s || this.boundDynamicVertexBuffer2 !== a;
              !e.extVertexArrayObject || u ? this.freshBind(t, i, n, r, o, s, a) : (e.bindVertexArrayOES.set(this.vao),
              s && s.bind(),
              r && r.dynamicDraw && r.bind(),
              a && a.bind())
          }
          ,
          li.prototype.freshBind = function(e, t, i, n, r, o, s) {
              var a, l = e.numAttributes, c = this.context, u = c.gl;
              if (c.extVertexArrayObject)
                  this.vao && this.destroy(),
                  this.vao = c.extVertexArrayObject.createVertexArrayOES(),
                  c.bindVertexArrayOES.set(this.vao),
                  a = 0,
                  this.boundProgram = e,
                  this.boundLayoutVertexBuffer = t,
                  this.boundPaintVertexBuffers = i,
                  this.boundIndexBuffer = n,
                  this.boundVertexOffset = r,
                  this.boundDynamicVertexBuffer = o,
                  this.boundDynamicVertexBuffer2 = s;
              else {
                  a = c.currentNumAttributes || 0;
                  for (var h = l; h < a; h++)
                      u.disableVertexAttribArray(h)
              }
              t.enableAttributes(u, e);
              for (var d = 0, p = i; d < p.length; d += 1)
                  p[d].enableAttributes(u, e);
              o && o.enableAttributes(u, e),
              s && s.enableAttributes(u, e),
              t.bind(),
              t.setVertexAttribPointers(u, e, r);
              for (var f = 0, m = i; f < m.length; f += 1) {
                  var g = m[f];
                  g.bind(),
                  g.setVertexAttribPointers(u, e, r)
              }
              o && (o.bind(),
              o.setVertexAttribPointers(u, e, r)),
              n && n.bind(),
              s && (s.bind(),
              s.setVertexAttribPointers(u, e, r)),
              c.currentNumAttributes = l
          }
          ,
          li.prototype.destroy = function() {
              this.vao && (this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao),
              this.vao = null)
          }
          ;
          var ci = function(t, i, n, r, o) {
              var s = t.gl;
              this.program = s.createProgram();
              var a = n.defines().concat("#define DEVICE_PIXEL_RATIO " + e.browser.devicePixelRatio.toFixed(1));
              o && a.push("#define OVERDRAW_INSPECTOR;");
              var l = a.concat(zt.fragmentSource, i.fragmentSource).join("\n")
                , c = a.concat(zt.vertexSource, i.vertexSource).join("\n")
                , u = s.createShader(s.FRAGMENT_SHADER);
              s.shaderSource(u, l),
              s.compileShader(u),
              s.attachShader(this.program, u);
              var h = s.createShader(s.VERTEX_SHADER);
              s.shaderSource(h, c),
              s.compileShader(h),
              s.attachShader(this.program, h);
              for (var d = n.layoutAttributes || [], p = 0; p < d.length; p++)
                  s.bindAttribLocation(this.program, p, d[p].name);
              s.linkProgram(this.program),
              this.numAttributes = s.getProgramParameter(this.program, s.ACTIVE_ATTRIBUTES),
              this.attributes = {};
              for (var f = {}, m = 0; m < this.numAttributes; m++) {
                  var g = s.getActiveAttrib(this.program, m);
                  g && (this.attributes[g.name] = s.getAttribLocation(this.program, g.name))
              }
              for (var v = s.getProgramParameter(this.program, s.ACTIVE_UNIFORMS), y = 0; y < v; y++) {
                  var _ = s.getActiveUniform(this.program, y);
                  _ && (f[_.name] = s.getUniformLocation(this.program, _.name))
              }
              this.fixedUniforms = r(t, f),
              this.binderUniforms = n.getUniforms(t, f)
          };
          function ui(t, i, n) {
              var r = 1 / st(n, 1, i.transform.tileZoom)
                , o = Math.pow(2, n.tileID.overscaledZ)
                , s = n.tileSize * Math.pow(2, i.transform.tileZoom) / o
                , a = s * (n.tileID.canonical.x + n.tileID.wrap * o)
                , l = s * n.tileID.canonical.y;
              return {
                  u_image: 0,
                  u_texsize: n.imageAtlasTexture.size,
                  u_scale: [e.browser.devicePixelRatio, r, t.fromScale, t.toScale],
                  u_fade: t.t,
                  u_pixel_coord_upper: [a >> 16, l >> 16],
                  u_pixel_coord_lower: [65535 & a, 65535 & l]
              }
          }
          ci.prototype.draw = function(e, t, i, n, r, o, s, a, l, c, u, h, d, p, f, m) {
              var g, v = e.gl;
              for (var y in e.program.set(this.program),
              e.setDepthMode(i),
              e.setStencilMode(n),
              e.setColorMode(r),
              e.setCullFace(o),
              this.fixedUniforms)
                  this.fixedUniforms[y].set(s[y]);
              p && p.setUniforms(e, this.binderUniforms, h, {
                  zoom: d
              });
              for (var _ = (g = {},
              g[v.LINES] = 2,
              g[v.TRIANGLES] = 3,
              g[v.LINE_STRIP] = 1,
              g)[t], b = 0, w = u.get(); b < w.length; b += 1) {
                  var x = w[b]
                    , k = x.vaos || (x.vaos = {});
                  (k[a] || (k[a] = new li)).bind(e, this, l, p ? p.getPaintVertexBuffers() : [], c, x.vertexOffset, f, m),
                  v.drawElements(t, x.primitiveLength * _, v.UNSIGNED_SHORT, x.primitiveOffset * _ * 2)
              }
          }
          ;
          var hi = function(t, i, n) {
              var r = i.style.light
                , o = r.properties.get("position")
                , s = [o.x, o.y, o.z]
                , a = e.create();
              "viewport" === r.properties.get("anchor") && e.fromRotation(a, -i.transform.angle),
              e.transformMat3(s, s, a);
              var l = r.properties.get("color");
              return {
                  u_matrix: t,
                  u_lightpos: s,
                  u_lightintensity: r.properties.get("intensity"),
                  u_lightcolor: [l.r, l.g, l.b],
                  u_vertical_gradient: +n
              }
          }
            , di = function(t, i, n, r, o, s) {
              return e.extend(hi(t, i, n), ui(o, i, s), {
                  u_height_factor: -Math.pow(2, r.overscaledZ) / s.tileSize / 8
              })
          }
            , pi = function(t, i, n) {
              var r = e.create$1();
              e.ortho(r, 0, t.width, t.height, 0, 0, 1);
              var o = t.context.gl;
              return {
                  u_matrix: r,
                  u_world: [o.drawingBufferWidth, o.drawingBufferHeight],
                  u_image: n,
                  u_opacity: i
              }
          }
            , fi = function(e) {
              return {
                  u_matrix: e
              }
          }
            , mi = function(t, i, n, r) {
              return e.extend(fi(t), ui(n, i, r))
          }
            , gi = function(e, t) {
              return {
                  u_matrix: e,
                  u_world: t
              }
          }
            , vi = function(t, i, n, r, o) {
              return e.extend(mi(t, i, n, r), {
                  u_world: o
              })
          }
            , yi = function(e, t, i, n) {
              var r, o, s = e.transform;
              if ("map" === n.paint.get("circle-pitch-alignment")) {
                  var a = st(i, 1, s.zoom);
                  r = !0,
                  o = [a, a]
              } else
                  r = !1,
                  o = s.pixelsToGLUnits;
              return {
                  u_camera_to_center_distance: s.cameraToCenterDistance,
                  u_scale_with_map: +("map" === n.paint.get("circle-pitch-scale")),
                  u_matrix: e.translatePosMatrix(t.posMatrix, i, n.paint.get("circle-translate"), n.paint.get("circle-translate-anchor")),
                  u_pitch_with_map: +r,
                  u_extrude_scale: o
              }
          }
            , _i = function(t, i) {
              return {
                  u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                  u_camera_to_center_distance: new e.Uniform1f(t,i.u_camera_to_center_distance),
                  u_pixels_to_tile_units: new e.Uniform1f(t,i.u_pixels_to_tile_units),
                  u_extrude_scale: new e.Uniform2f(t,i.u_extrude_scale),
                  u_overscale_factor: new e.Uniform1f(t,i.u_overscale_factor)
              }
          }
            , bi = function(e, t, i) {
              var n = st(i, 1, t.zoom)
                , r = Math.pow(2, t.zoom - i.tileID.overscaledZ)
                , o = i.tileID.overscaleFactor();
              return {
                  u_matrix: e,
                  u_camera_to_center_distance: t.cameraToCenterDistance,
                  u_pixels_to_tile_units: n,
                  u_extrude_scale: [t.pixelsToGLUnits[0] / (n * r), t.pixelsToGLUnits[1] / (n * r)],
                  u_overscale_factor: o
              }
          }
            , wi = function(e, t) {
              return {
                  u_matrix: e,
                  u_color: t
              }
          }
            , xi = function(e) {
              return {
                  u_matrix: e
              }
          }
            , ki = function(e, t, i, n) {
              return {
                  u_matrix: e,
                  u_extrude_scale: st(t, 1, i),
                  u_intensity: n
              }
          }
            , Si = function(e, t, i) {
              var n = i.paint.get("hillshade-shadow-color")
                , r = i.paint.get("hillshade-highlight-color")
                , o = i.paint.get("hillshade-accent-color")
                , s = i.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
              "viewport" === i.paint.get("hillshade-illumination-anchor") && (s -= e.transform.angle);
              var a = !e.options.moving;
              return {
                  u_matrix: e.transform.calculatePosMatrix(t.tileID.toUnwrapped(), a),
                  u_image: 0,
                  u_latrange: Ti(0, t.tileID),
                  u_light: [i.paint.get("hillshade-exaggeration"), s],
                  u_shadow: n,
                  u_highlight: r,
                  u_accent: o
              }
          }
            , Ei = function(t, i) {
              var n = t.dem.stride
                , r = e.create$1();
              return e.ortho(r, 0, e.EXTENT, -e.EXTENT, 0, 0, 1),
              e.translate(r, r, [0, -e.EXTENT, 0]),
              {
                  u_matrix: r,
                  u_image: 1,
                  u_dimension: [n, n],
                  u_zoom: t.tileID.overscaledZ,
                  u_maxzoom: i
              }
          };
          function Ti(t, i) {
              var n = Math.pow(2, i.canonical.z)
                , r = i.canonical.y;
              return [new e.MercatorCoordinate(0,r / n).toLngLat().lat, new e.MercatorCoordinate(0,(r + 1) / n).toLngLat().lat]
          }
          var Ci = function(e, t, i) {
              var n = e.transform;
              return {
                  u_matrix: Mi(e, t, i),
                  u_ratio: 1 / st(t, 1, n.zoom),
                  u_gl_units_to_pixels: [1 / n.pixelsToGLUnits[0], 1 / n.pixelsToGLUnits[1]]
              }
          }
            , Li = function(t, i, n) {
              return e.extend(Ci(t, i, n), {
                  u_image: 0
              })
          }
            , Ai = function(t, i, n, r) {
              var o = t.transform
                , s = Ii(i, o);
              return {
                  u_matrix: Mi(t, i, n),
                  u_texsize: i.imageAtlasTexture.size,
                  u_ratio: 1 / st(i, 1, o.zoom),
                  u_image: 0,
                  u_scale: [e.browser.devicePixelRatio, s, r.fromScale, r.toScale],
                  u_fade: r.t,
                  u_gl_units_to_pixels: [1 / o.pixelsToGLUnits[0], 1 / o.pixelsToGLUnits[1]]
              }
          }
            , Pi = function(t, i, n, r, o) {
              var s = t.transform
                , a = t.lineAtlas
                , l = Ii(i, s)
                , c = "round" === n.layout.get("line-cap")
                , u = a.getDash(r.from, c)
                , h = a.getDash(r.to, c)
                , d = u.width * o.fromScale
                , p = h.width * o.toScale;
              return e.extend(Ci(t, i, n), {
                  u_patternscale_a: [l / d, -u.height / 2],
                  u_patternscale_b: [l / p, -h.height / 2],
                  u_sdfgamma: a.width / (256 * Math.min(d, p) * e.browser.devicePixelRatio) / 2,
                  u_image: 0,
                  u_tex_y_a: u.y,
                  u_tex_y_b: h.y,
                  u_mix: o.t
              })
          };
          function Ii(e, t) {
              return 1 / st(e, 1, t.tileZoom)
          }
          function Mi(e, t, i) {
              return e.translatePosMatrix(t.tileID.posMatrix, t, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"))
          }
          var Oi = function(e, t, i, n, r) {
              return {
                  u_matrix: e,
                  u_tl_parent: t,
                  u_scale_parent: i,
                  u_buffer_scale: 1,
                  u_fade_t: n.mix,
                  u_opacity: n.opacity * r.paint.get("raster-opacity"),
                  u_image0: 0,
                  u_image1: 1,
                  u_brightness_low: r.paint.get("raster-brightness-min"),
                  u_brightness_high: r.paint.get("raster-brightness-max"),
                  u_saturation_factor: (s = r.paint.get("raster-saturation"),
                  s > 0 ? 1 - 1 / (1.001 - s) : -s),
                  u_contrast_factor: (o = r.paint.get("raster-contrast"),
                  o > 0 ? 1 / (1 - o) : 1 + o),
                  u_spin_weights: zi(r.paint.get("raster-hue-rotate"))
              };
              var o, s
          };
          function zi(e) {
              e *= Math.PI / 180;
              var t = Math.sin(e)
                , i = Math.cos(e);
              return [(2 * i + 1) / 3, (-Math.sqrt(3) * t - i + 1) / 3, (Math.sqrt(3) * t - i + 1) / 3]
          }
          var Di = function(e, t, i, n, r, o, s, a, l, c) {
              var u = r.transform;
              return {
                  u_is_size_zoom_constant: +("constant" === e || "source" === e),
                  u_is_size_feature_constant: +("constant" === e || "camera" === e),
                  u_size_t: t ? t.uSizeT : 0,
                  u_size: t ? t.uSize : 0,
                  u_camera_to_center_distance: u.cameraToCenterDistance,
                  u_pitch: u.pitch / 360 * 2 * Math.PI,
                  u_rotate_symbol: +i,
                  u_aspect_ratio: u.width / u.height,
                  u_fade_change: r.options.fadeDuration ? r.symbolFadeChange : 1,
                  u_matrix: o,
                  u_label_plane_matrix: s,
                  u_gl_coord_matrix: a,
                  u_is_text: +l,
                  u_pitch_with_map: +n,
                  u_texsize: c,
                  u_texture: 0
              }
          }
            , Ri = function(t, i, n, r, o, s, a, l, c, u, h) {
              var d = o.transform;
              return e.extend(Di(t, i, n, r, o, s, a, l, c, u), {
                  u_gamma_scale: r ? Math.cos(d._pitch) * d.cameraToCenterDistance : 1,
                  u_is_halo: +h
              })
          }
            , Bi = function(e, t, i) {
              return {
                  u_matrix: e,
                  u_opacity: t,
                  u_color: i
              }
          }
            , ji = function(t, i, n, r, o, s) {
              return e.extend(function(e, t, i, n) {
                  var r = i.imageManager.getPattern(e.from)
                    , o = i.imageManager.getPattern(e.to)
                    , s = i.imageManager.getPixelSize()
                    , a = s.width
                    , l = s.height
                    , c = Math.pow(2, n.tileID.overscaledZ)
                    , u = n.tileSize * Math.pow(2, i.transform.tileZoom) / c
                    , h = u * (n.tileID.canonical.x + n.tileID.wrap * c)
                    , d = u * n.tileID.canonical.y;
                  return {
                      u_image: 0,
                      u_pattern_tl_a: r.tl,
                      u_pattern_br_a: r.br,
                      u_pattern_tl_b: o.tl,
                      u_pattern_br_b: o.br,
                      u_texsize: [a, l],
                      u_mix: t.t,
                      u_pattern_size_a: r.displaySize,
                      u_pattern_size_b: o.displaySize,
                      u_scale_a: t.fromScale,
                      u_scale_b: t.toScale,
                      u_tile_units_to_pixels: 1 / st(n, 1, i.transform.tileZoom),
                      u_pixel_coord_upper: [h >> 16, d >> 16],
                      u_pixel_coord_lower: [65535 & h, 65535 & d]
                  }
              }(r, s, n, o), {
                  u_matrix: t,
                  u_opacity: i
              })
          }
            , Fi = {
              fillExtrusion: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_lightpos: new e.Uniform3f(t,i.u_lightpos),
                      u_lightintensity: new e.Uniform1f(t,i.u_lightintensity),
                      u_lightcolor: new e.Uniform3f(t,i.u_lightcolor),
                      u_vertical_gradient: new e.Uniform1f(t,i.u_vertical_gradient)
                  }
              },
              fillExtrusionPattern: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_lightpos: new e.Uniform3f(t,i.u_lightpos),
                      u_lightintensity: new e.Uniform1f(t,i.u_lightintensity),
                      u_lightcolor: new e.Uniform3f(t,i.u_lightcolor),
                      u_vertical_gradient: new e.Uniform1f(t,i.u_vertical_gradient),
                      u_height_factor: new e.Uniform1f(t,i.u_height_factor),
                      u_image: new e.Uniform1i(t,i.u_image),
                      u_texsize: new e.Uniform2f(t,i.u_texsize),
                      u_pixel_coord_upper: new e.Uniform2f(t,i.u_pixel_coord_upper),
                      u_pixel_coord_lower: new e.Uniform2f(t,i.u_pixel_coord_lower),
                      u_scale: new e.Uniform4f(t,i.u_scale),
                      u_fade: new e.Uniform1f(t,i.u_fade)
                  }
              },
              extrusionTexture: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_world: new e.Uniform2f(t,i.u_world),
                      u_image: new e.Uniform1i(t,i.u_image),
                      u_opacity: new e.Uniform1f(t,i.u_opacity)
                  }
              },
              fill: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix)
                  }
              },
              fillPattern: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_image: new e.Uniform1i(t,i.u_image),
                      u_texsize: new e.Uniform2f(t,i.u_texsize),
                      u_pixel_coord_upper: new e.Uniform2f(t,i.u_pixel_coord_upper),
                      u_pixel_coord_lower: new e.Uniform2f(t,i.u_pixel_coord_lower),
                      u_scale: new e.Uniform4f(t,i.u_scale),
                      u_fade: new e.Uniform1f(t,i.u_fade)
                  }
              },
              fillOutline: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_world: new e.Uniform2f(t,i.u_world)
                  }
              },
              fillOutlinePattern: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_world: new e.Uniform2f(t,i.u_world),
                      u_image: new e.Uniform1i(t,i.u_image),
                      u_texsize: new e.Uniform2f(t,i.u_texsize),
                      u_pixel_coord_upper: new e.Uniform2f(t,i.u_pixel_coord_upper),
                      u_pixel_coord_lower: new e.Uniform2f(t,i.u_pixel_coord_lower),
                      u_scale: new e.Uniform4f(t,i.u_scale),
                      u_fade: new e.Uniform1f(t,i.u_fade)
                  }
              },
              circle: function(t, i) {
                  return {
                      u_camera_to_center_distance: new e.Uniform1f(t,i.u_camera_to_center_distance),
                      u_scale_with_map: new e.Uniform1i(t,i.u_scale_with_map),
                      u_pitch_with_map: new e.Uniform1i(t,i.u_pitch_with_map),
                      u_extrude_scale: new e.Uniform2f(t,i.u_extrude_scale),
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix)
                  }
              },
              collisionBox: _i,
              collisionCircle: _i,
              debug: function(t, i) {
                  return {
                      u_color: new e.UniformColor(t,i.u_color),
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix)
                  }
              },
              clippingMask: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix)
                  }
              },
              heatmap: function(t, i) {
                  return {
                      u_extrude_scale: new e.Uniform1f(t,i.u_extrude_scale),
                      u_intensity: new e.Uniform1f(t,i.u_intensity),
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix)
                  }
              },
              heatmapTexture: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_world: new e.Uniform2f(t,i.u_world),
                      u_image: new e.Uniform1i(t,i.u_image),
                      u_color_ramp: new e.Uniform1i(t,i.u_color_ramp),
                      u_opacity: new e.Uniform1f(t,i.u_opacity)
                  }
              },
              hillshade: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_image: new e.Uniform1i(t,i.u_image),
                      u_latrange: new e.Uniform2f(t,i.u_latrange),
                      u_light: new e.Uniform2f(t,i.u_light),
                      u_shadow: new e.UniformColor(t,i.u_shadow),
                      u_highlight: new e.UniformColor(t,i.u_highlight),
                      u_accent: new e.UniformColor(t,i.u_accent)
                  }
              },
              hillshadePrepare: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_image: new e.Uniform1i(t,i.u_image),
                      u_dimension: new e.Uniform2f(t,i.u_dimension),
                      u_zoom: new e.Uniform1f(t,i.u_zoom),
                      u_maxzoom: new e.Uniform1f(t,i.u_maxzoom)
                  }
              },
              line: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_ratio: new e.Uniform1f(t,i.u_ratio),
                      u_gl_units_to_pixels: new e.Uniform2f(t,i.u_gl_units_to_pixels)
                  }
              },
              lineGradient: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_ratio: new e.Uniform1f(t,i.u_ratio),
                      u_gl_units_to_pixels: new e.Uniform2f(t,i.u_gl_units_to_pixels),
                      u_image: new e.Uniform1i(t,i.u_image)
                  }
              },
              linePattern: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_texsize: new e.Uniform2f(t,i.u_texsize),
                      u_ratio: new e.Uniform1f(t,i.u_ratio),
                      u_image: new e.Uniform1i(t,i.u_image),
                      u_gl_units_to_pixels: new e.Uniform2f(t,i.u_gl_units_to_pixels),
                      u_scale: new e.Uniform4f(t,i.u_scale),
                      u_fade: new e.Uniform1f(t,i.u_fade)
                  }
              },
              lineSDF: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_ratio: new e.Uniform1f(t,i.u_ratio),
                      u_gl_units_to_pixels: new e.Uniform2f(t,i.u_gl_units_to_pixels),
                      u_patternscale_a: new e.Uniform2f(t,i.u_patternscale_a),
                      u_patternscale_b: new e.Uniform2f(t,i.u_patternscale_b),
                      u_sdfgamma: new e.Uniform1f(t,i.u_sdfgamma),
                      u_image: new e.Uniform1i(t,i.u_image),
                      u_tex_y_a: new e.Uniform1f(t,i.u_tex_y_a),
                      u_tex_y_b: new e.Uniform1f(t,i.u_tex_y_b),
                      u_mix: new e.Uniform1f(t,i.u_mix)
                  }
              },
              raster: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_tl_parent: new e.Uniform2f(t,i.u_tl_parent),
                      u_scale_parent: new e.Uniform1f(t,i.u_scale_parent),
                      u_buffer_scale: new e.Uniform1f(t,i.u_buffer_scale),
                      u_fade_t: new e.Uniform1f(t,i.u_fade_t),
                      u_opacity: new e.Uniform1f(t,i.u_opacity),
                      u_image0: new e.Uniform1i(t,i.u_image0),
                      u_image1: new e.Uniform1i(t,i.u_image1),
                      u_brightness_low: new e.Uniform1f(t,i.u_brightness_low),
                      u_brightness_high: new e.Uniform1f(t,i.u_brightness_high),
                      u_saturation_factor: new e.Uniform1f(t,i.u_saturation_factor),
                      u_contrast_factor: new e.Uniform1f(t,i.u_contrast_factor),
                      u_spin_weights: new e.Uniform3f(t,i.u_spin_weights)
                  }
              },
              symbolIcon: function(t, i) {
                  return {
                      u_is_size_zoom_constant: new e.Uniform1i(t,i.u_is_size_zoom_constant),
                      u_is_size_feature_constant: new e.Uniform1i(t,i.u_is_size_feature_constant),
                      u_size_t: new e.Uniform1f(t,i.u_size_t),
                      u_size: new e.Uniform1f(t,i.u_size),
                      u_camera_to_center_distance: new e.Uniform1f(t,i.u_camera_to_center_distance),
                      u_pitch: new e.Uniform1f(t,i.u_pitch),
                      u_rotate_symbol: new e.Uniform1i(t,i.u_rotate_symbol),
                      u_aspect_ratio: new e.Uniform1f(t,i.u_aspect_ratio),
                      u_fade_change: new e.Uniform1f(t,i.u_fade_change),
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_label_plane_matrix: new e.UniformMatrix4f(t,i.u_label_plane_matrix),
                      u_gl_coord_matrix: new e.UniformMatrix4f(t,i.u_gl_coord_matrix),
                      u_is_text: new e.Uniform1f(t,i.u_is_text),
                      u_pitch_with_map: new e.Uniform1i(t,i.u_pitch_with_map),
                      u_texsize: new e.Uniform2f(t,i.u_texsize),
                      u_texture: new e.Uniform1i(t,i.u_texture)
                  }
              },
              symbolSDF: function(t, i) {
                  return {
                      u_is_size_zoom_constant: new e.Uniform1i(t,i.u_is_size_zoom_constant),
                      u_is_size_feature_constant: new e.Uniform1i(t,i.u_is_size_feature_constant),
                      u_size_t: new e.Uniform1f(t,i.u_size_t),
                      u_size: new e.Uniform1f(t,i.u_size),
                      u_camera_to_center_distance: new e.Uniform1f(t,i.u_camera_to_center_distance),
                      u_pitch: new e.Uniform1f(t,i.u_pitch),
                      u_rotate_symbol: new e.Uniform1i(t,i.u_rotate_symbol),
                      u_aspect_ratio: new e.Uniform1f(t,i.u_aspect_ratio),
                      u_fade_change: new e.Uniform1f(t,i.u_fade_change),
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_label_plane_matrix: new e.UniformMatrix4f(t,i.u_label_plane_matrix),
                      u_gl_coord_matrix: new e.UniformMatrix4f(t,i.u_gl_coord_matrix),
                      u_is_text: new e.Uniform1f(t,i.u_is_text),
                      u_pitch_with_map: new e.Uniform1i(t,i.u_pitch_with_map),
                      u_texsize: new e.Uniform2f(t,i.u_texsize),
                      u_texture: new e.Uniform1i(t,i.u_texture),
                      u_gamma_scale: new e.Uniform1f(t,i.u_gamma_scale),
                      u_is_halo: new e.Uniform1f(t,i.u_is_halo)
                  }
              },
              background: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_opacity: new e.Uniform1f(t,i.u_opacity),
                      u_color: new e.UniformColor(t,i.u_color)
                  }
              },
              backgroundPattern: function(t, i) {
                  return {
                      u_matrix: new e.UniformMatrix4f(t,i.u_matrix),
                      u_opacity: new e.Uniform1f(t,i.u_opacity),
                      u_image: new e.Uniform1i(t,i.u_image),
                      u_pattern_tl_a: new e.Uniform2f(t,i.u_pattern_tl_a),
                      u_pattern_br_a: new e.Uniform2f(t,i.u_pattern_br_a),
                      u_pattern_tl_b: new e.Uniform2f(t,i.u_pattern_tl_b),
                      u_pattern_br_b: new e.Uniform2f(t,i.u_pattern_br_b),
                      u_texsize: new e.Uniform2f(t,i.u_texsize),
                      u_mix: new e.Uniform1f(t,i.u_mix),
                      u_pattern_size_a: new e.Uniform2f(t,i.u_pattern_size_a),
                      u_pattern_size_b: new e.Uniform2f(t,i.u_pattern_size_b),
                      u_scale_a: new e.Uniform1f(t,i.u_scale_a),
                      u_scale_b: new e.Uniform1f(t,i.u_scale_b),
                      u_pixel_coord_upper: new e.Uniform2f(t,i.u_pixel_coord_upper),
                      u_pixel_coord_lower: new e.Uniform2f(t,i.u_pixel_coord_lower),
                      u_tile_units_to_pixels: new e.Uniform1f(t,i.u_tile_units_to_pixels)
                  }
              }
          };
          function Ni(t, i) {
              for (var n = t.sort(function(e, t) {
                  return e.tileID.isLessThan(t.tileID) ? -1 : t.tileID.isLessThan(e.tileID) ? 1 : 0
              }), r = 0; r < n.length; r++) {
                  var o = {}
                    , s = n[r]
                    , a = n.slice(r + 1);
                  Ui(s.tileID.wrapped(), s.tileID, a, new e.OverscaledTileID(0,s.tileID.wrap + 1,0,0,0), o),
                  s.setMask(o, i)
              }
          }
          function Ui(t, i, n, r, o) {
              for (var s = 0; s < n.length; s++) {
                  var a = n[s];
                  if (r.isLessThan(a.tileID))
                      break;
                  if (i.key === a.tileID.key)
                      return;
                  if (a.tileID.isChildOf(i)) {
                      for (var l = i.children(1 / 0), c = 0; c < l.length; c++)
                          Ui(t, l[c], n.slice(s), r, o);
                      return
                  }
              }
              var u = i.overscaledZ - t.overscaledZ
                , h = new e.CanonicalTileID(u,i.canonical.x - (t.canonical.x << u),i.canonical.y - (t.canonical.y << u));
              o[h.key] = o[h.key] || h
          }
          function qi(e, t, i, n, r) {
              for (var o = e.context, s = o.gl, a = r ? e.useProgram("collisionCircle") : e.useProgram("collisionBox"), l = 0; l < n.length; l++) {
                  var c = n[l]
                    , u = t.getTile(c)
                    , h = u.getBucket(i);
                  if (h) {
                      var d = r ? h.collisionCircle : h.collisionBox;
                      d && a.draw(o, r ? s.TRIANGLES : s.LINES, we.disabled, xe.disabled, e.colorModeForRenderPass(), Se.disabled, bi(c.posMatrix, e.transform, u), i.id, d.layoutVertexBuffer, d.indexBuffer, d.segments, null, e.transform.zoom, null, null, d.collisionVertexBuffer)
                  }
              }
          }
          var Hi = e.identity(new Float32Array(16))
            , Vi = e.properties.layout;
          function Wi(t, i, n, r, o, s, a, l, c, u, h, d) {
              for (var p, f, m = t.context, g = m.gl, v = t.transform, y = "map" === l, _ = "map" === c, b = y && "point" !== n.layout.get("symbol-placement"), w = y && !_ && !b, x = void 0 !== n.layout.get("symbol-sort-key").constantOr(1), k = t.depthModeForSublayer(0, we.ReadOnly), S = [], E = 0, T = r; E < T.length; E += 1) {
                  var C = T[E]
                    , L = i.getTile(C)
                    , A = L.getBucket(n);
                  if (A) {
                      var P = o ? A.text : A.icon;
                      if (P && P.segments.get().length) {
                          var I = P.programConfigurations.get(n.id)
                            , M = o || A.sdfIcons
                            , O = o ? A.textSizeData : A.iconSizeData;
                          p || (p = t.useProgram(M ? "symbolSDF" : "symbolIcon", I),
                          f = e.evaluateSizeForZoom(O, v.zoom, Vi.properties[o ? "text-size" : "icon-size"])),
                          m.activeTexture.set(g.TEXTURE0);
                          var z = void 0
                            , D = void 0
                            , R = void 0;
                          if (o)
                              D = L.glyphAtlasTexture,
                              R = g.LINEAR,
                              z = L.glyphAtlasTexture.size;
                          else {
                              var B = 1 !== n.layout.get("icon-size").constantOr(0) || A.iconsNeedLinear
                                , j = _ || 0 !== v.pitch;
                              D = L.imageAtlasTexture,
                              R = M || t.options.rotating || t.options.zooming || B || j ? g.LINEAR : g.NEAREST,
                              z = L.imageAtlasTexture.size
                          }
                          var F = st(L, 1, t.transform.zoom)
                            , N = We(C.posMatrix, _, y, t.transform, F)
                            , U = $e(C.posMatrix, _, y, t.transform, F);
                          b && Ze(A, C.posMatrix, t, o, N, U, _, u);
                          var q = t.translatePosMatrix(C.posMatrix, L, s, a)
                            , H = b ? Hi : N
                            , V = t.translatePosMatrix(U, L, s, a, !0)
                            , W = M && 0 !== n.paint.get(o ? "text-halo-width" : "icon-halo-width").constantOr(1)
                            , $ = {
                              program: p,
                              buffers: P,
                              uniformValues: M ? Ri(O.functionType, f, w, _, t, q, H, V, o, z, !0) : Di(O.functionType, f, w, _, t, q, H, V, o, z),
                              atlasTexture: D,
                              atlasInterpolation: R,
                              isSDF: M,
                              hasHalo: W
                          };
                          if (x)
                              for (var G = 0, X = P.segments.get(); G < X.length; G += 1) {
                                  var Z = X[G];
                                  S.push({
                                      segments: new e.SegmentVector([Z]),
                                      sortKey: Z.sortKey,
                                      state: $
                                  })
                              }
                          else
                              S.push({
                                  segments: P.segments,
                                  sortKey: 0,
                                  state: $
                              })
                      }
                  }
              }
              x && S.sort(function(e, t) {
                  return e.sortKey - t.sortKey
              });
              for (var Y = 0, K = S; Y < K.length; Y += 1) {
                  var J = K[Y]
                    , Q = J.state;
                  if (Q.atlasTexture.bind(Q.atlasInterpolation, g.CLAMP_TO_EDGE),
                  Q.isSDF) {
                      var ee = Q.uniformValues;
                      Q.hasHalo && (ee.u_is_halo = 1,
                      $i(Q.buffers, J.segments, n, t, Q.program, k, h, d, ee)),
                      ee.u_is_halo = 0
                  }
                  $i(Q.buffers, J.segments, n, t, Q.program, k, h, d, Q.uniformValues)
              }
          }
          function $i(e, t, i, n, r, o, s, a, l) {
              var c = n.context
                , u = c.gl;
              r.draw(c, u.TRIANGLES, o, s, a, Se.disabled, l, i.id, e.layoutVertexBuffer, e.indexBuffer, t, i.paint, n.transform.zoom, e.programConfigurations.get(i.id), e.dynamicLayoutVertexBuffer, e.opacityVertexBuffer)
          }
          function Gi(e, t, i, n, r, o, s) {
              var a, l, c, u, h, d = e.context.gl, p = i.paint.get("fill-pattern"), f = p && p.constantOr(1), m = i.getCrossfadeParameters();
              s ? (l = f && !i.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline",
              a = d.LINES) : (l = f ? "fillPattern" : "fill",
              a = d.TRIANGLES);
              for (var g = 0, v = n; g < v.length; g += 1) {
                  var y = v[g]
                    , _ = t.getTile(y);
                  if (!f || _.patternsLoaded()) {
                      var b = _.getBucket(i);
                      if (b) {
                          var w = b.programConfigurations.get(i.id)
                            , x = e.useProgram(l, w);
                          f && (e.context.activeTexture.set(d.TEXTURE0),
                          _.imageAtlasTexture.bind(d.LINEAR, d.CLAMP_TO_EDGE),
                          w.updatePatternPaintBuffers(m));
                          var k = p.constantOr(null);
                          if (k && _.imageAtlas) {
                              var S = _.imageAtlas.patternPositions[k.to]
                                , E = _.imageAtlas.patternPositions[k.from];
                              S && E && w.setConstantPatternPositions(S, E)
                          }
                          var T = e.translatePosMatrix(y.posMatrix, _, i.paint.get("fill-translate"), i.paint.get("fill-translate-anchor"));
                          if (s) {
                              u = b.indexBuffer2,
                              h = b.segments2;
                              var C = [d.drawingBufferWidth, d.drawingBufferHeight];
                              c = "fillOutlinePattern" === l && f ? vi(T, e, m, _, C) : gi(T, C)
                          } else
                              u = b.indexBuffer,
                              h = b.segments,
                              c = f ? mi(T, e, m, _) : fi(T);
                          x.draw(e.context, a, r, e.stencilModeForClipping(y), o, Se.disabled, c, i.id, b.layoutVertexBuffer, u, h, i.paint, e.transform.zoom, w)
                      }
                  }
              }
          }
          function Xi(t, i) {
              var n = t.context
                , r = n.gl
                , o = i.viewportFrame;
              if (t.depthRboNeedsClear && t.setupOffscreenDepthRenderbuffer(),
              !o) {
                  var s = new e.Texture(n,{
                      width: t.width,
                      height: t.height,
                      data: null
                  },r.RGBA);
                  s.bind(r.LINEAR, r.CLAMP_TO_EDGE),
                  (o = i.viewportFrame = n.createFramebuffer(t.width, t.height)).colorAttachment.set(s.texture)
              }
              n.bindFramebuffer.set(o.framebuffer),
              o.depthAttachment.set(t.depthRbo),
              t.depthRboNeedsClear && (n.clear({
                  depth: 1
              }),
              t.depthRboNeedsClear = !1),
              n.clear({
                  color: e.Color.transparent
              }),
              n.setStencilMode(xe.disabled),
              n.setDepthMode(new we(r.LEQUAL,we.ReadWrite,[0, 1])),
              n.setColorMode(t.colorModeForRenderPass())
          }
          function Zi(e, t, i) {
              var n = t.viewportFrame;
              if (n) {
                  var r = e.context
                    , o = r.gl;
                  r.activeTexture.set(o.TEXTURE0),
                  o.bindTexture(o.TEXTURE_2D, n.colorAttachment.get()),
                  e.useProgram("extrusionTexture").draw(r, o.TRIANGLES, we.disabled, xe.disabled, e.colorModeForRenderPass(), Se.disabled, pi(e, i, 0), t.id, e.viewportBuffer, e.quadTriangleIndexBuffer, e.viewportSegments, t.paint, e.transform.zoom)
              }
          }
          function Yi(e, t, i, n, r, o) {
              var s = e.context
                , a = s.gl
                , l = t.fbo;
              if (l) {
                  var c = e.useProgram("hillshade");
                  s.activeTexture.set(a.TEXTURE0),
                  a.bindTexture(a.TEXTURE_2D, l.colorAttachment.get());
                  var u = Si(e, t, i);
                  t.maskedBoundsBuffer && t.maskedIndexBuffer && t.segments ? c.draw(s, a.TRIANGLES, n, r, o, Se.disabled, u, i.id, t.maskedBoundsBuffer, t.maskedIndexBuffer, t.segments) : c.draw(s, a.TRIANGLES, n, r, o, Se.disabled, u, i.id, e.rasterBoundsBuffer, e.quadTriangleIndexBuffer, e.rasterBoundsSegments)
              }
          }
          function Ki(t, i, n, r, o, s, a) {
              var l = t.context
                , c = l.gl;
              if (i.dem && i.dem.data) {
                  var u = i.dem.dim
                    , h = i.dem.stride
                    , d = i.dem.getPixels();
                  if (l.activeTexture.set(c.TEXTURE1),
                  l.pixelStoreUnpackPremultiplyAlpha.set(!1),
                  i.demTexture = i.demTexture || t.getTileTexture(h),
                  i.demTexture) {
                      var p = i.demTexture;
                      p.update(d, {
                          premultiply: !1
                      }),
                      p.bind(c.NEAREST, c.CLAMP_TO_EDGE)
                  } else
                      i.demTexture = new e.Texture(l,d,c.RGBA,{
                          premultiply: !1
                      }),
                      i.demTexture.bind(c.NEAREST, c.CLAMP_TO_EDGE);
                  l.activeTexture.set(c.TEXTURE0);
                  var f = i.fbo;
                  if (!f) {
                      var m = new e.Texture(l,{
                          width: u,
                          height: u,
                          data: null
                      },c.RGBA);
                      m.bind(c.LINEAR, c.CLAMP_TO_EDGE),
                      (f = i.fbo = l.createFramebuffer(u, u)).colorAttachment.set(m.texture)
                  }
                  l.bindFramebuffer.set(f.framebuffer),
                  l.viewport.set([0, 0, u, u]),
                  t.useProgram("hillshadePrepare").draw(l, c.TRIANGLES, o, s, a, Se.disabled, Ei(i, r), n.id, t.rasterBoundsBuffer, t.quadTriangleIndexBuffer, t.rasterBoundsSegments),
                  i.needsHillshadePrepare = !1
              }
          }
          function Ji(t, i, n, r, o) {
              var s = r.paint.get("raster-fade-duration");
              if (s > 0) {
                  var a = e.browser.now()
                    , l = (a - t.timeAdded) / s
                    , c = i ? (a - i.timeAdded) / s : -1
                    , u = n.getSource()
                    , h = o.coveringZoomLevel({
                      tileSize: u.tileSize,
                      roundZoom: u.roundZoom
                  })
                    , d = !i || Math.abs(i.tileID.overscaledZ - h) > Math.abs(t.tileID.overscaledZ - h)
                    , p = d && t.refreshedUponExpiration ? 1 : e.clamp(d ? l : 1 - c, 0, 1);
                  return t.refreshedUponExpiration && l >= 1 && (t.refreshedUponExpiration = !1),
                  i ? {
                      opacity: 1,
                      mix: 1 - p
                  } : {
                      opacity: p,
                      mix: 0
                  }
              }
              return {
                  opacity: 1,
                  mix: 0
              }
          }
          function Qi(t, i, n) {
              var r = t.context
                , o = r.gl
                , s = n.posMatrix
                , a = t.useProgram("debug")
                , l = we.disabled
                , c = xe.disabled
                , u = t.colorModeForRenderPass()
                , h = "$debug";
              a.draw(r, o.LINE_STRIP, l, c, u, Se.disabled, wi(s, e.Color.red), h, t.debugBuffer, t.tileBorderIndexBuffer, t.debugSegments);
              for (var d = function(e, t, i, n) {
                  n = n || 1;
                  var r, o, s, a, l, c, u, h, d = [];
                  for (r = 0,
                  o = e.length; r < o; r++)
                      if (l = en[e[r]]) {
                          for (h = null,
                          s = 0,
                          a = l[1].length; s < a; s += 2)
                              -1 === l[1][s] && -1 === l[1][s + 1] ? h = null : (c = t + l[1][s] * n,
                              u = 200 - l[1][s + 1] * n,
                              h && d.push(h.x, h.y, c, u),
                              h = {
                                  x: c,
                                  y: u
                              });
                          t += l[0] * n
                      }
                  return d
              }(n.toString(), 50, 0, 5), p = new e.StructArrayLayout2i4, f = new e.StructArrayLayout2ui4, m = 0; m < d.length; m += 2)
                  p.emplaceBack(d[m], d[m + 1]),
                  f.emplaceBack(m, m + 1);
              for (var g = r.createVertexBuffer(p, Ot.members), v = r.createIndexBuffer(f), y = e.SegmentVector.simpleSegment(0, 0, p.length / 2, p.length / 2), _ = i.getTile(n).tileSize, b = e.EXTENT / (Math.pow(2, t.transform.zoom - n.overscaledZ) * _), w = [[-1, -1], [-1, 1], [1, -1], [1, 1]], x = 0; x < w.length; x++) {
                  var k = w[x];
                  a.draw(r, o.LINES, l, c, u, Se.disabled, wi(e.translate([], s, [b * k[0], b * k[1], 0]), e.Color.white), h, g, v, y)
              }
              a.draw(r, o.LINES, l, c, u, Se.disabled, wi(s, e.Color.black), h, g, v, y)
          }
          var en = {
              " ": [16, []],
              "!": [10, [5, 21, 5, 7, -1, -1, 5, 2, 4, 1, 5, 0, 6, 1, 5, 2]],
              '"': [16, [4, 21, 4, 14, -1, -1, 12, 21, 12, 14]],
              "#": [21, [11, 25, 4, -7, -1, -1, 17, 25, 10, -7, -1, -1, 4, 12, 18, 12, -1, -1, 3, 6, 17, 6]],
              $: [20, [8, 25, 8, -4, -1, -1, 12, 25, 12, -4, -1, -1, 17, 18, 15, 20, 12, 21, 8, 21, 5, 20, 3, 18, 3, 16, 4, 14, 5, 13, 7, 12, 13, 10, 15, 9, 16, 8, 17, 6, 17, 3, 15, 1, 12, 0, 8, 0, 5, 1, 3, 3]],
              "%": [24, [21, 21, 3, 0, -1, -1, 8, 21, 10, 19, 10, 17, 9, 15, 7, 14, 5, 14, 3, 16, 3, 18, 4, 20, 6, 21, 8, 21, 10, 20, 13, 19, 16, 19, 19, 20, 21, 21, -1, -1, 17, 7, 15, 6, 14, 4, 14, 2, 16, 0, 18, 0, 20, 1, 21, 3, 21, 5, 19, 7, 17, 7]],
              "&": [26, [23, 12, 23, 13, 22, 14, 21, 14, 20, 13, 19, 11, 17, 6, 15, 3, 13, 1, 11, 0, 7, 0, 5, 1, 4, 2, 3, 4, 3, 6, 4, 8, 5, 9, 12, 13, 13, 14, 14, 16, 14, 18, 13, 20, 11, 21, 9, 20, 8, 18, 8, 16, 9, 13, 11, 10, 16, 3, 18, 1, 20, 0, 22, 0, 23, 1, 23, 2]],
              "'": [10, [5, 19, 4, 20, 5, 21, 6, 20, 6, 18, 5, 16, 4, 15]],
              "(": [14, [11, 25, 9, 23, 7, 20, 5, 16, 4, 11, 4, 7, 5, 2, 7, -2, 9, -5, 11, -7]],
              ")": [14, [3, 25, 5, 23, 7, 20, 9, 16, 10, 11, 10, 7, 9, 2, 7, -2, 5, -5, 3, -7]],
              "*": [16, [8, 21, 8, 9, -1, -1, 3, 18, 13, 12, -1, -1, 13, 18, 3, 12]],
              "+": [26, [13, 18, 13, 0, -1, -1, 4, 9, 22, 9]],
              ",": [10, [6, 1, 5, 0, 4, 1, 5, 2, 6, 1, 6, -1, 5, -3, 4, -4]],
              "-": [26, [4, 9, 22, 9]],
              ".": [10, [5, 2, 4, 1, 5, 0, 6, 1, 5, 2]],
              "/": [22, [20, 25, 2, -7]],
              0: [20, [9, 21, 6, 20, 4, 17, 3, 12, 3, 9, 4, 4, 6, 1, 9, 0, 11, 0, 14, 1, 16, 4, 17, 9, 17, 12, 16, 17, 14, 20, 11, 21, 9, 21]],
              1: [20, [6, 17, 8, 18, 11, 21, 11, 0]],
              2: [20, [4, 16, 4, 17, 5, 19, 6, 20, 8, 21, 12, 21, 14, 20, 15, 19, 16, 17, 16, 15, 15, 13, 13, 10, 3, 0, 17, 0]],
              3: [20, [5, 21, 16, 21, 10, 13, 13, 13, 15, 12, 16, 11, 17, 8, 17, 6, 16, 3, 14, 1, 11, 0, 8, 0, 5, 1, 4, 2, 3, 4]],
              4: [20, [13, 21, 3, 7, 18, 7, -1, -1, 13, 21, 13, 0]],
              5: [20, [15, 21, 5, 21, 4, 12, 5, 13, 8, 14, 11, 14, 14, 13, 16, 11, 17, 8, 17, 6, 16, 3, 14, 1, 11, 0, 8, 0, 5, 1, 4, 2, 3, 4]],
              6: [20, [16, 18, 15, 20, 12, 21, 10, 21, 7, 20, 5, 17, 4, 12, 4, 7, 5, 3, 7, 1, 10, 0, 11, 0, 14, 1, 16, 3, 17, 6, 17, 7, 16, 10, 14, 12, 11, 13, 10, 13, 7, 12, 5, 10, 4, 7]],
              7: [20, [17, 21, 7, 0, -1, -1, 3, 21, 17, 21]],
              8: [20, [8, 21, 5, 20, 4, 18, 4, 16, 5, 14, 7, 13, 11, 12, 14, 11, 16, 9, 17, 7, 17, 4, 16, 2, 15, 1, 12, 0, 8, 0, 5, 1, 4, 2, 3, 4, 3, 7, 4, 9, 6, 11, 9, 12, 13, 13, 15, 14, 16, 16, 16, 18, 15, 20, 12, 21, 8, 21]],
              9: [20, [16, 14, 15, 11, 13, 9, 10, 8, 9, 8, 6, 9, 4, 11, 3, 14, 3, 15, 4, 18, 6, 20, 9, 21, 10, 21, 13, 20, 15, 18, 16, 14, 16, 9, 15, 4, 13, 1, 10, 0, 8, 0, 5, 1, 4, 3]],
              ":": [10, [5, 14, 4, 13, 5, 12, 6, 13, 5, 14, -1, -1, 5, 2, 4, 1, 5, 0, 6, 1, 5, 2]],
              ";": [10, [5, 14, 4, 13, 5, 12, 6, 13, 5, 14, -1, -1, 6, 1, 5, 0, 4, 1, 5, 2, 6, 1, 6, -1, 5, -3, 4, -4]],
              "<": [24, [20, 18, 4, 9, 20, 0]],
              "=": [26, [4, 12, 22, 12, -1, -1, 4, 6, 22, 6]],
              ">": [24, [4, 18, 20, 9, 4, 0]],
              "?": [18, [3, 16, 3, 17, 4, 19, 5, 20, 7, 21, 11, 21, 13, 20, 14, 19, 15, 17, 15, 15, 14, 13, 13, 12, 9, 10, 9, 7, -1, -1, 9, 2, 8, 1, 9, 0, 10, 1, 9, 2]],
              "@": [27, [18, 13, 17, 15, 15, 16, 12, 16, 10, 15, 9, 14, 8, 11, 8, 8, 9, 6, 11, 5, 14, 5, 16, 6, 17, 8, -1, -1, 12, 16, 10, 14, 9, 11, 9, 8, 10, 6, 11, 5, -1, -1, 18, 16, 17, 8, 17, 6, 19, 5, 21, 5, 23, 7, 24, 10, 24, 12, 23, 15, 22, 17, 20, 19, 18, 20, 15, 21, 12, 21, 9, 20, 7, 19, 5, 17, 4, 15, 3, 12, 3, 9, 4, 6, 5, 4, 7, 2, 9, 1, 12, 0, 15, 0, 18, 1, 20, 2, 21, 3, -1, -1, 19, 16, 18, 8, 18, 6, 19, 5]],
              A: [18, [9, 21, 1, 0, -1, -1, 9, 21, 17, 0, -1, -1, 4, 7, 14, 7]],
              B: [21, [4, 21, 4, 0, -1, -1, 4, 21, 13, 21, 16, 20, 17, 19, 18, 17, 18, 15, 17, 13, 16, 12, 13, 11, -1, -1, 4, 11, 13, 11, 16, 10, 17, 9, 18, 7, 18, 4, 17, 2, 16, 1, 13, 0, 4, 0]],
              C: [21, [18, 16, 17, 18, 15, 20, 13, 21, 9, 21, 7, 20, 5, 18, 4, 16, 3, 13, 3, 8, 4, 5, 5, 3, 7, 1, 9, 0, 13, 0, 15, 1, 17, 3, 18, 5]],
              D: [21, [4, 21, 4, 0, -1, -1, 4, 21, 11, 21, 14, 20, 16, 18, 17, 16, 18, 13, 18, 8, 17, 5, 16, 3, 14, 1, 11, 0, 4, 0]],
              E: [19, [4, 21, 4, 0, -1, -1, 4, 21, 17, 21, -1, -1, 4, 11, 12, 11, -1, -1, 4, 0, 17, 0]],
              F: [18, [4, 21, 4, 0, -1, -1, 4, 21, 17, 21, -1, -1, 4, 11, 12, 11]],
              G: [21, [18, 16, 17, 18, 15, 20, 13, 21, 9, 21, 7, 20, 5, 18, 4, 16, 3, 13, 3, 8, 4, 5, 5, 3, 7, 1, 9, 0, 13, 0, 15, 1, 17, 3, 18, 5, 18, 8, -1, -1, 13, 8, 18, 8]],
              H: [22, [4, 21, 4, 0, -1, -1, 18, 21, 18, 0, -1, -1, 4, 11, 18, 11]],
              I: [8, [4, 21, 4, 0]],
              J: [16, [12, 21, 12, 5, 11, 2, 10, 1, 8, 0, 6, 0, 4, 1, 3, 2, 2, 5, 2, 7]],
              K: [21, [4, 21, 4, 0, -1, -1, 18, 21, 4, 7, -1, -1, 9, 12, 18, 0]],
              L: [17, [4, 21, 4, 0, -1, -1, 4, 0, 16, 0]],
              M: [24, [4, 21, 4, 0, -1, -1, 4, 21, 12, 0, -1, -1, 20, 21, 12, 0, -1, -1, 20, 21, 20, 0]],
              N: [22, [4, 21, 4, 0, -1, -1, 4, 21, 18, 0, -1, -1, 18, 21, 18, 0]],
              O: [22, [9, 21, 7, 20, 5, 18, 4, 16, 3, 13, 3, 8, 4, 5, 5, 3, 7, 1, 9, 0, 13, 0, 15, 1, 17, 3, 18, 5, 19, 8, 19, 13, 18, 16, 17, 18, 15, 20, 13, 21, 9, 21]],
              P: [21, [4, 21, 4, 0, -1, -1, 4, 21, 13, 21, 16, 20, 17, 19, 18, 17, 18, 14, 17, 12, 16, 11, 13, 10, 4, 10]],
              Q: [22, [9, 21, 7, 20, 5, 18, 4, 16, 3, 13, 3, 8, 4, 5, 5, 3, 7, 1, 9, 0, 13, 0, 15, 1, 17, 3, 18, 5, 19, 8, 19, 13, 18, 16, 17, 18, 15, 20, 13, 21, 9, 21, -1, -1, 12, 4, 18, -2]],
              R: [21, [4, 21, 4, 0, -1, -1, 4, 21, 13, 21, 16, 20, 17, 19, 18, 17, 18, 15, 17, 13, 16, 12, 13, 11, 4, 11, -1, -1, 11, 11, 18, 0]],
              S: [20, [17, 18, 15, 20, 12, 21, 8, 21, 5, 20, 3, 18, 3, 16, 4, 14, 5, 13, 7, 12, 13, 10, 15, 9, 16, 8, 17, 6, 17, 3, 15, 1, 12, 0, 8, 0, 5, 1, 3, 3]],
              T: [16, [8, 21, 8, 0, -1, -1, 1, 21, 15, 21]],
              U: [22, [4, 21, 4, 6, 5, 3, 7, 1, 10, 0, 12, 0, 15, 1, 17, 3, 18, 6, 18, 21]],
              V: [18, [1, 21, 9, 0, -1, -1, 17, 21, 9, 0]],
              W: [24, [2, 21, 7, 0, -1, -1, 12, 21, 7, 0, -1, -1, 12, 21, 17, 0, -1, -1, 22, 21, 17, 0]],
              X: [20, [3, 21, 17, 0, -1, -1, 17, 21, 3, 0]],
              Y: [18, [1, 21, 9, 11, 9, 0, -1, -1, 17, 21, 9, 11]],
              Z: [20, [17, 21, 3, 0, -1, -1, 3, 21, 17, 21, -1, -1, 3, 0, 17, 0]],
              "[": [14, [4, 25, 4, -7, -1, -1, 5, 25, 5, -7, -1, -1, 4, 25, 11, 25, -1, -1, 4, -7, 11, -7]],
              "\\": [14, [0, 21, 14, -3]],
              "]": [14, [9, 25, 9, -7, -1, -1, 10, 25, 10, -7, -1, -1, 3, 25, 10, 25, -1, -1, 3, -7, 10, -7]],
              "^": [16, [6, 15, 8, 18, 10, 15, -1, -1, 3, 12, 8, 17, 13, 12, -1, -1, 8, 17, 8, 0]],
              _: [16, [0, -2, 16, -2]],
              "`": [10, [6, 21, 5, 20, 4, 18, 4, 16, 5, 15, 6, 16, 5, 17]],
              a: [19, [15, 14, 15, 0, -1, -1, 15, 11, 13, 13, 11, 14, 8, 14, 6, 13, 4, 11, 3, 8, 3, 6, 4, 3, 6, 1, 8, 0, 11, 0, 13, 1, 15, 3]],
              b: [19, [4, 21, 4, 0, -1, -1, 4, 11, 6, 13, 8, 14, 11, 14, 13, 13, 15, 11, 16, 8, 16, 6, 15, 3, 13, 1, 11, 0, 8, 0, 6, 1, 4, 3]],
              c: [18, [15, 11, 13, 13, 11, 14, 8, 14, 6, 13, 4, 11, 3, 8, 3, 6, 4, 3, 6, 1, 8, 0, 11, 0, 13, 1, 15, 3]],
              d: [19, [15, 21, 15, 0, -1, -1, 15, 11, 13, 13, 11, 14, 8, 14, 6, 13, 4, 11, 3, 8, 3, 6, 4, 3, 6, 1, 8, 0, 11, 0, 13, 1, 15, 3]],
              e: [18, [3, 8, 15, 8, 15, 10, 14, 12, 13, 13, 11, 14, 8, 14, 6, 13, 4, 11, 3, 8, 3, 6, 4, 3, 6, 1, 8, 0, 11, 0, 13, 1, 15, 3]],
              f: [12, [10, 21, 8, 21, 6, 20, 5, 17, 5, 0, -1, -1, 2, 14, 9, 14]],
              g: [19, [15, 14, 15, -2, 14, -5, 13, -6, 11, -7, 8, -7, 6, -6, -1, -1, 15, 11, 13, 13, 11, 14, 8, 14, 6, 13, 4, 11, 3, 8, 3, 6, 4, 3, 6, 1, 8, 0, 11, 0, 13, 1, 15, 3]],
              h: [19, [4, 21, 4, 0, -1, -1, 4, 10, 7, 13, 9, 14, 12, 14, 14, 13, 15, 10, 15, 0]],
              i: [8, [3, 21, 4, 20, 5, 21, 4, 22, 3, 21, -1, -1, 4, 14, 4, 0]],
              j: [10, [5, 21, 6, 20, 7, 21, 6, 22, 5, 21, -1, -1, 6, 14, 6, -3, 5, -6, 3, -7, 1, -7]],
              k: [17, [4, 21, 4, 0, -1, -1, 14, 14, 4, 4, -1, -1, 8, 8, 15, 0]],
              l: [8, [4, 21, 4, 0]],
              m: [30, [4, 14, 4, 0, -1, -1, 4, 10, 7, 13, 9, 14, 12, 14, 14, 13, 15, 10, 15, 0, -1, -1, 15, 10, 18, 13, 20, 14, 23, 14, 25, 13, 26, 10, 26, 0]],
              n: [19, [4, 14, 4, 0, -1, -1, 4, 10, 7, 13, 9, 14, 12, 14, 14, 13, 15, 10, 15, 0]],
              o: [19, [8, 14, 6, 13, 4, 11, 3, 8, 3, 6, 4, 3, 6, 1, 8, 0, 11, 0, 13, 1, 15, 3, 16, 6, 16, 8, 15, 11, 13, 13, 11, 14, 8, 14]],
              p: [19, [4, 14, 4, -7, -1, -1, 4, 11, 6, 13, 8, 14, 11, 14, 13, 13, 15, 11, 16, 8, 16, 6, 15, 3, 13, 1, 11, 0, 8, 0, 6, 1, 4, 3]],
              q: [19, [15, 14, 15, -7, -1, -1, 15, 11, 13, 13, 11, 14, 8, 14, 6, 13, 4, 11, 3, 8, 3, 6, 4, 3, 6, 1, 8, 0, 11, 0, 13, 1, 15, 3]],
              r: [13, [4, 14, 4, 0, -1, -1, 4, 8, 5, 11, 7, 13, 9, 14, 12, 14]],
              s: [17, [14, 11, 13, 13, 10, 14, 7, 14, 4, 13, 3, 11, 4, 9, 6, 8, 11, 7, 13, 6, 14, 4, 14, 3, 13, 1, 10, 0, 7, 0, 4, 1, 3, 3]],
              t: [12, [5, 21, 5, 4, 6, 1, 8, 0, 10, 0, -1, -1, 2, 14, 9, 14]],
              u: [19, [4, 14, 4, 4, 5, 1, 7, 0, 10, 0, 12, 1, 15, 4, -1, -1, 15, 14, 15, 0]],
              v: [16, [2, 14, 8, 0, -1, -1, 14, 14, 8, 0]],
              w: [22, [3, 14, 7, 0, -1, -1, 11, 14, 7, 0, -1, -1, 11, 14, 15, 0, -1, -1, 19, 14, 15, 0]],
              x: [17, [3, 14, 14, 0, -1, -1, 14, 14, 3, 0]],
              y: [16, [2, 14, 8, 0, -1, -1, 14, 14, 8, 0, 6, -4, 4, -6, 2, -7, 1, -7]],
              z: [17, [14, 14, 3, 0, -1, -1, 3, 14, 14, 14, -1, -1, 3, 0, 14, 0]],
              "{": [14, [9, 25, 7, 24, 6, 23, 5, 21, 5, 19, 6, 17, 7, 16, 8, 14, 8, 12, 6, 10, -1, -1, 7, 24, 6, 22, 6, 20, 7, 18, 8, 17, 9, 15, 9, 13, 8, 11, 4, 9, 8, 7, 9, 5, 9, 3, 8, 1, 7, 0, 6, -2, 6, -4, 7, -6, -1, -1, 6, 8, 8, 6, 8, 4, 7, 2, 6, 1, 5, -1, 5, -3, 6, -5, 7, -6, 9, -7]],
              "|": [8, [4, 25, 4, -7]],
              "}": [14, [5, 25, 7, 24, 8, 23, 9, 21, 9, 19, 8, 17, 7, 16, 6, 14, 6, 12, 8, 10, -1, -1, 7, 24, 8, 22, 8, 20, 7, 18, 6, 17, 5, 15, 5, 13, 6, 11, 10, 9, 6, 7, 5, 5, 5, 3, 6, 1, 7, 0, 8, -2, 8, -4, 7, -6, -1, -1, 8, 8, 6, 6, 6, 4, 7, 2, 8, 1, 9, -1, 9, -3, 8, -5, 7, -6, 5, -7]],
              "~": [24, [3, 6, 3, 8, 4, 11, 6, 12, 8, 12, 10, 11, 14, 8, 16, 7, 18, 7, 20, 8, 21, 10, -1, -1, 3, 8, 4, 10, 6, 11, 8, 11, 10, 10, 14, 7, 16, 6, 18, 6, 20, 7, 21, 10, 21, 12]]
          }
            , tn = {
              symbol: function(e, t, i, n) {
                  if ("translucent" === e.renderPass) {
                      var r = xe.disabled
                        , o = e.colorModeForRenderPass();
                      0 !== i.paint.get("icon-opacity").constantOr(1) && Wi(e, t, i, n, !1, i.paint.get("icon-translate"), i.paint.get("icon-translate-anchor"), i.layout.get("icon-rotation-alignment"), i.layout.get("icon-pitch-alignment"), i.layout.get("icon-keep-upright"), r, o),
                      0 !== i.paint.get("text-opacity").constantOr(1) && Wi(e, t, i, n, !0, i.paint.get("text-translate"), i.paint.get("text-translate-anchor"), i.layout.get("text-rotation-alignment"), i.layout.get("text-pitch-alignment"), i.layout.get("text-keep-upright"), r, o),
                      t.map.showCollisionBoxes && function(e, t, i, n) {
                          qi(e, t, i, n, !1),
                          qi(e, t, i, n, !0)
                      }(e, t, i, n)
                  }
              },
              circle: function(e, t, i, n) {
                  if ("translucent" === e.renderPass) {
                      var r = i.paint.get("circle-opacity")
                        , o = i.paint.get("circle-stroke-width")
                        , s = i.paint.get("circle-stroke-opacity");
                      if (0 !== r.constantOr(1) || 0 !== o.constantOr(1) && 0 !== s.constantOr(1))
                          for (var a = e.context, l = a.gl, c = e.depthModeForSublayer(0, we.ReadOnly), u = xe.disabled, h = e.colorModeForRenderPass(), d = 0; d < n.length; d++) {
                              var p = n[d]
                                , f = t.getTile(p)
                                , m = f.getBucket(i);
                              if (m) {
                                  var g = m.programConfigurations.get(i.id);
                                  e.useProgram("circle", g).draw(a, l.TRIANGLES, c, u, h, Se.disabled, yi(e, p, f, i), i.id, m.layoutVertexBuffer, m.indexBuffer, m.segments, i.paint, e.transform.zoom, g)
                              }
                          }
                  }
              },
              heatmap: function(t, i, n, r) {
                  if (0 !== n.paint.get("heatmap-opacity"))
                      if ("offscreen" === t.renderPass) {
                          var o = t.context
                            , s = o.gl
                            , a = t.depthModeForSublayer(0, we.ReadOnly)
                            , l = xe.disabled
                            , c = new ke([s.ONE, s.ONE],e.Color.transparent,[!0, !0, !0, !0]);
                          !function(e, t, i) {
                              var n = e.gl;
                              e.activeTexture.set(n.TEXTURE1),
                              e.viewport.set([0, 0, t.width / 4, t.height / 4]);
                              var r = i.heatmapFbo;
                              if (r)
                                  n.bindTexture(n.TEXTURE_2D, r.colorAttachment.get()),
                                  e.bindFramebuffer.set(r.framebuffer);
                              else {
                                  var o = n.createTexture();
                                  n.bindTexture(n.TEXTURE_2D, o),
                                  n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE),
                                  n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE),
                                  n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.LINEAR),
                                  n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, n.LINEAR),
                                  r = i.heatmapFbo = e.createFramebuffer(t.width / 4, t.height / 4),
                                  function e(t, i, n, r) {
                                      var o = t.gl;
                                      o.texImage2D(o.TEXTURE_2D, 0, o.RGBA, i.width / 4, i.height / 4, 0, o.RGBA, t.extTextureHalfFloat ? t.extTextureHalfFloat.HALF_FLOAT_OES : o.UNSIGNED_BYTE, null),
                                      r.colorAttachment.set(n),
                                      t.extTextureHalfFloat && o.checkFramebufferStatus(o.FRAMEBUFFER) !== o.FRAMEBUFFER_COMPLETE && (t.extTextureHalfFloat = null,
                                      r.colorAttachment.setDirty(),
                                      e(t, i, n, r))
                                  }(e, t, o, r)
                              }
                          }(o, t, n),
                          o.clear({
                              color: e.Color.transparent
                          });
                          for (var u = 0; u < r.length; u++) {
                              var h = r[u];
                              if (!i.hasRenderableParent(h)) {
                                  var d = i.getTile(h)
                                    , p = d.getBucket(n);
                                  if (p) {
                                      var f = p.programConfigurations.get(n.id)
                                        , m = t.useProgram("heatmap", f)
                                        , g = t.transform.zoom;
                                      m.draw(o, s.TRIANGLES, a, l, c, Se.disabled, ki(h.posMatrix, d, g, n.paint.get("heatmap-intensity")), n.id, p.layoutVertexBuffer, p.indexBuffer, p.segments, n.paint, t.transform.zoom, f)
                                  }
                              }
                          }
                          o.viewport.set([0, 0, t.width, t.height])
                      } else
                          "translucent" === t.renderPass && (t.context.setColorMode(t.colorModeForRenderPass()),
                          function(t, i) {
                              var n = t.context
                                , r = n.gl
                                , o = i.heatmapFbo;
                              if (o) {
                                  n.activeTexture.set(r.TEXTURE0),
                                  r.bindTexture(r.TEXTURE_2D, o.colorAttachment.get()),
                                  n.activeTexture.set(r.TEXTURE1);
                                  var s = i.colorRampTexture;
                                  s || (s = i.colorRampTexture = new e.Texture(n,i.colorRamp,r.RGBA)),
                                  s.bind(r.LINEAR, r.CLAMP_TO_EDGE),
                                  t.useProgram("heatmapTexture").draw(n, r.TRIANGLES, we.disabled, xe.disabled, t.colorModeForRenderPass(), Se.disabled, function(t, i, n, r) {
                                      var o = e.create$1();
                                      e.ortho(o, 0, t.width, t.height, 0, 0, 1);
                                      var s = t.context.gl;
                                      return {
                                          u_matrix: o,
                                          u_world: [s.drawingBufferWidth, s.drawingBufferHeight],
                                          u_image: n,
                                          u_color_ramp: r,
                                          u_opacity: i.paint.get("heatmap-opacity")
                                      }
                                  }(t, i, 0, 1), i.id, t.viewportBuffer, t.quadTriangleIndexBuffer, t.viewportSegments, i.paint, t.transform.zoom)
                              }
                          }(t, n))
              },
              line: function(t, i, n, r) {
                  if ("translucent" === t.renderPass) {
                      var o = n.paint.get("line-opacity")
                        , s = n.paint.get("line-width");
                      if (0 !== o.constantOr(1) && 0 !== s.constantOr(1)) {
                          var a = t.depthModeForSublayer(0, we.ReadOnly)
                            , l = t.colorModeForRenderPass()
                            , c = n.paint.get("line-dasharray")
                            , u = n.paint.get("line-pattern")
                            , h = u.constantOr(1)
                            , d = n.paint.get("line-gradient")
                            , p = n.getCrossfadeParameters()
                            , f = c ? "lineSDF" : h ? "linePattern" : d ? "lineGradient" : "line"
                            , m = t.context
                            , g = m.gl
                            , v = !0;
                          if (d) {
                              m.activeTexture.set(g.TEXTURE0);
                              var y = n.gradientTexture;
                              if (!n.gradient)
                                  return;
                              y || (y = n.gradientTexture = new e.Texture(m,n.gradient,g.RGBA)),
                              y.bind(g.LINEAR, g.CLAMP_TO_EDGE)
                          }
                          for (var _ = 0, b = r; _ < b.length; _ += 1) {
                              var w = b[_]
                                , x = i.getTile(w);
                              if (!h || x.patternsLoaded()) {
                                  var k = x.getBucket(n);
                                  if (k) {
                                      var S = k.programConfigurations.get(n.id)
                                        , E = t.context.program.get()
                                        , T = t.useProgram(f, S)
                                        , C = v || T.program !== E
                                        , L = u.constantOr(null);
                                      if (L && x.imageAtlas) {
                                          var A = x.imageAtlas.patternPositions[L.to]
                                            , P = x.imageAtlas.patternPositions[L.from];
                                          A && P && S.setConstantPatternPositions(A, P)
                                      }
                                      var I = c ? Pi(t, x, n, c, p) : h ? Ai(t, x, n, p) : d ? Li(t, x, n) : Ci(t, x, n);
                                      c && (C || t.lineAtlas.dirty) ? (m.activeTexture.set(g.TEXTURE0),
                                      t.lineAtlas.bind(m)) : h && (m.activeTexture.set(g.TEXTURE0),
                                      x.imageAtlasTexture.bind(g.LINEAR, g.CLAMP_TO_EDGE),
                                      S.updatePatternPaintBuffers(p)),
                                      T.draw(m, g.TRIANGLES, a, t.stencilModeForClipping(w), l, Se.disabled, I, n.id, k.layoutVertexBuffer, k.indexBuffer, k.segments, n.paint, t.transform.zoom, S),
                                      v = !1
                                  }
                              }
                          }
                      }
                  }
              },
              fill: function(t, i, n, r) {
                  var o = n.paint.get("fill-color")
                    , s = n.paint.get("fill-opacity");
                  if (0 !== s.constantOr(1)) {
                      var a = t.colorModeForRenderPass()
                        , l = n.paint.get("fill-pattern").constantOr(1) || 1 !== o.constantOr(e.Color.transparent).a || 1 !== s.constantOr(0) ? "translucent" : "opaque";
                      if (t.renderPass === l) {
                          var c = t.depthModeForSublayer(1, "opaque" === t.renderPass ? we.ReadWrite : we.ReadOnly);
                          Gi(t, i, n, r, c, a, !1)
                      }
                      if ("translucent" === t.renderPass && n.paint.get("fill-antialias")) {
                          var u = t.depthModeForSublayer(n.getPaintProperty("fill-outline-color") ? 2 : 0, we.ReadOnly);
                          Gi(t, i, n, r, u, a, !0)
                      }
                  }
              },
              "fill-extrusion": function(e, t, i, n) {
                  if (0 !== i.paint.get("fill-extrusion-opacity"))
                      if ("offscreen" === e.renderPass) {
                          Xi(e, i);
                          var r = new we(e.context.gl.LEQUAL,we.ReadWrite,[0, 1])
                            , o = xe.disabled
                            , s = e.colorModeForRenderPass();
                          !function(e, t, i, n, r, o, s) {
                              for (var a = e.context, l = a.gl, c = i.paint.get("fill-extrusion-pattern"), u = c.constantOr(1), h = i.getCrossfadeParameters(), d = 0, p = n; d < p.length; d += 1) {
                                  var f = p[d]
                                    , m = t.getTile(f)
                                    , g = m.getBucket(i);
                                  if (g) {
                                      var v = g.programConfigurations.get(i.id)
                                        , y = e.useProgram(u ? "fillExtrusionPattern" : "fillExtrusion", v);
                                      u && (e.context.activeTexture.set(l.TEXTURE0),
                                      m.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE),
                                      v.updatePatternPaintBuffers(h));
                                      var _ = c.constantOr(null);
                                      if (_ && m.imageAtlas) {
                                          var b = m.imageAtlas.patternPositions[_.to]
                                            , w = m.imageAtlas.patternPositions[_.from];
                                          b && w && v.setConstantPatternPositions(b, w)
                                      }
                                      var x = e.translatePosMatrix(f.posMatrix, m, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor"))
                                        , k = i.paint.get("fill-extrusion-vertical-gradient")
                                        , S = u ? di(x, e, k, f, h, m) : hi(x, e, k);
                                      y.draw(a, a.gl.TRIANGLES, r, o, s, Se.backCCW, S, i.id, g.layoutVertexBuffer, g.indexBuffer, g.segments, i.paint, e.transform.zoom, v)
                                  }
                              }
                          }(e, t, i, n, r, o, s)
                      } else
                          "translucent" === e.renderPass && Zi(e, i, i.paint.get("fill-extrusion-opacity"))
              },
              hillshade: function(e, t, i, n) {
                  if ("offscreen" === e.renderPass || "translucent" === e.renderPass) {
                      for (var r = e.context, o = t.getSource().maxzoom, s = e.depthModeForSublayer(0, we.ReadOnly), a = xe.disabled, l = e.colorModeForRenderPass(), c = 0, u = n; c < u.length; c += 1) {
                          var h = u[c]
                            , d = t.getTile(h);
                          d.needsHillshadePrepare && "offscreen" === e.renderPass ? Ki(e, d, i, o, s, a, l) : "translucent" === e.renderPass && Yi(e, d, i, s, a, l)
                      }
                      r.viewport.set([0, 0, e.width, e.height])
                  }
              },
              raster: function(e, t, i, n) {
                  if ("translucent" === e.renderPass && 0 !== i.paint.get("raster-opacity"))
                      for (var r = e.context, o = r.gl, s = t.getSource(), a = e.useProgram("raster"), l = xe.disabled, c = e.colorModeForRenderPass(), u = n.length && n[0].overscaledZ, h = !e.options.moving, d = 0, p = n; d < p.length; d += 1) {
                          var f = p[d]
                            , m = e.depthModeForSublayer(f.overscaledZ - u, 1 === i.paint.get("raster-opacity") ? we.ReadWrite : we.ReadOnly, o.LESS)
                            , g = t.getTile(f)
                            , v = e.transform.calculatePosMatrix(f.toUnwrapped(), h);
                          g.registerFadeDuration(i.paint.get("raster-fade-duration"));
                          var y = t.findLoadedParent(f, 0)
                            , _ = Ji(g, y, t, i, e.transform)
                            , b = void 0
                            , w = void 0
                            , x = "nearest" === i.paint.get("raster-resampling") ? o.NEAREST : o.LINEAR;
                          r.activeTexture.set(o.TEXTURE0),
                          g.texture.bind(x, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST),
                          r.activeTexture.set(o.TEXTURE1),
                          y ? (y.texture.bind(x, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST),
                          b = Math.pow(2, y.tileID.overscaledZ - g.tileID.overscaledZ),
                          w = [g.tileID.canonical.x * b % 1, g.tileID.canonical.y * b % 1]) : g.texture.bind(x, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST);
                          var k = Oi(v, w || [0, 0], b || 1, _, i);
                          s instanceof A ? a.draw(r, o.TRIANGLES, m, l, c, Se.disabled, k, i.id, s.boundsBuffer, e.quadTriangleIndexBuffer, s.boundsSegments) : g.maskedBoundsBuffer && g.maskedIndexBuffer && g.segments ? a.draw(r, o.TRIANGLES, m, l, c, Se.disabled, k, i.id, g.maskedBoundsBuffer, g.maskedIndexBuffer, g.segments, i.paint, e.transform.zoom) : a.draw(r, o.TRIANGLES, m, l, c, Se.disabled, k, i.id, e.rasterBoundsBuffer, e.quadTriangleIndexBuffer, e.rasterBoundsSegments)
                      }
              },
              background: function(e, t, i) {
                  var n = i.paint.get("background-color")
                    , r = i.paint.get("background-opacity");
                  if (0 !== r) {
                      var o = e.context
                        , s = o.gl
                        , a = e.transform
                        , l = a.tileSize
                        , c = i.paint.get("background-pattern");
                      if (!e.isPatternMissing(c)) {
                          var u = c || 1 !== n.a || 1 !== r ? "translucent" : "opaque";
                          if (e.renderPass === u) {
                              var h = xe.disabled
                                , d = e.depthModeForSublayer(0, "opaque" === u ? we.ReadWrite : we.ReadOnly)
                                , p = e.colorModeForRenderPass()
                                , f = e.useProgram(c ? "backgroundPattern" : "background")
                                , m = a.coveringTiles({
                                  tileSize: l
                              });
                              c && (o.activeTexture.set(s.TEXTURE0),
                              e.imageManager.bind(e.context));
                              for (var g = i.getCrossfadeParameters(), v = 0, y = m; v < y.length; v += 1) {
                                  var _ = y[v]
                                    , b = e.transform.calculatePosMatrix(_.toUnwrapped())
                                    , w = c ? ji(b, r, e, c, {
                                      tileID: _,
                                      tileSize: l
                                  }, g) : Bi(b, r, n);
                                  f.draw(o, s.TRIANGLES, d, h, p, Se.disabled, w, i.id, e.tileExtentBuffer, e.quadTriangleIndexBuffer, e.tileExtentSegments)
                              }
                          }
                      }
                  }
              },
              debug: function(e, t, i) {
                  for (var n = 0; n < i.length; n++)
                      Qi(e, t, i[n])
              },
              custom: function(e, t, i) {
                  var n = e.context
                    , r = i.implementation;
                  if ("offscreen" === e.renderPass) {
                      var o = r.prerender;
                      o && (e.setCustomLayerDefaults(),
                      o.call(r, n.gl, e.transform.customLayerMatrix()),
                      n.setDirty(),
                      e.setBaseState()),
                      "3d" === r.renderingMode && (e.setCustomLayerDefaults(),
                      Xi(e, i),
                      r.render(n.gl, e.transform.customLayerMatrix()),
                      n.setDirty(),
                      e.setBaseState())
                  } else if ("translucent" === e.renderPass)
                      if ("3d" === r.renderingMode)
                          Zi(e, i, 1);
                      else {
                          e.setCustomLayerDefaults(),
                          n.setColorMode(e.colorModeForRenderPass()),
                          n.setStencilMode(xe.disabled);
                          var s = e.depthModeForSublayer(0, we.ReadOnly);
                          n.setDepthMode(s),
                          r.render(n.gl, e.transform.customLayerMatrix()),
                          n.setDirty(),
                          e.setBaseState(),
                          n.bindFramebuffer.set(null)
                      }
              }
          }
            , nn = function(t, i) {
              this.context = new Ee(t),
              this.transform = i,
              this._tileTextures = {},
              this.setup(),
              this.numSublayers = Te.maxUnderzooming + Te.maxOverzooming + 1,
              this.depthEpsilon = 1 / Math.pow(2, 16),
              this.depthRboNeedsClear = !0,
              this.emptyProgramConfiguration = new e.ProgramConfiguration,
              this.crossTileSymbolIndex = new Lt
          };
          function rn(e, t) {
              if (e.y > t.y) {
                  var i = e;
                  e = t,
                  t = i
              }
              return {
                  x0: e.x,
                  y0: e.y,
                  x1: t.x,
                  y1: t.y,
                  dx: t.x - e.x,
                  dy: t.y - e.y
              }
          }
          function on(e, t, i, n, r) {
              var o = Math.max(i, Math.floor(t.y0))
                , s = Math.min(n, Math.ceil(t.y1));
              if (e.x0 === t.x0 && e.y0 === t.y0 ? e.x0 + t.dy / e.dy * e.dx < t.x1 : e.x1 - t.dy / e.dy * e.dx < t.x0) {
                  var a = e;
                  e = t,
                  t = a
              }
              for (var l = e.dx / e.dy, c = t.dx / t.dy, u = e.dx > 0, h = t.dx < 0, d = o; d < s; d++) {
                  var p = l * Math.max(0, Math.min(e.dy, d + u - e.y0)) + e.x0
                    , f = c * Math.max(0, Math.min(t.dy, d + h - t.y0)) + t.x0;
                  r(Math.floor(f), Math.ceil(p), d)
              }
          }
          function sn(e, t, i, n, r, o) {
              var s, a = rn(e, t), l = rn(t, i), c = rn(i, e);
              a.dy > l.dy && (s = a,
              a = l,
              l = s),
              a.dy > c.dy && (s = a,
              a = c,
              c = s),
              l.dy > c.dy && (s = l,
              l = c,
              c = s),
              a.dy && on(c, a, n, r, o),
              l.dy && on(c, l, n, r, o)
          }
          nn.prototype.resize = function(t, i) {
              var n = this.context.gl;
              if (this.width = t * e.browser.devicePixelRatio,
              this.height = i * e.browser.devicePixelRatio,
              this.context.viewport.set([0, 0, this.width, this.height]),
              this.style)
                  for (var r = 0, o = this.style._order; r < o.length; r += 1) {
                      var s = o[r];
                      this.style._layers[s].resize()
                  }
              this.depthRbo && (n.deleteRenderbuffer(this.depthRbo),
              this.depthRbo = null)
          }
          ,
          nn.prototype.setup = function() {
              var t = this.context
                , i = new e.StructArrayLayout2i4;
              i.emplaceBack(0, 0),
              i.emplaceBack(e.EXTENT, 0),
              i.emplaceBack(0, e.EXTENT),
              i.emplaceBack(e.EXTENT, e.EXTENT),
              this.tileExtentBuffer = t.createVertexBuffer(i, Ot.members),
              this.tileExtentSegments = e.SegmentVector.simpleSegment(0, 0, 4, 2);
              var n = new e.StructArrayLayout2i4;
              n.emplaceBack(0, 0),
              n.emplaceBack(e.EXTENT, 0),
              n.emplaceBack(0, e.EXTENT),
              n.emplaceBack(e.EXTENT, e.EXTENT),
              this.debugBuffer = t.createVertexBuffer(n, Ot.members),
              this.debugSegments = e.SegmentVector.simpleSegment(0, 0, 4, 5);
              var r = new e.StructArrayLayout4i8;
              r.emplaceBack(0, 0, 0, 0),
              r.emplaceBack(e.EXTENT, 0, e.EXTENT, 0),
              r.emplaceBack(0, e.EXTENT, 0, e.EXTENT),
              r.emplaceBack(e.EXTENT, e.EXTENT, e.EXTENT, e.EXTENT),
              this.rasterBoundsBuffer = t.createVertexBuffer(r, e.rasterBoundsAttributes.members),
              this.rasterBoundsSegments = e.SegmentVector.simpleSegment(0, 0, 4, 2);
              var o = new e.StructArrayLayout2i4;
              o.emplaceBack(0, 0),
              o.emplaceBack(1, 0),
              o.emplaceBack(0, 1),
              o.emplaceBack(1, 1),
              this.viewportBuffer = t.createVertexBuffer(o, Ot.members),
              this.viewportSegments = e.SegmentVector.simpleSegment(0, 0, 4, 2);
              var s = new e.StructArrayLayout1ui2;
              s.emplaceBack(0),
              s.emplaceBack(1),
              s.emplaceBack(3),
              s.emplaceBack(2),
              s.emplaceBack(0),
              this.tileBorderIndexBuffer = t.createIndexBuffer(s);
              var a = new e.StructArrayLayout3ui6;
              a.emplaceBack(0, 1, 2),
              a.emplaceBack(2, 1, 3),
              this.quadTriangleIndexBuffer = t.createIndexBuffer(a);
              var l = this.context.gl;
              this.stencilClearMode = new xe({
                  func: l.ALWAYS,
                  mask: 0
              },0,255,l.ZERO,l.ZERO,l.ZERO)
          }
          ,
          nn.prototype.clearStencil = function() {
              var t = this.context
                , i = t.gl
                , n = e.create$1();
              e.ortho(n, 0, this.width, this.height, 0, 0, 1),
              e.scale(n, n, [i.drawingBufferWidth, i.drawingBufferHeight, 0]),
              this.useProgram("clippingMask").draw(t, i.TRIANGLES, we.disabled, this.stencilClearMode, ke.disabled, Se.disabled, xi(n), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments)
          }
          ,
          nn.prototype._renderTileClippingMasks = function(e) {
              var t = this.context
                , i = t.gl;
              t.setColorMode(ke.disabled),
              t.setDepthMode(we.disabled);
              var n = this.useProgram("clippingMask")
                , r = 1;
              this._tileClippingMaskIDs = {};
              for (var o = 0, s = e; o < s.length; o += 1) {
                  var a = s[o]
                    , l = this._tileClippingMaskIDs[a.key] = r++;
                  n.draw(t, i.TRIANGLES, we.disabled, new xe({
                      func: i.ALWAYS,
                      mask: 0
                  },l,255,i.KEEP,i.KEEP,i.REPLACE), ke.disabled, Se.disabled, xi(a.posMatrix), "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments)
              }
          }
          ,
          nn.prototype.stencilModeForClipping = function(e) {
              var t = this.context.gl;
              return new xe({
                  func: t.EQUAL,
                  mask: 255
              },this._tileClippingMaskIDs[e.key],0,t.KEEP,t.KEEP,t.REPLACE)
          }
          ,
          nn.prototype.colorModeForRenderPass = function() {
              var t = this.context.gl;
              return this._showOverdrawInspector ? new ke([t.CONSTANT_COLOR, t.ONE],new e.Color(1 / 8,1 / 8,1 / 8,0),[!0, !0, !0, !0]) : "opaque" === this.renderPass ? ke.unblended : ke.alphaBlended
          }
          ,
          nn.prototype.depthModeForSublayer = function(e, t, i) {
              var n = 1 - ((1 + this.currentLayer) * this.numSublayers + e) * this.depthEpsilon;
              return new we(i || this.context.gl.LEQUAL,t,[n, n])
          }
          ,
          nn.prototype.render = function(t, i) {
              this.style = t,
              this.options = i,
              this.lineAtlas = t.lineAtlas,
              this.imageManager = t.imageManager,
              this.glyphManager = t.glyphManager,
              this.symbolFadeChange = t.placement.symbolFadeChange(e.browser.now());
              var n = this.style._order
                , r = this.style.sourceCaches;
              for (var o in r) {
                  var s = r[o];
                  s.used && s.prepare(this.context)
              }
              var a, l = {}, c = {}, u = {};
              for (var h in r) {
                  var d = r[h];
                  l[h] = d.getVisibleCoordinates(),
                  c[h] = l[h].slice().reverse(),
                  u[h] = d.getVisibleCoordinates(!0).reverse()
              }
              for (var p in r) {
                  var f = r[p]
                    , m = f.getSource();
                  if ("raster" === m.type || "raster-dem" === m.type) {
                      for (var g = [], v = 0, y = l[p]; v < y.length; v += 1) {
                          var _ = y[v];
                          g.push(f.getTile(_))
                      }
                      Ni(g, this.context)
                  }
              }
              this.renderPass = "offscreen",
              this.depthRboNeedsClear = !0;
              for (var b = 0, w = n; b < w.length; b += 1) {
                  var x = w[b]
                    , k = this.style._layers[x];
                  if (k.hasOffscreenPass() && !k.isHidden(this.transform.zoom)) {
                      var S = c[k.source];
                      ("custom" === k.type || S.length) && this.renderLayer(this, r[k.source], k, S)
                  }
              }
              for (this.context.bindFramebuffer.set(null),
              this.context.clear({
                  color: i.showOverdrawInspector ? e.Color.black : e.Color.transparent,
                  depth: 1
              }),
              this._showOverdrawInspector = i.showOverdrawInspector,
              this.depthRange = (t._order.length + 2) * this.numSublayers * this.depthEpsilon,
              this.renderPass = "opaque",
              this.currentLayer = n.length - 1; this.currentLayer >= 0; this.currentLayer--) {
                  var E = this.style._layers[n[this.currentLayer]]
                    , T = r[E.source]
                    , C = l[E.source];
                  E.source !== a && T && (this.clearStencil(),
                  T.getSource().isTileClipped && this._renderTileClippingMasks(C)),
                  this.renderLayer(this, T, E, C),
                  a = E.source
              }
              for (this.renderPass = "translucent",
              this.currentLayer = 0,
              a = null; this.currentLayer < n.length; this.currentLayer++) {
                  var L = this.style._layers[n[this.currentLayer]]
                    , A = r[L.source]
                    , P = ("symbol" === L.type ? u : c)[L.source];
                  L.source !== a && A && (this.clearStencil(),
                  A.getSource().isTileClipped && this._renderTileClippingMasks(l[L.source])),
                  this.renderLayer(this, A, L, P),
                  a = L.source
              }
              if (this.options.showTileBoundaries)
                  for (var I in r) {
                      tn.debug(this, r[I], l[I]);
                      break
                  }
              this.setCustomLayerDefaults()
          }
          ,
          nn.prototype.setupOffscreenDepthRenderbuffer = function() {
              var e = this.context;
              this.depthRbo || (this.depthRbo = e.createRenderbuffer(e.gl.DEPTH_COMPONENT16, this.width, this.height))
          }
          ,
          nn.prototype.renderLayer = function(e, t, i, n) {
              i.isHidden(this.transform.zoom) || ("background" === i.type || "custom" === i.type || n.length) && (this.id = i.id,
              tn[i.type](e, t, i, n))
          }
          ,
          nn.prototype.translatePosMatrix = function(t, i, n, r, o) {
              if (!n[0] && !n[1])
                  return t;
              var s = o ? "map" === r ? this.transform.angle : 0 : "viewport" === r ? -this.transform.angle : 0;
              if (s) {
                  var a = Math.sin(s)
                    , l = Math.cos(s);
                  n = [n[0] * l - n[1] * a, n[0] * a + n[1] * l]
              }
              var c = [o ? n[0] : st(i, n[0], this.transform.zoom), o ? n[1] : st(i, n[1], this.transform.zoom), 0]
                , u = new Float32Array(16);
              return e.translate(u, t, c),
              u
          }
          ,
          nn.prototype.saveTileTexture = function(e) {
              var t = this._tileTextures[e.size[0]];
              t ? t.push(e) : this._tileTextures[e.size[0]] = [e]
          }
          ,
          nn.prototype.getTileTexture = function(e) {
              var t = this._tileTextures[e];
              return t && t.length > 0 ? t.pop() : null
          }
          ,
          nn.prototype.isPatternMissing = function(e) {
              if (!e)
                  return !1;
              var t = this.imageManager.getPattern(e.from)
                , i = this.imageManager.getPattern(e.to);
              return !t || !i
          }
          ,
          nn.prototype.useProgram = function(e, t) {
              void 0 === t && (t = this.emptyProgramConfiguration),
              this.cache = this.cache || {};
              var i = "" + e + (t.cacheKey || "") + (this._showOverdrawInspector ? "/overdraw" : "");
              return this.cache[i] || (this.cache[i] = new ci(this.context,ai[e],t,Fi[e],this._showOverdrawInspector)),
              this.cache[i]
          }
          ,
          nn.prototype.setCustomLayerDefaults = function() {
              this.context.unbindVAO(),
              this.context.cullFace.setDefault(),
              this.context.activeTexture.setDefault(),
              this.context.pixelStoreUnpack.setDefault(),
              this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(),
              this.context.pixelStoreUnpackFlipY.setDefault()
          }
          ,
          nn.prototype.setBaseState = function() {
              var e = this.context.gl;
              this.context.cullFace.set(!1),
              this.context.viewport.set([0, 0, this.width, this.height]),
              this.context.blendEquation.set(e.FUNC_ADD)
          }
          ;
          var an = function(t, i, n) {
              this.tileSize = 512,
              this.maxValidLatitude = 85.051129,
              this._renderWorldCopies = void 0 === n || n,
              this._minZoom = t || 0,
              this._maxZoom = i || 22,
              this.setMaxBounds(),
              this.width = 0,
              this.height = 0,
              this._center = new e.LngLat(0,0),
              this.zoom = 0,
              this.angle = 0,
              this._fov = .6435011087932844,
              this._pitch = 0,
              this._unmodified = !0,
              this._posMatrixCache = {},
              this._alignedPosMatrixCache = {}
          }
            , ln = {
              minZoom: {
                  configurable: !0
              },
              maxZoom: {
                  configurable: !0
              },
              renderWorldCopies: {
                  configurable: !0
              },
              worldSize: {
                  configurable: !0
              },
              centerPoint: {
                  configurable: !0
              },
              size: {
                  configurable: !0
              },
              bearing: {
                  configurable: !0
              },
              pitch: {
                  configurable: !0
              },
              fov: {
                  configurable: !0
              },
              zoom: {
                  configurable: !0
              },
              center: {
                  configurable: !0
              },
              unmodified: {
                  configurable: !0
              },
              point: {
                  configurable: !0
              }
          };
          an.prototype.clone = function() {
              var e = new an(this._minZoom,this._maxZoom,this._renderWorldCopies);
              return e.tileSize = this.tileSize,
              e.latRange = this.latRange,
              e.width = this.width,
              e.height = this.height,
              e._center = this._center,
              e.zoom = this.zoom,
              e.angle = this.angle,
              e._fov = this._fov,
              e._pitch = this._pitch,
              e._unmodified = this._unmodified,
              e._calcMatrices(),
              e
          }
          ,
          ln.minZoom.get = function() {
              return this._minZoom
          }
          ,
          ln.minZoom.set = function(e) {
              this._minZoom !== e && (this._minZoom = e,
              this.zoom = Math.max(this.zoom, e))
          }
          ,
          ln.maxZoom.get = function() {
              return this._maxZoom
          }
          ,
          ln.maxZoom.set = function(e) {
              this._maxZoom !== e && (this._maxZoom = e,
              this.zoom = Math.min(this.zoom, e))
          }
          ,
          ln.renderWorldCopies.get = function() {
              return this._renderWorldCopies
          }
          ,
          ln.renderWorldCopies.set = function(e) {
              void 0 === e ? e = !0 : null === e && (e = !1),
              this._renderWorldCopies = e
          }
          ,
          ln.worldSize.get = function() {
              return this.tileSize * this.scale
          }
          ,
          ln.centerPoint.get = function() {
              return this.size._div(2)
          }
          ,
          ln.size.get = function() {
              return new e.Point(this.width,this.height)
          }
          ,
          ln.bearing.get = function() {
              return -this.angle / Math.PI * 180
          }
          ,
          ln.bearing.set = function(t) {
              var i = -e.wrap(t, -180, 180) * Math.PI / 180;
              this.angle !== i && (this._unmodified = !1,
              this.angle = i,
              this._calcMatrices(),
              this.rotationMatrix = e.create$2(),
              e.rotate(this.rotationMatrix, this.rotationMatrix, this.angle))
          }
          ,
          ln.pitch.get = function() {
              return this._pitch / Math.PI * 180
          }
          ,
          ln.pitch.set = function(t) {
              var i = e.clamp(t, 0, 60) / 180 * Math.PI;
              this._pitch !== i && (this._unmodified = !1,
              this._pitch = i,
              this._calcMatrices())
          }
          ,
          ln.fov.get = function() {
              return this._fov / Math.PI * 180
          }
          ,
          ln.fov.set = function(e) {
              e = Math.max(.01, Math.min(60, e)),
              this._fov !== e && (this._unmodified = !1,
              this._fov = e / 180 * Math.PI,
              this._calcMatrices())
          }
          ,
          ln.zoom.get = function() {
              return this._zoom
          }
          ,
          ln.zoom.set = function(e) {
              var t = Math.min(Math.max(e, this.minZoom), this.maxZoom);
              this._zoom !== t && (this._unmodified = !1,
              this._zoom = t,
              this.scale = this.zoomScale(t),
              this.tileZoom = Math.floor(t),
              this.zoomFraction = t - this.tileZoom,
              this._constrain(),
              this._calcMatrices())
          }
          ,
          ln.center.get = function() {
              return this._center
          }
          ,
          ln.center.set = function(e) {
              e.lat === this._center.lat && e.lng === this._center.lng || (this._unmodified = !1,
              this._center = e,
              this._constrain(),
              this._calcMatrices())
          }
          ,
          an.prototype.coveringZoomLevel = function(e) {
              return (e.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e.tileSize))
          }
          ,
          an.prototype.getVisibleUnwrappedCoordinates = function(t) {
              var i = [new e.UnwrappedTileID(0,t)];
              if (this._renderWorldCopies)
                  for (var n = this.pointCoordinate(new e.Point(0,0)), r = this.pointCoordinate(new e.Point(this.width,0)), o = this.pointCoordinate(new e.Point(this.width,this.height)), s = this.pointCoordinate(new e.Point(0,this.height)), a = Math.floor(Math.min(n.x, r.x, o.x, s.x)), l = Math.floor(Math.max(n.x, r.x, o.x, s.x)), c = a - 1; c <= l + 1; c++)
                      0 !== c && i.push(new e.UnwrappedTileID(c,t));
              return i
          }
          ,
          an.prototype.coveringTiles = function(t) {
              var i = this.coveringZoomLevel(t)
                , n = i;
              if (void 0 !== t.minzoom && i < t.minzoom)
                  return [];
              void 0 !== t.maxzoom && i > t.maxzoom && (i = t.maxzoom);
              var r = e.MercatorCoordinate.fromLngLat(this.center)
                , o = Math.pow(2, i)
                , s = new e.Point(o * r.x - .5,o * r.y - .5);
              return function(t, i, n, r) {
                  void 0 === r && (r = !0);
                  var o = 1 << t
                    , s = {};
                  function a(i, a, l) {
                      var c, u, h, d;
                      if (l >= 0 && l <= o)
                          for (c = i; c < a; c++)
                              u = Math.floor(c / o),
                              h = (c % o + o) % o,
                              0 !== u && !0 !== r || (d = new e.OverscaledTileID(n,u,t,h,l),
                              s[d.key] = d)
                  }
                  var l = i.map(function(t) {
                      return new e.Point(t.x,t.y)._mult(o)
                  });
                  return sn(l[0], l[1], l[2], 0, o, a),
                  sn(l[2], l[3], l[0], 0, o, a),
                  Object.keys(s).map(function(e) {
                      return s[e]
                  })
              }(i, [this.pointCoordinate(new e.Point(0,0)), this.pointCoordinate(new e.Point(this.width,0)), this.pointCoordinate(new e.Point(this.width,this.height)), this.pointCoordinate(new e.Point(0,this.height))], t.reparseOverscaled ? n : i, this._renderWorldCopies).sort(function(e, t) {
                  return s.dist(e.canonical) - s.dist(t.canonical)
              })
          }
          ,
          an.prototype.resize = function(e, t) {
              this.width = e,
              this.height = t,
              this.pixelsToGLUnits = [2 / e, -2 / t],
              this._constrain(),
              this._calcMatrices()
          }
          ,
          ln.unmodified.get = function() {
              return this._unmodified
          }
          ,
          an.prototype.zoomScale = function(e) {
              return Math.pow(2, e)
          }
          ,
          an.prototype.scaleZoom = function(e) {
              return Math.log(e) / Math.LN2
          }
          ,
          an.prototype.project = function(t) {
              var i = e.clamp(t.lat, -this.maxValidLatitude, this.maxValidLatitude);
              return new e.Point(e.mercatorXfromLng(t.lng) * this.worldSize,e.mercatorYfromLat(i) * this.worldSize)
          }
          ,
          an.prototype.unproject = function(t) {
              return new e.MercatorCoordinate(t.x / this.worldSize,t.y / this.worldSize).toLngLat()
          }
          ,
          ln.point.get = function() {
              return this.project(this.center)
          }
          ,
          an.prototype.setLocationAtPoint = function(t, i) {
              var n = this.pointCoordinate(i)
                , r = this.pointCoordinate(this.centerPoint)
                , o = this.locationCoordinate(t)
                , s = new e.MercatorCoordinate(o.x - (n.x - r.x),o.y - (n.y - r.y));
              this.center = this.coordinateLocation(s),
              this._renderWorldCopies && (this.center = this.center.wrap())
          }
          ,
          an.prototype.locationPoint = function(e) {
              return this.coordinatePoint(this.locationCoordinate(e))
          }
          ,
          an.prototype.pointLocation = function(e) {
              return this.coordinateLocation(this.pointCoordinate(e))
          }
          ,
          an.prototype.locationCoordinate = function(t) {
              return e.MercatorCoordinate.fromLngLat(t)
          }
          ,
          an.prototype.coordinateLocation = function(e) {
              return e.toLngLat()
          }
          ,
          an.prototype.pointCoordinate = function(t) {
              var i = [t.x, t.y, 0, 1]
                , n = [t.x, t.y, 1, 1];
              e.transformMat4(i, i, this.pixelMatrixInverse),
              e.transformMat4(n, n, this.pixelMatrixInverse);
              var r = i[3]
                , o = n[3]
                , s = i[0] / r
                , a = n[0] / o
                , l = i[1] / r
                , c = n[1] / o
                , u = i[2] / r
                , h = n[2] / o
                , d = u === h ? 0 : (0 - u) / (h - u);
              return new e.MercatorCoordinate(e.number(s, a, d) / this.worldSize,e.number(l, c, d) / this.worldSize)
          }
          ,
          an.prototype.coordinatePoint = function(t) {
              var i = [t.x * this.worldSize, t.y * this.worldSize, 0, 1];
              return e.transformMat4(i, i, this.pixelMatrix),
              new e.Point(i[0] / i[3],i[1] / i[3])
          }
          ,
          an.prototype.getBounds = function() {
              return (new e.LngLatBounds).extend(this.pointLocation(new e.Point(0,0))).extend(this.pointLocation(new e.Point(this.width,0))).extend(this.pointLocation(new e.Point(this.width,this.height))).extend(this.pointLocation(new e.Point(0,this.height)))
          }
          ,
          an.prototype.getMaxBounds = function() {
              return this.latRange && 2 === this.latRange.length && this.lngRange && 2 === this.lngRange.length ? new e.LngLatBounds([this.lngRange[0], this.latRange[0]],[this.lngRange[1], this.latRange[1]]) : null
          }
          ,
          an.prototype.setMaxBounds = function(e) {
              e ? (this.lngRange = [e.getWest(), e.getEast()],
              this.latRange = [e.getSouth(), e.getNorth()],
              this._constrain()) : (this.lngRange = null,
              this.latRange = [-this.maxValidLatitude, this.maxValidLatitude])
          }
          ,
          an.prototype.calculatePosMatrix = function(t, i) {
              void 0 === i && (i = !1);
              var n = t.key
                , r = i ? this._alignedPosMatrixCache : this._posMatrixCache;
              if (r[n])
                  return r[n];
              var o = t.canonical
                , s = this.worldSize / this.zoomScale(o.z)
                , a = o.x + Math.pow(2, o.z) * t.wrap
                , l = e.identity(new Float64Array(16));
              return e.translate(l, l, [a * s, o.y * s, 0]),
              e.scale(l, l, [s / e.EXTENT, s / e.EXTENT, 1]),
              e.multiply(l, i ? this.alignedProjMatrix : this.projMatrix, l),
              r[n] = new Float32Array(l),
              r[n]
          }
          ,
          an.prototype.customLayerMatrix = function() {
              return this.mercatorMatrix.slice()
          }
          ,
          an.prototype._constrain = function() {
              if (this.center && this.width && this.height && !this._constraining) {
                  this._constraining = !0;
                  var t, i, n, r, o = -90, s = 90, a = -180, l = 180, c = this.size, u = this._unmodified;
                  if (this.latRange) {
                      var h = this.latRange;
                      o = e.mercatorYfromLat(h[1]) * this.worldSize,
                      t = (s = e.mercatorYfromLat(h[0]) * this.worldSize) - o < c.y ? c.y / (s - o) : 0
                  }
                  if (this.lngRange) {
                      var d = this.lngRange;
                      a = e.mercatorXfromLng(d[0]) * this.worldSize,
                      i = (l = e.mercatorXfromLng(d[1]) * this.worldSize) - a < c.x ? c.x / (l - a) : 0
                  }
                  var p = this.point
                    , f = Math.max(i || 0, t || 0);
                  if (f)
                      return this.center = this.unproject(new e.Point(i ? (l + a) / 2 : p.x,t ? (s + o) / 2 : p.y)),
                      this.zoom += this.scaleZoom(f),
                      this._unmodified = u,
                      void (this._constraining = !1);
                  if (this.latRange) {
                      var m = p.y
                        , g = c.y / 2;
                      m - g < o && (r = o + g),
                      m + g > s && (r = s - g)
                  }
                  if (this.lngRange) {
                      var v = p.x
                        , y = c.x / 2;
                      v - y < a && (n = a + y),
                      v + y > l && (n = l - y)
                  }
                  void 0 === n && void 0 === r || (this.center = this.unproject(new e.Point(void 0 !== n ? n : p.x,void 0 !== r ? r : p.y))),
                  this._unmodified = u,
                  this._constraining = !1
              }
          }
          ,
          an.prototype._calcMatrices = function() {
              if (this.height) {
                  this.cameraToCenterDistance = .5 / Math.tan(this._fov / 2) * this.height;
                  var t = this._fov / 2
                    , i = Math.PI / 2 + this._pitch
                    , n = Math.sin(t) * this.cameraToCenterDistance / Math.sin(Math.PI - i - t)
                    , r = this.point
                    , o = r.x
                    , s = r.y
                    , a = 1.01 * (Math.cos(Math.PI / 2 - this._pitch) * n + this.cameraToCenterDistance)
                    , l = new Float64Array(16);
                  e.perspective(l, this._fov, this.width / this.height, 1, a),
                  e.scale(l, l, [1, -1, 1]),
                  e.translate(l, l, [0, 0, -this.cameraToCenterDistance]),
                  e.rotateX(l, l, this._pitch),
                  e.rotateZ(l, l, this.angle),
                  e.translate(l, l, [-o, -s, 0]),
                  this.mercatorMatrix = e.scale([], l, [this.worldSize, this.worldSize, this.worldSize]),
                  e.scale(l, l, [1, 1, e.mercatorZfromAltitude(1, this.center.lat) * this.worldSize, 1]),
                  this.projMatrix = l;
                  var c = this.width % 2 / 2
                    , u = this.height % 2 / 2
                    , h = Math.cos(this.angle)
                    , d = Math.sin(this.angle)
                    , p = o - Math.round(o) + h * c + d * u
                    , f = s - Math.round(s) + h * u + d * c
                    , m = new Float64Array(l);
                  if (e.translate(m, m, [p > .5 ? p - 1 : p, f > .5 ? f - 1 : f, 0]),
                  this.alignedProjMatrix = m,
                  l = e.create$1(),
                  e.scale(l, l, [this.width / 2, -this.height / 2, 1]),
                  e.translate(l, l, [1, -1, 0]),
                  this.pixelMatrix = e.multiply(new Float64Array(16), l, this.projMatrix),
                  !(l = e.invert(new Float64Array(16), this.pixelMatrix)))
                      throw new Error("failed to invert matrix");
                  this.pixelMatrixInverse = l,
                  this._posMatrixCache = {},
                  this._alignedPosMatrixCache = {}
              }
          }
          ,
          an.prototype.maxPitchScaleFactor = function() {
              if (!this.pixelMatrixInverse)
                  return 1;
              var t = this.pointCoordinate(new e.Point(0,0))
                , i = [t.x * this.worldSize, t.y * this.worldSize, 0, 1];
              return e.transformMat4(i, i, this.pixelMatrix)[3] / this.cameraToCenterDistance
          }
          ,
          an.prototype.getCameraPoint = function() {
              var t = this._pitch
                , i = Math.tan(t) * (this.cameraToCenterDistance || 1);
              return this.centerPoint.add(new e.Point(0,i))
          }
          ,
          an.prototype.getCameraQueryGeometry = function(t) {
              var i = this.getCameraPoint();
              if (1 === t.length)
                  return [t[0], i];
              for (var n = i.x, r = i.y, o = i.x, s = i.y, a = 0, l = t; a < l.length; a += 1) {
                  var c = l[a];
                  n = Math.min(n, c.x),
                  r = Math.min(r, c.y),
                  o = Math.max(o, c.x),
                  s = Math.max(s, c.y)
              }
              return [new e.Point(n,r), new e.Point(o,r), new e.Point(o,s), new e.Point(n,s), new e.Point(n,r)]
          }
          ,
          Object.defineProperties(an.prototype, ln);
          var cn = function() {
              var t, i, n, r;
              e.bindAll(["_onHashChange", "_updateHash"], this),
              this._updateHash = (t = this._updateHashUnthrottled.bind(this),
              i = !1,
              n = 0,
              r = function() {
                  n = 0,
                  i && (t(),
                  n = setTimeout(r, 300),
                  i = !1)
              }
              ,
              function() {
                  return i = !0,
                  n || r(),
                  n
              }
              )
          };
          cn.prototype.addTo = function(t) {
              return this._map = t,
              e.window.addEventListener("hashchange", this._onHashChange, !1),
              this._map.on("moveend", this._updateHash),
              this
          }
          ,
          cn.prototype.remove = function() {
              return e.window.removeEventListener("hashchange", this._onHashChange, !1),
              this._map.off("moveend", this._updateHash),
              clearTimeout(this._updateHash()),
              delete this._map,
              this
          }
          ,
          cn.prototype.getHashString = function(e) {
              var t = this._map.getCenter()
                , i = Math.round(100 * this._map.getZoom()) / 100
                , n = Math.ceil((i * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10)
                , r = Math.pow(10, n)
                , o = Math.round(t.lng * r) / r
                , s = Math.round(t.lat * r) / r
                , a = this._map.getBearing()
                , l = this._map.getPitch()
                , c = "";
              return c += e ? "#/" + o + "/" + s + "/" + i : "#" + i + "/" + s + "/" + o,
              (a || l) && (c += "/" + Math.round(10 * a) / 10),
              l && (c += "/" + Math.round(l)),
              c
          }
          ,
          cn.prototype._onHashChange = function() {
              var t = e.window.location.hash.replace("#", "").split("/");
              return t.length >= 3 && (this._map.jumpTo({
                  center: [+t[2], +t[1]],
                  zoom: +t[0],
                  bearing: +(t[3] || 0),
                  pitch: +(t[4] || 0)
              }),
              !0)
          }
          ,
          cn.prototype._updateHashUnthrottled = function() {
              var t = this.getHashString();
              try {
                  e.window.history.replaceState(e.window.history.state, "", t)
              } catch (e) {}
          }
          ;
          var un = function(t) {
              function n(n, r, o, s) {
                  void 0 === s && (s = {});
                  var a = i.mousePos(r.getCanvasContainer(), o)
                    , l = r.unproject(a);
                  t.call(this, n, e.extend({
                      point: a,
                      lngLat: l,
                      originalEvent: o
                  }, s)),
                  this._defaultPrevented = !1,
                  this.target = r
              }
              t && (n.__proto__ = t),
              n.prototype = Object.create(t && t.prototype),
              n.prototype.constructor = n;
              var r = {
                  defaultPrevented: {
                      configurable: !0
                  }
              };
              return n.prototype.preventDefault = function() {
                  this._defaultPrevented = !0
              }
              ,
              r.defaultPrevented.get = function() {
                  return this._defaultPrevented
              }
              ,
              Object.defineProperties(n.prototype, r),
              n
          }(e.Event)
            , hn = function(t) {
              function n(n, r, o) {
                  var s = i.touchPos(r.getCanvasContainer(), o)
                    , a = s.map(function(e) {
                      return r.unproject(e)
                  })
                    , l = s.reduce(function(e, t, i, n) {
                      return e.add(t.div(n.length))
                  }, new e.Point(0,0))
                    , c = r.unproject(l);
                  t.call(this, n, {
                      points: s,
                      point: l,
                      lngLats: a,
                      lngLat: c,
                      originalEvent: o
                  }),
                  this._defaultPrevented = !1
              }
              t && (n.__proto__ = t),
              n.prototype = Object.create(t && t.prototype),
              n.prototype.constructor = n;
              var r = {
                  defaultPrevented: {
                      configurable: !0
                  }
              };
              return n.prototype.preventDefault = function() {
                  this._defaultPrevented = !0
              }
              ,
              r.defaultPrevented.get = function() {
                  return this._defaultPrevented
              }
              ,
              Object.defineProperties(n.prototype, r),
              n
          }(e.Event)
            , dn = function(e) {
              function t(t, i, n) {
                  e.call(this, t, {
                      originalEvent: n
                  }),
                  this._defaultPrevented = !1
              }
              e && (t.__proto__ = e),
              t.prototype = Object.create(e && e.prototype),
              t.prototype.constructor = t;
              var i = {
                  defaultPrevented: {
                      configurable: !0
                  }
              };
              return t.prototype.preventDefault = function() {
                  this._defaultPrevented = !0
              }
              ,
              i.defaultPrevented.get = function() {
                  return this._defaultPrevented
              }
              ,
              Object.defineProperties(t.prototype, i),
              t
          }(e.Event)
            , pn = function(t) {
              this._map = t,
              this._el = t.getCanvasContainer(),
              this._delta = 0,
              e.bindAll(["_onWheel", "_onTimeout", "_onScrollFrame", "_onScrollFinished"], this)
          };
          pn.prototype.isEnabled = function() {
              return !!this._enabled
          }
          ,
          pn.prototype.isActive = function() {
              return !!this._active
          }
          ,
          pn.prototype.isZooming = function() {
              return !!this._zooming
          }
          ,
          pn.prototype.enable = function(e) {
              this.isEnabled() || (this._enabled = !0,
              this._aroundCenter = e && "center" === e.around)
          }
          ,
          pn.prototype.disable = function() {
              this.isEnabled() && (this._enabled = !1)
          }
          ,
          pn.prototype.onWheel = function(t) {
              if (this.isEnabled()) {
                  var i = t.deltaMode === e.window.WheelEvent.DOM_DELTA_LINE ? 40 * t.deltaY : t.deltaY
                    , n = e.browser.now()
                    , r = n - (this._lastWheelEventTime || 0);
                  this._lastWheelEventTime = n,
                  0 !== i && i % 4.000244140625 == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : r > 400 ? (this._type = null,
                  this._lastValue = i,
                  this._timeout = setTimeout(this._onTimeout, 40, t)) : this._type || (this._type = Math.abs(r * i) < 200 ? "trackpad" : "wheel",
                  this._timeout && (clearTimeout(this._timeout),
                  this._timeout = null,
                  i += this._lastValue)),
                  t.shiftKey && i && (i /= 4),
                  this._type && (this._lastWheelEvent = t,
                  this._delta -= i,
                  this.isActive() || this._start(t)),
                  t.preventDefault()
              }
          }
          ,
          pn.prototype._onTimeout = function(e) {
              this._type = "wheel",
              this._delta -= this._lastValue,
              this.isActive() || this._start(e)
          }
          ,
          pn.prototype._start = function(t) {
              if (this._delta) {
                  this._frameId && (this._map._cancelRenderFrame(this._frameId),
                  this._frameId = null),
                  this._active = !0,
                  this._zooming = !0,
                  this._map.fire(new e.Event("movestart",{
                      originalEvent: t
                  })),
                  this._map.fire(new e.Event("zoomstart",{
                      originalEvent: t
                  })),
                  this._finishTimeout && clearTimeout(this._finishTimeout);
                  var n = i.mousePos(this._el, t);
                  this._around = e.LngLat.convert(this._aroundCenter ? this._map.getCenter() : this._map.unproject(n)),
                  this._aroundPoint = this._map.transform.locationPoint(this._around),
                  this._frameId || (this._frameId = this._map._requestRenderFrame(this._onScrollFrame))
              }
          }
          ,
          pn.prototype._onScrollFrame = function() {
              var t = this;
              if (this._frameId = null,
              this.isActive()) {
                  var i = this._map.transform;
                  if (0 !== this._delta) {
                      var n = "wheel" === this._type && Math.abs(this._delta) > 4.000244140625 ? 1 / 450 : .01
                        , r = 2 / (1 + Math.exp(-Math.abs(this._delta * n)));
                      this._delta < 0 && 0 !== r && (r = 1 / r);
                      var o = "number" == typeof this._targetZoom ? i.zoomScale(this._targetZoom) : i.scale;
                      this._targetZoom = Math.min(i.maxZoom, Math.max(i.minZoom, i.scaleZoom(o * r))),
                      "wheel" === this._type && (this._startZoom = i.zoom,
                      this._easing = this._smoothOutEasing(200)),
                      this._delta = 0
                  }
                  var s = "number" == typeof this._targetZoom ? this._targetZoom : i.zoom
                    , a = this._startZoom
                    , l = this._easing
                    , c = !1;
                  if ("wheel" === this._type && a && l) {
                      var u = Math.min((e.browser.now() - this._lastWheelEventTime) / 200, 1)
                        , h = l(u);
                      i.zoom = e.number(a, s, h),
                      u < 1 ? this._frameId || (this._frameId = this._map._requestRenderFrame(this._onScrollFrame)) : c = !0
                  } else
                      i.zoom = s,
                      c = !0;
                  i.setLocationAtPoint(this._around, this._aroundPoint),
                  this._map.fire(new e.Event("move",{
                      originalEvent: this._lastWheelEvent
                  })),
                  this._map.fire(new e.Event("zoom",{
                      originalEvent: this._lastWheelEvent
                  })),
                  c && (this._active = !1,
                  this._finishTimeout = setTimeout(function() {
                      t._zooming = !1,
                      t._map.fire(new e.Event("zoomend",{
                          originalEvent: t._lastWheelEvent
                      })),
                      t._map.fire(new e.Event("moveend",{
                          originalEvent: t._lastWheelEvent
                      })),
                      delete t._targetZoom
                  }, 200))
              }
          }
          ,
          pn.prototype._smoothOutEasing = function(t) {
              var i = e.ease;
              if (this._prevEase) {
                  var n = this._prevEase
                    , r = (e.browser.now() - n.start) / n.duration
                    , o = n.easing(r + .01) - n.easing(r)
                    , s = .27 / Math.sqrt(o * o + 1e-4) * .01
                    , a = Math.sqrt(.0729 - s * s);
                  i = e.bezier(s, a, .25, 1)
              }
              return this._prevEase = {
                  start: e.browser.now(),
                  duration: t,
                  easing: i
              },
              i
          }
          ;
          var fn = function(t, i) {
              this._map = t,
              this._el = t.getCanvasContainer(),
              this._container = t.getContainer(),
              this._clickTolerance = i.clickTolerance || 1,
              e.bindAll(["_onMouseMove", "_onMouseUp", "_onKeyDown"], this)
          };
          fn.prototype.isEnabled = function() {
              return !!this._enabled
          }
          ,
          fn.prototype.isActive = function() {
              return !!this._active
          }
          ,
          fn.prototype.enable = function() {
              this.isEnabled() || (this._enabled = !0)
          }
          ,
          fn.prototype.disable = function() {
              this.isEnabled() && (this._enabled = !1)
          }
          ,
          fn.prototype.onMouseDown = function(t) {
              this.isEnabled() && t.shiftKey && 0 === t.button && (e.window.document.addEventListener("mousemove", this._onMouseMove, !1),
              e.window.document.addEventListener("keydown", this._onKeyDown, !1),
              e.window.document.addEventListener("mouseup", this._onMouseUp, !1),
              i.disableDrag(),
              this._startPos = this._lastPos = i.mousePos(this._el, t),
              this._active = !0)
          }
          ,
          fn.prototype._onMouseMove = function(e) {
              var t = i.mousePos(this._el, e);
              if (!(this._lastPos.equals(t) || !this._box && t.dist(this._startPos) < this._clickTolerance)) {
                  var n = this._startPos;
                  this._lastPos = t,
                  this._box || (this._box = i.create("div", "mapboxgl-boxzoom", this._container),
                  this._container.classList.add("mapboxgl-crosshair"),
                  this._fireEvent("boxzoomstart", e));
                  var r = Math.min(n.x, t.x)
                    , o = Math.max(n.x, t.x)
                    , s = Math.min(n.y, t.y)
                    , a = Math.max(n.y, t.y);
                  i.setTransform(this._box, "translate(" + r + "px," + s + "px)"),
                  this._box.style.width = o - r + "px",
                  this._box.style.height = a - s + "px"
              }
          }
          ,
          fn.prototype._onMouseUp = function(t) {
              if (0 === t.button) {
                  var n = this._startPos
                    , r = i.mousePos(this._el, t);
                  this._finish(),
                  i.suppressClick(),
                  n.x === r.x && n.y === r.y ? this._fireEvent("boxzoomcancel", t) : this._map.fitScreenCoordinates(n, r, this._map.getBearing(), {
                      linear: !0
                  }).fire(new e.Event("boxzoomend",{
                      originalEvent: t
                  }))
              }
          }
          ,
          fn.prototype._onKeyDown = function(e) {
              27 === e.keyCode && (this._finish(),
              this._fireEvent("boxzoomcancel", e))
          }
          ,
          fn.prototype._finish = function() {
              this._active = !1,
              e.window.document.removeEventListener("mousemove", this._onMouseMove, !1),
              e.window.document.removeEventListener("keydown", this._onKeyDown, !1),
              e.window.document.removeEventListener("mouseup", this._onMouseUp, !1),
              this._container.classList.remove("mapboxgl-crosshair"),
              this._box && (i.remove(this._box),
              this._box = null),
              i.enableDrag(),
              delete this._startPos,
              delete this._lastPos
          }
          ,
          fn.prototype._fireEvent = function(t, i) {
              return this._map.fire(new e.Event(t,{
                  originalEvent: i
              }))
          }
          ;
          var mn = e.bezier(0, 0, .25, 1)
            , gn = function(t, i) {
              this._map = t,
              this._el = i.element || t.getCanvasContainer(),
              this._state = "disabled",
              this._button = i.button || "right",
              this._bearingSnap = i.bearingSnap || 0,
              this._pitchWithRotate = !1 !== i.pitchWithRotate,
              e.bindAll(["onMouseDown", "_onMouseMove", "_onMouseUp", "_onBlur", "_onDragFrame"], this)
          };
          gn.prototype.isEnabled = function() {
              return "disabled" !== this._state
          }
          ,
          gn.prototype.isActive = function() {
              return "active" === this._state
          }
          ,
          gn.prototype.enable = function() {
              this.isEnabled() || (this._state = "enabled")
          }
          ,
          gn.prototype.disable = function() {
              if (this.isEnabled())
                  switch (this._state) {
                  case "active":
                      this._state = "disabled",
                      this._unbind(),
                      this._deactivate(),
                      this._fireEvent("rotateend"),
                      this._pitchWithRotate && this._fireEvent("pitchend"),
                      this._fireEvent("moveend");
                      break;
                  case "pending":
                      this._state = "disabled",
                      this._unbind();
                      break;
                  default:
                      this._state = "disabled"
                  }
          }
          ,
          gn.prototype.onMouseDown = function(t) {
              if ("enabled" === this._state) {
                  if ("right" === this._button) {
                      if (this._eventButton = i.mouseButton(t),
                      this._eventButton !== (t.ctrlKey ? 0 : 2))
                          return
                  } else {
                      if (t.ctrlKey || 0 !== i.mouseButton(t))
                          return;
                      this._eventButton = 0
                  }
                  i.disableDrag(),
                  e.window.document.addEventListener("mousemove", this._onMouseMove, {
                      capture: !0
                  }),
                  e.window.document.addEventListener("mouseup", this._onMouseUp),
                  e.window.addEventListener("blur", this._onBlur),
                  this._state = "pending",
                  this._inertia = [[e.browser.now(), this._map.getBearing()]],
                  this._startPos = this._lastPos = i.mousePos(this._el, t),
                  this._center = this._map.transform.centerPoint,
                  t.preventDefault()
              }
          }
          ,
          gn.prototype._onMouseMove = function(e) {
              var t = i.mousePos(this._el, e);
              this._lastPos.equals(t) || (this._lastMoveEvent = e,
              this._lastPos = t,
              "pending" === this._state && (this._state = "active",
              this._fireEvent("rotatestart", e),
              this._fireEvent("movestart", e),
              this._pitchWithRotate && this._fireEvent("pitchstart", e)),
              this._frameId || (this._frameId = this._map._requestRenderFrame(this._onDragFrame)))
          }
          ,
          gn.prototype._onDragFrame = function() {
              this._frameId = null;
              var t = this._lastMoveEvent;
              if (t) {
                  var i = this._map.transform
                    , n = this._startPos
                    , r = this._lastPos
                    , o = .8 * (n.x - r.x)
                    , s = -.5 * (n.y - r.y)
                    , a = i.bearing - o
                    , l = i.pitch - s
                    , c = this._inertia
                    , u = c[c.length - 1];
                  this._drainInertiaBuffer(),
                  c.push([e.browser.now(), this._map._normalizeBearing(a, u[1])]),
                  i.bearing = a,
                  this._pitchWithRotate && (this._fireEvent("pitch", t),
                  i.pitch = l),
                  this._fireEvent("rotate", t),
                  this._fireEvent("move", t),
                  delete this._lastMoveEvent,
                  this._startPos = this._lastPos
              }
          }
          ,
          gn.prototype._onMouseUp = function(e) {
              if (i.mouseButton(e) === this._eventButton)
                  switch (this._state) {
                  case "active":
                      this._state = "enabled",
                      i.suppressClick(),
                      this._unbind(),
                      this._deactivate(),
                      this._inertialRotate(e);
                      break;
                  case "pending":
                      this._state = "enabled",
                      this._unbind()
                  }
          }
          ,
          gn.prototype._onBlur = function(e) {
              switch (this._state) {
              case "active":
                  this._state = "enabled",
                  this._unbind(),
                  this._deactivate(),
                  this._fireEvent("rotateend", e),
                  this._pitchWithRotate && this._fireEvent("pitchend", e),
                  this._fireEvent("moveend", e);
                  break;
              case "pending":
                  this._state = "enabled",
                  this._unbind()
              }
          }
          ,
          gn.prototype._unbind = function() {
              e.window.document.removeEventListener("mousemove", this._onMouseMove, {
                  capture: !0
              }),
              e.window.document.removeEventListener("mouseup", this._onMouseUp),
              e.window.removeEventListener("blur", this._onBlur),
              i.enableDrag()
          }
          ,
          gn.prototype._deactivate = function() {
              this._frameId && (this._map._cancelRenderFrame(this._frameId),
              this._frameId = null),
              delete this._lastMoveEvent,
              delete this._startPos,
              delete this._lastPos
          }
          ,
          gn.prototype._inertialRotate = function(e) {
              var t = this;
              this._fireEvent("rotateend", e),
              this._drainInertiaBuffer();
              var i = this._map
                , n = i.getBearing()
                , r = this._inertia
                , o = function() {
                  Math.abs(n) < t._bearingSnap ? i.resetNorth({
                      noMoveStart: !0
                  }, {
                      originalEvent: e
                  }) : t._fireEvent("moveend", e),
                  t._pitchWithRotate && t._fireEvent("pitchend", e)
              };
              if (r.length < 2)
                  o();
              else {
                  var s = r[0]
                    , a = r[r.length - 1]
                    , l = r[r.length - 2]
                    , c = i._normalizeBearing(n, l[1])
                    , u = a[1] - s[1]
                    , h = u < 0 ? -1 : 1
                    , d = (a[0] - s[0]) / 1e3;
                  if (0 !== u && 0 !== d) {
                      var p = Math.abs(u * (.25 / d));
                      p > 180 && (p = 180);
                      var f = p / 180;
                      c += h * p * (f / 2),
                      Math.abs(i._normalizeBearing(c, 0)) < this._bearingSnap && (c = i._normalizeBearing(0, c)),
                      i.rotateTo(c, {
                          duration: 1e3 * f,
                          easing: mn,
                          noMoveStart: !0
                      }, {
                          originalEvent: e
                      })
                  } else
                      o()
              }
          }
          ,
          gn.prototype._fireEvent = function(t, i) {
              return this._map.fire(new e.Event(t,i ? {
                  originalEvent: i
              } : {}))
          }
          ,
          gn.prototype._drainInertiaBuffer = function() {
              for (var t = this._inertia, i = e.browser.now(); t.length > 0 && i - t[0][0] > 160; )
                  t.shift()
          }
          ;
          var vn = e.bezier(0, 0, .3, 1)
            , yn = function(t, i) {
              this._map = t,
              this._el = t.getCanvasContainer(),
              this._state = "disabled",
              this._clickTolerance = i.clickTolerance || 1,
              e.bindAll(["_onMove", "_onMouseUp", "_onTouchEnd", "_onBlur", "_onDragFrame"], this)
          };
          yn.prototype.isEnabled = function() {
              return "disabled" !== this._state
          }
          ,
          yn.prototype.isActive = function() {
              return "active" === this._state
          }
          ,
          yn.prototype.enable = function() {
              this.isEnabled() || (this._el.classList.add("mapboxgl-touch-drag-pan"),
              this._state = "enabled")
          }
          ,
          yn.prototype.disable = function() {
              if (this.isEnabled())
                  switch (this._el.classList.remove("mapboxgl-touch-drag-pan"),
                  this._state) {
                  case "active":
                      this._state = "disabled",
                      this._unbind(),
                      this._deactivate(),
                      this._fireEvent("dragend"),
                      this._fireEvent("moveend");
                      break;
                  case "pending":
                      this._state = "disabled",
                      this._unbind();
                      break;
                  default:
                      this._state = "disabled"
                  }
          }
          ,
          yn.prototype.onMouseDown = function(t) {
              "enabled" === this._state && (t.ctrlKey || 0 !== i.mouseButton(t) || (i.addEventListener(e.window.document, "mousemove", this._onMove, {
                  capture: !0
              }),
              i.addEventListener(e.window.document, "mouseup", this._onMouseUp),
              this._start(t)))
          }
          ,
          yn.prototype.onTouchStart = function(t) {
              "enabled" === this._state && (t.touches.length > 1 || (i.addEventListener(e.window.document, "touchmove", this._onMove, {
                  capture: !0,
                  passive: !1
              }),
              i.addEventListener(e.window.document, "touchend", this._onTouchEnd),
              this._start(t)))
          }
          ,
          yn.prototype._start = function(t) {
              e.window.addEventListener("blur", this._onBlur),
              this._state = "pending",
              this._startPos = this._mouseDownPos = this._lastPos = i.mousePos(this._el, t),
              this._inertia = [[e.browser.now(), this._startPos]]
          }
          ,
          yn.prototype._onMove = function(t) {
              t.preventDefault();
              var n = i.mousePos(this._el, t);
              this._lastPos.equals(n) || "pending" === this._state && n.dist(this._mouseDownPos) < this._clickTolerance || (this._lastMoveEvent = t,
              this._lastPos = n,
              this._drainInertiaBuffer(),
              this._inertia.push([e.browser.now(), this._lastPos]),
              "pending" === this._state && (this._state = "active",
              this._fireEvent("dragstart", t),
              this._fireEvent("movestart", t)),
              this._frameId || (this._frameId = this._map._requestRenderFrame(this._onDragFrame)))
          }
          ,
          yn.prototype._onDragFrame = function() {
              this._frameId = null;
              var e = this._lastMoveEvent;
              if (e) {
                  var t = this._map.transform;
                  t.setLocationAtPoint(t.pointLocation(this._startPos), this._lastPos),
                  this._fireEvent("drag", e),
                  this._fireEvent("move", e),
                  this._startPos = this._lastPos,
                  delete this._lastMoveEvent
              }
          }
          ,
          yn.prototype._onMouseUp = function(e) {
              if (0 === i.mouseButton(e))
                  switch (this._state) {
                  case "active":
                      this._state = "enabled",
                      i.suppressClick(),
                      this._unbind(),
                      this._deactivate(),
                      this._inertialPan(e);
                      break;
                  case "pending":
                      this._state = "enabled",
                      this._unbind()
                  }
          }
          ,
          yn.prototype._onTouchEnd = function(e) {
              switch (this._state) {
              case "active":
                  this._state = "enabled",
                  this._unbind(),
                  this._deactivate(),
                  this._inertialPan(e);
                  break;
              case "pending":
                  this._state = "enabled",
                  this._unbind()
              }
          }
          ,
          yn.prototype._onBlur = function(e) {
              switch (this._state) {
              case "active":
                  this._state = "enabled",
                  this._unbind(),
                  this._deactivate(),
                  this._fireEvent("dragend", e),
                  this._fireEvent("moveend", e);
                  break;
              case "pending":
                  this._state = "enabled",
                  this._unbind()
              }
          }
          ,
          yn.prototype._unbind = function() {
              i.removeEventListener(e.window.document, "touchmove", this._onMove, {
                  capture: !0,
                  passive: !1
              }),
              i.removeEventListener(e.window.document, "touchend", this._onTouchEnd),
              i.removeEventListener(e.window.document, "mousemove", this._onMove, {
                  capture: !0
              }),
              i.removeEventListener(e.window.document, "mouseup", this._onMouseUp),
              i.removeEventListener(e.window, "blur", this._onBlur)
          }
          ,
          yn.prototype._deactivate = function() {
              this._frameId && (this._map._cancelRenderFrame(this._frameId),
              this._frameId = null),
              delete this._lastMoveEvent,
              delete this._startPos,
              delete this._mouseDownPos,
              delete this._lastPos
          }
          ,
          yn.prototype._inertialPan = function(e) {
              this._fireEvent("dragend", e),
              this._drainInertiaBuffer();
              var t = this._inertia;
              if (t.length < 2)
                  this._fireEvent("moveend", e);
              else {
                  var i = t[t.length - 1]
                    , n = t[0]
                    , r = i[1].sub(n[1])
                    , o = (i[0] - n[0]) / 1e3;
                  if (0 === o || i[1].equals(n[1]))
                      this._fireEvent("moveend", e);
                  else {
                      var s = r.mult(.3 / o)
                        , a = s.mag();
                      a > 1400 && (a = 1400,
                      s._unit()._mult(a));
                      var l = a / 750
                        , c = s.mult(-l / 2);
                      this._map.panBy(c, {
                          duration: 1e3 * l,
                          easing: vn,
                          noMoveStart: !0
                      }, {
                          originalEvent: e
                      })
                  }
              }
          }
          ,
          yn.prototype._fireEvent = function(t, i) {
              return this._map.fire(new e.Event(t,i ? {
                  originalEvent: i
              } : {}))
          }
          ,
          yn.prototype._drainInertiaBuffer = function() {
              for (var t = this._inertia, i = e.browser.now(); t.length > 0 && i - t[0][0] > 160; )
                  t.shift()
          }
          ;
          var _n = function(t) {
              this._map = t,
              this._el = t.getCanvasContainer(),
              e.bindAll(["_onKeyDown"], this)
          };
          function bn(e) {
              return e * (2 - e)
          }
          _n.prototype.isEnabled = function() {
              return !!this._enabled
          }
          ,
          _n.prototype.enable = function() {
              this.isEnabled() || (this._el.addEventListener("keydown", this._onKeyDown, !1),
              this._enabled = !0)
          }
          ,
          _n.prototype.disable = function() {
              this.isEnabled() && (this._el.removeEventListener("keydown", this._onKeyDown),
              this._enabled = !1)
          }
          ,
          _n.prototype._onKeyDown = function(e) {
              if (!(e.altKey || e.ctrlKey || e.metaKey)) {
                  var t = 0
                    , i = 0
                    , n = 0
                    , r = 0
                    , o = 0;
                  switch (e.keyCode) {
                  case 61:
                  case 107:
                  case 171:
                  case 187:
                      t = 1;
                      break;
                  case 189:
                  case 109:
                  case 173:
                      t = -1;
                      break;
                  case 37:
                      e.shiftKey ? i = -1 : (e.preventDefault(),
                      r = -1);
                      break;
                  case 39:
                      e.shiftKey ? i = 1 : (e.preventDefault(),
                      r = 1);
                      break;
                  case 38:
                      e.shiftKey ? n = 1 : (e.preventDefault(),
                      o = -1);
                      break;
                  case 40:
                      e.shiftKey ? n = -1 : (o = 1,
                      e.preventDefault());
                      break;
                  default:
                      return
                  }
                  var s = this._map
                    , a = s.getZoom()
                    , l = {
                      duration: 300,
                      delayEndEvents: 500,
                      easing: bn,
                      zoom: t ? Math.round(a) + t * (e.shiftKey ? 2 : 1) : a,
                      bearing: s.getBearing() + 15 * i,
                      pitch: s.getPitch() + 10 * n,
                      offset: [100 * -r, 100 * -o],
                      center: s.getCenter()
                  };
                  s.easeTo(l, {
                      originalEvent: e
                  })
              }
          }
          ;
          var wn = function(t) {
              this._map = t,
              e.bindAll(["_onDblClick", "_onZoomEnd"], this)
          };
          wn.prototype.isEnabled = function() {
              return !!this._enabled
          }
          ,
          wn.prototype.isActive = function() {
              return !!this._active
          }
          ,
          wn.prototype.enable = function() {
              this.isEnabled() || (this._enabled = !0)
          }
          ,
          wn.prototype.disable = function() {
              this.isEnabled() && (this._enabled = !1)
          }
          ,
          wn.prototype.onTouchStart = function(e) {
              var t = this;
              this.isEnabled() && (e.points.length > 1 || (this._tapped ? (clearTimeout(this._tapped),
              this._tapped = null,
              this._zoom(e)) : this._tapped = setTimeout(function() {
                  t._tapped = null
              }, 300)))
          }
          ,
          wn.prototype.onDblClick = function(e) {
              this.isEnabled() && (e.originalEvent.preventDefault(),
              this._zoom(e))
          }
          ,
          wn.prototype._zoom = function(e) {
              this._active = !0,
              this._map.on("zoomend", this._onZoomEnd),
              this._map.zoomTo(this._map.getZoom() + (e.originalEvent.shiftKey ? -1 : 1), {
                  around: e.lngLat
              }, e)
          }
          ,
          wn.prototype._onZoomEnd = function() {
              this._active = !1,
              this._map.off("zoomend", this._onZoomEnd)
          }
          ;
          var xn = e.bezier(0, 0, .15, 1)
            , kn = function(t) {
              this._map = t,
              this._el = t.getCanvasContainer(),
              e.bindAll(["_onMove", "_onEnd", "_onTouchFrame"], this)
          };
          kn.prototype.isEnabled = function() {
              return !!this._enabled
          }
          ,
          kn.prototype.enable = function(e) {
              this.isEnabled() || (this._el.classList.add("mapboxgl-touch-zoom-rotate"),
              this._enabled = !0,
              this._aroundCenter = !!e && "center" === e.around)
          }
          ,
          kn.prototype.disable = function() {
              this.isEnabled() && (this._el.classList.remove("mapboxgl-touch-zoom-rotate"),
              this._enabled = !1)
          }
          ,
          kn.prototype.disableRotation = function() {
              this._rotationDisabled = !0
          }
          ,
          kn.prototype.enableRotation = function() {
              this._rotationDisabled = !1
          }
          ,
          kn.prototype.onStart = function(t) {
              if (this.isEnabled() && 2 === t.touches.length) {
                  var n = i.mousePos(this._el, t.touches[0])
                    , r = i.mousePos(this._el, t.touches[1])
                    , o = n.add(r).div(2);
                  this._startVec = n.sub(r),
                  this._startAround = this._map.transform.pointLocation(o),
                  this._gestureIntent = void 0,
                  this._inertia = [],
                  i.addEventListener(e.window.document, "touchmove", this._onMove, {
                      passive: !1
                  }),
                  i.addEventListener(e.window.document, "touchend", this._onEnd)
              }
          }
          ,
          kn.prototype._getTouchEventData = function(e) {
              var t = i.mousePos(this._el, e.touches[0])
                , n = i.mousePos(this._el, e.touches[1])
                , r = t.sub(n);
              return {
                  vec: r,
                  center: t.add(n).div(2),
                  scale: r.mag() / this._startVec.mag(),
                  bearing: this._rotationDisabled ? 0 : 180 * r.angleWith(this._startVec) / Math.PI
              }
          }
          ,
          kn.prototype._onMove = function(t) {
              if (2 === t.touches.length) {
                  var i = this._getTouchEventData(t)
                    , n = i.vec
                    , r = i.scale
                    , o = i.bearing;
                  if (!this._gestureIntent) {
                      var s = this._rotationDisabled && 1 !== r || Math.abs(1 - r) > .15;
                      Math.abs(o) > 10 ? this._gestureIntent = "rotate" : s && (this._gestureIntent = "zoom"),
                      this._gestureIntent && (this._map.fire(new e.Event(this._gestureIntent + "start",{
                          originalEvent: t
                      })),
                      this._map.fire(new e.Event("movestart",{
                          originalEvent: t
                      })),
                      this._startVec = n)
                  }
                  this._lastTouchEvent = t,
                  this._frameId || (this._frameId = this._map._requestRenderFrame(this._onTouchFrame)),
                  t.preventDefault()
              }
          }
          ,
          kn.prototype._onTouchFrame = function() {
              this._frameId = null;
              var t = this._gestureIntent;
              if (t) {
                  var i = this._map.transform;
                  this._startScale || (this._startScale = i.scale,
                  this._startBearing = i.bearing);
                  var n = this._getTouchEventData(this._lastTouchEvent)
                    , r = n.center
                    , o = n.bearing
                    , s = n.scale
                    , a = i.pointLocation(r)
                    , l = i.locationPoint(a);
                  "rotate" === t && (i.bearing = this._startBearing + o),
                  i.zoom = i.scaleZoom(this._startScale * s),
                  i.setLocationAtPoint(this._startAround, l),
                  this._map.fire(new e.Event(t,{
                      originalEvent: this._lastTouchEvent
                  })),
                  this._map.fire(new e.Event("move",{
                      originalEvent: this._lastTouchEvent
                  })),
                  this._drainInertiaBuffer(),
                  this._inertia.push([e.browser.now(), s, r])
              }
          }
          ,
          kn.prototype._onEnd = function(t) {
              i.removeEventListener(e.window.document, "touchmove", this._onMove, {
                  passive: !1
              }),
              i.removeEventListener(e.window.document, "touchend", this._onEnd);
              var n = this._gestureIntent
                , r = this._startScale;
              if (this._frameId && (this._map._cancelRenderFrame(this._frameId),
              this._frameId = null),
              delete this._gestureIntent,
              delete this._startScale,
              delete this._startBearing,
              delete this._lastTouchEvent,
              n) {
                  this._map.fire(new e.Event(n + "end",{
                      originalEvent: t
                  })),
                  this._drainInertiaBuffer();
                  var o = this._inertia
                    , s = this._map;
                  if (o.length < 2)
                      s.snapToNorth({}, {
                          originalEvent: t
                      });
                  else {
                      var a = o[o.length - 1]
                        , l = o[0]
                        , c = s.transform.scaleZoom(r * a[1])
                        , u = s.transform.scaleZoom(r * l[1])
                        , h = c - u
                        , d = (a[0] - l[0]) / 1e3
                        , p = a[2];
                      if (0 !== d && c !== u) {
                          var f = .15 * h / d;
                          Math.abs(f) > 2.5 && (f = f > 0 ? 2.5 : -2.5);
                          var m = 1e3 * Math.abs(f / (12 * .15))
                            , g = c + f * m / 2e3;
                          g < 0 && (g = 0),
                          s.easeTo({
                              zoom: g,
                              duration: m,
                              easing: xn,
                              around: this._aroundCenter ? s.getCenter() : s.unproject(p),
                              noMoveStart: !0
                          }, {
                              originalEvent: t
                          })
                      } else
                          s.snapToNorth({}, {
                              originalEvent: t
                          })
                  }
              }
          }
          ,
          kn.prototype._drainInertiaBuffer = function() {
              for (var t = this._inertia, i = e.browser.now(); t.length > 2 && i - t[0][0] > 160; )
                  t.shift()
          }
          ;
          var Sn = {
              scrollZoom: pn,
              boxZoom: fn,
              dragRotate: gn,
              dragPan: yn,
              keyboard: _n,
              doubleClickZoom: wn,
              touchZoomRotate: kn
          }
            , En = function(t) {
              function i(i, n) {
                  t.call(this),
                  this._moving = !1,
                  this._zooming = !1,
                  this.transform = i,
                  this._bearingSnap = n.bearingSnap,
                  e.bindAll(["_renderFrameCallback"], this)
              }
              return t && (i.__proto__ = t),
              i.prototype = Object.create(t && t.prototype),
              i.prototype.constructor = i,
              i.prototype.getCenter = function() {
                  return this.transform.center
              }
              ,
              i.prototype.setCenter = function(e, t) {
                  return this.jumpTo({
                      center: e
                  }, t)
              }
              ,
              i.prototype.panBy = function(t, i, n) {
                  return t = e.Point.convert(t).mult(-1),
                  this.panTo(this.transform.center, e.extend({
                      offset: t
                  }, i), n)
              }
              ,
              i.prototype.panTo = function(t, i, n) {
                  return this.easeTo(e.extend({
                      center: t
                  }, i), n)
              }
              ,
              i.prototype.getZoom = function() {
                  return this.transform.zoom
              }
              ,
              i.prototype.setZoom = function(e, t) {
                  return this.jumpTo({
                      zoom: e
                  }, t),
                  this
              }
              ,
              i.prototype.zoomTo = function(t, i, n) {
                  return this.easeTo(e.extend({
                      zoom: t
                  }, i), n)
              }
              ,
              i.prototype.zoomIn = function(e, t) {
                  return this.zoomTo(this.getZoom() + 1, e, t),
                  this
              }
              ,
              i.prototype.zoomOut = function(e, t) {
                  return this.zoomTo(this.getZoom() - 1, e, t),
                  this
              }
              ,
              i.prototype.getBearing = function() {
                  return this.transform.bearing
              }
              ,
              i.prototype.setBearing = function(e, t) {
                  return this.jumpTo({
                      bearing: e
                  }, t),
                  this
              }
              ,
              i.prototype.rotateTo = function(t, i, n) {
                  return this.easeTo(e.extend({
                      bearing: t
                  }, i), n)
              }
              ,
              i.prototype.resetNorth = function(t, i) {
                  return this.rotateTo(0, e.extend({
                      duration: 1e3
                  }, t), i),
                  this
              }
              ,
              i.prototype.snapToNorth = function(e, t) {
                  return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e, t) : this
              }
              ,
              i.prototype.getPitch = function() {
                  return this.transform.pitch
              }
              ,
              i.prototype.setPitch = function(e, t) {
                  return this.jumpTo({
                      pitch: e
                  }, t),
                  this
              }
              ,
              i.prototype.cameraForBounds = function(t, i) {
                  return t = e.LngLatBounds.convert(t),
                  this._cameraForBoxAndBearing(t.getNorthWest(), t.getSouthEast(), 0, i)
              }
              ,
              i.prototype._cameraForBoxAndBearing = function(t, i, n, r) {
                  if ("number" == typeof (r = e.extend({
                      padding: {
                          top: 0,
                          bottom: 0,
                          right: 0,
                          left: 0
                      },
                      offset: [0, 0],
                      maxZoom: this.transform.maxZoom
                  }, r)).padding) {
                      var o = r.padding;
                      r.padding = {
                          top: o,
                          bottom: o,
                          right: o,
                          left: o
                      }
                  }
                  if (e.isEqual(Object.keys(r.padding).sort(function(e, t) {
                      return e < t ? -1 : e > t ? 1 : 0
                  }), ["bottom", "left", "right", "top"])) {
                      var s = this.transform
                        , a = s.project(e.LngLat.convert(t))
                        , l = s.project(e.LngLat.convert(i))
                        , c = a.rotate(-n * Math.PI / 180)
                        , u = l.rotate(-n * Math.PI / 180)
                        , h = new e.Point(Math.max(c.x, u.x),Math.max(c.y, u.y))
                        , d = new e.Point(Math.min(c.x, u.x),Math.min(c.y, u.y))
                        , p = h.sub(d)
                        , f = (s.width - r.padding.left - r.padding.right) / p.x
                        , m = (s.height - r.padding.top - r.padding.bottom) / p.y;
                      if (!(m < 0 || f < 0)) {
                          var g = Math.min(s.scaleZoom(s.scale * Math.min(f, m)), r.maxZoom)
                            , v = e.Point.convert(r.offset)
                            , y = (r.padding.left - r.padding.right) / 2
                            , _ = (r.padding.top - r.padding.bottom) / 2
                            , b = new e.Point(v.x + y,v.y + _).mult(s.scale / s.zoomScale(g));
                          return {
                              center: s.unproject(a.add(l).div(2).sub(b)),
                              zoom: g,
                              bearing: n
                          }
                      }
                      e.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.")
                  } else
                      e.warnOnce("options.padding must be a positive number, or an Object with keys 'bottom', 'left', 'right', 'top'")
              }
              ,
              i.prototype.fitBounds = function(e, t, i) {
                  return this._fitInternal(this.cameraForBounds(e, t), t, i)
              }
              ,
              i.prototype.fitScreenCoordinates = function(t, i, n, r, o) {
                  return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(e.Point.convert(t)), this.transform.pointLocation(e.Point.convert(i)), n, r), r, o)
              }
              ,
              i.prototype._fitInternal = function(t, i, n) {
                  return t ? (i = e.extend(t, i)).linear ? this.easeTo(i, n) : this.flyTo(i, n) : this
              }
              ,
              i.prototype.jumpTo = function(t, i) {
                  this.stop();
                  var n = this.transform
                    , r = !1
                    , o = !1
                    , s = !1;
                  return "zoom"in t && n.zoom !== +t.zoom && (r = !0,
                  n.zoom = +t.zoom),
                  void 0 !== t.center && (n.center = e.LngLat.convert(t.center)),
                  "bearing"in t && n.bearing !== +t.bearing && (o = !0,
                  n.bearing = +t.bearing),
                  "pitch"in t && n.pitch !== +t.pitch && (s = !0,
                  n.pitch = +t.pitch),
                  this.fire(new e.Event("movestart",i)).fire(new e.Event("move",i)),
                  r && this.fire(new e.Event("zoomstart",i)).fire(new e.Event("zoom",i)).fire(new e.Event("zoomend",i)),
                  o && this.fire(new e.Event("rotatestart",i)).fire(new e.Event("rotate",i)).fire(new e.Event("rotateend",i)),
                  s && this.fire(new e.Event("pitchstart",i)).fire(new e.Event("pitch",i)).fire(new e.Event("pitchend",i)),
                  this.fire(new e.Event("moveend",i))
              }
              ,
              i.prototype.easeTo = function(t, i) {
                  var n = this;
                  this.stop(),
                  !1 === (t = e.extend({
                      offset: [0, 0],
                      duration: 500,
                      easing: e.ease
                  }, t)).animate && (t.duration = 0);
                  var r = this.transform
                    , o = this.getZoom()
                    , s = this.getBearing()
                    , a = this.getPitch()
                    , l = "zoom"in t ? +t.zoom : o
                    , c = "bearing"in t ? this._normalizeBearing(t.bearing, s) : s
                    , u = "pitch"in t ? +t.pitch : a
                    , h = r.centerPoint.add(e.Point.convert(t.offset))
                    , d = r.pointLocation(h)
                    , p = e.LngLat.convert(t.center || d);
                  this._normalizeCenter(p);
                  var f, m, g = r.project(d), v = r.project(p).sub(g), y = r.zoomScale(l - o);
                  return t.around && (f = e.LngLat.convert(t.around),
                  m = r.locationPoint(f)),
                  this._zooming = l !== o,
                  this._rotating = s !== c,
                  this._pitching = u !== a,
                  this._prepareEase(i, t.noMoveStart),
                  clearTimeout(this._easeEndTimeoutID),
                  this._ease(function(t) {
                      if (n._zooming && (r.zoom = e.number(o, l, t)),
                      n._rotating && (r.bearing = e.number(s, c, t)),
                      n._pitching && (r.pitch = e.number(a, u, t)),
                      f)
                          r.setLocationAtPoint(f, m);
                      else {
                          var d = r.zoomScale(r.zoom - o)
                            , p = l > o ? Math.min(2, y) : Math.max(.5, y)
                            , _ = Math.pow(p, 1 - t)
                            , b = r.unproject(g.add(v.mult(t * _)).mult(d));
                          r.setLocationAtPoint(r.renderWorldCopies ? b.wrap() : b, h)
                      }
                      n._fireMoveEvents(i)
                  }, function() {
                      t.delayEndEvents ? n._easeEndTimeoutID = setTimeout(function() {
                          return n._afterEase(i)
                      }, t.delayEndEvents) : n._afterEase(i)
                  }, t),
                  this
              }
              ,
              i.prototype._prepareEase = function(t, i) {
                  this._moving = !0,
                  i || this.fire(new e.Event("movestart",t)),
                  this._zooming && this.fire(new e.Event("zoomstart",t)),
                  this._rotating && this.fire(new e.Event("rotatestart",t)),
                  this._pitching && this.fire(new e.Event("pitchstart",t))
              }
              ,
              i.prototype._fireMoveEvents = function(t) {
                  this.fire(new e.Event("move",t)),
                  this._zooming && this.fire(new e.Event("zoom",t)),
                  this._rotating && this.fire(new e.Event("rotate",t)),
                  this._pitching && this.fire(new e.Event("pitch",t))
              }
              ,
              i.prototype._afterEase = function(t) {
                  var i = this._zooming
                    , n = this._rotating
                    , r = this._pitching;
                  this._moving = !1,
                  this._zooming = !1,
                  this._rotating = !1,
                  this._pitching = !1,
                  i && this.fire(new e.Event("zoomend",t)),
                  n && this.fire(new e.Event("rotateend",t)),
                  r && this.fire(new e.Event("pitchend",t)),
                  this.fire(new e.Event("moveend",t))
              }
              ,
              i.prototype.flyTo = function(t, i) {
                  var n = this;
                  this.stop(),
                  t = e.extend({
                      offset: [0, 0],
                      speed: 1.2,
                      curve: 1.42,
                      easing: e.ease
                  }, t);
                  var r = this.transform
                    , o = this.getZoom()
                    , s = this.getBearing()
                    , a = this.getPitch()
                    , l = "zoom"in t ? e.clamp(+t.zoom, r.minZoom, r.maxZoom) : o
                    , c = "bearing"in t ? this._normalizeBearing(t.bearing, s) : s
                    , u = "pitch"in t ? +t.pitch : a
                    , h = r.zoomScale(l - o)
                    , d = r.centerPoint.add(e.Point.convert(t.offset))
                    , p = r.pointLocation(d)
                    , f = e.LngLat.convert(t.center || p);
                  this._normalizeCenter(f);
                  var m = r.project(p)
                    , g = r.project(f).sub(m)
                    , v = t.curve
                    , y = Math.max(r.width, r.height)
                    , _ = y / h
                    , b = g.mag();
                  if ("minZoom"in t) {
                      var w = e.clamp(Math.min(t.minZoom, o, l), r.minZoom, r.maxZoom)
                        , x = y / r.zoomScale(w - o);
                      v = Math.sqrt(x / b * 2)
                  }
                  var k = v * v;
                  function S(e) {
                      var t = (_ * _ - y * y + (e ? -1 : 1) * k * k * b * b) / (2 * (e ? _ : y) * k * b);
                      return Math.log(Math.sqrt(t * t + 1) - t)
                  }
                  function E(e) {
                      return (Math.exp(e) - Math.exp(-e)) / 2
                  }
                  function T(e) {
                      return (Math.exp(e) + Math.exp(-e)) / 2
                  }
                  var C = S(0)
                    , L = function(e) {
                      return T(C) / T(C + v * e)
                  }
                    , A = function(e) {
                      return y * ((T(C) * (E(t = C + v * e) / T(t)) - E(C)) / k) / b;
                      var t
                  }
                    , P = (S(1) - C) / v;
                  if (Math.abs(b) < 1e-6 || !isFinite(P)) {
                      if (Math.abs(y - _) < 1e-6)
                          return this.easeTo(t, i);
                      var I = _ < y ? -1 : 1;
                      P = Math.abs(Math.log(_ / y)) / v,
                      A = function() {
                          return 0
                      }
                      ,
                      L = function(e) {
                          return Math.exp(I * v * e)
                      }
                  }
                  if ("duration"in t)
                      t.duration = +t.duration;
                  else {
                      var M = "screenSpeed"in t ? +t.screenSpeed / v : +t.speed;
                      t.duration = 1e3 * P / M
                  }
                  return t.maxDuration && t.duration > t.maxDuration && (t.duration = 0),
                  this._zooming = !0,
                  this._rotating = s !== c,
                  this._pitching = u !== a,
                  this._prepareEase(i, !1),
                  this._ease(function(t) {
                      var h = t * P
                        , p = 1 / L(h);
                      r.zoom = 1 === t ? l : o + r.scaleZoom(p),
                      n._rotating && (r.bearing = e.number(s, c, t)),
                      n._pitching && (r.pitch = e.number(a, u, t));
                      var v = 1 === t ? f : r.unproject(m.add(g.mult(A(h))).mult(p));
                      r.setLocationAtPoint(r.renderWorldCopies ? v.wrap() : v, d),
                      n._fireMoveEvents(i)
                  }, function() {
                      return n._afterEase(i)
                  }, t),
                  this
              }
              ,
              i.prototype.isEasing = function() {
                  return !!this._easeFrameId
              }
              ,
              i.prototype.stop = function() {
                  if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId),
                  delete this._easeFrameId,
                  delete this._onEaseFrame),
                  this._onEaseEnd) {
                      var e = this._onEaseEnd;
                      delete this._onEaseEnd,
                      e.call(this)
                  }
                  return this
              }
              ,
              i.prototype._ease = function(t, i, n) {
                  !1 === n.animate || 0 === n.duration ? (t(1),
                  i()) : (this._easeStart = e.browser.now(),
                  this._easeOptions = n,
                  this._onEaseFrame = t,
                  this._onEaseEnd = i,
                  this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback))
              }
              ,
              i.prototype._renderFrameCallback = function() {
                  var t = Math.min((e.browser.now() - this._easeStart) / this._easeOptions.duration, 1);
                  this._onEaseFrame(this._easeOptions.easing(t)),
                  t < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop()
              }
              ,
              i.prototype._normalizeBearing = function(t, i) {
                  t = e.wrap(t, -180, 180);
                  var n = Math.abs(t - i);
                  return Math.abs(t - 360 - i) < n && (t -= 360),
                  Math.abs(t + 360 - i) < n && (t += 360),
                  t
              }
              ,
              i.prototype._normalizeCenter = function(e) {
                  var t = this.transform;
                  if (t.renderWorldCopies && !t.lngRange) {
                      var i = e.lng - t.center.lng;
                      e.lng += i > 180 ? -360 : i < -180 ? 360 : 0
                  }
              }
              ,
              i
          }(e.Evented)
            , Tn = function(t) {
              void 0 === t && (t = {}),
              this.options = t,
              e.bindAll(["_updateEditLink", "_updateData", "_updateCompact"], this)
          };
          Tn.prototype.getDefaultPosition = function() {
              return "bottom-right"
          }
          ,
          Tn.prototype.onAdd = function(e) {
              var t = this.options && this.options.compact;
              return this._map = e,
              this._container = i.create("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"),
              this._innerContainer = i.create("div", "mapboxgl-ctrl-attrib-inner", this._container),
              t && this._container.classList.add("mapboxgl-compact"),
              this._updateAttributions(),
              this._updateEditLink(),
              this._map.on("styledata", this._updateData),
              this._map.on("sourcedata", this._updateData),
              this._map.on("moveend", this._updateEditLink),
              void 0 === t && (this._map.on("resize", this._updateCompact),
              this._updateCompact()),
              this._container
          }
          ,
          Tn.prototype.onRemove = function() {
              i.remove(this._container),
              this._map.off("styledata", this._updateData),
              this._map.off("sourcedata", this._updateData),
              this._map.off("moveend", this._updateEditLink),
              this._map.off("resize", this._updateCompact),
              this._map = void 0
          }
          ,
          Tn.prototype._updateEditLink = function() {
              var t = this._editLink;
              t || (t = this._editLink = this._container.querySelector(".mapbox-improve-map"));
              var i = [{
                  key: "owner",
                  value: this.styleOwner
              }, {
                  key: "id",
                  value: this.styleId
              }, {
                  key: "access_token",
                  value: e.config.ACCESS_TOKEN
              }];
              if (t) {
                  var n = i.reduce(function(e, t, n) {
                      return t.value && (e += t.key + "=" + t.value + (n < i.length - 1 ? "&" : "")),
                      e
                  }, "?");
                  t.href = e.config.FEEDBACK_URL + "/" + n + (this._map._hash ? this._map._hash.getHashString(!0) : "")
              }
          }
          ,
          Tn.prototype._updateData = function(e) {
              !e || "metadata" !== e.sourceDataType && "style" !== e.dataType || (this._updateAttributions(),
              this._updateEditLink())
          }
          ,
          Tn.prototype._updateAttributions = function() {
              if (this._map.style) {
                  var e = [];
                  if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e = e.concat(this.options.customAttribution.map(function(e) {
                      return "string" != typeof e ? "" : e
                  })) : "string" == typeof this.options.customAttribution && e.push(this.options.customAttribution)),
                  this._map.style.stylesheet) {
                      var t = this._map.style.stylesheet;
                      this.styleOwner = t.owner,
                      this.styleId = t.id
                  }
                  var i = this._map.style.sourceCaches;
                  for (var n in i) {
                      var r = i[n];
                      if (r.used) {
                          var o = r.getSource();
                          o.attribution && e.indexOf(o.attribution) < 0 && e.push(o.attribution)
                      }
                  }
                  e.sort(function(e, t) {
                      return e.length - t.length
                  }),
                  (e = e.filter(function(t, i) {
                      for (var n = i + 1; n < e.length; n++)
                          if (e[n].indexOf(t) >= 0)
                              return !1;
                      return !0
                  })).length ? (this._innerContainer.innerHTML = e.join(" | "),
                  this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"),
                  this._editLink = null
              }
          }
          ,
          Tn.prototype._updateCompact = function() {
              this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact")
          }
          ;
          var Cn = function() {
              e.bindAll(["_updateLogo"], this),
              e.bindAll(["_updateCompact"], this)
          };
          Cn.prototype.onAdd = function(e) {
              this._map = e,
              this._container = i.create("div", "mapboxgl-ctrl");
              var t = i.create("a", "mapboxgl-ctrl-logo");
              return t.target = "_blank",
              t.href = "https://www.mapbox.com/",
              t.setAttribute("aria-label", "Mapbox logo"),
              t.setAttribute("rel", "noopener"),
              this._container.appendChild(t),
              this._container.style.display = "none",
              this._map.on("sourcedata", this._updateLogo),
              this._updateLogo(),
              this._map.on("resize", this._updateCompact),
              this._updateCompact(),
              this._container
          }
          ,
          Cn.prototype.onRemove = function() {
              i.remove(this._container),
              this._map.off("sourcedata", this._updateLogo),
              this._map.off("resize", this._updateCompact)
          }
          ,
          Cn.prototype.getDefaultPosition = function() {
              return "bottom-left"
          }
          ,
          Cn.prototype._updateLogo = function(e) {
              e && "metadata" !== e.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none")
          }
          ,
          Cn.prototype._logoRequired = function() {
              if (this._map.style) {
                  var e = this._map.style.sourceCaches;
                  for (var t in e)
                      if (e[t].getSource().mapbox_logo)
                          return !0;
                  return !1
              }
          }
          ,
          Cn.prototype._updateCompact = function() {
              var e = this._container.children;
              if (e.length) {
                  var t = e[0];
                  this._map.getCanvasContainer().offsetWidth < 250 ? t.classList.add("mapboxgl-compact") : t.classList.remove("mapboxgl-compact")
              }
          }
          ;
          var Ln = function() {
              this._queue = [],
              this._id = 0,
              this._cleared = !1,
              this._currentlyRunning = !1
          };
          Ln.prototype.add = function(e) {
              var t = ++this._id;
              return this._queue.push({
                  callback: e,
                  id: t,
                  cancelled: !1
              }),
              t
          }
          ,
          Ln.prototype.remove = function(e) {
              for (var t = this._currentlyRunning, i = 0, n = t ? this._queue.concat(t) : this._queue; i < n.length; i += 1) {
                  var r = n[i];
                  if (r.id === e)
                      return void (r.cancelled = !0)
              }
          }
          ,
          Ln.prototype.run = function() {
              var e = this._currentlyRunning = this._queue;
              this._queue = [];
              for (var t = 0, i = e; t < i.length; t += 1) {
                  var n = i[t];
                  if (!n.cancelled && (n.callback(),
                  this._cleared))
                      break
              }
              this._cleared = !1,
              this._currentlyRunning = !1
          }
          ,
          Ln.prototype.clear = function() {
              this._currentlyRunning && (this._cleared = !0),
              this._queue = []
          }
          ;
          var An = e.window.HTMLImageElement
            , Pn = e.window.HTMLElement
            , In = {
              center: [0, 0],
              zoom: 0,
              bearing: 0,
              pitch: 0,
              minZoom: 0,
              maxZoom: 22,
              interactive: !0,
              scrollZoom: !0,
              boxZoom: !0,
              dragRotate: !0,
              dragPan: !0,
              keyboard: !0,
              doubleClickZoom: !0,
              touchZoomRotate: !0,
              bearingSnap: 7,
              clickTolerance: 3,
              hash: !1,
              attributionControl: !0,
              failIfMajorPerformanceCaveat: !1,
              preserveDrawingBuffer: !1,
              trackResize: !0,
              renderWorldCopies: !0,
              refreshExpiredTiles: !0,
              maxTileCacheSize: null,
              transformRequest: null,
              fadeDuration: 300,
              crossSourceCollisions: !0
          }
            , Mn = function(n) {
              function r(t) {
                  var r = this;
                  if (null != (t = e.extend({}, In, t)).minZoom && null != t.maxZoom && t.minZoom > t.maxZoom)
                      throw new Error("maxZoom must be greater than minZoom");
                  var o = new an(t.minZoom,t.maxZoom,t.renderWorldCopies);
                  n.call(this, o, t),
                  this._interactive = t.interactive,
                  this._maxTileCacheSize = t.maxTileCacheSize,
                  this._failIfMajorPerformanceCaveat = t.failIfMajorPerformanceCaveat,
                  this._preserveDrawingBuffer = t.preserveDrawingBuffer,
                  this._trackResize = t.trackResize,
                  this._bearingSnap = t.bearingSnap,
                  this._refreshExpiredTiles = t.refreshExpiredTiles,
                  this._fadeDuration = t.fadeDuration,
                  this._crossSourceCollisions = t.crossSourceCollisions,
                  this._crossFadingFactor = 1,
                  this._collectResourceTiming = t.collectResourceTiming,
                  this._renderTaskQueue = new Ln,
                  this._controls = [],
                  this._mapId = e.uniqueId();
                  var s = t.transformRequest;
                  if (this._transformRequest = s ? function(e, t) {
                      return s(e, t) || {
                          url: e
                      }
                  }
                  : function(e) {
                      return {
                          url: e
                      }
                  }
                  ,
                  "string" == typeof t.container) {
                      if (this._container = e.window.document.getElementById(t.container),
                      !this._container)
                          throw new Error("Container '" + t.container + "' not found.")
                  } else {
                      if (!(t.container instanceof Pn))
                          throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                      this._container = t.container
                  }
                  if (t.maxBounds && this.setMaxBounds(t.maxBounds),
                  e.bindAll(["_onWindowOnline", "_onWindowResize", "_contextLost", "_contextRestored"], this),
                  this._setupContainer(),
                  this._setupPainter(),
                  void 0 === this.painter)
                      throw new Error("Failed to initialize WebGL.");
                  this.on("move", function() {
                      return r._update(!1)
                  }),
                  this.on("moveend", function() {
                      return r._update(!1)
                  }),
                  this.on("zoom", function() {
                      return r._update(!0)
                  }),
                  void 0 !== e.window && (e.window.addEventListener("online", this._onWindowOnline, !1),
                  e.window.addEventListener("resize", this._onWindowResize, !1)),
                  function(e, t) {
                      var n = e.getCanvasContainer()
                        , r = null
                        , o = !1
                        , s = null;
                      for (var a in Sn)
                          e[a] = new Sn[a](e,t),
                          t.interactive && t[a] && e[a].enable(t[a]);
                      i.addEventListener(n, "mouseout", function(t) {
                          e.fire(new un("mouseout",e,t))
                      }),
                      i.addEventListener(n, "mousedown", function(r) {
                          o = !0,
                          s = i.mousePos(n, r);
                          var a = new un("mousedown",e,r);
                          e.fire(a),
                          a.defaultPrevented || (t.interactive && !e.doubleClickZoom.isActive() && e.stop(),
                          e.boxZoom.onMouseDown(r),
                          e.boxZoom.isActive() || e.dragPan.isActive() || e.dragRotate.onMouseDown(r),
                          e.boxZoom.isActive() || e.dragRotate.isActive() || e.dragPan.onMouseDown(r))
                      }),
                      i.addEventListener(n, "mouseup", function(t) {
                          var i = e.dragRotate.isActive();
                          r && !i && e.fire(new un("contextmenu",e,r)),
                          r = null,
                          o = !1,
                          e.fire(new un("mouseup",e,t))
                      }),
                      i.addEventListener(n, "mousemove", function(t) {
                          if (!e.dragPan.isActive() && !e.dragRotate.isActive()) {
                              for (var i = t.target; i && i !== n; )
                                  i = i.parentNode;
                              i === n && e.fire(new un("mousemove",e,t))
                          }
                      }),
                      i.addEventListener(n, "mouseover", function(t) {
                          for (var i = t.target; i && i !== n; )
                              i = i.parentNode;
                          i === n && e.fire(new un("mouseover",e,t))
                      }),
                      i.addEventListener(n, "touchstart", function(i) {
                          var n = new hn("touchstart",e,i);
                          e.fire(n),
                          n.defaultPrevented || (t.interactive && e.stop(),
                          e.boxZoom.isActive() || e.dragRotate.isActive() || e.dragPan.onTouchStart(i),
                          e.touchZoomRotate.onStart(i),
                          e.doubleClickZoom.onTouchStart(n))
                      }, {
                          passive: !1
                      }),
                      i.addEventListener(n, "touchmove", function(t) {
                          e.fire(new hn("touchmove",e,t))
                      }, {
                          passive: !1
                      }),
                      i.addEventListener(n, "touchend", function(t) {
                          e.fire(new hn("touchend",e,t))
                      }),
                      i.addEventListener(n, "touchcancel", function(t) {
                          e.fire(new hn("touchcancel",e,t))
                      }),
                      i.addEventListener(n, "click", function(r) {
                          var o = i.mousePos(n, r);
                          (o.equals(s) || o.dist(s) < t.clickTolerance) && e.fire(new un("click",e,r))
                      }),
                      i.addEventListener(n, "dblclick", function(t) {
                          var i = new un("dblclick",e,t);
                          e.fire(i),
                          i.defaultPrevented || e.doubleClickZoom.onDblClick(i)
                      }),
                      i.addEventListener(n, "contextmenu", function(t) {
                          var i = e.dragRotate.isActive();
                          o || i ? o && (r = t) : e.fire(new un("contextmenu",e,t)),
                          (e.dragRotate.isEnabled() || e.listens("contextmenu")) && t.preventDefault()
                      }),
                      i.addEventListener(n, "wheel", function(i) {
                          t.interactive && e.stop();
                          var n = new dn("wheel",e,i);
                          e.fire(n),
                          n.defaultPrevented || e.scrollZoom.onWheel(i)
                      }, {
                          passive: !1
                      })
                  }(this, t),
                  this._hash = t.hash && (new cn).addTo(this),
                  this._hash && this._hash._onHashChange() || (this.jumpTo({
                      center: t.center,
                      zoom: t.zoom,
                      bearing: t.bearing,
                      pitch: t.pitch
                  }),
                  t.bounds && (this.resize(),
                  this.fitBounds(t.bounds, e.extend({}, t.fitBoundsOptions, {
                      duration: 0
                  })))),
                  this.resize(),
                  t.style && this.setStyle(t.style, {
                      localIdeographFontFamily: t.localIdeographFontFamily
                  }),
                  t.attributionControl && this.addControl(new Tn({
                      customAttribution: t.customAttribution
                  })),
                  this.addControl(new Cn, t.logoPosition),
                  this.on("style.load", function() {
                      r.transform.unmodified && r.jumpTo(r.style.stylesheet)
                  }),
                  this.on("data", function(t) {
                      r._update("style" === t.dataType),
                      r.fire(new e.Event(t.dataType + "data",t))
                  }),
                  this.on("dataloading", function(t) {
                      r.fire(new e.Event(t.dataType + "dataloading",t))
                  })
              }
              n && (r.__proto__ = n),
              r.prototype = Object.create(n && n.prototype),
              r.prototype.constructor = r;
              var o = {
                  showTileBoundaries: {
                      configurable: !0
                  },
                  showCollisionBoxes: {
                      configurable: !0
                  },
                  showOverdrawInspector: {
                      configurable: !0
                  },
                  repaint: {
                      configurable: !0
                  },
                  vertices: {
                      configurable: !0
                  }
              };
              return r.prototype._getMapId = function() {
                  return this._mapId
              }
              ,
              r.prototype.addControl = function(t, i) {
                  if (void 0 === i && t.getDefaultPosition && (i = t.getDefaultPosition()),
                  void 0 === i && (i = "top-right"),
                  !t || !t.onAdd)
                      return this.fire(new e.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                  var n = t.onAdd(this);
                  this._controls.push(t);
                  var r = this._controlPositions[i];
                  return -1 !== i.indexOf("bottom") ? r.insertBefore(n, r.firstChild) : r.appendChild(n),
                  this
              }
              ,
              r.prototype.removeControl = function(t) {
                  if (!t || !t.onRemove)
                      return this.fire(new e.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                  var i = this._controls.indexOf(t);
                  return i > -1 && this._controls.splice(i, 1),
                  t.onRemove(this),
                  this
              }
              ,
              r.prototype.resize = function(t) {
                  var i = this._containerDimensions()
                    , n = i[0]
                    , r = i[1];
                  return this._resizeCanvas(n, r),
                  this.transform.resize(n, r),
                  this.painter.resize(n, r),
                  this.fire(new e.Event("movestart",t)).fire(new e.Event("move",t)).fire(new e.Event("resize",t)).fire(new e.Event("moveend",t)),
                  this
              }
              ,
              r.prototype.getBounds = function() {
                  return this.transform.getBounds()
              }
              ,
              r.prototype.getMaxBounds = function() {
                  return this.transform.getMaxBounds()
              }
              ,
              r.prototype.setMaxBounds = function(t) {
                  return this.transform.setMaxBounds(e.LngLatBounds.convert(t)),
                  this._update()
              }
              ,
              r.prototype.setMinZoom = function(e) {
                  if ((e = null == e ? 0 : e) >= 0 && e <= this.transform.maxZoom)
                      return this.transform.minZoom = e,
                      this._update(),
                      this.getZoom() < e && this.setZoom(e),
                      this;
                  throw new Error("minZoom must be between 0 and the current maxZoom, inclusive")
              }
              ,
              r.prototype.getMinZoom = function() {
                  return this.transform.minZoom
              }
              ,
              r.prototype.setMaxZoom = function(e) {
                  if ((e = null == e ? 22 : e) >= this.transform.minZoom)
                      return this.transform.maxZoom = e,
                      this._update(),
                      this.getZoom() > e && this.setZoom(e),
                      this;
                  throw new Error("maxZoom must be greater than the current minZoom")
              }
              ,
              r.prototype.getRenderWorldCopies = function() {
                  return this.transform.renderWorldCopies
              }
              ,
              r.prototype.setRenderWorldCopies = function(e) {
                  return this.transform.renderWorldCopies = e,
                  this._update()
              }
              ,
              r.prototype.getMaxZoom = function() {
                  return this.transform.maxZoom
              }
              ,
              r.prototype.project = function(t) {
                  return this.transform.locationPoint(e.LngLat.convert(t))
              }
              ,
              r.prototype.unproject = function(t) {
                  return this.transform.pointLocation(e.Point.convert(t))
              }
              ,
              r.prototype.isMoving = function() {
                  return this._moving || this.dragPan.isActive() || this.dragRotate.isActive() || this.scrollZoom.isActive()
              }
              ,
              r.prototype.isZooming = function() {
                  return this._zooming || this.scrollZoom.isZooming()
              }
              ,
              r.prototype.isRotating = function() {
                  return this._rotating || this.dragRotate.isActive()
              }
              ,
              r.prototype.on = function(e, t, i) {
                  var r = this;
                  if (void 0 === i)
                      return n.prototype.on.call(this, e, t);
                  var o = function() {
                      var n;
                      if ("mouseenter" === e || "mouseover" === e) {
                          var o = !1;
                          return {
                              layer: t,
                              listener: i,
                              delegates: {
                                  mousemove: function(n) {
                                      var s = r.getLayer(t) ? r.queryRenderedFeatures(n.point, {
                                          layers: [t]
                                      }) : [];
                                      s.length ? o || (o = !0,
                                      i.call(r, new un(e,r,n.originalEvent,{
                                          features: s
                                      }))) : o = !1
                                  },
                                  mouseout: function() {
                                      o = !1
                                  }
                              }
                          }
                      }
                      if ("mouseleave" === e || "mouseout" === e) {
                          var s = !1;
                          return {
                              layer: t,
                              listener: i,
                              delegates: {
                                  mousemove: function(n) {
                                      (r.getLayer(t) ? r.queryRenderedFeatures(n.point, {
                                          layers: [t]
                                      }) : []).length ? s = !0 : s && (s = !1,
                                      i.call(r, new un(e,r,n.originalEvent)))
                                  },
                                  mouseout: function(t) {
                                      s && (s = !1,
                                      i.call(r, new un(e,r,t.originalEvent)))
                                  }
                              }
                          }
                      }
                      return {
                          layer: t,
                          listener: i,
                          delegates: (n = {},
                          n[e] = function(e) {
                              var n = r.getLayer(t) ? r.queryRenderedFeatures(e.point, {
                                  layers: [t]
                              }) : [];
                              n.length && (e.features = n,
                              i.call(r, e),
                              delete e.features)
                          }
                          ,
                          n)
                      }
                  }();
                  for (var s in this._delegatedListeners = this._delegatedListeners || {},
                  this._delegatedListeners[e] = this._delegatedListeners[e] || [],
                  this._delegatedListeners[e].push(o),
                  o.delegates)
                      this.on(s, o.delegates[s]);
                  return this
              }
              ,
              r.prototype.off = function(e, t, i) {
                  if (void 0 === i)
                      return n.prototype.off.call(this, e, t);
                  if (this._delegatedListeners && this._delegatedListeners[e])
                      for (var r = this._delegatedListeners[e], o = 0; o < r.length; o++) {
                          var s = r[o];
                          if (s.layer === t && s.listener === i) {
                              for (var a in s.delegates)
                                  this.off(a, s.delegates[a]);
                              return r.splice(o, 1),
                              this
                          }
                      }
                  return this
              }
              ,
              r.prototype.queryRenderedFeatures = function(t, i) {
                  if (!this.style)
                      return [];
                  var n;
                  if (void 0 !== i || void 0 === t || t instanceof e.Point || Array.isArray(t) || (i = t,
                  t = void 0),
                  i = i || {},
                  (t = t || [[0, 0], [this.transform.width, this.transform.height]])instanceof e.Point || "number" == typeof t[0])
                      n = [e.Point.convert(t)];
                  else {
                      var r = e.Point.convert(t[0])
                        , o = e.Point.convert(t[1]);
                      n = [r, new e.Point(o.x,r.y), o, new e.Point(r.x,o.y), r]
                  }
                  return this.style.queryRenderedFeatures(n, i, this.transform)
              }
              ,
              r.prototype.querySourceFeatures = function(e, t) {
                  return this.style.querySourceFeatures(e, t)
              }
              ,
              r.prototype.setStyle = function(e, t) {
                  return (!t || !1 !== t.diff && !t.localIdeographFontFamily) && this.style && e ? (this._diffStyle(e, t),
                  this) : this._updateStyle(e, t)
              }
              ,
              r.prototype._updateStyle = function(e, t) {
                  return this.style && (this.style.setEventedParent(null),
                  this.style._remove()),
                  e ? (this.style = new Mt(this,t || {}),
                  this.style.setEventedParent(this, {
                      style: this.style
                  }),
                  "string" == typeof e ? this.style.loadURL(e) : this.style.loadJSON(e),
                  this) : (delete this.style,
                  this)
              }
              ,
              r.prototype._diffStyle = function(t, i) {
                  var n = this;
                  if ("string" == typeof t) {
                      var r = e.normalizeStyleURL(t)
                        , o = this._transformRequest(r, e.ResourceType.Style);
                      e.getJSON(o, function(t, r) {
                          t ? n.fire(new e.ErrorEvent(t)) : r && n._updateDiff(r, i)
                      })
                  } else
                      "object" == typeof t && this._updateDiff(t, i)
              }
              ,
              r.prototype._updateDiff = function(t, i) {
                  try {
                      this.style.setState(t) && this._update(!0)
                  } catch (n) {
                      e.warnOnce("Unable to perform style diff: " + (n.message || n.error || n) + ".  Rebuilding the style from scratch."),
                      this._updateStyle(t, i)
                  }
              }
              ,
              r.prototype.getStyle = function() {
                  if (this.style)
                      return this.style.serialize()
              }
              ,
              r.prototype.isStyleLoaded = function() {
                  return this.style ? this.style.loaded() : e.warnOnce("There is no style added to the map.")
              }
              ,
              r.prototype.addSource = function(e, t) {
                  return this.style.addSource(e, t),
                  this._update(!0)
              }
              ,
              r.prototype.isSourceLoaded = function(t) {
                  var i = this.style && this.style.sourceCaches[t];
                  if (void 0 !== i)
                      return i.loaded();
                  this.fire(new e.ErrorEvent(new Error("There is no source with ID '" + t + "'")))
              }
              ,
              r.prototype.areTilesLoaded = function() {
                  var e = this.style && this.style.sourceCaches;
                  for (var t in e) {
                      var i = e[t]._tiles;
                      for (var n in i) {
                          var r = i[n];
                          if ("loaded" !== r.state && "errored" !== r.state)
                              return !1
                      }
                  }
                  return !0
              }
              ,
              r.prototype.addSourceType = function(e, t, i) {
                  return this.style.addSourceType(e, t, i)
              }
              ,
              r.prototype.removeSource = function(e) {
                  return this.style.removeSource(e),
                  this._update(!0)
              }
              ,
              r.prototype.getSource = function(e) {
                  return this.style.getSource(e)
              }
              ,
              r.prototype.addImage = function(t, i, n) {
                  void 0 === n && (n = {});
                  var r = n.pixelRatio;
                  void 0 === r && (r = 1);
                  var o = n.sdf;
                  if (void 0 === o && (o = !1),
                  i instanceof An) {
                      var s = e.browser.getImageData(i)
                        , a = s.width
                        , l = s.height
                        , c = s.data;
                      this.style.addImage(t, {
                          data: new e.RGBAImage({
                              width: a,
                              height: l
                          },c),
                          pixelRatio: r,
                          sdf: o
                      })
                  } else {
                      if (void 0 === i.width || void 0 === i.height)
                          return this.fire(new e.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                      var u = i.width
                        , h = i.height
                        , d = i.data;
                      this.style.addImage(t, {
                          data: new e.RGBAImage({
                              width: u,
                              height: h
                          },new Uint8Array(d)),
                          pixelRatio: r,
                          sdf: o
                      })
                  }
              }
              ,
              r.prototype.hasImage = function(t) {
                  return t ? !!this.style.getImage(t) : (this.fire(new e.ErrorEvent(new Error("Missing required image id"))),
                  !1)
              }
              ,
              r.prototype.removeImage = function(e) {
                  this.style.removeImage(e)
              }
              ,
              r.prototype.loadImage = function(t, i) {
                  e.getImage(this._transformRequest(t, e.ResourceType.Image), i)
              }
              ,
              r.prototype.listImages = function() {
                  return this.style.listImages()
              }
              ,
              r.prototype.addLayer = function(e, t) {
                  return this.style.addLayer(e, t),
                  this._update(!0)
              }
              ,
              r.prototype.moveLayer = function(e, t) {
                  return this.style.moveLayer(e, t),
                  this._update(!0)
              }
              ,
              r.prototype.removeLayer = function(e) {
                  return this.style.removeLayer(e),
                  this._update(!0)
              }
              ,
              r.prototype.getLayer = function(e) {
                  return this.style.getLayer(e)
              }
              ,
              r.prototype.setFilter = function(e, t, i) {
                  return void 0 === i && (i = {}),
                  this.style.setFilter(e, t, i),
                  this._update(!0)
              }
              ,
              r.prototype.setLayerZoomRange = function(e, t, i) {
                  return this.style.setLayerZoomRange(e, t, i),
                  this._update(!0)
              }
              ,
              r.prototype.getFilter = function(e) {
                  return this.style.getFilter(e)
              }
              ,
              r.prototype.setPaintProperty = function(e, t, i, n) {
                  return void 0 === n && (n = {}),
                  this.style.setPaintProperty(e, t, i, n),
                  this._update(!0)
              }
              ,
              r.prototype.getPaintProperty = function(e, t) {
                  return this.style.getPaintProperty(e, t)
              }
              ,
              r.prototype.setLayoutProperty = function(e, t, i, n) {
                  return void 0 === n && (n = {}),
                  this.style.setLayoutProperty(e, t, i, n),
                  this._update(!0)
              }
              ,
              r.prototype.getLayoutProperty = function(e, t) {
                  return this.style.getLayoutProperty(e, t)
              }
              ,
              r.prototype.setLight = function(e, t) {
                  return void 0 === t && (t = {}),
                  this.style.setLight(e, t),
                  this._update(!0)
              }
              ,
              r.prototype.getLight = function() {
                  return this.style.getLight()
              }
              ,
              r.prototype.setFeatureState = function(e, t) {
                  return this.style.setFeatureState(e, t),
                  this._update()
              }
              ,
              r.prototype.removeFeatureState = function(e, t) {
                  return this.style.removeFeatureState(e, t),
                  this._update()
              }
              ,
              r.prototype.getFeatureState = function(e) {
                  return this.style.getFeatureState(e)
              }
              ,
              r.prototype.getContainer = function() {
                  return this._container
              }
              ,
              r.prototype.getCanvasContainer = function() {
                  return this._canvasContainer
              }
              ,
              r.prototype.getCanvas = function() {
                  return this._canvas
              }
              ,
              r.prototype._containerDimensions = function() {
                  var e = 0
                    , t = 0;
                  return this._container && (e = this._container.clientWidth || 400,
                  t = this._container.clientHeight || 300),
                  [e, t]
              }
              ,
              r.prototype._detectMissingCSS = function() {
                  "rgb(250, 128, 114)" !== e.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && e.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.")
              }
              ,
              r.prototype._setupContainer = function() {
                  var e = this._container;
                  e.classList.add("mapboxgl-map"),
                  (this._missingCSSCanary = i.create("div", "mapboxgl-canary", e)).style.visibility = "hidden",
                  this._detectMissingCSS();
                  var t = this._canvasContainer = i.create("div", "mapboxgl-canvas-container", e);
                  this._interactive && t.classList.add("mapboxgl-interactive"),
                  this._canvas = i.create("canvas", "mapboxgl-canvas", t),
                  this._canvas.style.position = "absolute",
                  this._canvas.addEventListener("webglcontextlost", this._contextLost, !1),
                  this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1),
                  this._canvas.setAttribute("tabindex", "0"),
                  this._canvas.setAttribute("aria-label", "Map");
                  var n = this._containerDimensions();
                  this._resizeCanvas(n[0], n[1]);
                  var r = this._controlContainer = i.create("div", "mapboxgl-control-container", e)
                    , o = this._controlPositions = {};
                  ["top-left", "top-right", "bottom-left", "bottom-right"].forEach(function(e) {
                      o[e] = i.create("div", "mapboxgl-ctrl-" + e, r)
                  })
              }
              ,
              r.prototype._resizeCanvas = function(t, i) {
                  var n = e.window.devicePixelRatio || 1;
                  this._canvas.width = n * t,
                  this._canvas.height = n * i,
                  this._canvas.style.width = t + "px",
                  this._canvas.style.height = i + "px"
              }
              ,
              r.prototype._setupPainter = function() {
                  var i = e.extend({
                      failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                      preserveDrawingBuffer: this._preserveDrawingBuffer
                  }, t.webGLContextAttributes)
                    , n = this._canvas.getContext("webgl", i) || this._canvas.getContext("experimental-webgl", i);
                  n ? (this.painter = new nn(n,this.transform),
                  e.webpSupported.testSupport(n)) : this.fire(new e.ErrorEvent(new Error("Failed to initialize WebGL")))
              }
              ,
              r.prototype._contextLost = function(t) {
                  t.preventDefault(),
                  this._frame && (this._frame.cancel(),
                  this._frame = null),
                  this.fire(new e.Event("webglcontextlost",{
                      originalEvent: t
                  }))
              }
              ,
              r.prototype._contextRestored = function(t) {
                  this._setupPainter(),
                  this.resize(),
                  this._update(),
                  this.fire(new e.Event("webglcontextrestored",{
                      originalEvent: t
                  }))
              }
              ,
              r.prototype.loaded = function() {
                  return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded()
              }
              ,
              r.prototype._update = function(e) {
                  return this.style ? (this._styleDirty = this._styleDirty || e,
                  this._sourcesDirty = !0,
                  this.triggerRepaint(),
                  this) : this
              }
              ,
              r.prototype._requestRenderFrame = function(e) {
                  return this._update(),
                  this._renderTaskQueue.add(e)
              }
              ,
              r.prototype._cancelRenderFrame = function(e) {
                  this._renderTaskQueue.remove(e)
              }
              ,
              r.prototype._render = function() {
                  this.painter.context.setDirty(),
                  this.painter.setBaseState(),
                  this._renderTaskQueue.run();
                  var t = !1;
                  if (this.style && this._styleDirty) {
                      this._styleDirty = !1;
                      var i = this.transform.zoom
                        , n = e.browser.now();
                      this.style.zoomHistory.update(i, n);
                      var r = new e.EvaluationParameters(i,{
                          now: n,
                          fadeDuration: this._fadeDuration,
                          zoomHistory: this.style.zoomHistory,
                          transition: this.style.getTransition()
                      })
                        , o = r.crossFadingFactor();
                      1 === o && o === this._crossFadingFactor || (t = !0,
                      this._crossFadingFactor = o),
                      this.style.update(r)
                  }
                  return this.style && this._sourcesDirty && (this._sourcesDirty = !1,
                  this.style._updateSources(this.transform)),
                  this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, this._fadeDuration, this._crossSourceCollisions),
                  this.painter.render(this.style, {
                      showTileBoundaries: this.showTileBoundaries,
                      showOverdrawInspector: this._showOverdrawInspector,
                      rotating: this.isRotating(),
                      zooming: this.isZooming(),
                      moving: this.isMoving(),
                      fadeDuration: this._fadeDuration
                  }),
                  this.fire(new e.Event("render")),
                  this.loaded() && !this._loaded && (this._loaded = !0,
                  this.fire(new e.Event("load"))),
                  this.style && (this.style.hasTransitions() || t) && (this._styleDirty = !0),
                  this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(),
                  this._sourcesDirty || this._repaint || this._styleDirty || this._placementDirty ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new e.Event("idle")),
                  this
              }
              ,
              r.prototype.remove = function() {
                  this._hash && this._hash.remove();
                  for (var t = 0, i = this._controls; t < i.length; t += 1)
                      i[t].onRemove(this);
                  this._controls = [],
                  this._frame && (this._frame.cancel(),
                  this._frame = null),
                  this._renderTaskQueue.clear(),
                  this.setStyle(null),
                  void 0 !== e.window && (e.window.removeEventListener("resize", this._onWindowResize, !1),
                  e.window.removeEventListener("online", this._onWindowOnline, !1));
                  var n = this.painter.context.gl.getExtension("WEBGL_lose_context");
                  n && n.loseContext(),
                  On(this._canvasContainer),
                  On(this._controlContainer),
                  On(this._missingCSSCanary),
                  this._container.classList.remove("mapboxgl-map"),
                  this.fire(new e.Event("remove"))
              }
              ,
              r.prototype.triggerRepaint = function() {
                  var t = this;
                  this.style && !this._frame && (this._frame = e.browser.frame(function() {
                      t._frame = null,
                      t._render()
                  }))
              }
              ,
              r.prototype._onWindowOnline = function() {
                  this._update()
              }
              ,
              r.prototype._onWindowResize = function() {
                  this._trackResize && this.resize()._update()
              }
              ,
              o.showTileBoundaries.get = function() {
                  return !!this._showTileBoundaries
              }
              ,
              o.showTileBoundaries.set = function(e) {
                  this._showTileBoundaries !== e && (this._showTileBoundaries = e,
                  this._update())
              }
              ,
              o.showCollisionBoxes.get = function() {
                  return !!this._showCollisionBoxes
              }
              ,
              o.showCollisionBoxes.set = function(e) {
                  this._showCollisionBoxes !== e && (this._showCollisionBoxes = e,
                  e ? this.style._generateCollisionBoxes() : this._update())
              }
              ,
              o.showOverdrawInspector.get = function() {
                  return !!this._showOverdrawInspector
              }
              ,
              o.showOverdrawInspector.set = function(e) {
                  this._showOverdrawInspector !== e && (this._showOverdrawInspector = e,
                  this._update())
              }
              ,
              o.repaint.get = function() {
                  return !!this._repaint
              }
              ,
              o.repaint.set = function(e) {
                  this._repaint !== e && (this._repaint = e,
                  this.triggerRepaint())
              }
              ,
              o.vertices.get = function() {
                  return !!this._vertices
              }
              ,
              o.vertices.set = function(e) {
                  this._vertices = e,
                  this._update()
              }
              ,
              Object.defineProperties(r.prototype, o),
              r
          }(En);
          function On(e) {
              e.parentNode && e.parentNode.removeChild(e)
          }
          var zn = {
              showCompass: !0,
              showZoom: !0
          }
            , Dn = function(t) {
              var n = this;
              this.options = e.extend({}, zn, t),
              this._container = i.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"),
              this._container.addEventListener("contextmenu", function(e) {
                  return e.preventDefault()
              }),
              this.options.showZoom && (this._zoomInButton = this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-in", "Zoom in", function() {
                  return n._map.zoomIn()
              }),
              this._zoomOutButton = this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-out", "Zoom out", function() {
                  return n._map.zoomOut()
              })),
              this.options.showCompass && (e.bindAll(["_rotateCompassArrow"], this),
              this._compass = this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-compass", "Reset bearing to north", function() {
                  return n._map.resetNorth()
              }),
              this._compassArrow = i.create("span", "mapboxgl-ctrl-compass-arrow", this._compass))
          };
          function Rn(t, i, n) {
              if (t = new e.LngLat(t.lng,t.lat),
              i) {
                  var r = new e.LngLat(t.lng - 360,t.lat)
                    , o = new e.LngLat(t.lng + 360,t.lat)
                    , s = n.locationPoint(t).distSqr(i);
                  n.locationPoint(r).distSqr(i) < s ? t = r : n.locationPoint(o).distSqr(i) < s && (t = o)
              }
              for (; Math.abs(t.lng - n.center.lng) > 180; ) {
                  var a = n.locationPoint(t);
                  if (a.x >= 0 && a.y >= 0 && a.x <= n.width && a.y <= n.height)
                      break;
                  t.lng > n.center.lng ? t.lng -= 360 : t.lng += 360
              }
              return t
          }
          Dn.prototype._rotateCompassArrow = function() {
              var e = "rotate(" + this._map.transform.angle * (180 / Math.PI) + "deg)";
              this._compassArrow.style.transform = e
          }
          ,
          Dn.prototype.onAdd = function(e) {
              return this._map = e,
              this.options.showCompass && (this._map.on("rotate", this._rotateCompassArrow),
              this._rotateCompassArrow(),
              this._handler = new gn(e,{
                  button: "left",
                  element: this._compass
              }),
              i.addEventListener(this._compass, "mousedown", this._handler.onMouseDown),
              this._handler.enable()),
              this._container
          }
          ,
          Dn.prototype.onRemove = function() {
              i.remove(this._container),
              this.options.showCompass && (this._map.off("rotate", this._rotateCompassArrow),
              i.removeEventListener(this._compass, "mousedown", this._handler.onMouseDown),
              this._handler.disable(),
              delete this._handler),
              delete this._map
          }
          ,
          Dn.prototype._createButton = function(e, t, n) {
              var r = i.create("button", e, this._container);
              return r.type = "button",
              r.title = t,
              r.setAttribute("aria-label", t),
              r.addEventListener("click", n),
              r
          }
          ;
          var Bn = {
              center: "translate(-50%,-50%)",
              top: "translate(-50%,0)",
              "top-left": "translate(0,0)",
              "top-right": "translate(-100%,0)",
              bottom: "translate(-50%,-100%)",
              "bottom-left": "translate(0,-100%)",
              "bottom-right": "translate(-100%,-100%)",
              left: "translate(0,-50%)",
              right: "translate(-100%,-50%)"
          };
          function jn(e, t, i) {
              var n = e.classList;
              for (var r in Bn)
                  n.remove("mapboxgl-" + i + "-anchor-" + r);
              n.add("mapboxgl-" + i + "-anchor-" + t)
          }
          var Fn, Nn = function(t) {
              function n(n, r) {
                  if (t.call(this),
                  (n instanceof e.window.HTMLElement || r) && (n = e.extend({
                      element: n
                  }, r)),
                  e.bindAll(["_update", "_onMove", "_onUp", "_addDragHandler", "_onMapClick"], this),
                  this._anchor = n && n.anchor || "center",
                  this._color = n && n.color || "#3FB1CE",
                  this._draggable = n && n.draggable || !1,
                  this._state = "inactive",
                  n && n.element)
                      this._element = n.element,
                      this._offset = e.Point.convert(n && n.offset || [0, 0]);
                  else {
                      this._defaultMarker = !0,
                      this._element = i.create("div");
                      var o = i.createNS("http://www.w3.org/2000/svg", "svg");
                      o.setAttributeNS(null, "height", "41px"),
                      o.setAttributeNS(null, "width", "27px"),
                      o.setAttributeNS(null, "viewBox", "0 0 27 41");
                      var s = i.createNS("http://www.w3.org/2000/svg", "g");
                      s.setAttributeNS(null, "stroke", "none"),
                      s.setAttributeNS(null, "stroke-width", "1"),
                      s.setAttributeNS(null, "fill", "none"),
                      s.setAttributeNS(null, "fill-rule", "evenodd");
                      var a = i.createNS("http://www.w3.org/2000/svg", "g");
                      a.setAttributeNS(null, "fill-rule", "nonzero");
                      var l = i.createNS("http://www.w3.org/2000/svg", "g");
                      l.setAttributeNS(null, "transform", "translate(3.0, 29.0)"),
                      l.setAttributeNS(null, "fill", "#000000");
                      for (var c = 0, u = [{
                          rx: "10.5",
                          ry: "5.25002273"
                      }, {
                          rx: "10.5",
                          ry: "5.25002273"
                      }, {
                          rx: "9.5",
                          ry: "4.77275007"
                      }, {
                          rx: "8.5",
                          ry: "4.29549936"
                      }, {
                          rx: "7.5",
                          ry: "3.81822308"
                      }, {
                          rx: "6.5",
                          ry: "3.34094679"
                      }, {
                          rx: "5.5",
                          ry: "2.86367051"
                      }, {
                          rx: "4.5",
                          ry: "2.38636864"
                      }]; c < u.length; c += 1) {
                          var h = u[c]
                            , d = i.createNS("http://www.w3.org/2000/svg", "ellipse");
                          d.setAttributeNS(null, "opacity", "0.04"),
                          d.setAttributeNS(null, "cx", "10.5"),
                          d.setAttributeNS(null, "cy", "5.80029008"),
                          d.setAttributeNS(null, "rx", h.rx),
                          d.setAttributeNS(null, "ry", h.ry),
                          l.appendChild(d)
                      }
                      var p = i.createNS("http://www.w3.org/2000/svg", "g");
                      p.setAttributeNS(null, "fill", this._color);
                      var f = i.createNS("http://www.w3.org/2000/svg", "path");
                      f.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"),
                      p.appendChild(f);
                      var m = i.createNS("http://www.w3.org/2000/svg", "g");
                      m.setAttributeNS(null, "opacity", "0.25"),
                      m.setAttributeNS(null, "fill", "#000000");
                      var g = i.createNS("http://www.w3.org/2000/svg", "path");
                      g.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"),
                      m.appendChild(g);
                      var v = i.createNS("http://www.w3.org/2000/svg", "g");
                      v.setAttributeNS(null, "transform", "translate(6.0, 7.0)"),
                      v.setAttributeNS(null, "fill", "#FFFFFF");
                      var y = i.createNS("http://www.w3.org/2000/svg", "g");
                      y.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                      var _ = i.createNS("http://www.w3.org/2000/svg", "circle");
                      _.setAttributeNS(null, "fill", "#000000"),
                      _.setAttributeNS(null, "opacity", "0.25"),
                      _.setAttributeNS(null, "cx", "5.5"),
                      _.setAttributeNS(null, "cy", "5.5"),
                      _.setAttributeNS(null, "r", "5.4999962");
                      var b = i.createNS("http://www.w3.org/2000/svg", "circle");
                      b.setAttributeNS(null, "fill", "#FFFFFF"),
                      b.setAttributeNS(null, "cx", "5.5"),
                      b.setAttributeNS(null, "cy", "5.5"),
                      b.setAttributeNS(null, "r", "5.4999962"),
                      y.appendChild(_),
                      y.appendChild(b),
                      a.appendChild(l),
                      a.appendChild(p),
                      a.appendChild(m),
                      a.appendChild(v),
                      a.appendChild(y),
                      o.appendChild(a),
                      this._element.appendChild(o),
                      this._offset = e.Point.convert(n && n.offset || [0, -14])
                  }
                  this._element.classList.add("mapboxgl-marker"),
                  this._popup = null
              }
              return t && (n.__proto__ = t),
              n.prototype = Object.create(t && t.prototype),
              n.prototype.constructor = n,
              n.prototype.addTo = function(e) {
                  return this.remove(),
                  this._map = e,
                  e.getCanvasContainer().appendChild(this._element),
                  e.on("move", this._update),
                  e.on("moveend", this._update),
                  this.setDraggable(this._draggable),
                  this._update(),
                  this._map.on("click", this._onMapClick),
                  this
              }
              ,
              n.prototype.remove = function() {
                  return this._map && (this._map.off("click", this._onMapClick),
                  this._map.off("move", this._update),
                  this._map.off("moveend", this._update),
                  this._map.off("mousedown", this._addDragHandler),
                  this._map.off("touchstart", this._addDragHandler),
                  this._map.off("mouseup", this._onUp),
                  this._map.off("touchend", this._onUp),
                  delete this._map),
                  i.remove(this._element),
                  this._popup && this._popup.remove(),
                  this
              }
              ,
              n.prototype.getLngLat = function() {
                  return this._lngLat
              }
              ,
              n.prototype.setLngLat = function(t) {
                  return this._lngLat = e.LngLat.convert(t),
                  this._pos = null,
                  this._popup && this._popup.setLngLat(this._lngLat),
                  this._update(),
                  this
              }
              ,
              n.prototype.getElement = function() {
                  return this._element
              }
              ,
              n.prototype.setPopup = function(e) {
                  if (this._popup && (this._popup.remove(),
                  this._popup = null),
                  e) {
                      if (!("offset"in e.options)) {
                          var t = Math.sqrt(Math.pow(13.5, 2) / 2);
                          e.options.offset = this._defaultMarker ? {
                              top: [0, 0],
                              "top-left": [0, 0],
                              "top-right": [0, 0],
                              bottom: [0, -38.1],
                              "bottom-left": [t, -1 * (24.6 + t)],
                              "bottom-right": [-t, -1 * (24.6 + t)],
                              left: [13.5, -24.6],
                              right: [-13.5, -24.6]
                          } : this._offset
                      }
                      this._popup = e,
                      this._lngLat && this._popup.setLngLat(this._lngLat)
                  }
                  return this
              }
              ,
              n.prototype._onMapClick = function(e) {
                  var t = e.originalEvent.target
                    , i = this._element;
                  this._popup && (t === i || i.contains(t)) && this.togglePopup()
              }
              ,
              n.prototype.getPopup = function() {
                  return this._popup
              }
              ,
              n.prototype.togglePopup = function() {
                  var e = this._popup;
                  return e ? (e.isOpen() ? e.remove() : e.addTo(this._map),
                  this) : this
              }
              ,
              n.prototype._update = function(e) {
                  this._map && (this._map.transform.renderWorldCopies && (this._lngLat = Rn(this._lngLat, this._pos, this._map.transform)),
                  this._pos = this._map.project(this._lngLat)._add(this._offset),
                  e && "moveend" !== e.type || (this._pos = this._pos.round()),
                  i.setTransform(this._element, Bn[this._anchor] + " translate(" + this._pos.x + "px, " + this._pos.y + "px)"),
                  jn(this._element, this._anchor, "marker"))
              }
              ,
              n.prototype.getOffset = function() {
                  return this._offset
              }
              ,
              n.prototype.setOffset = function(t) {
                  return this._offset = e.Point.convert(t),
                  this._update(),
                  this
              }
              ,
              n.prototype._onMove = function(t) {
                  this._pos = t.point.sub(this._positionDelta),
                  this._lngLat = this._map.unproject(this._pos),
                  this.setLngLat(this._lngLat),
                  this._element.style.pointerEvents = "none",
                  "pending" === this._state && (this._state = "active",
                  this.fire(new e.Event("dragstart"))),
                  this.fire(new e.Event("drag"))
              }
              ,
              n.prototype._onUp = function() {
                  this._element.style.pointerEvents = "auto",
                  this._positionDelta = null,
                  this._map.off("mousemove", this._onMove),
                  this._map.off("touchmove", this._onMove),
                  "active" === this._state && this.fire(new e.Event("dragend")),
                  this._state = "inactive"
              }
              ,
              n.prototype._addDragHandler = function(e) {
                  this._element.contains(e.originalEvent.target) && (e.preventDefault(),
                  this._positionDelta = e.point.sub(this._pos).add(this._offset),
                  this._state = "pending",
                  this._map.on("mousemove", this._onMove),
                  this._map.on("touchmove", this._onMove),
                  this._map.once("mouseup", this._onUp),
                  this._map.once("touchend", this._onUp))
              }
              ,
              n.prototype.setDraggable = function(e) {
                  return this._draggable = !!e,
                  this._map && (e ? (this._map.on("mousedown", this._addDragHandler),
                  this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler),
                  this._map.off("touchstart", this._addDragHandler))),
                  this
              }
              ,
              n.prototype.isDraggable = function() {
                  return this._draggable
              }
              ,
              n
          }(e.Evented), Un = {
              positionOptions: {
                  enableHighAccuracy: !1,
                  maximumAge: 0,
                  timeout: 6e3
              },
              fitBoundsOptions: {
                  maxZoom: 15
              },
              trackUserLocation: !1,
              showUserLocation: !0
          }, qn = function(t) {
              function n(i) {
                  t.call(this),
                  this.options = e.extend({}, Un, i),
                  e.bindAll(["_onSuccess", "_onError", "_finish", "_setupUI", "_updateCamera", "_updateMarker"], this)
              }
              return t && (n.__proto__ = t),
              n.prototype = Object.create(t && t.prototype),
              n.prototype.constructor = n,
              n.prototype.onAdd = function(t) {
                  var n;
                  return this._map = t,
                  this._container = i.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"),
                  n = this._setupUI,
                  void 0 !== Fn ? n(Fn) : void 0 !== e.window.navigator.permissions ? e.window.navigator.permissions.query({
                      name: "geolocation"
                  }).then(function(e) {
                      Fn = "denied" !== e.state,
                      n(Fn)
                  }) : (Fn = !!e.window.navigator.geolocation,
                  n(Fn)),
                  this._container
              }
              ,
              n.prototype.onRemove = function() {
                  void 0 !== this._geolocationWatchID && (e.window.navigator.geolocation.clearWatch(this._geolocationWatchID),
                  this._geolocationWatchID = void 0),
                  this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(),
                  i.remove(this._container),
                  this._map = void 0
              }
              ,
              n.prototype._onSuccess = function(t) {
                  if (this.options.trackUserLocation)
                      switch (this._lastKnownPosition = t,
                      this._watchState) {
                      case "WAITING_ACTIVE":
                      case "ACTIVE_LOCK":
                      case "ACTIVE_ERROR":
                          this._watchState = "ACTIVE_LOCK",
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),
                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                          break;
                      case "BACKGROUND":
                      case "BACKGROUND_ERROR":
                          this._watchState = "BACKGROUND",
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),
                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background")
                      }
                  this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t),
                  this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(t),
                  this.options.showUserLocation && this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"),
                  this.fire(new e.Event("geolocate",t)),
                  this._finish()
              }
              ,
              n.prototype._updateCamera = function(t) {
                  var i = new e.LngLat(t.coords.longitude,t.coords.latitude)
                    , n = t.coords.accuracy;
                  this._map.fitBounds(i.toBounds(n), this.options.fitBoundsOptions, {
                      geolocateSource: !0
                  })
              }
              ,
              n.prototype._updateMarker = function(e) {
                  e ? this._userLocationDotMarker.setLngLat([e.coords.longitude, e.coords.latitude]).addTo(this._map) : this._userLocationDotMarker.remove()
              }
              ,
              n.prototype._onError = function(t) {
                  if (this.options.trackUserLocation)
                      if (1 === t.code)
                          this._watchState = "OFF",
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),
                          void 0 !== this._geolocationWatchID && this._clearWatch();
                      else
                          switch (this._watchState) {
                          case "WAITING_ACTIVE":
                              this._watchState = "ACTIVE_ERROR",
                              this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),
                              this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                              break;
                          case "ACTIVE_LOCK":
                              this._watchState = "ACTIVE_ERROR",
                              this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),
                              this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"),
                              this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                              break;
                          case "BACKGROUND":
                              this._watchState = "BACKGROUND_ERROR",
                              this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),
                              this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"),
                              this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting")
                          }
                  "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("mapboxgl-user-location-dot-stale"),
                  this.fire(new e.Event("error",t)),
                  this._finish()
              }
              ,
              n.prototype._finish = function() {
                  this._timeoutId && clearTimeout(this._timeoutId),
                  this._timeoutId = void 0
              }
              ,
              n.prototype._setupUI = function(t) {
                  var n = this;
                  !1 !== t ? (this._container.addEventListener("contextmenu", function(e) {
                      return e.preventDefault()
                  }),
                  this._geolocateButton = i.create("button", "mapboxgl-ctrl-icon mapboxgl-ctrl-geolocate", this._container),
                  this._geolocateButton.type = "button",
                  this._geolocateButton.setAttribute("aria-label", "Geolocate"),
                  this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"),
                  this._watchState = "OFF"),
                  this.options.showUserLocation && (this._dotElement = i.create("div", "mapboxgl-user-location-dot"),
                  this._userLocationDotMarker = new Nn(this._dotElement),
                  this.options.trackUserLocation && (this._watchState = "OFF")),
                  this._geolocateButton.addEventListener("click", this.trigger.bind(this)),
                  this._setup = !0,
                  this.options.trackUserLocation && this._map.on("movestart", function(t) {
                      t.geolocateSource || "ACTIVE_LOCK" !== n._watchState || (n._watchState = "BACKGROUND",
                      n._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"),
                      n._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),
                      n.fire(new e.Event("trackuserlocationend")))
                  })) : e.warnOnce("Geolocation support is not available, the GeolocateControl will not be visible.")
              }
              ,
              n.prototype.trigger = function() {
                  if (!this._setup)
                      return e.warnOnce("Geolocate control triggered before added to a map"),
                      !1;
                  if (this.options.trackUserLocation) {
                      switch (this._watchState) {
                      case "OFF":
                          this._watchState = "WAITING_ACTIVE",
                          this.fire(new e.Event("trackuserlocationstart"));
                          break;
                      case "WAITING_ACTIVE":
                      case "ACTIVE_LOCK":
                      case "ACTIVE_ERROR":
                      case "BACKGROUND_ERROR":
                          this._watchState = "OFF",
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),
                          this.fire(new e.Event("trackuserlocationend"));
                          break;
                      case "BACKGROUND":
                          this._watchState = "ACTIVE_LOCK",
                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),
                          this._lastKnownPosition && this._updateCamera(this._lastKnownPosition),
                          this.fire(new e.Event("trackuserlocationstart"))
                      }
                      switch (this._watchState) {
                      case "WAITING_ACTIVE":
                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),
                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                          break;
                      case "ACTIVE_LOCK":
                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                          break;
                      case "ACTIVE_ERROR":
                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),
                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                          break;
                      case "BACKGROUND":
                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                          break;
                      case "BACKGROUND_ERROR":
                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),
                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error")
                      }
                      "OFF" === this._watchState && void 0 !== this._geolocationWatchID ? this._clearWatch() : void 0 === this._geolocationWatchID && (this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),
                      this._geolocateButton.setAttribute("aria-pressed", "true"),
                      this._geolocationWatchID = e.window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, this.options.positionOptions))
                  } else
                      e.window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions),
                      this._timeoutId = setTimeout(this._finish, 1e4);
                  return !0
              }
              ,
              n.prototype._clearWatch = function() {
                  e.window.navigator.geolocation.clearWatch(this._geolocationWatchID),
                  this._geolocationWatchID = void 0,
                  this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),
                  this._geolocateButton.setAttribute("aria-pressed", "false"),
                  this.options.showUserLocation && this._updateMarker(null)
              }
              ,
              n
          }(e.Evented), Hn = {
              maxWidth: 100,
              unit: "metric"
          }, Vn = function(t) {
              this.options = e.extend({}, Hn, t),
              e.bindAll(["_onMove", "setUnit"], this)
          };
          function Wn(e, t, i) {
              var n, r, o, s, a, l, c = i && i.maxWidth || 100, u = e._container.clientHeight / 2, h = (n = e.unproject([0, u]),
              r = e.unproject([c, u]),
              o = Math.PI / 180,
              s = n.lat * o,
              a = r.lat * o,
              l = Math.sin(s) * Math.sin(a) + Math.cos(s) * Math.cos(a) * Math.cos((r.lng - n.lng) * o),
              6371e3 * Math.acos(Math.min(l, 1)));
              if (i && "imperial" === i.unit) {
                  var d = 3.2808 * h;
                  d > 5280 ? $n(t, c, d / 5280, "mi") : $n(t, c, d, "ft")
              } else
                  i && "nautical" === i.unit ? $n(t, c, h / 1852, "nm") : $n(t, c, h, "m")
          }
          function $n(e, t, i, n) {
              var r, o, s, a = (r = i,
              (o = Math.pow(10, ("" + Math.floor(r)).length - 1)) * (s = (s = r / o) >= 10 ? 10 : s >= 5 ? 5 : s >= 3 ? 3 : s >= 2 ? 2 : s >= 1 ? 1 : function(e) {
                  var t = Math.pow(10, Math.ceil(-Math.log(e) / Math.LN10));
                  return Math.round(e * t) / t
              }(s))), l = a / i;
              "m" === n && a >= 1e3 && (a /= 1e3,
              n = "km"),
              e.style.width = t * l + "px",
              e.innerHTML = a + n
          }
          Vn.prototype.getDefaultPosition = function() {
              return "bottom-left"
          }
          ,
          Vn.prototype._onMove = function() {
              Wn(this._map, this._container, this.options)
          }
          ,
          Vn.prototype.onAdd = function(e) {
              return this._map = e,
              this._container = i.create("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e.getContainer()),
              this._map.on("move", this._onMove),
              this._onMove(),
              this._container
          }
          ,
          Vn.prototype.onRemove = function() {
              i.remove(this._container),
              this._map.off("move", this._onMove),
              this._map = void 0
          }
          ,
          Vn.prototype.setUnit = function(e) {
              this.options.unit = e,
              Wn(this._map, this._container, this.options)
          }
          ;
          var Gn = function(t) {
              this._fullscreen = !1,
              t && t.container && (t.container instanceof e.window.HTMLElement ? this._container = t.container : e.warnOnce("Full screen control 'container' must be a DOM element.")),
              e.bindAll(["_onClickFullscreen", "_changeIcon"], this),
              "onfullscreenchange"in e.window.document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange"in e.window.document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange"in e.window.document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange"in e.window.document && (this._fullscreenchange = "MSFullscreenChange"),
              this._className = "mapboxgl-ctrl"
          };
          Gn.prototype.onAdd = function(t) {
              return this._map = t,
              this._container || (this._container = this._map.getContainer()),
              this._controlContainer = i.create("div", this._className + " mapboxgl-ctrl-group"),
              this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none",
              e.warnOnce("This device does not support fullscreen mode.")),
              this._controlContainer
          }
          ,
          Gn.prototype.onRemove = function() {
              i.remove(this._controlContainer),
              this._map = null,
              e.window.document.removeEventListener(this._fullscreenchange, this._changeIcon)
          }
          ,
          Gn.prototype._checkFullscreenSupport = function() {
              return !!(e.window.document.fullscreenEnabled || e.window.document.mozFullScreenEnabled || e.window.document.msFullscreenEnabled || e.window.document.webkitFullscreenEnabled)
          }
          ,
          Gn.prototype._setupUI = function() {
              var t = this._fullscreenButton = i.create("button", this._className + "-icon " + this._className + "-fullscreen", this._controlContainer);
              t.setAttribute("aria-label", "Toggle fullscreen"),
              t.type = "button",
              this._fullscreenButton.addEventListener("click", this._onClickFullscreen),
              e.window.document.addEventListener(this._fullscreenchange, this._changeIcon)
          }
          ,
          Gn.prototype._isFullscreen = function() {
              return this._fullscreen
          }
          ,
          Gn.prototype._changeIcon = function() {
              (e.window.document.fullscreenElement || e.window.document.mozFullScreenElement || e.window.document.webkitFullscreenElement || e.window.document.msFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen,
              this._fullscreenButton.classList.toggle(this._className + "-shrink"),
              this._fullscreenButton.classList.toggle(this._className + "-fullscreen"))
          }
          ,
          Gn.prototype._onClickFullscreen = function() {
              this._isFullscreen() ? e.window.document.exitFullscreen ? e.window.document.exitFullscreen() : e.window.document.mozCancelFullScreen ? e.window.document.mozCancelFullScreen() : e.window.document.msExitFullscreen ? e.window.document.msExitFullscreen() : e.window.document.webkitCancelFullScreen && e.window.document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen()
          }
          ;
          var Xn = {
              closeButton: !0,
              closeOnClick: !0,
              className: ""
          }
            , Zn = function(t) {
              function n(i) {
                  t.call(this),
                  this.options = e.extend(Object.create(Xn), i),
                  e.bindAll(["_update", "_onClickClose", "remove"], this)
              }
              return t && (n.__proto__ = t),
              n.prototype = Object.create(t && t.prototype),
              n.prototype.constructor = n,
              n.prototype.addTo = function(t) {
                  return this._map = t,
                  this._map.on("move", this._update),
                  this.options.closeOnClick && this._map.on("click", this._onClickClose),
                  this._map.on("remove", this.remove),
                  this._update(),
                  this.fire(new e.Event("open")),
                  this
              }
              ,
              n.prototype.isOpen = function() {
                  return !!this._map
              }
              ,
              n.prototype.remove = function() {
                  return this._content && i.remove(this._content),
                  this._container && (i.remove(this._container),
                  delete this._container),
                  this._map && (this._map.off("move", this._update),
                  this._map.off("click", this._onClickClose),
                  this._map.off("remove", this.remove),
                  delete this._map),
                  this.fire(new e.Event("close")),
                  this
              }
              ,
              n.prototype.getLngLat = function() {
                  return this._lngLat
              }
              ,
              n.prototype.setLngLat = function(t) {
                  return this._lngLat = e.LngLat.convert(t),
                  this._pos = null,
                  this._update(),
                  this
              }
              ,
              n.prototype.setText = function(t) {
                  return this.setDOMContent(e.window.document.createTextNode(t))
              }
              ,
              n.prototype.setHTML = function(t) {
                  var i, n = e.window.document.createDocumentFragment(), r = e.window.document.createElement("body");
                  for (r.innerHTML = t; i = r.firstChild; )
                      n.appendChild(i);
                  return this.setDOMContent(n)
              }
              ,
              n.prototype.setDOMContent = function(e) {
                  return this._createContent(),
                  this._content.appendChild(e),
                  this._update(),
                  this
              }
              ,
              n.prototype._createContent = function() {
                  this._content && i.remove(this._content),
                  this._content = i.create("div", "mapboxgl-popup-content", this._container),
                  this.options.closeButton && (this._closeButton = i.create("button", "mapboxgl-popup-close-button", this._content),
                  this._closeButton.type = "button",
                  this._closeButton.setAttribute("aria-label", "Close popup"),
                  this._closeButton.innerHTML = "&#215;",
                  this._closeButton.addEventListener("click", this._onClickClose))
              }
              ,
              n.prototype._update = function() {
                  var t = this;
                  if (this._map && this._lngLat && this._content) {
                      this._container || (this._container = i.create("div", "mapboxgl-popup", this._map.getContainer()),
                      this._tip = i.create("div", "mapboxgl-popup-tip", this._container),
                      this._container.appendChild(this._content),
                      this.options.className && this.options.className.split(" ").forEach(function(e) {
                          return t._container.classList.add(e)
                      })),
                      this._map.transform.renderWorldCopies && (this._lngLat = Rn(this._lngLat, this._pos, this._map.transform));
                      var n = this._pos = this._map.project(this._lngLat)
                        , r = this.options.anchor
                        , o = function t(i) {
                          if (i) {
                              if ("number" == typeof i) {
                                  var n = Math.round(Math.sqrt(.5 * Math.pow(i, 2)));
                                  return {
                                      center: new e.Point(0,0),
                                      top: new e.Point(0,i),
                                      "top-left": new e.Point(n,n),
                                      "top-right": new e.Point(-n,n),
                                      bottom: new e.Point(0,-i),
                                      "bottom-left": new e.Point(n,-n),
                                      "bottom-right": new e.Point(-n,-n),
                                      left: new e.Point(i,0),
                                      right: new e.Point(-i,0)
                                  }
                              }
                              if (i instanceof e.Point || Array.isArray(i)) {
                                  var r = e.Point.convert(i);
                                  return {
                                      center: r,
                                      top: r,
                                      "top-left": r,
                                      "top-right": r,
                                      bottom: r,
                                      "bottom-left": r,
                                      "bottom-right": r,
                                      left: r,
                                      right: r
                                  }
                              }
                              return {
                                  center: e.Point.convert(i.center || [0, 0]),
                                  top: e.Point.convert(i.top || [0, 0]),
                                  "top-left": e.Point.convert(i["top-left"] || [0, 0]),
                                  "top-right": e.Point.convert(i["top-right"] || [0, 0]),
                                  bottom: e.Point.convert(i.bottom || [0, 0]),
                                  "bottom-left": e.Point.convert(i["bottom-left"] || [0, 0]),
                                  "bottom-right": e.Point.convert(i["bottom-right"] || [0, 0]),
                                  left: e.Point.convert(i.left || [0, 0]),
                                  right: e.Point.convert(i.right || [0, 0])
                              }
                          }
                          return t(new e.Point(0,0))
                      }(this.options.offset);
                      if (!r) {
                          var s, a = this._container.offsetWidth, l = this._container.offsetHeight;
                          s = n.y + o.bottom.y < l ? ["top"] : n.y > this._map.transform.height - l ? ["bottom"] : [],
                          n.x < a / 2 ? s.push("left") : n.x > this._map.transform.width - a / 2 && s.push("right"),
                          r = 0 === s.length ? "bottom" : s.join("-")
                      }
                      var c = n.add(o[r]).round();
                      i.setTransform(this._container, Bn[r] + " translate(" + c.x + "px," + c.y + "px)"),
                      jn(this._container, r, "popup")
                  }
              }
              ,
              n.prototype._onClickClose = function() {
                  this.remove()
              }
              ,
              n
          }(e.Evented)
            , Yn = {
              version: e.version,
              supported: t,
              setRTLTextPlugin: e.setRTLTextPlugin,
              Map: Mn,
              NavigationControl: Dn,
              GeolocateControl: qn,
              AttributionControl: Tn,
              ScaleControl: Vn,
              FullscreenControl: Gn,
              Popup: Zn,
              Marker: Nn,
              Style: Mt,
              LngLat: e.LngLat,
              LngLatBounds: e.LngLatBounds,
              Point: e.Point,
              MercatorCoordinate: e.MercatorCoordinate,
              Evented: e.Evented,
              config: e.config,
              get accessToken() {
                  return e.config.ACCESS_TOKEN
              },
              set accessToken(t) {
                  e.config.ACCESS_TOKEN = t
              },
              get baseApiUrl() {
                  return e.config.API_URL
              },
              set baseApiUrl(t) {
                  e.config.API_URL = t
              },
              get workerCount() {
                  return Pe.workerCount
              },
              set workerCount(e) {
                  Pe.workerCount = e
              },
              get maxParallelImageRequests() {
                  return e.config.MAX_PARALLEL_IMAGE_REQUESTS
              },
              set maxParallelImageRequests(t) {
                  e.config.MAX_PARALLEL_IMAGE_REQUESTS = t
              },
              workerUrl: ""
          };
          return Yn
      }),
      i
  }()
}
, function(e, t, i) {
  "use strict";
  var n = Array.isArray
    , r = Object.keys
    , o = Object.prototype.hasOwnProperty;
  e.exports = function e(t, i) {
      if (t === i)
          return !0;
      if (t && i && "object" == typeof t && "object" == typeof i) {
          var s, a, l, c = n(t), u = n(i);
          if (c && u) {
              if ((a = t.length) != i.length)
                  return !1;
              for (s = a; 0 != s--; )
                  if (!e(t[s], i[s]))
                      return !1;
              return !0
          }
          if (c != u)
              return !1;
          var h = t instanceof Date
            , d = i instanceof Date;
          if (h != d)
              return !1;
          if (h && d)
              return t.getTime() == i.getTime();
          var p = t instanceof RegExp
            , f = i instanceof RegExp;
          if (p != f)
              return !1;
          if (p && f)
              return t.toString() == i.toString();
          var m = r(t);
          if ((a = m.length) !== r(i).length)
              return !1;
          for (s = a; 0 != s--; )
              if (!o.call(i, m[s]))
                  return !1;
          for (s = a; 0 != s--; )
              if (!e(t[l = m[s]], i[l]))
                  return !1;
          return !0
      }
      return t != t && i != i
  }
}
, function(e, t, i) {
  var n = i(54);
  e.exports = function(e) {
      var t = n(e)
        , i = t % 1;
      return t == t ? i ? t - i : t : 0
  }
}
, function(e, t, i) {
  var n = i(23)
    , r = 1 / 0
    , o = 1.7976931348623157e308;
  e.exports = function(e) {
      return e ? (e = n(e)) === r || e === -r ? (e < 0 ? -1 : 1) * o : e == e ? e : 0 : 0 === e ? e : 0
  }
}
, function(e, t, i) {
  var n = i(56)
    , r = i(25)
    , o = i(8)
    , s = i(24)
    , a = 1 / 0
    , l = n ? n.prototype : void 0
    , c = l ? l.toString : void 0;
  e.exports = function e(t) {
      if ("string" == typeof t)
          return t;
      if (o(t))
          return r(t, e) + "";
      if (s(t))
          return c ? c.call(t) : "";
      var i = t + "";
      return "0" == i && 1 / t == -a ? "-0" : i
  }
}
, function(e, t, i) {
  var n = i(11).Symbol;
  e.exports = n
}
, function(e, t, i) {
  (function(t) {
      var i = "object" == typeof t && t && t.Object === Object && t;
      e.exports = i
  }
  ).call(this, i(21))
}
, function(e, t, i) {
  var n = i(59)("toUpperCase");
  e.exports = n
}
, function(e, t, i) {
  var n = i(60)
    , r = i(26)
    , o = i(62)
    , s = i(10);
  e.exports = function(e) {
      return function(t) {
          t = s(t);
          var i = r(t) ? o(t) : void 0
            , a = i ? i[0] : t.charAt(0)
            , l = i ? n(i, 1).join("") : t.slice(1);
          return a[e]() + l
      }
  }
}
, function(e, t, i) {
  var n = i(61);
  e.exports = function(e, t, i) {
      var r = e.length;
      return i = void 0 === i ? r : i,
      !t && i >= r ? e : n(e, t, i)
  }
}
, function(e, t) {
  e.exports = function(e, t, i) {
      var n = -1
        , r = e.length;
      t < 0 && (t = -t > r ? 0 : r + t),
      (i = i > r ? r : i) < 0 && (i += r),
      r = t > i ? 0 : i - t >>> 0,
      t >>>= 0;
      for (var o = Array(r); ++n < r; )
          o[n] = e[n + t];
      return o
  }
}
, function(e, t, i) {
  var n = i(63)
    , r = i(26)
    , o = i(64);
  e.exports = function(e) {
      return r(e) ? o(e) : n(e)
  }
}
, function(e, t) {
  e.exports = function(e) {
      return e.split("")
  }
}
, function(e, t) {
  e.exports = function(e) {
      return e.split("")
  }
}
, function(e, t, i) {
  var n = i(11);
  e.exports = function() {
      return n.Date.now()
  }
}
, function(e, t, i) {
  var n = i(67)
    , r = i(27)
    , o = i(75)
    , s = i(77)
    , a = i(3)
    , l = i(18)
    , c = i(31);
  e.exports = function e(t, i, u, h, d) {
      t !== i && o(i, function(o, l) {
          if (a(o))
              d || (d = new n),
              s(t, i, l, u, e, h, d);
          else {
              var p = h ? h(c(t, l), o, l + "", t, i, d) : void 0;
              void 0 === p && (p = o),
              r(t, l, p)
          }
      }, l)
  }
}
, function(e, t, i) {
  var n = i(68)
    , r = i(69)
    , o = i(70)
    , s = i(71)
    , a = i(72);
  function l(e) {
      var t = -1
        , i = null == e ? 0 : e.length;
      for (this.clear(); ++t < i; ) {
          var n = e[t];
          this.set(n[0], n[1])
      }
  }
  l.prototype.clear = n,
  l.prototype.delete = r,
  l.prototype.get = o,
  l.prototype.has = s,
  l.prototype.set = a,
  e.exports = l
}
, function(e, t) {
  e.exports = function() {
      this.__data__ = [],
      this.size = 0
  }
}
, function(e, t, i) {
  var n = i(12)
    , r = Array.prototype.splice;
  e.exports = function(e) {
      var t = this.__data__
        , i = n(t, e);
      return !(i < 0 || (i == t.length - 1 ? t.pop() : r.call(t, i, 1),
      --this.size,
      0))
  }
}
, function(e, t, i) {
  var n = i(12);
  e.exports = function(e) {
      var t = this.__data__
        , i = n(t, e);
      return i < 0 ? void 0 : t[i][1]
  }
}
, function(e, t, i) {
  var n = i(12);
  e.exports = function(e) {
      return n(this.__data__, e) > -1
  }
}
, function(e, t, i) {
  var n = i(12);
  e.exports = function(e, t) {
      var i = this.__data__
        , r = n(i, e);
      return r < 0 ? (++this.size,
      i.push([e, t])) : i[r][1] = t,
      this
  }
}
, function(e, t, i) {
  var n = i(74)
    , r = function() {
      try {
          var e = n(Object, "defineProperty");
          return e({}, "", {}),
          e
      } catch (e) {}
  }();
  e.exports = r
}
, function(e, t) {
  e.exports = function(e, t) {
      return null == e ? void 0 : e[t]
  }
}
, function(e, t, i) {
  var n = i(76)();
  e.exports = n
}
, function(e, t) {
  e.exports = function(e) {
      return function(t, i, n) {
          for (var r = -1, o = Object(t), s = n(t), a = s.length; a--; ) {
              var l = s[e ? a : ++r];
              if (!1 === i(o[l], l, o))
                  break
          }
          return t
      }
  }
}
, function(e, t, i) {
  var n = i(27)
    , r = i(78)
    , o = i(79)
    , s = i(82)
    , a = i(83)
    , l = i(86)
    , c = i(8)
    , u = i(87)
    , h = i(90)
    , d = i(14)
    , p = i(3)
    , f = i(30)
    , m = i(91)
    , g = i(31)
    , v = i(92);
  e.exports = function(e, t, i, y, _, b, w) {
      var x = g(e, i)
        , k = g(t, i)
        , S = w.get(k);
      if (S)
          n(e, i, S);
      else {
          var E = b ? b(x, k, i + "", e, t, w) : void 0
            , T = void 0 === E;
          if (T) {
              var C = c(k)
                , L = !C && h(k)
                , A = !C && !L && m(k);
              E = k,
              C || L || A ? c(x) ? E = x : u(x) ? E = s(x) : L ? (T = !1,
              E = r(k, !0)) : A ? (T = !1,
              E = o(k, !0)) : E = [] : f(k) || l(k) ? (E = x,
              l(x) ? E = v(x) : p(x) && !d(x) || (E = a(k))) : T = !1
          }
          T && (w.set(k, E),
          _(E, k, y, b, w),
          w.delete(k)),
          n(e, i, E)
      }
  }
}
, function(e, t, i) {
  (function(e) {
      var n = i(11)
        , r = t && !t.nodeType && t
        , o = r && "object" == typeof e && e && !e.nodeType && e
        , s = o && o.exports === r ? n.Buffer : void 0
        , a = s ? s.allocUnsafe : void 0;
      e.exports = function(e, t) {
          if (t)
              return e.slice();
          var i = e.length
            , n = a ? a(i) : new e.constructor(i);
          return e.copy(n),
          n
      }
  }
  ).call(this, i(48)(e))
}
, function(e, t, i) {
  var n = i(80);
  e.exports = function(e, t) {
      var i = t ? n(e.buffer) : e.buffer;
      return new e.constructor(i,e.byteOffset,e.length)
  }
}
, function(e, t, i) {
  var n = i(81);
  e.exports = function(e) {
      var t = new e.constructor(e.byteLength);
      return new n(t).set(new n(e)),
      t
  }
}
, function(e, t, i) {
  var n = i(11).Uint8Array;
  e.exports = n
}
, function(e, t) {
  e.exports = function(e, t) {
      var i = -1
        , n = e.length;
      for (t || (t = Array(n)); ++i < n; )
          t[i] = e[i];
      return t
  }
}
, function(e, t, i) {
  var n = i(84)
    , r = i(28)
    , o = i(85);
  e.exports = function(e) {
      return "function" != typeof e.constructor || o(e) ? {} : n(r(e))
  }
}
, function(e, t, i) {
  var n = i(3)
    , r = Object.create
    , o = function() {
      function e() {}
      return function(t) {
          if (!n(t))
              return {};
          if (r)
              return r(t);
          e.prototype = t;
          var i = new e;
          return e.prototype = void 0,
          i
      }
  }();
  e.exports = o
}
, function(e, t) {
  e.exports = function() {
      return !1
  }
}
, function(e, t) {
  e.exports = function() {
      return !1
  }
}
, function(e, t, i) {
  var n = i(88)
    , r = i(6);
  e.exports = function(e) {
      return r(e) && n(e)
  }
}
, function(e, t, i) {
  var n = i(14)
    , r = i(89);
  e.exports = function(e) {
      return null != e && r(e.length) && !n(e)
  }
}
, function(e, t) {
  var i = 9007199254740991;
  e.exports = function(e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= i
  }
}
, function(e, t) {
  e.exports = function() {
      return !1
  }
}
, function(e, t) {
  e.exports = function() {
      return !1
  }
}
, function(e, t, i) {
  var n = i(32)
    , r = i(18);
  e.exports = function(e) {
      return n(e, r(e))
  }
}
, function(e, t, i) {
  var n = i(17)
    , r = i(13)
    , o = Object.prototype.hasOwnProperty;
  e.exports = function(e, t, i) {
      var s = e[t];
      o.call(e, t) && r(s, i) && (void 0 !== i || t in e) || n(e, t, i)
  }
}
, function(e, t) {
  e.exports = function(e) {
      return e
  }
}
, function(e, t, i) {
  var n = i(35)
    , r = Math.max;
  e.exports = function(e, t, i) {
      return t = r(void 0 === t ? e.length - 1 : t, 0),
      function() {
          for (var o = arguments, s = -1, a = r(o.length - t, 0), l = Array(a); ++s < a; )
              l[s] = o[t + s];
          s = -1;
          for (var c = Array(t + 1); ++s < t; )
              c[s] = o[s];
          return c[t] = i(l),
          n(e, this, c)
      }
  }
}
, function(e, t) {
  e.exports = function(e) {
      return e
  }
}
, function(e, t, i) {
  var n = i(32)
    , r = i(33)
    , o = i(18)
    , s = r(function(e, t, i, r) {
      n(t, o(t), e, r)
  });
  e.exports = s
}
, function(e, t, i) {
  var n = i(35)
    , r = i(34)
    , o = i(37)
    , s = r(function(e, t) {
      try {
          return n(e, void 0, t)
      } catch (e) {
          return o(e) ? e : new Error(e)
      }
  });
  e.exports = s
}
, function(e, t, i) {
  var n = i(25);
  e.exports = function(e, t) {
      return n(t, function(t) {
          return e[t]
      })
  }
}
, function(e, t, i) {
  var n = i(13)
    , r = Object.prototype
    , o = r.hasOwnProperty;
  e.exports = function(e, t, i, s) {
      return void 0 === e || n(e, r[i]) && !o.call(s, i) ? t : e
  }
}
, function(e, t) {
  var i = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
  };
  e.exports = function(e) {
      return "\\" + i[e]
  }
}
, function(e, t, i) {
  var n = i(29)(Object.keys, Object);
  e.exports = n
}
, function(e, t, i) {
  var n = i(104)
    , r = {
      escape: i(107),
      evaluate: i(108),
      interpolate: i(38),
      variable: "",
      imports: {
          _: {
              escape: n
          }
      }
  };
  e.exports = r
}
, function(e, t, i) {
  var n = i(105)
    , r = i(10)
    , o = /[&<>"']/g
    , s = RegExp(o.source);
  e.exports = function(e) {
      return (e = r(e)) && s.test(e) ? e.replace(o, n) : e
  }
}
, function(e, t, i) {
  var n = i(106)({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
  });
  e.exports = n
}
, function(e, t) {
  e.exports = function(e) {
      return function(t) {
          return null == e ? void 0 : e[t]
      }
  }
}
, function(e, t) {
  e.exports = /<%-([\s\S]+?)%>/g
}
, function(e, t) {
  e.exports = /<%([\s\S]+?)%>/g
}
, function(e, t) {
  e.exports = '\n<div class="container">\n\t<div class="modal-cart__content">\n\t\t<h2>No items in<br>your bag</h2>\n\n\t\t<div class="modal-cart__buttons-wrapper">\n\t\t\t<ul class="modal-cart__buttons">\n\n\t\t\t\t\n\t\t\t\t\t\n\n  \n<a href="javascript:;" class="btn btn-lg btn-light btn-outlined " data-cta-rounded-rect >\n\t\t<span>Shop Men\'s</span>\n</a href="javascript:;">\n\n\t\t\t\t\n\t\t\t\t\t\n\n  \n<a href="javascript:;" class="btn btn-lg btn-light btn-outlined " data-cta-rounded-rect >\n\t\t<span>Shop Women\'s</span>\n</a href="javascript:;">\n\n\t\t\t\t\n\t\t\t\t\t\n\n  \n<a href="pages/page-plp-subcat-jackets" class="btn btn-lg btn-light btn-outlined " data-cta-rounded-rect >\n\t\t<span>Shop Kid\'s</span>\n</a href="pages/page-plp-subcat-jackets">\n\n\t\t\t\t\n\t\t\t\t\t\n\n  \n<a href="javascript:;" class="btn btn-lg btn-light btn-outlined " data-cta-rounded-rect >\n\t\t<span>Shop Packs</span>\n</a href="javascript:;">\n\n\t\t\t\t\n\t\t\t</ul>\n\t\t</div>\n\n\t\t<div class="modal-cart__mobile-only">\n\t\t\t\t\t\t\t<a class="modal-cart__bottom-link" href="javascript:;">Order Status\n\t\t\t\t\t<figure>\n\t\t\t\t\t\t<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 11">\n<path d="M10.6,8.9l5.7-5.7c0.4-0.4,0.4-1,0-1.4l-1.4-1.4c-0.4-0.4-1-0.4-1.4,0L8.5,5.3L3.5,0.4C3.1,0,2.5,0,2.1,0.4L0.7,1.8\n\tc-0.4,0.4-0.4,1,0,1.4l7.1,7.1c0.4,0.4,1,0.4,1.4,0L10.6,8.9L10.6,8.9z"/>\n</svg>\n\t\t\t\t\t</figure>\n\t\t\t\t</a>\n\t\t\t\t\t\t\t<a class="modal-cart__bottom-link" href="javascript:;">Repairs &amp; Returns\n\t\t\t\t\t<figure>\n\t\t\t\t\t\t<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 11">\n<path d="M10.6,8.9l5.7-5.7c0.4-0.4,0.4-1,0-1.4l-1.4-1.4c-0.4-0.4-1-0.4-1.4,0L8.5,5.3L3.5,0.4C3.1,0,2.5,0,2.1,0.4L0.7,1.8\n\tc-0.4,0.4-0.4,1,0,1.4l7.1,7.1c0.4,0.4,1,0.4,1.4,0L10.6,8.9L10.6,8.9z"/>\n</svg>\n\t\t\t\t\t</figure>\n\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t</div>\n</div>\n'
}
, function(e, t) {
  e.exports = '<h4 class="h4" style="color:#fff; padding-top: 10rem">Thank you for signing up.</h4>\n'
}
, function(e, t, i) {
  "use strict";
  var n = i(186)
    , r = i(112);
  function o(e) {
      r.call(this, e)
  }
  o.prototype = Object.create(r.prototype),
  o.prototype.constructor = o,
  o.prototype.sendRequest = n.browserSend,
  o.prototype.abortRequest = n.browserAbort,
  e.exports = function(e) {
      return new o(e)
  }
}
, function(e, t, i) {
  "use strict";
  var n = i(113)
    , r = i(192)
    , o = i(49);
  function s(e) {
      if (!e || !e.accessToken)
          throw new Error("Cannot create a client without an access token");
      n(e.accessToken),
      this.accessToken = e.accessToken,
      this.origin = e.origin || o.API_ORIGIN
  }
  s.prototype.createRequest = function(e) {
      return new r(this,e)
  }
  ,
  e.exports = s
}
, function(e, t, i) {
  "use strict";
  var n = i(191)
    , r = {};
  function o(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t)
  }
  e.exports = function(e) {
      if (r[e])
          return r[e];
      var t = e.split(".")
        , i = t[0]
        , s = t[1];
      if (!s)
          throw new Error("Invalid token");
      var a = function(e) {
          try {
              return JSON.parse(n.decode(e))
          } catch (e) {
              throw new Error("Invalid token")
          }
      }(s)
        , l = {
          usage: i,
          user: a.u
      };
      return o(a, "a") && (l.authorization = a.a),
      o(a, "exp") && (l.expires = 1e3 * a.exp),
      o(a, "iat") && (l.created = 1e3 * a.iat),
      o(a, "scopes") && (l.scopes = a.scopes),
      o(a, "client") && (l.client = a.client),
      o(a, "ll") && (l.lastLogin = a.ll),
      o(a, "iu") && (l.impersonator = a.iu),
      r[e] = l,
      l
  }
}
, function(e, t, i) {
  !function() {
      "use strict";
      e.exports = {
          polyfill: function() {
              var e = window
                , t = document;
              if (!("scrollBehavior"in t.documentElement.style && !0 !== e.__forceSmoothScrollPolyfill__)) {
                  var i, n = e.HTMLElement || e.Element, r = 468, o = {
                      scroll: e.scroll || e.scrollTo,
                      scrollBy: e.scrollBy,
                      elementScroll: n.prototype.scroll || l,
                      scrollIntoView: n.prototype.scrollIntoView
                  }, s = e.performance && e.performance.now ? e.performance.now.bind(e.performance) : Date.now, a = (i = e.navigator.userAgent,
                  new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(i) ? 1 : 0);
                  e.scroll = e.scrollTo = function() {
                      void 0 !== arguments[0] && (!0 !== c(arguments[0]) ? f.call(e, t.body, void 0 !== arguments[0].left ? ~~arguments[0].left : e.scrollX || e.pageXOffset, void 0 !== arguments[0].top ? ~~arguments[0].top : e.scrollY || e.pageYOffset) : o.scroll.call(e, void 0 !== arguments[0].left ? arguments[0].left : "object" != typeof arguments[0] ? arguments[0] : e.scrollX || e.pageXOffset, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : e.scrollY || e.pageYOffset))
                  }
                  ,
                  e.scrollBy = function() {
                      void 0 !== arguments[0] && (c(arguments[0]) ? o.scrollBy.call(e, void 0 !== arguments[0].left ? arguments[0].left : "object" != typeof arguments[0] ? arguments[0] : 0, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : 0) : f.call(e, t.body, ~~arguments[0].left + (e.scrollX || e.pageXOffset), ~~arguments[0].top + (e.scrollY || e.pageYOffset)))
                  }
                  ,
                  n.prototype.scroll = n.prototype.scrollTo = function() {
                      if (void 0 !== arguments[0])
                          if (!0 !== c(arguments[0])) {
                              var e = arguments[0].left
                                , t = arguments[0].top;
                              f.call(this, this, void 0 === e ? this.scrollLeft : ~~e, void 0 === t ? this.scrollTop : ~~t)
                          } else {
                              if ("number" == typeof arguments[0] && void 0 === arguments[1])
                                  throw new SyntaxError("Value could not be converted");
                              o.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left : "object" != typeof arguments[0] ? ~~arguments[0] : this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top : void 0 !== arguments[1] ? ~~arguments[1] : this.scrollTop)
                          }
                  }
                  ,
                  n.prototype.scrollBy = function() {
                      void 0 !== arguments[0] && (!0 !== c(arguments[0]) ? this.scroll({
                          left: ~~arguments[0].left + this.scrollLeft,
                          top: ~~arguments[0].top + this.scrollTop,
                          behavior: arguments[0].behavior
                      }) : o.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop))
                  }
                  ,
                  n.prototype.scrollIntoView = function() {
                      if (!0 !== c(arguments[0])) {
                          var i = function(e) {
                              var i;
                              do {
                                  i = (e = e.parentNode) === t.body
                              } while (!1 === i && !1 === d(e));return i = null,
                              e
                          }(this)
                            , n = i.getBoundingClientRect()
                            , r = this.getBoundingClientRect();
                          i !== t.body ? (f.call(this, i, i.scrollLeft + r.left - n.left, i.scrollTop + r.top - n.top),
                          "fixed" !== e.getComputedStyle(i).position && e.scrollBy({
                              left: n.left,
                              top: n.top,
                              behavior: "smooth"
                          })) : e.scrollBy({
                              left: r.left,
                              top: r.top,
                              behavior: "smooth"
                          })
                      } else
                          o.scrollIntoView.call(this, void 0 === arguments[0] || arguments[0])
                  }
              }
              function l(e, t) {
                  this.scrollLeft = e,
                  this.scrollTop = t
              }
              function c(e) {
                  if (null === e || "object" != typeof e || void 0 === e.behavior || "auto" === e.behavior || "instant" === e.behavior)
                      return !0;
                  if ("object" == typeof e && "smooth" === e.behavior)
                      return !1;
                  throw new TypeError("behavior member of ScrollOptions " + e.behavior + " is not a valid value for enumeration ScrollBehavior.")
              }
              function u(e, t) {
                  return "Y" === t ? e.clientHeight + a < e.scrollHeight : "X" === t ? e.clientWidth + a < e.scrollWidth : void 0
              }
              function h(t, i) {
                  var n = e.getComputedStyle(t, null)["overflow" + i];
                  return "auto" === n || "scroll" === n
              }
              function d(e) {
                  var t = u(e, "Y") && h(e, "Y")
                    , i = u(e, "X") && h(e, "X");
                  return t || i
              }
              function p(t) {
                  var i, n, o, a, l = (s() - t.startTime) / r;
                  a = l = l > 1 ? 1 : l,
                  i = .5 * (1 - Math.cos(Math.PI * a)),
                  n = t.startX + (t.x - t.startX) * i,
                  o = t.startY + (t.y - t.startY) * i,
                  t.method.call(t.scrollable, n, o),
                  n === t.x && o === t.y || e.requestAnimationFrame(p.bind(e, t))
              }
              function f(i, n, r) {
                  var a, c, u, h, d = s();
                  i === t.body ? (a = e,
                  c = e.scrollX || e.pageXOffset,
                  u = e.scrollY || e.pageYOffset,
                  h = o.scroll) : (a = i,
                  c = i.scrollLeft,
                  u = i.scrollTop,
                  h = l),
                  p({
                      scrollable: a,
                      method: h,
                      startTime: d,
                      startX: c,
                      startY: u,
                      x: n,
                      y: r
                  })
              }
          }
      }
  }()
}
, function(e, t) {
  e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="76" height="76">\n\t<g fill="none" fill-rule="evenodd">\n\t<rect width="60" height="60" fill="#FAFAFA" rx="30" transform="translate(8 2)"/>\n\t<path fill="#000" d="M42.85 34.607l-5.658 5.656a1 1 0 0 1-1.414 0l-1.414-1.414a1 1 0 0 1 0-1.414l4.95-4.95-4.95-4.95a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.414 0l7.071 7.071a1 1 0 0 1 0 1.414l-1.414 1.415z"/>\n\t</g>\n</svg>\n'
}
, function(e, t) {
  e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="76" height="76">\n\t<g fill="none" fill-rule="evenodd">\n\t<rect width="60" height="60" fill="#FAFAFA" rx="30" transform="rotate(-180 34 31)"/>\n\t<path fill="#000" d="M33.15 29.393l5.658-5.656a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1 0 1.414l-4.95 4.95 4.95 4.95a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 0 1-1.414 0l-7.071-7.071a1 1 0 0 1 0-1.414l1.414-1.415z"/>\n\t</g>\n</svg>\n'
}
, function(e, t) {
  e.exports = "\n"
}
, function(e, t) {
  e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="76" height="76">\n\t<g fill="none" fill-rule="evenodd">\n\t<rect width="60" height="60" fill="#FAFAFA" rx="30" transform="translate(8 2)"/>\n\t<g transform="rotate(45 17.929 46.314)">\n\t\t<rect width="44" height="44" fill="#FAFAFA" rx="22"/>\n\t\t<g fill="#000" transform="translate(13 13)">\n\t\t<rect width="20" height="4" x="-1" y="7" rx="1" transform="rotate(-45 9 9)"/>\n\t\t<path d="M4.05 1.222L16.778 13.95a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 0 1-1.414 0L1.222 4.05a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.414 0z"/>\n\t\t</g>\n\t</g>\n\t</g>\n</svg>\n'
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {
      toolbarSecondaryMenu: [{
          id: "",
          heading: "Overview"
      }, {
          id: "",
          heading: "Features"
      }, {
          id: "",
          heading: "Reviews (26)"
      }, {
          id: "",
          heading: "Impact"
      }]
  }
}
, function(e) {
  e.exports = {}
}
, function(e, t) {
  e.exports = '<div class="swiper-slide <%= classes %>" <%= params %> <%= caption %>>\n\t<img class="img-fluid" src="/assets/<%= src %>">\n</div>\n'
}
, function(e) {
  e.exports = {
      shoppingTool: {
          heading: "Show me..."
      }
  }
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {
      heading: "You’ve Done it!",
      text: "Please move on to the next task"
  }
}
, function(e) {
  e.exports = {
      id: "modal-cart",
      nav: {
          left: "Log In / Sign Up",
          middle: ["Order Status", "Repairs &amp; Returns"],
          linkUrl: "pages/page-account"
      },
      cartFull: {
          heading: "Your Bag",
          cta: {
              heading: "View Bag (1)"
          },
          products: [{
              columnClasses: "",
              classes: "product-tile--single",
              name: "Women's Down Sweater",
              price: "$229 - Extra Small - Jade",
              imageUrl: "images/plp/Men_s/Jackets _ Outerwear/Jackets _ Outwear/3_Down Sweater_$229/365b57.jpg"
          }, {
              classes: "product-tile--single",
              name: "Straight Fit Cords",
              price: "$89 - Medium - Grey",
              imageUrl: "images/search/products/pants/13_Straight_Fit_Cords_$89/55930_BENB.jpg"
          }, {
              columnClasses: "",
              classes: "product-tile--single",
              name: "W's Torrentshell Jacket",
              price: "$129 - Medium - Pesto",
              imageUrl: "images/pdp/config/Product-Torrentshell-Swatch-Pesto.jpg"
          }],
          ctas: [{
              classes: "",
              cta: {
                  heading: "Pay",
                  iconUrl: "payment/apple-icon.svg",
                  linkUrl: "javascript:;"
              }
          }, {
              classes: "paypal-btn",
              cta: {
                  heading: "Paypal",
                  iconUrl: "payment/paypal-icon.svg",
                  linkUrl: "javascript:;"
              }
          }, {
              classes: "checkout-btn",
              cta: {
                  heading: "Checkout $489",
                  linkUrl: "javascript:;"
              }
          }]
      },
      cartEmpty: {
          heading: "No items in<br>your bag",
          ctas: [{
              classes: "btn-lg btn-light btn-outlined",
              cta: {
                  heading: "Shop Men's",
                  linkUrl: "javascript:;"
              }
          }, {
              classes: "btn-lg btn-light btn-outlined",
              cta: {
                  heading: "Shop Women's",
                  linkUrl: "javascript:;"
              }
          }, {
              classes: "btn-lg btn-light btn-outlined",
              cta: {
                  heading: "Shop Kid's",
                  linkUrl: "pages/page-plp-subcat-jackets"
              }
          }, {
              classes: "btn-lg btn-light btn-outlined",
              cta: {
                  heading: "Shop Packs",
                  linkUrl: "javascript:;"
              }
          }]
      }
  }
}
, function(e, t) {
  e.exports = '\n<div class="container container--skinny">\n\t<div class="modal-cart__content modal-cart__content--full">\n\t\t<h2>Your Bag</h2>\n\t\t<p><a href="javascript:;">View Bag (1)</a></p>\n\n\t\t<ul class="modal-cart__products">\n\t\t\t<li class="modal-cart__product modal-cart__product--new">\n\t\t\t\t\t\t\t\t\n<div class="swiper-slide " data-product-tile >\n\t<div class="product-tile product-tile--single"  data-size-stock="">\n\t\t<a href="javascript:;" data-image-zoom-url="images/pdp/config/Product-Torrentshell-Swatch-Pesto.jpg">\n\t\t\t<div class="product-tile__image-wrap">\n\n\t\t\t\t\n\t\t\t\t<div class="product-tile__image">\n\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t<img class="lazyload" data-src="/assets/images/pdp/config/Product-Torrentshell-Swatch-Pesto.jpg" alt="">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</a>\n\n\t\t<div class="product-tile__meta">\n\n\t\t\t<div class="product-tile__meta-primary">\n\t\t\t\t<a href="javascript:;">\n\t\t\t\t\t<h3 class="product-tile__name">W\'s Torrentshell Jacket</h3>\n\t\t\t\t\t<span class="product-tile__price">$129 - Medium - Pesto</span>\n\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t\n\t\t</div>\n\t</div>\n</div>\n\t\t\t</li>\n\n\t\t\t<li class="modal-cart__product">\n\t\t\t\t\t\t\t\t\n<div class="swiper-slide " data-product-tile >\n\t<div class="product-tile product-tile--single"  data-size-stock="">\n\t\t<a href="javascript:;" data-image-zoom-url="images/search/products/pants/13_Straight_Fit_Cords_$89/55930_BENB.jpg">\n\t\t\t<div class="product-tile__image-wrap">\n\n\t\t\t\t\n\t\t\t\t<div class="product-tile__image">\n\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t<img class="lazyload" data-src="/assets/images/search/products/pants/13_Straight_Fit_Cords_$89/55930_BENB.jpg" alt="">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</a>\n\n\t\t<div class="product-tile__meta">\n\n\t\t\t<div class="product-tile__meta-primary">\n\t\t\t\t<a href="javascript:;">\n\t\t\t\t\t<h3 class="product-tile__name">Straight Fit Cords</h3>\n\t\t\t\t\t<span class="product-tile__price">$89 - Medium - Grey</span>\n\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t\n\t\t</div>\n\t</div>\n</div>\n\t\t\t</li>\n\n\t\t\t<li class="modal-cart__product">\n\t\t\t\t\t\t\t\t\n<div class="swiper-slide " data-product-tile >\n\t<div class="product-tile product-tile--single"  data-size-stock="">\n\t\t<a href="javascript:;" data-image-zoom-url="images/plp/Men_s/Jackets _ Outerwear/Jackets _ Outwear/3_Down Sweater_$229/365b57.jpg">\n\t\t\t<div class="product-tile__image-wrap">\n\n\t\t\t\t\n\t\t\t\t<div class="product-tile__image">\n\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t<img class="lazyload" data-src="/assets/images/plp/Men_s/Jackets _ Outerwear/Jackets _ Outwear/3_Down Sweater_$229/365b57.jpg" alt="">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</a>\n\n\t\t<div class="product-tile__meta">\n\n\t\t\t<div class="product-tile__meta-primary">\n\t\t\t\t<a href="javascript:;">\n\t\t\t\t\t<h3 class="product-tile__name">Women\'s Down Sweater</h3>\n\t\t\t\t\t<span class="product-tile__price">$229 - Extra Small - Jade</span>\n\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t\n\t\t</div>\n\t</div>\n</div>\n\t\t\t</li>\n\t\t</ul>\n\n\n\t\t<div class="modal-cart__buttons-wrapper">\n\t\t\t<ul class="modal-cart__buttons">\n\n\t\t\t\t\n\t\t\t\t\t\n\n  \n<a href="javascript:;" class="btn btn-lg btn-light " data-cta-rounded-rect >\n\t<figure class=""><svg xmlns="http://www.w3.org/2000/svg" width="13" height="16">\n<g fill="#FFF" fill-rule="evenodd">\n<path d="M9.22 2.775c.51-.747.857-1.75.765-2.775-.746.043-1.657.577-2.184 1.325-.474.64-.893 1.685-.784 2.667.838.085 1.676-.49 2.204-1.217"/>\n<path d="M9.663 4.005c-1.315-.078-2.433.739-3.061.739-.629 0-1.59-.7-2.63-.68-1.355.019-2.61.776-3.298 1.981C-.74 8.457.3 12.033 1.675 13.996c.668.972 1.472 2.041 2.532 2.003 1.001-.039 1.394-.642 2.61-.642 1.217 0 1.57.642 2.63.623 1.1-.02 1.787-.972 2.454-1.945.766-1.107 1.079-2.176 1.099-2.235-.02-.02-2.12-.817-2.139-3.208-.02-2.002 1.648-2.954 1.727-3.013-.942-1.38-2.414-1.535-2.925-1.574"/>\n</g>\n</svg></figure>\t<span>Pay</span>\n</a href="javascript:;">\n\n\t\t\t\t\n\t\t\t\t\t\n\n  \n<a href="javascript:;" class="btn btn-lg btn-light paypal-btn" data-cta-rounded-rect >\n\t<figure class=""><svg xmlns="http://www.w3.org/2000/svg" width="16" height="21">\n<g fill="#FFF" fill-rule="evenodd">\n<path d="M13.706 6.612c.195-1.47 0-2.45-.782-3.428-.847-.98-2.345-1.4-4.233-1.4H3.155c-.39 0-.716.28-.781.7L.094 18.018c-.065.35.13.63.456.63h3.452l-.26 1.609c-.065.21.195.49.39.49h2.931c.326 0 .586-.28.651-.63l.065-.14.52-3.638.066-.21c.066-.42.326-.63.651-.63h.456c2.8 0 4.95-1.26 5.601-4.689.26-1.47.13-2.729-.586-3.569-.26-.209-.521-.489-.781-.629" opacity=".7"/>\n<path d="M13.706 6.612c.195-1.47 0-2.45-.782-3.428-.847-.98-2.345-1.4-4.233-1.4H3.155c-.39 0-.716.28-.781.7L.094 18.018c-.065.35.13.63.456.63h3.452l.847-5.809-.066.21c.13-.419.391-.699.847-.699h1.628c3.191 0 5.666-1.4 6.382-5.388 0-.14 0-.28.066-.35" opacity=".7"/>\n<path d="M5.76 6.612c0-.21.13-.42.391-.56.065 0 .195-.07.26-.07h4.364c.521 0 .977.07 1.432.14.131 0 .196 0 .391.07.066.07.196.07.326.14.065 0 .065 0 .195.07l.587.21c.195-1.47 0-2.45-.782-3.358-.847-.98-2.345-1.47-4.233-1.47H3.155c-.39 0-.716.35-.781.7L.094 18.018c-.065.35.13.63.456.63h3.452l.847-5.809.911-6.227z"/>\n<g opacity=".2">\n<path d="M13.678 6.597c.312.185.589.406.797.663.346.405.554.921.658 1.51.103-1.178-.07-2.136-.658-2.872-.208-.258-.45-.442-.727-.626 0 .405 0 .847-.07 1.325zM.21 17.093L2.39 2.51a.77.77 0 0 1 .762-.7h5.54c1.905 0 3.394.443 4.225 1.437a3.65 3.65 0 0 1 .761 1.768c.139-1.326-.069-2.247-.761-3.094C12.086.89 10.597.447 8.692.447h-5.54c-.38 0-.727.295-.796.7L.07 16.688c0 .148.034.295.138.405zM3.775 18.64l-.034.221c-.035.148.034.295.138.405l.104-.626h-.208z"/>\n</g>\n</g>\n</svg></figure>\t<span>Paypal</span>\n</a href="javascript:;">\n\n\t\t\t\t\n\t\t\t\t\t\n\n  \n<a href="javascript:;" class="btn btn-lg btn-light checkout-btn" data-cta-rounded-rect >\n\t\t<span>Checkout $489</span>\n</a href="javascript:;">\n\n\t\t\t\t\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n</div>\n'
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {
      id: "modal-fit",
      heading: "Fit Guide",
      paragraphs: ["Though each Patagonia® product is designed and shaped specifically for its intended use, we can generalize our fit descriptions in four ways:"],
      fits: [{
          heading: "Formfitting",
          blurb: "Conforms to the body’s contours.",
          imageUrl: "images/modals/fit/fit-guide-1.png"
      }, {
          heading: "Slim Fit",
          blurb: "Closer-fitting. Slim-fitting technical garments may be worn over baselayers and light midlayers.",
          imageUrl: "images/modals/fit/fit-guide-1.png"
      }, {
          heading: "Regular Fit",
          blurb: "Neither slim nor oversized. Regular-fitting technical garments may be worn over heavier midlayers.",
          imageUrl: "images/modals/fit/fit-guide-1.png"
      }, {
          heading: "Relaxed Fit",
          blurb: "Drapes loosely on the body.",
          imageUrl: "images/modals/fit/fit-guide-1.png"
      }]
  }
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {
      id: "modal-shipping",
      heading: "Free Shipping<br>On Orders Over $79",
      paragraphs: ["Retro occupy organic, stumptown shabby chic pour-over roof party DIY normcore. Actually artisan organic occupy, Wes Anderson ugh whatever pour-over gastropub selvage. Chillwave craft beer tote bag stumptown quinoa hashtag.", "Dreamcatcher locavore iPhone chillwave, occupy trust fund slow-carb distillery art party narwhal. Ennui shabby chic Brooklyn, fanny pack direct trade Tumblr tattooed retro polaroid deep v chia vinyl Austin Tonx food truck. Literally ugh umami, pickled jean shorts Wes Anderson letterpress. Banjo Tonx beard biodiesel narwhal."]
  }
}
, function(e) {
  e.exports = {
      id: "modal-size",
      headings: ["Size Chart", "Measuring Instructions", "Fit Guide"],
      paragraphs: ["Ali, the model, is 5’9 and is wearing a size small. She skis and plays the banjo in her free time.", "Though each Patagonia® product is designed and shaped specifically for its intended use, we can generalize our fit descriptions in four ways:"],
      sizeInfoCats: ["Numeric", "Chest", "Waist", "Hip"],
      sizeImageUrl: "images/modals/size/size-guide-1.png",
      sizes: [{
          name: "XXS",
          info: {
              numeric: "10-2",
              chest: "32-33",
              waist: "29.5-30.5",
              hip: "32-33"
          }
      }, {
          name: "XS",
          info: {
              numeric: "20-2",
              chest: "32-33",
              waist: "29.5-30.5",
              hip: "32-33"
          }
      }, {
          name: "S",
          info: {
              numeric: "30-2",
              chest: "32-33",
              waist: "29.5-30.5",
              hip: "32-33"
          }
      }, {
          name: "M",
          info: {
              numeric: "40-2",
              chest: "32-33",
              waist: "29.5-30.5",
              hip: "32-33"
          }
      }, {
          name: "L",
          info: {
              numeric: "50-2",
              chest: "32-33",
              waist: "29.5-30.5",
              hip: "32-33"
          }
      }, {
          name: "XL",
          info: {
              numeric: "60-2",
              chest: "32-33",
              waist: "29.5-30.5",
              hip: "32-33"
          }
      }],
      instructions: [{
          heading: "Sleeve",
          blurb: "With elbow bent, measure from the center (back) of neck to elbow and down to wrist."
      }, {
          heading: "Inseam",
          blurb: "Take a pair of pants that fit well and measure from the crotch to bottom of leg. All pants come with a finished hem."
      }, {
          heading: "Hands",
          blurb: "Measure around the fullest part of the hand, not including thumb."
      }, {
          heading: "Chest/Bust",
          blurb: "Measure around your chest/bust, just under armpit."
      }, {
          heading: "Waist",
          blurb: "Measure around waist at the smallest circumference."
      }, {
          heading: "Hips",
          blurb: "Measure around waist at the smallest circumference."
      }],
      slides: [{
          imageUrl: "images/modals/fit/fit-guide-1.png",
          badge: "1/4",
          caption: {
              heading: "Formfitting",
              text: "Conforms to the body’s contours.<br><br>"
          }
      }, {
          imageUrl: "images/modals/fit/fit-guide-2.png",
          badge: "2/4",
          caption: {
              heading: "Slim Fit",
              text: "Closer-fitting. Slim-fitting technical garments may be worn over baselayers and light midlayers."
          }
      }, {
          imageUrl: "images/modals/fit/fit-guide-3.png",
          badge: "3/4",
          caption: {
              heading: "Regular Fit",
              text: "Neither slim nor oversized. Regular-fitting technical garments may be worn over heavier midlayers."
          }
      }, {
          imageUrl: "images/modals/fit/fit-guide-3.png",
          badge: "4/4",
          caption: {
              heading: "Relaxed Fit",
              text: "Drapes loosely on the body.<br><br>"
          }
      }]
  }
}
, function(e) {
  e.exports = {
      id: "modal-video"
  }
}
, function(e) {
  e.exports = {
      expanded: {
          ui: {
              loginCta: {
                  heading: "Log In / Sign Up",
                  linkUrl: "pages/page-account"
              }
          }
      },
      icons: [{
          id: "search",
          iconUrl: "navigation-primary/search.svg",
          linkUrl: "javascript:;",
          params: "data-search-overlay-trigger"
      }, {
          id: "cart",
          iconUrl: "navigation-primary/cart.svg",
          linkUrl: "javascript:;",
          states: {
              full: {
                  iconUrl: "navigation-primary/cart-full.svg",
                  params: "data-cart-full-state-icon"
              }
          }
      }, {
          id: "hamburger",
          iconUrl: "navigation-primary/hamburger.svg",
          linkUrl: "javascript:;"
      }, {
          id: "close",
          iconUrl: "navigation-primary/x.svg",
          linkUrl: "javascript:;"
      }],
      items: [{
          id: "shop",
          heading: "Shop",
          linkUrl: "javascript:;"
      }, {
          id: "activism",
          heading: "Activism",
          linkUrl: "javascript:;"
      }, {
          id: "sports",
          heading: "Sports",
          linkUrl: "javascript:;"
      }, {
          id: "stories",
          heading: "Stories",
          linkUrl: "javascript:;"
      }],
      logo: {
          iconUrl: "assets/vectors/logo.svg",
          linkUrl: "pages/page-home"
      },
      sections: {
          activism: {
              linkUrl: "javascript:;"
          },
          cart: {
              linkUrl: "javascript:;"
          },
          hamburger: {
              type: "support",
              background: {
                  imageUrl: "images/navigation/support/bg.png",
                  imageUrlMobile: "images/navigation/support/bg-mobile.png"
              },
              bug: {
                  cta: {
                      heading: "Need Help?",
                      linkUrl: "javascript:;"
                  }
              },
              column: {
                  left: {
                      heading: "Business Unusual",
                      linkUrl: "javascript:;",
                      items: [{
                          heading: "Mission",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "Footprint",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "History",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "Company Info",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "Stores",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "Careers",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "Press & PR",
                          linkUrl: "javascript:;"
                      }]
                  },
                  right: {
                      heading: "Customer Service",
                      linkUrl: "javascript:;",
                      items: [{
                          heading: "FAQ’s",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "Returns & Repairs",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "Find an Order",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "Product Care",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "Corporate Sales",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "Sponsorship",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "Become a Grantee",
                          linkUrl: "javascript:;"
                      }]
                  }
              },
              logos: {
                  desktop: [{
                      svgId: "navigation-primary/sub-brand/PAW-2-WHI.svg",
                      linkUrl: "javascript:;"
                  }, {
                      svgId: "navigation-primary/sub-brand/Provisions-WHI.svg",
                      linkUrl: "javascript:;"
                  }, {
                      svgId: "navigation-primary/sub-brand/WW-Color.svg",
                      linkUrl: "javascript:;"
                  }],
                  mobile: [{
                      classes: "is-stacked",
                      svgId: "navigation-primary/sub-brand/PAW-1-BLK.svg",
                      linkUrl: "javascript:;"
                  }, {
                      svgId: "navigation-primary/sub-brand/WW-Color.svg",
                      linkUrl: "javascript:;"
                  }, {
                      svgId: "navigation-primary/sub-brand/Provisions-GRY.svg",
                      linkUrl: "javascript:;"
                  }]
              }
          },
          search: {
              heading: "Search",
              linkUrl: "javascript:;"
          },
          shop: {
              type: "big-list",
              items: {
                  womens: {
                      heading: "Women’s",
                      linkUrl: "javascript:;",
                      submenu: {
                          items: [{
                              heading: "All Women’s",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "New",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Jackets & Vests",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Fleece",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Sweatshirts & Hoodies",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Sweaters",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Shirts",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "T-Shirts",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Pants & Jeans",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Snow & Alpine Pants",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Shorts",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Dresses & Skirts",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Swimwear",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Wetsuits",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Waders & Gear",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Baselayers",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Bras & Underwear",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Socks",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Hats & Accessories",
                              linkUrl: "javascript:;"
                          }]
                      }
                  },
                  mens: {
                      heading: "Men’s",
                      linkUrl: "javascript:;",
                      submenu: {
                          items: [{
                              heading: "All Men’s",
                              linkUrl: "pages/page-plp-cat"
                          }, {
                              heading: "New Arrivals",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Jackets & Outerwear",
                              linkUrl: "pages/page-plp-subcat-jackets"
                          }, {
                              heading: "Fleece & Sweaters",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Shirts",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Pants",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Shorts",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Baselayer",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Workwear",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Hats & Accessories",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Socks & Underwear",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Web Specials",
                              linkUrl: "javascript:;"
                          }]
                      }
                  },
                  kids: {
                      heading: "Kids’",
                      headingAlt: "Kids & Baby",
                      linkUrl: "javascript:;",
                      submenu: {
                          items: [{
                              heading: "All Kids’",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "New",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Kids' Snow Gear",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Babies & Toddlers",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Boys",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Girls",
                              linkUrl: "javascript:;"
                          }]
                      }
                  },
                  packsGear: {
                      heading: "Packs & Gear",
                      linkUrl: "javascript:;",
                      submenu: {
                          items: [{
                              heading: "All Packs & Gear",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Sleeping Bags",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Black Hole® Bags",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Backpacks",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Laptop Bags",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Totes & Slings",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Duffel & Travel Bags",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Technical Packs",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Water Bottles & More",
                              linkUrl: "javascript:;"
                          }]
                      }
                  },
                  webSpecials: {
                      heading: "Web Specials",
                      linkUrl: "javascript:;",
                      submenu: {
                          items: [{
                              heading: "All Web Specials",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Men’s",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Women’s",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Kids’ & Baby",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Packs & Gear",
                              linkUrl: "javascript:;"
                          }]
                      }
                  },
                  collections: {
                      heading: "Collections",
                      linkUrl: "javascript:;",
                      submenu: {
                          items: [{
                              heading: "All Collections",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Workwear",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Micro Puff®",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Fair Trade Certified",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Capilene® Air",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Woolyester Fleece",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Recycled Cashmere",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Silent Down",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Patagonia Essentials",
                              linkUrl: "javascript:;"
                          }]
                      }
                  },
                  booksFilms: {
                      heading: "Books & Films",
                      linkUrl: "javascript:;",
                      submenu: {
                          items: [{
                              heading: "All Books & Films",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Stories that Inspire",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "DVDs",
                              linkUrl: "javascript:;"
                          }]
                      }
                  },
                  giftCards: {
                      heading: "Gift Cards",
                      linkUrl: "javascript:;",
                      submenu: {
                          items: [{
                              heading: "Always the right size",
                              linkUrl: "javascript:;"
                          }]
                      }
                  },
                  usedGear: {
                      heading: "Used Gear",
                      linkUrl: "javascript:;",
                      submenu: {
                          items: [{
                              heading: "Worn Wear",
                              linkUrl: "javascript:;"
                          }]
                      }
                  },
                  food: {
                      heading: "Food",
                      linkUrl: "javascript:;",
                      submenu: {
                          items: [{
                              heading: "All Food",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Meat + Seafood",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Soups + Sides",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Breakfast",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Beer",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Snacks",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Provisions Boxes",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Dry Goods",
                              linkUrl: "javascript:;"
                          }, {
                              heading: "Shop by Lifestyle",
                              linkUrl: "javascript:;"
                          }]
                      }
                  }
              }
          },
          sports: {
              type: "big-list",
              items: [{
                  heading: "Surfing",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Climbing",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Trail Running",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Mountain Biking",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Fly Fishing",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Snow",
                  linkUrl: "javascript:;"
              }]
          },
          stories: {
              linkUrl: "javascript:;"
          }
      },
      ui: {
          back: "Back",
          help: "Need Help?"
      }
  }
}
, function(e, t) {
  e.exports = '<div class="navigation-primary__expanded-secondary-menu navigation-primary__expanded-section navigation-primary__expanded-section--big-list">\n\t<ul class="navigation-primary__expanded-section--content-wrapper">\n\t\t<% for (var i = 0; i<items.length; i++) { %>\n\t\t\t<% var item = items[i]; %>\n\t\t\t<li>\n\t\t\t\t<a href="<%= item.linkUrl %>">\n\t\t\t\t\t<h2><%= item.heading %></h2>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t<% } %>\n\t</ul>\n\t<figure class="navigation-primary__expanded--gradient-overlay"></figure>\n</div>\n'
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {
      toolbar: {
          productName: "Men’s Nine Trails Shirt: Feather Grey",
          productPrice: "$49",
          sizeGuide: "Size Guide",
          colors: [{
              hex: "#99A5AA"
          }, {
              hex: "#E0B1BD"
          }, {
              hex: "#1E9CCC"
          }, {
              hex: "#D7DDC5"
          }, {
              hex: "#689494"
          }, {
              hex: "#333333"
          }],
          sizes: [{
              name: "xs"
          }, {
              name: "s"
          }, {
              name: "m"
          }, {
              name: "l"
          }, {
              name: "xl"
          }, {
              name: "xxl"
          }]
      },
      overview: {
          heading: "Overview",
          text: "Comfort and versatility of a daily-wear T-shirt with the technical benefits of wicking, fast drying &amp; Polygiene® permanent odor control.",
          ctas: [{
              heading: "Tech Specs",
              classes: "is-large",
              params: 'data-modal-trigger data-modal-target="#tech-specs"'
          }],
          modal: {
              paragraphs: ["Comfort and versatility of a daily-wear T-shirt with the technical benefits of wicking, fast drying &amp; Polygiene® permanent odor control.", "Our Nine Trails running top excels at shifting gears throughout the day. The trail-worthy 100% polyester spun jersey fabric wicks moisture, breathes freely and dries rapidly—but looks and feels like cotton.", "The combination of comfort and technical performance yields everyday versatility, complemented by details like set-in sleeves with underarm gussets for chafe-free range of motion.", "With Polygiene® permanent odor control, no tags for no itch, and a locker loop to let it dry until tomorrow. Reflective logo on the left chest keeps you visible."],
              specs: [{
                  category: "Waterproof",
                  check: !0
              }, {
                  category: "Windproof",
                  check: !0
              }, {
                  category: "Packable",
                  check: !0
              }, {
                  category: "Hood",
                  check: !0
              }, {
                  category: "Best Use",
                  info: "Multisport"
              }, {
                  category: "Fit/Sizing",
                  info: "Regular"
              }, {
                  category: "Weight",
                  info: "207g"
              }]
          }
      },
      features: {
          heading: "Features"
      },
      reviews: {
          heading: "Reviews",
          averageRating: {
              heading: "Average Rating",
              stat: "4.0"
          },
          averageFit: {
              heading: "Average Fit",
              stat: "True To Size"
          },
          recommend: {
              heading: "Would Recommend",
              stat: "28/32"
          },
          cta: {
              heading: "View 32 Reviews"
          }
      },
      recommended: {
          heading: "Recommended",
          content: {
              title: "Trail Running Essentials",
              ctas: [{
                  heading: "Goes With",
                  classes: ""
              }, {
                  heading: "Similar",
                  classes: "is-outlined"
              }]
          },
          slider: {
              productName: "Product Name",
              productPrice: "$280",
              qty: "68"
          }
      }
  }
}
, function(e) {
  e.exports = {
      drawers: {
          top: {
              message: "Free Shipping Over $75 + Ironclad Guarantee",
              content: {
                  heading: "Free Shipping Over $75",
                  paragraphs: [{
                      heading: "Shipping Policy Information",
                      blurb: "We do our best to process and ship orders within 1-2 business days. Please keep in mind that we get backlogged during the holiday season and it could take longer. If you have any questions about your order, please contact our friendly Customer Service and we'll be glad to help."
                  }, {
                      heading: "Return &amp; Exchange Policy",
                      blurb: "We do not set a time limit on returns, though we ask that returns for fit or color be made in a timely manner and that items be kept in new condition with tags attached. We accept both current season and discounted items for return.",
                      cta: "See FAQ's"
                  }]
              }
          },
          bottom: {
              message: "Sign up for Patagonia Emails"
          }
      },
      heroes: [{
          content: {
              heading: "Treeline",
              cta: {
                  heading: "Watch the Film"
              }
          },
          backgroundUrl: "",
          videoUrl: "video/home/home-video-bg.mp4",
          overlayInfo: {
              blurb: "After a finger-numbing ride through the highlands, Carston can't quite believe his luck as he warms up under one of Icelands's most luxurious natural amenities — unlimited hot water from underground geothermal fields.",
              caption: "Photo: Mary McIntyre",
              cta: {
                  heading: "Link To Story"
              }
          }
      }],
      collectionHeaders: [{
          name: "Shop",
          cta: {
              heading: "Shop All"
          }
      }, {
          eyebrow: "Activism",
          name: "Take action near you",
          location: {
              heading: "Ventura, CA"
          }
      }, {
          eyebrow: "Stories",
          name: "Stories that Inspire",
          cta: {
              heading: "View All"
          }
      }],
      collections: [{
          slider: [{
              heading: "Women's",
              imageUrl: "images/home/collections/tile-womens.jpg",
              cta: {
                  heading: "Shop",
                  linkUrl: "pages/page-plp-subcat-jackets"
              }
          }, {
              heading: "Men's",
              imageUrl: "images/home/collections/tile-mens.jpg",
              cta: {
                  heading: "Shop",
                  linkUrl: "pages/page-plp-cat"
              }
          }, {
              heading: "Kids &amp; Baby",
              imageUrl: "images/home/collections/tile-kids-baby.jpg",
              cta: {
                  heading: "Shop",
                  linkUrl: "javascript:;"
              }
          }, {
              heading: "Packs &amp; Gear",
              imageUrl: "images/home/collections/tile-accessories.jpg",
              cta: {
                  heading: "Shop",
                  linkUrl: "javascript:;"
              }
          }, {
              heading: "Web Specials",
              imageUrl: "images/home/collections/tile-web-specials.jpg",
              cta: {
                  heading: "Shop",
                  linkUrl: "javascript:;"
              }
          }, {
              heading: "Books",
              imageUrl: "images/home/collections/tile-books.jpg",
              cta: {
                  heading: "Shop",
                  linkUrl: "javascript:;"
              }
          }]
      }, {
          slider: [{
              heading: "Snow",
              imageUrl: "images/collections/sports/Snow600x600.png",
              cta: {
                  heading: "Go",
                  linkUrl: "javascript:;"
              }
          }, {
              heading: "Climbing",
              imageUrl: "images/collections/sports/Climb600x600.png",
              cta: {
                  heading: "Go",
                  linkUrl: "javascript:;"
              }
          }, {
              heading: "Surfing",
              imageUrl: "images/collections/sports/Surf600x600.png",
              cta: {
                  heading: "Go",
                  linkUrl: "javascript:;"
              }
          }, {
              heading: "Trail Running",
              imageUrl: "images/collections/sports/trail_running600x600.png",
              cta: {
                  heading: "Go",
                  linkUrl: "javascript:;"
              }
          }, {
              heading: "Mountain Biking",
              imageUrl: "images/collections/sports/mt_biking600x600.png",
              cta: {
                  heading: "Go",
                  linkUrl: "javascript:;"
              }
          }, {
              heading: "Fly Fishing",
              imageUrl: "images/collections/sports/Fish600x600.png",
              cta: {
                  heading: "Go",
                  linkUrl: "javascript:;"
              }
          }]
      }],
      storytellingSections: [{
          config: {
              background: {
                  color: "#000000"
              }
          },
          frames: [{
              module: {
                  type: "hero",
                  options: {
                      eyebrow: "Activism",
                      content: {
                          heading: "Save the Tarkine",
                          blurb: "Home to one of the last undisturbed tracts of old growth rainforest in the world. Yet this place, which remains largely as it was when dinosaurs roamed the planet, is at the mercy of destructive extraction industries.",
                          cta: {
                              heading: "Sign The Petition"
                          },
                          ctaSecondary: {
                              heading: "Explore Activism"
                          }
                      },
                      overlayInfo: {
                          blurb: "After a finger-numbing ride through the highlands, Carston can't quite believe his luck as he warms up under one of Icelands's most luxurious natural amenities — unlimited hot water from underground geothermal fields.",
                          caption: "Photo: Mary McIntyre",
                          cta: {
                              heading: "Link To Story"
                          }
                      }
                  }
              },
              background: {
                  animation: {
                      origin: "50% 80%",
                      start: {
                          opacity: 1,
                          scale: 1
                      },
                      end: {
                          opacity: .6,
                          scale: 1.1
                      }
                  },
                  color: "#000000",
                  imageUrlDesktop: "images/home/storytelling/bg-tarkine.jpg",
                  imageUrlMobile: ""
              }
          }, {
              module: {
                  type: "slider-cards",
                  options: {
                      heading: "Take Action",
                      ctaPrimary: {
                          heading: "View All",
                          linkUrl: "javascript:;"
                      },
                      ctaSecondary: {
                          heading: "View All",
                          linkUrl: "javascript:;"
                      },
                      slider: [{
                          classes: "swiper-slide card--paw-event",
                          imageUrl: "images/home/paw/paw-event.jpg",
                          heading: "Ocean Friendly Restaurants Fall Kickoff Meeting",
                          metaPrimary: "RSVP",
                          metaSecondary: "Ventura, CA<br>November 12<br>6pm-10pm",
                          badgeHeading: "Event",
                          iconUrl: "paw/event.svg"
                      }, {
                          classes: "swiper-slide card--paw-petition",
                          imageUrl: "images/home/paw/paw-environment.jpg",
                          heading: "Tell Congress to Protect Our Marine Sanctuaries and Monuments",
                          metaPrimary: "Take Action",
                          metaSecondary: "Surfrider Foundation<br>36 Days Left to Act",
                          badgeHeading: "Petition",
                          iconUrl: "paw/petition.svg"
                      }, {
                          classes: "swiper-slide card--paw-volunteer",
                          imageUrl: "images/home/paw/paw-petition.jpg",
                          heading: "Help With Google Adwords Setup",
                          metaPrimary: "Take Action",
                          metaSecondary: "Surfrider Foundation<br>1 Week",
                          badgeHeading: "Volunteer",
                          iconUrl: "paw/volunteer.svg"
                      }, {
                          classes: "swiper-slide card--paw-grantee",
                          imageUrl: "images/home/paw/paw-volunteer.jpg",
                          heading: "San Dieguito River Valley Conservancy",
                          metaPrimary: "Take Action",
                          metaSecondary: "Biodiversity<br>La Jolla, CA",
                          badgeHeading: "Grantee"
                      }, {
                          classes: "swiper-slide card--paw-event",
                          imageUrl: "images/home/paw/paw-event.jpg",
                          heading: "Ocean Friendly Restaurants Fall Kickoff Meeting",
                          metaPrimary: "RSVP",
                          metaSecondary: "Ventura, CA<br>November 12<br>6pm-10pm",
                          badgeHeading: "Event",
                          iconUrl: "paw/event.svg"
                      }, {
                          classes: "swiper-slide card--paw-petition",
                          imageUrl: "images/home/paw/paw-environment.jpg",
                          heading: "Tell Congress to Protect Our Marine Sanctuaries and Monuments",
                          metaPrimary: "Take Action",
                          metaSecondary: "Surfrider Foundation<br>36 Days Left to Act",
                          badgeHeading: "Petition",
                          iconUrl: "paw/petition.svg"
                      }, {
                          classes: "swiper-slide card--paw-volunteer",
                          imageUrl: "images/home/paw/paw-petition.jpg",
                          heading: "Help With Google Adwords Setup",
                          metaPrimary: "Take Action",
                          metaSecondary: "Surfrider Foundation<br>1 Week",
                          badgeHeading: "Volunteer",
                          iconUrl: "paw/volunteer.svg"
                      }, {
                          classes: "swiper-slide card--paw-grantee",
                          imageUrl: "images/home/paw/paw-volunteer.jpg",
                          heading: "San Dieguito River Valley Conservancy",
                          metaPrimary: "Take Action",
                          metaSecondary: "Biodiversity<br>La Jolla, CA",
                          badgeHeading: "Grantee"
                      }]
                  }
              },
              background: {
                  animation: {
                      origin: "50% 80%",
                      start: {
                          opacity: 1,
                          scale: 1
                      },
                      end: {
                          opacity: 1,
                          scale: 1
                      }
                  },
                  color: "#6A8BEA",
                  imageUrlDesktop: "",
                  imageUrlMobile: ""
              }
          }]
      }, {
          config: {
              background: {
                  color: "#000000"
              }
          },
          frames: [{
              module: {
                  type: "hero",
                  options: {
                      eyebrow: "Stories",
                      content: {
                          heading: "The Brave<br> Women of Bosnia",
                          blurb: "Activism and the feminine spirit unite to save Europe’s last wild rivers. Mornings in Fojnica, Bosnia-Herzegovina, bring a harmony of Franciscan monastery bells, the valley draped in fog and wood smoke.<br>By Molly Baker",
                          cta: {
                              heading: "Read The Story"
                          },
                          ctaSecondary: {
                              heading: "Browse All Stories"
                          }
                      },
                      overlayInfo: {
                          blurb: "After a finger-numbing ride through the highlands, Carston can't quite believe his luck as he warms up under one of Icelands's most luxurious natural amenities — unlimited hot water from underground geothermal fields.",
                          caption: "Photo: Mary McIntyre",
                          cta: {
                              heading: "Link To Story"
                          }
                      }
                  }
              },
              background: {
                  animation: {
                      origin: "50% 80%",
                      start: {
                          opacity: 1,
                          scale: 1
                      },
                      end: {
                          opacity: .8,
                          scale: 1.1
                      }
                  },
                  color: "#021827",
                  imageUrlDesktop: "images/home/storytelling/bg-bosnia.jpg",
                  imageUrlMobile: ""
              }
          }, {
              module: {
                  type: "slider-cards",
                  cardType: "story",
                  options: {
                      heading: "Stories",
                      ctaPrimary: {
                          heading: "View All",
                          linkUrl: "javascript:;"
                      },
                      ctaSecondary: {
                          heading: "View All",
                          linkUrl: "javascript:;"
                      },
                      slider: [{
                          videoUrl: "video/cards/BHOE-Ambient-Card.mp4",
                          heading: "Blue Heart of Europe",
                          badgeHeading: "Film",
                          metaPrimary: "00:00",
                          cardSubType: "video"
                      }, {
                          imageUrl: "images/home/stories/story-article-1.jpg",
                          heading: "Endless Fire Season",
                          metaPrimary: "Read",
                          metaSecondary: "By Krista Langlois",
                          badgeHeading: "The Cleanest Line",
                          cardSubType: "article",
                          iconUrl: "external-link-arrow.svg"
                      }, {
                          videoUrl: "video/cards/BearsEars-Ambient-Card.mp4",
                          heading: "This is Bear Ears",
                          badgeHeading: "Interactive",
                          metaPrimary: "",
                          cardSubType: "video",
                          isInteractive: !0
                      }, {
                          imageUrl: "images/home/stories/story-article-2.jpg",
                          heading: "Inclement Gifts",
                          metaPrimary: "Read",
                          metaSecondary: "By Krista Langlois",
                          badgeHeading: "The Cleanest Line",
                          cardSubType: "article",
                          iconUrl: "external-link-arrow.svg"
                      }, {
                          videoUrl: "video/cards/BHOE-Ambient-Card.mp4",
                          heading: "Blue Heart of Europe",
                          badgeHeading: "Film",
                          metaPrimary: "00:00",
                          cardSubType: "video"
                      }, {
                          imageUrl: "images/home/stories/story-article-1.jpg",
                          heading: "Title of a The Cleanest Line Story",
                          metaPrimary: "Read",
                          metaSecondary: "By Krista Langlois",
                          badgeHeading: "The Cleanest Line",
                          cardSubType: "article",
                          iconUrl: "external-link-arrow.svg"
                      }, {
                          videoUrl: "video/cards/BHOE-Ambient-Card.mp4",
                          heading: "Blue Heart of Europe",
                          badgeHeading: "Film",
                          metaPrimary: "00:00",
                          cardSubType: "video"
                      }, {
                          imageUrl: "images/home/stories/story-article-2.jpg",
                          heading: "Title of a The Cleanest Line Story",
                          metaPrimary: "Read",
                          metaSecondary: "By Krista Langlois",
                          badgeHeading: "The Cleanest Line",
                          cardSubType: "article",
                          iconUrl: "external-link-arrow.svg"
                      }]
                  }
              },
              background: {
                  animation: {
                      origin: "50% 80%",
                      start: {
                          opacity: 1,
                          scale: 1
                      },
                      end: {
                          opacity: .8,
                          scale: 1.1
                      }
                  },
                  color: "#F2F2F2",
                  imageUrlDesktop: "",
                  imageUrlMobile: ""
              }
          }]
      }],
      fullSections: [{
          eyebrow: "Featured Petition",
          heading: "Save the Tarkine",
          blurb: "For almost 40 years, Patagonia has supported grassroots activists working to find solutions to the environmental crisis. But in this time of unprecedented threats, it’s often hard to know the best way to get involved. That’s why we’re connecting individuals with our grantees, to take action on the most pressing issues facing the world today.",
          cta: {
              heading: "View Petition"
          },
          bgImageUrl: "images/home/full-sections/bg-tarkine.jpg"
      }, {
          eyebrow: "Featured Story",
          heading: "The Point is Forever",
          blurb: "For almost 40 years, Patagonia has supported grassroots activists working to find solutions to the environmental crisis. But in this time of unprecedented threats, it’s often hard to know the best way to get involved. That’s why we’re connecting individuals with our grantees, to take action on the most pressing issues facing the world today.",
          cta: {
              heading: "Read Story"
          },
          bgImageUrl: "images/home/full-sections/bg-point-is-forever.jpg"
      }],
      sportsLinks: ["Surfing", "Climbing", "Trail Running", "Mountain Biking", "Fly Fishing", "Snow"]
  }
}
, function(e) {
  e.exports = {
      dataUrl: "https://jsonplaceholder.typicode.com/posts",
      defaults: {
          ui: {
              headingCategories: "Popular Searches",
              headingProducts: "You Recently Viewed",
              headingResultsCount: "Showing # of ",
              headingResultsCountCta: "# results",
              defaultCategoryHeading: "Clothing"
          },
          categories: [{
              heading: "Hats",
              linkUrl: "javascript:;"
          }, {
              heading: "Rain",
              linkUrl: "javascript:;"
          }, {
              heading: "Fleece",
              linkUrl: "javascript:;"
          }, {
              heading: "Better Sweater",
              linkUrl: "javascript:;"
          }, {
              heading: "Vests",
              linkUrl: "javascript:;"
          }],
          products: [{
              classes: "product-tile--single",
              name: "Better Sweater",
              price: "$139",
              imageUrl: "images/plp/Men_s/Fleece/Fleece/1_Better Sweater_$139/7e2a32.jpg"
          }, {
              classes: "product-tile--single",
              name: "Organic Cotton Quilt Snap-T® Pullover",
              price: "$149",
              imageUrl: "images/plp/Men_s/Fleece/Fleece/2_Organic Cotton Wuilt Snap-T® Pullover_$149/4d494a.jpg"
          }, {
              classes: "product-tile--single",
              name: "R1® Pullover",
              price: "$129",
              imageUrl: "images/plp/Men_s/Fleece/Fleece/4_R1® Pullover_$129/343436.jpg"
          }, {
              classes: "product-tile--single",
              name: "Crosstrek Jacket",
              price: "$149",
              imageUrl: "images/plp/Men_s/Fleece/Fleece/5_Crosstrek Jackets_$149/008ea4.jpg"
          }, {
              classes: "product-tile--single",
              name: "R1 Fleece Pants",
              price: "$119",
              imageUrl: "images/search/products/pants/12_R1_Fleece_Pants_$119/82156_FGE.jpg"
          }, {
              classes: "product-tile--single",
              name: "Straight Fit Cords",
              price: "$89",
              imageUrl: "images/search/products/pants/13_Straight_Fit_Cords_$89/55930_BENB.jpg"
          }, {
              classes: "product-tile--single",
              name: "Performance Regular Fit Jeans",
              price: "$119",
              imageUrl: "images/search/products/pants/5_Performance_Regular_Fit_Jeans_$119/56200_DDNM.jpg"
          }, {
              classes: "product-tile--single",
              name: "Four Canyon Twill Pants",
              price: "$79",
              imageUrl: "images/search/products/pants/6_Four_Canyon_Twill_Pants_$79/56060_INDG.jpg"
          }]
      },
      query: {
          ui: {
              placeholder: "Start Typing"
          },
          categories: {
              pants: [{
                  heading: "Men's Pants",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Women's Pants",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Snow Pants",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Sweat Pants",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Jeans",
                  linkUrl: "javascript:;"
              }],
              jackets: [{
                  heading: "Men's Jackets",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Women's Jackets",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Kids Jackets",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Rain Jackets",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Snow Jackets",
                  linkUrl: "javascript:;"
              }],
              women: [{
                  heading: "Women's Pants",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Snow Pants",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Sweat Pants",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Jeans",
                  linkUrl: "javascript:;"
              }],
              men: [{
                  heading: "Men's Pants",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Snow Pants",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Sweat Pants",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Jeans",
                  linkUrl: "javascript:;"
              }]
          },
          products: [{
              classes: "product-tile--single",
              name: "Grade VII Down Parka",
              price: "$899",
              imageUrl: "images/product-tiles/insulated-jackets/1.jpg",
              rightBadge: "Exclusive"
          }, {
              classes: "product-tile--single",
              name: "Men's Hi-Loft Down Hoody",
              price: "$279",
              imageUrl: "images/product-tiles/insulated-jackets/2.jpg"
          }, {
              classes: "product-tile--single",
              name: "Tres 3-in-1 Parka",
              price: "$549",
              imageUrl: "images/product-tiles/insulated-jackets/3.jpg"
          }, {
              classes: "product-tile--single",
              name: "Micro Puff Storm Jacket",
              price: "$899",
              imageUrl: "images/product-tiles/insulated-jackets/4.jpg"
          }, {
              classes: "product-tile--single",
              name: "Nano Air",
              price: "$549",
              imageUrl: "images/product-tiles/insulated-jackets/5.jpg"
          }, {
              classes: "product-tile--single",
              name: "Nano Puff Bivy",
              price: "$899",
              imageUrl: "images/product-tiles/insulated-jackets/6.jpg",
              rightBadge: "Exclusive"
          }, {
              classes: "product-tile--single",
              name: "Diamond Quilt Bomber Hoody",
              price: "$279",
              imageUrl: "images/product-tiles/insulated-jackets/7.jpg"
          }, {
              classes: "product-tile--single",
              name: "Torrent Shell Jacket",
              price: "$129",
              imageUrl: "images/plp/Men_s/Jackets _ Outerwear/Jackets _ Outwear/6_Torrent Shell_$129/b65c3e.jpg"
          }, {
              classes: "product-tile--single",
              name: "Women's Down Sweater",
              price: "$229",
              imageUrl: "images/plp/Men_s/Jackets _ Outerwear/Jackets _ Outwear/3_Down Sweater_$229/365b57.jpg"
          }, {
              classes: "product-tile--single",
              name: "Nano Puff Jacket",
              price: "$199",
              imageUrl: "images/plp/Men_s/Jackets _ Outerwear/Jackets _ Outwear/2_Nano Puff_$199/30504b.jpg"
          }, {
              classes: "product-tile--single",
              name: "R1® Pullover",
              price: "$129",
              imageUrl: "images/plp/Men_s/Fleece/Fleece/4_R1® Pullover_$129/343436.jpg"
          }, {
              classes: "product-tile--single",
              name: "Iron Forge Hemp® Canvas Double Knee Pants",
              price: "$69",
              imageUrl: "images/search/products/pants/1_Iron_Forge_Hemp®_Canvas_Double_Knee_Pants_$69/55785_FTGN.jpg"
          }, {
              classes: "product-tile--single",
              name: "All Seasons Hemp Canvas Double Knee Pants",
              price: "$79",
              imageUrl: "images/search/products/pants/2_All_Seasons_Hemp_Canvas_Double_Knee_Pants_$79/55296_COI.jpg"
          }, {
              classes: "product-tile--single",
              name: "Performance Twill Jeans",
              price: "$99",
              imageUrl: "images/search/products/pants/3_Performance_Twill_Jeans_$99/56490_INDG.jpg"
          }, {
              classes: "product-tile--single",
              name: "Stonycroft Jeans",
              price: "$69",
              imageUrl: "images/search/products/pants/4_Stonycroft_Jeans_$69/55625_INDG.jpg"
          }, {
              classes: "product-tile--single",
              name: "Performance Regular Fit Jeans",
              price: "$119",
              imageUrl: "images/search/products/pants/5_Performance_Regular_Fit_Jeans_$119/56200_DDNM.jpg"
          }, {
              classes: "product-tile--single",
              name: "Four Canyon Twill Pants",
              price: "$79",
              imageUrl: "images/search/products/pants/6_Four_Canyon_Twill_Pants_$79/56060_INDG.jpg"
          }, {
              classes: "product-tile--single",
              name: "Woolie Fleece Pants",
              price: "$119",
              imageUrl: "images/search/products/pants/7_Woolie_Fleece_Pants_$119/56720_OAT.jpg"
          }, {
              classes: "product-tile--single",
              name: "Mahnya Fleece Pants",
              price: "$79",
              imageUrl: "images/search/products/pants/8_Mahnya_Fleece_Pants_$79/56666_NVYB.jpg"
          }, {
              classes: "product-tile--single",
              name: "Stretch Thermal Pants",
              price: "$119",
              imageUrl: "images/search/products/pants/9_Stretch_Thermal_Pants_$119/87000_BLK.jpg"
          }, {
              classes: "product-tile--single",
              name: "Synchilla Snap-T Fleece Pants",
              price: "$99",
              imageUrl: "images/search/products/pants/10_Synchilla_Snap-T_Fleece_Pants_$99/56675_NKL.jpg"
          }, {
              classes: "product-tile--single",
              name: "Terrebonne Jogger",
              price: "$79",
              imageUrl: "images/search/products/pants/11_Terrebonne_Jogger_$79/24540_FGE.jpg"
          }, {
              classes: "product-tile--single",
              name: "R1 Fleece Pants",
              price: "$119",
              imageUrl: "images/search/products/pants/12_R1_Fleece_Pants_$119/82156_FGE.jpg"
          }, {
              classes: "product-tile--single",
              name: "Straight Fit Cords",
              price: "$89",
              imageUrl: "images/search/products/pants/13_Straight_Fit_Cords_$89/55930_BENB.jpg"
          }, {
              classes: "product-tile--single",
              name: "Quandary Pants",
              price: "$79",
              imageUrl: "images/search/products/pants/14_Quandary_Pants_$79/55181_ELKH.jpg"
          }, {
              classes: "product-tile--single",
              name: "Wind Shield Soft Shell Pants",
              price: "$159",
              imageUrl: "images/search/products/pants/15_Wind_Shield_Soft_Shell_Pants_$159/24102_BLK.jpg"
          }, {
              classes: "product-tile--single",
              name: "Kalorama Corduroy Pants",
              price: "$99",
              imageUrl: "images/search/products/pants/17_Kalorama_Corduroy_Pants_$99/56605_ASHT.jpg"
          }, {
              classes: "product-tile--single",
              name: "Torrentshell Pants",
              price: "$99",
              imageUrl: "images/search/products/pants/18_Torrentshell_Pants_$99/83812_FGE.jpg"
          }, {
              classes: "product-tile--single",
              name: "Nano Puff Pants",
              price: "$179",
              imageUrl: "images/search/products/pants/19_Nano_Puff_Pants_$179/82140_FGE.jpg"
          }, {
              classes: "product-tile--single",
              name: "Cloud Ridge Pants",
              price: "$179",
              imageUrl: "images/search/products/pants/20_Cloud_Ridge_Pants_$179/83695_BLK.jpg"
          }, {
              classes: "product-tile--single",
              name: "Steel Forge Denim Pants",
              price: "$159",
              imageUrl: "images/search/products/pants/21_Steel_Forge_Denim_Pants_$159/56120_DDNM.jpg"
          }, {
              classes: "product-tile--single",
              name: "Sandy Cay Pants",
              price: "$79",
              imageUrl: "images/search/products/pants/22_Sandy_Cay_Pants_$79/82091_ELKH.jpg"
          }, {
              classes: "product-tile--single",
              name: "Guidewater II",
              price: "$99",
              imageUrl: "images/search/products/pants/23_Guidewater_II_Pants_$99/82102_ASHT.jpg"
          }, {
              classes: "product-tile--single",
              name: "Hampi Rock Pants",
              price: "$79",
              imageUrl: "images/search/products/pants/24_Hampi_Rock_Pants_$79/82940_COI.jpg"
          }, {
              classes: "product-tile--single",
              name: "RPS Rock Pants",
              price: "$89",
              imageUrl: "images/search/products/pants/25_RPS_Rock_Pants_$89/83071_NVYB.jpg"
          }, {
              classes: "product-tile--single",
              name: "Shelled Insulator Pants",
              price: "$169",
              imageUrl: "images/search/products/pants/26_Shelled_Insulator_Pants_$169/25669_FGE.jpg"
          }, {
              classes: "product-tile--single",
              name: "Quandary Convertible Pants",
              price: "$89",
              imageUrl: "images/search/products/pants/27_Quandary_Convertible_Pants_$89/55255_FGE.jpg"
          }, {
              classes: "product-tile--single",
              name: "Peak Mission Tights",
              price: "$119",
              imageUrl: "images/search/products/pants/28_Peak_Mission_Tights_$119/23985_BLK.jpg"
          }, {
              classes: "product-tile--single",
              name: "Performance Gi IV Pants",
              price: "$89",
              imageUrl: "images/search/products/pants/29_Performance_Gi_IV_Pants_$89/55316_NVYB.jpg"
          }, {
              classes: "product-tile--single",
              name: "Stretch Thermal Pants",
              price: "$119",
              imageUrl: "images/search/products/pants/30_Stretch_Thermal_Pants_$119/87000_BLK.jpg"
          }]
      },
      results: {
          ui: {
              didYouMean: "Did you Mean",
              sampleSuggestion: "Patagonia",
              viewAllResults: "View All <%= count %> Results",
              subheading: "Showing <%= count %> results"
          }
      },
      noResults: {
          heading: "Hmm, No Results",
          subheading: "0 results for",
          background: {
              imageUrl: "images/search/no-results.png",
              imageUrlMobile: "images/search/no-results-mobile.png"
          }
      }
  }
}
, function(e, t) {
  e.exports = '<% for (var i = 0; i < items.length; i++) { %>\n\t<% var item = items[i]; %>\n\t<li>\n\t\t<a href="<%= item.linkUrl %>">\n\t\t\t<span class="h7"><%= item.heading %></span>\n\t\t</a>\n\t</li>\n<% } %>\n'
}
, function(e, t) {
  e.exports = '<% for (var i = 0; i < items.length; i++) { %>\n\t<% if (i >= 12) { break; } %>\n\t<% var item = items[i]; %>\n\t\n<li class="search-overlay__results-product-tile-wrapper col-6 col-md-6 col-lg-4 col-xl-3 <%= item.columnClasses %>" data-product-tile >\n\t<div class="product-tile search-overlay__results-product-tile <%= item.classes %>"  data-size-stock="">\n\t\t<a href="javascript:;" data-image-zoom-url="<%= item.imageUrl %>">\n\t\t\t<div class="product-tile__image-wrap">\n\n\t\t\t\t\n\t\t\t\t<div class="product-tile__image">\n\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t<img class="lazyload" data-src="/assets/<%= item.imageUrl %>" alt="">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</a>\n\n\t\t<div class="product-tile__meta">\n\n\t\t\t<div class="product-tile__meta-primary">\n\t\t\t\t<a href="javascript:;">\n\t\t\t\t\t<h3 class="product-tile__name"><%= item.name %></h3>\n\t\t\t\t\t<span class="product-tile__price"><%= item.price %></span>\n\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t</div>\n\n\t\t\t\n\t\t</div>\n\t</div>\n</li>\n<% } %>\n'
}
, function(e) {
  e.exports = {
      dataUrl: "https://jsonplaceholder.typicode.com/posts",
      results: {
          ui: {
              showingResults: "Showing 12 results",
              viewAllResults: "View All <%= count %> Results"
          },
          shoppingTool: {
              expanded: {
                  categoryPrimary: {
                      heading: "“Pants”",
                      type: "text-list",
                      multiselect: !1,
                      items: [{
                          heading: "<span class='medium'>Pants in</span> Men's",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "<span class='medium'>Pants in</span> Women's",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "<span class='medium'>Pants in</span> Kids",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "<span class='medium'>Pants in</span> Snow",
                          linkUrl: "javascript:;"
                      }, {
                          heading: "<span class='medium'>Pants in</span> Climb",
                          linkUrl: "javascript:;"
                      }]
                  }
              }
          },
          categories: [{
              heading: "Men's Pants",
              count: 23,
              linkUrl: "javascript:;"
          }, {
              heading: "Women's Pants",
              count: 13,
              linkUrl: "javascript:;"
          }, {
              heading: "Snow Pants",
              count: 15,
              linkUrl: "javascript:;"
          }, {
              heading: "Sweat Pants",
              count: 8,
              linkUrl: "javascript:;"
          }, {
              heading: "Jeans",
              count: 11,
              linkUrl: "javascript:;"
          }],
          items: [{
              classes: "product-tile--single",
              name: "Iron Forge Hemp® Canvas Double Knee Pants",
              price: "$69",
              imageUrl: "images/search/products/pants/1_Iron_Forge_Hemp®_Canvas_Double_Knee_Pants_$69/55785_FTGN.jpg"
          }, {
              classes: "product-tile--single",
              name: "All Seasons Hemp Canvas Double Knee Pants",
              price: "$79",
              imageUrl: "images/search/products/pants/2_All_Seasons_Hemp_Canvas_Double_Knee_Pants_$79/55296_COI.jpg"
          }, {
              classes: "product-tile--single",
              name: "Performance Twill Jeans",
              price: "$99",
              imageUrl: "images/search/products/pants/3_Performance_Twill_Jeans_$99/56490_INDG.jpg"
          }, {
              classes: "product-tile--single",
              name: "Stonycroft Jeans",
              price: "$69",
              imageUrl: "images/search/products/pants/4_Stonycroft_Jeans_$69/55625_INDG.jpg"
          }, {
              classes: "product-tile--single",
              name: "Performance Regular Fit Jeans",
              price: "$119",
              imageUrl: "images/search/products/pants/5_Performance_Regular_Fit_Jeans_$119/56200_DDNM.jpg"
          }, {
              classes: "product-tile--single",
              name: "Four Canyon Twill Pants",
              price: "$79",
              imageUrl: "images/search/products/pants/6_Four_Canyon_Twill_Pants_$79/56060_INDG.jpg"
          }, {
              classes: "product-tile--single",
              name: "Woolie Fleece Pants",
              price: "$119",
              imageUrl: "images/search/products/pants/7_Woolie_Fleece_Pants_$119/56720_OAT.jpg"
          }, {
              classes: "product-tile--single",
              name: "Mahnya Fleece Pants",
              price: "$79",
              imageUrl: "images/search/products/pants/8_Mahnya_Fleece_Pants_$79/56666_NVYB.jpg"
          }, {
              classes: "product-tile--single",
              name: "Stretch Thermal Pants",
              price: "$119",
              imageUrl: "images/search/products/pants/9_Stretch_Thermal_Pants_$119/87000_BLK.jpg"
          }, {
              classes: "product-tile--single",
              name: "Synchilla Snap-T Fleece Pants",
              price: "$99",
              imageUrl: "images/search/products/pants/10_Synchilla_Snap-T_Fleece_Pants_$99/56675_NKL.jpg"
          }, {
              classes: "product-tile--single",
              name: "Terrebonne Jogger",
              price: "$79",
              imageUrl: "images/search/products/pants/11_Terrebonne_Jogger_$79/24540_FGE.jpg"
          }, {
              classes: "product-tile--single",
              name: "R1 Fleece Pants",
              price: "$119",
              imageUrl: "images/search/products/pants/12_R1_Fleece_Pants_$119/82156_FGE.jpg"
          }, {
              classes: "product-tile--single",
              name: "Straight Fit Cords",
              price: "$89",
              imageUrl: "images/search/products/pants/13_Straight_Fit_Cords_$89/55930_BENB.jpg"
          }, {
              classes: "product-tile--single",
              name: "Quandary Pants",
              price: "$79",
              imageUrl: "images/search/products/pants/14_Quandary_Pants_$79/55181_ELKH.jpg"
          }, {
              classes: "product-tile--single",
              name: "Wind Shield Soft Shell Pants",
              price: "$159",
              imageUrl: "images/search/products/pants/15_Wind_Shield_Soft_Shell_Pants_$159/24102_BLK.jpg"
          }, {
              classes: "product-tile--single",
              name: "Kalorama Corduroy Pants",
              price: "$99",
              imageUrl: "images/search/products/pants/17_Kalorama_Corduroy_Pants_$99/56605_ASHT.jpg"
          }, {
              classes: "product-tile--single",
              name: "Torrentshell Pants",
              price: "$99",
              imageUrl: "images/search/products/pants/18_Torrentshell_Pants_$99/83812_FGE.jpg"
          }, {
              classes: "product-tile--single",
              name: "Nano Puff Pants",
              price: "$179",
              imageUrl: "images/search/products/pants/19_Nano_Puff_Pants_$179/82140_FGE.jpg"
          }, {
              classes: "product-tile--single",
              name: "Cloud Ridge Pants",
              price: "$179",
              imageUrl: "images/search/products/pants/20_Cloud_Ridge_Pants_$179/83695_BLK.jpg"
          }, {
              classes: "product-tile--single",
              name: "Steel Forge Denim Pants",
              price: "$159",
              imageUrl: "images/search/products/pants/21_Steel_Forge_Denim_Pants_$159/56120_DDNM.jpg"
          }, {
              classes: "product-tile--single",
              name: "Sandy Cay Pants",
              price: "$79",
              imageUrl: "images/search/products/pants/22_Sandy_Cay_Pants_$79/82091_ELKH.jpg"
          }, {
              classes: "product-tile--single",
              name: "Guidewater II",
              price: "$99",
              imageUrl: "images/search/products/pants/23_Guidewater_II_Pants_$99/82102_ASHT.jpg"
          }, {
              classes: "product-tile--single",
              name: "Hampi Rock Pants",
              price: "$79",
              imageUrl: "images/search/products/pants/24_Hampi_Rock_Pants_$79/82940_COI.jpg"
          }, {
              classes: "product-tile--single",
              name: "RPS Rock Pants",
              price: "$89",
              imageUrl: "images/search/products/pants/25_RPS_Rock_Pants_$89/83071_NVYB.jpg"
          }, {
              classes: "product-tile--single",
              name: "Shelled Insulator Pants",
              price: "$169",
              imageUrl: "images/search/products/pants/26_Shelled_Insulator_Pants_$169/25669_FGE.jpg"
          }, {
              classes: "product-tile--single",
              name: "Quandary Convertible Pants",
              price: "$89",
              imageUrl: "images/search/products/pants/27_Quandary_Convertible_Pants_$89/55255_FGE.jpg"
          }, {
              classes: "product-tile--single",
              name: "Peak Mission Tights",
              price: "$119",
              imageUrl: "images/search/products/pants/28_Peak_Mission_Tights_$119/23985_BLK.jpg"
          }, {
              classes: "product-tile--single",
              name: "Performance Gi IV Pants",
              price: "$89",
              imageUrl: "images/search/products/pants/29_Performance_Gi_IV_Pants_$89/55316_NVYB.jpg"
          }, {
              classes: "product-tile--single",
              name: "Stretch Thermal Pants",
              price: "$119",
              imageUrl: "images/search/products/pants/30_Stretch_Thermal_Pants_$119/87000_BLK.jpg"
          }]
      },
      sliders: {
          routing: [{
              heading: "Men's Pants",
              imageUrl: "images/search/results/categories/600x600_Denim.jpg",
              cta: {
                  heading: "Shop",
                  linkUrl: "javascript:;"
              }
          }, {
              heading: "Women's Pants",
              imageUrl: "images/search/results/categories/600x600_women_s.jpg",
              cta: {
                  heading: "Shop",
                  linkUrl: "javascript:;"
              }
          }, {
              heading: "Leggings",
              imageUrl: "images/search/results/categories/600x600_leggings.jpg",
              cta: {
                  heading: "Shop",
                  linkUrl: "javascript:;"
              }
          }, {
              heading: "Snow Pants",
              imageUrl: "images/search/results/categories/600x600_snow_pants.jpg",
              cta: {
                  heading: "Shop",
                  linkUrl: "javascript:;"
              }
          }],
          stories: {
              title: "Stories",
              cards: [{
                  heading: "Dyneema Denim",
                  badgeHeading: "Film",
                  metaPrimary: "Materials & Technology",
                  videoUrl: "video/cards/BHOE-Ambient-Card.mp4",
                  cardSubType: "video"
              }, {
                  heading: "Product Testing – Dracula and Cassin Simul-Solo",
                  metaPrimary: "Read",
                  metaSecondary: "By Colin Haley",
                  imageUrl: "images/search/results/stories/600x400_TCL_1.jpg",
                  badgeHeading: "The Cleanest Line",
                  cardSubType: "article",
                  iconUrl: "external-link-arrow.svg"
              }, {
                  heading: "Hemp Fiber",
                  badgeHeading: "Film",
                  metaPrimary: "Materials & Technology",
                  videoUrl: "video/cards/BHOE-Ambient-Card.mp4",
                  cardSubType: "video"
              }, {
                  heading: "Two New Products I Want to Rave About",
                  metaPrimary: "By Colin Haley",
                  metaSecondary: "By Taylor Cox",
                  imageUrl: "images/search/results/stories/600x600_men_s.jpg",
                  badgeHeading: "The Cleanest Line",
                  cardSubType: "article",
                  iconUrl: "external-link-arrow.svg"
              }]
          }
      },
      noResults: {
          heading: "There are no results for",
          background: {
              imageUrl: "search/no-results.png",
              imageUrlMobile: "search/no-results-mobile.png"
          }
      }
  }
}
, function(e) {
  e.exports = {
      config: {
          rootCategory: !1
      },
      collapsed: {
          heading: "Show me..."
      },
      expanded: {
          ui: {
              apply: "Apply",
              clearAll: "Clear All",
              done: "Done",
              prevCategoryCta: {
                  heading: "Previous Category",
                  linkUrl: "javascript:;"
              },
              search: "Search",
              sizeFitColor: "Size, fit & color"
          },
          categoryPrimary: {
              heading: "Jackets & Outerwear",
              type: "text-list",
              multiselect: !1,
              items: [{
                  heading: "Insulated",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Shells",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Rainwear",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Vests",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Windbreakers",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Workwear",
                  linkUrl: "javascript:;"
              }, {
                  heading: "Casual",
                  linkUrl: "javascript:;"
              }]
          },
          categories: [{
              heading: "Size",
              type: "circle-buttons",
              multiselect: !0,
              items: [{
                  heading: "xs"
              }, {
                  heading: "s"
              }, {
                  heading: "m"
              }, {
                  heading: "l"
              }, {
                  heading: "xl"
              }, {
                  heading: "xxl"
              }, {
                  heading: "3xl"
              }]
          }, {
              heading: "Fit",
              type: "text-buttons",
              multiselect: !0,
              items: [{
                  heading: "Regular"
              }, {
                  heading: "Slim Fit"
              }, {
                  heading: "Casual Fit"
              }]
          }, {
              heading: "Color",
              type: "swatches",
              multiselect: !0,
              items: [{
                  hex: "#cc0000"
              }, {
                  hex: "#00cc00"
              }, {
                  hex: "#0000cc"
              }, {
                  hex: "#cccc00"
              }, {
                  hex: "#00cccc"
              }, {
                  hex: "#cc00cc"
              }, {
                  hex: "#cccccc"
              }]
          }, {
              heading: "Sort By",
              type: "text-list",
              multiselect: !1,
              items: [{
                  heading: "Featured",
                  default: !0
              }, {
                  heading: "Name (A-Z)"
              }, {
                  heading: "Name (Z-A)"
              }, {
                  heading: "Lowest Price"
              }, {
                  heading: "Newest"
              }, {
                  heading: "Highest Rated"
              }, {
                  heading: "Most Popular"
              }]
          }]
      }
  }
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {
      slides: [{
          image: {
              linkUrl: "images/sliders/image-gallery-1.jpg"
          },
          overlayInfo: {
              blurb: "1. Occupy organic, stumptown shabby chic pour-over roof this is a link to somewhere.",
              caption: "Photo: Mary McIntyre",
              cta: {
                  heading: "Link To Story"
              }
          }
      }, {
          image: {
              linkUrl: "images/sliders/image-gallery-2.jpg"
          },
          overlayInfo: {
              blurb: "2. Occupy organic, stumptown shabby chic pour-over roof this is a link to somewhere.",
              caption: "Photo: Mary McIntyre",
              cta: {
                  heading: "Link To Story"
              }
          }
      }, {
          image: {
              linkUrl: "images/sliders/image-gallery-3.jpg"
          },
          overlayInfo: {
              blurb: "3. Occupy organic, stumptown shabby chic pour-over roof this is a link to somewhere.",
              caption: "Photo: Mary McIntyre",
              cta: {
                  heading: "Link To Story"
              }
          }
      }, {
          image: {
              linkUrl: "images/sliders/image-gallery-4.jpg"
          },
          overlayInfo: {
              blurb: "4. Occupy organic, stumptown shabby chic pour-over roof this is a link to somewhere.",
              caption: "Photo: Mary McIntyre",
              cta: {
                  heading: "Link To Story"
              }
          }
      }, {
          image: {
              linkUrl: "images/sliders/image-gallery-1.jpg"
          },
          overlayInfo: {
              blurb: "5. Occupy organic, stumptown shabby chic pour-over roof this is a link to somewhere.",
              caption: "Photo: Mary McIntyre",
              cta: {
                  heading: "Link To Story"
              }
          }
      }]
  }
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {}
}
, function(e) {
  e.exports = {
      groups: [{
          heading: "CTA Rounded Rectangle Large - 56px",
          type: "cta-rounded-rect",
          buttons: [{
              heading: "Button",
              classes: "btn-lg btn-dark"
          }, {
              heading: "Button",
              classes: "btn-lg btn-light"
          }, {
              heading: "Button",
              classes: "btn-lg btn-dark btn-outlined"
          }, {
              heading: "Button",
              classes: "btn-lg btn-light btn-outlined"
          }]
      }, {
          heading: "CTA Rounded Rectangle - 44px",
          type: "cta-rounded-rect",
          buttons: [{
              heading: "Button",
              classes: "btn-dark"
          }, {
              heading: "Button",
              classes: "btn-light"
          }, {
              heading: "Button",
              classes: "btn-dark btn-outlined"
          }, {
              heading: "Button",
              classes: "btn-light btn-outlined"
          }, {
              heading: "Button",
              classes: "btn-progress"
          }]
      }, {
          heading: "CTA Rounded Rectangle - 32px",
          type: "cta-rounded-rect",
          buttons: [{
              heading: "Button",
              classes: "btn-sm btn-dark"
          }, {
              heading: "Button",
              classes: "btn-sm btn-light"
          }, {
              heading: "Button",
              classes: "btn-sm btn-dark btn-outlined"
          }, {
              heading: "Button",
              classes: "btn-sm btn-light btn-outlined"
          }, {
              heading: "Button",
              classes: "btn-sm btn-progress"
          }]
      }, {
          heading: "CTA Rounded Rectangle - 24px",
          type: "cta-rounded-rect",
          buttons: [{
              heading: "Button",
              classes: "btn-xs btn-dark"
          }, {
              heading: "Button",
              classes: "btn-xs btn-light"
          }, {
              heading: "Button",
              classes: "btn-xs btn-progress"
          }]
      }, {
          heading: "CTA Circle with Text",
          type: "cta-circle",
          buttons: [{
              heading: "xs",
              classes: ""
          }, {
              heading: "xs",
              classes: "cta-circle-light"
          }, {
              heading: "xs",
              classes: "cta-circle-outlined"
          }, {
              heading: "xs",
              classes: "cta-circle-outlined cta-circle-light"
          }]
      }, {
          heading: "CTA Circle with Icon - 56px",
          type: "cta-circle",
          buttons: [{
              iconUrl: "cta-circle/x.svg",
              classes: "cta-circle-lg"
          }, {
              iconUrl: "cta-circle/x.svg",
              classes: "cta-circle-lg cta-circle-light"
          }, {
              iconUrl: "cta-circle/x.svg",
              classes: "cta-circle-lg cta-circle-outlined"
          }, {
              iconUrl: "cta-circle/x.svg",
              classes: "cta-circle-lg cta-circle-outlined cta-circle-light"
          }]
      }, {
          heading: "CTA Circle with Icon - 44px",
          type: "cta-circle",
          buttons: [{
              iconUrl: "cta-circle/x.svg",
              classes: ""
          }, {
              iconUrl: "cta-circle/x.svg",
              classes: "cta-circle-light"
          }, {
              iconUrl: "cta-circle/x.svg",
              classes: "cta-circle-outlined"
          }, {
              iconUrl: "cta-circle/x.svg",
              classes: "cta-circle-outlined cta-circle-light"
          }]
      }, {
          heading: "CTA Circle with Icon - 32px",
          type: "cta-circle",
          buttons: [{
              iconUrl: "cta-circle/x.svg",
              classes: "cta-circle-sm"
          }, {
              iconUrl: "cta-circle/x.svg",
              classes: "cta-circle-sm cta-circle-light"
          }, {
              iconUrl: "cta-circle/x.svg",
              classes: "cta-circle-sm cta-circle-outlined"
          }, {
              iconUrl: "cta-circle/x.svg",
              classes: "cta-circle-sm cta-circle-outlined cta-circle-light"
          }]
      }, {
          heading: "CTA Circle with Swatch",
          type: "cta-circle",
          buttons: [{
              iconUrl: "cta-circle/check.svg",
              hex: "#FA4616"
          }, {
              iconUrl: "cta-circle/check.svg",
              hex: "#500778"
          }, {
              iconUrl: "cta-circle/check.svg",
              hex: "#003DA5"
          }, {
              iconUrl: "cta-circle/check.svg",
              hex: "#FEB904"
          }, {
              iconUrl: "cta-circle/check.svg",
              hex: "#32B67A"
          }, {
              iconUrl: "cta-circle/check.svg",
              hex: "#003DA5",
              hex2: "#FA4616"
          }]
      }, {
          heading: "CTA Circle with Swatch (small)",
          type: "cta-circle",
          buttons: [{
              classes: "cta-circle-sm",
              iconUrl: "cta-circle/check.svg",
              hex: "#FA4616"
          }, {
              classes: "cta-circle-sm",
              iconUrl: "cta-circle/check.svg",
              hex: "#500778"
          }, {
              classes: "cta-circle-sm",
              iconUrl: "cta-circle/check.svg",
              hex: "#003DA5"
          }, {
              classes: "cta-circle-sm",
              iconUrl: "cta-circle/check.svg",
              hex: "#FEB904"
          }, {
              classes: "cta-circle-sm",
              iconUrl: "cta-circle/check.svg",
              hex: "#32B67A"
          }, {
              classes: "cta-circle-sm",
              iconUrl: "cta-circle/check.svg",
              hex: "#003DA5",
              hex2: "#FA4616"
          }]
      }, {
          heading: "Back Links",
          type: "cta-link-back",
          buttons: [{
              heading: "CTA Link Back",
              classes: "is-left",
              iconUrl: "cta-link/arrow-left.svg"
          }, {
              heading: "CTA Link Back",
              classes: "is-left cta-link-back-light",
              iconUrl: "cta-link/arrow-left.svg"
          }]
      }, {
          heading: "Underlined Links",
          type: "cta-link-underline",
          buttons: [{
              heading: "CTA Link Underline",
              classes: ""
          }, {
              heading: "CTA Link Underline",
              classes: "cta-link-underline-light"
          }]
      }, {
          heading: "Underlined Links (reversed)",
          type: "cta-link-underline",
          buttons: [{
              heading: "Reversed CTA Link Underline",
              classes: "cta-link-underline-in"
          }, {
              heading: "Reversed CTA Link Underline",
              classes: "cta-link-underline-in cta-link-underline-light"
          }]
      }, {
          heading: "Checkout Buttons",
          type: "cta-rounded-rect",
          buttons: [{
              heading: "Checkout",
              classes: "btn-lg btn-dark btn-checkout"
          }, {
              heading: "Pay",
              classes: "btn-lg btn-light btn-apple",
              iconUrl: "payment/apple-icon.svg"
          }, {
              heading: "Pay",
              classes: "btn-lg btn-dark btn-apple",
              iconUrl: "payment/apple-icon.svg"
          }, {
              heading: "PayPal",
              classes: "btn-lg btn-dark btn-paypal",
              iconUrl: "payment/paypal-icon.svg"
          }]
      }]
  }
}
, function(e) {
  e.exports = {
      sections: [{
          anchorId: "card-paw",
          heading: "PAW Cards",
          content: {
              cards: [{
                  classes: "card--paw-event",
                  colClasses: "col-sm-6 col-md-6 col-lg-4 col-xl-3",
                  imageUrl: "images/home/paw/paw-event.jpg",
                  heading: "Ocean Friendly Restaurants Fall Kickoff Meeting",
                  metaPrimary: "RSVP",
                  metaSecondary: "Ventura, CA<br>November 12<br>6pm-10pm",
                  badgeHeading: "Event",
                  iconUrl: "paw/event.svg"
              }, {
                  classes: "card--paw-petition",
                  colClasses: "col-sm-6 col-md-6 col-lg-4 col-xl-3",
                  imageUrl: "images/home/paw/paw-environment.jpg",
                  heading: "Tell Congress to Protect Our Marine Sanctuaries and Monuments",
                  metaPrimary: "Take Action",
                  metaSecondary: "Surfrider Foundation<br>36 Days Left to Act",
                  badgeHeading: "Petition",
                  iconUrl: "paw/petition.svg"
              }, {
                  classes: "card--paw-volunteer",
                  colClasses: "col-sm-6 col-md-6 col-lg-4 col-xl-3",
                  imageUrl: "images/home/paw/paw-petition.jpg",
                  heading: "Help With Google Adwords Setup",
                  metaPrimary: "Take Action",
                  metaSecondary: "Surfrider Foundation<br>1 Week",
                  badgeHeading: "Volunteer",
                  iconUrl: "paw/volunteer.svg"
              }, {
                  classes: "card--paw-grantee",
                  colClasses: "col-sm-6 col-md-6 col-lg-4 col-xl-3",
                  imageUrl: "images/home/paw/paw-volunteer.jpg",
                  heading: "San Dieguito River Valley Conservancy",
                  metaPrimary: "Take Action",
                  metaSecondary: "Biodiversity<br>La Jolla, CA",
                  badgeHeading: "Grantee",
                  iconUrl: "paw/volunteer.svg"
              }]
          }
      }, {
          anchorId: "card-paw-generic",
          heading: "PAW Generic Cards",
          content: {
              cards: [{
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  imageUrl: "images/cards/card-paw-generic.jpg",
                  metaPrimary: "Take Action"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  imageUrl: "images/cards/card-paw-generic.jpg",
                  metaPrimary: "Take Action"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  imageUrl: "images/cards/card-paw-generic.jpg",
                  metaPrimary: "Take Action"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  imageUrl: "images/cards/card-paw-generic.jpg",
                  metaPrimary: "Take Action"
              }]
          }
      }, {
          anchorId: "card-stories",
          heading: "Stories Cards",
          variations: {
              video: {
                  heading: "Video Version",
                  id: "card-stories-video"
              },
              article: {
                  heading: "Article Version",
                  id: "card-stories-article"
              }
          },
          content: {
              cardStories: [{
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  videoUrl: "video/cards/BHOE-Ambient-Card.mp4",
                  heading: "Blue Heart of Europe",
                  badgeHeading: "Film",
                  metaPrimary: "00:00",
                  cardSubType: "video"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  videoUrl: "video/cards/BearsEars-Ambient-Card.mp4",
                  heading: "Blue Heart of Europe",
                  badgeHeading: "Interactive",
                  metaPrimary: "",
                  cardSubType: "video",
                  isInteractive: !0
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  videoUrl: "video/cards/BHOE-Ambient-Card.mp4",
                  heading: "Blue Heart of Europe",
                  badgeHeading: "Film",
                  metaPrimary: "00:00",
                  cardSubType: "video"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  videoUrl: "video/cards/BearsEars-Ambient-Card.mp4",
                  heading: "Blue Heart of Europe",
                  badgeHeading: "Interactive",
                  metaPrimary: "",
                  cardSubType: "video",
                  isInteractive: !0
              }],
              cardArticles: [{
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  imageUrl: "images/cards/card-cleanest-line.jpg",
                  heading: "Story Headline Can Sit Nicely Right Here",
                  metaPrimary: "Read",
                  metaSecondary: "By Krista Langlois",
                  badgeHeading: "The Cleanest Line",
                  iconUrl: "external-link-arrow.svg"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  imageUrl: "images/cards/card-cleanest-line.jpg",
                  heading: "Story Headline Can Sit Nicely Right Here",
                  metaPrimary: "Read",
                  metaSecondary: "By Krista Langlois",
                  badgeHeading: "The Cleanest Line",
                  iconUrl: "external-link-arrow.svg"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  imageUrl: "images/cards/card-cleanest-line.jpg",
                  heading: "Story Headline Can Sit Nicely Right Here",
                  metaPrimary: "Read",
                  metaSecondary: "By Krista Langlois",
                  badgeHeading: "The Cleanest Line",
                  iconUrl: "external-link-arrow.svg"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  imageUrl: "images/cards/card-cleanest-line.jpg",
                  heading: "Story Headline Can Sit Nicely Right Here",
                  metaPrimary: "Read",
                  metaSecondary: "By Krista Langlois",
                  badgeHeading: "The Cleanest Line",
                  iconUrl: "external-link-arrow.svg"
              }]
          }
      }, {
          anchorId: "card-image",
          heading: "Image Cards",
          variations: {
              small: {
                  heading: "Routing - Small",
                  id: "card-image-small"
              },
              large: {
                  heading: "Routing - Large",
                  id: "card-image-large"
              },
              smallImage: {
                  heading: "Image - Portrait",
                  id: "card-image-small"
              },
              largeImage: {
                  heading: "Image - Landscape",
                  id: "card-image-large"
              }
          },
          content: {
              cardsRoutingSmall: [{
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  heading: "Label",
                  imageUrl: "images/cards/card-routing-small.jpg",
                  cta: {
                      heading: "Shop",
                      linkUrl: "pages/page-plp-subcat-jackets"
                  }
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  heading: "Label",
                  imageUrl: "images/cards/card-routing-small.jpg",
                  cta: {
                      heading: "Shop",
                      linkUrl: "pages/page-plp-cat"
                  }
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  heading: "Label",
                  imageUrl: "images/cards/card-routing-small.jpg",
                  cta: {
                      heading: "Shop",
                      linkUrl: "javascript:;"
                  }
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  heading: "Label",
                  imageUrl: "images/cards/card-routing-small.jpg",
                  cta: {
                      heading: "Shop",
                      linkUrl: "javascript:;"
                  }
              }],
              cardsRoutingLarge: [{
                  colClasses: "col-sm-6 col-md-6 col-lg-6",
                  classes: "card--lg",
                  heading: "Label",
                  imageUrl: "images/cards/card-routing-large.jpg",
                  cta: {
                      heading: "Shop",
                      linkUrl: "pages/page-plp-subcat-jackets"
                  }
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-6",
                  classes: "card--lg",
                  heading: "Label",
                  imageUrl: "images/cards/card-routing-large.jpg",
                  cta: {
                      heading: "Shop",
                      linkUrl: "pages/page-plp-cat"
                  }
              }],
              cardsImageSmall: [{
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  heading: "",
                  imageUrl: "images/cards/card-image-small.jpg"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  heading: "",
                  imageUrl: "images/cards/card-image-small.jpg"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  heading: "",
                  imageUrl: "images/cards/card-image-small.jpg"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  heading: "",
                  imageUrl: "images/cards/card-image-small.jpg"
              }],
              cardsImageLarge: [{
                  colClasses: "col-sm-6 col-md-6 col-lg-6",
                  classes: "card--lg",
                  heading: "",
                  imageUrl: "images/cards/card-routing-large.jpg"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-6",
                  classes: "card--lg",
                  heading: "",
                  imageUrl: "images/cards/card-routing-large.jpg"
              }]
          }
      }, {
          anchorId: "card-review",
          heading: "Review Cards",
          content: {
              cards: [{
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  heading: "Jenny",
                  subheading: "Los Angeles",
                  text: "This jacket looks great. I love the Tomato color for making me more visible on roadways…"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  heading: "Jenny",
                  subheading: "Los Angeles",
                  text: "This jacket looks great. I love the Tomato color for making me more visible on roadways…"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  heading: "Jenny",
                  subheading: "Los Angeles",
                  text: "This jacket looks great. I love the Tomato color for making me more visible on roadways…"
              }, {
                  colClasses: "col-sm-6 col-md-6 col-lg-3",
                  heading: "Jenny",
                  subheading: "Los Angeles",
                  text: "This jacket looks great. I love the Tomato color for making me more visible on roadways…"
              }]
          }
      }, {
          anchorId: "card-content",
          heading: "Content Cards",
          variations: {
              default: {
                  heading: "Image + Copy",
                  id: "card-feature-default"
              }
          },
          content: {
              cards: [{
                  label: "Image + Text",
                  colClasses: "col-sm-6 col-md-4 col-lg-3",
                  imageUrl: "images/cards/card-content.jpg",
                  badge: "",
                  caption: {
                      heading: "Title Goes Here",
                      text: "Description goes here lorem ipsum Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                  }
              }, {
                  label: "Ambient Video",
                  colClasses: "col-sm-6 col-md-4 col-lg-3",
                  videoUrl: "video/pdp/micropuff/tile-1-v2.mp4",
                  imageUrl: "images/cards/card-content.jpg",
                  badge: "",
                  caption: {
                      heading: "Title Goes Here",
                      text: "Description goes here lorem ipsum Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                  }
              }, {
                  label: "Click To Play Video",
                  colClasses: "col-sm-6 col-md-4 col-lg-3",
                  imageUrl: "images/cards/card-content.jpg",
                  badge: "",
                  caption: {
                      heading: "Title Goes Here",
                      text: "Description goes here lorem ipsum Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                  },
                  videoModal: {
                      linkUrl: "google.com"
                  }
              }, {
                  label: "Text Only",
                  colClasses: "col-sm-6 col-md-4 col-lg-3",
                  badge: "",
                  caption: {
                      heading: "Title Goes Here",
                      text: "Description goes here lorem ipsum Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                  }
              }]
          }
      }, {
          anchorId: "card-products",
          heading: "Products",
          subvariations: {
              full: {
                  heading: "Full"
              },
              standard: {
                  heading: "Standard"
              },
              colorway: {
                  heading: "Colorway"
              }
          },
          productTiles: [{
              columnClasses: "col-sm-6 col-md-4 col-lg-3",
              name: "Product Name Goes Here & It Be Really Super Long...",
              price: "$199",
              rightBadge: "New",
              imageUrl: "images/product-tiles/demo/fleece/product-tile-fleece-grey.jpg",
              logoBadge: "images/badges/goretex.png",
              colors: [{
                  hex: "#5D5B66"
              }, {
                  hex: "#9E680E"
              }, {
                  hex: "#4D5E3A"
              }, {
                  hex: "#45324C"
              }],
              colorQty: "# of Colors"
          }, {
              columnClasses: "col-sm-6 col-md-4 col-lg-3",
              name: "Product Name Here",
              price: "$199",
              imageUrl: "images/product-tiles/demo/fleece/product-tile-fleece-grey.jpg",
              colors: [{
                  hex: "#5D5B66"
              }, {
                  hex: "#9E680E"
              }, {
                  hex: "#4D5E3A"
              }, {
                  hex: "#45324C"
              }],
              colorQty: "# of Colors"
          }, {
              columnClasses: "col-sm-6 col-md-4 col-lg-3",
              name: "Color Name Here",
              price: "$199",
              imageUrl: "images/product-tiles/demo/fleece/product-tile-fleece-grey.jpg"
          }, {
              classes: "product-tile--bg",
              columnClasses: "col-sm-6 col-md-4 col-lg-3",
              name: "Product Name",
              price: "$280",
              imageUrl: "images/product-tiles/demo/fleece/product-tile-model.jpg",
              colors: [{
                  hex: "#003DA5"
              }, {
                  hex: "#003DA5"
              }, {
                  hex: "#003DA5"
              }, {
                  hex: "#003DA5"
              }, {
                  hex: "#003DA5"
              }, {
                  hex: "#003DA5"
              }, {
                  hex: "#003DA5"
              }, {
                  hex: "#003DA5"
              }, {
                  hex: "#003DA5"
              }, {
                  hex: "#003DA5"
              }, {
                  hex: "#003DA5"
              }, {
                  hex: "#003DA5"
              }, {
                  hex: "#003DA5"
              }]
          }]
      }]
  }
}
, function(e) {
  e.exports = {
      groups: [{
          heading: "Brand Colors",
          colors: [{
              id: "",
              heading: "",
              subheading: "",
              hex: "#FA4616"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#500778"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#003DA5"
          }]
      }, {
          heading: "Bright Colors",
          colors: [{
              id: "",
              heading: "",
              subheading: "ERROR",
              hex: "#E10000"
          }, {
              id: "",
              heading: "",
              subheading: "WARNING",
              hex: "#FEB904"
          }, {
              id: "",
              heading: "",
              subheading: "SUCCESS",
              hex: "#32B67A"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#6A8CE9"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#342E7D"
          }]
      }, {
          heading: "Neutral ",
          colors: [{
              id: "",
              heading: "",
              subheading: "",
              hex: "#000000"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#222222"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#333333"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#4A4A4A"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#999999"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#CCCCCC"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#E1E1E1"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#EAEAEA"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#F5F5F5"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#FAFAFA"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#F5F5F5"
          }, {
              id: "",
              heading: "",
              subheading: "",
              hex: "#FFFFFF"
          }]
      }]
  }
}
, function(e) {
  e.exports = {
      groups: [{
          heading: "Form Fields"
      }, {
          heading: "Form States"
      }]
  }
}
, function(e) {
  e.exports = {
      heading: "Heroes",
      headings: ["Hero PLP", "Hero PLP - Ambient Video", "Hero PLP - No Image", "Hero Fullscreen - Ambient Video", "Hero Fullscreen - Film Campaign", "Hero Fullscreen - Sale Campaign", "Hero Fullscreen - Product Campaign"],
      plpHero: {
          heading: "Category Title",
          background: {
              imageUrl: "images/hero/hero-plp-cat.jpg"
          },
          videoBackground: {
              linkUrl: "video/home/home-video-bg.mp4"
          }
      },
      heroes: [{
          content: {
              heading: "Campaign Title Goes Here",
              cta: {
                  heading: "Call To Action"
              }
          },
          backgroundUrl: "images/hero/hero-cta.jpg",
          overlayInfo: {
              blurb: "After a finger-numbing ride through the highlands, Carston can't quite believe his luck as he warms up under one of Icelands's most luxurious natural amenities — unlimited hot water from underground geothermal fields.",
              caption: "Photo: Mary McIntyre",
              cta: {
                  heading: "Link To Story"
              }
          }
      }, {
          content: {
              heading: "Mountain Biking Gear Guide",
              cta: {
                  heading: "Call To Action"
              }
          },
          backgroundUrl: "images/hero/hero-cta.jpg",
          overlayInfo: {
              blurb: "After a finger-numbing ride through the highlands, Carston can't quite believe his luck as he warms up under one of Icelands's most luxurious natural amenities — unlimited hot water from underground geothermal fields.",
              caption: "Photo: Mary McIntyre",
              cta: {
                  heading: "Link To Story"
              }
          }
      }, {
          content: {
              heading: "Get it Before<br>it’s Gone",
              cta: {
                  heading: "Shop Sale"
              }
          },
          backgroundUrl: "images/hero/hero-sale.jpg",
          overlayInfo: {
              blurb: "After a finger-numbing ride through the highlands, Carston can't quite believe his luck as he warms up under one of Icelands's most luxurious natural amenities — unlimited hot water from underground geothermal fields.",
              caption: "Photo: Mary McIntyre",
              cta: {
                  heading: "Link To Story"
              }
          }
      }, {
          content: {
              heading: "What's In<br>Your Baggies",
              cta: {
                  heading: "Shop Baggies"
              }
          },
          backgroundUrl: "images/hero/hero-baggies.jpg",
          overlayInfo: {
              blurb: "After a finger-numbing ride through the highlands, Carston can't quite believe his luck as he warms up under one of Icelands's most luxurious natural amenities — unlimited hot water from underground geothermal fields.",
              caption: "Photo: Mary McIntyre",
              cta: {
                  heading: "Link To Story"
              }
          }
      }]
  }
}
, function(e) {
  e.exports = {
      icons: {
          heading: "Icons",
          type: {
              icon: {
                  items: [{
                      svgId: "shopping-bag"
                  }, {
                      svgId: "shopping-bag-filled"
                  }, {
                      svgId: "chevron-down"
                  }, {
                      svgId: "chevron-left"
                  }, {
                      svgId: "chevron-right"
                  }, {
                      svgId: "search"
                  }, {
                      svgId: "ellipses"
                  }, {
                      svgId: "info"
                  }, {
                      svgId: "burger"
                  }, {
                      svgId: "check"
                  }, {
                      svgId: "minus"
                  }, {
                      svgId: "plus"
                  }, {
                      svgId: "x"
                  }, {
                      svgId: "arrow-expand"
                  }, {
                      svgId: "share"
                  }, {
                      svgId: "volume-unmuted"
                  }, {
                      svgId: "volume-muted"
                  }, {
                      svgId: "thumbs-up"
                  }, {
                      svgId: "thumbs-down"
                  }, {
                      svgId: "map-pin"
                  }, {
                      svgId: "social/facebook"
                  }, {
                      svgId: "social/twitter"
                  }, {
                      svgId: "social/instagram"
                  }, {
                      svgId: "social/pinterest"
                  }, {
                      svgId: "lock-locked"
                  }, {
                      svgId: "lock-unlocked"
                  }, {
                      svgId: "play"
                  }, {
                      svgId: "pause"
                  }, {
                      svgId: "rating-star-filled"
                  }, {
                      svgId: "rating-star-outlined"
                  }]
              },
              payment: {
                  items: [{
                      svgId: "payment/paypal"
                  }, {
                      svgId: "payment/visa"
                  }, {
                      svgId: "payment/mastercard"
                  }, {
                      svgId: "payment/amex"
                  }]
              }
          }
      },
      badges: {
          heading: "Badges",
          type: {
              logos: {
                  items: [{
                      imageUrl: "images/badges/goretex.png"
                  }, {
                      imageUrl: "images/badges/fair-trade-sewing.png"
                  }, {
                      imageUrl: "images/badges/re-gen-organic.png"
                  }, {
                      imageUrl: "images/badges/backpacker-editors-choice.png"
                  }, {
                      imageUrl: "images/badges/outside-goty.png"
                  }, {
                      imageUrl: "images/badges/tested-tough.png"
                  }, {
                      imageUrl: "images/badges/bluesign.png"
                  }, {
                      imageUrl: "images/badges/yulex.png"
                  }]
              },
              text: {
                  items: [{
                      heading: "New",
                      light: !0,
                      background: {}
                  }, {
                      heading: "New Color",
                      light: !0,
                      background: {}
                  }, {
                      heading: "Sale",
                      dark: !0,
                      background: {
                          color: "#FA4616"
                      }
                  }, {
                      heading: "Exclusive",
                      dark: !0,
                      background: {
                          color: "#500778"
                      }
                  }]
              }
          }
      },
      ui: {
          default: "Default",
          inverse: "Inverse (Dark Background)",
          text: "Text"
      }
  }
}
, function(e) {
  e.exports = {
      sections: [{
          anchorId: "patagonia-logos",
          heading: "Patagonia Logos",
          items: [{
              type: "default",
              heading: "Default Logo",
              svgId: "logo"
          }, {
              type: "blocked",
              heading: "Blocked Logo",
              svgId: "logo-blocked"
          }]
      }, {
          anchorId: "sub-brand-logos",
          heading: "Sub Brand Logos",
          items: [{
              type: "paw",
              heading: "PAW",
              svgs: [{
                  id: "PAW-1-BLK",
                  classes: ""
              }, {
                  id: "PAW-1-WHI",
                  classes: "is-inverse"
              }]
          }, {
              type: "paw-alternate",
              heading: "PAW Alternate",
              svgs: [{
                  id: "PAW-2-BLK",
                  classes: ""
              }, {
                  id: "PAW-2-WHI",
                  classes: "is-inverse"
              }]
          }, {
              type: "provisions",
              heading: "Provisions",
              svgs: [{
                  id: "Provisions-BLK",
                  classes: ""
              }, {
                  id: "Provisions-GRY",
                  classes: ""
              }, {
                  id: "Provisions-WHI",
                  classes: "is-inverse"
              }]
          }, {
              type: "worn-wear",
              heading: "Worn Wear",
              svgs: [{
                  id: "WW-Color",
                  classes: ""
              }, {
                  id: "WW-WHI",
                  classes: "is-inverse"
              }]
          }]
      }]
  }
}
, function(e) {
  e.exports = {
      sections: {
          navigation: {
              anchorId: "header",
              heading: "Primary Navigation A",
              headingAlt: "Primary Navigation B",
              variations: {
                  default: {
                      heading: "Header (Default)",
                      id: "header-default"
                  },
                  dark: {
                      heading: "Header (Within Dark Container)",
                      id: "header-dark"
                  },
                  full: {
                      heading: "Header (w/ Full Cart)",
                      id: "header-full-cart"
                  }
              }
          },
          subnavigation: {
              anchorId: "subnav",
              heading: "Sub-Navigation",
              variations: {
                  pdp: {
                      heading: "Sub-Navigation (PDP)",
                      id: "subnav-pdp"
                  }
              },
              content: {
                  items: {
                      details: {
                          id: "details",
                          headingSubnav: "Details"
                      },
                      reviews: {
                          id: "reviews",
                          headingSubnav: "Reviews"
                      },
                      sizing: {
                          id: "sizing",
                          headingSubnav: "Sizing"
                      },
                      ironclad: {
                          id: "ironclad",
                          headingSubnav: "Guarantee"
                      }
                  },
                  cta: {
                      heading: "Buy",
                      linkUrl: "javascript:;"
                  }
              }
          },
          cartEmpty: {
              anchorId: "cartEmpty",
              heading: "Mini Bag (Empty)",
              variations: {},
              content: {}
          },
          cartFull: {
              anchorId: "cartFull",
              heading: "Mini Bag (Full)",
              variations: {},
              content: {}
          },
          footer: {
              anchorId: "footer",
              heading: "Footer"
          },
          preFooter: {
              anchorId: "pre-footer-router",
              heading: "Pre-Footer Router",
              content: {
                  columns: [{
                      heading: "Shop Men’s",
                      ctas: [{
                          classes: "is-large is-outlined",
                          cta: {
                              heading: "All",
                              linkUrl: "javascript:;"
                          }
                      }, {
                          classes: "is-large is-outlined",
                          cta: {
                              heading: "New",
                              linkUrl: "javascript:;"
                          }
                      }, {
                          classes: "is-large is-outlined",
                          cta: {
                              heading: "Jackets",
                              linkUrl: "pages/page-plp-subcat-jackets"
                          }
                      }, {
                          classes: "is-large is-outlined",
                          cta: {
                              heading: "Pants",
                              linkUrl: "javascript:;"
                          }
                      }, {
                          classes: "is-large is-outlined",
                          cta: {
                              heading: "&#8230;",
                              linkUrl: "javascript:;"
                          }
                      }]
                  }, {
                      heading: "Search"
                  }]
              }
          },
          shoppingTool: {
              anchorId: "shopping-tool",
              heading: "Shopping Tool",
              variations: {
                  integrated: {
                      heading: "Hero PLP (Shopping Tool Integrated)"
                  }
              }
          },
          tabs: {
              anchorId: "tabs",
              heading: "Tabs"
          },
          accordion: {
              heading: "Accordion",
              features: {
                  id: "features",
                  heading: "Features"
              },
              specs: {
                  id: "specs",
                  heading: "Specs"
              },
              reviews: {
                  id: "reviews",
                  heading: "Reviews"
              },
              supply: {
                  id: "supply-chain",
                  heading: "Supply Chain"
              },
              ironclad: {
                  id: "ironclad",
                  heading: "Ironclad Guarantee"
              }
          }
      }
  }
}
, function(e) {
  e.exports = {
      groups: {
          productTiles: {
              heading: "Product Tiles",
              qty: "+32"
          },
          productHeaders: {
              heading: "Category / Product Header",
              categoryTitle: "Category Title",
              productName: "Product Name",
              productPrice: "$199-250",
              qty: "68"
          },
          productClusters: {
              heading: "Example Cluster"
          }
      },
      productTilesOne: [{
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-fleece-1.jpg"
      }, {
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-fleece-2.jpg"
      }, {
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-fleece-3.jpg"
      }, {
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-fleece-4.jpg"
      }, {
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-fleece-5.jpg"
      }, {
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-fleece-6.jpg"
      }, {
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-fleece-7.jpg"
      }, {
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-fleece-8.jpg"
      }],
      productTilesTwo: [{
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-jacket-1.jpg"
      }, {
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-jacket-2.jpg"
      }, {
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-jacket-3.jpg"
      }, {
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-jacket-4.jpg"
      }, {
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-jacket-5.jpg"
      }, {
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-jacket-6.jpg"
      }, {
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-jacket-7.jpg"
      }, {
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/product-tile-jacket-8.jpg"
      }]
  }
}
, function(e) {
  e.exports = {
      groups: {
          productTiles: {
              heading: "Product Tile Examples",
              qty: "+32"
          },
          productHeaders: {
              heading: "Category / Product Header",
              categoryTitle: "Category Title",
              productName: "Product Name",
              productPrice: "$199-250",
              qty: "68"
          },
          productClusters: {
              heading: "Worse / Best Case"
          }
      },
      productTilesOne: [{
          columnClasses: "col-md-4 col-lg-4",
          classes: "product-tile--bg",
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/demo/fleece/product-tile-model.jpg",
          colors: [{
              hex: "#5D5B66"
          }, {
              hex: "#9E680E"
          }, {
              hex: "#4D5E3A"
          }, {
              hex: "#45324C"
          }]
      }, {
          columnClasses: "col-md-4 col-lg-4",
          classes: "product-tile--overlay",
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/demo/fleece/product-tile-fleece-grey.jpg",
          colors: [{
              hex: "#5D5B66"
          }, {
              hex: "#9E680E"
          }, {
              hex: "#4D5E3A"
          }, {
              hex: "#45324C"
          }],
          overlayText: "The PowSlayer Jacket is lightweight, packable, optimized for backcountry touring and features a minimalist design."
      }, {
          columnClasses: "col-md-4 col-lg-4",
          name: "Product Name",
          price: "$280",
          imageUrl: "images/product-tiles/demo/fleece/product-tile-fleece-grey.jpg",
          colors: [{
              hex: "#5D5B66"
          }, {
              hex: "#9E680E"
          }, {
              hex: "#4D5E3A"
          }, {
              hex: "#45324C"
          }]
      }],
      productTilesTwo: [{
          columnClasses: "col-md-6 col-lg-4",
          classes: "product-tile--colors",
          name: "Training For The New Alpinism:<br>A Manual For The Climber As Athlete By Steve House And Scott Johnston (Patagonia Published Paperback Book/Also Available As An Ebook, $14.95)",
          price: '<span class="after-long-title"><s>$199</s> $120-149</span>',
          imageUrl: "images/product-tiles/demo/fleece/product-tile-fleece-grey.jpg",
          colorQty: "17 colors",
          colors: [{
              hex: "#5D5B66"
          }, {
              hex: "#9E680E"
          }, {
              hex: "#4D5E3A"
          }, {
              hex: "#45324C"
          }, {
              hex: "#5D5B66"
          }, {
              hex: "#9E680E"
          }, {
              hex: "#4D5E3A"
          }, {
              hex: "#45324C"
          }, {
              hex: "#5D5B66"
          }, {
              hex: "#9E680E"
          }, {
              hex: "#4D5E3A"
          }, {
              hex: "#45324C"
          }, {
              hex: "#5D5B66"
          }, {
              hex: "#9E680E"
          }, {
              hex: "#4D5E3A"
          }, {
              hex: "#45324C"
          }, {
              hex: "#45324C"
          }],
          rightBadge: "Exclusive",
          leftBadge: "images/icons/outside-gear.png"
      }, {
          columnClasses: "col-md-6 col-lg-4",
          classes: "product-tile--colors",
          name: "Los Gatos Fleece",
          price: "$120",
          imageUrl: "images/product-tiles/demo/fleece/product-tile-fleece-grey.jpg",
          colorQty: "6 colors",
          colors: [{
              hex: "#5D5B66"
          }, {
              hex: "#9E680E"
          }, {
              hex: "#4D5E3A"
          }, {
              hex: "#45324C"
          }, {
              hex: "#4D5E3A"
          }, {
              hex: "#45324C"
          }]
      }]
  }
}
, function(e) {
  e.exports = {
      heading: "Buy Configuration",
      sections: [{
          anchorId: "buy-configration-default",
          heading: "Standard",
          content: {
              config: {
                  instructions: "Select Color (8) & Size",
                  colorProducts: [{
                      columnClasses: "col-md-4 col-lg-4",
                      classes: "product-tile--single product-tile--config",
                      name: "Pesto",
                      price: "$149",
                      imageUrl: "images/pdp/config/Product-Torrentshell-Swatch-Pesto.jpg",
                      imageZoomUrl: "images/pdp/config/Product-Torrentshell-Swatch-Pesto.jpg",
                      sizeStock: "['xxs', 'xs', 's', 'm', 'l']",
                      colorParams: 'data-color="pesto"'
                  }, {
                      columnClasses: "col-md-6 col-lg-4",
                      classes: "product-tile--single product-tile--config",
                      name: "Tomato",
                      price: "<s>$149</s> $99",
                      imageUrl: "images/pdp/config/Product-Torrentshell-Swatch-Tomato.jpg",
                      imageZoomUrl: "images/pdp/torrentshell/carousel/Product-Torrentshell-Swatch-Tomato.jpg",
                      sizeStock: "['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']",
                      colorParams: 'data-color="tomato"'
                  }, {
                      columnClasses: "col-md-4 col-lg-4",
                      classes: "product-tile--single product-tile--config",
                      name: "Balkan Blue",
                      price: "$149",
                      imageUrl: "images/pdp/config/Product-Torrentshell-Swatch-BalkanBlue.jpg",
                      imageZoomUrl: "images/pdp/torrentshell/carousel/Product-Torrentshell-Swatch-BalkanBlue.jpg",
                      sizeStock: "['xxs', 'xs', 's', 'm', 'xl', 'xxl']",
                      colorParams: 'data-color="balkan-blue"'
                  }, {
                      columnClasses: "col-md-6 col-lg-4",
                      classes: "product-tile--single product-tile--config",
                      name: "Black",
                      price: "$149",
                      imageUrl: "images/pdp/config/Product-Torrentshell-Swatch-Black.jpg",
                      imageZoomUrl: "images/pdp/torrentshell/carousel/Product-Torrentshell-Swatch-Black.jpg",
                      sizeStock: "['s', 'm', 'l', 'xl', 'xxl']",
                      colorParams: 'data-color="swatch-black"'
                  }, {
                      columnClasses: "col-md-4 col-lg-4",
                      classes: "product-tile--single product-tile--config",
                      name: "Arrow Red",
                      price: "$149",
                      imageUrl: "images/pdp/config/Product-Torrentshell-Swatch-ArrowRed.jpg",
                      imageZoomUrl: "images/pdp/torrentshell/carousel/Product-Torrentshell-Swatch-ArrowRed.jpg",
                      sizeStock: "['s', 'm', 'l']",
                      colorParams: 'data-color="arrow-red"'
                  }, {
                      columnClasses: "col-md-6 col-lg-4",
                      classes: "product-tile--single product-tile--config",
                      name: "Vjosa Green",
                      price: "$149",
                      imageUrl: "images/pdp/config/Product-Torrentshell-Swatch-VjosaGreen.jpg",
                      imageZoomUrl: "images/pdp/torrentshell/carousel/Product-Torrentshell-Swatch-VjosaGreen.jpg",
                      sizeStock: "['xxs', 'xs', 'xl', 'xxl']",
                      colorParams: 'data-color="vjosa-green"'
                  }, {
                      columnClasses: "col-md-4 col-lg-4",
                      classes: "product-tile--single product-tile--config",
                      name: "Light Acai",
                      price: "$149",
                      imageUrl: "images/pdp/config/Product-Torrentshell-Swatch-LightAcai.jpg",
                      imageZoomUrl: "images/pdp/torrentshell/carousel/Product-Torrentshell-Swatch-LightAcai.jpg",
                      sizeStock: "['xxs', 's', 'l', 'xxl']",
                      colorParams: 'data-color="light-acai"'
                  }, {
                      columnClasses: "col-md-6 col-lg-4",
                      classes: "product-tile--single product-tile--config",
                      name: "Navy Blue",
                      price: "$149",
                      imageUrl: "images/pdp/config/Product-Torrentshell-Swatch-NavyBlue.jpg",
                      imageZoomUrl: "images/pdp/torrentshell/carousel/Product-Torrentshell-Swatch-NavyBlue.jpg",
                      sizeStock: "['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']",
                      colorParams: 'data-color="navy-blue"'
                  }],
                  sizes: [{
                      params: 'data-size="xxs"',
                      name: "XXS",
                      productStock: "['pesto', 'tomato', 'balkan-blue', 'vjosa-green', 'light-acai', 'navy-blue']"
                  }, {
                      params: 'data-size="xs"',
                      name: "XS",
                      productStock: "['pesto', 'tomato', 'balkan-blue', 'vjosa-green', 'navy-blue']"
                  }, {
                      params: 'data-size="s"',
                      name: "S",
                      productStock: "['pesto', 'tomato', 'balkan-blue', 'swatch-black', 'arrow-red', 'light-acai', 'navy-blue']"
                  }, {
                      params: 'data-size="m"',
                      name: "M",
                      productStock: "['pesto', 'tomato', 'balkan-blue', 'swatch-black', 'arrow-red', 'navy-blue']"
                  }, {
                      params: 'data-size="l"',
                      name: "L",
                      productStock: "['pesto', 'tomato', 'swatch-black', 'arrow-red', 'light-acai', 'navy-blue']"
                  }, {
                      params: 'data-size="xl"',
                      name: "XL",
                      productStock: "['tomato', 'balkan-blue', 'swatch-black', 'vjosa-green', 'navy-blue']"
                  }],
                  sizeCta: {
                      heading: "What's My Size?"
                  },
                  buyBtn: {
                      heading: "Add to Bag"
                  },
                  appleBtn: {
                      heading: '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="13"><g fill="#FFF" fill-rule="nonzero"><path d="M7.327 2.101c.438-.544.734-1.276.656-2.023-.64.031-1.421.42-1.874.966-.406.466-.765 1.229-.672 1.945.72.062 1.437-.358 1.89-.888M7.975 3.129c-1.044-.062-1.931.59-2.43.59-.498 0-1.261-.56-2.087-.544-1.074.016-2.071.62-2.617 1.583-1.121 1.925-.296 4.78.795 6.348.53.776 1.168 1.63 2.009 1.6.794-.032 1.106-.513 2.072-.513.965 0 1.246.512 2.087.497.872-.016 1.417-.776 1.947-1.553.607-.884.856-1.738.872-1.784-.016-.016-1.682-.653-1.698-2.562-.015-1.598 1.309-2.359 1.37-2.406C9.549 3.284 8.38 3.16 7.976 3.13"/></g></svg> Pay'
                  },
                  oos: {
                      text: "Out of Stock.",
                      cta: {
                          heading: "Notify Me"
                      }
                  }
              }
          }
      }, {
          anchorId: "buy-configration-worst-case",
          heading: "Worst Case",
          content: {
              config: {
                  instructions: "Select Color (1)",
                  centered: !0,
                  colorProducts: [{
                      columnClasses: "col-md-4 col-lg-4",
                      classes: "product-tile--single product-tile--config",
                      name: "Pesto",
                      price: "$149",
                      imageUrl: "images/pdp/config/Product-Torrentshell-Swatch-Pesto.jpg",
                      imageZoomUrl: "images/pdp/config/Product-Torrentshell-Swatch-Pesto.jpg",
                      sizeStock: "['xxs', 'xs', 's', 'm', 'l']",
                      colorParams: 'data-color="pesto"'
                  }],
                  fits: {
                      headings: ["Select Fit", "Select Size"],
                      ctas: [{
                          heading: "Short"
                      }, {
                          heading: "Button"
                      }, {
                          heading: "Long"
                      }]
                  },
                  sizes: [{
                      params: 'data-size="xxs"',
                      name: "XXS",
                      productStock: "['pesto', 'tomato', 'balkan-blue', 'vjosa-green', 'light-acai', 'navy-blue']"
                  }, {
                      params: 'data-size="xs"',
                      name: "XS",
                      productStock: "['pesto', 'tomato', 'balkan-blue', 'vjosa-green', 'navy-blue']"
                  }, {
                      params: 'data-size="s"',
                      name: "S",
                      productStock: "['pesto', 'tomato', 'balkan-blue', 'swatch-black', 'arrow-red', 'light-acai', 'navy-blue']"
                  }, {
                      params: 'data-size="m"',
                      name: "M",
                      productStock: "['pesto', 'tomato', 'balkan-blue', 'swatch-black', 'arrow-red', 'navy-blue']"
                  }, {
                      params: 'data-size="l"',
                      name: "L",
                      productStock: "['pesto', 'tomato', 'swatch-black', 'arrow-red', 'light-acai', 'navy-blue']"
                  }, {
                      params: 'data-size="xl"',
                      name: "XL",
                      productStock: "['tomato', 'balkan-blue', 'swatch-black', 'vjosa-green', 'navy-blue']"
                  }],
                  sizeCta: {
                      heading: "What's My Size?"
                  },
                  buyBtn: {
                      heading: "Add to Bag"
                  },
                  appleBtn: {
                      heading: '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="13"><g fill="#FFF" fill-rule="nonzero"><path d="M7.327 2.101c.438-.544.734-1.276.656-2.023-.64.031-1.421.42-1.874.966-.406.466-.765 1.229-.672 1.945.72.062 1.437-.358 1.89-.888M7.975 3.129c-1.044-.062-1.931.59-2.43.59-.498 0-1.261-.56-2.087-.544-1.074.016-2.071.62-2.617 1.583-1.121 1.925-.296 4.78.795 6.348.53.776 1.168 1.63 2.009 1.6.794-.032 1.106-.513 2.072-.513.965 0 1.246.512 2.087.497.872-.016 1.417-.776 1.947-1.553.607-.884.856-1.738.872-1.784-.016-.016-1.682-.653-1.698-2.562-.015-1.598 1.309-2.359 1.37-2.406C9.549 3.284 8.38 3.16 7.976 3.13"/></g></svg> Pay'
                  },
                  oos: {
                      text: "Out of Stock.",
                      cta: {
                          heading: "Notify Me"
                      }
                  }
              }
          }
      }, {
          anchorId: "buy-configration-minimal",
          heading: "Minimal",
          content: {
              config: {
                  instructions: "Select Color (1)",
                  centered: !0,
                  colorProducts: [{
                      columnClasses: "col-md-4 col-lg-4",
                      classes: "product-tile--single product-tile--config",
                      name: "Pesto",
                      price: "$149",
                      imageUrl: "images/pdp/config/Product-Torrentshell-Swatch-Pesto.jpg",
                      imageZoomUrl: "images/pdp/config/Product-Torrentshell-Swatch-Pesto.jpg",
                      sizeStock: "['xxs', 'xs', 's', 'm', 'l']",
                      colorParams: 'data-color="pesto"'
                  }],
                  buyBtn: {
                      heading: "Add to Bag"
                  },
                  appleBtn: {
                      heading: '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="13"><g fill="#FFF" fill-rule="nonzero"><path d="M7.327 2.101c.438-.544.734-1.276.656-2.023-.64.031-1.421.42-1.874.966-.406.466-.765 1.229-.672 1.945.72.062 1.437-.358 1.89-.888M7.975 3.129c-1.044-.062-1.931.59-2.43.59-.498 0-1.261-.56-2.087-.544-1.074.016-2.071.62-2.617 1.583-1.121 1.925-.296 4.78.795 6.348.53.776 1.168 1.63 2.009 1.6.794-.032 1.106-.513 2.072-.513.965 0 1.246.512 2.087.497.872-.016 1.417-.776 1.947-1.553.607-.884.856-1.738.872-1.784-.016-.016-1.682-.653-1.698-2.562-.015-1.598 1.309-2.359 1.37-2.406C9.549 3.284 8.38 3.16 7.976 3.13"/></g></svg> Pay'
                  },
                  oos: {
                      text: "Out of Stock.",
                      cta: {
                          heading: "Notify Me"
                      }
                  }
              }
          }
      }]
  }
}
, function(e) {
  e.exports = {
      fields: {
          heading: "Search Fields",
          placeholder: "Search"
      },
      overlay: {
          heading: "Search Overlay"
      },
      results: {
          heading: "Search Results"
      }
  }
}
, function(e) {
  e.exports = {
      heading: "Shopping Tool",
      heroHeading: "Hero PLP (Shopping Tool Integrated)"
  }
}
, function(e) {
  e.exports = {
      headlineText: "The More You Know,<br>the Less You Need.",
      headings: {
          heading: "Headings"
      },
      paragraph: {
          headings: ["Body Copy", "Snippets", "Captions"],
          blurbs: ["Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.", "Occupy organic, stumptown shabby chic pour-over roof party DIY normcore. Actually artisan organic occupy, Wes Anderson ugh whatever pour-over gastropub selvage."]
      },
      typeStyles: {
          heading: "Type Styles",
          link: "This is a <a href='javascript:;'>text link.</a>",
          linkAlt: "This is an <a class='alt' href='javascript:;'>alt text link.</a>",
          medium: "<span class='medium'>Medium is used to change the weight to Medium.</span>",
          demi: "<span class='demi'>Demi is used to change the weight to Demi.</span>",
          strong: "<strong>Strong is used to indicate bold importance.</strong>",
          emphasis: "This text has added emphasis.",
          i: "The <i>i element</i> is text that is set off from the normal text.",
          u: "The <u>u element</u> is text with an unarticulated, though explicitly rendered, non-textual annotation",
          s: "<s>This text has a strikethrough.</s>",
          sup: "Superscript<sup>&reg;</sup>",
          sub: "Subscript for things like H<sub>2</sub>O",
          small: "<small>This small text is small for for fine print, etc. it is 0.75em.</small>",
          abbr: "Abbreviation: <abbr title='HyperText Markup Language'>HTML</abbr>",
          mark: "The <mark>mark element</mark> indicates a highlight",
          q: "<q>This text is a short inline quotation.</q>",
          hr: "<small style='color: #807E7E;'>This is a horizontal rule.</small><hr />",
          ol: {
              heading: "This is a ordered list:",
              line1: "This is line one.",
              line2: "This is line two.",
              line3: "This is line three."
          },
          ul: {
              heading: "This is a unordered list:",
              line1: "This is line one.",
              line2: "This is line two.",
              line3: "This is line three."
          }
      }
  }
}
, function(e) {
  e.exports = {
      eyebrow: "Explore Footprint",
      items: [{
          heading: "Footprint",
          href: "fpc-home.html"
      }, {
          heading: "Why We Recycle",
          href: "fpc-recycle-story.html"
      }, {
          heading: "Materials and Technology",
          href: "fpc-materials-tech-landing.html"
      }, {
          heading: "Social Responsibility",
          href: "fpc-social-responsibilities.html"
      }, {
          heading: "Facilities",
          href: "fpc-facilities-landing.html"
      }]
  }
}
, function(e) {
  e.exports = {}
}
, function(e, t, i) {}
, function(e, t) {
  !function(e, t) {
      "use strict";
      if ("IntersectionObserver"in e && "IntersectionObserverEntry"in e && "intersectionRatio"in e.IntersectionObserverEntry.prototype)
          "isIntersecting"in e.IntersectionObserverEntry.prototype || Object.defineProperty(e.IntersectionObserverEntry.prototype, "isIntersecting", {
              get: function() {
                  return this.intersectionRatio > 0
              }
          });
      else {
          var i = [];
          r.prototype.THROTTLE_TIMEOUT = 100,
          r.prototype.POLL_INTERVAL = null,
          r.prototype.USE_MUTATION_OBSERVER = !0,
          r.prototype.observe = function(e) {
              if (!this._observationTargets.some(function(t) {
                  return t.element == e
              })) {
                  if (!e || 1 != e.nodeType)
                      throw new Error("target must be an Element");
                  this._registerInstance(),
                  this._observationTargets.push({
                      element: e,
                      entry: null
                  }),
                  this._monitorIntersections(),
                  this._checkForIntersections()
              }
          }
          ,
          r.prototype.unobserve = function(e) {
              this._observationTargets = this._observationTargets.filter(function(t) {
                  return t.element != e
              }),
              this._observationTargets.length || (this._unmonitorIntersections(),
              this._unregisterInstance())
          }
          ,
          r.prototype.disconnect = function() {
              this._observationTargets = [],
              this._unmonitorIntersections(),
              this._unregisterInstance()
          }
          ,
          r.prototype.takeRecords = function() {
              var e = this._queuedEntries.slice();
              return this._queuedEntries = [],
              e
          }
          ,
          r.prototype._initThresholds = function(e) {
              var t = e || [0];
              return Array.isArray(t) || (t = [t]),
              t.sort().filter(function(e, t, i) {
                  if ("number" != typeof e || isNaN(e) || e < 0 || e > 1)
                      throw new Error("threshold must be a number between 0 and 1 inclusively");
                  return e !== i[t - 1]
              })
          }
          ,
          r.prototype._parseRootMargin = function(e) {
              var t = (e || "0px").split(/\s+/).map(function(e) {
                  var t = /^(-?\d*\.?\d+)(px|%)$/.exec(e);
                  if (!t)
                      throw new Error("rootMargin must be specified in pixels or percent");
                  return {
                      value: parseFloat(t[1]),
                      unit: t[2]
                  }
              });
              return t[1] = t[1] || t[0],
              t[2] = t[2] || t[0],
              t[3] = t[3] || t[1],
              t
          }
          ,
          r.prototype._monitorIntersections = function() {
              this._monitoringIntersections || (this._monitoringIntersections = !0,
              this.POLL_INTERVAL ? this._monitoringInterval = setInterval(this._checkForIntersections, this.POLL_INTERVAL) : (o(e, "resize", this._checkForIntersections, !0),
              o(t, "scroll", this._checkForIntersections, !0),
              this.USE_MUTATION_OBSERVER && "MutationObserver"in e && (this._domObserver = new MutationObserver(this._checkForIntersections),
              this._domObserver.observe(t, {
                  attributes: !0,
                  childList: !0,
                  characterData: !0,
                  subtree: !0
              }))))
          }
          ,
          r.prototype._unmonitorIntersections = function() {
              this._monitoringIntersections && (this._monitoringIntersections = !1,
              clearInterval(this._monitoringInterval),
              this._monitoringInterval = null,
              s(e, "resize", this._checkForIntersections, !0),
              s(t, "scroll", this._checkForIntersections, !0),
              this._domObserver && (this._domObserver.disconnect(),
              this._domObserver = null))
          }
          ,
          r.prototype._checkForIntersections = function() {
              var t = this._rootIsInDom()
                , i = t ? this._getRootRect() : {
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  width: 0,
                  height: 0
              };
              this._observationTargets.forEach(function(r) {
                  var o = r.element
                    , s = a(o)
                    , l = this._rootContainsTarget(o)
                    , c = r.entry
                    , u = t && l && this._computeTargetAndRootIntersection(o, i)
                    , h = r.entry = new n({
                      time: e.performance && performance.now && performance.now(),
                      target: o,
                      boundingClientRect: s,
                      rootBounds: i,
                      intersectionRect: u
                  });
                  c ? t && l ? this._hasCrossedThreshold(c, h) && this._queuedEntries.push(h) : c && c.isIntersecting && this._queuedEntries.push(h) : this._queuedEntries.push(h)
              }, this),
              this._queuedEntries.length && this._callback(this.takeRecords(), this)
          }
          ,
          r.prototype._computeTargetAndRootIntersection = function(i, n) {
              if ("none" != e.getComputedStyle(i).display) {
                  for (var r, o, s, l, u, h, d, p, f = a(i), m = c(i), g = !1; !g; ) {
                      var v = null
                        , y = 1 == m.nodeType ? e.getComputedStyle(m) : {};
                      if ("none" == y.display)
                          return;
                      if (m == this.root || m == t ? (g = !0,
                      v = n) : m != t.body && m != t.documentElement && "visible" != y.overflow && (v = a(m)),
                      v && (r = v,
                      o = f,
                      s = void 0,
                      l = void 0,
                      u = void 0,
                      h = void 0,
                      d = void 0,
                      p = void 0,
                      s = Math.max(r.top, o.top),
                      l = Math.min(r.bottom, o.bottom),
                      u = Math.max(r.left, o.left),
                      h = Math.min(r.right, o.right),
                      p = l - s,
                      !(f = (d = h - u) >= 0 && p >= 0 && {
                          top: s,
                          bottom: l,
                          left: u,
                          right: h,
                          width: d,
                          height: p
                      })))
                          break;
                      m = c(m)
                  }
                  return f
              }
          }
          ,
          r.prototype._getRootRect = function() {
              var e;
              if (this.root)
                  e = a(this.root);
              else {
                  var i = t.documentElement
                    , n = t.body;
                  e = {
                      top: 0,
                      left: 0,
                      right: i.clientWidth || n.clientWidth,
                      width: i.clientWidth || n.clientWidth,
                      bottom: i.clientHeight || n.clientHeight,
                      height: i.clientHeight || n.clientHeight
                  }
              }
              return this._expandRectByRootMargin(e)
          }
          ,
          r.prototype._expandRectByRootMargin = function(e) {
              var t = this._rootMarginValues.map(function(t, i) {
                  return "px" == t.unit ? t.value : t.value * (i % 2 ? e.width : e.height) / 100
              })
                , i = {
                  top: e.top - t[0],
                  right: e.right + t[1],
                  bottom: e.bottom + t[2],
                  left: e.left - t[3]
              };
              return i.width = i.right - i.left,
              i.height = i.bottom - i.top,
              i
          }
          ,
          r.prototype._hasCrossedThreshold = function(e, t) {
              var i = e && e.isIntersecting ? e.intersectionRatio || 0 : -1
                , n = t.isIntersecting ? t.intersectionRatio || 0 : -1;
              if (i !== n)
                  for (var r = 0; r < this.thresholds.length; r++) {
                      var o = this.thresholds[r];
                      if (o == i || o == n || o < i != o < n)
                          return !0
                  }
          }
          ,
          r.prototype._rootIsInDom = function() {
              return !this.root || l(t, this.root)
          }
          ,
          r.prototype._rootContainsTarget = function(e) {
              return l(this.root || t, e)
          }
          ,
          r.prototype._registerInstance = function() {
              i.indexOf(this) < 0 && i.push(this)
          }
          ,
          r.prototype._unregisterInstance = function() {
              var e = i.indexOf(this);
              -1 != e && i.splice(e, 1)
          }
          ,
          e.IntersectionObserver = r,
          e.IntersectionObserverEntry = n
      }
      function n(e) {
          this.time = e.time,
          this.target = e.target,
          this.rootBounds = e.rootBounds,
          this.boundingClientRect = e.boundingClientRect,
          this.intersectionRect = e.intersectionRect || {
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              width: 0,
              height: 0
          },
          this.isIntersecting = !!e.intersectionRect;
          var t = this.boundingClientRect
            , i = t.width * t.height
            , n = this.intersectionRect
            , r = n.width * n.height;
          this.intersectionRatio = i ? Number((r / i).toFixed(4)) : this.isIntersecting ? 1 : 0
      }
      function r(e, t) {
          var i, n, r, o = t || {};
          if ("function" != typeof e)
              throw new Error("callback must be a function");
          if (o.root && 1 != o.root.nodeType)
              throw new Error("root must be an Element");
          this._checkForIntersections = (i = this._checkForIntersections.bind(this),
          n = this.THROTTLE_TIMEOUT,
          r = null,
          function() {
              r || (r = setTimeout(function() {
                  i(),
                  r = null
              }, n))
          }
          ),
          this._callback = e,
          this._observationTargets = [],
          this._queuedEntries = [],
          this._rootMarginValues = this._parseRootMargin(o.rootMargin),
          this.thresholds = this._initThresholds(o.threshold),
          this.root = o.root || null,
          this.rootMargin = this._rootMarginValues.map(function(e) {
              return e.value + e.unit
          }).join(" ")
      }
      function o(e, t, i, n) {
          "function" == typeof e.addEventListener ? e.addEventListener(t, i, n || !1) : "function" == typeof e.attachEvent && e.attachEvent("on" + t, i)
      }
      function s(e, t, i, n) {
          "function" == typeof e.removeEventListener ? e.removeEventListener(t, i, n || !1) : "function" == typeof e.detatchEvent && e.detatchEvent("on" + t, i)
      }
      function a(e) {
          var t;
          try {
              t = e.getBoundingClientRect()
          } catch (e) {}
          return t ? (t.width && t.height || (t = {
              top: t.top,
              right: t.right,
              bottom: t.bottom,
              left: t.left,
              width: t.right - t.left,
              height: t.bottom - t.top
          }),
          t) : {
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              width: 0,
              height: 0
          }
      }
      function l(e, t) {
          for (var i = t; i; ) {
              if (i == e)
                  return !0;
              i = c(i)
          }
          return !1
      }
      function c(e) {
          var t = e.parentNode;
          return t && 11 == t.nodeType && t.host ? t.host : t
      }
  }(window, document)
}
, function(e, t) {
  for (var i = ["webkit", "moz"], n = 0, r = i.length; n < r && !window.requestAnimationFrame; ++n)
      window.requestAnimationFrame = window["".concat(i[n], "RequestAnimationFrame")],
      window.cancelAnimationFrame = window["".concat(i[n], "CancelAnimationFrame")] || window["".concat(i[n], "CancelRequestAnimationFrame")];
  var o = 0;
  window.requestAnimationFrame || (window.requestAnimationFrame = function(e) {
      var t = Date.now()
        , i = Math.max(0, 16 - (t - o))
        , n = window.setTimeout(function() {
          e(t + i)
      }, i);
      return o = t + i,
      n
  }
  ),
  window.cancelAnimationFrame || (window.cancelAnimationFrame = function(e) {
      clearTimeout(e)
  }
  ),
  window.URL = window.URL || window.webkitURL,
  window.AudioContext = window.AudioContext || window.webkitAudioContext,
  window.navigator.vibrate = window.navigator.vibrate || window.navigator.webkitVibrate || window.navigator.mozVibrate || window.navigator.msVibrate
}
, function(e, t, i) {
  /*!
* Bootstrap v4.2.1 (https://getbootstrap.com/)
* Copyright 2011-2018 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
* Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
*/
  !function(e, t, i) {
      "use strict";
      function n(e, t) {
          for (var i = 0; i < t.length; i++) {
              var n = t[i];
              n.enumerable = n.enumerable || !1,
              n.configurable = !0,
              "value"in n && (n.writable = !0),
              Object.defineProperty(e, n.key, n)
          }
      }
      function r(e, t, i) {
          return t && n(e.prototype, t),
          i && n(e, i),
          e
      }
      function o(e, t, i) {
          return t in e ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
          }) : e[t] = i,
          e
      }
      function s(e) {
          for (var t = 1; t < arguments.length; t++) {
              var i = null != arguments[t] ? arguments[t] : {}
                , n = Object.keys(i);
              "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(i).filter(function(e) {
                  return Object.getOwnPropertyDescriptor(i, e).enumerable
              }))),
              n.forEach(function(t) {
                  o(e, t, i[t])
              })
          }
          return e
      }
      t = t && t.hasOwnProperty("default") ? t.default : t,
      i = i && i.hasOwnProperty("default") ? i.default : i;
      var a = "transitionend";
      function l(e) {
          var t = this
            , n = !1;
          return i(this).one(c.TRANSITION_END, function() {
              n = !0
          }),
          setTimeout(function() {
              n || c.triggerTransitionEnd(t)
          }, e),
          this
      }
      var c = {
          TRANSITION_END: "bsTransitionEnd",
          getUID: function(e) {
              do {
                  e += ~~(1e6 * Math.random())
              } while (document.getElementById(e));return e
          },
          getSelectorFromElement: function(e) {
              var t = e.getAttribute("data-target");
              if (!t || "#" === t) {
                  var i = e.getAttribute("href");
                  t = i && "#" !== i ? i.trim() : ""
              }
              return t && document.querySelector(t) ? t : null
          },
          getTransitionDurationFromElement: function(e) {
              if (!e)
                  return 0;
              var t = i(e).css("transition-duration")
                , n = i(e).css("transition-delay")
                , r = parseFloat(t)
                , o = parseFloat(n);
              return r || o ? (t = t.split(",")[0],
              n = n.split(",")[0],
              1e3 * (parseFloat(t) + parseFloat(n))) : 0
          },
          reflow: function(e) {
              return e.offsetHeight
          },
          triggerTransitionEnd: function(e) {
              i(e).trigger(a)
          },
          supportsTransitionEnd: function() {
              return Boolean(a)
          },
          isElement: function(e) {
              return (e[0] || e).nodeType
          },
          typeCheckConfig: function(e, t, i) {
              for (var n in i)
                  if (Object.prototype.hasOwnProperty.call(i, n)) {
                      var r = i[n]
                        , o = t[n]
                        , s = o && c.isElement(o) ? "element" : (a = o,
                      {}.toString.call(a).match(/\s([a-z]+)/i)[1].toLowerCase());
                      if (!new RegExp(r).test(s))
                          throw new Error(e.toUpperCase() + ': Option "' + n + '" provided type "' + s + '" but expected type "' + r + '".')
                  }
              var a
          },
          findShadowRoot: function(e) {
              if (!document.documentElement.attachShadow)
                  return null;
              if ("function" == typeof e.getRootNode) {
                  var t = e.getRootNode();
                  return t instanceof ShadowRoot ? t : null
              }
              return e instanceof ShadowRoot ? e : e.parentNode ? c.findShadowRoot(e.parentNode) : null
          }
      };
      i.fn.emulateTransitionEnd = l,
      i.event.special[c.TRANSITION_END] = {
          bindType: a,
          delegateType: a,
          handle: function(e) {
              if (i(e.target).is(this))
                  return e.handleObj.handler.apply(this, arguments)
          }
      };
      var u = i.fn.alert
        , h = {
          CLOSE: "close.bs.alert",
          CLOSED: "closed.bs.alert",
          CLICK_DATA_API: "click.bs.alert.data-api"
      }
        , d = {
          ALERT: "alert",
          FADE: "fade",
          SHOW: "show"
      }
        , p = function() {
          function e(e) {
              this._element = e
          }
          var t = e.prototype;
          return t.close = function(e) {
              var t = this._element;
              e && (t = this._getRootElement(e));
              var i = this._triggerCloseEvent(t);
              i.isDefaultPrevented() || this._removeElement(t)
          }
          ,
          t.dispose = function() {
              i.removeData(this._element, "bs.alert"),
              this._element = null
          }
          ,
          t._getRootElement = function(e) {
              var t = c.getSelectorFromElement(e)
                , n = !1;
              return t && (n = document.querySelector(t)),
              n || (n = i(e).closest("." + d.ALERT)[0]),
              n
          }
          ,
          t._triggerCloseEvent = function(e) {
              var t = i.Event(h.CLOSE);
              return i(e).trigger(t),
              t
          }
          ,
          t._removeElement = function(e) {
              var t = this;
              if (i(e).removeClass(d.SHOW),
              i(e).hasClass(d.FADE)) {
                  var n = c.getTransitionDurationFromElement(e);
                  i(e).one(c.TRANSITION_END, function(i) {
                      return t._destroyElement(e, i)
                  }).emulateTransitionEnd(n)
              } else
                  this._destroyElement(e)
          }
          ,
          t._destroyElement = function(e) {
              i(e).detach().trigger(h.CLOSED).remove()
          }
          ,
          e._jQueryInterface = function(t) {
              return this.each(function() {
                  var n = i(this)
                    , r = n.data("bs.alert");
                  r || (r = new e(this),
                  n.data("bs.alert", r)),
                  "close" === t && r[t](this)
              })
          }
          ,
          e._handleDismiss = function(e) {
              return function(t) {
                  t && t.preventDefault(),
                  e.close(this)
              }
          }
          ,
          r(e, null, [{
              key: "VERSION",
              get: function() {
                  return "4.2.1"
              }
          }]),
          e
      }();
      i(document).on(h.CLICK_DATA_API, '[data-dismiss="alert"]', p._handleDismiss(new p)),
      i.fn.alert = p._jQueryInterface,
      i.fn.alert.Constructor = p,
      i.fn.alert.noConflict = function() {
          return i.fn.alert = u,
          p._jQueryInterface
      }
      ;
      var f = i.fn.button
        , m = {
          ACTIVE: "active",
          BUTTON: "btn",
          FOCUS: "focus"
      }
        , g = {
          DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
          DATA_TOGGLE: '[data-toggle="buttons"]',
          INPUT: 'input:not([type="hidden"])',
          ACTIVE: ".active",
          BUTTON: ".btn"
      }
        , v = {
          CLICK_DATA_API: "click.bs.button.data-api",
          FOCUS_BLUR_DATA_API: "focus.bs.button.data-api blur.bs.button.data-api"
      }
        , y = function() {
          function e(e) {
              this._element = e
          }
          var t = e.prototype;
          return t.toggle = function() {
              var e = !0
                , t = !0
                , n = i(this._element).closest(g.DATA_TOGGLE)[0];
              if (n) {
                  var r = this._element.querySelector(g.INPUT);
                  if (r) {
                      if ("radio" === r.type)
                          if (r.checked && this._element.classList.contains(m.ACTIVE))
                              e = !1;
                          else {
                              var o = n.querySelector(g.ACTIVE);
                              o && i(o).removeClass(m.ACTIVE)
                          }
                      if (e) {
                          if (r.hasAttribute("disabled") || n.hasAttribute("disabled") || r.classList.contains("disabled") || n.classList.contains("disabled"))
                              return;
                          r.checked = !this._element.classList.contains(m.ACTIVE),
                          i(r).trigger("change")
                      }
                      r.focus(),
                      t = !1
                  }
              }
              t && this._element.setAttribute("aria-pressed", !this._element.classList.contains(m.ACTIVE)),
              e && i(this._element).toggleClass(m.ACTIVE)
          }
          ,
          t.dispose = function() {
              i.removeData(this._element, "bs.button"),
              this._element = null
          }
          ,
          e._jQueryInterface = function(t) {
              return this.each(function() {
                  var n = i(this).data("bs.button");
                  n || (n = new e(this),
                  i(this).data("bs.button", n)),
                  "toggle" === t && n[t]()
              })
          }
          ,
          r(e, null, [{
              key: "VERSION",
              get: function() {
                  return "4.2.1"
              }
          }]),
          e
      }();
      i(document).on(v.CLICK_DATA_API, g.DATA_TOGGLE_CARROT, function(e) {
          e.preventDefault();
          var t = e.target;
          i(t).hasClass(m.BUTTON) || (t = i(t).closest(g.BUTTON)),
          y._jQueryInterface.call(i(t), "toggle")
      }).on(v.FOCUS_BLUR_DATA_API, g.DATA_TOGGLE_CARROT, function(e) {
          var t = i(e.target).closest(g.BUTTON)[0];
          i(t).toggleClass(m.FOCUS, /^focus(in)?$/.test(e.type))
      }),
      i.fn.button = y._jQueryInterface,
      i.fn.button.Constructor = y,
      i.fn.button.noConflict = function() {
          return i.fn.button = f,
          y._jQueryInterface
      }
      ;
      var _ = "carousel"
        , b = ".bs.carousel"
        , w = i.fn[_]
        , x = {
          interval: 5e3,
          keyboard: !0,
          slide: !1,
          pause: "hover",
          wrap: !0,
          touch: !0
      }
        , k = {
          interval: "(number|boolean)",
          keyboard: "boolean",
          slide: "(boolean|string)",
          pause: "(string|boolean)",
          wrap: "boolean",
          touch: "boolean"
      }
        , S = {
          NEXT: "next",
          PREV: "prev",
          LEFT: "left",
          RIGHT: "right"
      }
        , E = {
          SLIDE: "slide.bs.carousel",
          SLID: "slid.bs.carousel",
          KEYDOWN: "keydown.bs.carousel",
          MOUSEENTER: "mouseenter.bs.carousel",
          MOUSELEAVE: "mouseleave.bs.carousel",
          TOUCHSTART: "touchstart.bs.carousel",
          TOUCHMOVE: "touchmove.bs.carousel",
          TOUCHEND: "touchend.bs.carousel",
          POINTERDOWN: "pointerdown.bs.carousel",
          POINTERUP: "pointerup.bs.carousel",
          DRAG_START: "dragstart.bs.carousel",
          LOAD_DATA_API: "load.bs.carousel.data-api",
          CLICK_DATA_API: "click.bs.carousel.data-api"
      }
        , T = {
          CAROUSEL: "carousel",
          ACTIVE: "active",
          SLIDE: "slide",
          RIGHT: "carousel-item-right",
          LEFT: "carousel-item-left",
          NEXT: "carousel-item-next",
          PREV: "carousel-item-prev",
          ITEM: "carousel-item",
          POINTER_EVENT: "pointer-event"
      }
        , C = {
          ACTIVE: ".active",
          ACTIVE_ITEM: ".active.carousel-item",
          ITEM: ".carousel-item",
          ITEM_IMG: ".carousel-item img",
          NEXT_PREV: ".carousel-item-next, .carousel-item-prev",
          INDICATORS: ".carousel-indicators",
          DATA_SLIDE: "[data-slide], [data-slide-to]",
          DATA_RIDE: '[data-ride="carousel"]'
      }
        , L = {
          TOUCH: "touch",
          PEN: "pen"
      }
        , A = function() {
          function e(e, t) {
              this._items = null,
              this._interval = null,
              this._activeElement = null,
              this._isPaused = !1,
              this._isSliding = !1,
              this.touchTimeout = null,
              this.touchStartX = 0,
              this.touchDeltaX = 0,
              this._config = this._getConfig(t),
              this._element = e,
              this._indicatorsElement = this._element.querySelector(C.INDICATORS),
              this._touchSupported = "ontouchstart"in document.documentElement || navigator.maxTouchPoints > 0,
              this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent),
              this._addEventListeners()
          }
          var t = e.prototype;
          return t.next = function() {
              this._isSliding || this._slide(S.NEXT)
          }
          ,
          t.nextWhenVisible = function() {
              !document.hidden && i(this._element).is(":visible") && "hidden" !== i(this._element).css("visibility") && this.next()
          }
          ,
          t.prev = function() {
              this._isSliding || this._slide(S.PREV)
          }
          ,
          t.pause = function(e) {
              e || (this._isPaused = !0),
              this._element.querySelector(C.NEXT_PREV) && (c.triggerTransitionEnd(this._element),
              this.cycle(!0)),
              clearInterval(this._interval),
              this._interval = null
          }
          ,
          t.cycle = function(e) {
              e || (this._isPaused = !1),
              this._interval && (clearInterval(this._interval),
              this._interval = null),
              this._config.interval && !this._isPaused && (this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval))
          }
          ,
          t.to = function(e) {
              var t = this;
              this._activeElement = this._element.querySelector(C.ACTIVE_ITEM);
              var n = this._getItemIndex(this._activeElement);
              if (!(e > this._items.length - 1 || e < 0))
                  if (this._isSliding)
                      i(this._element).one(E.SLID, function() {
                          return t.to(e)
                      });
                  else {
                      if (n === e)
                          return this.pause(),
                          void this.cycle();
                      var r = e > n ? S.NEXT : S.PREV;
                      this._slide(r, this._items[e])
                  }
          }
          ,
          t.dispose = function() {
              i(this._element).off(b),
              i.removeData(this._element, "bs.carousel"),
              this._items = null,
              this._config = null,
              this._element = null,
              this._interval = null,
              this._isPaused = null,
              this._isSliding = null,
              this._activeElement = null,
              this._indicatorsElement = null
          }
          ,
          t._getConfig = function(e) {
              return e = s({}, x, e),
              c.typeCheckConfig(_, e, k),
              e
          }
          ,
          t._handleSwipe = function() {
              var e = Math.abs(this.touchDeltaX);
              if (!(e <= 40)) {
                  var t = e / this.touchDeltaX;
                  t > 0 && this.prev(),
                  t < 0 && this.next()
              }
          }
          ,
          t._addEventListeners = function() {
              var e = this;
              this._config.keyboard && i(this._element).on(E.KEYDOWN, function(t) {
                  return e._keydown(t)
              }),
              "hover" === this._config.pause && i(this._element).on(E.MOUSEENTER, function(t) {
                  return e.pause(t)
              }).on(E.MOUSELEAVE, function(t) {
                  return e.cycle(t)
              }),
              this._addTouchEventListeners()
          }
          ,
          t._addTouchEventListeners = function() {
              var e = this;
              if (this._touchSupported) {
                  var t = function(t) {
                      e._pointerEvent && L[t.originalEvent.pointerType.toUpperCase()] ? e.touchStartX = t.originalEvent.clientX : e._pointerEvent || (e.touchStartX = t.originalEvent.touches[0].clientX)
                  }
                    , n = function(t) {
                      e._pointerEvent && L[t.originalEvent.pointerType.toUpperCase()] && (e.touchDeltaX = t.originalEvent.clientX - e.touchStartX),
                      e._handleSwipe(),
                      "hover" === e._config.pause && (e.pause(),
                      e.touchTimeout && clearTimeout(e.touchTimeout),
                      e.touchTimeout = setTimeout(function(t) {
                          return e.cycle(t)
                      }, 500 + e._config.interval))
                  };
                  i(this._element.querySelectorAll(C.ITEM_IMG)).on(E.DRAG_START, function(e) {
                      return e.preventDefault()
                  }),
                  this._pointerEvent ? (i(this._element).on(E.POINTERDOWN, function(e) {
                      return t(e)
                  }),
                  i(this._element).on(E.POINTERUP, function(e) {
                      return n(e)
                  }),
                  this._element.classList.add(T.POINTER_EVENT)) : (i(this._element).on(E.TOUCHSTART, function(e) {
                      return t(e)
                  }),
                  i(this._element).on(E.TOUCHMOVE, function(t) {
                      return function(t) {
                          t.originalEvent.touches && t.originalEvent.touches.length > 1 ? e.touchDeltaX = 0 : e.touchDeltaX = t.originalEvent.touches[0].clientX - e.touchStartX
                      }(t)
                  }),
                  i(this._element).on(E.TOUCHEND, function(e) {
                      return n(e)
                  }))
              }
          }
          ,
          t._keydown = function(e) {
              if (!/input|textarea/i.test(e.target.tagName))
                  switch (e.which) {
                  case 37:
                      e.preventDefault(),
                      this.prev();
                      break;
                  case 39:
                      e.preventDefault(),
                      this.next()
                  }
          }
          ,
          t._getItemIndex = function(e) {
              return this._items = e && e.parentNode ? [].slice.call(e.parentNode.querySelectorAll(C.ITEM)) : [],
              this._items.indexOf(e)
          }
          ,
          t._getItemByDirection = function(e, t) {
              var i = e === S.NEXT
                , n = e === S.PREV
                , r = this._getItemIndex(t)
                , o = this._items.length - 1
                , s = n && 0 === r || i && r === o;
              if (s && !this._config.wrap)
                  return t;
              var a = e === S.PREV ? -1 : 1
                , l = (r + a) % this._items.length;
              return -1 === l ? this._items[this._items.length - 1] : this._items[l]
          }
          ,
          t._triggerSlideEvent = function(e, t) {
              var n = this._getItemIndex(e)
                , r = this._getItemIndex(this._element.querySelector(C.ACTIVE_ITEM))
                , o = i.Event(E.SLIDE, {
                  relatedTarget: e,
                  direction: t,
                  from: r,
                  to: n
              });
              return i(this._element).trigger(o),
              o
          }
          ,
          t._setActiveIndicatorElement = function(e) {
              if (this._indicatorsElement) {
                  var t = [].slice.call(this._indicatorsElement.querySelectorAll(C.ACTIVE));
                  i(t).removeClass(T.ACTIVE);
                  var n = this._indicatorsElement.children[this._getItemIndex(e)];
                  n && i(n).addClass(T.ACTIVE)
              }
          }
          ,
          t._slide = function(e, t) {
              var n, r, o, s = this, a = this._element.querySelector(C.ACTIVE_ITEM), l = this._getItemIndex(a), u = t || a && this._getItemByDirection(e, a), h = this._getItemIndex(u), d = Boolean(this._interval);
              if (e === S.NEXT ? (n = T.LEFT,
              r = T.NEXT,
              o = S.LEFT) : (n = T.RIGHT,
              r = T.PREV,
              o = S.RIGHT),
              u && i(u).hasClass(T.ACTIVE))
                  this._isSliding = !1;
              else {
                  var p = this._triggerSlideEvent(u, o);
                  if (!p.isDefaultPrevented() && a && u) {
                      this._isSliding = !0,
                      d && this.pause(),
                      this._setActiveIndicatorElement(u);
                      var f = i.Event(E.SLID, {
                          relatedTarget: u,
                          direction: o,
                          from: l,
                          to: h
                      });
                      if (i(this._element).hasClass(T.SLIDE)) {
                          i(u).addClass(r),
                          c.reflow(u),
                          i(a).addClass(n),
                          i(u).addClass(n);
                          var m = parseInt(u.getAttribute("data-interval"), 10);
                          m ? (this._config.defaultInterval = this._config.defaultInterval || this._config.interval,
                          this._config.interval = m) : this._config.interval = this._config.defaultInterval || this._config.interval;
                          var g = c.getTransitionDurationFromElement(a);
                          i(a).one(c.TRANSITION_END, function() {
                              i(u).removeClass(n + " " + r).addClass(T.ACTIVE),
                              i(a).removeClass(T.ACTIVE + " " + r + " " + n),
                              s._isSliding = !1,
                              setTimeout(function() {
                                  return i(s._element).trigger(f)
                              }, 0)
                          }).emulateTransitionEnd(g)
                      } else
                          i(a).removeClass(T.ACTIVE),
                          i(u).addClass(T.ACTIVE),
                          this._isSliding = !1,
                          i(this._element).trigger(f);
                      d && this.cycle()
                  }
              }
          }
          ,
          e._jQueryInterface = function(t) {
              return this.each(function() {
                  var n = i(this).data("bs.carousel")
                    , r = s({}, x, i(this).data());
                  "object" == typeof t && (r = s({}, r, t));
                  var o = "string" == typeof t ? t : r.slide;
                  if (n || (n = new e(this,r),
                  i(this).data("bs.carousel", n)),
                  "number" == typeof t)
                      n.to(t);
                  else if ("string" == typeof o) {
                      if (void 0 === n[o])
                          throw new TypeError('No method named "' + o + '"');
                      n[o]()
                  } else
                      r.interval && (n.pause(),
                      n.cycle())
              })
          }
          ,
          e._dataApiClickHandler = function(t) {
              var n = c.getSelectorFromElement(this);
              if (n) {
                  var r = i(n)[0];
                  if (r && i(r).hasClass(T.CAROUSEL)) {
                      var o = s({}, i(r).data(), i(this).data())
                        , a = this.getAttribute("data-slide-to");
                      a && (o.interval = !1),
                      e._jQueryInterface.call(i(r), o),
                      a && i(r).data("bs.carousel").to(a),
                      t.preventDefault()
                  }
              }
          }
          ,
          r(e, null, [{
              key: "VERSION",
              get: function() {
                  return "4.2.1"
              }
          }, {
              key: "Default",
              get: function() {
                  return x
              }
          }]),
          e
      }();
      i(document).on(E.CLICK_DATA_API, C.DATA_SLIDE, A._dataApiClickHandler),
      i(window).on(E.LOAD_DATA_API, function() {
          for (var e = [].slice.call(document.querySelectorAll(C.DATA_RIDE)), t = 0, n = e.length; t < n; t++) {
              var r = i(e[t]);
              A._jQueryInterface.call(r, r.data())
          }
      }),
      i.fn[_] = A._jQueryInterface,
      i.fn[_].Constructor = A,
      i.fn[_].noConflict = function() {
          return i.fn[_] = w,
          A._jQueryInterface
      }
      ;
      var P = "collapse"
        , I = i.fn[P]
        , M = {
          toggle: !0,
          parent: ""
      }
        , O = {
          toggle: "boolean",
          parent: "(string|element)"
      }
        , z = {
          SHOW: "show.bs.collapse",
          SHOWN: "shown.bs.collapse",
          HIDE: "hide.bs.collapse",
          HIDDEN: "hidden.bs.collapse",
          CLICK_DATA_API: "click.bs.collapse.data-api"
      }
        , D = {
          SHOW: "show",
          COLLAPSE: "collapse",
          COLLAPSING: "collapsing",
          COLLAPSED: "collapsed"
      }
        , R = {
          WIDTH: "width",
          HEIGHT: "height"
      }
        , B = {
          ACTIVES: ".show, .collapsing",
          DATA_TOGGLE: '[data-toggle="collapse"]'
      }
        , j = function() {
          function e(e, t) {
              this._isTransitioning = !1,
              this._element = e,
              this._config = this._getConfig(t),
              this._triggerArray = [].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#' + e.id + '"],[data-toggle="collapse"][data-target="#' + e.id + '"]'));
              for (var i = [].slice.call(document.querySelectorAll(B.DATA_TOGGLE)), n = 0, r = i.length; n < r; n++) {
                  var o = i[n]
                    , s = c.getSelectorFromElement(o)
                    , a = [].slice.call(document.querySelectorAll(s)).filter(function(t) {
                      return t === e
                  });
                  null !== s && a.length > 0 && (this._selector = s,
                  this._triggerArray.push(o))
              }
              this._parent = this._config.parent ? this._getParent() : null,
              this._config.parent || this._addAriaAndCollapsedClass(this._element, this._triggerArray),
              this._config.toggle && this.toggle()
          }
          var t = e.prototype;
          return t.toggle = function() {
              i(this._element).hasClass(D.SHOW) ? this.hide() : this.show()
          }
          ,
          t.show = function() {
              var t, n, r = this;
              if (!(this._isTransitioning || i(this._element).hasClass(D.SHOW) || (this._parent && 0 === (t = [].slice.call(this._parent.querySelectorAll(B.ACTIVES)).filter(function(e) {
                  return "string" == typeof r._config.parent ? e.getAttribute("data-parent") === r._config.parent : e.classList.contains(D.COLLAPSE)
              })).length && (t = null),
              t && (n = i(t).not(this._selector).data("bs.collapse")) && n._isTransitioning))) {
                  var o = i.Event(z.SHOW);
                  if (i(this._element).trigger(o),
                  !o.isDefaultPrevented()) {
                      t && (e._jQueryInterface.call(i(t).not(this._selector), "hide"),
                      n || i(t).data("bs.collapse", null));
                      var s = this._getDimension();
                      i(this._element).removeClass(D.COLLAPSE).addClass(D.COLLAPSING),
                      this._element.style[s] = 0,
                      this._triggerArray.length && i(this._triggerArray).removeClass(D.COLLAPSED).attr("aria-expanded", !0),
                      this.setTransitioning(!0);
                      var a = s[0].toUpperCase() + s.slice(1)
                        , l = "scroll" + a
                        , u = c.getTransitionDurationFromElement(this._element);
                      i(this._element).one(c.TRANSITION_END, function() {
                          i(r._element).removeClass(D.COLLAPSING).addClass(D.COLLAPSE).addClass(D.SHOW),
                          r._element.style[s] = "",
                          r.setTransitioning(!1),
                          i(r._element).trigger(z.SHOWN)
                      }).emulateTransitionEnd(u),
                      this._element.style[s] = this._element[l] + "px"
                  }
              }
          }
          ,
          t.hide = function() {
              var e = this;
              if (!this._isTransitioning && i(this._element).hasClass(D.SHOW)) {
                  var t = i.Event(z.HIDE);
                  if (i(this._element).trigger(t),
                  !t.isDefaultPrevented()) {
                      var n = this._getDimension();
                      this._element.style[n] = this._element.getBoundingClientRect()[n] + "px",
                      c.reflow(this._element),
                      i(this._element).addClass(D.COLLAPSING).removeClass(D.COLLAPSE).removeClass(D.SHOW);
                      var r = this._triggerArray.length;
                      if (r > 0)
                          for (var o = 0; o < r; o++) {
                              var s = this._triggerArray[o]
                                , a = c.getSelectorFromElement(s);
                              if (null !== a) {
                                  var l = i([].slice.call(document.querySelectorAll(a)));
                                  l.hasClass(D.SHOW) || i(s).addClass(D.COLLAPSED).attr("aria-expanded", !1)
                              }
                          }
                      this.setTransitioning(!0),
                      this._element.style[n] = "";
                      var u = c.getTransitionDurationFromElement(this._element);
                      i(this._element).one(c.TRANSITION_END, function() {
                          e.setTransitioning(!1),
                          i(e._element).removeClass(D.COLLAPSING).addClass(D.COLLAPSE).trigger(z.HIDDEN)
                      }).emulateTransitionEnd(u)
                  }
              }
          }
          ,
          t.setTransitioning = function(e) {
              this._isTransitioning = e
          }
          ,
          t.dispose = function() {
              i.removeData(this._element, "bs.collapse"),
              this._config = null,
              this._parent = null,
              this._element = null,
              this._triggerArray = null,
              this._isTransitioning = null
          }
          ,
          t._getConfig = function(e) {
              return (e = s({}, M, e)).toggle = Boolean(e.toggle),
              c.typeCheckConfig(P, e, O),
              e
          }
          ,
          t._getDimension = function() {
              var e = i(this._element).hasClass(R.WIDTH);
              return e ? R.WIDTH : R.HEIGHT
          }
          ,
          t._getParent = function() {
              var t, n = this;
              c.isElement(this._config.parent) ? (t = this._config.parent,
              void 0 !== this._config.parent.jquery && (t = this._config.parent[0])) : t = document.querySelector(this._config.parent);
              var r = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]'
                , o = [].slice.call(t.querySelectorAll(r));
              return i(o).each(function(t, i) {
                  n._addAriaAndCollapsedClass(e._getTargetFromElement(i), [i])
              }),
              t
          }
          ,
          t._addAriaAndCollapsedClass = function(e, t) {
              var n = i(e).hasClass(D.SHOW);
              t.length && i(t).toggleClass(D.COLLAPSED, !n).attr("aria-expanded", n)
          }
          ,
          e._getTargetFromElement = function(e) {
              var t = c.getSelectorFromElement(e);
              return t ? document.querySelector(t) : null
          }
          ,
          e._jQueryInterface = function(t) {
              return this.each(function() {
                  var n = i(this)
                    , r = n.data("bs.collapse")
                    , o = s({}, M, n.data(), "object" == typeof t && t ? t : {});
                  if (!r && o.toggle && /show|hide/.test(t) && (o.toggle = !1),
                  r || (r = new e(this,o),
                  n.data("bs.collapse", r)),
                  "string" == typeof t) {
                      if (void 0 === r[t])
                          throw new TypeError('No method named "' + t + '"');
                      r[t]()
                  }
              })
          }
          ,
          r(e, null, [{
              key: "VERSION",
              get: function() {
                  return "4.2.1"
              }
          }, {
              key: "Default",
              get: function() {
                  return M
              }
          }]),
          e
      }();
      i(document).on(z.CLICK_DATA_API, B.DATA_TOGGLE, function(e) {
          "A" === e.currentTarget.tagName && e.preventDefault();
          var t = i(this)
            , n = c.getSelectorFromElement(this)
            , r = [].slice.call(document.querySelectorAll(n));
          i(r).each(function() {
              var e = i(this)
                , n = e.data("bs.collapse")
                , r = n ? "toggle" : t.data();
              j._jQueryInterface.call(e, r)
          })
      }),
      i.fn[P] = j._jQueryInterface,
      i.fn[P].Constructor = j,
      i.fn[P].noConflict = function() {
          return i.fn[P] = I,
          j._jQueryInterface
      }
      ;
      var F = "dropdown"
        , N = i.fn[F]
        , U = new RegExp("38|40|27")
        , q = {
          HIDE: "hide.bs.dropdown",
          HIDDEN: "hidden.bs.dropdown",
          SHOW: "show.bs.dropdown",
          SHOWN: "shown.bs.dropdown",
          CLICK: "click.bs.dropdown",
          CLICK_DATA_API: "click.bs.dropdown.data-api",
          KEYDOWN_DATA_API: "keydown.bs.dropdown.data-api",
          KEYUP_DATA_API: "keyup.bs.dropdown.data-api"
      }
        , H = {
          DISABLED: "disabled",
          SHOW: "show",
          DROPUP: "dropup",
          DROPRIGHT: "dropright",
          DROPLEFT: "dropleft",
          MENURIGHT: "dropdown-menu-right",
          MENULEFT: "dropdown-menu-left",
          POSITION_STATIC: "position-static"
      }
        , V = {
          DATA_TOGGLE: '[data-toggle="dropdown"]',
          FORM_CHILD: ".dropdown form",
          MENU: ".dropdown-menu",
          NAVBAR_NAV: ".navbar-nav",
          VISIBLE_ITEMS: ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)"
      }
        , W = {
          TOP: "top-start",
          TOPEND: "top-end",
          BOTTOM: "bottom-start",
          BOTTOMEND: "bottom-end",
          RIGHT: "right-start",
          RIGHTEND: "right-end",
          LEFT: "left-start",
          LEFTEND: "left-end"
      }
        , $ = {
          offset: 0,
          flip: !0,
          boundary: "scrollParent",
          reference: "toggle",
          display: "dynamic"
      }
        , G = {
          offset: "(number|string|function)",
          flip: "boolean",
          boundary: "(string|element)",
          reference: "(string|element)",
          display: "string"
      }
        , X = function() {
          function e(e, t) {
              this._element = e,
              this._popper = null,
              this._config = this._getConfig(t),
              this._menu = this._getMenuElement(),
              this._inNavbar = this._detectNavbar(),
              this._addEventListeners()
          }
          var n = e.prototype;
          return n.toggle = function() {
              if (!this._element.disabled && !i(this._element).hasClass(H.DISABLED)) {
                  var n = e._getParentFromElement(this._element)
                    , r = i(this._menu).hasClass(H.SHOW);
                  if (e._clearMenus(),
                  !r) {
                      var o = {
                          relatedTarget: this._element
                      }
                        , s = i.Event(q.SHOW, o);
                      if (i(n).trigger(s),
                      !s.isDefaultPrevented()) {
                          if (!this._inNavbar) {
                              if (void 0 === t)
                                  throw new TypeError("Bootstrap's dropdowns require Popper.js (https://popper.js.org/)");
                              var a = this._element;
                              "parent" === this._config.reference ? a = n : c.isElement(this._config.reference) && (a = this._config.reference,
                              void 0 !== this._config.reference.jquery && (a = this._config.reference[0])),
                              "scrollParent" !== this._config.boundary && i(n).addClass(H.POSITION_STATIC),
                              this._popper = new t(a,this._menu,this._getPopperConfig())
                          }
                          "ontouchstart"in document.documentElement && 0 === i(n).closest(V.NAVBAR_NAV).length && i(document.body).children().on("mouseover", null, i.noop),
                          this._element.focus(),
                          this._element.setAttribute("aria-expanded", !0),
                          i(this._menu).toggleClass(H.SHOW),
                          i(n).toggleClass(H.SHOW).trigger(i.Event(q.SHOWN, o))
                      }
                  }
              }
          }
          ,
          n.show = function() {
              if (!(this._element.disabled || i(this._element).hasClass(H.DISABLED) || i(this._menu).hasClass(H.SHOW))) {
                  var t = {
                      relatedTarget: this._element
                  }
                    , n = i.Event(q.SHOW, t)
                    , r = e._getParentFromElement(this._element);
                  i(r).trigger(n),
                  n.isDefaultPrevented() || (i(this._menu).toggleClass(H.SHOW),
                  i(r).toggleClass(H.SHOW).trigger(i.Event(q.SHOWN, t)))
              }
          }
          ,
          n.hide = function() {
              if (!this._element.disabled && !i(this._element).hasClass(H.DISABLED) && i(this._menu).hasClass(H.SHOW)) {
                  var t = {
                      relatedTarget: this._element
                  }
                    , n = i.Event(q.HIDE, t)
                    , r = e._getParentFromElement(this._element);
                  i(r).trigger(n),
                  n.isDefaultPrevented() || (i(this._menu).toggleClass(H.SHOW),
                  i(r).toggleClass(H.SHOW).trigger(i.Event(q.HIDDEN, t)))
              }
          }
          ,
          n.dispose = function() {
              i.removeData(this._element, "bs.dropdown"),
              i(this._element).off(".bs.dropdown"),
              this._element = null,
              this._menu = null,
              null !== this._popper && (this._popper.destroy(),
              this._popper = null)
          }
          ,
          n.update = function() {
              this._inNavbar = this._detectNavbar(),
              null !== this._popper && this._popper.scheduleUpdate()
          }
          ,
          n._addEventListeners = function() {
              var e = this;
              i(this._element).on(q.CLICK, function(t) {
                  t.preventDefault(),
                  t.stopPropagation(),
                  e.toggle()
              })
          }
          ,
          n._getConfig = function(e) {
              return e = s({}, this.constructor.Default, i(this._element).data(), e),
              c.typeCheckConfig(F, e, this.constructor.DefaultType),
              e
          }
          ,
          n._getMenuElement = function() {
              if (!this._menu) {
                  var t = e._getParentFromElement(this._element);
                  t && (this._menu = t.querySelector(V.MENU))
              }
              return this._menu
          }
          ,
          n._getPlacement = function() {
              var e = i(this._element.parentNode)
                , t = W.BOTTOM;
              return e.hasClass(H.DROPUP) ? (t = W.TOP,
              i(this._menu).hasClass(H.MENURIGHT) && (t = W.TOPEND)) : e.hasClass(H.DROPRIGHT) ? t = W.RIGHT : e.hasClass(H.DROPLEFT) ? t = W.LEFT : i(this._menu).hasClass(H.MENURIGHT) && (t = W.BOTTOMEND),
              t
          }
          ,
          n._detectNavbar = function() {
              return i(this._element).closest(".navbar").length > 0
          }
          ,
          n._getPopperConfig = function() {
              var e = this
                , t = {};
              "function" == typeof this._config.offset ? t.fn = function(t) {
                  return t.offsets = s({}, t.offsets, e._config.offset(t.offsets) || {}),
                  t
              }
              : t.offset = this._config.offset;
              var i = {
                  placement: this._getPlacement(),
                  modifiers: {
                      offset: t,
                      flip: {
                          enabled: this._config.flip
                      },
                      preventOverflow: {
                          boundariesElement: this._config.boundary
                      }
                  }
              };
              return "static" === this._config.display && (i.modifiers.applyStyle = {
                  enabled: !1
              }),
              i
          }
          ,
          e._jQueryInterface = function(t) {
              return this.each(function() {
                  var n = i(this).data("bs.dropdown")
                    , r = "object" == typeof t ? t : null;
                  if (n || (n = new e(this,r),
                  i(this).data("bs.dropdown", n)),
                  "string" == typeof t) {
                      if (void 0 === n[t])
                          throw new TypeError('No method named "' + t + '"');
                      n[t]()
                  }
              })
          }
          ,
          e._clearMenus = function(t) {
              if (!t || 3 !== t.which && ("keyup" !== t.type || 9 === t.which))
                  for (var n = [].slice.call(document.querySelectorAll(V.DATA_TOGGLE)), r = 0, o = n.length; r < o; r++) {
                      var s = e._getParentFromElement(n[r])
                        , a = i(n[r]).data("bs.dropdown")
                        , l = {
                          relatedTarget: n[r]
                      };
                      if (t && "click" === t.type && (l.clickEvent = t),
                      a) {
                          var c = a._menu;
                          if (i(s).hasClass(H.SHOW) && !(t && ("click" === t.type && /input|textarea/i.test(t.target.tagName) || "keyup" === t.type && 9 === t.which) && i.contains(s, t.target))) {
                              var u = i.Event(q.HIDE, l);
                              i(s).trigger(u),
                              u.isDefaultPrevented() || ("ontouchstart"in document.documentElement && i(document.body).children().off("mouseover", null, i.noop),
                              n[r].setAttribute("aria-expanded", "false"),
                              i(c).removeClass(H.SHOW),
                              i(s).removeClass(H.SHOW).trigger(i.Event(q.HIDDEN, l)))
                          }
                      }
                  }
          }
          ,
          e._getParentFromElement = function(e) {
              var t, i = c.getSelectorFromElement(e);
              return i && (t = document.querySelector(i)),
              t || e.parentNode
          }
          ,
          e._dataApiKeydownHandler = function(t) {
              if ((/input|textarea/i.test(t.target.tagName) ? !(32 === t.which || 27 !== t.which && (40 !== t.which && 38 !== t.which || i(t.target).closest(V.MENU).length)) : U.test(t.which)) && (t.preventDefault(),
              t.stopPropagation(),
              !this.disabled && !i(this).hasClass(H.DISABLED))) {
                  var n = e._getParentFromElement(this)
                    , r = i(n).hasClass(H.SHOW);
                  if (r && (!r || 27 !== t.which && 32 !== t.which)) {
                      var o = [].slice.call(n.querySelectorAll(V.VISIBLE_ITEMS));
                      if (0 !== o.length) {
                          var s = o.indexOf(t.target);
                          38 === t.which && s > 0 && s--,
                          40 === t.which && s < o.length - 1 && s++,
                          s < 0 && (s = 0),
                          o[s].focus()
                      }
                  } else {
                      if (27 === t.which) {
                          var a = n.querySelector(V.DATA_TOGGLE);
                          i(a).trigger("focus")
                      }
                      i(this).trigger("click")
                  }
              }
          }
          ,
          r(e, null, [{
              key: "VERSION",
              get: function() {
                  return "4.2.1"
              }
          }, {
              key: "Default",
              get: function() {
                  return $
              }
          }, {
              key: "DefaultType",
              get: function() {
                  return G
              }
          }]),
          e
      }();
      i(document).on(q.KEYDOWN_DATA_API, V.DATA_TOGGLE, X._dataApiKeydownHandler).on(q.KEYDOWN_DATA_API, V.MENU, X._dataApiKeydownHandler).on(q.CLICK_DATA_API + " " + q.KEYUP_DATA_API, X._clearMenus).on(q.CLICK_DATA_API, V.DATA_TOGGLE, function(e) {
          e.preventDefault(),
          e.stopPropagation(),
          X._jQueryInterface.call(i(this), "toggle")
      }).on(q.CLICK_DATA_API, V.FORM_CHILD, function(e) {
          e.stopPropagation()
      }),
      i.fn[F] = X._jQueryInterface,
      i.fn[F].Constructor = X,
      i.fn[F].noConflict = function() {
          return i.fn[F] = N,
          X._jQueryInterface
      }
      ;
      var Z = i.fn.modal
        , Y = {
          backdrop: !0,
          keyboard: !0,
          focus: !0,
          show: !0
      }
        , K = {
          backdrop: "(boolean|string)",
          keyboard: "boolean",
          focus: "boolean",
          show: "boolean"
      }
        , J = {
          HIDE: "hide.bs.modal",
          HIDDEN: "hidden.bs.modal",
          SHOW: "show.bs.modal",
          SHOWN: "shown.bs.modal",
          FOCUSIN: "focusin.bs.modal",
          RESIZE: "resize.bs.modal",
          CLICK_DISMISS: "click.dismiss.bs.modal",
          KEYDOWN_DISMISS: "keydown.dismiss.bs.modal",
          MOUSEUP_DISMISS: "mouseup.dismiss.bs.modal",
          MOUSEDOWN_DISMISS: "mousedown.dismiss.bs.modal",
          CLICK_DATA_API: "click.bs.modal.data-api"
      }
        , Q = {
          SCROLLBAR_MEASURER: "modal-scrollbar-measure",
          BACKDROP: "modal-backdrop",
          OPEN: "modal-open",
          FADE: "fade",
          SHOW: "show"
      }
        , ee = {
          DIALOG: ".modal-dialog",
          DATA_TOGGLE: '[data-toggle="modal"]',
          DATA_DISMISS: '[data-dismiss="modal"]',
          FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
          STICKY_CONTENT: ".sticky-top"
      }
        , te = function() {
          function e(e, t) {
              this._config = this._getConfig(t),
              this._element = e,
              this._dialog = e.querySelector(ee.DIALOG),
              this._backdrop = null,
              this._isShown = !1,
              this._isBodyOverflowing = !1,
              this._ignoreBackdropClick = !1,
              this._isTransitioning = !1,
              this._scrollbarWidth = 0
          }
          var t = e.prototype;
          return t.toggle = function(e) {
              return this._isShown ? this.hide() : this.show(e)
          }
          ,
          t.show = function(e) {
              var t = this;
              if (!this._isShown && !this._isTransitioning) {
                  i(this._element).hasClass(Q.FADE) && (this._isTransitioning = !0);
                  var n = i.Event(J.SHOW, {
                      relatedTarget: e
                  });
                  i(this._element).trigger(n),
                  this._isShown || n.isDefaultPrevented() || (this._isShown = !0,
                  this._checkScrollbar(),
                  this._setScrollbar(),
                  this._adjustDialog(),
                  this._setEscapeEvent(),
                  this._setResizeEvent(),
                  i(this._element).on(J.CLICK_DISMISS, ee.DATA_DISMISS, function(e) {
                      return t.hide(e)
                  }),
                  i(this._dialog).on(J.MOUSEDOWN_DISMISS, function() {
                      i(t._element).one(J.MOUSEUP_DISMISS, function(e) {
                          i(e.target).is(t._element) && (t._ignoreBackdropClick = !0)
                      })
                  }),
                  this._showBackdrop(function() {
                      return t._showElement(e)
                  }))
              }
          }
          ,
          t.hide = function(e) {
              var t = this;
              if (e && e.preventDefault(),
              this._isShown && !this._isTransitioning) {
                  var n = i.Event(J.HIDE);
                  if (i(this._element).trigger(n),
                  this._isShown && !n.isDefaultPrevented()) {
                      this._isShown = !1;
                      var r = i(this._element).hasClass(Q.FADE);
                      if (r && (this._isTransitioning = !0),
                      this._setEscapeEvent(),
                      this._setResizeEvent(),
                      i(document).off(J.FOCUSIN),
                      i(this._element).removeClass(Q.SHOW),
                      i(this._element).off(J.CLICK_DISMISS),
                      i(this._dialog).off(J.MOUSEDOWN_DISMISS),
                      r) {
                          var o = c.getTransitionDurationFromElement(this._element);
                          i(this._element).one(c.TRANSITION_END, function(e) {
                              return t._hideModal(e)
                          }).emulateTransitionEnd(o)
                      } else
                          this._hideModal()
                  }
              }
          }
          ,
          t.dispose = function() {
              [window, this._element, this._dialog].forEach(function(e) {
                  return i(e).off(".bs.modal")
              }),
              i(document).off(J.FOCUSIN),
              i.removeData(this._element, "bs.modal"),
              this._config = null,
              this._element = null,
              this._dialog = null,
              this._backdrop = null,
              this._isShown = null,
              this._isBodyOverflowing = null,
              this._ignoreBackdropClick = null,
              this._isTransitioning = null,
              this._scrollbarWidth = null
          }
          ,
          t.handleUpdate = function() {
              this._adjustDialog()
          }
          ,
          t._getConfig = function(e) {
              return e = s({}, Y, e),
              c.typeCheckConfig("modal", e, K),
              e
          }
          ,
          t._showElement = function(e) {
              var t = this
                , n = i(this._element).hasClass(Q.FADE);
              this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE || document.body.appendChild(this._element),
              this._element.style.display = "block",
              this._element.removeAttribute("aria-hidden"),
              this._element.setAttribute("aria-modal", !0),
              this._element.scrollTop = 0,
              n && c.reflow(this._element),
              i(this._element).addClass(Q.SHOW),
              this._config.focus && this._enforceFocus();
              var r = i.Event(J.SHOWN, {
                  relatedTarget: e
              })
                , o = function() {
                  t._config.focus && t._element.focus(),
                  t._isTransitioning = !1,
                  i(t._element).trigger(r)
              };
              if (n) {
                  var s = c.getTransitionDurationFromElement(this._dialog);
                  i(this._dialog).one(c.TRANSITION_END, o).emulateTransitionEnd(s)
              } else
                  o()
          }
          ,
          t._enforceFocus = function() {
              var e = this;
              i(document).off(J.FOCUSIN).on(J.FOCUSIN, function(t) {
                  document !== t.target && e._element !== t.target && 0 === i(e._element).has(t.target).length && e._element.focus()
              })
          }
          ,
          t._setEscapeEvent = function() {
              var e = this;
              this._isShown && this._config.keyboard ? i(this._element).on(J.KEYDOWN_DISMISS, function(t) {
                  27 === t.which && (t.preventDefault(),
                  e.hide())
              }) : this._isShown || i(this._element).off(J.KEYDOWN_DISMISS)
          }
          ,
          t._setResizeEvent = function() {
              var e = this;
              this._isShown ? i(window).on(J.RESIZE, function(t) {
                  return e.handleUpdate(t)
              }) : i(window).off(J.RESIZE)
          }
          ,
          t._hideModal = function() {
              var e = this;
              this._element.style.display = "none",
              this._element.setAttribute("aria-hidden", !0),
              this._element.removeAttribute("aria-modal"),
              this._isTransitioning = !1,
              this._showBackdrop(function() {
                  i(document.body).removeClass(Q.OPEN),
                  e._resetAdjustments(),
                  e._resetScrollbar(),
                  i(e._element).trigger(J.HIDDEN)
              })
          }
          ,
          t._removeBackdrop = function() {
              this._backdrop && (i(this._backdrop).remove(),
              this._backdrop = null)
          }
          ,
          t._showBackdrop = function(e) {
              var t = this
                , n = i(this._element).hasClass(Q.FADE) ? Q.FADE : "";
              if (this._isShown && this._config.backdrop) {
                  if (this._backdrop = document.createElement("div"),
                  this._backdrop.className = Q.BACKDROP,
                  n && this._backdrop.classList.add(n),
                  i(this._backdrop).appendTo(document.body),
                  i(this._element).on(J.CLICK_DISMISS, function(e) {
                      t._ignoreBackdropClick ? t._ignoreBackdropClick = !1 : e.target === e.currentTarget && ("static" === t._config.backdrop ? t._element.focus() : t.hide())
                  }),
                  n && c.reflow(this._backdrop),
                  i(this._backdrop).addClass(Q.SHOW),
                  !e)
                      return;
                  if (!n)
                      return void e();
                  var r = c.getTransitionDurationFromElement(this._backdrop);
                  i(this._backdrop).one(c.TRANSITION_END, e).emulateTransitionEnd(r)
              } else if (!this._isShown && this._backdrop) {
                  i(this._backdrop).removeClass(Q.SHOW);
                  var o = function() {
                      t._removeBackdrop(),
                      e && e()
                  };
                  if (i(this._element).hasClass(Q.FADE)) {
                      var s = c.getTransitionDurationFromElement(this._backdrop);
                      i(this._backdrop).one(c.TRANSITION_END, o).emulateTransitionEnd(s)
                  } else
                      o()
              } else
                  e && e()
          }
          ,
          t._adjustDialog = function() {
              var e = this._element.scrollHeight > document.documentElement.clientHeight;
              !this._isBodyOverflowing && e && (this._element.style.paddingLeft = this._scrollbarWidth + "px"),
              this._isBodyOverflowing && !e && (this._element.style.paddingRight = this._scrollbarWidth + "px")
          }
          ,
          t._resetAdjustments = function() {
              this._element.style.paddingLeft = "",
              this._element.style.paddingRight = ""
          }
          ,
          t._checkScrollbar = function() {
              var e = document.body.getBoundingClientRect();
              this._isBodyOverflowing = e.left + e.right < window.innerWidth,
              this._scrollbarWidth = this._getScrollbarWidth()
          }
          ,
          t._setScrollbar = function() {
              var e = this;
              if (this._isBodyOverflowing) {
                  var t = [].slice.call(document.querySelectorAll(ee.FIXED_CONTENT))
                    , n = [].slice.call(document.querySelectorAll(ee.STICKY_CONTENT));
                  i(t).each(function(t, n) {
                      var r = n.style.paddingRight
                        , o = i(n).css("padding-right");
                      i(n).data("padding-right", r).css("padding-right", parseFloat(o) + e._scrollbarWidth + "px")
                  }),
                  i(n).each(function(t, n) {
                      var r = n.style.marginRight
                        , o = i(n).css("margin-right");
                      i(n).data("margin-right", r).css("margin-right", parseFloat(o) - e._scrollbarWidth + "px")
                  });
                  var r = document.body.style.paddingRight
                    , o = i(document.body).css("padding-right");
                  i(document.body).data("padding-right", r).css("padding-right", parseFloat(o) + this._scrollbarWidth + "px")
              }
              i(document.body).addClass(Q.OPEN)
          }
          ,
          t._resetScrollbar = function() {
              var e = [].slice.call(document.querySelectorAll(ee.FIXED_CONTENT));
              i(e).each(function(e, t) {
                  var n = i(t).data("padding-right");
                  i(t).removeData("padding-right"),
                  t.style.paddingRight = n || ""
              });
              var t = [].slice.call(document.querySelectorAll("" + ee.STICKY_CONTENT));
              i(t).each(function(e, t) {
                  var n = i(t).data("margin-right");
                  void 0 !== n && i(t).css("margin-right", n).removeData("margin-right")
              });
              var n = i(document.body).data("padding-right");
              i(document.body).removeData("padding-right"),
              document.body.style.paddingRight = n || ""
          }
          ,
          t._getScrollbarWidth = function() {
              var e = document.createElement("div");
              e.className = Q.SCROLLBAR_MEASURER,
              document.body.appendChild(e);
              var t = e.getBoundingClientRect().width - e.clientWidth;
              return document.body.removeChild(e),
              t
          }
          ,
          e._jQueryInterface = function(t, n) {
              return this.each(function() {
                  var r = i(this).data("bs.modal")
                    , o = s({}, Y, i(this).data(), "object" == typeof t && t ? t : {});
                  if (r || (r = new e(this,o),
                  i(this).data("bs.modal", r)),
                  "string" == typeof t) {
                      if (void 0 === r[t])
                          throw new TypeError('No method named "' + t + '"');
                      r[t](n)
                  } else
                      o.show && r.show(n)
              })
          }
          ,
          r(e, null, [{
              key: "VERSION",
              get: function() {
                  return "4.2.1"
              }
          }, {
              key: "Default",
              get: function() {
                  return Y
              }
          }]),
          e
      }();
      i(document).on(J.CLICK_DATA_API, ee.DATA_TOGGLE, function(e) {
          var t, n = this, r = c.getSelectorFromElement(this);
          r && (t = document.querySelector(r));
          var o = i(t).data("bs.modal") ? "toggle" : s({}, i(t).data(), i(this).data());
          "A" !== this.tagName && "AREA" !== this.tagName || e.preventDefault();
          var a = i(t).one(J.SHOW, function(e) {
              e.isDefaultPrevented() || a.one(J.HIDDEN, function() {
                  i(n).is(":visible") && n.focus()
              })
          });
          te._jQueryInterface.call(i(t), o, this)
      }),
      i.fn.modal = te._jQueryInterface,
      i.fn.modal.Constructor = te,
      i.fn.modal.noConflict = function() {
          return i.fn.modal = Z,
          te._jQueryInterface
      }
      ;
      var ie = "tooltip"
        , ne = i.fn.tooltip
        , re = new RegExp("(^|\\s)bs-tooltip\\S+","g")
        , oe = {
          animation: "boolean",
          template: "string",
          title: "(string|element|function)",
          trigger: "string",
          delay: "(number|object)",
          html: "boolean",
          selector: "(string|boolean)",
          placement: "(string|function)",
          offset: "(number|string)",
          container: "(string|element|boolean)",
          fallbackPlacement: "(string|array)",
          boundary: "(string|element)"
      }
        , se = {
          AUTO: "auto",
          TOP: "top",
          RIGHT: "right",
          BOTTOM: "bottom",
          LEFT: "left"
      }
        , ae = {
          animation: !0,
          template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
          trigger: "hover focus",
          title: "",
          delay: 0,
          html: !1,
          selector: !1,
          placement: "top",
          offset: 0,
          container: !1,
          fallbackPlacement: "flip",
          boundary: "scrollParent"
      }
        , le = {
          SHOW: "show",
          OUT: "out"
      }
        , ce = {
          HIDE: "hide.bs.tooltip",
          HIDDEN: "hidden.bs.tooltip",
          SHOW: "show.bs.tooltip",
          SHOWN: "shown.bs.tooltip",
          INSERTED: "inserted.bs.tooltip",
          CLICK: "click.bs.tooltip",
          FOCUSIN: "focusin.bs.tooltip",
          FOCUSOUT: "focusout.bs.tooltip",
          MOUSEENTER: "mouseenter.bs.tooltip",
          MOUSELEAVE: "mouseleave.bs.tooltip"
      }
        , ue = {
          FADE: "fade",
          SHOW: "show"
      }
        , he = {
          TOOLTIP: ".tooltip",
          TOOLTIP_INNER: ".tooltip-inner",
          ARROW: ".arrow"
      }
        , de = {
          HOVER: "hover",
          FOCUS: "focus",
          CLICK: "click",
          MANUAL: "manual"
      }
        , pe = function() {
          function e(e, i) {
              if (void 0 === t)
                  throw new TypeError("Bootstrap's tooltips require Popper.js (https://popper.js.org/)");
              this._isEnabled = !0,
              this._timeout = 0,
              this._hoverState = "",
              this._activeTrigger = {},
              this._popper = null,
              this.element = e,
              this.config = this._getConfig(i),
              this.tip = null,
              this._setListeners()
          }
          var n = e.prototype;
          return n.enable = function() {
              this._isEnabled = !0
          }
          ,
          n.disable = function() {
              this._isEnabled = !1
          }
          ,
          n.toggleEnabled = function() {
              this._isEnabled = !this._isEnabled
          }
          ,
          n.toggle = function(e) {
              if (this._isEnabled)
                  if (e) {
                      var t = this.constructor.DATA_KEY
                        , n = i(e.currentTarget).data(t);
                      n || (n = new this.constructor(e.currentTarget,this._getDelegateConfig()),
                      i(e.currentTarget).data(t, n)),
                      n._activeTrigger.click = !n._activeTrigger.click,
                      n._isWithActiveTrigger() ? n._enter(null, n) : n._leave(null, n)
                  } else {
                      if (i(this.getTipElement()).hasClass(ue.SHOW))
                          return void this._leave(null, this);
                      this._enter(null, this)
                  }
          }
          ,
          n.dispose = function() {
              clearTimeout(this._timeout),
              i.removeData(this.element, this.constructor.DATA_KEY),
              i(this.element).off(this.constructor.EVENT_KEY),
              i(this.element).closest(".modal").off("hide.bs.modal"),
              this.tip && i(this.tip).remove(),
              this._isEnabled = null,
              this._timeout = null,
              this._hoverState = null,
              this._activeTrigger = null,
              null !== this._popper && this._popper.destroy(),
              this._popper = null,
              this.element = null,
              this.config = null,
              this.tip = null
          }
          ,
          n.show = function() {
              var e = this;
              if ("none" === i(this.element).css("display"))
                  throw new Error("Please use show on visible elements");
              var n = i.Event(this.constructor.Event.SHOW);
              if (this.isWithContent() && this._isEnabled) {
                  i(this.element).trigger(n);
                  var r = c.findShadowRoot(this.element)
                    , o = i.contains(null !== r ? r : this.element.ownerDocument.documentElement, this.element);
                  if (n.isDefaultPrevented() || !o)
                      return;
                  var s = this.getTipElement()
                    , a = c.getUID(this.constructor.NAME);
                  s.setAttribute("id", a),
                  this.element.setAttribute("aria-describedby", a),
                  this.setContent(),
                  this.config.animation && i(s).addClass(ue.FADE);
                  var l = "function" == typeof this.config.placement ? this.config.placement.call(this, s, this.element) : this.config.placement
                    , u = this._getAttachment(l);
                  this.addAttachmentClass(u);
                  var h = this._getContainer();
                  i(s).data(this.constructor.DATA_KEY, this),
                  i.contains(this.element.ownerDocument.documentElement, this.tip) || i(s).appendTo(h),
                  i(this.element).trigger(this.constructor.Event.INSERTED),
                  this._popper = new t(this.element,s,{
                      placement: u,
                      modifiers: {
                          offset: {
                              offset: this.config.offset
                          },
                          flip: {
                              behavior: this.config.fallbackPlacement
                          },
                          arrow: {
                              element: he.ARROW
                          },
                          preventOverflow: {
                              boundariesElement: this.config.boundary
                          }
                      },
                      onCreate: function(t) {
                          t.originalPlacement !== t.placement && e._handlePopperPlacementChange(t)
                      },
                      onUpdate: function(t) {
                          return e._handlePopperPlacementChange(t)
                      }
                  }),
                  i(s).addClass(ue.SHOW),
                  "ontouchstart"in document.documentElement && i(document.body).children().on("mouseover", null, i.noop);
                  var d = function() {
                      e.config.animation && e._fixTransition();
                      var t = e._hoverState;
                      e._hoverState = null,
                      i(e.element).trigger(e.constructor.Event.SHOWN),
                      t === le.OUT && e._leave(null, e)
                  };
                  if (i(this.tip).hasClass(ue.FADE)) {
                      var p = c.getTransitionDurationFromElement(this.tip);
                      i(this.tip).one(c.TRANSITION_END, d).emulateTransitionEnd(p)
                  } else
                      d()
              }
          }
          ,
          n.hide = function(e) {
              var t = this
                , n = this.getTipElement()
                , r = i.Event(this.constructor.Event.HIDE)
                , o = function() {
                  t._hoverState !== le.SHOW && n.parentNode && n.parentNode.removeChild(n),
                  t._cleanTipClass(),
                  t.element.removeAttribute("aria-describedby"),
                  i(t.element).trigger(t.constructor.Event.HIDDEN),
                  null !== t._popper && t._popper.destroy(),
                  e && e()
              };
              if (i(this.element).trigger(r),
              !r.isDefaultPrevented()) {
                  if (i(n).removeClass(ue.SHOW),
                  "ontouchstart"in document.documentElement && i(document.body).children().off("mouseover", null, i.noop),
                  this._activeTrigger[de.CLICK] = !1,
                  this._activeTrigger[de.FOCUS] = !1,
                  this._activeTrigger[de.HOVER] = !1,
                  i(this.tip).hasClass(ue.FADE)) {
                      var s = c.getTransitionDurationFromElement(n);
                      i(n).one(c.TRANSITION_END, o).emulateTransitionEnd(s)
                  } else
                      o();
                  this._hoverState = ""
              }
          }
          ,
          n.update = function() {
              null !== this._popper && this._popper.scheduleUpdate()
          }
          ,
          n.isWithContent = function() {
              return Boolean(this.getTitle())
          }
          ,
          n.addAttachmentClass = function(e) {
              i(this.getTipElement()).addClass("bs-tooltip-" + e)
          }
          ,
          n.getTipElement = function() {
              return this.tip = this.tip || i(this.config.template)[0],
              this.tip
          }
          ,
          n.setContent = function() {
              var e = this.getTipElement();
              this.setElementContent(i(e.querySelectorAll(he.TOOLTIP_INNER)), this.getTitle()),
              i(e).removeClass(ue.FADE + " " + ue.SHOW)
          }
          ,
          n.setElementContent = function(e, t) {
              var n = this.config.html;
              "object" == typeof t && (t.nodeType || t.jquery) ? n ? i(t).parent().is(e) || e.empty().append(t) : e.text(i(t).text()) : e[n ? "html" : "text"](t)
          }
          ,
          n.getTitle = function() {
              var e = this.element.getAttribute("data-original-title");
              return e || (e = "function" == typeof this.config.title ? this.config.title.call(this.element) : this.config.title),
              e
          }
          ,
          n._getContainer = function() {
              return !1 === this.config.container ? document.body : c.isElement(this.config.container) ? i(this.config.container) : i(document).find(this.config.container)
          }
          ,
          n._getAttachment = function(e) {
              return se[e.toUpperCase()]
          }
          ,
          n._setListeners = function() {
              var e = this
                , t = this.config.trigger.split(" ");
              t.forEach(function(t) {
                  if ("click" === t)
                      i(e.element).on(e.constructor.Event.CLICK, e.config.selector, function(t) {
                          return e.toggle(t)
                      });
                  else if (t !== de.MANUAL) {
                      var n = t === de.HOVER ? e.constructor.Event.MOUSEENTER : e.constructor.Event.FOCUSIN
                        , r = t === de.HOVER ? e.constructor.Event.MOUSELEAVE : e.constructor.Event.FOCUSOUT;
                      i(e.element).on(n, e.config.selector, function(t) {
                          return e._enter(t)
                      }).on(r, e.config.selector, function(t) {
                          return e._leave(t)
                      })
                  }
              }),
              i(this.element).closest(".modal").on("hide.bs.modal", function() {
                  e.element && e.hide()
              }),
              this.config.selector ? this.config = s({}, this.config, {
                  trigger: "manual",
                  selector: ""
              }) : this._fixTitle()
          }
          ,
          n._fixTitle = function() {
              var e = typeof this.element.getAttribute("data-original-title");
              (this.element.getAttribute("title") || "string" !== e) && (this.element.setAttribute("data-original-title", this.element.getAttribute("title") || ""),
              this.element.setAttribute("title", ""))
          }
          ,
          n._enter = function(e, t) {
              var n = this.constructor.DATA_KEY;
              (t = t || i(e.currentTarget).data(n)) || (t = new this.constructor(e.currentTarget,this._getDelegateConfig()),
              i(e.currentTarget).data(n, t)),
              e && (t._activeTrigger["focusin" === e.type ? de.FOCUS : de.HOVER] = !0),
              i(t.getTipElement()).hasClass(ue.SHOW) || t._hoverState === le.SHOW ? t._hoverState = le.SHOW : (clearTimeout(t._timeout),
              t._hoverState = le.SHOW,
              t.config.delay && t.config.delay.show ? t._timeout = setTimeout(function() {
                  t._hoverState === le.SHOW && t.show()
              }, t.config.delay.show) : t.show())
          }
          ,
          n._leave = function(e, t) {
              var n = this.constructor.DATA_KEY;
              (t = t || i(e.currentTarget).data(n)) || (t = new this.constructor(e.currentTarget,this._getDelegateConfig()),
              i(e.currentTarget).data(n, t)),
              e && (t._activeTrigger["focusout" === e.type ? de.FOCUS : de.HOVER] = !1),
              t._isWithActiveTrigger() || (clearTimeout(t._timeout),
              t._hoverState = le.OUT,
              t.config.delay && t.config.delay.hide ? t._timeout = setTimeout(function() {
                  t._hoverState === le.OUT && t.hide()
              }, t.config.delay.hide) : t.hide())
          }
          ,
          n._isWithActiveTrigger = function() {
              for (var e in this._activeTrigger)
                  if (this._activeTrigger[e])
                      return !0;
              return !1
          }
          ,
          n._getConfig = function(e) {
              return "number" == typeof (e = s({}, this.constructor.Default, i(this.element).data(), "object" == typeof e && e ? e : {})).delay && (e.delay = {
                  show: e.delay,
                  hide: e.delay
              }),
              "number" == typeof e.title && (e.title = e.title.toString()),
              "number" == typeof e.content && (e.content = e.content.toString()),
              c.typeCheckConfig(ie, e, this.constructor.DefaultType),
              e
          }
          ,
          n._getDelegateConfig = function() {
              var e = {};
              if (this.config)
                  for (var t in this.config)
                      this.constructor.Default[t] !== this.config[t] && (e[t] = this.config[t]);
              return e
          }
          ,
          n._cleanTipClass = function() {
              var e = i(this.getTipElement())
                , t = e.attr("class").match(re);
              null !== t && t.length && e.removeClass(t.join(""))
          }
          ,
          n._handlePopperPlacementChange = function(e) {
              var t = e.instance;
              this.tip = t.popper,
              this._cleanTipClass(),
              this.addAttachmentClass(this._getAttachment(e.placement))
          }
          ,
          n._fixTransition = function() {
              var e = this.getTipElement()
                , t = this.config.animation;
              null === e.getAttribute("x-placement") && (i(e).removeClass(ue.FADE),
              this.config.animation = !1,
              this.hide(),
              this.show(),
              this.config.animation = t)
          }
          ,
          e._jQueryInterface = function(t) {
              return this.each(function() {
                  var n = i(this).data("bs.tooltip")
                    , r = "object" == typeof t && t;
                  if ((n || !/dispose|hide/.test(t)) && (n || (n = new e(this,r),
                  i(this).data("bs.tooltip", n)),
                  "string" == typeof t)) {
                      if (void 0 === n[t])
                          throw new TypeError('No method named "' + t + '"');
                      n[t]()
                  }
              })
          }
          ,
          r(e, null, [{
              key: "VERSION",
              get: function() {
                  return "4.2.1"
              }
          }, {
              key: "Default",
              get: function() {
                  return ae
              }
          }, {
              key: "NAME",
              get: function() {
                  return ie
              }
          }, {
              key: "DATA_KEY",
              get: function() {
                  return "bs.tooltip"
              }
          }, {
              key: "Event",
              get: function() {
                  return ce
              }
          }, {
              key: "EVENT_KEY",
              get: function() {
                  return ".bs.tooltip"
              }
          }, {
              key: "DefaultType",
              get: function() {
                  return oe
              }
          }]),
          e
      }();
      i.fn.tooltip = pe._jQueryInterface,
      i.fn.tooltip.Constructor = pe,
      i.fn.tooltip.noConflict = function() {
          return i.fn.tooltip = ne,
          pe._jQueryInterface
      }
      ;
      var fe = "popover"
        , me = i.fn.popover
        , ge = new RegExp("(^|\\s)bs-popover\\S+","g")
        , ve = s({}, pe.Default, {
          placement: "right",
          trigger: "click",
          content: "",
          template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
      })
        , ye = s({}, pe.DefaultType, {
          content: "(string|element|function)"
      })
        , _e = {
          FADE: "fade",
          SHOW: "show"
      }
        , be = {
          TITLE: ".popover-header",
          CONTENT: ".popover-body"
      }
        , we = {
          HIDE: "hide.bs.popover",
          HIDDEN: "hidden.bs.popover",
          SHOW: "show.bs.popover",
          SHOWN: "shown.bs.popover",
          INSERTED: "inserted.bs.popover",
          CLICK: "click.bs.popover",
          FOCUSIN: "focusin.bs.popover",
          FOCUSOUT: "focusout.bs.popover",
          MOUSEENTER: "mouseenter.bs.popover",
          MOUSELEAVE: "mouseleave.bs.popover"
      }
        , xe = function(e) {
          var t, n;
          function o() {
              return e.apply(this, arguments) || this
          }
          n = e,
          (t = o).prototype = Object.create(n.prototype),
          t.prototype.constructor = t,
          t.__proto__ = n;
          var s = o.prototype;
          return s.isWithContent = function() {
              return this.getTitle() || this._getContent()
          }
          ,
          s.addAttachmentClass = function(e) {
              i(this.getTipElement()).addClass("bs-popover-" + e)
          }
          ,
          s.getTipElement = function() {
              return this.tip = this.tip || i(this.config.template)[0],
              this.tip
          }
          ,
          s.setContent = function() {
              var e = i(this.getTipElement());
              this.setElementContent(e.find(be.TITLE), this.getTitle());
              var t = this._getContent();
              "function" == typeof t && (t = t.call(this.element)),
              this.setElementContent(e.find(be.CONTENT), t),
              e.removeClass(_e.FADE + " " + _e.SHOW)
          }
          ,
          s._getContent = function() {
              return this.element.getAttribute("data-content") || this.config.content
          }
          ,
          s._cleanTipClass = function() {
              var e = i(this.getTipElement())
                , t = e.attr("class").match(ge);
              null !== t && t.length > 0 && e.removeClass(t.join(""))
          }
          ,
          o._jQueryInterface = function(e) {
              return this.each(function() {
                  var t = i(this).data("bs.popover")
                    , n = "object" == typeof e ? e : null;
                  if ((t || !/dispose|hide/.test(e)) && (t || (t = new o(this,n),
                  i(this).data("bs.popover", t)),
                  "string" == typeof e)) {
                      if (void 0 === t[e])
                          throw new TypeError('No method named "' + e + '"');
                      t[e]()
                  }
              })
          }
          ,
          r(o, null, [{
              key: "VERSION",
              get: function() {
                  return "4.2.1"
              }
          }, {
              key: "Default",
              get: function() {
                  return ve
              }
          }, {
              key: "NAME",
              get: function() {
                  return fe
              }
          }, {
              key: "DATA_KEY",
              get: function() {
                  return "bs.popover"
              }
          }, {
              key: "Event",
              get: function() {
                  return we
              }
          }, {
              key: "EVENT_KEY",
              get: function() {
                  return ".bs.popover"
              }
          }, {
              key: "DefaultType",
              get: function() {
                  return ye
              }
          }]),
          o
      }(pe);
      i.fn.popover = xe._jQueryInterface,
      i.fn.popover.Constructor = xe,
      i.fn.popover.noConflict = function() {
          return i.fn.popover = me,
          xe._jQueryInterface
      }
      ;
      var ke = "scrollspy"
        , Se = i.fn[ke]
        , Ee = {
          offset: 10,
          method: "auto",
          target: ""
      }
        , Te = {
          offset: "number",
          method: "string",
          target: "(string|element)"
      }
        , Ce = {
          ACTIVATE: "activate.bs.scrollspy",
          SCROLL: "scroll.bs.scrollspy",
          LOAD_DATA_API: "load.bs.scrollspy.data-api"
      }
        , Le = {
          DROPDOWN_ITEM: "dropdown-item",
          DROPDOWN_MENU: "dropdown-menu",
          ACTIVE: "active"
      }
        , Ae = {
          DATA_SPY: '[data-spy="scroll"]',
          ACTIVE: ".active",
          NAV_LIST_GROUP: ".nav, .list-group",
          NAV_LINKS: ".nav-link",
          NAV_ITEMS: ".nav-item",
          LIST_ITEMS: ".list-group-item",
          DROPDOWN: ".dropdown",
          DROPDOWN_ITEMS: ".dropdown-item",
          DROPDOWN_TOGGLE: ".dropdown-toggle"
      }
        , Pe = {
          OFFSET: "offset",
          POSITION: "position"
      }
        , Ie = function() {
          function e(e, t) {
              var n = this;
              this._element = e,
              this._scrollElement = "BODY" === e.tagName ? window : e,
              this._config = this._getConfig(t),
              this._selector = this._config.target + " " + Ae.NAV_LINKS + "," + this._config.target + " " + Ae.LIST_ITEMS + "," + this._config.target + " " + Ae.DROPDOWN_ITEMS,
              this._offsets = [],
              this._targets = [],
              this._activeTarget = null,
              this._scrollHeight = 0,
              i(this._scrollElement).on(Ce.SCROLL, function(e) {
                  return n._process(e)
              }),
              this.refresh(),
              this._process()
          }
          var t = e.prototype;
          return t.refresh = function() {
              var e = this
                , t = this._scrollElement === this._scrollElement.window ? Pe.OFFSET : Pe.POSITION
                , n = "auto" === this._config.method ? t : this._config.method
                , r = n === Pe.POSITION ? this._getScrollTop() : 0;
              this._offsets = [],
              this._targets = [],
              this._scrollHeight = this._getScrollHeight();
              var o = [].slice.call(document.querySelectorAll(this._selector));
              o.map(function(e) {
                  var t, o = c.getSelectorFromElement(e);
                  if (o && (t = document.querySelector(o)),
                  t) {
                      var s = t.getBoundingClientRect();
                      if (s.width || s.height)
                          return [i(t)[n]().top + r, o]
                  }
                  return null
              }).filter(function(e) {
                  return e
              }).sort(function(e, t) {
                  return e[0] - t[0]
              }).forEach(function(t) {
                  e._offsets.push(t[0]),
                  e._targets.push(t[1])
              })
          }
          ,
          t.dispose = function() {
              i.removeData(this._element, "bs.scrollspy"),
              i(this._scrollElement).off(".bs.scrollspy"),
              this._element = null,
              this._scrollElement = null,
              this._config = null,
              this._selector = null,
              this._offsets = null,
              this._targets = null,
              this._activeTarget = null,
              this._scrollHeight = null
          }
          ,
          t._getConfig = function(e) {
              if ("string" != typeof (e = s({}, Ee, "object" == typeof e && e ? e : {})).target) {
                  var t = i(e.target).attr("id");
                  t || (t = c.getUID(ke),
                  i(e.target).attr("id", t)),
                  e.target = "#" + t
              }
              return c.typeCheckConfig(ke, e, Te),
              e
          }
          ,
          t._getScrollTop = function() {
              return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop
          }
          ,
          t._getScrollHeight = function() {
              return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
          }
          ,
          t._getOffsetHeight = function() {
              return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height
          }
          ,
          t._process = function() {
              var e = this._getScrollTop() + this._config.offset
                , t = this._getScrollHeight()
                , i = this._config.offset + t - this._getOffsetHeight();
              if (this._scrollHeight !== t && this.refresh(),
              e >= i) {
                  var n = this._targets[this._targets.length - 1];
                  this._activeTarget !== n && this._activate(n)
              } else {
                  if (this._activeTarget && e < this._offsets[0] && this._offsets[0] > 0)
                      return this._activeTarget = null,
                      void this._clear();
                  for (var r = this._offsets.length, o = r; o--; ) {
                      var s = this._activeTarget !== this._targets[o] && e >= this._offsets[o] && (void 0 === this._offsets[o + 1] || e < this._offsets[o + 1]);
                      s && this._activate(this._targets[o])
                  }
              }
          }
          ,
          t._activate = function(e) {
              this._activeTarget = e,
              this._clear();
              var t = this._selector.split(",").map(function(t) {
                  return t + '[data-target="' + e + '"],' + t + '[href="' + e + '"]'
              })
                , n = i([].slice.call(document.querySelectorAll(t.join(","))));
              n.hasClass(Le.DROPDOWN_ITEM) ? (n.closest(Ae.DROPDOWN).find(Ae.DROPDOWN_TOGGLE).addClass(Le.ACTIVE),
              n.addClass(Le.ACTIVE)) : (n.addClass(Le.ACTIVE),
              n.parents(Ae.NAV_LIST_GROUP).prev(Ae.NAV_LINKS + ", " + Ae.LIST_ITEMS).addClass(Le.ACTIVE),
              n.parents(Ae.NAV_LIST_GROUP).prev(Ae.NAV_ITEMS).children(Ae.NAV_LINKS).addClass(Le.ACTIVE)),
              i(this._scrollElement).trigger(Ce.ACTIVATE, {
                  relatedTarget: e
              })
          }
          ,
          t._clear = function() {
              [].slice.call(document.querySelectorAll(this._selector)).filter(function(e) {
                  return e.classList.contains(Le.ACTIVE)
              }).forEach(function(e) {
                  return e.classList.remove(Le.ACTIVE)
              })
          }
          ,
          e._jQueryInterface = function(t) {
              return this.each(function() {
                  var n = i(this).data("bs.scrollspy")
                    , r = "object" == typeof t && t;
                  if (n || (n = new e(this,r),
                  i(this).data("bs.scrollspy", n)),
                  "string" == typeof t) {
                      if (void 0 === n[t])
                          throw new TypeError('No method named "' + t + '"');
                      n[t]()
                  }
              })
          }
          ,
          r(e, null, [{
              key: "VERSION",
              get: function() {
                  return "4.2.1"
              }
          }, {
              key: "Default",
              get: function() {
                  return Ee
              }
          }]),
          e
      }();
      i(window).on(Ce.LOAD_DATA_API, function() {
          for (var e = [].slice.call(document.querySelectorAll(Ae.DATA_SPY)), t = e.length, n = t; n--; ) {
              var r = i(e[n]);
              Ie._jQueryInterface.call(r, r.data())
          }
      }),
      i.fn[ke] = Ie._jQueryInterface,
      i.fn[ke].Constructor = Ie,
      i.fn[ke].noConflict = function() {
          return i.fn[ke] = Se,
          Ie._jQueryInterface
      }
      ;
      var Me = i.fn.tab
        , Oe = {
          HIDE: "hide.bs.tab",
          HIDDEN: "hidden.bs.tab",
          SHOW: "show.bs.tab",
          SHOWN: "shown.bs.tab",
          CLICK_DATA_API: "click.bs.tab.data-api"
      }
        , ze = {
          DROPDOWN_MENU: "dropdown-menu",
          ACTIVE: "active",
          DISABLED: "disabled",
          FADE: "fade",
          SHOW: "show"
      }
        , De = {
          DROPDOWN: ".dropdown",
          NAV_LIST_GROUP: ".nav, .list-group",
          ACTIVE: ".active",
          ACTIVE_UL: "> li > .active",
          DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
          DROPDOWN_TOGGLE: ".dropdown-toggle",
          DROPDOWN_ACTIVE_CHILD: "> .dropdown-menu .active"
      }
        , Re = function() {
          function e(e) {
              this._element = e
          }
          var t = e.prototype;
          return t.show = function() {
              var e = this;
              if (!(this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && i(this._element).hasClass(ze.ACTIVE) || i(this._element).hasClass(ze.DISABLED))) {
                  var t, n, r = i(this._element).closest(De.NAV_LIST_GROUP)[0], o = c.getSelectorFromElement(this._element);
                  if (r) {
                      var s = "UL" === r.nodeName || "OL" === r.nodeName ? De.ACTIVE_UL : De.ACTIVE;
                      n = (n = i.makeArray(i(r).find(s)))[n.length - 1]
                  }
                  var a = i.Event(Oe.HIDE, {
                      relatedTarget: this._element
                  })
                    , l = i.Event(Oe.SHOW, {
                      relatedTarget: n
                  });
                  if (n && i(n).trigger(a),
                  i(this._element).trigger(l),
                  !l.isDefaultPrevented() && !a.isDefaultPrevented()) {
                      o && (t = document.querySelector(o)),
                      this._activate(this._element, r);
                      var u = function() {
                          var t = i.Event(Oe.HIDDEN, {
                              relatedTarget: e._element
                          })
                            , r = i.Event(Oe.SHOWN, {
                              relatedTarget: n
                          });
                          i(n).trigger(t),
                          i(e._element).trigger(r)
                      };
                      t ? this._activate(t, t.parentNode, u) : u()
                  }
              }
          }
          ,
          t.dispose = function() {
              i.removeData(this._element, "bs.tab"),
              this._element = null
          }
          ,
          t._activate = function(e, t, n) {
              var r = this
                , o = !t || "UL" !== t.nodeName && "OL" !== t.nodeName ? i(t).children(De.ACTIVE) : i(t).find(De.ACTIVE_UL)
                , s = o[0]
                , a = n && s && i(s).hasClass(ze.FADE)
                , l = function() {
                  return r._transitionComplete(e, s, n)
              };
              if (s && a) {
                  var u = c.getTransitionDurationFromElement(s);
                  i(s).removeClass(ze.SHOW).one(c.TRANSITION_END, l).emulateTransitionEnd(u)
              } else
                  l()
          }
          ,
          t._transitionComplete = function(e, t, n) {
              if (t) {
                  i(t).removeClass(ze.ACTIVE);
                  var r = i(t.parentNode).find(De.DROPDOWN_ACTIVE_CHILD)[0];
                  r && i(r).removeClass(ze.ACTIVE),
                  "tab" === t.getAttribute("role") && t.setAttribute("aria-selected", !1)
              }
              if (i(e).addClass(ze.ACTIVE),
              "tab" === e.getAttribute("role") && e.setAttribute("aria-selected", !0),
              c.reflow(e),
              i(e).addClass(ze.SHOW),
              e.parentNode && i(e.parentNode).hasClass(ze.DROPDOWN_MENU)) {
                  var o = i(e).closest(De.DROPDOWN)[0];
                  if (o) {
                      var s = [].slice.call(o.querySelectorAll(De.DROPDOWN_TOGGLE));
                      i(s).addClass(ze.ACTIVE)
                  }
                  e.setAttribute("aria-expanded", !0)
              }
              n && n()
          }
          ,
          e._jQueryInterface = function(t) {
              return this.each(function() {
                  var n = i(this)
                    , r = n.data("bs.tab");
                  if (r || (r = new e(this),
                  n.data("bs.tab", r)),
                  "string" == typeof t) {
                      if (void 0 === r[t])
                          throw new TypeError('No method named "' + t + '"');
                      r[t]()
                  }
              })
          }
          ,
          r(e, null, [{
              key: "VERSION",
              get: function() {
                  return "4.2.1"
              }
          }]),
          e
      }();
      i(document).on(Oe.CLICK_DATA_API, De.DATA_TOGGLE, function(e) {
          e.preventDefault(),
          Re._jQueryInterface.call(i(this), "show")
      }),
      i.fn.tab = Re._jQueryInterface,
      i.fn.tab.Constructor = Re,
      i.fn.tab.noConflict = function() {
          return i.fn.tab = Me,
          Re._jQueryInterface
      }
      ;
      var Be = i.fn.toast
        , je = {
          CLICK_DISMISS: "click.dismiss.bs.toast",
          HIDE: "hide.bs.toast",
          HIDDEN: "hidden.bs.toast",
          SHOW: "show.bs.toast",
          SHOWN: "shown.bs.toast"
      }
        , Fe = {
          FADE: "fade",
          HIDE: "hide",
          SHOW: "show",
          SHOWING: "showing"
      }
        , Ne = {
          animation: "boolean",
          autohide: "boolean",
          delay: "number"
      }
        , Ue = {
          animation: !0,
          autohide: !0,
          delay: 500
      }
        , qe = {
          DATA_DISMISS: '[data-dismiss="toast"]'
      }
        , He = function() {
          function e(e, t) {
              this._element = e,
              this._config = this._getConfig(t),
              this._timeout = null,
              this._setListeners()
          }
          var t = e.prototype;
          return t.show = function() {
              var e = this;
              i(this._element).trigger(je.SHOW),
              this._config.animation && this._element.classList.add(Fe.FADE);
              var t = function() {
                  e._element.classList.remove(Fe.SHOWING),
                  e._element.classList.add(Fe.SHOW),
                  i(e._element).trigger(je.SHOWN),
                  e._config.autohide && e.hide()
              };
              if (this._element.classList.remove(Fe.HIDE),
              this._element.classList.add(Fe.SHOWING),
              this._config.animation) {
                  var n = c.getTransitionDurationFromElement(this._element);
                  i(this._element).one(c.TRANSITION_END, t).emulateTransitionEnd(n)
              } else
                  t()
          }
          ,
          t.hide = function(e) {
              var t = this;
              this._element.classList.contains(Fe.SHOW) && (i(this._element).trigger(je.HIDE),
              e ? this._close() : this._timeout = setTimeout(function() {
                  t._close()
              }, this._config.delay))
          }
          ,
          t.dispose = function() {
              clearTimeout(this._timeout),
              this._timeout = null,
              this._element.classList.contains(Fe.SHOW) && this._element.classList.remove(Fe.SHOW),
              i(this._element).off(je.CLICK_DISMISS),
              i.removeData(this._element, "bs.toast"),
              this._element = null,
              this._config = null
          }
          ,
          t._getConfig = function(e) {
              return e = s({}, Ue, i(this._element).data(), "object" == typeof e && e ? e : {}),
              c.typeCheckConfig("toast", e, this.constructor.DefaultType),
              e
          }
          ,
          t._setListeners = function() {
              var e = this;
              i(this._element).on(je.CLICK_DISMISS, qe.DATA_DISMISS, function() {
                  return e.hide(!0)
              })
          }
          ,
          t._close = function() {
              var e = this
                , t = function() {
                  e._element.classList.add(Fe.HIDE),
                  i(e._element).trigger(je.HIDDEN)
              };
              if (this._element.classList.remove(Fe.SHOW),
              this._config.animation) {
                  var n = c.getTransitionDurationFromElement(this._element);
                  i(this._element).one(c.TRANSITION_END, t).emulateTransitionEnd(n)
              } else
                  t()
          }
          ,
          e._jQueryInterface = function(t) {
              return this.each(function() {
                  var n = i(this)
                    , r = n.data("bs.toast")
                    , o = "object" == typeof t && t;
                  if (r || (r = new e(this,o),
                  n.data("bs.toast", r)),
                  "string" == typeof t) {
                      if (void 0 === r[t])
                          throw new TypeError('No method named "' + t + '"');
                      r[t](this)
                  }
              })
          }
          ,
          r(e, null, [{
              key: "VERSION",
              get: function() {
                  return "4.2.1"
              }
          }, {
              key: "DefaultType",
              get: function() {
                  return Ne
              }
          }]),
          e
      }();
      i.fn.toast = He._jQueryInterface,
      i.fn.toast.Constructor = He,
      i.fn.toast.noConflict = function() {
          return i.fn.toast = Be,
          He._jQueryInterface
      }
      ,
      function() {
          if (void 0 === i)
              throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
          var e = i.fn.jquery.split(" ")[0].split(".");
          if (e[0] < 2 && e[1] < 9 || 1 === e[0] && 9 === e[1] && e[2] < 1 || e[0] >= 4)
              throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0")
      }(),
      e.Util = c,
      e.Alert = p,
      e.Button = y,
      e.Carousel = A,
      e.Collapse = j,
      e.Dropdown = X,
      e.Modal = te,
      e.Popover = xe,
      e.Scrollspy = Ie,
      e.Tab = Re,
      e.Toast = He,
      e.Tooltip = pe,
      Object.defineProperty(e, "__esModule", {
          value: !0
      })
  }(t, i(183), i(7))
}
, function(e, t, i) {
  "use strict";
  i.r(t),
  function(e) {
      for (/**!
* @fileOverview Kickass library to create and place poppers near their reference elements.
* @version 1.14.6
* @license
* Copyright (c) 2016 Federico Zivolo and contributors
*
* Permission is hereby granted, free of charge, to any person obtaining a copy
* of this software and associated documentation files (the "Software"), to deal
* in the Software without restriction, including without limitation the rights
* to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
* copies of the Software, and to permit persons to whom the Software is
* furnished to do so, subject to the following conditions:
*
* The above copyright notice and this permission notice shall be included in all
* copies or substantial portions of the Software.
*
* THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
* IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
* AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
* LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
* OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
* SOFTWARE.
*/
      var i = "undefined" != typeof window && "undefined" != typeof document, n = ["Edge", "Trident", "Firefox"], r = 0, o = 0; o < n.length; o += 1)
          if (i && navigator.userAgent.indexOf(n[o]) >= 0) {
              r = 1;
              break
          }
      var s = i && window.Promise ? function(e) {
          var t = !1;
          return function() {
              t || (t = !0,
              window.Promise.resolve().then(function() {
                  t = !1,
                  e()
              }))
          }
      }
      : function(e) {
          var t = !1;
          return function() {
              t || (t = !0,
              setTimeout(function() {
                  t = !1,
                  e()
              }, r))
          }
      }
      ;
      function a(e) {
          return e && "[object Function]" === {}.toString.call(e)
      }
      function l(e, t) {
          if (1 !== e.nodeType)
              return [];
          var i = e.ownerDocument.defaultView.getComputedStyle(e, null);
          return t ? i[t] : i
      }
      function c(e) {
          return "HTML" === e.nodeName ? e : e.parentNode || e.host
      }
      function u(e) {
          if (!e)
              return document.body;
          switch (e.nodeName) {
          case "HTML":
          case "BODY":
              return e.ownerDocument.body;
          case "#document":
              return e.body
          }
          var t = l(e)
            , i = t.overflow
            , n = t.overflowX
            , r = t.overflowY;
          return /(auto|scroll|overlay)/.test(i + r + n) ? e : u(c(e))
      }
      var h = i && !(!window.MSInputMethodContext || !document.documentMode)
        , d = i && /MSIE 10/.test(navigator.userAgent);
      function p(e) {
          return 11 === e ? h : 10 === e ? d : h || d
      }
      function f(e) {
          if (!e)
              return document.documentElement;
          for (var t = p(10) ? document.body : null, i = e.offsetParent || null; i === t && e.nextElementSibling; )
              i = (e = e.nextElementSibling).offsetParent;
          var n = i && i.nodeName;
          return n && "BODY" !== n && "HTML" !== n ? -1 !== ["TH", "TD", "TABLE"].indexOf(i.nodeName) && "static" === l(i, "position") ? f(i) : i : e ? e.ownerDocument.documentElement : document.documentElement
      }
      function m(e) {
          return null !== e.parentNode ? m(e.parentNode) : e
      }
      function g(e, t) {
          if (!(e && e.nodeType && t && t.nodeType))
              return document.documentElement;
          var i = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING
            , n = i ? e : t
            , r = i ? t : e
            , o = document.createRange();
          o.setStart(n, 0),
          o.setEnd(r, 0);
          var s, a, l = o.commonAncestorContainer;
          if (e !== l && t !== l || n.contains(r))
              return "BODY" === (a = (s = l).nodeName) || "HTML" !== a && f(s.firstElementChild) !== s ? f(l) : l;
          var c = m(e);
          return c.host ? g(c.host, t) : g(e, m(t).host)
      }
      function v(e) {
          var t = "top" === (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top") ? "scrollTop" : "scrollLeft"
            , i = e.nodeName;
          if ("BODY" === i || "HTML" === i) {
              var n = e.ownerDocument.documentElement;
              return (e.ownerDocument.scrollingElement || n)[t]
          }
          return e[t]
      }
      function y(e, t) {
          var i = "x" === t ? "Left" : "Top"
            , n = "Left" === i ? "Right" : "Bottom";
          return parseFloat(e["border" + i + "Width"], 10) + parseFloat(e["border" + n + "Width"], 10)
      }
      function _(e, t, i, n) {
          return Math.max(t["offset" + e], t["scroll" + e], i["client" + e], i["offset" + e], i["scroll" + e], p(10) ? parseInt(i["offset" + e]) + parseInt(n["margin" + ("Height" === e ? "Top" : "Left")]) + parseInt(n["margin" + ("Height" === e ? "Bottom" : "Right")]) : 0)
      }
      function b(e) {
          var t = e.body
            , i = e.documentElement
            , n = p(10) && getComputedStyle(i);
          return {
              height: _("Height", t, i, n),
              width: _("Width", t, i, n)
          }
      }
      var w = function(e, t) {
          if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function")
      }
        , x = function() {
          function e(e, t) {
              for (var i = 0; i < t.length; i++) {
                  var n = t[i];
                  n.enumerable = n.enumerable || !1,
                  n.configurable = !0,
                  "value"in n && (n.writable = !0),
                  Object.defineProperty(e, n.key, n)
              }
          }
          return function(t, i, n) {
              return i && e(t.prototype, i),
              n && e(t, n),
              t
          }
      }()
        , k = function(e, t, i) {
          return t in e ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
          }) : e[t] = i,
          e
      }
        , S = Object.assign || function(e) {
          for (var t = 1; t < arguments.length; t++) {
              var i = arguments[t];
              for (var n in i)
                  Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n])
          }
          return e
      }
      ;
      function E(e) {
          return S({}, e, {
              right: e.left + e.width,
              bottom: e.top + e.height
          })
      }
      function T(e) {
          var t = {};
          try {
              if (p(10)) {
                  t = e.getBoundingClientRect();
                  var i = v(e, "top")
                    , n = v(e, "left");
                  t.top += i,
                  t.left += n,
                  t.bottom += i,
                  t.right += n
              } else
                  t = e.getBoundingClientRect()
          } catch (e) {}
          var r = {
              left: t.left,
              top: t.top,
              width: t.right - t.left,
              height: t.bottom - t.top
          }
            , o = "HTML" === e.nodeName ? b(e.ownerDocument) : {}
            , s = o.width || e.clientWidth || r.right - r.left
            , a = o.height || e.clientHeight || r.bottom - r.top
            , c = e.offsetWidth - s
            , u = e.offsetHeight - a;
          if (c || u) {
              var h = l(e);
              c -= y(h, "x"),
              u -= y(h, "y"),
              r.width -= c,
              r.height -= u
          }
          return E(r)
      }
      function C(e, t) {
          var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2]
            , n = p(10)
            , r = "HTML" === t.nodeName
            , o = T(e)
            , s = T(t)
            , a = u(e)
            , c = l(t)
            , h = parseFloat(c.borderTopWidth, 10)
            , d = parseFloat(c.borderLeftWidth, 10);
          i && r && (s.top = Math.max(s.top, 0),
          s.left = Math.max(s.left, 0));
          var f = E({
              top: o.top - s.top - h,
              left: o.left - s.left - d,
              width: o.width,
              height: o.height
          });
          if (f.marginTop = 0,
          f.marginLeft = 0,
          !n && r) {
              var m = parseFloat(c.marginTop, 10)
                , g = parseFloat(c.marginLeft, 10);
              f.top -= h - m,
              f.bottom -= h - m,
              f.left -= d - g,
              f.right -= d - g,
              f.marginTop = m,
              f.marginLeft = g
          }
          return (n && !i ? t.contains(a) : t === a && "BODY" !== a.nodeName) && (f = function(e, t) {
              var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2]
                , n = v(t, "top")
                , r = v(t, "left")
                , o = i ? -1 : 1;
              return e.top += n * o,
              e.bottom += n * o,
              e.left += r * o,
              e.right += r * o,
              e
          }(f, t)),
          f
      }
      function L(e) {
          if (!e || !e.parentElement || p())
              return document.documentElement;
          for (var t = e.parentElement; t && "none" === l(t, "transform"); )
              t = t.parentElement;
          return t || document.documentElement
      }
      function A(e, t, i, n) {
          var r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4]
            , o = {
              top: 0,
              left: 0
          }
            , s = r ? L(e) : g(e, t);
          if ("viewport" === n)
              o = function(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
                    , i = e.ownerDocument.documentElement
                    , n = C(e, i)
                    , r = Math.max(i.clientWidth, window.innerWidth || 0)
                    , o = Math.max(i.clientHeight, window.innerHeight || 0)
                    , s = t ? 0 : v(i)
                    , a = t ? 0 : v(i, "left");
                  return E({
                      top: s - n.top + n.marginTop,
                      left: a - n.left + n.marginLeft,
                      width: r,
                      height: o
                  })
              }(s, r);
          else {
              var a = void 0;
              "scrollParent" === n ? "BODY" === (a = u(c(t))).nodeName && (a = e.ownerDocument.documentElement) : a = "window" === n ? e.ownerDocument.documentElement : n;
              var h = C(a, s, r);
              if ("HTML" !== a.nodeName || function e(t) {
                  var i = t.nodeName;
                  return "BODY" !== i && "HTML" !== i && ("fixed" === l(t, "position") || e(c(t)))
              }(s))
                  o = h;
              else {
                  var d = b(e.ownerDocument)
                    , p = d.height
                    , f = d.width;
                  o.top += h.top - h.marginTop,
                  o.bottom = p + h.top,
                  o.left += h.left - h.marginLeft,
                  o.right = f + h.left
              }
          }
          var m = "number" == typeof (i = i || 0);
          return o.left += m ? i : i.left || 0,
          o.top += m ? i : i.top || 0,
          o.right -= m ? i : i.right || 0,
          o.bottom -= m ? i : i.bottom || 0,
          o
      }
      function P(e, t, i, n, r) {
          var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
          if (-1 === e.indexOf("auto"))
              return e;
          var s = A(i, n, o, r)
            , a = {
              top: {
                  width: s.width,
                  height: t.top - s.top
              },
              right: {
                  width: s.right - t.right,
                  height: s.height
              },
              bottom: {
                  width: s.width,
                  height: s.bottom - t.bottom
              },
              left: {
                  width: t.left - s.left,
                  height: s.height
              }
          }
            , l = Object.keys(a).map(function(e) {
              return S({
                  key: e
              }, a[e], {
                  area: (t = a[e],
                  t.width * t.height)
              });
              var t
          }).sort(function(e, t) {
              return t.area - e.area
          })
            , c = l.filter(function(e) {
              var t = e.width
                , n = e.height;
              return t >= i.clientWidth && n >= i.clientHeight
          })
            , u = c.length > 0 ? c[0].key : l[0].key
            , h = e.split("-")[1];
          return u + (h ? "-" + h : "")
      }
      function I(e, t, i) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
          return C(i, n ? L(t) : g(t, i), n)
      }
      function M(e) {
          var t = e.ownerDocument.defaultView.getComputedStyle(e)
            , i = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0)
            , n = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0);
          return {
              width: e.offsetWidth + n,
              height: e.offsetHeight + i
          }
      }
      function O(e) {
          var t = {
              left: "right",
              right: "left",
              bottom: "top",
              top: "bottom"
          };
          return e.replace(/left|right|bottom|top/g, function(e) {
              return t[e]
          })
      }
      function z(e, t, i) {
          i = i.split("-")[0];
          var n = M(e)
            , r = {
              width: n.width,
              height: n.height
          }
            , o = -1 !== ["right", "left"].indexOf(i)
            , s = o ? "top" : "left"
            , a = o ? "left" : "top"
            , l = o ? "height" : "width"
            , c = o ? "width" : "height";
          return r[s] = t[s] + t[l] / 2 - n[l] / 2,
          r[a] = i === a ? t[a] - n[c] : t[O(a)],
          r
      }
      function D(e, t) {
          return Array.prototype.find ? e.find(t) : e.filter(t)[0]
      }
      function R(e, t, i) {
          return (void 0 === i ? e : e.slice(0, function(e, t, i) {
              if (Array.prototype.findIndex)
                  return e.findIndex(function(e) {
                      return e[t] === i
                  });
              var n = D(e, function(e) {
                  return e[t] === i
              });
              return e.indexOf(n)
          }(e, "name", i))).forEach(function(e) {
              e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
              var i = e.function || e.fn;
              e.enabled && a(i) && (t.offsets.popper = E(t.offsets.popper),
              t.offsets.reference = E(t.offsets.reference),
              t = i(t, e))
          }),
          t
      }
      function B(e, t) {
          return e.some(function(e) {
              var i = e.name;
              return e.enabled && i === t
          })
      }
      function j(e) {
          for (var t = [!1, "ms", "Webkit", "Moz", "O"], i = e.charAt(0).toUpperCase() + e.slice(1), n = 0; n < t.length; n++) {
              var r = t[n]
                , o = r ? "" + r + i : e;
              if (void 0 !== document.body.style[o])
                  return o
          }
          return null
      }
      function F(e) {
          var t = e.ownerDocument;
          return t ? t.defaultView : window
      }
      function N(e, t, i, n) {
          i.updateBound = n,
          F(e).addEventListener("resize", i.updateBound, {
              passive: !0
          });
          var r = u(e);
          return function e(t, i, n, r) {
              var o = "BODY" === t.nodeName
                , s = o ? t.ownerDocument.defaultView : t;
              s.addEventListener(i, n, {
                  passive: !0
              }),
              o || e(u(s.parentNode), i, n, r),
              r.push(s)
          }(r, "scroll", i.updateBound, i.scrollParents),
          i.scrollElement = r,
          i.eventsEnabled = !0,
          i
      }
      function U() {
          var e, t;
          this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate),
          this.state = (e = this.reference,
          t = this.state,
          F(e).removeEventListener("resize", t.updateBound),
          t.scrollParents.forEach(function(e) {
              e.removeEventListener("scroll", t.updateBound)
          }),
          t.updateBound = null,
          t.scrollParents = [],
          t.scrollElement = null,
          t.eventsEnabled = !1,
          t))
      }
      function q(e) {
          return "" !== e && !isNaN(parseFloat(e)) && isFinite(e)
      }
      function H(e, t) {
          Object.keys(t).forEach(function(i) {
              var n = "";
              -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(i) && q(t[i]) && (n = "px"),
              e.style[i] = t[i] + n
          })
      }
      var V = i && /Firefox/i.test(navigator.userAgent);
      function W(e, t, i) {
          var n = D(e, function(e) {
              return e.name === t
          })
            , r = !!n && e.some(function(e) {
              return e.name === i && e.enabled && e.order < n.order
          });
          if (!r) {
              var o = "`" + t + "`"
                , s = "`" + i + "`";
              console.warn(s + " modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!")
          }
          return r
      }
      var $ = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"]
        , G = $.slice(3);
      function X(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
            , i = G.indexOf(e)
            , n = G.slice(i + 1).concat(G.slice(0, i));
          return t ? n.reverse() : n
      }
      var Z = {
          FLIP: "flip",
          CLOCKWISE: "clockwise",
          COUNTERCLOCKWISE: "counterclockwise"
      };
      function Y(e, t, i, n) {
          var r = [0, 0]
            , o = -1 !== ["right", "left"].indexOf(n)
            , s = e.split(/(\+|\-)/).map(function(e) {
              return e.trim()
          })
            , a = s.indexOf(D(s, function(e) {
              return -1 !== e.search(/,|\s/)
          }));
          s[a] && -1 === s[a].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
          var l = /\s*,\s*|\s+/
            , c = -1 !== a ? [s.slice(0, a).concat([s[a].split(l)[0]]), [s[a].split(l)[1]].concat(s.slice(a + 1))] : [s];
          return (c = c.map(function(e, n) {
              var r = (1 === n ? !o : o) ? "height" : "width"
                , s = !1;
              return e.reduce(function(e, t) {
                  return "" === e[e.length - 1] && -1 !== ["+", "-"].indexOf(t) ? (e[e.length - 1] = t,
                  s = !0,
                  e) : s ? (e[e.length - 1] += t,
                  s = !1,
                  e) : e.concat(t)
              }, []).map(function(e) {
                  return function(e, t, i, n) {
                      var r = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/)
                        , o = +r[1]
                        , s = r[2];
                      if (!o)
                          return e;
                      if (0 === s.indexOf("%")) {
                          var a = void 0;
                          switch (s) {
                          case "%p":
                              a = i;
                              break;
                          case "%":
                          case "%r":
                          default:
                              a = n
                          }
                          return E(a)[t] / 100 * o
                      }
                      if ("vh" === s || "vw" === s)
                          return ("vh" === s ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * o;
                      return o
                  }(e, r, t, i)
              })
          })).forEach(function(e, t) {
              e.forEach(function(i, n) {
                  q(i) && (r[t] += i * ("-" === e[n - 1] ? -1 : 1))
              })
          }),
          r
      }
      var K = {
          placement: "bottom",
          positionFixed: !1,
          eventsEnabled: !0,
          removeOnDestroy: !1,
          onCreate: function() {},
          onUpdate: function() {},
          modifiers: {
              shift: {
                  order: 100,
                  enabled: !0,
                  fn: function(e) {
                      var t = e.placement
                        , i = t.split("-")[0]
                        , n = t.split("-")[1];
                      if (n) {
                          var r = e.offsets
                            , o = r.reference
                            , s = r.popper
                            , a = -1 !== ["bottom", "top"].indexOf(i)
                            , l = a ? "left" : "top"
                            , c = a ? "width" : "height"
                            , u = {
                              start: k({}, l, o[l]),
                              end: k({}, l, o[l] + o[c] - s[c])
                          };
                          e.offsets.popper = S({}, s, u[n])
                      }
                      return e
                  }
              },
              offset: {
                  order: 200,
                  enabled: !0,
                  fn: function(e, t) {
                      var i = t.offset
                        , n = e.placement
                        , r = e.offsets
                        , o = r.popper
                        , s = r.reference
                        , a = n.split("-")[0]
                        , l = void 0;
                      return l = q(+i) ? [+i, 0] : Y(i, o, s, a),
                      "left" === a ? (o.top += l[0],
                      o.left -= l[1]) : "right" === a ? (o.top += l[0],
                      o.left += l[1]) : "top" === a ? (o.left += l[0],
                      o.top -= l[1]) : "bottom" === a && (o.left += l[0],
                      o.top += l[1]),
                      e.popper = o,
                      e
                  },
                  offset: 0
              },
              preventOverflow: {
                  order: 300,
                  enabled: !0,
                  fn: function(e, t) {
                      var i = t.boundariesElement || f(e.instance.popper);
                      e.instance.reference === i && (i = f(i));
                      var n = j("transform")
                        , r = e.instance.popper.style
                        , o = r.top
                        , s = r.left
                        , a = r[n];
                      r.top = "",
                      r.left = "",
                      r[n] = "";
                      var l = A(e.instance.popper, e.instance.reference, t.padding, i, e.positionFixed);
                      r.top = o,
                      r.left = s,
                      r[n] = a,
                      t.boundaries = l;
                      var c = t.priority
                        , u = e.offsets.popper
                        , h = {
                          primary: function(e) {
                              var i = u[e];
                              return u[e] < l[e] && !t.escapeWithReference && (i = Math.max(u[e], l[e])),
                              k({}, e, i)
                          },
                          secondary: function(e) {
                              var i = "right" === e ? "left" : "top"
                                , n = u[i];
                              return u[e] > l[e] && !t.escapeWithReference && (n = Math.min(u[i], l[e] - ("right" === e ? u.width : u.height))),
                              k({}, i, n)
                          }
                      };
                      return c.forEach(function(e) {
                          var t = -1 !== ["left", "top"].indexOf(e) ? "primary" : "secondary";
                          u = S({}, u, h[t](e))
                      }),
                      e.offsets.popper = u,
                      e
                  },
                  priority: ["left", "right", "top", "bottom"],
                  padding: 5,
                  boundariesElement: "scrollParent"
              },
              keepTogether: {
                  order: 400,
                  enabled: !0,
                  fn: function(e) {
                      var t = e.offsets
                        , i = t.popper
                        , n = t.reference
                        , r = e.placement.split("-")[0]
                        , o = Math.floor
                        , s = -1 !== ["top", "bottom"].indexOf(r)
                        , a = s ? "right" : "bottom"
                        , l = s ? "left" : "top"
                        , c = s ? "width" : "height";
                      return i[a] < o(n[l]) && (e.offsets.popper[l] = o(n[l]) - i[c]),
                      i[l] > o(n[a]) && (e.offsets.popper[l] = o(n[a])),
                      e
                  }
              },
              arrow: {
                  order: 500,
                  enabled: !0,
                  fn: function(e, t) {
                      var i;
                      if (!W(e.instance.modifiers, "arrow", "keepTogether"))
                          return e;
                      var n = t.element;
                      if ("string" == typeof n) {
                          if (!(n = e.instance.popper.querySelector(n)))
                              return e
                      } else if (!e.instance.popper.contains(n))
                          return console.warn("WARNING: `arrow.element` must be child of its popper element!"),
                          e;
                      var r = e.placement.split("-")[0]
                        , o = e.offsets
                        , s = o.popper
                        , a = o.reference
                        , c = -1 !== ["left", "right"].indexOf(r)
                        , u = c ? "height" : "width"
                        , h = c ? "Top" : "Left"
                        , d = h.toLowerCase()
                        , p = c ? "left" : "top"
                        , f = c ? "bottom" : "right"
                        , m = M(n)[u];
                      a[f] - m < s[d] && (e.offsets.popper[d] -= s[d] - (a[f] - m)),
                      a[d] + m > s[f] && (e.offsets.popper[d] += a[d] + m - s[f]),
                      e.offsets.popper = E(e.offsets.popper);
                      var g = a[d] + a[u] / 2 - m / 2
                        , v = l(e.instance.popper)
                        , y = parseFloat(v["margin" + h], 10)
                        , _ = parseFloat(v["border" + h + "Width"], 10)
                        , b = g - e.offsets.popper[d] - y - _;
                      return b = Math.max(Math.min(s[u] - m, b), 0),
                      e.arrowElement = n,
                      e.offsets.arrow = (k(i = {}, d, Math.round(b)),
                      k(i, p, ""),
                      i),
                      e
                  },
                  element: "[x-arrow]"
              },
              flip: {
                  order: 600,
                  enabled: !0,
                  fn: function(e, t) {
                      if (B(e.instance.modifiers, "inner"))
                          return e;
                      if (e.flipped && e.placement === e.originalPlacement)
                          return e;
                      var i = A(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed)
                        , n = e.placement.split("-")[0]
                        , r = O(n)
                        , o = e.placement.split("-")[1] || ""
                        , s = [];
                      switch (t.behavior) {
                      case Z.FLIP:
                          s = [n, r];
                          break;
                      case Z.CLOCKWISE:
                          s = X(n);
                          break;
                      case Z.COUNTERCLOCKWISE:
                          s = X(n, !0);
                          break;
                      default:
                          s = t.behavior
                      }
                      return s.forEach(function(a, l) {
                          if (n !== a || s.length === l + 1)
                              return e;
                          n = e.placement.split("-")[0],
                          r = O(n);
                          var c = e.offsets.popper
                            , u = e.offsets.reference
                            , h = Math.floor
                            , d = "left" === n && h(c.right) > h(u.left) || "right" === n && h(c.left) < h(u.right) || "top" === n && h(c.bottom) > h(u.top) || "bottom" === n && h(c.top) < h(u.bottom)
                            , p = h(c.left) < h(i.left)
                            , f = h(c.right) > h(i.right)
                            , m = h(c.top) < h(i.top)
                            , g = h(c.bottom) > h(i.bottom)
                            , v = "left" === n && p || "right" === n && f || "top" === n && m || "bottom" === n && g
                            , y = -1 !== ["top", "bottom"].indexOf(n)
                            , _ = !!t.flipVariations && (y && "start" === o && p || y && "end" === o && f || !y && "start" === o && m || !y && "end" === o && g);
                          (d || v || _) && (e.flipped = !0,
                          (d || v) && (n = s[l + 1]),
                          _ && (o = function(e) {
                              return "end" === e ? "start" : "start" === e ? "end" : e
                          }(o)),
                          e.placement = n + (o ? "-" + o : ""),
                          e.offsets.popper = S({}, e.offsets.popper, z(e.instance.popper, e.offsets.reference, e.placement)),
                          e = R(e.instance.modifiers, e, "flip"))
                      }),
                      e
                  },
                  behavior: "flip",
                  padding: 5,
                  boundariesElement: "viewport"
              },
              inner: {
                  order: 700,
                  enabled: !1,
                  fn: function(e) {
                      var t = e.placement
                        , i = t.split("-")[0]
                        , n = e.offsets
                        , r = n.popper
                        , o = n.reference
                        , s = -1 !== ["left", "right"].indexOf(i)
                        , a = -1 === ["top", "left"].indexOf(i);
                      return r[s ? "left" : "top"] = o[i] - (a ? r[s ? "width" : "height"] : 0),
                      e.placement = O(t),
                      e.offsets.popper = E(r),
                      e
                  }
              },
              hide: {
                  order: 800,
                  enabled: !0,
                  fn: function(e) {
                      if (!W(e.instance.modifiers, "hide", "preventOverflow"))
                          return e;
                      var t = e.offsets.reference
                        , i = D(e.instance.modifiers, function(e) {
                          return "preventOverflow" === e.name
                      }).boundaries;
                      if (t.bottom < i.top || t.left > i.right || t.top > i.bottom || t.right < i.left) {
                          if (!0 === e.hide)
                              return e;
                          e.hide = !0,
                          e.attributes["x-out-of-boundaries"] = ""
                      } else {
                          if (!1 === e.hide)
                              return e;
                          e.hide = !1,
                          e.attributes["x-out-of-boundaries"] = !1
                      }
                      return e
                  }
              },
              computeStyle: {
                  order: 850,
                  enabled: !0,
                  fn: function(e, t) {
                      var i = t.x
                        , n = t.y
                        , r = e.offsets.popper
                        , o = D(e.instance.modifiers, function(e) {
                          return "applyStyle" === e.name
                      }).gpuAcceleration;
                      void 0 !== o && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                      var s = void 0 !== o ? o : t.gpuAcceleration
                        , a = f(e.instance.popper)
                        , l = T(a)
                        , c = {
                          position: r.position
                      }
                        , u = function(e, t) {
                          var i = e.offsets
                            , n = i.popper
                            , r = i.reference
                            , o = -1 !== ["left", "right"].indexOf(e.placement)
                            , s = -1 !== e.placement.indexOf("-")
                            , a = r.width % 2 == n.width % 2
                            , l = r.width % 2 == 1 && n.width % 2 == 1
                            , c = function(e) {
                              return e
                          }
                            , u = t ? o || s || a ? Math.round : Math.floor : c
                            , h = t ? Math.round : c;
                          return {
                              left: u(l && !s && t ? n.left - 1 : n.left),
                              top: h(n.top),
                              bottom: h(n.bottom),
                              right: u(n.right)
                          }
                      }(e, window.devicePixelRatio < 2 || !V)
                        , h = "bottom" === i ? "top" : "bottom"
                        , d = "right" === n ? "left" : "right"
                        , p = j("transform")
                        , m = void 0
                        , g = void 0;
                      if (g = "bottom" === h ? "HTML" === a.nodeName ? -a.clientHeight + u.bottom : -l.height + u.bottom : u.top,
                      m = "right" === d ? "HTML" === a.nodeName ? -a.clientWidth + u.right : -l.width + u.right : u.left,
                      s && p)
                          c[p] = "translate3d(" + m + "px, " + g + "px, 0)",
                          c[h] = 0,
                          c[d] = 0,
                          c.willChange = "transform";
                      else {
                          var v = "bottom" === h ? -1 : 1
                            , y = "right" === d ? -1 : 1;
                          c[h] = g * v,
                          c[d] = m * y,
                          c.willChange = h + ", " + d
                      }
                      var _ = {
                          "x-placement": e.placement
                      };
                      return e.attributes = S({}, _, e.attributes),
                      e.styles = S({}, c, e.styles),
                      e.arrowStyles = S({}, e.offsets.arrow, e.arrowStyles),
                      e
                  },
                  gpuAcceleration: !0,
                  x: "bottom",
                  y: "right"
              },
              applyStyle: {
                  order: 900,
                  enabled: !0,
                  fn: function(e) {
                      var t, i;
                      return H(e.instance.popper, e.styles),
                      t = e.instance.popper,
                      i = e.attributes,
                      Object.keys(i).forEach(function(e) {
                          !1 !== i[e] ? t.setAttribute(e, i[e]) : t.removeAttribute(e)
                      }),
                      e.arrowElement && Object.keys(e.arrowStyles).length && H(e.arrowElement, e.arrowStyles),
                      e
                  },
                  onLoad: function(e, t, i, n, r) {
                      var o = I(r, t, e, i.positionFixed)
                        , s = P(i.placement, o, t, e, i.modifiers.flip.boundariesElement, i.modifiers.flip.padding);
                      return t.setAttribute("x-placement", s),
                      H(t, {
                          position: i.positionFixed ? "fixed" : "absolute"
                      }),
                      i
                  },
                  gpuAcceleration: void 0
              }
          }
      }
        , J = function() {
          function e(t, i) {
              var n = this
                , r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              w(this, e),
              this.scheduleUpdate = function() {
                  return requestAnimationFrame(n.update)
              }
              ,
              this.update = s(this.update.bind(this)),
              this.options = S({}, e.Defaults, r),
              this.state = {
                  isDestroyed: !1,
                  isCreated: !1,
                  scrollParents: []
              },
              this.reference = t && t.jquery ? t[0] : t,
              this.popper = i && i.jquery ? i[0] : i,
              this.options.modifiers = {},
              Object.keys(S({}, e.Defaults.modifiers, r.modifiers)).forEach(function(t) {
                  n.options.modifiers[t] = S({}, e.Defaults.modifiers[t] || {}, r.modifiers ? r.modifiers[t] : {})
              }),
              this.modifiers = Object.keys(this.options.modifiers).map(function(e) {
                  return S({
                      name: e
                  }, n.options.modifiers[e])
              }).sort(function(e, t) {
                  return e.order - t.order
              }),
              this.modifiers.forEach(function(e) {
                  e.enabled && a(e.onLoad) && e.onLoad(n.reference, n.popper, n.options, e, n.state)
              }),
              this.update();
              var o = this.options.eventsEnabled;
              o && this.enableEventListeners(),
              this.state.eventsEnabled = o
          }
          return x(e, [{
              key: "update",
              value: function() {
                  return function() {
                      if (!this.state.isDestroyed) {
                          var e = {
                              instance: this,
                              styles: {},
                              arrowStyles: {},
                              attributes: {},
                              flipped: !1,
                              offsets: {}
                          };
                          e.offsets.reference = I(this.state, this.popper, this.reference, this.options.positionFixed),
                          e.placement = P(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding),
                          e.originalPlacement = e.placement,
                          e.positionFixed = this.options.positionFixed,
                          e.offsets.popper = z(this.popper, e.offsets.reference, e.placement),
                          e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute",
                          e = R(this.modifiers, e),
                          this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0,
                          this.options.onCreate(e))
                      }
                  }
                  .call(this)
              }
          }, {
              key: "destroy",
              value: function() {
                  return function() {
                      return this.state.isDestroyed = !0,
                      B(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"),
                      this.popper.style.position = "",
                      this.popper.style.top = "",
                      this.popper.style.left = "",
                      this.popper.style.right = "",
                      this.popper.style.bottom = "",
                      this.popper.style.willChange = "",
                      this.popper.style[j("transform")] = ""),
                      this.disableEventListeners(),
                      this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper),
                      this
                  }
                  .call(this)
              }
          }, {
              key: "enableEventListeners",
              value: function() {
                  return function() {
                      this.state.eventsEnabled || (this.state = N(this.reference, this.options, this.state, this.scheduleUpdate))
                  }
                  .call(this)
              }
          }, {
              key: "disableEventListeners",
              value: function() {
                  return U.call(this)
              }
          }]),
          e
      }();
      J.Utils = ("undefined" != typeof window ? window : e).PopperUtils,
      J.placements = $,
      J.Defaults = K,
      t.default = J
  }
  .call(this, i(21))
}
, function(e, t, i) {
  !function(t, i) {
      var n = function(e, t) {
          "use strict";
          if (!t.getElementsByClassName)
              return;
          var i, n, r = t.documentElement, o = e.Date, s = e.HTMLPictureElement, a = e.addEventListener, l = e.setTimeout, c = e.requestAnimationFrame || l, u = e.requestIdleCallback, h = /^picture$/i, d = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, f = Array.prototype.forEach, m = function(e, t) {
              return p[t] || (p[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")),
              p[t].test(e.getAttribute("class") || "") && p[t]
          }, g = function(e, t) {
              m(e, t) || e.setAttribute("class", (e.getAttribute("class") || "").trim() + " " + t)
          }, v = function(e, t) {
              var i;
              (i = m(e, t)) && e.setAttribute("class", (e.getAttribute("class") || "").replace(i, " "))
          }, y = function(e, t, i) {
              var n = i ? "addEventListener" : "removeEventListener";
              i && y(e, t),
              d.forEach(function(i) {
                  e[n](i, t)
              })
          }, _ = function(e, n, r, o, s) {
              var a = t.createEvent("Event");
              return r || (r = {}),
              r.instance = i,
              a.initEvent(n, !o, !s),
              a.detail = r,
              e.dispatchEvent(a),
              a
          }, b = function(t, i) {
              var r;
              !s && (r = e.picturefill || n.pf) ? (i && i.src && !t.getAttribute("srcset") && t.setAttribute("srcset", i.src),
              r({
                  reevaluate: !0,
                  elements: [t]
              })) : i && i.src && (t.src = i.src)
          }, w = function(e, t) {
              return (getComputedStyle(e, null) || {})[t]
          }, x = function(e, t, i) {
              for (i = i || e.offsetWidth; i < n.minSize && t && !e._lazysizesWidth; )
                  i = t.offsetWidth,
                  t = t.parentNode;
              return i
          }, k = (L = [],
          A = [],
          P = L,
          I = function() {
              var e = P;
              for (P = L.length ? A : L,
              T = !0,
              C = !1; e.length; )
                  e.shift()();
              T = !1
          }
          ,
          M = function(e, i) {
              T && !i ? e.apply(this, arguments) : (P.push(e),
              C || (C = !0,
              (t.hidden ? l : c)(I)))
          }
          ,
          M._lsFlush = I,
          M), S = function(e, t) {
              return t ? function() {
                  k(e)
              }
              : function() {
                  var t = this
                    , i = arguments;
                  k(function() {
                      e.apply(t, i)
                  })
              }
          }, E = function(e) {
              var t, i, n = function() {
                  t = null,
                  e()
              }, r = function() {
                  var e = o.now() - i;
                  e < 99 ? l(r, 99 - e) : (u || n)(n)
              };
              return function() {
                  i = o.now(),
                  t || (t = l(r, 99))
              }
          };
          var T, C, L, A, P, I, M;
          !function() {
              var t, i = {
                  lazyClass: "lazyload",
                  loadedClass: "lazyloaded",
                  loadingClass: "lazyloading",
                  preloadClass: "lazypreload",
                  errorClass: "lazyerror",
                  autosizesClass: "lazyautosizes",
                  srcAttr: "data-src",
                  srcsetAttr: "data-srcset",
                  sizesAttr: "data-sizes",
                  minSize: 40,
                  customMedia: {},
                  init: !0,
                  expFactor: 1.5,
                  hFac: .8,
                  loadMode: 2,
                  loadHidden: !0,
                  ricTimeout: 0,
                  throttleDelay: 125
              };
              for (t in n = e.lazySizesConfig || e.lazysizesConfig || {},
              i)
                  t in n || (n[t] = i[t]);
              e.lazySizesConfig = n,
              l(function() {
                  n.init && D()
              })
          }();
          var O = function() {
              var s, c, d, p, x, T, C, L, A, P, I, M, O, D, R, B, j, F, N, U, q, H = /^img$/i, V = /^iframe$/i, W = "onscroll"in e && !/(gle|ing)bot/.test(navigator.userAgent), $ = 0, G = 0, X = -1, Z = function(e) {
                  G--,
                  e && e.target && y(e.target, Z),
                  (!e || G < 0 || !e.target) && (G = 0)
              }, Y = function(e, i) {
                  var n, o = e, s = "hidden" == w(t.body, "visibility") || "hidden" != w(e.parentNode, "visibility") && "hidden" != w(e, "visibility");
                  for (L -= i,
                  I += i,
                  A -= i,
                  P += i; s && (o = o.offsetParent) && o != t.body && o != r; )
                      (s = (w(o, "opacity") || 1) > 0) && "visible" != w(o, "overflow") && (n = o.getBoundingClientRect(),
                      s = P > n.left && A < n.right && I > n.top - 1 && L < n.bottom + 1);
                  return s
              }, K = function() {
                  var e, o, a, l, u, h, d, f, m, g = i.elements;
                  if ((p = n.loadMode) && G < 8 && (e = g.length)) {
                      o = 0,
                      X++,
                      null == O && ("expand"in n || (n.expand = r.clientHeight > 500 && r.clientWidth > 500 ? 500 : 370),
                      M = n.expand,
                      O = M * n.expFactor),
                      $ < O && G < 1 && X > 2 && p > 2 && !t.hidden ? ($ = O,
                      X = 0) : $ = p > 1 && X > 1 && G < 6 ? M : 0;
                      for (; o < e; o++)
                          if (g[o] && !g[o]._lazyRace)
                              if (W)
                                  if ((f = g[o].getAttribute("data-expand")) && (h = 1 * f) || (h = $),
                                  m !== h && (T = innerWidth + h * D,
                                  C = innerHeight + h,
                                  d = -1 * h,
                                  m = h),
                                  a = g[o].getBoundingClientRect(),
                                  (I = a.bottom) >= d && (L = a.top) <= C && (P = a.right) >= d * D && (A = a.left) <= T && (I || P || A || L) && (n.loadHidden || "hidden" != w(g[o], "visibility")) && (c && G < 3 && !f && (p < 3 || X < 4) || Y(g[o], h))) {
                                      if (re(g[o]),
                                      u = !0,
                                      G > 9)
                                          break
                                  } else
                                      !u && c && !l && G < 4 && X < 4 && p > 2 && (s[0] || n.preloadAfterLoad) && (s[0] || !f && (I || P || A || L || "auto" != g[o].getAttribute(n.sizesAttr))) && (l = s[0] || g[o]);
                              else
                                  re(g[o]);
                      l && !u && re(l)
                  }
              }, J = (R = K,
              j = 0,
              F = n.throttleDelay,
              N = n.ricTimeout,
              U = function() {
                  B = !1,
                  j = o.now(),
                  R()
              }
              ,
              q = u && N > 49 ? function() {
                  u(U, {
                      timeout: N
                  }),
                  N !== n.ricTimeout && (N = n.ricTimeout)
              }
              : S(function() {
                  l(U)
              }, !0),
              function(e) {
                  var t;
                  (e = !0 === e) && (N = 33),
                  B || (B = !0,
                  (t = F - (o.now() - j)) < 0 && (t = 0),
                  e || t < 9 ? q() : l(q, t))
              }
              ), Q = function(e) {
                  g(e.target, n.loadedClass),
                  v(e.target, n.loadingClass),
                  y(e.target, te),
                  _(e.target, "lazyloaded")
              }, ee = S(Q), te = function(e) {
                  ee({
                      target: e.target
                  })
              }, ie = function(e) {
                  var t, i = e.getAttribute(n.srcsetAttr);
                  (t = n.customMedia[e.getAttribute("data-media") || e.getAttribute("media")]) && e.setAttribute("media", t),
                  i && e.setAttribute("srcset", i)
              }, ne = S(function(e, t, i, r, o) {
                  var s, a, c, u, p, m;
                  (p = _(e, "lazybeforeunveil", t)).defaultPrevented || (r && (i ? g(e, n.autosizesClass) : e.setAttribute("sizes", r)),
                  a = e.getAttribute(n.srcsetAttr),
                  s = e.getAttribute(n.srcAttr),
                  o && (c = e.parentNode,
                  u = c && h.test(c.nodeName || "")),
                  m = t.firesLoad || "src"in e && (a || s || u),
                  p = {
                      target: e
                  },
                  m && (y(e, Z, !0),
                  clearTimeout(d),
                  d = l(Z, 2500),
                  g(e, n.loadingClass),
                  y(e, te, !0)),
                  u && f.call(c.getElementsByTagName("source"), ie),
                  a ? e.setAttribute("srcset", a) : s && !u && (V.test(e.nodeName) ? function(e, t) {
                      try {
                          e.contentWindow.location.replace(t)
                      } catch (i) {
                          e.src = t
                      }
                  }(e, s) : e.src = s),
                  o && (a || u) && b(e, {
                      src: s
                  })),
                  e._lazyRace && delete e._lazyRace,
                  v(e, n.lazyClass),
                  k(function() {
                      (!m || e.complete && e.naturalWidth > 1) && (m ? Z(p) : G--,
                      Q(p))
                  }, !0)
              }), re = function(e) {
                  var t, i = H.test(e.nodeName), r = i && (e.getAttribute(n.sizesAttr) || e.getAttribute("sizes")), o = "auto" == r;
                  (!o && c || !i || !e.getAttribute("src") && !e.srcset || e.complete || m(e, n.errorClass) || !m(e, n.lazyClass)) && (t = _(e, "lazyunveilread").detail,
                  o && z.updateElem(e, !0, e.offsetWidth),
                  e._lazyRace = !0,
                  G++,
                  ne(e, t, o, r, i))
              }, oe = function() {
                  if (!c)
                      if (o.now() - x < 999)
                          l(oe, 999);
                      else {
                          var e = E(function() {
                              n.loadMode = 3,
                              J()
                          });
                          c = !0,
                          n.loadMode = 3,
                          J(),
                          a("scroll", function() {
                              3 == n.loadMode && (n.loadMode = 2),
                              e()
                          }, !0)
                      }
              };
              return {
                  _: function() {
                      x = o.now(),
                      i.elements = t.getElementsByClassName(n.lazyClass),
                      s = t.getElementsByClassName(n.lazyClass + " " + n.preloadClass),
                      D = n.hFac,
                      a("scroll", J, !0),
                      a("resize", J, !0),
                      e.MutationObserver ? new MutationObserver(J).observe(r, {
                          childList: !0,
                          subtree: !0,
                          attributes: !0
                      }) : (r.addEventListener("DOMNodeInserted", J, !0),
                      r.addEventListener("DOMAttrModified", J, !0),
                      setInterval(J, 999)),
                      a("hashchange", J, !0),
                      ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(e) {
                          t.addEventListener(e, J, !0)
                      }),
                      /d$|^c/.test(t.readyState) ? oe() : (a("load", oe),
                      t.addEventListener("DOMContentLoaded", J),
                      l(oe, 2e4)),
                      i.elements.length ? (K(),
                      k._lsFlush()) : J()
                  },
                  checkElems: J,
                  unveil: re
              }
          }()
            , z = (B = S(function(e, t, i, n) {
              var r, o, s;
              if (e._lazysizesWidth = n,
              n += "px",
              e.setAttribute("sizes", n),
              h.test(t.nodeName || ""))
                  for (r = t.getElementsByTagName("source"),
                  o = 0,
                  s = r.length; o < s; o++)
                      r[o].setAttribute("sizes", n);
              i.detail.dataAttr || b(e, i.detail)
          }),
          j = function(e, t, i) {
              var n, r = e.parentNode;
              r && (i = x(e, r, i),
              (n = _(e, "lazybeforesizes", {
                  width: i,
                  dataAttr: !!t
              })).defaultPrevented || (i = n.detail.width) && i !== e._lazysizesWidth && B(e, r, n, i))
          }
          ,
          F = E(function() {
              var e, t = R.length;
              if (t)
                  for (e = 0; e < t; e++)
                      j(R[e])
          }),
          {
              _: function() {
                  R = t.getElementsByClassName(n.autosizesClass),
                  a("resize", F)
              },
              checkElems: F,
              updateElem: j
          })
            , D = function() {
              D.i || (D.i = !0,
              z._(),
              O._())
          };
          var R, B, j, F;
          return i = {
              cfg: n,
              autoSizer: z,
              loader: O,
              init: D,
              uP: b,
              aC: g,
              rC: v,
              hC: m,
              fire: _,
              gW: x,
              rAF: k
          }
      }(t, t.document);
      t.lazySizes = n,
      e.exports && (e.exports = n)
  }(window)
}
, function(e, t, i) {
  "use strict";
  var n = i(111);
  e.exports = n
}
, function(e, t, i) {
  "use strict";
  var n = i(187)
    , r = i(189)
    , o = i(49)
    , s = i(190)
    , a = {};
  function l(e) {
      var t = e.total
        , i = e.loaded;
      return {
          total: t,
          transferred: i,
          percent: 100 * i / t
      }
  }
  function c(e, t) {
      return new Promise(function(i, n) {
          t.onprogress = function(t) {
              e.emitter.emit(o.EVENT_PROGRESS_DOWNLOAD, l(t))
          }
          ;
          var s = e.file;
          s && (t.upload.onprogress = function(t) {
              e.emitter.emit(o.EVENT_PROGRESS_UPLOAD, l(t))
          }
          ),
          t.onerror = function(e) {
              n(e)
          }
          ,
          t.onabort = function() {
              var t = new r({
                  request: e,
                  type: o.ERROR_REQUEST_ABORTED
              });
              n(t)
          }
          ,
          t.onload = function() {
              if (delete a[e.id],
              t.status < 200 || t.status >= 400) {
                  var o = new r({
                      request: e,
                      body: t.response,
                      statusCode: t.status
                  });
                  n(o)
              } else
                  i(t)
          }
          ;
          var c = e.body;
          "string" == typeof c ? t.send(c) : c ? t.send(JSON.stringify(c)) : s ? t.send(s) : t.send(),
          a[e.id] = t
      }
      ).then(function(t) {
          return function(e, t) {
              return new n(e,{
                  body: t.response,
                  headers: s(t.getAllResponseHeaders()),
                  statusCode: t.status
              })
          }(e, t)
      })
  }
  function u(e, t) {
      var i = e.url(t)
        , n = new window.XMLHttpRequest;
      return n.open(e.method, i),
      Object.keys(e.headers).forEach(function(t) {
          n.setRequestHeader(t, e.headers[t])
      }),
      n
  }
  e.exports = {
      browserAbort: function(e) {
          var t = a[e.id];
          t && (t.abort(),
          delete a[e.id])
      },
      sendRequestXhr: c,
      browserSend: function(e) {
          return Promise.resolve().then(function() {
              var t = u(e, e.client.accessToken);
              return c(e, t)
          })
      },
      createRequestXhr: u
  }
}
, function(e, t, i) {
  "use strict";
  var n = i(188);
  function r(e, t) {
      this.request = e,
      this.headers = t.headers,
      this.rawBody = t.body,
      this.statusCode = t.statusCode;
      try {
          this.body = JSON.parse(t.body || "{}")
      } catch (e) {
          this.body = t.body
      }
      this.links = n(this.headers.link)
  }
  r.prototype.hasNextPage = function() {
      return !!this.links.next
  }
  ,
  r.prototype.nextPage = function() {
      return this.hasNextPage() ? this.request._extend({
          path: this.links.next.url
      }) : null
  }
  ,
  e.exports = r
}
, function(e, t, i) {
  "use strict";
  e.exports = function(e) {
      return e ? e.split(/,\s*</).reduce(function(e, t) {
          var i = function(e) {
              var t = e.match(/<?([^>]*)>(.*)/);
              if (!t)
                  return null;
              var i = t[1]
                , n = t[2].split(";")
                , r = null
                , o = n.reduce(function(e, t) {
                  var i = function(e) {
                      var t = e.match(/\s*(.+)\s*=\s*"?([^"]+)"?/);
                      return t ? {
                          key: t[1],
                          value: t[2]
                      } : null
                  }(t);
                  return i ? "rel" === i.key ? (r || (r = i.value),
                  e) : (e[i.key] = i.value,
                  e) : e
              }, {});
              return r ? {
                  url: i,
                  rel: r,
                  params: o
              } : null
          }(t);
          return i ? (i.rel.split(/\s+/).forEach(function(t) {
              e[t] || (e[t] = {
                  url: i.url,
                  params: i.params
              })
          }),
          e) : e
      }, {}) : {}
  }
}
, function(e, t, i) {
  "use strict";
  var n = i(49);
  e.exports = function(e) {
      var t, i = e.type || n.ERROR_HTTP;
      if (e.body)
          try {
              t = JSON.parse(e.body)
          } catch (i) {
              t = e.body
          }
      else
          t = null;
      var r = e.message || null;
      r || ("string" == typeof t ? r = t : t && "string" == typeof t.message ? r = t.message : i === n.ERROR_REQUEST_ABORTED && (r = "Request aborted")),
      this.message = r,
      this.type = i,
      this.statusCode = e.statusCode || null,
      this.request = e.request,
      this.body = t
  }
}
, function(e, t, i) {
  "use strict";
  e.exports = function(e) {
      var t = {};
      return e ? (e.trim().split(/[\r|\n]+/).forEach(function(e) {
          var i, n, r = (n = (i = e).indexOf(":"),
          {
              name: i.substring(0, n).trim().toLowerCase(),
              value: i.substring(n + 1).trim()
          });
          t[r.name] = r.value
      }),
      t) : t
  }
}
, function(e, t, i) {
  (function(e, n) {
      var r;
      /*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
      !function(o) {
          var s = t
            , a = (e && e.exports,
          "object" == typeof n && n);
          a.global !== a && a.window;
          var l = function(e) {
              this.message = e
          };
          (l.prototype = new Error).name = "InvalidCharacterError";
          var c = function(e) {
              throw new l(e)
          }
            , u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
            , h = /[\t\n\f\r ]/g
            , d = {
              encode: function(e) {
                  e = String(e),
                  /[^\0-\xFF]/.test(e) && c("The string to be encoded contains characters outside of the Latin1 range.");
                  for (var t, i, n, r, o = e.length % 3, s = "", a = -1, l = e.length - o; ++a < l; )
                      t = e.charCodeAt(a) << 16,
                      i = e.charCodeAt(++a) << 8,
                      n = e.charCodeAt(++a),
                      s += u.charAt((r = t + i + n) >> 18 & 63) + u.charAt(r >> 12 & 63) + u.charAt(r >> 6 & 63) + u.charAt(63 & r);
                  return 2 == o ? (t = e.charCodeAt(a) << 8,
                  i = e.charCodeAt(++a),
                  s += u.charAt((r = t + i) >> 10) + u.charAt(r >> 4 & 63) + u.charAt(r << 2 & 63) + "=") : 1 == o && (r = e.charCodeAt(a),
                  s += u.charAt(r >> 2) + u.charAt(r << 4 & 63) + "=="),
                  s
              },
              decode: function(e) {
                  var t = (e = String(e).replace(h, "")).length;
                  t % 4 == 0 && (t = (e = e.replace(/==?$/, "")).length),
                  (t % 4 == 1 || /[^+a-zA-Z0-9\/]/.test(e)) && c("Invalid character: the string to be decoded is not correctly encoded.");
                  for (var i, n, r = 0, o = "", s = -1; ++s < t; )
                      n = u.indexOf(e.charAt(s)),
                      i = r % 4 ? 64 * i + n : n,
                      r++ % 4 && (o += String.fromCharCode(255 & i >> (-2 * r & 6)));
                  return o
              },
              version: "0.1.0"
          };
          void 0 === (r = function() {
              return d
          }
          .call(t, i, t, e)) || (e.exports = r)
      }()
  }
  ).call(this, i(48)(e), i(21))
}
, function(e, t, i) {
  "use strict";
  var n = i(113)
    , r = i(50)
    , o = i(193)
    , s = i(194)
    , a = i(49)
    , l = 1;
  function c(e, t) {
      if (!e)
          throw new Error("MapiRequest requires a client");
      if (!t || !t.path || !t.method)
          throw new Error("MapiRequest requires an options object with path and method properties");
      var i = {};
      t.body && (i["content-type"] = "application/json");
      var n = r(i, t.headers)
        , s = Object.keys(n).reduce(function(e, t) {
          return e[t.toLowerCase()] = n[t],
          e
      }, {});
      this.id = l++,
      this._options = t,
      this.emitter = new o,
      this.client = e,
      this.response = null,
      this.error = null,
      this.sent = !1,
      this.aborted = !1,
      this.path = t.path,
      this.method = t.method,
      this.origin = t.origin || e.origin,
      this.query = t.query || {},
      this.params = t.params || {},
      this.body = t.body || null,
      this.file = t.file || null,
      this.headers = s
  }
  c.prototype.url = function(e) {
      var t = s.prependOrigin(this.path, this.origin);
      t = s.appendQueryObject(t, this.query);
      var i = this.params;
      if (e) {
          t = s.appendQueryParam(t, "access_token", e);
          var o = n(e).user;
          i = r({
              ownerId: o
          }, i)
      }
      return t = s.interpolateRouteParams(t, i),
      t
  }
  ,
  c.prototype.send = function() {
      var e = this;
      if (e.sent)
          throw new Error("This request has already been sent. Check the response and error properties. Create a new request with clone().");
      return e.sent = !0,
      e.client.sendRequest(e).then(function(t) {
          return e.response = t,
          e.emitter.emit(a.EVENT_RESPONSE, t),
          t
      }, function(t) {
          throw e.error = t,
          e.emitter.emit(a.EVENT_ERROR, t),
          t
      })
  }
  ,
  c.prototype.abort = function() {
      this._nextPageRequest && (this._nextPageRequest.abort(),
      delete this._nextPageRequest),
      this.response || this.error || this.aborted || (this.aborted = !0,
      this.client.abortRequest(this))
  }
  ,
  c.prototype.eachPage = function(e) {
      var t = this;
      function i(i) {
          e(null, i, function() {
              delete t._nextPageRequest;
              var e = i.nextPage();
              e && (t._nextPageRequest = e,
              r(e))
          })
      }
      function n(t) {
          e(t, null, function() {})
      }
      function r(e) {
          e.send().then(i, n)
      }
      r(this)
  }
  ,
  c.prototype.clone = function() {
      return this._extend()
  }
  ,
  c.prototype._extend = function(e) {
      var t = r(this._options, e);
      return new c(this.client,t)
  }
  ,
  e.exports = c
}
, function(e, t, i) {
  "use strict";
  var n = Object.prototype.hasOwnProperty
    , r = "~";
  function o() {}
  function s(e, t, i) {
      this.fn = e,
      this.context = t,
      this.once = i || !1
  }
  function a(e, t, i, n, o) {
      if ("function" != typeof i)
          throw new TypeError("The listener must be a function");
      var a = new s(i,n || e,o)
        , l = r ? r + t : t;
      return e._events[l] ? e._events[l].fn ? e._events[l] = [e._events[l], a] : e._events[l].push(a) : (e._events[l] = a,
      e._eventsCount++),
      e
  }
  function l(e, t) {
      0 == --e._eventsCount ? e._events = new o : delete e._events[t]
  }
  function c() {
      this._events = new o,
      this._eventsCount = 0
  }
  Object.create && (o.prototype = Object.create(null),
  (new o).__proto__ || (r = !1)),
  c.prototype.eventNames = function() {
      var e, t, i = [];
      if (0 === this._eventsCount)
          return i;
      for (t in e = this._events)
          n.call(e, t) && i.push(r ? t.slice(1) : t);
      return Object.getOwnPropertySymbols ? i.concat(Object.getOwnPropertySymbols(e)) : i
  }
  ,
  c.prototype.listeners = function(e) {
      var t = r ? r + e : e
        , i = this._events[t];
      if (!i)
          return [];
      if (i.fn)
          return [i.fn];
      for (var n = 0, o = i.length, s = new Array(o); n < o; n++)
          s[n] = i[n].fn;
      return s
  }
  ,
  c.prototype.listenerCount = function(e) {
      var t = r ? r + e : e
        , i = this._events[t];
      return i ? i.fn ? 1 : i.length : 0
  }
  ,
  c.prototype.emit = function(e, t, i, n, o, s) {
      var a = r ? r + e : e;
      if (!this._events[a])
          return !1;
      var l, c, u = this._events[a], h = arguments.length;
      if (u.fn) {
          switch (u.once && this.removeListener(e, u.fn, void 0, !0),
          h) {
          case 1:
              return u.fn.call(u.context),
              !0;
          case 2:
              return u.fn.call(u.context, t),
              !0;
          case 3:
              return u.fn.call(u.context, t, i),
              !0;
          case 4:
              return u.fn.call(u.context, t, i, n),
              !0;
          case 5:
              return u.fn.call(u.context, t, i, n, o),
              !0;
          case 6:
              return u.fn.call(u.context, t, i, n, o, s),
              !0
          }
          for (c = 1,
          l = new Array(h - 1); c < h; c++)
              l[c - 1] = arguments[c];
          u.fn.apply(u.context, l)
      } else {
          var d, p = u.length;
          for (c = 0; c < p; c++)
              switch (u[c].once && this.removeListener(e, u[c].fn, void 0, !0),
              h) {
              case 1:
                  u[c].fn.call(u[c].context);
                  break;
              case 2:
                  u[c].fn.call(u[c].context, t);
                  break;
              case 3:
                  u[c].fn.call(u[c].context, t, i);
                  break;
              case 4:
                  u[c].fn.call(u[c].context, t, i, n);
                  break;
              default:
                  if (!l)
                      for (d = 1,
                      l = new Array(h - 1); d < h; d++)
                          l[d - 1] = arguments[d];
                  u[c].fn.apply(u[c].context, l)
              }
      }
      return !0
  }
  ,
  c.prototype.on = function(e, t, i) {
      return a(this, e, t, i, !1)
  }
  ,
  c.prototype.once = function(e, t, i) {
      return a(this, e, t, i, !0)
  }
  ,
  c.prototype.removeListener = function(e, t, i, n) {
      var o = r ? r + e : e;
      if (!this._events[o])
          return this;
      if (!t)
          return l(this, o),
          this;
      var s = this._events[o];
      if (s.fn)
          s.fn !== t || n && !s.once || i && s.context !== i || l(this, o);
      else {
          for (var a = 0, c = [], u = s.length; a < u; a++)
              (s[a].fn !== t || n && !s[a].once || i && s[a].context !== i) && c.push(s[a]);
          c.length ? this._events[o] = 1 === c.length ? c[0] : c : l(this, o)
      }
      return this
  }
  ,
  c.prototype.removeAllListeners = function(e) {
      var t;
      return e ? (t = r ? r + e : e,
      this._events[t] && l(this, t)) : (this._events = new o,
      this._eventsCount = 0),
      this
  }
  ,
  c.prototype.off = c.prototype.removeListener,
  c.prototype.addListener = c.prototype.on,
  c.prefixed = r,
  c.EventEmitter = c,
  e.exports = c
}
, function(e, t, i) {
  "use strict";
  function n(e) {
      return Array.isArray(e) ? e.map(encodeURIComponent).join(",") : encodeURIComponent(String(e))
  }
  function r(e, t, i) {
      if (!1 === i || null === i)
          return e;
      var r = /\?/.test(e) ? "&" : "?"
        , o = encodeURIComponent(t);
      return void 0 !== i && "" !== i && !0 !== i && (o += "=" + n(i)),
      "" + e + r + o
  }
  e.exports = {
      appendQueryObject: function(e, t) {
          if (!t)
              return e;
          var i = e;
          return Object.keys(t).forEach(function(e) {
              var n = t[e];
              void 0 !== n && (Array.isArray(n) && (n = n.filter(function(e) {
                  return !!e
              }).join(",")),
              i = r(i, e, n))
          }),
          i
      },
      appendQueryParam: r,
      prependOrigin: function(e, t) {
          if (!t)
              return e;
          if ("http" === e.slice(0, 4))
              return e;
          var i = "/" === e[0] ? "" : "/";
          return "" + t.replace(/\/$/, "") + i + e
      },
      interpolateRouteParams: function(e, t) {
          return t ? e.replace(/\/:([a-zA-Z0-9]+)/g, function(e, i) {
              var r = t[i];
              if (void 0 === r)
                  throw new Error("Unspecified route parameter " + i);
              return "/" + n(r)
          }) : e
      }
  }
}
, function(e, t, i) {
  "use strict";
  var n = i(50)
    , r = i(196)
    , o = i(199)
    , s = i(200)
    , a = i(202)
    , l = {}
    , c = ["country", "region", "postcode", "district", "place", "locality", "neighborhood", "address", "poi", "poi.landmark"];
  l.forwardGeocode = function(e) {
      r.assertShape({
          query: r.required(r.string),
          mode: r.oneOf("mapbox.places", "mapbox.places-permanent"),
          countries: r.arrayOf(r.string),
          proximity: r.coordinates,
          types: r.arrayOf(r.oneOf(c)),
          autocomplete: r.boolean,
          bbox: r.arrayOf(r.number),
          limit: r.number,
          language: r.arrayOf(r.string)
      })(e),
      e.mode = e.mode || "mapbox.places";
      var t = s(n({
          country: e.countries
      }, o(e, ["proximity", "types", "autocomplete", "bbox", "limit", "language"])));
      return this.client.createRequest({
          method: "GET",
          path: "/geocoding/v5/:mode/:query.json",
          params: o(e, ["mode", "query"]),
          query: t
      })
  }
  ,
  l.reverseGeocode = function(e) {
      r.assertShape({
          query: r.required(r.coordinates),
          mode: r.oneOf("mapbox.places", "mapbox.places-permanent"),
          countries: r.arrayOf(r.string),
          types: r.arrayOf(r.oneOf(c)),
          bbox: r.arrayOf(r.number),
          limit: r.number,
          language: r.arrayOf(r.string),
          reverseMode: r.oneOf("distance", "score")
      })(e),
      e.mode = e.mode || "mapbox.places";
      var t = s(n({
          country: e.countries
      }, o(e, ["country", "types", "bbox", "limit", "language", "reverseMode"])));
      return this.client.createRequest({
          method: "GET",
          path: "/geocoding/v5/:mode/:query.json",
          params: o(e, ["mode", "query"]),
          query: t
      })
  }
  ,
  e.exports = a(l)
}
, function(e, t, i) {
  "use strict";
  (function(t) {
      var n = i(50)
        , r = i(197);
      e.exports = n(r, {
          file: function(e) {
              if ("undefined" != typeof window) {
                  if (e instanceof t.Blob || e instanceof t.ArrayBuffer)
                      return;
                  return "Blob or ArrayBuffer"
              }
              if ("string" != typeof e && void 0 === e.pipe)
                  return "Filename or Readable stream"
          },
          date: function(e) {
              if ("boolean" == typeof e)
                  return "date";
              try {
                  var t = new Date(e);
                  if (t.getTime && isNaN(t.getTime()))
                      return "date"
              } catch (e) {
                  return "date"
              }
          },
          coordinates: function(e) {
              return r.tuple(r.number, r.number)(e)
          },
          assertShape: function(e, t) {
              return r.assert(r.strictShape(e), t)
          }
      })
  }
  ).call(this, i(21))
}
, function(e, t, i) {
  "use strict";
  var n = i(198)
    , r = i(50)
    , o = "value"
    , s = {};
  function a(e) {
      var t = Array.isArray(e);
      return function(i) {
          var n, r = l(s.plainArray, i);
          if (r)
              return r;
          if (t && i.length !== e.length)
              return "an array with " + e.length + " items";
          for (var o = 0; o < i.length; o++)
              if (r = l((n = o,
              t ? e[n] : e), i[o]))
                  return [o].concat(r)
      }
  }
  function l(e, t) {
      if (null != t || e.hasOwnProperty("__required")) {
          var i = e(t);
          return i ? Array.isArray(i) ? i : [i] : void 0
      }
  }
  function c(e, t) {
      var i = e.length
        , n = e[i - 1]
        , s = e.slice(0, i - 1);
      return 0 === s.length && (s = [o]),
      t = r(t, {
          path: s
      }),
      "function" == typeof n ? n(t) : u(t, function(e) {
          return "must be " + function(e) {
              if (/^an? /.test(e))
                  return e;
              if (/^[aeiou]/i.test(e))
                  return "an " + e;
              if (/^[a-z]/i.test(e))
                  return "a " + e;
              return e
          }(e) + "."
      }(n))
  }
  function u(e, t) {
      return (h(e.path) ? "Item at position " : "") + (e.path.join(".") + " " + t)
  }
  function h(e) {
      return "number" == typeof e[e.length - 1] || "number" == typeof e[0]
  }
  s.assert = function(e, t) {
      return t = t || {},
      function(i) {
          var n = l(e, i);
          if (n) {
              var r = c(n, t);
              throw t.apiName && (r = t.apiName + ": " + r),
              new Error(r)
          }
      }
  }
  ,
  s.shape = function(e) {
      var t, i = (t = e,
      Object.keys(t || {}).map(function(e) {
          return {
              key: e,
              value: t[e]
          }
      }));
      return function(e) {
          var t, n = l(s.plainObject, e);
          if (n)
              return n;
          for (var r = [], a = 0; a < i.length; a++)
              t = i[a].key,
              (n = l(i[a].value, e[t])) && r.push([t].concat(n));
          return r.length < 2 ? r[0] : function(e) {
              r = r.map(function(t) {
                  return "- " + t[0] + ": " + c(t, e).split("\n").join("\n  ")
              });
              var t = e.path.join(".");
              return "The following properties" + (t === o ? "" : " of " + t) + " have invalid values:\n  " + r.join("\n  ")
          }
      }
  }
  ,
  s.strictShape = function(e) {
      var t = s.shape(e);
      return function(i) {
          var n = t(i);
          if (n)
              return n;
          var r = Object.keys(i).reduce(function(t, i) {
              return void 0 === e[i] && t.push(i),
              t
          }, []);
          return 0 !== r.length ? function() {
              return "The following keys are invalid: " + r.join(", ")
          }
          : void 0
      }
  }
  ,
  s.arrayOf = function(e) {
      return a(e)
  }
  ,
  s.tuple = function() {
      return a(Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments))
  }
  ,
  s.required = function(e) {
      function t(t) {
          return null == t ? function(e) {
              return u(e, h(e.path) ? "cannot be undefined/null." : "is required.")
          }
          : e.apply(this, arguments)
      }
      return t.__required = !0,
      t
  }
  ,
  s.oneOfType = function() {
      var e = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments);
      return function(t) {
          var i = e.map(function(e) {
              return l(e, t)
          }).filter(Boolean);
          if (i.length === e.length)
              return i.every(function(e) {
                  return 1 === e.length && "string" == typeof e[0]
              }) ? function(e) {
                  if (e.length < 2)
                      return e[0];
                  if (2 === e.length)
                      return e.join(" or ");
                  return e.slice(0, -1).join(", ") + ", or " + e.slice(-1)
              }(i.map(function(e) {
                  return e[0]
              })) : i.reduce(function(e, t) {
                  return t.length > e.length ? t : e
              })
      }
  }
  ,
  s.equal = function(e) {
      return function(t) {
          if (t !== e)
              return JSON.stringify(e)
      }
  }
  ,
  s.oneOf = function() {
      var e = (Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments)).map(function(e) {
          return s.equal(e)
      });
      return s.oneOfType.apply(this, e)
  }
  ,
  s.range = function(e) {
      var t = e[0]
        , i = e[1];
      return function(e) {
          if (l(s.number, e) || e < t || e > i)
              return "number between " + t + " & " + i + " (inclusive)"
      }
  }
  ,
  s.any = function() {}
  ,
  s.boolean = function(e) {
      if ("boolean" != typeof e)
          return "boolean"
  }
  ,
  s.number = function(e) {
      if ("number" != typeof e)
          return "number"
  }
  ,
  s.plainArray = function(e) {
      if (!Array.isArray(e))
          return "array"
  }
  ,
  s.plainObject = function(e) {
      if (!n(e))
          return "object"
  }
  ,
  s.string = function(e) {
      if ("string" != typeof e)
          return "string"
  }
  ,
  s.func = function(e) {
      if ("function" != typeof e)
          return "function"
  }
  ,
  s.validate = l,
  s.processMessage = c,
  e.exports = s
}
, function(e, t, i) {
  "use strict";
  var n = Object.prototype.toString;
  e.exports = function(e) {
      var t;
      return "[object Object]" === n.call(e) && (null === (t = Object.getPrototypeOf(e)) || t === Object.getPrototypeOf({}))
  }
}
, function(e, t, i) {
  "use strict";
  e.exports = function(e, t) {
      var i = function(e, i) {
          return -1 !== t.indexOf(e) && void 0 !== i
      };
      return "function" == typeof t && (i = t),
      Object.keys(e).filter(function(t) {
          return i(t, e[t])
      }).reduce(function(t, i) {
          return t[i] = e[i],
          t
      }, {})
  }
}
, function(e, t, i) {
  "use strict";
  var n = i(201);
  e.exports = function(e) {
      return n(e, function(e, t) {
          return "boolean" == typeof t ? JSON.stringify(t) : t
      })
  }
}
, function(e, t, i) {
  "use strict";
  e.exports = function(e, t) {
      return Object.keys(e).reduce(function(i, n) {
          return i[n] = t(n, e[n]),
          i
      }, {})
  }
}
, function(e, t, i) {
  "use strict";
  var n = i(112)
    , r = i(111);
  e.exports = function(e) {
      return function(t) {
          var i;
          i = n.prototype.isPrototypeOf(t) ? t : r(t);
          var o = Object.create(e);
          return o.client = i,
          o
      }
  }
}
, , , function(e, t, i) {
  "use strict";
  i.r(t);
  i(179),
  i(180);
  var n = i(114)
    , r = i.n(n);
  i(181);
  r.a.polyfill();
  i(182),
  i(184);
  var o = i(0);
  function s(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var a = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              container: t
          },
          this.defaults = {
              autoEnable: !0,
              scrollObjectSelector: "[data-skrollex]",
              scrollObjectChildSelector: "[data-skrollex-child]",
              classInit: "sk-init",
              classShowFirst: "sk-show-first",
              classShowStart: "sk-show-start",
              classShow: "sk-show",
              classShowComplete: "sk-show-complete",
              classHideStart: "sk-hide-start",
              classHide: "sk-hide",
              classInViewport: "sk-viewport-in",
              classOutViewport: "sk-viewport-out",
              attributeUniqueId: "data-skrollex-id",
              attributeGroup: "data-skrollex-group",
              attributeStagger: "data-skrollex-stagger",
              showGutterTop: "0px",
              showGutterBottom: "0%",
              observerThreshold: [.5],
              stagger: .1,
              maxStaggerElementOffset: 10,
              onElementInit: function() {},
              onElementShow: function() {},
              onElementHide: function() {},
              onElementViewportEnter: function() {},
              onElementViewportLeave: function() {}
          },
          this.options = this._merge(this.defaults, i),
          this.events = Object(o.a)(this),
          this.counters = {
              uid: 0
          },
          this.flags = {
              isEnabled: !1,
              isListening: !1
          },
          this.observers = {
              intersection: null
          },
          this.scrollObjects = {
              all: [],
              children: [],
              elements: [],
              groups: [],
              queue: [],
              lastTriggeredObserverEntry: null,
              lastTriggerTime: Date.now()
          },
          this.timing = {
              staggerDelay: 0
          },
          this.vendorPrefixes = {
              animationEnd: {
                  animation: "animationend",
                  MozAnimation: "animationend",
                  MSAnimation: "msAnimationEnd",
                  OAnimation: "oAnimationEnd",
                  WebkitAnimation: "webkitAnimationEnd"
              },
              transitionEnd: {
                  transition: "transitionend",
                  MozTransition: "transitionend",
                  MSTransition: "msTransitionEnd",
                  OTransition: "oTransitionEnd",
                  WebkitTransition: "webkitTransitionEnd"
              }
          },
          this.transitions = {
              animationEnd: this._getVendorPrefixedName("animationEnd"),
              transitionEnd: this._getVendorPrefixedName("transitionEnd")
          },
          this.options.autoEnable && this.enable()
      }
      var t, i, n;
      return t = e,
      n = [{
          key: "SHOW",
          get: function() {
              return "show"
          }
      }, {
          key: "HIDE",
          get: function() {
              return "hide"
          }
      }, {
          key: "VIEWPORT_ENTER",
          get: function() {
              return "viewportEnter"
          }
      }, {
          key: "VIEWPORT_LEAVE",
          get: function() {
              return "viewportLeave"
          }
      }],
      (i = [{
          key: "enable",
          value: function() {
              if (!this.flags.isEnabled) {
                  this.flags.isEnabled = !0,
                  this._addEventListeners();
                  ["complete", "loaded", "interactive"].indexOf(document.readyState) > -1 ? this.events._onDomReady() : document.addEventListener("DOMContentLoaded", this.events._onDomReady)
              }
          }
      }, {
          key: "disable",
          value: function() {
              this.flags.isEnabled && (this.flags.isEnabled = !1,
              this._removeEventListeners())
          }
      }, {
          key: "refresh",
          value: function() {
              this._destroyElements(),
              this._createElements()
          }
      }, {
          key: "add",
          value: function(e) {
              this._createElement(e)
          }
      }, {
          key: "_onDomReady",
          value: function() {
              this._createElements()
          }
      }, {
          key: "_onObserverUpdate",
          value: function(e) {
              var t = !0
                , i = !1
                , n = void 0;
              try {
                  for (var r, o = e[Symbol.iterator](); !(t = (r = o.next()).done); t = !0) {
                      var s = r.value;
                      this._updateElement(s)
                  }
              } catch (e) {
                  i = !0,
                  n = e
              } finally {
                  try {
                      t || null == o.return || o.return()
                  } finally {
                      if (i)
                          throw n
                  }
              }
          }
      }, {
          key: "_onUpdateScrollObjectQueue",
          value: function() {
              this.updateScrollObjectQueue()
          }
      }, {
          key: "_addEventListeners",
          value: function() {
              this.flags.isListening || (this.flags.isListening = !0,
              this.observers.intersection = new IntersectionObserver(this.events._onObserverUpdate,{
                  rootMargin: "".concat(this.options.showGutterTop, " 0px ").concat(this.options.showGutterBottom, " 0px"),
                  threshold: this.options.observerThreshold
              }))
          }
      }, {
          key: "_removeEventListeners",
          value: function() {
              this.flags.isListening && (this.flags.isListening = !1,
              this.observers.intersection.disconnect(),
              this.observers.intersection = null)
          }
      }, {
          key: "_createElements",
          value: function() {
              for (var e = document.querySelectorAll(this.options.scrollObjectSelector), t = 0; t < e.length; t++) {
                  var i = e[t];
                  this._createElement(i)
              }
          }
      }, {
          key: "_createElement",
          value: function(e) {
              if (-1 === this.scrollObjects.elements.indexOf(e)) {
                  var t = this._createElementConfig(e);
                  this.scrollObjects.elements.push(e),
                  this.scrollObjects.all.push(t),
                  this.observers.intersection.observe(e)
              }
          }
      }, {
          key: "_createElementConfig",
          value: function(e) {
              var t = this._getUid()
                , i = []
                , n = e.hasAttribute(this.options.attributeGroup)
                , r = e.hasAttribute(this.options.attributeGroup) ? parseFloat(e.getAttribute(this.options.attributeStagger)) : 0;
              if (isNaN(r) && (r = 0),
              e.setAttribute(this.options.attributeUniqueId, t),
              e.classList.add(this.options.classInit),
              n)
                  for (var o = e.querySelectorAll("*:not([".concat(this.options.attributeGroup, "]) ").concat(this.options.scrollObjectChildSelector)), s = 0; s < o.length; s++) {
                      var a = o[s];
                      i.push(this._createElementConfig(a))
                  }
              return {
                  el: e,
                  id: t,
                  isFirstShow: !0,
                  isInViewport: !1,
                  hideOffscreen: !1,
                  autoShowChildren: n,
                  children: i,
                  stagger: r
              }
          }
      }, {
          key: "_destroyElements",
          value: function() {
              var e = this.scrollObjects.all
                , t = !0
                , i = !1
                , n = void 0;
              try {
                  for (var r, o = e[Symbol.iterator](); !(t = (r = o.next()).done); t = !0) {
                      var s = r.value;
                      s.el.removeAttribute(this.options.attributeUniqueId),
                      this.observers.intersection.unobserve(s.el)
                  }
              } catch (e) {
                  i = !0,
                  n = e
              } finally {
                  try {
                      t || null == o.return || o.return()
                  } finally {
                      if (i)
                          throw n
                  }
              }
          }
      }, {
          key: "_updateElement",
          value: function(e) {
              var t = parseInt(e.target.getAttribute(this.options.attributeUniqueId), 10)
                , i = this._getScrollObjectReference(t);
              this._checkElementVisibility(e.target) && (e.intersectionRatio > 0 ? this._calculateShowDelay(e, i) : this._hideElement(i, e))
          }
      }, {
          key: "_calculateShowDelay",
          value: function(e, t) {
              var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0
                , n = Date.now()
                , r = (n - this.scrollObjects.lastTriggerTime) / 1e3;
              this.scrollObjects.lastTriggeredObserverEntry || (this.scrollObjects.lastTriggeredObserverEntry = e);
              var o = this._checkHorizontalOffset(e, this.scrollObjects.lastTriggeredObserverEntry);
              if (i ? this._queueScrollObject(t, i) : r < this.options.stagger && o < this.options.maxStaggerElementOffset ? (this.timing.staggerDelay += this.options.stagger,
              this._queueScrollObject(t, this.timing.staggerDelay + t.stagger)) : (this._showElement(t, e),
              this.timing.staggerDelay = t.stagger),
              t.autoShowChildren && t.children.length > 0)
                  for (var s = this.options.stagger, a = 0; a < t.children.length; a++) {
                      var l = t.children[a];
                      this._calculateShowDelay(e, l, s * (a + 1) + t.stagger)
                  }
              this.options.onElementViewportEnter(t.el),
              this.scrollObjects.lastTriggerTime = n,
              this.scrollObjects.lastTriggeredObserverEntry = e
          }
      }, {
          key: "_showElement",
          value: function(t) {
              var i = this;
              t.el.classList.remove(this.options.classOutViewport),
              t.el.classList.add(this.options.classInViewport),
              t.isInViewport || (t.isInViewport = !0,
              t.el.classList.remove(this.options.classHide),
              t.el.classList.add(this.options.classShowStart, this.options.classShowFirst),
              this._transition(t.el, function(e) {
                  e.classList.remove(i.options.classShowStart),
                  e.classList.add(i.options.classShow)
              }, function(e) {
                  e.classList.remove(i.options.classShow),
                  e.classList.add(i.options.classShowComplete)
              }),
              t.el.dispatchEvent(new Event(e.SHOW)),
              this.options.onElementShow(t.el, t))
          }
      }, {
          key: "_hideElement",
          value: function(t) {
              t.el.classList.add(this.options.classOutViewport),
              t.el.classList.remove(this.options.classInViewport, this.options.classShowFirst),
              t.isInViewport && (t.hideOffscreen && (t.isInViewport = !1,
              t.el.classList.remove(this.options.classShow),
              t.el.classList.add(this.options.classHide),
              t.el.dispatchEvent(new Event(e.HIDE)),
              this.options.onElementHide(t.el, t)),
              this.options.onElementViewportLeave(t.el, t))
          }
      }, {
          key: "updateScrollObjectQueue",
          value: function() {
              for (var e = Date.now(), t = 0; t < this.scrollObjects.queue.length; t++) {
                  var i = this.scrollObjects.queue[t];
                  (e - i.delayStart) / 1e3 >= i.delay && (this._showElement(i.scrollObj),
                  this.scrollObjects.queue.splice(t, 1))
              }
              this.scrollObjects.queue.length > 0 && S.a.one(this._onUpdateScrollObjectQueue, this)
          }
      }, {
          key: "_queueScrollObject",
          value: function(e, t) {
              this.scrollObjects.queue.push({
                  scrollObj: e,
                  delay: t,
                  delayStart: Date.now()
              }),
              e.el.setAttribute("data-stagger-time", t),
              this._onUpdateScrollObjectQueue()
          }
      }, {
          key: "destroy",
          value: function() {
              this._destroyElements(),
              this.disable()
          }
      }, {
          key: "_checkElementVisibility",
          value: function(e) {
              return null !== e.offsetParent
          }
      }, {
          key: "_checkHorizontalOffset",
          value: function(e, t) {
              return e.boundingClientRect.top - t.boundingClientRect.top
          }
      }, {
          key: "_getUid",
          value: function() {
              return ++this.counters.uid
          }
      }, {
          key: "_getScrollObjectReference",
          value: function(e) {
              for (var t = 0; t < this.scrollObjects.all.length; t++) {
                  var i = this.scrollObjects.all[t];
                  if (i.id === e)
                      return i
              }
          }
      }, {
          key: "_getVendorPrefixedName",
          value: function() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "animationEnd";
              for (var t in this.vendorPrefixes[e])
                  if (void 0 !== this.el.container.style[t])
                      return this.vendorPrefixes[e][t]
          }
      }, {
          key: "_transition",
          value: function(e, t, i) {
              var n, r, o = this, s = function(e, t) {
                  e.removeEventListener(o.transitions.animationEnd, t),
                  e.removeEventListener(o.transitions.transitionEnd, t)
              };
              t(e),
              r = function() {
                  s(e),
                  i(e)
              }
              ,
              s(n = e, i),
              n.addEventListener(o.transitions.animationEnd, r),
              n.addEventListener(o.transitions.transitionEnd, r)
          }
      }, {
          key: "_merge",
          value: function() {
              for (var e = {}, t = !1, i = 0, n = arguments.length, r = new Array(n), o = 0; o < n; o++)
                  r[o] = arguments[o];
              "[object Boolean]" === Object.prototype.toString.call(r[0]) && (t = r[0],
              i++);
              for (var s = function(i) {
                  for (var n in i)
                      Object.prototype.hasOwnProperty.call(i, n) && (t && "[object Object]" === Object.prototype.toString.call(i[n]) ? e[n] = extend(e[n], i[n]) : e[n] = i[n])
              }; i < r.length; i++)
                  s(r[i]);
              return e
          }
      }]) && s(t.prototype, i),
      n && s(t, n),
      e
  }();
  function l(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var c = new (function() {
      function e() {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              target: null
          },
          this.easing = {
              easeOutDynamic: [.175, .29, .405, 1],
              easeOutBounce: [.3, 1.605, .605, 1.005],
              easeInSlide: [.81, .005, .59, .98],
              easeInOutSlide: [.58, .305, .17, 1],
              easeInOutSoft: [.545, .015, .335, 1],
              easeOutSlide: [.395, 0, .135, 1],
              easeOutSoft: [.38, .41, .27, 1],
              easeOutZoom: [.395, .005, .19, 1],
              easeHover: [.235, 0, .05, .95],
              easeFade: [.265, .035, .205, .995]
          },
          this.flags = {
              isInitialized: !1
          },
          this.skrollex = null,
          this.events = Object(o.a)(this)
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function(e) {
              this.flags.isInitialized || (this.flags.isInitialized = !0,
              this.el.target = e,
              this.addEventListeners())
          }
      }, {
          key: "initSkrollex",
          value: function() {
              var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null) || this.el.target;
              this.skrollex = new a(e)
          }
      }, {
          key: "reset",
          value: function() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
              this.flags.isInitialized = !1,
              this.removeEventListeners(),
              this.init(e)
          }
      }, {
          key: "addEventListeners",
          value: function() {
              this.skrollex || this.el.target.querySelector("[data-skrollex-manual-init]") || this.initSkrollex()
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              this.skrollex && (this.skrollex.destroy(),
              this.skrollex = null)
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeAll(),
              this.removeEventListeners()
          }
      }]) && l(t.prototype, i),
      n && l(t, n),
      e
  }())
    , u = i(1);
  function h(e) {
      return function(e) {
          if (Array.isArray(e)) {
              for (var t = 0, i = new Array(e.length); t < e.length; t++)
                  i[t] = e[t];
              return i
          }
      }(e) || function(e) {
          if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))
              return Array.from(e)
      }(e) || function() {
          throw new TypeError("Invalid attempt to spread non-iterable instance")
      }()
  }
  function d(e, t) {
      if (!(e instanceof t))
          throw new TypeError("Cannot call a class as a function")
  }
  function p(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  function f(e, t, i) {
      return t && p(e.prototype, t),
      i && p(e, i),
      e
  }
  function m(e, t) {
      return function(e) {
          if (Array.isArray(e))
              return e
      }(e) || function(e, t) {
          var i = []
            , n = !0
            , r = !1
            , o = void 0;
          try {
              for (var s, a = e[Symbol.iterator](); !(n = (s = a.next()).done) && (i.push(s.value),
              !t || i.length !== t); n = !0)
                  ;
          } catch (e) {
              r = !0,
              o = e
          } finally {
              try {
                  n || null == a.return || a.return()
              } finally {
                  if (r)
                      throw o
              }
          }
          return i
      }(e, t) || function() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance")
      }()
  }
  var g = "data-blob";
  function v(e) {
      return new Promise(function(t) {
          new u.e("blob").get(e).then(function(e) {
              var i = new Image;
              i.onload = function() {
                  t({
                      node: i,
                      naturalWidth: i.naturalWidth,
                      naturalHeight: i.naturalHeight,
                      aspectRatio: i.naturalHeight / i.naturalWidth,
                      scale: 1,
                      width: 0,
                      height: 0,
                      left: 0,
                      top: 0
                  }),
                  window.URL.revokeObjectURL(i.src)
              }
              ,
              i.src = window.URL.createObjectURL(e.response)
          })
      }
      )
  }
  function y(e, t) {
      var i = m(e, 2)
        , n = i[0]
        , r = i[1]
        , o = n
        , s = o * t;
      return s < r && (o = (s = r) / t),
      {
          width: o,
          height: s,
          left: (n - o) / 2,
          top: (r - s) / 2
      }
  }
  function _(e, t, i, n, r, o) {
      var s = 2 * i
        , a = 2 * n
        , l = e - s + r
        , c = t - a + o
        , u = s - 2 * e
        , h = a - 2 * t
        , d = 4 * (l * l + c * c)
        , p = 4 * (l * u + c * h)
        , f = u * u + h * h
        , m = d;
      m += p,
      m += f,
      m = 2 * Math.sqrt(m);
      var g = Math.sqrt(d)
        , v = 2 * d * g
        , y = p / g;
      return d = 4 * f * d - p * p,
      (v * m + g * p * (m - (f = 2 * Math.sqrt(f))) + d * Math.log((2 * g + y + m) / (y + f))) / (4 * v)
  }
  var b = function() {
      function e(t, i, n) {
          d(this, e),
          this.blobCenter = t,
          this.radius = i,
          this.position = n * (Math.PI / 180),
          this.x = 0,
          this.y = 0,
          this.offRadius = i,
          this.speed = 2 * Math.random() + .5,
          this.cycle = 0
      }
      return f(e, [{
          key: "update",
          value: function(e) {
              var t = Math.cos(this.cycle * (Math.PI / 180)) * (this.radius / 750);
              this.offRadius -= t,
              this.offRadius > this.radius && (this.offRadius += 2 * t),
              this.offRadius < 0 && (this.offRadius = 0);
              var i = Math.cos(this.position) * this.offRadius
                , n = Math.sin(this.position) * this.offRadius
                , r = m(this.blobCenter, 2)
                , o = r[0]
                , s = r[1];
              this.x = i + o,
              this.y = n + s,
              this.cycle += e || this.speed,
              this.cycle >= 360 && (this.cycle -= 360)
          }
      }]),
      e
  }()
    , w = function() {
      function e(t) {
          var i = this;
          d(this, e),
          this.canvas = document.createElement("canvas"),
          this.context = this.canvas.getContext("2d"),
          this.fill = "#000000",
          this.width = 0,
          this.height = 0,
          this.radius = 0,
          this.center = [0, 0],
          this.scale = 0,
          this.points = [],
          this.image = null,
          t && v(t).then(function(e) {
              i.image = Object.assign(e, y([i.width, i.height], e.aspectRatio))
          })
      }
      return f(e, [{
          key: "resize",
          value: function(e) {
              var t = m(e, 2)
                , i = t[0]
                , n = t[1];
              this.width = i,
              this.height = n,
              this.radius = Math.round(Math.min(i, n) / 2 * .95),
              this.center = [i / 2, n / 2],
              this.canvas.width = i,
              this.canvas.height = n,
              this.context.fillStyle = this.fill,
              this.context.strokeStyle = this.fill,
              this.context.lineWidth = 2,
              this.alignPoints(),
              this.image && (this.image = Object.assign(this.image, y([this.width, this.height], this.image.aspectRatio)))
          }
      }, {
          key: "alignPoints",
          value: function() {
              this.points = [];
              for (var e = 0; e < 9; ++e)
                  this.points.push(new b(this.center,this.radius,40 * e))
          }
      }, {
          key: "update",
          value: function(e) {
              for (var t = 0, i = this.points.length; t < i; ++t)
                  this.points[t].update(e ? e[t].speed : null)
          }
      }, {
          key: "clear",
          value: function() {
              this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
          }
      }, {
          key: "render",
          value: function(e) {
              this.context.beginPath();
              var t = this.points.length - 1
                , i = (this.points[0].x + this.points[t].x) / 2
                , n = (this.points[0].y + this.points[t].y) / 2;
              this.context.moveTo(i, n);
              for (var r = 0, o = [i, n], s = 0; s < t; ++s) {
                  var a = (this.points[s].x + this.points[s + 1].x) / 2
                    , l = (this.points[s].y + this.points[s + 1].y) / 2;
                  this.context.quadraticCurveTo(this.points[s].x, this.points[s].y, a, l),
                  r += _(o[0], o[1], this.points[s].x, this.points[s].y, a, l),
                  o = [a, l]
              }
              if (this.context.quadraticCurveTo(this.points[t].x, this.points[t].y, i, n),
              r += _(o[0], o[1], this.points[t].x, this.points[t].y, i, n),
              this.context.closePath(),
              this.dashes) {
                  var c = r / this.dashes;
                  this.context.setLineDash([c, c]),
                  this.context.stroke()
              } else
                  this.context.fill();
              if (this.context.globalCompositeOperation = "source-in",
              this.image) {
                  var u = this.image.width * (2 - this.scale)
                    , h = this.image.height * (2 - this.scale)
                    , d = this.image.left + (this.image.width - u) / 2
                    , p = this.image.top + (this.image.height - h) / 2;
                  this.context.drawImage(this.image.node, d, p, u, h)
              } else if (e) {
                  var f = this.width * (2 - this.scale)
                    , m = this.height * (2 - this.scale)
                    , g = (this.width - f) / 2
                    , v = (this.height - m) / 2;
                  this.context.drawImage(e.node, e.left, e.top, e.width, e.height, g, v, f, m)
              }
              this.context.globalCompositeOperation = "source-over"
          }
      }]),
      e
  }()
    , x = function() {
      function e(t) {
          var i = this;
          d(this, e),
          this.el = {
              scene: t,
              blobs: t.querySelectorAll("[".concat(g, "]")),
              content: t.querySelector("figcaption")
          },
          this.states = {
              hasContent: null !== this.el.content
          },
          this.duration = 60,
          this.canvas = {},
          this.context = {},
          this.theme = t.getAttribute("".concat(g, "-scene")),
          this.backgroundSrc = t.getAttribute("".concat(g, "-scene-background")),
          this.backgroundOpacity = t.getAttribute("".concat(g, "-scene-background-opacity")),
          this.background = null,
          this.movingBackground = t.hasAttribute("".concat(g, "-moving-background")),
          this.contentLayers = ["foreground", "background"],
          this.contentIndex = !1,
          this.fillStyle = {},
          this.blobs = [],
          this.coords = {},
          this.bounds = {},
          this.mimic = {},
          this.createCanvas("composition"),
          this.createCanvas("image"),
          this.backgroundSrc && v(this.backgroundSrc).then(function(e) {
              i.background = Object.assign(e, y(i.bounds.scene, e.aspectRatio)),
              i.prerenderBackground()
          }),
          this.parseDOM(),
          this.measure(),
          this.resize()
      }
      return f(e, [{
          key: "createCanvas",
          value: function(e) {
              var t = document.createElement("canvas");
              this.canvas[e] = t,
              this.context[e] = t.getContext("2d")
          }
      }, {
          key: "resizeCanvas",
          value: function(e, t) {
              var i = m(t, 2)
                , n = i[0]
                , r = i[1];
              this.canvas[e].width = n,
              this.canvas[e].height = r
          }
      }, {
          key: "documentOffset",
          value: function(e) {
              var t = e.getBoundingClientRect();
              return [Math.round(t.left + window.scrollX), Math.round(t.top + window.scrollY)]
          }
      }, {
          key: "parseDOM",
          value: function() {
              var e = 0
                , t = !0
                , i = !1
                , n = void 0;
              try {
                  for (var r, o = this.el.blobs[Symbol.iterator](); !(t = (r = o.next()).done); t = !0) {
                      var s = r.value
                        , a = new w(s.getAttribute("".concat(g, "-image")));
                      a.id = s.getAttribute("".concat(g, "-id")),
                      a.mimic = s.getAttribute("".concat(g, "-mimic")),
                      a.opacity = s.getAttribute("".concat(g, "-opacity")),
                      a.fill = s.getAttribute("".concat(g, "-fill")),
                      a.delay = s.getAttribute("".concat(g, "-delay")),
                      a.dashes = s.getAttribute("".concat(g, "-dashes")),
                      a.inheritBackground = s.hasAttribute("".concat(g, "-inherit-background")),
                      a.frame = (a.delay ? 60 * parseFloat(a.delay) : 9 * e++) + this.duration + 9,
                      "tunnel" === this.theme && (a.scale = 1,
                      a.frame = 0),
                      this.blobs.push(a)
                  }
              } catch (e) {
                  i = !0,
                  n = e
              } finally {
                  try {
                      t || null == o.return || o.return()
                  } finally {
                      if (i)
                          throw n
                  }
              }
              if (this.states.hasContent) {
                  this.contentIndex = h(this.el.content.parentNode.children).indexOf(this.el.content) - 1;
                  var l = !0
                    , c = !1
                    , u = void 0;
                  try {
                      for (var d, p = this.contentLayers[Symbol.iterator](); !(l = (d = p.next()).done); l = !0) {
                          var f = d.value;
                          this.fillStyle[f] = this.el.content.getAttribute("".concat(g, "-").concat(f, "-fill")),
                          this.createCanvas(f)
                      }
                  } catch (e) {
                      c = !0,
                      u = e
                  } finally {
                      try {
                          l || null == p.return || p.return()
                      } finally {
                          if (c)
                              throw u
                      }
                  }
                  this.wrapText()
              }
          }
      }, {
          key: "measure",
          value: function() {
              if (this.bounds.scene = [Math.round(this.el.scene.clientWidth), Math.round(this.el.scene.clientHeight)],
              this.coords.scene = this.documentOffset(this.el.scene),
              this.states.hasContent) {
                  var e = this.el.content.getBoundingClientRect();
                  this.bounds.content = [Math.round(e.width), Math.round(e.height)],
                  this.coords.content = [Math.round(e.left - this.coords.scene[0] + window.scrollX), Math.round(e.top - this.coords.scene[1] + window.scrollY)]
              }
              this.bounds.blobs = [],
              this.coords.blobs = [];
              var t = !0
                , i = !1
                , n = void 0;
              try {
                  for (var r, o = this.el.blobs[Symbol.iterator](); !(t = (r = o.next()).done); t = !0) {
                      var s = r.value.getBoundingClientRect();
                      this.bounds.blobs.push([Math.round(s.width), Math.round(s.height)]),
                      this.coords.blobs.push([Math.round(s.left - this.coords.scene[0] + window.scrollX), Math.round(s.top - this.coords.scene[1] + window.scrollY)])
                  }
              } catch (e) {
                  i = !0,
                  n = e
              } finally {
                  try {
                      t || null == o.return || o.return()
                  } finally {
                      if (i)
                          throw n
                  }
              }
          }
      }, {
          key: "resize",
          value: function() {
              var e = m(this.bounds.scene, 2)
                , t = e[0]
                , i = e[1];
              this.canvas.composition.width = t,
              this.canvas.composition.height = i,
              this.canvas.image.width = t,
              this.canvas.image.height = i;
              for (var n = 0, r = this.blobs.length; n < r; ++n)
                  this.blobs[n].resize(this.bounds.blobs[n]);
              if (this.states.hasContent) {
                  var o = m(this.bounds.content, 2)
                    , s = o[0]
                    , a = o[1]
                    , l = !0
                    , c = !1
                    , u = void 0;
                  try {
                      for (var h, d = this.contentLayers[Symbol.iterator](); !(l = (h = d.next()).done); l = !0) {
                          var p = h.value;
                          this.canvas[p].width = s,
                          this.canvas[p].height = a,
                          this.context[p].textBaseline = "top",
                          this.context[p].fillStyle = this.fillStyle[p]
                      }
                  } catch (e) {
                      c = !0,
                      u = e
                  } finally {
                      try {
                          l || null == d.return || d.return()
                      } finally {
                          if (c)
                              throw u
                      }
                  }
                  this.prerenderText()
              }
              this.background && (this.background = Object.assign(this.background, y(this.bounds.scene, this.background.aspectRatio)),
              this.prerenderBackground())
          }
      }, {
          key: "wrapText",
          value: function() {
              this.states.textWrapped = !0;
              var e = this.el.content.childNodes
                , t = !0
                , i = !1
                , n = void 0;
              try {
                  for (var r, o = e[Symbol.iterator](); !(t = (r = o.next()).done); t = !0) {
                      var s = r.value;
                      if (1 === s.nodeType) {
                          var a = s.innerText.split("");
                          s.innerHTML = "";
                          var l = !0
                            , c = !1
                            , u = void 0;
                          try {
                              for (var h, d = a[Symbol.iterator](); !(l = (h = d.next()).done); l = !0) {
                                  var p = h.value;
                                  s.innerHTML += "<span>".concat(p, "</span>")
                              }
                          } catch (e) {
                              c = !0,
                              u = e
                          } finally {
                              try {
                                  l || null == d.return || d.return()
                              } finally {
                                  if (c)
                                      throw u
                              }
                          }
                      }
                  }
              } catch (e) {
                  i = !0,
                  n = e
              } finally {
                  try {
                      t || null == o.return || o.return()
                  } finally {
                      if (i)
                          throw n
                  }
              }
          }
      }, {
          key: "prerenderText",
          value: function() {
              var e = !0
                , t = !1
                , i = void 0;
              try {
                  for (var n, r = this.contentLayers[Symbol.iterator](); !(e = (n = r.next()).done); e = !0) {
                      var o = n.value;
                      this.context[o].clearRect(0, 0, this.canvas[o].width, this.canvas[o].height)
                  }
              } catch (e) {
                  t = !0,
                  i = e
              } finally {
                  try {
                      e || null == r.return || r.return()
                  } finally {
                      if (t)
                          throw i
                  }
              }
              var s = this.el.content.querySelectorAll("span")
                , a = !0
                , l = !1
                , c = void 0;
              try {
                  for (var u, h = s[Symbol.iterator](); !(a = (u = h.next()).done); a = !0) {
                      var d = u.value
                        , p = getComputedStyle(d)
                        , f = parseFloat(p.getPropertyValue("font-size"))
                        , m = !0
                        , g = !1
                        , v = void 0;
                      try {
                          for (var y, _ = this.contentLayers[Symbol.iterator](); !(m = (y = _.next()).done); m = !0) {
                              var b = y.value;
                              this.context[b].font = "".concat(p.getPropertyValue("font-style"), " normal ").concat(p.getPropertyValue("font-width"), " ").concat(f, "px ").concat(p.getPropertyValue("font-family")),
                              this.context[b].fillText(d.innerText, Math.round(d.offsetLeft), Math.round(d.offsetTop + .16 * f))
                          }
                      } catch (e) {
                          g = !0,
                          v = e
                      } finally {
                          try {
                              m || null == _.return || _.return()
                          } finally {
                              if (g)
                                  throw v
                          }
                      }
                  }
              } catch (e) {
                  l = !0,
                  c = e
              } finally {
                  try {
                      a || null == h.return || h.return()
                  } finally {
                      if (l)
                          throw c
                  }
              }
          }
      }, {
          key: "prerenderBackground",
          value: function() {
              this.context.image.drawImage(this.background.node, this.background.left, this.background.top, this.background.width, this.background.height)
          }
      }, {
          key: "update",
          value: function() {
              var e = !0
                , t = !1
                , i = void 0;
              try {
                  for (var n, r = this.blobs[Symbol.iterator](); !(e = (n = r.next()).done); e = !0) {
                      var s = n.value;
                      if (s.update(this.mimic[s.mimic]),
                      s.id && (this.mimic[s.id] = s.points),
                      s.frame > 0 && (--s.frame,
                      s.frame <= this.duration)) {
                          var a = o.e.easeOutBack(this.duration - s.frame, 0, 1, this.duration);
                          s.scale = a
                      }
                  }
              } catch (e) {
                  t = !0,
                  i = e
              } finally {
                  try {
                      e || null == r.return || r.return()
                  } finally {
                      if (t)
                          throw i
                  }
              }
          }
      }, {
          key: "clear",
          value: function() {
              this.context.composition.clearRect(0, 0, this.canvas.composition.width, this.canvas.composition.height);
              var e = !0
                , t = !1
                , i = void 0;
              try {
                  for (var n, r = this.blobs[Symbol.iterator](); !(e = (n = r.next()).done); e = !0) {
                      n.value.clear()
                  }
              } catch (e) {
                  t = !0,
                  i = e
              } finally {
                  try {
                      e || null == r.return || r.return()
                  } finally {
                      if (t)
                          throw i
                  }
              }
          }
      }, {
          key: "render",
          value: function() {
              this.context.composition.globalCompositeOperation = "source-over";
              for (var e = 0, t = this.blobs.length; e < t; ++e) {
                  var i = m(this.bounds.blobs[e], 2)
                    , n = i[0]
                    , r = i[1]
                    , o = m(this.coords.blobs[e], 2)
                    , s = o[0]
                    , a = o[1];
                  if (n && r) {
                      this.blobs[e].inheritBackground && this.background ? this.blobs[e].render({
                          node: this.canvas.image,
                          left: s,
                          top: a,
                          width: n,
                          height: r
                      }) : this.blobs[e].render(),
                      (this.blobs[e].opacity || 0 === this.blobs[e].opacity) && (this.context.composition.globalAlpha = this.blobs[e].opacity);
                      var l = this.blobs[e].width * this.blobs[e].scale
                        , c = this.blobs[e].height * this.blobs[e].scale;
                      this.context.composition.drawImage(this.blobs[e].canvas, s + (this.blobs[e].width - l) / 2, a + (this.blobs[e].height - c) / 2, l, c),
                      this.context.composition.globalAlpha = 1
                  }
                  this.states.hasContent && e === this.contentIndex ? (this.context.composition.globalCompositeOperation = "source-atop",
                  this.context.composition.drawImage(this.canvas.foreground, this.coords.content[0], this.coords.content[1]),
                  this.context.composition.globalCompositeOperation = "destination-over",
                  this.context.composition.drawImage(this.canvas.background, this.coords.content[0], this.coords.content[1])) : this.context.composition.globalCompositeOperation = "destination-over"
              }
              this.background && ((this.backgroundOpacity || 0 === this.backgroundOpacity) && (this.context.composition.globalAlpha = this.backgroundOpacity),
              this.context.composition.drawImage(this.canvas.image, 0, 0),
              this.context.composition.globalAlpha = 1)
          }
      }]),
      e
  }()
    , k = new (function() {
      function e() {
          d(this, e),
          this.scenes = [],
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      return f(e, [{
          key: "init",
          value: function(e) {
              this.scan(e),
              this.loop()
          }
      }, {
          key: "scan",
          value: function(e) {
              this.scenes = [];
              var t = e.querySelectorAll("[".concat(g, "-scene]"))
                , i = !0
                , n = !1
                , r = void 0;
              try {
                  for (var o, s = t[Symbol.iterator](); !(i = (o = s.next()).done); i = !0) {
                      var a = o.value
                        , l = new x(a);
                      this.scenes.push(l),
                      this.appendCanvas(a, l.canvas.composition)
                  }
              } catch (e) {
                  n = !0,
                  r = e
              } finally {
                  try {
                      i || null == s.return || s.return()
                  } finally {
                      if (n)
                          throw r
                  }
              }
          }
      }, {
          key: "appendCanvas",
          value: function(e, t) {
              t.style.width = "100%",
              t.style.height = "100%",
              t.style.position = "absolute",
              t.style.left = 0,
              t.style.top = 0,
              t.style.pointerEvents = "none",
              e.appendChild(t)
          }
      }, {
          key: "loop",
          value: function() {
              var e = this;
              this.frame = requestAnimationFrame(function() {
                  return e.loop()
              });
              var t = !0
                , i = !1
                , n = void 0;
              try {
                  for (var r, o = this.scenes[Symbol.iterator](); !(t = (r = o.next()).done); t = !0) {
                      var s = r.value;
                      window.scrollY + window.innerHeight > s.coords.scene[1] && window.scrollY < s.coords.scene[1] + s.bounds.scene[1] && (s.update(),
                      s.clear(),
                      s.render())
                  }
              } catch (e) {
                  i = !0,
                  n = e
              } finally {
                  try {
                      t || null == o.return || o.return()
                  } finally {
                      if (i)
                          throw n
                  }
              }
          }
      }, {
          key: "resize",
          value: function() {
              var e = !0
                , t = !1
                , i = void 0;
              try {
                  for (var n, r = this.scenes[Symbol.iterator](); !(e = (n = r.next()).done); e = !0) {
                      var o = n.value;
                      o.measure(),
                      o.resize()
                  }
              } catch (e) {
                  t = !0,
                  i = e
              } finally {
                  try {
                      e || null == r.return || r.return()
                  } finally {
                      if (t)
                          throw i
                  }
              }
          }
      }, {
          key: "getScene",
          value: function(e) {
              var t = !0
                , i = !1
                , n = void 0;
              try {
                  for (var r, o = this.scenes[Symbol.iterator](); !(t = (r = o.next()).done); t = !0) {
                      var s = r.value;
                      if (s.el.scene === e)
                          return s
                  }
              } catch (e) {
                  i = !0,
                  n = e
              } finally {
                  try {
                      t || null == o.return || o.return()
                  } finally {
                      if (i)
                          throw n
                  }
              }
          }
      }, {
          key: "_onWindowLoad",
          value: function() {
              this.resize()
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.resize()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("load", this.events._onWindowLoad),
              window.addEventListener("resize", this.events._onWindowResize)
          }
      }]),
      e
  }())
    , S = i(2)
    , E = i(115)
    , T = i.n(E)
    , C = i(116)
    , L = i.n(C)
    , A = i(117)
    , P = i.n(A)
    , I = i(118)
    , M = i.n(I);
  function O(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var z = new (function() {
      function e() {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              cursor: null,
              cursorContainer: null,
              defaultCursorButtons: null,
              nearestButton: null
          },
          this.coords = {
              mouseX: 0,
              mouseY: 0,
              cursorX: 0,
              cursorY: 0
          },
          this.flags = {
              isInitialized: !1,
              isShowing: !1,
              isTracking: !1
          },
          this.icons = {
              id: null,
              template: {
                  next: T.a,
                  prev: L.a,
                  shop: P.a,
                  zoom: M.a
              }
          },
          this.observers = {
              mutation: null
          },
          this.timeouts = {
              showCursor: null,
              hideCursor: null
          },
          this.events = Object(o.a)(this)
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function(e) {
              this.flags.isInitialized || (this.flags.isInitialized = !0,
              this.setCursorContainer(e),
              this.addEventListeners())
          }
      }, {
          key: "setCursorContainer",
          value: function(e) {
              e && (this.el.cursorContainer = e),
              this.el.cursor && this.el.cursor.remove(),
              this.el.cursor = this.el.cursor || document.createElement("div"),
              this.el.cursor.setAttribute("data-custom-cursor", !0),
              this.el.cursorContainer.appendChild(this.el.cursor)
          }
      }, {
          key: "change",
          value: function(e) {
              var t, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
              (this.el.cursorContainer.classList.add("is-custom-cursor"),
              e && e !== this.icons.id) ? (this.icons.id = e,
              i !== this.el.cursorContainer && this.setCursorContainer(i),
              "shop-icon" === this.icons.id ? t = this.icons.template.shop : "zoom-icon" === this.icons.id ? t = this.icons.template.zoom : "next-icon" === this.icons.id ? t = this.icons.template.next : "prev-icon" === this.icons.id && (t = this.icons.template.prev),
              this.el.cursor.innerHTML = t,
              clearTimeout(this.timeouts.hideCursor),
              this.showCursor(!0)) : this.showCursor(!1);
              this.startMouseTracking()
          }
      }, {
          key: "off",
          value: function() {
              clearTimeout(this.timeouts.showCursor),
              this.hideCursor(0, !1)
          }
      }, {
          key: "on",
          value: function() {
              this.startMouseTracking(),
              this.showCursor(!0)
          }
      }, {
          key: "showCursor",
          value: function() {
              var e = this
                , t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              this.flags.isShowing && !t || (this.flags.isShowing = !0,
              clearTimeout(this.timeouts.showCursor),
              clearTimeout(this.timeouts.hideCursor),
              this.timeouts.showCursor = setTimeout(function() {
                  e.icons.id && e.el.cursorContainer.classList.add("is-custom-cursor"),
                  e.el.cursor.classList.remove("is-off"),
                  e.el.cursor.classList.add("is-on")
              }, 200))
          }
      }, {
          key: "hideCursor",
          value: function() {
              var e = this
                , t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 100
                , i = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
              this.flags.isShowing && (this.flags.isShowing = !1,
              clearTimeout(this.timeouts.showCursor),
              clearTimeout(this.timeouts.hideCursor),
              this.timeouts.hideCursor = setTimeout(function() {
                  e.el.cursorContainer.classList.remove("is-custom-cursor"),
                  e.el.cursor.classList.remove("is-on"),
                  e.el.cursor.classList.add("is-off"),
                  i && e.removeCursor()
              }, t))
          }
      }, {
          key: "removeCursor",
          value: function() {
              this.el.cursorContainer.classList.remove("is-custom-cursor"),
              this.el.cursor.classList.remove("is-on"),
              this.el.cursor.classList.add("is-off"),
              clearTimeout(this.timeouts.showCursor),
              clearTimeout(this.timeouts.hideCursor),
              this.stopMouseTracking(),
              this.icons.id = ""
          }
      }, {
          key: "startMouseTracking",
          value: function() {
              this.flags.isTracking || (S.a.on(this.events._onTick),
              window.removeEventListener("mousemove", this.events._onMouseMove),
              window.addEventListener("mousemove", this.events._onMouseMove),
              this.flags.isTracking = !0)
          }
      }, {
          key: "stopMouseTracking",
          value: function() {
              this.flags.isTracking && (S.a.off(this.events._onTick),
              window.removeEventListener("mousemove", this.events._onMouseMove),
              this.flags.isTracking = !1)
          }
      }, {
          key: "_onTick",
          value: function() {
              this.coords.cursorX += (this.coords.mouseX - this.coords.cursorX) / 4,
              this.coords.cursorY += (this.coords.mouseY - this.coords.cursorY) / 4,
              this.el.cursor.style.transform = "translate(".concat(this.coords.cursorX, "px, ").concat(this.coords.cursorY, "px)")
          }
      }, {
          key: "_onMouseMove",
          value: function(e) {
              var t = parseInt(document.body.style.top || 0);
              this.coords.mouseX = e.pageX,
              this.coords.mouseY = e.pageY - t
          }
      }, {
          key: "addEventListeners",
          value: function() {
              this.observeMutations()
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              this.stopMouseTracking(),
              this.unobserveMutations()
          }
      }, {
          key: "observeMutations",
          value: function() {
              var e = this;
              if (!this.observers.mutation) {
                  var t = o.i.debounce(function() {
                      e.addCtaListeners()
                  }, 250, {
                      leading: !1,
                      trailing: !0
                  });
                  new MutationObserver(t).observe(document.body.querySelector("main"), {
                      attributes: !1,
                      childList: !0,
                      subtree: !0
                  })
              }
          }
      }, {
          key: "unobserveMutations",
          value: function() {
              this.observers.mutation && (this.observers.mutation.disconnect(),
              this.observers.mutation = null)
          }
      }, {
          key: "addCtaListeners",
          value: function() {
              this.removeCtaListeners(),
              this.el.defaultCursorButtons = document.body.querySelectorAll("[data-default-cursor]"),
              Object(o.k)(this.el.defaultCursorButtons, "mouseenter", this.events._onDefaultCursorButtonOver),
              Object(o.k)(this.el.defaultCursorButtons, "mouseleave", this.events._onDefaultCursorButtonLeave)
          }
      }, {
          key: "removeCtaListeners",
          value: function() {
              Object(o.m)(this.el.defaultCursorButtons, "mouseenter", this.events._onDefaultCursorButtonOver),
              Object(o.m)(this.el.defaultCursorButtons, "mouseleave", this.events._onDefaultCursorButtonLeave)
          }
      }, {
          key: "_onDefaultCursorButtonOver",
          value: function() {
              this.hideCursor(0, !1)
          }
      }, {
          key: "_onDefaultCursorButtonLeave",
          value: function() {
              this.showCursor(0)
          }
      }, {
          key: "reset",
          value: function(e) {
              this.removeCursor(),
              this.setCursorContainer(e)
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && O(t.prototype, i),
      n && O(t, n),
      e
  }());
  function D(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var R = new (function() {
      function e() {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.lines = [],
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function(e) {
              this.scan(e),
              this.appendMask(),
              this.resize(),
              this.renderDashArray()
          }
      }, {
          key: "scan",
          value: function(e) {
              this.lines = [];
              var t = e.querySelectorAll("[".concat("data-dotted-line", "]"))
                , i = !0
                , n = !1
                , r = void 0;
              try {
                  for (var o, s = t[Symbol.iterator](); !(i = (o = s.next()).done); i = !0) {
                      var a = o.value;
                      this.lines.push({
                          el: a,
                          path: a.querySelector("path"),
                          length: 0,
                          width: 0,
                          height: 0
                      })
                  }
              } catch (e) {
                  n = !0,
                  r = e
              } finally {
                  try {
                      i || null == s.return || s.return()
                  } finally {
                      if (n)
                          throw r
                  }
              }
          }
      }, {
          key: "appendMask",
          value: function() {
              var e = 0
                , t = !0
                , i = !1
                , n = void 0;
              try {
                  for (var r, o = this.lines[Symbol.iterator](); !(t = (r = o.next()).done); t = !0) {
                      var s = r.value
                        , a = "http://www.w3.org/2000/svg"
                        , l = "dotted-line-".concat(e++)
                        , c = document.createElementNS(a, "defs")
                        , u = document.createElementNS(a, "mask")
                        , h = document.createElementNS(a, "path");
                      h.setAttribute("d", s.path.getAttribute("d")),
                      u.appendChild(h),
                      u.setAttribute("id", l),
                      u.appendChild(h),
                      c.appendChild(u),
                      s.el.insertBefore(c, s.path),
                      s.path.setAttribute("mask", "url(#".concat(l, ")")),
                      s.mask = h
                  }
              } catch (e) {
                  i = !0,
                  n = e
              } finally {
                  try {
                      t || null == o.return || o.return()
                  } finally {
                      if (i)
                          throw n
                  }
              }
          }
      }, {
          key: "resize",
          value: function() {
              var e = !0
                , t = !1
                , i = void 0;
              try {
                  for (var n, r = this.lines[Symbol.iterator](); !(e = (n = r.next()).done); e = !0) {
                      var o = n.value;
                      o.length = o.mask.getTotalLength(),
                      o.width = o.el.clientWidth,
                      o.height = o.el.clientHeight
                  }
              } catch (e) {
                  t = !0,
                  i = e
              } finally {
                  try {
                      e || null == r.return || r.return()
                  } finally {
                      if (t)
                          throw i
                  }
              }
          }
      }, {
          key: "renderDashArray",
          value: function() {
              var e = !0
                , t = !1
                , i = void 0;
              try {
                  for (var n, r = this.lines[Symbol.iterator](); !(e = (n = r.next()).done); e = !0) {
                      var o = n.value;
                      o.mask.style.strokeDasharray = o.length,
                      o.mask.style.strokeDashoffset = o.length
                  }
              } catch (e) {
                  t = !0,
                  i = e
              } finally {
                  try {
                      e || null == r.return || r.return()
                  } finally {
                      if (t)
                          throw i
                  }
              }
          }
      }, {
          key: "_onWindowLoad",
          value: function() {
              this.resize(),
              this.renderDashArray()
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.resize(),
              this.renderDashArray()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("load", this.events._onWindowLoad),
              window.addEventListener("resize", this.events._onWindowResize)
          }
      }]) && D(t.prototype, i),
      n && D(t, n),
      e
  }());
  function B(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var j = new (function() {
      function e() {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              target: null
          },
          this.coords = {
              mouse: {
                  clientX: 0,
                  clientY: 0,
                  pageX: 0,
                  pageY: 0
              },
              window: {
                  width: 0,
                  height: 0,
                  scrollTop: 0,
                  scrollLeft: 0
              }
          },
          this.counters = {
              instances: 0
          },
          this.flags = {
              isInitialized: !1
          },
          this.events = Object(o.a)(this)
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function(e) {
              this.flags.isInitialized || (this.el.target = e,
              this.addEventListeners())
          }
      }, {
          key: "reset",
          value: function() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
              this.counters.instances = 0,
              e && (this.flags.isInitialized = !1,
              this.removeEventListeners(),
              this.init(e))
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("resize", this.events._onResize),
              window.addEventListener("scroll", this.events._onScroll, {
                  passive: !0
              }),
              window.addEventListener("mousemove", this.events._onMouseMove),
              this.checkResize()
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("resize", this.events._onResize),
              window.removeEventListener("scroll", this.events._onScroll),
              window.removeEventListener("mousemove", this.events._onMouseMove)
          }
      }, {
          key: "_onResize",
          value: function() {
              this.checkResize()
          }
      }, {
          key: "_onScroll",
          value: function() {
              this.checkScroll()
          }
      }, {
          key: "_onMouseMove",
          value: function(e) {
              this.checkMouseMove(e)
          }
      }, {
          key: "checkResize",
          value: function() {
              Object.assign(this.coords.window, {
                  width: window.top ? Math.min(window.innerWidth, window.top.innerWidth) : window.innerWidth,
                  height: window.top ? Math.min(window.innerHeight, window.top.innerHeight) : window.innerHeight
              }),
              this.checkScroll()
          }
      }, {
          key: "checkScroll",
          value: function() {
              Object.assign(this.coords.window, {
                  scrollTop: window.scrollY,
                  scrollLeft: window.scrollX
              })
          }
      }, {
          key: "checkMouseMove",
          value: function(e) {
              Object.assign(this.coords.mouse, {
                  clientX: e.clientX,
                  clientY: e.clientY,
                  pageX: e.pageX,
                  pageY: e.pageY
              })
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && B(t.prototype, i),
      n && B(t, n),
      e
  }());
  i(119);
  function F(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var N = "field-search"
    , U = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              input: t.querySelector(".".concat(N, "__input")),
              text: t.querySelector(".".concat(N, "__visible-text"))
          },
          this.defaults = {},
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(o.a)(this),
          this.flags = {
              isControlled: this.el.section.closest("[data-search-wrapper]")
          },
          this.states = {
              suggestion: ""
          },
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.addEventListeners()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              this.el.input.addEventListener("input", this.events._onInput),
              this.el.input.addEventListener("keyup", this.events._onKeyUp),
              this.el.section.addEventListener("suggestion", this.events._onSuggestion)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              this.el.input.removeEventListener("input", this.events._onInput),
              this.el.input.removeEventListener("keyup", this.events._onKeyUp),
              this.el.section.removeEventListener("suggestion", this.events._onSuggestion)
          }
      }, {
          key: "_onInput",
          value: function() {
              var e = this.el.input.value;
              e || (this.states.suggestion = ""),
              this.updateText(e)
          }
      }, {
          key: "_onKeyUp",
          value: function(e) {
              13 === e.keyCode && this.el.input.dispatchEvent(new Event("submit"))
          }
      }, {
          key: "_onSuggestion",
          value: function(e) {
              e.detail && "default" !== e.detail ? this.states.suggestion = e.detail : this.states.suggestion = "",
              this.updateText(this.el.input.value)
          }
      }, {
          key: "updateText",
          value: function(e) {
              if (e) {
                  var t = e.toLowerCase()
                    , i = this.states.suggestion.split(t)
                    , n = t;
                  n = i.length >= 2 ? '<span class="suggestion">'.concat(i[0], "</span>").concat(t, '<span class="suggestion">').concat(i[1], "</span>") : 0 === this.states.suggestion.indexOf(t) ? '<span class="suggestion">'.concat(i[0], "</span>").concat(t) : "".concat(t, '<span class="suggestion">').concat(i[0], "</span>"),
                  this.el.text.innerHTML = n
              } else {
                  var r = o.i.capitalize(this.el.text.getAttribute("data-placeholder"));
                  this.el.text.innerHTML = '<span class="placeholder">'.concat(r, "</span>")
              }
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && F(t.prototype, i),
      n && F(t, n),
      e
  }()
    , q = i(16);
  function H(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var V = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              target: t,
              video: null,
              counters: t.querySelectorAll("[data-skrollex-video-counter]")
          },
          this.defaults = {},
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(o.a)(this),
          this.counters = {
              videoTime: 0
          },
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              "video" === this.el.target.nodeName.toLowerCase() ? this.el.video = this.el.target : this.el.video = this.el.target.querySelector("video"),
              this.el.video && (c.skrollex.add(this.el.target),
              this.addEventListeners())
          }
      }, {
          key: "addEventListeners",
          value: function() {
              this.el.target.addEventListener(a.SHOW, this.events._onSkrollexShow),
              this.el.target.addEventListener(a.HIDE, this.events._onSkrollexHide),
              this.el.video && this.el.counters && S.a.on(this.events._onTick)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              this.el.target.removeEventListener(a.SHOW, this.events._onSkrollexShow),
              this.el.target.removeEventListener(a.HIDE, this.events._onSkrollexHide)
          }
      }, {
          key: "_onSkrollexShow",
          value: function() {
              this.el.video.play()
          }
      }, {
          key: "_onSkrollexHide",
          value: function() {
              this.el.video.pause()
          }
      }, {
          key: "_onTick",
          value: function() {
              this.updateVideoTime()
          }
      }, {
          key: "updateVideoTime",
          value: function() {
              var e = Math.floor(this.el.video.currentTime);
              if (e !== this.counters.videoTime) {
                  var t = String(e);
                  t = t.length < 2 ? "0".concat(t) : t,
                  t = ":".concat(t),
                  this.counters.videoTime = e;
                  for (var i = 0; i < this.el.counters.length; i++)
                      this.el.counters[i].innerHTML = t
              }
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && H(t.prototype, i),
      n && H(t, n),
      e
  }();
  function W(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var $ = function() {
      function e(t) {
          if (function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners(),
          !Object(o.j)("large")) {
              var i = this.el.section.querySelector("video");
              i && i.play()
          }
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              Object(o.j)("large") && this.el.section.hasAttribute("data-card-has-blurb") && (this.el.section.addEventListener("mouseenter", this.events._onCardHover),
              this.el.section.addEventListener("mouseleave", this.events._onCardLeave))
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              this.el.section.removeEventListener("mouseenter", this.events._onCardHover),
              this.el.section.removeEventListener("mouseleave", this.events._onCardLeave)
          }
      }, {
          key: "_onCardHover",
          value: function(e) {
              var t = e.currentTarget
                , i = t.querySelector(".card__blurb-wrapper")
                , n = i.children[0];
              i.hasAttribute("data-blurb-offset-bottom") ? Object.assign(i.style, {
                  height: "".concat(n.offsetHeight, "px"),
                  bottom: "-".concat(n.offsetHeight + 10, "px"),
                  opacity: 1
              }) : Object.assign(i.style, {
                  height: "".concat(n.offsetHeight, "px"),
                  opacity: 1
              });
              var r = t.querySelector("video");
              Object(o.j)("large") && r && r.play()
          }
      }, {
          key: "_onCardLeave",
          value: function(e) {
              var t = e.currentTarget
                , i = t.querySelector(".card__blurb-wrapper");
              Object.assign(i.style, {
                  height: "",
                  opacity: ""
              });
              var n = t.querySelector("video");
              Object(o.j)("large") && n && n.pause()
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && W(t.prototype, i),
      n && W(t, n),
      e
  }()
    , G = i(7)
    , X = i.n(G);
  function Z(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(120);
  var Y = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.setStickyHeaders(),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              window.matchMedia("(min-width: 992px)").addListener(this.events._onBreakpointResize)
          }
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "_onBreakpointResize",
          value: function() {
              this.setStickyHeaders()
          }
      }, {
          key: "_onResize",
          value: function() {}
      }, {
          key: "setStickyHeaders",
          value: function() {
              var e = X()(".".concat("accordion-pdp", "__collapse"));
              Object(o.j)("large") ? Object(o.j)("large") && e.each(function() {
                  X()(this).addClass("show"),
                  X()(this).prev().removeClass("is-sticky")
              }) : e.each(function() {
                  var e = this;
                  X()(this).removeClass("show"),
                  X()(this).on("show.bs.collapse", function() {
                      X()(e).prev().addClass("is-sticky")
                  }),
                  X()(this).on("hidden.bs.collapse", function() {
                      X()(e).prev().removeClass("is-sticky")
                  })
              })
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Z(t.prototype, i),
      n && Z(t, n),
      e
  }();
  function K(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(121);
  var J = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && K(t.prototype, i),
      n && K(t, n),
      e
  }();
  function Q(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var ee = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              destination: null
          },
          this.defaults = {},
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              var e = this.el.section.getAttribute("data-".concat("anchor-link"));
              this.el.destination = document.body.querySelector("[data-".concat("anchor-link", '-destination="').concat(e, '"]')),
              this.el.destination && this.addEventListeners()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              this.el.section.addEventListener("click", this.events._onClick)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              this.el.section.removeEventListener("click", this.events._onClick)
          }
      }, {
          key: "_onClick",
          value: function() {
              var e = parseFloat(this.el.section.getAttribute("data-".concat("anchor-link", "-offset")));
              e = isNaN(e) ? 0 : e,
              window.scrollTo({
                  top: Object(o.g)(this.el.destination).scrollTop - e,
                  behavior: "smooth"
              })
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Q(t.prototype, i),
      n && Q(t, n),
      e
  }();
  function te(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(122);
  var ie = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && te(t.prototype, i),
      n && te(t, n),
      e
  }();
  i(123),
  i(110);
  function ne(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var re = "drawer-bottom"
    , oe = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              drawerBar: t.querySelector(".".concat(re, "__bar")),
              drawerForm: t.querySelector(".".concat(re, "__form")),
              drawerClose: t.querySelector(".".concat(re, "__close")),
              drawerSubmit: t.querySelector(".".concat(re, "__submit")),
              footerLink: document.querySelector("[data-email-capture-trigger]")
          },
          this.flags = {
              isDrawerCollapsed: !0,
              isUserClosed: !1
          },
          this.timeouts = {
              collapse: null
          },
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.addEventListeners()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              this.el.footerLink && this.el.footerLink.addEventListener("click", this.events._onTriggerClick),
              this.el.drawerClose.addEventListener("click", this.events._onCloseClick),
              this.el.drawerClose.addEventListener("touchstart", this.events._onCloseClick),
              this.el.drawerSubmit.addEventListener("click", this.events._onSubmitClick)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              this.el.footerLink && this.el.footerLink.addEventListener("click", this.events._onTriggerClick),
              this.el.drawerClose.removeEventListener("click", this.events._onCloseClick),
              this.el.drawerSubmit.removeEventListener("click", this.events._onSubmitClick)
          }
      }, {
          key: "_onTriggerClick",
          value: function() {
              this.flags.isDrawerCollapsed && this.triggerForm()
          }
      }, {
          key: "_onSubmitClick",
          value: function() {
              this.showSuccess()
          }
      }, {
          key: "_onCloseClick",
          value: function() {
              this.hideDrawer(!0)
          }
      }, {
          key: "hideDrawer",
          value: function() {
              var e = this
                , t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              this.flags.isDrawerCollapsed && !t || (this.flags.isUserClosed = t,
              this.flags.isDrawerCollapsed = !0,
              this.el.drawerBar.classList.remove("is-shown"),
              clearTimeout(this.timeouts.collapse),
              this.timeouts.collapse = setTimeout(function() {
                  e.el.drawerBar.classList.add("is-hidden")
              }, 500))
          }
      }, {
          key: "showForm",
          value: function() {
              this.flags.isDrawerCollapsed && !this.flags.isUserClosed ? this.triggerForm() : this.hideDrawer()
          }
      }, {
          key: "triggerForm",
          value: function() {
              var e = this;
              this.flags.isDrawerCollapsed = !1,
              this.el.drawerBar.classList.remove("is-hidden"),
              clearTimeout(this.timeouts.collapse),
              S.a.one(function() {
                  e.el.drawerBar.classList.add("is-shown")
              })
          }
      }, {
          key: "showSuccess",
          value: function() {
              this.el.drawerForm.innerHTML = templateForm
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && ne(t.prototype, i),
      n && ne(t, n),
      e
  }();
  function se(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(124);
  var ae = "drawer-top"
    , le = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              drawerMessage: t.querySelector(".".concat(ae, "__message")),
              drawerBody: t.querySelector(".".concat(ae, "__body")),
              drawerClose: t.querySelector(".".concat(ae, "__close")),
              drawerSearch: t.querySelector(".".concat(ae, " .navigation-primary__expanded-bar-search-cta"))
          },
          this.flags = {
              isDrawerCollapsed: !0
          },
          this.timeouts = {
              collapse: null
          },
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.addEventListeners()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              this.el.drawerMessage.addEventListener("click", this.events._onMessageClick),
              this.el.drawerClose.addEventListener("click", this.events._onCloseClick)
          }
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "_onMessageClick",
          value: function() {
              this.toggleDrawerBody()
          }
      }, {
          key: "_onCloseClick",
          value: function() {
              this.collapseDrawerBody()
          }
      }, {
          key: "toggleDrawerBody",
          value: function() {
              this.timeouts.toggle || (this.flags.isDrawerCollapsed ? this.expandDrawerBody() : this.collapseDrawerBody())
          }
      }, {
          key: "collapseDrawerBody",
          value: function() {
              var e = this;
              this.flags.isDrawerCollapsed || (this.flags.isDrawerCollapsed = !0,
              this.el.drawerMessage.classList.remove("is-hidden"),
              this.el.section.classList.remove("is-expanded"),
              this.el.section.classList.add("is-collapsed", "is-animating"),
              clearTimeout(this.timeouts.toggle),
              this.timeouts.toggle = setTimeout(function() {
                  e.timeouts.toggle = null,
                  e.el.section.classList.remove("is-animating")
              }, 600))
          }
      }, {
          key: "expandDrawerBody",
          value: function() {
              var e = this;
              this.flags.isDrawerCollapsed && (this.flags.isDrawerCollapsed = !1,
              this.el.drawerMessage.classList.add("is-hidden"),
              this.el.section.classList.remove("is-collapsed"),
              this.el.section.classList.add("is-animating"),
              S.a.one(function() {
                  e.el.section.classList.add("is-expanded")
              }),
              clearTimeout(this.timeouts.toggle),
              this.timeouts.toggle = setTimeout(function() {
                  e.timeouts.toggle = null,
                  e.el.section.classList.remove("is-animating")
              }, 600))
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && se(t.prototype, i),
      n && se(t, n),
      e
  }()
    , ce = "undefined" == typeof document ? {
      body: {},
      addEventListener: function() {},
      removeEventListener: function() {},
      activeElement: {
          blur: function() {},
          nodeName: ""
      },
      querySelector: function() {
          return null
      },
      querySelectorAll: function() {
          return []
      },
      getElementById: function() {
          return null
      },
      createEvent: function() {
          return {
              initEvent: function() {}
          }
      },
      createElement: function() {
          return {
              children: [],
              childNodes: [],
              style: {},
              setAttribute: function() {},
              getElementsByTagName: function() {
                  return []
              }
          }
      },
      location: {
          hash: ""
      }
  } : document
    , ue = "undefined" == typeof window ? {
      document: ce,
      navigator: {
          userAgent: ""
      },
      location: {},
      history: {},
      CustomEvent: function() {
          return this
      },
      addEventListener: function() {},
      removeEventListener: function() {},
      getComputedStyle: function() {
          return {
              getPropertyValue: function() {
                  return ""
              }
          }
      },
      Image: function() {},
      Date: function() {},
      screen: {},
      setTimeout: function() {},
      clearTimeout: function() {}
  } : window;
  class he {
      constructor(e) {
          const t = this;
          for (let i = 0; i < e.length; i += 1)
              t[i] = e[i];
          return t.length = e.length,
          this
      }
  }
  function de(e, t) {
      const i = [];
      let n = 0;
      if (e && !t && e instanceof he)
          return e;
      if (e)
          if ("string" == typeof e) {
              let r, o;
              const s = e.trim();
              if (s.indexOf("<") >= 0 && s.indexOf(">") >= 0) {
                  let e = "div";
                  for (0 === s.indexOf("<li") && (e = "ul"),
                  0 === s.indexOf("<tr") && (e = "tbody"),
                  0 !== s.indexOf("<td") && 0 !== s.indexOf("<th") || (e = "tr"),
                  0 === s.indexOf("<tbody") && (e = "table"),
                  0 === s.indexOf("<option") && (e = "select"),
                  (o = ce.createElement(e)).innerHTML = s,
                  n = 0; n < o.childNodes.length; n += 1)
                      i.push(o.childNodes[n])
              } else
                  for (r = t || "#" !== e[0] || e.match(/[ .<>:~]/) ? (t || ce).querySelectorAll(e.trim()) : [ce.getElementById(e.trim().split("#")[1])],
                  n = 0; n < r.length; n += 1)
                      r[n] && i.push(r[n])
          } else if (e.nodeType || e === ue || e === ce)
              i.push(e);
          else if (e.length > 0 && e[0].nodeType)
              for (n = 0; n < e.length; n += 1)
                  i.push(e[n]);
      return new he(i)
  }
  function pe(e) {
      const t = [];
      for (let i = 0; i < e.length; i += 1)
          -1 === t.indexOf(e[i]) && t.push(e[i]);
      return t
  }
  de.fn = he.prototype,
  de.Class = he,
  de.Dom7 = he;
  "resize scroll".split(" ");
  const fe = {
      addClass: function(e) {
          if (void 0 === e)
              return this;
          const t = e.split(" ");
          for (let e = 0; e < t.length; e += 1)
              for (let i = 0; i < this.length; i += 1)
                  void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.add(t[e]);
          return this
      },
      removeClass: function(e) {
          const t = e.split(" ");
          for (let e = 0; e < t.length; e += 1)
              for (let i = 0; i < this.length; i += 1)
                  void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.remove(t[e]);
          return this
      },
      hasClass: function(e) {
          return !!this[0] && this[0].classList.contains(e)
      },
      toggleClass: function(e) {
          const t = e.split(" ");
          for (let e = 0; e < t.length; e += 1)
              for (let i = 0; i < this.length; i += 1)
                  void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.toggle(t[e]);
          return this
      },
      attr: function(e, t) {
          if (1 === arguments.length && "string" == typeof e)
              return this[0] ? this[0].getAttribute(e) : void 0;
          for (let i = 0; i < this.length; i += 1)
              if (2 === arguments.length)
                  this[i].setAttribute(e, t);
              else
                  for (const t in e)
                      this[i][t] = e[t],
                      this[i].setAttribute(t, e[t]);
          return this
      },
      removeAttr: function(e) {
          for (let t = 0; t < this.length; t += 1)
              this[t].removeAttribute(e);
          return this
      },
      data: function(e, t) {
          let i;
          if (void 0 !== t) {
              for (let n = 0; n < this.length; n += 1)
                  (i = this[n]).dom7ElementDataStorage || (i.dom7ElementDataStorage = {}),
                  i.dom7ElementDataStorage[e] = t;
              return this
          }
          if (i = this[0]) {
              if (i.dom7ElementDataStorage && e in i.dom7ElementDataStorage)
                  return i.dom7ElementDataStorage[e];
              const t = i.getAttribute(`data-${e}`);
              return t || void 0
          }
      },
      transform: function(e) {
          for (let t = 0; t < this.length; t += 1) {
              const i = this[t].style;
              i.webkitTransform = e,
              i.transform = e
          }
          return this
      },
      transition: function(e) {
          "string" != typeof e && (e = `${e}ms`);
          for (let t = 0; t < this.length; t += 1) {
              const i = this[t].style;
              i.webkitTransitionDuration = e,
              i.transitionDuration = e
          }
          return this
      },
      on: function(...e) {
          let[t,i,n,r] = e;
          function o(e) {
              const t = e.target;
              if (!t)
                  return;
              const r = e.target.dom7EventData || [];
              if (r.indexOf(e) < 0 && r.unshift(e),
              de(t).is(i))
                  n.apply(t, r);
              else {
                  const e = de(t).parents();
                  for (let t = 0; t < e.length; t += 1)
                      de(e[t]).is(i) && n.apply(e[t], r)
              }
          }
          function s(e) {
              const t = e && e.target && e.target.dom7EventData || [];
              t.indexOf(e) < 0 && t.unshift(e),
              n.apply(this, t)
          }
          "function" == typeof e[1] && ([t,n,r] = e,
          i = void 0),
          r || (r = !1);
          const a = t.split(" ");
          let l;
          for (let e = 0; e < this.length; e += 1) {
              const t = this[e];
              if (i)
                  for (l = 0; l < a.length; l += 1) {
                      const e = a[l];
                      t.dom7LiveListeners || (t.dom7LiveListeners = {}),
                      t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []),
                      t.dom7LiveListeners[e].push({
                          listener: n,
                          proxyListener: o
                      }),
                      t.addEventListener(e, o, r)
                  }
              else
                  for (l = 0; l < a.length; l += 1) {
                      const e = a[l];
                      t.dom7Listeners || (t.dom7Listeners = {}),
                      t.dom7Listeners[e] || (t.dom7Listeners[e] = []),
                      t.dom7Listeners[e].push({
                          listener: n,
                          proxyListener: s
                      }),
                      t.addEventListener(e, s, r)
                  }
          }
          return this
      },
      off: function(...e) {
          let[t,i,n,r] = e;
          "function" == typeof e[1] && ([t,n,r] = e,
          i = void 0),
          r || (r = !1);
          const o = t.split(" ");
          for (let e = 0; e < o.length; e += 1) {
              const t = o[e];
              for (let e = 0; e < this.length; e += 1) {
                  const o = this[e];
                  let s;
                  if (!i && o.dom7Listeners ? s = o.dom7Listeners[t] : i && o.dom7LiveListeners && (s = o.dom7LiveListeners[t]),
                  s && s.length)
                      for (let e = s.length - 1; e >= 0; e -= 1) {
                          const i = s[e];
                          n && i.listener === n ? (o.removeEventListener(t, i.proxyListener, r),
                          s.splice(e, 1)) : n || (o.removeEventListener(t, i.proxyListener, r),
                          s.splice(e, 1))
                      }
              }
          }
          return this
      },
      trigger: function(...e) {
          const t = e[0].split(" ")
            , i = e[1];
          for (let n = 0; n < t.length; n += 1) {
              const r = t[n];
              for (let t = 0; t < this.length; t += 1) {
                  const n = this[t];
                  let o;
                  try {
                      o = new ue.CustomEvent(r,{
                          detail: i,
                          bubbles: !0,
                          cancelable: !0
                      })
                  } catch (e) {
                      (o = ce.createEvent("Event")).initEvent(r, !0, !0),
                      o.detail = i
                  }
                  n.dom7EventData = e.filter((e,t)=>t > 0),
                  n.dispatchEvent(o),
                  n.dom7EventData = [],
                  delete n.dom7EventData
              }
          }
          return this
      },
      transitionEnd: function(e) {
          const t = ["webkitTransitionEnd", "transitionend"]
            , i = this;
          let n;
          function r(o) {
              if (o.target === this)
                  for (e.call(this, o),
                  n = 0; n < t.length; n += 1)
                      i.off(t[n], r)
          }
          if (e)
              for (n = 0; n < t.length; n += 1)
                  i.on(t[n], r);
          return this
      },
      outerWidth: function(e) {
          if (this.length > 0) {
              if (e) {
                  const e = this.styles();
                  return this[0].offsetWidth + parseFloat(e.getPropertyValue("margin-right")) + parseFloat(e.getPropertyValue("margin-left"))
              }
              return this[0].offsetWidth
          }
          return null
      },
      outerHeight: function(e) {
          if (this.length > 0) {
              if (e) {
                  const e = this.styles();
                  return this[0].offsetHeight + parseFloat(e.getPropertyValue("margin-top")) + parseFloat(e.getPropertyValue("margin-bottom"))
              }
              return this[0].offsetHeight
          }
          return null
      },
      offset: function() {
          if (this.length > 0) {
              const e = this[0]
                , t = e.getBoundingClientRect()
                , i = ce.body
                , n = e.clientTop || i.clientTop || 0
                , r = e.clientLeft || i.clientLeft || 0
                , o = e === ue ? ue.scrollY : e.scrollTop
                , s = e === ue ? ue.scrollX : e.scrollLeft;
              return {
                  top: t.top + o - n,
                  left: t.left + s - r
              }
          }
          return null
      },
      css: function(e, t) {
          let i;
          if (1 === arguments.length) {
              if ("string" != typeof e) {
                  for (i = 0; i < this.length; i += 1)
                      for (let t in e)
                          this[i].style[t] = e[t];
                  return this
              }
              if (this[0])
                  return ue.getComputedStyle(this[0], null).getPropertyValue(e)
          }
          if (2 === arguments.length && "string" == typeof e) {
              for (i = 0; i < this.length; i += 1)
                  this[i].style[e] = t;
              return this
          }
          return this
      },
      each: function(e) {
          if (!e)
              return this;
          for (let t = 0; t < this.length; t += 1)
              if (!1 === e.call(this[t], t, this[t]))
                  return this;
          return this
      },
      html: function(e) {
          if (void 0 === e)
              return this[0] ? this[0].innerHTML : void 0;
          for (let t = 0; t < this.length; t += 1)
              this[t].innerHTML = e;
          return this
      },
      text: function(e) {
          if (void 0 === e)
              return this[0] ? this[0].textContent.trim() : null;
          for (let t = 0; t < this.length; t += 1)
              this[t].textContent = e;
          return this
      },
      is: function(e) {
          const t = this[0];
          let i, n;
          if (!t || void 0 === e)
              return !1;
          if ("string" == typeof e) {
              if (t.matches)
                  return t.matches(e);
              if (t.webkitMatchesSelector)
                  return t.webkitMatchesSelector(e);
              if (t.msMatchesSelector)
                  return t.msMatchesSelector(e);
              for (i = de(e),
              n = 0; n < i.length; n += 1)
                  if (i[n] === t)
                      return !0;
              return !1
          }
          if (e === ce)
              return t === ce;
          if (e === ue)
              return t === ue;
          if (e.nodeType || e instanceof he) {
              for (i = e.nodeType ? [e] : e,
              n = 0; n < i.length; n += 1)
                  if (i[n] === t)
                      return !0;
              return !1
          }
          return !1
      },
      index: function() {
          let e, t = this[0];
          if (t) {
              for (e = 0; null !== (t = t.previousSibling); )
                  1 === t.nodeType && (e += 1);
              return e
          }
      },
      eq: function(e) {
          if (void 0 === e)
              return this;
          const t = this.length;
          let i;
          return new he(e > t - 1 ? [] : e < 0 ? (i = t + e) < 0 ? [] : [this[i]] : [this[e]])
      },
      append: function(...e) {
          let t;
          for (let i = 0; i < e.length; i += 1) {
              t = e[i];
              for (let e = 0; e < this.length; e += 1)
                  if ("string" == typeof t) {
                      const i = ce.createElement("div");
                      for (i.innerHTML = t; i.firstChild; )
                          this[e].appendChild(i.firstChild)
                  } else if (t instanceof he)
                      for (let i = 0; i < t.length; i += 1)
                          this[e].appendChild(t[i]);
                  else
                      this[e].appendChild(t)
          }
          return this
      },
      prepend: function(e) {
          let t, i;
          for (t = 0; t < this.length; t += 1)
              if ("string" == typeof e) {
                  const n = ce.createElement("div");
                  for (n.innerHTML = e,
                  i = n.childNodes.length - 1; i >= 0; i -= 1)
                      this[t].insertBefore(n.childNodes[i], this[t].childNodes[0])
              } else if (e instanceof he)
                  for (i = 0; i < e.length; i += 1)
                      this[t].insertBefore(e[i], this[t].childNodes[0]);
              else
                  this[t].insertBefore(e, this[t].childNodes[0]);
          return this
      },
      next: function(e) {
          return this.length > 0 ? e ? this[0].nextElementSibling && de(this[0].nextElementSibling).is(e) ? new he([this[0].nextElementSibling]) : new he([]) : this[0].nextElementSibling ? new he([this[0].nextElementSibling]) : new he([]) : new he([])
      },
      nextAll: function(e) {
          const t = [];
          let i = this[0];
          if (!i)
              return new he([]);
          for (; i.nextElementSibling; ) {
              const n = i.nextElementSibling;
              e ? de(n).is(e) && t.push(n) : t.push(n),
              i = n
          }
          return new he(t)
      },
      prev: function(e) {
          if (this.length > 0) {
              const t = this[0];
              return e ? t.previousElementSibling && de(t.previousElementSibling).is(e) ? new he([t.previousElementSibling]) : new he([]) : t.previousElementSibling ? new he([t.previousElementSibling]) : new he([])
          }
          return new he([])
      },
      prevAll: function(e) {
          const t = [];
          let i = this[0];
          if (!i)
              return new he([]);
          for (; i.previousElementSibling; ) {
              const n = i.previousElementSibling;
              e ? de(n).is(e) && t.push(n) : t.push(n),
              i = n
          }
          return new he(t)
      },
      parent: function(e) {
          const t = [];
          for (let i = 0; i < this.length; i += 1)
              null !== this[i].parentNode && (e ? de(this[i].parentNode).is(e) && t.push(this[i].parentNode) : t.push(this[i].parentNode));
          return de(pe(t))
      },
      parents: function(e) {
          const t = [];
          for (let i = 0; i < this.length; i += 1) {
              let n = this[i].parentNode;
              for (; n; )
                  e ? de(n).is(e) && t.push(n) : t.push(n),
                  n = n.parentNode
          }
          return de(pe(t))
      },
      closest: function(e) {
          let t = this;
          return void 0 === e ? new he([]) : (t.is(e) || (t = t.parents(e).eq(0)),
          t)
      },
      find: function(e) {
          const t = [];
          for (let i = 0; i < this.length; i += 1) {
              const n = this[i].querySelectorAll(e);
              for (let e = 0; e < n.length; e += 1)
                  t.push(n[e])
          }
          return new he(t)
      },
      children: function(e) {
          const t = [];
          for (let i = 0; i < this.length; i += 1) {
              const n = this[i].childNodes;
              for (let i = 0; i < n.length; i += 1)
                  e ? 1 === n[i].nodeType && de(n[i]).is(e) && t.push(n[i]) : 1 === n[i].nodeType && t.push(n[i])
          }
          return new he(pe(t))
      },
      remove: function() {
          for (let e = 0; e < this.length; e += 1)
              this[e].parentNode && this[e].parentNode.removeChild(this[e]);
          return this
      },
      add: function(...e) {
          const t = this;
          let i, n;
          for (i = 0; i < e.length; i += 1) {
              const r = de(e[i]);
              for (n = 0; n < r.length; n += 1)
                  t[t.length] = r[n],
                  t.length += 1
          }
          return t
      },
      styles: function() {
          return this[0] ? ue.getComputedStyle(this[0], null) : {}
      }
  };
  Object.keys(fe).forEach(e=>{
      de.fn[e] = fe[e]
  }
  );
  const me = {
      deleteProps(e) {
          const t = e;
          Object.keys(t).forEach(e=>{
              try {
                  t[e] = null
              } catch (e) {}
              try {
                  delete t[e]
              } catch (e) {}
          }
          )
      },
      nextTick: (e,t=0)=>setTimeout(e, t),
      now: ()=>Date.now(),
      getTranslate(e, t="x") {
          let i, n, r;
          const o = ue.getComputedStyle(e, null);
          return ue.WebKitCSSMatrix ? ((n = o.transform || o.webkitTransform).split(",").length > 6 && (n = n.split(", ").map(e=>e.replace(",", ".")).join(", ")),
          r = new ue.WebKitCSSMatrix("none" === n ? "" : n)) : i = (r = o.MozTransform || o.OTransform || o.MsTransform || o.msTransform || o.transform || o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","),
          "x" === t && (n = ue.WebKitCSSMatrix ? r.m41 : 16 === i.length ? parseFloat(i[12]) : parseFloat(i[4])),
          "y" === t && (n = ue.WebKitCSSMatrix ? r.m42 : 16 === i.length ? parseFloat(i[13]) : parseFloat(i[5])),
          n || 0
      },
      parseUrlQuery(e) {
          const t = {};
          let i, n, r, o, s = e || ue.location.href;
          if ("string" == typeof s && s.length)
              for (o = (n = (s = s.indexOf("?") > -1 ? s.replace(/\S*\?/, "") : "").split("&").filter(e=>"" !== e)).length,
              i = 0; i < o; i += 1)
                  r = n[i].replace(/#\S+/g, "").split("="),
                  t[decodeURIComponent(r[0])] = void 0 === r[1] ? void 0 : decodeURIComponent(r[1]) || "";
          return t
      },
      isObject: e=>"object" == typeof e && null !== e && e.constructor && e.constructor === Object,
      extend(...e) {
          const t = Object(e[0]);
          for (let i = 1; i < e.length; i += 1) {
              const n = e[i];
              if (null != n) {
                  const e = Object.keys(Object(n));
                  for (let i = 0, r = e.length; i < r; i += 1) {
                      const r = e[i]
                        , o = Object.getOwnPropertyDescriptor(n, r);
                      void 0 !== o && o.enumerable && (me.isObject(t[r]) && me.isObject(n[r]) ? me.extend(t[r], n[r]) : !me.isObject(t[r]) && me.isObject(n[r]) ? (t[r] = {},
                      me.extend(t[r], n[r])) : t[r] = n[r])
                  }
              }
          }
          return t
      }
  }
    , ge = function() {
      const e = ce.createElement("div");
      return {
          touch: ue.Modernizr && !0 === ue.Modernizr.touch || !!(ue.navigator.maxTouchPoints > 0 || "ontouchstart"in ue || ue.DocumentTouch && ce instanceof ue.DocumentTouch),
          pointerEvents: !!(ue.navigator.pointerEnabled || ue.PointerEvent || "maxTouchPoints"in ue.navigator),
          prefixedPointerEvents: !!ue.navigator.msPointerEnabled,
          transition: function() {
              const t = e.style;
              return "transition"in t || "webkitTransition"in t || "MozTransition"in t
          }(),
          transforms3d: ue.Modernizr && !0 === ue.Modernizr.csstransforms3d || function() {
              const t = e.style;
              return "webkitPerspective"in t || "MozPerspective"in t || "OPerspective"in t || "MsPerspective"in t || "perspective"in t
          }(),
          flexbox: function() {
              const t = e.style
                , i = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" ");
              for (let e = 0; e < i.length; e += 1)
                  if (i[e]in t)
                      return !0;
              return !1
          }(),
          observer: "MutationObserver"in ue || "WebkitMutationObserver"in ue,
          passiveListener: function() {
              let e = !1;
              try {
                  const t = Object.defineProperty({}, "passive", {
                      get() {
                          e = !0
                      }
                  });
                  ue.addEventListener("testPassiveListener", null, t)
              } catch (e) {}
              return e
          }(),
          gestures: "ongesturestart"in ue
      }
  }();
  class ve {
      constructor(e={}) {
          const t = this;
          t.params = e,
          t.eventsListeners = {},
          t.params && t.params.on && Object.keys(t.params.on).forEach(e=>{
              t.on(e, t.params.on[e])
          }
          )
      }
      on(e, t, i) {
          const n = this;
          if ("function" != typeof t)
              return n;
          const r = i ? "unshift" : "push";
          return e.split(" ").forEach(e=>{
              n.eventsListeners[e] || (n.eventsListeners[e] = []),
              n.eventsListeners[e][r](t)
          }
          ),
          n
      }
      once(e, t, i) {
          const n = this;
          if ("function" != typeof t)
              return n;
          return n.on(e, function i(...r) {
              t.apply(n, r),
              n.off(e, i)
          }, i)
      }
      off(e, t) {
          const i = this;
          return i.eventsListeners ? (e.split(" ").forEach(e=>{
              void 0 === t ? i.eventsListeners[e] = [] : i.eventsListeners[e] && i.eventsListeners[e].length && i.eventsListeners[e].forEach((n,r)=>{
                  n === t && i.eventsListeners[e].splice(r, 1)
              }
              )
          }
          ),
          i) : i
      }
      emit(...e) {
          const t = this;
          if (!t.eventsListeners)
              return t;
          let i, n, r;
          return "string" == typeof e[0] || Array.isArray(e[0]) ? (i = e[0],
          n = e.slice(1, e.length),
          r = t) : (i = e[0].events,
          n = e[0].data,
          r = e[0].context || t),
          (Array.isArray(i) ? i : i.split(" ")).forEach(e=>{
              if (t.eventsListeners && t.eventsListeners[e]) {
                  const i = [];
                  t.eventsListeners[e].forEach(e=>{
                      i.push(e)
                  }
                  ),
                  i.forEach(e=>{
                      e.apply(r, n)
                  }
                  )
              }
          }
          ),
          t
      }
      useModulesParams(e) {
          const t = this;
          t.modules && Object.keys(t.modules).forEach(i=>{
              const n = t.modules[i];
              n.params && me.extend(e, n.params)
          }
          )
      }
      useModules(e={}) {
          const t = this;
          t.modules && Object.keys(t.modules).forEach(i=>{
              const n = t.modules[i]
                , r = e[i] || {};
              n.instance && Object.keys(n.instance).forEach(e=>{
                  const i = n.instance[e];
                  t[e] = "function" == typeof i ? i.bind(t) : i
              }
              ),
              n.on && t.on && Object.keys(n.on).forEach(e=>{
                  t.on(e, n.on[e])
              }
              ),
              n.create && n.create.bind(t)(r)
          }
          )
      }
      static set components(e) {
          this.use && this.use(e)
      }
      static installModule(e, ...t) {
          const i = this;
          i.prototype.modules || (i.prototype.modules = {});
          const n = e.name || `${Object.keys(i.prototype.modules).length}_${me.now()}`;
          return i.prototype.modules[n] = e,
          e.proto && Object.keys(e.proto).forEach(t=>{
              i.prototype[t] = e.proto[t]
          }
          ),
          e.static && Object.keys(e.static).forEach(t=>{
              i[t] = e.static[t]
          }
          ),
          e.install && e.install.apply(i, t),
          i
      }
      static use(e, ...t) {
          const i = this;
          return Array.isArray(e) ? (e.forEach(e=>i.installModule(e)),
          i) : i.installModule(e, ...t)
      }
  }
  var ye = {
      updateSize: function() {
          const e = this;
          let t, i;
          const n = e.$el;
          t = void 0 !== e.params.width ? e.params.width : n[0].clientWidth,
          i = void 0 !== e.params.height ? e.params.height : n[0].clientHeight,
          0 === t && e.isHorizontal() || 0 === i && e.isVertical() || (t = t - parseInt(n.css("padding-left"), 10) - parseInt(n.css("padding-right"), 10),
          i = i - parseInt(n.css("padding-top"), 10) - parseInt(n.css("padding-bottom"), 10),
          me.extend(e, {
              width: t,
              height: i,
              size: e.isHorizontal() ? t : i
          }))
      },
      updateSlides: function() {
          const e = this
            , t = e.params
            , {$wrapperEl: i, size: n, rtlTranslate: r, wrongRTL: o} = e
            , s = e.virtual && t.virtual.enabled
            , a = s ? e.virtual.slides.length : e.slides.length
            , l = i.children(`.${e.params.slideClass}`)
            , c = s ? e.virtual.slides.length : l.length;
          let u = [];
          const h = []
            , d = [];
          let p = t.slidesOffsetBefore;
          "function" == typeof p && (p = t.slidesOffsetBefore.call(e));
          let f = t.slidesOffsetAfter;
          "function" == typeof f && (f = t.slidesOffsetAfter.call(e));
          const m = e.snapGrid.length
            , g = e.snapGrid.length;
          let v, y, _ = t.spaceBetween, b = -p, w = 0, x = 0;
          if (void 0 === n)
              return;
          "string" == typeof _ && _.indexOf("%") >= 0 && (_ = parseFloat(_.replace("%", "")) / 100 * n),
          e.virtualSize = -_,
          r ? l.css({
              marginLeft: "",
              marginTop: ""
          }) : l.css({
              marginRight: "",
              marginBottom: ""
          }),
          t.slidesPerColumn > 1 && (v = Math.floor(c / t.slidesPerColumn) === c / e.params.slidesPerColumn ? c : Math.ceil(c / t.slidesPerColumn) * t.slidesPerColumn,
          "auto" !== t.slidesPerView && "row" === t.slidesPerColumnFill && (v = Math.max(v, t.slidesPerView * t.slidesPerColumn)));
          const k = t.slidesPerColumn
            , S = v / k
            , E = Math.floor(c / t.slidesPerColumn);
          for (let i = 0; i < c; i += 1) {
              y = 0;
              const r = l.eq(i);
              if (t.slidesPerColumn > 1) {
                  let n, o, s;
                  "column" === t.slidesPerColumnFill ? (s = i - (o = Math.floor(i / k)) * k,
                  (o > E || o === E && s === k - 1) && (s += 1) >= k && (s = 0,
                  o += 1),
                  n = o + s * v / k,
                  r.css({
                      "-webkit-box-ordinal-group": n,
                      "-moz-box-ordinal-group": n,
                      "-ms-flex-order": n,
                      "-webkit-order": n,
                      order: n
                  })) : o = i - (s = Math.floor(i / S)) * S,
                  r.css(`margin-${e.isHorizontal() ? "top" : "left"}`, 0 !== s && t.spaceBetween && `${t.spaceBetween}px`).attr("data-swiper-column", o).attr("data-swiper-row", s)
              }
              if ("none" !== r.css("display")) {
                  if ("auto" === t.slidesPerView) {
                      const i = ue.getComputedStyle(r[0], null)
                        , n = r[0].style.transform
                        , o = r[0].style.webkitTransform;
                      if (n && (r[0].style.transform = "none"),
                      o && (r[0].style.webkitTransform = "none"),
                      t.roundLengths)
                          y = e.isHorizontal() ? r.outerWidth(!0) : r.outerHeight(!0);
                      else if (e.isHorizontal()) {
                          const e = parseFloat(i.getPropertyValue("width"))
                            , t = parseFloat(i.getPropertyValue("padding-left"))
                            , n = parseFloat(i.getPropertyValue("padding-right"))
                            , r = parseFloat(i.getPropertyValue("margin-left"))
                            , o = parseFloat(i.getPropertyValue("margin-right"))
                            , s = i.getPropertyValue("box-sizing");
                          y = s && "border-box" === s ? e + r + o : e + t + n + r + o
                      } else {
                          const e = parseFloat(i.getPropertyValue("height"))
                            , t = parseFloat(i.getPropertyValue("padding-top"))
                            , n = parseFloat(i.getPropertyValue("padding-bottom"))
                            , r = parseFloat(i.getPropertyValue("margin-top"))
                            , o = parseFloat(i.getPropertyValue("margin-bottom"))
                            , s = i.getPropertyValue("box-sizing");
                          y = s && "border-box" === s ? e + r + o : e + t + n + r + o
                      }
                      n && (r[0].style.transform = n),
                      o && (r[0].style.webkitTransform = o),
                      t.roundLengths && (y = Math.floor(y))
                  } else
                      y = (n - (t.slidesPerView - 1) * _) / t.slidesPerView,
                      t.roundLengths && (y = Math.floor(y)),
                      l[i] && (e.isHorizontal() ? l[i].style.width = `${y}px` : l[i].style.height = `${y}px`);
                  l[i] && (l[i].swiperSlideSize = y),
                  d.push(y),
                  t.centeredSlides ? (b = b + y / 2 + w / 2 + _,
                  0 === w && 0 !== i && (b = b - n / 2 - _),
                  0 === i && (b = b - n / 2 - _),
                  Math.abs(b) < .001 && (b = 0),
                  t.roundLengths && (b = Math.floor(b)),
                  x % t.slidesPerGroup == 0 && u.push(b),
                  h.push(b)) : (t.roundLengths && (b = Math.floor(b)),
                  x % t.slidesPerGroup == 0 && u.push(b),
                  h.push(b),
                  b = b + y + _),
                  e.virtualSize += y + _,
                  w = y,
                  x += 1
              }
          }
          let T;
          if (e.virtualSize = Math.max(e.virtualSize, n) + f,
          r && o && ("slide" === t.effect || "coverflow" === t.effect) && i.css({
              width: `${e.virtualSize + t.spaceBetween}px`
          }),
          ge.flexbox && !t.setWrapperSize || (e.isHorizontal() ? i.css({
              width: `${e.virtualSize + t.spaceBetween}px`
          }) : i.css({
              height: `${e.virtualSize + t.spaceBetween}px`
          })),
          t.slidesPerColumn > 1 && (e.virtualSize = (y + t.spaceBetween) * v,
          e.virtualSize = Math.ceil(e.virtualSize / t.slidesPerColumn) - t.spaceBetween,
          e.isHorizontal() ? i.css({
              width: `${e.virtualSize + t.spaceBetween}px`
          }) : i.css({
              height: `${e.virtualSize + t.spaceBetween}px`
          }),
          t.centeredSlides)) {
              T = [];
              for (let i = 0; i < u.length; i += 1) {
                  let n = u[i];
                  t.roundLengths && (n = Math.floor(n)),
                  u[i] < e.virtualSize + u[0] && T.push(n)
              }
              u = T
          }
          if (!t.centeredSlides) {
              T = [];
              for (let i = 0; i < u.length; i += 1) {
                  let r = u[i];
                  t.roundLengths && (r = Math.floor(r)),
                  u[i] <= e.virtualSize - n && T.push(r)
              }
              u = T,
              Math.floor(e.virtualSize - n) - Math.floor(u[u.length - 1]) > 1 && u.push(e.virtualSize - n)
          }
          if (0 === u.length && (u = [0]),
          0 !== t.spaceBetween && (e.isHorizontal() ? r ? l.css({
              marginLeft: `${_}px`
          }) : l.css({
              marginRight: `${_}px`
          }) : l.css({
              marginBottom: `${_}px`
          })),
          t.centerInsufficientSlides) {
              let e = 0;
              if (d.forEach(i=>{
                  e += i + (t.spaceBetween ? t.spaceBetween : 0)
              }
              ),
              (e -= t.spaceBetween) < n) {
                  const t = (n - e) / 2;
                  u.forEach((e,i)=>{
                      u[i] = e - t
                  }
                  ),
                  h.forEach((e,i)=>{
                      h[i] = e + t
                  }
                  )
              }
          }
          me.extend(e, {
              slides: l,
              snapGrid: u,
              slidesGrid: h,
              slidesSizesGrid: d
          }),
          c !== a && e.emit("slidesLengthChange"),
          u.length !== m && (e.params.watchOverflow && e.checkOverflow(),
          e.emit("snapGridLengthChange")),
          h.length !== g && e.emit("slidesGridLengthChange"),
          (t.watchSlidesProgress || t.watchSlidesVisibility) && e.updateSlidesOffset()
      },
      updateAutoHeight: function(e) {
          const t = this
            , i = [];
          let n, r = 0;
          if ("number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed),
          "auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
              for (n = 0; n < Math.ceil(t.params.slidesPerView); n += 1) {
                  const e = t.activeIndex + n;
                  if (e > t.slides.length)
                      break;
                  i.push(t.slides.eq(e)[0])
              }
          else
              i.push(t.slides.eq(t.activeIndex)[0]);
          for (n = 0; n < i.length; n += 1)
              if (void 0 !== i[n]) {
                  const e = i[n].offsetHeight;
                  r = e > r ? e : r
              }
          r && t.$wrapperEl.css("height", `${r}px`)
      },
      updateSlidesOffset: function() {
          const e = this
            , t = e.slides;
          for (let i = 0; i < t.length; i += 1)
              t[i].swiperSlideOffset = e.isHorizontal() ? t[i].offsetLeft : t[i].offsetTop
      },
      updateSlidesProgress: function(e=this && this.translate || 0) {
          const t = this
            , i = t.params
            , {slides: n, rtlTranslate: r} = t;
          if (0 === n.length)
              return;
          void 0 === n[0].swiperSlideOffset && t.updateSlidesOffset();
          let o = -e;
          r && (o = e),
          n.removeClass(i.slideVisibleClass),
          t.visibleSlidesIndexes = [],
          t.visibleSlides = [];
          for (let e = 0; e < n.length; e += 1) {
              const s = n[e]
                , a = (o + (i.centeredSlides ? t.minTranslate() : 0) - s.swiperSlideOffset) / (s.swiperSlideSize + i.spaceBetween);
              if (i.watchSlidesVisibility) {
                  const r = -(o - s.swiperSlideOffset)
                    , a = r + t.slidesSizesGrid[e];
                  (r >= 0 && r < t.size || a > 0 && a <= t.size || r <= 0 && a >= t.size) && (t.visibleSlides.push(s),
                  t.visibleSlidesIndexes.push(e),
                  n.eq(e).addClass(i.slideVisibleClass))
              }
              s.progress = r ? -a : a
          }
          t.visibleSlides = de(t.visibleSlides)
      },
      updateProgress: function(e=this && this.translate || 0) {
          const t = this
            , i = t.params
            , n = t.maxTranslate() - t.minTranslate();
          let {progress: r, isBeginning: o, isEnd: s} = t;
          const a = o
            , l = s;
          0 === n ? (r = 0,
          o = !0,
          s = !0) : (o = (r = (e - t.minTranslate()) / n) <= 0,
          s = r >= 1),
          me.extend(t, {
              progress: r,
              isBeginning: o,
              isEnd: s
          }),
          (i.watchSlidesProgress || i.watchSlidesVisibility) && t.updateSlidesProgress(e),
          o && !a && t.emit("reachBeginning toEdge"),
          s && !l && t.emit("reachEnd toEdge"),
          (a && !o || l && !s) && t.emit("fromEdge"),
          t.emit("progress", r)
      },
      updateSlidesClasses: function() {
          const e = this
            , {slides: t, params: i, $wrapperEl: n, activeIndex: r, realIndex: o} = e
            , s = e.virtual && i.virtual.enabled;
          let a;
          t.removeClass(`${i.slideActiveClass} ${i.slideNextClass} ${i.slidePrevClass} ${i.slideDuplicateActiveClass} ${i.slideDuplicateNextClass} ${i.slideDuplicatePrevClass}`),
          (a = s ? e.$wrapperEl.find(`.${i.slideClass}[data-swiper-slide-index="${r}"]`) : t.eq(r)).addClass(i.slideActiveClass),
          i.loop && (a.hasClass(i.slideDuplicateClass) ? n.children(`.${i.slideClass}:not(.${i.slideDuplicateClass})[data-swiper-slide-index="${o}"]`).addClass(i.slideDuplicateActiveClass) : n.children(`.${i.slideClass}.${i.slideDuplicateClass}[data-swiper-slide-index="${o}"]`).addClass(i.slideDuplicateActiveClass));
          let l = a.nextAll(`.${i.slideClass}`).eq(0).addClass(i.slideNextClass);
          i.loop && 0 === l.length && (l = t.eq(0)).addClass(i.slideNextClass);
          let c = a.prevAll(`.${i.slideClass}`).eq(0).addClass(i.slidePrevClass);
          i.loop && 0 === c.length && (c = t.eq(-1)).addClass(i.slidePrevClass),
          i.loop && (l.hasClass(i.slideDuplicateClass) ? n.children(`.${i.slideClass}:not(.${i.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(i.slideDuplicateNextClass) : n.children(`.${i.slideClass}.${i.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(i.slideDuplicateNextClass),
          c.hasClass(i.slideDuplicateClass) ? n.children(`.${i.slideClass}:not(.${i.slideDuplicateClass})[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`).addClass(i.slideDuplicatePrevClass) : n.children(`.${i.slideClass}.${i.slideDuplicateClass}[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`).addClass(i.slideDuplicatePrevClass))
      },
      updateActiveIndex: function(e) {
          const t = this
            , i = t.rtlTranslate ? t.translate : -t.translate
            , {slidesGrid: n, snapGrid: r, params: o, activeIndex: s, realIndex: a, snapIndex: l} = t;
          let c, u = e;
          if (void 0 === u) {
              for (let e = 0; e < n.length; e += 1)
                  void 0 !== n[e + 1] ? i >= n[e] && i < n[e + 1] - (n[e + 1] - n[e]) / 2 ? u = e : i >= n[e] && i < n[e + 1] && (u = e + 1) : i >= n[e] && (u = e);
              o.normalizeSlideIndex && (u < 0 || void 0 === u) && (u = 0)
          }
          if ((c = r.indexOf(i) >= 0 ? r.indexOf(i) : Math.floor(u / o.slidesPerGroup)) >= r.length && (c = r.length - 1),
          u === s)
              return void (c !== l && (t.snapIndex = c,
              t.emit("snapIndexChange")));
          const h = parseInt(t.slides.eq(u).attr("data-swiper-slide-index") || u, 10);
          me.extend(t, {
              snapIndex: c,
              realIndex: h,
              previousIndex: s,
              activeIndex: u
          }),
          t.emit("activeIndexChange"),
          t.emit("snapIndexChange"),
          a !== h && t.emit("realIndexChange"),
          t.emit("slideChange")
      },
      updateClickedSlide: function(e) {
          const t = this
            , i = t.params
            , n = de(e.target).closest(`.${i.slideClass}`)[0];
          let r = !1;
          if (n)
              for (let e = 0; e < t.slides.length; e += 1)
                  t.slides[e] === n && (r = !0);
          if (!n || !r)
              return t.clickedSlide = void 0,
              void (t.clickedIndex = void 0);
          t.clickedSlide = n,
          t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(de(n).attr("data-swiper-slide-index"), 10) : t.clickedIndex = de(n).index(),
          i.slideToClickedSlide && void 0 !== t.clickedIndex && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide()
      }
  };
  var _e = {
      getTranslate: function(e=(this.isHorizontal() ? "x" : "y")) {
          const {params: t, rtlTranslate: i, translate: n, $wrapperEl: r} = this;
          if (t.virtualTranslate)
              return i ? -n : n;
          let o = me.getTranslate(r[0], e);
          return i && (o = -o),
          o || 0
      },
      setTranslate: function(e, t) {
          const i = this
            , {rtlTranslate: n, params: r, $wrapperEl: o, progress: s} = i;
          let a, l = 0, c = 0;
          i.isHorizontal() ? l = n ? -e : e : c = e,
          r.roundLengths && (l = Math.floor(l),
          c = Math.floor(c)),
          r.virtualTranslate || (ge.transforms3d ? o.transform(`translate3d(${l}px, ${c}px, 0px)`) : o.transform(`translate(${l}px, ${c}px)`)),
          i.previousTranslate = i.translate,
          i.translate = i.isHorizontal() ? l : c;
          const u = i.maxTranslate() - i.minTranslate();
          (a = 0 === u ? 0 : (e - i.minTranslate()) / u) !== s && i.updateProgress(e),
          i.emit("setTranslate", i.translate, t)
      },
      minTranslate: function() {
          return -this.snapGrid[0]
      },
      maxTranslate: function() {
          return -this.snapGrid[this.snapGrid.length - 1]
      }
  };
  var be = {
      setTransition: function(e, t) {
          this.$wrapperEl.transition(e),
          this.emit("setTransition", e, t)
      },
      transitionStart: function(e=!0, t) {
          const i = this
            , {activeIndex: n, params: r, previousIndex: o} = i;
          r.autoHeight && i.updateAutoHeight();
          let s = t;
          if (s || (s = n > o ? "next" : n < o ? "prev" : "reset"),
          i.emit("transitionStart"),
          e && n !== o) {
              if ("reset" === s)
                  return void i.emit("slideResetTransitionStart");
              i.emit("slideChangeTransitionStart"),
              "next" === s ? i.emit("slideNextTransitionStart") : i.emit("slidePrevTransitionStart")
          }
      },
      transitionEnd: function(e=!0, t) {
          const i = this
            , {activeIndex: n, previousIndex: r} = i;
          i.animating = !1,
          i.setTransition(0);
          let o = t;
          if (o || (o = n > r ? "next" : n < r ? "prev" : "reset"),
          i.emit("transitionEnd"),
          e && n !== r) {
              if ("reset" === o)
                  return void i.emit("slideResetTransitionEnd");
              i.emit("slideChangeTransitionEnd"),
              "next" === o ? i.emit("slideNextTransitionEnd") : i.emit("slidePrevTransitionEnd")
          }
      }
  };
  var we = {
      slideTo: function(e=0, t=this.params.speed, i=!0, n) {
          const r = this;
          let o = e;
          o < 0 && (o = 0);
          const {params: s, snapGrid: a, slidesGrid: l, previousIndex: c, activeIndex: u, rtlTranslate: h} = r;
          if (r.animating && s.preventInteractionOnTransition)
              return !1;
          let d = Math.floor(o / s.slidesPerGroup);
          d >= a.length && (d = a.length - 1),
          (u || s.initialSlide || 0) === (c || 0) && i && r.emit("beforeSlideChangeStart");
          const p = -a[d];
          if (r.updateProgress(p),
          s.normalizeSlideIndex)
              for (let e = 0; e < l.length; e += 1)
                  -Math.floor(100 * p) >= Math.floor(100 * l[e]) && (o = e);
          if (r.initialized && o !== u) {
              if (!r.allowSlideNext && p < r.translate && p < r.minTranslate())
                  return !1;
              if (!r.allowSlidePrev && p > r.translate && p > r.maxTranslate() && (u || 0) !== o)
                  return !1
          }
          let f;
          return f = o > u ? "next" : o < u ? "prev" : "reset",
          h && -p === r.translate || !h && p === r.translate ? (r.updateActiveIndex(o),
          s.autoHeight && r.updateAutoHeight(),
          r.updateSlidesClasses(),
          "slide" !== s.effect && r.setTranslate(p),
          "reset" !== f && (r.transitionStart(i, f),
          r.transitionEnd(i, f)),
          !1) : (0 !== t && ge.transition ? (r.setTransition(t),
          r.setTranslate(p),
          r.updateActiveIndex(o),
          r.updateSlidesClasses(),
          r.emit("beforeTransitionStart", t, n),
          r.transitionStart(i, f),
          r.animating || (r.animating = !0,
          r.onSlideToWrapperTransitionEnd || (r.onSlideToWrapperTransitionEnd = function(e) {
              r && !r.destroyed && e.target === this && (r.$wrapperEl[0].removeEventListener("transitionend", r.onSlideToWrapperTransitionEnd),
              r.$wrapperEl[0].removeEventListener("webkitTransitionEnd", r.onSlideToWrapperTransitionEnd),
              r.onSlideToWrapperTransitionEnd = null,
              delete r.onSlideToWrapperTransitionEnd,
              r.transitionEnd(i, f))
          }
          ),
          r.$wrapperEl[0].addEventListener("transitionend", r.onSlideToWrapperTransitionEnd),
          r.$wrapperEl[0].addEventListener("webkitTransitionEnd", r.onSlideToWrapperTransitionEnd))) : (r.setTransition(0),
          r.setTranslate(p),
          r.updateActiveIndex(o),
          r.updateSlidesClasses(),
          r.emit("beforeTransitionStart", t, n),
          r.transitionStart(i, f),
          r.transitionEnd(i, f)),
          !0)
      },
      slideToLoop: function(e=0, t=this.params.speed, i=!0, n) {
          const r = this;
          let o = e;
          return r.params.loop && (o += r.loopedSlides),
          r.slideTo(o, t, i, n)
      },
      slideNext: function(e=this.params.speed, t=!0, i) {
          const n = this
            , {params: r, animating: o} = n;
          return r.loop ? !o && (n.loopFix(),
          n._clientLeft = n.$wrapperEl[0].clientLeft,
          n.slideTo(n.activeIndex + r.slidesPerGroup, e, t, i)) : n.slideTo(n.activeIndex + r.slidesPerGroup, e, t, i)
      },
      slidePrev: function(e=this.params.speed, t=!0, i) {
          const n = this
            , {params: r, animating: o, snapGrid: s, slidesGrid: a, rtlTranslate: l} = n;
          if (r.loop) {
              if (o)
                  return !1;
              n.loopFix(),
              n._clientLeft = n.$wrapperEl[0].clientLeft
          }
          function c(e) {
              return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e)
          }
          const u = c(l ? n.translate : -n.translate)
            , h = s.map(e=>c(e))
            , d = (a.map(e=>c(e)),
          s[h.indexOf(u)],
          s[h.indexOf(u) - 1]);
          let p;
          return void 0 !== d && (p = a.indexOf(d)) < 0 && (p = n.activeIndex - 1),
          n.slideTo(p, e, t, i)
      },
      slideReset: function(e=this.params.speed, t=!0, i) {
          return this.slideTo(this.activeIndex, e, t, i)
      },
      slideToClosest: function(e=this.params.speed, t=!0, i) {
          const n = this;
          let r = n.activeIndex;
          const o = Math.floor(r / n.params.slidesPerGroup);
          if (o < n.snapGrid.length - 1) {
              const e = n.rtlTranslate ? n.translate : -n.translate
                , t = n.snapGrid[o];
              e - t > (n.snapGrid[o + 1] - t) / 2 && (r = n.params.slidesPerGroup)
          }
          return n.slideTo(r, e, t, i)
      },
      slideToClickedSlide: function() {
          const e = this
            , {params: t, $wrapperEl: i} = e
            , n = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
          let r, o = e.clickedIndex;
          if (t.loop) {
              if (e.animating)
                  return;
              r = parseInt(de(e.clickedSlide).attr("data-swiper-slide-index"), 10),
              t.centeredSlides ? o < e.loopedSlides - n / 2 || o > e.slides.length - e.loopedSlides + n / 2 ? (e.loopFix(),
              o = i.children(`.${t.slideClass}[data-swiper-slide-index="${r}"]:not(.${t.slideDuplicateClass})`).eq(0).index(),
              me.nextTick(()=>{
                  e.slideTo(o)
              }
              )) : e.slideTo(o) : o > e.slides.length - n ? (e.loopFix(),
              o = i.children(`.${t.slideClass}[data-swiper-slide-index="${r}"]:not(.${t.slideDuplicateClass})`).eq(0).index(),
              me.nextTick(()=>{
                  e.slideTo(o)
              }
              )) : e.slideTo(o)
          } else
              e.slideTo(o)
      }
  };
  var xe = {
      loopCreate: function() {
          const e = this
            , {params: t, $wrapperEl: i} = e;
          i.children(`.${t.slideClass}.${t.slideDuplicateClass}`).remove();
          let n = i.children(`.${t.slideClass}`);
          if (t.loopFillGroupWithBlank) {
              const e = t.slidesPerGroup - n.length % t.slidesPerGroup;
              if (e !== t.slidesPerGroup) {
                  for (let n = 0; n < e; n += 1) {
                      const e = de(ce.createElement("div")).addClass(`${t.slideClass} ${t.slideBlankClass}`);
                      i.append(e)
                  }
                  n = i.children(`.${t.slideClass}`)
              }
          }
          "auto" !== t.slidesPerView || t.loopedSlides || (t.loopedSlides = n.length),
          e.loopedSlides = parseInt(t.loopedSlides || t.slidesPerView, 10),
          e.loopedSlides += t.loopAdditionalSlides,
          e.loopedSlides > n.length && (e.loopedSlides = n.length);
          const r = []
            , o = [];
          n.each((t,i)=>{
              const s = de(i);
              t < e.loopedSlides && o.push(i),
              t < n.length && t >= n.length - e.loopedSlides && r.push(i),
              s.attr("data-swiper-slide-index", t)
          }
          );
          for (let e = 0; e < o.length; e += 1)
              i.append(de(o[e].cloneNode(!0)).addClass(t.slideDuplicateClass));
          for (let e = r.length - 1; e >= 0; e -= 1)
              i.prepend(de(r[e].cloneNode(!0)).addClass(t.slideDuplicateClass))
      },
      loopFix: function() {
          const e = this
            , {params: t, activeIndex: i, slides: n, loopedSlides: r, allowSlidePrev: o, allowSlideNext: s, snapGrid: a, rtlTranslate: l} = e;
          let c;
          e.allowSlidePrev = !0,
          e.allowSlideNext = !0;
          const u = -a[i] - e.getTranslate();
          i < r ? (c = n.length - 3 * r + i,
          c += r,
          e.slideTo(c, 0, !1, !0) && 0 !== u && e.setTranslate((l ? -e.translate : e.translate) - u)) : ("auto" === t.slidesPerView && i >= 2 * r || i >= n.length - r) && (c = -n.length + i + r,
          c += r,
          e.slideTo(c, 0, !1, !0) && 0 !== u && e.setTranslate((l ? -e.translate : e.translate) - u));
          e.allowSlidePrev = o,
          e.allowSlideNext = s
      },
      loopDestroy: function() {
          const {$wrapperEl: e, params: t, slides: i} = this;
          e.children(`.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`).remove(),
          i.removeAttr("data-swiper-slide-index")
      }
  };
  var ke = {
      setGrabCursor: function(e) {
          if (ge.touch || !this.params.simulateTouch || this.params.watchOverflow && this.isLocked)
              return;
          const t = this.el;
          t.style.cursor = "move",
          t.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab",
          t.style.cursor = e ? "-moz-grabbin" : "-moz-grab",
          t.style.cursor = e ? "grabbing" : "grab"
      },
      unsetGrabCursor: function() {
          ge.touch || this.params.watchOverflow && this.isLocked || (this.el.style.cursor = "")
      }
  };
  var Se = {
      appendSlide: function(e) {
          const t = this
            , {$wrapperEl: i, params: n} = t;
          if (n.loop && t.loopDestroy(),
          "object" == typeof e && "length"in e)
              for (let t = 0; t < e.length; t += 1)
                  e[t] && i.append(e[t]);
          else
              i.append(e);
          n.loop && t.loopCreate(),
          n.observer && ge.observer || t.update()
      },
      prependSlide: function(e) {
          const t = this
            , {params: i, $wrapperEl: n, activeIndex: r} = t;
          i.loop && t.loopDestroy();
          let o = r + 1;
          if ("object" == typeof e && "length"in e) {
              for (let t = 0; t < e.length; t += 1)
                  e[t] && n.prepend(e[t]);
              o = r + e.length
          } else
              n.prepend(e);
          i.loop && t.loopCreate(),
          i.observer && ge.observer || t.update(),
          t.slideTo(o, 0, !1)
      },
      addSlide: function(e, t) {
          const i = this
            , {$wrapperEl: n, params: r, activeIndex: o} = i;
          let s = o;
          r.loop && (s -= i.loopedSlides,
          i.loopDestroy(),
          i.slides = n.children(`.${r.slideClass}`));
          const a = i.slides.length;
          if (e <= 0)
              return void i.prependSlide(t);
          if (e >= a)
              return void i.appendSlide(t);
          let l = s > e ? s + 1 : s;
          const c = [];
          for (let t = a - 1; t >= e; t -= 1) {
              const e = i.slides.eq(t);
              e.remove(),
              c.unshift(e)
          }
          if ("object" == typeof t && "length"in t) {
              for (let e = 0; e < t.length; e += 1)
                  t[e] && n.append(t[e]);
              l = s > e ? s + t.length : s
          } else
              n.append(t);
          for (let e = 0; e < c.length; e += 1)
              n.append(c[e]);
          r.loop && i.loopCreate(),
          r.observer && ge.observer || i.update(),
          r.loop ? i.slideTo(l + i.loopedSlides, 0, !1) : i.slideTo(l, 0, !1)
      },
      removeSlide: function(e) {
          const t = this
            , {params: i, $wrapperEl: n, activeIndex: r} = t;
          let o = r;
          i.loop && (o -= t.loopedSlides,
          t.loopDestroy(),
          t.slides = n.children(`.${i.slideClass}`));
          let s, a = o;
          if ("object" == typeof e && "length"in e) {
              for (let i = 0; i < e.length; i += 1)
                  s = e[i],
                  t.slides[s] && t.slides.eq(s).remove(),
                  s < a && (a -= 1);
              a = Math.max(a, 0)
          } else
              s = e,
              t.slides[s] && t.slides.eq(s).remove(),
              s < a && (a -= 1),
              a = Math.max(a, 0);
          i.loop && t.loopCreate(),
          i.observer && ge.observer || t.update(),
          i.loop ? t.slideTo(a + t.loopedSlides, 0, !1) : t.slideTo(a, 0, !1)
      },
      removeAllSlides: function() {
          const e = this
            , t = [];
          for (let i = 0; i < e.slides.length; i += 1)
              t.push(i);
          e.removeSlide(t)
      }
  };
  const Ee = function() {
      const e = ue.navigator.userAgent
        , t = {
          ios: !1,
          android: !1,
          androidChrome: !1,
          desktop: !1,
          windows: !1,
          iphone: !1,
          ipod: !1,
          ipad: !1,
          cordova: ue.cordova || ue.phonegap,
          phonegap: ue.cordova || ue.phonegap
      }
        , i = e.match(/(Windows Phone);?[\s\/]+([\d.]+)?/)
        , n = e.match(/(Android);?[\s\/]+([\d.]+)?/)
        , r = e.match(/(iPad).*OS\s([\d_]+)/)
        , o = e.match(/(iPod)(.*OS\s([\d_]+))?/)
        , s = !r && e.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
      if (i && (t.os = "windows",
      t.osVersion = i[2],
      t.windows = !0),
      n && !i && (t.os = "android",
      t.osVersion = n[2],
      t.android = !0,
      t.androidChrome = e.toLowerCase().indexOf("chrome") >= 0),
      (r || s || o) && (t.os = "ios",
      t.ios = !0),
      s && !o && (t.osVersion = s[2].replace(/_/g, "."),
      t.iphone = !0),
      r && (t.osVersion = r[2].replace(/_/g, "."),
      t.ipad = !0),
      o && (t.osVersion = o[3] ? o[3].replace(/_/g, ".") : null,
      t.iphone = !0),
      t.ios && t.osVersion && e.indexOf("Version/") >= 0 && "10" === t.osVersion.split(".")[0] && (t.osVersion = e.toLowerCase().split("version/")[1].split(" ")[0]),
      t.desktop = !(t.os || t.android || t.webView),
      t.webView = (s || r || o) && e.match(/.*AppleWebKit(?!.*Safari)/i),
      t.os && "ios" === t.os) {
          const e = t.osVersion.split(".")
            , i = ce.querySelector('meta[name="viewport"]');
          t.minimalUi = !t.webView && (o || s) && (1 * e[0] == 7 ? 1 * e[1] >= 1 : 1 * e[0] > 7) && i && i.getAttribute("content").indexOf("minimal-ui") >= 0
      }
      return t.pixelRatio = ue.devicePixelRatio || 1,
      t
  }();
  function Te() {
      const e = this
        , {params: t, el: i} = e;
      if (i && 0 === i.offsetWidth)
          return;
      t.breakpoints && e.setBreakpoint();
      const {allowSlideNext: n, allowSlidePrev: r, snapGrid: o} = e;
      if (e.allowSlideNext = !0,
      e.allowSlidePrev = !0,
      e.updateSize(),
      e.updateSlides(),
      t.freeMode) {
          const i = Math.min(Math.max(e.translate, e.maxTranslate()), e.minTranslate());
          e.setTranslate(i),
          e.updateActiveIndex(),
          e.updateSlidesClasses(),
          t.autoHeight && e.updateAutoHeight()
      } else
          e.updateSlidesClasses(),
          ("auto" === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0);
      e.allowSlidePrev = r,
      e.allowSlideNext = n,
      e.params.watchOverflow && o !== e.snapGrid && e.checkOverflow()
  }
  var Ce = {
      attachEvents: function() {
          const e = this
            , {params: t, touchEvents: i, el: n, wrapperEl: r} = e;
          e.onTouchStart = function(e) {
              const t = this
                , i = t.touchEventsData
                , {params: n, touches: r} = t;
              if (t.animating && n.preventInteractionOnTransition)
                  return;
              let o = e;
              if (o.originalEvent && (o = o.originalEvent),
              i.isTouchEvent = "touchstart" === o.type,
              !i.isTouchEvent && "which"in o && 3 === o.which)
                  return;
              if (!i.isTouchEvent && "button"in o && o.button > 0)
                  return;
              if (i.isTouched && i.isMoved)
                  return;
              if (n.noSwiping && de(o.target).closest(n.noSwipingSelector ? n.noSwipingSelector : `.${n.noSwipingClass}`)[0])
                  return void (t.allowClick = !0);
              if (n.swipeHandler && !de(o).closest(n.swipeHandler)[0])
                  return;
              r.currentX = "touchstart" === o.type ? o.targetTouches[0].pageX : o.pageX,
              r.currentY = "touchstart" === o.type ? o.targetTouches[0].pageY : o.pageY;
              const s = r.currentX
                , a = r.currentY
                , l = n.edgeSwipeDetection || n.iOSEdgeSwipeDetection
                , c = n.edgeSwipeThreshold || n.iOSEdgeSwipeThreshold;
              if (!l || !(s <= c || s >= ue.screen.width - c)) {
                  if (me.extend(i, {
                      isTouched: !0,
                      isMoved: !1,
                      allowTouchCallbacks: !0,
                      isScrolling: void 0,
                      startMoving: void 0
                  }),
                  r.startX = s,
                  r.startY = a,
                  i.touchStartTime = me.now(),
                  t.allowClick = !0,
                  t.updateSize(),
                  t.swipeDirection = void 0,
                  n.threshold > 0 && (i.allowThresholdMove = !1),
                  "touchstart" !== o.type) {
                      let e = !0;
                      de(o.target).is(i.formElements) && (e = !1),
                      ce.activeElement && de(ce.activeElement).is(i.formElements) && ce.activeElement !== o.target && ce.activeElement.blur();
                      const r = e && t.allowTouchMove && n.touchStartPreventDefault;
                      (n.touchStartForcePreventDefault || r) && o.preventDefault()
                  }
                  t.emit("touchStart", o)
              }
          }
          .bind(e),
          e.onTouchMove = function(e) {
              const t = this
                , i = t.touchEventsData
                , {params: n, touches: r, rtlTranslate: o} = t;
              let s = e;
              if (s.originalEvent && (s = s.originalEvent),
              !i.isTouched)
                  return void (i.startMoving && i.isScrolling && t.emit("touchMoveOpposite", s));
              if (i.isTouchEvent && "mousemove" === s.type)
                  return;
              const a = "touchmove" === s.type ? s.targetTouches[0].pageX : s.pageX
                , l = "touchmove" === s.type ? s.targetTouches[0].pageY : s.pageY;
              if (s.preventedByNestedSwiper)
                  return r.startX = a,
                  void (r.startY = l);
              if (!t.allowTouchMove)
                  return t.allowClick = !1,
                  void (i.isTouched && (me.extend(r, {
                      startX: a,
                      startY: l,
                      currentX: a,
                      currentY: l
                  }),
                  i.touchStartTime = me.now()));
              if (i.isTouchEvent && n.touchReleaseOnEdges && !n.loop)
                  if (t.isVertical()) {
                      if (l < r.startY && t.translate <= t.maxTranslate() || l > r.startY && t.translate >= t.minTranslate())
                          return i.isTouched = !1,
                          void (i.isMoved = !1)
                  } else if (a < r.startX && t.translate <= t.maxTranslate() || a > r.startX && t.translate >= t.minTranslate())
                      return;
              if (i.isTouchEvent && ce.activeElement && s.target === ce.activeElement && de(s.target).is(i.formElements))
                  return i.isMoved = !0,
                  void (t.allowClick = !1);
              if (i.allowTouchCallbacks && t.emit("touchMove", s),
              s.targetTouches && s.targetTouches.length > 1)
                  return;
              r.currentX = a,
              r.currentY = l;
              const c = r.currentX - r.startX
                , u = r.currentY - r.startY;
              if (t.params.threshold && Math.sqrt(c ** 2 + u ** 2) < t.params.threshold)
                  return;
              if (void 0 === i.isScrolling) {
                  let e;
                  t.isHorizontal() && r.currentY === r.startY || t.isVertical() && r.currentX === r.startX ? i.isScrolling = !1 : c * c + u * u >= 25 && (e = 180 * Math.atan2(Math.abs(u), Math.abs(c)) / Math.PI,
                  i.isScrolling = t.isHorizontal() ? e > n.touchAngle : 90 - e > n.touchAngle)
              }
              if (i.isScrolling && t.emit("touchMoveOpposite", s),
              void 0 === i.startMoving && (r.currentX === r.startX && r.currentY === r.startY || (i.startMoving = !0)),
              i.isScrolling)
                  return void (i.isTouched = !1);
              if (!i.startMoving)
                  return;
              t.allowClick = !1,
              s.preventDefault(),
              n.touchMoveStopPropagation && !n.nested && s.stopPropagation(),
              i.isMoved || (n.loop && t.loopFix(),
              i.startTranslate = t.getTranslate(),
              t.setTransition(0),
              t.animating && t.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
              i.allowMomentumBounce = !1,
              !n.grabCursor || !0 !== t.allowSlideNext && !0 !== t.allowSlidePrev || t.setGrabCursor(!0),
              t.emit("sliderFirstMove", s)),
              t.emit("sliderMove", s),
              i.isMoved = !0;
              let h = t.isHorizontal() ? c : u;
              r.diff = h,
              h *= n.touchRatio,
              o && (h = -h),
              t.swipeDirection = h > 0 ? "prev" : "next",
              i.currentTranslate = h + i.startTranslate;
              let d = !0
                , p = n.resistanceRatio;
              if (n.touchReleaseOnEdges && (p = 0),
              h > 0 && i.currentTranslate > t.minTranslate() ? (d = !1,
              n.resistance && (i.currentTranslate = t.minTranslate() - 1 + (-t.minTranslate() + i.startTranslate + h) ** p)) : h < 0 && i.currentTranslate < t.maxTranslate() && (d = !1,
              n.resistance && (i.currentTranslate = t.maxTranslate() + 1 - (t.maxTranslate() - i.startTranslate - h) ** p)),
              d && (s.preventedByNestedSwiper = !0),
              !t.allowSlideNext && "next" === t.swipeDirection && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate),
              !t.allowSlidePrev && "prev" === t.swipeDirection && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate),
              n.threshold > 0) {
                  if (!(Math.abs(h) > n.threshold || i.allowThresholdMove))
                      return void (i.currentTranslate = i.startTranslate);
                  if (!i.allowThresholdMove)
                      return i.allowThresholdMove = !0,
                      r.startX = r.currentX,
                      r.startY = r.currentY,
                      i.currentTranslate = i.startTranslate,
                      void (r.diff = t.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY)
              }
              n.followFinger && ((n.freeMode || n.watchSlidesProgress || n.watchSlidesVisibility) && (t.updateActiveIndex(),
              t.updateSlidesClasses()),
              n.freeMode && (0 === i.velocities.length && i.velocities.push({
                  position: r[t.isHorizontal() ? "startX" : "startY"],
                  time: i.touchStartTime
              }),
              i.velocities.push({
                  position: r[t.isHorizontal() ? "currentX" : "currentY"],
                  time: me.now()
              })),
              t.updateProgress(i.currentTranslate),
              t.setTranslate(i.currentTranslate))
          }
          .bind(e),
          e.onTouchEnd = function(e) {
              const t = this
                , i = t.touchEventsData
                , {params: n, touches: r, rtlTranslate: o, $wrapperEl: s, slidesGrid: a, snapGrid: l} = t;
              let c = e;
              if (c.originalEvent && (c = c.originalEvent),
              i.allowTouchCallbacks && t.emit("touchEnd", c),
              i.allowTouchCallbacks = !1,
              !i.isTouched)
                  return i.isMoved && n.grabCursor && t.setGrabCursor(!1),
                  i.isMoved = !1,
                  void (i.startMoving = !1);
              n.grabCursor && i.isMoved && i.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
              const u = me.now()
                , h = u - i.touchStartTime;
              if (t.allowClick && (t.updateClickedSlide(c),
              t.emit("tap", c),
              h < 300 && u - i.lastClickTime > 300 && (i.clickTimeout && clearTimeout(i.clickTimeout),
              i.clickTimeout = me.nextTick(()=>{
                  t && !t.destroyed && t.emit("click", c)
              }
              , 300)),
              h < 300 && u - i.lastClickTime < 300 && (i.clickTimeout && clearTimeout(i.clickTimeout),
              t.emit("doubleTap", c))),
              i.lastClickTime = me.now(),
              me.nextTick(()=>{
                  t.destroyed || (t.allowClick = !0)
              }
              ),
              !i.isTouched || !i.isMoved || !t.swipeDirection || 0 === r.diff || i.currentTranslate === i.startTranslate)
                  return i.isTouched = !1,
                  i.isMoved = !1,
                  void (i.startMoving = !1);
              let d;
              if (i.isTouched = !1,
              i.isMoved = !1,
              i.startMoving = !1,
              d = n.followFinger ? o ? t.translate : -t.translate : -i.currentTranslate,
              n.freeMode) {
                  if (d < -t.minTranslate())
                      return void t.slideTo(t.activeIndex);
                  if (d > -t.maxTranslate())
                      return void (t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1));
                  if (n.freeModeMomentum) {
                      if (i.velocities.length > 1) {
                          const e = i.velocities.pop()
                            , r = i.velocities.pop()
                            , o = e.position - r.position
                            , s = e.time - r.time;
                          t.velocity = o / s,
                          t.velocity /= 2,
                          Math.abs(t.velocity) < n.freeModeMinimumVelocity && (t.velocity = 0),
                          (s > 150 || me.now() - e.time > 300) && (t.velocity = 0)
                      } else
                          t.velocity = 0;
                      t.velocity *= n.freeModeMomentumVelocityRatio,
                      i.velocities.length = 0;
                      let e = 1e3 * n.freeModeMomentumRatio;
                      const r = t.velocity * e;
                      let a = t.translate + r;
                      o && (a = -a);
                      let c, u = !1;
                      const h = 20 * Math.abs(t.velocity) * n.freeModeMomentumBounceRatio;
                      let d;
                      if (a < t.maxTranslate())
                          n.freeModeMomentumBounce ? (a + t.maxTranslate() < -h && (a = t.maxTranslate() - h),
                          c = t.maxTranslate(),
                          u = !0,
                          i.allowMomentumBounce = !0) : a = t.maxTranslate(),
                          n.loop && n.centeredSlides && (d = !0);
                      else if (a > t.minTranslate())
                          n.freeModeMomentumBounce ? (a - t.minTranslate() > h && (a = t.minTranslate() + h),
                          c = t.minTranslate(),
                          u = !0,
                          i.allowMomentumBounce = !0) : a = t.minTranslate(),
                          n.loop && n.centeredSlides && (d = !0);
                      else if (n.freeModeSticky) {
                          let e;
                          for (let t = 0; t < l.length; t += 1)
                              if (l[t] > -a) {
                                  e = t;
                                  break
                              }
                          a = -(a = Math.abs(l[e] - a) < Math.abs(l[e - 1] - a) || "next" === t.swipeDirection ? l[e] : l[e - 1])
                      }
                      if (d && t.once("transitionEnd", ()=>{
                          t.loopFix()
                      }
                      ),
                      0 !== t.velocity)
                          e = o ? Math.abs((-a - t.translate) / t.velocity) : Math.abs((a - t.translate) / t.velocity);
                      else if (n.freeModeSticky)
                          return void t.slideToClosest();
                      n.freeModeMomentumBounce && u ? (t.updateProgress(c),
                      t.setTransition(e),
                      t.setTranslate(a),
                      t.transitionStart(!0, t.swipeDirection),
                      t.animating = !0,
                      s.transitionEnd(()=>{
                          t && !t.destroyed && i.allowMomentumBounce && (t.emit("momentumBounce"),
                          t.setTransition(n.speed),
                          t.setTranslate(c),
                          s.transitionEnd(()=>{
                              t && !t.destroyed && t.transitionEnd()
                          }
                          ))
                      }
                      )) : t.velocity ? (t.updateProgress(a),
                      t.setTransition(e),
                      t.setTranslate(a),
                      t.transitionStart(!0, t.swipeDirection),
                      t.animating || (t.animating = !0,
                      s.transitionEnd(()=>{
                          t && !t.destroyed && t.transitionEnd()
                      }
                      ))) : t.updateProgress(a),
                      t.updateActiveIndex(),
                      t.updateSlidesClasses()
                  } else if (n.freeModeSticky)
                      return void t.slideToClosest();
                  return void ((!n.freeModeMomentum || h >= n.longSwipesMs) && (t.updateProgress(),
                  t.updateActiveIndex(),
                  t.updateSlidesClasses()))
              }
              let p = 0
                , f = t.slidesSizesGrid[0];
              for (let e = 0; e < a.length; e += n.slidesPerGroup)
                  void 0 !== a[e + n.slidesPerGroup] ? d >= a[e] && d < a[e + n.slidesPerGroup] && (p = e,
                  f = a[e + n.slidesPerGroup] - a[e]) : d >= a[e] && (p = e,
                  f = a[a.length - 1] - a[a.length - 2]);
              const m = (d - a[p]) / f;
              if (h > n.longSwipesMs) {
                  if (!n.longSwipes)
                      return void t.slideTo(t.activeIndex);
                  "next" === t.swipeDirection && (m >= n.longSwipesRatio ? t.slideTo(p + n.slidesPerGroup) : t.slideTo(p)),
                  "prev" === t.swipeDirection && (m > 1 - n.longSwipesRatio ? t.slideTo(p + n.slidesPerGroup) : t.slideTo(p))
              } else {
                  if (!n.shortSwipes)
                      return void t.slideTo(t.activeIndex);
                  "next" === t.swipeDirection && t.slideTo(p + n.slidesPerGroup),
                  "prev" === t.swipeDirection && t.slideTo(p)
              }
          }
          .bind(e),
          e.onClick = function(e) {
              const t = this;
              t.allowClick || (t.params.preventClicks && e.preventDefault(),
              t.params.preventClicksPropagation && t.animating && (e.stopPropagation(),
              e.stopImmediatePropagation()))
          }
          .bind(e);
          const o = "container" === t.touchEventsTarget ? n : r
            , s = !!t.nested;
          if (ge.touch || !ge.pointerEvents && !ge.prefixedPointerEvents) {
              if (ge.touch) {
                  const n = !("touchstart" !== i.start || !ge.passiveListener || !t.passiveListeners) && {
                      passive: !0,
                      capture: !1
                  };
                  o.addEventListener(i.start, e.onTouchStart, n),
                  o.addEventListener(i.move, e.onTouchMove, ge.passiveListener ? {
                      passive: !1,
                      capture: s
                  } : s),
                  o.addEventListener(i.end, e.onTouchEnd, n)
              }
              (t.simulateTouch && !Ee.ios && !Ee.android || t.simulateTouch && !ge.touch && Ee.ios) && (o.addEventListener("mousedown", e.onTouchStart, !1),
              ce.addEventListener("mousemove", e.onTouchMove, s),
              ce.addEventListener("mouseup", e.onTouchEnd, !1))
          } else
              o.addEventListener(i.start, e.onTouchStart, !1),
              ce.addEventListener(i.move, e.onTouchMove, s),
              ce.addEventListener(i.end, e.onTouchEnd, !1);
          (t.preventClicks || t.preventClicksPropagation) && o.addEventListener("click", e.onClick, !0),
          e.on(Ee.ios || Ee.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Te, !0)
      },
      detachEvents: function() {
          const e = this
            , {params: t, touchEvents: i, el: n, wrapperEl: r} = e
            , o = "container" === t.touchEventsTarget ? n : r
            , s = !!t.nested;
          if (ge.touch || !ge.pointerEvents && !ge.prefixedPointerEvents) {
              if (ge.touch) {
                  const n = !("onTouchStart" !== i.start || !ge.passiveListener || !t.passiveListeners) && {
                      passive: !0,
                      capture: !1
                  };
                  o.removeEventListener(i.start, e.onTouchStart, n),
                  o.removeEventListener(i.move, e.onTouchMove, s),
                  o.removeEventListener(i.end, e.onTouchEnd, n)
              }
              (t.simulateTouch && !Ee.ios && !Ee.android || t.simulateTouch && !ge.touch && Ee.ios) && (o.removeEventListener("mousedown", e.onTouchStart, !1),
              ce.removeEventListener("mousemove", e.onTouchMove, s),
              ce.removeEventListener("mouseup", e.onTouchEnd, !1))
          } else
              o.removeEventListener(i.start, e.onTouchStart, !1),
              ce.removeEventListener(i.move, e.onTouchMove, s),
              ce.removeEventListener(i.end, e.onTouchEnd, !1);
          (t.preventClicks || t.preventClicksPropagation) && o.removeEventListener("click", e.onClick, !0),
          e.off(Ee.ios || Ee.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Te)
      }
  };
  var Le = {
      setBreakpoint: function() {
          const e = this
            , {activeIndex: t, initialized: i, loopedSlides: n=0, params: r} = e
            , o = r.breakpoints;
          if (!o || o && 0 === Object.keys(o).length)
              return;
          const s = e.getBreakpoint(o);
          if (s && e.currentBreakpoint !== s) {
              const a = s in o ? o[s] : void 0;
              a && ["slidesPerView", "spaceBetween", "slidesPerGroup"].forEach(e=>{
                  const t = a[e];
                  void 0 !== t && (a[e] = "slidesPerView" !== e || "AUTO" !== t && "auto" !== t ? "slidesPerView" === e ? parseFloat(t) : parseInt(t, 10) : "auto")
              }
              );
              const l = a || e.originalParams
                , c = r.loop && l.slidesPerView !== r.slidesPerView;
              me.extend(e.params, l),
              me.extend(e, {
                  allowTouchMove: e.params.allowTouchMove,
                  allowSlideNext: e.params.allowSlideNext,
                  allowSlidePrev: e.params.allowSlidePrev
              }),
              e.currentBreakpoint = s,
              c && i && (e.loopDestroy(),
              e.loopCreate(),
              e.updateSlides(),
              e.slideTo(t - n + e.loopedSlides, 0, !1)),
              e.emit("breakpoint", l)
          }
      },
      getBreakpoint: function(e) {
          const t = this;
          if (!e)
              return;
          let i = !1;
          const n = [];
          Object.keys(e).forEach(e=>{
              n.push(e)
          }
          ),
          n.sort((e,t)=>parseInt(e, 10) - parseInt(t, 10));
          for (let e = 0; e < n.length; e += 1) {
              const r = n[e];
              t.params.breakpointsInverse ? r <= ue.innerWidth && (i = r) : r >= ue.innerWidth && !i && (i = r)
          }
          return i || "max"
      }
  };
  const Ae = function() {
      return {
          isIE: !!ue.navigator.userAgent.match(/Trident/g) || !!ue.navigator.userAgent.match(/MSIE/g),
          isEdge: !!ue.navigator.userAgent.match(/Edge/g),
          isSafari: function() {
              const e = ue.navigator.userAgent.toLowerCase();
              return e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0
          }(),
          isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ue.navigator.userAgent)
      }
  }();
  var Pe = {
      init: !0,
      direction: "horizontal",
      touchEventsTarget: "container",
      initialSlide: 0,
      speed: 300,
      preventInteractionOnTransition: !1,
      edgeSwipeDetection: !1,
      edgeSwipeThreshold: 20,
      freeMode: !1,
      freeModeMomentum: !0,
      freeModeMomentumRatio: 1,
      freeModeMomentumBounce: !0,
      freeModeMomentumBounceRatio: 1,
      freeModeMomentumVelocityRatio: 1,
      freeModeSticky: !1,
      freeModeMinimumVelocity: .02,
      autoHeight: !1,
      setWrapperSize: !1,
      virtualTranslate: !1,
      effect: "slide",
      breakpoints: void 0,
      breakpointsInverse: !1,
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerColumn: 1,
      slidesPerColumnFill: "column",
      slidesPerGroup: 1,
      centeredSlides: !1,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      normalizeSlideIndex: !0,
      centerInsufficientSlides: !1,
      watchOverflow: !1,
      roundLengths: !1,
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: !0,
      shortSwipes: !0,
      longSwipes: !0,
      longSwipesRatio: .5,
      longSwipesMs: 300,
      followFinger: !0,
      allowTouchMove: !0,
      threshold: 0,
      touchMoveStopPropagation: !0,
      touchStartPreventDefault: !0,
      touchStartForcePreventDefault: !1,
      touchReleaseOnEdges: !1,
      uniqueNavElements: !0,
      resistance: !0,
      resistanceRatio: .85,
      watchSlidesProgress: !1,
      watchSlidesVisibility: !1,
      grabCursor: !1,
      preventClicks: !0,
      preventClicksPropagation: !0,
      slideToClickedSlide: !1,
      preloadImages: !0,
      updateOnImagesReady: !0,
      loop: !1,
      loopAdditionalSlides: 0,
      loopedSlides: null,
      loopFillGroupWithBlank: !1,
      allowSlidePrev: !0,
      allowSlideNext: !0,
      swipeHandler: null,
      noSwiping: !0,
      noSwipingClass: "swiper-no-swiping",
      noSwipingSelector: null,
      passiveListeners: !0,
      containerModifierClass: "swiper-container-",
      slideClass: "swiper-slide",
      slideBlankClass: "swiper-slide-invisible-blank",
      slideActiveClass: "swiper-slide-active",
      slideDuplicateActiveClass: "swiper-slide-duplicate-active",
      slideVisibleClass: "swiper-slide-visible",
      slideDuplicateClass: "swiper-slide-duplicate",
      slideNextClass: "swiper-slide-next",
      slideDuplicateNextClass: "swiper-slide-duplicate-next",
      slidePrevClass: "swiper-slide-prev",
      slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
      wrapperClass: "swiper-wrapper",
      runCallbacksOnInit: !0
  };
  const Ie = {
      update: ye,
      translate: _e,
      transition: be,
      slide: we,
      loop: xe,
      grabCursor: ke,
      manipulation: Se,
      events: Ce,
      breakpoints: Le,
      checkOverflow: {
          checkOverflow: function() {
              const e = this
                , t = e.isLocked;
              e.isLocked = 1 === e.snapGrid.length,
              e.allowSlideNext = !e.isLocked,
              e.allowSlidePrev = !e.isLocked,
              t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"),
              t && t !== e.isLocked && (e.isEnd = !1,
              e.navigation.update())
          }
      },
      classes: {
          addClasses: function() {
              const {classNames: e, params: t, rtl: i, $el: n} = this
                , r = [];
              r.push(t.direction),
              t.freeMode && r.push("free-mode"),
              ge.flexbox || r.push("no-flexbox"),
              t.autoHeight && r.push("autoheight"),
              i && r.push("rtl"),
              t.slidesPerColumn > 1 && r.push("multirow"),
              Ee.android && r.push("android"),
              Ee.ios && r.push("ios"),
              (Ae.isIE || Ae.isEdge) && (ge.pointerEvents || ge.prefixedPointerEvents) && r.push(`wp8-${t.direction}`),
              r.forEach(i=>{
                  e.push(t.containerModifierClass + i)
              }
              ),
              n.addClass(e.join(" "))
          },
          removeClasses: function() {
              const {$el: e, classNames: t} = this;
              e.removeClass(t.join(" "))
          }
      },
      images: {
          loadImage: function(e, t, i, n, r, o) {
              let s;
              function a() {
                  o && o()
              }
              e.complete && r ? a() : t ? ((s = new ue.Image).onload = a,
              s.onerror = a,
              n && (s.sizes = n),
              i && (s.srcset = i),
              t && (s.src = t)) : a()
          },
          preloadImages: function() {
              const e = this;
              function t() {
                  null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                  e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(),
                  e.emit("imagesReady")))
              }
              e.imagesToLoad = e.$el.find("img");
              for (let i = 0; i < e.imagesToLoad.length; i += 1) {
                  const n = e.imagesToLoad[i];
                  e.loadImage(n, n.currentSrc || n.getAttribute("src"), n.srcset || n.getAttribute("srcset"), n.sizes || n.getAttribute("sizes"), !0, t)
              }
          }
      }
  }
    , Me = {};
  class Oe extends ve {
      constructor(...e) {
          let t, i;
          1 === e.length && e[0].constructor && e[0].constructor === Object ? i = e[0] : [t,i] = e,
          i || (i = {}),
          i = me.extend({}, i),
          t && !i.el && (i.el = t),
          super(i),
          Object.keys(Ie).forEach(e=>{
              Object.keys(Ie[e]).forEach(t=>{
                  Oe.prototype[t] || (Oe.prototype[t] = Ie[e][t])
              }
              )
          }
          );
          const n = this;
          void 0 === n.modules && (n.modules = {}),
          Object.keys(n.modules).forEach(e=>{
              const t = n.modules[e];
              if (t.params) {
                  const e = Object.keys(t.params)[0]
                    , n = t.params[e];
                  if ("object" != typeof n || null === n)
                      return;
                  if (!(e in i && "enabled"in n))
                      return;
                  !0 === i[e] && (i[e] = {
                      enabled: !0
                  }),
                  "object" != typeof i[e] || "enabled"in i[e] || (i[e].enabled = !0),
                  i[e] || (i[e] = {
                      enabled: !1
                  })
              }
          }
          );
          const r = me.extend({}, Pe);
          n.useModulesParams(r),
          n.params = me.extend({}, r, Me, i),
          n.originalParams = me.extend({}, n.params),
          n.passedParams = me.extend({}, i),
          n.$ = de;
          const o = de(n.params.el);
          if (!(t = o[0]))
              return;
          if (o.length > 1) {
              const e = [];
              return o.each((t,n)=>{
                  const r = me.extend({}, i, {
                      el: n
                  });
                  e.push(new Oe(r))
              }
              ),
              e
          }
          t.swiper = n,
          o.data("swiper", n);
          const s = o.children(`.${n.params.wrapperClass}`);
          return me.extend(n, {
              $el: o,
              el: t,
              $wrapperEl: s,
              wrapperEl: s[0],
              classNames: [],
              slides: de(),
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal: ()=>"horizontal" === n.params.direction,
              isVertical: ()=>"vertical" === n.params.direction,
              rtl: "rtl" === t.dir.toLowerCase() || "rtl" === o.css("direction"),
              rtlTranslate: "horizontal" === n.params.direction && ("rtl" === t.dir.toLowerCase() || "rtl" === o.css("direction")),
              wrongRTL: "-webkit-box" === s.css("display"),
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              allowSlideNext: n.params.allowSlideNext,
              allowSlidePrev: n.params.allowSlidePrev,
              touchEvents: function() {
                  const e = ["touchstart", "touchmove", "touchend"];
                  let t = ["mousedown", "mousemove", "mouseup"];
                  return ge.pointerEvents ? t = ["pointerdown", "pointermove", "pointerup"] : ge.prefixedPointerEvents && (t = ["MSPointerDown", "MSPointerMove", "MSPointerUp"]),
                  n.touchEventsTouch = {
                      start: e[0],
                      move: e[1],
                      end: e[2]
                  },
                  n.touchEventsDesktop = {
                      start: t[0],
                      move: t[1],
                      end: t[2]
                  },
                  ge.touch || !n.params.simulateTouch ? n.touchEventsTouch : n.touchEventsDesktop
              }(),
              touchEventsData: {
                  isTouched: void 0,
                  isMoved: void 0,
                  allowTouchCallbacks: void 0,
                  touchStartTime: void 0,
                  isScrolling: void 0,
                  currentTranslate: void 0,
                  startTranslate: void 0,
                  allowThresholdMove: void 0,
                  formElements: "input, select, option, textarea, button, video",
                  lastClickTime: me.now(),
                  clickTimeout: void 0,
                  velocities: [],
                  allowMomentumBounce: void 0,
                  isTouchEvent: void 0,
                  startMoving: void 0
              },
              allowClick: !0,
              allowTouchMove: n.params.allowTouchMove,
              touches: {
                  startX: 0,
                  startY: 0,
                  currentX: 0,
                  currentY: 0,
                  diff: 0
              },
              imagesToLoad: [],
              imagesLoaded: 0
          }),
          n.useModules(),
          n.params.init && n.init(),
          n
      }
      slidesPerViewDynamic() {
          const {params: e, slides: t, slidesGrid: i, size: n, activeIndex: r} = this;
          let o = 1;
          if (e.centeredSlides) {
              let e, i = t[r].swiperSlideSize;
              for (let s = r + 1; s < t.length; s += 1)
                  t[s] && !e && (o += 1,
                  (i += t[s].swiperSlideSize) > n && (e = !0));
              for (let s = r - 1; s >= 0; s -= 1)
                  t[s] && !e && (o += 1,
                  (i += t[s].swiperSlideSize) > n && (e = !0))
          } else
              for (let e = r + 1; e < t.length; e += 1)
                  i[e] - i[r] < n && (o += 1);
          return o
      }
      update() {
          const e = this;
          if (!e || e.destroyed)
              return;
          const {snapGrid: t, params: i} = e;
          function n() {
              const t = e.rtlTranslate ? -1 * e.translate : e.translate
                , i = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
              e.setTranslate(i),
              e.updateActiveIndex(),
              e.updateSlidesClasses()
          }
          let r;
          i.breakpoints && e.setBreakpoint(),
          e.updateSize(),
          e.updateSlides(),
          e.updateProgress(),
          e.updateSlidesClasses(),
          e.params.freeMode ? (n(),
          e.params.autoHeight && e.updateAutoHeight()) : (r = ("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0)) || n(),
          i.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
          e.emit("update")
      }
      init() {
          const e = this;
          e.initialized || (e.emit("beforeInit"),
          e.params.breakpoints && e.setBreakpoint(),
          e.addClasses(),
          e.params.loop && e.loopCreate(),
          e.updateSize(),
          e.updateSlides(),
          e.params.watchOverflow && e.checkOverflow(),
          e.params.grabCursor && e.setGrabCursor(),
          e.params.preloadImages && e.preloadImages(),
          e.params.loop ? e.slideTo(e.params.initialSlide + e.loopedSlides, 0, e.params.runCallbacksOnInit) : e.slideTo(e.params.initialSlide, 0, e.params.runCallbacksOnInit),
          e.attachEvents(),
          e.initialized = !0,
          e.emit("init"))
      }
      destroy(e=!0, t=!0) {
          const i = this
            , {params: n, $el: r, $wrapperEl: o, slides: s} = i;
          return void 0 === i.params || i.destroyed ? null : (i.emit("beforeDestroy"),
          i.initialized = !1,
          i.detachEvents(),
          n.loop && i.loopDestroy(),
          t && (i.removeClasses(),
          r.removeAttr("style"),
          o.removeAttr("style"),
          s && s.length && s.removeClass([n.slideVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index").removeAttr("data-swiper-column").removeAttr("data-swiper-row")),
          i.emit("destroy"),
          Object.keys(i.eventsListeners).forEach(e=>{
              i.off(e)
          }
          ),
          !1 !== e && (i.$el[0].swiper = null,
          i.$el.data("swiper", null),
          me.deleteProps(i)),
          i.destroyed = !0,
          null)
      }
      static extendDefaults(e) {
          me.extend(Me, e)
      }
      static get extendedDefaults() {
          return Me
      }
      static get defaults() {
          return Pe
      }
      static get Class() {
          return ve
      }
      static get$() {
          return de
      }
  }
  var ze = {
      name: "device",
      proto: {
          device: Ee
      },
      static: {
          device: Ee
      }
  }
    , De = {
      name: "support",
      proto: {
          support: ge
      },
      static: {
          support: ge
      }
  }
    , Re = {
      name: "browser",
      proto: {
          browser: Ae
      },
      static: {
          browser: Ae
      }
  }
    , Be = {
      name: "resize",
      create() {
          const e = this;
          me.extend(e, {
              resize: {
                  resizeHandler() {
                      e && !e.destroyed && e.initialized && (e.emit("beforeResize"),
                      e.emit("resize"))
                  },
                  orientationChangeHandler() {
                      e && !e.destroyed && e.initialized && e.emit("orientationchange")
                  }
              }
          })
      },
      on: {
          init() {
              ue.addEventListener("resize", this.resize.resizeHandler),
              ue.addEventListener("orientationchange", this.resize.orientationChangeHandler)
          },
          destroy() {
              ue.removeEventListener("resize", this.resize.resizeHandler),
              ue.removeEventListener("orientationchange", this.resize.orientationChangeHandler)
          }
      }
  };
  const je = {
      func: ue.MutationObserver || ue.WebkitMutationObserver,
      attach(e, t={}) {
          const i = this
            , n = new (0,
          je.func)(e=>{
              if (1 === e.length)
                  return void i.emit("observerUpdate", e[0]);
              const t = function() {
                  i.emit("observerUpdate", e[0])
              };
              ue.requestAnimationFrame ? ue.requestAnimationFrame(t) : ue.setTimeout(t, 0)
          }
          );
          n.observe(e, {
              attributes: void 0 === t.attributes || t.attributes,
              childList: void 0 === t.childList || t.childList,
              characterData: void 0 === t.characterData || t.characterData
          }),
          i.observer.observers.push(n)
      },
      init() {
          const e = this;
          if (ge.observer && e.params.observer) {
              if (e.params.observeParents) {
                  const t = e.$el.parents();
                  for (let i = 0; i < t.length; i += 1)
                      e.observer.attach(t[i])
              }
              e.observer.attach(e.$el[0], {
                  childList: e.params.observeSlideChildren
              }),
              e.observer.attach(e.$wrapperEl[0], {
                  attributes: !1
              })
          }
      },
      destroy() {
          this.observer.observers.forEach(e=>{
              e.disconnect()
          }
          ),
          this.observer.observers = []
      }
  };
  var Fe = {
      name: "observer",
      params: {
          observer: !1,
          observeParents: !1,
          observeSlideChildren: !1
      },
      create() {
          me.extend(this, {
              observer: {
                  init: je.init.bind(this),
                  attach: je.attach.bind(this),
                  destroy: je.destroy.bind(this),
                  observers: []
              }
          })
      },
      on: {
          init() {
              this.observer.init()
          },
          destroy() {
              this.observer.destroy()
          }
      }
  };
  const Ne = {
      update(e) {
          const t = this
            , {slidesPerView: i, slidesPerGroup: n, centeredSlides: r} = t.params
            , {addSlidesBefore: o, addSlidesAfter: s} = t.params.virtual
            , {from: a, to: l, slides: c, slidesGrid: u, renderSlide: h, offset: d} = t.virtual;
          t.updateActiveIndex();
          const p = t.activeIndex || 0;
          let f, m, g;
          f = t.rtlTranslate ? "right" : t.isHorizontal() ? "left" : "top",
          r ? (m = Math.floor(i / 2) + n + o,
          g = Math.floor(i / 2) + n + s) : (m = i + (n - 1) + o,
          g = n + s);
          const v = Math.max((p || 0) - g, 0)
            , y = Math.min((p || 0) + m, c.length - 1)
            , _ = (t.slidesGrid[v] || 0) - (t.slidesGrid[0] || 0);
          function b() {
              t.updateSlides(),
              t.updateProgress(),
              t.updateSlidesClasses(),
              t.lazy && t.params.lazy.enabled && t.lazy.load()
          }
          if (me.extend(t.virtual, {
              from: v,
              to: y,
              offset: _,
              slidesGrid: t.slidesGrid
          }),
          a === v && l === y && !e)
              return t.slidesGrid !== u && _ !== d && t.slides.css(f, `${_}px`),
              void t.updateProgress();
          if (t.params.virtual.renderExternal)
              return t.params.virtual.renderExternal.call(t, {
                  offset: _,
                  from: v,
                  to: y,
                  slides: function() {
                      const e = [];
                      for (let t = v; t <= y; t += 1)
                          e.push(c[t]);
                      return e
                  }()
              }),
              void b();
          const w = []
            , x = [];
          if (e)
              t.$wrapperEl.find(`.${t.params.slideClass}`).remove();
          else
              for (let e = a; e <= l; e += 1)
                  (e < v || e > y) && t.$wrapperEl.find(`.${t.params.slideClass}[data-swiper-slide-index="${e}"]`).remove();
          for (let t = 0; t < c.length; t += 1)
              t >= v && t <= y && (void 0 === l || e ? x.push(t) : (t > l && x.push(t),
              t < a && w.push(t)));
          x.forEach(e=>{
              t.$wrapperEl.append(h(c[e], e))
          }
          ),
          w.sort((e,t)=>t - e).forEach(e=>{
              t.$wrapperEl.prepend(h(c[e], e))
          }
          ),
          t.$wrapperEl.children(".swiper-slide").css(f, `${_}px`),
          b()
      },
      renderSlide(e, t) {
          const i = this
            , n = i.params.virtual;
          if (n.cache && i.virtual.cache[t])
              return i.virtual.cache[t];
          const r = n.renderSlide ? de(n.renderSlide.call(i, e, t)) : de(`<div class="${i.params.slideClass}" data-swiper-slide-index="${t}">${e}</div>`);
          return r.attr("data-swiper-slide-index") || r.attr("data-swiper-slide-index", t),
          n.cache && (i.virtual.cache[t] = r),
          r
      },
      appendSlide(e) {
          this.virtual.slides.push(e),
          this.virtual.update(!0)
      },
      prependSlide(e) {
          const t = this;
          if (t.virtual.slides.unshift(e),
          t.params.virtual.cache) {
              const e = t.virtual.cache
                , i = {};
              Object.keys(e).forEach(t=>{
                  i[t + 1] = e[t]
              }
              ),
              t.virtual.cache = i
          }
          t.virtual.update(!0),
          t.slideNext(0)
      }
  };
  var Ue = {
      name: "virtual",
      params: {
          virtual: {
              enabled: !1,
              slides: [],
              cache: !0,
              renderSlide: null,
              renderExternal: null,
              addSlidesBefore: 0,
              addSlidesAfter: 0
          }
      },
      create() {
          me.extend(this, {
              virtual: {
                  update: Ne.update.bind(this),
                  appendSlide: Ne.appendSlide.bind(this),
                  prependSlide: Ne.prependSlide.bind(this),
                  renderSlide: Ne.renderSlide.bind(this),
                  slides: this.params.virtual.slides,
                  cache: {}
              }
          })
      },
      on: {
          beforeInit() {
              const e = this;
              if (!e.params.virtual.enabled)
                  return;
              e.classNames.push(`${e.params.containerModifierClass}virtual`);
              const t = {
                  watchSlidesProgress: !0
              };
              me.extend(e.params, t),
              me.extend(e.originalParams, t),
              e.params.initialSlide || e.virtual.update()
          },
          setTranslate() {
              this.params.virtual.enabled && this.virtual.update()
          }
      }
  };
  const qe = {
      handle(e) {
          const t = this
            , {rtlTranslate: i} = t;
          let n = e;
          n.originalEvent && (n = n.originalEvent);
          const r = n.keyCode || n.charCode;
          if (!t.allowSlideNext && (t.isHorizontal() && 39 === r || t.isVertical() && 40 === r))
              return !1;
          if (!t.allowSlidePrev && (t.isHorizontal() && 37 === r || t.isVertical() && 38 === r))
              return !1;
          if (!(n.shiftKey || n.altKey || n.ctrlKey || n.metaKey || ce.activeElement && ce.activeElement.nodeName && ("input" === ce.activeElement.nodeName.toLowerCase() || "textarea" === ce.activeElement.nodeName.toLowerCase()))) {
              if (t.params.keyboard.onlyInViewport && (37 === r || 39 === r || 38 === r || 40 === r)) {
                  let e = !1;
                  if (t.$el.parents(`.${t.params.slideClass}`).length > 0 && 0 === t.$el.parents(`.${t.params.slideActiveClass}`).length)
                      return;
                  const n = ue.innerWidth
                    , r = ue.innerHeight
                    , o = t.$el.offset();
                  i && (o.left -= t.$el[0].scrollLeft);
                  const s = [[o.left, o.top], [o.left + t.width, o.top], [o.left, o.top + t.height], [o.left + t.width, o.top + t.height]];
                  for (let t = 0; t < s.length; t += 1) {
                      const i = s[t];
                      i[0] >= 0 && i[0] <= n && i[1] >= 0 && i[1] <= r && (e = !0)
                  }
                  if (!e)
                      return
              }
              t.isHorizontal() ? (37 !== r && 39 !== r || (n.preventDefault ? n.preventDefault() : n.returnValue = !1),
              (39 === r && !i || 37 === r && i) && t.slideNext(),
              (37 === r && !i || 39 === r && i) && t.slidePrev()) : (38 !== r && 40 !== r || (n.preventDefault ? n.preventDefault() : n.returnValue = !1),
              40 === r && t.slideNext(),
              38 === r && t.slidePrev()),
              t.emit("keyPress", r)
          }
      },
      enable() {
          this.keyboard.enabled || (de(ce).on("keydown", this.keyboard.handle),
          this.keyboard.enabled = !0)
      },
      disable() {
          this.keyboard.enabled && (de(ce).off("keydown", this.keyboard.handle),
          this.keyboard.enabled = !1)
      }
  };
  var He = {
      name: "keyboard",
      params: {
          keyboard: {
              enabled: !1,
              onlyInViewport: !0
          }
      },
      create() {
          me.extend(this, {
              keyboard: {
                  enabled: !1,
                  enable: qe.enable.bind(this),
                  disable: qe.disable.bind(this),
                  handle: qe.handle.bind(this)
              }
          })
      },
      on: {
          init() {
              const e = this;
              e.params.keyboard.enabled && e.keyboard.enable()
          },
          destroy() {
              const e = this;
              e.keyboard.enabled && e.keyboard.disable()
          }
      }
  };
  const Ve = {
      lastScrollTime: me.now(),
      event: ue.navigator.userAgent.indexOf("firefox") > -1 ? "DOMMouseScroll" : function() {
          let e = "onwheel"in ce;
          if (!e) {
              const t = ce.createElement("div");
              t.setAttribute("onwheel", "return;"),
              e = "function" == typeof t.onwheel
          }
          return !e && ce.implementation && ce.implementation.hasFeature && !0 !== ce.implementation.hasFeature("", "") && (e = ce.implementation.hasFeature("Events.wheel", "3.0")),
          e
      }() ? "wheel" : "mousewheel",
      normalize(e) {
          let t = 0
            , i = 0
            , n = 0
            , r = 0;
          return "detail"in e && (i = e.detail),
          "wheelDelta"in e && (i = -e.wheelDelta / 120),
          "wheelDeltaY"in e && (i = -e.wheelDeltaY / 120),
          "wheelDeltaX"in e && (t = -e.wheelDeltaX / 120),
          "axis"in e && e.axis === e.HORIZONTAL_AXIS && (t = i,
          i = 0),
          n = 10 * t,
          r = 10 * i,
          "deltaY"in e && (r = e.deltaY),
          "deltaX"in e && (n = e.deltaX),
          (n || r) && e.deltaMode && (1 === e.deltaMode ? (n *= 40,
          r *= 40) : (n *= 800,
          r *= 800)),
          n && !t && (t = n < 1 ? -1 : 1),
          r && !i && (i = r < 1 ? -1 : 1),
          {
              spinX: t,
              spinY: i,
              pixelX: n,
              pixelY: r
          }
      },
      handleMouseEnter() {
          this.mouseEntered = !0
      },
      handleMouseLeave() {
          this.mouseEntered = !1
      },
      handle(e) {
          let t = e;
          const i = this
            , n = i.params.mousewheel;
          if (!i.mouseEntered && !n.releaseOnEdges)
              return !0;
          t.originalEvent && (t = t.originalEvent);
          let r = 0;
          const o = i.rtlTranslate ? -1 : 1
            , s = Ve.normalize(t);
          if (n.forceToAxis)
              if (i.isHorizontal()) {
                  if (!(Math.abs(s.pixelX) > Math.abs(s.pixelY)))
                      return !0;
                  r = s.pixelX * o
              } else {
                  if (!(Math.abs(s.pixelY) > Math.abs(s.pixelX)))
                      return !0;
                  r = s.pixelY
              }
          else
              r = Math.abs(s.pixelX) > Math.abs(s.pixelY) ? -s.pixelX * o : -s.pixelY;
          if (0 === r)
              return !0;
          if (n.invert && (r = -r),
          i.params.freeMode) {
              i.params.loop && i.loopFix();
              let e = i.getTranslate() + r * n.sensitivity;
              const o = i.isBeginning
                , s = i.isEnd;
              if (e >= i.minTranslate() && (e = i.minTranslate()),
              e <= i.maxTranslate() && (e = i.maxTranslate()),
              i.setTransition(0),
              i.setTranslate(e),
              i.updateProgress(),
              i.updateActiveIndex(),
              i.updateSlidesClasses(),
              (!o && i.isBeginning || !s && i.isEnd) && i.updateSlidesClasses(),
              i.params.freeModeSticky && (clearTimeout(i.mousewheel.timeout),
              i.mousewheel.timeout = me.nextTick(()=>{
                  i.slideToClosest()
              }
              , 300)),
              i.emit("scroll", t),
              i.params.autoplay && i.params.autoplayDisableOnInteraction && i.autoplay.stop(),
              e === i.minTranslate() || e === i.maxTranslate())
                  return !0
          } else {
              if (me.now() - i.mousewheel.lastScrollTime > 60)
                  if (r < 0)
                      if (i.isEnd && !i.params.loop || i.animating) {
                          if (n.releaseOnEdges)
                              return !0
                      } else
                          i.slideNext(),
                          i.emit("scroll", t);
                  else if (i.isBeginning && !i.params.loop || i.animating) {
                      if (n.releaseOnEdges)
                          return !0
                  } else
                      i.slidePrev(),
                      i.emit("scroll", t);
              i.mousewheel.lastScrollTime = (new ue.Date).getTime()
          }
          return t.preventDefault ? t.preventDefault() : t.returnValue = !1,
          !1
      },
      enable() {
          const e = this;
          if (!Ve.event)
              return !1;
          if (e.mousewheel.enabled)
              return !1;
          let t = e.$el;
          return "container" !== e.params.mousewheel.eventsTarged && (t = de(e.params.mousewheel.eventsTarged)),
          t.on("mouseenter", e.mousewheel.handleMouseEnter),
          t.on("mouseleave", e.mousewheel.handleMouseLeave),
          t.on(Ve.event, e.mousewheel.handle),
          e.mousewheel.enabled = !0,
          !0
      },
      disable() {
          const e = this;
          if (!Ve.event)
              return !1;
          if (!e.mousewheel.enabled)
              return !1;
          let t = e.$el;
          return "container" !== e.params.mousewheel.eventsTarged && (t = de(e.params.mousewheel.eventsTarged)),
          t.off(Ve.event, e.mousewheel.handle),
          e.mousewheel.enabled = !1,
          !0
      }
  };
  const We = {
      update() {
          const e = this
            , t = e.params.navigation;
          if (e.params.loop)
              return;
          const {$nextEl: i, $prevEl: n} = e.navigation;
          n && n.length > 0 && (e.isBeginning ? n.addClass(t.disabledClass) : n.removeClass(t.disabledClass),
          n[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass)),
          i && i.length > 0 && (e.isEnd ? i.addClass(t.disabledClass) : i.removeClass(t.disabledClass),
          i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass))
      },
      onPrevClick(e) {
          e.preventDefault(),
          this.isBeginning && !this.params.loop || this.slidePrev()
      },
      onNextClick(e) {
          e.preventDefault(),
          this.isEnd && !this.params.loop || this.slideNext()
      },
      init() {
          const e = this
            , t = e.params.navigation;
          if (!t.nextEl && !t.prevEl)
              return;
          let i, n;
          t.nextEl && (i = de(t.nextEl),
          e.params.uniqueNavElements && "string" == typeof t.nextEl && i.length > 1 && 1 === e.$el.find(t.nextEl).length && (i = e.$el.find(t.nextEl))),
          t.prevEl && (n = de(t.prevEl),
          e.params.uniqueNavElements && "string" == typeof t.prevEl && n.length > 1 && 1 === e.$el.find(t.prevEl).length && (n = e.$el.find(t.prevEl))),
          i && i.length > 0 && i.on("click", e.navigation.onNextClick),
          n && n.length > 0 && n.on("click", e.navigation.onPrevClick),
          me.extend(e.navigation, {
              $nextEl: i,
              nextEl: i && i[0],
              $prevEl: n,
              prevEl: n && n[0]
          })
      },
      destroy() {
          const e = this
            , {$nextEl: t, $prevEl: i} = e.navigation;
          t && t.length && (t.off("click", e.navigation.onNextClick),
          t.removeClass(e.params.navigation.disabledClass)),
          i && i.length && (i.off("click", e.navigation.onPrevClick),
          i.removeClass(e.params.navigation.disabledClass))
      }
  };
  const $e = {
      update() {
          const e = this
            , t = e.rtl
            , i = e.params.pagination;
          if (!i.el || !e.pagination.el || !e.pagination.$el || 0 === e.pagination.$el.length)
              return;
          const n = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length
            , r = e.pagination.$el;
          let o;
          const s = e.params.loop ? Math.ceil((n - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
          if (e.params.loop ? ((o = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)) > n - 1 - 2 * e.loopedSlides && (o -= n - 2 * e.loopedSlides),
          o > s - 1 && (o -= s),
          o < 0 && "bullets" !== e.params.paginationType && (o = s + o)) : o = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0,
          "bullets" === i.type && e.pagination.bullets && e.pagination.bullets.length > 0) {
              const n = e.pagination.bullets;
              let s, a, l;
              if (i.dynamicBullets && (e.pagination.bulletSize = n.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0),
              r.css(e.isHorizontal() ? "width" : "height", `${e.pagination.bulletSize * (i.dynamicMainBullets + 4)}px`),
              i.dynamicMainBullets > 1 && void 0 !== e.previousIndex && (e.pagination.dynamicBulletIndex += o - e.previousIndex,
              e.pagination.dynamicBulletIndex > i.dynamicMainBullets - 1 ? e.pagination.dynamicBulletIndex = i.dynamicMainBullets - 1 : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)),
              s = o - e.pagination.dynamicBulletIndex,
              l = ((a = s + (Math.min(n.length, i.dynamicMainBullets) - 1)) + s) / 2),
              n.removeClass(`${i.bulletActiveClass} ${i.bulletActiveClass}-next ${i.bulletActiveClass}-next-next ${i.bulletActiveClass}-prev ${i.bulletActiveClass}-prev-prev ${i.bulletActiveClass}-main`),
              r.length > 1)
                  n.each((e,t)=>{
                      const n = de(t)
                        , r = n.index();
                      r === o && n.addClass(i.bulletActiveClass),
                      i.dynamicBullets && (r >= s && r <= a && n.addClass(`${i.bulletActiveClass}-main`),
                      r === s && n.prev().addClass(`${i.bulletActiveClass}-prev`).prev().addClass(`${i.bulletActiveClass}-prev-prev`),
                      r === a && n.next().addClass(`${i.bulletActiveClass}-next`).next().addClass(`${i.bulletActiveClass}-next-next`))
                  }
                  );
              else {
                  if (n.eq(o).addClass(i.bulletActiveClass),
                  i.dynamicBullets) {
                      const e = n.eq(s)
                        , t = n.eq(a);
                      for (let e = s; e <= a; e += 1)
                          n.eq(e).addClass(`${i.bulletActiveClass}-main`);
                      e.prev().addClass(`${i.bulletActiveClass}-prev`).prev().addClass(`${i.bulletActiveClass}-prev-prev`),
                      t.next().addClass(`${i.bulletActiveClass}-next`).next().addClass(`${i.bulletActiveClass}-next-next`)
                  }
              }
              if (i.dynamicBullets) {
                  const r = Math.min(n.length, i.dynamicMainBullets + 4)
                    , o = (e.pagination.bulletSize * r - e.pagination.bulletSize) / 2 - l * e.pagination.bulletSize
                    , s = t ? "right" : "left";
                  n.css(e.isHorizontal() ? s : "top", `${o}px`)
              }
          }
          if ("fraction" === i.type && (r.find(`.${i.currentClass}`).text(i.formatFractionCurrent(o + 1)),
          r.find(`.${i.totalClass}`).text(i.formatFractionTotal(s))),
          "progressbar" === i.type) {
              let t;
              t = i.progressbarOpposite ? e.isHorizontal() ? "vertical" : "horizontal" : e.isHorizontal() ? "horizontal" : "vertical";
              const n = (o + 1) / s;
              let a = 1
                , l = 1;
              "horizontal" === t ? a = n : l = n,
              r.find(`.${i.progressbarFillClass}`).transform(`translate3d(0,0,0) scaleX(${a}) scaleY(${l})`).transition(e.params.speed)
          }
          "custom" === i.type && i.renderCustom ? (r.html(i.renderCustom(e, o + 1, s)),
          e.emit("paginationRender", e, r[0])) : e.emit("paginationUpdate", e, r[0]),
          r[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](i.lockClass)
      },
      render() {
          const e = this
            , t = e.params.pagination;
          if (!t.el || !e.pagination.el || !e.pagination.$el || 0 === e.pagination.$el.length)
              return;
          const i = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length
            , n = e.pagination.$el;
          let r = "";
          if ("bullets" === t.type) {
              const o = e.params.loop ? Math.ceil((i - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
              for (let i = 0; i < o; i += 1)
                  t.renderBullet ? r += t.renderBullet.call(e, i, t.bulletClass) : r += `<${t.bulletElement} class="${t.bulletClass}"></${t.bulletElement}>`;
              n.html(r),
              e.pagination.bullets = n.find(`.${t.bulletClass}`)
          }
          "fraction" === t.type && (r = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : `<span class="${t.currentClass}"></span>` + " / " + `<span class="${t.totalClass}"></span>`,
          n.html(r)),
          "progressbar" === t.type && (r = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : `<span class="${t.progressbarFillClass}"></span>`,
          n.html(r)),
          "custom" !== t.type && e.emit("paginationRender", e.pagination.$el[0])
      },
      init() {
          const e = this
            , t = e.params.pagination;
          if (!t.el)
              return;
          let i = de(t.el);
          0 !== i.length && (e.params.uniqueNavElements && "string" == typeof t.el && i.length > 1 && 1 === e.$el.find(t.el).length && (i = e.$el.find(t.el)),
          "bullets" === t.type && t.clickable && i.addClass(t.clickableClass),
          i.addClass(t.modifierClass + t.type),
          "bullets" === t.type && t.dynamicBullets && (i.addClass(`${t.modifierClass}${t.type}-dynamic`),
          e.pagination.dynamicBulletIndex = 0,
          t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
          "progressbar" === t.type && t.progressbarOpposite && i.addClass(t.progressbarOppositeClass),
          t.clickable && i.on("click", `.${t.bulletClass}`, function(t) {
              t.preventDefault();
              let i = de(this).index() * e.params.slidesPerGroup;
              e.params.loop && (i += e.loopedSlides),
              e.slideTo(i)
          }),
          me.extend(e.pagination, {
              $el: i,
              el: i[0]
          }))
      },
      destroy() {
          const e = this.params.pagination;
          if (!e.el || !this.pagination.el || !this.pagination.$el || 0 === this.pagination.$el.length)
              return;
          const t = this.pagination.$el;
          t.removeClass(e.hiddenClass),
          t.removeClass(e.modifierClass + e.type),
          this.pagination.bullets && this.pagination.bullets.removeClass(e.bulletActiveClass),
          e.clickable && t.off("click", `.${e.bulletClass}`)
      }
  };
  const Ge = {
      setTranslate() {
          const e = this;
          if (!e.params.scrollbar.el || !e.scrollbar.el)
              return;
          const {scrollbar: t, rtlTranslate: i, progress: n} = e
            , {dragSize: r, trackSize: o, $dragEl: s, $el: a} = t
            , l = e.params.scrollbar;
          let c = r
            , u = (o - r) * n;
          i ? (u = -u) > 0 ? (c = r - u,
          u = 0) : -u + r > o && (c = o + u) : u < 0 ? (c = r + u,
          u = 0) : u + r > o && (c = o - u),
          e.isHorizontal() ? (ge.transforms3d ? s.transform(`translate3d(${u}px, 0, 0)`) : s.transform(`translateX(${u}px)`),
          s[0].style.width = `${c}px`) : (ge.transforms3d ? s.transform(`translate3d(0px, ${u}px, 0)`) : s.transform(`translateY(${u}px)`),
          s[0].style.height = `${c}px`),
          l.hide && (clearTimeout(e.scrollbar.timeout),
          a[0].style.opacity = 1,
          e.scrollbar.timeout = setTimeout(()=>{
              a[0].style.opacity = 0,
              a.transition(400)
          }
          , 1e3))
      },
      setTransition(e) {
          this.params.scrollbar.el && this.scrollbar.el && this.scrollbar.$dragEl.transition(e)
      },
      updateSize() {
          const e = this;
          if (!e.params.scrollbar.el || !e.scrollbar.el)
              return;
          const {scrollbar: t} = e
            , {$dragEl: i, $el: n} = t;
          i[0].style.width = "",
          i[0].style.height = "";
          const r = e.isHorizontal() ? n[0].offsetWidth : n[0].offsetHeight
            , o = e.size / e.virtualSize
            , s = o * (r / e.size);
          let a;
          a = "auto" === e.params.scrollbar.dragSize ? r * o : parseInt(e.params.scrollbar.dragSize, 10),
          e.isHorizontal() ? i[0].style.width = `${a}px` : i[0].style.height = `${a}px`,
          n[0].style.display = o >= 1 ? "none" : "",
          e.params.scrollbarHide && (n[0].style.opacity = 0),
          me.extend(t, {
              trackSize: r,
              divider: o,
              moveDivider: s,
              dragSize: a
          }),
          t.$el[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](e.params.scrollbar.lockClass)
      },
      setDragPosition(e) {
          const {scrollbar: t, rtlTranslate: i} = this
            , {$el: n, dragSize: r, trackSize: o} = t;
          let s, a;
          a = ((s = this.isHorizontal() ? "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX || e.clientX : "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY || e.clientY) - n.offset()[this.isHorizontal() ? "left" : "top"] - r / 2) / (o - r),
          a = Math.max(Math.min(a, 1), 0),
          i && (a = 1 - a);
          const l = this.minTranslate() + (this.maxTranslate() - this.minTranslate()) * a;
          this.updateProgress(l),
          this.setTranslate(l),
          this.updateActiveIndex(),
          this.updateSlidesClasses()
      },
      onDragStart(e) {
          const t = this.params.scrollbar
            , {scrollbar: i, $wrapperEl: n} = this
            , {$el: r, $dragEl: o} = i;
          this.scrollbar.isTouched = !0,
          e.preventDefault(),
          e.stopPropagation(),
          n.transition(100),
          o.transition(100),
          i.setDragPosition(e),
          clearTimeout(this.scrollbar.dragTimeout),
          r.transition(0),
          t.hide && r.css("opacity", 1),
          this.emit("scrollbarDragStart", e)
      },
      onDragMove(e) {
          const {scrollbar: t, $wrapperEl: i} = this
            , {$el: n, $dragEl: r} = t;
          this.scrollbar.isTouched && (e.preventDefault ? e.preventDefault() : e.returnValue = !1,
          t.setDragPosition(e),
          i.transition(0),
          n.transition(0),
          r.transition(0),
          this.emit("scrollbarDragMove", e))
      },
      onDragEnd(e) {
          const t = this
            , i = t.params.scrollbar
            , {scrollbar: n} = t
            , {$el: r} = n;
          t.scrollbar.isTouched && (t.scrollbar.isTouched = !1,
          i.hide && (clearTimeout(t.scrollbar.dragTimeout),
          t.scrollbar.dragTimeout = me.nextTick(()=>{
              r.css("opacity", 0),
              r.transition(400)
          }
          , 1e3)),
          t.emit("scrollbarDragEnd", e),
          i.snapOnRelease && t.slideToClosest())
      },
      enableDraggable() {
          const e = this;
          if (!e.params.scrollbar.el)
              return;
          const {scrollbar: t, touchEventsTouch: i, touchEventsDesktop: n, params: r} = e
            , o = t.$el[0]
            , s = !(!ge.passiveListener || !r.passiveListeners) && {
              passive: !1,
              capture: !1
          }
            , a = !(!ge.passiveListener || !r.passiveListeners) && {
              passive: !0,
              capture: !1
          };
          ge.touch ? (o.addEventListener(i.start, e.scrollbar.onDragStart, s),
          o.addEventListener(i.move, e.scrollbar.onDragMove, s),
          o.addEventListener(i.end, e.scrollbar.onDragEnd, a)) : (o.addEventListener(n.start, e.scrollbar.onDragStart, s),
          ce.addEventListener(n.move, e.scrollbar.onDragMove, s),
          ce.addEventListener(n.end, e.scrollbar.onDragEnd, a))
      },
      disableDraggable() {
          const e = this;
          if (!e.params.scrollbar.el)
              return;
          const {scrollbar: t, touchEventsTouch: i, touchEventsDesktop: n, params: r} = e
            , o = t.$el[0]
            , s = !(!ge.passiveListener || !r.passiveListeners) && {
              passive: !1,
              capture: !1
          }
            , a = !(!ge.passiveListener || !r.passiveListeners) && {
              passive: !0,
              capture: !1
          };
          ge.touch ? (o.removeEventListener(i.start, e.scrollbar.onDragStart, s),
          o.removeEventListener(i.move, e.scrollbar.onDragMove, s),
          o.removeEventListener(i.end, e.scrollbar.onDragEnd, a)) : (o.removeEventListener(n.start, e.scrollbar.onDragStart, s),
          ce.removeEventListener(n.move, e.scrollbar.onDragMove, s),
          ce.removeEventListener(n.end, e.scrollbar.onDragEnd, a))
      },
      init() {
          const e = this;
          if (!e.params.scrollbar.el)
              return;
          const {scrollbar: t, $el: i} = e
            , n = e.params.scrollbar;
          let r = de(n.el);
          e.params.uniqueNavElements && "string" == typeof n.el && r.length > 1 && 1 === i.find(n.el).length && (r = i.find(n.el));
          let o = r.find(`.${e.params.scrollbar.dragClass}`);
          0 === o.length && (o = de(`<div class="${e.params.scrollbar.dragClass}"></div>`),
          r.append(o)),
          me.extend(t, {
              $el: r,
              el: r[0],
              $dragEl: o,
              dragEl: o[0]
          }),
          n.draggable && t.enableDraggable()
      },
      destroy() {
          this.scrollbar.disableDraggable()
      }
  };
  const Xe = {
      setTransform(e, t) {
          const {rtl: i} = this
            , n = de(e)
            , r = i ? -1 : 1
            , o = n.attr("data-swiper-parallax") || "0";
          let s = n.attr("data-swiper-parallax-x")
            , a = n.attr("data-swiper-parallax-y");
          const l = n.attr("data-swiper-parallax-scale")
            , c = n.attr("data-swiper-parallax-opacity");
          if (s || a ? (s = s || "0",
          a = a || "0") : this.isHorizontal() ? (s = o,
          a = "0") : (a = o,
          s = "0"),
          s = s.indexOf("%") >= 0 ? `${parseInt(s, 10) * t * r}%` : `${s * t * r}px`,
          a = a.indexOf("%") >= 0 ? `${parseInt(a, 10) * t}%` : `${a * t}px`,
          null != c) {
              const e = c - (c - 1) * (1 - Math.abs(t));
              n[0].style.opacity = e
          }
          if (null == l)
              n.transform(`translate3d(${s}, ${a}, 0px)`);
          else {
              const e = l - (l - 1) * (1 - Math.abs(t));
              n.transform(`translate3d(${s}, ${a}, 0px) scale(${e})`)
          }
      },
      setTranslate() {
          const e = this
            , {$el: t, slides: i, progress: n, snapGrid: r} = e;
          t.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each((t,i)=>{
              e.parallax.setTransform(i, n)
          }
          ),
          i.each((t,i)=>{
              let o = i.progress;
              e.params.slidesPerGroup > 1 && "auto" !== e.params.slidesPerView && (o += Math.ceil(t / 2) - n * (r.length - 1)),
              o = Math.min(Math.max(o, -1), 1),
              de(i).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each((t,i)=>{
                  e.parallax.setTransform(i, o)
              }
              )
          }
          )
      },
      setTransition(e=this.params.speed) {
          const {$el: t} = this;
          t.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each((t,i)=>{
              const n = de(i);
              let r = parseInt(n.attr("data-swiper-parallax-duration"), 10) || e;
              0 === e && (r = 0),
              n.transition(r)
          }
          )
      }
  };
  const Ze = {
      getDistanceBetweenTouches(e) {
          if (e.targetTouches.length < 2)
              return 1;
          const t = e.targetTouches[0].pageX
            , i = e.targetTouches[0].pageY
            , n = e.targetTouches[1].pageX
            , r = e.targetTouches[1].pageY;
          return Math.sqrt((n - t) ** 2 + (r - i) ** 2)
      },
      onGestureStart(e) {
          const t = this
            , i = t.params.zoom
            , n = t.zoom
            , {gesture: r} = n;
          if (n.fakeGestureTouched = !1,
          n.fakeGestureMoved = !1,
          !ge.gestures) {
              if ("touchstart" !== e.type || "touchstart" === e.type && e.targetTouches.length < 2)
                  return;
              n.fakeGestureTouched = !0,
              r.scaleStart = Ze.getDistanceBetweenTouches(e)
          }
          r.$slideEl && r.$slideEl.length || (r.$slideEl = de(e.target).closest(".swiper-slide"),
          0 === r.$slideEl.length && (r.$slideEl = t.slides.eq(t.activeIndex)),
          r.$imageEl = r.$slideEl.find("img, svg, canvas"),
          r.$imageWrapEl = r.$imageEl.parent(`.${i.containerClass}`),
          r.maxRatio = r.$imageWrapEl.attr("data-swiper-zoom") || i.maxRatio,
          0 !== r.$imageWrapEl.length) ? (r.$imageEl.transition(0),
          t.zoom.isScaling = !0) : r.$imageEl = void 0
      },
      onGestureChange(e) {
          const t = this.params.zoom
            , i = this.zoom
            , {gesture: n} = i;
          if (!ge.gestures) {
              if ("touchmove" !== e.type || "touchmove" === e.type && e.targetTouches.length < 2)
                  return;
              i.fakeGestureMoved = !0,
              n.scaleMove = Ze.getDistanceBetweenTouches(e)
          }
          n.$imageEl && 0 !== n.$imageEl.length && (ge.gestures ? i.scale = e.scale * i.currentScale : i.scale = n.scaleMove / n.scaleStart * i.currentScale,
          i.scale > n.maxRatio && (i.scale = n.maxRatio - 1 + (i.scale - n.maxRatio + 1) ** .5),
          i.scale < t.minRatio && (i.scale = t.minRatio + 1 - (t.minRatio - i.scale + 1) ** .5),
          n.$imageEl.transform(`translate3d(0,0,0) scale(${i.scale})`))
      },
      onGestureEnd(e) {
          const t = this.params.zoom
            , i = this.zoom
            , {gesture: n} = i;
          if (!ge.gestures) {
              if (!i.fakeGestureTouched || !i.fakeGestureMoved)
                  return;
              if ("touchend" !== e.type || "touchend" === e.type && e.changedTouches.length < 2 && !Ee.android)
                  return;
              i.fakeGestureTouched = !1,
              i.fakeGestureMoved = !1
          }
          n.$imageEl && 0 !== n.$imageEl.length && (i.scale = Math.max(Math.min(i.scale, n.maxRatio), t.minRatio),
          n.$imageEl.transition(this.params.speed).transform(`translate3d(0,0,0) scale(${i.scale})`),
          i.currentScale = i.scale,
          i.isScaling = !1,
          1 === i.scale && (n.$slideEl = void 0))
      },
      onTouchStart(e) {
          const t = this.zoom
            , {gesture: i, image: n} = t;
          i.$imageEl && 0 !== i.$imageEl.length && (n.isTouched || (Ee.android && e.preventDefault(),
          n.isTouched = !0,
          n.touchesStart.x = "touchstart" === e.type ? e.targetTouches[0].pageX : e.pageX,
          n.touchesStart.y = "touchstart" === e.type ? e.targetTouches[0].pageY : e.pageY))
      },
      onTouchMove(e) {
          const t = this
            , i = t.zoom
            , {gesture: n, image: r, velocity: o} = i;
          if (!n.$imageEl || 0 === n.$imageEl.length)
              return;
          if (t.allowClick = !1,
          !r.isTouched || !n.$slideEl)
              return;
          r.isMoved || (r.width = n.$imageEl[0].offsetWidth,
          r.height = n.$imageEl[0].offsetHeight,
          r.startX = me.getTranslate(n.$imageWrapEl[0], "x") || 0,
          r.startY = me.getTranslate(n.$imageWrapEl[0], "y") || 0,
          n.slideWidth = n.$slideEl[0].offsetWidth,
          n.slideHeight = n.$slideEl[0].offsetHeight,
          n.$imageWrapEl.transition(0),
          t.rtl && (r.startX = -r.startX,
          r.startY = -r.startY));
          const s = r.width * i.scale
            , a = r.height * i.scale;
          if (!(s < n.slideWidth && a < n.slideHeight)) {
              if (r.minX = Math.min(n.slideWidth / 2 - s / 2, 0),
              r.maxX = -r.minX,
              r.minY = Math.min(n.slideHeight / 2 - a / 2, 0),
              r.maxY = -r.minY,
              r.touchesCurrent.x = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX,
              r.touchesCurrent.y = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY,
              !r.isMoved && !i.isScaling) {
                  if (t.isHorizontal() && (Math.floor(r.minX) === Math.floor(r.startX) && r.touchesCurrent.x < r.touchesStart.x || Math.floor(r.maxX) === Math.floor(r.startX) && r.touchesCurrent.x > r.touchesStart.x))
                      return void (r.isTouched = !1);
                  if (!t.isHorizontal() && (Math.floor(r.minY) === Math.floor(r.startY) && r.touchesCurrent.y < r.touchesStart.y || Math.floor(r.maxY) === Math.floor(r.startY) && r.touchesCurrent.y > r.touchesStart.y))
                      return void (r.isTouched = !1)
              }
              e.preventDefault(),
              e.stopPropagation(),
              r.isMoved = !0,
              r.currentX = r.touchesCurrent.x - r.touchesStart.x + r.startX,
              r.currentY = r.touchesCurrent.y - r.touchesStart.y + r.startY,
              r.currentX < r.minX && (r.currentX = r.minX + 1 - (r.minX - r.currentX + 1) ** .8),
              r.currentX > r.maxX && (r.currentX = r.maxX - 1 + (r.currentX - r.maxX + 1) ** .8),
              r.currentY < r.minY && (r.currentY = r.minY + 1 - (r.minY - r.currentY + 1) ** .8),
              r.currentY > r.maxY && (r.currentY = r.maxY - 1 + (r.currentY - r.maxY + 1) ** .8),
              o.prevPositionX || (o.prevPositionX = r.touchesCurrent.x),
              o.prevPositionY || (o.prevPositionY = r.touchesCurrent.y),
              o.prevTime || (o.prevTime = Date.now()),
              o.x = (r.touchesCurrent.x - o.prevPositionX) / (Date.now() - o.prevTime) / 2,
              o.y = (r.touchesCurrent.y - o.prevPositionY) / (Date.now() - o.prevTime) / 2,
              Math.abs(r.touchesCurrent.x - o.prevPositionX) < 2 && (o.x = 0),
              Math.abs(r.touchesCurrent.y - o.prevPositionY) < 2 && (o.y = 0),
              o.prevPositionX = r.touchesCurrent.x,
              o.prevPositionY = r.touchesCurrent.y,
              o.prevTime = Date.now(),
              n.$imageWrapEl.transform(`translate3d(${r.currentX}px, ${r.currentY}px,0)`)
          }
      },
      onTouchEnd() {
          const e = this.zoom
            , {gesture: t, image: i, velocity: n} = e;
          if (!t.$imageEl || 0 === t.$imageEl.length)
              return;
          if (!i.isTouched || !i.isMoved)
              return i.isTouched = !1,
              void (i.isMoved = !1);
          i.isTouched = !1,
          i.isMoved = !1;
          let r = 300
            , o = 300;
          const s = n.x * r
            , a = i.currentX + s
            , l = n.y * o
            , c = i.currentY + l;
          0 !== n.x && (r = Math.abs((a - i.currentX) / n.x)),
          0 !== n.y && (o = Math.abs((c - i.currentY) / n.y));
          const u = Math.max(r, o);
          i.currentX = a,
          i.currentY = c;
          const h = i.width * e.scale
            , d = i.height * e.scale;
          i.minX = Math.min(t.slideWidth / 2 - h / 2, 0),
          i.maxX = -i.minX,
          i.minY = Math.min(t.slideHeight / 2 - d / 2, 0),
          i.maxY = -i.minY,
          i.currentX = Math.max(Math.min(i.currentX, i.maxX), i.minX),
          i.currentY = Math.max(Math.min(i.currentY, i.maxY), i.minY),
          t.$imageWrapEl.transition(u).transform(`translate3d(${i.currentX}px, ${i.currentY}px,0)`)
      },
      onTransitionEnd() {
          const e = this.zoom
            , {gesture: t} = e;
          t.$slideEl && this.previousIndex !== this.activeIndex && (t.$imageEl.transform("translate3d(0,0,0) scale(1)"),
          t.$imageWrapEl.transform("translate3d(0,0,0)"),
          e.scale = 1,
          e.currentScale = 1,
          t.$slideEl = void 0,
          t.$imageEl = void 0,
          t.$imageWrapEl = void 0)
      },
      toggle(e) {
          const t = this.zoom;
          t.scale && 1 !== t.scale ? t.out() : t.in(e)
      },
      in(e) {
          const t = this
            , i = t.zoom
            , n = t.params.zoom
            , {gesture: r, image: o} = i;
          if (r.$slideEl || (r.$slideEl = t.clickedSlide ? de(t.clickedSlide) : t.slides.eq(t.activeIndex),
          r.$imageEl = r.$slideEl.find("img, svg, canvas"),
          r.$imageWrapEl = r.$imageEl.parent(`.${n.containerClass}`)),
          !r.$imageEl || 0 === r.$imageEl.length)
              return;
          let s, a, l, c, u, h, d, p, f, m, g, v, y, _, b, w, x, k;
          r.$slideEl.addClass(`${n.zoomedSlideClass}`),
          void 0 === o.touchesStart.x && e ? (s = "touchend" === e.type ? e.changedTouches[0].pageX : e.pageX,
          a = "touchend" === e.type ? e.changedTouches[0].pageY : e.pageY) : (s = o.touchesStart.x,
          a = o.touchesStart.y),
          i.scale = r.$imageWrapEl.attr("data-swiper-zoom") || n.maxRatio,
          i.currentScale = r.$imageWrapEl.attr("data-swiper-zoom") || n.maxRatio,
          e ? (x = r.$slideEl[0].offsetWidth,
          k = r.$slideEl[0].offsetHeight,
          u = (l = r.$slideEl.offset().left) + x / 2 - s,
          h = (c = r.$slideEl.offset().top) + k / 2 - a,
          f = r.$imageEl[0].offsetWidth,
          m = r.$imageEl[0].offsetHeight,
          g = f * i.scale,
          v = m * i.scale,
          b = -(y = Math.min(x / 2 - g / 2, 0)),
          w = -(_ = Math.min(k / 2 - v / 2, 0)),
          (d = u * i.scale) < y && (d = y),
          d > b && (d = b),
          (p = h * i.scale) < _ && (p = _),
          p > w && (p = w)) : (d = 0,
          p = 0),
          r.$imageWrapEl.transition(300).transform(`translate3d(${d}px, ${p}px,0)`),
          r.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${i.scale})`)
      },
      out() {
          const e = this
            , t = e.zoom
            , i = e.params.zoom
            , {gesture: n} = t;
          n.$slideEl || (n.$slideEl = e.clickedSlide ? de(e.clickedSlide) : e.slides.eq(e.activeIndex),
          n.$imageEl = n.$slideEl.find("img, svg, canvas"),
          n.$imageWrapEl = n.$imageEl.parent(`.${i.containerClass}`)),
          n.$imageEl && 0 !== n.$imageEl.length && (t.scale = 1,
          t.currentScale = 1,
          n.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
          n.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),
          n.$slideEl.removeClass(`${i.zoomedSlideClass}`),
          n.$slideEl = void 0)
      },
      enable() {
          const e = this
            , t = e.zoom;
          if (t.enabled)
              return;
          t.enabled = !0;
          const i = !("touchstart" !== e.touchEvents.start || !ge.passiveListener || !e.params.passiveListeners) && {
              passive: !0,
              capture: !1
          };
          ge.gestures ? (e.$wrapperEl.on("gesturestart", ".swiper-slide", t.onGestureStart, i),
          e.$wrapperEl.on("gesturechange", ".swiper-slide", t.onGestureChange, i),
          e.$wrapperEl.on("gestureend", ".swiper-slide", t.onGestureEnd, i)) : "touchstart" === e.touchEvents.start && (e.$wrapperEl.on(e.touchEvents.start, ".swiper-slide", t.onGestureStart, i),
          e.$wrapperEl.on(e.touchEvents.move, ".swiper-slide", t.onGestureChange, i),
          e.$wrapperEl.on(e.touchEvents.end, ".swiper-slide", t.onGestureEnd, i)),
          e.$wrapperEl.on(e.touchEvents.move, `.${e.params.zoom.containerClass}`, t.onTouchMove)
      },
      disable() {
          const e = this
            , t = e.zoom;
          if (!t.enabled)
              return;
          e.zoom.enabled = !1;
          const i = !("touchstart" !== e.touchEvents.start || !ge.passiveListener || !e.params.passiveListeners) && {
              passive: !0,
              capture: !1
          };
          ge.gestures ? (e.$wrapperEl.off("gesturestart", ".swiper-slide", t.onGestureStart, i),
          e.$wrapperEl.off("gesturechange", ".swiper-slide", t.onGestureChange, i),
          e.$wrapperEl.off("gestureend", ".swiper-slide", t.onGestureEnd, i)) : "touchstart" === e.touchEvents.start && (e.$wrapperEl.off(e.touchEvents.start, ".swiper-slide", t.onGestureStart, i),
          e.$wrapperEl.off(e.touchEvents.move, ".swiper-slide", t.onGestureChange, i),
          e.$wrapperEl.off(e.touchEvents.end, ".swiper-slide", t.onGestureEnd, i)),
          e.$wrapperEl.off(e.touchEvents.move, `.${e.params.zoom.containerClass}`, t.onTouchMove)
      }
  };
  const Ye = {
      loadInSlide(e, t=!0) {
          const i = this
            , n = i.params.lazy;
          if (void 0 === e)
              return;
          if (0 === i.slides.length)
              return;
          const r = i.virtual && i.params.virtual.enabled ? i.$wrapperEl.children(`.${i.params.slideClass}[data-swiper-slide-index="${e}"]`) : i.slides.eq(e);
          let o = r.find(`.${n.elementClass}:not(.${n.loadedClass}):not(.${n.loadingClass})`);
          !r.hasClass(n.elementClass) || r.hasClass(n.loadedClass) || r.hasClass(n.loadingClass) || (o = o.add(r[0])),
          0 !== o.length && o.each((e,o)=>{
              const s = de(o);
              s.addClass(n.loadingClass);
              const a = s.attr("data-background")
                , l = s.attr("data-src")
                , c = s.attr("data-srcset")
                , u = s.attr("data-sizes");
              i.loadImage(s[0], l || a, c, u, !1, ()=>{
                  if (null != i && i && (!i || i.params) && !i.destroyed) {
                      if (a ? (s.css("background-image", `url("${a}")`),
                      s.removeAttr("data-background")) : (c && (s.attr("srcset", c),
                      s.removeAttr("data-srcset")),
                      u && (s.attr("sizes", u),
                      s.removeAttr("data-sizes")),
                      l && (s.attr("src", l),
                      s.removeAttr("data-src"))),
                      s.addClass(n.loadedClass).removeClass(n.loadingClass),
                      r.find(`.${n.preloaderClass}`).remove(),
                      i.params.loop && t) {
                          const e = r.attr("data-swiper-slide-index");
                          if (r.hasClass(i.params.slideDuplicateClass)) {
                              const t = i.$wrapperEl.children(`[data-swiper-slide-index="${e}"]:not(.${i.params.slideDuplicateClass})`);
                              i.lazy.loadInSlide(t.index(), !1)
                          } else {
                              const t = i.$wrapperEl.children(`.${i.params.slideDuplicateClass}[data-swiper-slide-index="${e}"]`);
                              i.lazy.loadInSlide(t.index(), !1)
                          }
                      }
                      i.emit("lazyImageReady", r[0], s[0])
                  }
              }
              ),
              i.emit("lazyImageLoad", r[0], s[0])
          }
          )
      },
      load() {
          const e = this
            , {$wrapperEl: t, params: i, slides: n, activeIndex: r} = e
            , o = e.virtual && i.virtual.enabled
            , s = i.lazy;
          let a = i.slidesPerView;
          function l(e) {
              if (o) {
                  if (t.children(`.${i.slideClass}[data-swiper-slide-index="${e}"]`).length)
                      return !0
              } else if (n[e])
                  return !0;
              return !1
          }
          function c(e) {
              return o ? de(e).attr("data-swiper-slide-index") : de(e).index()
          }
          if ("auto" === a && (a = 0),
          e.lazy.initialImageLoaded || (e.lazy.initialImageLoaded = !0),
          e.params.watchSlidesVisibility)
              t.children(`.${i.slideVisibleClass}`).each((t,i)=>{
                  const n = o ? de(i).attr("data-swiper-slide-index") : de(i).index();
                  e.lazy.loadInSlide(n)
              }
              );
          else if (a > 1)
              for (let t = r; t < r + a; t += 1)
                  l(t) && e.lazy.loadInSlide(t);
          else
              e.lazy.loadInSlide(r);
          if (s.loadPrevNext)
              if (a > 1 || s.loadPrevNextAmount && s.loadPrevNextAmount > 1) {
                  const t = s.loadPrevNextAmount
                    , i = a
                    , o = Math.min(r + i + Math.max(t, i), n.length)
                    , c = Math.max(r - Math.max(i, t), 0);
                  for (let t = r + a; t < o; t += 1)
                      l(t) && e.lazy.loadInSlide(t);
                  for (let t = c; t < r; t += 1)
                      l(t) && e.lazy.loadInSlide(t)
              } else {
                  const n = t.children(`.${i.slideNextClass}`);
                  n.length > 0 && e.lazy.loadInSlide(c(n));
                  const r = t.children(`.${i.slidePrevClass}`);
                  r.length > 0 && e.lazy.loadInSlide(c(r))
              }
      }
  };
  const Ke = {
      LinearSpline: function(e, t) {
          const i = function() {
              let e, t, i;
              return (n,r)=>{
                  for (t = -1,
                  e = n.length; e - t > 1; )
                      n[i = e + t >> 1] <= r ? t = i : e = i;
                  return e
              }
          }();
          let n, r;
          return this.x = e,
          this.y = t,
          this.lastIndex = e.length - 1,
          this.interpolate = function(e) {
              return e ? (r = i(this.x, e),
              n = r - 1,
              (e - this.x[n]) * (this.y[r] - this.y[n]) / (this.x[r] - this.x[n]) + this.y[n]) : 0
          }
          ,
          this
      },
      getInterpolateFunction(e) {
          const t = this;
          t.controller.spline || (t.controller.spline = t.params.loop ? new Ke.LinearSpline(t.slidesGrid,e.slidesGrid) : new Ke.LinearSpline(t.snapGrid,e.snapGrid))
      },
      setTranslate(e, t) {
          const i = this
            , n = i.controller.control;
          let r, o;
          function s(e) {
              const t = i.rtlTranslate ? -i.translate : i.translate;
              "slide" === i.params.controller.by && (i.controller.getInterpolateFunction(e),
              o = -i.controller.spline.interpolate(-t)),
              o && "container" !== i.params.controller.by || (r = (e.maxTranslate() - e.minTranslate()) / (i.maxTranslate() - i.minTranslate()),
              o = (t - i.minTranslate()) * r + e.minTranslate()),
              i.params.controller.inverse && (o = e.maxTranslate() - o),
              e.updateProgress(o),
              e.setTranslate(o, i),
              e.updateActiveIndex(),
              e.updateSlidesClasses()
          }
          if (Array.isArray(n))
              for (let e = 0; e < n.length; e += 1)
                  n[e] !== t && n[e]instanceof Oe && s(n[e]);
          else
              n instanceof Oe && t !== n && s(n)
      },
      setTransition(e, t) {
          const i = this
            , n = i.controller.control;
          let r;
          function o(t) {
              t.setTransition(e, i),
              0 !== e && (t.transitionStart(),
              t.params.autoHeight && me.nextTick(()=>{
                  t.updateAutoHeight()
              }
              ),
              t.$wrapperEl.transitionEnd(()=>{
                  n && (t.params.loop && "slide" === i.params.controller.by && t.loopFix(),
                  t.transitionEnd())
              }
              ))
          }
          if (Array.isArray(n))
              for (r = 0; r < n.length; r += 1)
                  n[r] !== t && n[r]instanceof Oe && o(n[r]);
          else
              n instanceof Oe && t !== n && o(n)
      }
  };
  const Je = {
      makeElFocusable: e=>(e.attr("tabIndex", "0"),
      e),
      addElRole: (e,t)=>(e.attr("role", t),
      e),
      addElLabel: (e,t)=>(e.attr("aria-label", t),
      e),
      disableEl: e=>(e.attr("aria-disabled", !0),
      e),
      enableEl: e=>(e.attr("aria-disabled", !1),
      e),
      onEnterKey(e) {
          const t = this
            , i = t.params.a11y;
          if (13 !== e.keyCode)
              return;
          const n = de(e.target);
          t.navigation && t.navigation.$nextEl && n.is(t.navigation.$nextEl) && (t.isEnd && !t.params.loop || t.slideNext(),
          t.isEnd ? t.a11y.notify(i.lastSlideMessage) : t.a11y.notify(i.nextSlideMessage)),
          t.navigation && t.navigation.$prevEl && n.is(t.navigation.$prevEl) && (t.isBeginning && !t.params.loop || t.slidePrev(),
          t.isBeginning ? t.a11y.notify(i.firstSlideMessage) : t.a11y.notify(i.prevSlideMessage)),
          t.pagination && n.is(`.${t.params.pagination.bulletClass}`) && n[0].click()
      },
      notify(e) {
          const t = this.a11y.liveRegion;
          0 !== t.length && (t.html(""),
          t.html(e))
      },
      updateNavigation() {
          const e = this;
          if (e.params.loop)
              return;
          const {$nextEl: t, $prevEl: i} = e.navigation;
          i && i.length > 0 && (e.isBeginning ? e.a11y.disableEl(i) : e.a11y.enableEl(i)),
          t && t.length > 0 && (e.isEnd ? e.a11y.disableEl(t) : e.a11y.enableEl(t))
      },
      updatePagination() {
          const e = this
            , t = e.params.a11y;
          e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.bullets.each((i,n)=>{
              const r = de(n);
              e.a11y.makeElFocusable(r),
              e.a11y.addElRole(r, "button"),
              e.a11y.addElLabel(r, t.paginationBulletMessage.replace(/{{index}}/, r.index() + 1))
          }
          )
      },
      init() {
          const e = this;
          e.$el.append(e.a11y.liveRegion);
          const t = e.params.a11y;
          let i, n;
          e.navigation && e.navigation.$nextEl && (i = e.navigation.$nextEl),
          e.navigation && e.navigation.$prevEl && (n = e.navigation.$prevEl),
          i && (e.a11y.makeElFocusable(i),
          e.a11y.addElRole(i, "button"),
          e.a11y.addElLabel(i, t.nextSlideMessage),
          i.on("keydown", e.a11y.onEnterKey)),
          n && (e.a11y.makeElFocusable(n),
          e.a11y.addElRole(n, "button"),
          e.a11y.addElLabel(n, t.prevSlideMessage),
          n.on("keydown", e.a11y.onEnterKey)),
          e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.$el.on("keydown", `.${e.params.pagination.bulletClass}`, e.a11y.onEnterKey)
      },
      destroy() {
          const e = this;
          let t, i;
          e.a11y.liveRegion && e.a11y.liveRegion.length > 0 && e.a11y.liveRegion.remove(),
          e.navigation && e.navigation.$nextEl && (t = e.navigation.$nextEl),
          e.navigation && e.navigation.$prevEl && (i = e.navigation.$prevEl),
          t && t.off("keydown", e.a11y.onEnterKey),
          i && i.off("keydown", e.a11y.onEnterKey),
          e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.$el.off("keydown", `.${e.params.pagination.bulletClass}`, e.a11y.onEnterKey)
      }
  };
  const Qe = {
      init() {
          const e = this;
          if (!e.params.history)
              return;
          if (!ue.history || !ue.history.pushState)
              return e.params.history.enabled = !1,
              void (e.params.hashNavigation.enabled = !0);
          const t = e.history;
          t.initialized = !0,
          t.paths = Qe.getPathValues(),
          (t.paths.key || t.paths.value) && (t.scrollToSlide(0, t.paths.value, e.params.runCallbacksOnInit),
          e.params.history.replaceState || ue.addEventListener("popstate", e.history.setHistoryPopState))
      },
      destroy() {
          const e = this;
          e.params.history.replaceState || ue.removeEventListener("popstate", e.history.setHistoryPopState)
      },
      setHistoryPopState() {
          this.history.paths = Qe.getPathValues(),
          this.history.scrollToSlide(this.params.speed, this.history.paths.value, !1)
      },
      getPathValues() {
          const e = ue.location.pathname.slice(1).split("/").filter(e=>"" !== e)
            , t = e.length;
          return {
              key: e[t - 2],
              value: e[t - 1]
          }
      },
      setHistory(e, t) {
          if (!this.history.initialized || !this.params.history.enabled)
              return;
          const i = this.slides.eq(t);
          let n = Qe.slugify(i.attr("data-history"));
          ue.location.pathname.includes(e) || (n = `${e}/${n}`);
          const r = ue.history.state;
          r && r.value === n || (this.params.history.replaceState ? ue.history.replaceState({
              value: n
          }, null, n) : ue.history.pushState({
              value: n
          }, null, n))
      },
      slugify: e=>e.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""),
      scrollToSlide(e, t, i) {
          const n = this;
          if (t)
              for (let r = 0, o = n.slides.length; r < o; r += 1) {
                  const o = n.slides.eq(r);
                  if (Qe.slugify(o.attr("data-history")) === t && !o.hasClass(n.params.slideDuplicateClass)) {
                      const t = o.index();
                      n.slideTo(t, e, i)
                  }
              }
          else
              n.slideTo(0, e, i)
      }
  };
  const et = {
      onHashCange() {
          const e = this
            , t = ce.location.hash.replace("#", "");
          if (t !== e.slides.eq(e.activeIndex).attr("data-hash")) {
              const i = e.$wrapperEl.children(`.${e.params.slideClass}[data-hash="${t}"]`).index();
              if (void 0 === i)
                  return;
              e.slideTo(i)
          }
      },
      setHash() {
          const e = this;
          if (e.hashNavigation.initialized && e.params.hashNavigation.enabled)
              if (e.params.hashNavigation.replaceState && ue.history && ue.history.replaceState)
                  ue.history.replaceState(null, null, `#${e.slides.eq(e.activeIndex).attr("data-hash")}` || "");
              else {
                  const t = e.slides.eq(e.activeIndex)
                    , i = t.attr("data-hash") || t.attr("data-history");
                  ce.location.hash = i || ""
              }
      },
      init() {
          const e = this;
          if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled)
              return;
          e.hashNavigation.initialized = !0;
          const t = ce.location.hash.replace("#", "");
          if (t) {
              const i = 0;
              for (let n = 0, r = e.slides.length; n < r; n += 1) {
                  const r = e.slides.eq(n);
                  if ((r.attr("data-hash") || r.attr("data-history")) === t && !r.hasClass(e.params.slideDuplicateClass)) {
                      const t = r.index();
                      e.slideTo(t, i, e.params.runCallbacksOnInit, !0)
                  }
              }
          }
          e.params.hashNavigation.watchState && de(ue).on("hashchange", e.hashNavigation.onHashCange)
      },
      destroy() {
          const e = this;
          e.params.hashNavigation.watchState && de(ue).off("hashchange", e.hashNavigation.onHashCange)
      }
  };
  const tt = {
      run() {
          const e = this
            , t = e.slides.eq(e.activeIndex);
          let i = e.params.autoplay.delay;
          t.attr("data-swiper-autoplay") && (i = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
          e.autoplay.timeout = me.nextTick(()=>{
              e.params.autoplay.reverseDirection ? e.params.loop ? (e.loopFix(),
              e.slidePrev(e.params.speed, !0, !0),
              e.emit("autoplay")) : e.isBeginning ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(e.slides.length - 1, e.params.speed, !0, !0),
              e.emit("autoplay")) : (e.slidePrev(e.params.speed, !0, !0),
              e.emit("autoplay")) : e.params.loop ? (e.loopFix(),
              e.slideNext(e.params.speed, !0, !0),
              e.emit("autoplay")) : e.isEnd ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(0, e.params.speed, !0, !0),
              e.emit("autoplay")) : (e.slideNext(e.params.speed, !0, !0),
              e.emit("autoplay"))
          }
          , i)
      },
      start() {
          return void 0 === this.autoplay.timeout && (!this.autoplay.running && (this.autoplay.running = !0,
          this.emit("autoplayStart"),
          this.autoplay.run(),
          !0))
      },
      stop() {
          const e = this;
          return !!e.autoplay.running && (void 0 !== e.autoplay.timeout && (e.autoplay.timeout && (clearTimeout(e.autoplay.timeout),
          e.autoplay.timeout = void 0),
          e.autoplay.running = !1,
          e.emit("autoplayStop"),
          !0))
      },
      pause(e) {
          const t = this;
          t.autoplay.running && (t.autoplay.paused || (t.autoplay.timeout && clearTimeout(t.autoplay.timeout),
          t.autoplay.paused = !0,
          0 !== e && t.params.autoplay.waitForTransition ? (t.$wrapperEl[0].addEventListener("transitionend", t.autoplay.onTransitionEnd),
          t.$wrapperEl[0].addEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd)) : (t.autoplay.paused = !1,
          t.autoplay.run())))
      }
  };
  const it = {
      setTranslate() {
          const e = this
            , {slides: t} = e;
          for (let i = 0; i < t.length; i += 1) {
              const t = e.slides.eq(i);
              let n = -t[0].swiperSlideOffset;
              e.params.virtualTranslate || (n -= e.translate);
              let r = 0;
              e.isHorizontal() || (r = n,
              n = 0);
              const o = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(t[0].progress), 0) : 1 + Math.min(Math.max(t[0].progress, -1), 0);
              t.css({
                  opacity: o
              }).transform(`translate3d(${n}px, ${r}px, 0px)`)
          }
      },
      setTransition(e) {
          const t = this
            , {slides: i, $wrapperEl: n} = t;
          if (i.transition(e),
          t.params.virtualTranslate && 0 !== e) {
              let e = !1;
              i.transitionEnd(()=>{
                  if (e)
                      return;
                  if (!t || t.destroyed)
                      return;
                  e = !0,
                  t.animating = !1;
                  const i = ["webkitTransitionEnd", "transitionend"];
                  for (let e = 0; e < i.length; e += 1)
                      n.trigger(i[e])
              }
              )
          }
      }
  };
  const nt = {
      setTranslate() {
          const {$el: e, $wrapperEl: t, slides: i, width: n, height: r, rtlTranslate: o, size: s} = this
            , a = this.params.cubeEffect
            , l = this.isHorizontal()
            , c = this.virtual && this.params.virtual.enabled;
          let u, h = 0;
          a.shadow && (l ? (0 === (u = t.find(".swiper-cube-shadow")).length && (u = de('<div class="swiper-cube-shadow"></div>'),
          t.append(u)),
          u.css({
              height: `${n}px`
          })) : 0 === (u = e.find(".swiper-cube-shadow")).length && (u = de('<div class="swiper-cube-shadow"></div>'),
          e.append(u)));
          for (let e = 0; e < i.length; e += 1) {
              const t = i.eq(e);
              let n = e;
              c && (n = parseInt(t.attr("data-swiper-slide-index"), 10));
              let r = 90 * n
                , u = Math.floor(r / 360);
              o && (r = -r,
              u = Math.floor(-r / 360));
              const d = Math.max(Math.min(t[0].progress, 1), -1);
              let p = 0
                , f = 0
                , m = 0;
              n % 4 == 0 ? (p = 4 * -u * s,
              m = 0) : (n - 1) % 4 == 0 ? (p = 0,
              m = 4 * -u * s) : (n - 2) % 4 == 0 ? (p = s + 4 * u * s,
              m = s) : (n - 3) % 4 == 0 && (p = -s,
              m = 3 * s + 4 * s * u),
              o && (p = -p),
              l || (f = p,
              p = 0);
              const g = `rotateX(${l ? 0 : -r}deg) rotateY(${l ? r : 0}deg) translate3d(${p}px, ${f}px, ${m}px)`;
              if (d <= 1 && d > -1 && (h = 90 * n + 90 * d,
              o && (h = 90 * -n - 90 * d)),
              t.transform(g),
              a.slideShadows) {
                  let e = l ? t.find(".swiper-slide-shadow-left") : t.find(".swiper-slide-shadow-top")
                    , i = l ? t.find(".swiper-slide-shadow-right") : t.find(".swiper-slide-shadow-bottom");
                  0 === e.length && (e = de(`<div class="swiper-slide-shadow-${l ? "left" : "top"}"></div>`),
                  t.append(e)),
                  0 === i.length && (i = de(`<div class="swiper-slide-shadow-${l ? "right" : "bottom"}"></div>`),
                  t.append(i)),
                  e.length && (e[0].style.opacity = Math.max(-d, 0)),
                  i.length && (i[0].style.opacity = Math.max(d, 0))
              }
          }
          if (t.css({
              "-webkit-transform-origin": `50% 50% -${s / 2}px`,
              "-moz-transform-origin": `50% 50% -${s / 2}px`,
              "-ms-transform-origin": `50% 50% -${s / 2}px`,
              "transform-origin": `50% 50% -${s / 2}px`
          }),
          a.shadow)
              if (l)
                  u.transform(`translate3d(0px, ${n / 2 + a.shadowOffset}px, ${-n / 2}px) rotateX(90deg) rotateZ(0deg) scale(${a.shadowScale})`);
              else {
                  const e = Math.abs(h) - 90 * Math.floor(Math.abs(h) / 90)
                    , t = 1.5 - (Math.sin(2 * e * Math.PI / 360) / 2 + Math.cos(2 * e * Math.PI / 360) / 2)
                    , i = a.shadowScale
                    , n = a.shadowScale / t
                    , o = a.shadowOffset;
                  u.transform(`scale3d(${i}, 1, ${n}) translate3d(0px, ${r / 2 + o}px, ${-r / 2 / n}px) rotateX(-90deg)`)
              }
          const d = Ae.isSafari || Ae.isUiWebView ? -s / 2 : 0;
          t.transform(`translate3d(0px,0,${d}px) rotateX(${this.isHorizontal() ? 0 : h}deg) rotateY(${this.isHorizontal() ? -h : 0}deg)`)
      },
      setTransition(e) {
          const {$el: t, slides: i} = this;
          i.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),
          this.params.cubeEffect.shadow && !this.isHorizontal() && t.find(".swiper-cube-shadow").transition(e)
      }
  };
  const rt = {
      setTranslate() {
          const e = this
            , {slides: t, rtlTranslate: i} = e;
          for (let n = 0; n < t.length; n += 1) {
              const r = t.eq(n);
              let o = r[0].progress;
              e.params.flipEffect.limitRotation && (o = Math.max(Math.min(r[0].progress, 1), -1));
              let s = -180 * o
                , a = 0
                , l = -r[0].swiperSlideOffset
                , c = 0;
              if (e.isHorizontal() ? i && (s = -s) : (c = l,
              l = 0,
              a = -s,
              s = 0),
              r[0].style.zIndex = -Math.abs(Math.round(o)) + t.length,
              e.params.flipEffect.slideShadows) {
                  let t = e.isHorizontal() ? r.find(".swiper-slide-shadow-left") : r.find(".swiper-slide-shadow-top")
                    , i = e.isHorizontal() ? r.find(".swiper-slide-shadow-right") : r.find(".swiper-slide-shadow-bottom");
                  0 === t.length && (t = de(`<div class="swiper-slide-shadow-${e.isHorizontal() ? "left" : "top"}"></div>`),
                  r.append(t)),
                  0 === i.length && (i = de(`<div class="swiper-slide-shadow-${e.isHorizontal() ? "right" : "bottom"}"></div>`),
                  r.append(i)),
                  t.length && (t[0].style.opacity = Math.max(-o, 0)),
                  i.length && (i[0].style.opacity = Math.max(o, 0))
              }
              r.transform(`translate3d(${l}px, ${c}px, 0px) rotateX(${a}deg) rotateY(${s}deg)`)
          }
      },
      setTransition(e) {
          const t = this
            , {slides: i, activeIndex: n, $wrapperEl: r} = t;
          if (i.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),
          t.params.virtualTranslate && 0 !== e) {
              let e = !1;
              i.eq(n).transitionEnd(function() {
                  if (e)
                      return;
                  if (!t || t.destroyed)
                      return;
                  e = !0,
                  t.animating = !1;
                  const i = ["webkitTransitionEnd", "transitionend"];
                  for (let e = 0; e < i.length; e += 1)
                      r.trigger(i[e])
              })
          }
      }
  };
  const ot = {
      setTranslate() {
          const {width: e, height: t, slides: i, $wrapperEl: n, slidesSizesGrid: r} = this
            , o = this.params.coverflowEffect
            , s = this.isHorizontal()
            , a = this.translate
            , l = s ? e / 2 - a : t / 2 - a
            , c = s ? o.rotate : -o.rotate
            , u = o.depth;
          for (let e = 0, t = i.length; e < t; e += 1) {
              const t = i.eq(e)
                , n = r[e]
                , a = (l - t[0].swiperSlideOffset - n / 2) / n * o.modifier;
              let h = s ? c * a : 0
                , d = s ? 0 : c * a
                , p = -u * Math.abs(a)
                , f = s ? 0 : o.stretch * a
                , m = s ? o.stretch * a : 0;
              Math.abs(m) < .001 && (m = 0),
              Math.abs(f) < .001 && (f = 0),
              Math.abs(p) < .001 && (p = 0),
              Math.abs(h) < .001 && (h = 0),
              Math.abs(d) < .001 && (d = 0);
              const g = `translate3d(${m}px,${f}px,${p}px)  rotateX(${d}deg) rotateY(${h}deg)`;
              if (t.transform(g),
              t[0].style.zIndex = 1 - Math.abs(Math.round(a)),
              o.slideShadows) {
                  let e = s ? t.find(".swiper-slide-shadow-left") : t.find(".swiper-slide-shadow-top")
                    , i = s ? t.find(".swiper-slide-shadow-right") : t.find(".swiper-slide-shadow-bottom");
                  0 === e.length && (e = de(`<div class="swiper-slide-shadow-${s ? "left" : "top"}"></div>`),
                  t.append(e)),
                  0 === i.length && (i = de(`<div class="swiper-slide-shadow-${s ? "right" : "bottom"}"></div>`),
                  t.append(i)),
                  e.length && (e[0].style.opacity = a > 0 ? a : 0),
                  i.length && (i[0].style.opacity = -a > 0 ? -a : 0)
              }
          }
          if (ge.pointerEvents || ge.prefixedPointerEvents) {
              n[0].style.perspectiveOrigin = `${l}px 50%`
          }
      },
      setTransition(e) {
          this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e)
      }
  };
  const st = {
      init() {
          const e = this
            , {thumbs: t} = e.params
            , i = e.constructor;
          t.swiper instanceof i ? (e.thumbs.swiper = t.swiper,
          me.extend(e.thumbs.swiper.originalParams, {
              watchSlidesProgress: !0,
              slideToClickedSlide: !1
          }),
          me.extend(e.thumbs.swiper.params, {
              watchSlidesProgress: !0,
              slideToClickedSlide: !1
          })) : me.isObject(t.swiper) && (e.thumbs.swiper = new i(me.extend({}, t.swiper, {
              watchSlidesVisibility: !0,
              watchSlidesProgress: !0,
              slideToClickedSlide: !1
          })),
          e.thumbs.swiperCreated = !0),
          e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass),
          e.thumbs.swiper.on("tap", e.thumbs.onThumbClick)
      },
      onThumbClick() {
          const e = this
            , t = e.thumbs.swiper;
          if (!t)
              return;
          const i = t.clickedIndex
            , n = t.clickedSlide;
          if (n && de(n).hasClass(e.params.thumbs.slideThumbActiveClass))
              return;
          if (null == i)
              return;
          let r;
          if (r = t.params.loop ? parseInt(de(t.clickedSlide).attr("data-swiper-slide-index"), 10) : i,
          e.params.loop) {
              let t = e.activeIndex;
              e.slides.eq(t).hasClass(e.params.slideDuplicateClass) && (e.loopFix(),
              e._clientLeft = e.$wrapperEl[0].clientLeft,
              t = e.activeIndex);
              const i = e.slides.eq(t).prevAll(`[data-swiper-slide-index="${r}"]`).eq(0).index()
                , n = e.slides.eq(t).nextAll(`[data-swiper-slide-index="${r}"]`).eq(0).index();
              r = void 0 === i ? n : void 0 === n ? i : n - t < t - i ? n : i
          }
          e.slideTo(r)
      },
      update(e) {
          const t = this
            , i = t.thumbs.swiper;
          if (!i)
              return;
          const n = "auto" === i.params.slidesPerView ? i.slidesPerViewDynamic() : i.params.slidesPerView;
          if (t.realIndex !== i.realIndex) {
              let r, o = i.activeIndex;
              if (i.params.loop) {
                  i.slides.eq(o).hasClass(i.params.slideDuplicateClass) && (i.loopFix(),
                  i._clientLeft = i.$wrapperEl[0].clientLeft,
                  o = i.activeIndex);
                  const e = i.slides.eq(o).prevAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index()
                    , n = i.slides.eq(o).nextAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index();
                  r = void 0 === e ? n : void 0 === n ? e : n - o == o - e ? o : n - o < o - e ? n : e
              } else
                  r = t.realIndex;
              i.visibleSlidesIndexes.indexOf(r) < 0 && (i.params.centeredSlides ? r = r > o ? r - Math.floor(n / 2) + 1 : r + Math.floor(n / 2) - 1 : r > o && (r = r - n + 1),
              i.slideTo(r, e ? 0 : void 0))
          }
          let r = 1;
          const o = t.params.thumbs.slideThumbActiveClass;
          if (t.params.slidesPerView > 1 && !t.params.centeredSlides && (r = t.params.slidesPerView),
          i.slides.removeClass(o),
          i.params.loop)
              for (let e = 0; e < r; e += 1)
                  i.$wrapperEl.children(`[data-swiper-slide-index="${t.realIndex + e}"]`).addClass(o);
          else
              for (let e = 0; e < r; e += 1)
                  i.slides.eq(t.realIndex + e).addClass(o)
      }
  };
  const at = [ze, De, Re, Be, Fe, Ue, He, {
      name: "mousewheel",
      params: {
          mousewheel: {
              enabled: !1,
              releaseOnEdges: !1,
              invert: !1,
              forceToAxis: !1,
              sensitivity: 1,
              eventsTarged: "container"
          }
      },
      create() {
          me.extend(this, {
              mousewheel: {
                  enabled: !1,
                  enable: Ve.enable.bind(this),
                  disable: Ve.disable.bind(this),
                  handle: Ve.handle.bind(this),
                  handleMouseEnter: Ve.handleMouseEnter.bind(this),
                  handleMouseLeave: Ve.handleMouseLeave.bind(this),
                  lastScrollTime: me.now()
              }
          })
      },
      on: {
          init() {
              this.params.mousewheel.enabled && this.mousewheel.enable()
          },
          destroy() {
              this.mousewheel.enabled && this.mousewheel.disable()
          }
      }
  }, {
      name: "navigation",
      params: {
          navigation: {
              nextEl: null,
              prevEl: null,
              hideOnClick: !1,
              disabledClass: "swiper-button-disabled",
              hiddenClass: "swiper-button-hidden",
              lockClass: "swiper-button-lock"
          }
      },
      create() {
          me.extend(this, {
              navigation: {
                  init: We.init.bind(this),
                  update: We.update.bind(this),
                  destroy: We.destroy.bind(this),
                  onNextClick: We.onNextClick.bind(this),
                  onPrevClick: We.onPrevClick.bind(this)
              }
          })
      },
      on: {
          init() {
              this.navigation.init(),
              this.navigation.update()
          },
          toEdge() {
              this.navigation.update()
          },
          fromEdge() {
              this.navigation.update()
          },
          destroy() {
              this.navigation.destroy()
          },
          click(e) {
              const t = this
                , {$nextEl: i, $prevEl: n} = t.navigation;
              !t.params.navigation.hideOnClick || de(e.target).is(n) || de(e.target).is(i) || (i && i.toggleClass(t.params.navigation.hiddenClass),
              n && n.toggleClass(t.params.navigation.hiddenClass))
          }
      }
  }, {
      name: "pagination",
      params: {
          pagination: {
              el: null,
              bulletElement: "span",
              clickable: !1,
              hideOnClick: !1,
              renderBullet: null,
              renderProgressbar: null,
              renderFraction: null,
              renderCustom: null,
              progressbarOpposite: !1,
              type: "bullets",
              dynamicBullets: !1,
              dynamicMainBullets: 1,
              formatFractionCurrent: e=>e,
              formatFractionTotal: e=>e,
              bulletClass: "swiper-pagination-bullet",
              bulletActiveClass: "swiper-pagination-bullet-active",
              modifierClass: "swiper-pagination-",
              currentClass: "swiper-pagination-current",
              totalClass: "swiper-pagination-total",
              hiddenClass: "swiper-pagination-hidden",
              progressbarFillClass: "swiper-pagination-progressbar-fill",
              progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
              clickableClass: "swiper-pagination-clickable",
              lockClass: "swiper-pagination-lock"
          }
      },
      create() {
          me.extend(this, {
              pagination: {
                  init: $e.init.bind(this),
                  render: $e.render.bind(this),
                  update: $e.update.bind(this),
                  destroy: $e.destroy.bind(this),
                  dynamicBulletIndex: 0
              }
          })
      },
      on: {
          init() {
              this.pagination.init(),
              this.pagination.render(),
              this.pagination.update()
          },
          activeIndexChange() {
              const e = this;
              e.params.loop ? e.pagination.update() : void 0 === e.snapIndex && e.pagination.update()
          },
          snapIndexChange() {
              const e = this;
              e.params.loop || e.pagination.update()
          },
          slidesLengthChange() {
              const e = this;
              e.params.loop && (e.pagination.render(),
              e.pagination.update())
          },
          snapGridLengthChange() {
              const e = this;
              e.params.loop || (e.pagination.render(),
              e.pagination.update())
          },
          destroy() {
              this.pagination.destroy()
          },
          click(e) {
              const t = this;
              t.params.pagination.el && t.params.pagination.hideOnClick && t.pagination.$el.length > 0 && !de(e.target).hasClass(t.params.pagination.bulletClass) && t.pagination.$el.toggleClass(t.params.pagination.hiddenClass)
          }
      }
  }, {
      name: "scrollbar",
      params: {
          scrollbar: {
              el: null,
              dragSize: "auto",
              hide: !1,
              draggable: !1,
              snapOnRelease: !0,
              lockClass: "swiper-scrollbar-lock",
              dragClass: "swiper-scrollbar-drag"
          }
      },
      create() {
          me.extend(this, {
              scrollbar: {
                  init: Ge.init.bind(this),
                  destroy: Ge.destroy.bind(this),
                  updateSize: Ge.updateSize.bind(this),
                  setTranslate: Ge.setTranslate.bind(this),
                  setTransition: Ge.setTransition.bind(this),
                  enableDraggable: Ge.enableDraggable.bind(this),
                  disableDraggable: Ge.disableDraggable.bind(this),
                  setDragPosition: Ge.setDragPosition.bind(this),
                  onDragStart: Ge.onDragStart.bind(this),
                  onDragMove: Ge.onDragMove.bind(this),
                  onDragEnd: Ge.onDragEnd.bind(this),
                  isTouched: !1,
                  timeout: null,
                  dragTimeout: null
              }
          })
      },
      on: {
          init() {
              this.scrollbar.init(),
              this.scrollbar.updateSize(),
              this.scrollbar.setTranslate()
          },
          update() {
              this.scrollbar.updateSize()
          },
          resize() {
              this.scrollbar.updateSize()
          },
          observerUpdate() {
              this.scrollbar.updateSize()
          },
          setTranslate() {
              this.scrollbar.setTranslate()
          },
          setTransition(e) {
              this.scrollbar.setTransition(e)
          },
          destroy() {
              this.scrollbar.destroy()
          }
      }
  }, {
      name: "parallax",
      params: {
          parallax: {
              enabled: !1
          }
      },
      create() {
          me.extend(this, {
              parallax: {
                  setTransform: Xe.setTransform.bind(this),
                  setTranslate: Xe.setTranslate.bind(this),
                  setTransition: Xe.setTransition.bind(this)
              }
          })
      },
      on: {
          beforeInit() {
              this.params.parallax.enabled && (this.params.watchSlidesProgress = !0,
              this.originalParams.watchSlidesProgress = !0)
          },
          init() {
              this.params.parallax && this.parallax.setTranslate()
          },
          setTranslate() {
              this.params.parallax && this.parallax.setTranslate()
          },
          setTransition(e) {
              this.params.parallax && this.parallax.setTransition(e)
          }
      }
  }, {
      name: "zoom",
      params: {
          zoom: {
              enabled: !1,
              maxRatio: 3,
              minRatio: 1,
              toggle: !0,
              containerClass: "swiper-zoom-container",
              zoomedSlideClass: "swiper-slide-zoomed"
          }
      },
      create() {
          const e = this
            , t = {
              enabled: !1,
              scale: 1,
              currentScale: 1,
              isScaling: !1,
              gesture: {
                  $slideEl: void 0,
                  slideWidth: void 0,
                  slideHeight: void 0,
                  $imageEl: void 0,
                  $imageWrapEl: void 0,
                  maxRatio: 3
              },
              image: {
                  isTouched: void 0,
                  isMoved: void 0,
                  currentX: void 0,
                  currentY: void 0,
                  minX: void 0,
                  minY: void 0,
                  maxX: void 0,
                  maxY: void 0,
                  width: void 0,
                  height: void 0,
                  startX: void 0,
                  startY: void 0,
                  touchesStart: {},
                  touchesCurrent: {}
              },
              velocity: {
                  x: void 0,
                  y: void 0,
                  prevPositionX: void 0,
                  prevPositionY: void 0,
                  prevTime: void 0
              }
          };
          "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach(i=>{
              t[i] = Ze[i].bind(e)
          }
          ),
          me.extend(e, {
              zoom: t
          });
          let i = 1;
          Object.defineProperty(e.zoom, "scale", {
              get: ()=>i,
              set(t) {
                  if (i !== t) {
                      const i = e.zoom.gesture.$imageEl ? e.zoom.gesture.$imageEl[0] : void 0
                        , n = e.zoom.gesture.$slideEl ? e.zoom.gesture.$slideEl[0] : void 0;
                      e.emit("zoomChange", t, i, n)
                  }
                  i = t
              }
          })
      },
      on: {
          init() {
              const e = this;
              e.params.zoom.enabled && e.zoom.enable()
          },
          destroy() {
              this.zoom.disable()
          },
          touchStart(e) {
              this.zoom.enabled && this.zoom.onTouchStart(e)
          },
          touchEnd(e) {
              this.zoom.enabled && this.zoom.onTouchEnd(e)
          },
          doubleTap(e) {
              const t = this;
              t.params.zoom.enabled && t.zoom.enabled && t.params.zoom.toggle && t.zoom.toggle(e)
          },
          transitionEnd() {
              const e = this;
              e.zoom.enabled && e.params.zoom.enabled && e.zoom.onTransitionEnd()
          }
      }
  }, {
      name: "lazy",
      params: {
          lazy: {
              enabled: !1,
              loadPrevNext: !1,
              loadPrevNextAmount: 1,
              loadOnTransitionStart: !1,
              elementClass: "swiper-lazy",
              loadingClass: "swiper-lazy-loading",
              loadedClass: "swiper-lazy-loaded",
              preloaderClass: "swiper-lazy-preloader"
          }
      },
      create() {
          me.extend(this, {
              lazy: {
                  initialImageLoaded: !1,
                  load: Ye.load.bind(this),
                  loadInSlide: Ye.loadInSlide.bind(this)
              }
          })
      },
      on: {
          beforeInit() {
              const e = this;
              e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1)
          },
          init() {
              const e = this;
              e.params.lazy.enabled && !e.params.loop && 0 === e.params.initialSlide && e.lazy.load()
          },
          scroll() {
              const e = this;
              e.params.freeMode && !e.params.freeModeSticky && e.lazy.load()
          },
          resize() {
              const e = this;
              e.params.lazy.enabled && e.lazy.load()
          },
          scrollbarDragMove() {
              const e = this;
              e.params.lazy.enabled && e.lazy.load()
          },
          transitionStart() {
              const e = this;
              e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || !e.params.lazy.loadOnTransitionStart && !e.lazy.initialImageLoaded) && e.lazy.load()
          },
          transitionEnd() {
              const e = this;
              e.params.lazy.enabled && !e.params.lazy.loadOnTransitionStart && e.lazy.load()
          }
      }
  }, {
      name: "controller",
      params: {
          controller: {
              control: void 0,
              inverse: !1,
              by: "slide"
          }
      },
      create() {
          me.extend(this, {
              controller: {
                  control: this.params.controller.control,
                  getInterpolateFunction: Ke.getInterpolateFunction.bind(this),
                  setTranslate: Ke.setTranslate.bind(this),
                  setTransition: Ke.setTransition.bind(this)
              }
          })
      },
      on: {
          update() {
              const e = this;
              e.controller.control && e.controller.spline && (e.controller.spline = void 0,
              delete e.controller.spline)
          },
          resize() {
              const e = this;
              e.controller.control && e.controller.spline && (e.controller.spline = void 0,
              delete e.controller.spline)
          },
          observerUpdate() {
              const e = this;
              e.controller.control && e.controller.spline && (e.controller.spline = void 0,
              delete e.controller.spline)
          },
          setTranslate(e, t) {
              this.controller.control && this.controller.setTranslate(e, t)
          },
          setTransition(e, t) {
              this.controller.control && this.controller.setTransition(e, t)
          }
      }
  }, {
      name: "a11y",
      params: {
          a11y: {
              enabled: !0,
              notificationClass: "swiper-notification",
              prevSlideMessage: "Previous slide",
              nextSlideMessage: "Next slide",
              firstSlideMessage: "This is the first slide",
              lastSlideMessage: "This is the last slide",
              paginationBulletMessage: "Go to slide {{index}}"
          }
      },
      create() {
          const e = this;
          me.extend(e, {
              a11y: {
                  liveRegion: de(`<span class="${e.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`)
              }
          }),
          Object.keys(Je).forEach(t=>{
              e.a11y[t] = Je[t].bind(e)
          }
          )
      },
      on: {
          init() {
              this.params.a11y.enabled && (this.a11y.init(),
              this.a11y.updateNavigation())
          },
          toEdge() {
              this.params.a11y.enabled && this.a11y.updateNavigation()
          },
          fromEdge() {
              this.params.a11y.enabled && this.a11y.updateNavigation()
          },
          paginationUpdate() {
              this.params.a11y.enabled && this.a11y.updatePagination()
          },
          destroy() {
              this.params.a11y.enabled && this.a11y.destroy()
          }
      }
  }, {
      name: "history",
      params: {
          history: {
              enabled: !1,
              replaceState: !1,
              key: "slides"
          }
      },
      create() {
          me.extend(this, {
              history: {
                  init: Qe.init.bind(this),
                  setHistory: Qe.setHistory.bind(this),
                  setHistoryPopState: Qe.setHistoryPopState.bind(this),
                  scrollToSlide: Qe.scrollToSlide.bind(this),
                  destroy: Qe.destroy.bind(this)
              }
          })
      },
      on: {
          init() {
              const e = this;
              e.params.history.enabled && e.history.init()
          },
          destroy() {
              const e = this;
              e.params.history.enabled && e.history.destroy()
          },
          transitionEnd() {
              const e = this;
              e.history.initialized && e.history.setHistory(e.params.history.key, e.activeIndex)
          }
      }
  }, {
      name: "hash-navigation",
      params: {
          hashNavigation: {
              enabled: !1,
              replaceState: !1,
              watchState: !1
          }
      },
      create() {
          me.extend(this, {
              hashNavigation: {
                  initialized: !1,
                  init: et.init.bind(this),
                  destroy: et.destroy.bind(this),
                  setHash: et.setHash.bind(this),
                  onHashCange: et.onHashCange.bind(this)
              }
          })
      },
      on: {
          init() {
              const e = this;
              e.params.hashNavigation.enabled && e.hashNavigation.init()
          },
          destroy() {
              const e = this;
              e.params.hashNavigation.enabled && e.hashNavigation.destroy()
          },
          transitionEnd() {
              const e = this;
              e.hashNavigation.initialized && e.hashNavigation.setHash()
          }
      }
  }, {
      name: "autoplay",
      params: {
          autoplay: {
              enabled: !1,
              delay: 3e3,
              waitForTransition: !0,
              disableOnInteraction: !0,
              stopOnLastSlide: !1,
              reverseDirection: !1
          }
      },
      create() {
          const e = this;
          me.extend(e, {
              autoplay: {
                  running: !1,
                  paused: !1,
                  run: tt.run.bind(e),
                  start: tt.start.bind(e),
                  stop: tt.stop.bind(e),
                  pause: tt.pause.bind(e),
                  onTransitionEnd(t) {
                      e && !e.destroyed && e.$wrapperEl && t.target === this && (e.$wrapperEl[0].removeEventListener("transitionend", e.autoplay.onTransitionEnd),
                      e.$wrapperEl[0].removeEventListener("webkitTransitionEnd", e.autoplay.onTransitionEnd),
                      e.autoplay.paused = !1,
                      e.autoplay.running ? e.autoplay.run() : e.autoplay.stop())
                  }
              }
          })
      },
      on: {
          init() {
              const e = this;
              e.params.autoplay.enabled && e.autoplay.start()
          },
          beforeTransitionStart(e, t) {
              const i = this;
              i.autoplay.running && (t || !i.params.autoplay.disableOnInteraction ? i.autoplay.pause(e) : i.autoplay.stop())
          },
          sliderFirstMove() {
              const e = this;
              e.autoplay.running && (e.params.autoplay.disableOnInteraction ? e.autoplay.stop() : e.autoplay.pause())
          },
          destroy() {
              const e = this;
              e.autoplay.running && e.autoplay.stop()
          }
      }
  }, {
      name: "effect-fade",
      params: {
          fadeEffect: {
              crossFade: !1
          }
      },
      create() {
          me.extend(this, {
              fadeEffect: {
                  setTranslate: it.setTranslate.bind(this),
                  setTransition: it.setTransition.bind(this)
              }
          })
      },
      on: {
          beforeInit() {
              if ("fade" !== this.params.effect)
                  return;
              this.classNames.push(`${this.params.containerModifierClass}fade`);
              const e = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  spaceBetween: 0,
                  virtualTranslate: !0
              };
              me.extend(this.params, e),
              me.extend(this.originalParams, e)
          },
          setTranslate() {
              "fade" === this.params.effect && this.fadeEffect.setTranslate()
          },
          setTransition(e) {
              "fade" === this.params.effect && this.fadeEffect.setTransition(e)
          }
      }
  }, {
      name: "effect-cube",
      params: {
          cubeEffect: {
              slideShadows: !0,
              shadow: !0,
              shadowOffset: 20,
              shadowScale: .94
          }
      },
      create() {
          me.extend(this, {
              cubeEffect: {
                  setTranslate: nt.setTranslate.bind(this),
                  setTransition: nt.setTransition.bind(this)
              }
          })
      },
      on: {
          beforeInit() {
              if ("cube" !== this.params.effect)
                  return;
              this.classNames.push(`${this.params.containerModifierClass}cube`),
              this.classNames.push(`${this.params.containerModifierClass}3d`);
              const e = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  resistanceRatio: 0,
                  spaceBetween: 0,
                  centeredSlides: !1,
                  virtualTranslate: !0
              };
              me.extend(this.params, e),
              me.extend(this.originalParams, e)
          },
          setTranslate() {
              "cube" === this.params.effect && this.cubeEffect.setTranslate()
          },
          setTransition(e) {
              "cube" === this.params.effect && this.cubeEffect.setTransition(e)
          }
      }
  }, {
      name: "effect-flip",
      params: {
          flipEffect: {
              slideShadows: !0,
              limitRotation: !0
          }
      },
      create() {
          me.extend(this, {
              flipEffect: {
                  setTranslate: rt.setTranslate.bind(this),
                  setTransition: rt.setTransition.bind(this)
              }
          })
      },
      on: {
          beforeInit() {
              if ("flip" !== this.params.effect)
                  return;
              this.classNames.push(`${this.params.containerModifierClass}flip`),
              this.classNames.push(`${this.params.containerModifierClass}3d`);
              const e = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  spaceBetween: 0,
                  virtualTranslate: !0
              };
              me.extend(this.params, e),
              me.extend(this.originalParams, e)
          },
          setTranslate() {
              "flip" === this.params.effect && this.flipEffect.setTranslate()
          },
          setTransition(e) {
              "flip" === this.params.effect && this.flipEffect.setTransition(e)
          }
      }
  }, {
      name: "effect-coverflow",
      params: {
          coverflowEffect: {
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: !0
          }
      },
      create() {
          me.extend(this, {
              coverflowEffect: {
                  setTranslate: ot.setTranslate.bind(this),
                  setTransition: ot.setTransition.bind(this)
              }
          })
      },
      on: {
          beforeInit() {
              "coverflow" === this.params.effect && (this.classNames.push(`${this.params.containerModifierClass}coverflow`),
              this.classNames.push(`${this.params.containerModifierClass}3d`),
              this.params.watchSlidesProgress = !0,
              this.originalParams.watchSlidesProgress = !0)
          },
          setTranslate() {
              "coverflow" === this.params.effect && this.coverflowEffect.setTranslate()
          },
          setTransition(e) {
              "coverflow" === this.params.effect && this.coverflowEffect.setTransition(e)
          }
      }
  }, {
      name: "thumbs",
      params: {
          thumbs: {
              swiper: null,
              slideThumbActiveClass: "swiper-slide-thumb-active",
              thumbsContainerClass: "swiper-container-thumbs"
          }
      },
      create() {
          me.extend(this, {
              thumbs: {
                  swiper: null,
                  init: st.init.bind(this),
                  update: st.update.bind(this),
                  onThumbClick: st.onThumbClick.bind(this)
              }
          })
      },
      on: {
          beforeInit() {
              const {thumbs: e} = this.params;
              e && e.swiper && (this.thumbs.init(),
              this.thumbs.update(!0))
          },
          slideChange() {
              this.thumbs.swiper && this.thumbs.update()
          },
          update() {
              this.thumbs.swiper && this.thumbs.update()
          },
          resize() {
              this.thumbs.swiper && this.thumbs.update()
          },
          observerUpdate() {
              this.thumbs.swiper && this.thumbs.update()
          },
          setTransition(e) {
              const t = this.thumbs.swiper;
              t && t.setTransition(e)
          },
          beforeDestroy() {
              const e = this.thumbs.swiper;
              e && this.thumbs.swiperCreated && e && e.destroy()
          }
      }
  }];
  void 0 === Oe.use && (Oe.use = Oe.Class.use,
  Oe.installModule = Oe.Class.installModule),
  Oe.use(at);
  var lt = Oe;
  function ct(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(125);
  var ut = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.swiper = null,
          this.swiperOptions = {
              direction: "horizontal",
              slidesPerView: 1,
              spaceBetween: 8,
              scrollbar: {
                  el: ".swiper-scrollbar",
                  hide: !1
              }
          },
          this.breakpoint = window.matchMedia("(min-width: 768px)"),
          this.events = Object(o.a)(this),
          this.init(),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              this.breakpoint.addListener(this.events._onBreakpointResize)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              this.breakpoint.removeListener(this.events._onBreakpointResize)
          }
      }, {
          key: "init",
          value: function() {
              this.breakpoint.matches ? this.swiper && this.swiper.destroy() : this.breakpoint.matches || this.swiper || this.createSlider()
          }
      }, {
          key: "_onBreakpointResize",
          value: function() {
              this.init()
          }
      }, {
          key: "createSlider",
          value: function() {
              if (!this.swiper) {
                  var e = "swiper-".concat(++j.counters.instances);
                  this.el.section.querySelector(".swiper-container").setAttribute("id", e),
                  this.swiper = new lt("#".concat(e),this.swiperOptions)
              }
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && ct(t.prototype, i),
      n && ct(t, n),
      e
  }();
  function ht(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(126);
  var dt = "grid-product-tiles-overview"
    , pt = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              productTiles: t.querySelectorAll(".".concat(dt, " .product-tile")),
              tileHoverArea: t.querySelectorAll(".".concat(dt, " .product-tile__image-wrap"))
          },
          this.flags = {
              isMobileSlider: !0
          },
          this.mobileBreakpoint = window.matchMedia("(min-width: 768px)"),
          this.mobileSwiper = null,
          this.mobileSwiperOptions = {
              direction: "horizontal",
              slidesPerView: 2.0625,
              spaceBetween: 8,
              slidesOffsetAfter: 8
          },
          this.desktopSwiper = null,
          this.desktopSwiperOptions = {
              direction: "horizontal",
              slidesPerView: 3,
              spaceBetween: 22,
              slidesOffsetAfter: 22,
              breakpoints: {
                  768: {
                      slidesPerView: 2.0625,
                      spaceBetween: 8,
                      slidesOffsetAfter: 8
                  }
              }
          },
          this.events = Object(o.a)(this),
          this.init(),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.checkDesktop(),
              this.flags.isMobileSlider ? this.initMobileSlider() : this.initDesktopSlider()
          }
      }, {
          key: "checkDesktop",
          value: function() {
              this.el.section.hasAttribute("data-desktop-slider") && (this.flags.isMobileSlider = !1)
          }
      }, {
          key: "addEventListeners",
          value: function() {
              var e = this;
              this.flags.isMobileSlider && this.mobileBreakpoint.addListener(this.events._onBreakpointResize);
              this.el.tileHoverArea.forEach(function(t) {
                  t.addEventListener("mouseenter", e.events._onProductTileHover),
                  t.addEventListener("mouseleave", e.events._onProductTileHoverOut)
              })
          }
      }, {
          key: "_onBreakpointResize",
          value: function() {
              this.initMobileSlider()
          }
      }, {
          key: "_onProductTileHover",
          value: function() {}
      }, {
          key: "_onProductTileHoverOut",
          value: function() {}
      }, {
          key: "initMobileSlider",
          value: function() {
              var e = this.mobileBreakpoint;
              !0 === e.matches ? null !== this.mobileSwiper && this.destroyMobileSlider() : !1 === e.matches && this.createMobileSlider()
          }
      }, {
          key: "createMobileSlider",
          value: function() {
              var e = "swiper-".concat(++j.counters.instances);
              this.el.section.querySelector(".swiper-container").setAttribute("id", e),
              this.mobileSwiper || (this.mobileSwiper = new lt("#".concat(e),this.mobileSwiperOptions))
          }
      }, {
          key: "destroyMobileSlider",
          value: function() {
              this.mobileSwiper.destroy(!1, !0)
          }
      }, {
          key: "initDesktopSlider",
          value: function() {
              var e = "swiper-".concat(++j.counters.instances);
              this.el.section.querySelector(".swiper-container").setAttribute("id", e),
              this.desktopSwiper || (this.desktopSwiper = new lt("#".concat(e),this.desktopSwiperOptions))
          }
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && ht(t.prototype, i),
      n && ht(t, n),
      e
  }();
  function ft(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(127);
  var mt = "grid-product-tiles-pdp-colors"
    , gt = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              buttonNext: t.querySelector(".swiper-button-next"),
              buttonPrev: t.querySelector(".swiper-button-prev"),
              productTiles: t.querySelectorAll(".".concat(mt, " .product-tile")),
              swiperContainer: t.querySelector(".swiper-container"),
              tileHoverArea: t.querySelectorAll(".".concat(mt, " .product-tile:not(.product-tile--feat) .product-tile__image-wrap")),
              colorCount: document.querySelector(".buy-config [data-title-color-count]")
          },
          this.flags = {
              isSlider: !0
          },
          this.swiper = null;
          var i = {
              swiperNext: ".".concat(mt, " .swiper-container .swiper-button-next"),
              swiperPrev: ".".concat(mt, " .swiper-container .swiper-button-prev")
          }
            , n = i.swiperNext
            , r = i.swiperPrev;
          this.swiperOptions = {
              centeredSlides: !1,
              direction: "horizontal",
              slidesPerView: 6,
              spaceBetween: 8,
              watchOverflow: !0,
              allowTouchMove: !1,
              navigation: {
                  nextEl: n,
                  prevEl: r
              },
              breakpoints: {
                  480: {
                      slidesOffsetBefore: 0,
                      slidesOffsetAfter: 0,
                      slidesPerView: 2,
                      allowTouchMove: !0
                  },
                  768: {
                      slidesOffsetBefore: 0,
                      slidesOffsetAfter: 0,
                      slidesPerView: 3,
                      allowTouchMove: !0
                  },
                  992: {
                      slidesOffsetBefore: 0,
                      slidesOffsetAfter: 0,
                      slidesPerView: 4,
                      allowTouchMove: !1
                  },
                  1200: {
                      slidesOffsetBefore: 0,
                      slidesOffsetAfter: 0,
                      slidesPerView: 4,
                      allowTouchMove: !1
                  },
                  1440: {
                      slidesOffsetBefore: 0,
                      slidesOffsetAfter: 0,
                      slidesPerView: 6,
                      allowTouchMove: !1
                  },
                  1600: {
                      slidesOffsetBefore: 0,
                      slidesOffsetAfter: 0,
                      slidesPerView: 6,
                      allowTouchMove: !1
                  },
                  1800: {
                      slidesOffsetBefore: 0,
                      slidesOffsetAfter: 0,
                      slidesPerView: 6,
                      allowTouchMove: !1
                  }
              }
          },
          this.events = Object(o.a)(this),
          this.initSlider(),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              var e = this;
              window.addEventListener("resize", this.events._onWindowResize),
              this.swiper.on("fromEdge", function() {
                  u.b.lawg("end")
              }),
              this.swiper.on("init", function() {
                  e.checkWindowSize()
              })
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("resize", this.events._onWindowResize)
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.checkWindowSize()
          }
      }, {
          key: "_onProductTileHover",
          value: function() {}
      }, {
          key: "_onProductTileHoverOut",
          value: function() {}
      }, {
          key: "checkWindowSize",
          value: function() {
              this.el.buttonNext.classList.contains("swiper-button-disabled") ? this.el.swiperContainer.classList.add("is-next-disabled") : this.el.swiperContainer.classList.remove("is-next-disabled")
          }
      }, {
          key: "initSlider",
          value: function() {
              this.createSlider(),
              this.checkWindowSize(),
              this.el.colorCount && (this.el.colorCount.innerHTML = " (".concat(this.swiper.slides.length, ")"))
          }
      }, {
          key: "createSlider",
          value: function() {
              var e = "swiper-".concat(++j.counters.instances);
              this.el.section.querySelector(".swiper-container").setAttribute("id", e),
              this.swiper = new lt("#".concat(e),this.swiperOptions)
          }
      }, {
          key: "destroySlider",
          value: function() {
              this.swiper.destroy(!1, !0)
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && ft(t.prototype, i),
      n && ft(t, n),
      e
  }();
  function vt(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var yt = function() {
      function e(t, i, n) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              ctaBar: t.querySelector("#".concat(i, " .cta-progress")),
              ctaBarHead: t.querySelector("#".concat(i, " .cta-progress .cta-progress__head")),
              ctaBarQty: t.querySelector("#".concat(i, " .cta-progress .cta-progress__text-qty")),
              ctaBarTxtAll: t.querySelector("#".concat(i, " .cta-progress .cta-progress__text-all"))
          },
          this.events = Object(o.a)(this),
          this.init(n)
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              this.el.ctaBarTxtAll.addEventListener("mouseenter", this.events._onMouseenter),
              this.el.ctaBarTxtAll.addEventListener("mouseleave", this.events._onMouseleave)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              this.el.ctaBarTxtAll.removeEventListener("mouseenter", this.events._onMouseenter),
              this.el.ctaBarTxtAll.removeEventListener("mouseleave", this.events._onMouseleave)
          }
      }, {
          key: "_onMouseenter",
          value: function() {
              this.expandBtn()
          }
      }, {
          key: "_onMouseleave",
          value: function() {
              this.shrinkBtn()
          }
      }, {
          key: "expandBtn",
          value: function() {
              var e = this;
              setTimeout(function() {
                  e.el.ctaBar.classList.add("is-expanded"),
                  e.el.ctaBarQty.classList.add("is-shown"),
                  e.el.ctaBarTxtAll.classList.add("is-disabled")
              }, 0)
          }
      }, {
          key: "shrinkBtn",
          value: function() {
              this.el.ctaBar.classList.remove("is-expanded"),
              this.el.ctaBarQty.classList.remove("is-shown"),
              this.el.ctaBarTxtAll.classList.remove("is-disabled")
          }
      }, {
          key: "init",
          value: function(e) {
              var t = this;
              this.el.ctaBarHead.style.transform = "translateX(-".concat(100 - 100 / e.slides.length, "%)"),
              e.isEnd && (this.el.ctaBarHead.style = null,
              this.el.ctaBar.style = null,
              this.el.ctaBarHead.style.transform = "scaleX(1)",
              this.el.ctaBar.classList.add("is-expanded"),
              this.el.ctaBarQty.classList.add("is-shown")),
              e.on("slideChangeTransitionStart", function() {
                  e.isBeginning || (t.el.ctaBarHead.style.transform = "translateX(-".concat(100 - 100 * e.progress, "%)"))
              }),
              e.on("reachBeginning", function() {
                  t.el.ctaBarHead.style.transform = "translateX(-".concat(100 - 100 / e.slides.length, "%)"),
                  t.shrinkBtn()
              }),
              e.on("reachEnd", function() {
                  t.el.ctaBarHead.style.transform = "translateX(0)",
                  t.expandBtn()
              }),
              e.on("fromEdge", function() {
                  e.isBeginning || (t.el.ctaBarHead.style.transform = "translateX(-".concat(100 - 100 * e.progress, "%)"),
                  t.shrinkBtn())
              }),
              Object(o.j)("medium") && e.slides[4] && e.slides[4].classList.contains("col-lg-6") && (e.on("slideNextTransitionStart", function() {
                  e.slideTo(2, 400),
                  e.off("slideNextTransitionStart")
              }),
              e.on("reachBeginning", function() {
                  e.on("slidePrevTransitionEnd", function() {
                      e.on("slideNextTransitionStart", function() {
                          e.slideTo(2, 400),
                          e.off("slideNextTransitionStart")
                      }),
                      e.off("slidePrevTransitionEnd")
                  })
              }),
              e.on("slidePrevTransitionStart", function() {
                  e.slides[e.activeIndex + 3].classList.contains("col-lg-6") && e.slideTo(0, 400)
              }))
          }
      }]) && vt(t.prototype, i),
      n && vt(t, n),
      e
  }();
  function _t(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(128);
  var bt = "grid-product-tiles-plp-carousel"
    , wt = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              productTiles: t.querySelectorAll(".".concat(bt, " .product-tile")),
              tileHoverArea: t.querySelectorAll(".".concat(bt, " .product-tile:not(.product-tile--feat) .product-tile__image-wrap")),
              featTileHoverArea: t.querySelectorAll(".".concat(bt, " .product-tile--feat .product-tile__image-wrap")),
              prev: t.querySelector(".".concat(bt, " .swiper-button-prev")),
              next: t.querySelector(".".concat(bt, " .swiper-button-next")),
              header: t.querySelector(".".concat(bt, " .grid-product-tiles__header")),
              slideImage: t.querySelectorAll(".".concat(bt, " .product-tile__image-wrap"))
          },
          this.slider = null,
          this.sliderOptions = {
              direction: "horizontal",
              slidesPerView: "auto",
              allowTouchMove: !1,
              centerInsufficientSlides: !0,
              navigation: {
                  nextEl: ".".concat(bt, " .swiper-button-next"),
                  prevEl: ".".concat(bt, " .swiper-button-prev")
              },
              breakpoints: {
                  1024: {
                      allowTouchMove: !0
                  }
              }
          },
          this.bounds = {
              slideHeight: null,
              btnHeight: null,
              headerHeight: null
          },
          this.events = Object(o.a)(this),
          this.init(),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.matchFeatTileHeights(),
              this.initSlider(),
              this.measure(),
              this.placeSliderCtrls()
          }
      }, {
          key: "measure",
          value: function() {
              this.bounds.slideHeight = this.el.slideImage[0].clientHeight,
              this.bounds.btnHeight = this.el.next.offsetHeight,
              this.bounds.headerHeight = this.el.header.offsetHeight
          }
      }, {
          key: "addEventListeners",
          value: function() {
              var e = this;
              this.el.tileHoverArea.forEach(function(t) {
                  t.addEventListener("mouseenter", e.events._onProductTileHover),
                  t.addEventListener("mouseleave", e.events._onProductTileHoverOut)
              }),
              window.addEventListener("modalopen", function() {
                  e.slider && e.slider.update()
              }),
              window.addEventListener("resize", this.events._onWindowResize)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              var e = this;
              this.el.tileHoverArea.forEach(function(t) {
                  t.removeEventListener("mouseenter", e.events._onProductTileHover),
                  t.removeEventListener("mouseleave", e.events._onProductTileHoverOut)
              }),
              window.removeEventListener("resize", this.events._onWindowResize)
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.matchFeatTileHeights(),
              this.measure(),
              this.placeSliderCtrls()
          }
      }, {
          key: "placeSliderCtrls",
          value: function() {
              var e, t = this.bounds.slideHeight, i = this.bounds.btnHeight / 2;
              if (this.el.header) {
                  var n = this.bounds.headerHeight
                    , r = getComputedStyle(this.el.header);
                  e = t / 2 + (n += parseInt(r.marginLeft) + parseInt(r.marginRight))
              } else
                  e = t / 2;
              this.el.prev.style.top = "".concat(e - i, "px"),
              this.el.next.style.top = "".concat(e - i, "px")
          }
      }, {
          key: "matchFeatTileHeights",
          value: function() {
              var e = 0;
              this.el.tileHoverArea.forEach(function(t) {
                  var i = t.clientHeight;
                  i >= e && (e = i)
              }),
              this.el.featTileHoverArea.forEach(function(t) {
                  t.style.height = "".concat(e, "px")
              })
          }
      }, {
          key: "initSlider",
          value: function() {
              var e = "swiper-".concat(++j.counters.instances);
              this.el.section.querySelector(".swiper-container").setAttribute("id", e),
              this.slider || (this.slider = new lt("#".concat(e),this.sliderOptions)),
              this.slider && (this.ctaProgress = new yt(this.el.section,e,this.slider))
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && _t(t.prototype, i),
      n && _t(t, n),
      e
  }();
  function xt(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(129);
  var kt = "grid-product-tiles-plp-default"
    , St = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              productTiles: t.querySelectorAll(".".concat(kt, " .product-tile")),
              tileHoverArea: t.querySelectorAll(".".concat(kt, " .product-tile:not(.product-tile--feat) .product-tile__image-wrap")),
              featTileHoverArea: t.querySelectorAll(".".concat(kt, " .product-tile--feat .product-tile__image-wrap"))
          },
          this.flags = {
              isInitialized: !1,
              isMobileSlider: !0
          },
          this.mobileBreakpoint = window.matchMedia("(min-width: 768px)"),
          this.mobileSwiper = null,
          this.mobileSwiperOptions = {
              direction: "horizontal",
              slidesPerView: 2,
              spaceBetween: 8
          },
          this.events = Object(o.a)(this),
          this.init(),
          this.addEventListeners(),
          u.b.lawg("GridProductTilesPlpDefault", this.el.section)
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.flags.isInitialized || (this.flags.isInitialized = !0,
              this.el.section.hasAttribute("data-no-slider") ? this.flags.isMobileSlider = !1 : (this.flags.isMobileSlider = !0,
              this.matchFeatTileHeights(),
              this.initMobileSlider()))
          }
      }, {
          key: "addEventListeners",
          value: function() {
              var e = this;
              this.flags.isMobileSlider && this.mobileBreakpoint.addListener(this.events._onBreakpointResize);
              this.el.tileHoverArea.forEach(function(t) {
                  t.addEventListener("mouseenter", e.events._onProductTileHover),
                  t.addEventListener("mouseleave", e.events._onProductTileHoverOut)
              }),
              window.addEventListener("modalopen", function() {
                  e.mobileSwiper && e.mobileSwiper.update()
              }),
              window.addEventListener("resize", this.events._onWindowResize)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              var e = this;
              this.el.tileHoverArea.forEach(function(t) {
                  t.removeEventListener("mouseenter", e.events._onProductTileHover),
                  t.removeEventListener("mouseleave", e.events._onProductTileHoverOut)
              }),
              window.removeEventListener("resize", this.events._onWindowResize)
          }
      }, {
          key: "_onBreakpointResize",
          value: function() {
              this.initMobileSlider()
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.matchFeatTileHeights()
          }
      }, {
          key: "_onProductTileHover",
          value: function() {}
      }, {
          key: "_onProductTileHoverOut",
          value: function() {}
      }, {
          key: "matchFeatTileHeights",
          value: function() {
              var e = 0;
              this.el.tileHoverArea.forEach(function(t) {
                  var i = t.clientHeight;
                  i >= e && (e = i)
              }),
              this.el.featTileHoverArea.forEach(function(t) {
                  t.style.height = "".concat(e, "px")
              })
          }
      }, {
          key: "initMobileSlider",
          value: function() {
              var e = this.mobileBreakpoint;
              !0 === e.matches ? null !== this.mobileSwiper && this.destroyMobileSlider() : !1 === e.matches && this.createMobileSlider()
          }
      }, {
          key: "createMobileSlider",
          value: function() {
              var e = this;
              if (!this.mobileSwiper) {
                  var t = "swiper-".concat(++j.counters.instances);
                  this.el.section.querySelector(".swiper-container").setAttribute("id", t),
                  this.mobileSwiper = new lt("#".concat(t),this.mobileSwiperOptions);
                  var i = this.el.section.querySelector("#".concat(t, " .grid-product-tiles__btn-bar"))
                    , n = this.el.section.querySelector("#".concat(t, " .grid-product-tiles__btn-bar-head"))
                    , r = this.el.section.querySelector("#".concat(t, " .grid-product-tiles__btn-bar-text-qty"));
                  n.style.transform = "scaleX(0.125)",
                  this.mobileSwiper.on("slideChange", function() {
                      n.style.transform = "scaleX(".concat(.1 + .9 * e.mobileSwiper.progress, ")")
                  }),
                  this.mobileSwiper.on("reachEnd", function() {
                      i.style.transitionDelay = "0.3s",
                      r.style.transitionDelay = "0.4s",
                      i.style.height = "2.4rem",
                      r.classList.add("is-shown")
                  }),
                  this.mobileSwiper.on("fromEdge", function() {
                      i.style.transitionDelay = "0s",
                      r.style.transitionDelay = "0s",
                      i.style.height = "0.2rem",
                      r.classList.remove("is-shown")
                  })
              }
          }
      }, {
          key: "destroyMobileSlider",
          value: function() {
              this.el.section.querySelector(".swiper-container").removeAttribute("id"),
              this.mobileSwiper.destroy(!1, !0),
              this.mobileSwiper = null
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && xt(t.prototype, i),
      n && xt(t, n),
      e
  }();
  function Et(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(130);
  var Tt = "hero-pdp"
    , Ct = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              scaler: t.querySelector(".".concat(Tt, "__scaler")),
              slider: t.querySelector(".".concat(Tt, "__slider")),
              sliderTrack: t.querySelector(".".concat(Tt, " .swiper-wrapper")),
              toolbar: t.querySelector(".".concat(Tt, "__toolbar")),
              toolbarSizes: t.querySelectorAll(".".concat(Tt, "__sizes li a")),
              toolbarOutOfStock: t.querySelector(".".concat(Tt, "__toolbar-out-of-stock")),
              toolbarSelected: t.querySelector(".".concat(Tt, "__selected-color"))
          },
          this.swiper = null,
          this.desktopBreakpoint = null,
          this.currentMouseX = 0,
          this.flags = {
              isToolbarSticky: !1,
              isDesktop: window.matchMedia("(min-width: 768px)"),
              isSliderPeekingRight: !1,
              isSliderPeekingLeft: !1,
              isSliderReset: !1
          },
          this.bounds = {
              slider: null,
              toolbar: null
          },
          this.events = Object(o.a)(this),
          this.createSwiper(),
          this.measure(),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "measure",
          value: function() {
              this.flags.isDesktop.matches && (this.bounds.slider = {
                  top: this.el.slider.getBoundingClientRect().top + window.scrollY,
                  height: this.el.slider.offsetHeight
              },
              this.bounds.toolbar = {
                  height: this.el.toolbar.offsetHeight
              })
          }
      }, {
          key: "addEventListeners",
          value: function() {
              var e = this;
              this.flags.isDesktop.matches && this.el.section.addEventListener("mousemove", this.events._onSlideAdjacentHover),
              window.addEventListener("scroll", this.events._onWindowScroll, {
                  passive: !0
              }),
              window.addEventListener("resize", this.events._onWindowResize);
              var t = this.el.slider
                , i = this.el.toolbarSizes
                , n = this.el.toolbarOutOfStock;
              this.flags.isDesktop.matches && i.forEach(function(i) {
                  i.classList.contains("disabled") ? i.addEventListener("mouseenter", e.events._onOutOfStockHover) : (i.removeEventListener("mouseenter", e.events._onOutOfStockHover),
                  i.addEventListener("mouseenter", e.events._onOutOfStockHoverOut),
                  t.addEventListener("mouseenter", e.events._onOutOfStockHoverOut),
                  n.addEventListener("mouseleave", e.events._onOutOfStockHoverOut))
              }),
              this.flags.isToolbarSticky || this.el.toolbarSelected.addEventListener("mouseenter", this.events._onSelectedHover)
          }
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "_onWindowResize",
          value: function() {
              this.measure(),
              this.setSwiperHeight(),
              this.toggleStickyToolbar()
          }
      }, {
          key: "_onWindowScroll",
          value: function() {
              this.toggleStickyToolbar()
          }
      }, {
          key: "_onSelectedHover",
          value: function(e) {
              e.preventDefault(),
              this.showToolbarPrimary()
          }
      }, {
          key: "_onSelectedHoverOut",
          value: function(e) {
              e.preventDefault(),
              this.hideToolbarPrimary()
          }
      }, {
          key: "_onOutOfStockHover",
          value: function(e) {
              e.preventDefault(),
              this.showToolbarOutOfStock()
          }
      }, {
          key: "_onOutOfStockHoverOut",
          value: function(e) {
              e.preventDefault(),
              this.hideToolbarOutOfStock()
          }
      }, {
          key: "_onSlideAdjacentHover",
          value: function(e) {
              this.flags.isDesktop.matches && (e.preventDefault(),
              e.pageX / window.innerWidth > .75 && !this.flags.isSliderPeekingRight ? (this.peekSlideRight(),
              this.flags.isSliderPeekingRight = !0) : e.pageX / window.innerWidth < .75 && e.pageX / window.innerWidth > .25 && this.flags.isSliderPeekingRight && e.pageX < this.currentMouseX ? (this.resetRightSlidePeek(),
              this.flags.isSliderPeekingRight = !1) : e.pageX / window.innerWidth < .75 && e.pageX / window.innerWidth > .25 && this.flags.isSliderPeekingLeft && e.pageX > this.currentMouseX ? (this.resetLeftSlidePeek(),
              this.flags.isSliderPeekingLeft = !1) : e.pageX / window.innerWidth < .25 && !this.flags.isSliderPeekingLeft && (this.peekSlideLeft(),
              this.flags.isSliderPeekingLeft = !0),
              this.currentMouseX = e.pageX)
          }
      }, {
          key: "createSwiper",
          value: function() {
              var e = {
                  swiperContainer: ".".concat(Tt, " .swiper-container"),
                  swiperScrollbar: ".".concat(Tt, " .swiper-container .swiper-scrollbar"),
                  swiperNext: ".".concat(Tt, " .swiper-container .swiper-button-next"),
                  swiperPrev: ".".concat(Tt, " .swiper-container .swiper-button-prev")
              }
                , t = e.swiperContainer
                , i = {
                  direction: "horizontal",
                  centeredSlides: !0,
                  initialSlide: 1,
                  slidesPerView: 1.7,
                  loop: !0,
                  loopAdditionalSlides: 100,
                  allowTouchMove: !1,
                  navigation: {
                      nextEl: e.swiperNext,
                      prevEl: e.swiperPrev
                  },
                  scrollbar: {
                      el: e.swiperScrollbar,
                      hide: !1
                  },
                  breakpoints: {
                      768: {
                          allowTouchMove: !0,
                          slidesPerView: 1,
                          loop: !1,
                          loopAdditionalSlides: 0
                      }
                  }
              };
              this.swiper = new lt(t,i),
              this.setSwiperHeight()
          }
      }, {
          key: "setSwiperHeight",
          value: function() {
              var e = this.el.slider
                , t = this.el.toolbar.offsetHeight
                , i = this.el.scaler.clientHeight;
              e.style.height = "".concat(i - t, "px")
          }
      }, {
          key: "resetSlideTransform",
          value: function() {
              var e = this.swiper.getTranslate();
              this.el.sliderTrack.style.transform = "translate3d(".concat(e, "px, 0, 0)")
          }
      }, {
          key: "resetRightSlidePeek",
          value: function() {
              var e = this.el.section.querySelector(".".concat(Tt, " .swiper-button-next"))
                , t = this.swiper.getTranslate();
              this.el.sliderTrack.style.transition = "transform 0.2s ease-in-out",
              this.el.sliderTrack.style.transform = "translate3d(".concat(t + 100, "px, 0, 0)"),
              e.classList.remove("is-shown")
          }
      }, {
          key: "resetLeftSlidePeek",
          value: function() {
              var e = this.el.section.querySelector(".".concat(Tt, " .swiper-button-prev"))
                , t = this.swiper.getTranslate();
              this.el.sliderTrack.style.transition = "transform 0.2s ease-in-out",
              this.el.sliderTrack.style.transform = "translate3d(".concat(t - 100, "px, 0, 0)"),
              e.classList.remove("is-shown")
          }
      }, {
          key: "peekSlideRight",
          value: function() {
              var e = this.el.section.querySelector(".".concat(Tt, " .swiper-button-next"))
                , t = this.swiper.getTranslate();
              this.el.sliderTrack.style.transition = "transform 0.2s cubic-bezier(0.580, 0.305, 0.170, 1.000)",
              this.el.sliderTrack.style.transform = "translate3d(".concat(t - 100, "px, 0, 0)"),
              e.classList.add("is-shown")
          }
      }, {
          key: "peekSlideLeft",
          value: function() {
              var e = this.el.section.querySelector(".".concat(Tt, " .swiper-button-prev"))
                , t = this.swiper.getTranslate();
              this.el.sliderTrack.style.transition = "transform 0.2s cubic-bezier(0.580, 0.305, 0.170, 1.000)",
              this.el.sliderTrack.style.transform = "translate3d(".concat(t + 100, "px, 0, 0)"),
              e.classList.add("is-shown")
          }
      }, {
          key: "toggleStickyToolbar",
          value: function() {
              if (this.flags.isDesktop.matches) {
                  var e = this.el.toolbar
                    , t = this.el.toolbarOutOfStock
                    , i = this.bounds.slider.top + this.bounds.slider.height;
                  !this.flags.isToolbarSticky && window.scrollY >= i ? (e.classList.add("is-sticky"),
                  this.flags.isToolbarSticky = !0) : this.flags.isToolbarSticky && window.scrollY < i && (e.classList.remove("is-sticky"),
                  t.classList.remove("is-sticky"),
                  this.flags.isToolbarSticky = !1)
              }
          }
      }, {
          key: "showToolbarPrimary",
          value: function() {
              this.flags.isDesktop.matches && (this.el.toolbar.classList.add("is-primary-menu"),
              this.el.toolbar.removeEventListener("mouseleave", this.events._onSelectedHoverOut),
              this.el.toolbar.addEventListener("mouseleave", this.events._onSelectedHoverOut))
          }
      }, {
          key: "hideToolbarPrimary",
          value: function() {
              this.flags.isDesktop.matches && (this.el.toolbar.classList.remove("is-primary-menu"),
              this.el.toolbar.removeEventListener("mouseleave", this.events._onSelectedHoverOut))
          }
      }, {
          key: "showToolbarOutOfStock",
          value: function() {
              if (this.el.toolbarOutOfStock.style = "",
              this.el.toolbarOutOfStock.classList.add("is-shown"),
              this.el.toolbar.classList.contains("is-sticky") && this.el.toolbar.classList.contains("is-primary-menu")) {
                  var e = this.el.toolbar.offsetHeight;
                  this.el.toolbarOutOfStock.classList.add("is-sticky"),
                  this.el.toolbarOutOfStock.style.top = "".concat(e, "px")
              } else
                  this.el.toolbarOutOfStock.classList.remove("is-sticky")
          }
      }, {
          key: "hideToolbarOutOfStock",
          value: function() {
              var e = this;
              this.el.toolbarOutOfStock.style.opacity = 0,
              setTimeout(function() {
                  e.el.toolbarOutOfStock.classList.remove("is-shown")
              }, 100)
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Et(t.prototype, i),
      n && Et(t, n),
      e
  }()
    , Lt = (i(131),
  i(132))
    , At = i.n(Lt);
  function Pt(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var It = "hero-pdp-v2"
    , Mt = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              contentTop: t.querySelector(".".concat(It, "__content-top")),
              contentBottom: t.querySelector(".".concat(It, "__content-bottom")),
              heroBadge: t.querySelector(".".concat(It, "__right-badge")),
              heroConfig: t.querySelector(".buy-config"),
              heroCta: t.querySelector(".buy-config__cta"),
              heroCtaBtn: t.querySelector(".buy-config__cta-btn-group"),
              heroSizes: t.querySelector(".buy-config__sizes"),
              heroSizeBtns: t.querySelectorAll(".buy-config__sizes .cta-circle"),
              heroBuyBtn: t.querySelector(".buy-config__cta-buy"),
              heroAppleBtn: t.querySelector(".buy-config__cta-pay"),
              heroModalTrigger: t.querySelector(".buy-config__cta-modal-trigger"),
              heroNotify: t.querySelector(".buy-config__notify"),
              heroReviews: t.querySelector(".".concat(It, "__intro-reviews")),
              heroZoomArea: t.querySelector(".".concat(It, "__zoom-area")),
              heroZoomClose: t.querySelector(".".concat(It, "__close")),
              introContainer: t.querySelector(".".concat(It, "__intro")),
              intro: t.querySelector(".".concat(It, "__intro-content")),
              swatchesWrapper: t.querySelector(".buy-config__colors"),
              swatchProductTiles: t.querySelectorAll(".product-tile--config"),
              slider: t.querySelector(".".concat(It, "__slider")),
              sliderWrapper: t.querySelector(".".concat(It, "__slider .swiper-wrapper")),
              sliderContainer: t.querySelector(".".concat(It, "__slider .swiper-container")),
              sliderSlide: t.querySelector(".".concat(It, "__slider .swiper-slide")),
              sliderSlides: t.querySelectorAll(".".concat(It, "__slider .swiper-slide")),
              sliderProgressBar: t.querySelector(".".concat(It, "__slider-progress")),
              sliderProgressBarHead: t.querySelector(".".concat(It, "__slider-progress-head")),
              sliderModalTrigger: t.querySelector(".".concat(It, "__slider-modal-trigger")),
              sliderCaption: t.querySelector(".".concat(It, "__slider-caption")),
              sliderCaptionText: t.querySelector(".".concat(It, "__slider-caption span")),
              body: document.querySelector("body"),
              primaryNav: document.querySelector(".page-pdp__navigation-primary"),
              reviewSection: document.querySelector("#collapse-reviews"),
              shippingTopbar: document.querySelector(".page-pdp__topbar"),
              drawerTop: document.querySelector(".drawer-top"),
              drawerTopToggler: document.querySelector("[data-drawer-toggler]"),
              subnavCta: document.querySelector(".navigation-subnav-pdp__cta")
          },
          this.animation = {
              slideTime: 450
          },
          this.bounds = {
              config: null,
              contentBottomTop: null,
              heroTop: null,
              sliderTop: null,
              reviewsTop: null,
              ctaOffsetTop: null,
              ctaOffsetBottom: null,
              ctaHeight: null,
              slideWidth: 0
          },
          this.breakpoints = {
              desktop: null,
              mobile: window.matchMedia("(max-width: 768px)")
          },
          this.coords = {
              currentMouseX: 0,
              peekNextRatio: .75,
              peekPrevRatio: .25,
              zoomPeekNextRatio: .6,
              zoomPeekPrevRatio: .4,
              peekImageRatio: .16,
              toggleScrollY: 0
          },
          this.counters = {
              slideIndex: 0
          },
          this.flags = {
              isDesktop: window.matchMedia("(min-width: 768px)"),
              isSliderPeekingRight: !1,
              isSliderPeekingLeft: !1,
              isSliderReset: !1,
              isSliderFirst: !0,
              isSliderFirstPrepend: !0,
              isSliderZoomed: !1,
              isSliderZooming: !1,
              isSwatchSelected: !1,
              isSizeSelected: !1,
              isPrevActive: !1,
              isNextActive: !1,
              isMouseOverClose: !1
          },
          this.productData = {
              sizeStock: null,
              productStock: null
          },
          this.swiper = null,
          this.timeouts = {
              tileFade: null,
              tileSwap: null
          },
          this.lirp = new u.c,
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.measure(),
              this.createSwiper(),
              this.addEventListeners(),
              this.setTileActive(this.el.swatchProductTiles[0], !0),
              this.progressSlideBar()
          }
      }, {
          key: "getBounds",
          value: function(e, t) {
              var i = 0
                , n = t;
              do {
                  isNaN(n[e]) || (i += n[e]),
                  n = n.offsetParent
              } while (n);return i
          }
      }, {
          key: "measure",
          value: function() {
              this.bounds.config = Object(o.g)(this.el.heroConfig),
              this.bounds.ctaHeight = this.el.heroCta.offsetHeight,
              this.bounds.configTop = this.getBounds("offsetTop", this.el.heroConfig),
              this.bounds.ctaOffsetTop = this.getBounds("offsetTop", this.el.heroCta),
              this.bounds.ctaOffsetBottom = parseInt(getComputedStyle(this.el.heroCtaBtn).bottom, 10),
              this.bounds.reviewsTop = this.getBounds("offsetTop", this.el.reviewSection),
              this.bounds.sliderTop = this.getBounds("offsetTop", this.el.slider),
              this.bounds.slideWidth = this.el.sliderSlides[0].offsetWidth
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("scroll", this.events._onWindowScroll, {
                  passive: !0
              }),
              window.addEventListener("resize", this.events._onWindowResize),
              this.breakpoints.mobile.addListener(this.events._onBpResize),
              this.el.slider.addEventListener("mousemove", this.events._onSlideAdjacentHover, {
                  passive: !0
              }),
              this.el.slider.addEventListener("mouseenter", this.events._onHeroHover),
              this.el.slider.addEventListener("mouseleave", this.events._onHeroHoverOut),
              this.el.slider.addEventListener("click", this.events._onHeroClick),
              this.el.heroZoomArea.addEventListener("click", this.events._onZoomClick),
              this.el.heroZoomClose.addEventListener("click", this.events._onZoomCloseClick),
              this.el.heroZoomClose.addEventListener("mouseenter", this.events._onZoomCloseHover),
              this.el.heroZoomClose.addEventListener("mouseleave", this.events._onZoomCloseHoverOut),
              this.el.heroCtaBtn.addEventListener("click", this.events._onHeroCtaBtnClick),
              this.el.heroReviews.addEventListener("click", this.events._onHeroReviewsClick),
              this.el.subnavCta && this.el.subnavCta.addEventListener("click", this.events._onHeroCtaBtnClick),
              Object(o.k)(this.el.swatchProductTiles, "click", this.events._onConfigTileClick),
              Object(o.k)(this.el.heroSizeBtns, "click", this.events._onSizeButtonClick),
              this.swiper.on("slideChangeTransitionStart", this.events._onSlideChange),
              this.lirp.callback = this.events._onLirpUpdate,
              this.lirp.callbackComplete = this.events._onLirpComplete,
              this.checkResize()
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("scroll", this.events._onWindowScroll),
              window.removeEventListener("resize", this.events._onWindowResize),
              this.el.slider.removeEventListener("mousemove", this.events._onSlideAdjacentHover),
              this.el.slider.removeEventListener("mouseenter", this.events._onHeroHover),
              this.el.slider.removeEventListener("mouseleave", this.events._onHeroHoverOut),
              this.el.slider.removeEventListener("click", this.events._onHeroClick),
              this.el.heroCtaBtn.removeEventListener("click", this.events._onHeroCtaBtnClick),
              this.el.heroReviews.removeEventListener("click", this.events._onHeroReviewsClick),
              this.el.subnavCta && this.el.subnavCta.removeEventListener("click", this.events._onHeroCtaBtnClick),
              Object(o.m)(this.el.swatchProductTiles, "click", this.events._onConfigTileClick),
              Object(o.m)(this.el.heroSizeBtns, "click", this.events._onSizeButtonClick),
              this.swiper && this.swiper.off("slideChangeTransitionStart"),
              this.lirp && this.lirp.destroy()
          }
      }, {
          key: "_onWindowScroll",
          value: function() {
              this.checkScroll()
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.checkResize()
          }
      }, {
          key: "_onBpResize",
          value: function() {
              this.unstickSlider(),
              this.swiper.destroy(),
              this.swiper = null,
              this.createSwiper()
          }
      }, {
          key: "_onHeroHover",
          value: function() {
              Object(o.j)("large") && z.change("zoom-icon")
          }
      }, {
          key: "_onHeroHoverOut",
          value: function() {
              z.off()
          }
      }, {
          key: "_onHeroClick",
          value: function() {
              this.checkSliderClick()
          }
      }, {
          key: "_onZoomHeroClick",
          value: function() {
              this.checkZoomClick()
          }
      }, {
          key: "_onHeroCtaBtnClick",
          value: function() {
              this.scrollCta()
          }
      }, {
          key: "_onHeroReviewsClick",
          value: function() {
              this.scrollReviews()
          }
      }, {
          key: "_onSlideNextClick",
          value: function(e) {
              e.preventDefault(),
              this.gotoNextSlide()
          }
      }, {
          key: "_onSlidePrevClick",
          value: function(e) {
              e.preventDefault(),
              this.gotoPrevSlide()
          }
      }, {
          key: "_onSlideAdjacentHover",
          value: function(e) {
              this.checkSliderMousePeeking(e.pageX)
          }
      }, {
          key: "_onZoomAdjacentHover",
          value: function(e) {
              this.checkZoomMousePeeking(e.pageX)
          }
      }, {
          key: "_onZoomTransitionEnd",
          value: function(e) {
              "transform" !== !e.propertyName && (this.changeZoomCtrls(),
              this.el.sliderContainer.removeEventListener("transitionend", this.events._onZoomTransitionEnd, !1))
          }
      }, {
          key: "_onConfigTileClick",
          value: function(e) {
              e.preventDefault();
              var t = e.currentTarget
                , i = t.classList.contains("active");
              i || (this.productData.sizeStock = null,
              this.productData.productStock = null,
              this.clearSwatchSelect(),
              this.hideNotice(),
              t.classList.contains("disabled") ? this.showOosNotice() : i || (this.setTileActive(t),
              this.el.drawerTopToggler.classList.add("is-uncollapsed")))
          }
      }, {
          key: "_onSizeButtonClick",
          value: function(e) {
              e.preventDefault();
              var t = e.currentTarget
                , i = t.classList.contains("cta-circle-outlined");
              this.hideNotice(),
              this.clearSizeSelect(),
              this.selectSize(t),
              i ? (t.classList.remove("cta-circle-outlined"),
              this.el.drawerTopToggler.classList.add("is-uncollapsed"),
              this.updateCtaPrice()) : (t.classList.add("cta-circle-outlined"),
              Object(o.l)(this.el.swatchProductTiles, "remove", "disabled"),
              this.resetCtaPrice())
          }
      }, {
          key: "_onZoomClick",
          value: function() {
              this.zoomSlider()
          }
      }, {
          key: "_onZoomCloseClick",
          value: function() {
              this.zoomOutSlider()
          }
      }, {
          key: "_onZoomCloseHover",
          value: function() {
              this.flags.isMouseOverClose = !0,
              z.off()
          }
      }, {
          key: "_onZoomCloseHoverOut",
          value: function() {
              this.flags.isMouseOverClose = !1,
              z.on()
          }
      }, {
          key: "_onSlideChange",
          value: function() {
              var e = this.el.sliderWrapper.querySelector(".swiper-slide-active");
              if (this.flags.isSliderZoomed)
                  if (this.flags.modalTriggerShown = !0,
                  e.classList.contains("swiper-slide--appended") || e.classList.contains("swiper-slide--prepended")) {
                      this.flags.modalTriggerShown = !1;
                      var t = e.getAttribute("data-caption");
                      this.el.sliderModalTrigger.classList.remove("is-shown"),
                      this.el.sliderCaptionText.innerHTML = t,
                      this.el.sliderCaption.classList.add("is-shown")
                  } else
                      this.flags.modalTriggerShown = !0,
                      this.el.sliderCaptionText.innerHTML = "",
                      this.el.sliderCaption.classList.remove("is-shown"),
                      this.el.sliderModalTrigger.classList.add("is-shown")
          }
      }, {
          key: "_onLirpUpdate",
          value: function(e) {
              this.peekSlidesTo(e)
          }
      }, {
          key: "_onLirpComplete",
          value: function() {
              this.flags.isSliderPeekingLeft || this.flags.isSliderPeekingRight || this.resetPeekingComplete()
          }
      }, {
          key: "checkResize",
          value: function() {
              this.measure(),
              this.unstickSlider();
              var e = this.el.heroSizes.querySelector("ul");
              e.children[0].offsetWidth * e.children.length > e.offsetWidth ? this.el.heroSizes.classList.add("is-offscreen") : this.el.heroSizes.classList.remove("is-offscreen"),
              this.checkScroll()
          }
      }, {
          key: "checkScroll",
          value: function() {
              this.el.shippingTopbar && this.toggleTopbar(),
              this.hideDrawerToggler(),
              this.toggleStickyCta(),
              this.toggleStickySlider()
          }
      }, {
          key: "showOosNotice",
          value: function() {
              this.showNotice("oos"),
              this.resetCtaPrice()
          }
      }, {
          key: "setTileActive",
          value: function(e) {
              var t = this
                , i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
                , n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
              if (!e.classList.contains("active") || i) {
                  this.clearSwatchSelect(),
                  e.classList.add("active");
                  for (var r = e.querySelector("a").getAttribute("data-image-zoom-url").split(","), s = [], a = 0; a < r.length; a++) {
                      var l = r[a];
                      s.push({
                          imageUrl: l,
                          params: 'data-color="'.concat(e.getAttribute("data-color"), '"'),
                          caption: 'data-caption="'.concat(e.getAttribute("data-caption"), '"')
                      })
                  }
                  if (this.clearSwatchDisabled(),
                  this.flags.isSliderFirst)
                      this.flags.isSliderFirst = !1,
                      this.appendNewSlides(this.makeNewSlides(s, "swiper-slide--appended")),
                      this.appendSwatchSlides();
                  else if (n)
                      if (this.flags.isSliderFirstPrepend)
                          this.flags.isSliderFirstPrepend = !1,
                          this.removePrevNewSlides(),
                          this.prependNewSlides(this.makeNewSlides(s, "swiper-slide--prepended")),
                          this.appendSwatchSlides(),
                          this.el.slider.classList.add("is-first-tile-waiting"),
                          this.swiper.slideTo(0, this.animation.slideTime),
                          S.a.one(function() {
                              t.el.slider.classList.remove("is-first-tile-waiting")
                          });
                      else {
                          var c = this.swiper.activeIndex
                            , u = c === Object(o.f)(e) ? 0 : this.animation.slideTime;
                          this.prependNewSlides(this.makeNewSlides(s, "swiper-slide--prepended")),
                          this.el.slider.classList.add("is-swapping"),
                          this.swiper.slideTo(c, 0),
                          this.el.slider.classList.add("is-init"),
                          S.a.one(function() {
                              t.el.slider.classList.remove("is-init"),
                              t.swiper.slideTo(0, u)
                          }),
                          clearTimeout(this.timeouts.tileSwap),
                          this.timeouts.tileSwap = setTimeout(function() {
                              t.removePrevNewSlides(),
                              t.appendSwatchSlides(),
                              t.swiper.slideTo(0, 0),
                              t.el.slider.classList.remove("is-swapping")
                          }, Math.max(300, u))
                      }
                  n && this.resetPeeking(),
                  e.dataset.sizeStock && (this.productData.sizeStock = JSON.parse(e.dataset.sizeStock.replace(/'/g, '"')),
                  this.el.heroSizes.classList.remove("is-ready"),
                  S.a.one(function() {
                      t.el.heroSizes.classList.add("is-ready")
                  }),
                  this.showSizes()),
                  this.flags.isSwatchSelected = !0,
                  this.updateCtaPrice()
              }
          }
      }, {
          key: "checkSliderMousePeeking",
          value: function(e) {
              if (Object(o.j)("large")) {
                  var t = !1;
                  e / window.innerWidth > this.coords.peekNextRatio ? this.swiper.isEnd || (t = !0,
                  this.flags.isSliderPeekingRight || (this.flags.isSliderPeekingRight = !0,
                  z.change("next-icon")),
                  this.peekNext(this.getPeekRatio())) : e / window.innerWidth < this.coords.peekPrevRatio && (this.swiper.isBeginning || (t = !0,
                  this.flags.isSliderPeekingLeft || (this.flags.isSliderPeekingLeft = !0,
                  z.change("prev-icon")),
                  this.peekPrev(this.getPeekRatio()))),
                  this.swiper.animating || t || (this.flags.isSliderPeekingLeft = !1,
                  this.flags.isSliderPeekingRight = !1,
                  this.resetPeeking(),
                  z.change("zoom-icon"))
              }
              this.coords.currentMouseX = e
          }
      }, {
          key: "checkZoomMousePeeking",
          value: function(e) {
              if (Object(o.j)("large")) {
                  var t = !1;
                  e / window.innerWidth > this.coords.zoomPeekNextRatio ? this.swiper.isEnd || (t = !0,
                  this.flags.isSliderPeekingRight || (this.flags.isSliderPeekingRight = !0,
                  z.change("next-icon")),
                  this.peekNext(this.getPeekRatio())) : e / window.innerWidth < this.coords.zoomPeekPrevRatio && (this.swiper.isBeginning || (t = !0,
                  this.flags.isSliderPeekingLeft || (this.flags.isSliderPeekingLeft = !0,
                  z.change("prev-icon")),
                  this.peekPrev(this.getPeekRatio()))),
                  this.swiper.animating || t || (this.flags.isSliderPeekingLeft = !1,
                  this.flags.isSliderPeekingRight = !1,
                  this.resetPeeking(),
                  z.off())
              }
              this.coords.currentMouseX = e
          }
      }, {
          key: "peekNext",
          value: function() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
              this.el.slider.classList.add("is-peeking"),
              this.lirp.update(0 - this.coords.peekImageRatio * this.bounds.slideWidth * e)
          }
      }, {
          key: "peekPrev",
          value: function() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
              this.el.slider.classList.add("is-peeking"),
              this.lirp.update(0 + this.coords.peekImageRatio * this.bounds.slideWidth * e)
          }
      }, {
          key: "resetPeeking",
          value: function() {
              this.lirp.update(0)
          }
      }, {
          key: "resetPeekingComplete",
          value: function() {
              this.el.slider.classList.remove("is-peeking")
          }
      }, {
          key: "peekSlidesTo",
          value: function() {
              for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = 0; t < this.swiper.slides.length; t++) {
                  var i = this.swiper.slides[t];
                  Object.assign(i.style, {
                      transform: "translateX(".concat(e, "px)")
                  })
              }
          }
      }, {
          key: "getPeekRatio",
          value: function() {
              var e = window.innerWidth
                , t = this.coords.currentMouseX / e;
              return t >= this.coords.peekNextRatio ? Math.pow((t - this.coords.peekNextRatio) / (1 - this.coords.peekNextRatio), 1) : t < this.coords.peekPrevRatio ? Math.pow(1 - t / this.coords.peekPrevRatio, 1) : 0
          }
      }, {
          key: "checkSlideStatus",
          value: function() {
              var e = this.getActiveSlideIndex();
              e >= this.el.sliderSlides.length - 1 ? this.flags.isNextActive = !1 : this.flags.isNextActive = !0,
              this.flags.isPrevActive = !(e <= 0)
          }
      }, {
          key: "checkSliderClick",
          value: function() {
              this.coords.currentMouseX / window.innerWidth > .85 ? this.swiper.isEnd || this.flags.isMouseOverClose || this.gotoNextSlide() : this.coords.currentMouseX / window.innerWidth < .85 && this.coords.currentMouseX / window.innerWidth > .15 && !this.swiper.animating || this.coords.currentMouseX / window.innerWidth < .15 && (this.swiper.isBeginning || this.gotoPrevSlide())
          }
      }, {
          key: "checkZoomClick",
          value: function() {
              this.coords.currentMouseX / window.innerWidth > .5 ? this.swiper.isEnd || this.flags.isMouseOverClose || this.gotoNextSlide() : this.coords.currentMouseX / window.innerWidth < .5 && (this.swiper.isBeginning || this.gotoPrevSlide())
          }
      }, {
          key: "createSwiper",
          value: function() {
              var e = {
                  swiperContainer: ".".concat(It, "__slider .swiper-container"),
                  swiperScrollbar: ".".concat(It, "__slider .swiper-container .swiper-scrollbar"),
                  swiperNext: ".".concat(It, "__slider .swiper-container .swiper-button-next"),
                  swiperPrev: ".".concat(It, "__slider .swiper-container .swiper-button-prev")
              }
                , t = e.swiperContainer
                , i = {
                  direction: "horizontal",
                  centeredSlides: !0,
                  slidesPerView: "auto",
                  loop: !1,
                  allowTouchMove: !1,
                  preventInteractionOnTransition: !1,
                  navigation: {
                      nextEl: e.swiperNext,
                      prevEl: e.swiperPrev
                  },
                  scrollbar: {
                      el: e.swiperScrollbar,
                      hide: !1
                  },
                  breakpoints: {
                      768: {
                          allowTouchMove: !0,
                          slidesPerView: 1
                      }
                  }
              };
              this.swiper = new lt(t,i)
          }
      }, {
          key: "getActiveSlideIndex",
          value: function() {
              if (this.swiper)
                  return this.swiper.activeIndex
          }
      }, {
          key: "progressSlideBar",
          value: function() {
              var e = this;
              this.el.sliderProgressBarHead.style.transform = "scaleX(0)",
              this.swiper.on("slideChange", function() {
                  e.el.sliderProgressBarHead.style.transform = "scaleX(".concat(e.swiper.progress, ")")
              })
          }
      }, {
          key: "zoomSlider",
          value: function() {
              var e = this;
              if (!this.flags.isSliderZooming && !this.flags.isSliderZoomed) {
                  this.flags.isSliderZoomed = !0,
                  this.flags.isSliderZooming = !0,
                  setTimeout(function() {
                      return e.changeZoomCtrls()
                  }, 0);
                  var t = 0 - this.bounds.sliderTop + window.scrollY
                    , i = 0 - this.bounds.sliderTop + window.scrollY;
                  window.scrollY > this.bounds.sliderTop && (this.el.section.classList.add("is-zoomed-in-low"),
                  t = 0),
                  this.el.sliderContainer.style.transform = "matrix(1, 0, 0, 1, 0, ".concat(t, ")"),
                  this.coords.toggleScrollY = window.scrollY,
                  this.el.drawerTop.classList.add("is-hidden"),
                  this.el.drawerTop.classList.remove("is-hidden-out"),
                  this.el.primaryNav.classList.add("is-hidden"),
                  this.el.primaryNav.classList.remove("is-hidden-out"),
                  this.el.heroCta.classList.add("is-hidden"),
                  this.el.heroBadge.classList.add("is-hidden"),
                  this.el.contentBottom.classList.add("is-hidden"),
                  this.el.introContainer.classList.add("is-hidden"),
                  this.el.heroZoomClose.classList.add("is-shown"),
                  this.el.sliderModalTrigger.classList.add("is-shown"),
                  this.el.section.classList.add("is-zoomed"),
                  this.el.sliderContainer.classList.add("is-zoomed"),
                  document.body.classList.contains("is-safari-ios") && (this.el.sliderContainer.style.height = "".concat(window.innerHeight, "px"));
                  var n = Object(o.j)("large") && !document.body.classList.contains("is-user-touch") ? 900 : 0;
                  setTimeout(function() {
                      e.flags.isSliderZooming = !1,
                      e.el.section.classList.add("is-zoomed-complete"),
                      e.el.sliderContainer.style.transform = "matrix(1, 0, 0, 1, 0, ".concat(i, ")"),
                      document.body.classList.add("no-scroll"),
                      document.body.style.top = "".concat(0 - e.coords.toggleScrollY, "px")
                  }, n)
              }
          }
      }, {
          key: "zoomOutSlider",
          value: function() {
              var e = this;
              if (!this.flags.isSliderZooming && this.flags.isSliderZoomed) {
                  this.flags.isSliderZoomed = !1,
                  this.flags.isSliderZooming = !0,
                  setTimeout(function() {
                      return e.revertZoomCtrls()
                  }, 0);
                  var t = 0 - this.bounds.sliderTop + window.scrollY;
                  document.body.classList.remove("no-scroll"),
                  document.body.style.top = "",
                  window.scrollTo({
                      top: this.coords.toggleScrollY
                  }),
                  window.scrollY > this.bounds.sliderTop ? (this.el.section.classList.add("is-zoomed-out-low"),
                  this.el.sliderContainer.style = null,
                  S.a.one(function() {
                      e.el.section.classList.remove("is-zoomed-out-low"),
                      e.el.sliderContainer.style = null
                  })) : (this.el.sliderContainer.style.transform = "matrix(1, 0, 0, 1, 0, ".concat(t, ")"),
                  S.a.one(function() {
                      e.el.sliderContainer.style = null
                  })),
                  this.el.drawerTop.classList.remove("is-hidden"),
                  this.el.drawerTop.classList.add("is-hidden-out"),
                  this.el.primaryNav.classList.remove("is-hidden"),
                  this.el.primaryNav.classList.add("is-hidden-out"),
                  this.el.contentBottom.classList.remove("is-hidden"),
                  this.el.heroCta.classList.remove("is-hidden"),
                  this.el.heroBadge.classList.remove("is-hidden"),
                  this.el.heroZoomClose.classList.remove("is-shown"),
                  this.el.introContainer.classList.remove("is-hidden"),
                  this.el.section.classList.remove("is-zoomed", "is-zoomed-in-low", "is-zoomed-complete"),
                  this.el.sliderContainer.classList.remove("is-zoomed"),
                  this.el.sliderModalTrigger.classList.remove("is-shown"),
                  this.el.sliderCaption.classList.remove("is-shown");
                  var i = Object(o.j)("large") && !document.body.classList.contains("is-user-touch") ? 600 : 0;
                  setTimeout(function() {
                      e.flags.isSliderZooming = !1
                  }, i)
              }
          }
      }, {
          key: "changeZoomCtrls",
          value: function() {
              z.off(),
              this.el.slider.removeEventListener("mouseenter", this.events._onHeroHover),
              this.el.slider.removeEventListener("mouseleave", this.events._onHeroHoverOut),
              this.el.slider.removeEventListener("mousemove", this.events._onSlideAdjacentHover, {
                  passive: !0
              }),
              this.el.slider.removeEventListener("click", this.events._onHeroClick),
              this.el.slider.addEventListener("mousemove", this.events._onZoomAdjacentHover, {
                  passive: !0
              }),
              this.el.slider.addEventListener("click", this.events._onZoomHeroClick)
          }
      }, {
          key: "revertZoomCtrls",
          value: function() {
              this.el.slider.removeEventListener("mousemove", this.events._onZoomAdjacentHover),
              this.el.slider.removeEventListener("click", this.events._onZoomHeroClick),
              this.el.slider.addEventListener("mousemove", this.events._onSlideAdjacentHover),
              this.el.slider.addEventListener("mouseenter", this.events._onHeroHover),
              this.el.slider.addEventListener("mouseleave", this.events._onHeroHoverOut),
              this.el.slider.addEventListener("click", this.events._onHeroClick)
          }
      }, {
          key: "gotoNextSlide",
          value: function() {
              this.seekSlideIndex(this.swiper.activeIndex + 1)
          }
      }, {
          key: "gotoPrevSlide",
          value: function() {
              this.seekSlideIndex(this.swiper.activeIndex - 1)
          }
      }, {
          key: "seekSlideIndex",
          value: function(e) {
              var t = Math.max(0, Math.min(e, this.swiper.slides.length))
                , i = this.swiper.activeIndex
                , n = Math.abs(t - i);
              t !== i && this.swiper.slideTo(t, n * this.animation.slideTime)
          }
      }, {
          key: "makeNewSlides",
          value: function(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ""
                , i = [];
              return e.forEach(function(e) {
                  var n = o.i.template(At.a)({
                      classes: t,
                      params: e.params,
                      src: e.imageUrl,
                      caption: e.caption
                  });
                  i.push(n)
              }),
              i
          }
      }, {
          key: "appendSwatchSlides",
          value: function() {
              for (var e = [], t = 0; t < this.el.swatchProductTiles.length; t++) {
                  var i = this.el.swatchProductTiles[t];
                  if (!i.classList.contains("active")) {
                      for (var n = i.querySelector("a").getAttribute("data-image-zoom-url").split(","), r = [], o = 0; o < n.length; o++) {
                          var s = n[o];
                          r.push({
                              imageUrl: s,
                              params: 'data-color="'.concat(i.getAttribute("data-color"), '"'),
                              caption: 'data-caption="'.concat(i.getAttribute("data-caption"), '"')
                          })
                      }
                      e = e.concat(r)
                  }
              }
              this.appendNewSlides(this.makeNewSlides(e, "swiper-slide--appended"))
          }
      }, {
          key: "appendNewSlides",
          value: function(e) {
              this.swiper.appendSlide(e),
              this.swiper.update()
          }
      }, {
          key: "prependNewSlides",
          value: function(e) {
              this.swiper.prependSlide(e),
              this.swiper.update()
          }
      }, {
          key: "removePrevNewSlides",
          value: function() {
              var e = this
                , t = this.el.slider.querySelectorAll(".swiper-slide")
                , i = [];
              t.forEach(function(t, n) {
                  0 === n && e.el.slider.classList.contains("is-swapping") || (t.classList.contains("swiper-slide--prepended") || t.classList.contains("swiper-slide--appended")) && i.push(n)
              }),
              this.swiper.removeSlide(i)
          }
      }, {
          key: "showSizes",
          value: function() {
              var e = this;
              this.el.heroSizeBtns.forEach(function(t) {
                  t.classList.add("disabled"),
                  e.productData.sizeStock.includes(t.dataset.size) && t.classList.remove("disabled")
              })
          }
      }, {
          key: "selectSize",
          value: function(e) {
              var t = this;
              e.classList.contains("cta-circle-outlined") ? (e.classList.contains("disabled") ? (this.flags.isSizeSelected = !1,
              this.showNotice("oos")) : (this.flags.isSizeSelected = !0,
              this.flags.isSwatchSelected || (this.productData.productStock = JSON.parse(e.dataset.productStock.replace(/'/g, '"')),
              this.el.swatchProductTiles.forEach(function(e) {
                  e.classList.add("disabled"),
                  t.productData.productStock.includes(e.dataset.color) && e.classList.remove("disabled")
              }))),
              e.classList.remove("cta-circle-outlined")) : (this.flags.isSizeSelected = !1,
              e.classList.add("cta-circle-outlined"))
          }
      }, {
          key: "showNotice",
          value: function() {
              this.el.heroNotify.classList.add("is-visible")
          }
      }, {
          key: "hideNotice",
          value: function() {
              this.el.heroNotify.classList.remove("is-visible")
          }
      }, {
          key: "updateCtaPrice",
          value: function() {
              this.flags.isSizeSelected && this.flags.isSwatchSelected ? (this.el.heroBuyBtn.textContent = "Add to Bag",
              this.el.heroBuyBtn.classList.add("is-valid"),
              this.el.heroAppleBtn.classList.add("is-visible"),
              this.el.heroCtaBtn.removeEventListener("click", this.events._onHeroCtaBtnClick)) : this.resetCtaPrice()
          }
      }, {
          key: "clearSwatchSelect",
          value: function() {
              this.flags.isSwatchSelected = !1,
              Object(o.l)(this.el.swatchProductTiles, "remove", "active")
          }
      }, {
          key: "clearSwatchDisabled",
          value: function() {
              Object(o.l)(this.el.swatchProductTiles, "remove", "disabled")
          }
      }, {
          key: "clearSizeSelect",
          value: function() {
              this.flags.isSizeSelected = !1,
              Object(o.l)(this.el.heroSizeBtns, "add", "cta-circle-outlined")
          }
      }, {
          key: "resetCtaPrice",
          value: function() {
              this.el.heroBuyBtn.textContent = "Buy $99-$149",
              this.el.heroBuyBtn.classList.remove("is-valid"),
              this.el.heroAppleBtn.classList.remove("is-visible"),
              this.el.heroCtaBtn.addEventListener("click", this.events._onHeroCtaBtnClick)
          }
      }, {
          key: "toggleStickySlider",
          value: function() {
              window.scrollY >= this.bounds.sliderTop ? this.stickSlider() : this.unstickSlider()
          }
      }, {
          key: "stickSlider",
          value: function() {
              var e = this.el.slider.offsetHeight;
              Object(o.j)("large") && (this.el.contentBottom.style = "margin-top: ".concat(e, "px"),
              this.el.slider.classList.add("is-sticky"))
          }
      }, {
          key: "unstickSlider",
          value: function() {
              this.el.contentBottom.style = "",
              this.el.slider.classList.remove("is-sticky"),
              this.el.drawerTopToggler.classList.remove("is-uncollapsed")
          }
      }, {
          key: "toggleTopbar",
          value: function() {
              window.scrollY > this.el.primaryNav.offsetHeight ? this.el.shippingTopbar.classList.add("is-visible") : this.el.shippingTopbar.classList.remove("is-visible")
          }
      }, {
          key: "scrollReviews",
          value: function() {
              var e = this.bounds.reviewsTop;
              window.scrollTo({
                  top: e,
                  behavior: "smooth"
              })
          }
      }, {
          key: "scrollCta",
          value: function() {
              var e = this.bounds.config.height + this.bounds.sliderTop - this.bounds.ctaOffsetBottom - this.bounds.ctaHeight;
              isNaN(e) || window.scrollTo({
                  top: e,
                  behavior: "smooth"
              })
          }
      }, {
          key: "toggleStickyCta",
          value: function() {
              var e = j.coords.window.height;
              window.scrollY + e < this.bounds.ctaOffsetTop + this.el.heroCta.offsetHeight + this.bounds.ctaOffsetBottom ? this.stickCtaBottom() : window.scrollY > this.bounds.ctaOffsetTop - this.bounds.ctaOffsetBottom ? (this.el.shippingTopbar && this.el.shippingTopbar.classList.remove("is-visible"),
              this.el.drawerTop.classList.remove("is-shown")) : this.unstickCta()
          }
      }, {
          key: "stickCtaBottom",
          value: function() {
              this.flags.isSizeSelected && this.flags.isSwatchSelected ? this.el.heroBuyBtn.textContent = "Add to Bag" : this.el.heroBuyBtn.textContent = "Buy $99-$149",
              this.el.heroCtaBtn.classList.add("is-sticky--bottom")
          }
      }, {
          key: "stickCtaTop",
          value: function() {
              this.flags.isSizeSelected && this.flags.isSwatchSelected ? this.el.heroBuyBtn.textContent = "Add to Bag" : this.el.heroBuyBtn.textContent = "Buy $99-$149",
              this.el.heroCtaBtn.classList.add("is-sticky--top")
          }
      }, {
          key: "unstickCta",
          value: function() {
              this.flags.isSizeSelected && this.flags.isSwatchSelected ? this.el.heroBuyBtn.textContent = "Add to Bag" : this.el.heroBuyBtn.textContent = "Buy $99-$149",
              this.el.heroCtaBtn.classList.remove("is-sticky--top"),
              this.el.heroCtaBtn.classList.remove("is-sticky--bottom")
          }
      }, {
          key: "toggleDrawerTop",
          value: function() {
              window.scrollY > this.el.primaryNav.offsetHeight ? this.el.drawerTop.classList.add("is-shown") : this.el.drawerTop.classList.remove("is-shown")
          }
      }, {
          key: "hideDrawerToggler",
          value: function() {
              window.scrollY > this.el.primaryNav.offsetHeight + this.el.section.offsetHeight && this.el.drawerTopToggler.classList.remove("is-uncollapsed")
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners(),
              this.el.body.classList.remove("is-modal-open")
          }
      }]) && Pt(t.prototype, i),
      n && Pt(t, n),
      e
  }();
  function Ot(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(133);
  var zt = "hero-plp"
    , Dt = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              body: document.querySelector("body"),
              navigation: document.querySelector(".navigation-primary"),
              bgWrapper: t.querySelector(".".concat(zt, "__bg-wrapper")),
              bgWhiteBlock: t.querySelector(".".concat(zt, "__bg-white-block")),
              bgImage: t.querySelector(".hero-plp__bg--full"),
              content: t.querySelector(".".concat(zt, "__content")),
              contentWrapper: t.querySelector(".".concat(zt, "__content-wrapper")),
              scaler: t.querySelector(".".concat(zt, "__scaler")),
              shoppingTool: t.querySelector(".".concat(zt, "__content--shopping-tool")),
              shoppingToolWrapper: t.querySelector(".".concat(zt, "__content--shopping-tool-wrapper")),
              infoOpen: t.querySelector(".".concat(zt, "__info-open")),
              infoClose: t.querySelector(".".concat(zt, "__info-close"))
          },
          this.bounds = {
              content: null,
              section: null,
              shoppingTool: null
          },
          this.config = {
              scrollSnapMax: 100
          },
          this.flags = {
              isPendingShrinkDelay: !1,
              isScrolled: !1,
              isShowing: !1,
              isShrinkAnimating: !1,
              isShrunk: !1,
              isStickyTool: !1
          },
          this.status = {
              shoppingTool: "default",
              shrinkDelayTriggerTime: -1
          },
          this.timeouts = {
              shoppingTool: null,
              shrink: null
          },
          this.scrollDetector = null,
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.addEventListeners(),
              this.show(!1)
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("resize", this.events._onResize),
              window.addEventListener("scroll", this.events._onScroll, {
                  passive: !0
              }),
              Object(o.j)("large") && (this.el.infoOpen.addEventListener("click", this.events._onInfoOpenClick),
              this.el.infoClose.addEventListener("click", this.events._onInfoCloseClick)),
              this.scrollDetector = new u.d(window),
              this._onResize()
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("resize", this.events._onResize),
              window.removeEventListener("scroll", this.events._onScroll),
              this.el.infoOpen.removeEventListener("click", this.events._onInfoOpenClick),
              this.el.infoClose.removeEventListener("click", this.events._onInfoCloseClick),
              this.scrollDetector.destroy()
          }
      }, {
          key: "_onResize",
          value: function() {
              this.bounds.content = Object(o.g)(this.el.content),
              this.bounds.section = Object(o.g)(this.el.section),
              this.bounds.shoppingTool = Object(o.g)(this.el.shoppingTool);
              var e = j.coords.window.height
                , t = this.getFinalHeight();
              Object(o.j)("large") ? (this.flags.isShrunk || (t = e),
              this.flags.isShrinkAnimating || (this.el.bgWrapper.style.height = "".concat(t, "px"),
              this.el.contentWrapper.style.height = "".concat(t, "px"))) : (this.el.bgWrapper.style.height = "".concat(t, "px"),
              this.el.contentWrapper.style.height = "".concat(t, "px")),
              this.checkScroll()
          }
      }, {
          key: "_onScroll",
          value: function() {
              this.checkScroll()
          }
      }, {
          key: "_onInfoOpenClick",
          value: function() {
              this.enlarge()
          }
      }, {
          key: "_onInfoCloseClick",
          value: function() {
              this.enlargeOut()
          }
      }, {
          key: "checkScroll",
          value: function() {
              var e = this
                , t = window.scrollY;
              this.flags.isShrunk && !this.flags.isPendingShrinkDelay ? (t >= this.bounds.content.scrollBottom - 2 * this.bounds.shoppingTool.height ? this.flags.isScrolled || (this.flags.isScrolled = !0,
              this.el.section.classList.add("is-scrolled")) : this.flags.isScrolled && (this.flags.isScrolled = !1,
              this.el.section.classList.remove("is-scrolled"),
              this.el.section.classList.add("is-back-from-scrolled")),
              t >= this.bounds.content.scrollBottom + this.bounds.shoppingTool.height ? this.flags.isStickyTool || "default" !== this.status.shoppingTool || (this.flags.isStickyTool = !0,
              this.el.section.classList.add("is-tool-changing"),
              this.timeouts.shoppingTool = window.setTimeout(function() {
                  e.el.section.classList.add("is-sticky-tool"),
                  e.el.shoppingTool.classList.add("is-inverse"),
                  e.el.section.classList.remove("is-tool-changing"),
                  e.status.shoppingTool = "fixed"
              }, 300)) : this.flags.isStickyTool && "fixed" === this.status.shoppingTool && (this.flags.isStickyTool = !1,
              this.status.shoppingTool = "fromFixed",
              this.el.section.classList.add("is-tool-changing"),
              this.timeouts.shoppingTool = window.setTimeout(function() {
                  e.el.section.classList.remove("is-sticky-tool"),
                  e.el.bgImage && e.el.shoppingTool.classList.remove("is-inverse"),
                  e.el.section.classList.remove("is-tool-changing"),
                  e.status.shoppingTool = "default"
              }, 300)),
              this.scrollDetector.direction === u.d.DOWN ? Math.abs(this.scrollDetector.directionDistance) >= 300 && this.el.section.classList.remove("is-sticky-hidden") : this.scrollDetector.direction === u.d.UP && Math.abs(this.scrollDetector.directionDistance) >= 300 && this.el.section.classList.add("is-sticky-hidden")) : t > this.config.scrollSnapMax && this.shrink(0)
          }
      }, {
          key: "loadImages",
          value: function() {
              var e = this
                , t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
              if (this.el.bgImage) {
                  var i = this.el.bgImage.getAttribute("data-lazy-image-url")
                    , n = new Image
                    , r = function() {
                      e.el.bgImage.style.background = "url(".concat(i, ") no-repeat"),
                      e.el.bgImage.classList.add("is-loaded")
                  };
                  t ? (n.addEventListener("load", function() {
                      r(),
                      e.shrink()
                  }),
                  n.setAttribute("src", i)) : (n.addEventListener("load", function() {
                      r()
                  }),
                  n.setAttribute("src", i),
                  this.shrink())
              } else
                  this.shrink()
          }
      }, {
          key: "show",
          value: function() {
              var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
              if (!this.flags.isShowing) {
                  this.flags.isShowing = !0;
                  var t = window.scrollY
                    , i = j.coords.window.height
                    , n = this.flags.isShrunk || !Object(o.j)("large") ? this.getFinalHeight() : i
                    , r = this.getFinalHeight();
                  t > this.config.scrollSnapMax ? this.el.section.classList.add("is-overflow-hidden") : window.scrollTo({
                      top: 0,
                      behavior: "smooth"
                  }),
                  this.el.section.classList.add("active"),
                  this.el.bgWrapper.style.height = "".concat(n, "px"),
                  this.el.contentWrapper.style.height = "".concat(r, "px"),
                  this.loadImages(e)
              }
          }
      }, {
          key: "shrink",
          value: function() {
              var e = this
                , t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 720;
              if (!this.flags.isShrunk || this.flags.isPendingShrinkDelay) {
                  this.flags.isShrunk = !0,
                  this.flags.isPendingShrinkDelay = !0;
                  var i = j.coords.window.height
                    , n = this.getFinalHeight()
                    , r = i - (n + 50 - 30);
                  this.show();
                  var s = Date.now();
                  (-1 === this.status.shrinkDelayTriggerTime || s + t < this.status.shrinkDelayTriggerTime) && (this.status.shrinkDelayTriggerTime = s + t,
                  clearTimeout(this.timeouts.shrink),
                  this.timeouts.shrink = setTimeout(function() {
                      if (e.flags.isPendingShrinkDelay = !1,
                      Object(o.j)("large")) {
                          var t = e.el.section.nextElementSibling;
                          e.flags.isShrinkAnimating = !0,
                          e.el.bgWrapper.style.height = "".concat(i, "px"),
                          e.el.content.style.transform = "translateY(".concat(r, "px)"),
                          t && (t.style.transform = "translateY(".concat(r, "px)")),
                          S.a.one(function() {
                              e.el.section.classList.add("is-in"),
                              S.a.one(function() {
                                  c.initSkrollex(),
                                  window.setTimeout(function() {
                                      e.el.bgWrapper.style.height = "".concat(n + 50, "px"),
                                      t && (t.style.transform = ""),
                                      e.el.content.style.transform = "",
                                      e.el.section.classList.add("is-next-section-in"),
                                      e.flags.isShrinkAnimating = !1,
                                      e.el.infoOpen.classList.add("is-shown")
                                  }, 160)
                              })
                          })
                      } else
                          e.el.section.classList.remove("is-overflow-hidden"),
                          e._onResize(),
                          c.initSkrollex(),
                          e.el.section.classList.add("is-in")
                  }, t))
              }
          }
      }, {
          key: "enlarge",
          value: function() {
              var e = this.el.section.nextElementSibling;
              this.el.body.classList.add("is-modal-open"),
              this.el.navigation.classList.add("is-hidden"),
              this.el.navigation.classList.remove("is-hidden-out"),
              this.el.bgWrapper.classList.add("is-fullscreen"),
              this.el.bgWhiteBlock.classList.add("is-hidden"),
              this.el.content.classList.add("is-hidden"),
              this.el.infoClose.classList.add("is-shown"),
              this.el.infoOpen.classList.remove("is-shown"),
              e && (e.style.opacity = "0",
              e.style.transform = "translateY(6.0rem)",
              e.style.transition = "opacity 0.3s ease-in-out, transform 0.3s ease-in-out"),
              window.scrollTo({
                  top: 0,
                  behavior: "smooth"
              })
          }
      }, {
          key: "enlargeOut",
          value: function() {
              var e = this.el.section.nextElementSibling;
              e && (e.style = ""),
              this.el.body.classList.remove("is-modal-open"),
              this.el.navigation.classList.remove("is-hidden"),
              this.el.navigation.classList.add("is-hidden-out"),
              this.el.bgWrapper.classList.remove("is-fullscreen"),
              this.el.bgWrapper.style.transition = "height 0.6s ease-in-out",
              this.el.bgWhiteBlock.classList.remove("is-hidden"),
              this.el.content.classList.remove("is-hidden"),
              this.el.infoClose.classList.remove("is-shown"),
              this.el.infoOpen.classList.add("is-shown"),
              e && (e.style.opacity = "1",
              e.style.transform = "translateY(0)",
              e.style.transition = "opacity 0.3s ease-in-out, transform 0.3s ease-in-out"),
              window.scrollTo({
                  top: 0,
                  behavior: "smooth"
              })
          }
      }, {
          key: "getFinalHeight",
          value: function() {
              return Object(o.j)("large"),
              this.el.scaler.offsetHeight
          }
      }, {
          key: "destroy",
          value: function() {
              document.body.classList.remove("is-fixed"),
              this.removeEventListeners()
          }
      }]) && Ot(t.prototype, i),
      n && Ot(t, n),
      e
  }();
  function Rt(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(134);
  var Bt = "hero-main"
    , jt = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              body: document.querySelector("body"),
              drawerTop: document.querySelector(".drawer-top"),
              navigation: document.querySelector(".navigation-primary"),
              infoOpenBtn: t.querySelector(".".concat(Bt, "__info-open")),
              infoCloseBtn: t.querySelector(".".concat(Bt, "__info-close")),
              heroCaret: t.querySelector(".".concat(Bt, "__caret")),
              heroCtaBtn: t.querySelector(".".concat(Bt, "__cta a")),
              heroBottom: t.querySelector(".".concat(Bt, "__bottom")),
              heroOverlay: t.querySelector(".".concat(Bt, "__overlay")),
              heroVideoOverlay: t.querySelector(".".concat(Bt, "__video-overlay")),
              heroOverlayInfo: t.querySelector(".".concat(Bt, "__overlay-info")),
              heroBackground: t.querySelector(".".concat(Bt, "__bg")),
              heroTakeoverContainer: t.querySelector(".".concat(Bt, "__inner-container"))
          },
          this.flags = {
              isInfoShown: !1,
              isNavHidden: !1
          },
          this.events = Object(o.a)(this),
          this.initialAnim(),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              this.el.navigation && (this.el.navigation.addEventListener("mouseenter", this.events._onNavHover),
              this.el.navigation.addEventListener("mouseleave", this.events._onNavHoverOut)),
              this.el.heroCtaBtn && (this.el.heroCtaBtn.addEventListener("mouseenter", this.events._onCtaHover),
              this.el.heroCtaBtn.addEventListener("mouseleave", this.events._onCtaHoverOut)),
              this.el.heroCaret && this.el.heroCaret.addEventListener("click", this.events._onCaretClick),
              this.el.infoOpenBtn && this.el.infoOpenBtn.addEventListener("click", this.events._onOpenClick),
              this.el.infoCloseBtn && this.el.infoCloseBtn.addEventListener("click", this.events._onCloseClick),
              this.el.heroBottom.addEventListener("mouseenter", this.events._onHeroBottomHover)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              this.el.navigation && (this.el.navigation.removeEventListener("mouseenter", this.events._onNavHover),
              this.el.navigation.removeEventListener("mouseleave", this.events._onNavHoverOut)),
              this.el.heroCtaBtn && (this.el.heroCtaBtn.removeEventListener("mouseenter", this.events._onCtaHover),
              this.el.heroCtaBtn.removeEventListener("mouseleave", this.events._onCtaHoverOut)),
              this.el.heroCaret && this.el.heroCaret.removeEventListener("click", this.events._onCaretClick),
              this.el.infoOpenBtn && this.el.infoOpenBtn.removeEventListener("click", this.events._onOpenClick),
              this.el.infoCloseBtn && this.el.infoCloseBtn.removeEventListener("click", this.events._onCloseClick),
              this.el.heroBottom.removeEventListener("mouseenter", this.events._onHeroBottomHover)
          }
      }, {
          key: "_onNavHover",
          value: function() {
              this.dimHeroOverlay()
          }
      }, {
          key: "_onNavHoverOut",
          value: function() {
              this.el.heroOverlay.style = "",
              this.el.heroBottom.style = "",
              this.undimHeroOverlay()
          }
      }, {
          key: "_onCtaHover",
          value: function() {
              this.zoomInBg()
          }
      }, {
          key: "_onCtaHoverOut",
          value: function() {
              this.zoomOutBg()
          }
      }, {
          key: "_onHeroBottomHover",
          value: function() {
              this.el.heroOverlay.style = "",
              this.el.heroBottom.style = ""
          }
      }, {
          key: "_onOpenClick",
          value: function(e) {
              e.preventDefault(),
              this.toggleNav(),
              this.toggleInfo(),
              this.el.heroTakeoverContainer && this.heroTakeover()
          }
      }, {
          key: "_onCloseClick",
          value: function(e) {
              e.preventDefault(),
              this.toggleNav(),
              this.toggleInfo(),
              this.el.heroTakeoverContainer && this.heroTakeoverOut()
          }
      }, {
          key: "_onOverlayCloseClick",
          value: function() {
              this.toggleNav(),
              this.toggleInfo(),
              this.el.heroTakeoverContainer && this.heroTakeoverOut()
          }
      }, {
          key: "_onCaretClick",
          value: function() {
              this.scrollDown()
          }
      }, {
          key: "initialAnim",
          value: function() {
              this.toggleOverlays(),
              this.el.heroBottom.classList.add("is-visible")
          }
      }, {
          key: "toggleOverlays",
          value: function() {
              this.el.heroVideoOverlay && this.el.heroVideoOverlay.classList.add("is-hidden")
          }
      }, {
          key: "dimHeroOverlay",
          value: function() {
              Object(o.j)("large") && this.el.heroOverlay.classList.add("is-dim")
          }
      }, {
          key: "undimHeroOverlay",
          value: function() {
              this.el.heroOverlay.classList.remove("is-dim")
          }
      }, {
          key: "showOverlayInfo",
          value: function() {
              this.el.heroOverlayInfo.classList.add("is-shown"),
              this.el.heroBottom.classList.add("is-hidden"),
              this.el.heroBottom.classList.remove("is-visible")
          }
      }, {
          key: "hideOverlayInfo",
          value: function() {
              this.el.heroOverlayInfo.classList.remove("is-shown"),
              this.el.heroBottom.classList.remove("is-hidden"),
              this.el.heroBottom.classList.add("is-visible")
          }
      }, {
          key: "toggleInfo",
          value: function() {
              this.flags.isInfoShown ? (this.flags.isInfoShown = !1,
              this.el.section.classList.add("is-info-delayed"),
              this.undimHeroOverlay(),
              this.hideOverlayInfo(),
              this.el.heroOverlayInfo.removeEventListener("click", this.events._onOverlayCloseClick)) : (this.flags.isInfoShown = !0,
              this.el.section.classList.remove("is-info-delayed"),
              this.dimHeroOverlay(),
              this.showOverlayInfo(),
              this.el.heroOverlayInfo.addEventListener("click", this.events._onOverlayCloseClick))
          }
      }, {
          key: "toggleNav",
          value: function() {
              this.flags.isNavHidden ? (this.flags.isNavHidden = !1,
              this.el.navigation && (this.el.drawerTop.classList.add("is-visible"),
              this.el.drawerTop.classList.remove("is-hidden"),
              this.el.navigation.classList.remove("is-hidden"),
              this.el.navigation.classList.add("is-hidden-out", "is-hero-delayed"))) : (this.flags.isNavHidden = !0,
              this.el.navigation && (this.el.drawerTop.classList.remove("is-visible"),
              this.el.drawerTop.classList.add("is-hidden"),
              this.el.navigation.classList.add("is-hidden"),
              this.el.navigation.classList.remove("is-hidden-out", "is-hero-delayed")))
          }
      }, {
          key: "zoomInBg",
          value: function() {
              this.el.heroBackground.classList.add("is-zoomed")
          }
      }, {
          key: "zoomOutBg",
          value: function() {
              this.el.heroBackground.classList.remove("is-zoomed")
          }
      }, {
          key: "heroTakeover",
          value: function() {
              this.el.body.classList.add("is-modal-open"),
              window.scrollTo({
                  top: 0,
                  behavior: "smooth"
              })
          }
      }, {
          key: "heroTakeoverOut",
          value: function() {
              this.el.body.classList.remove("is-modal-open"),
              this.el.heroTakeoverContainer.classList.remove("is-takeover")
          }
      }, {
          key: "scrollDown",
          value: function() {
              var e = document.querySelector(".drawer-top").offsetHeight
                , t = this.el.section.offsetHeight;
              window.scrollTo({
                  top: t + e,
                  behavior: "smooth"
              })
          }
      }, {
          key: "destroy",
          value: function() {
              this.el.body.classList.remove("is-modal-open"),
              this.removeEventListeners()
          }
      }]) && Rt(t.prototype, i),
      n && Rt(t, n),
      e
  }();
  function Ft(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(135);
  var Nt = "modal-deadend"
    , Ut = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              body: document.querySelector("body"),
              modal: null,
              modalBody: t.querySelector(".".concat(Nt, " .modal-body")),
              modalTriggers: document.querySelectorAll('[data-modal-trigger="'.concat(Nt, '"]')),
              modalClose: document.querySelector(".".concat(Nt, " [data-modal-close]")),
              pdpCta: document.querySelector(".buy-config__cta-btn-group")
          },
          this.flags = {
              isModalShown: !1
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              var e = this;
              this.el.modalTriggers.forEach(function(t) {
                  t.addEventListener("click", e.events._onModalTriggerClick)
              }),
              this.el.modalClose.addEventListener("click", this.events._onModalCloseClick)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              var e = this;
              this.el.modalTriggers.forEach(function(t) {
                  t.removeEventListener("click", e.events._onModalTriggerClick)
              }),
              this.el.modalClose.removeEventListener("click", this.events._onModalCloseClick)
          }
      }, {
          key: "_onModalTriggerClick",
          value: function() {
              this.showModal()
          }
      }, {
          key: "_onModalCloseClick",
          value: function() {
              this.hideModal()
          }
      }, {
          key: "_onModalScroll",
          value: function() {}
      }, {
          key: "getModal",
          value: function() {
              var e = this.el.modalTriggers[0].getAttribute("data-modal-target");
              this.el.modal = document.querySelector("#".concat(e))
          }
      }, {
          key: "showModal",
          value: function() {
              if (!this.flags.isModalShown) {
                  this.getModal();
                  var e = this.el.modal
                    , t = this.el.modalBody
                    , i = this.el.body;
                  e.style = "",
                  i.classList.add("is-modal-open"),
                  e.classList.add("is-open"),
                  setTimeout(function() {
                      t.classList.add("is-open")
                  }, 400),
                  this.flags.isModalShown = !0,
                  this.el.modal.addEventListener("scroll", this.events._onModalScroll, {
                      passive: !0
                  })
              }
          }
      }, {
          key: "hideModal",
          value: function() {
              if (this.flags.isModalShown) {
                  var e = this.el.modal
                    , t = this.el.modalBody
                    , i = this.el.body;
                  e.style.opacity = 0,
                  setTimeout(function() {
                      i.classList.remove("is-modal-open"),
                      e.classList.remove("is-open"),
                      t.classList.remove("is-open")
                  }, 300),
                  this.flags.isModalShown = !1
              }
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Ft(t.prototype, i),
      n && Ft(t, n),
      e
  }()
    , qt = (i(136),
  i(109))
    , Ht = i.n(qt)
    , Vt = i(137)
    , Wt = i.n(Vt);
  function $t(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var Gt = "modal-cart"
    , Xt = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              body: document.querySelector("body"),
              modal: null,
              modalBody: t.querySelector(".".concat(Gt, " .modal-body")),
              modalClose: t.querySelector(".".concat(Gt, " [data-modal-close]")),
              modalTemplateArea: t.querySelector(".".concat(Gt, " [data-cart-template-area]")),
              modalTriggerAddToCart: document.querySelector(".buy-config__cta-buy"),
              modalTrigger: document.querySelector(".navigation-primary__icon--cart"),
              pdpCtaBtn: document.querySelector(".buy-config__cta-btn-group")
          },
          this.flags = {
              isAddingItem: !1,
              isAutoOpen: "true" === this.el.section.getAttribute("data-auto-open"),
              isCartEmpty: "true" !== this.el.section.getAttribute("data-cart-full"),
              isItemAdded: !1,
              isLimitOne: "false" !== this.el.section.getAttribute("data-limit-one"),
              isModalShown: !1
          },
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.flags.isCartEmpty && (this.el.modalTemplateArea.innerHTML = Ht.a),
              this.addEventListeners(),
              this.flags.isAutoOpen && (this.flags.isCartEmpty ? this.showEmptyCart() : this.showAddItemToCart())
          }
      }, {
          key: "addEventListeners",
          value: function() {
              var e = this;
              this.el.modalTrigger.addEventListener("click", this.events._onModalTriggerClick),
              this.el.modalClose.addEventListener("click", this.events._onModalCloseClick),
              this.el.pdpCtaBtn && this.el.pdpCtaBtn.addEventListener("click", function(t) {
                  (t.target.closest(".btn").classList.contains("is-valid") || t.target.closest(".btn").classList.contains("is-visible")) && e.showEmptyCart()
              }),
              this.el.modalTriggerAddToCart && this.el.modalTriggerAddToCart.addEventListener("click", function(t) {
                  (t.target.closest(".btn").classList.contains("is-valid") || t.target.closest(".btn").classList.contains("is-visible")) && e.showAddItemToCart()
              })
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              this.el.modalTrigger.removeEventListener("click", this.events._onModalTriggerClick),
              this.el.modalClose.removeEventListener("click", this.events._onModalCloseClick)
          }
      }, {
          key: "_onModalTriggerClick",
          value: function() {
              this.showModal()
          }
      }, {
          key: "_onModalCloseClick",
          value: function() {
              this.hideModal()
          }
      }, {
          key: "_onModalScroll",
          value: function() {}
      }, {
          key: "showEmptyCart",
          value: function() {
              this.flags.isCartEmpty = !0,
              this.flags.isAddingItem = !1,
              this.showModal()
          }
      }, {
          key: "showAddItemToCart",
          value: function() {
              this.flags.isCartEmpty = !1,
              this.flags.isAddingItem = !0;
              for (var e = document.querySelectorAll("[data-cart-full-state-icon]"), t = 0; t < e.length; t++) {
                  e[t].classList.add("active")
              }
              this.showModal()
          }
      }, {
          key: "getModal",
          value: function() {
              this.el.modal = this.flags.isLimitOne ? document.querySelector("#".concat(Gt)) : this.el.section.querySelector(".modal")
          }
      }, {
          key: "showModal",
          value: function() {
              var e = this;
              this.flags.isModalShown || (this.switchCartTemplate(),
              this.getModal(),
              this.el.modal.style = "",
              this.el.modal.classList.add("is-open"),
              this.flags.isModalShown = !0,
              this.el.modal.addEventListener("scroll", this.events._onModalScroll, {
                  passive: !0
              }),
              setTimeout(function() {
                  e.el.modal.classList.add("is-open-in"),
                  window.scrollTo(0, 0)
              }, 400),
              this.flags.isAddingItem && (this.el.modal.classList.add("is-adding-product"),
              this.el.modal.classList.remove("is-product-added"),
              this.flags.isItemAdded = !0,
              this.flags.isAddingItem = !1,
              setTimeout(function() {
                  e.el.modal.classList.add("is-open", "is-product-added"),
                  window.scrollTo(0, 0)
              }, 860)))
          }
      }, {
          key: "hideModal",
          value: function() {
              var e = this;
              this.flags.isModalShown && (this.el.modal.style.opacity = 0,
              setTimeout(function() {
                  e.el.modal.classList.remove("is-open", "is-open-in")
              }, 300),
              this.flags.isModalShown = !1)
          }
      }, {
          key: "switchCartTemplate",
          value: function() {
              this.el.modalTemplateArea.innerHTML = "",
              this.flags.isCartEmpty ? this.flags.isCartEmpty && (this.el.modalTemplateArea.innerHTML = Ht.a) : this.el.modalTemplateArea.innerHTML = Wt.a
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners(),
              this.el.body.classList.remove("is-modal-open")
          }
      }]) && $t(t.prototype, i),
      n && $t(t, n),
      e
  }();
  function Zt(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(138);
  var Yt = "modal-compare"
    , Kt = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              body: document.querySelector("body"),
              modal: null,
              modalBody: t.querySelector(".".concat(Yt, " .modal-body")),
              modalTrigger: document.querySelectorAll("[data-modal-trigger]"),
              modalClose: t.querySelector(".".concat(Yt, "__close")),
              compareButtons: t.querySelectorAll(".".concat(Yt, " .btn")),
              compareListing: t.querySelector(".".concat(Yt, "__listing")),
              compareForm: t.querySelector(".".concat(Yt, "__form"))
          },
          this.flags = {
              isModalShown: !1
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              var e = this;
              this.el.modalTrigger && (Object(o.k)(this.el.modalTrigger, "click", this.events._onModalTriggerClick),
              this.el.modalClose.addEventListener("click", this.events._onModalCloseClick)),
              this.el.compareButtons.forEach(function(t) {
                  t.addEventListener("click", e.events._onModalCtaClick)
              })
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              var e = this;
              Object(o.m)(this.el.modalTrigger, "click", this.events._onModalTriggerClick),
              this.el.modalClose.removeEventListener("click", this.events._onModalCloseClick),
              this.el.compareButtons.forEach(function(t) {
                  t.removeEventListener("click", e.events._onModalCtaClick)
              })
          }
      }, {
          key: "_onModalTriggerClick",
          value: function() {
              this.showModal()
          }
      }, {
          key: "_onModalCloseClick",
          value: function() {
              this.hideModal()
          }
      }, {
          key: "_onModalCtaClick",
          value: function() {
              this.showListing()
          }
      }, {
          key: "_onModalScroll",
          value: function() {}
      }, {
          key: "getModal",
          value: function() {
              var e = this.el.modalTrigger[0].getAttribute("data-modal-target");
              this.el.modal = document.querySelector("#".concat(e))
          }
      }, {
          key: "showModal",
          value: function() {
              if (!this.flags.isModalShown) {
                  this.flags.isModalShown = !0,
                  this.getModal();
                  var e = this.el.modal
                    , t = this.el.modalBody
                    , i = this.el.body
                    , n = new Event("modalopen");
                  e.style = "",
                  i.classList.add("is-modal-open"),
                  e.classList.add("is-open"),
                  e.style.overflowY = "hidden",
                  setTimeout(function() {
                      t.classList.add("is-open")
                  }, 400),
                  this.el.modal.addEventListener("scroll", this.events._onModalScroll, {
                      passive: !0
                  }),
                  window.dispatchEvent(n)
              }
          }
      }, {
          key: "hideModal",
          value: function() {
              if (this.flags.isModalShown) {
                  var e = this.el.modal
                    , t = this.el.modalBody
                    , i = this.el.body;
                  e.style.opacity = 0,
                  setTimeout(function() {
                      i.classList.remove("is-modal-open"),
                      e.classList.remove("is-open"),
                      t.classList.remove("is-open")
                  }, 300),
                  this.resetModal(),
                  this.flags.isModalShown = !1
              }
          }
      }, {
          key: "showListing",
          value: function() {
              this.el.modal.style.overflowY = "auto",
              this.el.compareListing.classList.add("is-shown"),
              this.el.compareForm.classList.add("is-hidden")
          }
      }, {
          key: "resetModal",
          value: function() {
              this.el.compareListing.classList.remove("is-shown"),
              this.el.compareForm.classList.remove("is-hidden")
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Zt(t.prototype, i),
      n && Zt(t, n),
      e
  }();
  function Jt(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(139);
  var Qt = "modal-fit"
    , ei = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              body: document.querySelector("body"),
              modal: null,
              modalBody: t.querySelector(".".concat(Qt, " .modal-body")),
              modalTriggers: document.querySelectorAll('[data-modal-trigger="'.concat(Qt, '"]')),
              modalClose: document.querySelector(".".concat(Qt, " [data-modal-close]"))
          },
          this.flags = {
              isModalShown: !1
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              var e = this;
              this.el.modalTriggers.forEach(function(t) {
                  t.addEventListener("click", e.events._onModalTriggerClick)
              }),
              this.el.modalClose.addEventListener("click", this.events._onModalCloseClick),
              Object(o.j)("medium") && window.addEventListener("resize", this.events._onWindowResize)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              var e = this;
              this.el.modalTriggers.forEach(function(t) {
                  t.removeEventListener("click", e.events._onModalTriggerClick)
              }),
              this.el.modalClose.removeEventListener("click", this.events._onModalCloseClick),
              window.removeEventListener("resize", this.events._onWindowResize)
          }
      }, {
          key: "_onModalTriggerClick",
          value: function() {
              this.showModal()
          }
      }, {
          key: "_onModalCloseClick",
          value: function() {
              this.hideModal()
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.matchHeights()
          }
      }, {
          key: "getModal",
          value: function() {
              var e = this.el.modalTriggers[0].getAttribute("data-modal-target");
              this.el.modal = document.querySelector("#".concat(e))
          }
      }, {
          key: "showModal",
          value: function() {
              if (!this.flags.isModalShown) {
                  this.getModal();
                  var e = this.el.modal
                    , t = this.el.modalBody
                    , i = this.el.body;
                  e.style = "",
                  i.classList.add("is-modal-open"),
                  e.classList.add("is-open"),
                  setTimeout(function() {
                      t.classList.add("is-open")
                  }, 400),
                  Object(o.j)("medium") && this.matchHeights(),
                  this.flags.isModalShown = !0
              }
          }
      }, {
          key: "hideModal",
          value: function() {
              if (this.flags.isModalShown) {
                  var e = this.el.modal
                    , t = this.el.modalBody
                    , i = this.el.body;
                  e.style.opacity = 0,
                  setTimeout(function() {
                      i.classList.remove("is-modal-open"),
                      e.classList.remove("is-open"),
                      t.classList.remove("is-open")
                  }, 300),
                  Object(o.j)("medium") && this.matchHeights(),
                  this.flags.isModalShown = !1
              }
          }
      }, {
          key: "matchHeights",
          value: function() {
              for (var e = document.querySelectorAll(".".concat(Qt, " [data-match-height]")), t = 0, i = 0; i < e.length; i++) {
                  var n = e[i];
                  n.style.height = "auto",
                  n.clientHeight >= t && (t = n.clientHeight)
              }
              for (var r = 0; r < e.length; r++) {
                  e[r].style.height = "".concat(t, "px")
              }
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Jt(t.prototype, i),
      n && Jt(t, n),
      e
  }();
  function ti(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(140);
  var ii = "modal-guide"
    , ni = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              body: document.querySelector("body"),
              modal: null,
              modalClose: t.querySelector(".".concat(ii, "__close")),
              modalReference: document.querySelector("[data-modal-reference]"),
              modalTrigger: document.querySelector("[data-modal-trigger]"),
              modalBody: t.querySelector(".".concat(ii, " .modal-body"))
          },
          this.flags = {
              isModalShown: !1
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              var e = this.el.modalTrigger
                , t = this.el.modalClose;
              e.addEventListener("click", this.events._onModalTriggerClick),
              t.addEventListener("click", this.events._onModalCloseClick)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              var e = this.el.modalTrigger
                , t = this.el.modalClose;
              e.removeEventListener("click", this.events._onModalTriggerClick),
              t.removeEventListener("click", this.events._onModalCloseClick)
          }
      }, {
          key: "_onModalTriggerClick",
          value: function() {
              this.showModal()
          }
      }, {
          key: "_onModalCloseClick",
          value: function() {
              this.hideModal()
          }
      }, {
          key: "_onModalScroll",
          value: function() {}
      }, {
          key: "getModal",
          value: function() {
              var e = this.el.modalTrigger.getAttribute("data-modal-target");
              this.el.modal = document.querySelector("#".concat(e))
          }
      }, {
          key: "showModal",
          value: function() {
              if (!this.flags.isModalShown) {
                  this.getModal();
                  var e = this.el.modal
                    , t = this.el.modalBody
                    , i = this.el.body
                    , n = new Event("modalopen");
                  e.style = "",
                  i.classList.add("is-modal-open"),
                  e.classList.add("is-open"),
                  setTimeout(function() {
                      t.classList.add("is-open")
                  }, 400),
                  this.flags.isModalShown = !0,
                  this.el.modal.addEventListener("scroll", this.events._onModalScroll, {
                      passive: !0
                  }),
                  window.dispatchEvent(n)
              }
          }
      }, {
          key: "hideModal",
          value: function() {
              if (this.flags.isModalShown) {
                  var e = this.el.modal
                    , t = this.el.modalBody
                    , i = this.el.body;
                  e.style.opacity = 0,
                  setTimeout(function() {
                      i.classList.remove("is-modal-open"),
                      e.classList.remove("is-open"),
                      t.classList.remove("is-open")
                  }, 300),
                  this.flags.isModalShown = !1
              }
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && ti(t.prototype, i),
      n && ti(t, n),
      e
  }();
  function ri(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(141);
  var oi = "modal-scroll"
    , si = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              body: document.querySelector("body"),
              modal: null,
              modalBody: t.querySelector(".".concat(oi, " .modal-body")),
              modalReference: document.querySelector("[data-modal-reference]"),
              modalTrigger: document.querySelector("[data-modal-trigger]"),
              modalClose: document.querySelector("[data-modal-close]")
          },
          this.flags = {
              isModalShown: !1
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              var e = this.el.modalTrigger
                , t = this.el.modalClose;
              e.addEventListener("click", this.events._onModalTriggerClick),
              t.addEventListener("click", this.events._onModalCloseClick)
          }
      }, {
          key: "_onModalTriggerClick",
          value: function(e) {
              this.matchModalTop(),
              this.showModal(),
              this.controlModalFades(e)
          }
      }, {
          key: "_onModalCloseClick",
          value: function() {
              this.hideModal()
          }
      }, {
          key: "_onModalScroll",
          value: function(e) {
              this.controlModalFades(e)
          }
      }, {
          key: "getModal",
          value: function() {
              var e = this.el.modalTrigger.getAttribute("data-modal-target");
              this.el.modal = document.querySelector(".modal".concat(e))
          }
      }, {
          key: "showModal",
          value: function() {
              if (!this.flags.isModalShown) {
                  this.getModal();
                  var e = this.el.modal
                    , t = this.el.body;
                  e.style = "",
                  t.classList.add("is-modal-open"),
                  e.classList.add("is-open"),
                  this.flags.isModalShown = !0,
                  this.el.modal.addEventListener("scroll", this.events._onModalScroll, {
                      passive: !0
                  })
              }
          }
      }, {
          key: "hideModal",
          value: function() {
              if (this.flags.isModalShown) {
                  var e = this.el.modal
                    , t = this.el.body;
                  e.style.opacity = 0,
                  setTimeout(function() {
                      t.classList.remove("is-modal-open"),
                      e.classList.remove("is-open")
                  }, 100),
                  this.flags.isModalShown = !1
              }
          }
      }, {
          key: "matchModalTop",
          value: function() {
              var e = document.querySelector("[data-modal-reference]").getBoundingClientRect().top;
              this.el.modalBody.style.paddingTop = "".concat(e, "px")
          }
      }, {
          key: "controlModalFades",
          value: function(e) {
              e.target.scrollTop <= 0 ? (this.el.modal.classList.remove("is-bottom"),
              this.el.modal.classList.add("is-top")) : e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight ? (this.el.modal.classList.remove("is-top"),
              this.el.modal.classList.add("is-bottom")) : (this.el.modal.classList.remove("is-top"),
              this.el.modal.classList.remove("is-bottom"))
          }
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && ri(t.prototype, i),
      n && ri(t, n),
      e
  }();
  function ai(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(142);
  var li = "modal-shipping"
    , ci = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              body: document.querySelector("body"),
              modal: null,
              modalBody: t.querySelector(".".concat(li, " .modal-body")),
              modalTriggers: document.querySelectorAll('[data-modal-trigger="'.concat(li, '"]')),
              modalClose: document.querySelector(".".concat(li, " [data-modal-close]"))
          },
          this.flags = {
              isModalShown: !1
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              var e = this;
              this.el.modalTriggers.forEach(function(t) {
                  t.addEventListener("click", e.events._onModalTriggerClick)
              }),
              this.el.modalClose.addEventListener("click", this.events._onModalCloseClick)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              var e = this;
              this.el.modalTriggers.forEach(function(t) {
                  t.removeEventListener("click", e.events._onModalTriggerClick)
              }),
              this.el.modalClose.removeEventListener("click", this.events._onModalCloseClick)
          }
      }, {
          key: "_onModalTriggerClick",
          value: function() {
              this.showModal()
          }
      }, {
          key: "_onModalCloseClick",
          value: function() {
              this.hideModal()
          }
      }, {
          key: "_onModalScroll",
          value: function() {}
      }, {
          key: "getModal",
          value: function() {
              var e = this.el.modalTriggers[0].getAttribute("data-modal-target");
              this.el.modal = document.querySelector("#".concat(e))
          }
      }, {
          key: "showModal",
          value: function() {
              if (!this.flags.isModalShown) {
                  this.getModal();
                  var e = this.el.modal
                    , t = this.el.modalBody
                    , i = this.el.body;
                  e.style = "",
                  i.classList.add("is-modal-open"),
                  e.classList.add("is-open"),
                  setTimeout(function() {
                      t.classList.add("is-open")
                  }, 400),
                  this.flags.isModalShown = !0,
                  this.el.modal.addEventListener("scroll", this.events._onModalScroll, {
                      passive: !0
                  })
              }
          }
      }, {
          key: "hideModal",
          value: function() {
              if (this.flags.isModalShown) {
                  var e = this.el.modal
                    , t = this.el.modalBody
                    , i = this.el.body;
                  e.style.opacity = 0,
                  setTimeout(function() {
                      i.classList.remove("is-modal-open"),
                      e.classList.remove("is-open"),
                      t.classList.remove("is-open")
                  }, 300),
                  this.flags.isModalShown = !1
              }
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && ai(t.prototype, i),
      n && ai(t, n),
      e
  }();
  function ui(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(143);
  var hi = "modal-size"
    , di = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              body: document.querySelector("body"),
              modal: null,
              modalBody: t.querySelector(".".concat(hi, " .modal-body")),
              modalTriggers: document.querySelectorAll('[data-modal-trigger="'.concat(hi, '"]')),
              modalClose: document.querySelector(".".concat(hi, " [data-modal-close]")),
              sizeItems: t.querySelectorAll(".".concat(hi, "__chips li")),
              sizeBlurbs: t.querySelectorAll(".".concat(hi, "__blurbs")),
              slider: t.querySelector(".".concat(hi, " .slider-features--size-modal"))
          },
          this.flags = {
              isModalShown: !1
          },
          this.swiper = null,
          this.breakpoint = window.matchMedia("(min-width: 768px)"),
          this.swiperOptions = {
              direction: "horizontal",
              slidesPerView: 1,
              spaceBetween: 8,
              scrollbar: {
                  el: ".swiper-scrollbar",
                  hide: !1
              }
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              var e = this;
              this.el.modalTriggers.forEach(function(t) {
                  t.addEventListener("click", e.events._onModalTriggerClick)
              }),
              this.el.modalClose.addEventListener("click", this.events._onModalCloseClick),
              this.el.sizeItems.forEach(function(t) {
                  t.addEventListener("click", e.events._onSizeItemClick)
              }),
              Object(o.j)("medium") && window.addEventListener("resize", this.events._onWindowResize)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              var e = this;
              this.el.modalTriggers.forEach(function(t) {
                  t.removeEventListener("click", e.events._onModalTriggerClick)
              }),
              this.el.modalClose.removeEventListener("click", this.events._onModalCloseClick),
              window.removeEventListener("resize", this.events._onWindowResize)
          }
      }, {
          key: "_onModalTriggerClick",
          value: function() {
              this.showModal()
          }
      }, {
          key: "_onModalCloseClick",
          value: function() {
              this.hideModal()
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.matchHeights()
          }
      }, {
          key: "_onSizeItemClick",
          value: function(e) {
              this.showSizeBlurb(e.currentTarget)
          }
      }, {
          key: "getModal",
          value: function() {
              this.el.modal = document.querySelector("#".concat(hi))
          }
      }, {
          key: "showModal",
          value: function() {
              var e = this;
              if (!this.flags.isModalShown) {
                  this.getModal();
                  var t = this.el.modal
                    , i = this.el.modalBody
                    , n = this.el.body;
                  t.style = "",
                  n.classList.add("is-modal-open"),
                  t.classList.add("is-open"),
                  setTimeout(function() {
                      i.classList.add("is-open"),
                      e.initSizeBlurb(),
                      e.breakpoint.matches ? e.swiper && e.swiper.destroy() : e.breakpoint.matches || e.swiper || e.createSlider(),
                      e.el.slider.classList.add("is-shown")
                  }, 400),
                  Object(o.j)("medium") && this.matchHeights(),
                  this.flags.isModalShown = !0
              }
          }
      }, {
          key: "hideModal",
          value: function() {
              var e = this;
              if (this.flags.isModalShown) {
                  var t = this.el.modal
                    , i = this.el.modalBody
                    , n = this.el.body;
                  t.style.opacity = 0,
                  setTimeout(function() {
                      n.classList.remove("is-modal-open"),
                      t.classList.remove("is-open"),
                      i.classList.remove("is-open"),
                      e.el.slider.classList.remove("is-shown")
                  }, 300),
                  Object(o.j)("medium") && this.matchHeights(),
                  this.flags.isModalShown = !1
              }
          }
      }, {
          key: "initSizeBlurb",
          value: function() {
              this.el.sizeItems[2].querySelector("a").classList.remove("cta-circle-outlined"),
              this.el.sizeBlurbs[2].classList.add("is-shown")
          }
      }, {
          key: "showSizeBlurb",
          value: function(e) {
              var t = e.getAttribute("data-index") - 1
                , i = this.el.sizeBlurbs[t];
              this.el.sizeItems.forEach(function(e) {
                  e.querySelector("a").classList.add("cta-circle-outlined")
              }),
              this.el.sizeBlurbs.forEach(function(e) {
                  e.classList.remove("is-shown")
              }),
              e.querySelector("a").classList.remove("cta-circle-outlined"),
              i.classList.add("is-shown")
          }
      }, {
          key: "createSlider",
          value: function() {
              if (!this.swiper) {
                  var e = "swiper-".concat(++j.counters.instances);
                  this.el.section.querySelector(".".concat(hi, " .slider-features--size-modal .swiper-container")).setAttribute("id", e),
                  this.swiper = new lt("#".concat(e),this.swiperOptions)
              }
          }
      }, {
          key: "matchHeights",
          value: function() {
              for (var e = document.querySelectorAll(".".concat(hi, " [data-match-height]")), t = 0, i = 0; i < e.length; i++) {
                  var n = e[i];
                  n.style.height = "auto",
                  n.clientHeight >= t && (t = n.clientHeight)
              }
              for (var r = 0; r < e.length; r++) {
                  e[r].style.height = "".concat(t, "px")
              }
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && ui(t.prototype, i),
      n && ui(t, n),
      e
  }();
  function pi(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(144);
  var fi = "modal-video"
    , mi = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              body: document.querySelector("body"),
              modal: null,
              modalBody: t.querySelector(".".concat(fi, " .modal-body")),
              modalTriggers: document.querySelectorAll('[data-modal-trigger="'.concat(fi, '"]')),
              modalClose: document.querySelector(".".concat(fi, " [data-modal-close]")),
              videoProgressBar: t.querySelector(".".concat(fi, "__ctrls-bar")),
              videoProgressHead: t.querySelector(".".concat(fi, "__ctrls-bar-head")),
              videoCurrentTime: t.querySelector(".".concat(fi, "__ctrls-meta [data-current-time]")),
              videoTotalTime: t.querySelector(".".concat(fi, "__ctrls-meta [data-total-time]")),
              videoPlayback: t.querySelector(".".concat(fi, "__ctrls-playback")),
              videoPlay: t.querySelector(".".concat(fi, "__ctrls-play")),
              videoPause: t.querySelector(".".concat(fi, "__ctrls-pause")),
              videoVolume: t.querySelector(".".concat(fi, "__ctrls-volume")),
              videoUnmuted: t.querySelector(".".concat(fi, "__ctrls-volume-unmuted")),
              videoMuted: t.querySelector(".".concat(fi, "__ctrls-volume-muted"))
          },
          this.flags = {
              isModalShown: !1,
              isVideoPlaying: !1,
              isVideoUnmuted: !0
          },
          this.mousedown = !1,
          this.events = Object(o.a)(this),
          this.player = null,
          this.playerTotalTime = null,
          this.videoId = null,
          this.getId(),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "getId",
          value: function() {
              this.videoId = this.el.section.getAttribute("data-video-id")
          }
      }, {
          key: "addEventListeners",
          value: function() {
              var e = this;
              this.el.modalTriggers.forEach(function(t) {
                  return t.addEventListener("click", e.events._onModalTriggerClick)
              }),
              this.el.modalClose.addEventListener("click", this.events._onModalCloseClick),
              this.el.videoProgressBar.addEventListener("click", this.events._onPlayerProgressClick),
              this.el.videoPlayback.addEventListener("click", this.events._onPlayerPlaybackClick),
              this.el.videoVolume.addEventListener("click", this.events._onPlayerVolumeClick),
              this.el.videoProgressBar.addEventListener("mousemove", this.events._onPlayerProgressMousemove),
              this.el.videoProgressBar.addEventListener("mousedown", this.events._onPlayerProgressMousedown),
              this.el.videoProgressBar.addEventListener("mouseup", this.events._onPlayerProgressMouseup)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              var e = this;
              this.el.modalTriggers.forEach(function(t) {
                  return t.removeEventListener("click", e.events._onModalTriggerClick)
              }),
              this.el.modalClose.removeEventListener("click", this.events._onModalCloseClick),
              this.el.videoProgressBar.removeEventListener("click", this.events._onPlayerProgressClick),
              this.el.videoPlayback.removeEventListener("click", this.events._onPlayerPlaybackClick),
              this.el.videoVolume.removeEventListener("click", this.events._onPlayerVolumeClick),
              this.el.videoProgressBar.removeEventListener("mousemove", this.events._onPlayerProgressMousemove),
              this.el.videoProgressBar.removeEventListener("mousedown", this.events._onPlayerProgressMousedown),
              this.el.videoProgressBar.removeEventListener("mouseup", this.events._onPlayerProgressMouseup)
          }
      }, {
          key: "_onModalTriggerClick",
          value: function() {
              var e = this;
              this.showModal(),
              this.loadPlayerScript(),
              this.player ? (this.flags.isVideoPlaying = !0,
              this.player.playVideo()) : window.onYouTubePlayerAPIReady = function() {
                  return e.initPlayer()
              }
          }
      }, {
          key: "_onModalCloseClick",
          value: function() {
              this.hideModal(),
              this.player.pauseVideo(),
              this.flags.isVideoPlaying = !1
          }
      }, {
          key: "_onPlayerProgressMousedown",
          value: function() {
              this.mousedown = !0
          }
      }, {
          key: "_onPlayerProgressMouseup",
          value: function() {
              this.mousedown = !1
          }
      }, {
          key: "_onPlayerProgressMousemove",
          value: function(e) {
              this.mousedown && this.scrubPlayerProgress(e)
          }
      }, {
          key: "_onPlayerTick",
          value: function() {
              this.setPlayerProgress()
          }
      }, {
          key: "_onPlayerProgressClick",
          value: function(e) {
              this.scrubPlayerProgress(e)
          }
      }, {
          key: "_onPlayerPlaybackClick",
          value: function() {
              this.togglePlay()
          }
      }, {
          key: "_onPlayerVolumeClick",
          value: function() {
              this.toggleVolume()
          }
      }, {
          key: "getModal",
          value: function() {
              this.el.modal = document.querySelector("#".concat(fi))
          }
      }, {
          key: "showModal",
          value: function() {
              if (!this.flags.isModalShown) {
                  this.togglePlay(),
                  this.getModal();
                  var e = this.el.modal
                    , t = this.el.modalBody
                    , i = this.el.body;
                  e.style = "",
                  i.classList.add("is-modal-open"),
                  e.classList.add("is-open"),
                  setTimeout(function() {
                      t.classList.add("is-open")
                  }, 400),
                  this.flags.isModalShown = !0
              }
          }
      }, {
          key: "hideModal",
          value: function() {
              if (this.flags.isModalShown) {
                  var e = this.el.modal
                    , t = this.el.modalBody
                    , i = this.el.body;
                  e.style.opacity = 0,
                  setTimeout(function() {
                      i.classList.remove("is-modal-open"),
                      e.classList.remove("is-open"),
                      t.classList.remove("is-open")
                  }, 300),
                  this.flags.isModalShown = !1
              }
          }
      }, {
          key: "loadPlayerScript",
          value: function() {
              var e = document.createElement("script");
              e.src = "https://www.youtube.com/iframe_api";
              var t = document.getElementsByTagName("script")[0];
              t.parentNode.insertBefore(e, t)
          }
      }, {
          key: "initPlayer",
          value: function() {
              this.flags.isVideoPlaying = !0,
              this.player = new YT.Player("player",{
                  height: "100%",
                  width: "100%",
                  videoId: this.videoId,
                  playerVars: {
                      autoplay: 1,
                      controls: 0,
                      showinfo: 0,
                      modestbranding: 1,
                      loop: 1,
                      fs: 0,
                      cc_load_policy: 0,
                      iv_load_policy: 3,
                      autohide: 0,
                      rel: 0,
                      html5: 1
                  },
                  events: {
                      onReady: this.onPlayerReady.bind(this),
                      onStateChange: this.onPlayerStateChange.bind(this)
                  }
              })
          }
      }, {
          key: "onPlayerReady",
          value: function() {
              this.playerTotalTime = this.player.getDuration(),
              this.el.videoTotalTime.innerHTML = this.formatTime(this.playerTotalTime),
              S.a.on(this.events._onPlayerTick)
          }
      }, {
          key: "onPlayerStateChange",
          value: function(e) {
              e.data === YT.PlayerState.ENDED ? S.a.off(this.events._onPlayerTick) : e.data === YT.PlayerState.PLAYING && this.el.videoProgressHead.classList.remove("is-hidden")
          }
      }, {
          key: "setPlayerProgress",
          value: function() {
              var e = this.player.getCurrentTime()
                , t = e / this.playerTotalTime * 100;
              this.el.videoProgressHead.style.transform = "translateX(".concat(-100 + t, "%)"),
              this.el.videoCurrentTime.innerHTML = this.formatTime(e)
          }
      }, {
          key: "scrubPlayerProgress",
          value: function(e) {
              var t = e.offsetX / this.el.videoProgressBar.offsetWidth * this.playerTotalTime;
              this.player.seekTo(t)
          }
      }, {
          key: "togglePlay",
          value: function() {
              this.flags.isVideoPlaying ? (this.flags.isVideoPlaying = !1,
              this.el.videoPlay.classList.remove("is-hidden"),
              this.el.videoPause.classList.add("is-hidden"),
              this.player && this.player.pauseVideo()) : (this.flags.isVideoPlaying = !0,
              this.el.videoPause.classList.remove("is-hidden"),
              this.el.videoPlay.classList.add("is-hidden"),
              this.player && this.player.playVideo())
          }
      }, {
          key: "togglePlay",
          value: function() {
              this.flags.isVideoPlaying ? (this.flags.isVideoPlaying = !1,
              this.el.videoPlay.classList.remove("is-hidden"),
              this.el.videoPause.classList.add("is-hidden"),
              this.player && this.player.pauseVideo()) : (this.flags.isVideoPlaying = !0,
              this.el.videoPause.classList.remove("is-hidden"),
              this.el.videoPlay.classList.add("is-hidden"),
              this.player && this.player.playVideo())
          }
      }, {
          key: "toggleVolume",
          value: function() {
              this.flags.isVideoUnmuted ? (this.flags.isVideoUnmuted = !1,
              this.el.videoUnmuted.classList.add("is-hidden"),
              this.el.videoMuted.classList.remove("is-hidden"),
              this.player && this.player.mute()) : (this.flags.isVideoUnmuted = !0,
              this.el.videoUnmuted.classList.remove("is-hidden"),
              this.el.videoMuted.classList.add("is-hidden"),
              this.player && this.player.unMute())
          }
      }, {
          key: "formatTime",
          value: function(e) {
              e = Math.round(e);
              var t = Math.floor(e / 60)
                , i = e - 60 * t;
              return t + ":" + (i = i < 10 ? "0" + i : i)
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && pi(t.prototype, i),
      n && pi(t, n),
      e
  }()
    , gi = (i(145),
  i(146))
    , vi = i.n(gi);
  function yi(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var _i = "navigation-primary"
    , bi = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              logo: t.querySelector(".".concat(_i, "__logo")),
              backCta: t.querySelector(".".concat(_i, "__expanded-bar-back-cta")),
              closeCta: t.querySelector(".".concat(_i, "__expanded-bar-close-cta")),
              searchCta: t.querySelector(".".concat(_i, "__expanded-bar-search-cta")),
              navItems: t.querySelectorAll(".".concat(_i, "__nav-item")),
              navItemsLinks: t.querySelectorAll(".".concat(_i, "__nav-item a")),
              icons: t.querySelectorAll(".".concat(_i, "__icon")),
              iconLinks: t.querySelectorAll(".".concat(_i, "__icon a")),
              expandedSections: t.querySelectorAll(".".concat(_i, "__expanded-section")),
              expandedNavItems: t.querySelectorAll(".".concat(_i, "__expanded-nav-item")),
              expandedNavItemsContainer: t.querySelector(".".concat(_i, "__expanded-nav-items")),
              expandedNavItemsLinks: t.querySelectorAll(".".concat(_i, "__expanded-nav-item a")),
              expandedSectionLinks: t.querySelectorAll(".".concat(_i, "__expanded-section li > a")),
              expandedMobileSection: t.querySelector(".".concat(_i, "__expanded-section--mobile")),
              expandedMobileSectionLinks: t.querySelectorAll(".".concat(_i, "__expanded-section--mobile li a")),
              primarySectionsWrapper: t.querySelector(".".concat(_i, "__expanded-primary-menus-wrapper")),
              submenuWrapper: t.querySelector(".".concat(_i, "__expanded-submenu-wrapper")),
              submenu: null,
              lastSection: null
          },
          this.defaults = {
              noFlyGutter: 300
          },
          this.options = Object.assign({}, this.defaults, i),
          this.ab = "a",
          this.bounds = {
              hero: null,
              noFlys: []
          },
          this.coords = {
              toggleScrollY: 0,
              topNavHeight: 0
          },
          this.flags = {
              isExpanded: !1,
              isExpandedIn: !1,
              isMobileOpen: !1,
              isScrollConcat: !1,
              isSticky: !1,
              isSubmenuOpen: !1
          },
          this.states = {},
          this.debounced = {
              resize: o.i.debounce(this.checkResize.bind(this), 250, {
                  leading: !1,
                  trailing: !0
              })
          },
          this.templates = {
              submenu: o.i.template(vi.a)
          },
          this.timeouts = {
              remove: null,
              sticky: null
          },
          this.scrollDetector = {
              window: null,
              primary: null,
              subnav: null
          },
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      n = [{
          key: "NAV_ITEM_CLICK",
          get: function() {
              return "navItemClick"
          }
      }, {
          key: "NAV_MODAL_OPEN",
          get: function() {
              return "navModalOpen"
          }
      }, {
          key: "NAV_MODAL_CLOSE",
          get: function() {
              return "navModalClose"
          }
      }],
      (i = [{
          key: "init",
          value: function() {
              this.el.section.classList.contains("is-a") ? this.ab = "a" : this.el.section.classList.contains("is-b") ? this.ab = "b" : "b" === Object(o.h)(window.location.search || window.location.hash).nav && (this.ab = "b",
              this.el.section.classList.add("is-b")),
              this.el.section.classList.add("is-collapsed", "is-not-sticky"),
              this.initializeMobileMenu(),
              this.addEventListeners()
          }
      }, {
          key: "initializeMobileMenu",
          value: function() {
              for (var e = this.el.expandedMobileSection.querySelectorAll(".".concat(_i, "__expanded-section--list-sections li")), t = this.el.expandedMobileSection.querySelectorAll(".".concat(_i, "__expanded-section--list-support li")), i = 0; i < t.length; i++) {
                  t[i].style.transitionDelay = "".concat(.06 * i + .06 * e.length + .12, "s")
              }
          }
      }, {
          key: "addEventListeners",
          value: function() {
              Object(o.k)(this.el.expandedMobileSectionLinks, "click", this.events._onMobileMenuSectionLinkClick),
              Object(o.k)(this.el.expandedNavItemsLinks, "click", this.events._onExpandedNavItemClick),
              Object(o.k)(this.el.expandedSectionLinks, "click", this.events._onSectionLinkClick),
              Object(o.k)(this.el.iconLinks, "click", this.events._onIconClick),
              Object(o.k)(this.el.navItemsLinks, "click", this.events._onNavItemClick),
              this.el.backCta.addEventListener("click", this.events._onBackCtaClick),
              this.el.closeCta.addEventListener("click", this.events._onCloseCtaClick),
              this.el.searchCta.addEventListener("click", this.events._onSearchCtaClick),
              this.el.logo.addEventListener("click", this.events._onLogoClick),
              window.addEventListener(e.NAV_MODAL_OPEN, this.events._onNavModalOpen),
              window.addEventListener(e.NAV_MODAL_CLOSE, this.events._onNavModalClose),
              window.addEventListener("resize", this.events._onWindowResize),
              window.addEventListener("scroll", this.events._onWindowScroll, {
                  passive: !0
              }),
              this.el.primarySectionsWrapper.addEventListener("scroll", this.events._onPrimarySectionScroll, {
                  passive: !0
              }),
              this.el.submenuWrapper.addEventListener("scroll", this.events._onSubmenuScroll, {
                  passive: !0
              }),
              this.scrollDetector.window = new u.d(window),
              this.scrollDetector.expanded = new u.d(this.el.primarySectionsWrapper,{
                  callback: this.events._onScrollDirectionChange
              }),
              this.scrollDetector.submenu = new u.d(this.el.submenuWrapper,{
                  callback: this.events._onScrollDirectionChangeSubmenu
              }),
              this.checkResize()
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              Object(o.m)(this.el.expandedMobileSectionLinks, "click", this.events._onMobileMenuSectionLinkClick),
              Object(o.m)(this.el.expandedNavItemsLinks, "click", this.events._onExpandedNavItemClick),
              Object(o.m)(this.el.expandedSectionLinks, "click", this.events._onSectionLinkClick),
              Object(o.m)(this.el.iconLinks, "click", this.events._onIconClick),
              Object(o.m)(this.el.navItemsLinks, "click", this.events._onNavItemClick),
              this.el.backCta.removeEventListener("click", this.events._onBackCtaClick),
              this.el.closeCta.removeEventListener("click", this.events._onCloseCtaClick),
              this.el.searchCta.removeEventListener("click", this.events._onSearchCtaClick),
              this.el.logo.removeEventListener("click", this.events._onLogoClick),
              window.removeEventListener(e.NAV_MODAL_OPEN, this.events._onNavModalOpen),
              window.removeEventListener(e.NAV_MODAL_CLOSE, this.events._onNavModalClose),
              window.removeEventListener("resize", this.events._onWindowResize),
              window.removeEventListener("scroll", this.events._onWindowScroll),
              this.el.primarySectionsWrapper.removeEventListener("scroll", this.events._onPrimarySectionScroll),
              this.el.submenuWrapper.removeEventListener("scroll", this.events._onSubmenuScroll),
              this.scrollDetector.window.destroy(),
              this.scrollDetector.expanded.destroy(),
              this.scrollDetector.submenu.destroy()
          }
      }, {
          key: "_onNavItemClick",
          value: function(e) {
              var t = e.currentTarget;
              this.activateMenuItem(t)
          }
      }, {
          key: "_onExpandedNavItemClick",
          value: function(e) {
              var t = e.currentTarget;
              this.activateMenuItem(t)
          }
      }, {
          key: "_onIconClick",
          value: function(e) {
              var t = e.currentTarget
                , i = t.getAttribute("data-section-id");
              Object(o.j)("large") ? this.activateMenuItem(t) : "hamburger" === i && this.openMobileMenu()
          }
      }, {
          key: "_onBackCtaClick",
          value: function() {
              this.flags.isSubmenuOpen ? this.hideSubmenu() : Object(o.j)("large") || this.openMobileMenu()
          }
      }, {
          key: "_onCloseCtaClick",
          value: function() {
              this.flags.isExpandedIn && this.closeMobileMenu()
          }
      }, {
          key: "_onLogoClick",
          value: function(e) {
              var t = e.currentTarget;
              this.activateMenuItem(t)
          }
      }, {
          key: "_onSearchCtaClick",
          value: function() {
              var e = this;
              S.a.one(function() {
                  e.closeMenu()
              })
          }
      }, {
          key: "_onSectionLinkClick",
          value: function(e) {
              var t = e.currentTarget.getAttribute("data-submenu");
              void 0 !== t && this.showSubmenu(JSON.parse(decodeURIComponent(t)))
          }
      }, {
          key: "_onMobileMenuSectionLinkClick",
          value: function(e) {
              var t = e.currentTarget;
              this.flags.isExpandedIn && this.activateMenuItem(t)
          }
      }, {
          key: "_onNavModalOpen",
          value: function() {
              this.el.section.classList.contains("is-nav-modal-open") || (this.el.section.classList.add("is-nav-modal-open", "is-dark"),
              this.closeMenu())
          }
      }, {
          key: "_onNavModalClose",
          value: function() {
              this.el.section.classList.remove("is-nav-modal-open")
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.checkResize()
          }
      }, {
          key: "_onWindowScroll",
          value: function() {
              this.checkScroll()
          }
      }, {
          key: "_onPrimarySectionScroll",
          value: function() {
              this.checkScroll()
          }
      }, {
          key: "_onSubmenuScroll",
          value: function() {
              this.checkScroll()
          }
      }, {
          key: "_onScrollDirectionChange",
          value: function(e) {
              this.flags.isExpanded && !this.flags.isSubmenuOpen && (e.direction === u.d.UP ? (this.el.section.classList.remove("is-scroll-down"),
              this.el.section.classList.add("is-scroll-up")) : e.direction === u.d.DOWN && (this.el.section.classList.remove("is-scroll-up"),
              this.el.section.classList.add("is-scroll-down")))
          }
      }, {
          key: "_onScrollDirectionChangeSubmenu",
          value: function(e) {
              this.flags.isExpanded && this.flags.isSubmenuOpen && (e.direction === u.d.UP ? (this.el.section.classList.remove("is-scroll-down"),
              this.el.section.classList.add("is-scroll-up")) : e.direction === u.d.DOWN && (this.el.section.classList.remove("is-scroll-up"),
              this.el.section.classList.add("is-scroll-down")))
          }
      }, {
          key: "activateMenuItem",
          value: function(t) {
              var i = t.getAttribute("data-section-id");
              "shop" === i && "b" === this.ab && (i = "shop-b");
              var n = this.el.section.querySelector(".".concat(_i, "__nav-item.active, .").concat(_i, "__icon.active"))
                , r = this.el.section.querySelector(".".concat(_i, '__expanded-section[data-section-id="').concat(i, '"]'))
                , o = t.closest("li") ? t.closest("li") : t.closest("div");
              n && n.classList.remove("active"),
              o && o.classList.add("active"),
              window.dispatchEvent(new Event(e.NAV_ITEM_CLICK)),
              this.expandMenuSection(r)
          }
      }, {
          key: "expandMenuSection",
          value: function(e) {
              var t = this
                , i = this.el.section.querySelector(".".concat(_i, "__expanded-section.active"));
              if (e && e !== i) {
                  var n = e.getAttribute("data-section-id")
                    , r = this.el.section.querySelector(".".concat(_i, "__nav-item.active, .").concat(_i, "__icon.active"))
                    , s = this.el.section.querySelector(".".concat(_i, '__nav-item a[data-section-id="').concat(n, '"], .').concat(_i, '__icon a[data-section-id="').concat(n, '"]'))
                    , a = this.el.expandedNavItemsContainer.querySelector('[data-section-id="'.concat(n, '"]'))
                    , l = a ? a.closest("li") : null
                    , c = 0;
                  this.flags.isExpanded = !0,
                  Object(o.l)(this.el.expandedNavItems, "remove", "active"),
                  l && l.classList.add("active"),
                  r && r.classList.remove("active");
                  var u = this.el.section === window ? window.scrollY : this.el.section.scrollTop
                    , h = this.el.section.offsetTop;
                  if (h > 0 && u < h && window.scrollTo({
                      top: h,
                      behavior: "smooth"
                  }),
                  i && (this.closeLastSection(i),
                  c += 60),
                  s)
                      (s.closest("li") ? s.closest("li") : s.closest("div")).classList.add("active");
                  e.classList.remove("is-reset"),
                  e.classList.add("active"),
                  setTimeout(function() {
                      S.a.one(function() {
                          e.classList.add("is-expanded")
                      })
                  }, c),
                  this.el.section.classList.add("is-expanded", "is-section-".concat(n)),
                  this.el.section.classList.remove("is-collapsed"),
                  S.a.one(function() {
                      t.flags.isExpandedIn = !0,
                      t.el.section.classList.add("is-expanded-in")
                  }),
                  window.dispatchEvent(new CustomEvent("menuExpand",{
                      target: this.el.section
                  })),
                  this.coords.topNavHeight = this.el.expandedNavItemsContainer.clientHeight,
                  document.body.classList.contains("no-scroll") || (this.coords.toggleScrollY = window.scrollY,
                  document.body.classList.add("no-scroll"),
                  document.body.style.top = "-".concat(this.coords.toggleScrollY, "px"))
              } else
                  this.closeMenu(!!e)
          }
      }, {
          key: "closeLastSection",
          value: function() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null
                , t = e || this.el.section.querySelector(".".concat(_i, "__expanded-section.active"));
              if (t) {
                  var i = e.getAttribute("data-section-id");
                  this.flags.isSubmenuOpen && this.hideSubmenu(),
                  this.el.section.classList.remove("is-section-".concat(i)),
                  this.el.lastSection = t,
                  t.classList.add("is-trans-collapsed"),
                  t.classList.remove("is-expanded", "active"),
                  setTimeout(function() {
                      t.classList.remove("is-expanded", "is-trans-collapsed")
                  }, 500)
              }
          }
      }, {
          key: "setCurrentPageNavItemIndicator",
          value: function() {
              var e = document.body.querySelector("main > section").getAttribute("class");
              (e.indexOf("page-wrapper--plp") >= 0 || e.indexOf("page-wrapper--pdp") >= 0) && this.el.navItems[0].classList.add("active")
          }
      }, {
          key: "hideLastSection",
          value: function() {}
      }, {
          key: "showLastSection",
          value: function() {}
      }, {
          key: "renderSubmenu",
          value: function(e) {
              if (e)
                  return this.templates.submenu(e)
          }
      }, {
          key: "showSubmenu",
          value: function(e) {
              var t = this;
              if (e && !this.el.submenu) {
                  var i = this.renderSubmenu(e);
                  this.killRemoveTimeout(),
                  i && (this.flags.isSubmenuOpen = !0,
                  this.el.submenuWrapper.innerHTML = i,
                  this.el.submenu = this.el.submenuWrapper.firstChild,
                  this.el.section.classList.add("is-submenu-expanded"),
                  this.el.submenuWrapper.classList.add("active"),
                  this.el.submenu.classList.add("active"),
                  S.a.one(function() {
                      t.el.submenuWrapper.classList.add("is-expanded"),
                      t.el.submenu.classList.add("is-expanded")
                  }))
              }
          }
      }, {
          key: "hideSubmenu",
          value: function() {
              var e = this
                , t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0]
                , i = this.el.primarySectionsWrapper.querySelector(".".concat(_i, "__expanded-section.active"));
              i && (i.classList.add("is-reset"),
              i.classList.remove("is-expanded")),
              this.el.section.classList.remove("is-submenu-expanded"),
              this.el.submenu.classList.add("is-trans-collapsed"),
              this.el.submenu.classList.remove("is-expanded"),
              t && !this.timeouts.remove && (this.flags.isSubmenuOpen = !1,
              this.timeouts.remove = setTimeout(function() {
                  e.removeSubmenu(),
                  e.timeouts.remove = null,
                  e.el.submenuWrapper.classList.remove("active", "is-expanded");
                  var t = e.el.primarySectionsWrapper.querySelector(".".concat(_i, "__expanded-section.active"));
                  i === t && (i.classList.remove("is-reset"),
                  e.flags.isExpanded && i.classList.add("is-expanded"))
              }, 300))
          }
      }, {
          key: "hideSubmenuNow",
          value: function() {}
      }, {
          key: "killRemoveTimeout",
          value: function() {
              clearTimeout(this.timeouts.remove),
              this.timeouts.remove = null
          }
      }, {
          key: "removeSubmenu",
          value: function() {
              if (this.el.submenu) {
                  var e = this.el.primarySectionsWrapper.querySelector(".".concat(_i, "__expanded-section.active"));
                  e && e.classList.remove("is-reset"),
                  this.el.submenuWrapper.classList.remove("active", "is-expanded"),
                  this.killRemoveTimeout(),
                  this.el.submenu.remove(),
                  this.el.submenu = null
              }
          }
      }, {
          key: "closeMenu",
          value: function() {
              var e = this
                , t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0]
                , i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
              if (this.el.section.classList.contains("is-expanded")) {
                  var n = this.el.section.querySelector(".".concat(_i, "__expanded-section.active"))
                    , r = i ? 0 : 300;
                  this.flags.isExpanded = !1,
                  this.flags.isExpandedIn = !1,
                  this.el.section.classList.add("is-collapsed", "is-trans-collapsed"),
                  this.el.section.classList.remove("is-expanded-in", "is-mobile-index", "is-submenu-expanded"),
                  this.closeLastSection(n),
                  t && (Object(o.l)(this.el.navItems, "remove", "active"),
                  Object(o.l)(this.el.expandedNavItems, "remove", "active")),
                  setTimeout(function() {
                      e.setCurrentPageNavItemIndicator(),
                      e.el.section.classList.remove("is-expanded", "is-trans-collapsed"),
                      document.body.classList.remove("no-scroll"),
                      document.body.style.top = "",
                      window.dispatchEvent(new CustomEvent("menuCollapse",{
                          target: e.el.section
                      })),
                      window.scrollTo({
                          top: e.coords.toggleScrollY
                      })
                  }, r)
              }
          }
      }, {
          key: "openMobileMenu",
          value: function() {
              var t = this
                , i = this.el.section.querySelector(".".concat(_i, "__nav-item--hamburger, .").concat(_i, "__icon--hamburger"))
                , n = this.el.section.querySelector(".".concat(_i, '__expanded-section[data-section-id="mobile"]'))
                , r = this.el.section.querySelector(".".concat(_i, "__nav-item.active, .").concat(_i, "__icon.active"));
              r && r.classList.remove("active"),
              i.classList.add("active"),
              S.a.one(function() {
                  t.el.section.classList.add("is-mobile-index")
              }),
              window.dispatchEvent(new Event(e.NAV_ITEM_CLICK)),
              this.expandMenuSection(n)
          }
      }, {
          key: "closeMobileMenu",
          value: function() {
              this.closeMenu()
          }
      }, {
          key: "makeSticky",
          value: function() {
              var e = this;
              this.flags.isSticky || (this.flags.isSticky = !0,
              this.el.section.classList.add("is-sticky"),
              this.el.section.classList.remove("is-not-sticky"),
              S.a.one(function() {
                  e.flags.isSticky && e.el.section.classList.add("is-sticky-in")
              }))
          }
      }, {
          key: "makeUnSticky",
          value: function() {
              var e = this;
              this.flags.isSticky && (this.flags.isSticky = !1,
              this.el.section.classList.add("is-sticky-out"),
              window.clearTimeout(this.timeouts.sticky),
              this.timeouts.sticky = window.setTimeout(function() {
                  e.el.section.classList.remove("is-sticky-out", "is-sticky", "is-sticky-in"),
                  e.el.section.classList.add("is-out", "is-not-sticky"),
                  e.timeouts.sticky = null,
                  S.a.one(function() {
                      e.el.section.classList.add("is-in"),
                      e.el.section.classList.remove("is-out")
                  })
              }, 300))
          }
      }, {
          key: "checkResize",
          value: function() {
              var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0]
                , t = this.el.section.querySelector(".".concat(_i, "__expanded-section.active"))
                , i = t ? t.getAttribute("data-section-id") : "";
              Object(o.j)("large") && t ? (t.classList.contains("".concat(_i, "__expanded-section--mobile-support-column")) || "mobile" === i) && this.closeMenu() : Object(o.j)("large") || "hamburger" !== i || this.expandMenuSection(this.el.expandedMobileSection);
              var n = document.body.querySelector(".hero");
              n && (this.bounds.hero = Object(o.g)(n));
              var r = document.body.querySelectorAll("[data-navigation-nofly-zone]");
              if (this.bounds.noFlys = [],
              r && r.length)
                  for (var s = 0; s < r.length; s++) {
                      var a = r[s];
                      this.bounds.noFlys.push(Object(o.g)(a))
                  }
              this.coords.topNavHeight = this.el.expandedNavItemsContainer.clientHeight,
              e && this.checkScroll()
          }
      }, {
          key: "checkScroll",
          value: function() {
              var e = window.scrollY
                , t = !1;
              if (this.debounced.resize(!1),
              document.body.classList.contains("no-scroll")) {
                  var i = (this.flags.isSubmenuOpen ? this.el.submenuWrapper : this.el.primarySectionsWrapper).scrollTop;
                  !this.flags.isScrollConcat && i > this.coords.topNavHeight ? (this.flags.isScrollConcat = !0,
                  this.el.section.classList.add("is-top-bar-concat")) : this.flags.isScrollConcat && i <= this.coords.topNavHeight && (this.flags.isScrollConcat = !1,
                  this.el.section.classList.remove("is-top-bar-concat"))
              } else {
                  for (var n = 0; n < this.bounds.noFlys.length; n++) {
                      var r = this.bounds.noFlys[n];
                      if (e >= r.scrollTop - this.options.noFlyGutter && e <= r.scrollBottom + this.options.noFlyGutter) {
                          t = !0;
                          break
                      }
                  }
                  t ? this.flags.isSticky && (this.scrollDetector.window.disable(),
                  this.makeUnSticky()) : (this.scrollDetector.window.enable(),
                  this.scrollDetector.window.direction === u.d.UP ? (this.bounds.hero && e > this.bounds.hero.scrollTop + this.bounds.hero.height ? !this.flags.isSticky && Math.abs(this.scrollDetector.window.directionDistance) >= 300 && this.makeSticky() : this.makeUnSticky(),
                  e < this.el.section.offsetHeight + this.el.section.offsetTop && this.el.section.classList.contains("is-after-drawer") && this.el.section.classList.remove("is-after-drawer--scrolled")) : this.scrollDetector.window.direction === u.d.DOWN && (this.flags.isSticky && Math.abs(this.scrollDetector.window.directionDistance) >= 300 && this.makeUnSticky(),
                  e > this.el.section.offsetHeight + this.el.section.offsetTop && this.el.section.classList.contains("is-after-drawer") && this.el.section.classList.add("is-after-drawer--scrolled")))
              }
          }
      }, {
          key: "destroy",
          value: function() {
              this.closeMenu(!0, !0),
              this.removeEventListeners()
          }
      }]) && yi(t.prototype, i),
      n && yi(t, n),
      e
  }();
  function wi(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(147);
  var xi = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              container: t.closest("[data-navigation-subnav-container]")
          },
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.addEventListeners()
          }
      }, {
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && wi(t.prototype, i),
      n && wi(t, n),
      e
  }();
  function ki(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(148);
  var Si = "navigation-subnav-pdp"
    , Ei = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              container: t.closest("[data-navigation-subnav-container]"),
              activeLine: t.querySelector(".".concat(Si, "__active-line")),
              bottomLine: t.querySelector(".".concat(Si, "__bottom-line")),
              links: t.querySelector(".".concat(Si, "__links")),
              navItems: t.querySelectorAll(".".concat(Si, "__nav-item")),
              navItemLinks: t.querySelectorAll(".".concat(Si, "__nav-item a")),
              heading: t.querySelector(".".concat(Si, "__heading")),
              wrapper: t.querySelector(".".concat(Si, "__links-wrapper")),
              fpcBtn: t.querySelector(".".concat(Si, "__fpc-btn")),
              scrollZones: null,
              productTitle: document.querySelector(".hero-pdp-v2__intro-title")
          },
          this.defaults = {
              anchorScrollGutter: 81,
              lineScrollAmount: 140,
              uiShowRatio: .75
          },
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(o.a)(this),
          this.coords = {
              container: null,
              lineRatioLast: 0,
              scrollZones: []
          },
          this.debounced = {
              resize: o.i.debounce(this.checkResize.bind(this), 250, {
                  leading: !1,
                  trailing: !0
              }),
              scrollComplete: o.i.debounce(this.events._onScrollComplete.bind(this), 250, {
                  leading: !1,
                  trailing: !0
              })
          },
          this.flags = {
              isScrollSeeking: !1,
              hasContainer: null !== this.el.container
          },
          this.states = {
              activeMenuItemIndex: 0
          },
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.el.scrollZones = [];
              for (var e = 0; e < this.el.navItemLinks.length; e++) {
                  var t = this.el.navItemLinks[e]
                    , i = document.querySelector('[data-anchor-link-destination="'.concat(t.getAttribute("data-anchor-link"), '"]'));
                  this.el.scrollZones.push(i || null)
              }
              if (this.el.productTitle && this.setHeading(),
              !Object(o.j)("medium")) {
                  var n = 2 * (window.innerWidth / 4) + this.el.navItems[0].offsetWidth * this.el.navItems.length;
                  this.el.bottomLine.style.width = "".concat(n, "px")
              }
              this.activateMenuItem(this.el.navItemLinks[0], !0),
              this.addEventListeners()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("resize", this.events._onResize),
              window.addEventListener("scroll", this.events._onScroll, {
                  passive: !0
              }),
              Object(o.k)(this.el.navItemLinks, "click", this.events._onNavItemClick),
              this.checkResize()
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("resize", this.events._onResize),
              window.removeEventListener("scroll", this.events._onScroll),
              Object(o.m)(this.el.navItemLinks, "click", this.events._onNavItemClick)
          }
      }, {
          key: "_onResize",
          value: function() {
              this.checkResize()
          }
      }, {
          key: "_onScroll",
          value: function() {
              this.checkScroll()
          }
      }, {
          key: "_onNavItemClick",
          value: function(e) {
              var t = e.currentTarget;
              if (this.flags.isScrollSeeking = !0,
              this.activateMenuItem(t),
              !Object(o.j)("medium")) {
                  var i = t.getBoundingClientRect()
                    , n = this.el.wrapper.scrollLeft;
                  this.el.wrapper.scrollTo({
                      top: 0,
                      left: i.left - t.offsetWidth / 2 + n,
                      behavior: "smooth"
                  })
              }
          }
      }, {
          key: "_onScrollComplete",
          value: function() {
              this.flags.isScrollSeeking = !1
          }
      }, {
          key: "activateMenuItem",
          value: function(e) {
              if (!e.classList.contains("is-active")) {
                  var t = j.coords.window.width
                    , i = this.el.links.offsetWidth
                    , n = e.getBoundingClientRect()
                    , r = n.left - (t - i) / 2
                    , s = n.width / 100;
                  if (this.states.activeMenuItemIndex = Object(o.f)(e.closest("li")),
                  Object(o.l)(this.el.navItemLinks, "remove", "is-active"),
                  e.classList.add("is-active"),
                  this.el.section.classList.add("is-link-active"),
                  Object(o.j)("medium"))
                      this.el.activeLine.style.transform = "translateX(".concat(r, "px) scaleX(").concat(s, ")");
                  else {
                      var a = this.el.wrapper.scrollLeft;
                      this.el.activeLine.style.transform = "translateX(".concat(r + a, "px) scaleX(").concat(s, ")")
                  }
              }
          }
      }, {
          key: "setHeading",
          value: function() {
              var e = this.el.productTitle.innerHTML;
              this.el.heading.innerHTML = e
          }
      }, {
          key: "checkResize",
          value: function() {
              var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
              this.flags.hasContainer && (this.coords.container = Object(o.g)(this.el.container)),
              this.coords.scrollZones = [];
              for (var t = 0; t < this.el.scrollZones.length; t++) {
                  var i = this.el.scrollZones[t];
                  i ? this.coords.scrollZones.push(Object(o.g)(i)) : this.coords.scrollZones.push(null)
              }
              e && this.checkScroll();
              var n = this.el.section.querySelector(".".concat(Si, "__link.is-active"))
                , r = j.coords.window.width
                , s = this.el.links.offsetWidth
                , a = n.getBoundingClientRect()
                , l = a.left - (r - s) / 2
                , c = a.width / 100;
              if (Object(o.j)("medium"))
                  this.el.activeLine.style.transform = "translateX(".concat(l, "px) scaleX(").concat(c, ")");
              else {
                  var u = this.el.wrapper.scrollLeft;
                  this.el.activeLine.style.transform = "translateX(".concat(l + u, "px) scaleX(").concat(c, ")"),
                  this.el.wrapper.scrollTo({
                      top: 0,
                      left: a.left - n.offsetWidth / 2 + u,
                      behavior: "smooth"
                  })
              }
              this.checkLineWidth()
          }
      }, {
          key: "checkScroll",
          value: function() {
              var e = window.scrollY;
              if (this.flags.hasContainer && e >= this.coords.container.scrollTop ? (this.el.section.classList.add("is-sticky"),
              this.el.fpcBtn && this.el.fpcBtn.classList.add("is-shown")) : (this.el.section.classList.remove("is-sticky"),
              this.el.fpcBtn && this.el.fpcBtn.classList.remove("is-shown")),
              this.flags.isScrollSeeking)
                  this.debounced.scrollComplete();
              else {
                  for (var t = 0, i = 0; i < this.coords.scrollZones.length; i++) {
                      var n = this.coords.scrollZones[i];
                      if (n && e >= n.scrollTop - this.options.anchorScrollGutter && e <= n.scrollBottom - this.options.anchorScrollGutter) {
                          t = i;
                          break
                      }
                  }
                  if (this.states.activeMenuItemIndex !== t && (this.activateMenuItem(this.el.navItemLinks[t]),
                  !Object(o.j)("medium"))) {
                      var r = this.el.navItemLinks[t].getBoundingClientRect()
                        , s = this.el.wrapper.scrollLeft;
                      this.el.wrapper.scrollTo({
                          top: 0,
                          left: r.left - this.el.navItemLinks[t].offsetWidth / 2 + s,
                          behavior: "smooth"
                      })
                  }
              }
              this.checkLineWidth(),
              this.debounced.resize(!1)
          }
      }, {
          key: "checkLineWidth",
          value: function() {
              var e = window.scrollY
                , t = j.coords.window.width;
              if (this.el.section.classList.contains("is-sticky")) {
                  var i = this.el.links.offsetWidth
                    , n = e - this.coords.container.scrollTop
                    , r = t / i
                    , o = Math.min(r, (r - 1) * (n / this.options.lineScrollAmount) + 1)
                    , s = Math.min(1, o / r);
                  this.coords.lineRatioLast !== o && (this.coords.lineRatioLast = o,
                  this.el.bottomLine.style.transform = "scaleX(".concat(o, ")"),
                  s >= this.options.uiShowRatio ? this.el.section.classList.add("is-ui-showing") : this.el.section.classList.remove("is-ui-showing"))
              } else
                  this.el.bottomLine.style.transform = "",
                  this.el.section.classList.remove("is-ui-showing"),
                  this.coords.lineRatioLast = -1
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && ki(t.prototype, i),
      n && ki(t, n),
      e
  }();
  function Ti(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(149);
  var Ci = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.featSlider = null,
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Ti(t.prototype, i),
      n && Ti(t, n),
      e
  }();
  function Li(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(150);
  var Ai = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Li(t.prototype, i),
      n && Li(t, n),
      e
  }()
    , Pi = i(22)
    , Ii = i(151)
    , Mi = i(152)
    , Oi = i.n(Mi)
    , zi = i(153)
    , Di = i.n(zi);
  function Ri(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var Bi = Ii
    , ji = "search-overlay"
    , Fi = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              closeX: t.querySelector(".".concat(ji, "__close-cta")),
              queryField: t.querySelector(".".concat(ji, "__query-field")),
              queryFieldInput: t.querySelector(".".concat(ji, "__query-field input")),
              queryFieldWrapper: t.querySelector(".".concat(ji, "__query-field-wrapper")),
              suggestionWrapper: t.querySelector(".".concat(ji, "__suggestion-wrapper")),
              suggestionSupheader: t.querySelector(".".concat(ji, "__suggestion-supheader")),
              suggestionHeader: t.querySelector(".".concat(ji, "__suggestion-header")),
              categoriesHeader: t.querySelector(".".concat(ji, "__categories-header")),
              categoriesItemsWrapper: t.querySelector(".".concat(ji, "__categories-items-wrapper")),
              categoriesItems: t.querySelectorAll(".".concat(ji, "__categories-items-wrapper li")),
              categoriesItemsButtons: t.querySelectorAll(".".concat(ji, "__categories-items-wrapper li a")),
              categoriesWrapper: t.querySelector(".".concat(ji, "__categories")),
              results: t.querySelector(".".concat(ji, "__results")),
              resultsHeaderCount: t.querySelector(".".concat(ji, "__results-query-header-count")),
              resultsProductsWrapper: t.querySelector(".".concat(ji, "__results-products-wrapper")),
              resultsProducts: t.querySelectorAll(".".concat(ji, "__results-products-wrapper li")),
              resultsMoreCta: t.querySelector(".".concat(ji, "__results-more-cta")),
              resultsMoreCtaHeading: t.querySelector(".".concat(ji, "__results-more-cta .cta-rounded-rect__heading")),
              noResults: t.querySelector(".".concat(ji, "__no-results")),
              noResultsQueryHeadingSpan: t.querySelector(".".concat(ji, "__no-results-query-heading span"))
          },
          this.globalEl = {
              triggerButtons: document.body.querySelectorAll("[data-search-overlay-trigger]")
          },
          this.defaults = {
              fewResultsCount: 3,
              maxResultsCount: 12
          },
          this.options = Object.assign({}, this.defaults, i),
          this.coords = {
              toggleScrollY: 0,
              queryFieldWrapperHeight: 0
          },
          this.flags = {
              isShowing: !1,
              isDefaultResults: !0,
              isFetchingResults: !1,
              isNoResults: !1
          },
          this.queued = {
              renderResults: null
          },
          this.observers = {
              intersection: null
          },
          this.requests = {
              search: null
          },
          this.states = {
              queryString: null,
              resultsString: null,
              suggestionString: null,
              resultsArrayString: null
          },
          this.throttled = {
              checkInput: o.i.throttle(this.checkInput.bind(this), 240, {
                  leading: !0
              })
          },
          this.timeouts = {
              collapse: null,
              results: null
          },
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.addEventListeners()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              this.el.closeX.addEventListener("click", this.events._onCloseClick),
              this.el.queryFieldInput.addEventListener("input", this.events._onQueryInput),
              this.el.queryFieldInput.addEventListener("submit", this.events._onQuerySubmit),
              this.el.resultsMoreCta.addEventListener("click", this.events._onResultsClick),
              this.el.section.addEventListener("scroll", this.events._onScroll, {
                  passive: !0
              }),
              window.addEventListener("resize", this.events._onWindowResize),
              this.globalEl.triggerButtons && Object(o.k)(this.globalEl.triggerButtons, "click", this.events._onTriggerClick)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              this.el.closeX.removeEventListener("click", this.events._onCloseClick),
              this.el.queryFieldInput.removeEventListener("input", this.events._onQueryInput),
              this.el.queryFieldInput.removeEventListener("submit", this.events._onQuerySubmit),
              this.el.resultsMoreCta.removeEventListener("click", this.events._onResultsClick),
              this.el.section.addEventListener("scroll", this.events._onScroll, {
                  passive: !0
              }),
              window.removeEventListener("resize", this.events._onWindowResize),
              this.globalEl.triggerButtons && Object(o.m)(this.globalEl.triggerButtons, "click", this.events._onTriggerClick)
          }
      }, {
          key: "_onQueryInput",
          value: function() {
              this.throttled.checkInput()
          }
      }, {
          key: "_onQuerySubmit",
          value: function() {
              window.location.hash ? window.location.hash = "pages/page-search" : window.location.href = "pages/page-search",
              this.rafHide()
          }
      }, {
          key: "_onAnchorClick",
          value: function() {
              this.rafHide()
          }
      }, {
          key: "_onCloseClick",
          value: function() {
              this.hide()
          }
      }, {
          key: "_onResultsClick",
          value: function() {
              this.rafHide()
          }
      }, {
          key: "_onTriggerClick",
          value: function() {
              this.show()
          }
      }, {
          key: "_onScroll",
          value: function() {
              this.checkScroll()
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.checkResize()
          }
      }, {
          key: "show",
          value: function() {
              var e = this;
              this.flags.isShowing || (this.flags.isShowing = !0,
              this.coords.toggleScrollY = window.scrollY,
              document.body.classList.add("is-fixed"),
              document.body.style.top = "-".concat(this.coords.toggleScrollY, "px"),
              this.el.section.classList.add("active", "is-init"),
              this.el.queryFieldInput.focus(),
              clearTimeout(this.timeouts.collapse),
              this.timeouts.collapse = null,
              S.a.one(function() {
                  e.el.section.classList.add("is-in", "is-first-in"),
                  e.el.section.classList.remove("is-init"),
                  e.checkResize()
              }))
          }
      }, {
          key: "hide",
          value: function() {
              var e = this;
              this.flags.isShowing && (this.flags.isShowing = !1,
              document.body.classList.remove("is-fixed"),
              document.body.style.top = "",
              window.scrollTo({
                  top: this.coords.toggleScrollY
              }),
              this.el.section.classList.add("is-out"),
              this.killObservers(),
              clearTimeout(this.timeouts.collapse),
              this.timeouts.collapse = setTimeout(function() {
                  e.el.section.classList.remove("is-in", "is-out", "active", "is-first-in", "is-default", "is-default-in", "is-results", "is-results-in", "is-few-results"),
                  e.timeouts.collapse = null
              }, 600))
          }
      }, {
          key: "rafHide",
          value: function() {
              var e = this;
              S.a.one(function() {
                  e.hide()
              })
          }
      }, {
          key: "checkScroll",
          value: function() {}
      }, {
          key: "checkResize",
          value: function() {
              var e = this.coords.queryFieldWrapperHeight
                , t = getComputedStyle(this.el.queryFieldWrapper)
                , i = parseInt(t.getPropertyValue("padding-top"));
              this.coords.queryFieldWrapperHeight = 2 * i + this.el.queryField.offsetHeight,
              this.observers.intersection && e === this.coords.queryFieldWrapperHeight || (this.killObservers(),
              this.observers.intersection = new IntersectionObserver(this.events._onObserverUpdate,{
                  rootMargin: "-".concat(this.coords.queryFieldWrapperHeight + i, "px 0px 0px 0px"),
                  threshold: 0
              }),
              this.observers.intersection.observe(this.el.categoriesWrapper))
          }
      }, {
          key: "_onObserverUpdate",
          value: function(e) {
              for (var t = 0; t < e.length; t++) {
                  var i = e[t];
                  i.target === this.el.categoriesWrapper && (i.isIntersecting ? this.el.section.classList.add("is-scroll-categories") : this.el.section.classList.remove("is-scroll-categories"))
              }
          }
      }, {
          key: "killObservers",
          value: function() {
              this.observers.intersection && (this.observers.intersection.disconnect(),
              this.observers.intersection = null)
          }
      }, {
          key: "checkInput",
          value: function() {
              var e = this.el.queryFieldInput.value;
              this.fetchResults(e)
          }
      }, {
          key: "fetchResults",
          value: function(e) {
              this.requests.search ? this.requests.search.queryString !== e && (this.abortCurrentQuery(),
              this.createQuery(e)) : this.createQuery(e)
          }
      }, {
          key: "createQuery",
          value: function(e) {
              var t = this;
              if (!this.requests.search) {
                  var i = new Pi.a("text");
                  this.requests.search = {
                      xhrQuery: i,
                      queryString: e
                  },
                  i.get(Bi.dataUrl).then(function(e) {
                      return t.onQueryComplete(e.response)
                  })
              }
          }
      }, {
          key: "onQueryComplete",
          value: function() {
              this.requests.search && (this.states.queryString = this.requests.search.queryString,
              this.abortCurrentQuery(),
              this.renderResults())
          }
      }, {
          key: "abortCurrentQuery",
          value: function() {
              this.requests.search && (this.requests.search.xhrQuery.abort(),
              this.requests.search = null)
          }
      }, {
          key: "renderResults",
          value: function() {
              var e = this
                , t = this.getResults(this.states.queryString);
              if (t) {
                  this.hideNoResults();
                  for (var i = t.default ? "default" : this.states.queryString, n = o.i.capitalize(this.states.queryString), r = [], s = 0; s < t.products.length; s++)
                      r.push(t.products[s].imageUrl);
                  var a = r.join(",");
                  if (this.states.resultsArrayString !== a) {
                      if (u.b.lawg(this.states.resultsArrayString, a),
                      this.states.resultsString = i,
                      this.states.resultsArrayString = a,
                      t.default)
                          this.el.section.classList.remove("is-first-in", "is-results", "is-results-in"),
                          this.el.section.classList.add("is-default"),
                          S.a.one(function() {
                              e.el.section.classList.add("is-default-in")
                          });
                      else {
                          this.el.section.classList.remove("is-first-in", "is-default", "is-default-in", "is-results-in"),
                          this.el.section.classList.add("is-results"),
                          S.a.one(function() {
                              e.el.section.classList.add("is-results-in")
                          }),
                          t.matchingQuery ? (this.el.suggestionWrapper.classList.remove("is-display-none"),
                          this.el.suggestionHeader.innerHTML = '<a href="pages/page-search">'.concat(o.i.capitalize(t.matchingQuery), "</a>"),
                          this.el.suggestionHeader.querySelector("a").addEventListener("click", this.events._onAnchorClick)) : this.el.suggestionWrapper.classList.add("is-display-none");
                          var l = this.el.resultsMoreCta.getAttribute("data-heading");
                          this.el.resultsMoreCta.innerHTML = o.i.template(l)({
                              count: t.products.length
                          })
                      }
                      for (var c = [], h = 0; h < t.categories.length; h++) {
                          var d = t.categories[h];
                          c.push(Object.assign({}, d, {
                              heading: d.heading.replace(n, "<strong>".concat(n, "</strong>"))
                          }))
                      }
                      this.el.queryField.dispatchEvent(new CustomEvent("suggestion",{
                          detail: t.matchingQuery
                      })),
                      this.el.categoriesItemsWrapper.innerHTML = o.i.template(Oi.a)({
                          items: c
                      }),
                      this.el.resultsProductsWrapper.innerHTML = o.i.template(Di.a)({
                          items: t.products
                      }),
                      t.products.length > this.options.fewResultsCount ? this.el.section.classList.remove("is-few-results") : this.el.section.classList.add("is-few-results");
                      var p = Math.min(t.products.length, this.options.maxResultsCount)
                        , f = t.products.length
                        , m = this.el.resultsHeaderCount.querySelector("span");
                      m.innerHTML = m.getAttribute("data-title-template").split("#").join(p);
                      var g = this.el.resultsHeaderCount.querySelector("a");
                      g.querySelector("span").innerHTML = g.getAttribute("data-title-template").split("#").join(f)
                  }
              } else
                  this.el.queryField.dispatchEvent(new CustomEvent("suggestion",{
                      detail: ""
                  })),
                  this.states.resultsString = "",
                  this.states.resultsArrayString = "",
                  this.showNoResults()
          }
      }, {
          key: "showNoResults",
          value: function() {
              var e = this;
              this.flags.isNoResults || (this.flags.isNoResults = !0,
              this.el.section.classList.remove("is-results", "is-results-in", "is-default", "is-default-in", "is-few-results", "is-no-results-in"),
              this.el.section.classList.add("is-no-results"),
              S.a.one(function() {
                  e.el.section.classList.add("is-no-results-in")
              })),
              this.el.noResultsQueryHeadingSpan.innerHTML = "".concat(this.states.queryString)
          }
      }, {
          key: "hideNoResults",
          value: function() {
              this.flags.isNoResults && (this.flags.isNoResults = !1,
              this.el.section.classList.remove("is-no-results", "is-no-results-in"))
          }
      }, {
          key: "getResults",
          value: function(e) {
              var t = e.toLowerCase()
                , i = {
                  default: !1,
                  matchingQuery: "",
                  categories: [],
                  products: []
              };
              if (!(e.length >= 3))
                  return Object.assign(i, {
                      default: !0,
                      categories: Bi.defaults.categories,
                      products: Bi.defaults.products
                  }),
                  i;
              for (var n = Bi.query.products, r = 0; r < n.length; r++) {
                  var o = n[r];
                  o.name.toLowerCase().indexOf(t) >= 0 && i.products.push(o)
              }
              if (i.products.length) {
                  var s = Bi.query.categories
                    , a = {
                      categories: null,
                      charactersOff: -1,
                      key: null
                  };
                  for (var l in s) {
                      var c = -1;
                      t.indexOf(l) >= 0 ? c = t.split(l).join("").length : l.indexOf(t) >= 0 && (c = l.split(t).join("").length),
                      l.length >= t.length && c >= 0 && (-1 === a.charactersOff || a.charactersOff > c) && Object.assign(a, {
                          categories: s[l],
                          charactersOff: c,
                          key: l
                      })
                  }
                  return a.categories && (i.categories = a.categories),
                  i.matchingQuery = a.key,
                  u.b.lawg("autocomplete:", i.matchingQuery),
                  i.categories.length || i.categories.push({
                      heading: Bi.defaults.ui.defaultCategoryHeading,
                      count: i.products.length,
                      linkUrl: "javascript:;"
                  }),
                  i
              }
              return null
          }
      }, {
          key: "destroy",
          value: function() {
              document.body.classList.remove("no-scroll"),
              this.removeEventListeners()
          }
      }]) && Ri(t.prototype, i),
      n && Ri(t, n),
      e
  }();
  function Ni(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(154);
  var Ui = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              target: t
          },
          this.defaults = {},
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {}
      }, {
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Ni(t.prototype, i),
      n && Ni(t, n),
      e
  }();
  function qi(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(155);
  var Hi = "shopping-tool"
    , Vi = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              wrapper: t.closest(".shopping-tool__wrapper"),
              collapsed: t.querySelector(".".concat(Hi, "__collapsed")),
              applyCta: t.querySelector(".".concat(Hi, "__cta-anchor--apply")),
              applyCtaWrapper: t.querySelector(".".concat(Hi, "__cta-anchor-wrapper--apply")),
              clearAllCta: t.querySelector(".".concat(Hi, "__expanded--cta-clear-all")),
              closeCta: t.querySelector(".".concat(Hi, "__close-cta")),
              doneCta: t.querySelector(".".concat(Hi, "__done")),
              expandCta: t.querySelector(".".concat(Hi, "__collapsed--cta")),
              filterCta: t.querySelector(".".concat(Hi, "__cta-anchor--size-fit")),
              filterCtaWrapper: t.querySelector(".".concat(Hi, "__cta-anchor-wrapper--size-fit")),
              filterCount: t.querySelector(".".concat(Hi, "__collapsed--filter-count")),
              expanded: t.querySelector(".".concat(Hi, "__expanded")),
              expandedContent: t.querySelector(".".concat(Hi, "__expanded--content")),
              categories: t.querySelectorAll(".".concat(Hi, "__expanded--category")),
              categoryPrimary: t.querySelector(".".concat(Hi, "__expanded--category-primary")),
              categoryHeaders: t.querySelectorAll(".".concat(Hi, "__category-header")),
              categoryItems: t.querySelectorAll(".".concat(Hi, "__expanded--category ul li > *")),
              searchCta: t.querySelector(".".concat(Hi, "__search")),
              topNav: t.querySelector(".".concat(Hi, "__expanded--top-nav"))
          },
          this.events = Object(o.a)(this),
          this.ab = "a",
          this.coords = {
              toggleScrollY: 0,
              categoryPrimary: null,
              categoryFirst: null,
              scrollYPrev: 0,
              topNav: null
          },
          this.counters = {
              filters: 0
          },
          this.flags = {
              isContentClipping: !1,
              isBarShowing: !0,
              isExpanded: !1,
              isFilterClipping: !1,
              isScrollConcat: !1,
              hasParent: !1
          },
          this.timeouts = {
              toggleBar: null
          },
          this.scrollDetector = null,
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.configHero(),
              this.selectDefaults(),
              this.addEventListeners()
          }
      }, {
          key: "configHero",
          value: function() {
              "b" === Object(o.h)(window.location.search || window.location.hash).st && (this.ab = "b",
              this.el.section.classList.add("is-b")),
              this.el.wrapper && (this.el.wrapper.classList.add("has-shopping-tool"),
              this.flags.hasParent = !0,
              "b" === this.ab && this.el.wrapper.classList.add("is-shopping-tool-b"))
          }
      }, {
          key: "selectDefaults",
          value: function() {
              for (var e = 0; e < this.el.categories.length; e++) {
                  var t = this.el.categories[e];
                  if ("true" !== t.getAttribute("data-multiselect")) {
                      var i = t.querySelector("ul li[data-default]");
                      i && this.toggleCategoryItem(i)
                  }
              }
          }
      }, {
          key: "addEventListeners",
          value: function() {
              this.el.clearAllCta.addEventListener("click", this.events._onClearCtaClick),
              this.el.closeCta.addEventListener("click", this.events._onCloseCtaClick),
              this.el.doneCta.addEventListener("click", this.events._onDoneCtaClick),
              this.el.expandCta.addEventListener("click", this.events._onExpandCtaClick),
              this.el.filterCta.addEventListener("click", this.events._onFilterCtaClick),
              this.el.applyCta.addEventListener("click", this.events._onApplyCtaClick),
              this.el.expandedContent.addEventListener("scroll", this.events._onScroll, {
                  passive: !0
              }),
              window.addEventListener("resize", this.events._onWindowResize),
              Object(o.k)(this.el.categoryHeaders, "click", this.events._onCategoryHeaderClick),
              Object(o.k)(this.el.categoryItems, "click", this.events._onCategoryItemClick),
              this.scrollDetector = new u.d(this.el.expandedContent,{
                  callback: this.events._onScrollDirectionChange
              })
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              this.el.clearAllCta.removeEventListener("click", this.events._onClearCtaClick),
              this.el.closeCta.removeEventListener("click", this.events._onCloseCtaClick),
              this.el.doneCta.removeEventListener("click", this.events._onDoneCtaClick),
              this.el.expandCta.removeEventListener("click", this.events._onExpandCtaClick),
              this.el.filterCta.addEventListener("click", this.events._onFilterCtaClick),
              this.el.applyCta.addEventListener("click", this.events._onApplyCtaClick),
              this.el.expandedContent.removeEventListener("scroll", this.events._onScroll),
              window.removeEventListener("resize", this.events._onWindowResize),
              Object(o.m)(this.el.categoryHeaders, "click", this.events._onCategoryHeaderClick),
              Object(o.m)(this.el.categoryItems, "click", this.events._onCategoryItemClick),
              this.scrollDetector.destroy(),
              this.scrollDetector = null
          }
      }, {
          key: "_onClearCtaClick",
          value: function() {
              this.reset()
          }
      }, {
          key: "_onCloseCtaClick",
          value: function() {
              this.collapse()
          }
      }, {
          key: "_onDoneCtaClick",
          value: function() {
              this.collapse()
          }
      }, {
          key: "_onExpandCtaClick",
          value: function() {
              this.expand()
          }
      }, {
          key: "_onFilterCtaClick",
          value: function() {
              var e = this
                , t = j.coords.window.height
                , i = this.el.expandedContent.scrollTop
                , n = Math.min(this.el.categories[1].offsetTop, this.el.expandedContent.scrollHeight - t);
              Object(o.d)(c.easing.easeOutSoft, i, n, 500, function(t) {
                  e.el.expandedContent.scrollTop = t
              })
          }
      }, {
          key: "_onApplyCtaClick",
          value: function() {
              this.collapse()
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.checkResize()
          }
      }, {
          key: "_onScroll",
          value: function() {
              this.checkScroll()
          }
      }, {
          key: "_onCategoryHeaderClick",
          value: function(e) {
              var t = e.currentTarget.closest(".".concat(Hi, "__expanded--category"));
              this.toggleCategory(t)
          }
      }, {
          key: "_onCategoryItemClick",
          value: function(e) {
              var t = e.currentTarget;
              this.toggleCategoryItem(t)
          }
      }, {
          key: "_onScrollDirectionChange",
          value: function(e) {
              this.flags.isExpanded && (e.direction === u.d.UP ? (this.el.section.classList.remove("is-scroll-down"),
              this.el.section.classList.add("is-scroll-up")) : e.direction === u.d.DOWN && (this.el.section.classList.remove("is-scroll-up"),
              this.el.section.classList.add("is-scroll-down")))
          }
      }, {
          key: "expand",
          value: function() {
              var e = this;
              this.flags.hasParent && (this.flags.isExpanded = !0,
              this.el.wrapper.classList.add("is-expanded"),
              this.el.wrapper.classList.remove("is-collapsed", "is-content-clipping", "is-filter-clipping", "is-scroll-up", "is-scroll-down", "is-top-bar-concat"),
              this.coords.toggleScrollY = window.scrollY,
              document.body.classList.add("no-scroll"),
              document.body.style.top = "-".concat(this.coords.toggleScrollY, "px"),
              this._onWindowResize(),
              S.a.one(function() {
                  e.el.wrapper.classList.add("animate-in")
              }))
          }
      }, {
          key: "collapse",
          value: function() {
              var e = this;
              if (this.flags.hasParent) {
                  this.flags.isExpanded = !1,
                  this.el.wrapper.classList.remove("animate-in"),
                  this.el.wrapper.classList.add("is-collapsing"),
                  document.body.classList.remove("no-scroll"),
                  document.body.style.top = "",
                  window.scrollTo({
                      top: this.coords.toggleScrollY
                  });
                  var t = this.getFilterCount();
                  this.el.filterCount.querySelector("span").innerHTML = t,
                  t ? this.el.filterCount.classList.add("is-visible") : this.el.filterCount.classList.remove("is-visible"),
                  this.hideDone(),
                  this.hidePill(),
                  setTimeout(function() {
                      e.el.wrapper.classList.remove("is-expanded", "is-collapsing")
                  }, 300)
              }
          }
      }, {
          key: "toggleCategory",
          value: function(e) {
              var t = e.querySelector("ul");
              if (e.classList.contains("is-expanded"))
                  e.classList.remove("is-expanded"),
                  e.classList.add("is-collapsed"),
                  t.style.height = "";
              else {
                  e.classList.add("is-expanded", "is-pending-animation");
                  var i = "".concat(t.clientHeight, "px");
                  e.classList.remove("is-expanded"),
                  e.classList.add("is-collapsed"),
                  S.a.one(function() {
                      e.classList.remove("is-pending-animation", "is-collapsed"),
                      e.classList.add("is-expanded"),
                      t.style.height = i
                  })
              }
          }
      }, {
          key: "toggleCategoryItem",
          value: function(e) {
              var t = e.closest(".".concat(Hi, "__expanded--category"))
                , i = t.querySelectorAll("li")
                , n = e.closest("li")
                , r = t.querySelectorAll("li > *")
                , s = n.children[0]
                , a = t.querySelector(".".concat(Hi, "__category-header--sort-term"))
                , l = "true" === t.getAttribute("data-multiselect");
              if (!t.classList.contains("".concat(Hi, "__expanded--category-primary"))) {
                  if (l)
                      n.classList.toggle("active"),
                      n.classList.contains("active") ? s.classList.add("active") : s.classList.remove("active");
                  else
                      !n.classList.contains("active") && (Object(o.l)(i, "remove", "active"),
                      Object(o.l)(r, "remove", "active"),
                      n.classList.add("active"),
                      a.innerHTML = e.querySelector("span").innerText);
                  this.updateFilterCount()
              }
          }
      }, {
          key: "getFilterCount",
          value: function() {
              for (var e = this.el.categories, t = 0, i = 0; i < e.length; i++) {
                  var n = e[i]
                    , r = n.querySelectorAll("li > *")
                    , s = Object(o.l)(r, "contains", "active", !0)
                    , a = "true" === n.getAttribute("data-multiselect");
                  if (a && s > 0)
                      t += s;
                  else if (!a) {
                      var l = n.querySelector("[data-default]");
                      l && !l.classList.contains("active") && t++
                  }
              }
              return t
          }
      }, {
          key: "updateFilterCount",
          value: function() {
              for (var e = this.el.categories, t = 0; t < e.length; t++) {
                  var i = e[t]
                    , n = i.querySelectorAll("li")
                    , r = i.querySelector(".".concat(Hi, "__category-header--filter-count"))
                    , s = Object(o.l)(n, "contains", "active", !0);
                  "true" === i.getAttribute("data-multiselect") && s > 0 ? (r.querySelector("span").innerHTML = s,
                  i.classList.add("is-filtered")) : i.classList.remove("is-filtered")
              }
              var a = this.getFilterCount();
              a > 0 ? (this.el.applyCtaWrapper.classList.add("active"),
              this.el.clearAllCta.querySelector("span").innerHTML = "".concat(this.el.clearAllCta.getAttribute("data-title"), " (").concat(a, ")")) : (this.hideDone(),
              this.el.applyCtaWrapper.classList.remove("active"),
              this.el.clearAllCta.querySelector("span").innerHTML = this.el.clearAllCta.getAttribute("data-title"))
          }
      }, {
          key: "showPill",
          value: function() {
              this.el.section.classList.add("is-filter-clipping"),
              this.el.applyCtaWrapper.classList.contains("active") || this.el.filterCtaWrapper.classList.add("active")
          }
      }, {
          key: "hidePill",
          value: function() {
              this.el.section.classList.remove("is-filter-clipping"),
              this.el.filterCtaWrapper.classList.remove("active")
          }
      }, {
          key: "showDone",
          value: function() {
              this.el.closeCta.classList.remove("is-visible"),
              this.el.searchCta.classList.remove("is-visible"),
              this.el.doneCta.classList.add("is-visible")
          }
      }, {
          key: "hideDone",
          value: function() {
              this.el.doneCta.classList.remove("is-visible"),
              this.el.closeCta.classList.add("is-visible"),
              this.el.searchCta.classList.add("is-visible")
          }
      }, {
          key: "checkResize",
          value: function() {
              var e = j.coords.window.height;
              if (this.flags.isExpanded) {
                  this.coords.categoryPrimaryTop = this.el.categoryPrimary.offsetTop,
                  this.coords.categoryFirst = this.el.categories[1].offsetTop,
                  this.coords.topNavHeight = this.el.topNav.clientHeight,
                  this.el.expandedContent.scrollHeight > e ? this.showPill() : this.hidePill(),
                  this.el.applyCta.style.minWidth = "",
                  this.el.filterCta.style.minWidth = "";
                  var t = Math.ceil(Math.max(this.el.applyCta.offsetWidth, this.el.filterCta.offsetWidth));
                  this.el.applyCta.style.minWidth = "".concat(t, "px"),
                  this.el.filterCta.style.minWidth = "".concat(t, "px"),
                  this._onScroll()
              }
          }
      }, {
          key: "checkScroll",
          value: function() {
              var e = this.el.expandedContent.scrollTop;
              e > this.coords.categoryPrimaryTop - this.coords.topNavHeight - 50 ? this.flags.isContentClipping || (this.flags.isContentClipping = !0,
              this.el.section.classList.add("is-content-clipping")) : this.flags.isContentClipping && (this.flags.isContentClipping = !1,
              this.el.section.classList.remove("is-content-clipping")),
              !this.flags.isScrollConcat && e > this.coords.topNavHeight ? (this.flags.isScrollConcat = !0,
              this.el.section.classList.add("is-top-bar-concat")) : this.flags.isScrollConcat && e <= this.coords.topNavHeight && (this.flags.isScrollConcat = !1,
              this.el.section.classList.remove("is-top-bar-concat")),
              this.coords.scrollYPrev = e
          }
      }, {
          key: "reset",
          value: function() {
              for (var e = this.el.categories, t = 0; t < e.length; t++) {
                  var i = e[t]
                    , n = i.querySelectorAll("li")
                    , r = i.querySelectorAll("li > a.active");
                  Object(o.l)(n, "remove", "active"),
                  Object(o.l)(r, "remove", "active")
              }
              this.hideDone(),
              this.updateFilterCount(),
              this.selectDefaults()
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && qi(t.prototype, i),
      n && qi(t, n),
      e
  }();
  function Wi(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(156);
  var $i = "slider-cards"
    , Gi = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              cardTitles: t.querySelectorAll(".".concat($i, " .card__title"))
          },
          this.slider = null,
          this.ctaProgress = null,
          this.events = Object(o.a)(this),
          this.init(),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.createSlider()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("resize", this.events._onResize)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("resize", this.events._onResize)
          }
      }, {
          key: "_onResize",
          value: function() {}
      }, {
          key: "_onCardHover",
          value: function(e) {
              var t = e.currentTarget.querySelector(".card__blurb-wrapper")
                , i = t.children[0];
              Object.assign(t.style, {
                  height: "".concat(i.offsetHeight, "px"),
                  opacity: 1
              })
          }
      }, {
          key: "_onCardLeave",
          value: function(e) {
              var t = e.currentTarget.querySelector(".card__blurb-wrapper");
              Object.assign(t.style, {
                  height: "",
                  opacity: ""
              })
          }
      }, {
          key: "createSlider",
          value: function() {
              var e = "swiper-".concat(++j.counters.instances);
              this.el.section.querySelector(".swiper-container").setAttribute("id", e);
              var t = {
                  direction: "horizontal",
                  slidesPerView: 4,
                  spaceBetween: 20,
                  loop: !1,
                  allowTouchMove: !1,
                  preventInteractionOnTransition: !0,
                  preloadImages: !1,
                  lazy: {
                      loadOnTransitionStart: !0,
                      loadPrevNext: !0
                  },
                  navigation: {
                      nextEl: ".".concat($i, " .swiper-button-next"),
                      prevEl: ".".concat($i, " .swiper-button-prev")
                  },
                  breakpoints: {
                      1280: {
                          slidesPerView: 3
                      },
                      1024: {
                          slidesPerView: 3,
                          spaceBetween: 8,
                          allowTouchMove: !0
                      },
                      900: {
                          slidesPerView: 2,
                          spaceBetween: 8,
                          allowTouchMove: !0
                      },
                      768: {
                          slidesPerView: 2,
                          spaceBetween: 8,
                          allowTouchMove: !0
                      },
                      600: {
                          slidesPerView: 1,
                          spaceBetween: 8,
                          allowTouchMove: !0
                      },
                      480: {
                          slidesPerView: 1,
                          spaceBetween: 8,
                          allowTouchMove: !0
                      }
                  }
              };
              this.slider = new lt("#".concat(e),t),
              this.slider && (this.ctaProgress = new yt(this.el.section,e,this.slider))
          }
      }, {
          key: "getCardTitleMaxHeight",
          value: function() {
              for (var e = 0, t = 0; t < this.el.cardTitles.length; t++)
                  this.el.cardTitles[t].style.height = "auto",
                  this.el.cardTitles[t].clientHeight > e && (e = this.el.cardTitles[t].clientHeight);
              return e
          }
      }, {
          key: "matchCardTitleHeights",
          value: function() {
              for (var e = this.getCardTitleMaxHeight(), t = 0; t < this.el.cardTitles.length; t++)
                  this.el.cardTitles[t].style.height = "".concat(e, "px")
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Wi(t.prototype, i),
      n && Wi(t, n),
      e
  }();
  function Xi(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(157);
  var Zi = "slider-collections"
    , Yi = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              slider: t.querySelector(".".concat(Zi, "__container")),
              slideSlide: t.querySelector(".".concat(Zi, "__container .swiper-slide"))
          },
          this.slider = null,
          this.ctaProgress = null,
          this.events = Object(o.a)(this),
          this.createSlider(),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "createSlider",
          value: function() {
              var e = "swiper-".concat(++j.counters.instances);
              this.el.section.querySelector(".swiper-container").setAttribute("id", e);
              var t = {
                  direction: "horizontal",
                  slidesPerView: 4,
                  spaceBetween: 20,
                  loop: !1,
                  allowTouchMove: !1,
                  preventInteractionOnTransition: !0,
                  preloadImages: !1,
                  lazy: {
                      loadOnTransitionStart: !0,
                      loadPrevNext: !0
                  },
                  navigation: {
                      nextEl: ".".concat(Zi, " .swiper-button-next"),
                      prevEl: ".".concat(Zi, " .swiper-button-prev")
                  },
                  breakpoints: {
                      1280: {
                          slidesPerView: 3
                      },
                      1024: {
                          slidesPerView: 3,
                          spaceBetween: 8,
                          allowTouchMove: !0
                      },
                      992: {
                          slidesPerView: 2,
                          spaceBetween: 8,
                          allowTouchMove: !0
                      },
                      480: {
                          slidesPerView: 1,
                          spaceBetween: 8,
                          allowTouchMove: !0
                      }
                  }
              };
              this.slider = new lt("#".concat(e),t),
              this.slider && (this.ctaProgress = new yt(this.el.section,e,this.slider))
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Xi(t.prototype, i),
      n && Xi(t, n),
      e
  }();
  function Ki(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(158);
  var Ji = "slider-features"
    , Qi = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              slides: ".".concat(Ji)
          },
          this.featSlider = null,
          this.mobileBreakpoint = window.matchMedia("(max-width: 992px)"),
          this.events = Object(o.a)(this),
          this.init(),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              Object(o.j)("large") ? this.featSlider ? this.featSlider.destroy(!0, !0) : this.featSlider = null : this.createFeatSlider()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              var e = this
                , t = document.querySelectorAll(".".concat(Ji));
              X()(".collapse").on("show.bs.collapse", function() {
                  t.forEach(function(e) {
                      e.style.opacity = 0
                  })
              }),
              X()(".collapse").on("shown.bs.collapse", function() {
                  e.updateFeatSlider(),
                  t.forEach(function(e) {
                      e.style.opacity = 1
                  })
              }),
              this.mobileBreakpoint.addListener(this.events._onBreakpointResize)
          }
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "_onBreakpointResize",
          value: function() {
              this.init()
          }
      }, {
          key: "createFeatSlider",
          value: function() {
              var e = "swiper-".concat(++j.counters.instances)
                , t = this.el.section.querySelector(".".concat(Ji, " .swiper-container"));
              t.setAttribute("id", e);
              var i = {
                  swiperScrollbar: "#".concat(e, " .swiper-scrollbar"),
                  swiperPagination: "#".concat(e, " .swiper-pagination")
              }
                , n = {
                  direction: "horizontal",
                  slidesPerView: 2.0625,
                  spaceBetween: 76,
                  observer: !0,
                  scrollbar: {
                      el: i.swiperScrollbar,
                      hide: !1
                  },
                  pagination: {
                      el: i.swiperPagination,
                      type: "fraction"
                  },
                  breakpoints: {
                      768: {
                          slidesPerView: 1.0225,
                          spaceBetween: 8,
                          slidesOffsetAfter: 8
                      }
                  }
              };
              this.featSlider = new lt(t,n)
          }
      }, {
          key: "updateFeatSlider",
          value: function() {
              this.featSlider.update()
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Ki(t.prototype, i),
      n && Ki(t, n),
      e
  }();
  function en(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(159);
  var tn = "slider-gallery"
    , nn = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              slider: t.querySelector(".".concat(tn, "__container")),
              sliderSlide: t.querySelector(".".concat(tn, "__container .swiper-slide")),
              sliderSlides: t.querySelectorAll(".".concat(tn, "__container .swiper-slide"))
          },
          this.swiper = null,
          this.events = Object(o.a)(this),
          this.currentMouseX = 0,
          this.createSwiper(),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              var e = this;
              this.el.slider.addEventListener("mousemove", this.events._onSlideAdjacentHover),
              window.addEventListener("modalopen", function() {
                  e.swiper && e.swiper.update()
              })
          }
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "_onSlideNextClick",
          value: function(e) {
              e.preventDefault(),
              this.gotoNextSlide()
          }
      }, {
          key: "_onSlidePrevClick",
          value: function(e) {
              e.preventDefault(),
              this.gotoPrevSlide()
          }
      }, {
          key: "_onSlideAdjacentHover",
          value: function(e) {
              e.preventDefault();
              e.pageX / window.innerWidth > 1 - .3333 ? this.swiper.isEnd || (this.el.section.addEventListener("click", this.events._onSlideNextClick),
              Object(o.j)("medium") && z.change("next-icon")) : e.pageX / window.innerWidth < .3333 ? this.swiper.isBeginning || (this.el.section.addEventListener("click", this.events._onSlidePrevClick),
              Object(o.j)("medium") && z.change("prev-icon")) : z.hideCursor(0, !1),
              this.currentMouseX = e.pageX
          }
      }, {
          key: "createSwiper",
          value: function() {
              var e = {
                  swiperContainer: ".".concat(tn, "__container .swiper-container"),
                  swiperScrollbar: ".".concat(tn, "__container .swiper-container .swiper-scrollbar"),
                  swiperNext: ".".concat(tn, "__container .swiper-container .swiper-button-next"),
                  swiperPrev: ".".concat(tn, "__container .swiper-container .swiper-button-prev")
              }
                , t = e.swiperContainer
                , i = {
                  direction: "horizontal",
                  centeredSlides: !0,
                  slidesPerView: 1,
                  loop: !1,
                  allowTouchMove: !1,
                  preventInteractionOnTransition: !0,
                  navigation: {
                      nextEl: e.swiperNext,
                      prevEl: e.swiperPrev
                  },
                  scrollbar: {
                      el: e.swiperScrollbar,
                      hide: !1
                  },
                  breakpoints: {
                      768: {
                          allowTouchMove: !0,
                          slidesPerView: 1
                      }
                  }
              };
              this.swiper = new lt(t,i)
          }
      }, {
          key: "getActiveSlideIndex",
          value: function() {
              if (this.swiper)
                  return this.swiper.activeIndex
          }
      }, {
          key: "gotoNextSlide",
          value: function() {
              this.swiper.slideNext(450);
              var e = this.getActiveSlideIndex()
                , t = this.el.sliderSlide.offsetWidth
                , i = this.swiper.getTranslate() - t;
              this.swiper.setTranslate(i),
              e + 1 >= this.el.sliderSlides.length && this.el.section.removeEventListener("click", this.events._onSlideNextClick)
          }
      }, {
          key: "gotoPrevSlide",
          value: function() {
              this.swiper.slidePrev(450);
              var e = this.getActiveSlideIndex()
                , t = this.el.sliderSlide.offsetWidth
                , i = this.swiper.getTranslate() + t;
              this.swiper.setTranslate(i),
              e <= 0 && this.el.section.removeEventListener("click", this.events._onSlidePrevClick)
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && en(t.prototype, i),
      n && en(t, n),
      e
  }();
  function rn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(160);
  var on = "slider-gallery-image"
    , sn = function() {
      function e(t) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              container: t.querySelector(".".concat(on, "__container")),
              swiperWrapper: t.querySelector(".".concat(on, " .swiper-wrapper")),
              swiperContainer: t.querySelector(".".concat(on, " .swiper-container")),
              swiperSlides: t.querySelectorAll(".".concat(on, " .swiper-slide")),
              fullscreenCaptionsContainer: t.querySelector(".".concat(on, "__fullscreen-captions")),
              fullscreenControls: t.querySelector(".".concat(on, "__fullscreen-overlay")),
              fullscreenCloseCta: t.querySelector(".".concat(on, "__fullscreen-close-cta")),
              fullscreenNext: t.querySelector(".".concat(on, "__fullscreen-button-next")),
              fullscreenPrev: t.querySelector(".".concat(on, "__fullscreen-button-prev")),
              fullscreenProgress: t.querySelector(".".concat(on, "__fullscreen-progress")),
              fullscreenProgressHandle: t.querySelector(".".concat(on, "__fullscreen-progress-drag")),
              fullscreenInfoContentWrappers: t.querySelectorAll(".".concat(on, "__fullscreen-content-wrapper")),
              fullscreenInfoCtas: t.querySelectorAll(".".concat(on, "__fullscreen-info-cta")),
              body: document.querySelector("body"),
              navigation: document.querySelector(".navigation-primary")
          },
          this.defaults = {
              peekNextRatio: .75,
              peekPrevRatio: .25,
              peekImageRatio: .25,
              cursorNextRatio: .5,
              cursorPrevRatio: .5
          },
          this.options = Object.assign({}, this.defaults, i),
          this.bounds = {
              windowWidth: null,
              swiperHeight: null,
              swiperTop: null,
              swiperLeft: null
          },
          this.coords = {
              mouse: {
                  pageX: 0,
                  pageY: 0
              },
              slider: {}
          },
          this.flags = {
              isMouseOverCta: !1,
              isSliderPeekingLeft: !1,
              isSliderPeekingRight: !1,
              isSliding: !1,
              isZoomed: !1
          },
          this.slide = {
              current: null
          },
          this.states = {
              zoomSlideInitialIndex: 0,
              zoomSlideIndex: 0
          },
          this.slider = null,
          this.sliderOptions = {
              direction: "horizontal",
              slidesPerView: 2,
              spaceBetween: 10,
              loop: !1,
              allowTouchMove: !1,
              preventInteractionOnTransition: !0,
              preloadImages: !1,
              lazy: {
                  loadOnTransitionStart: !0,
                  loadPrevNext: !0
              },
              navigation: {
                  nextEl: ".".concat(on, " .swiper-button-next"),
                  prevEl: ".".concat(on, " .swiper-button-prev")
              },
              breakpoints: {
                  480: {
                      slidesPerView: 1,
                      allowTouchMove: !0
                  },
                  768: {
                      slidesPerView: 2,
                      allowTouchMove: !0
                  }
              }
          },
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.createSlider(),
              this.measureDom(),
              this.setSliderHolder(),
              this.addEventListeners()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("mousemove", this.events._onMouseMove, {
                  passive: !0
              }),
              Object(o.k)(this.el.swiperSlides, "click", this.events._onSlideClick),
              Object(o.k)(this.el.fullscreenInfoCtas, "click", this.events._onInfoCtaClick),
              Object(o.k)(this.el.fullscreenInfoCtas, "mouseenter", this.events._onInfoCtaEnter),
              Object(o.k)(this.el.fullscreenInfoCtas, "mouseleave", this.events._onInfoCtaLeave),
              this.el.section.addEventListener("click", this.events._onSectionClick),
              this.el.fullscreenCloseCta.addEventListener("click", this.events._onFullscreenCloseCtaClick),
              this.el.fullscreenCloseCta.addEventListener("mouseenter", this.events._onFullscreenCloseCtaEnter),
              this.el.fullscreenCloseCta.addEventListener("mouseleave", this.events._onFullscreenCloseCtaLeave),
              this.el.fullscreenPrev.addEventListener("click", this.events._onFullscreenPrevClick),
              this.el.fullscreenNext.addEventListener("click", this.events._onFullscreenNextClick)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("mousemove", this.events._onMouseMove, {
                  passive: !0
              }),
              Object(o.m)(this.el.swiperSlides, "click", this.events._onSlideClick),
              Object(o.m)(this.el.fullscreenInfoCtas, "click", this.events._onInfoCtaClick),
              Object(o.m)(this.el.fullscreenInfoCtas, "mouseenter", this.events._onInfoCtaEnter),
              Object(o.m)(this.el.fullscreenInfoCtas, "mouseleave", this.events._onInfoCtaLeave),
              this.el.section.removeEventListener("click", this.events._onSectionClick),
              this.el.fullscreenCloseCta.removeEventListener("click", this.events._onFullscreenCloseCtaClick),
              this.el.fullscreenCloseCta.removeEventListener("mouseenter", this.events._onFullscreenCloseCtaEnter),
              this.el.fullscreenCloseCta.removeEventListener("mouseleave", this.events._onFullscreenCloseCtaLeave),
              this.el.fullscreenPrev.removeEventListener("click", this.events._onFullscreenPrevClick),
              this.el.fullscreenNext.removeEventListener("click", this.events._onFullscreenNextClick)
          }
      }, {
          key: "_onSectionClick",
          value: function() {
              this.flags.isZoomed && !this.flags.isMouseOverCta && this.measureMouseClickPos()
          }
      }, {
          key: "_onMouseMove",
          value: function(e) {
              this.measureMouse(e)
          }
      }, {
          key: "_onSlideClick",
          value: function(e) {
              this.zoomSlides(e)
          }
      }, {
          key: "_onInfoCtaClick",
          value: function(e) {
              this.toggleInfo(e.currentTarget.closest("li"))
          }
      }, {
          key: "_onInfoCtaEnter",
          value: function() {
              this.flags.isMouseOverCta = !0,
              this.flags.isZoomed && z.off()
          }
      }, {
          key: "_onInfoCtaLeave",
          value: function() {
              this.flags.isMouseOverCta = !1,
              this.flags.isZoomed && z.on()
          }
      }, {
          key: "_onFullscreenCloseCtaClick",
          value: function() {
              this.zoomOut()
          }
      }, {
          key: "_onFullscreenCloseCtaEnter",
          value: function() {
              this.flags.isMouseOverCta = !0,
              this.flags.isZoomed && z.off()
          }
      }, {
          key: "_onFullscreenCloseCtaLeave",
          value: function() {
              this.flags.isMouseOverCta = !1,
              this.flags.isZoomed && z.on()
          }
      }, {
          key: "_onFullscreenPrevClick",
          value: function() {
              this.changeZoomSlideIndex(this.states.zoomSlideIndex - 1)
          }
      }, {
          key: "_onFullscreenNextClick",
          value: function() {
              this.changeZoomSlideIndex(this.states.zoomSlideIndex + 1)
          }
      }, {
          key: "measureDom",
          value: function() {
              this.bounds.swiperHeight = this.el.swiperContainer.offsetHeight,
              this.bounds.swiperLeft = this.el.container.offsetLeft,
              this.bounds.swiperTop = this.getBounds("offsetTop", this.el.swiperContainer)
          }
      }, {
          key: "measureMouse",
          value: function(e) {
              this.coords.mouse.pageX = e.pageX,
              this.coords.mouse.pageY = e.pageY,
              this.flags.isZoomed && this.updateZoomCursor()
          }
      }, {
          key: "measureMouseClickPos",
          value: function() {
              var e = this.coords.mouse.pageX
                , t = window.innerWidth;
              if (this.flags.isZoomed && !this.flags.isZoomAnimating && !this.flags.isMouseOverCta) {
                  var i = e / t;
                  i >= this.options.cursorNextRatio ? (this.changeZoomSlideIndex(this.states.zoomSlideIndex + 1),
                  this.updateZoomCursor()) : i < this.options.cursorPrevRatio && (this.changeZoomSlideIndex(this.states.zoomSlideIndex - 1),
                  this.updateZoomCursor())
              }
          }
      }, {
          key: "measureSliderCoords",
          value: function() {
              var e = this.el.swiperSlides[0].offsetWidth
                , t = this.el.swiperSlides[0].offsetHeight
                , i = parseInt(this.slide.current.style.marginRight)
                , n = window.innerWidth
                , r = window.innerHeight
                , o = e / t
                , s = n / r
                , a = o > s ? r / t : n / e
                , l = window.getComputedStyle(this.el.swiperWrapper).getPropertyValue("transform")
                , c = parseInt(l.split("matrix(")[1].split(",")[4])
                , u = (e * a - n) / 2
                , h = (t * a - r) / 2
                , d = this.bounds.swiperTop - window.scrollY
                , p = this.bounds.swiperLeft;
              this.coords.slider = {
                  slideWidth: e,
                  slideHeight: t,
                  slideMargin: i,
                  slideAspectRatio: o,
                  windowAspectRatio: s,
                  scale: a,
                  swiperWrapperTransform: l,
                  swiperTransformX: c,
                  widthOffset: u,
                  heightOffset: h,
                  containerScrollOffset: d,
                  containerLeftOffset: p
              }
          }
      }, {
          key: "setSliderHolder",
          value: function() {
              this.el.container.style.paddingTop = "".concat(this.bounds.swiperHeight, "px")
          }
      }, {
          key: "createSlider",
          value: function() {
              var e = "swiper-".concat(++j.counters.instances);
              this.el.section.querySelector(".swiper-container").setAttribute("id", e),
              this.slider = new lt("#".concat(e),this.sliderOptions)
          }
      }, {
          key: "zoomSlides",
          value: function(e) {
              var t = this;
              if (!this.flags.isZoomed && !this.flags.isZoomAnimating) {
                  this.flags.isZoomed = !0,
                  this.flags.isZoomAnimating = !0,
                  this.slide.current = e.target.closest(".swiper-slide"),
                  this.states.zoomSlideInitialIndex = parseInt(this.slide.current.getAttribute("data-slide-index")),
                  this.measureSliderCoords(),
                  this.el.body.classList.add("is-modal-open"),
                  this.el.navigation.classList.add("is-hidden"),
                  this.el.section.classList.add("is-fullscreen-mode"),
                  this.el.fullscreenControls.classList.add("is-controls-shown"),
                  this.changeZoomSlideIndex(this.states.zoomSlideInitialIndex);
                  var i = Math.max(0, Math.ceil(this.coords.slider.widthOffset - 2 * this.coords.slider.scale) / this.coords.slider.scale)
                    , n = Math.max(0, Math.ceil(this.coords.slider.heightOffset - 2 * this.coords.slider.scale) / this.coords.slider.scale);
                  setTimeout(function() {
                      t.flags.isZoomAnimating = !1;
                      for (var e = 0; e < t.el.swiperSlides.length; e++) {
                          var r = t.el.swiperSlides[e];
                          Object.assign(r.style, {
                              clipPath: "inset(".concat(n, "px ").concat(i, "px)")
                          })
                      }
                      t.updateZoomCursor()
                  }, 700)
              }
          }
      }, {
          key: "changeZoomSlideIndex",
          value: function(e) {
              var t = this;
              if (!this.flags.isSliding && e >= 0 && e <= this.el.swiperSlides.length - 1) {
                  this.flags.isSliding = !0,
                  this.states.zoomSlideIndex = e,
                  this.el.section.classList.add("is-sliding"),
                  Object(o.l)(this.el.swiperSlides, "remove", "active"),
                  this.el.swiperSlides[this.states.zoomSlideIndex].classList.add("active"),
                  this.hideAllInfo(),
                  this.updateProgressBar(),
                  this.flags.isSliderPeekingLeft || this.flags.isSliderPeekingRight ? (this.el.section.classList.remove("is-peeking"),
                  this.flags.isSliderPeekingLeft ? this.slideToRatio((this.states.zoomSlideIndex - this.options.peekImageRatio * this.getPeekRatio()) / this.el.swiperSlides.length) : this.slideToRatio((this.states.zoomSlideIndex + this.options.peekImageRatio * this.getPeekRatio()) / this.el.swiperSlides.length)) : this.slideToRatio(this.states.zoomSlideIndex / this.el.swiperSlides.length);
                  var i = window.innerWidth;
                  Object.assign(this.el.fullscreenCaptionsContainer.style, {
                      transform: "translateX(".concat(0 - i * this.states.zoomSlideIndex, "px)")
                  }),
                  setTimeout(function() {
                      t.flags.isSliding = !1,
                      t.el.section.classList.remove("is-sliding")
                  }, 700)
              }
          }
      }, {
          key: "slideToRatio",
          value: function(e) {
              var t = Math.min(Math.max(0, e * this.el.swiperSlides.length), this.el.swiperSlides.length - 1);
              this.measureSliderCoords();
              var i = Math.round(0 - (this.coords.slider.heightOffset + this.coords.slider.containerScrollOffset) / this.coords.slider.scale)
                , n = []
                , r = 0;
              r = Object(o.j)("large") ? this.coords.slider.slideWidth / this.coords.slider.scale + this.coords.slider.containerLeftOffset - this.coords.slider.slideMargin : 2 * this.coords.slider.widthOffset / this.coords.slider.scale;
              for (var s = 0; s < this.el.swiperSlides.length; s++) {
                  var a = r * (s - this.states.zoomSlideIndex)
                    , l = (this.coords.slider.containerLeftOffset + this.coords.slider.widthOffset + this.coords.slider.swiperTransformX) / this.coords.slider.scale
                    , c = (this.coords.slider.slideWidth + this.coords.slider.slideMargin) / this.coords.slider.scale * t
                    , u = Math.round(a - l - c);
                  n.push(u)
              }
              for (var h = 0; h < this.el.swiperSlides.length; h++) {
                  var d = this.el.swiperSlides[h]
                    , p = n[h];
                  Object.assign(d.style, {
                      transform: "scale(".concat(this.coords.slider.scale, ") translateX(").concat(p, "px) translateY(").concat(i, "px)")
                  })
              }
          }
      }, {
          key: "zoomOut",
          value: function() {
              var e = this;
              this.flags.isZoomed && !this.flags.isZoomAnimating && (this.flags.isZoomed = !1,
              this.flags.isZoomAnimating = !0,
              this.el.section.classList.add("is-slider-correcting", "is-fullscreen-out"),
              this.el.section.classList.remove("is-fullscreen-mode"),
              this.el.fullscreenControls.classList.remove("is-controls-shown"),
              this.hideCursor(),
              this.slider.slideTo(this.states.zoomSlideIndex, 0),
              this.changeZoomSlideIndex(this.states.zoomSlideIndex),
              S.a.one(function() {
                  e.el.section.classList.remove("is-slider-correcting");
                  for (var t = 0; t < e.el.swiperSlides.length; t++) {
                      var i = e.el.swiperSlides[t];
                      Object.assign(i.style, {
                          clipPath: "",
                          transform: ""
                      })
                  }
              }),
              setTimeout(function() {
                  e.flags.isZoomAnimating = !1,
                  e.el.body.classList.remove("is-modal-open"),
                  e.el.navigation.classList.remove("is-hidden"),
                  e.el.section.classList.remove("is-fullscreen-out")
              }, 700))
          }
      }, {
          key: "updateZoomCursor",
          value: function() {
              var e = this.coords.mouse.pageX
                , t = window.innerWidth;
              if (!this.flags.isSliding && Object(o.j)("large")) {
                  var i = e / t
                    , n = !0
                    , r = !1;
                  i >= this.options.cursorNextRatio ? this.states.zoomSlideIndex < this.el.swiperSlides.length - 1 ? (this.flags.isMouseOverCta || z.change("next-icon"),
                  i >= this.options.peekNextRatio && (r = !0,
                  this.flags.isSliderPeekingRight || (this.flags.isSliderPeekingRight = !0,
                  this.flags.isSliderPeekingLeft = !1),
                  this.peekNext(this.getPeekRatio()))) : n = !1 : i < this.options.cursorPrevRatio ? this.states.zoomSlideIndex > 0 ? (this.flags.isMouseOverCta || z.change("prev-icon"),
                  i < this.options.peekPrevRatio && (r = !0,
                  this.flags.isSliderPeekingLeft || (this.flags.isSliderPeekingLeft = !0,
                  this.flags.isSliderPeekingRight = !1),
                  this.peekPrev(this.getPeekRatio()))) : n = !1 : this.slider.animating || !this.flags.isSliderPeekingLeft && !this.flags.isSliderPeekingRight || (n = !1),
                  n || this.hideCursor(),
                  r || !this.flags.isSliderPeekingLeft && !this.flags.isSliderPeekingRight || (this.flags.isSliderPeekingLeft = !1,
                  this.flags.isSliderPeekingRight = !1,
                  this.resetPeek())
              }
          }
      }, {
          key: "updateProgressBar",
          value: function() {
              var e = 1 - (this.states.zoomSlideIndex + 1) / this.el.swiperSlides.length
                , t = this.el.fullscreenProgress.offsetWidth;
              Object.assign(this.el.fullscreenProgressHandle.style, {
                  transform: "translateX(".concat(0 - e * t, "px)")
              })
          }
      }, {
          key: "hideCursor",
          value: function() {
              z.off()
          }
      }, {
          key: "updateProgress",
          value: function() {}
      }, {
          key: "toggleInfo",
          value: function(e) {
              e && (e.classList.contains("is-content-shown") ? this.hideInfo(e) : this.showInfo(e))
          }
      }, {
          key: "showInfo",
          value: function(e) {
              e && (e.classList.add("is-content-shown"),
              this.el.swiperSlides[this.states.zoomSlideIndex].classList.add("is-content-shown"))
          }
      }, {
          key: "hideInfo",
          value: function(e) {
              e && (e.classList.remove("is-content-shown"),
              this.el.swiperSlides[this.states.zoomSlideIndex].classList.remove("is-content-shown"))
          }
      }, {
          key: "hideAllInfo",
          value: function() {
              for (var e = 0; e < this.el.fullscreenInfoContentWrappers.length; e++)
                  this.hideInfo(this.el.fullscreenInfoContentWrappers[e])
          }
      }, {
          key: "peekNext",
          value: function() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
              this.el.section.classList.add("is-peeking"),
              this.slideToRatio((this.states.zoomSlideIndex + this.options.peekImageRatio * e) / this.el.swiperSlides.length)
          }
      }, {
          key: "peekPrev",
          value: function() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
              this.el.section.classList.add("is-peeking"),
              this.slideToRatio((this.states.zoomSlideIndex - this.options.peekImageRatio * e) / this.el.swiperSlides.length)
          }
      }, {
          key: "resetPeek",
          value: function() {
              this.el.section.classList.remove("is-peeking"),
              this.slideToRatio(this.states.zoomSlideIndex / this.el.swiperSlides.length)
          }
      }, {
          key: "getPeekRatio",
          value: function() {
              var e = this.coords.mouse.pageX / window.innerWidth;
              return e >= this.options.peekNextRatio ? Math.pow((e - this.options.peekNextRatio) / (1 - this.options.peekNextRatio), 2) : e < this.options.peekPrevRatio ? Math.pow(1 - e / this.options.peekPrevRatio, 2) : 0
          }
      }, {
          key: "getBounds",
          value: function(e, t) {
              var i = 0
                , n = t;
              do {
                  isNaN(n[e]) || (i += n[e]),
                  n = n.offsetParent
              } while (n);return i
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && rn(t.prototype, i),
      n && rn(t, n),
      e
  }();
  function an(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(161);
  var ln = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.slider = null,
          this.events = Object(o.a)(this),
          this.createSlider()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "createSlider",
          value: function() {
              var e = this
                , t = "swiper-".concat(++j.counters.instances)
                , i = "swiper-pagination-".concat(++j.counters.instances)
                , n = this.el.section.querySelector(".".concat("slider-product-tile", "__container"))
                , r = this.el.section.querySelector(".".concat("slider-product-tile", "__pagination"))
                , o = n.querySelectorAll(".".concat("slider-product-tile", "__slide"))
                , s = this.el.section.querySelector(".product-tile__stat")
                , a = [];
              n.setAttribute("id", t),
              r.setAttribute("id", i);
              var l = !0
                , c = !1
                , u = void 0;
              try {
                  for (var h, d = o[Symbol.iterator](); !(l = (h = d.next()).done); l = !0) {
                      var p = h.value.getAttribute("data-product-hex");
                      a.push(p)
                  }
              } catch (e) {
                  c = !0,
                  u = e
              } finally {
                  try {
                      l || null == d.return || d.return()
                  } finally {
                      if (c)
                          throw u
                  }
              }
              s.innerHTML = "".concat(a.length, " colors");
              var f = {
                  swiperWrapper: "".concat("slider-product-tile", "__wrapper"),
                  swiperSlide: "".concat("slider-product-tile", "__slide"),
                  swiperBullet: "".concat("slider-product-tile", "__bullet"),
                  swiperBulletActive: "".concat("slider-product-tile", "__bullet--active")
              }
                , m = {
                  wrapperClass: f.swiperWrapper,
                  direction: "horizontal",
                  effect: "fade",
                  slideClass: f.swiperSlide,
                  slidesPerView: 1,
                  slidesOffsetAfter: 0,
                  spaceBetween: 0,
                  speed: 300,
                  allowTouchMove: !1,
                  preloadImages: !1,
                  lazy: {
                      elementClass: "slider-product-tile__slide-image",
                      loadOnTransitionStart: !0
                  },
                  pagination: {
                      el: r,
                      type: "bullets",
                      clickable: !0,
                      bulletClass: f.swiperBullet,
                      bulletActiveClass: f.swiperBulletActive,
                      renderBullet: function(e, t) {
                          return '<li id="'.concat(e, '" class="').concat(t, '">\n\t\t\t\t\t\t\t\t<a href="javascript:;" class="cta-circle product-tile--colors cta-circle--swatch" data-cta-circle="" data-link-routed="true">\n\t\t\t\t\t\t\t\t\t<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">\n\t\t\t\t\t\t\t\t\t<path d="M28.6,17.9l-0.8-0.8c-0.4-0.4-1-0.4-1.4,0l-6.1,6.1l-2.6-2.6\n\t\t\t\t\t\t\t\t\t\tc-0.4-0.4-1-0.4-1.4,0l-0.8,0.8c-0.4,0.4-0.4,1,0,1.4l4.1,4.1c0.4,0.4,1,0.4,1.4,0l0.7-0.7l6.8-6.8C29,18.9,29,18.3,28.6,17.9z"></path>\n\t\t\t\t\t\t\t\t\t</svg\n\t\t\t\t\t\t\t\t\t<figure class="cta-circle__outline"></figure>\n\t\t\t\t\t\t\t\t\t<figure class="cta-circle__bg">\n\t\t\t\t\t\t\t\t\t\t<figure style="background: ').concat(a[e], '"></figure>\n\t\t\t\t\t\t\t\t\t</figure>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</li>')
                      }
                  },
                  breakpoints: {}
              };
              this.slider = new lt(n,m),
              this.slider.on("slideChange", function() {
                  0 === e.slider.activeIndex ? e.el.section.classList.remove("is-cover-hidden") : e.el.section.classList.add("is-cover-hidden")
              })
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && an(t.prototype, i),
      n && an(t, n),
      e
  }();
  i(162);
  function cn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var un = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              image: t.querySelector("img")
          },
          this.defaults = {
              animationData: null,
              index: 0,
              foregrounds: []
          },
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(o.a)(this),
          this.boundaryForegrounds = {
              top: null,
              bottom: null
          },
          this.bounds = {
              section: null,
              isBoundsUpdated: !1
          },
          this.flags = {
              isIntersecting: !1
          },
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.addEventListeners()
          }
      }, {
          key: "checkScroll",
          value: function(e) {
              if (this.boundaryForegrounds && this.boundaryForegrounds.top && this.boundaryForegrounds.bottom) {
                  var t = j.coords.window.height
                    , i = this.boundaryForegrounds.top.sectionBounds
                    , n = this.boundaryForegrounds.bottom.sectionBounds
                    , r = .4 * t
                    , o = 1 * (n.scrollBottom - i.scrollTop)
                    , s = Math.min(1, Math.max(0, (e + r - i.scrollTop) / o))
                    , a = Math.min(1, Math.max(0, (e + t - n.scrollTop) / Math.min(t, n.height)));
                  if (0 === this.options.index ? Object.assign(this.el.section.style, {
                      opacity: 1
                  }) : Object.assign(this.el.section.style, {
                      opacity: a
                  }),
                  this.options.index,
                  this.options.animationData && this.el.image) {
                      var l = this.options.animationData
                        , c = l.start
                        , u = l.end
                        , h = void 0 !== c.opacity ? (u.opacity - c.opacity) * s + c.opacity : ""
                        , d = void 0 !== c.scale ? (u.scale - c.scale) * s + c.scale : ""
                        , p = void 0 !== l.transformOrigin ? l.transformOrigin : "";
                      Object.assign(this.el.image.style, {
                          opacity: h,
                          transform: d ? "scale(".concat(d, ")") : "",
                          transformOrigin: p
                      })
                  }
              }
          }
      }, {
          key: "tick",
          value: function() {
              this.flags.isBoundsUpdated = !1
          }
      }, {
          key: "updateBounds",
          value: function() {
              var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              this.flags.isBoundsUpdated && !e || (this.bounds.section = Object(o.g)(this.el.section)),
              this.flags.isBoundsUpdated = !0
          }
      }, {
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "setBoundaryForegrounds",
          value: function(e, t) {
              Object.assign(this.boundaryForegrounds, {
                  top: e,
                  bottom: t
              })
          }
      }, {
          key: "clearState",
          value: function() {
              Object.assign(this.flags, {
                  isTop: !1,
                  isBottom: !1,
                  isActive: !1,
                  isPrev: !1
              }),
              this.el.section.classList.remove("active", "active-last")
          }
      }, {
          key: "setInactive",
          value: function() {
              this.clearState()
          }
      }, {
          key: "setActive",
          value: function() {
              this.clearState(),
              this.flags.isActive = !0,
              this.el.section.classList.add("active")
          }
      }, {
          key: "setPrev",
          value: function() {
              this.clearState(),
              this.flags.isPrev = !0,
              this.el.section.classList.add("active-last")
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }, {
          key: "sectionBounds",
          get: function() {
              return this.bounds.section
          }
      }, {
          key: "section",
          get: function() {
              return this.el.section
          }
      }, {
          key: "index",
          get: function() {
              return this.options.index
          }
      }]) && cn(t.prototype, i),
      n && cn(t, n),
      e
  }();
  function hn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var dn = "storytelling__border"
    , pn = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              borderTop: t.querySelector(".".concat(dn, "-top")),
              borderRight: t.querySelector(".".concat(dn, "-right")),
              borderBottom: t.querySelector(".".concat(dn, "-bottom")),
              borderLeft: t.querySelector(".".concat(dn, "-left"))
          },
          this.defaults = {
              foregrounds: {
                  top: null,
                  bottom: null
              }
          },
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(o.a)(this),
          this.flags = {},
          this.ratios = {
              trigger: .4,
              scrollOffset: .333
          },
          this.states = {
              scaleRatio: 1,
              lastScrollY: 0
          },
          this.lirp = new u.c(1,{
              minDifference: .001,
              ratio: .1
          }),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.addEventListeners()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("resize", this.events._onResize),
              this.lirp.callback = this.events._onLirpUpdate,
              this.lirp.callbackComplete = this.events._onLirpComplete,
              this.checkResize()
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("resize", this.events._onResize),
              this.lirp && this.lirp.destroy()
          }
      }, {
          key: "_onResize",
          value: function() {
              this.checkResize()
          }
      }, {
          key: "_onLirpUpdate",
          value: function(e) {
              Object.assign(this.el.borderTop.style, {
                  transform: "scaleY(".concat(e, ")")
              }),
              Object.assign(this.el.borderRight.style, {
                  transform: "scaleX(".concat(e, ")")
              }),
              Object.assign(this.el.borderBottom.style, {
                  transform: "scaleY(".concat(e, ")")
              }),
              Object.assign(this.el.borderLeft.style, {
                  transform: "scaleX(".concat(e, ")")
              })
          }
      }, {
          key: "_onLirpComplete",
          value: function() {}
      }, {
          key: "checkResize",
          value: function() {
              Object.assign(this.ratios, {
                  trigger: Object(o.j)("medium") ? .333 : .1,
                  scrollOffset: Object(o.j)("medium") ? .4 : .6
              })
          }
      }, {
          key: "checkScroll",
          value: function(e) {
              if (e !== this.states.lastScrollY) {
                  if (this.options.foregrounds.top) {
                      var t = j.coords.window.height
                        , i = this.options.foregrounds.top.sectionBounds
                        , n = this.options.foregrounds.bottom.sectionBounds
                        , r = this.ratios.trigger
                        , o = t * this.ratios.scrollOffset
                        , s = t * r
                        , a = 1 - (i === n || i.scrollBottom > e + o ? Math.min(1, Math.max(0, (e + o - i.scrollTop) / s - (1 - r))) : 1);
                      a !== this.states.scaleRatio && (this.states.scaleRatio = a,
                      this.lirp.update(this.states.scaleRatio))
                  }
                  this.states.lastScrollY = e
              }
          }
      }, {
          key: "tick",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && hn(t.prototype, i),
      n && hn(t, n),
      e
  }()
    , fn = i(9)
    , mn = i.n(fn);
  function gn(e) {
      return function(e) {
          if (Array.isArray(e)) {
              for (var t = 0, i = new Array(e.length); t < e.length; t++)
                  i[t] = e[t];
              return i
          }
      }(e) || function(e) {
          if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))
              return Array.from(e)
      }(e) || function() {
          throw new TypeError("Invalid attempt to spread non-iterable instance")
      }()
  }
  function vn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var yn = "storytelling__foreground"
    , _n = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              contentWrapper: t.querySelector(".".concat(yn, "-content-wrapper")),
              innerContentContainer: null
          },
          this.defaults = {
              index: 0,
              backgrounds: [],
              fadeInGutter: {
                  min: .1,
                  max: .6
              },
              minFadeTriggerWinHeightFraction: .4
          },
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(o.a)(this),
          this.bounds = {
              innerContent: null,
              section: null,
              verticalGutterIn: 0,
              verticalGutterOut: 0,
              visibilityTriggerHeight: 0
          },
          this.easing = {
              fade: mn.a.apply(void 0, gn(c.easing.easeOutSoft))
          },
          this.flags = {
              isTop: !1,
              isBottom: !1,
              isActive: !1,
              isInactive: !0,
              isPrev: !1,
              isBoundsUpdated: !1
          },
          this.ratios = {
              trigger: .4,
              scrollOffset: .333
          },
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              var e = this.el.section.querySelector("[data-storytelling-foreground-content-container]");
              this.el.innerContentContainer = e || this.el.contentWrapper,
              this.addEventListeners()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("resize", this.events._onWindowResize),
              this._onWindowResize()
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("resize", this.events._onWindowResize)
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.checkResize()
          }
      }, {
          key: "checkResize",
          value: function() {
              this.updateContentWrapperBounds(),
              0 === this.options.index ? Object.assign(this.ratios, {
                  trigger: Object(o.j)("medium") ? .333 : .1,
                  scrollOffset: Object(o.j)("medium") ? .4 : .6
              }) : Object.assign(this.ratios, {
                  trigger: Object(o.j)("medium") ? .6 : .2,
                  scrollOffset: Object(o.j)("medium") ? .8 : .9
              })
          }
      }, {
          key: "getScrollProperties",
          value: function(e) {
              if (!this.flags.isInactive) {
                  var t = j.coords.window.height
                    , i = this.ratios.trigger
                    , n = t * this.ratios.scrollOffset
                    , r = t * i
                    , o = this.bounds.section.scrollBottom > e + n ? Math.min(1, Math.max(0, (e + n - this.bounds.section.scrollTop) / r - (1 - i))) : 1;
                  return 0 === this.options.index && o > .8 || this.options.index > 0 && o > 0 ? this.el.section.classList.add("is-on-screen") : this.el.section.classList.remove("is-on-screen"),
                  o >= 1 ? this.el.section.classList.add("is-in-center") : this.el.section.classList.remove("is-in-center"),
                  {
                      opacity: this.easing.fade(o)
                  }
              }
              return {
                  opacity: 0
              }
          }
      }, {
          key: "updateScrollProperties",
          value: function(e) {
              Object.assign(this.el.section.style, e)
          }
      }, {
          key: "tick",
          value: function() {
              this.flags.isBoundsUpdated = !1
          }
      }, {
          key: "updateBounds",
          value: function() {
              var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              this.flags.isBoundsUpdated && !e || (this.bounds.innerContent = Object(o.g)(this.el.innerContentContainer),
              this.bounds.section = Object(o.g)(this.el.section)),
              this.flags.isBoundsUpdated = !0
          }
      }, {
          key: "updateContentWrapperBounds",
          value: function() {
              var e = j.coords.window.height;
              this.updateBounds(),
              this.bounds.verticalGutterIn = Math.round((this.bounds.section.height - this.el.innerContentContainer.clientHeight) / 2),
              this.bounds.verticalGutterOut = Math.round((this.bounds.section.height - this.el.contentWrapper.clientHeight) / 2),
              this.bounds.visibilityTriggerHeight = Math.max(this.el.innerContentContainer.clientHeight, e * this.options.minFadeTriggerWinHeightFraction)
          }
      }, {
          key: "clearState",
          value: function() {
              Object.assign(this.flags, {
                  isTop: !1,
                  isBottom: !1,
                  isActive: !1,
                  isInactive: !0,
                  isPrev: !1
              }),
              this.el.section.classList.remove("active", "active-last", "is-top", "is-bottom")
          }
      }, {
          key: "setInactive",
          value: function() {
              this.clearState()
          }
      }, {
          key: "setActive",
          value: function() {
              this.clearState(),
              this.flags.isActive = !0,
              this.flags.isInactive = !1,
              this.el.section.classList.add("active")
          }
      }, {
          key: "setPrev",
          value: function() {
              this.clearState(),
              this.flags.isPrev = !0,
              this.flags.isInactive = !1,
              this.el.section.classList.add("active-last")
          }
      }, {
          key: "setTop",
          value: function() {
              this.clearState(),
              this.flags.isTop = !0,
              this.flags.isInactive = !1,
              this.el.section.classList.add("is-top")
          }
      }, {
          key: "setBottom",
          value: function() {
              this.clearState(),
              this.flags.isBottom = !0,
              this.flags.isInactive = !1,
              this.el.section.classList.add("is-bottom")
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }, {
          key: "sectionBounds",
          get: function() {
              return this.bounds.section
          }
      }, {
          key: "section",
          get: function() {
              return this.el.section
          }
      }, {
          key: "index",
          get: function() {
              return this.options.index
          }
      }]) && vn(t.prototype, i),
      n && vn(t, n),
      e
  }();
  function bn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var wn = "storytelling__progress"
    , xn = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              track: t.querySelector(".".concat(wn, "-track")),
              bg: t.querySelector(".".concat(wn, "-bg"))
          },
          this.defaults = {
              controller: null
          },
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(o.a)(this),
          this.coords = {
              controller: null
          },
          this.flags = {},
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.addEventListeners()
          }
      }, {
          key: "checkScroll",
          value: function(e) {
              if (this.options.controller) {
                  var t = j.coords.window.height
                    , i = Math.max(0, Math.min(1, (e - this.coords.controller.scrollTop) / (this.coords.controller.height - t)));
                  i >= 0 && i <= 1 && Object.assign(this.el.track.style, {
                      transform: "scaleX(".concat(i, ")")
                  })
              }
          }
      }, {
          key: "tick",
          value: function() {}
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("resize", this.events._onResize),
              this._onResize()
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("resize", this.events._onResize)
          }
      }, {
          key: "_onResize",
          value: function() {
              this.options.controller && (this.coords.controller = Object(o.g)(this.options.controller.el.section))
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && bn(t.prototype, i),
      n && bn(t, n),
      e
  }();
  function kn(e, t) {
      return function(e) {
          if (Array.isArray(e))
              return e
      }(e) || function(e, t) {
          var i = []
            , n = !0
            , r = !1
            , o = void 0;
          try {
              for (var s, a = e[Symbol.iterator](); !(n = (s = a.next()).done) && (i.push(s.value),
              !t || i.length !== t); n = !0)
                  ;
          } catch (e) {
              r = !0,
              o = e
          } finally {
              try {
                  n || null == a.return || a.return()
              } finally {
                  if (r)
                      throw o
              }
          }
          return i
      }(e, t) || function() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance")
      }()
  }
  function Sn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var En = "storytelling-scroller"
    , Tn = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              backgrounds: t.querySelectorAll(".".concat(En, "__background")),
              backgroundActive: null,
              backgroundsWithContent: null,
              backgroundsWrapper: t.querySelector(".".concat(En, "__backgrounds")),
              border: t.querySelector(".".concat(En, "__border")),
              foregrounds: t.querySelectorAll(".".concat(En, "__foreground")),
              foregroundActive: null,
              foregroundContents: t.querySelectorAll(".".concat(En, "__foreground-content-wrapper")),
              foregroundsWrapper: t.querySelector(".".concat(En, "__foregrounds")),
              progress: t.querySelector(".".concat(En, "__progress")),
              skip: t.querySelector(".".concat(En, "__skip"))
          },
          this.defaults = {},
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(o.a)(this),
          this.bounds = {
              foregroundsWrapper: null
          },
          this.coords = {
              scrollYPrev: 0
          },
          this.dataMaps = {
              backgrounds: []
          },
          this.flags = {
              isBackgroundsLocked: !1,
              isIe: !1,
              isMobileOpen: !1,
              isSticky: !1
          },
          this.observers = {
              intersection: new IntersectionObserver(this.events._onObserverUpdate,{
                  rootMargin: "0px",
                  threshold: 0
              })
          },
          this.timeouts = {
              sticky: null
          },
          this.border = null,
          this.progress = new xn(this.el.progress,{
              controller: this
          }),
          this.backgrounds = {
              all: [],
              active: null,
              prev: null
          },
          this.foregrounds = {
              all: [],
              active: null,
              prev: null,
              top: null,
              bottom: null
          },
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.configAnimationData(),
              this.configBackgrounds(),
              this.configForegrounds(),
              this.addEventListeners()
          }
      }, {
          key: "configAnimationData",
          value: function() {
              var e = this;
              this.el.backgrounds.forEach(function(t, i) {
                  var n = {}
                    , r = t.getAttribute("data-animation-origin");
                  r && (n.transformOrigin = r);
                  var o = t.getAttribute("data-animation-start");
                  if (o) {
                      var s = o.split(",");
                      n.start = {};
                      for (var a = 0; a < s.length; a++) {
                          var l = s[a].trim().split(":");
                          l.length > 1 && (n.start[l[0]] = parseFloat(l[1]))
                      }
                  }
                  var c = t.getAttribute("data-animation-end");
                  if (c) {
                      var u = c.split(",");
                      n.end = {};
                      for (var h = 0; h < u.length; h++) {
                          var d = u[h].trim().split(":");
                          d.length > 1 && (n.end[d[0]] = parseFloat(d[1]))
                      }
                  }
                  e.dataMaps.backgrounds[i] = n
              })
          }
      }, {
          key: "configBackgrounds",
          value: function() {
              for (var e = 0; e < this.el.backgrounds.length; e++) {
                  var t = this.el.backgrounds[e]
                    , i = new un(t,{
                      animationData: this.dataMaps.backgrounds[e],
                      index: e,
                      foregrounds: this.foregrounds
                  });
                  this.backgrounds.all.push(i)
              }
              this.el.backgroundsWithContent = [];
              for (var n = 0; n < this.el.backgrounds.length; n++) {
                  var r = this.el.backgrounds[n];
                  "false" !== r.getAttribute("data-has-background") && this.el.backgroundsWithContent.push(r)
              }
          }
      }, {
          key: "configForegrounds",
          value: function() {
              for (var e = 0; e < this.el.foregrounds.length; e++) {
                  var t = this.el.foregrounds[e]
                    , i = new _n(t,{
                      index: e,
                      backgrounds: this.backgrounds
                  });
                  this.foregrounds.all.push(i)
              }
              this.border = new pn(this.el.border,{
                  foregrounds: {
                      top: this.foregrounds.all[0],
                      bottom: this.foregrounds.all[this.foregrounds.all.length - 1]
                  }
              })
          }
      }, {
          key: "addEventListeners",
          value: function() {
              var e = this;
              window.addEventListener("resize", this.events._onWindowResize),
              this.el.skip && this.el.skip.addEventListener("click", this.events._onSkipClick),
              this.el.foregrounds.forEach(function(t) {
                  e.observers.intersection.observe(t)
              }),
              S.a.on(this.events._onRafTick),
              this.checkWindowSize(),
              this.checkScroll()
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              var e = this;
              window.removeEventListener("resize", this.events._onWindowResize),
              this.el.skip && this.el.skip.addEventListener("click", this.events._onSkipClick),
              this.el.foregrounds.forEach(function(t) {
                  e.observers.intersection.unobserve(t)
              }),
              S.a.off(this.events._onRafTick)
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.checkWindowSize()
          }
      }, {
          key: "_onSkipClick",
          value: function() {
              var e = Object(o.g)(this.el.section).scrollBottom - 100;
              window.scrollTo({
                  top: e,
                  behavior: "smooth"
              })
          }
      }, {
          key: "_onRafTick",
          value: function() {
              this.foregrounds.active && this.foregrounds.active.tick(),
              this.foregrounds.prev && this.foregrounds.prev.tick(),
              this.foregrounds.top && this.foregrounds.top.tick(),
              this.foregrounds.bottom && this.foregrounds.bottom.tick(),
              this.backgrounds.active && this.backgrounds.active.tick(),
              this.backgrounds.prev && this.backgrounds.prev.tick(),
              this.checkScroll()
          }
      }, {
          key: "_onObserverUpdate",
          value: function(e) {
              for (var t = -1, i = !1, n = !1, r = null, s = 0; s < e.length; s++) {
                  var a = e[s];
                  a.isIntersecting && (this.foregrounds.prev = this.foregrounds.active,
                  this.foregrounds.active = this.getForegroundByElement(a.target),
                  t = this.foregrounds.active.index,
                  r = a,
                  i = !0,
                  n = !0)
              }
              if (n || (this.foregrounds.prev = this.foregrounds.active,
              this.foregrounds.active = null),
              i && t >= 0) {
                  for (var l = this.el.backgrounds[t]; "false" === l.getAttribute("data-has-background") && t >= 0; ) {
                      if (!(--t >= 0)) {
                          l = kn(this.el.backgroundsWithContent, 1)[0],
                          t = Object(o.f)(l, this.el.backgrounds);
                          break
                      }
                      l = this.el.backgrounds[t]
                  }
                  var c = this.el.backgroundsWithContent.indexOf(l);
                  0 === r.intersectionRect.top ? c < this.el.backgroundsWithContent.length - 1 ? (this.backgrounds.prev = this.getBackgroundByElement(this.el.backgroundsWithContent[c + 1]),
                  this.backgrounds.prev.setPrev()) : this.backgrounds.prev = null : c > 0 ? (this.backgrounds.prev = this.getBackgroundByElement(this.el.backgroundsWithContent[c - 1]),
                  this.backgrounds.prev.setPrev()) : this.backgrounds.prev = null,
                  this.backgrounds.active = this.getBackgroundByElement(l),
                  this.backgrounds.active.setActive();
                  for (var u = 0; u < this.backgrounds.length; u++) {
                      var h = this.backgrounds.all[u];
                      h !== this.backgrounds.active && h !== this.backgrounds.prev && h.setInactive()
                  }
                  var d = Object(o.f)(this.el.backgroundsWithContent[c])
                    , p = c < this.el.backgroundsWithContent.length - 1 ? c + 1 : c
                    , f = Object(o.f)(this.el.backgroundsWithContent[p], this.el.backgrounds)
                    , m = d >= this.backgrounds.all.length - 1 ? d : f - 1;
                  1 === this.el.backgroundsWithContent.length ? (d = 0,
                  m = this.foregrounds.all.length - 1) : d >= m && (d = Math.max(0, m - 1)),
                  this.foregrounds.top = this.foregrounds.all[d],
                  this.foregrounds.bottom = this.foregrounds.all[m],
                  this.foregrounds.active.setActive(),
                  this.foregrounds.top.setTop(),
                  this.foregrounds.bottom.setBottom(),
                  this.foregrounds.prev && this.foregrounds.prev.setPrev(),
                  this.backgrounds.active.setBoundaryForegrounds(this.foregrounds.top, this.foregrounds.bottom),
                  this.checkScroll()
              }
          }
      }, {
          key: "checkWindowSize",
          value: function() {
              this.checkScroll()
          }
      }, {
          key: "checkScroll",
          value: function() {
              var e = window.scrollY
                , t = j.coords.window.height;
              if (this.bounds.foregroundsWrapper = Object(o.g)(this.el.foregroundsWrapper),
              !!(this.bounds.foregroundsWrapper.scrollTop < e + t && this.bounds.foregroundsWrapper.scrollBottom > e)) {
                  var i = e >= this.bounds.foregroundsWrapper.scrollTop
                    , n = e <= this.bounds.foregroundsWrapper.scrollBottom - t;
                  i && n ? (this.el.section.classList.add("is-background-locked"),
                  this.lockBackgrounds()) : this.el.section.classList.remove("is-background-locked"),
                  i ? n || this.unlockBackgrounds(!0) : this.unlockBackgrounds(!1);
                  for (var r = 0; r < this.foregrounds.all.length; r++) {
                      this.foregrounds.all[r].updateBounds()
                  }
                  for (var s = 0; s < this.backgrounds.all.length; s++) {
                      this.backgrounds.all[s].updateBounds()
                  }
                  for (var a = [], l = 0; l < this.foregrounds.all.length; l++) {
                      var c = this.foregrounds.all[l];
                      a.push(c.getScrollProperties(e, this.coords.scrollYPrev))
                  }
                  for (var u = 0, h = 0; h < a.length; h++) {
                      a[h].opacity > 0 && (u = h)
                  }
                  for (var d = Math.pow(1 - a[u].opacity, 2), p = 0; p < this.foregrounds.all.length; p++) {
                      var f = this.foregrounds.all[p];
                      p < u ? f.updateScrollProperties({
                          opacity: a[p].opacity * d
                      }) : f.updateScrollProperties(a[p])
                  }
                  for (var m = 0; m < this.backgrounds.all.length; m++) {
                      this.backgrounds.all[m].checkScroll(e, this.coords.scrollYPrev)
                  }
                  this.border && this.border.checkScroll(e, this.coords.scrollYPrev),
                  this.progress && this.progress.checkScroll(e, this.coords.scrollYPrev)
              }
              this.coords.scrollYPrev = e
          }
      }, {
          key: "lockBackgrounds",
          value: function() {
              this.flags.isIe && !this.flags.isBackgroundsLocked && (u.b.lawg("internet explorer: lock backgrounds"),
              this.flags.isBackgroundsLocked = !0,
              this.el.backgroundsWrapper.classList.add("is-fixed"),
              this.el.backgroundsWrapper.classList.remove("is-bottom"),
              this.el.backgroundsWrapper.style.position = "fixed")
          }
      }, {
          key: "unlockBackgrounds",
          value: function() {
              var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              this.flags.isIe && this.flags.isBackgroundsLocked && (u.b.lawg("internet explorer: unlock backgrounds"),
              this.flags.isBackgroundsLocked = !1,
              this.el.backgroundsWrapper.classList.remove("is-fixed"),
              this.el.backgroundsWrapper.style.position = "",
              e ? this.el.backgroundsWrapper.classList.add("is-bottom") : this.el.backgroundsWrapper.classList.remove("is-bottom"))
          }
      }, {
          key: "getForegroundByElement",
          value: function(e) {
              for (var t = 0; t < this.foregrounds.all.length; t++) {
                  var i = this.foregrounds.all[t];
                  if (i.section === e)
                      return i
              }
          }
      }, {
          key: "getBackgroundByElement",
          value: function(e) {
              for (var t = 0; t < this.backgrounds.all.length; t++) {
                  var i = this.backgrounds.all[t];
                  if (i.section === e)
                      return i
              }
          }
      }, {
          key: "destroy",
          value: function() {
              for (var e = 0; e < this.backgrounds.length; e++)
                  this.backgrounds[e].destroy();
              for (var t = 0; t < this.foregrounds.length; t++)
                  this.foregrounds[t].destroy();
              this.border && this.border.destroy(),
              this.progress && this.progress.destroy(),
              this.removeEventListeners()
          }
      }]) && Sn(t.prototype, i),
      n && Sn(t, n),
      e
  }();
  function Cn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var Ln = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.defaults = {},
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.addEventListeners()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("menuExpand", this.events._onMenuExpand),
              window.addEventListener("menuCollapse", this.events._onMenuCollapse)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("menuExpand", this.events._onMenuExpand),
              window.removeEventListener("menuCollapse", this.events._onMenuCollapse)
          }
      }, {
          key: "_onMenuExpand",
          value: function() {
              this.hide()
          }
      }, {
          key: "_onMenuCollapse",
          value: function() {
              this.show()
          }
      }, {
          key: "show",
          value: function() {
              this.el.section.classList.add("active")
          }
      }, {
          key: "hide",
          value: function() {
              this.el.section.classList.remove("active")
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Cn(t.prototype, i),
      n && Cn(t, n),
      e
  }();
  function An(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(163);
  var Pn = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && An(t.prototype, i),
      n && An(t, n),
      e
  }();
  function In(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(164);
  var Mn = "styleguide-cards"
    , On = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              cardTitles: t.querySelectorAll(".".concat(Mn, " [data-card-paw] .card__title"))
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "getCardTitleMaxHeight",
          value: function() {
              for (var e = 0, t = 0; t < this.el.cardTitles.length; t++)
                  this.el.cardTitles[t].style.height = "auto",
                  this.el.cardTitles[t].clientHeight > e && (e = this.el.cardTitles[t].clientHeight);
              return e
          }
      }, {
          key: "matchCardTitleHeights",
          value: function() {
              for (var e = this.getCardTitleMaxHeight(), t = 0; t < this.el.cardTitles.length; t++)
                  this.el.cardTitles[t].style.height = "".concat(e, "px")
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && In(t.prototype, i),
      n && In(t, n),
      e
  }();
  function zn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(165);
  var Dn = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && zn(t.prototype, i),
      n && zn(t, n),
      e
  }();
  function Rn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(166);
  var Bn = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Rn(t.prototype, i),
      n && Rn(t, n),
      e
  }();
  function jn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(167);
  var Fn = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && jn(t.prototype, i),
      n && jn(t, n),
      e
  }();
  function Nn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(168);
  var Un = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Nn(t.prototype, i),
      n && Nn(t, n),
      e
  }();
  function qn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(169);
  var Hn = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && qn(t.prototype, i),
      n && qn(t, n),
      e
  }();
  function Vn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(170);
  var Wn = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Vn(t.prototype, i),
      n && Vn(t, n),
      e
  }();
  function $n(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(171);
  var Gn = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && $n(t.prototype, i),
      n && $n(t, n),
      e
  }();
  function Xn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(172);
  var Zn = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Xn(t.prototype, i),
      n && Xn(t, n),
      e
  }();
  function Yn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(173);
  var Kn = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              configuredSections: t.querySelectorAll(".buy-configuration__section--configured")
          },
          this.events = Object(o.a)(this),
          this.addEventListeners(),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "init",
          value: function() {
              this.el.configuredSections.forEach(function(e) {
                  var t = e.querySelector(".buy-config__cta-buy")
                    , i = e.querySelector(".buy-config__cta-pay");
                  t.classList.add("is-valid"),
                  i.classList.add("is-visible")
              })
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Yn(t.prototype, i),
      n && Yn(t, n),
      e
  }();
  function Jn(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(174);
  var Qn = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Jn(t.prototype, i),
      n && Jn(t, n),
      e
  }();
  function er(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(175);
  var tr = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && er(t.prototype, i),
      n && er(t, n),
      e
  }();
  function ir(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(176);
  var nr = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && ir(t.prototype, i),
      n && ir(t, n),
      e
  }()
    , rr = i(51)
    , or = i.n(rr);
  function sr(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var ar = i(185)
    , lr = i(195)
    , cr = "mapbox-sandbox"
    , ur = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              listing: t.querySelector(".".concat(cr, "__sidebar-listing"))
          },
          this.accessToken = "pk.eyJ1IjoiYmFzaWNkZXYiLCJhIjoiY2p0a2UxMTdxMGdkbTQzbGx2OTg4cWtvdyJ9.aV7X9lwaUhLw9s5svm2y0w",
          this.map = null,
          this.client = null,
          this.geocode = null,
          this.locations = [{
              id: "",
              center: "",
              address: "18201 NE Portal Way, Suite 101 Portland, OR"
          }, {
              id: "",
              center: "",
              address: "6545 East Pacific Coast Hwy Long Beach, CA United States"
          }, {
              id: "",
              center: "",
              address: "2514 82nd St Lubbock, TX United States"
          }, {
              id: "",
              center: "",
              address: "462 Lane Drive Florence, AL United States"
          }, {
              id: "",
              center: "",
              address: "7818 Palace Drive Cincinnati, OH United States"
          }, {
              id: "",
              center: "",
              address: "1546 Carter St Mount Airy, NC United States"
          }, {
              id: "",
              center: "",
              address: "295 Blue Ball Rd Elkton, MD United States"
          }, {
              id: "",
              center: "",
              address: "509 Glenbrook Rd Stamford, CT United States"
          }, {
              id: "",
              center: "",
              address: "19 British American Blvd Latham, NY United States"
          }, {
              id: "",
              center: "",
              address: "46 Stafford St Lawrence, MA United States"
          }, {
              id: "",
              center: "",
              address: "Plot No. 4, IGC Kheda Pithampur Industrial Area District Dhar, Madhya Pradesh India"
          }, {
              id: "",
              center: "",
              address: "4 Chome-3-11 Minami-Senba Chuo-ku, Osaka Japan"
          }],
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.client = ar({
                  accessToken: this.accessToken
              }),
              this.geocode = lr(this.client),
              or.a.accessToken = this.accessToken,
              this.map = new or.a.Map({
                  container: "mapbox-canvas",
                  style: "mapbox://styles/mapbox/streets-v9",
                  center: [5, 30],
                  zoom: 1.5,
                  scrollZoom: !1
              }),
              this.map && this.addLocationMarkers(this.locations).then(this.populateListing(this.locations))
          }
      }, {
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "addLocationMarkers",
          value: function(e) {
              var t = this;
              return new Promise(function(i) {
                  var n = 0
                    , r = e.length;
                  e.forEach(function(e) {
                      t.geocode.forwardGeocode({
                          query: e.address,
                          autocomplete: !1,
                          limit: 1
                      }).send().then(function(i) {
                          if (i && i.body && i.body.features && i.body.features.length) {
                              var n = i.body.features[0];
                              e.center = n.center,
                              e.id = n.id,
                              (new or.a.Marker).setLngLat(n.center).addTo(t.map)
                          }
                      }),
                      n++ >= r && i()
                  })
              }
              )
          }
      }, {
          key: "populateListing",
          value: function(e) {
              var t = this;
              e.forEach(function(e) {
                  var i = document.createElement("li");
                  i.setAttribute("data-id", e.id),
                  i.innerHTML = e.address,
                  t.el.listing.appendChild(i)
              })
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && sr(t.prototype, i),
      n && sr(t, n),
      e
  }();
  function hr(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var dr = "card-impact"
    , pr = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              svg: t.querySelector(".".concat(dr, "__icons svg")),
              icons: t.querySelectorAll(".".concat(dr, " .impact-icon:not(.impact-icon--focus)")),
              focusIcon: t.querySelector(".".concat(dr, " .impact-icon--focus")),
              blobScene: t.querySelector("[data-blob-scene]"),
              contentSlides: t.querySelectorAll(".".concat(dr, "__content-slide"))
          },
          this.slider = null,
          this.delayTime = null,
          this.transitionTime = null,
          this.bounds = {
              cardTop: null,
              cardWidth: null,
              iconWidth: null,
              iconOffsetLeft: null
          },
          this.blobScene = k.getScene(this.el.blobScene),
          this.events = Object(o.a)(this),
          this.measure(),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              var e = parseInt(getComputedStyle(this.el.section).getPropertyValue("--delay-time").replace(/\D/g, ""))
                , t = parseInt(getComputedStyle(this.el.section).getPropertyValue("--transition-time").replace(/\D/g, ""));
              this.delayTime = e,
              this.transitionTime = t,
              this.setFocusIconPos(),
              this.createSlider(),
              this.addSliderEvents(),
              this.addEventListeners()
          }
      }, {
          key: "measure",
          value: function() {
              this.bounds.cardTop = this.el.section.getBoundingClientRect().top,
              this.bounds.svgWidth = this.el.svg.getBBox().width,
              this.bounds.iconWidth = this.el.focusIcon.getBBox().width,
              this.bounds.iconOffsetLeft = this.el.focusIcon.getBBox().x
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("resize", this.events._onResize),
              Object(o.j)("large") ? (this.el.section.addEventListener("mouseenter", this.events._onMouseEnter),
              this.el.section.addEventListener("mouseleave", this.events._onMouseLeave)) : window.addEventListener("scroll", this.events._onScroll)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("resize", this.events._onResize),
              this.el.section.removeEventListener("mouseenter", this.events._onMouseEnter),
              this.el.section.removeEventListener("mouseleave", this.events._onMouseLeave)
          }
      }, {
          key: "_onResize",
          value: function() {
              this.measure(),
              this.setFocusIconPos()
          }
      }, {
          key: "_onScroll",
          value: function() {
              this.scrollAutoplay()
          }
      }, {
          key: "_onMouseEnter",
          value: function() {
              this.startSlider()
          }
      }, {
          key: "_onMouseLeave",
          value: function() {
              this.stopSlider()
          }
      }, {
          key: "createSlider",
          value: function() {
              var e = "swiper-".concat(++j.counters.instances);
              this.el.section.querySelector(".swiper-container").setAttribute("id", e);
              var t = {
                  autoplay: {
                      delay: this.delayTime,
                      disableOnInteraction: !1
                  },
                  speed: this.transitionTime,
                  direction: "horizontal",
                  slidesPerView: "auto",
                  spaceBetween: 0,
                  loop: !1,
                  effect: "fade",
                  allowTouchMove: !1,
                  preventInteractionOnTransition: !0,
                  pagination: {
                      el: ".swiper-pagination",
                      type: "bullets",
                      clickable: !0,
                      renderBullet: function(e, t) {
                          return '<li class="'.concat(t, '" data-bullet-index="').concat(e, '">\n\t\t\t\t\t\t\t\t<div class="swiper-pagination-bullet-progress-wrapper">\n\t\t\t\t\t\t\t\t\t<span class="swiper-pagination-bullet-progress"></span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</li>')
                      }
                  },
                  breakpoints: {
                      991: {
                          allowTouchMove: !0
                      }
                  }
              };
              this.slider = new lt("#".concat(e),t),
              this.slider.autoplay.stop()
          }
      }, {
          key: "addSliderEvents",
          value: function() {
              var e = this;
              this.slider && (this.slider.on("slideChange", function() {
                  switch (e.el.section.querySelector(".".concat(dr, "__content-slide.is-active")).classList.remove("is-active"),
                  e.el.contentSlides[e.slider.realIndex].classList.add("is-active"),
                  e.slider.realIndex) {
                  case 2:
                      e.slider.autoplay.running || (e.slider.allowSlideNext = !1,
                      e.slider.allowSlidePrev = !0),
                      e.el.section.classList.remove("is-focus-icon"),
                      e.el.section.classList.add("is-all-icons"),
                      e.el.focusIcon.style.transform = "none";
                      break;
                  case 1:
                      e.slider.allowSlideNext = !0,
                      e.slider.allowSlidePrev = !0,
                      e.setFocusIconPos(),
                      e.el.section.classList.remove("is-all-icons"),
                      e.el.section.classList.add("is-focus-icon");
                      break;
                  case 0:
                      e.slider.autoplay.running || (e.slider.allowSlidePrev = !1,
                      e.slider.allowSlideNext = !0),
                      e.setFocusIconPos(),
                      e.el.section.classList.remove("is-all-icons"),
                      e.el.section.classList.remove("is-focus-icon")
                  }
              }),
              Object(o.j)("large") || (this.slider.on("touchStart", function() {
                  e.stopSlider(),
                  e.el.section.classList.contains("is-playing") || e.el.section.classList.add("is-playing"),
                  2 === e.slider.realIndex ? e.slider.allowSlideNext = !1 : 0 === e.slider.realIndex ? e.slider.allowSlidePrev = !1 : (e.slider.allowSlideNext = !0,
                  e.slider.allowSlidePrev = !0)
              }),
              this.slider.on("touchEnd", function() {
                  e.startSlider()
              })))
          }
      }, {
          key: "startSlider",
          value: function() {
              this.slider.autoplay.start(),
              this.el.section.classList.add("is-playing")
          }
      }, {
          key: "stopSlider",
          value: function() {
              this.slider.autoplay.stop(),
              this.el.section.classList.remove("is-playing")
          }
      }, {
          key: "scrollAutoplay",
          value: function() {
              window.scrollY > this.bounds.cardTop ? this.startSlider() : this.stopSlider()
          }
      }, {
          key: "setFocusIconPos",
          value: function() {
              var e = (this.bounds.svgWidth - this.bounds.iconWidth) / 2 - this.bounds.iconOffsetLeft;
              this.el.focusIcon.style.transform = "scale(".concat(1.4, ") translate(").concat(e, "px, 8%)")
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && hr(t.prototype, i),
      n && hr(t, n),
      e
  }();
  function fr(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var mr = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.slider = null,
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.createSlider()
          }
      }, {
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "createSlider",
          value: function() {
              var e = "swiper-".concat(++j.counters.instances);
              this.el.section.querySelector(".swiper-container").setAttribute("id", e);
              var t = {
                  direction: "horizontal",
                  slidesPerView: "auto",
                  spaceBetween: 20,
                  loop: !1,
                  allowTouchMove: !1,
                  preventInteractionOnTransition: !0,
                  navigation: {
                      nextEl: ".".concat("slider-progress-tile", " .swiper-button-next"),
                      prevEl: ".".concat("slider-progress-tile", " .swiper-button-prev")
                  },
                  breakpoints: {
                      991: {
                          allowTouchMove: !0,
                          freeMode: !0
                      }
                  }
              };
              this.slider = new lt("#".concat(e),t)
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && fr(t.prototype, i),
      n && fr(t, n),
      e
  }();
  function gr(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var vr = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t
          },
          this.slider = null,
          this.events = Object(o.a)(this),
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              this.createSlider()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("resize", this.events._onResize)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("resize", this.events._onResize)
          }
      }, {
          key: "_onResize",
          value: function() {}
      }, {
          key: "createSlider",
          value: function() {
              var e = "swiper-".concat(++j.counters.instances);
              this.el.section.querySelector(".swiper-container").setAttribute("id", e);
              var t = {
                  direction: "horizontal",
                  slidesPerView: 1,
                  spaceBetween: 0,
                  loop: !0,
                  allowTouchMove: !0,
                  preventInteractionOnTransition: !0,
                  effect: "fade",
                  speed: 600,
                  navigation: {
                      nextEl: ".".concat("slider-social-proof", " .swiper-button-next"),
                      prevEl: ".".concat("slider-social-proof", " .swiper-button-prev")
                  }
              };
              this.slider = new lt("#".concat(e),t)
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && gr(t.prototype, i),
      n && gr(t, n),
      e
  }();
  function yr(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  i(177);
  var _r = "modal-fpc"
    , br = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              body: document.querySelector("body"),
              modal: null,
              modalBody: t.querySelector(".".concat(_r, " .modal-body")),
              modalTriggers: document.querySelectorAll('[data-modal-trigger="'.concat(_r, '"]')),
              modalClose: document.querySelector(".".concat(_r, " [data-modal-close]"))
          },
          this.flags = {
              isModalShown: !1
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "addEventListeners",
          value: function() {
              Object(o.k)(this.el.modalTriggers, "click", this.events._onModalTriggerClick),
              this.el.modalClose.addEventListener("click", this.events._onModalCloseClick)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              Object(o.m)(this.el.modalTriggers, "click", this.events._onModalTriggerClick),
              this.el.modalClose.removeEventListener("click", this.events._onModalCloseClick)
          }
      }, {
          key: "_onModalTriggerClick",
          value: function() {
              this.showModal()
          }
      }, {
          key: "_onModalCloseClick",
          value: function() {
              this.hideModal()
          }
      }, {
          key: "_onModalScroll",
          value: function() {}
      }, {
          key: "getModal",
          value: function() {
              var e = this.el.modalTriggers[0].getAttribute("data-modal-trigger");
              this.el.modal = document.querySelector("#".concat(e))
          }
      }, {
          key: "showModal",
          value: function() {
              if (!this.flags.isModalShown) {
                  this.getModal();
                  var e = this.el.modal
                    , t = this.el.modalBody
                    , i = this.el.body;
                  e.style = "",
                  i.classList.add("is-modal-open"),
                  e.classList.add("is-open"),
                  setTimeout(function() {
                      return t.classList.add("is-open")
                  }, 100),
                  setTimeout(function() {
                      return t.classList.add("is-open-complete")
                  }, 400),
                  this.flags.isModalShown = !0,
                  k.resize(),
                  this.el.modal.addEventListener("scroll", this.events._onModalScroll, {
                      passive: !0
                  })
              }
          }
      }, {
          key: "hideModal",
          value: function() {
              if (this.flags.isModalShown) {
                  var e = this.el.modal
                    , t = this.el.modalBody
                    , i = this.el.body;
                  e.style.opacity = 0,
                  setTimeout(function() {
                      i.classList.remove("is-modal-open"),
                      e.classList.remove("is-open"),
                      t.classList.remove("is-open"),
                      t.classList.remove("is-open-complete")
                  }, 300),
                  this.flags.isModalShown = !1
              }
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && yr(t.prototype, i),
      n && yr(t, n),
      e
  }();
  function wr(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var xr = "navigation-fpc"
    , kr = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              top: t.previousElementSibling,
              dropdown: t.querySelector(".".concat(xr, "__dropdown")),
              dropdownToggle: t.querySelector(".".concat(xr, "__dropdown-toggle")),
              dropdownLinks: t.querySelectorAll(".".concat(xr, "__dropdown .nav-link"))
          },
          this.topHeight = null,
          this.subnav = {
              el: null,
              offsetTop: null
          },
          this.stLast = 0,
          this.events = Object(o.a)(this),
          this.init(),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              "false" === this.el.section.getAttribute("data-sub-nav") ? this.topHeight = this.getBoundsSiblingHeight(this.el.top) : (this.subnav.el = document.querySelector('[class^="navigation-subnav-"]'),
              this.subnav.offsetTop = this.getBounds("offsetTop", this.subnav.el))
          }
      }, {
          key: "addEventListeners",
          value: function() {
              "false" === this.el.section.getAttribute("data-sub-nav") ? (window.addEventListener("scroll", this.events._onWithoutAnchorScroll),
              window.addEventListener("resize", this.events._onWithoutAnchorResize)) : window.addEventListener("scroll", this.events._onWithAnchorScroll),
              this.el.dropdownToggle && this.el.dropdown && (this.el.dropdownToggle.addEventListener("click", this.events._onDropdownToggleClick),
              Object(o.k)(this.el.dropdownLinks, "click", this.events._onDropdownLinkClick))
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("scroll", this.events._onWithoutAnchorScroll),
              window.removeEventListener("resize", this.events._onWithoutAnchorResize),
              window.removeEventListener("scroll", this.events._onWithAnchorScroll),
              Object(o.m)(this.el.dropdownLinks, "click", this.events._onDropdownLinkClick)
          }
      }, {
          key: "_onWithoutAnchorScroll",
          value: function() {
              this.toggleNavAfterTop()
          }
      }, {
          key: "_onWithoutAnchorResize",
          value: function() {
              this.topHeight = this.getBoundsSiblingHeight(this.el.top)
          }
      }, {
          key: "_onWithAnchorScroll",
          value: function() {
              this.toggleNavAfterAnchor()
          }
      }, {
          key: "_onDropdownToggleClick",
          value: function() {
              this.toggleDropdown()
          }
      }, {
          key: "_onDropdownLinkClick",
          value: function(e) {
              this.setActiveDropdown(e)
          }
      }, {
          key: "toggleNavAfterTop",
          value: function() {
              window.scrollY > this.topHeight - this.topHeight / 4 ? this.el.section.classList.add("is-shown") : this.el.section.classList.remove("is-shown")
          }
      }, {
          key: "toggleNavAfterAnchor",
          value: function() {
              if (window.scrollY > this.subnav.offsetTop) {
                  var e = window.pageYOffset || document.documentElement.scrollTop;
                  e > this.stLast ? (this.subnav.el.classList.remove("is-hidden"),
                  this.el.section.classList.remove("is-shown"),
                  this.subnav.el.classList.add("is-shown")) : (this.subnav.el.classList.remove("is-shown"),
                  this.subnav.el.classList.add("is-hidden"),
                  this.el.section.classList.add("is-shown")),
                  this.stLast = e <= 0 ? 0 : e
              } else
                  this.subnav.el.classList.remove("is-hidden"),
                  this.subnav.el.classList.remove("is-shown"),
                  this.el.section.classList.remove("is-shown")
          }
      }, {
          key: "toggleDropdown",
          value: function() {
              this.el.dropdown.classList.contains("is-shown") ? this.el.dropdown.classList.remove("is-shown") : this.el.dropdown.classList.add("is-shown")
          }
      }, {
          key: "setActiveDropdown",
          value: function(e) {
              var t = this.getBounds("offsetTop", document.querySelector(".navigation-subnav-tabs-content"))
                , i = e.currentTarget.querySelector("span").innerHTML;
              this.el.section.querySelector(".".concat(xr, "__dropdown-toggle-current")).innerHTML = i,
              window.scrollTo({
                  top: t - 164
              }),
              this.el.dropdown.classList.contains("is-shown") ? this.el.dropdown.classList.remove("is-shown") : this.el.dropdown.classList.add("is-shown")
          }
      }, {
          key: "getBounds",
          value: function(e, t) {
              var i = 0
                , n = t;
              do {
                  isNaN(n[e]) || (i += n[e]),
                  n = n.offsetParent
              } while (n);return i
          }
      }, {
          key: "getBoundsSiblingHeight",
          value: function(e) {
              var t = 0
                , i = e;
              do {
                  isNaN(i.offsetHeight) || 0 === i.offsetHeight || i.classList.contains("navigation-primary") || (t += i.offsetHeight),
                  i = i.previousElementSibling
              } while (i);return t
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && wr(t.prototype, i),
      n && wr(t, n),
      e
  }();
  function Sr(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var Er = "navigation-subnav-tabs"
    , Tr = function() {
      function e(t, i) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              container: t.closest("[data-navigation-subnav-container]"),
              activeLine: t.querySelector(".".concat(Er, "__active-line")),
              bottomLine: t.querySelector(".".concat(Er, "__bottom-line")),
              links: t.querySelector(".".concat(Er, " .nav")),
              navItems: t.querySelectorAll(".".concat(Er, " .nav-item")),
              navItemLinks: t.querySelectorAll(".".concat(Er, " .nav-item a")),
              heading: t.querySelector(".".concat(Er, "__heading")),
              wrapper: t.querySelector(".".concat(Er, "__links-wrapper")),
              fpcBtn: t.querySelector(".".concat(Er, "__fpc-btn")),
              navFpc: document.querySelector(".navigation-fpc")
          },
          this.defaults = {
              anchorScrollGutter: 81,
              lineScrollAmount: 140,
              uiShowRatio: .75
          },
          this.options = Object.assign({}, this.defaults, i),
          this.events = Object(o.a)(this),
          this.coords = {
              container: null,
              lineRatioLast: 0
          },
          this.debounced = {
              resize: o.i.debounce(this.checkResize.bind(this), 250, {
                  leading: !1,
                  trailing: !0
              })
          },
          this.flags = {
              hasContainer: null !== this.el.container
          },
          this.states = {
              activeMenuItemIndex: 0
          },
          this.init()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function() {
              if (!Object(o.j)("medium")) {
                  var e = 2 * (window.innerWidth / 4) + this.el.navItems[0].offsetWidth * this.el.navItems.length;
                  this.el.bottomLine.style.width = "".concat(e, "px")
              }
              this.activateMenuItem(this.el.navItemLinks[0], !0),
              this.addEventListeners()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("resize", this.events._onResize),
              window.addEventListener("scroll", this.events._onScroll, {
                  passive: !0
              }),
              Object(o.k)(this.el.navItemLinks, "click", this.events._onNavItemClick),
              this.checkResize()
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("resize", this.events._onResize),
              window.removeEventListener("scroll", this.events._onScroll),
              Object(o.m)(this.el.navItemLinks, "click", this.events._onNavItemClick)
          }
      }, {
          key: "_onResize",
          value: function() {
              this.checkResize()
          }
      }, {
          key: "_onScroll",
          value: function() {
              this.checkScroll()
          }
      }, {
          key: "_onNavItemClick",
          value: function(e) {
              var t = e.currentTarget;
              if (this.activateMenuItem(t),
              !Object(o.j)("medium")) {
                  var i = t.getBoundingClientRect()
                    , n = this.el.wrapper.scrollLeft;
                  this.el.wrapper.scrollTo({
                      top: 0,
                      left: i.left - t.offsetWidth / 2 + n,
                      behavior: "smooth"
                  })
              }
          }
      }, {
          key: "activateMenuItem",
          value: function(e) {
              if (!e.classList.contains("is-active")) {
                  this.flags.hasContainer && (this.coords.container = Object(o.g)(this.el.container));
                  var t = j.coords.window.width
                    , i = this.el.links.offsetWidth
                    , n = e.getBoundingClientRect()
                    , r = n.left - (t - i) / 2
                    , s = n.width / 100;
                  if (this.states.activeMenuItemIndex = Object(o.f)(e.closest("li")),
                  Object(o.l)(this.el.navItemLinks, "remove", "is-active"),
                  e.classList.add("is-active"),
                  this.el.section.classList.add("is-link-active"),
                  this.el.section.classList.contains("is-sticky") && (window.scrollTo({
                      top: this.coords.container.scrollTop + 1
                  }),
                  this.el.navFpc && this.el.navFpc.classList.remove("is-shown")),
                  Object(o.j)("medium"))
                      this.el.activeLine.style.transform = "translateX(".concat(r, "px) scaleX(").concat(s, ")");
                  else {
                      var a = this.el.wrapper.scrollLeft;
                      this.el.activeLine.style.transform = "translateX(".concat(r + a, "px) scaleX(").concat(s, ")")
                  }
              }
          }
      }, {
          key: "checkResize",
          value: function() {
              var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
              this.flags.hasContainer && (this.coords.container = Object(o.g)(this.el.container)),
              e && this.checkScroll();
              var t = this.el.section.querySelector(".".concat(Er, " .nav-link.is-active"))
                , i = j.coords.window.width
                , n = this.el.links.offsetWidth
                , r = t.getBoundingClientRect()
                , s = r.left - (i - n) / 2
                , a = r.width / 100;
              if (Object(o.j)("medium"))
                  this.el.activeLine.style.transform = "translateX(".concat(s, "px) scaleX(").concat(a, ")");
              else {
                  var l = this.el.wrapper.scrollLeft;
                  this.el.activeLine.style.transform = "translateX(".concat(s + l, "px) scaleX(").concat(a, ")"),
                  this.el.wrapper.scrollTo({
                      top: 0,
                      left: r.left - t.offsetWidth / 2 + l,
                      behavior: "smooth"
                  })
              }
              this.checkLineWidth()
          }
      }, {
          key: "checkScroll",
          value: function() {
              var e = window.scrollY;
              this.flags.hasContainer && e >= this.coords.container.scrollTop ? (this.el.section.classList.add("is-sticky"),
              this.el.fpcBtn && this.el.fpcBtn.classList.add("is-shown")) : (this.el.section.classList.remove("is-sticky"),
              this.el.fpcBtn && this.el.fpcBtn.classList.remove("is-shown")),
              this.checkLineWidth()
          }
      }, {
          key: "checkLineWidth",
          value: function() {
              var e = window.scrollY
                , t = j.coords.window.width;
              if (this.el.section.classList.contains("is-sticky")) {
                  var i = this.el.links.offsetWidth
                    , n = e - this.coords.container.scrollTop
                    , r = t / i
                    , o = Math.min(r, (r - 1) * (n / this.options.lineScrollAmount) + 1)
                    , s = Math.min(1, o / r);
                  this.coords.lineRatioLast !== o && (this.coords.lineRatioLast = o,
                  this.el.bottomLine.style.transform = "scaleX(".concat(o, ")"),
                  s >= this.options.uiShowRatio ? this.el.section.classList.add("is-ui-showing") : this.el.section.classList.remove("is-ui-showing"))
              } else
                  this.el.bottomLine.style.transform = "",
                  this.el.section.classList.remove("is-ui-showing"),
                  this.coords.lineRatioLast = -1
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Sr(t.prototype, i),
      n && Sr(t, n),
      e
  }();
  function Cr(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var Lr = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              heading: t
          },
          this.events = Object(o.a)(this),
          this.wrapWords(),
          this.applyDelays(),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "wrapWords",
          value: function() {
              var e = this.el.heading.innerText.split(" ");
              this.el.heading.innerHTML = "<span>".concat(e.join("</span> <span>"), "</span>")
          }
      }, {
          key: "applyDelays",
          value: function() {
              var e = null
                , t = null
                , i = this.el.heading.querySelectorAll("span")
                , n = !0
                , r = !1
                , o = void 0;
              try {
                  for (var s, a = i[Symbol.iterator](); !(n = (s = a.next()).done); n = !0) {
                      var l = s.value;
                      l.offsetTop !== e && (e = l.offsetTop,
                      null === t ? t = 0 : t += .25),
                      l.style.transitionDelay = "".concat(t, "s")
                  }
              } catch (e) {
                  r = !0,
                  o = e
              } finally {
                  try {
                      n || null == a.return || a.return()
                  } finally {
                      if (r)
                          throw o
                  }
              }
          }
      }, {
          key: "_onWindowLoad",
          value: function() {
              this.applyDelays()
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.applyDelays()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("resize", this.events._onWindowResize)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("resize", this.events._onWindowResize)
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Cr(t.prototype, i),
      n && Cr(t, n),
      e
  }();
  function Ar(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var Pr = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              path: t.querySelector("path")
          },
          this.offset = 0,
          this.height = 0,
          this.pathLength = 0,
          this.progress = 0,
          this.events = Object(o.a)(this),
          this.addEventListeners(),
          this.measure()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "measure",
          value: function() {
              var e = this.el.section.getBoundingClientRect();
              this.offset = window.scrollY + e.top,
              this.height = e.height,
              this.pathLength = this.el.path.getTotalLength()
          }
      }, {
          key: "renderStrokeOffset",
          value: function() {
              this.el.path.style.strokeDasharray = this.pathLength;
              var e = this.pathLength;
              this.progress > 0 && (e = this.progress < 1 ? this.pathLength - this.pathLength * this.progress : 0),
              this.el.path.style.strokeDashoffset = e
          }
      }, {
          key: "_onWindowLoad",
          value: function() {
              this.measure(),
              this.renderStrokeOffset()
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.measure(),
              this.renderStrokeOffset()
          }
      }, {
          key: "_onWindowScroll",
          value: function() {
              this.progress = (window.scrollY - this.offset) / (this.height - window.innerHeight),
              this.renderStrokeOffset()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("load", this.events._onWindowLoad),
              window.addEventListener("resize", this.events._onWindowResize),
              window.addEventListener("scroll", this.events._onWindowScroll, !0)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("load", this.events._onWindowLoad),
              window.removeEventListener("resize", this.events._onWindowResize),
              window.removeEventListener("scroll", this.events._onWindowScroll, !0)
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Ar(t.prototype, i),
      n && Ar(t, n),
      e
  }();
  function Ir(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var Mr = "scroll-slider"
    , Or = function() {
      function e(t) {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              section: t,
              index: t.querySelector(".".concat(Mr, "__index-current")),
              list: t.querySelector("ul")
          },
          this.offset = 0,
          this.height = 0,
          this.progress = 0,
          this.events = Object(o.a)(this),
          this.addEventListeners(),
          this.measure()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "measure",
          value: function() {
              var e = this.el.section.getBoundingClientRect();
              this.offset = window.scrollY + e.top,
              this.height = e.height
          }
      }, {
          key: "renderTransform",
          value: function() {
              var e = 0;
              this.progress > 0 && (e = this.progress < 1 ? 500 * -this.progress : -500),
              this.el.list.style.transform = "translateX(".concat(e, "vw)")
          }
      }, {
          key: "_onWindowLoad",
          value: function() {
              this.measure(),
              this.renderTransform()
          }
      }, {
          key: "_onWindowResize",
          value: function() {
              this.measure(),
              this.renderTransform()
          }
      }, {
          key: "_onWindowScroll",
          value: function() {
              this.progress = (window.scrollY - this.offset) / (this.height - window.innerHeight),
              this.renderTransform()
          }
      }, {
          key: "addEventListeners",
          value: function() {
              window.addEventListener("load", this.events._onWindowLoad),
              window.addEventListener("resize", this.events._onWindowResize),
              window.addEventListener("scroll", this.events._onWindowScroll, !0)
          }
      }, {
          key: "removeEventListeners",
          value: function() {
              window.removeEventListener("load", this.events._onWindowLoad),
              window.removeEventListener("resize", this.events._onWindowResize),
              window.removeEventListener("scroll", this.events._onWindowScroll, !0)
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && Ir(t.prototype, i),
      n && Ir(t, n),
      e
  }();
  function zr(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var Dr = new (function() {
      function e() {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              target: null
          },
          this.config = {},
          this.flags = {
              isInitialized: !1
          },
          this.moduleClasses = {},
          this.instantiatedModules = [],
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              this.flags.isInitialized || (this.el.target = e,
              this.moduleClasses = {
                  Card: {
                      class: $,
                      selector: "card"
                  },
                  FieldSearch: {
                      class: U,
                      selector: N
                  },
                  StyleguideSubnavAnchored: {
                      class: Ln,
                      selector: "styleguide-subnav-anchored"
                  },
                  Lazy: {
                      class: q.a,
                      selector: q.b
                  },
                  AccordionPdp: {
                      class: Y,
                      selector: "accordion-pdp"
                  },
                  AlertSpecial: {
                      class: J,
                      selector: "alert-special"
                  },
                  AnchorLink: {
                      class: ee,
                      selector: "anchor-link"
                  },
                  CalloutBlurb: {
                      class: ie,
                      selector: "callout-blurb"
                  },
                  DrawerBottom: {
                      class: oe,
                      selector: re
                  },
                  DrawerTop: {
                      class: le,
                      selector: ae
                  },
                  GridImages: {
                      class: ut,
                      selector: "grid-images"
                  },
                  GridProductTilesOverview: {
                      class: pt,
                      selector: dt
                  },
                  GridProductTilesPdpColors: {
                      class: gt,
                      selector: mt
                  },
                  GridProductTilesPlpCarousel: {
                      class: wt,
                      selector: bt
                  },
                  GridProductTilesPlpDefault: {
                      class: St,
                      selector: kt
                  },
                  HeroPDP: {
                      class: Ct,
                      selector: Tt
                  },
                  HeroPdpV2: {
                      class: Mt,
                      selector: It
                  },
                  HeroPLP: {
                      class: Dt,
                      selector: zt
                  },
                  HeroMain: {
                      class: jt,
                      selector: Bt
                  },
                  ModalCompare: {
                      class: Kt,
                      selector: Yt
                  },
                  ModalCart: {
                      class: Xt,
                      selector: Gt
                  },
                  ModalDeadend: {
                      class: Ut,
                      selector: Nt
                  },
                  ModalFit: {
                      class: ei,
                      selector: Qt
                  },
                  ModalGuide: {
                      class: ni,
                      selector: ii
                  },
                  ModalScroll: {
                      class: si,
                      selector: oi
                  },
                  ModalShipping: {
                      class: ci,
                      selector: li
                  },
                  ModalSize: {
                      class: di,
                      selector: hi
                  },
                  ModalVideo: {
                      class: mi,
                      selector: fi
                  },
                  NavigationPrimary: {
                      class: bi,
                      selector: _i
                  },
                  NavigationSubnav: {
                      class: xi,
                      selector: "navigation-subnav"
                  },
                  NavigationSubnavPdp: {
                      class: Ei,
                      selector: Si
                  },
                  PagePDP: {
                      class: Ci,
                      selector: "page-pdp"
                  },
                  PageHome: {
                      class: Ai,
                      selector: "page-home"
                  },
                  SearchOverlay: {
                      class: Fi,
                      selector: ji
                  },
                  SearchResults: {
                      class: Ui,
                      selector: "search-results"
                  },
                  ShoppingTool: {
                      class: Vi,
                      selector: Hi
                  },
                  SkrollexVideo: {
                      class: V,
                      selector: "skrollex-video"
                  },
                  SliderCards: {
                      class: Gi,
                      selector: $i
                  },
                  SliderCollections: {
                      class: Yi,
                      selector: Zi
                  },
                  SliderFeatures: {
                      class: Qi,
                      selector: Ji
                  },
                  SliderGallery: {
                      class: nn,
                      selector: tn
                  },
                  SliderGalleryImage: {
                      class: sn,
                      selector: on
                  },
                  SliderProductTile: {
                      class: ln,
                      selector: "slider-product-tile"
                  },
                  StorytellingScroller: {
                      class: Tn,
                      selector: En
                  },
                  StyleguideButtons: {
                      class: Pn,
                      selector: "styleguide-buttons"
                  },
                  StyleguideCards: {
                      class: On,
                      selector: Mn
                  },
                  StyleguideColor: {
                      class: Dn,
                      selector: "styleguide-color"
                  },
                  StyleguideForms: {
                      class: Bn,
                      selector: "styleguide-forms"
                  },
                  StyleguideHero: {
                      class: Fn,
                      selector: "styleguide-hero"
                  },
                  StyleguideIcons: {
                      class: Un,
                      selector: "styleguide-icons"
                  },
                  StyleguideLogos: {
                      class: Hn,
                      selector: "styleguide-logos"
                  },
                  StyleguideNavigation: {
                      class: Wn,
                      selector: "styleguide-navigation"
                  },
                  StyleguideProductTiles: {
                      class: Gn,
                      selector: "styleguide-product-tiles"
                  },
                  StyleguideProductTilesOverview: {
                      class: Zn,
                      selector: "styleguide-product-tiles-overview"
                  },
                  StyleguideBuyConfig: {
                      class: Kn,
                      selector: "styleguide-buy-config"
                  },
                  StyleguideSearch: {
                      class: Qn,
                      selector: "styleguide-search"
                  },
                  StyleguideShoppingTool: {
                      class: tr,
                      selector: "styleguide-shopping-tool"
                  },
                  StyleguideTypography: {
                      class: nr,
                      selector: "styleguide-typography"
                  },
                  MapboxSandbox: {
                      class: ur,
                      selector: cr
                  },
                  CardImpact: {
                      class: pr,
                      selector: dr
                  },
                  SliderProgressTile: {
                      class: mr,
                      selector: "slider-progress-tile"
                  },
                  SliderSocialProof: {
                      class: vr,
                      selector: "slider-social-proof"
                  },
                  ModalFPC: {
                      class: br,
                      selector: _r
                  },
                  NavigationFpc: {
                      class: kr,
                      selector: xr
                  },
                  NavigationSubnavTabs: {
                      class: Tr,
                      selector: Er
                  },
                  MaskHeading: {
                      class: Lr,
                      selector: "mask-heading"
                  },
                  ScrollGraph: {
                      class: Pr,
                      selector: "scroll-graph"
                  },
                  ScrollSlider: {
                      class: Or,
                      selector: Mr
                  }
              },
              this.config = Object.assign(this.config, t),
              this.flags.isInitialized = !0,
              this.scan())
          }
      }, {
          key: "scan",
          value: function() {
              if (this.flags.isInitialized) {
                  for (var e = [], t = 0; t < this.instantiatedModules.length; t++) {
                      var i = this.instantiatedModules[t];
                      i.target.closest("body") ? e.push(i) : i.instance.destroy()
                  }
                  for (var n in this.instantiatedModules = e,
                  this.moduleClasses) {
                      var r = this.moduleClasses[n]
                        , o = r.class
                        , s = "[data-".concat(r.selector, "]")
                        , a = this.el.target.querySelectorAll(s);
                      if (a.length)
                          for (var l = 0; l < a.length; l++) {
                              var c = a[l];
                              if (!c.getAttribute("data-js-module")) {
                                  var u = new o(c);
                                  this.instantiatedModules.push({
                                      target: c,
                                      instance: u,
                                      selector: s
                                  }),
                                  c.setAttribute("data-js-module", !0)
                              }
                          }
                  }
              }
          }
      }, {
          key: "removeAll",
          value: function() {
              for (var e = 0; e < this.instantiatedModules.length; e++) {
                  this.instantiatedModules[e].instance.destroy()
              }
              this.instantiatedModules = []
          }
      }, {
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "destroy",
          value: function() {
              this.removeAll(),
              this.removeEventListeners()
          }
      }]) && zr(t.prototype, i),
      n && zr(t, n),
      e
  }())
    , Rr = i(4)
    , Br = (i(178),
  i(20));
  function jr(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  var Fr = new (function() {
      function e() {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              target: null
          },
          this.defaults = {
              overridePageAnchors: !1
          },
          this.options = {},
          this.flags = {
              isInitialized: !1
          },
          this.events = Object(o.a)(this)
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "init",
          value: function(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              this.flags.isInitialized || (this.flags.isInitialized = !0,
              this.el.target = e,
              this.options = Object.assign({}, t, this.defaults),
              this.configRouting(),
              this.options.overridePageAnchors && this.overridePageAnchors(),
              this.addEventListeners())
          }
      }, {
          key: "addEventListeners",
          value: function() {}
      }, {
          key: "removeEventListeners",
          value: function() {}
      }, {
          key: "configRouting",
          value: function() {
              var e = this;
              Rr.a.root = Br.root,
              Rr.a.start({
                  "/": function() {
                      e.open("home")
                  },
                  "/404": function() {
                      e.open("404")
                  },
                  "/:page": function(t) {
                      e.open(t)
                  },
                  "/:page/:a/?:b/?:c": function(t, i, n, r) {
                      e.open(t, [i, n, r])
                  }
              })
          }
      }, {
          key: "open",
          value: function(e, t) {
              Dr.scan(e, t),
              this.scan(e, t)
          }
      }, {
          key: "overridePageAnchors",
          value: function() {
              if (this.flags.isInitialized && this.options.overridePageAnchors)
                  for (var e = this.el.target.querySelectorAll('a:not([href*="http"]):not([data-bypass]):not([data-modal-link])'), t = 0; t < e.length; t++) {
                      var i = e[t];
                      i.setAttribute("data-link-routed", !0),
                      i.removeEventListener("click", this.events._onAnchorClick),
                      i.addEventListener("click", this.events._onAnchorClick)
                  }
          }
      }, {
          key: "_onAnchorClick",
          value: function(e) {
              var t = e.currentTarget.getAttribute("href");
              return t && 0 !== t.indexOf("javascript") && Rr.a.navigate(t),
              e.preventDefault(),
              !1
          }
      }, {
          key: "scan",
          value: function() {
              this.flags.isInitialized && this.options.overridePageAnchors && this.overridePageAnchors()
          }
      }, {
          key: "destroy",
          value: function() {
              this.removeEventListeners()
          }
      }]) && jr(t.prototype, i),
      n && jr(t, n),
      e
  }());
  function Nr(e, t) {
      for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1,
          n.configurable = !0,
          "value"in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n)
      }
  }
  new (function() {
      function e() {
          !function(e, t) {
              if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function")
          }(this, e),
          this.el = {
              main: document.body.querySelector("main")
          },
          this.flags = {
              isControllersInitialized: !1,
              isDOMContentLoaded: !1,
              isIFrameInjectionComplete: !1,
              isIframeReady: !1,
              isInIframe: window.frameElement && "iframe" === window.frameElement.nodeName.toLowerCase(),
              isStylesReady: !1
          },
          this.events = Object(o.a)(this),
          this.addEventListeners()
      }
      var t, i, n;
      return t = e,
      (i = [{
          key: "initControllers",
          value: function() {
              this.flags.isControllersInitialized || (c.init(document.body),
              k.init(document.body),
              z.init(this.el.main.querySelector(".page") || this.el.main),
              R.init(document.body),
              j.init(document.body),
              Dr.init(document.body),
              S.a.init(document.body),
              Fr.init(document.body),
              this.flags.isControllersInitialized = !0)
          }
      }, {
          key: "scanControllers",
          value: function() {
              Fr.scan(document.body),
              z.reset(document.body),
              c.reset(document.body),
              Dr.scan(document.body)
          }
      }, {
          key: "addEventListeners",
          value: function() {
              document.addEventListener("DOMContentLoaded", this.events._onDOMContentLoaded),
              document.addEventListener("DOMContentUpdate", this.events._onDOMContentUpdate),
              Object(o.b)(!0),
              Object(o.c)(),
              this.flags.isInIframe && window.addEventListener("message", this.events._onIFrameMessage)
          }
      }, {
          key: "_onDOMContentLoaded",
          value: function() {
              this.flags.isDOMContentLoaded = !0,
              this.checkReady()
          }
      }, {
          key: "_onDOMContentUpdate",
          value: function() {
              var e = this;
              this.flags.isControllersInitialized ? S.a.one(function() {
                  window.scrollTo({
                      top: 0
                  }),
                  e.scanControllers()
              }) : (this.flags.isIFrameInjectionComplete = !0,
              this.checkReady())
          }
      }, {
          key: "_onWindowLoad",
          value: function() {
              this.flags.isStylesReady = !0,
              this.checkReady()
          }
      }, {
          key: "_onIFrameMessage",
          value: function() {
              this.flags.isIFrameInjectionComplete = !0,
              this.flags.isIframeReady ? this.scanControllers() : this.checkReady()
          }
      }, {
          key: "checkReady",
          value: function() {
              this.flags.isDOMContentLoaded && (this.flags.isIFrameInjectionComplete || !this.flags.isInIframe || this.flags.isStylesRead) && this.initControllers()
          }
      }]) && Nr(t.prototype, i),
      n && Nr(t, n),
      e
  }())
}
]);
//# sourceMappingURL=main.bundle.js.map


! function (t) {
  var e = {};

  function n(r) {
    if (e[r]) return e[r].exports;
    var i = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports
  }
  n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    })
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    })
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t)
      for (var i in t) n.d(r, i, function (e) {
        return t[e]
      }.bind(null, i));
    return r
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default
    } : function () {
      return t
    };
    return n.d(e, "a", e), e
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e)
  }, n.p = "/", n(n.s = 203)
}([function (t, e, n) {
  "use strict";
  var r = function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "_on",
        n = {},
        r = Reflect.ownKeys(Reflect.getPrototypeOf(t)),
        i = !0,
        o = !1,
        s = void 0;
      try {
        for (var a, u = r[Symbol.iterator](); !(i = (a = u.next()).done); i = !0) {
          var c = a.value;
          0 === c.indexOf(e) && (n[c] = t[c].bind(t))
        }
      } catch (t) {
        o = !0, s = t
      } finally {
        try {
          i || null == u.return || u.return()
        } finally {
          if (o) throw s
        }
      }
      return n
    },
    i = function () {
      var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
        e = window.navigator.userAgent,
        n = !!e.match(/iPad/i) || !!e.match(/iPhone/i),
        r = !!e.match(/WebKit/i),
        i = n && r && !e.match(/CriOS/i),
        o = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      return t && (o && document.body.classList.add("is-safari"), i && document.body.classList.add("is-safari-ios")), {
        safari: o,
        safariIos: i
      }
    },
    o = function () {
      return window.addEventListener("touchstart", function t() {
        document.body.classList.add("is-user-touch"), window.removeEventListener("touchstart", t, !1)
      }, !1), "ontouchstart" in document.documentElement && document.body.classList.add("is-touch-browser"), this
    },
    s = function (t, e, n, r) {
      return (t /= r) < 1 / 2.75 ? n * (7.5625 * t * t) + e : t < 2 / 2.75 ? n * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + e : t < 2.5 / 2.75 ? n * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + e : n * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + e
    },
    a = function (t, e, n, r) {
      return n - s(r - t, 0, n, r) + e
    },
    u = {
      easeInQuad: function (t, e, n, r) {
        return n * (t /= r) * t + e
      },
      easeOutQuad: function (t, e, n, r) {
        return -n * (t /= r) * (t - 2) + e
      },
      easeInOutQuad: function (t, e, n, r) {
        return (t /= r / 2) < 1 ? n / 2 * t * t + e : -n / 2 * (--t * (t - 2) - 1) + e
      },
      easeInCubic: function (t, e, n, r) {
        return n * (t /= r) * t * t + e
      },
      easeOutCubic: function (t, e, n, r) {
        return n * ((t = t / r - 1) * t * t + 1) + e
      },
      easeInOutCubic: function (t, e, n, r) {
        return (t /= r / 2) < 1 ? n / 2 * t * t * t + e : n / 2 * ((t -= 2) * t * t + 2) + e
      },
      easeInQuart: function (t, e, n, r) {
        return n * (t /= r) * t * t * t + e
      },
      easeOutQuart: function (t, e, n, r) {
        return -n * ((t = t / r - 1) * t * t * t - 1) + e
      },
      easeInOutQuart: function (t, e, n, r) {
        return (t /= r / 2) < 1 ? n / 2 * t * t * t * t + e : -n / 2 * ((t -= 2) * t * t * t - 2) + e
      },
      easeInQuint: function (t, e, n, r) {
        return n * (t /= r) * t * t * t * t + e
      },
      easeOutQuint: function (t, e, n, r) {
        return n * ((t = t / r - 1) * t * t * t * t + 1) + e
      },
      easeInOutQuint: function (t, e, n, r) {
        return (t /= r / 2) < 1 ? n / 2 * t * t * t * t * t + e : n / 2 * ((t -= 2) * t * t * t * t + 2) + e
      },
      easeInSine: function (t, e, n, r) {
        return -n * Math.cos(t / r * (Math.PI / 2)) + n + e
      },
      easeOutSine: function (t, e, n, r) {
        return n * Math.sin(t / r * (Math.PI / 2)) + e
      },
      easeInOutSine: function (t, e, n, r) {
        return -n / 2 * (Math.cos(Math.PI * t / r) - 1) + e
      },
      easeInExpo: function (t, e, n, r) {
        return 0 == t ? e : n * Math.pow(2, 10 * (t / r - 1)) + e
      },
      easeOutExpo: function (t, e, n, r) {
        return t == r ? e + n : n * (1 - Math.pow(2, -10 * t / r)) + e
      },
      easeInOutExpo: function (t, e, n, r) {
        return 0 == t ? e : t == r ? e + n : (t /= r / 2) < 1 ? n / 2 * Math.pow(2, 10 * (t - 1)) + e : n / 2 * (2 - Math.pow(2, -10 * --t)) + e
      },
      easeInCirc: function (t, e, n, r) {
        return -n * (Math.sqrt(1 - (t /= r) * t) - 1) + e
      },
      easeOutCirc: function (t, e, n, r) {
        return n * Math.sqrt(1 - (t = t / r - 1) * t) + e
      },
      easeInOutCirc: function (t, e, n, r) {
        return (t /= r / 2) < 1 ? -n / 2 * (Math.sqrt(1 - t * t) - 1) + e : n / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + e
      },
      easeInElastic: function (t, e, n, r) {
        var i = 1.70158,
          o = 0,
          s = n;
        if (0 == t) return e;
        if (1 == (t /= r)) return e + n;
        if (o || (o = .3 * r), s < Math.abs(n)) {
          s = n;
          i = o / 4
        } else i = o / (2 * Math.PI) * Math.asin(n / s);
        return -s * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - i) * (2 * Math.PI) / o) + e
      },
      easeOutElastic: function (t, e, n, r) {
        var i = 1.70158,
          o = 0,
          s = n;
        if (0 == t) return e;
        if (1 == (t /= r)) return e + n;
        if (o || (o = .3 * r), s < Math.abs(n)) {
          s = n;
          i = o / 4
        } else i = o / (2 * Math.PI) * Math.asin(n / s);
        return s * Math.pow(2, -10 * t) * Math.sin((t * r - i) * (2 * Math.PI) / o) + n + e
      },
      easeInOutElastic: function (t, e, n, r) {
        var i = 1.70158,
          o = 0,
          s = n;
        if (0 == t) return e;
        if (2 == (t /= r / 2)) return e + n;
        if (o || (o = r * (.3 * 1.5)), s < Math.abs(n)) {
          s = n;
          i = o / 4
        } else i = o / (2 * Math.PI) * Math.asin(n / s);
        return t < 1 ? s * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - i) * (2 * Math.PI) / o) * -.5 + e : s * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * r - i) * (2 * Math.PI) / o) * .5 + n + e
      },
      easeInBack: function (t, e, n, r, i) {
        return null == i && (i = 1.70158), n * (t /= r) * t * ((i + 1) * t - i) + e
      },
      easeOutBack: function (t, e, n, r, i) {
        return null == i && (i = 1.70158), n * ((t = t / r - 1) * t * ((i + 1) * t + i) + 1) + e
      },
      easeInOutBack: function (t, e, n, r, i) {
        return null == i && (i = 1.70158), (t /= r / 2) < 1 ? n / 2 * (t * t * ((1 + (i *= 1.525)) * t - i)) + e : n / 2 * ((t -= 2) * t * ((1 + (i *= 1.525)) * t + i) + 2) + e
      },
      easeInBounce: a,
      easeOutBounce: s,
      easeInOutBounce: function (t, e, n, r) {
        return t < r / 2 ? .5 * a(2 * t, 0, n, r) + e : .5 * s(2 * t - r, 0, n, r) + .5 * n + e
      }
    },
    c = n(9),
    l = n.n(c),
    f = n(2);

  function h(t) {
    return function (t) {
      if (Array.isArray(t)) {
        for (var e = 0, n = new Array(t.length); e < t.length; e++) n[e] = t[e];
        return n
      }
    }(t) || function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t)
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance")
    }()
  }
  var d = function (t, e, n, r, i) {
      var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
        s = l.a.apply(void 0, h(t)),
        a = Date.now(),
        u = 0,
        c = function () {
          var t = Math.min(1, u / r);
          return e + s(t) * (n - e)
        };
      f.a.on(function t() {
        (u = Date.now() - a) < r ? i(c()) : (i(c()), "function" == typeof o && o(c()), f.a.off(t))
      })
    },
    v = function (t) {
      for (var e = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null) || t.parentElement.children, n = 0; n < e.length; n++)
        if (t === e[n]) return n;
      return -1
    },
    p = function (t) {
      var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : window;
      if (t) {
        var r = t.offsetLeft,
          i = t.offsetTop,
          o = t.offsetWidth,
          s = t.offsetHeight,
          a = {
            top: i,
            bottom: i + s,
            left: r,
            right: r + o,
            width: o,
            height: s,
            centerX: r + o / 2,
            centerY: r + s / 2
          };
        if (e) {
          var u = t.getBoundingClientRect();
          a.scrollTop = u.top + n.scrollY, a.scrollBottom = a.scrollTop + a.height, a.scrollLeft = u.left + n.scrollX, a.scrollRight = a.scrollLeft + a.width
        }
        return a
      }
    },
    y = function (t) {
      var e;
      if (t) {
        var n = t.indexOf("?");
        n >= 0 ? e = t.substring(n + 1) : -1 === t.indexOf("#") && (e = t)
      } else e = window.location.search.substring(1);
      var r = {};
      if (!e) return r;
      for (var i = e.split("&"), o = 0; o < i.length; o++) {
        var s = i[o].split("=");
        if (s[0]) {
          var a = s[0],
            u = s[1] || null;
          r[a] = u
        }
      }
      return r
    },
    g = n(20),
    b = function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "min",
        n = "min" === e ? "min" : "max",
        r = "width" === (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "width") ? "width" : "height",
        i = g.breakpoints[t];
      return "max" === e && i++, window.matchMedia("(".concat(n, "-").concat(r, ":").concat(i, "px)")).matches
    },
    m = function (t, e, n) {
      var r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
      if (t)
        for (var i = 0; i < t.length; i++) {
          var o = t[i];
          r && o.removeEventListener(e, n), o.addEventListener(e, n)
        }
    },
    w = function (t, e, n) {
      if (t)
        for (var r = 0; r < t.length; r++) {
          t[r].removeEventListener(e, n)
        }
    };

  function k(t) {
    return function (t) {
      if (Array.isArray(t)) {
        for (var e = 0, n = new Array(t.length); e < t.length; e++) n[e] = t[e];
        return n
      }
    }(t) || function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t)
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance")
    }()
  }
  var x = function (t, e, n, r) {
      var i;
      if (t) {
        for (var o = [], s = !1, a = !1, u = 0; u < t.length; u++) {
          var c = t[u],
            l = {},
            f = void 0;
          switch (e) {
            case "add":
            case "remove":
              f = G.isArray(n) ? n : [n], (i = c.classList)[e].apply(i, k(f));
              break;
            case "item":
            case "contains":
              l.target = c, l.value = c.classList[e](n), o.push(l), s = !0, a = !0 === r;
              break;
            case "toggle":
            case "replace":
              c.classList[e](n, r)
          }
        }
        if (s) {
          if (a) {
            for (var h = 0, d = 0; d < o.length; d++) o[d].value && h++;
            o = h
          }
          return o
        }
      }
      return null
    },
    _ = n(8),
    S = n.n(_),
    j = n(39),
    L = n.n(j),
    O = n(14),
    E = n.n(O),
    A = n(40),
    P = n.n(A),
    C = n(41),
    M = n.n(C),
    T = n(3),
    I = n.n(T),
    D = n(42),
    q = n.n(D),
    R = n(43),
    z = n.n(R),
    V = n(44),
    F = n.n(V),
    B = n(19),
    N = n.n(B),
    W = n(45),
    U = n.n(W),
    H = n(46),
    Y = n.n(H),
    $ = n(47),
    Q = n.n($),
    G = {
      isArray: S.a,
      isBoolean: L.a,
      isFunction: E.a,
      isInteger: P.a,
      isNumber: M.a,
      isObject: I.a,
      isString: q.a,
      isUndefined: z.a,
      capitalize: F.a,
      debounce: N.a,
      merge: U.a,
      template: Y.a,
      throttle: Q.a
    };
  n.d(e, "a", function () {
    return r
  }), n.d(e, "b", function () {
    return i
  }), n.d(e, "c", function () {
    return o
  }), n.d(e, "e", function () {
    return u
  }), n.d(e, "d", function () {
    return d
  }), n.d(e, "f", function () {
    return v
  }), n.d(e, "g", function () {
    return p
  }), n.d(e, "h", function () {
    return y
  }), n.d(e, "j", function () {
    return b
  }), n.d(e, "k", function () {
    return m
  }), n.d(e, "m", function () {
    return w
  }), n.d(e, "l", function () {
    return x
  }), n.d(e, "i", function () {
    return G
  })
}, function (t, e, n) {
  "use strict";
  n(9);
  var r = n(0),
    i = n(2);

  function o(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r)
    }
  }
  var s = n(52),
    a = function () {
      function t() {
        ! function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, t), this.debug = {
          log: !0
        }, this.objects = {
          subscribers: []
        }
      }
      var e, n, r;
      return e = t, (n = [{
        key: "on",
        value: function (t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
            r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
          this._addListener(t, e, n, !0, r)
        }
      }, {
        key: "one",
        value: function (t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
            r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
          this._addListener(t, e, n, !1, r)
        }
      }, {
        key: "off",
        value: function (t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
            r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
          this._removeListener(t, e, n, r)
        }
      }, {
        key: "dispatch",
        value: function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this._dispatch(t, e)
        }
      }, {
        key: "_addListener",
        value: function (t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
            r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
            i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
          this.objects.subscribers || (this.objects.subscribers = []), this.debug.log && c.lawg("_addListener1", t, e, n, i);
          for (var o = !1, a = 0, u = this.objects.subscribers.length; a < u; a++) {
            var l = this.objects.subscribers[a];
            l.eventId !== t || l.callback !== e || l.context !== n && (l.context || n) || l.recurring !== r || !s(subscribe.params, i) || (o = !0)
          }
          this.debug.log && c.lawg("match?", o, t), o || this.objects.subscribers.push({
            eventId: t,
            callback: e,
            context: n,
            recurring: r,
            params: i
          }), this.debug.log && c.lawg("_addListener2", this.objects.subscribers)
        }
      }, {
        key: "_removeListener",
        value: function (t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
            r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
          this.objects.subscribers || (this.objects.subscribers = []);
          for (var i = 0, o = this.objects.subscribers.length; i < o; i++) {
            var a = this.objects.subscribers[i];
            if (a.eventId === t && a.callback === e && (a.context === n || !a.context && !n) && s(r)) {
              this.objects.subscribers.splice(i, 1);
              break
            }
          }
        }
      }, {
        key: "_dispatch",
        value: function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (this.objects.subscribers && this.objects.subscribers.length) {
            for (var n = this.objects.subscribers.concat(), r = [], i = 0, o = n.length; i < o; i++) {
              var s = n[i];
              if (s.eventId === t && (r.push(s), !s.recurring)) {
                var a = this.objects.subscribers.indexOf(s);
                this.objects.subscribers.splice(a, 1), this.debug.log && c.lawg("splice @", a, s.callback)
              }
            }
            for (var u = 0, l = r.length; u < l; u++) {
              var f = r[u];
              f.callback.apply(f.context, [f, e])
            }
          }
        }
      }, {
        key: "removeAll",
        value: function () {
          this.objects.subscribers = []
        }
      }, {
        key: "reset",
        value: function () {
          this.removeAll()
        }
      }]) && o(e.prototype, n), r && o(e, r), t
    }();
  n(16);

  function u(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r)
    }
  }
  var c = new(function () {
    function t(e) {
      ! function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
      }(this, t), this.config = {
        logInProduction: !1
      }, Object.assign(this.config, e)
    }
    var e, n, r;
    return e = t, (n = [{
      key: "assert",
      value: function (t) {
        for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) n[r - 1] = arguments[r];
        this.run.apply(this, ["assert", t].concat(n))
      }
    }, {
      key: "clear",
      value: function () {
        this.run("clear")
      }
    }, {
      key: "debug",
      value: function () {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
        this.run.apply(this, ["debug"].concat(e))
      }
    }, {
      key: "dir",
      value: function (t, e) {
        this.run("dir", t, e)
      }
    }, {
      key: "dirxml",
      value: function () {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
        this.run.apply(this, ["dirxml"].concat(e))
      }
    }, {
      key: "error",
      value: function () {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
        this.run.apply(this, ["error"].concat(e))
      }
    }, {
      key: "info",
      value: function () {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
        this.run.apply(this, ["info"].concat(e))
      }
    }, {
      key: "lawg",
      value: function () {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
        this.run.apply(this, ["groupCollapsed"].concat(e)), this.run.apply(this, ["trace"].concat(e)), this.run("groupEnd")
      }
    }, {
      key: "log",
      value: function () {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
        this.run.apply(this, ["log"].concat(e))
      }
    }, {
      key: "table",
      value: function (t, e) {
        this.run("table", t, e)
      }
    }, {
      key: "trace",
      value: function () {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
        this.run.apply(this, ["trace"].concat(e))
      }
    }, {
      key: "warn",
      value: function () {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
        this.run.apply(this, ["warn"].concat(e))
      }
    }, {
      key: "count",
      value: function (t) {
        this.run("count", t)
      }
    }, {
      key: "countReset",
      value: function (t) {
        this.run("countReset", t)
      }
    }, {
      key: "group",
      value: function () {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
        this.run.apply(this, ["group"].concat(e))
      }
    }, {
      key: "groupCollapsed",
      value: function () {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
        this.run.apply(this, ["groupCollapsed"].concat(e))
      }
    }, {
      key: "groupEnd",
      value: function () {
        this.run("groupEnd")
      }
    }, {
      key: "time",
      value: function (t) {
        this.run("time", t)
      }
    }, {
      key: "timeLog",
      value: function (t) {
        for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) n[r - 1] = arguments[r];
        this.run.apply(this, ["timeLog"].concat(n))
      }
    }, {
      key: "timeEnd",
      value: function (t) {
        this.run("timeEnd", t)
      }
    }, {
      key: "run",
      value: function (t) {
        if (this.validateEnvironment()) {
          for (var e, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = arguments[i];
          (e = window.console)[t].apply(e, r)
        }
      }
    }, {
      key: "validateEnvironment",
      value: function () {
        return this.config.logInProduction, "console" in window
      }
    }]) && u(e.prototype, n), r && u(e, r), t
  }());

  function l(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r)
    }
  }
  var f = function () {
    function t() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      ! function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
      }(this, t), this.defaults = {
        currentValue: e,
        lastValue: null,
        callback: null,
        callbackComplete: null,
        ratio: .16,
        minDifference: .2
      }, this.options = Object.assign({}, this.defaults, n), this.events = Object(r.a)(this), this.flags = {
        isPaused: !0,
        isStopped: !0,
        isComplete: !1
      }, this.states = {
        currentValue: this.options.currentValue,
        lastValue: null === this.options.lastValue ? this.options.currentValue : this.options.lastValue,
        easedValue: null === this.options.lastValue ? this.options.currentValue : this.options.lastValue,
        startTime: Date.now()
      }, this.init()
    }
    var e, n, o;
    return e = t, (n = [{
      key: "init",
      value: function () {
        this.start()
      }
    }, {
      key: "resetTime",
      value: function () {
        this.states.startTime = Date.now()
      }
    }, {
      key: "pause",
      value: function () {
        this.flags.isPaused || (this.flags.isPaused = !0, i.a.off(this.events._onLoop))
      }
    }, {
      key: "unpause",
      value: function () {
        this.flags.isPaused && (this.flags.isPaused = !1, this.flags.isStopped && (this.flags.isStopped = !1, this.resetTime()), i.a.on(this.events._onLoop))
      }
    }, {
      key: "start",
      value: function () {
        this.unpause()
      }
    }, {
      key: "stop",
      value: function () {
        this.pause(), this.flags.isStopped = !0
      }
    }, {
      key: "_onLoop",
      value: function () {
        this.tick()
      }
    }, {
      key: "tick",
      value: function () {
        this.flags.isComplete || (this.states.timeElapsed = Date.now() - this.states.startTime, this.calculate())
      }
    }, {
      key: "calculate",
      value: function () {
        var t = (this.states.currentValue - this.states.lastValue) * this.options.ratio;
        Math.abs(t) < this.options.minDifference && (t = 0), this.states.lastValue = this.states.easedValue, this.states.easedValue = this.states.easedValue + t, t ? "function" == typeof this.options.callback && this.options.callback(this.states.easedValue) : ("function" == typeof this.options.callback && this.options.callback(this.states.easedValue), "function" == typeof this.options.callbackComplete && this.options.callbackComplete(this.states.easedValue), this.flags.isComplete = !0)
      }
    }, {
      key: "update",
      value: function (t) {
        this.states.currentValue !== t && (this.options.currentValue = t, this.states.currentValue = t, this.resetTime(), this.flags.isComplete = !1)
      }
    }, {
      key: "destroy",
      value: function () {
        this.stop()
      }
    }, {
      key: "paused",
      get: function () {
        return this.flags.isPaused
      }
    }, {
      key: "playing",
      get: function () {
        return !this.flags.isPaused
      }
    }, {
      key: "value",
      get: function () {
        return this.states.easedValue
      }
    }, {
      key: "callback",
      set: function (t) {
        this.options.callback = t
      }
    }, {
      key: "callbackComplete",
      set: function (t) {
        this.options.callbackComplete = t
      }
    }]) && l(e.prototype, n), o && l(e, o), t
  }();

  function h(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r)
    }
  }
  var d = function () {
    function t(e, n) {
      ! function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
      }(this, t), this.el = {
        section: e
      }, this.defaults = {
        autoEnable: !0,
        callback: null,
        switchBuffer: 60
      }, this.options = Object.assign({}, this.defaults, n), this.events = Object(r.a)(this), this.coords = {
        directionDistance: 0,
        scrollYLast: 0,
        scrollDirectionSwitchY: -1
      }, this.flags = {
        isEnabled: !1,
        isInitialized: !1,
        isScrollDirectionSwitch: !1
      }, this.status = {
        direction: t.STATIC
      }, this.footlong = new a, this.init()
    }
    var e, n, i;
    return e = t, i = [{
      key: "DIRECTION_CHANGE",
      get: function () {
        return "directionChange"
      }
    }, {
      key: "UP",
      get: function () {
        return "up"
      }
    }, {
      key: "DOWN",
      get: function () {
        return "down"
      }
    }, {
      key: "STATIC",
      get: function () {
        return "static"
      }
    }], (n = [{
      key: "init",
      value: function () {
        this.addEventListeners(), this.options.autoEnable && this.enable()
      }
    }, {
      key: "addEventListeners",
      value: function () {
        this.el.section.addEventListener("resize", this.events._onResize), this.el.section.addEventListener("scroll", this.events._onScroll, {
          passive: !0
        })
      }
    }, {
      key: "removeEventListeners",
      value: function () {
        this.el.section.addEventListener("resize", this.events._onResize), this.el.section.addEventListener("scroll", this.events._onScroll)
      }
    }, {
      key: "_onResize",
      value: function () {
        this.checkResize()
      }
    }, {
      key: "_onScroll",
      value: function () {
        this.checkScroll()
      }
    }, {
      key: "checkResize",
      value: function () {
        this.flags.isEnabled && this.checkScroll()
      }
    }, {
      key: "checkScroll",
      value: function () {
        var e = Math.max(0, this.el.section === window ? window.scrollY : this.el.section.scrollTop);
        if (this.flags.isEnabled)
          if (this.coords.directionDistance = e - this.coords.scrollDirectionSwitchY, this.isScrollDirectionSwitch) this.status.direction === t.DOWN && this.coords.directionDistance > 0 || this.status.direction === t.UP && this.coords.directionDistance < 0 ? this.isScrollDirectionSwitch = !1 : Math.abs(this.coords.directionDistance) >= this.options.switchBuffer && (this.isScrollDirectionSwitch = !1, this.setDirection(this.coords.directionDistance < 0 ? t.UP : t.DOWN));
          else {
            var n = e - this.coords.scrollYLast;
            this.status.direction === t.DOWN && n < 0 || this.status.direction === t.UP && n > 0 ? (this.isScrollDirectionSwitch = !0, this.coords.scrollDirectionSwitchY = e) : e - this.coords.scrollYLast > 0 ? this.setDirection(t.DOWN) : e - this.coords.scrollYLast < 0 ? this.setDirection(t.UP) : e - this.coords.scrollYLast == 0 && this.setDirection(t.STATIC)
          } this.coords.scrollYLast = e
      }
    }, {
      key: "setDirection",
      value: function (e) {
        this.status.direction !== e && (this.status.direction = e, this.options.callback && this.options.callback.apply(null, [{
          direction: this.status.direction
        }]), this.dispatch(t.DIRECTION_CHANGE, {
          direction: this.status.direction,
          directionDistance: this.coords.directionDistance
        }))
      }
    }, {
      key: "enable",
      value: function () {
        this.flags.isEnabled || (this.flags.isEnabled = !0, this.coords.directionDistance = 0, this.setDirection(t.STATIC))
      }
    }, {
      key: "disable",
      value: function () {
        this.flags.isEnabled && (this.flags.isEnabled = !1, this.coords.directionDistance = 0, this.setDirection(t.STATIC))
      }
    }, {
      key: "on",
      value: function (t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        this.footlong.on(t, e, n, r)
      }
    }, {
      key: "one",
      value: function () {
        this.footlong.one(eventId, callback, context, params)
      }
    }, {
      key: "off",
      value: function () {
        this.footlong.off(eventId, callback, context, params)
      }
    }, {
      key: "dispatch",
      value: function (e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
        this.footlong.dispatch(t.DIRECTION_CHANGE, n)
      }
    }, {
      key: "destroy",
      value: function () {
        this.removeEventListeners()
      }
    }, {
      key: "direction",
      get: function () {
        return this.status.direction
      }
    }, {
      key: "directionDistance",
      get: function () {
        return this.coords.directionDistance
      }
    }]) && h(e.prototype, n), i && h(e, i), t
  }();

  function v(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r)
    }
  }
  var p = function () {
    function t(e) {
      ! function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
      }(this, t), this.xhr = new XMLHttpRequest, this.type = e, this.url = "", this.data = null, this.header = {}, this.onprogress = !1, this.timeout = 3e4
    }
    var e, n, r;
    return e = t, (n = [{
      key: "setHeader",
      value: function (t, e) {
        return this.header[t] = e, this
      }
    }, {
      key: "onProgress",
      value: function (t) {
        return this.onprogress = t, this
      }
    }, {
      key: "setTimeout",
      value: function (t) {
        return this.timeout = t, this
      }
    }, {
      key: "setType",
      value: function () {
        try {
          this.xhr.responseType = this.type
        } catch (t) {}
      }
    }, {
      key: "onreadystatechange",
      value: function (t, e) {
        var n = this;
        this.xhr.onreadystatechange = function () {
          4 === n.xhr.readyState && (200 === n.xhr.status ? t(n.xhr) : e(n.xhr))
        }
      }
    }, {
      key: "request",
      value: function (t) {
        var e = this;
        return new Promise(function (n, r) {
          for (var i in e.onprogress && (e.xhr.onprogress = e.onprogress), e.setType(), e.onreadystatechange(n, r), e.xhr.open(t, e.url, !0), e.header) e.xhr.setRequestHeader(i, e.header[i]);
          e.xhr.timeout = e.timeout, e.xhr.send(e.data)
        })
      }
    }, {
      key: "get",
      value: function (t) {
        return this.url = t, this.request("GET")
      }
    }, {
      key: "post",
      value: function (t, e) {
        return this.url = t, this.data = e, this.request("POST")
      }
    }, {
      key: "put",
      value: function (t, e) {
        return this.url = t, this.data = e, this.request("PUT")
      }
    }, {
      key: "delete",
      value: function (t, e) {
        return this.url = t, this.data = e, this.request("DELETE")
      }
    }, {
      key: "abort",
      value: function () {
        this.xhr.abort()
      }
    }]) && v(e.prototype, n), r && v(e, r), t
  }();
  n.d(e, "a", function () {
    return a
  }), n.d(e, "b", function () {
    return c
  }), n.d(e, "c", function () {
    return f
  }), n.d(e, "d", function () {
    return d
  }), n.d(e, "e", function () {
    return p
  })
}, function (t, e, n) {
  "use strict";
  var r = n(1);

  function i(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r)
    }
  }
  var o = function () {
    function t() {
      ! function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
      }(this, t), this.objects = {
        animationFrame: null,
        subscribers: []
      }, this.counters = {
        frame: 0
      }, this.flags = {
        autoStart: !0,
        isPlaying: !1
      }, this.debug = {
        log: !1
      }
    }
    var e, n, o;
    return e = t, (n = [{
      key: "init",
      value: function () {
        this.flags.autoStart && this.start()
      }
    }, {
      key: "on",
      value: function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
          r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
        this._addListener(t, e, n, r)
      }
    }, {
      key: "one",
      value: function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
        this._addListener(t, e, !1, n)
      }
    }, {
      key: "off",
      value: function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
        this._removeListener(t, e)
      }
    }, {
      key: "pause",
      value: function () {
        this.flags.isPlaying && (this.flags.isPlaying = !1)
      }
    }, {
      key: "unpause",
      value: function () {
        this.flags.isPlaying || (this.flags.isPlaying = !0, this._tick())
      }
    }, {
      key: "start",
      value: function () {
        this.unpause()
      }
    }, {
      key: "removeAll",
      value: function () {
        this.objects.subscribers = []
      }
    }, {
      key: "resetFrameCount",
      value: function () {
        this.counters.frame = 0
      }
    }, {
      key: "reset",
      value: function () {
        this.removeAll(), this.resetFrameCount()
      }
    }, {
      key: "_addListener",
      value: function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
          i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
        this.objects.subscribers || (this.objects.subscribers = []), this.debug.log && r.b.lawg("add RAF", t, e, n, i, "now", this.counters.frame);
        for (var o = !1, s = 0, a = this.objects.subscribers.length; s < a; s++) {
          var u = this.objects.subscribers[s];
          if (u.callback === t && this.isContextMatch(u.context, e) && u.recurring === n && u.frameDelay === i) {
            o = !0;
            break
          }
        }
        this.debug.log && r.b.lawg("match?", o), o || this.objects.subscribers.push({
          callback: t,
          context: e,
          recurring: n,
          frameDelay: i,
          triggerFrame: this.counters.frame + i,
          startFrame: this.counters.frame
        }), this.debug.log && r.b.lawg("_addListener", this.objects.subscribers)
      }
    }, {
      key: "_removeListener",
      value: function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
          r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
        this.objects.subscribers || (this.objects.subscribers = []);
        for (var i = 0, o = this.objects.subscribers.length; i < o; i++) {
          var s = this.objects.subscribers[i];
          if (s.callback === t && this.isContextMatch(s.context, e) && s.recurring === n && s.frameDelay === r) {
            this.objects.subscribers.splice(i, 1);
            break
          }
        }
      }
    }, {
      key: "_triggerFrame",
      value: function () {
        if (this.objects.subscribers && this.objects.subscribers.length) {
          for (var t = this.objects.subscribers.concat(), e = [], n = 0, i = t.length; n < i; n++) {
            var o = t[n];
            if (this.counters.frame >= o.triggerFrame)
              if (e.push(o), o.recurring) o.triggerFrame += o.frameDelay;
              else {
                var s = this.objects.subscribers.indexOf(o);
                this.objects.subscribers.splice(s, 1), this.debug.log && r.b.lawg("splice @", s, o.callback)
              }
          }
          for (var a = 0, u = e.length; a < u; a++) {
            var c = e[a];
            c.callback.apply(c.context, [])
          }
        }
      }
    }, {
      key: "_tick",
      value: function () {
        var t = this,
          e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        this.counters.frame++, this.objects.animationFrame = window.requestAnimationFrame(function () {
          (t.flags.isPlaying || e) && (t._triggerFrame(), t._tick())
        })
      }
    }, {
      key: "isContextMatch",
      value: function (t, e) {
        return t && e ? t === e : !t && !e
      }
    }]) && i(e.prototype, n), o && i(e, o), t
  }();
  e.a = new o
}, function (t, e) {
  t.exports = function (t) {
    var e = typeof t;
    return null != t && ("object" == e || "function" == e)
  }
}, function (t, e, n) {
  "use strict";
  e.a = new class {
    constructor() {
      this.routes = [], this.map = {}, this.root = "/", this.http404 = "/404", this.redirects = {}, this.addEventListeners()
    }
    parse(t) {
      return decodeURI(t).split("/").filter(t => {
        if ("" !== t) return t
      })
    }
    route(t, e) {
      const n = this.parse(t);
      this.routes.push(t), this.map[t] = {
        params: n,
        fn: e
      }
    }
    navigate(t) {
      if (t !== window.location.pathname) {
        let e = t;
        this.redirects[t] && (e = this.redirects[t]), window.history.pushState(!1, !1, this.root.replace(/\/$/, "") + e)
      }
      this.check()
    }
    redirect(t) {
      for (const e in t) this.redirects[e] = t[e]
    }
    check() {
      let t = window.location.pathname.replace(this.root.replace(/\/$/, ""), ""),
        e = {
          route: !1,
          accuracy: 0,
          variables: []
        };
      this.redirects[t] && (t = this.redirects[t]);
      const n = this.parse(t);
      for (const t in this.routes) {
        const r = this.map[this.routes[t]].params,
          i = [];
        let o = 0;
        if (n.length) {
          if (n.length <= r.length)
            for (const t in r)
              if (n[t])
                if (n[t] === r[t]) o += 100;
                else if (":" === r[t].charAt(0)) o += 5, i.push(n[t]);
          else {
            if ("?" !== r[t].charAt(0)) break;
            o += 1, ":" === r[t].charAt(1) && i.push(n[t])
          } else "?" !== r[t].charAt(0) && (o = 0)
        } else e = {
          route: "/",
          accuracy: o,
          variables: i
        };
        o && o >= e.accuracy && (e = {
          route: this.routes[t],
          accuracy: o,
          variables: i
        })
      }
      e.route && this.map[e.route] ? this.map[e.route].fn(...e.variables) : this.map[this.http404] && this.map[this.http404].fn()
    }
    start(t) {
      if (t)
        for (const e in t) this.route(e, t[e]);
      this.check()
    }
    _windowOnPopstate() {
      this.check()
    }
    addEventListeners() {
      this._windowOnPopstate = this._windowOnPopstate.bind(this), window.addEventListener("popstate", this._windowOnPopstate)
    }
    removeEventListeners() {
      window.removeEventListener("popstate", this._windowOnPopstate)
    }
  }
}, function (t, e) {
  var n = Object.prototype.toString;
  t.exports = function (t) {
    return n.call(t)
  }
}, function (t, e) {
  t.exports = function (t) {
    return null != t && "object" == typeof t
  }
}, , function (t, e) {
  var n = Array.isArray;
  t.exports = n
}, function (t, e) {
  var n = 4,
    r = .001,
    i = 1e-7,
    o = 10,
    s = 11,
    a = 1 / (s - 1),
    u = "function" == typeof Float32Array;

  function c(t, e) {
    return 1 - 3 * e + 3 * t
  }

  function l(t, e) {
    return 3 * e - 6 * t
  }

  function f(t) {
    return 3 * t
  }

  function h(t, e, n) {
    return ((c(e, n) * t + l(e, n)) * t + f(e)) * t
  }

  function d(t, e, n) {
    return 3 * c(e, n) * t * t + 2 * l(e, n) * t + f(e)
  }

  function v(t) {
    return t
  }
  t.exports = function (t, e, c, l) {
    if (!(0 <= t && t <= 1 && 0 <= c && c <= 1)) throw new Error("bezier x values must be in [0, 1] range");
    if (t === e && c === l) return v;
    for (var f = u ? new Float32Array(s) : new Array(s), p = 0; p < s; ++p) f[p] = h(p * a, t, c);

    function y(e) {
      for (var u = 0, l = 1, v = s - 1; l !== v && f[l] <= e; ++l) u += a;
      var p = u + (e - f[--l]) / (f[l + 1] - f[l]) * a,
        y = d(p, t, c);
      return y >= r ? function (t, e, r, i) {
        for (var o = 0; o < n; ++o) {
          var s = d(e, r, i);
          if (0 === s) return e;
          e -= (h(e, r, i) - t) / s
        }
        return e
      }(e, p, t, c) : 0 === y ? p : function (t, e, n, r, s) {
        var a, u, c = 0;
        do {
          (a = h(u = e + (n - e) / 2, r, s) - t) > 0 ? n = u : e = u
        } while (Math.abs(a) > i && ++c < o);
        return u
      }(e, u, u + a, t, c)
    }
    return function (t) {
      return 0 === t ? 0 : 1 === t ? 1 : h(y(t), e, l)
    }
  }
}, function (t, e, n) {
  var r = n(55);
  t.exports = function (t) {
    return null == t ? "" : r(t)
  }
}, function (t, e, n) {
  var r = n(57),
    i = "object" == typeof self && self && self.Object === Object && self,
    o = r || i || Function("return this")();
  t.exports = o
}, function (t, e, n) {
  var r = n(13);
  t.exports = function (t, e) {
    for (var n = t.length; n--;)
      if (r(t[n][0], e)) return n;
    return -1
  }
}, function (t, e) {
  t.exports = function (t, e) {
    return t === e || t != t && e != e
  }
}, function (t, e, n) {
  var r = n(5),
    i = n(3),
    o = "[object AsyncFunction]",
    s = "[object Function]",
    a = "[object GeneratorFunction]",
    u = "[object Proxy]";
  t.exports = function (t) {
    if (!i(t)) return !1;
    var e = r(t);
    return e == s || e == a || e == o || e == u
  }
}, function (t) {
  t.exports = {
    sessionStorageKey: "styleguide-active-content",
    blueprint: {
      styleguide: {
        title: "Styleguide",
        content: {
          buttons: {
            title: "Buttons",
            content: [{
              type: "module",
              path: "styleguide/buttons"
            }]
          },
          color: {
            title: "Color",
            content: [{
              type: "module",
              path: "styleguide/color"
            }]
          },
          forms: {
            title: "Forms",
            content: [{
              type: "module",
              path: "styleguide/forms"
            }]
          },
          icons: {
            title: "Icons & Badges",
            content: [{
              type: "module",
              path: "styleguide/icons"
            }]
          },
          logos: {
            title: "Logos",
            content: [{
              type: "module",
              path: "styleguide/logos"
            }]
          },
          typography: {
            title: "Typography",
            content: [{
              type: "module",
              path: "styleguide/typography"
            }]
          },
          blobs: {
            title: "Blobs",
            content: [{
              type: "module",
              path: "styleguide/blobs"
            }]
          }
        }
      },
      modules: {
        title: "Modules",
        content: {
          navigation: {
            title: "Navigation",
            content: [{
              type: "module",
              path: "styleguide/navigation"
            }]
          },
          modals: {
            title: "Modals",
            content: [{
              type: "module",
              path: "styleguide/modals"
            }]
          },
          banners: {
            title: "Banners",
            content: [{
              type: "module",
              path: "styleguide/banners"
            }]
          },
          hero: {
            title: "Heroes",
            content: [{
              type: "module",
              path: "styleguide/hero"
            }]
          },
          cards: {
            title: "Cards",
            content: [{
              type: "module",
              path: "styleguide/cards"
            }]
          },
          carousels: {
            title: "Carousels",
            content: [{
              type: "module",
              path: "styleguide/carousels"
            }]
          },
          "in-grid-marketing": {
            title: "In-Grid Marketing",
            content: [{
              type: "module",
              path: "styleguide/in-grid-marketing"
            }]
          },
          storytelling: {
            title: "Storytelling",
            content: [{
              type: "module",
              path: "styleguide/storytelling"
            }]
          },
          gallery: {
            title: "Full-Screen Gallery",
            content: [{
              type: "module",
              path: "styleguide/gallery"
            }]
          },
          "buy-configuration": {
            title: "Buy Configuration",
            content: [{
              type: "module",
              path: "styleguide/buy-configuration"
            }]
          },
          search: {
            title: "Search",
            content: [{
              type: "module",
              path: "styleguide/search"
            }]
          }
        }
      },
      pages: {
        title: "Pages",
        content: {
          "page-pdp-mens": {
            title: "PDP Micro Puff - Men",
            content: [{
              type: "module",
              path: "styleguide/page-pdp-mens"
            }]
          },
          "page-pdp-womens": {
            title: "PDP Torrentshell - Women",
            content: [{
              type: "module",
              path: "styleguide/page-pdp-womens"
            }]
          },
          "page-plp-cat": {
            title: "PLP Category - Men",
            content: [{
              type: "module",
              path: "styleguide/page-plp-cat"
            }]
          },
          "page-plp-subcat-jackets": {
            title: "PLP Subcategory - Jackets",
            content: [{
              type: "module",
              path: "styleguide/page-plp-subcat-jackets"
            }]
          },
          "page-plp-subcat-insulated": {
            title: "PLP Subcategory - Insulated",
            content: [{
              type: "module",
              path: "styleguide/page-plp-subcat-insulated"
            }]
          },
          "page-plp-subcat-shells": {
            title: "PLP Subcategory - Shells",
            content: [{
              type: "module",
              path: "styleguide/page-plp-subcat-shells"
            }]
          },
          "page-search": {
            title: "Search Results",
            content: [{
              type: "module",
              path: "styleguide/page-search"
            }]
          },
          "page-home": {
            title: "Home",
            content: [{
              type: "module",
              path: "styleguide/page-home"
            }]
          },
          "page-sports": {
            title: "Sports",
            content: [{
              type: "module",
              path: "styleguide/page-sports"
            }],
            hidden: !0
          },
          "page-account": {
            title: "Log In / Account",
            content: [{
              type: "module",
              path: "styleguide/page-account"
            }]
          }
        }
      }
    },
    defaultContent: "styleguide/typography",
    devMode: !0,
    sizes: {
      phone: [375, 667],
      tablet: [768, 1024],
      full: [0, 0]
    }
  }
}, function (t, e, n) {
  "use strict";
  n.d(e, "b", function () {
    return s
  }), n.d(e, "a", function () {
    return a
  });
  var r = n(0);

  function i(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r)
    }
  }

  function o(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
  }
  var s = "lazy",
    a = function () {
      function t(e, n) {
        o(this, t), this.el = {
          section: e
        }, this.defaults = {}, this.options = Object.assign({}, this.defaults, n), this.events = Object(r.a)(this), this.flags = {
          isMainController: !1
        }, this.queue = [], this.lazyItems = [], this.init()
      }
      var e, n, s;
      return e = t, (n = [{
        key: "init",
        value: function () {
          var t = this.el.section.getAttribute("data-lazy-src");
          if (!Object(r.j)("medium")) {
            var e = this.el.section.getAttribute("data-lazy-src-mobile");
            e && (t = e)
          }
          this.el.section.setAttribute("src", t), this.addEventListeners()
        }
      }, {
        key: "addEventListeners",
        value: function () {}
      }, {
        key: "removeEventListeners",
        value: function () {}
      }, {
        key: "_onScroll",
        value: function () {}
      }, {
        key: "destroy",
        value: function () {
          this.removeEventListeners()
        }
      }]) && i(e.prototype, n), s && i(e, s), t
    }()
}, function (t, e, n) {
  var r = n(73);
  t.exports = function (t, e, n) {
    "__proto__" == e && r ? r(t, e, {
      configurable: !0,
      enumerable: !0,
      value: n,
      writable: !0
    }) : t[e] = n
  }
}, function (t, e) {
  t.exports = function (t) {
    var e = [];
    if (null != t)
      for (var n in Object(t)) e.push(n);
    return e
  }
}, function (t, e, n) {
  var r = n(3),
    i = n(65),
    o = n(23),
    s = "Expected a function",
    a = Math.max,
    u = Math.min;
  t.exports = function (t, e, n) {
    var c, l, f, h, d, v, p = 0,
      y = !1,
      g = !1,
      b = !0;
    if ("function" != typeof t) throw new TypeError(s);

    function m(e) {
      var n = c,
        r = l;
      return c = l = void 0, p = e, h = t.apply(r, n)
    }

    function w(t) {
      var n = t - v;
      return void 0 === v || n >= e || n < 0 || g && t - p >= f
    }

    function k() {
      var t = i();
      if (w(t)) return x(t);
      d = setTimeout(k, function (t) {
        var n = e - (t - v);
        return g ? u(n, f - (t - p)) : n
      }(t))
    }

    function x(t) {
      return d = void 0, b && c ? m(t) : (c = l = void 0, h)
    }

    function _() {
      var t = i(),
        n = w(t);
      if (c = arguments, l = this, v = t, n) {
        if (void 0 === d) return function (t) {
          return p = t, d = setTimeout(k, e), y ? m(t) : h
        }(v);
        if (g) return d = setTimeout(k, e), m(v)
      }
      return void 0 === d && (d = setTimeout(k, e)), h
    }
    return e = o(e) || 0, r(n) && (y = !!n.leading, f = (g = "maxWait" in n) ? a(o(n.maxWait) || 0, e) : f, b = "trailing" in n ? !!n.trailing : b), _.cancel = function () {
      void 0 !== d && clearTimeout(d), p = 0, c = v = l = d = void 0
    }, _.flush = function () {
      return void 0 === d ? h : x(i())
    }, _
  }
}, function (t) {
  t.exports = {
    root: "/",
    breakpoints: {
      tiny: 480,
      small: 576,
      medium: 768,
      large: 992,
      xlarge: 1280,
      xxlarge: 1440,
      xxxlarge: 1600,
      xxxxlarge: 1800
    }
  }
}, function (t, e) {
  var n;
  n = function () {
    return this
  }();
  try {
    n = n || new Function("return this")()
  } catch (t) {
    "object" == typeof window && (n = window)
  }
  t.exports = n
}, function (t, e, n) {
  "use strict";
  n.d(e, "a", function () {
    return r
  });
  class r {
    constructor(t) {
      this.xhr = new XMLHttpRequest, this.type = t, this.url = "", this.data = null, this.header = {}, this.onprogress = !1, this.timeout = 3e4
    }
    setHeader(t, e) {
      return this.header[t] = e, this
    }
    onProgress(t) {
      return this.onprogress = t, this
    }
    setTimeout(t) {
      return this.timeout = t, this
    }
    setType() {
      try {
        this.xhr.responseType = this.type
      } catch (t) {}
    }
    onreadystatechange(t, e) {
      this.xhr.onreadystatechange = (() => {
        4 === this.xhr.readyState && (200 === this.xhr.status ? t(this.xhr) : e(this.xhr))
      })
    }
    request(t) {
      return new Promise((e, n) => {
        this.onprogress && (this.xhr.onprogress = this.onprogress), this.setType(), this.onreadystatechange(e, n), this.xhr.open(t, this.url, !0);
        for (const t in this.header) this.xhr.setRequestHeader(t, this.header[t]);
        this.xhr.timeout = this.timeout, this.xhr.send(this.data)
      })
    }
    get(t) {
      return this.url = t, this.request("GET")
    }
    post(t, e) {
      return this.url = t, this.data = e, this.request("POST")
    }
    put(t, e) {
      return this.url = t, this.data = e, this.request("PUT")
    }
    delete(t, e) {
      return this.url = t, this.data = e, this.request("DELETE")
    }
    abort() {
      this.xhr.abort()
    }
  }
}, function (t, e, n) {
  var r = n(3),
    i = n(24),
    o = NaN,
    s = /^\s+|\s+$/g,
    a = /^[-+]0x[0-9a-f]+$/i,
    u = /^0b[01]+$/i,
    c = /^0o[0-7]+$/i,
    l = parseInt;
  t.exports = function (t) {
    if ("number" == typeof t) return t;
    if (i(t)) return o;
    if (r(t)) {
      var e = "function" == typeof t.valueOf ? t.valueOf() : t;
      t = r(e) ? e + "" : e
    }
    if ("string" != typeof t) return 0 === t ? t : +t;
    t = t.replace(s, "");
    var n = u.test(t);
    return n || c.test(t) ? l(t.slice(2), n ? 2 : 8) : a.test(t) ? o : +t
  }
}, function (t, e) {
  t.exports = function () {
    return !1
  }
}, function (t, e) {
  t.exports = function (t, e) {
    for (var n = -1, r = null == t ? 0 : t.length, i = Array(r); ++n < r;) i[n] = e(t[n], n, t);
    return i
  }
}, function (t, e) {
  t.exports = function () {
    return !1
  }
}, function (t, e, n) {
  var r = n(17),
    i = n(13);
  t.exports = function (t, e, n) {
    (void 0 === n || i(t[e], n)) && (void 0 !== n || e in t) || r(t, e, n)
  }
}, function (t, e, n) {
  var r = n(29)(Object.getPrototypeOf, Object);
  t.exports = r
}, function (t, e) {
  t.exports = function (t, e) {
    return function (n) {
      return t(e(n))
    }
  }
}, function (t, e, n) {
  var r = n(5),
    i = n(28),
    o = n(6),
    s = "[object Object]",
    a = Function.prototype,
    u = Object.prototype,
    c = a.toString,
    l = u.hasOwnProperty,
    f = c.call(Object);
  t.exports = function (t) {
    if (!o(t) || r(t) != s) return !1;
    var e = i(t);
    if (null === e) return !0;
    var n = l.call(e, "constructor") && e.constructor;
    return "function" == typeof n && n instanceof n && c.call(n) == f
  }
}, function (t, e) {
  t.exports = function (t, e) {
    if ("__proto__" != e) return t[e]
  }
}, function (t, e, n) {
  var r = n(93),
    i = n(17);
  t.exports = function (t, e, n, o) {
    var s = !n;
    n || (n = {});
    for (var a = -1, u = e.length; ++a < u;) {
      var c = e[a],
        l = o ? o(n[c], t[c], c, n, t) : void 0;
      void 0 === l && (l = t[c]), s ? i(n, c, l) : r(n, c, l)
    }
    return n
  }
}, function (t, e, n) {
  var r = n(34),
    i = n(36);
  t.exports = function (t) {
    return r(function (e, n) {
      var r = -1,
        o = n.length,
        s = o > 1 ? n[o - 1] : void 0,
        a = o > 2 ? n[2] : void 0;
      for (s = t.length > 3 && "function" == typeof s ? (o--, s) : void 0, a && i(n[0], n[1], a) && (s = o < 3 ? void 0 : s, o = 1), e = Object(e); ++r < o;) {
        var u = n[r];
        u && t(e, u, r, s)
      }
      return e
    })
  }
}, function (t, e, n) {
  var r = n(94),
    i = n(95),
    o = n(96);
  t.exports = function (t, e) {
    return o(i(t, e, r), t + "")
  }
}, function (t, e) {
  t.exports = function (t, e, n) {
    switch (n.length) {
      case 0:
        return t.call(e);
      case 1:
        return t.call(e, n[0]);
      case 2:
        return t.call(e, n[0], n[1]);
      case 3:
        return t.call(e, n[0], n[1], n[2])
    }
    return t.apply(e, n)
  }
}, function (t, e) {
  t.exports = function () {
    return !1
  }
}, function (t, e, n) {
  var r = n(5),
    i = n(6),
    o = n(30),
    s = "[object DOMException]",
    a = "[object Error]";
  t.exports = function (t) {
    if (!i(t)) return !1;
    var e = r(t);
    return e == a || e == s || "string" == typeof t.message && "string" == typeof t.name && !o(t)
  }
}, function (t, e) {
  t.exports = /<%=([\s\S]+?)%>/g
}, function (t, e, n) {
  var r = n(5),
    i = n(6),
    o = "[object Boolean]";
  t.exports = function (t) {
    return !0 === t || !1 === t || i(t) && r(t) == o
  }
}, function (t, e, n) {
  var r = n(53);
  t.exports = function (t) {
    return "number" == typeof t && t == r(t)
  }
}, function (t, e, n) {
  var r = n(5),
    i = n(6),
    o = "[object Number]";
  t.exports = function (t) {
    return "number" == typeof t || i(t) && r(t) == o
  }
}, function (t, e, n) {
  var r = n(5),
    i = n(8),
    o = n(6),
    s = "[object String]";
  t.exports = function (t) {
    return "string" == typeof t || !i(t) && o(t) && r(t) == s
  }
}, function (t, e) {
  t.exports = function (t) {
    return void 0 === t
  }
}, function (t, e, n) {
  var r = n(10),
    i = n(58);
  t.exports = function (t) {
    return i(r(t).toLowerCase())
  }
}, function (t, e, n) {
  var r = n(66),
    i = n(33)(function (t, e, n) {
      r(t, e, n)
    });
  t.exports = i
}, function (t, e, n) {
  var r = n(97),
    i = n(98),
    o = n(99),
    s = n(100),
    a = n(101),
    u = n(37),
    c = n(36),
    l = n(102),
    f = n(38),
    h = n(103),
    d = n(10),
    v = /\b__p \+= '';/g,
    p = /\b(__p \+=) '' \+/g,
    y = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
    g = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
    b = /($^)/,
    m = /['\n\r\u2028\u2029\\]/g;
  t.exports = function (t, e, n) {
    var w = h.imports._.templateSettings || h;
    n && c(t, e, n) && (e = void 0), t = d(t), e = r({}, e, w, s);
    var k, x, _ = r({}, e.imports, w.imports, s),
      S = l(_),
      j = o(_, S),
      L = 0,
      O = e.interpolate || b,
      E = "__p += '",
      A = RegExp((e.escape || b).source + "|" + O.source + "|" + (O === f ? g : b).source + "|" + (e.evaluate || b).source + "|$", "g"),
      P = "sourceURL" in e ? "//# sourceURL=" + e.sourceURL + "\n" : "";
    t.replace(A, function (e, n, r, i, o, s) {
      return r || (r = i), E += t.slice(L, s).replace(m, a), n && (k = !0, E += "' +\n__e(" + n + ") +\n'"), o && (x = !0, E += "';\n" + o + ";\n__p += '"), r && (E += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), L = s + e.length, e
    }), E += "';\n";
    var C = e.variable;
    C || (E = "with (obj) {\n" + E + "\n}\n"), E = (x ? E.replace(v, "") : E).replace(p, "$1").replace(y, "$1;"), E = "function(" + (C || "obj") + ") {\n" + (C ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (k ? ", __e = _.escape" : "") + (x ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + E + "return __p\n}";
    var M = i(function () {
      return Function(S, P + "return " + E).apply(void 0, j)
    });
    if (M.source = E, u(M)) throw M;
    return M
  }
}, function (t, e, n) {
  var r = n(19),
    i = n(3),
    o = "Expected a function";
  t.exports = function (t, e, n) {
    var s = !0,
      a = !0;
    if ("function" != typeof t) throw new TypeError(o);
    return i(n) && (s = "leading" in n ? !!n.leading : s, a = "trailing" in n ? !!n.trailing : a), r(t, e, {
      leading: s,
      maxWait: e,
      trailing: a
    })
  }
}, function (t, e) {
  t.exports = function (t) {
    return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
      enumerable: !0,
      get: function () {
        return t.l
      }
    }), Object.defineProperty(t, "id", {
      enumerable: !0,
      get: function () {
        return t.i
      }
    }), t.webpackPolyfill = 1), t
  }
}, , , , function (t, e, n) {
  "use strict";
  var r = Array.isArray,
    i = Object.keys,
    o = Object.prototype.hasOwnProperty;
  t.exports = function t(e, n) {
    if (e === n) return !0;
    if (e && n && "object" == typeof e && "object" == typeof n) {
      var s, a, u, c = r(e),
        l = r(n);
      if (c && l) {
        if ((a = e.length) != n.length) return !1;
        for (s = a; 0 != s--;)
          if (!t(e[s], n[s])) return !1;
        return !0
      }
      if (c != l) return !1;
      var f = e instanceof Date,
        h = n instanceof Date;
      if (f != h) return !1;
      if (f && h) return e.getTime() == n.getTime();
      var d = e instanceof RegExp,
        v = n instanceof RegExp;
      if (d != v) return !1;
      if (d && v) return e.toString() == n.toString();
      var p = i(e);
      if ((a = p.length) !== i(n).length) return !1;
      for (s = a; 0 != s--;)
        if (!o.call(n, p[s])) return !1;
      for (s = a; 0 != s--;)
        if (!t(e[u = p[s]], n[u])) return !1;
      return !0
    }
    return e != e && n != n
  }
}, function (t, e, n) {
  var r = n(54);
  t.exports = function (t) {
    var e = r(t),
      n = e % 1;
    return e == e ? n ? e - n : e : 0
  }
}, function (t, e, n) {
  var r = n(23),
    i = 1 / 0,
    o = 1.7976931348623157e308;
  t.exports = function (t) {
    return t ? (t = r(t)) === i || t === -i ? (t < 0 ? -1 : 1) * o : t == t ? t : 0 : 0 === t ? t : 0
  }
}, function (t, e, n) {
  var r = n(56),
    i = n(25),
    o = n(8),
    s = n(24),
    a = 1 / 0,
    u = r ? r.prototype : void 0,
    c = u ? u.toString : void 0;
  t.exports = function t(e) {
    if ("string" == typeof e) return e;
    if (o(e)) return i(e, t) + "";
    if (s(e)) return c ? c.call(e) : "";
    var n = e + "";
    return "0" == n && 1 / e == -a ? "-0" : n
  }
}, function (t, e, n) {
  var r = n(11).Symbol;
  t.exports = r
}, function (t, e, n) {
  (function (e) {
    var n = "object" == typeof e && e && e.Object === Object && e;
    t.exports = n
  }).call(this, n(21))
}, function (t, e, n) {
  var r = n(59)("toUpperCase");
  t.exports = r
}, function (t, e, n) {
  var r = n(60),
    i = n(26),
    o = n(62),
    s = n(10);
  t.exports = function (t) {
    return function (e) {
      e = s(e);
      var n = i(e) ? o(e) : void 0,
        a = n ? n[0] : e.charAt(0),
        u = n ? r(n, 1).join("") : e.slice(1);
      return a[t]() + u
    }
  }
}, function (t, e, n) {
  var r = n(61);
  t.exports = function (t, e, n) {
    var i = t.length;
    return n = void 0 === n ? i : n, !e && n >= i ? t : r(t, e, n)
  }
}, function (t, e) {
  t.exports = function (t, e, n) {
    var r = -1,
      i = t.length;
    e < 0 && (e = -e > i ? 0 : i + e), (n = n > i ? i : n) < 0 && (n += i), i = e > n ? 0 : n - e >>> 0, e >>>= 0;
    for (var o = Array(i); ++r < i;) o[r] = t[r + e];
    return o
  }
}, function (t, e, n) {
  var r = n(63),
    i = n(26),
    o = n(64);
  t.exports = function (t) {
    return i(t) ? o(t) : r(t)
  }
}, function (t, e) {
  t.exports = function (t) {
    return t.split("")
  }
}, function (t, e) {
  t.exports = function (t) {
    return t.split("")
  }
}, function (t, e, n) {
  var r = n(11);
  t.exports = function () {
    return r.Date.now()
  }
}, function (t, e, n) {
  var r = n(67),
    i = n(27),
    o = n(75),
    s = n(77),
    a = n(3),
    u = n(18),
    c = n(31);
  t.exports = function t(e, n, l, f, h) {
    e !== n && o(n, function (o, u) {
      if (a(o)) h || (h = new r), s(e, n, u, l, t, f, h);
      else {
        var d = f ? f(c(e, u), o, u + "", e, n, h) : void 0;
        void 0 === d && (d = o), i(e, u, d)
      }
    }, u)
  }
}, function (t, e, n) {
  var r = n(68),
    i = n(69),
    o = n(70),
    s = n(71),
    a = n(72);

  function u(t) {
    var e = -1,
      n = null == t ? 0 : t.length;
    for (this.clear(); ++e < n;) {
      var r = t[e];
      this.set(r[0], r[1])
    }
  }
  u.prototype.clear = r, u.prototype.delete = i, u.prototype.get = o, u.prototype.has = s, u.prototype.set = a, t.exports = u
}, function (t, e) {
  t.exports = function () {
    this.__data__ = [], this.size = 0
  }
}, function (t, e, n) {
  var r = n(12),
    i = Array.prototype.splice;
  t.exports = function (t) {
    var e = this.__data__,
      n = r(e, t);
    return !(n < 0 || (n == e.length - 1 ? e.pop() : i.call(e, n, 1), --this.size, 0))
  }
}, function (t, e, n) {
  var r = n(12);
  t.exports = function (t) {
    var e = this.__data__,
      n = r(e, t);
    return n < 0 ? void 0 : e[n][1]
  }
}, function (t, e, n) {
  var r = n(12);
  t.exports = function (t) {
    return r(this.__data__, t) > -1
  }
}, function (t, e, n) {
  var r = n(12);
  t.exports = function (t, e) {
    var n = this.__data__,
      i = r(n, t);
    return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this
  }
}, function (t, e, n) {
  var r = n(74),
    i = function () {
      try {
        var t = r(Object, "defineProperty");
        return t({}, "", {}), t
      } catch (t) {}
    }();
  t.exports = i
}, function (t, e) {
  t.exports = function (t, e) {
    return null == t ? void 0 : t[e]
  }
}, function (t, e, n) {
  var r = n(76)();
  t.exports = r
}, function (t, e) {
  t.exports = function (t) {
    return function (e, n, r) {
      for (var i = -1, o = Object(e), s = r(e), a = s.length; a--;) {
        var u = s[t ? a : ++i];
        if (!1 === n(o[u], u, o)) break
      }
      return e
    }
  }
}, function (t, e, n) {
  var r = n(27),
    i = n(78),
    o = n(79),
    s = n(82),
    a = n(83),
    u = n(86),
    c = n(8),
    l = n(87),
    f = n(90),
    h = n(14),
    d = n(3),
    v = n(30),
    p = n(91),
    y = n(31),
    g = n(92);
  t.exports = function (t, e, n, b, m, w, k) {
    var x = y(t, n),
      _ = y(e, n),
      S = k.get(_);
    if (S) r(t, n, S);
    else {
      var j = w ? w(x, _, n + "", t, e, k) : void 0,
        L = void 0 === j;
      if (L) {
        var O = c(_),
          E = !O && f(_),
          A = !O && !E && p(_);
        j = _, O || E || A ? c(x) ? j = x : l(x) ? j = s(x) : E ? (L = !1, j = i(_, !0)) : A ? (L = !1, j = o(_, !0)) : j = [] : v(_) || u(_) ? (j = x, u(x) ? j = g(x) : d(x) && !h(x) || (j = a(_))) : L = !1
      }
      L && (k.set(_, j), m(j, _, b, w, k), k.delete(_)), r(t, n, j)
    }
  }
}, function (t, e, n) {
  (function (t) {
    var r = n(11),
      i = e && !e.nodeType && e,
      o = i && "object" == typeof t && t && !t.nodeType && t,
      s = o && o.exports === i ? r.Buffer : void 0,
      a = s ? s.allocUnsafe : void 0;
    t.exports = function (t, e) {
      if (e) return t.slice();
      var n = t.length,
        r = a ? a(n) : new t.constructor(n);
      return t.copy(r), r
    }
  }).call(this, n(48)(t))
}, function (t, e, n) {
  var r = n(80);
  t.exports = function (t, e) {
    var n = e ? r(t.buffer) : t.buffer;
    return new t.constructor(n, t.byteOffset, t.length)
  }
}, function (t, e, n) {
  var r = n(81);
  t.exports = function (t) {
    var e = new t.constructor(t.byteLength);
    return new r(e).set(new r(t)), e
  }
}, function (t, e, n) {
  var r = n(11).Uint8Array;
  t.exports = r
}, function (t, e) {
  t.exports = function (t, e) {
    var n = -1,
      r = t.length;
    for (e || (e = Array(r)); ++n < r;) e[n] = t[n];
    return e
  }
}, function (t, e, n) {
  var r = n(84),
    i = n(28),
    o = n(85);
  t.exports = function (t) {
    return "function" != typeof t.constructor || o(t) ? {} : r(i(t))
  }
}, function (t, e, n) {
  var r = n(3),
    i = Object.create,
    o = function () {
      function t() {}
      return function (e) {
        if (!r(e)) return {};
        if (i) return i(e);
        t.prototype = e;
        var n = new t;
        return t.prototype = void 0, n
      }
    }();
  t.exports = o
}, function (t, e) {
  t.exports = function () {
    return !1
  }
}, function (t, e) {
  t.exports = function () {
    return !1
  }
}, function (t, e, n) {
  var r = n(88),
    i = n(6);
  t.exports = function (t) {
    return i(t) && r(t)
  }
}, function (t, e, n) {
  var r = n(14),
    i = n(89);
  t.exports = function (t) {
    return null != t && i(t.length) && !r(t)
  }
}, function (t, e) {
  var n = 9007199254740991;
  t.exports = function (t) {
    return "number" == typeof t && t > -1 && t % 1 == 0 && t <= n
  }
}, function (t, e) {
  t.exports = function () {
    return !1
  }
}, function (t, e) {
  t.exports = function () {
    return !1
  }
}, function (t, e, n) {
  var r = n(32),
    i = n(18);
  t.exports = function (t) {
    return r(t, i(t))
  }
}, function (t, e, n) {
  var r = n(17),
    i = n(13),
    o = Object.prototype.hasOwnProperty;
  t.exports = function (t, e, n) {
    var s = t[e];
    o.call(t, e) && i(s, n) && (void 0 !== n || e in t) || r(t, e, n)
  }
}, function (t, e) {
  t.exports = function (t) {
    return t
  }
}, function (t, e, n) {
  var r = n(35),
    i = Math.max;
  t.exports = function (t, e, n) {
    return e = i(void 0 === e ? t.length - 1 : e, 0),
      function () {
        for (var o = arguments, s = -1, a = i(o.length - e, 0), u = Array(a); ++s < a;) u[s] = o[e + s];
        s = -1;
        for (var c = Array(e + 1); ++s < e;) c[s] = o[s];
        return c[e] = n(u), r(t, this, c)
      }
  }
}, function (t, e) {
  t.exports = function (t) {
    return t
  }
}, function (t, e, n) {
  var r = n(32),
    i = n(33),
    o = n(18),
    s = i(function (t, e, n, i) {
      r(e, o(e), t, i)
    });
  t.exports = s
}, function (t, e, n) {
  var r = n(35),
    i = n(34),
    o = n(37),
    s = i(function (t, e) {
      try {
        return r(t, void 0, e)
      } catch (t) {
        return o(t) ? t : new Error(t)
      }
    });
  t.exports = s
}, function (t, e, n) {
  var r = n(25);
  t.exports = function (t, e) {
    return r(e, function (e) {
      return t[e]
    })
  }
}, function (t, e, n) {
  var r = n(13),
    i = Object.prototype,
    o = i.hasOwnProperty;
  t.exports = function (t, e, n, s) {
    return void 0 === t || r(t, i[n]) && !o.call(s, n) ? e : t
  }
}, function (t, e) {
  var n = {
    "\\": "\\",
    "'": "'",
    "\n": "n",
    "\r": "r",
    "\u2028": "u2028",
    "\u2029": "u2029"
  };
  t.exports = function (t) {
    return "\\" + n[t]
  }
}, function (t, e, n) {
  var r = n(29)(Object.keys, Object);
  t.exports = r
}, function (t, e, n) {
  var r = n(104),
    i = {
      escape: n(107),
      evaluate: n(108),
      interpolate: n(38),
      variable: "",
      imports: {
        _: {
          escape: r
        }
      }
    };
  t.exports = i
}, function (t, e, n) {
  var r = n(105),
    i = n(10),
    o = /[&<>"']/g,
    s = RegExp(o.source);
  t.exports = function (t) {
    return (t = i(t)) && s.test(t) ? t.replace(o, r) : t
  }
}, function (t, e, n) {
  var r = n(106)({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  });
  t.exports = r
}, function (t, e) {
  t.exports = function (t) {
    return function (e) {
      return null == t ? void 0 : t[e]
    }
  }
}, function (t, e) {
  t.exports = /<%-([\s\S]+?)%>/g
}, function (t, e) {
  t.exports = /<%([\s\S]+?)%>/g
}, , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , function (t, e, n) {
  "use strict";
  n.r(e);
  var r = n(22),
    i = n(4),
    o = (n(204), n(0)),
    s = n(15);

  function a(t) {
    return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
    })(t)
  }

  function u(t, e) {
    return function (t) {
      if (Array.isArray(t)) return t
    }(t) || function (t, e) {
      var n = [],
        r = !0,
        i = !1,
        o = void 0;
      try {
        for (var s, a = t[Symbol.iterator](); !(r = (s = a.next()).done) && (n.push(s.value), !e || n.length !== e); r = !0);
      } catch (t) {
        i = !0, o = t
      } finally {
        try {
          r || null == a.return || a.return()
        } finally {
          if (i) throw o
        }
      }
      return n
    }(t, e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance")
    }()
  }

  function c(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
  }

  function l(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r)
    }
  }

  function f(t, e, n) {
    return e && l(t.prototype, e), n && l(t, n), t
  }
  var h = "styleguide",
    d = function () {
      function t(e) {
        c(this, t), this.el = {
          sidebar: e,
          resize: e.querySelector(".".concat(h, "__resize")),
          nav: e.querySelector(".".concat(h, "__nav")),
          iframe: document.querySelector(".".concat(h, "__iframe iframe")),
          overlay: document.querySelector(".".concat(h, "__overlay")),
          sidebarToggle: document.querySelector(".".concat(h, "__toggle-sidebar"))
        }, this._activeContent = null, this.events = Object(o.a)(this), this.renderSidebar(), this.addEventListeners()
      }
      return f(t, [{
        key: "renderItems",
        value: function (t, e, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
            o = document.createElement("ul");
          for (var s in e) {
            var a = e[s],
              u = "".concat(t).concat(s),
              c = u.replace(i.a.root, ""),
              l = document.createElement("li");
            r || l.classList.add("styleguide__nav-category"), o.appendChild(l), Array.isArray(a.content) ? a.hidden || (l.innerHTML = '<a href="'.concat(u, '" class="h9">').concat(a.title, '</a><a class="expand" href="/styleguide/iframe.php#').concat(c, '">\n\t\t\t\t\t\t<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.5 11.6">\n\t\t\t\t\t\t\t<path d="M10.5,0h-8c-0.6,0-1,0.4-1,1v1c0,0.6,0.4,1,1,1h3.9L0.3,9.2c-0.4,0.4-0.4,1,0,1.4L1,11.3\n\t\t\t\t\t\t\tc0.4,0.4,1,0.4,1.4,0l6.1-6.1V9c0,0.6,0.4,1,1,1h1c0.6,0,1-0.4,1-1V2V1C11.5,0.4,11.1,0,10.5,0z"/>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</a>')) : (l.innerHTML = '<span class="h10">'.concat(a.title, "</span>"), this.renderItems("".concat(u, "/"), a.content, l, !0))
          }
          n.appendChild(o)
        }
      }, {
        key: "renderSidebar",
        value: function () {
          this.renderItems(i.a.root, s.blueprint, this.el.nav)
        }
      }, {
        key: "highlightActiveContent",
        value: function () {
          var t = this.el.nav.querySelectorAll("a"),
            e = !0,
            n = !1,
            r = void 0;
          try {
            for (var o, s = t[Symbol.iterator](); !(e = (o = s.next()).done); e = !0) {
              var a = o.value,
                u = a.getAttribute("href");
              a.classList[i.a.root + this.activeContent === u ? "add" : "remove"]("active")
            }
          } catch (t) {
            n = !0, r = t
          } finally {
            try {
              e || null == s.return || s.return()
            } finally {
              if (n) throw r
            }
          }
        }
      }, {
        key: "toggleSidebar",
        value: function () {
          this.el.sidebar.classList.contains("active") ? this.closeSidebar() : this.openSidebar()
        }
      }, {
        key: "openSidebar",
        value: function () {
          document.querySelector("main").classList.remove("is-sidebar-disabled"), this.el.sidebar.classList.add("active"), this.el.iframe.contentWindow.postMessage("sidebarOpen", "*"), this.checkSidebarState()
        }
      }, {
        key: "closeSidebar",
        value: function () {
          document.querySelector("main").classList.add("is-sidebar-disabled"), this.el.sidebar.classList.remove("active"), this.el.iframe.contentWindow.postMessage("sidebarClose", "*"), this.checkSidebarState()
        }
      }, {
        key: "checkSidebarState",
        value: function () {
          var t = this;
          this.el.sidebar.classList.contains("active") ? (this.el.overlay.classList.add("active"), Object(o.j)("medium") ? document.body.classList.remove("no-scroll") : document.body.classList.add("no-scroll"), requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              t.el.overlay.classList.add("is-in")
            })
          })) : (this.el.overlay.classList.remove("is-in"), document.body.classList.remove("no-scroll"), setTimeout(function () {
            t.el.overlay.classList.remove("active")
          }, 300))
        }
      }, {
        key: "addEventListeners",
        value: function () {
          var t = !0,
            e = !1,
            n = void 0;
          try {
            for (var r, i = this.el.resize.querySelectorAll("button")[Symbol.iterator](); !(t = (r = i.next()).done); t = !0) {
              r.value.addEventListener("click", this.events._onResizeButtonsClick)
            }
          } catch (t) {
            e = !0, n = t
          } finally {
            try {
              t || null == i.return || i.return()
            } finally {
              if (e) throw n
            }
          }
          var s = this.el.nav.querySelectorAll('a:not([href="javascript:;"]):not([href=""]):not(.expand)'),
            a = !0,
            u = !1,
            c = void 0;
          try {
            for (var l, f = s[Symbol.iterator](); !(a = (l = f.next()).done); a = !0) {
              l.value.addEventListener("click", this.events._onNavAnchorClick)
            }
          } catch (t) {
            u = !0, c = t
          } finally {
            try {
              a || null == f.return || f.return()
            } finally {
              if (u) throw c
            }
          }
          this.el.sidebar.querySelector(".".concat(h, "__sidebar-header a")).addEventListener("click", this.events._onNavAnchorClick), this.el.sidebarToggle.addEventListener("click", this.events._onSidebarToggleClick), Object(o.j)("medium") || this.closeSidebar()
        }
      }, {
        key: "removeEventListeners",
        value: function () {
          var t = !0,
            e = !1,
            n = void 0;
          try {
            for (var r, i = this.el.resize.querySelectorAll("button")[Symbol.iterator](); !(t = (r = i.next()).done); t = !0) {
              r.value.removeEventListener("click", this.events._onResizeButtonsClick)
            }
          } catch (t) {
            e = !0, n = t
          } finally {
            try {
              t || null == i.return || i.return()
            } finally {
              if (e) throw n
            }
          }
          var o = !0,
            s = !1,
            a = void 0;
          try {
            for (var u, c = this.el.nav.querySelectorAll("a")[Symbol.iterator](); !(o = (u = c.next()).done); o = !0) {
              u.value.removeEventListener("click", this.events._onNavAnchorClick)
            }
          } catch (t) {
            s = !0, a = t
          } finally {
            try {
              o || null == c.return || c.return()
            } finally {
              if (s) throw a
            }
          }
          this.el.sidebar.querySelector(".".concat(h, "__sidebar-header a")).removeEventListener("click", this.events._onNavAnchorClick), this.el.sidebarToggle.removeEventListener("click", this.events._onSidebarToggleClick)
        }
      }, {
        key: "_onResizeButtonsClick",
        value: function (t) {
          var e = t.currentTarget.getAttribute("data-size"),
            n = u(s.sizes[e], 2),
            r = n[0],
            i = n[1];
          this.el.iframe.style.width = r ? "".concat(r, "px") : "", this.el.iframe.style.height = i ? "".concat(i, "px") : ""
        }
      }, {
        key: "_onNavAnchorClick",
        value: function (t) {
          t.preventDefault(), this.el.iframe.contentWindow.location.href !== "".concat(window.location.origin, "/styleguide/iframe.php") && this.el.iframe.setAttribute("src", "/styleguide/iframe.php");
          var e = t.currentTarget.getAttribute("href").replace(i.a.root, "/");
          i.a.navigate(e), Object(o.j)("medium") || this.closeSidebar()
        }
      }, {
        key: "_onSidebarToggleClick",
        value: function (t) {
          t.preventDefault(), this.toggleSidebar()
        }
      }, {
        key: "activeContent",
        get: function () {
          return this._activeContent
        },
        set: function (t) {
          this._activeContent = t, this.highlightActiveContent()
        }
      }]), t
    }(),
    v = function () {
      function t() {
        c(this, t), this.el = {}, this.sidebar = null, this.events = Object(o.a)(this), i.a.root = "/styleguide/", this.addEventListeners()
      }
      return f(t, [{
        key: "setActiveContent",
        value: function (t) {
          sessionStorage.setItem(s.sessionStorageKey, t), this.sidebar.activeContent = t
        }
      }, {
        key: "initializeSidebar",
        value: function () {
          var t = document.querySelector(".".concat(h, "__sidebar"));
          this.sidebar = new d(t)
        }
      }, {
        key: "initializeRouter",
        value: function () {
          var t = this;
          i.a.start({
            "/": function () {
              t.setActiveContent(s.defaultContent)
            },
            "/:a/?:b/?:c/?:d/?:e": function () {
              for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
              t.setActiveContent(n.join("/"))
            }
          })
        }
      }, {
        key: "_onDOMContentLoaded",
        value: function () {
          this.initializeSidebar(), this.initializeRouter()
        }
      }, {
        key: "_onPostMessage",
        value: function (t) {
          if (t.isTrusted && t.data && t.data.isAnchorLink) {
            var e = t.data.linkUrl.replace(i.a.root, "");
            i.a.navigate("/".concat(e))
          }
        }
      }, {
        key: "addEventListeners",
        value: function () {
          document.addEventListener("DOMContentLoaded", this.events._onDOMContentLoaded), window.addEventListener("message", this.events._onPostMessage)
        }
      }, {
        key: "removeEventListeners",
        value: function () {
          document.removeEventListener("DOMContentLoaded", this.events._onDOMContentLoaded), window.removeEventListener("message", this.events._onPostMessage)
        }
      }]), t
    }(),
    p = function () {
      function t() {
        c(this, t), this.el = {}, this.events = Object(o.a)(this), this.flags = {
          isStandalone: window.self === window.top,
          isInIframe: window.frameElement && "iframe" === window.frameElement.nodeName.toLowerCase()
        }, this.observers = {
          mutation: null
        }, this.addEventListeners()
      }
      return f(t, [{
        key: "addEventListeners",
        value: function () {
          window.addEventListener("load", this.events._onWindowLoad), window.addEventListener("message", this.events._onPostMessage), window.addEventListener("storage", this.events._onWindowSessionStorage), this.flags.isStandalone && window.addEventListener("hashchange", this.events._onHashChange), this.observeMutations()
        }
      }, {
        key: "removeEventListeners",
        value: function () {
          window.removeEventListener("load", this.events._onWindowLoad), window.removeEventListener("message", this.events._onPostMessage), window.removeEventListener("storage", this.events._onWindowSessionStorage), this.unobserveMutations()
        }
      }, {
        key: "observeMutations",
        value: function () {
          var t = this;
          if (!this.observers.mutation) {
            var e = o.i.debounce(function () {
              t.overridePageAnchors()
            }, 250, {
              leading: !1,
              trailing: !0
            });
            new MutationObserver(e).observe(document.body.querySelector("main"), {
              attributes: !1,
              childList: !0,
              subtree: !0
            })
          }
        }
      }, {
        key: "unobserveMutations",
        value: function () {
          this.observers.mutation && (this.observers.mutation.disconnect(), this.observers.mutation = null)
        }
      }, {
        key: "_onWindowLoad",
        value: function () {
          var t = String(window.location.hash).substr(1);
          t ? sessionStorage.setItem(s.sessionStorageKey, t) : this.renderActiveContent(), this.renderActiveContent()
        }
      }, {
        key: "_onWindowSessionStorage",
        value: function (t) {
          t.key === s.sessionStorageKey && this.renderActiveContent()
        }
      }, {
        key: "_onPostMessage",
        value: function (t) {
          "sidebarOpen" === t.data ? document.body.classList.add("no-scroll") : "sidebarClose" === t.data && document.body.classList.remove("no-scroll")
        }
      }, {
        key: "_onHashChange",
        value: function () {
          location.reload()
        }
      }, {
        key: "fetchBit",
        value: function (t) {
          return new Promise(function (e) {
            new r.a("text").get("/bits/".concat(t, "/template.html")).then(function (t) {
              return e(t.response)
            })
          })
        }
      }, {
        key: "fetchModule",
        value: function (t) {
          return new Promise(function (e) {
            new r.a("text").get("/modules/".concat(t, "/template.html")).then(function (t) {
              return e(t.response)
            })
          })
        }
      }, {
        key: "fetchPage",
        value: function () {}
      }, {
        key: "renderActiveContent",
        value: function () {
          var t = this;
          return new Promise(function (e) {
            var n = sessionStorage.getItem(s.sessionStorageKey);
            if (n) {
              var r = s.blueprint,
                i = n.split("?")[0].split("/"),
                o = !0,
                u = !1,
                c = void 0;
              try {
                for (var l, f = i[Symbol.iterator](); !(o = (l = f.next()).done); o = !0) {
                  var h = l.value;
                  r = "object" === a(r[h].content) ? r[h].content : r[h]
                }
              } catch (t) {
                u = !0, c = t
              } finally {
                try {
                  o || null == f.return || f.return()
                } finally {
                  if (u) throw c
                }
              }
              var d = [],
                v = !0,
                p = !1,
                y = void 0;
              try {
                for (var g, b = r[Symbol.iterator](); !(v = (g = b.next()).done); v = !0) {
                  var m = g.value,
                    w = m.type.replace(/^\w/, function (t) {
                      return t.toUpperCase()
                    });
                  d.push(t["fetch".concat(w)](m.path))
                }
              } catch (t) {
                p = !0, y = t
              } finally {
                try {
                  v || null == b.return || b.return()
                } finally {
                  if (p) throw y
                }
              }
              Promise.all(d).then(function (n) {
                var r = "",
                  i = !0,
                  o = !1,
                  s = void 0;
                try {
                  for (var a, u = n[Symbol.iterator](); !(i = (a = u.next()).done); i = !0) {
                    r += a.value
                  }
                } catch (t) {
                  o = !0, s = t
                } finally {
                  try {
                    i || null == u.return || u.return()
                  } finally {
                    if (o) throw s
                  }
                }
                document.querySelector("main").innerHTML = r, document.dispatchEvent(new Event("DOMContentUpdate")), t.overridePageAnchors(), e()
              })
            }
          })
        }
      }, {
        key: "overridePageAnchors",
        value: function () {
          var t = document.querySelector("main").querySelectorAll('a:not([href="javascript:;"]):not([href=""])');
          Object(o.m)(t, "click", this.events._onPageAnchorClick), Object(o.k)(t, "click", this.events._onPageAnchorClick)
        }
      }, {
        key: "_onPageAnchorClick",
        value: function (t) {
          var e = t.currentTarget.getAttribute("href");
          return t.preventDefault(), this.flags.isStandalone ? String(window.location.hash).substr(1) === e ? window.location.reload() : window.location.hash = e : parent.postMessage({
            isAnchorLink: !0,
            linkUrl: e
          }, "*"), !1
        }
      }]), t
    }();
  e.default = window.self !== window.top || window.location.pathname.includes("iframe") ? new p : new v
}, function (t, e, n) {}]);
//# sourceMappingURL=styleguide.bundle.js.map
$(function () {
  
  if(window.innerWidth < 768){
    setTimeout(function(){
      $('.fc-listYear-button').click();
    }, 100)
  }
});